(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb015"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb015"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("23NWZ", function(module, exports) {
// A library of seedable RNGs implemented in Javascript.
//
// Usage:
//
// var seedrandom = require('seedrandom');
// var random = seedrandom(1); // or any seed.
// var x = random();       // 0 <= x < 1.  Every bit is random.
// var x = random.quick(); // 0 <= x < 1.  32 bits of randomness.
// alea, a 53-bit multiply-with-carry generator by Johannes Baagøe.
// Period: ~2^116
// Reported to pass all BigCrush tests.

var $7d0dU = parcelRequire("7d0dU");

var $gGYRB = parcelRequire("gGYRB");

var $6P4IY = parcelRequire("6P4IY");

var $dhG1c = parcelRequire("dhG1c");

var $bB3CY = parcelRequire("bB3CY");

var $b4qVD = parcelRequire("b4qVD");

var $1bRTn = parcelRequire("1bRTn");
$1bRTn.alea = $7d0dU;
$1bRTn.xor128 = $gGYRB;
$1bRTn.xorwow = $6P4IY;
$1bRTn.xorshift7 = $dhG1c;
$1bRTn.xor4096 = $bB3CY;
$1bRTn.tychei = $b4qVD;
module.exports = $1bRTn;

});
parcelRegister("7d0dU", function(module, exports) {
// A port of an algorithm by Johannes Baagøe <baagoe@baagoe.com>, 2010
// http://baagoe.com/en/RandomMusings/javascript/
// https://github.com/nquinlan/better-random-numbers-for-javascript-mirror
// Original work is under MIT license -
// Copyright (C) 2010 by Johannes Baagøe <baagoe@baagoe.org>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
(function(global, module1, define1) {
    function Alea(seed) {
        var me = this, mash = Mash();
        me.next = function() {
            var t = 2091639 * me.s0 + me.c * 2.3283064365386963e-10; // 2^-32
            me.s0 = me.s1;
            me.s1 = me.s2;
            return me.s2 = t - (me.c = t | 0);
        };
        // Apply the seeding algorithm from Baagoe.
        me.c = 1;
        me.s0 = mash(' ');
        me.s1 = mash(' ');
        me.s2 = mash(' ');
        me.s0 -= mash(seed);
        if (me.s0 < 0) me.s0 += 1;
        me.s1 -= mash(seed);
        if (me.s1 < 0) me.s1 += 1;
        me.s2 -= mash(seed);
        if (me.s2 < 0) me.s2 += 1;
        mash = null;
    }
    function copy(f, t) {
        t.c = f.c;
        t.s0 = f.s0;
        t.s1 = f.s1;
        t.s2 = f.s2;
        return t;
    }
    function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
            return xg.next() * 0x100000000 | 0;
        };
        prng.double = function() {
            return prng() + (prng() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
        };
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    function Mash() {
        var n = 0xefc8249d;
        var mash = function(data) {
            data = String(data);
            for(var i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                var h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.alea = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("gGYRB", function(module, exports) {
// A Javascript implementaion of the "xor128" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x << 11;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            return me.w ^= me.w >>> 19 ^ t ^ t >>> 8;
        };
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor128 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("6P4IY", function(module, exports) {
// A Javascript implementaion of the "xorwow" prng algorithm by
// George Marsaglia.  See http://www.jstatsoft.org/v08/i14/paper
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var t = me.x ^ me.x >>> 2;
            me.x = me.y;
            me.y = me.z;
            me.z = me.w;
            me.w = me.v;
            return (me.d = me.d + 362437 | 0) + (me.v = me.v ^ me.v << 4 ^ (t ^ t << 1)) | 0;
        };
        me.x = 0;
        me.y = 0;
        me.z = 0;
        me.w = 0;
        me.v = 0;
        if (seed === (seed | 0)) // Integer seed.
        me.x = seed;
        else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 64; k++){
            me.x ^= strseed.charCodeAt(k) | 0;
            if (k == strseed.length) me.d = me.x << 10 ^ me.x >>> 4;
            me.next();
        }
    }
    function copy(f, t) {
        t.x = f.x;
        t.y = f.y;
        t.z = f.z;
        t.w = f.w;
        t.v = f.v;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorwow = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("dhG1c", function(module, exports) {
// A Javascript implementaion of the "xorshift7" algorithm by
// François Panneton and Pierre L'ecuyer:
// "On the Xorgshift Random Number Generators"
// http://saluc.engr.uconn.edu/refs/crypto/rng/panneton05onthexorshift.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            // Update xor generator.
            var X = me.x, i = me.i, t, v, w;
            t = X[i];
            t ^= t >>> 7;
            v = t ^ t << 24;
            t = X[i + 1 & 7];
            v ^= t ^ t >>> 10;
            t = X[i + 3 & 7];
            v ^= t ^ t >>> 3;
            t = X[i + 4 & 7];
            v ^= t ^ t << 7;
            t = X[i + 7 & 7];
            t = t ^ t << 13;
            v ^= t ^ t << 9;
            X[i] = v;
            me.i = i + 1 & 7;
            return v;
        };
        function init(me, seed) {
            var j, w, X = [];
            if (seed === (seed | 0)) // Seed state array using a 32-bit integer.
            w = X[0] = seed;
            else {
                // Seed state using a string.
                seed = '' + seed;
                for(j = 0; j < seed.length; ++j)X[j & 7] = X[j & 7] << 15 ^ seed.charCodeAt(j) + X[j + 1 & 7] << 13;
            }
            // Enforce an array length of 8, not all zeroes.
            while(X.length < 8)X.push(0);
            for(j = 0; j < 8 && X[j] === 0; ++j);
            if (j == 8) w = X[7] = -1;
            else w = X[j];
            me.x = X;
            me.i = 0;
            // Discard an initial 256 values.
            for(j = 256; j > 0; --j)me.next();
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.x = f.x.slice();
        t.i = f.i;
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.x) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xorshift7 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("bB3CY", function(module, exports) {
// A Javascript implementaion of Richard Brent's Xorgens xor4096 algorithm.
//
// This fast non-cryptographic random number generator is designed for
// use in Monte-Carlo algorithms. It combines a long-period xorshift
// generator with a Weyl generator, and it passes all common batteries
// of stasticial tests for randomness while consuming only a few nanoseconds
// for each prng generated.  For background on the generator, see Brent's
// paper: "Some long-period random number generators using shifts and xors."
// http://arxiv.org/pdf/1004.3115v1.pdf
//
// Usage:
//
// var xor4096 = require('xor4096');
// random = xor4096(1);                        // Seed with int32 or string.
// assert.equal(random(), 0.1520436450538547); // (0, 1) range, 53 bits.
// assert.equal(random.int32(), 1806534897);   // signed int32, 32 bits.
//
// For nonzero numeric keys, this impelementation provides a sequence
// identical to that by Brent's xorgens 3 implementaion in C.  This
// implementation also provides for initalizing the generator with
// string seeds, or for saving and restoring the state of the generator.
//
// On Chrome, this prng benchmarks about 2.1 times slower than
// Javascript's built-in Math.random().
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this;
        // Set up generator function.
        me.next = function() {
            var w = me.w, X = me.X, i = me.i, t, v;
            // Update Weyl generator.
            me.w = w = w + 0x61c88647 | 0;
            // Update xor generator.
            v = X[i + 34 & 127];
            t = X[i = i + 1 & 127];
            v ^= v << 13;
            t ^= t << 17;
            v ^= v >>> 15;
            t ^= t >>> 12;
            // Update Xor generator array state.
            v = X[i] = v ^ t;
            me.i = i;
            // Result is the combination.
            return v + (w ^ w >>> 16) | 0;
        };
        function init(me, seed) {
            var t, v, i, j, w, X = [], limit = 128;
            if (seed === (seed | 0)) {
                // Numeric seeds initialize v, which is used to generates X.
                v = seed;
                seed = null;
            } else {
                // String seeds are mixed into v and X one character at a time.
                seed = seed + '\0';
                v = 0;
                limit = Math.max(limit, seed.length);
            }
            // Initialize circular array and weyl value.
            for(i = 0, j = -32; j < limit; ++j){
                // Put the unicode characters into the array, and shuffle them.
                if (seed) v ^= seed.charCodeAt((j + 32) % seed.length);
                // After 32 shuffles, take v as the starting w value.
                if (j === 0) w = v;
                v ^= v << 10;
                v ^= v >>> 15;
                v ^= v << 4;
                v ^= v >>> 13;
                if (j >= 0) {
                    w = w + 0x61c88647 | 0; // Weyl.
                    t = X[j & 127] ^= v + w; // Combine xor and weyl to init array.
                    i = 0 == t ? i + 1 : 0; // Count zeroes.
                }
            }
            // We have detected all zeroes; make the key nonzero.
            if (i >= 128) X[(seed && seed.length || 0) & 127] = -1;
            // Run the generator 512 times to further mix the state before using it.
            // Factoring this as a function slows the main generator, so it is just
            // unrolled here.  The weyl generator is not advanced while warming up.
            i = 127;
            for(j = 512; j > 0; --j){
                v = X[i + 34 & 127];
                t = X[i = i + 1 & 127];
                v ^= v << 13;
                t ^= t << 17;
                v ^= v >>> 15;
                t ^= t >>> 12;
                X[i] = v ^ t;
            }
            // Storing state as object members is faster than using closure variables.
            me.w = w;
            me.X = X;
            me.i = i;
        }
        init(me, seed);
    }
    function copy(f, t) {
        t.i = f.i;
        t.w = f.w;
        t.X = f.X.slice();
        return t;
    }
    function impl(seed, opts) {
        if (seed == null) seed = +new Date;
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (state.X) copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.xor4096 = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("b4qVD", function(module, exports) {
// A Javascript implementaion of the "Tyche-i" prng algorithm by
// Samuel Neves and Filipe Araujo.
// See https://eden.dei.uc.pt/~sneves/pubs/2011-snfa2.pdf
(function(global, module1, define1) {
    function XorGen(seed) {
        var me = this, strseed = '';
        // Set up generator function.
        me.next = function() {
            var b = me.b, c = me.c, d = me.d, a = me.a;
            b = b << 25 ^ b >>> 7 ^ c;
            c = c - d | 0;
            d = d << 24 ^ d >>> 8 ^ a;
            a = a - b | 0;
            me.b = b = b << 20 ^ b >>> 12 ^ c;
            me.c = c = c - d | 0;
            me.d = d << 16 ^ c >>> 16 ^ a;
            return me.a = a - b | 0;
        };
        /* The following is non-inverted tyche, which has better internal
   * bit diffusion, but which is about 25% slower than tyche-i in JS.
  me.next = function() {
    var a = me.a, b = me.b, c = me.c, d = me.d;
    a = (me.a + me.b | 0) >>> 0;
    d = me.d ^ a; d = d << 16 ^ d >>> 16;
    c = me.c + d | 0;
    b = me.b ^ c; b = b << 12 ^ d >>> 20;
    me.a = a = a + b | 0;
    d = d ^ a; me.d = d = d << 8 ^ d >>> 24;
    me.c = c = c + d | 0;
    b = b ^ c;
    return me.b = (b << 7 ^ b >>> 25);
  }
  */ me.a = 0;
        me.b = 0;
        me.c = -1640531527;
        me.d = 1367130551;
        if (seed === Math.floor(seed)) {
            // Integer seed.
            me.a = seed / 0x100000000 | 0;
            me.b = seed | 0;
        } else // String seed.
        strseed += seed;
        // Mix in string seed, then discard an initial batch of 64 values.
        for(var k = 0; k < strseed.length + 20; k++){
            me.b ^= strseed.charCodeAt(k) | 0;
            me.next();
        }
    }
    function copy(f, t) {
        t.a = f.a;
        t.b = f.b;
        t.c = f.c;
        t.d = f.d;
        return t;
    }
    function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
            return (xg.next() >>> 0) / 0x100000000;
        };
        prng.double = function() {
            do var top = xg.next() >>> 11, bot = (xg.next() >>> 0) / 0x100000000, result = (top + bot) / 2097152;
            while (result === 0);
            return result;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
            if (typeof state == 'object') copy(state, xg);
            prng.state = function() {
                return copy(xg, {});
            };
        }
        return prng;
    }
    if (module1 && module1.exports) module1.exports = impl;
    else if (define1 && define1.amd) define1(function() {
        return impl;
    });
    else this.tychei = impl;
})(this, module, typeof define == 'function' && define // present with an AMD loader
);

});

parcelRegister("1bRTn", function(module, exports) {

/*
Copyright 2019 David Bau.

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ (function(global, pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var width = 256, chunks = 6, digits = 52, rngname = 'random', startdenom = math.pow(width, chunks), significance = math.pow(2, digits), overflow = significance * 2, mask = width - 1, nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //
    function seedrandom(seed, options, callback) {
        var key = [];
        options = options == true ? {
            entropy: true
        } : options || {};
        // Flatten the seed string or build one from local entropy if needed.
        var shortseed = mixkey(flatten(options.entropy ? [
            seed,
            tostring(pool)
        ] : seed == null ? autoseed() : seed, 3), key);
        // Use the seed to initialize an ARC4 generator.
        var arc4 = new ARC4(key);
        // This function returns a random double in [0, 1) that contains
        // randomness in every bit of the mantissa of the IEEE 754 value.
        var prng = function() {
            var n = arc4.g(chunks), d = startdenom, x = 0; //   and no 'extra last byte'.
            while(n < significance){
                n = (n + x) * width; //   shifting numerator and
                d *= width; //   denominator and generating a
                x = arc4.g(1); //   new least-significant-byte.
            }
            while(n >= overflow){
                n /= 2; //   last byte, shift everything
                d /= 2; //   right using integer math until
                x >>>= 1; //   we have exactly the desired bits.
            }
            return (n + x) / d; // Form the number within [0, 1).
        };
        prng.int32 = function() {
            return arc4.g(4) | 0;
        };
        prng.quick = function() {
            return arc4.g(4) / 0x100000000;
        };
        prng.double = prng;
        // Mix the randomness into accumulated entropy.
        mixkey(tostring(arc4.S), pool);
        // Calling convention: what to return as a function of prng, seed, is_math.
        return (options.pass || callback || function(prng, seed, is_math_call, state) {
            if (state) {
                // Load the arc4 state from the given state if it has an S array.
                if (state.S) copy(state, arc4);
                // Only provide the .state method if requested via options.state.
                prng.state = function() {
                    return copy(arc4, {});
                };
            }
            // If called as a method of Math (Math.seedrandom()), mutate
            // Math.random because that is how seedrandom.js has worked since v1.0.
            if (is_math_call) {
                math[rngname] = prng;
                return seed;
            } else return prng;
        })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }
    //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //
    function ARC4(key) {
        var t, keylen = key.length, me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
        // The empty key [] is treated as [0].
        if (!keylen) key = [
            keylen++
        ];
        // Set up S using the standard key scheduling algorithm.
        while(i < width)s[i] = i++;
        for(i = 0; i < width; i++){
            s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
            s[j] = t;
        }
        // The "g" method returns the next (count) outputs as one number.
        (me.g = function(count) {
            // Using instance members instead of closure state nearly doubles speed.
            var t, r = 0, i = me.i, j = me.j, s = me.S;
            while(count--){
                t = s[i = mask & i + 1];
                r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
            }
            me.i = i;
            me.j = j;
            return r;
        // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
        })(width);
    }
    //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //
    function copy(f, t) {
        t.i = f.i;
        t.j = f.j;
        t.S = f.S.slice();
        return t;
    }
    //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //
    function flatten(obj, depth) {
        var result = [], typ = typeof obj, prop;
        if (depth && typ == 'object') {
            for(prop in obj)try {
                result.push(flatten(obj[prop], depth - 1));
            } catch (e) {}
        }
        return result.length ? result : typ == 'string' ? obj : obj + '\0';
    }
    //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //
    function mixkey(seed, key) {
        var stringseed = seed + '', smear, j = 0;
        while(j < stringseed.length)key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
        return tostring(key);
    }
    //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //
    function autoseed() {
        try {
            var out;
            if (nodecrypto && (out = nodecrypto.randomBytes)) // The use of 'out' to remember randomBytes makes tight minified code.
            out = out(width);
            else {
                out = new Uint8Array(width);
                (global.crypto || global.msCrypto).getRandomValues(out);
            }
            return tostring(out);
        } catch (e) {
            var browser = global.navigator, plugins = browser && browser.plugins;
            return [
                +new Date,
                global,
                plugins,
                global.screen,
                tostring(pool)
            ];
        }
    }
    //
    // tostring()
    // Converts an array of charcodes to a string
    //
    function tostring(a) {
        return String.fromCharCode.apply(0, a);
    }
    //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //
    mixkey(math.random(), pool);
    //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    if (0, module.exports) {
        module.exports = seedrandom;
        // When in node.js, try using crypto package for autoseeding.
        try {
            nodecrypto = (parcelRequire("9XjBr"));
        } catch (ex) {}
    } else if (typeof define == 'function' && define.amd) define(function() {
        return seedrandom;
    });
    else // When included as a plain script, set up Math.seedrandom global.
    math['seed' + rngname] = seedrandom;
// End anonymous scope, and pass initial values.
})(// global: `self` in browsers (including strict mode and web workers),
// otherwise `this` in Node and other environments
typeof self !== 'undefined' ? self : module.exports, [], Math // math: package containing random, pow, and seedrandom
);

});
parcelRegister("9XjBr", function(module, exports) {
"use strict";

});



parcelRegister("RIXNk", function(module, exports) {
$parcel$export(module.exports, "losses", function () { return (parcelRequire("4I5dI")).losses; });
$parcel$export(module.exports, "tensor1d", function () { return (parcelRequire("8tOOR")).tensor1d; });
$parcel$export(module.exports, "tensor2d", function () { return (parcelRequire("9NdGd")).tensor2d; });
$parcel$export(module.exports, "train", function () { return (parcelRequire("1d10n")).train; });
$parcel$export(module.exports, "version_core", function () { return (parcelRequire("3YsQX")).version; });
$parcel$export(module.exports, "layers", function () { return (parcelRequire("9W3RU")); });
$parcel$export(module.exports, "loadLayersModel", function () { return (parcelRequire("1dKdw")).loadLayersModel; });
$parcel$export(module.exports, "sequential", function () { return (parcelRequire("hCaeT")).sequential; });
$parcel$export(module.exports, "version_layers", function () { return (parcelRequire("kw5Gh")).version; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $3YsQX = parcelRequire("3YsQX");
parcelRequire("icUUP");
parcelRequire("6ly9j");
parcelRequire("dCUqA");
var $kw5Gh = parcelRequire("kw5Gh");
parcelRequire("lQoXD");
var $hNaaE = parcelRequire("hNaaE");
parcelRequire("bOU3T");
var $4amQM = parcelRequire("4amQM");
parcelRequire("i0b4d");
var $dqT0h = parcelRequire("dqT0h");
parcelRequire("6SCsp");
var $5QpdQ = parcelRequire("5QpdQ");

var $4Ci0Z = parcelRequire("4Ci0Z");
const $0a17d426fda4d200$export$83d89fbfd8236492 = {
    'tfjs-core': (0, $3YsQX.version),
    'tfjs-backend-cpu': (0, $dqT0h.version),
    'tfjs-backend-webgl': (0, $5QpdQ.version),
    'tfjs-data': (0, $4amQM.version),
    'tfjs-layers': (0, $kw5Gh.version),
    'tfjs-converter': (0, $hNaaE.version),
    'tfjs': (0, $4Ci0Z.version)
};

});
parcelRegister("8AHkS", function(module, exports) {
$parcel$export(module.exports, "_FusedMatMul", function () { return (parcelRequire("9BGT9"))._FusedMatMul; });
$parcel$export(module.exports, "Abs", function () { return (parcelRequire("9BGT9")).Abs; });
$parcel$export(module.exports, "Acos", function () { return (parcelRequire("9BGT9")).Acos; });
$parcel$export(module.exports, "Acosh", function () { return (parcelRequire("9BGT9")).Acosh; });
$parcel$export(module.exports, "Add", function () { return (parcelRequire("9BGT9")).Add; });
$parcel$export(module.exports, "AddN", function () { return (parcelRequire("9BGT9")).AddN; });
$parcel$export(module.exports, "All", function () { return (parcelRequire("9BGT9")).All; });
$parcel$export(module.exports, "Any", function () { return (parcelRequire("9BGT9")).Any; });
$parcel$export(module.exports, "ArgMax", function () { return (parcelRequire("9BGT9")).ArgMax; });
$parcel$export(module.exports, "ArgMin", function () { return (parcelRequire("9BGT9")).ArgMin; });
$parcel$export(module.exports, "Asin", function () { return (parcelRequire("9BGT9")).Asin; });
$parcel$export(module.exports, "Asinh", function () { return (parcelRequire("9BGT9")).Asinh; });
$parcel$export(module.exports, "Atan", function () { return (parcelRequire("9BGT9")).Atan; });
$parcel$export(module.exports, "Atan2", function () { return (parcelRequire("9BGT9")).Atan2; });
$parcel$export(module.exports, "Atanh", function () { return (parcelRequire("9BGT9")).Atanh; });
$parcel$export(module.exports, "AvgPool", function () { return (parcelRequire("9BGT9")).AvgPool; });
$parcel$export(module.exports, "AvgPool3D", function () { return (parcelRequire("9BGT9")).AvgPool3D; });
$parcel$export(module.exports, "AvgPool3DGrad", function () { return (parcelRequire("9BGT9")).AvgPool3DGrad; });
$parcel$export(module.exports, "AvgPoolGrad", function () { return (parcelRequire("9BGT9")).AvgPoolGrad; });
$parcel$export(module.exports, "BatchMatMul", function () { return (parcelRequire("9BGT9")).BatchMatMul; });
$parcel$export(module.exports, "BatchToSpaceND", function () { return (parcelRequire("9BGT9")).BatchToSpaceND; });
$parcel$export(module.exports, "Bincount", function () { return (parcelRequire("9BGT9")).Bincount; });
$parcel$export(module.exports, "BitwiseAnd", function () { return (parcelRequire("9BGT9")).BitwiseAnd; });
$parcel$export(module.exports, "BroadcastArgs", function () { return (parcelRequire("9BGT9")).BroadcastArgs; });
$parcel$export(module.exports, "Cast", function () { return (parcelRequire("9BGT9")).Cast; });
$parcel$export(module.exports, "Ceil", function () { return (parcelRequire("9BGT9")).Ceil; });
$parcel$export(module.exports, "ClipByValue", function () { return (parcelRequire("9BGT9")).ClipByValue; });
$parcel$export(module.exports, "Complex", function () { return (parcelRequire("9BGT9")).Complex; });
$parcel$export(module.exports, "ComplexAbs", function () { return (parcelRequire("9BGT9")).ComplexAbs; });
$parcel$export(module.exports, "Concat", function () { return (parcelRequire("9BGT9")).Concat; });
$parcel$export(module.exports, "Conv2D", function () { return (parcelRequire("9BGT9")).Conv2D; });
$parcel$export(module.exports, "Conv2DBackpropFilter", function () { return (parcelRequire("9BGT9")).Conv2DBackpropFilter; });
$parcel$export(module.exports, "Conv2DBackpropInput", function () { return (parcelRequire("9BGT9")).Conv2DBackpropInput; });
$parcel$export(module.exports, "Conv3D", function () { return (parcelRequire("9BGT9")).Conv3D; });
$parcel$export(module.exports, "Conv3DBackpropFilterV2", function () { return (parcelRequire("9BGT9")).Conv3DBackpropFilterV2; });
$parcel$export(module.exports, "Conv3DBackpropInputV2", function () { return (parcelRequire("9BGT9")).Conv3DBackpropInputV2; });
$parcel$export(module.exports, "Cos", function () { return (parcelRequire("9BGT9")).Cos; });
$parcel$export(module.exports, "Cosh", function () { return (parcelRequire("9BGT9")).Cosh; });
$parcel$export(module.exports, "CropAndResize", function () { return (parcelRequire("9BGT9")).CropAndResize; });
$parcel$export(module.exports, "Cumprod", function () { return (parcelRequire("9BGT9")).Cumprod; });
$parcel$export(module.exports, "Cumsum", function () { return (parcelRequire("9BGT9")).Cumsum; });
$parcel$export(module.exports, "DenseBincount", function () { return (parcelRequire("9BGT9")).DenseBincount; });
$parcel$export(module.exports, "DepthToSpace", function () { return (parcelRequire("9BGT9")).DepthToSpace; });
$parcel$export(module.exports, "DepthwiseConv2dNative", function () { return (parcelRequire("9BGT9")).DepthwiseConv2dNative; });
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropFilter", function () { return (parcelRequire("9BGT9")).DepthwiseConv2dNativeBackpropFilter; });
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropInput", function () { return (parcelRequire("9BGT9")).DepthwiseConv2dNativeBackpropInput; });
$parcel$export(module.exports, "Diag", function () { return (parcelRequire("9BGT9")).Diag; });
$parcel$export(module.exports, "Dilation2D", function () { return (parcelRequire("9BGT9")).Dilation2D; });
$parcel$export(module.exports, "Dilation2DBackpropFilter", function () { return (parcelRequire("9BGT9")).Dilation2DBackpropFilter; });
$parcel$export(module.exports, "Dilation2DBackpropInput", function () { return (parcelRequire("9BGT9")).Dilation2DBackpropInput; });
$parcel$export(module.exports, "Draw", function () { return (parcelRequire("9BGT9")).Draw; });
$parcel$export(module.exports, "Einsum", function () { return (parcelRequire("9BGT9")).Einsum; });
$parcel$export(module.exports, "Elu", function () { return (parcelRequire("9BGT9")).Elu; });
$parcel$export(module.exports, "EluGrad", function () { return (parcelRequire("9BGT9")).EluGrad; });
$parcel$export(module.exports, "Equal", function () { return (parcelRequire("9BGT9")).Equal; });
$parcel$export(module.exports, "Erf", function () { return (parcelRequire("9BGT9")).Erf; });
$parcel$export(module.exports, "Exp", function () { return (parcelRequire("9BGT9")).Exp; });
$parcel$export(module.exports, "ExpandDims", function () { return (parcelRequire("9BGT9")).ExpandDims; });
$parcel$export(module.exports, "Expm1", function () { return (parcelRequire("9BGT9")).Expm1; });
$parcel$export(module.exports, "FFT", function () { return (parcelRequire("9BGT9")).FFT; });
$parcel$export(module.exports, "Fill", function () { return (parcelRequire("9BGT9")).Fill; });
$parcel$export(module.exports, "FlipLeftRight", function () { return (parcelRequire("9BGT9")).FlipLeftRight; });
$parcel$export(module.exports, "Floor", function () { return (parcelRequire("9BGT9")).Floor; });
$parcel$export(module.exports, "FloorDiv", function () { return (parcelRequire("9BGT9")).FloorDiv; });
$parcel$export(module.exports, "FromPixels", function () { return (parcelRequire("9BGT9")).FromPixels; });
$parcel$export(module.exports, "FusedBatchNorm", function () { return (parcelRequire("9BGT9")).FusedBatchNorm; });
$parcel$export(module.exports, "FusedConv2D", function () { return (parcelRequire("9BGT9")).FusedConv2D; });
$parcel$export(module.exports, "FusedDepthwiseConv2D", function () { return (parcelRequire("9BGT9")).FusedDepthwiseConv2D; });
$parcel$export(module.exports, "GatherNd", function () { return (parcelRequire("9BGT9")).GatherNd; });
$parcel$export(module.exports, "GatherV2", function () { return (parcelRequire("9BGT9")).GatherV2; });
$parcel$export(module.exports, "Greater", function () { return (parcelRequire("9BGT9")).Greater; });
$parcel$export(module.exports, "GreaterEqual", function () { return (parcelRequire("9BGT9")).GreaterEqual; });
$parcel$export(module.exports, "Identity", function () { return (parcelRequire("9BGT9")).Identity; });
$parcel$export(module.exports, "IFFT", function () { return (parcelRequire("9BGT9")).IFFT; });
$parcel$export(module.exports, "Imag", function () { return (parcelRequire("9BGT9")).Imag; });
$parcel$export(module.exports, "IsFinite", function () { return (parcelRequire("9BGT9")).IsFinite; });
$parcel$export(module.exports, "IsInf", function () { return (parcelRequire("9BGT9")).IsInf; });
$parcel$export(module.exports, "IsNan", function () { return (parcelRequire("9BGT9")).IsNan; });
$parcel$export(module.exports, "LeakyRelu", function () { return (parcelRequire("9BGT9")).LeakyRelu; });
$parcel$export(module.exports, "Less", function () { return (parcelRequire("9BGT9")).Less; });
$parcel$export(module.exports, "LessEqual", function () { return (parcelRequire("9BGT9")).LessEqual; });
$parcel$export(module.exports, "LinSpace", function () { return (parcelRequire("9BGT9")).LinSpace; });
$parcel$export(module.exports, "Log", function () { return (parcelRequire("9BGT9")).Log; });
$parcel$export(module.exports, "Log1p", function () { return (parcelRequire("9BGT9")).Log1p; });
$parcel$export(module.exports, "LogicalAnd", function () { return (parcelRequire("9BGT9")).LogicalAnd; });
$parcel$export(module.exports, "LogicalNot", function () { return (parcelRequire("9BGT9")).LogicalNot; });
$parcel$export(module.exports, "LogicalOr", function () { return (parcelRequire("9BGT9")).LogicalOr; });
$parcel$export(module.exports, "LRN", function () { return (parcelRequire("9BGT9")).LRN; });
$parcel$export(module.exports, "LRNGrad", function () { return (parcelRequire("9BGT9")).LRNGrad; });
$parcel$export(module.exports, "Max", function () { return (parcelRequire("9BGT9")).Max; });
$parcel$export(module.exports, "Maximum", function () { return (parcelRequire("9BGT9")).Maximum; });
$parcel$export(module.exports, "MaxPool", function () { return (parcelRequire("9BGT9")).MaxPool; });
$parcel$export(module.exports, "MaxPool3D", function () { return (parcelRequire("9BGT9")).MaxPool3D; });
$parcel$export(module.exports, "MaxPool3DGrad", function () { return (parcelRequire("9BGT9")).MaxPool3DGrad; });
$parcel$export(module.exports, "MaxPoolGrad", function () { return (parcelRequire("9BGT9")).MaxPoolGrad; });
$parcel$export(module.exports, "MaxPoolWithArgmax", function () { return (parcelRequire("9BGT9")).MaxPoolWithArgmax; });
$parcel$export(module.exports, "Mean", function () { return (parcelRequire("9BGT9")).Mean; });
$parcel$export(module.exports, "Min", function () { return (parcelRequire("9BGT9")).Min; });
$parcel$export(module.exports, "Minimum", function () { return (parcelRequire("9BGT9")).Minimum; });
$parcel$export(module.exports, "MirrorPad", function () { return (parcelRequire("9BGT9")).MirrorPad; });
$parcel$export(module.exports, "Mod", function () { return (parcelRequire("9BGT9")).Mod; });
$parcel$export(module.exports, "Multinomial", function () { return (parcelRequire("9BGT9")).Multinomial; });
$parcel$export(module.exports, "Multiply", function () { return (parcelRequire("9BGT9")).Multiply; });
$parcel$export(module.exports, "Neg", function () { return (parcelRequire("9BGT9")).Neg; });
$parcel$export(module.exports, "NonMaxSuppressionV3", function () { return (parcelRequire("9BGT9")).NonMaxSuppressionV3; });
$parcel$export(module.exports, "NonMaxSuppressionV4", function () { return (parcelRequire("9BGT9")).NonMaxSuppressionV4; });
$parcel$export(module.exports, "NonMaxSuppressionV5", function () { return (parcelRequire("9BGT9")).NonMaxSuppressionV5; });
$parcel$export(module.exports, "NotEqual", function () { return (parcelRequire("9BGT9")).NotEqual; });
$parcel$export(module.exports, "OneHot", function () { return (parcelRequire("9BGT9")).OneHot; });
$parcel$export(module.exports, "OnesLike", function () { return (parcelRequire("9BGT9")).OnesLike; });
$parcel$export(module.exports, "Pack", function () { return (parcelRequire("9BGT9")).Pack; });
$parcel$export(module.exports, "PadV2", function () { return (parcelRequire("9BGT9")).PadV2; });
$parcel$export(module.exports, "Pow", function () { return (parcelRequire("9BGT9")).Pow; });
$parcel$export(module.exports, "Prelu", function () { return (parcelRequire("9BGT9")).Prelu; });
$parcel$export(module.exports, "Prod", function () { return (parcelRequire("9BGT9")).Prod; });
$parcel$export(module.exports, "RaggedGather", function () { return (parcelRequire("9BGT9")).RaggedGather; });
$parcel$export(module.exports, "RaggedRange", function () { return (parcelRequire("9BGT9")).RaggedRange; });
$parcel$export(module.exports, "RaggedTensorToTensor", function () { return (parcelRequire("9BGT9")).RaggedTensorToTensor; });
$parcel$export(module.exports, "Range", function () { return (parcelRequire("9BGT9")).Range; });
$parcel$export(module.exports, "Real", function () { return (parcelRequire("9BGT9")).Real; });
$parcel$export(module.exports, "RealDiv", function () { return (parcelRequire("9BGT9")).RealDiv; });
$parcel$export(module.exports, "Reciprocal", function () { return (parcelRequire("9BGT9")).Reciprocal; });
$parcel$export(module.exports, "Relu", function () { return (parcelRequire("9BGT9")).Relu; });
$parcel$export(module.exports, "Relu6", function () { return (parcelRequire("9BGT9")).Relu6; });
$parcel$export(module.exports, "Reshape", function () { return (parcelRequire("9BGT9")).Reshape; });
$parcel$export(module.exports, "ResizeBilinear", function () { return (parcelRequire("9BGT9")).ResizeBilinear; });
$parcel$export(module.exports, "ResizeBilinearGrad", function () { return (parcelRequire("9BGT9")).ResizeBilinearGrad; });
$parcel$export(module.exports, "ResizeNearestNeighbor", function () { return (parcelRequire("9BGT9")).ResizeNearestNeighbor; });
$parcel$export(module.exports, "ResizeNearestNeighborGrad", function () { return (parcelRequire("9BGT9")).ResizeNearestNeighborGrad; });
$parcel$export(module.exports, "Reverse", function () { return (parcelRequire("9BGT9")).Reverse; });
$parcel$export(module.exports, "RotateWithOffset", function () { return (parcelRequire("9BGT9")).RotateWithOffset; });
$parcel$export(module.exports, "Round", function () { return (parcelRequire("9BGT9")).Round; });
$parcel$export(module.exports, "Rsqrt", function () { return (parcelRequire("9BGT9")).Rsqrt; });
$parcel$export(module.exports, "ScatterNd", function () { return (parcelRequire("9BGT9")).ScatterNd; });
$parcel$export(module.exports, "SearchSorted", function () { return (parcelRequire("9BGT9")).SearchSorted; });
$parcel$export(module.exports, "Select", function () { return (parcelRequire("9BGT9")).Select; });
$parcel$export(module.exports, "Selu", function () { return (parcelRequire("9BGT9")).Selu; });
$parcel$export(module.exports, "Sigmoid", function () { return (parcelRequire("9BGT9")).Sigmoid; });
$parcel$export(module.exports, "Sign", function () { return (parcelRequire("9BGT9")).Sign; });
$parcel$export(module.exports, "Sin", function () { return (parcelRequire("9BGT9")).Sin; });
$parcel$export(module.exports, "Sinh", function () { return (parcelRequire("9BGT9")).Sinh; });
$parcel$export(module.exports, "Slice", function () { return (parcelRequire("9BGT9")).Slice; });
$parcel$export(module.exports, "Softmax", function () { return (parcelRequire("9BGT9")).Softmax; });
$parcel$export(module.exports, "Softplus", function () { return (parcelRequire("9BGT9")).Softplus; });
$parcel$export(module.exports, "SpaceToBatchND", function () { return (parcelRequire("9BGT9")).SpaceToBatchND; });
$parcel$export(module.exports, "SparseFillEmptyRows", function () { return (parcelRequire("9BGT9")).SparseFillEmptyRows; });
$parcel$export(module.exports, "SparseReshape", function () { return (parcelRequire("9BGT9")).SparseReshape; });
$parcel$export(module.exports, "SparseSegmentMean", function () { return (parcelRequire("9BGT9")).SparseSegmentMean; });
$parcel$export(module.exports, "SparseSegmentSum", function () { return (parcelRequire("9BGT9")).SparseSegmentSum; });
$parcel$export(module.exports, "SparseToDense", function () { return (parcelRequire("9BGT9")).SparseToDense; });
$parcel$export(module.exports, "SplitV", function () { return (parcelRequire("9BGT9")).SplitV; });
$parcel$export(module.exports, "Sqrt", function () { return (parcelRequire("9BGT9")).Sqrt; });
$parcel$export(module.exports, "Square", function () { return (parcelRequire("9BGT9")).Square; });
$parcel$export(module.exports, "SquaredDifference", function () { return (parcelRequire("9BGT9")).SquaredDifference; });
$parcel$export(module.exports, "StaticRegexReplace", function () { return (parcelRequire("9BGT9")).StaticRegexReplace; });
$parcel$export(module.exports, "Step", function () { return (parcelRequire("9BGT9")).Step; });
$parcel$export(module.exports, "StridedSlice", function () { return (parcelRequire("9BGT9")).StridedSlice; });
$parcel$export(module.exports, "StringNGrams", function () { return (parcelRequire("9BGT9")).StringNGrams; });
$parcel$export(module.exports, "StringSplit", function () { return (parcelRequire("9BGT9")).StringSplit; });
$parcel$export(module.exports, "StringToHashBucketFast", function () { return (parcelRequire("9BGT9")).StringToHashBucketFast; });
$parcel$export(module.exports, "Sub", function () { return (parcelRequire("9BGT9")).Sub; });
$parcel$export(module.exports, "Sum", function () { return (parcelRequire("9BGT9")).Sum; });
$parcel$export(module.exports, "Tan", function () { return (parcelRequire("9BGT9")).Tan; });
$parcel$export(module.exports, "Tanh", function () { return (parcelRequire("9BGT9")).Tanh; });
$parcel$export(module.exports, "TensorScatterUpdate", function () { return (parcelRequire("9BGT9")).TensorScatterUpdate; });
$parcel$export(module.exports, "Tile", function () { return (parcelRequire("9BGT9")).Tile; });
$parcel$export(module.exports, "TopK", function () { return (parcelRequire("9BGT9")).TopK; });
$parcel$export(module.exports, "Transform", function () { return (parcelRequire("9BGT9")).Transform; });
$parcel$export(module.exports, "Transpose", function () { return (parcelRequire("9BGT9")).Transpose; });
$parcel$export(module.exports, "Unique", function () { return (parcelRequire("9BGT9")).Unique; });
$parcel$export(module.exports, "Unpack", function () { return (parcelRequire("9BGT9")).Unpack; });
$parcel$export(module.exports, "UnsortedSegmentSum", function () { return (parcelRequire("9BGT9")).UnsortedSegmentSum; });
$parcel$export(module.exports, "ZerosLike", function () { return (parcelRequire("9BGT9")).ZerosLike; });
$parcel$export(module.exports, "abs", function () { return (parcelRequire("57D4R")).abs; });
$parcel$export(module.exports, "add", function () { return (parcelRequire("6Ab5n")).add; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("c3y0I")).all; });
$parcel$export(module.exports, "any", function () { return (parcelRequire("dODwI")).any; });
$parcel$export(module.exports, "argMax", function () { return (parcelRequire("kRlq3")).argMax; });
$parcel$export(module.exports, "avgPool", function () { return (parcelRequire("4LG6a")).avgPool; });
$parcel$export(module.exports, "avgPool3d", function () { return (parcelRequire("dTgsp")).avgPool3d; });
$parcel$export(module.exports, "backend", function () { return (parcelRequire("d7Nxs")).backend; });
$parcel$export(module.exports, "dispose", function () { return (parcelRequire("d7Nxs")).dispose; });
$parcel$export(module.exports, "engine", function () { return (parcelRequire("d7Nxs")).engine; });
$parcel$export(module.exports, "keep", function () { return (parcelRequire("d7Nxs")).keep; });
$parcel$export(module.exports, "memory", function () { return (parcelRequire("d7Nxs")).memory; });
$parcel$export(module.exports, "registerBackend", function () { return (parcelRequire("d7Nxs")).registerBackend; });
$parcel$export(module.exports, "setBackend", function () { return (parcelRequire("d7Nxs")).setBackend; });
$parcel$export(module.exports, "tidy", function () { return (parcelRequire("d7Nxs")).tidy; });
$parcel$export(module.exports, "batchNorm2d", function () { return (parcelRequire("cgFzb")).batchNorm2d; });
$parcel$export(module.exports, "batchNorm3d", function () { return (parcelRequire("hBBSw")).batchNorm3d; });
$parcel$export(module.exports, "batchNorm4d", function () { return (parcelRequire("5JMTM")).batchNorm4d; });
$parcel$export(module.exports, "broadcastTo", function () { return (parcelRequire("bMTXt")).broadcastTo; });
$parcel$export(module.exports, "buffer", function () { return (parcelRequire("5siju")).buffer; });
$parcel$export(module.exports, "cast", function () { return (parcelRequire("fxiHg")).cast; });
$parcel$export(module.exports, "clipByValue", function () { return (parcelRequire("iAQYk")).clipByValue; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("ek4FP")).clone; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("1goxr")).concat; });
$parcel$export(module.exports, "concat1d", function () { return (parcelRequire("j5YCL")).concat1d; });
$parcel$export(module.exports, "concat2d", function () { return (parcelRequire("kEtq4")).concat2d; });
$parcel$export(module.exports, "concat3d", function () { return (parcelRequire("601hZ")).concat3d; });
$parcel$export(module.exports, "concat4d", function () { return (parcelRequire("30mc4")).concat4d; });
$parcel$export(module.exports, "conv1d", function () { return (parcelRequire("7vGQw")).conv1d; });
$parcel$export(module.exports, "conv2d", function () { return (parcelRequire("9JluG")).conv2d; });
$parcel$export(module.exports, "conv2dTranspose", function () { return (parcelRequire("gVSKY")).conv2dTranspose; });
$parcel$export(module.exports, "conv3d", function () { return (parcelRequire("4B9eF")).conv3d; });
$parcel$export(module.exports, "conv3dTranspose", function () { return (parcelRequire("lqPND")).conv3dTranspose; });
$parcel$export(module.exports, "DataStorage", function () { return (parcelRequire("2vCd3")).DataStorage; });
$parcel$export(module.exports, "KernelBackend", function () { return (parcelRequire("2vCd3")).KernelBackend; });
$parcel$export(module.exports, "denseBincount", function () { return (parcelRequire("dzBZ1")).denseBincount; });
$parcel$export(module.exports, "depthwiseConv2d", function () { return (parcelRequire("kQqya")).depthwiseConv2d; });
$parcel$export(module.exports, "div", function () { return (parcelRequire("dIChU")).div; });
$parcel$export(module.exports, "elu", function () { return (parcelRequire("4YAd3")).elu; });
$parcel$export(module.exports, "env", function () { return (parcelRequire("tdutJ")).env; });
$parcel$export(module.exports, "equal", function () { return (parcelRequire("28GAP")).equal; });
$parcel$export(module.exports, "erf", function () { return (parcelRequire("86rqz")).erf; });
$parcel$export(module.exports, "exp", function () { return (parcelRequire("1lCoz")).exp; });
$parcel$export(module.exports, "expandDims", function () { return (parcelRequire("fO4kJ")).expandDims; });
$parcel$export(module.exports, "eye", function () { return (parcelRequire("8YZZT")).eye; });
$parcel$export(module.exports, "fill", function () { return (parcelRequire("2d2dF")).fill; });
$parcel$export(module.exports, "floor", function () { return (parcelRequire("3k4XX")).floor; });
$parcel$export(module.exports, "gather", function () { return (parcelRequire("eFeE9")).gather; });
$parcel$export(module.exports, "greater", function () { return (parcelRequire("lOlhm")).greater; });
$parcel$export(module.exports, "greaterEqual", function () { return (parcelRequire("kKLvn")).greaterEqual; });
$parcel$export(module.exports, "leakyRelu", function () { return (parcelRequire("kFoUG")).leakyRelu; });
$parcel$export(module.exports, "log", function () { return (parcelRequire("1gLFX")).log; });
$parcel$export(module.exports, "log1p", function () { return (parcelRequire("ifd1X")).log1p; });
$parcel$export(module.exports, "logicalAnd", function () { return (parcelRequire("gXTMu")).logicalAnd; });
$parcel$export(module.exports, "logSoftmax", function () { return (parcelRequire("2vk2B")).logSoftmax; });
$parcel$export(module.exports, "logSumExp", function () { return (parcelRequire("1UrMu")).logSumExp; });
$parcel$export(module.exports, "matMul", function () { return (parcelRequire("VLFo8")).matMul; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("9GR6N")).max; });
$parcel$export(module.exports, "maximum", function () { return (parcelRequire("jRQ3p")).maximum; });
$parcel$export(module.exports, "maxPool", function () { return (parcelRequire("kHqOQ")).maxPool; });
$parcel$export(module.exports, "maxPool3d", function () { return (parcelRequire("hG9Ff")).maxPool3d; });
$parcel$export(module.exports, "mean", function () { return (parcelRequire("3TgHP")).mean; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("1KFHq")).min; });
$parcel$export(module.exports, "minimum", function () { return (parcelRequire("7es6p")).minimum; });
$parcel$export(module.exports, "moments", function () { return (parcelRequire("lImqN")).moments; });
$parcel$export(module.exports, "mul", function () { return (parcelRequire("5hAos")).mul; });
$parcel$export(module.exports, "neg", function () { return (parcelRequire("jMlCE")).neg; });
$parcel$export(module.exports, "nextFrame", function () { return (parcelRequire("k22sw")).nextFrame; });
$parcel$export(module.exports, "notEqual", function () { return (parcelRequire("8BIHZ")).notEqual; });
$parcel$export(module.exports, "oneHot", function () { return (parcelRequire("7k013")).oneHot; });
$parcel$export(module.exports, "ones", function () { return (parcelRequire("K2k22")).ones; });
$parcel$export(module.exports, "onesLike", function () { return (parcelRequire("6zg0w")).onesLike; });
$parcel$export(module.exports, "Optimizer", function () { return (parcelRequire("2jiJm")).Optimizer; });
$parcel$export(module.exports, "pad", function () { return (parcelRequire("9XHOJ")).pad; });
$parcel$export(module.exports, "pow", function () { return (parcelRequire("eCViQ")).pow; });
$parcel$export(module.exports, "prelu", function () { return (parcelRequire("8b5dq")).prelu; });
$parcel$export(module.exports, "randomNormal", function () { return (parcelRequire("kaIUV")).randomNormal; });
$parcel$export(module.exports, "randomUniform", function () { return (parcelRequire("9ORo6")).randomUniform; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("kh5mA")).range; });
$parcel$export(module.exports, "registerKernel", function () { return (parcelRequire("fPoI0")).registerKernel; });
$parcel$export(module.exports, "relu", function () { return (parcelRequire("aQaR3")).relu; });
$parcel$export(module.exports, "reshape", function () { return (parcelRequire("8nMOl")).reshape; });
$parcel$export(module.exports, "reverse", function () { return (parcelRequire("5ApPj")).reverse; });
$parcel$export(module.exports, "scalar", function () { return (parcelRequire("7hONX")).scalar; });
$parcel$export(module.exports, "selu", function () { return (parcelRequire("6DicT")).selu; });
$parcel$export(module.exports, "separableConv2d", function () { return (parcelRequire("2ICVg")).separableConv2d; });
$parcel$export(module.exports, "sigmoid", function () { return (parcelRequire("dzpno")).sigmoid; });
$parcel$export(module.exports, "slice", function () { return (parcelRequire("l7afw")).slice; });
$parcel$export(module.exports, "slice1d", function () { return (parcelRequire("c8zsf")).slice1d; });
$parcel$export(module.exports, "slice2d", function () { return (parcelRequire("kzTOv")).slice2d; });
$parcel$export(module.exports, "slice3d", function () { return (parcelRequire("gaDoi")).slice3d; });
$parcel$export(module.exports, "slice4d", function () { return (parcelRequire("6aiGU")).slice4d; });
$parcel$export(module.exports, "softmax", function () { return (parcelRequire("2J1JW")).softmax; });
$parcel$export(module.exports, "softplus", function () { return (parcelRequire("11Nx5")).softplus; });
$parcel$export(module.exports, "split", function () { return (parcelRequire("crriC")).split; });
$parcel$export(module.exports, "sqrt", function () { return (parcelRequire("g3lev")).sqrt; });
$parcel$export(module.exports, "squeeze", function () { return (parcelRequire("gP42y")).squeeze; });
$parcel$export(module.exports, "stack", function () { return (parcelRequire("lq9U1")).stack; });
$parcel$export(module.exports, "sub", function () { return (parcelRequire("5jGN9")).sub; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("fPnAL")).sum; });
$parcel$export(module.exports, "sumOutType", function () { return (parcelRequire("kKv2E")).sumOutType; });
$parcel$export(module.exports, "upcastType", function () { return (parcelRequire("kKv2E")).upcastType; });
$parcel$export(module.exports, "tanh", function () { return (parcelRequire("cJm46")).tanh; });
$parcel$export(module.exports, "tensor", function () { return (parcelRequire("eZfvk")).tensor; });
$parcel$export(module.exports, "Tensor", function () { return (parcelRequire("3pVUH")).Tensor; });
$parcel$export(module.exports, "TensorBuffer", function () { return (parcelRequire("3pVUH")).TensorBuffer; });
$parcel$export(module.exports, "tensor1d", function () { return (parcelRequire("8tOOR")).tensor1d; });
$parcel$export(module.exports, "tensor2d", function () { return (parcelRequire("9NdGd")).tensor2d; });
$parcel$export(module.exports, "tile", function () { return (parcelRequire("dolPi")).tile; });
$parcel$export(module.exports, "train", function () { return (parcelRequire("1d10n")).train; });
$parcel$export(module.exports, "truncatedNormal", function () { return (parcelRequire("9VTJm")).truncatedNormal; });
$parcel$export(module.exports, "unstack", function () { return (parcelRequire("3mzDh")).unstack; });
$parcel$export(module.exports, "variable", function () { return (parcelRequire("ftQEj")).variable; });
$parcel$export(module.exports, "variableGrads", function () { return (parcelRequire("1Npyr")).variableGrads; });
$parcel$export(module.exports, "where", function () { return (parcelRequire("3A1QZ")).where; });
$parcel$export(module.exports, "zeros", function () { return (parcelRequire("lxzgt")).zeros; });
$parcel$export(module.exports, "zerosLike", function () { return (parcelRequire("cztsD")).zerosLike; });

$parcel$export(module.exports, "backend_util", function () { return (parcelRequire("dEVRx")); });
$parcel$export(module.exports, "broadcast_util", function () { return (parcelRequire("5mf1d")); });
$parcel$export(module.exports, "browser", function () { return (parcelRequire("iVJWR")); });
$parcel$export(module.exports, "device_util", function () { return (parcelRequire("egPzb")); });
$parcel$export(module.exports, "fused", function () { return (parcelRequire("eJ7TQ")); });
$parcel$export(module.exports, "io", function () { return (parcelRequire("feqcJ")); });
$parcel$export(module.exports, "kernel_impls", function () { return (parcelRequire("iEnT2")); });
$parcel$export(module.exports, "serialization", function () { return (parcelRequire("ki3lz")); });
$parcel$export(module.exports, "slice_util", function () { return (parcelRequire("iEcDD")); });
$parcel$export(module.exports, "tensor_util", function () { return (parcelRequire("gpWQN")); });
$parcel$export(module.exports, "util", function () { return (parcelRequire("lBDHD")); });
$parcel$export(module.exports, "version_core", function () { return (parcelRequire("3YsQX")).version; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code.
parcelRequire("9pNhm");

var $8WiHb = parcelRequire("8WiHb");
parcelRequire("9BGT9");parcelRequire("57D4R");parcelRequire("6Ab5n");parcelRequire("c3y0I");parcelRequire("dODwI");parcelRequire("kRlq3");parcelRequire("4LG6a");parcelRequire("dTgsp");parcelRequire("d7Nxs");
var $dEVRx = parcelRequire("dEVRx");parcelRequire("cgFzb");parcelRequire("hBBSw");parcelRequire("5JMTM");
var $5mf1d = parcelRequire("5mf1d");parcelRequire("bMTXt");
var $iVJWR = parcelRequire("iVJWR");parcelRequire("5siju");parcelRequire("fxiHg");parcelRequire("iAQYk");parcelRequire("ek4FP");parcelRequire("1goxr");parcelRequire("j5YCL");parcelRequire("kEtq4");parcelRequire("601hZ");parcelRequire("30mc4");parcelRequire("7vGQw");parcelRequire("9JluG");parcelRequire("gVSKY");parcelRequire("4B9eF");parcelRequire("lqPND");parcelRequire("2vCd3");parcelRequire("dzBZ1");parcelRequire("kQqya");
var $egPzb = parcelRequire("egPzb");parcelRequire("dIChU");
var $e1QJV = parcelRequire("e1QJV");parcelRequire("4YAd3");parcelRequire("tdutJ");parcelRequire("28GAP");parcelRequire("86rqz");parcelRequire("1lCoz");parcelRequire("fO4kJ");parcelRequire("8YZZT");parcelRequire("2d2dF");parcelRequire("3k4XX");
var $eJ7TQ = parcelRequire("eJ7TQ");parcelRequire("eFeE9");parcelRequire("lOlhm");parcelRequire("kKLvn");
var $4I5dI = parcelRequire("4I5dI");
var $feqcJ = parcelRequire("feqcJ");
var $iEnT2 = parcelRequire("iEnT2");parcelRequire("kFoUG");parcelRequire("1gLFX");parcelRequire("ifd1X");parcelRequire("gXTMu");parcelRequire("2vk2B");parcelRequire("1UrMu");parcelRequire("VLFo8");parcelRequire("9GR6N");parcelRequire("jRQ3p");parcelRequire("kHqOQ");parcelRequire("hG9Ff");parcelRequire("3TgHP");parcelRequire("1KFHq");parcelRequire("7es6p");parcelRequire("lImqN");parcelRequire("5hAos");parcelRequire("jMlCE");parcelRequire("k22sw");parcelRequire("8BIHZ");parcelRequire("7k013");parcelRequire("K2k22");parcelRequire("6zg0w");parcelRequire("2jiJm");parcelRequire("9XHOJ");parcelRequire("eCViQ");parcelRequire("8b5dq");parcelRequire("kaIUV");parcelRequire("9ORo6");parcelRequire("kh5mA");parcelRequire("fPoI0");parcelRequire("aQaR3");parcelRequire("8nMOl");parcelRequire("5ApPj");parcelRequire("7hONX");parcelRequire("6DicT");parcelRequire("2ICVg");
var $ki3lz = parcelRequire("ki3lz");parcelRequire("dzpno");parcelRequire("l7afw");
var $iEcDD = parcelRequire("iEcDD");parcelRequire("c8zsf");parcelRequire("kzTOv");parcelRequire("gaDoi");parcelRequire("6aiGU");parcelRequire("2J1JW");parcelRequire("11Nx5");parcelRequire("crriC");parcelRequire("g3lev");parcelRequire("gP42y");parcelRequire("lq9U1");parcelRequire("5jGN9");parcelRequire("fPnAL");parcelRequire("kKv2E");parcelRequire("cJm46");parcelRequire("eZfvk");parcelRequire("3pVUH");
var $gpWQN = parcelRequire("gpWQN");parcelRequire("8tOOR");parcelRequire("9NdGd");parcelRequire("dolPi");parcelRequire("1d10n");
var $9c2so = parcelRequire("9c2so");parcelRequire("9VTJm");parcelRequire("3mzDh");
var $lBDHD = parcelRequire("lBDHD");parcelRequire("ftQEj");parcelRequire("1Npyr");
var $3YsQX = parcelRequire("3YsQX");parcelRequire("3A1QZ");parcelRequire("lxzgt");parcelRequire("cztsD");
(0, $8WiHb.registerOptimizers)();
$parcel$exportWildcard(module.exports, $e1QJV);
$parcel$exportWildcard(module.exports, $4I5dI);
$parcel$exportWildcard(module.exports, $9c2so);

});
parcelRegister("9pNhm", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Required side effectful code for tfjs-core
// Set up Engine and ENV

var $e6Ey6 = parcelRequire("e6Ey6");
parcelRequire("fJy9j");
parcelRequire("1T16V");
parcelRequire("8RL6x");

var $5siju = parcelRequire("5siju");

var $fxiHg = parcelRequire("fxiHg");

var $ek4FP = parcelRequire("ek4FP");

var $iM8Nn = parcelRequire("iM8Nn");

var $3pVUH = parcelRequire("3pVUH");
(0, $e6Ey6.getOrMakeEngine)();
const $6dacacaa1cbc08ef$var$opHandler = {
    buffer: $5siju.buffer,
    cast: $fxiHg.cast,
    clone: $ek4FP.clone,
    print: $iM8Nn.print
};
(0, $3pVUH.setOpHandler)($6dacacaa1cbc08ef$var$opHandler);

});
parcelRegister("e6Ey6", function(module, exports) {

$parcel$export(module.exports, "ENGINE", function () { return $a451146aa29932d6$export$33b63313cc511a3b; });
$parcel$export(module.exports, "getOrMakeEngine", function () { return $a451146aa29932d6$export$ca8737f6c8c212b8; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2vCd3 = parcelRequire("2vCd3");

var $tdutJ = parcelRequire("tdutJ");

var $hri9Y = parcelRequire("hri9Y");

var $9BGT9 = parcelRequire("9BGT9");

var $fPoI0 = parcelRequire("fPoI0");

var $8Tale = parcelRequire("8Tale");

var $crjA3 = parcelRequire("crjA3");

var $9jvFp = parcelRequire("9jvFp");

var $3pVUH = parcelRequire("3pVUH");

var $gpWQN = parcelRequire("gpWQN");

var $eOiOM = parcelRequire("eOiOM");
var $lBDHD = parcelRequire("lBDHD");
function $a451146aa29932d6$var$isRegisteredKernelInvocation(kernelInvocation) {
    return kernelInvocation.kernelName != null;
}
class $a451146aa29932d6$var$EngineState {
    constructor(){
        // Public since optimizers will use it.
        this.registeredVariables = {};
        this.nextTapeNodeId = 0;
        this.numBytes = 0;
        this.numTensors = 0;
        this.numStringTensors = 0;
        this.numDataBuffers = 0;
        // Number of nested tf.grad() statements when computing higher-order
        // gradients. E.g. `1` for first-order gradients and `2` for second-order
        // gradients. Used to track if the tape should be removed after a backprop.
        this.gradientDepth = 0;
        // Number of nested kernel calls. When kernel depth is greater than 1, we turn
        // off the tape.
        this.kernelDepth = 0;
        this.scopeStack = [];
        /**
         * Keeps track of the number of data moves during a kernel execution. We
         * maintain a stack since kernels can call other kernels, recursively.
         */ this.numDataMovesStack = [];
        this.nextScopeId = 0;
        this.tensorInfo = new WeakMap();
        this.profiling = false;
        this.activeProfile = {
            newBytes: 0,
            newTensors: 0,
            peakBytes: 0,
            kernels: [],
            result: null,
            get kernelNames () {
                return Array.from(new Set(this.kernels.map((k)=>k.name)));
            }
        };
    }
    dispose() {
        for(const variableName in this.registeredVariables)this.registeredVariables[variableName].dispose();
    }
}
class $a451146aa29932d6$export$2c3b404bf3a77a1f {
    constructor(ENV){
        this.ENV = ENV;
        this.registry = {};
        this.registryFactory = {};
        this.pendingBackendInitId = 0;
        this.state = new $a451146aa29932d6$var$EngineState();
    }
    async ready() {
        if (this.pendingBackendInit != null) return this.pendingBackendInit.then(()=>{});
        if (this.backendInstance != null) return;
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const success = await this.initializeBackend(backendName).success;
            if (success) {
                await this.setBackend(backendName);
                return;
            }
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    get backend() {
        if (this.pendingBackendInit != null) throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make ` + `sure to await tf.ready() or await tf.setBackend() before calling ` + `other methods`);
        if (this.backendInstance == null) {
            const { name: name, asyncInit: asyncInit } = this.initializeBackendsAndReturnBest();
            if (asyncInit) throw new Error(`The highest priority backend '${name}' has not yet been ` + `initialized. Make sure to await tf.ready() or ` + `await tf.setBackend() before calling other methods`);
            this.setBackend(name);
        }
        return this.backendInstance;
    }
    backendNames() {
        return Object.keys(this.registryFactory);
    }
    findBackend(backendName) {
        if (!(backendName in this.registry)) {
            // If the backend hasn't been initialized but we have a registry entry for
            // it, initialize it and return it.
            if (backendName in this.registryFactory) {
                const { asyncInit: asyncInit } = this.initializeBackend(backendName);
                if (asyncInit) // Backend is not ready yet.
                return null;
            } else return null;
        }
        return this.registry[backendName];
    }
    findBackendFactory(backendName) {
        if (!(backendName in this.registryFactory)) return null;
        return this.registryFactory[backendName].factory;
    }
    registerBackend(backendName, factory, priority = 1) {
        if (backendName in this.registryFactory) {
            $8Tale.warn(`${backendName} backend was already registered. ` + `Reusing existing backend factory.`);
            return false;
        }
        this.registryFactory[backendName] = {
            factory: factory,
            priority: priority
        };
        return true;
    }
    async setBackend(backendName) {
        if (this.registryFactory[backendName] == null) throw new Error(`Backend name '${backendName}' not found in registry`);
        this.backendName = backendName;
        if (this.registry[backendName] == null) {
            this.backendInstance = null;
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            const result = asyncInit ? await success : success;
            if (!result) return false;
        }
        this.backendInstance = this.registry[backendName];
        this.setupRegisteredKernels();
        // Reset the profiler.
        this.profiler = new (0, $crjA3.Profiler)(this.backendInstance);
        return true;
    }
    setupRegisteredKernels() {
        const kernels = (0, $fPoI0.getKernelsForBackend)(this.backendName);
        kernels.forEach((kernel)=>{
            if (kernel.setupFunc != null) kernel.setupFunc(this.backendInstance);
        });
    }
    disposeRegisteredKernels(backendName) {
        const kernels = (0, $fPoI0.getKernelsForBackend)(backendName);
        kernels.forEach((kernel)=>{
            if (kernel.disposeFunc != null) kernel.disposeFunc(this.registry[backendName]);
        });
    }
    /**
     * Initializes a backend by looking up the backend name in the factory
     * registry and calling the factory method. Returns a boolean representing
     * whether the initialization of the backend succeeded. Throws an error if
     * there is no backend in the factory registry.
     */ initializeBackend(backendName) {
        const registryFactoryEntry = this.registryFactory[backendName];
        if (registryFactoryEntry == null) throw new Error(`Cannot initialize backend ${backendName}, no registration found.`);
        try {
            const backend = registryFactoryEntry.factory();
            /* Test if the factory returns a promise.
            Done in a more liberal way than
            previous 'Promise.resolve(backend)===backend'
            as we needed to account for custom Promise
            implementations (e.g. Angular) */ if (backend && !(backend instanceof (0, $2vCd3.KernelBackend)) && typeof backend.then === 'function') {
                const promiseId = ++this.pendingBackendInitId;
                const success = backend.then((backendInstance)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.registry[backendName] = backendInstance;
                    this.pendingBackendInit = null;
                    return true;
                }).catch((err)=>{
                    // Outdated promise. Another backend was set in the meantime.
                    if (promiseId < this.pendingBackendInitId) return false;
                    this.pendingBackendInit = null;
                    $8Tale.warn(`Initialization of backend ${backendName} failed`);
                    $8Tale.warn(err.stack || err.message);
                    return false;
                });
                this.pendingBackendInit = success;
                return {
                    success: success,
                    asyncInit: true
                };
            } else {
                this.registry[backendName] = backend;
                return {
                    success: true,
                    asyncInit: false
                };
            }
        } catch (err) {
            $8Tale.warn(`Initialization of backend ${backendName} failed`);
            $8Tale.warn(err.stack || err.message);
            return {
                success: false,
                asyncInit: false
            };
        }
    }
    removeBackend(backendName) {
        if (!(backendName in this.registryFactory)) throw new Error(`${backendName} backend not found in registry`);
        if (this.backendName === backendName && this.pendingBackendInit != null) // There is a pending promise of the backend we want to remove. Make it
        // obsolete.
        this.pendingBackendInitId++;
        if (backendName in this.registry) {
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        delete this.registryFactory[backendName];
        // Unset the backend if it is active.
        if (this.backendName === backendName) {
            this.pendingBackendInit = null;
            this.backendName = null;
            this.backendInstance = null;
        }
    }
    getSortedBackends() {
        if (Object.keys(this.registryFactory).length === 0) throw new Error('No backend found in registry.');
        return Object.keys(this.registryFactory).sort((a, b)=>{
            // Highest priority comes first.
            return this.registryFactory[b].priority - this.registryFactory[a].priority;
        });
    }
    initializeBackendsAndReturnBest() {
        const sortedBackends = this.getSortedBackends();
        for(let i = 0; i < sortedBackends.length; i++){
            const backendName = sortedBackends[i];
            const { success: success, asyncInit: asyncInit } = this.initializeBackend(backendName);
            if (asyncInit || success) return {
                name: backendName,
                asyncInit: asyncInit
            };
        }
        throw new Error(`Could not initialize any backends, all backend initializations ` + `failed.`);
    }
    moveData(backend, dataId) {
        const info = this.state.tensorInfo.get(dataId);
        const srcBackend = info.backend;
        const values = this.readSync(dataId);
        const refCount = srcBackend.refCount(dataId);
        // Delete the tensor from the old backend and move it to the new
        // backend.
        srcBackend.disposeData(dataId, true);
        info.backend = backend;
        backend.move(dataId, values, info.shape, info.dtype, refCount);
        if (this.shouldCheckForMemLeaks()) // Track the number of moves during a kernel execution to correctly
        // detect memory leaks.
        this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++;
    }
    tidy(nameOrFn, fn) {
        let name = null;
        if (fn == null) {
            // Called with only 1 argument.
            if (typeof nameOrFn !== 'function') throw new Error('Please provide a function to tidy()');
            fn = nameOrFn;
        } else {
            // Called with 2 arguments.
            if (typeof nameOrFn !== 'string' && !(nameOrFn instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
            if (typeof fn !== 'function') throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
            name = nameOrFn;
        // TODO(nsthorat,smilkov): Do operation logging and performance
        // profiling.
        }
        let result;
        return this.scopedRun(()=>this.startScope(name), ()=>this.endScope(result), ()=>{
            result = fn();
            if (result instanceof Promise) console.error('Cannot return a Promise inside of tidy.');
            return result;
        });
    }
    scopedRun(start, end, f) {
        start();
        try {
            const res = f();
            end();
            return res;
        } catch (ex) {
            end();
            throw ex;
        }
    }
    nextTensorId() {
        return $a451146aa29932d6$export$2c3b404bf3a77a1f.nextTensorId++;
    }
    nextVariableId() {
        return $a451146aa29932d6$export$2c3b404bf3a77a1f.nextVariableId++;
    }
    /**
     * This method is called instead of the public-facing tensor.clone() when
     * saving a tensor for backwards pass. It makes sure to add the clone
     * operation to the tape regardless of being called inside a kernel
     * execution.
     */ clone(x) {
        const y = $a451146aa29932d6$export$33b63313cc511a3b.runKernel((0, $9BGT9.Identity), {
            x: x
        });
        const inputs = {
            x: x
        };
        const grad = (dy)=>({
                x: ()=>{
                    const dtype = 'float32';
                    const gradInputs = {
                        x: dy
                    };
                    const attrs = {
                        dtype: dtype
                    };
                    return $a451146aa29932d6$export$33b63313cc511a3b.runKernel((0, $9BGT9.Cast), gradInputs, // tslint:disable-next-line: no-unnecessary-type-assertion
                    attrs);
                }
            });
        const saved = [];
        this.addTapeNode(this.state.activeScope.name, inputs, [
            y
        ], grad, saved, {});
        return y;
    }
    /**
     * Execute a kernel with the given name and return the output tensor.
     *
     * @param kernelName The name of the kernel to execute.
     * @param inputs A map of input names to tensors.
     * @param attrs A map of attribute names to their values. An attribute is a
     *     primitive (non-tensor) input to the kernel.
     * @param inputsToSave A list of tensors, inputs to save for the backprop
     *     computation.
     * @param outputsToSave A list of booleans, specifying which output to save
     *     for the backprop computation. These are booleans since the output
     * tensors are not visible to the user.
     */ runKernel(kernelName, inputs, attrs) {
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        const hasKernel = (0, $fPoI0.getKernel)(kernelName, this.backendName) != null;
        if (!hasKernel) throw new Error(`Kernel '${kernelName}' not registered for backend '${this.backendName}'`);
        return this.runKernelFunc({
            kernelName: kernelName,
            inputs: inputs,
            attrs: attrs
        });
    }
    shouldCheckForMemLeaks() {
        return this.ENV.getBool('IS_TEST');
    }
    checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos) {
        const numDataIdsAfter = this.backend.numDataIds();
        // Count the number of data ids associated with the result of the kernel.
        let numOutputDataIds = 0;
        outInfos.forEach((info)=>{
            // Complex numbers allocate 3 data ids, one for 'real', one for
            // 'imaginary', and one for the container that holds the former two.
            numOutputDataIds += info.dtype === 'complex64' ? 3 : 1;
        });
        // Account for the number of moves during kernel execution. A "data move"
        // can happen in the middle of a kernel execution, placing a new (key,value)
        // pair in the data storage. Since data moves have net zero effect (we
        // always remove the data from the old backend), we have to cancel them out
        // when detecting memory leaks.
        const numMoves = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1];
        const dataIdsLeaked = numDataIdsAfter - numDataIdsBefore - numOutputDataIds - numMoves;
        if (dataIdsLeaked > 0) throw new Error(`Backend '${this.backendName}' has an internal memory leak ` + `(${dataIdsLeaked} data ids) after running '${kernelName}'`);
    }
    /**
     * Internal helper method to execute a kernel Func
     *
     * Use `runKernel` to execute kernels from outside of engine.
     */ runKernelFunc(kernelParams) {
        let outputs;
        let saved = [];
        const isTapeOn = this.isTapeOn();
        const startingBytecount = this.state.numBytes;
        const startingNumTensors = this.state.numTensors;
        if (this.shouldCheckForMemLeaks()) this.state.numDataMovesStack.push(0);
        let kernelFunc;
        if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
        // can be deferred until an op/ kernel is run).
        // The below getter has side effects that will try to initialize the
        // backend and set properties like this.backendName
        // tslint:disable-next-line: no-unused-expression
        this.backend;
        let out;
        const kernelOrScopeName = $a451146aa29932d6$var$isRegisteredKernelInvocation(kernelParams) ? kernelParams.kernelName : this.state.activeScope != null ? this.state.activeScope.name : '';
        // Create the kernelFunc from either a registered kernel OR passed in
        // forward/backward functions (used by custom grad). In this context a
        // kernelFunc wraps a kernel implementation with some bookkeeping.
        if ($a451146aa29932d6$var$isRegisteredKernelInvocation(kernelParams)) {
            const { kernelName: kernelName, inputs: inputs, attrs: attrs } = kernelParams;
            if (this.backendName == null) // backend has not been initialized yet (backend initialization is lazy
            // can be deferred until an op/ kernel is run).
            // The below getter has side effects that will try to initialize the
            // backend and set properties like this.backendName
            // tslint:disable-next-line: no-unused-expression
            this.backend;
            const kernel = (0, $fPoI0.getKernel)(kernelName, this.backendName);
            $eOiOM.assert(kernel != null, ()=>`Cannot find registered kernel '${kernelName}' for backend '${this.backendName}'`);
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = kernel.kernelFunc({
                    inputs: inputs,
                    attrs: attrs,
                    backend: this.backend
                });
                const outInfos = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) this.checkKernelForMemLeak(kernelName, numDataIdsBefore, outInfos);
                const outTensors = outInfos.map((outInfo)=>{
                    // todo (yassogba) remove this option (Tensor) when node backend
                    // methods have been modularized and they all return tensorInfo.
                    // TensorInfos do not have a rank attribute.
                    if (outInfo.rank != null) return outInfo;
                    return this.makeTensorFromTensorInfo(outInfo);
                });
                // Save any required inputs and outputs.
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since there would be no backprop for these tensors
                // (which would otherwise dispose them).
                if (isTapeOn) {
                    const tensorsToSave = this.getTensorsForGradient(kernelName, inputs, outTensors);
                    saved = this.saveTensorsForBackwardMode(tensorsToSave);
                }
                return outTensors;
            };
        } else {
            const { forwardFunc: forwardFunc } = kernelParams;
            // Running a customGrad op.
            const saveFunc = (tensors)=>{
                // Do not save unless we are recording to the tape. Otherwise it would
                // cause a mem leak since we would never run backprop, which disposes
                // the kept tensors.
                if (!isTapeOn) return;
                saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
            };
            kernelFunc = ()=>{
                const numDataIdsBefore = this.backend.numDataIds();
                out = this.tidy(()=>forwardFunc(this.backend, saveFunc));
                const outs = Array.isArray(out) ? out : [
                    out
                ];
                if (this.shouldCheckForMemLeaks()) // Scope name is used to print a more helpful error message if needed.
                this.checkKernelForMemLeak(kernelOrScopeName, numDataIdsBefore, outs);
                return outs;
            };
        }
        //
        // Run the kernelFunc. Optionally profiling it.
        //
        const { inputs: inputs, attrs: attrs } = kernelParams;
        const backwardsFunc = $a451146aa29932d6$var$isRegisteredKernelInvocation(kernelParams) ? null : kernelParams.backwardsFunc;
        let kernelProfile;
        this.scopedRun(// Stop recording to a tape when running a kernel.
        ()=>this.state.kernelDepth++, ()=>this.state.kernelDepth--, ()=>{
            if (!this.ENV.getBool('DEBUG') && !this.state.profiling) outputs = kernelFunc();
            else {
                kernelProfile = this.profiler.profileKernel(kernelOrScopeName, inputs, ()=>kernelFunc());
                if (this.ENV.getBool('DEBUG')) this.profiler.logKernelProfile(kernelProfile);
                outputs = kernelProfile.outputs;
            }
        });
        if (isTapeOn) this.addTapeNode(kernelOrScopeName, inputs, outputs, backwardsFunc, saved, attrs);
        if (this.state.profiling) this.state.activeProfile.kernels.push({
            name: kernelOrScopeName,
            bytesAdded: this.state.numBytes - startingBytecount,
            totalBytesSnapshot: this.state.numBytes,
            tensorsAdded: this.state.numTensors - startingNumTensors,
            totalTensorsSnapshot: this.state.numTensors,
            inputShapes: Object.keys(inputs).map((key)=>inputs[key] != null ? inputs[key].shape : null),
            outputShapes: outputs.map((item)=>item.shape),
            kernelTimeMs: kernelProfile.timeMs,
            extraInfo: kernelProfile.extraInfo
        });
        return Array.isArray(out) ? outputs : outputs[0];
    }
    /**
     * Saves tensors used in forward mode for use in backward mode.
     *
     * @param tensors the list of tensors to save.
     */ saveTensorsForBackwardMode(tensors) {
        const saved = tensors.map((tensor)=>this.keep(this.clone(tensor)));
        return saved;
    }
    /**
     * Returns a list of tensors to save for a given gradient calculation.
     *
     * @param kernelName name of kernel to look up gradient for.
     * @param inputs a map of input tensors.
     * @param outputs an array of output tensors from forward mode of kernel.
     */ getTensorsForGradient(kernelName, inputs, outputs) {
        const gradConfig = (0, $fPoI0.getGradient)(kernelName);
        if (gradConfig != null) {
            const inputsToSave = gradConfig.inputsToSave || [];
            const outputsToSave = gradConfig.outputsToSave || [];
            // If saveAllInputs is true, all inputs will be saved. Otherwise, inputs
            // specified in inputsToSave will be saved.
            let inputTensorsToSave;
            if (gradConfig.saveAllInputs) {
                $eOiOM.assert(Array.isArray(inputs), ()=>'saveAllInputs is true, expected inputs to be an array.');
                inputTensorsToSave = Object.keys(inputs).map((key)=>inputs[key]);
            } else inputTensorsToSave = inputsToSave.map((inputName)=>inputs[inputName]);
            const outputTensorsToSave = outputs.filter((_, i)=>outputsToSave[i]);
            return inputTensorsToSave.concat(outputTensorsToSave);
        }
        // We return an empty list rather than throw an error because the kernel we
        // are looking up may not actually be relevant to backproping through the
        // overall function
        //
        // See 'does not error if irrelevant (pruned) ops are missing grads' test
        // in gradients_test.ts for an example.
        return [];
    }
    /**
     * Internal method used by public APIs for tensor creation. Makes a new
     * tensor with the provided shape, dtype and values. It always
     * creates a new data id and writes the values to the underlying backend.
     */ makeTensor(values, shape, dtype, backend) {
        if (values == null) throw new Error('Values passed to engine.makeTensor() are null');
        dtype = dtype || 'float32';
        backend = backend || this.backend;
        let backendVals = values;
        if (dtype === 'string' && $eOiOM.isString(values[0])) backendVals = values.map((d)=>$lBDHD.encodeString(d));
        const dataId = backend.write(backendVals, shape, dtype);
        const t = new (0, $3pVUH.Tensor)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        // Count bytes for string tensors.
        if (dtype === 'string') {
            const info = this.state.tensorInfo.get(dataId);
            const newBytes = (0, $eOiOM.bytesFromStringArray)(backendVals);
            this.state.numBytes += newBytes - info.bytes;
            info.bytes = newBytes;
        }
        return t;
    }
    /**
     * Internal method used by backends. Makes a new tensor
     * that is a wrapper around an existing data id. It doesn't create
     * a new data id, only increments the ref count used in memory tracking.
     * @deprecated
     */ makeTensorFromDataId(dataId, shape, dtype, backend) {
        dtype = dtype || 'float32';
        const tensorInfo = {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
        return this.makeTensorFromTensorInfo(tensorInfo, backend);
    }
    /**
     * Internal method used by backends. Makes a new tensor that is a wrapper
     * around an existing data id in TensorInfo. It doesn't create a new data id,
     * only increments the ref count used in memory tracking.
     */ makeTensorFromTensorInfo(tensorInfo, backend) {
        const { dataId: dataId, shape: shape, dtype: dtype } = tensorInfo;
        const t = new (0, $3pVUH.Tensor)(shape, dtype, dataId, this.nextTensorId());
        this.trackTensor(t, backend);
        return t;
    }
    makeVariable(initialValue, trainable = true, name, dtype) {
        name = name || this.nextVariableId().toString();
        if (dtype != null && dtype !== initialValue.dtype) initialValue = initialValue.cast(dtype);
        const v = new (0, $3pVUH.Variable)(initialValue, trainable, name, this.nextTensorId());
        if (this.state.registeredVariables[v.name] != null) throw new Error(`Variable with name ${v.name} was already registered`);
        this.state.registeredVariables[v.name] = v;
        this.incRef(v, this.backend);
        return v;
    }
    trackTensor(a, backend) {
        this.state.numTensors++;
        if (a.dtype === 'string') this.state.numStringTensors++;
        // Bytes for complex numbers are counted by their components. Bytes for
        // string tensors are counted when writing values.
        let bytes = 0;
        if (a.dtype !== 'complex64' && a.dtype !== 'string') bytes = a.size * $eOiOM.bytesPerElement(a.dtype);
        this.state.numBytes += bytes;
        if (!this.state.tensorInfo.has(a.dataId)) {
            this.state.numDataBuffers++;
            this.state.tensorInfo.set(a.dataId, {
                backend: backend || this.backend,
                dtype: a.dtype,
                shape: a.shape,
                bytes: bytes
            });
        }
        if (!(a instanceof (0, $3pVUH.Variable))) this.track(a);
    }
    // Track the tensor by dataId and increase the refCount for the dataId in the
    // backend.
    // TODO(pyu10055): This is currently used by makeVariable method, to increase
    // refCount on the backend for the dataId. It can potentially be replaced with
    // Identity op indead of calling backend directly.
    incRef(a, backend) {
        this.trackTensor(a, backend);
        this.backend.incRef(a.dataId);
    }
    removeDataId(dataId, backend) {
        if (this.state.tensorInfo.has(dataId) && this.state.tensorInfo.get(dataId).backend === backend) {
            this.state.tensorInfo.delete(dataId);
            this.state.numDataBuffers--;
        }
    }
    disposeTensor(a) {
        if (!this.state.tensorInfo.has(a.dataId)) return;
        const info = this.state.tensorInfo.get(a.dataId);
        this.state.numTensors--;
        if (a.dtype === 'string') {
            this.state.numStringTensors--;
            this.state.numBytes -= info.bytes;
        }
        // Don't count bytes for complex numbers as they are counted by their
        // components.
        if (a.dtype !== 'complex64' && a.dtype !== 'string') {
            const bytes = a.size * $eOiOM.bytesPerElement(a.dtype);
            this.state.numBytes -= bytes;
        }
        // Remove the reference to dataId if backend dispose the data successfully
        if (info.backend.disposeData(a.dataId)) this.removeDataId(a.dataId, info.backend);
    // TODO(nsthorat): Construct an error and save the stack trace for
    // debugging when in debug mode. Creating a stack trace is too expensive
    // to do unconditionally.
    }
    disposeVariables() {
        for(const varName in this.state.registeredVariables){
            const v = this.state.registeredVariables[varName];
            this.disposeVariable(v);
        }
    }
    disposeVariable(v) {
        this.disposeTensor(v);
        if (this.state.registeredVariables[v.name] != null) delete this.state.registeredVariables[v.name];
    }
    memory() {
        const info = this.backend.memory();
        info.numTensors = this.state.numTensors;
        info.numDataBuffers = this.state.numDataBuffers;
        info.numBytes = this.state.numBytes;
        if (this.state.numStringTensors > 0) {
            info.unreliable = true;
            if (info.reasons == null) info.reasons = [];
            info.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)");
        }
        return info;
    }
    async profile(query) {
        this.state.profiling = true;
        const startBytes = this.state.numBytes;
        const startNumTensors = this.state.numTensors;
        this.state.activeProfile.kernels = [];
        this.state.activeProfile.result = await query();
        this.state.profiling = false;
        this.state.activeProfile.peakBytes = Math.max(...this.state.activeProfile.kernels.map((d)=>d.totalBytesSnapshot));
        this.state.activeProfile.newBytes = this.state.numBytes - startBytes;
        this.state.activeProfile.newTensors = this.state.numTensors - startNumTensors;
        for (const kernel of this.state.activeProfile.kernels){
            kernel.kernelTimeMs = await kernel.kernelTimeMs;
            kernel.extraInfo = await kernel.extraInfo;
        }
        return this.state.activeProfile;
    }
    isTapeOn() {
        return this.state.gradientDepth > 0 && this.state.kernelDepth === 0;
    }
    addTapeNode(kernelName, inputs, outputs, gradientsFunc, saved, attrs) {
        const tapeNode = {
            id: this.state.nextTapeNodeId++,
            kernelName: kernelName,
            inputs: inputs,
            outputs: outputs,
            saved: saved
        };
        const gradConfig = (0, $fPoI0.getGradient)(kernelName);
        if (gradConfig != null) gradientsFunc = gradConfig.gradFunc;
        if (gradientsFunc != null) tapeNode.gradient = (dys)=>{
            // TODO(smilkov): To optimize back-prop, pass dys that are not used in
            // the backprop graph to the user as null instead of zeros
            dys = dys.map((dy, i)=>{
                if (dy == null) {
                    const output = outputs[i];
                    const vals = $eOiOM.makeZerosTypedArray(output.size, output.dtype);
                    return this.makeTensor(vals, output.shape, output.dtype);
                }
                return dy;
            });
            // Grad functions of ops with single outputs expect a dy, while ops
            // with multiple outputs expect dys (array of dy).
            return gradientsFunc(dys.length > 1 ? dys : dys[0], saved, attrs);
        };
        this.state.activeTape.push(tapeNode);
    }
    keep(result) {
        result.kept = true;
        return result;
    }
    startTape() {
        if (this.state.gradientDepth === 0) this.state.activeTape = [];
        this.state.gradientDepth++;
    }
    endTape() {
        this.state.gradientDepth--;
    }
    /**
     * Start a scope. Use this with endScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ startScope(name) {
        const scopeInfo = {
            track: [],
            name: 'unnamed scope',
            id: this.state.nextScopeId++
        };
        if (name) scopeInfo.name = name;
        this.state.scopeStack.push(scopeInfo);
        this.state.activeScope = scopeInfo;
    }
    /**
     * End a scope. Use this with startScope() to achieve the same functionality
     * as scope() without the need for a function closure.
     */ endScope(result) {
        const tensorsToTrackInParent = (0, $gpWQN.getTensorsInContainer)(result);
        const tensorsToTrackInParentSet = new Set(tensorsToTrackInParent.map((t)=>t.id));
        // Dispose the arrays tracked in this scope.
        for(let i = 0; i < this.state.activeScope.track.length; i++){
            const tensor = this.state.activeScope.track[i];
            if (!tensor.kept && !tensorsToTrackInParentSet.has(tensor.id)) tensor.dispose();
        }
        const oldScope = this.state.scopeStack.pop();
        this.state.activeScope = this.state.scopeStack.length === 0 ? null : this.state.scopeStack[this.state.scopeStack.length - 1];
        // Track the current result in the parent scope.
        tensorsToTrackInParent.forEach((tensor)=>{
            // Only track the tensor if was allocated in the inner scope and is not
            // globally kept.
            if (!tensor.kept && tensor.scopeId === oldScope.id) this.track(tensor);
        });
    }
    /**
     * Returns gradients of `f` with respect to each of the `xs`. The gradients
     * returned are of the same length as `xs`, but some might be null if `f`
     * was not a function of that `x`. It also takes optional dy to multiply the
     * gradient, which defaults to `1`.
     */ gradients(f, xs, dy, allowNoGradients = false) {
        $eOiOM.assert(xs.length > 0, ()=>'gradients() received an empty list of xs.');
        if (dy != null && dy.dtype !== 'float32') throw new Error(`dy must have 'float32' dtype, but has '${dy.dtype}'`);
        const y = this.scopedRun(()=>this.startTape(), ()=>this.endTape(), ()=>this.tidy('forward', f));
        $eOiOM.assert(y instanceof (0, $3pVUH.Tensor), ()=>'The result y returned by f() must be a tensor.');
        // Filter out the nodes that don't connect x => y.
        const filteredTape = (0, $9jvFp.getFilteredNodesXToY)(this.state.activeTape, xs, y);
        if (!allowNoGradients && filteredTape.length === 0 && xs.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
        return this.tidy('backward', ()=>{
            const accumulatedGradientMap = {};
            accumulatedGradientMap[y.id] = dy == null ? $a451146aa29932d6$var$ones(y.shape) : dy;
            // Backprop gradients through the filtered nodes.
            (0, $9jvFp.backpropagateGradients)(accumulatedGradientMap, filteredTape, // Pass the tidy function to avoid circular dep with `tape.ts`.
            (f)=>this.tidy(f), // Pass an add function to avoide a circular dep with `tape.ts`.
            $a451146aa29932d6$export$e16d8520af44a096);
            const grads = xs.map((x)=>accumulatedGradientMap[x.id]);
            if (this.state.gradientDepth === 0) {
                // This means that we are not computing higher-order gradients
                // and can clean up the tape.
                this.state.activeTape.forEach((node)=>{
                    for (const tensor of node.saved)tensor.dispose();
                });
                this.state.activeTape = null;
            }
            return {
                value: y,
                grads: grads
            };
        });
    }
    customGrad(f) {
        $eOiOM.assert($eOiOM.isFunction(f), ()=>'The f passed in customGrad(f) must be a function.');
        return (...inputs)=>{
            $eOiOM.assert(inputs.every((t)=>t instanceof (0, $3pVUH.Tensor)), ()=>"The args passed in customGrad(f)(x1, x2,...) must all be tensors");
            let res;
            const inputMap = {};
            inputs.forEach((input, i)=>{
                inputMap[i] = input;
            });
            const forwardFunc = (_, save)=>{
                res = f(...[
                    ...inputs,
                    save
                ]);
                $eOiOM.assert(res.value instanceof (0, $3pVUH.Tensor), ()=>"The function f passed in customGrad(f) must return an object where `obj.value` is a tensor");
                $eOiOM.assert($eOiOM.isFunction(res.gradFunc), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function.");
                return res.value;
            };
            const backwardsFunc = (dy, saved)=>{
                const gradRes = res.gradFunc(dy, saved);
                const grads = Array.isArray(gradRes) ? gradRes : [
                    gradRes
                ];
                $eOiOM.assert(grads.length === inputs.length, ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...).");
                $eOiOM.assert(grads.every((t)=>t instanceof (0, $3pVUH.Tensor)), ()=>"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.");
                const gradMap = {};
                grads.forEach((grad, i)=>{
                    gradMap[i] = ()=>grad;
                });
                return gradMap;
            };
            return this.runKernelFunc({
                forwardFunc: forwardFunc,
                backwardsFunc: backwardsFunc,
                inputs: inputMap
            });
        };
    }
    readSync(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readSync(dataId);
    }
    read(dataId) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.read(dataId);
    }
    readToGPU(dataId, options) {
        // Route the read to the correct backend.
        const info = this.state.tensorInfo.get(dataId);
        return info.backend.readToGPU(dataId, options);
    }
    async time(query) {
        const start = (0, $lBDHD.now)();
        const timingInfo = await this.backend.time(query);
        timingInfo.wallMs = (0, $lBDHD.now)() - start;
        return timingInfo;
    }
    /**
     * Tracks a Tensor in the current scope to be automatically cleaned up
     * when the current scope ends, and returns the value.
     *
     * @param result The Tensor to track in the current scope.
     */ track(result) {
        if (this.state.activeScope != null) {
            result.scopeId = this.state.activeScope.id;
            this.state.activeScope.track.push(result);
        }
        return result;
    }
    get registeredVariables() {
        return this.state.registeredVariables;
    }
    /**
     * Resets the engine state. Removes all backends but does not remove
     * registered backend factories.
     */ reset() {
        // Make any pending promise obsolete.
        this.pendingBackendInitId++;
        this.state.dispose();
        this.ENV.reset();
        this.state = new $a451146aa29932d6$var$EngineState();
        for(const backendName in this.registry){
            this.disposeRegisteredKernels(backendName);
            this.registry[backendName].dispose();
            delete this.registry[backendName];
        }
        this.backendName = null;
        this.backendInstance = null;
        this.pendingBackendInit = null;
    }
}
$a451146aa29932d6$export$2c3b404bf3a77a1f.nextTensorId = 0;
$a451146aa29932d6$export$2c3b404bf3a77a1f.nextVariableId = 0;
function $a451146aa29932d6$var$ones(shape) {
    const values = (0, $eOiOM.makeOnesTypedArray)((0, $eOiOM.sizeFromShape)(shape), 'float32');
    return $a451146aa29932d6$export$33b63313cc511a3b.makeTensor(values, shape, 'float32');
}
function $a451146aa29932d6$export$ca8737f6c8c212b8() {
    const ns = (0, $hri9Y.getGlobalNamespace)();
    if (ns._tfengine == null) {
        const environment = new (0, $tdutJ.Environment)(ns);
        ns._tfengine = new $a451146aa29932d6$export$2c3b404bf3a77a1f(environment);
    }
    (0, $tdutJ.setEnvironmentGlobal)(ns._tfengine.ENV);
    // Tell the current tensor interface that the global engine is responsible
    // for tracking.
    (0, $3pVUH.setTensorTracker)(()=>ns._tfengine);
    return ns._tfengine;
}
const $a451146aa29932d6$export$33b63313cc511a3b = $a451146aa29932d6$export$ca8737f6c8c212b8();
function $a451146aa29932d6$export$e16d8520af44a096(a, b) {
    // We duplicate Add here to avoid a circular dependency with add.ts.
    const inputs = {
        a: a,
        b: b
    };
    return $a451146aa29932d6$export$33b63313cc511a3b.runKernel((0, $9BGT9.Add), inputs);
}

});
parcelRegister("2vCd3", function(module, exports) {

$parcel$export(module.exports, "DataStorage", function () { return $1d3c1d9fa5e40960$export$e95767ffe2e60cec; });
$parcel$export(module.exports, "KernelBackend", function () { return $1d3c1d9fa5e40960$export$543916c62202b50a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $1d3c1d9fa5e40960$export$76e53a66c52b6d4d = 1e-7;
const $1d3c1d9fa5e40960$export$49716d145771e6a2 = 1e-4;
class $1d3c1d9fa5e40960$export$e95767ffe2e60cec {
    constructor(backend, dataMover){
        this.backend = backend;
        this.dataMover = dataMover;
        this.data = new WeakMap();
        this.dataIdsCount = 0;
    }
    get(dataId) {
        if (!this.data.has(dataId)) this.dataMover.moveData(this.backend, dataId);
        return this.data.get(dataId);
    }
    set(dataId, value) {
        this.dataIdsCount++;
        this.data.set(dataId, value);
    }
    has(dataId) {
        return this.data.has(dataId);
    }
    delete(dataId) {
        this.dataIdsCount--;
        return this.data.delete(dataId);
    }
    numDataIds() {
        return this.dataIdsCount;
    }
}
class $1d3c1d9fa5e40960$export$543916c62202b50a {
    refCount(dataId) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('refCount');
    }
    incRef(dataId) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('incRef');
    }
    timerAvailable() {
        return true;
    }
    time(f) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('time');
    }
    read(dataId) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('read');
    }
    readSync(dataId) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('readSync');
    }
    readToGPU(dataId, options) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('readToGPU');
    }
    numDataIds() {
        return $1d3c1d9fa5e40960$var$notYetImplemented('numDataIds');
    }
    disposeData(dataId, force) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('disposeData');
    }
    write(values, shape, dtype) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('write');
    }
    move(dataId, values, shape, dtype, refCount) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('move');
    }
    createTensorFromGPUData(values, shape, dtype) {
        return $1d3c1d9fa5e40960$var$notYetImplemented('createTensorFromGPUData');
    }
    memory() {
        return $1d3c1d9fa5e40960$var$notYetImplemented('memory');
    }
    /** Returns the highest precision for floats in bits (e.g. 16 or 32) */ floatPrecision() {
        return $1d3c1d9fa5e40960$var$notYetImplemented('floatPrecision');
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $1d3c1d9fa5e40960$export$76e53a66c52b6d4d : $1d3c1d9fa5e40960$export$49716d145771e6a2;
    }
    dispose() {
        return $1d3c1d9fa5e40960$var$notYetImplemented('dispose');
    }
}
function $1d3c1d9fa5e40960$var$notYetImplemented(kernelName) {
    throw new Error(`'${kernelName}' not yet implemented or not found in the registry. ` + `This kernel may not be supported by the tfjs backend you have chosen`);
}

});

parcelRegister("tdutJ", function(module, exports) {

$parcel$export(module.exports, "Environment", function () { return $057d2c7f76eebe32$export$7dc6752a22ab011a; });
$parcel$export(module.exports, "env", function () { return $057d2c7f76eebe32$export$a7b6bc01c63cdfc3; });
$parcel$export(module.exports, "setEnvironmentGlobal", function () { return $057d2c7f76eebe32$export$3ef32a49eeda04cc; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
// Expects flags from URL in the format ?tfjsflags=FLAG1:1,FLAG2:true.
const $057d2c7f76eebe32$var$TENSORFLOWJS_FLAGS_PREFIX = 'tfjsflags';
class $057d2c7f76eebe32$export$7dc6752a22ab011a {
    // tslint:disable-next-line: no-any
    constructor(global){
        this.global = global;
        this.flags = {};
        this.flagRegistry = {};
        this.urlFlags = {};
        // Jasmine spies on this in 'environment_test.ts'
        this.getQueryParams = $057d2c7f76eebe32$export$e2de15bbd9edf9c6;
        this.populateURLFlags();
    }
    setPlatform(platformName, platform) {
        if (this.platform != null) {
            if (!($057d2c7f76eebe32$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $057d2c7f76eebe32$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Platform ${this.platformName} has already been set. ` + `Overwriting the platform with ${platformName}.`);
        }
        this.platformName = platformName;
        this.platform = platform;
    }
    registerFlag(flagName, evaluationFn, setHook) {
        this.flagRegistry[flagName] = {
            evaluationFn: evaluationFn,
            setHook: setHook
        };
        // Override the flag value from the URL. This has to happen here because
        // the environment is initialized before flags get registered.
        if (this.urlFlags[flagName] != null) {
            const flagValue = this.urlFlags[flagName];
            if (!($057d2c7f76eebe32$export$a7b6bc01c63cdfc3().getBool('IS_TEST') || $057d2c7f76eebe32$export$a7b6bc01c63cdfc3().getBool('PROD'))) console.warn(`Setting feature override from URL ${flagName}: ${flagValue}.`);
            this.set(flagName, flagValue);
        }
    }
    async getAsync(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        this.flags[flagName] = await this.evaluateFlag(flagName);
        return this.flags[flagName];
    }
    get(flagName) {
        if (flagName in this.flags) return this.flags[flagName];
        const flagValue = this.evaluateFlag(flagName);
        if ((0, $eOiOM.isPromise)(flagValue)) throw new Error(`Flag ${flagName} cannot be synchronously evaluated. ` + `Please use getAsync() instead.`);
        this.flags[flagName] = flagValue;
        return this.flags[flagName];
    }
    getNumber(flagName) {
        return this.get(flagName);
    }
    getBool(flagName) {
        return this.get(flagName);
    }
    getString(flagName) {
        return this.get(flagName);
    }
    getFlags() {
        return this.flags;
    }
    // For backwards compatibility.
    get features() {
        return this.flags;
    }
    set(flagName, value) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot set flag ${flagName} as it has not been registered.`);
        this.flags[flagName] = value;
        if (this.flagRegistry[flagName].setHook != null) this.flagRegistry[flagName].setHook(value);
    }
    evaluateFlag(flagName) {
        if (this.flagRegistry[flagName] == null) throw new Error(`Cannot evaluate flag '${flagName}': no evaluation function found.`);
        return this.flagRegistry[flagName].evaluationFn();
    }
    setFlags(flags) {
        this.flags = Object.assign({}, flags);
    }
    reset() {
        this.flags = {};
        this.urlFlags = {};
        this.populateURLFlags();
    }
    populateURLFlags() {
        if (typeof this.global === 'undefined' || typeof this.global.location === 'undefined' || typeof this.global.location.search === 'undefined') return;
        const urlParams = this.getQueryParams(this.global.location.search);
        if ($057d2c7f76eebe32$var$TENSORFLOWJS_FLAGS_PREFIX in urlParams) {
            const keyValues = urlParams[$057d2c7f76eebe32$var$TENSORFLOWJS_FLAGS_PREFIX].split(',');
            keyValues.forEach((keyValue)=>{
                const [key, value] = keyValue.split(':');
                this.urlFlags[key] = $057d2c7f76eebe32$var$parseValue(key, value);
            });
        }
    }
}
function $057d2c7f76eebe32$export$e2de15bbd9edf9c6(queryString) {
    const params = {};
    queryString.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, (s, ...t)=>{
        $057d2c7f76eebe32$var$decodeParam(params, t[0], t[1]);
        return t.join('=');
    });
    return params;
}
function $057d2c7f76eebe32$var$decodeParam(params, name, value) {
    params[decodeURIComponent(name)] = decodeURIComponent(value || '');
}
function $057d2c7f76eebe32$var$parseValue(flagName, value) {
    const lowerCaseValue = value.toLowerCase();
    if (lowerCaseValue === 'true' || lowerCaseValue === 'false') return lowerCaseValue === 'true';
    else if (`${+lowerCaseValue}` === lowerCaseValue) return +lowerCaseValue;
    else return value;
}
function $057d2c7f76eebe32$export$a7b6bc01c63cdfc3() {
    return $057d2c7f76eebe32$export$83401e34d5e11bf4;
}
let $057d2c7f76eebe32$export$83401e34d5e11bf4 = null;
function $057d2c7f76eebe32$export$3ef32a49eeda04cc(environment) {
    $057d2c7f76eebe32$export$83401e34d5e11bf4 = environment;
}

});
parcelRegister("eOiOM", function(module, exports) {

$parcel$export(module.exports, "shuffle", function () { return $ac8455127ad7d8b2$export$448332262467e042; });
$parcel$export(module.exports, "swap", function () { return $ac8455127ad7d8b2$export$b0e76d9850c64156; });
$parcel$export(module.exports, "shuffleCombo", function () { return $ac8455127ad7d8b2$export$ae1498b5fd31a179; });
$parcel$export(module.exports, "clamp", function () { return $ac8455127ad7d8b2$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "nearestLargerEven", function () { return $ac8455127ad7d8b2$export$ece2fd7300c99d1f; });
$parcel$export(module.exports, "sum", function () { return $ac8455127ad7d8b2$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "randUniform", function () { return $ac8455127ad7d8b2$export$1c2519d52242937; });
$parcel$export(module.exports, "distSquared", function () { return $ac8455127ad7d8b2$export$499eb56409f6cbc2; });
$parcel$export(module.exports, "assert", function () { return $ac8455127ad7d8b2$export$a7a9523472993e97; });
$parcel$export(module.exports, "assertShapesMatch", function () { return $ac8455127ad7d8b2$export$e08b27e7f37e2782; });
$parcel$export(module.exports, "arraysEqual", function () { return $ac8455127ad7d8b2$export$234180f8206db11b; });
$parcel$export(module.exports, "assertNonNull", function () { return $ac8455127ad7d8b2$export$44a06cc2759dd036; });
$parcel$export(module.exports, "sizeFromShape", function () { return $ac8455127ad7d8b2$export$b4c3214a70a0e73f; });
$parcel$export(module.exports, "isScalarShape", function () { return $ac8455127ad7d8b2$export$d58b8d1ec2129064; });
$parcel$export(module.exports, "arraysEqualWithNull", function () { return $ac8455127ad7d8b2$export$9efb31c074e61de7; });
$parcel$export(module.exports, "isInt", function () { return $ac8455127ad7d8b2$export$357fc28f6427af8b; });
$parcel$export(module.exports, "tanh", function () { return $ac8455127ad7d8b2$export$7128670e45beef9a; });
$parcel$export(module.exports, "sizeToSquarishShape", function () { return $ac8455127ad7d8b2$export$55bdc5631791c247; });
$parcel$export(module.exports, "createShuffledIndices", function () { return $ac8455127ad7d8b2$export$49070d702e17365; });
$parcel$export(module.exports, "rightPad", function () { return $ac8455127ad7d8b2$export$390245bab32fb60f; });
$parcel$export(module.exports, "repeatedTry", function () { return $ac8455127ad7d8b2$export$aa345f93372ddb7b; });
$parcel$export(module.exports, "inferFromImplicitShape", function () { return $ac8455127ad7d8b2$export$e9459a51c182ffc2; });
$parcel$export(module.exports, "parseAxisParam", function () { return $ac8455127ad7d8b2$export$72b84eb9fe1f482; });
$parcel$export(module.exports, "squeezeShape", function () { return $ac8455127ad7d8b2$export$3106ace2a3b5396d; });
$parcel$export(module.exports, "getTypedArrayFromDType", function () { return $ac8455127ad7d8b2$export$3b783bdb77632623; });
$parcel$export(module.exports, "getArrayFromDType", function () { return $ac8455127ad7d8b2$export$24f13f6206df8f7c; });
$parcel$export(module.exports, "checkConversionForErrors", function () { return $ac8455127ad7d8b2$export$579cf7b8ff0a87a3; });
$parcel$export(module.exports, "isValidDtype", function () { return $ac8455127ad7d8b2$export$a6a3df2178ac9529; });
$parcel$export(module.exports, "hasEncodingLoss", function () { return $ac8455127ad7d8b2$export$9130d84b35fa7b98; });
$parcel$export(module.exports, "bytesPerElement", function () { return $ac8455127ad7d8b2$export$3f355ce86503b89f; });
$parcel$export(module.exports, "bytesFromStringArray", function () { return $ac8455127ad7d8b2$export$c474902e1102282d; });
$parcel$export(module.exports, "isString", function () { return $ac8455127ad7d8b2$export$844ec244b1367d54; });
$parcel$export(module.exports, "isBoolean", function () { return $ac8455127ad7d8b2$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "isNumber", function () { return $ac8455127ad7d8b2$export$7e4aa119212bc614; });
$parcel$export(module.exports, "inferDtype", function () { return $ac8455127ad7d8b2$export$2005775d905d2dc2; });
$parcel$export(module.exports, "isFunction", function () { return $ac8455127ad7d8b2$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "nearestDivisor", function () { return $ac8455127ad7d8b2$export$c0ff3276320ddb5e; });
$parcel$export(module.exports, "computeStrides", function () { return $ac8455127ad7d8b2$export$6ad0292cf4d50f79; });
$parcel$export(module.exports, "toNestedArray", function () { return $ac8455127ad7d8b2$export$3983c25181aa68cc; });
$parcel$export(module.exports, "convertBackendValuesAndArrayBuffer", function () { return $ac8455127ad7d8b2$export$568d15cfc23dac5d; });
$parcel$export(module.exports, "makeOnesTypedArray", function () { return $ac8455127ad7d8b2$export$b915f681a907ae99; });
$parcel$export(module.exports, "makeZerosTypedArray", function () { return $ac8455127ad7d8b2$export$edbc8aedac4e036f; });
$parcel$export(module.exports, "makeZerosNestedTypedArray", function () { return $ac8455127ad7d8b2$export$eef638260c005c74; });
$parcel$export(module.exports, "assertNonNegativeIntegerDimensions", function () { return $ac8455127ad7d8b2$export$3d8b7619bac22cf5; });
$parcel$export(module.exports, "locToIndex", function () { return $ac8455127ad7d8b2$export$a14b009c502dc3b4; });
$parcel$export(module.exports, "indexToLoc", function () { return $ac8455127ad7d8b2$export$2d1ada4c755a8699; });
$parcel$export(module.exports, "isPromise", function () { return $ac8455127ad7d8b2$export$4369c812aac99591; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Shuffles the array in-place using Fisher-Yates algorithm.
 *
 * ```js
 * const a = [1, 2, 3, 4, 5];
 * tf.util.shuffle(a);
 * console.log(a);
 * ```
 *
 * @param array The array to shuffle in-place.
 *
 * @doc {heading: 'Util', namespace: 'util'}
 */ // tslint:disable-next-line:no-any
function $ac8455127ad7d8b2$export$448332262467e042(array) {
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element with it
        $ac8455127ad7d8b2$export$b0e76d9850c64156(array, counter, index);
    }
}
function $ac8455127ad7d8b2$export$ae1498b5fd31a179(// tslint:disable-next-line:no-any
array, // tslint:disable-next-line:no-any
array2) {
    if (array.length !== array2.length) throw new Error(`Array sizes must match to be shuffled together ` + `First array length was ${array.length}` + `Second array length was ${array2.length}`);
    let counter = array.length;
    let index = 0;
    // While there are elements in the array
    while(counter > 0){
        // Pick a random index
        index = Math.random() * counter | 0;
        // Decrease counter by 1
        counter--;
        // And swap the last element of each array with it
        $ac8455127ad7d8b2$export$b0e76d9850c64156(array, counter, index);
        $ac8455127ad7d8b2$export$b0e76d9850c64156(array2, counter, index);
    }
}
function $ac8455127ad7d8b2$export$7d15b64cf5a3a4c4(min, x, max) {
    return Math.max(min, Math.min(x, max));
}
function $ac8455127ad7d8b2$export$ece2fd7300c99d1f(val) {
    return val % 2 === 0 ? val : val + 1;
}
function $ac8455127ad7d8b2$export$b0e76d9850c64156(object, left, right) {
    const temp = object[left];
    object[left] = object[right];
    object[right] = temp;
}
function $ac8455127ad7d8b2$export$8a63f25cc62965f1(arr) {
    let sum = 0;
    for(let i = 0; i < arr.length; i++)sum += arr[i];
    return sum;
}
function $ac8455127ad7d8b2$export$1c2519d52242937(a, b) {
    const r = Math.random();
    return b * r + (1 - r) * a;
}
function $ac8455127ad7d8b2$export$499eb56409f6cbc2(a, b) {
    let result = 0;
    for(let i = 0; i < a.length; i++){
        const diff = Number(a[i]) - Number(b[i]);
        result += diff * diff;
    }
    return result;
}
function $ac8455127ad7d8b2$export$a7a9523472993e97(expr, msg) {
    if (!expr) throw new Error(typeof msg === 'string' ? msg : msg());
}
function $ac8455127ad7d8b2$export$e08b27e7f37e2782(shapeA, shapeB, errorMessagePrefix = '') {
    $ac8455127ad7d8b2$export$a7a9523472993e97($ac8455127ad7d8b2$export$234180f8206db11b(shapeA, shapeB), ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
}
function $ac8455127ad7d8b2$export$44a06cc2759dd036(a) {
    $ac8455127ad7d8b2$export$a7a9523472993e97(a != null, ()=>`The input to the tensor constructor must be a non-null value.`);
}
function $ac8455127ad7d8b2$export$b4c3214a70a0e73f(shape) {
    if (shape.length === 0) // Scalar.
    return 1;
    let size = shape[0];
    for(let i = 1; i < shape.length; i++)size *= shape[i];
    return size;
}
function $ac8455127ad7d8b2$export$d58b8d1ec2129064(shape) {
    return shape.length === 0;
}
function $ac8455127ad7d8b2$export$9efb31c074e61de7(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== null && n2[i] !== null && n1[i] !== n2[i]) return false;
    }
    return true;
}
function $ac8455127ad7d8b2$export$234180f8206db11b(n1, n2) {
    if (n1 === n2) return true;
    if (n1 == null || n2 == null) return false;
    if (n1.length !== n2.length) return false;
    for(let i = 0; i < n1.length; i++){
        if (n1[i] !== n2[i]) return false;
    }
    return true;
}
function $ac8455127ad7d8b2$export$357fc28f6427af8b(a) {
    return a % 1 === 0;
}
function $ac8455127ad7d8b2$export$7128670e45beef9a(x) {
    // tslint:disable-next-line:no-any
    if (Math.tanh != null) // tslint:disable-next-line:no-any
    return Math.tanh(x);
    if (x === Infinity) return 1;
    else if (x === -Infinity) return -1;
    else {
        const e2x = Math.exp(2 * x);
        return (e2x - 1) / (e2x + 1);
    }
}
function $ac8455127ad7d8b2$export$55bdc5631791c247(size) {
    const width = Math.ceil(Math.sqrt(size));
    return [
        width,
        Math.ceil(size / width)
    ];
}
function $ac8455127ad7d8b2$export$49070d702e17365(n) {
    const shuffledIndices = new Uint32Array(n);
    for(let i = 0; i < n; ++i)shuffledIndices[i] = i;
    $ac8455127ad7d8b2$export$448332262467e042(shuffledIndices);
    return shuffledIndices;
}
function $ac8455127ad7d8b2$export$390245bab32fb60f(a, size) {
    if (size <= a.length) return a;
    return a + ' '.repeat(size - a.length);
}
function $ac8455127ad7d8b2$export$aa345f93372ddb7b(checkFn, delayFn = (counter)=>0, maxCounter, scheduleFn) {
    return new Promise((resolve, reject)=>{
        let tryCount = 0;
        const tryFn = ()=>{
            if (checkFn()) {
                resolve();
                return;
            }
            tryCount++;
            const nextBackoff = delayFn(tryCount);
            if (maxCounter != null && tryCount >= maxCounter) {
                reject();
                return;
            }
            if (scheduleFn != null) scheduleFn(tryFn, nextBackoff);
            else // google3 does not allow assigning another variable to setTimeout.
            // Don't refactor this so scheduleFn has a default value of setTimeout.
            setTimeout(tryFn, nextBackoff);
        };
        tryFn();
    });
}
function $ac8455127ad7d8b2$export$e9459a51c182ffc2(shape, size) {
    let shapeProd = 1;
    let implicitIdx = -1;
    for(let i = 0; i < shape.length; ++i){
        if (shape[i] >= 0) shapeProd *= shape[i];
        else if (shape[i] === -1) {
            if (implicitIdx !== -1) throw Error(`Shapes can only have 1 implicit size. ` + `Found -1 at dim ${implicitIdx} and dim ${i}`);
            implicitIdx = i;
        } else if (shape[i] < 0) throw Error(`Shapes can not be < 0. Found ${shape[i]} at dim ${i}`);
    }
    if (implicitIdx === -1) {
        if (size > 0 && size !== shapeProd) throw Error(`Size(${size}) must match the product of shape ${shape}`);
        return shape;
    }
    if (shapeProd === 0) throw Error(`Cannot infer the missing size in [${shape}] when ` + `there are 0 elements`);
    if (size % shapeProd !== 0) throw Error(`The implicit shape can't be a fractional number. ` + `Got ${size} / ${shapeProd}`);
    const newShape = shape.slice();
    newShape[implicitIdx] = size / shapeProd;
    return newShape;
}
function $ac8455127ad7d8b2$export$72b84eb9fe1f482(axis, shape) {
    const rank = shape.length;
    // Normalize input
    axis = axis == null ? shape.map((s, i)=>i) : [].concat(axis);
    // Check for valid range
    $ac8455127ad7d8b2$export$a7a9523472993e97(axis.every((ax)=>ax >= -rank && ax < rank), ()=>`All values in axis param must be in range [-${rank}, ${rank}) but ` + `got axis ${axis}`);
    // Check for only integers
    $ac8455127ad7d8b2$export$a7a9523472993e97(axis.every((ax)=>$ac8455127ad7d8b2$export$357fc28f6427af8b(ax)), ()=>`All values in axis param must be integers but ` + `got axis ${axis}`);
    // Handle negative axis.
    return axis.map((a)=>a < 0 ? rank + a : a);
}
function $ac8455127ad7d8b2$export$3106ace2a3b5396d(shape, axis) {
    const newShape = [];
    const keptDims = [];
    const isEmptyArray = axis != null && Array.isArray(axis) && axis.length === 0;
    const axes = axis == null || isEmptyArray ? null : $ac8455127ad7d8b2$export$72b84eb9fe1f482(axis, shape).sort();
    let j = 0;
    for(let i = 0; i < shape.length; ++i){
        if (axes != null) {
            if (axes[j] === i && shape[i] !== 1) throw new Error(`Can't squeeze axis ${i} since its dim '${shape[i]}' is not 1`);
            if ((axes[j] == null || axes[j] > i) && shape[i] === 1) {
                newShape.push(shape[i]);
                keptDims.push(i);
            }
            if (axes[j] <= i) j++;
        }
        if (shape[i] !== 1) {
            newShape.push(shape[i]);
            keptDims.push(i);
        }
    }
    return {
        newShape: newShape,
        keptDims: keptDims
    };
}
function $ac8455127ad7d8b2$export$3b783bdb77632623(dtype, size) {
    return $ac8455127ad7d8b2$export$24f13f6206df8f7c(dtype, size);
}
function $ac8455127ad7d8b2$export$24f13f6206df8f7c(dtype, size) {
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else if (dtype === 'string') values = new Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    return values;
}
function $ac8455127ad7d8b2$export$579cf7b8ff0a87a3(vals, dtype) {
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) throw Error(`A tensor of type ${dtype} being uploaded contains ${num}.`);
    }
}
function $ac8455127ad7d8b2$export$a6a3df2178ac9529(dtype) {
    return dtype === 'bool' || dtype === 'complex64' || dtype === 'float32' || dtype === 'int32' || dtype === 'string';
}
function $ac8455127ad7d8b2$export$9130d84b35fa7b98(oldType, newType) {
    if (newType === 'complex64') return false;
    if (newType === 'float32' && oldType !== 'complex64') return false;
    if (newType === 'int32' && oldType !== 'float32' && oldType !== 'complex64') return false;
    if (newType === 'bool' && oldType === 'bool') return false;
    return true;
}
function $ac8455127ad7d8b2$export$3f355ce86503b89f(dtype) {
    if (dtype === 'float32' || dtype === 'int32') return 4;
    else if (dtype === 'complex64') return 8;
    else if (dtype === 'bool') return 1;
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $ac8455127ad7d8b2$export$c474902e1102282d(arr) {
    if (arr == null) return 0;
    let bytes = 0;
    arr.forEach((x)=>bytes += x.length);
    return bytes;
}
function $ac8455127ad7d8b2$export$844ec244b1367d54(value) {
    return typeof value === 'string' || value instanceof String;
}
function $ac8455127ad7d8b2$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $ac8455127ad7d8b2$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $ac8455127ad7d8b2$export$2005775d905d2dc2(values) {
    if (Array.isArray(values)) return $ac8455127ad7d8b2$export$2005775d905d2dc2(values[0]);
    if (values instanceof Float32Array) return 'float32';
    else if (values instanceof Int32Array || values instanceof Uint8Array || values instanceof Uint8ClampedArray) return 'int32';
    else if ($ac8455127ad7d8b2$export$7e4aa119212bc614(values)) return 'float32';
    else if ($ac8455127ad7d8b2$export$844ec244b1367d54(values)) return 'string';
    else if ($ac8455127ad7d8b2$export$f9ce7b637dfbe238(values)) return 'bool';
    return 'float32';
}
function $ac8455127ad7d8b2$export$f6e2535fb5126e54(f) {
    return !!(f && f.constructor && f.call && f.apply);
}
function $ac8455127ad7d8b2$export$c0ff3276320ddb5e(size, start) {
    for(let i = start; i < size; ++i){
        if (size % i === 0) return i;
    }
    return size;
}
function $ac8455127ad7d8b2$export$6ad0292cf4d50f79(shape) {
    const rank = shape.length;
    if (rank < 2) return [];
    // Last dimension has implicit stride of 1, thus having D-1 (instead of D)
    // strides.
    const strides = new Array(rank - 1);
    strides[rank - 2] = shape[rank - 1];
    for(let i = rank - 3; i >= 0; --i)strides[i] = strides[i + 1] * shape[i + 1];
    return strides;
}
function $ac8455127ad7d8b2$var$createNestedArray(offset, shape, a, isComplex = false) {
    const ret = new Array();
    if (shape.length === 1) {
        const d = shape[0] * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = a[offset + i];
    } else {
        const d = shape[0];
        const rest = shape.slice(1);
        const len = rest.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
        for(let i = 0; i < d; i++)ret[i] = $ac8455127ad7d8b2$var$createNestedArray(offset + i * len, rest, a, isComplex);
    }
    return ret;
}
function $ac8455127ad7d8b2$export$3983c25181aa68cc(shape, a, isComplex = false) {
    if (shape.length === 0) // Scalar type should return a single number.
    return a[0];
    const size = shape.reduce((acc, c)=>acc * c) * (isComplex ? 2 : 1);
    if (size === 0) // A tensor with shape zero should be turned into empty list.
    return [];
    if (size !== a.length) throw new Error(`[${shape}] does not match the input size ${a.length}${isComplex ? ' for a complex tensor' : ''}.`);
    return $ac8455127ad7d8b2$var$createNestedArray(0, shape, a, isComplex);
}
function $ac8455127ad7d8b2$export$568d15cfc23dac5d(data, dtype) {
    // If is type Uint8Array[], return it directly.
    if (Array.isArray(data)) return data;
    if (dtype === 'float32') return data instanceof Float32Array ? data : new Float32Array(data);
    else if (dtype === 'int32') return data instanceof Int32Array ? data : new Int32Array(data);
    else if (dtype === 'bool' || dtype === 'string') return Uint8Array.from(new Int32Array(data));
    else throw new Error(`Unknown dtype ${dtype}`);
}
function $ac8455127ad7d8b2$export$b915f681a907ae99(size, dtype) {
    const array = $ac8455127ad7d8b2$export$edbc8aedac4e036f(size, dtype);
    for(let i = 0; i < array.length; i++)array[i] = 1;
    return array;
}
function $ac8455127ad7d8b2$export$edbc8aedac4e036f(size, dtype) {
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(size);
    else if (dtype === 'int32') return new Int32Array(size);
    else if (dtype === 'bool') return new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
}
function $ac8455127ad7d8b2$export$eef638260c005c74(shape, dtype) {
    const size = shape.reduce((prev, curr)=>prev * curr, 1);
    if (dtype == null || dtype === 'float32') return $ac8455127ad7d8b2$export$3983c25181aa68cc(shape, new Float32Array(size));
    else if (dtype === 'int32') return $ac8455127ad7d8b2$export$3983c25181aa68cc(shape, new Int32Array(size));
    else if (dtype === 'bool') return $ac8455127ad7d8b2$export$3983c25181aa68cc(shape, new Uint8Array(size));
    else throw new Error(`Unknown data type ${dtype}`);
}
function $ac8455127ad7d8b2$export$3d8b7619bac22cf5(shape) {
    shape.forEach((dimSize)=>{
        $ac8455127ad7d8b2$export$a7a9523472993e97(Number.isInteger(dimSize) && dimSize >= 0, ()=>`Tensor must have a shape comprised of positive integers but got ` + `shape [${shape}].`);
    });
}
function $ac8455127ad7d8b2$export$a14b009c502dc3b4(locs, rank, strides) {
    if (rank === 0) return 0;
    else if (rank === 1) return locs[0];
    let index = locs[locs.length - 1];
    for(let i = 0; i < locs.length - 1; ++i)index += strides[i] * locs[i];
    return index;
}
function $ac8455127ad7d8b2$export$2d1ada4c755a8699(index, rank, strides) {
    if (rank === 0) return [];
    else if (rank === 1) return [
        index
    ];
    const locs = new Array(rank);
    for(let i = 0; i < locs.length - 1; ++i){
        locs[i] = Math.floor(index / strides[i]);
        index -= locs[i] * strides[i];
    }
    locs[locs.length - 1] = index;
    return locs;
}
function $ac8455127ad7d8b2$export$4369c812aac99591(object) {
    //  We chose to not use 'obj instanceOf Promise' for two reasons:
    //  1. It only reliably works for es6 Promise, not other Promise
    //  implementations.
    //  2. It doesn't work with framework that uses zone.js. zone.js monkey
    //  patch the async calls, so it is possible the obj (patched) is
    //  comparing to a pre-patched Promise.
    return object && object.then && typeof object.then === 'function';
}

});


parcelRegister("hri9Y", function(module, exports) {

$parcel$export(module.exports, "getGlobalNamespace", function () { return $cb230b7029d4fd11$export$5054b240ae6849b7; });
$parcel$export(module.exports, "getGlobal", function () { return $cb230b7029d4fd11$export$a4e55266d2135a7f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Note that the identifier globalNameSpace is scoped to this module, but will
// always resolve to the same global object regardless of how the module is
// resolved.
// tslint:disable-next-line:no-any

var $3O3MM = parcelRequire("3O3MM");
let $cb230b7029d4fd11$var$globalNameSpace;
function $cb230b7029d4fd11$export$5054b240ae6849b7() {
    if ($cb230b7029d4fd11$var$globalNameSpace == null) {
        // tslint:disable-next-line:no-any
        let ns;
        if (typeof window !== 'undefined') ns = window;
        else if (typeof $parcel$global !== 'undefined') ns = $parcel$global;
        else if (typeof $3O3MM !== 'undefined') ns = $3O3MM;
        else if (typeof self !== 'undefined') ns = self;
        else throw new Error('Could not find a global object');
        $cb230b7029d4fd11$var$globalNameSpace = ns;
    }
    return $cb230b7029d4fd11$var$globalNameSpace;
}
// tslint:disable-next-line:no-any
function $cb230b7029d4fd11$var$getGlobalMap() {
    const ns = $cb230b7029d4fd11$export$5054b240ae6849b7();
    if (ns._tfGlobals == null) ns._tfGlobals = new Map();
    return ns._tfGlobals;
}
function $cb230b7029d4fd11$export$a4e55266d2135a7f(key, init) {
    const globalMap = $cb230b7029d4fd11$var$getGlobalMap();
    if (globalMap.has(key)) return globalMap.get(key);
    else {
        const singleton = init();
        globalMap.set(key, singleton);
        return globalMap.get(key);
    }
}

});
parcelRegister("3O3MM", function(module, exports) {
// shim for using process in browser
var $2c58fa5e8f03dd34$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2c58fa5e8f03dd34$var$cachedSetTimeout;
var $2c58fa5e8f03dd34$var$cachedClearTimeout;
function $2c58fa5e8f03dd34$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $2c58fa5e8f03dd34$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $2c58fa5e8f03dd34$var$cachedSetTimeout = setTimeout;
        else $2c58fa5e8f03dd34$var$cachedSetTimeout = $2c58fa5e8f03dd34$var$defaultSetTimout;
    } catch (e) {
        $2c58fa5e8f03dd34$var$cachedSetTimeout = $2c58fa5e8f03dd34$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $2c58fa5e8f03dd34$var$cachedClearTimeout = clearTimeout;
        else $2c58fa5e8f03dd34$var$cachedClearTimeout = $2c58fa5e8f03dd34$var$defaultClearTimeout;
    } catch (e) {
        $2c58fa5e8f03dd34$var$cachedClearTimeout = $2c58fa5e8f03dd34$var$defaultClearTimeout;
    }
})();
function $2c58fa5e8f03dd34$var$runTimeout(fun) {
    if ($2c58fa5e8f03dd34$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2c58fa5e8f03dd34$var$cachedSetTimeout === $2c58fa5e8f03dd34$var$defaultSetTimout || !$2c58fa5e8f03dd34$var$cachedSetTimeout) && setTimeout) {
        $2c58fa5e8f03dd34$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2c58fa5e8f03dd34$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2c58fa5e8f03dd34$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2c58fa5e8f03dd34$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2c58fa5e8f03dd34$var$runClearTimeout(marker) {
    if ($2c58fa5e8f03dd34$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2c58fa5e8f03dd34$var$cachedClearTimeout === $2c58fa5e8f03dd34$var$defaultClearTimeout || !$2c58fa5e8f03dd34$var$cachedClearTimeout) && clearTimeout) {
        $2c58fa5e8f03dd34$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2c58fa5e8f03dd34$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2c58fa5e8f03dd34$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2c58fa5e8f03dd34$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2c58fa5e8f03dd34$var$queue = [];
var $2c58fa5e8f03dd34$var$draining = false;
var $2c58fa5e8f03dd34$var$currentQueue;
var $2c58fa5e8f03dd34$var$queueIndex = -1;
function $2c58fa5e8f03dd34$var$cleanUpNextTick() {
    if (!$2c58fa5e8f03dd34$var$draining || !$2c58fa5e8f03dd34$var$currentQueue) return;
    $2c58fa5e8f03dd34$var$draining = false;
    if ($2c58fa5e8f03dd34$var$currentQueue.length) $2c58fa5e8f03dd34$var$queue = $2c58fa5e8f03dd34$var$currentQueue.concat($2c58fa5e8f03dd34$var$queue);
    else $2c58fa5e8f03dd34$var$queueIndex = -1;
    if ($2c58fa5e8f03dd34$var$queue.length) $2c58fa5e8f03dd34$var$drainQueue();
}
function $2c58fa5e8f03dd34$var$drainQueue() {
    if ($2c58fa5e8f03dd34$var$draining) return;
    var timeout = $2c58fa5e8f03dd34$var$runTimeout($2c58fa5e8f03dd34$var$cleanUpNextTick);
    $2c58fa5e8f03dd34$var$draining = true;
    var len = $2c58fa5e8f03dd34$var$queue.length;
    while(len){
        $2c58fa5e8f03dd34$var$currentQueue = $2c58fa5e8f03dd34$var$queue;
        $2c58fa5e8f03dd34$var$queue = [];
        while(++$2c58fa5e8f03dd34$var$queueIndex < len)if ($2c58fa5e8f03dd34$var$currentQueue) $2c58fa5e8f03dd34$var$currentQueue[$2c58fa5e8f03dd34$var$queueIndex].run();
        $2c58fa5e8f03dd34$var$queueIndex = -1;
        len = $2c58fa5e8f03dd34$var$queue.length;
    }
    $2c58fa5e8f03dd34$var$currentQueue = null;
    $2c58fa5e8f03dd34$var$draining = false;
    $2c58fa5e8f03dd34$var$runClearTimeout(timeout);
}
$2c58fa5e8f03dd34$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2c58fa5e8f03dd34$var$queue.push(new $2c58fa5e8f03dd34$var$Item(fun, args));
    if ($2c58fa5e8f03dd34$var$queue.length === 1 && !$2c58fa5e8f03dd34$var$draining) $2c58fa5e8f03dd34$var$runTimeout($2c58fa5e8f03dd34$var$drainQueue);
};
// v8 likes predictible objects
function $2c58fa5e8f03dd34$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2c58fa5e8f03dd34$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2c58fa5e8f03dd34$var$process.title = 'browser';
$2c58fa5e8f03dd34$var$process.browser = true;
$2c58fa5e8f03dd34$var$process.env = {};
$2c58fa5e8f03dd34$var$process.argv = [];
$2c58fa5e8f03dd34$var$process.version = ''; // empty string to avoid regexp issues
$2c58fa5e8f03dd34$var$process.versions = {};
function $2c58fa5e8f03dd34$var$noop() {}
$2c58fa5e8f03dd34$var$process.on = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.addListener = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.once = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.off = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.removeListener = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.removeAllListeners = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.emit = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.prependListener = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.prependOnceListener = $2c58fa5e8f03dd34$var$noop;
$2c58fa5e8f03dd34$var$process.listeners = function(name) {
    return [];
};
$2c58fa5e8f03dd34$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$2c58fa5e8f03dd34$var$process.cwd = function() {
    return '/';
};
$2c58fa5e8f03dd34$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$2c58fa5e8f03dd34$var$process.umask = function() {
    return 0;
};

});


parcelRegister("9BGT9", function(module, exports) {

$parcel$export(module.exports, "Abs", function () { return $6fe8d689b60c784e$export$b73c596ee8758a66; });
$parcel$export(module.exports, "Acos", function () { return $6fe8d689b60c784e$export$3b952c9980dac550; });
$parcel$export(module.exports, "Acosh", function () { return $6fe8d689b60c784e$export$987da490b7c2e7dd; });
$parcel$export(module.exports, "Add", function () { return $6fe8d689b60c784e$export$d0265b2c425512d6; });
$parcel$export(module.exports, "AddN", function () { return $6fe8d689b60c784e$export$eef235ad06d3226a; });
$parcel$export(module.exports, "All", function () { return $6fe8d689b60c784e$export$5dceb1ab650a1776; });
$parcel$export(module.exports, "Any", function () { return $6fe8d689b60c784e$export$b24b633b1364b94b; });
$parcel$export(module.exports, "ArgMax", function () { return $6fe8d689b60c784e$export$17612294a1503e1c; });
$parcel$export(module.exports, "ArgMin", function () { return $6fe8d689b60c784e$export$baabd09270cbbd94; });
$parcel$export(module.exports, "Asin", function () { return $6fe8d689b60c784e$export$664c8ca7e7e5c126; });
$parcel$export(module.exports, "Asinh", function () { return $6fe8d689b60c784e$export$847c88940cb7dcb5; });
$parcel$export(module.exports, "Atan", function () { return $6fe8d689b60c784e$export$bac667d46ac043ae; });
$parcel$export(module.exports, "Atanh", function () { return $6fe8d689b60c784e$export$98981a86fa2b1366; });
$parcel$export(module.exports, "Atan2", function () { return $6fe8d689b60c784e$export$3bf4c619ce589f4b; });
$parcel$export(module.exports, "AvgPool", function () { return $6fe8d689b60c784e$export$37f2cc7be1add88c; });
$parcel$export(module.exports, "AvgPoolGrad", function () { return $6fe8d689b60c784e$export$9873fd6046cd6951; });
$parcel$export(module.exports, "AvgPool3D", function () { return $6fe8d689b60c784e$export$390ecb697af103f6; });
$parcel$export(module.exports, "AvgPool3DGrad", function () { return $6fe8d689b60c784e$export$7163112adf28c062; });
$parcel$export(module.exports, "BatchMatMul", function () { return $6fe8d689b60c784e$export$9a3bf60b23f63c8; });
$parcel$export(module.exports, "BatchToSpaceND", function () { return $6fe8d689b60c784e$export$e2743f47f61cca1f; });
$parcel$export(module.exports, "Bincount", function () { return $6fe8d689b60c784e$export$45dfbbff595c32aa; });
$parcel$export(module.exports, "BitwiseAnd", function () { return $6fe8d689b60c784e$export$a9e259e32a62221f; });
$parcel$export(module.exports, "BroadcastTo", function () { return $6fe8d689b60c784e$export$ea5eeb875a7c4dd1; });
$parcel$export(module.exports, "BroadcastArgs", function () { return $6fe8d689b60c784e$export$32877b1d6d497805; });
$parcel$export(module.exports, "Cast", function () { return $6fe8d689b60c784e$export$107ecfb3d1ccbd77; });
$parcel$export(module.exports, "Ceil", function () { return $6fe8d689b60c784e$export$d4a1bccfd52ebd3; });
$parcel$export(module.exports, "ClipByValue", function () { return $6fe8d689b60c784e$export$611c0e357ac37f7d; });
$parcel$export(module.exports, "Complex", function () { return $6fe8d689b60c784e$export$50ceb3fb9926e63e; });
$parcel$export(module.exports, "ComplexAbs", function () { return $6fe8d689b60c784e$export$32902e58f1b48f4b; });
$parcel$export(module.exports, "Concat", function () { return $6fe8d689b60c784e$export$936bbfc007425eea; });
$parcel$export(module.exports, "Conv2D", function () { return $6fe8d689b60c784e$export$57742e605d475795; });
$parcel$export(module.exports, "Conv2DBackpropFilter", function () { return $6fe8d689b60c784e$export$32a8943c0f1ca5a7; });
$parcel$export(module.exports, "Conv2DBackpropInput", function () { return $6fe8d689b60c784e$export$e26961e8ed0eb404; });
$parcel$export(module.exports, "Conv3D", function () { return $6fe8d689b60c784e$export$9d3874201dd21933; });
$parcel$export(module.exports, "Conv3DBackpropFilterV2", function () { return $6fe8d689b60c784e$export$dd2885efe6043eee; });
$parcel$export(module.exports, "Conv3DBackpropInputV2", function () { return $6fe8d689b60c784e$export$a54f552d6d7d521f; });
$parcel$export(module.exports, "Cos", function () { return $6fe8d689b60c784e$export$ddfd0a983d257666; });
$parcel$export(module.exports, "Cosh", function () { return $6fe8d689b60c784e$export$5e311a1c57b0d27c; });
$parcel$export(module.exports, "Cumprod", function () { return $6fe8d689b60c784e$export$e581acc6014c47a; });
$parcel$export(module.exports, "Cumsum", function () { return $6fe8d689b60c784e$export$706617d894ad63da; });
$parcel$export(module.exports, "CropAndResize", function () { return $6fe8d689b60c784e$export$50bc9557793c2e04; });
$parcel$export(module.exports, "DenseBincount", function () { return $6fe8d689b60c784e$export$5bab6834954299c5; });
$parcel$export(module.exports, "DepthToSpace", function () { return $6fe8d689b60c784e$export$fb0ee52d0cd6f233; });
$parcel$export(module.exports, "DepthwiseConv2dNative", function () { return $6fe8d689b60c784e$export$7c0fc590ff9e156f; });
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropFilter", function () { return $6fe8d689b60c784e$export$c99f139e0d4d1833; });
$parcel$export(module.exports, "DepthwiseConv2dNativeBackpropInput", function () { return $6fe8d689b60c784e$export$8649ca3b17033a24; });
$parcel$export(module.exports, "Diag", function () { return $6fe8d689b60c784e$export$ca73a25315ddeb7f; });
$parcel$export(module.exports, "Dilation2D", function () { return $6fe8d689b60c784e$export$dbbb7830c6497701; });
$parcel$export(module.exports, "Dilation2DBackpropInput", function () { return $6fe8d689b60c784e$export$5dd675a6b0f37e17; });
$parcel$export(module.exports, "Dilation2DBackpropFilter", function () { return $6fe8d689b60c784e$export$91add972be69d592; });
$parcel$export(module.exports, "Draw", function () { return $6fe8d689b60c784e$export$dca20402ebea5ece; });
$parcel$export(module.exports, "RealDiv", function () { return $6fe8d689b60c784e$export$b9880b86e1014bb8; });
$parcel$export(module.exports, "Einsum", function () { return $6fe8d689b60c784e$export$2541d8be32f3c641; });
$parcel$export(module.exports, "Elu", function () { return $6fe8d689b60c784e$export$64636e173424d83d; });
$parcel$export(module.exports, "EluGrad", function () { return $6fe8d689b60c784e$export$9906be4699a73c53; });
$parcel$export(module.exports, "Erf", function () { return $6fe8d689b60c784e$export$c2ee2551ce71f1d0; });
$parcel$export(module.exports, "Equal", function () { return $6fe8d689b60c784e$export$8dcf9f58ce5cdfc; });
$parcel$export(module.exports, "Exp", function () { return $6fe8d689b60c784e$export$f908be7a96fb3363; });
$parcel$export(module.exports, "ExpandDims", function () { return $6fe8d689b60c784e$export$2391750b1d901146; });
$parcel$export(module.exports, "Expm1", function () { return $6fe8d689b60c784e$export$261f26143a1ff3; });
$parcel$export(module.exports, "FFT", function () { return $6fe8d689b60c784e$export$677347237c014ba; });
$parcel$export(module.exports, "Fill", function () { return $6fe8d689b60c784e$export$ffffe40bfa0649a3; });
$parcel$export(module.exports, "FlipLeftRight", function () { return $6fe8d689b60c784e$export$34e7296fc8558df5; });
$parcel$export(module.exports, "Floor", function () { return $6fe8d689b60c784e$export$4880b0ae5643c62b; });
$parcel$export(module.exports, "FloorDiv", function () { return $6fe8d689b60c784e$export$d79b5692ede26c2f; });
$parcel$export(module.exports, "FusedBatchNorm", function () { return $6fe8d689b60c784e$export$3821a0416660aaa2; });
$parcel$export(module.exports, "GatherV2", function () { return $6fe8d689b60c784e$export$ccd988942e5c0181; });
$parcel$export(module.exports, "GatherNd", function () { return $6fe8d689b60c784e$export$4ef6e37a23721703; });
$parcel$export(module.exports, "Greater", function () { return $6fe8d689b60c784e$export$d0a25eac5ee3f515; });
$parcel$export(module.exports, "GreaterEqual", function () { return $6fe8d689b60c784e$export$3b7d21bc9aee0851; });
$parcel$export(module.exports, "Identity", function () { return $6fe8d689b60c784e$export$544bf02140fa9a77; });
$parcel$export(module.exports, "IFFT", function () { return $6fe8d689b60c784e$export$21c6f576ae8100e8; });
$parcel$export(module.exports, "Imag", function () { return $6fe8d689b60c784e$export$303b4473993a24f; });
$parcel$export(module.exports, "IsFinite", function () { return $6fe8d689b60c784e$export$b9fcc0946d7d485e; });
$parcel$export(module.exports, "IsInf", function () { return $6fe8d689b60c784e$export$74b5a3bc735b152; });
$parcel$export(module.exports, "IsNan", function () { return $6fe8d689b60c784e$export$9912dc4fc649dbec; });
$parcel$export(module.exports, "LeakyRelu", function () { return $6fe8d689b60c784e$export$f0c7162bb7af1a2d; });
$parcel$export(module.exports, "Less", function () { return $6fe8d689b60c784e$export$728c50f1c88ac779; });
$parcel$export(module.exports, "LessEqual", function () { return $6fe8d689b60c784e$export$84afd0d8f7fb8c5d; });
$parcel$export(module.exports, "LinSpace", function () { return $6fe8d689b60c784e$export$34f0ab8eba543ee6; });
$parcel$export(module.exports, "Log", function () { return $6fe8d689b60c784e$export$ce30dbb46644d06c; });
$parcel$export(module.exports, "Log1p", function () { return $6fe8d689b60c784e$export$70f05bf9ddcfca68; });
$parcel$export(module.exports, "LogicalAnd", function () { return $6fe8d689b60c784e$export$8a27ff10dff4d6e5; });
$parcel$export(module.exports, "LogicalNot", function () { return $6fe8d689b60c784e$export$4393bee5596c68c2; });
$parcel$export(module.exports, "LogicalOr", function () { return $6fe8d689b60c784e$export$c49f9f5ffc6f678c; });
$parcel$export(module.exports, "LogSoftmax", function () { return $6fe8d689b60c784e$export$85b5bcbd60848a10; });
$parcel$export(module.exports, "LRN", function () { return $6fe8d689b60c784e$export$eb2f713fc3e1ca9a; });
$parcel$export(module.exports, "LRNGrad", function () { return $6fe8d689b60c784e$export$73ba43cd0ce95b10; });
$parcel$export(module.exports, "Max", function () { return $6fe8d689b60c784e$export$d36c09e5d02927e7; });
$parcel$export(module.exports, "Maximum", function () { return $6fe8d689b60c784e$export$d8d02ac92d161004; });
$parcel$export(module.exports, "MaxPool", function () { return $6fe8d689b60c784e$export$39ea33024ddd5cf; });
$parcel$export(module.exports, "MaxPoolGrad", function () { return $6fe8d689b60c784e$export$f0f010b1d1db8a46; });
$parcel$export(module.exports, "MaxPool3D", function () { return $6fe8d689b60c784e$export$88fdc64af890fc53; });
$parcel$export(module.exports, "MaxPool3DGrad", function () { return $6fe8d689b60c784e$export$52be2c00371a1350; });
$parcel$export(module.exports, "MaxPoolWithArgmax", function () { return $6fe8d689b60c784e$export$deac4b7497b4047f; });
$parcel$export(module.exports, "Mean", function () { return $6fe8d689b60c784e$export$1c2d59c4b681fbd8; });
$parcel$export(module.exports, "Min", function () { return $6fe8d689b60c784e$export$dfed19fabc75a31d; });
$parcel$export(module.exports, "Minimum", function () { return $6fe8d689b60c784e$export$23cb308301e89d6b; });
$parcel$export(module.exports, "MirrorPad", function () { return $6fe8d689b60c784e$export$f4c0e95fd7fd31e5; });
$parcel$export(module.exports, "Mod", function () { return $6fe8d689b60c784e$export$e4835a5e3f3674d5; });
$parcel$export(module.exports, "Multinomial", function () { return $6fe8d689b60c784e$export$ee0a8cfb693e0e3f; });
$parcel$export(module.exports, "Multiply", function () { return $6fe8d689b60c784e$export$f14f83b3b531d498; });
$parcel$export(module.exports, "Neg", function () { return $6fe8d689b60c784e$export$c07c549000872073; });
$parcel$export(module.exports, "NotEqual", function () { return $6fe8d689b60c784e$export$385ebe9945cae0c5; });
$parcel$export(module.exports, "NonMaxSuppressionV3", function () { return $6fe8d689b60c784e$export$5e11788439c2f04; });
$parcel$export(module.exports, "NonMaxSuppressionV4", function () { return $6fe8d689b60c784e$export$7df908154366fe7f; });
$parcel$export(module.exports, "NonMaxSuppressionV5", function () { return $6fe8d689b60c784e$export$cb45d3fcefce2ef0; });
$parcel$export(module.exports, "OnesLike", function () { return $6fe8d689b60c784e$export$a2962e735c809d91; });
$parcel$export(module.exports, "OneHot", function () { return $6fe8d689b60c784e$export$18982b43ba8c02e9; });
$parcel$export(module.exports, "Pack", function () { return $6fe8d689b60c784e$export$c26f40b29201e5b7; });
$parcel$export(module.exports, "PadV2", function () { return $6fe8d689b60c784e$export$5d47ba206577f0f2; });
$parcel$export(module.exports, "Pow", function () { return $6fe8d689b60c784e$export$ce28d653ec559ee; });
$parcel$export(module.exports, "Prelu", function () { return $6fe8d689b60c784e$export$a42f35f308fc2fa3; });
$parcel$export(module.exports, "Prod", function () { return $6fe8d689b60c784e$export$b8a16d526a791fb0; });
$parcel$export(module.exports, "RaggedGather", function () { return $6fe8d689b60c784e$export$ffee9c5b4fce08a1; });
$parcel$export(module.exports, "RaggedRange", function () { return $6fe8d689b60c784e$export$9d0615a9a6d213d2; });
$parcel$export(module.exports, "RaggedTensorToTensor", function () { return $6fe8d689b60c784e$export$616d73a9ab7617c7; });
$parcel$export(module.exports, "Range", function () { return $6fe8d689b60c784e$export$9a58ef0d7ad3278c; });
$parcel$export(module.exports, "Real", function () { return $6fe8d689b60c784e$export$f41305719b94e675; });
$parcel$export(module.exports, "Reciprocal", function () { return $6fe8d689b60c784e$export$c6e4a23ed5e0415b; });
$parcel$export(module.exports, "Relu", function () { return $6fe8d689b60c784e$export$9a6ff968bf961432; });
$parcel$export(module.exports, "Reshape", function () { return $6fe8d689b60c784e$export$755ddd847e5abe03; });
$parcel$export(module.exports, "ResizeNearestNeighbor", function () { return $6fe8d689b60c784e$export$6c8d8ec26192bb18; });
$parcel$export(module.exports, "ResizeNearestNeighborGrad", function () { return $6fe8d689b60c784e$export$b84ac31c55aa023b; });
$parcel$export(module.exports, "ResizeBilinear", function () { return $6fe8d689b60c784e$export$24f2f15d869e0fd; });
$parcel$export(module.exports, "ResizeBilinearGrad", function () { return $6fe8d689b60c784e$export$2d3cf759f1538c13; });
$parcel$export(module.exports, "Relu6", function () { return $6fe8d689b60c784e$export$3be9e924f629054e; });
$parcel$export(module.exports, "Reverse", function () { return $6fe8d689b60c784e$export$53c81f36b32e1bba; });
$parcel$export(module.exports, "Round", function () { return $6fe8d689b60c784e$export$c5ed3eef16c0612f; });
$parcel$export(module.exports, "Rsqrt", function () { return $6fe8d689b60c784e$export$7cc53aa09f5f3a2d; });
$parcel$export(module.exports, "ScatterNd", function () { return $6fe8d689b60c784e$export$28eef6f0168af686; });
$parcel$export(module.exports, "TensorScatterUpdate", function () { return $6fe8d689b60c784e$export$20050a140fd1de77; });
$parcel$export(module.exports, "SearchSorted", function () { return $6fe8d689b60c784e$export$9a1405490b09867e; });
$parcel$export(module.exports, "Select", function () { return $6fe8d689b60c784e$export$ef9b1a59e592288f; });
$parcel$export(module.exports, "Selu", function () { return $6fe8d689b60c784e$export$6760d858e6f2594a; });
$parcel$export(module.exports, "Slice", function () { return $6fe8d689b60c784e$export$b3f2e2de3a8baa1e; });
$parcel$export(module.exports, "Sin", function () { return $6fe8d689b60c784e$export$75be1b631f7687; });
$parcel$export(module.exports, "Sinh", function () { return $6fe8d689b60c784e$export$b8c187376329d79b; });
$parcel$export(module.exports, "Sign", function () { return $6fe8d689b60c784e$export$1db683ad541682f6; });
$parcel$export(module.exports, "Sigmoid", function () { return $6fe8d689b60c784e$export$fde18c826dda6b1b; });
$parcel$export(module.exports, "Softplus", function () { return $6fe8d689b60c784e$export$c5af433747f1fd0a; });
$parcel$export(module.exports, "Sqrt", function () { return $6fe8d689b60c784e$export$21ab404ab9d512a6; });
$parcel$export(module.exports, "Sum", function () { return $6fe8d689b60c784e$export$534760f50726d5; });
$parcel$export(module.exports, "SpaceToBatchND", function () { return $6fe8d689b60c784e$export$f63ac5409312707c; });
$parcel$export(module.exports, "SplitV", function () { return $6fe8d689b60c784e$export$8dffabb4071f05aa; });
$parcel$export(module.exports, "Softmax", function () { return $6fe8d689b60c784e$export$350a526055d3ca6e; });
$parcel$export(module.exports, "SparseFillEmptyRows", function () { return $6fe8d689b60c784e$export$8f1933853a5c8cca; });
$parcel$export(module.exports, "SparseReshape", function () { return $6fe8d689b60c784e$export$f08f0dca44fa542; });
$parcel$export(module.exports, "SparseSegmentMean", function () { return $6fe8d689b60c784e$export$610b077aecc2447b; });
$parcel$export(module.exports, "SparseSegmentSum", function () { return $6fe8d689b60c784e$export$68351c28d7116b56; });
$parcel$export(module.exports, "SparseToDense", function () { return $6fe8d689b60c784e$export$2c426709a9332421; });
$parcel$export(module.exports, "SquaredDifference", function () { return $6fe8d689b60c784e$export$2f922d20d66089c6; });
$parcel$export(module.exports, "Square", function () { return $6fe8d689b60c784e$export$b09fb900337259de; });
$parcel$export(module.exports, "StaticRegexReplace", function () { return $6fe8d689b60c784e$export$2fbaa77553edaeff; });
$parcel$export(module.exports, "StridedSlice", function () { return $6fe8d689b60c784e$export$60c7f9ac271417a9; });
$parcel$export(module.exports, "StringNGrams", function () { return $6fe8d689b60c784e$export$11a7f4af7d96ad41; });
$parcel$export(module.exports, "StringSplit", function () { return $6fe8d689b60c784e$export$7e266f7223b9d396; });
$parcel$export(module.exports, "StringToHashBucketFast", function () { return $6fe8d689b60c784e$export$a5639899909bc8ae; });
$parcel$export(module.exports, "Sub", function () { return $6fe8d689b60c784e$export$d7a01e11500dfb6f; });
$parcel$export(module.exports, "Tan", function () { return $6fe8d689b60c784e$export$115b2d5263ba5985; });
$parcel$export(module.exports, "Tanh", function () { return $6fe8d689b60c784e$export$893b6e865e352c83; });
$parcel$export(module.exports, "Tile", function () { return $6fe8d689b60c784e$export$235cb65c20ad2b7; });
$parcel$export(module.exports, "TopK", function () { return $6fe8d689b60c784e$export$c593cd1ea0d02ebd; });
$parcel$export(module.exports, "Transform", function () { return $6fe8d689b60c784e$export$563a914cafbdc389; });
$parcel$export(module.exports, "Transpose", function () { return $6fe8d689b60c784e$export$7e714455f9a1f8f7; });
$parcel$export(module.exports, "Unique", function () { return $6fe8d689b60c784e$export$8e3adf126971a183; });
$parcel$export(module.exports, "Unpack", function () { return $6fe8d689b60c784e$export$441ad6bfc5db8ab4; });
$parcel$export(module.exports, "UnsortedSegmentSum", function () { return $6fe8d689b60c784e$export$af810663cded5fe2; });
$parcel$export(module.exports, "ZerosLike", function () { return $6fe8d689b60c784e$export$430969a37eda1e88; });
$parcel$export(module.exports, "Step", function () { return $6fe8d689b60c784e$export$fd55ce593607084a; });
$parcel$export(module.exports, "FromPixels", function () { return $6fe8d689b60c784e$export$d0eb4e7054966c48; });
$parcel$export(module.exports, "RotateWithOffset", function () { return $6fe8d689b60c784e$export$c5a44649815d1c3; });
$parcel$export(module.exports, "_FusedMatMul", function () { return $6fe8d689b60c784e$export$8d1af0f7c2a4da9e; });
$parcel$export(module.exports, "FusedConv2D", function () { return $6fe8d689b60c784e$export$86f8a8e3a8f2a8f2; });
$parcel$export(module.exports, "FusedDepthwiseConv2D", function () { return $6fe8d689b60c784e$export$5a249e8f498c02c1; });
const $6fe8d689b60c784e$export$b73c596ee8758a66 = 'Abs';
const $6fe8d689b60c784e$export$3b952c9980dac550 = 'Acos';
const $6fe8d689b60c784e$export$987da490b7c2e7dd = 'Acosh';
const $6fe8d689b60c784e$export$d0265b2c425512d6 = 'Add';
const $6fe8d689b60c784e$export$eef235ad06d3226a = 'AddN';
const $6fe8d689b60c784e$export$5dceb1ab650a1776 = 'All';
const $6fe8d689b60c784e$export$b24b633b1364b94b = 'Any';
const $6fe8d689b60c784e$export$17612294a1503e1c = 'ArgMax';
const $6fe8d689b60c784e$export$baabd09270cbbd94 = 'ArgMin';
const $6fe8d689b60c784e$export$664c8ca7e7e5c126 = 'Asin';
const $6fe8d689b60c784e$export$847c88940cb7dcb5 = 'Asinh';
const $6fe8d689b60c784e$export$bac667d46ac043ae = 'Atan';
const $6fe8d689b60c784e$export$98981a86fa2b1366 = 'Atanh';
const $6fe8d689b60c784e$export$3bf4c619ce589f4b = 'Atan2';
const $6fe8d689b60c784e$export$37f2cc7be1add88c = 'AvgPool';
const $6fe8d689b60c784e$export$9873fd6046cd6951 = 'AvgPoolGrad';
const $6fe8d689b60c784e$export$390ecb697af103f6 = 'AvgPool3D';
const $6fe8d689b60c784e$export$7163112adf28c062 = 'AvgPool3DGrad';
const $6fe8d689b60c784e$export$9a3bf60b23f63c8 = 'BatchMatMul';
const $6fe8d689b60c784e$export$e2743f47f61cca1f = 'BatchToSpaceND';
const $6fe8d689b60c784e$export$45dfbbff595c32aa = 'Bincount';
const $6fe8d689b60c784e$export$a9e259e32a62221f = 'BitwiseAnd';
const $6fe8d689b60c784e$export$ea5eeb875a7c4dd1 = 'BroadcastTo';
const $6fe8d689b60c784e$export$32877b1d6d497805 = 'BroadcastArgs';
const $6fe8d689b60c784e$export$107ecfb3d1ccbd77 = 'Cast';
const $6fe8d689b60c784e$export$d4a1bccfd52ebd3 = 'Ceil';
const $6fe8d689b60c784e$export$611c0e357ac37f7d = 'ClipByValue';
const $6fe8d689b60c784e$export$50ceb3fb9926e63e = 'Complex';
const $6fe8d689b60c784e$export$32902e58f1b48f4b = 'ComplexAbs';
const $6fe8d689b60c784e$export$936bbfc007425eea = 'Concat';
const $6fe8d689b60c784e$export$57742e605d475795 = 'Conv2D';
const $6fe8d689b60c784e$export$32a8943c0f1ca5a7 = 'Conv2DBackpropFilter';
const $6fe8d689b60c784e$export$e26961e8ed0eb404 = 'Conv2DBackpropInput';
const $6fe8d689b60c784e$export$9d3874201dd21933 = 'Conv3D';
const $6fe8d689b60c784e$export$dd2885efe6043eee = 'Conv3DBackpropFilterV2';
const $6fe8d689b60c784e$export$a54f552d6d7d521f = 'Conv3DBackpropInputV2';
const $6fe8d689b60c784e$export$ddfd0a983d257666 = 'Cos';
const $6fe8d689b60c784e$export$5e311a1c57b0d27c = 'Cosh';
const $6fe8d689b60c784e$export$e581acc6014c47a = 'Cumprod';
const $6fe8d689b60c784e$export$706617d894ad63da = 'Cumsum';
const $6fe8d689b60c784e$export$50bc9557793c2e04 = 'CropAndResize';
const $6fe8d689b60c784e$export$5bab6834954299c5 = 'DenseBincount';
const $6fe8d689b60c784e$export$fb0ee52d0cd6f233 = 'DepthToSpace';
const $6fe8d689b60c784e$export$7c0fc590ff9e156f = 'DepthwiseConv2dNative';
const $6fe8d689b60c784e$export$c99f139e0d4d1833 = 'DepthwiseConv2dNativeBackpropFilter';
const $6fe8d689b60c784e$export$8649ca3b17033a24 = 'DepthwiseConv2dNativeBackpropInput';
const $6fe8d689b60c784e$export$ca73a25315ddeb7f = 'Diag';
const $6fe8d689b60c784e$export$dbbb7830c6497701 = 'Dilation2D';
const $6fe8d689b60c784e$export$5dd675a6b0f37e17 = 'Dilation2DBackpropInput';
const $6fe8d689b60c784e$export$91add972be69d592 = 'Dilation2DBackpropFilter';
const $6fe8d689b60c784e$export$dca20402ebea5ece = 'Draw';
const $6fe8d689b60c784e$export$b9880b86e1014bb8 = 'RealDiv';
const $6fe8d689b60c784e$export$2541d8be32f3c641 = 'Einsum';
const $6fe8d689b60c784e$export$64636e173424d83d = 'Elu';
const $6fe8d689b60c784e$export$9906be4699a73c53 = 'EluGrad';
const $6fe8d689b60c784e$export$c2ee2551ce71f1d0 = 'Erf';
const $6fe8d689b60c784e$export$8dcf9f58ce5cdfc = 'Equal';
const $6fe8d689b60c784e$export$f908be7a96fb3363 = 'Exp';
const $6fe8d689b60c784e$export$2391750b1d901146 = 'ExpandDims';
const $6fe8d689b60c784e$export$261f26143a1ff3 = 'Expm1';
const $6fe8d689b60c784e$export$677347237c014ba = 'FFT';
const $6fe8d689b60c784e$export$ffffe40bfa0649a3 = 'Fill';
const $6fe8d689b60c784e$export$34e7296fc8558df5 = 'FlipLeftRight';
const $6fe8d689b60c784e$export$4880b0ae5643c62b = 'Floor';
const $6fe8d689b60c784e$export$d79b5692ede26c2f = 'FloorDiv';
const $6fe8d689b60c784e$export$3821a0416660aaa2 = 'FusedBatchNorm';
const $6fe8d689b60c784e$export$ccd988942e5c0181 = 'GatherV2';
const $6fe8d689b60c784e$export$4ef6e37a23721703 = 'GatherNd';
const $6fe8d689b60c784e$export$d0a25eac5ee3f515 = 'Greater';
const $6fe8d689b60c784e$export$3b7d21bc9aee0851 = 'GreaterEqual';
const $6fe8d689b60c784e$export$544bf02140fa9a77 = 'Identity';
const $6fe8d689b60c784e$export$21c6f576ae8100e8 = 'IFFT';
const $6fe8d689b60c784e$export$303b4473993a24f = 'Imag';
const $6fe8d689b60c784e$export$b9fcc0946d7d485e = 'IsFinite';
const $6fe8d689b60c784e$export$74b5a3bc735b152 = 'IsInf';
const $6fe8d689b60c784e$export$9912dc4fc649dbec = 'IsNan';
const $6fe8d689b60c784e$export$f0c7162bb7af1a2d = 'LeakyRelu';
const $6fe8d689b60c784e$export$728c50f1c88ac779 = 'Less';
const $6fe8d689b60c784e$export$84afd0d8f7fb8c5d = 'LessEqual';
const $6fe8d689b60c784e$export$34f0ab8eba543ee6 = 'LinSpace';
const $6fe8d689b60c784e$export$ce30dbb46644d06c = 'Log';
const $6fe8d689b60c784e$export$70f05bf9ddcfca68 = 'Log1p';
const $6fe8d689b60c784e$export$8a27ff10dff4d6e5 = 'LogicalAnd';
const $6fe8d689b60c784e$export$4393bee5596c68c2 = 'LogicalNot';
const $6fe8d689b60c784e$export$c49f9f5ffc6f678c = 'LogicalOr';
const $6fe8d689b60c784e$export$656629b293485eff = 'LogicalXor';
const $6fe8d689b60c784e$export$85b5bcbd60848a10 = 'LogSoftmax';
const $6fe8d689b60c784e$export$9ec35fe80d53e931 = 'LowerBound';
const $6fe8d689b60c784e$export$eb2f713fc3e1ca9a = 'LRN';
const $6fe8d689b60c784e$export$73ba43cd0ce95b10 = 'LRNGrad';
const $6fe8d689b60c784e$export$b4571177c51d555b = 'MatrixBandPart';
const $6fe8d689b60c784e$export$d36c09e5d02927e7 = 'Max';
const $6fe8d689b60c784e$export$d8d02ac92d161004 = 'Maximum';
const $6fe8d689b60c784e$export$39ea33024ddd5cf = 'MaxPool';
const $6fe8d689b60c784e$export$f0f010b1d1db8a46 = 'MaxPoolGrad';
const $6fe8d689b60c784e$export$88fdc64af890fc53 = 'MaxPool3D';
const $6fe8d689b60c784e$export$52be2c00371a1350 = 'MaxPool3DGrad';
const $6fe8d689b60c784e$export$deac4b7497b4047f = 'MaxPoolWithArgmax';
const $6fe8d689b60c784e$export$1c2d59c4b681fbd8 = 'Mean';
const $6fe8d689b60c784e$export$dfed19fabc75a31d = 'Min';
const $6fe8d689b60c784e$export$23cb308301e89d6b = 'Minimum';
const $6fe8d689b60c784e$export$f4c0e95fd7fd31e5 = 'MirrorPad';
const $6fe8d689b60c784e$export$e4835a5e3f3674d5 = 'Mod';
const $6fe8d689b60c784e$export$ee0a8cfb693e0e3f = 'Multinomial';
const $6fe8d689b60c784e$export$f14f83b3b531d498 = 'Multiply';
const $6fe8d689b60c784e$export$c07c549000872073 = 'Neg';
const $6fe8d689b60c784e$export$385ebe9945cae0c5 = 'NotEqual';
const $6fe8d689b60c784e$export$5e11788439c2f04 = 'NonMaxSuppressionV3';
const $6fe8d689b60c784e$export$7df908154366fe7f = 'NonMaxSuppressionV4';
const $6fe8d689b60c784e$export$cb45d3fcefce2ef0 = 'NonMaxSuppressionV5';
const $6fe8d689b60c784e$export$a2962e735c809d91 = 'OnesLike';
const $6fe8d689b60c784e$export$18982b43ba8c02e9 = 'OneHot';
const $6fe8d689b60c784e$export$c26f40b29201e5b7 = 'Pack';
const $6fe8d689b60c784e$export$5d47ba206577f0f2 = 'PadV2';
const $6fe8d689b60c784e$export$14963ee5c8637e11 = 'Pool';
const $6fe8d689b60c784e$export$ce28d653ec559ee = 'Pow';
const $6fe8d689b60c784e$export$a42f35f308fc2fa3 = 'Prelu';
const $6fe8d689b60c784e$export$b8a16d526a791fb0 = 'Prod';
const $6fe8d689b60c784e$export$ffee9c5b4fce08a1 = 'RaggedGather';
const $6fe8d689b60c784e$export$9d0615a9a6d213d2 = 'RaggedRange';
const $6fe8d689b60c784e$export$616d73a9ab7617c7 = 'RaggedTensorToTensor';
const $6fe8d689b60c784e$export$9a58ef0d7ad3278c = 'Range';
const $6fe8d689b60c784e$export$f41305719b94e675 = 'Real';
const $6fe8d689b60c784e$export$c6e4a23ed5e0415b = 'Reciprocal';
const $6fe8d689b60c784e$export$9a6ff968bf961432 = 'Relu';
const $6fe8d689b60c784e$export$755ddd847e5abe03 = 'Reshape';
const $6fe8d689b60c784e$export$6c8d8ec26192bb18 = 'ResizeNearestNeighbor';
const $6fe8d689b60c784e$export$b84ac31c55aa023b = 'ResizeNearestNeighborGrad';
const $6fe8d689b60c784e$export$24f2f15d869e0fd = 'ResizeBilinear';
const $6fe8d689b60c784e$export$2d3cf759f1538c13 = 'ResizeBilinearGrad';
const $6fe8d689b60c784e$export$3be9e924f629054e = 'Relu6';
const $6fe8d689b60c784e$export$53c81f36b32e1bba = 'Reverse';
const $6fe8d689b60c784e$export$c5ed3eef16c0612f = 'Round';
const $6fe8d689b60c784e$export$7cc53aa09f5f3a2d = 'Rsqrt';
const $6fe8d689b60c784e$export$28eef6f0168af686 = 'ScatterNd';
const $6fe8d689b60c784e$export$20050a140fd1de77 = 'TensorScatterUpdate';
const $6fe8d689b60c784e$export$9a1405490b09867e = 'SearchSorted';
const $6fe8d689b60c784e$export$ef9b1a59e592288f = 'Select';
const $6fe8d689b60c784e$export$6760d858e6f2594a = 'Selu';
const $6fe8d689b60c784e$export$b3f2e2de3a8baa1e = 'Slice';
const $6fe8d689b60c784e$export$75be1b631f7687 = 'Sin';
const $6fe8d689b60c784e$export$b8c187376329d79b = 'Sinh';
const $6fe8d689b60c784e$export$1db683ad541682f6 = 'Sign';
const $6fe8d689b60c784e$export$fde18c826dda6b1b = 'Sigmoid';
const $6fe8d689b60c784e$export$c5af433747f1fd0a = 'Softplus';
const $6fe8d689b60c784e$export$21ab404ab9d512a6 = 'Sqrt';
const $6fe8d689b60c784e$export$534760f50726d5 = 'Sum';
const $6fe8d689b60c784e$export$f63ac5409312707c = 'SpaceToBatchND';
const $6fe8d689b60c784e$export$8dffabb4071f05aa = 'SplitV';
const $6fe8d689b60c784e$export$350a526055d3ca6e = 'Softmax';
const $6fe8d689b60c784e$export$8f1933853a5c8cca = 'SparseFillEmptyRows';
const $6fe8d689b60c784e$export$f08f0dca44fa542 = 'SparseReshape';
const $6fe8d689b60c784e$export$610b077aecc2447b = 'SparseSegmentMean';
const $6fe8d689b60c784e$export$68351c28d7116b56 = 'SparseSegmentSum';
const $6fe8d689b60c784e$export$2c426709a9332421 = 'SparseToDense';
const $6fe8d689b60c784e$export$2f922d20d66089c6 = 'SquaredDifference';
const $6fe8d689b60c784e$export$b09fb900337259de = 'Square';
const $6fe8d689b60c784e$export$2fbaa77553edaeff = 'StaticRegexReplace';
const $6fe8d689b60c784e$export$60c7f9ac271417a9 = 'StridedSlice';
const $6fe8d689b60c784e$export$11a7f4af7d96ad41 = 'StringNGrams';
const $6fe8d689b60c784e$export$7e266f7223b9d396 = 'StringSplit';
const $6fe8d689b60c784e$export$a5639899909bc8ae = 'StringToHashBucketFast';
const $6fe8d689b60c784e$export$d7a01e11500dfb6f = 'Sub';
const $6fe8d689b60c784e$export$115b2d5263ba5985 = 'Tan';
const $6fe8d689b60c784e$export$893b6e865e352c83 = 'Tanh';
const $6fe8d689b60c784e$export$235cb65c20ad2b7 = 'Tile';
const $6fe8d689b60c784e$export$c593cd1ea0d02ebd = 'TopK';
const $6fe8d689b60c784e$export$563a914cafbdc389 = 'Transform';
const $6fe8d689b60c784e$export$7e714455f9a1f8f7 = 'Transpose';
const $6fe8d689b60c784e$export$8e3adf126971a183 = 'Unique';
const $6fe8d689b60c784e$export$441ad6bfc5db8ab4 = 'Unpack';
const $6fe8d689b60c784e$export$af810663cded5fe2 = 'UnsortedSegmentSum';
const $6fe8d689b60c784e$export$7dc194c8da2f9058 = 'UpperBound';
const $6fe8d689b60c784e$export$430969a37eda1e88 = 'ZerosLike';
const $6fe8d689b60c784e$export$fd55ce593607084a = 'Step';
const $6fe8d689b60c784e$export$d0eb4e7054966c48 = 'FromPixels';
const $6fe8d689b60c784e$export$c5a44649815d1c3 = 'RotateWithOffset';
const $6fe8d689b60c784e$export$8d1af0f7c2a4da9e = '_FusedMatMul';
const $6fe8d689b60c784e$export$86f8a8e3a8f2a8f2 = 'FusedConv2D';
const $6fe8d689b60c784e$export$5a249e8f498c02c1 = 'FusedDepthwiseConv2D';

});

parcelRegister("fPoI0", function(module, exports) {

$parcel$export(module.exports, "getKernel", function () { return $b85ec918a14b3234$export$1b85808c967cc434; });
$parcel$export(module.exports, "getGradient", function () { return $b85ec918a14b3234$export$e14995d3ec1747ee; });
$parcel$export(module.exports, "getKernelsForBackend", function () { return $b85ec918a14b3234$export$e4b8d76e176eaecc; });
$parcel$export(module.exports, "registerKernel", function () { return $b85ec918a14b3234$export$f3f7c443f3a606e6; });
$parcel$export(module.exports, "registerGradient", function () { return $b85ec918a14b3234$export$de9396b872fdfcc3; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $tdutJ = parcelRequire("tdutJ");

var $hri9Y = parcelRequire("hri9Y");

var $8Tale = parcelRequire("8Tale");
const $b85ec918a14b3234$var$kernelRegistry = (0, $hri9Y.getGlobal)('kernelRegistry', ()=>new Map());
const $b85ec918a14b3234$var$gradRegistry = (0, $hri9Y.getGlobal)('gradRegistry', ()=>new Map());
function $b85ec918a14b3234$export$1b85808c967cc434(kernelName, backendName) {
    const key = $b85ec918a14b3234$var$makeKey(kernelName, backendName);
    return $b85ec918a14b3234$var$kernelRegistry.get(key);
}
function $b85ec918a14b3234$export$e14995d3ec1747ee(kernelName) {
    return $b85ec918a14b3234$var$gradRegistry.get(kernelName);
}
function $b85ec918a14b3234$export$e4b8d76e176eaecc(backendName) {
    const it = $b85ec918a14b3234$var$kernelRegistry.entries();
    const result = [];
    while(true){
        const { done: done, value: value } = it.next();
        if (done) break;
        const [key, config] = value;
        const [backend] = key.split('_');
        if (backend === backendName) result.push(config);
    }
    return result;
}
function $b85ec918a14b3234$export$f3f7c443f3a606e6(config) {
    const { kernelName: kernelName, backendName: backendName } = config;
    const key = $b85ec918a14b3234$var$makeKey(kernelName, backendName);
    if ($b85ec918a14b3234$var$kernelRegistry.has(key)) $8Tale.warn(`The kernel '${kernelName}' for backend ` + `'${backendName}' is already registered`);
    $b85ec918a14b3234$var$kernelRegistry.set(key, config);
}
function $b85ec918a14b3234$export$de9396b872fdfcc3(config) {
    const { kernelName: kernelName } = config;
    if ($b85ec918a14b3234$var$gradRegistry.has(kernelName)) // TODO (yassogba) after 3.0 assess whether we need to keep this gated
    // to debug mode.
    {
        if ((0, $tdutJ.env)().getBool('DEBUG')) $8Tale.warn(`Overriding the gradient for '${kernelName}'`);
    }
    $b85ec918a14b3234$var$gradRegistry.set(kernelName, config);
}
function $b85ec918a14b3234$export$1c3fb41896379a12(kernelName, backendName) {
    const key = $b85ec918a14b3234$var$makeKey(kernelName, backendName);
    if (!$b85ec918a14b3234$var$kernelRegistry.has(key)) throw new Error(`The kernel '${kernelName}' for backend ` + `'${backendName}' is not registered`);
    $b85ec918a14b3234$var$kernelRegistry.delete(key);
}
function $b85ec918a14b3234$export$41b3e24402efeb81(kernelName) {
    if (!$b85ec918a14b3234$var$gradRegistry.has(kernelName)) throw new Error(`The gradient '${kernelName}' for backend is not registered`);
    $b85ec918a14b3234$var$gradRegistry.delete(kernelName);
}
function $b85ec918a14b3234$export$fb249e95c44186e6(registeredBackendName, newBackendName) {
    const kernels = $b85ec918a14b3234$export$e4b8d76e176eaecc(registeredBackendName);
    kernels.forEach((kernelConfig)=>{
        const newKernelConfig = Object.assign({}, kernelConfig, {
            backendName: newBackendName
        });
        $b85ec918a14b3234$export$f3f7c443f3a606e6(newKernelConfig);
    });
}
function $b85ec918a14b3234$var$makeKey(kernelName, backendName) {
    return `${backendName}_${kernelName}`;
}

});
parcelRegister("8Tale", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $678b7b669f81657b$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "log", function () { return $678b7b669f81657b$export$bef1f36f5486a6a3; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $tdutJ = parcelRequire("tdutJ");
function $678b7b669f81657b$export$c106dd0671a0fc2d(...msg) {
    if (!((0, $tdutJ.env)().getBool('IS_TEST') || (0, $tdutJ.env)().getBool('PROD'))) console.warn(...msg);
}
function $678b7b669f81657b$export$bef1f36f5486a6a3(...msg) {
    if (!((0, $tdutJ.env)().getBool('IS_TEST') || (0, $tdutJ.env)().getBool('PROD'))) console.log(...msg);
}

});


parcelRegister("crjA3", function(module, exports) {

$parcel$export(module.exports, "Profiler", function () { return $90e731f5d87cc5bb$export$e2c29f18771995cb; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $tdutJ = parcelRequire("tdutJ");

var $lBDHD = parcelRequire("lBDHD");
var $eOiOM = parcelRequire("eOiOM");
class $90e731f5d87cc5bb$export$e2c29f18771995cb {
    constructor(backendTimer, logger){
        this.backendTimer = backendTimer;
        this.logger = logger;
        if (logger == null) this.logger = new $90e731f5d87cc5bb$export$efa9a398d6368992();
    }
    profileKernel(kernelName, inputs, f) {
        let outputs;
        const holdResultWrapperFn = ()=>{
            outputs = f();
        };
        let timer;
        const start = $lBDHD.now();
        if (this.backendTimer.timerAvailable()) timer = this.backendTimer.time(holdResultWrapperFn);
        else {
            holdResultWrapperFn();
            for (const output of outputs)output.dataSync();
            timer = Promise.resolve({
                kernelMs: $lBDHD.now() - start
            });
        }
        if ((0, $tdutJ.env)().getBool('CHECK_COMPUTATION_FOR_ERRORS')) for(let i = 0; i < outputs.length; i++){
            const output = outputs[i];
            // Dangling promise here because we don't want to propagate up
            // asynchronicity.
            output.data().then((tensorVals)=>{
                $90e731f5d87cc5bb$export$7f6e9a47e989eedc(tensorVals, output.dtype, kernelName);
            });
        }
        const kernelProfile = {
            kernelName: kernelName,
            outputs: outputs,
            inputs: inputs,
            timeMs: timer.then((timing)=>timing.kernelMs),
            extraInfo: timer.then((timing)=>timing.getExtraProfileInfo != null ? timing.getExtraProfileInfo() : '')
        };
        return kernelProfile;
    }
    logKernelProfile(kernelProfile) {
        const { kernelName: kernelName, outputs: outputs, timeMs: timeMs, inputs: inputs, extraInfo: extraInfo } = kernelProfile;
        outputs.forEach((result)=>{
            Promise.all([
                result.data(),
                timeMs,
                extraInfo
            ]).then((valueContainer)=>{
                this.logger.logKernelProfile(kernelName, result, valueContainer[0], valueContainer[1], inputs, valueContainer[2]);
            });
        });
    }
}
function $90e731f5d87cc5bb$export$7f6e9a47e989eedc(vals, dtype, kernelName) {
    if (dtype !== 'float32') // Only floating point computations will generate NaN values
    return false;
    for(let i = 0; i < vals.length; i++){
        const num = vals[i];
        if (isNaN(num) || !isFinite(num)) {
            // Throwing custom exception so behavior is testable.
            console.warn(`Found ${num} in the result of '${kernelName}'`);
            return true;
        }
    }
    return false;
}
class $90e731f5d87cc5bb$export$efa9a398d6368992 {
    logKernelProfile(name, result, vals, timeMs, inputs, extraInfo) {
        const time = typeof timeMs === 'number' ? $eOiOM.rightPad(`${timeMs}ms`, 9) : timeMs['error'];
        const paddedName = $eOiOM.rightPad(name, 25);
        const rank = result.rank;
        const size = result.size;
        const shape = $eOiOM.rightPad(result.shape.toString(), 14);
        let inputShapesDescription = '';
        for(const name in inputs){
            const input = inputs[name];
            if (input != null) {
                // The input might be a non-tensor (e.g HTMLImageElement), in which case
                // we claim the output shape as input shape.
                const inputShape = input.shape || result.shape;
                const inputRank = inputShape.length;
                inputShapesDescription += `${name}: ${inputRank}D ${inputRank > 0 ? inputShape : ''} `;
            }
        }
        console.log(`%c${paddedName}\t%c${time}\t%c${rank}D ${shape}\t%c${size}\t%c${inputShapesDescription}\t%c${extraInfo}`, 'font-weight:bold', 'color:red', 'color:blue', 'color: orange', 'color: green', 'color: steelblue');
    }
}

});
parcelRegister("lBDHD", function(module, exports) {

$parcel$export(module.exports, "createScalarValue", function () { return $fbabd9d294ad75b6$export$cd3f28d8002ec2a2; });
$parcel$export(module.exports, "encodeString", function () { return $fbabd9d294ad75b6$export$8146d2e653b87d6a; });
$parcel$export(module.exports, "toTypedArray", function () { return $fbabd9d294ad75b6$export$965adc581230795c; });
$parcel$export(module.exports, "flatten", function () { return $fbabd9d294ad75b6$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "now", function () { return $fbabd9d294ad75b6$export$461939dd4422153; });
$parcel$export(module.exports, "fetch", function () { return $fbabd9d294ad75b6$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "decodeString", function () { return $fbabd9d294ad75b6$export$a0fb664af7d0cc44; });
$parcel$export(module.exports, "isTypedArray", function () { return $fbabd9d294ad75b6$export$b119cc7e1840e59c; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $tdutJ = parcelRequire("tdutJ");

var $axMwq = parcelRequire("axMwq");

var $eOiOM = parcelRequire("eOiOM");

var $3qRP7 = parcelRequire("3qRP7");
function $fbabd9d294ad75b6$export$cd3f28d8002ec2a2(value, dtype) {
    if (dtype === 'string') return $fbabd9d294ad75b6$export$8146d2e653b87d6a(value);
    return $fbabd9d294ad75b6$export$965adc581230795c([
        value
    ], dtype);
}
function $fbabd9d294ad75b6$var$noConversionNeeded(a, dtype) {
    return a instanceof Float32Array && dtype === 'float32' || a instanceof Int32Array && dtype === 'int32' || a instanceof Uint8Array && dtype === 'bool';
}
function $fbabd9d294ad75b6$export$965adc581230795c(a, dtype) {
    if (dtype === 'string') throw new Error('Cannot convert a string[] to a TypedArray');
    if (Array.isArray(a)) a = $fbabd9d294ad75b6$export$bffa455ba8c619a6(a);
    if ((0, $tdutJ.env)().getBool('DEBUG')) $eOiOM.checkConversionForErrors(a, dtype);
    if ($fbabd9d294ad75b6$var$noConversionNeeded(a, dtype)) return a;
    if (dtype == null || dtype === 'float32' || dtype === 'complex64') return new Float32Array(a);
    else if (dtype === 'int32') return new Int32Array(a);
    else if (dtype === 'bool') {
        const bool = new Uint8Array(a.length);
        for(let i = 0; i < bool.length; ++i)if (Math.round(a[i]) !== 0) bool[i] = 1;
        return bool;
    } else throw new Error(`Unknown data type ${dtype}`);
}
function $fbabd9d294ad75b6$export$461939dd4422153() {
    return (0, $tdutJ.env)().platform.now();
}
function $fbabd9d294ad75b6$export$e7aa7bc5c1b3cfb3(path, requestInits) {
    return (0, $tdutJ.env)().platform.fetch(path, requestInits);
}
function $fbabd9d294ad75b6$export$8146d2e653b87d6a(s, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $tdutJ.env)().platform.encode(s, encoding);
}
function $fbabd9d294ad75b6$export$a0fb664af7d0cc44(bytes, encoding = 'utf-8') {
    encoding = encoding || 'utf-8';
    return (0, $tdutJ.env)().platform.decode(bytes, encoding);
}
function $fbabd9d294ad75b6$export$b119cc7e1840e59c(a) {
    // TODO(mattsoulanille): Remove this fallback in 5.0.0
    if ((0, $tdutJ.env)().platform.isTypedArray != null) return (0, $tdutJ.env)().platform.isTypedArray(a);
    else return (0, $axMwq.isTypedArrayBrowser)(a);
}
function $fbabd9d294ad75b6$export$bffa455ba8c619a6(arr, result = [], skipTypedArray = false) {
    if (result == null) result = [];
    if (typeof arr === 'boolean' || typeof arr === 'number' || typeof arr === 'string' || $eOiOM.isPromise(arr) || arr == null || $fbabd9d294ad75b6$export$b119cc7e1840e59c(arr) && skipTypedArray) result.push(arr);
    else if (Array.isArray(arr) || $fbabd9d294ad75b6$export$b119cc7e1840e59c(arr)) for(let i = 0; i < arr.length; ++i)$fbabd9d294ad75b6$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    else {
        let maxIndex = -1;
        for (const key of Object.keys(arr))// 0 or positive integer.
        if (/^([1-9]+[0-9]*|0)$/.test(key)) maxIndex = Math.max(maxIndex, Number(key));
        for(let i = 0; i <= maxIndex; i++)// tslint:disable-next-line: no-unnecessary-type-assertion
        $fbabd9d294ad75b6$export$bffa455ba8c619a6(arr[i], result, skipTypedArray);
    }
    return result;
}
$parcel$exportWildcard(module.exports, $eOiOM);
$parcel$exportWildcard(module.exports, $3qRP7);

});
parcelRegister("axMwq", function(module, exports) {

$parcel$export(module.exports, "isTypedArrayBrowser", function () { return $7ad29fe7ba1244e2$export$632e6430b2d784cd; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $7ad29fe7ba1244e2$export$632e6430b2d784cd(a) {
    return a instanceof Float32Array || a instanceof Int32Array || a instanceof Uint8Array || a instanceof Uint8ClampedArray;
}

});

parcelRegister("3qRP7", function(module, exports) {

$parcel$export(module.exports, "hexToLong", function () { return $27fd8d0c8b9b1c9b$export$20e49d17901a85a5; });
$parcel$export(module.exports, "fingerPrint64", function () { return $27fd8d0c8b9b1c9b$export$919ee948dc019032; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for allowing cjs module to be included in bundle created by
// rollup.

var $gPSCs = parcelRequire("gPSCs");
// tslint:disable-next-line
const $27fd8d0c8b9b1c9b$var$Long = // tslint:disable-next-line
$gPSCs.default || $gPSCs;
function $27fd8d0c8b9b1c9b$export$20e49d17901a85a5(hex) {
    return $27fd8d0c8b9b1c9b$var$Long.fromString(hex, true, 16);
}
// Some primes between 2^63 and 2^64 for various uses.
// Hex 0xc3a5c85c97cb3127
const $27fd8d0c8b9b1c9b$var$k0 = $27fd8d0c8b9b1c9b$export$20e49d17901a85a5('c3a5c85c97cb3127');
// Hex 0xb492b66fbe98f273
const $27fd8d0c8b9b1c9b$var$k1 = $27fd8d0c8b9b1c9b$export$20e49d17901a85a5('b492b66fbe98f273');
// Hex 0x9ae16a3b2f90404f
const $27fd8d0c8b9b1c9b$var$k2 = $27fd8d0c8b9b1c9b$export$20e49d17901a85a5('9ae16a3b2f90404f');
function $27fd8d0c8b9b1c9b$var$shiftMix(val) {
    return val.xor(val.shru(47));
}
function $27fd8d0c8b9b1c9b$var$fetch(s, offset, numBytes) {
    const bytes = s.slice(offset, offset + numBytes);
    return $27fd8d0c8b9b1c9b$var$Long.fromBytes(Array.from(bytes), true, true);
}
function $27fd8d0c8b9b1c9b$var$fetch64(s, offset) {
    return $27fd8d0c8b9b1c9b$var$fetch(s, offset, 8);
}
function $27fd8d0c8b9b1c9b$var$fetch32(s, offset) {
    return $27fd8d0c8b9b1c9b$var$fetch(s, offset, 4);
}
function $27fd8d0c8b9b1c9b$var$rotate64(val, shift) {
    // Avoid shifting by 64: doing so yields an undefined result.
    return shift === 0 ? val : val.shru(shift).or(val.shl(64 - shift));
}
function $27fd8d0c8b9b1c9b$var$hashLen16(u, v, mul = $27fd8d0c8b9b1c9b$export$20e49d17901a85a5('9ddfea08eb382d69')) {
    // Murmur-inspired hashing.
    let a = u.xor(v).mul(mul);
    a = a.xor(a.shru(47));
    let b = v.xor(a).mul(mul);
    b = b.xor(b.shru(47));
    b = b.mul(mul);
    return b;
}
// Return a 16-byte hash for 48 bytes.  Quick and dirty.
// Callers do best to use "random-looking" values for a and b.
function $27fd8d0c8b9b1c9b$var$weakHashLen32WithSeeds(w, x, y, z, a, b) {
    a = a.add(w);
    b = $27fd8d0c8b9b1c9b$var$rotate64(b.add(a).add(z), 21);
    const c = a;
    a = a.add(x);
    a = a.add(y);
    b = b.add($27fd8d0c8b9b1c9b$var$rotate64(a, 44));
    return [
        a.add(z),
        b.add(c)
    ];
}
function $27fd8d0c8b9b1c9b$var$weakHashLen32WithSeedsStr(s, offset, a, b) {
    return $27fd8d0c8b9b1c9b$var$weakHashLen32WithSeeds($27fd8d0c8b9b1c9b$var$fetch64(s, offset), $27fd8d0c8b9b1c9b$var$fetch64(s, offset + 8), $27fd8d0c8b9b1c9b$var$fetch64(s, offset + 16), $27fd8d0c8b9b1c9b$var$fetch64(s, offset + 24), a, b);
}
function $27fd8d0c8b9b1c9b$var$hashLen0to16(s, len = s.length) {
    if (len >= 8) {
        const mul = $27fd8d0c8b9b1c9b$var$k2.add(len * 2);
        const a = $27fd8d0c8b9b1c9b$var$fetch64(s, 0).add($27fd8d0c8b9b1c9b$var$k2);
        const b = $27fd8d0c8b9b1c9b$var$fetch64(s, len - 8);
        const c = $27fd8d0c8b9b1c9b$var$rotate64(b, 37).mul(mul).add(a);
        const d = $27fd8d0c8b9b1c9b$var$rotate64(a, 25).add(b).mul(mul);
        return $27fd8d0c8b9b1c9b$var$hashLen16(c, d, mul);
    }
    if (len >= 4) {
        const mul = $27fd8d0c8b9b1c9b$var$k2.add(len * 2);
        const a = $27fd8d0c8b9b1c9b$var$fetch32(s, 0);
        return $27fd8d0c8b9b1c9b$var$hashLen16(a.shl(3).add(len), $27fd8d0c8b9b1c9b$var$fetch32(s, len - 4), mul);
    }
    if (len > 0) {
        const a = s[0];
        const b = s[len >> 1];
        const c = s[len - 1];
        const y = a + (b << 8);
        const z = len + (c << 2);
        return $27fd8d0c8b9b1c9b$var$shiftMix($27fd8d0c8b9b1c9b$var$k2.mul(y).xor($27fd8d0c8b9b1c9b$var$k0.mul(z))).mul($27fd8d0c8b9b1c9b$var$k2);
    }
    return $27fd8d0c8b9b1c9b$var$k2;
}
function $27fd8d0c8b9b1c9b$var$hashLen17to32(s, len = s.length) {
    const mul = $27fd8d0c8b9b1c9b$var$k2.add(len * 2);
    const a = $27fd8d0c8b9b1c9b$var$fetch64(s, 0).mul($27fd8d0c8b9b1c9b$var$k1);
    const b = $27fd8d0c8b9b1c9b$var$fetch64(s, 8);
    const c = $27fd8d0c8b9b1c9b$var$fetch64(s, len - 8).mul(mul);
    const d = $27fd8d0c8b9b1c9b$var$fetch64(s, len - 16).mul($27fd8d0c8b9b1c9b$var$k2);
    return $27fd8d0c8b9b1c9b$var$hashLen16($27fd8d0c8b9b1c9b$var$rotate64(a.add(b), 43).add($27fd8d0c8b9b1c9b$var$rotate64(c, 30)).add(d), a.add($27fd8d0c8b9b1c9b$var$rotate64(b.add($27fd8d0c8b9b1c9b$var$k2), 18)).add(c), mul);
}
function $27fd8d0c8b9b1c9b$var$hashLen33to64(s, len = s.length) {
    const mul = $27fd8d0c8b9b1c9b$var$k2.add(len * 2);
    const a = $27fd8d0c8b9b1c9b$var$fetch64(s, 0).mul($27fd8d0c8b9b1c9b$var$k2);
    const b = $27fd8d0c8b9b1c9b$var$fetch64(s, 8);
    const c = $27fd8d0c8b9b1c9b$var$fetch64(s, len - 8).mul(mul);
    const d = $27fd8d0c8b9b1c9b$var$fetch64(s, len - 16).mul($27fd8d0c8b9b1c9b$var$k2);
    const y = $27fd8d0c8b9b1c9b$var$rotate64(a.add(b), 43).add($27fd8d0c8b9b1c9b$var$rotate64(c, 30)).add(d);
    const z = $27fd8d0c8b9b1c9b$var$hashLen16(y, a.add($27fd8d0c8b9b1c9b$var$rotate64(b.add($27fd8d0c8b9b1c9b$var$k2), 18)).add(c), mul);
    const e = $27fd8d0c8b9b1c9b$var$fetch64(s, 16).mul(mul);
    const f = $27fd8d0c8b9b1c9b$var$fetch64(s, 24);
    const g = y.add($27fd8d0c8b9b1c9b$var$fetch64(s, len - 32)).mul(mul);
    const h = z.add($27fd8d0c8b9b1c9b$var$fetch64(s, len - 24)).mul(mul);
    return $27fd8d0c8b9b1c9b$var$hashLen16($27fd8d0c8b9b1c9b$var$rotate64(e.add(f), 43).add($27fd8d0c8b9b1c9b$var$rotate64(g, 30)).add(h), e.add($27fd8d0c8b9b1c9b$var$rotate64(f.add(a), 18)).add(g), mul);
}
function $27fd8d0c8b9b1c9b$export$919ee948dc019032(s, len = s.length) {
    const seed = $27fd8d0c8b9b1c9b$var$Long.fromNumber(81, true);
    if (len <= 32) {
        if (len <= 16) return $27fd8d0c8b9b1c9b$var$hashLen0to16(s, len);
        else return $27fd8d0c8b9b1c9b$var$hashLen17to32(s, len);
    } else if (len <= 64) return $27fd8d0c8b9b1c9b$var$hashLen33to64(s, len);
    // For strings over 64 bytes we loop.  Internal state consists of
    // 56 bytes: v, w, x, y, and z.
    let x = seed;
    let y = seed.mul($27fd8d0c8b9b1c9b$var$k1).add(113);
    let z = $27fd8d0c8b9b1c9b$var$shiftMix(y.mul($27fd8d0c8b9b1c9b$var$k2).add(113)).mul($27fd8d0c8b9b1c9b$var$k2);
    let v = [
        $27fd8d0c8b9b1c9b$var$Long.UZERO,
        $27fd8d0c8b9b1c9b$var$Long.UZERO
    ];
    let w = [
        $27fd8d0c8b9b1c9b$var$Long.UZERO,
        $27fd8d0c8b9b1c9b$var$Long.UZERO
    ];
    x = x.mul($27fd8d0c8b9b1c9b$var$k2).add($27fd8d0c8b9b1c9b$var$fetch64(s, 0));
    let offset = 0;
    // Set end so that after the loop we have 1 to 64 bytes left to process.
    const end = (len - 1 >> 6) * 64;
    const last64 = end + (len - 1 & 63) - 63;
    do {
        x = $27fd8d0c8b9b1c9b$var$rotate64(x.add(y).add(v[0]).add($27fd8d0c8b9b1c9b$var$fetch64(s, offset + 8)), 37).mul($27fd8d0c8b9b1c9b$var$k1);
        y = $27fd8d0c8b9b1c9b$var$rotate64(y.add(v[1]).add($27fd8d0c8b9b1c9b$var$fetch64(s, offset + 48)), 42).mul($27fd8d0c8b9b1c9b$var$k1);
        x = x.xor(w[1]);
        y = y.add(v[0]).add($27fd8d0c8b9b1c9b$var$fetch64(s, offset + 40));
        z = $27fd8d0c8b9b1c9b$var$rotate64(z.add(w[0]), 33).mul($27fd8d0c8b9b1c9b$var$k1);
        v = $27fd8d0c8b9b1c9b$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul($27fd8d0c8b9b1c9b$var$k1), x.add(w[0]));
        w = $27fd8d0c8b9b1c9b$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($27fd8d0c8b9b1c9b$var$fetch64(s, offset + 16)));
        [z, x] = [
            x,
            z
        ];
        offset += 64;
    }while (offset !== end);
    const mul = $27fd8d0c8b9b1c9b$var$k1.add(z.and(0xff).shl(1));
    // Point to the last 64 bytes of input.
    offset = last64;
    w[0] = w[0].add(len - 1 & 63);
    v[0] = v[0].add(w[0]);
    w[0] = w[0].add(v[0]);
    x = $27fd8d0c8b9b1c9b$var$rotate64(x.add(y).add(v[0]).add($27fd8d0c8b9b1c9b$var$fetch64(s, offset + 8)), 37).mul(mul);
    y = $27fd8d0c8b9b1c9b$var$rotate64(y.add(v[1]).add($27fd8d0c8b9b1c9b$var$fetch64(s, offset + 48)), 42).mul(mul);
    x = x.xor(w[1].mul(9));
    y = y.add(v[0].mul(9).add($27fd8d0c8b9b1c9b$var$fetch64(s, offset + 40)));
    z = $27fd8d0c8b9b1c9b$var$rotate64(z.add(w[0]), 33).mul(mul);
    v = $27fd8d0c8b9b1c9b$var$weakHashLen32WithSeedsStr(s, offset, v[1].mul(mul), x.add(w[0]));
    w = $27fd8d0c8b9b1c9b$var$weakHashLen32WithSeedsStr(s, offset + 32, z.add(w[1]), y.add($27fd8d0c8b9b1c9b$var$fetch64(s, offset + 16)));
    [z, x] = [
        x,
        z
    ];
    return $27fd8d0c8b9b1c9b$var$hashLen16($27fd8d0c8b9b1c9b$var$hashLen16(v[0], w[0], mul).add($27fd8d0c8b9b1c9b$var$shiftMix(y).mul($27fd8d0c8b9b1c9b$var$k0)).add(z), $27fd8d0c8b9b1c9b$var$hashLen16(v[1], w[1], mul).add(x), mul);
}

});
parcelRegister("gPSCs", function(module, exports) {
module.exports = $c41bc7064da96f44$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $c41bc7064da96f44$var$wasm = null;
try {
    $c41bc7064da96f44$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $c41bc7064da96f44$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $c41bc7064da96f44$var$Long.prototype.__isLong__;
Object.defineProperty($c41bc7064da96f44$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $c41bc7064da96f44$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $c41bc7064da96f44$var$Long.isLong = $c41bc7064da96f44$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $c41bc7064da96f44$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $c41bc7064da96f44$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $c41bc7064da96f44$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $c41bc7064da96f44$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $c41bc7064da96f44$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $c41bc7064da96f44$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $c41bc7064da96f44$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $c41bc7064da96f44$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $c41bc7064da96f44$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $c41bc7064da96f44$var$Long.fromInt = $c41bc7064da96f44$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $c41bc7064da96f44$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $c41bc7064da96f44$var$UZERO : $c41bc7064da96f44$var$ZERO;
    if (unsigned) {
        if (value < 0) return $c41bc7064da96f44$var$UZERO;
        if (value >= $c41bc7064da96f44$var$TWO_PWR_64_DBL) return $c41bc7064da96f44$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$c41bc7064da96f44$var$TWO_PWR_63_DBL) return $c41bc7064da96f44$var$MIN_VALUE;
        if (value + 1 >= $c41bc7064da96f44$var$TWO_PWR_63_DBL) return $c41bc7064da96f44$var$MAX_VALUE;
    }
    if (value < 0) return $c41bc7064da96f44$var$fromNumber(-value, unsigned).neg();
    return $c41bc7064da96f44$var$fromBits(value % $c41bc7064da96f44$var$TWO_PWR_32_DBL | 0, value / $c41bc7064da96f44$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $c41bc7064da96f44$var$Long.fromNumber = $c41bc7064da96f44$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $c41bc7064da96f44$var$fromBits(lowBits, highBits, unsigned) {
    return new $c41bc7064da96f44$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $c41bc7064da96f44$var$Long.fromBits = $c41bc7064da96f44$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $c41bc7064da96f44$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $c41bc7064da96f44$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error('empty string');
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $c41bc7064da96f44$var$ZERO;
    if (typeof unsigned === 'number') // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    var p;
    if ((p = str.indexOf('-')) > 0) throw Error('interior hyphen');
    else if (p === 0) return $c41bc7064da96f44$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $c41bc7064da96f44$var$fromNumber($c41bc7064da96f44$var$pow_dbl(radix, 8));
    var result = $c41bc7064da96f44$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $c41bc7064da96f44$var$fromNumber($c41bc7064da96f44$var$pow_dbl(radix, size));
            result = result.mul(power).add($c41bc7064da96f44$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($c41bc7064da96f44$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $c41bc7064da96f44$var$Long.fromString = $c41bc7064da96f44$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $c41bc7064da96f44$var$fromValue(val, unsigned) {
    if (typeof val === 'number') return $c41bc7064da96f44$var$fromNumber(val, unsigned);
    if (typeof val === 'string') return $c41bc7064da96f44$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $c41bc7064da96f44$var$fromBits(val.low, val.high, typeof unsigned === 'boolean' ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $c41bc7064da96f44$var$Long.fromValue = $c41bc7064da96f44$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $c41bc7064da96f44$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $c41bc7064da96f44$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $c41bc7064da96f44$var$TWO_PWR_32_DBL = $c41bc7064da96f44$var$TWO_PWR_16_DBL * $c41bc7064da96f44$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $c41bc7064da96f44$var$TWO_PWR_64_DBL = $c41bc7064da96f44$var$TWO_PWR_32_DBL * $c41bc7064da96f44$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $c41bc7064da96f44$var$TWO_PWR_63_DBL = $c41bc7064da96f44$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $c41bc7064da96f44$var$TWO_PWR_24 = $c41bc7064da96f44$var$fromInt($c41bc7064da96f44$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $c41bc7064da96f44$var$ZERO = $c41bc7064da96f44$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $c41bc7064da96f44$var$Long.ZERO = $c41bc7064da96f44$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $c41bc7064da96f44$var$UZERO = $c41bc7064da96f44$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $c41bc7064da96f44$var$Long.UZERO = $c41bc7064da96f44$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $c41bc7064da96f44$var$ONE = $c41bc7064da96f44$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $c41bc7064da96f44$var$Long.ONE = $c41bc7064da96f44$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $c41bc7064da96f44$var$UONE = $c41bc7064da96f44$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $c41bc7064da96f44$var$Long.UONE = $c41bc7064da96f44$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $c41bc7064da96f44$var$NEG_ONE = $c41bc7064da96f44$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $c41bc7064da96f44$var$Long.NEG_ONE = $c41bc7064da96f44$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $c41bc7064da96f44$var$MAX_VALUE = $c41bc7064da96f44$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $c41bc7064da96f44$var$Long.MAX_VALUE = $c41bc7064da96f44$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $c41bc7064da96f44$var$MAX_UNSIGNED_VALUE = $c41bc7064da96f44$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $c41bc7064da96f44$var$Long.MAX_UNSIGNED_VALUE = $c41bc7064da96f44$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $c41bc7064da96f44$var$MIN_VALUE = $c41bc7064da96f44$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $c41bc7064da96f44$var$Long.MIN_VALUE = $c41bc7064da96f44$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $c41bc7064da96f44$var$LongPrototype = $c41bc7064da96f44$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $c41bc7064da96f44$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $c41bc7064da96f44$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $c41bc7064da96f44$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $c41bc7064da96f44$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $c41bc7064da96f44$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError('radix');
    if (this.isZero()) return '0';
    if (this.isNegative()) {
        if (this.eq($c41bc7064da96f44$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $c41bc7064da96f44$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return '-' + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $c41bc7064da96f44$var$fromNumber($c41bc7064da96f44$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = '';
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = '0' + digits;
            result = '' + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $c41bc7064da96f44$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $c41bc7064da96f44$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $c41bc7064da96f44$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $c41bc7064da96f44$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $c41bc7064da96f44$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($c41bc7064da96f44$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.eqz = $c41bc7064da96f44$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.equals = function equals(other) {
    if (!$c41bc7064da96f44$var$isLong(other)) other = $c41bc7064da96f44$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.eq = $c41bc7064da96f44$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.neq = $c41bc7064da96f44$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.ne = $c41bc7064da96f44$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.lt = $c41bc7064da96f44$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.lte = $c41bc7064da96f44$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.le = $c41bc7064da96f44$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.gt = $c41bc7064da96f44$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.gte = $c41bc7064da96f44$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $c41bc7064da96f44$var$LongPrototype.ge = $c41bc7064da96f44$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $c41bc7064da96f44$var$LongPrototype.compare = function compare(other) {
    if (!$c41bc7064da96f44$var$isLong(other)) other = $c41bc7064da96f44$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $c41bc7064da96f44$var$LongPrototype.comp = $c41bc7064da96f44$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $c41bc7064da96f44$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($c41bc7064da96f44$var$MIN_VALUE)) return $c41bc7064da96f44$var$MIN_VALUE;
    return this.not().add($c41bc7064da96f44$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $c41bc7064da96f44$var$LongPrototype.neg = $c41bc7064da96f44$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $c41bc7064da96f44$var$LongPrototype.add = function add(addend) {
    if (!$c41bc7064da96f44$var$isLong(addend)) addend = $c41bc7064da96f44$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $c41bc7064da96f44$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $c41bc7064da96f44$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$c41bc7064da96f44$var$isLong(subtrahend)) subtrahend = $c41bc7064da96f44$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $c41bc7064da96f44$var$LongPrototype.sub = $c41bc7064da96f44$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $c41bc7064da96f44$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $c41bc7064da96f44$var$ZERO;
    if (!$c41bc7064da96f44$var$isLong(multiplier)) multiplier = $c41bc7064da96f44$var$fromValue(multiplier);
    // use wasm support if present
    if ($c41bc7064da96f44$var$wasm) {
        var low = $c41bc7064da96f44$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $c41bc7064da96f44$var$fromBits(low, $c41bc7064da96f44$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $c41bc7064da96f44$var$ZERO;
    if (this.eq($c41bc7064da96f44$var$MIN_VALUE)) return multiplier.isOdd() ? $c41bc7064da96f44$var$MIN_VALUE : $c41bc7064da96f44$var$ZERO;
    if (multiplier.eq($c41bc7064da96f44$var$MIN_VALUE)) return this.isOdd() ? $c41bc7064da96f44$var$MIN_VALUE : $c41bc7064da96f44$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($c41bc7064da96f44$var$TWO_PWR_24) && multiplier.lt($c41bc7064da96f44$var$TWO_PWR_24)) return $c41bc7064da96f44$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $c41bc7064da96f44$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $c41bc7064da96f44$var$LongPrototype.mul = $c41bc7064da96f44$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $c41bc7064da96f44$var$LongPrototype.divide = function divide(divisor) {
    if (!$c41bc7064da96f44$var$isLong(divisor)) divisor = $c41bc7064da96f44$var$fromValue(divisor);
    if (divisor.isZero()) throw Error('division by zero');
    // use wasm support if present
    if ($c41bc7064da96f44$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $c41bc7064da96f44$var$wasm.div_u : $c41bc7064da96f44$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $c41bc7064da96f44$var$fromBits(low, $c41bc7064da96f44$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $c41bc7064da96f44$var$UZERO : $c41bc7064da96f44$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($c41bc7064da96f44$var$MIN_VALUE)) {
            if (divisor.eq($c41bc7064da96f44$var$ONE) || divisor.eq($c41bc7064da96f44$var$NEG_ONE)) return $c41bc7064da96f44$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($c41bc7064da96f44$var$MIN_VALUE)) return $c41bc7064da96f44$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($c41bc7064da96f44$var$ZERO)) return divisor.isNegative() ? $c41bc7064da96f44$var$ONE : $c41bc7064da96f44$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($c41bc7064da96f44$var$MIN_VALUE)) return this.unsigned ? $c41bc7064da96f44$var$UZERO : $c41bc7064da96f44$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $c41bc7064da96f44$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $c41bc7064da96f44$var$UZERO;
        if (divisor.gt(this.shru(1))) return $c41bc7064da96f44$var$UONE;
        res = $c41bc7064da96f44$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $c41bc7064da96f44$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $c41bc7064da96f44$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $c41bc7064da96f44$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $c41bc7064da96f44$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $c41bc7064da96f44$var$LongPrototype.div = $c41bc7064da96f44$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $c41bc7064da96f44$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$c41bc7064da96f44$var$isLong(divisor)) divisor = $c41bc7064da96f44$var$fromValue(divisor);
    // use wasm support if present
    if ($c41bc7064da96f44$var$wasm) {
        var low = (this.unsigned ? $c41bc7064da96f44$var$wasm.rem_u : $c41bc7064da96f44$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $c41bc7064da96f44$var$fromBits(low, $c41bc7064da96f44$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $c41bc7064da96f44$var$LongPrototype.mod = $c41bc7064da96f44$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $c41bc7064da96f44$var$LongPrototype.rem = $c41bc7064da96f44$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $c41bc7064da96f44$var$LongPrototype.not = function not() {
    return $c41bc7064da96f44$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $c41bc7064da96f44$var$LongPrototype.and = function and(other) {
    if (!$c41bc7064da96f44$var$isLong(other)) other = $c41bc7064da96f44$var$fromValue(other);
    return $c41bc7064da96f44$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $c41bc7064da96f44$var$LongPrototype.or = function or(other) {
    if (!$c41bc7064da96f44$var$isLong(other)) other = $c41bc7064da96f44$var$fromValue(other);
    return $c41bc7064da96f44$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $c41bc7064da96f44$var$LongPrototype.xor = function xor(other) {
    if (!$c41bc7064da96f44$var$isLong(other)) other = $c41bc7064da96f44$var$fromValue(other);
    return $c41bc7064da96f44$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $c41bc7064da96f44$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($c41bc7064da96f44$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $c41bc7064da96f44$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $c41bc7064da96f44$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $c41bc7064da96f44$var$LongPrototype.shl = $c41bc7064da96f44$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $c41bc7064da96f44$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($c41bc7064da96f44$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $c41bc7064da96f44$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $c41bc7064da96f44$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $c41bc7064da96f44$var$LongPrototype.shr = $c41bc7064da96f44$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $c41bc7064da96f44$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($c41bc7064da96f44$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $c41bc7064da96f44$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $c41bc7064da96f44$var$fromBits(high, 0, this.unsigned);
        else return $c41bc7064da96f44$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $c41bc7064da96f44$var$LongPrototype.shru = $c41bc7064da96f44$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $c41bc7064da96f44$var$LongPrototype.shr_u = $c41bc7064da96f44$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $c41bc7064da96f44$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $c41bc7064da96f44$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $c41bc7064da96f44$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $c41bc7064da96f44$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $c41bc7064da96f44$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $c41bc7064da96f44$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $c41bc7064da96f44$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $c41bc7064da96f44$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $c41bc7064da96f44$var$Long.fromBytesLE(bytes, unsigned) : $c41bc7064da96f44$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $c41bc7064da96f44$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $c41bc7064da96f44$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $c41bc7064da96f44$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $c41bc7064da96f44$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});




parcelRegister("9jvFp", function(module, exports) {

$parcel$export(module.exports, "getFilteredNodesXToY", function () { return $6c7e73cfd4f3a13f$export$13eebbb952f0db02; });
$parcel$export(module.exports, "backpropagateGradients", function () { return $6c7e73cfd4f3a13f$export$2992958ba0a8790d; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
function $6c7e73cfd4f3a13f$export$13eebbb952f0db02(tape, xs, y) {
    // Forward pass to compute all the nodes and Tensors that are transitively a
    // function of x.
    const tensorsFromX = {};
    const nodesFromX = {};
    for(let i = 0; i < xs.length; i++)tensorsFromX[xs[i].id] = true;
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        const nodeInputs = node.inputs;
        for(const inputName in nodeInputs){
            const input = nodeInputs[inputName];
            let anyInputFromX = false;
            for(let j = 0; j < xs.length; j++)if (tensorsFromX[input.id]) {
                node.outputs.forEach((output)=>tensorsFromX[output.id] = true);
                anyInputFromX = true;
                nodesFromX[node.id] = true;
                break;
            }
            if (anyInputFromX) break;
        }
    }
    // Backward pass to find all of the nodes and Tensors that lead to y.
    const tensorsLeadToY = {};
    tensorsLeadToY[y.id] = true;
    const nodesToY = {};
    for(let i = tape.length - 1; i >= 0; i--){
        const node = tape[i];
        const nodeInputs = node.inputs;
        // If any of the outputs lead to y, mark all of the inputs as leading to y.
        for(let j = 0; j < node.outputs.length; j++)if (tensorsLeadToY[node.outputs[j].id]) {
            for(const inputName in nodeInputs){
                tensorsLeadToY[nodeInputs[inputName].id] = true;
                nodesToY[node.id] = true;
            }
            break;
        }
    }
    // Return the paths that come from x and lead to y.
    const filteredTape = [];
    for(let i = 0; i < tape.length; i++){
        const node = tape[i];
        if (nodesFromX[node.id] && nodesToY[node.id]) {
            // Prune the inputs from the node that aren't a function of x.
            const prunedInputs = {};
            for(const inputName in node.inputs){
                const nodeInput = node.inputs[inputName];
                if (tensorsFromX[nodeInput.id]) prunedInputs[inputName] = nodeInput;
            }
            // Copy the node and overwrite inputsAndArgs to the pruned version.
            const prunedNode = Object.assign({}, node);
            prunedNode.inputs = prunedInputs;
            prunedNode.outputs = node.outputs;
            filteredTape.push(prunedNode);
        }
    }
    return filteredTape;
}
function $6c7e73cfd4f3a13f$export$2992958ba0a8790d(tensorAccumulatedGradientMap, filteredTape, tidy, add) {
    // Walk the tape backward and keep a map of Tensor to its gradient.
    for(let i = filteredTape.length - 1; i >= 0; i--){
        const node = filteredTape[i];
        const dys = [];
        node.outputs.forEach((o)=>{
            const gradTensor = tensorAccumulatedGradientMap[o.id];
            if (gradTensor != null) dys.push(gradTensor);
            else // This particular output is not in the back-propagation subgraph, so it
            // does not affect the final output, thus we put null for its dy.
            dys.push(null);
        });
        if (node.gradient == null) throw new Error(`Cannot compute gradient: gradient function not found ` + `for ${node.kernelName}.`);
        // Backprop dy through this node and accumulate gradients over the inputs.
        const inputGradients = node.gradient(dys);
        for(const inputName in node.inputs){
            if (!(inputName in inputGradients)) throw new Error(`Cannot backprop through input ${inputName}. ` + `Available gradients found: ${Object.keys(inputGradients)}.`);
            // Call the gradient function.
            const dx = tidy(()=>inputGradients[inputName]());
            if (dx.dtype !== 'float32') throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `${inputName} must have 'float32' dtype, but has '${dx.dtype}'`);
            const x = node.inputs[inputName];
            if (!$eOiOM.arraysEqual(dx.shape, x.shape)) throw new Error(`Error in gradient for op ${node.kernelName}. The gradient of input ` + `'${inputName}' has shape '${dx.shape}', which does not match ` + `the shape of the input '${x.shape}'`);
            if (tensorAccumulatedGradientMap[x.id] == null) tensorAccumulatedGradientMap[x.id] = dx;
            else {
                const curGradient = tensorAccumulatedGradientMap[x.id];
                tensorAccumulatedGradientMap[x.id] = add(curGradient, dx);
                curGradient.dispose();
            }
        }
    }
}

});

parcelRegister("3pVUH", function(module, exports) {

$parcel$export(module.exports, "TensorBuffer", function () { return $27d0a156a77e5ce2$export$350df26cd52e08e1; });
$parcel$export(module.exports, "setTensorTracker", function () { return $27d0a156a77e5ce2$export$b1e34d2f0ffbbd85; });
$parcel$export(module.exports, "setOpHandler", function () { return $27d0a156a77e5ce2$export$1efe8d8b4884ad31; });
$parcel$export(module.exports, "setDeprecationWarningFn", function () { return $27d0a156a77e5ce2$export$ca605c1d8919649f; });
$parcel$export(module.exports, "Tensor", function () { return $27d0a156a77e5ce2$export$7b6b8d90402f8814; });
$parcel$export(module.exports, "getGlobalTensorClass", function () { return $27d0a156a77e5ce2$export$3cbd87e9d6a9b7ac; });
$parcel$export(module.exports, "Variable", function () { return $27d0a156a77e5ce2$export$c867a5c9595a1350; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Workaround for: https://github.com/bazelbuild/rules_nodejs/issues/1265
/// <reference types="@webgpu/types/dist" />

var $hri9Y = parcelRequire("hri9Y");

var $5MMao = parcelRequire("5MMao");

var $eOiOM = parcelRequire("eOiOM");
var $lBDHD = parcelRequire("lBDHD");
class $27d0a156a77e5ce2$export$350df26cd52e08e1 {
    constructor(shape, dtype, values){
        this.dtype = dtype;
        this.shape = shape.slice();
        this.size = $eOiOM.sizeFromShape(shape);
        if (values != null) {
            const n = values.length;
            $eOiOM.assert(n === this.size, ()=>`Length of values '${n}' does not match the size ` + `inferred by the shape '${this.size}'.`);
        }
        if (dtype === 'complex64') throw new Error(`complex64 dtype TensorBuffers are not supported. Please create ` + `a TensorBuffer for the real and imaginary parts separately and ` + `call tf.complex(real, imag).`);
        this.values = values || $eOiOM.getArrayFromDType(dtype, this.size);
        this.strides = (0, $eOiOM.computeStrides)(shape);
    }
    /**
     * Sets a value in the buffer at a given location.
     *
     * @param value The value to set.
     * @param locs  The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ set(value, ...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        $eOiOM.assert(locs.length === this.rank, ()=>`The number of provided coordinates (${locs.length}) must ` + `match the rank (${this.rank})`);
        const index = this.locToIndex(locs);
        this.values[index] = value;
    }
    /**
     * Returns the value in the buffer at the provided location.
     *
     * @param locs The location indices.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ get(...locs) {
        if (locs.length === 0) locs = [
            0
        ];
        let i = 0;
        for (const loc of locs){
            if (loc < 0 || loc >= this.shape[i]) {
                const msg = `Requested out of range element at ${locs}. ` + `  Buffer shape=${this.shape}`;
                throw new Error(msg);
            }
            i++;
        }
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return this.values[index];
    }
    locToIndex(locs) {
        if (this.rank === 0) return 0;
        else if (this.rank === 1) return locs[0];
        let index = locs[locs.length - 1];
        for(let i = 0; i < locs.length - 1; ++i)index += this.strides[i] * locs[i];
        return index;
    }
    indexToLoc(index) {
        if (this.rank === 0) return [];
        else if (this.rank === 1) return [
            index
        ];
        const locs = new Array(this.shape.length);
        for(let i = 0; i < locs.length - 1; ++i){
            locs[i] = Math.floor(index / this.strides[i]);
            index -= locs[i] * this.strides[i];
        }
        locs[locs.length - 1] = index;
        return locs;
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Creates an immutable `tf.Tensor` object from the buffer.
     *
     * @doc {heading: 'Tensors', subheading: 'Creation'}
     */ toTensor() {
        return $27d0a156a77e5ce2$var$trackerFn().makeTensor(this.values, this.shape, this.dtype);
    }
}
// For tracking tensor creation and disposal.
let $27d0a156a77e5ce2$var$trackerFn = null;
// Used by chaining methods to call into ops.
let $27d0a156a77e5ce2$var$opHandler = null;
// Used to warn about deprecated methods.
let $27d0a156a77e5ce2$var$deprecationWarningFn = null;
function $27d0a156a77e5ce2$export$b1e34d2f0ffbbd85(fn) {
    $27d0a156a77e5ce2$var$trackerFn = fn;
}
function $27d0a156a77e5ce2$export$1efe8d8b4884ad31(handler) {
    $27d0a156a77e5ce2$var$opHandler = handler;
}
function $27d0a156a77e5ce2$export$ca605c1d8919649f(fn) {
    $27d0a156a77e5ce2$var$deprecationWarningFn = fn;
}
class $27d0a156a77e5ce2$export$7b6b8d90402f8814 {
    constructor(shape, dtype, dataId, id){
        /** Whether this tensor has been globally kept. */ this.kept = false;
        this.isDisposedInternal = false;
        this.shape = shape.slice();
        this.dtype = dtype || 'float32';
        this.size = $eOiOM.sizeFromShape(shape);
        this.strides = (0, $eOiOM.computeStrides)(shape);
        this.dataId = dataId;
        this.id = id;
        this.rankType = this.rank < 5 ? this.rank.toString() : 'higher';
    }
    get rank() {
        return this.shape.length;
    }
    /**
     * Returns a promise of `tf.TensorBuffer` that holds the underlying data.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async buffer() {
        const vals = await this.data();
        return $27d0a156a77e5ce2$var$opHandler.buffer(this.shape, this.dtype, vals);
    }
    /**
     * Returns a `tf.TensorBuffer` that holds the underlying data.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ bufferSync() {
        return $27d0a156a77e5ce2$var$opHandler.buffer(this.shape, this.dtype, this.dataSync());
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * asynchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async array() {
        const vals = await this.data();
        return (0, $eOiOM.toNestedArray)(this.shape, vals, this.dtype === 'complex64');
    }
    /**
     * Returns the tensor data as a nested array. The transfer of data is done
     * synchronously.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ arraySync() {
        return (0, $eOiOM.toNestedArray)(this.shape, this.dataSync(), this.dtype === 'complex64');
    }
    /**
     * Asynchronously downloads the values from the `tf.Tensor`. Returns a
     * promise of `TypedArray` that resolves when the computation has finished.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ async data() {
        this.throwIfDisposed();
        const data = $27d0a156a77e5ce2$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') {
            const bytes = await data;
            try {
                return bytes.map((b)=>$lBDHD.decodeString(b));
            } catch (_a) {
                throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
            }
        }
        return data;
    }
    /**
     * Copy the tensor's data to a new GPU resource. Comparing to the `dataSync()`
     * and `data()`, this method prevents data from being downloaded to CPU.
     *
     * For WebGL backend, the data will be stored on a densely packed texture.
     * This means that the texture will use the RGBA channels to store value.
     *
     * For WebGPU backend, the data will be stored on a buffer. There is no
     * parameter, so can not use a user-defined size to create the buffer.
     *
     * @param options:
     *     For WebGL,
     *         - customTexShape: Optional. If set, will use the user defined
     *     texture shape to create the texture.
     *
     * @returns For WebGL backend, a GPUData contains the new texture and
     *     its information.
     *     {
     *        tensorRef: The tensor that is associated with this texture,
     *        texture: WebGLTexture,
     *        texShape: [number, number] // [height, width]
     *     }
     *
     *     For WebGPU backend, a GPUData contains the new buffer.
     *     {
     *        tensorRef: The tensor that is associated with this buffer,
     *        buffer: GPUBuffer,
     *     }
     *
     *     Remember to dispose the GPUData after it is used by
     *     `res.tensorRef.dispose()`.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataToGPU(options) {
        this.throwIfDisposed();
        return $27d0a156a77e5ce2$var$trackerFn().readToGPU(this.dataId, options);
    }
    /**
     * Synchronously downloads the values from the `tf.Tensor`. This blocks the
     * UI thread until the values are ready, which can cause performance issues.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dataSync() {
        this.throwIfDisposed();
        const data = $27d0a156a77e5ce2$var$trackerFn().readSync(this.dataId);
        if (this.dtype === 'string') try {
            return data.map((b)=>$lBDHD.decodeString(b));
        } catch (_a) {
            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().");
        }
        return data;
    }
    /** Returns the underlying bytes of the tensor's data. */ async bytes() {
        this.throwIfDisposed();
        const data = await $27d0a156a77e5ce2$var$trackerFn().read(this.dataId);
        if (this.dtype === 'string') return data;
        else return new Uint8Array(data.buffer);
    }
    /**
     * Disposes `tf.Tensor` from memory.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ dispose() {
        if (this.isDisposed) return;
        if (this.kerasMask) this.kerasMask.dispose();
        $27d0a156a77e5ce2$var$trackerFn().disposeTensor(this);
        this.isDisposedInternal = true;
    }
    get isDisposed() {
        return this.isDisposedInternal;
    }
    throwIfDisposed() {
        if (this.isDisposed) throw new Error(`Tensor is disposed.`);
    }
    /**
     * Prints the `tf.Tensor`. See `tf.print` for details.
     *
     * @param verbose Whether to print verbose information about the tensor,
     *    including dtype and size.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ print(verbose = false) {
        return $27d0a156a77e5ce2$var$opHandler.print(this, verbose);
    }
    /**
     * Returns a copy of the tensor. See `tf.clone` for details.
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ clone() {
        this.throwIfDisposed();
        return $27d0a156a77e5ce2$var$opHandler.clone(this);
    }
    /**
     * Returns a human-readable description of the tensor. Useful for logging.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ toString(verbose = false) {
        const vals = this.dataSync();
        return (0, $5MMao.tensorToString)(vals, this.shape, this.dtype, verbose);
    }
    cast(dtype) {
        this.throwIfDisposed();
        return $27d0a156a77e5ce2$var$opHandler.cast(this, dtype);
    }
    variable(trainable = true, name, dtype) {
        this.throwIfDisposed();
        return $27d0a156a77e5ce2$var$trackerFn().makeVariable(this, trainable, name, dtype);
    }
}
Object.defineProperty($27d0a156a77e5ce2$export$7b6b8d90402f8814, Symbol.hasInstance, {
    value: (instance)=>{
        // Implementation note: we should use properties of the object that will be
        // defined before the constructor body has finished executing (methods).
        // This is because when this code is transpiled by babel, babel will call
        // classCallCheck before the constructor body is run.
        // See https://github.com/tensorflow/tfjs/issues/3384 for backstory.
        return !!instance && instance.data != null && instance.dataSync != null && instance.throwIfDisposed != null;
    }
});
function $27d0a156a77e5ce2$export$3cbd87e9d6a9b7ac() {
    // Use getGlobal so that we can augment the Tensor class across package
    // boundaries because the node resolution alg may result in different modules
    // being returned for this file depending on the path they are loaded from.
    return (0, $hri9Y.getGlobal)('Tensor', ()=>{
        return $27d0a156a77e5ce2$export$7b6b8d90402f8814;
    });
}
// Global side effect. Cache global reference to Tensor class
$27d0a156a77e5ce2$export$3cbd87e9d6a9b7ac();
class $27d0a156a77e5ce2$export$c867a5c9595a1350 extends $27d0a156a77e5ce2$export$7b6b8d90402f8814 {
    constructor(initialValue, trainable, name, tensorId){
        super(initialValue.shape, initialValue.dtype, initialValue.dataId, tensorId);
        this.trainable = trainable;
        this.name = name;
    }
    /**
     * Assign a new `tf.Tensor` to this variable. The new `tf.Tensor` must have
     * the same shape and dtype as the old `tf.Tensor`.
     *
     * @param newValue New tensor to be assigned to this variable.
     *
     * @doc {heading: 'Tensors', subheading: 'Classes'}
     */ assign(newValue) {
        if (newValue.dtype !== this.dtype) throw new Error(`dtype of the new value (${newValue.dtype}) and ` + `previous value (${this.dtype}) must match`);
        if (!$eOiOM.arraysEqual(newValue.shape, this.shape)) throw new Error(`shape of the new value (${newValue.shape}) and ` + `previous value (${this.shape}) must match`);
        $27d0a156a77e5ce2$var$trackerFn().disposeTensor(this);
        this.dataId = newValue.dataId;
        $27d0a156a77e5ce2$var$trackerFn().incRef(this, null);
    }
    dispose() {
        $27d0a156a77e5ce2$var$trackerFn().disposeVariable(this);
        this.isDisposedInternal = true;
    }
}
Object.defineProperty($27d0a156a77e5ce2$export$c867a5c9595a1350, Symbol.hasInstance, {
    value: (instance)=>{
        return instance instanceof $27d0a156a77e5ce2$export$7b6b8d90402f8814 && instance.assign != null && instance.assign instanceof Function;
    }
});

});
parcelRegister("5MMao", function(module, exports) {

$parcel$export(module.exports, "tensorToString", function () { return $4366cc5748558cd0$export$7febe2c78b16daa7; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
// Maximum number of values before we decide to show ellipsis.
const $4366cc5748558cd0$var$FORMAT_LIMIT_NUM_VALS = 20;
// Number of first and last values to show when displaying a, b,...,y, z.
const $4366cc5748558cd0$var$FORMAT_NUM_FIRST_LAST_VALS = 3;
// Number of significant digits to show.
const $4366cc5748558cd0$var$FORMAT_NUM_SIG_DIGITS = 7;
function $4366cc5748558cd0$export$7febe2c78b16daa7(vals, shape, dtype, verbose) {
    const strides = (0, $eOiOM.computeStrides)(shape);
    const padPerCol = $4366cc5748558cd0$var$computeMaxSizePerColumn(vals, shape, dtype, strides);
    const rank = shape.length;
    const valsLines = $4366cc5748558cd0$var$subTensorToString(vals, shape, dtype, strides, padPerCol);
    const lines = [
        'Tensor'
    ];
    if (verbose) {
        lines.push(`  dtype: ${dtype}`);
        lines.push(`  rank: ${rank}`);
        lines.push(`  shape: [${shape}]`);
        lines.push(`  values:`);
    }
    lines.push(valsLines.map((l)=>'    ' + l).join('\n'));
    return lines.join('\n');
}
function $4366cc5748558cd0$var$computeMaxSizePerColumn(vals, shape, dtype, strides) {
    const n = (0, $eOiOM.sizeFromShape)(shape);
    const numCols = strides[strides.length - 1];
    const padPerCol = new Array(numCols).fill(0);
    const rank = shape.length;
    const valuesOrTuples = dtype === 'complex64' ? $4366cc5748558cd0$var$createComplexTuples(vals) : vals;
    if (rank > 1) for(let row = 0; row < n / numCols; row++){
        const offset = row * numCols;
        for(let j = 0; j < numCols; j++)padPerCol[j] = Math.max(padPerCol[j], $4366cc5748558cd0$var$valToString(valuesOrTuples[offset + j], 0, dtype).length);
    }
    return padPerCol;
}
function $4366cc5748558cd0$var$valToString(val, pad, dtype) {
    let valStr;
    if (Array.isArray(val)) valStr = `${parseFloat(val[0].toFixed($4366cc5748558cd0$var$FORMAT_NUM_SIG_DIGITS))} + ` + `${parseFloat(val[1].toFixed($4366cc5748558cd0$var$FORMAT_NUM_SIG_DIGITS))}j`;
    else if ((0, $eOiOM.isString)(val)) valStr = `'${val}'`;
    else if (dtype === 'bool') valStr = $4366cc5748558cd0$var$boolNumToString(val);
    else valStr = parseFloat(val.toFixed($4366cc5748558cd0$var$FORMAT_NUM_SIG_DIGITS)).toString();
    return (0, $eOiOM.rightPad)(valStr, pad);
}
function $4366cc5748558cd0$var$boolNumToString(v) {
    return v === 0 ? 'false' : 'true';
}
function $4366cc5748558cd0$var$subTensorToString(vals, shape, dtype, strides, padPerCol, isLast = true) {
    const storagePerElement = dtype === 'complex64' ? 2 : 1;
    const size = shape[0];
    const rank = shape.length;
    if (rank === 0) {
        if (dtype === 'complex64') {
            const complexTuple = $4366cc5748558cd0$var$createComplexTuples(vals);
            return [
                $4366cc5748558cd0$var$valToString(complexTuple[0], 0, dtype)
            ];
        }
        if (dtype === 'bool') return [
            $4366cc5748558cd0$var$boolNumToString(vals[0])
        ];
        return [
            vals[0].toString()
        ];
    }
    if (rank === 1) {
        if (size > $4366cc5748558cd0$var$FORMAT_LIMIT_NUM_VALS) {
            const firstValsSize = $4366cc5748558cd0$var$FORMAT_NUM_FIRST_LAST_VALS * storagePerElement;
            let firstVals = Array.from(vals.slice(0, firstValsSize));
            let lastVals = Array.from(vals.slice((size - $4366cc5748558cd0$var$FORMAT_NUM_FIRST_LAST_VALS) * storagePerElement, size * storagePerElement));
            if (dtype === 'complex64') {
                firstVals = $4366cc5748558cd0$var$createComplexTuples(firstVals);
                lastVals = $4366cc5748558cd0$var$createComplexTuples(lastVals);
            }
            return [
                '[' + firstVals.map((x, i)=>$4366cc5748558cd0$var$valToString(x, padPerCol[i], dtype)).join(', ') + ', ..., ' + lastVals.map((x, i)=>$4366cc5748558cd0$var$valToString(x, padPerCol[size - $4366cc5748558cd0$var$FORMAT_NUM_FIRST_LAST_VALS + i], dtype)).join(', ') + ']'
            ];
        }
        const displayVals = dtype === 'complex64' ? $4366cc5748558cd0$var$createComplexTuples(vals) : Array.from(vals);
        return [
            '[' + displayVals.map((x, i)=>$4366cc5748558cd0$var$valToString(x, padPerCol[i], dtype)).join(', ') + ']'
        ];
    }
    // The array is rank 2 or more.
    const subshape = shape.slice(1);
    const substrides = strides.slice(1);
    const stride = strides[0] * storagePerElement;
    const lines = [];
    if (size > $4366cc5748558cd0$var$FORMAT_LIMIT_NUM_VALS) {
        for(let i = 0; i < $4366cc5748558cd0$var$FORMAT_NUM_FIRST_LAST_VALS; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$4366cc5748558cd0$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, false));
        }
        lines.push('...');
        for(let i = size - $4366cc5748558cd0$var$FORMAT_NUM_FIRST_LAST_VALS; i < size; i++){
            const start = i * stride;
            const end = start + stride;
            lines.push(...$4366cc5748558cd0$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
        }
    } else for(let i = 0; i < size; i++){
        const start = i * stride;
        const end = start + stride;
        lines.push(...$4366cc5748558cd0$var$subTensorToString(vals.slice(start, end), subshape, dtype, substrides, padPerCol, i === size - 1 /* isLast */ ));
    }
    const sep = rank === 2 ? ',' : '';
    lines[0] = '[' + (size > 0 ? lines[0] + sep : '');
    for(let i = 1; i < lines.length - 1; i++)lines[i] = ' ' + lines[i] + sep;
    let newLineSep = ',\n';
    for(let i = 2; i < rank; i++)newLineSep += '\n';
    lines[lines.length - 1] = ' ' + lines[lines.length - 1] + ']' + (isLast ? '' : newLineSep);
    return lines;
}
function $4366cc5748558cd0$var$createComplexTuples(vals) {
    const complexTuples = [];
    for(let i = 0; i < vals.length; i += 2)complexTuples.push([
        vals[i],
        vals[i + 1]
    ]);
    return complexTuples;
}

});


parcelRegister("gpWQN", function(module, exports) {

$parcel$export(module.exports, "makeTypesMatch", function () { return $bf3ca19e53e39017$export$8b0e24c749a224d7; });
$parcel$export(module.exports, "assertTypesMatch", function () { return $bf3ca19e53e39017$export$8a66522456343d17; });
$parcel$export(module.exports, "isTensorInList", function () { return $bf3ca19e53e39017$export$537d2ee9de90a490; });
$parcel$export(module.exports, "getTensorsInContainer", function () { return $bf3ca19e53e39017$export$888c106d343989f5; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3pVUH = parcelRequire("3pVUH");

var $kKv2E = parcelRequire("kKv2E");

var $eOiOM = parcelRequire("eOiOM");
function $bf3ca19e53e39017$export$8b0e24c749a224d7(a, b) {
    if (a.dtype === b.dtype) return [
        a,
        b
    ];
    const dtype = (0, $kKv2E.upcastType)(a.dtype, b.dtype);
    return [
        a.cast(dtype),
        b.cast(dtype)
    ];
}
function $bf3ca19e53e39017$export$8a66522456343d17(a, b) {
    (0, $eOiOM.assert)(a.dtype === b.dtype, ()=>`The dtypes of the first(${a.dtype}) and` + ` second(${b.dtype}) input must match`);
}
function $bf3ca19e53e39017$export$537d2ee9de90a490(tensor, tensorList) {
    return tensorList.some((x)=>x.id === tensor.id);
}
function $bf3ca19e53e39017$export$888c106d343989f5(result) {
    const list = [];
    const seen = new Set();
    $bf3ca19e53e39017$var$walkTensorContainer(result, list, seen);
    return list;
}
function $bf3ca19e53e39017$var$walkTensorContainer(container, list, seen) {
    if (container == null) return;
    if (container instanceof (0, $3pVUH.Tensor)) {
        list.push(container);
        return;
    }
    if (!$bf3ca19e53e39017$var$isIterable(container)) return;
    // Iteration over keys works also for arrays.
    const iterable = container;
    for(const k in iterable){
        const val = iterable[k];
        if (!seen.has(val)) {
            seen.add(val);
            $bf3ca19e53e39017$var$walkTensorContainer(val, list, seen);
        }
    }
}
// tslint:disable-next-line:no-any
function $bf3ca19e53e39017$var$isIterable(obj) {
    return Array.isArray(obj) || typeof obj === 'object';
}

});
parcelRegister("kKv2E", function(module, exports) {

$parcel$export(module.exports, "upcastType", function () { return $f1b02ec1fb6c711b$export$7bcca02d1a156bdf; });
$parcel$export(module.exports, "sumOutType", function () { return $f1b02ec1fb6c711b$export$3479b4fbed3c0d8d; });
$parcel$export(module.exports, "isWebGLData", function () { return $f1b02ec1fb6c711b$export$12371c78da2a116a; });
$parcel$export(module.exports, "isWebGPUData", function () { return $f1b02ec1fb6c711b$export$db4071ca636ae03b; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $f1b02ec1fb6c711b$export$c36edca8f8f0427a;
(function(Rank) {
    Rank["R0"] = "R0";
    Rank["R1"] = "R1";
    Rank["R2"] = "R2";
    Rank["R3"] = "R3";
    Rank["R4"] = "R4";
    Rank["R5"] = "R5";
    Rank["R6"] = "R6";
})($f1b02ec1fb6c711b$export$c36edca8f8f0427a || ($f1b02ec1fb6c711b$export$c36edca8f8f0427a = {}));
// Looks for upcasting types. Used, for example, in operations with mixed dtype
// inputs.
var $f1b02ec1fb6c711b$var$UpcastInt32AndMap;
(function(UpcastInt32AndMap) {
    UpcastInt32AndMap["float32"] = "float32";
    UpcastInt32AndMap["int32"] = "int32";
    UpcastInt32AndMap["bool"] = "int32";
    UpcastInt32AndMap["complex64"] = "complex64";
})($f1b02ec1fb6c711b$var$UpcastInt32AndMap || ($f1b02ec1fb6c711b$var$UpcastInt32AndMap = {}));
var $f1b02ec1fb6c711b$var$UpcastBoolAndMap;
(function(UpcastBoolAndMap) {
    UpcastBoolAndMap["float32"] = "float32";
    UpcastBoolAndMap["int32"] = "int32";
    UpcastBoolAndMap["bool"] = "bool";
    UpcastBoolAndMap["complex64"] = "complex64";
})($f1b02ec1fb6c711b$var$UpcastBoolAndMap || ($f1b02ec1fb6c711b$var$UpcastBoolAndMap = {}));
var $f1b02ec1fb6c711b$var$UpcastFloat32AndMap;
(function(UpcastFloat32AndMap) {
    UpcastFloat32AndMap["float32"] = "float32";
    UpcastFloat32AndMap["int32"] = "float32";
    UpcastFloat32AndMap["bool"] = "float32";
    UpcastFloat32AndMap["complex64"] = "complex64";
})($f1b02ec1fb6c711b$var$UpcastFloat32AndMap || ($f1b02ec1fb6c711b$var$UpcastFloat32AndMap = {}));
var $f1b02ec1fb6c711b$var$UpcastComplex64AndMap;
(function(UpcastComplex64AndMap) {
    UpcastComplex64AndMap["float32"] = "complex64";
    UpcastComplex64AndMap["int32"] = "complex64";
    UpcastComplex64AndMap["bool"] = "complex64";
    UpcastComplex64AndMap["complex64"] = "complex64";
})($f1b02ec1fb6c711b$var$UpcastComplex64AndMap || ($f1b02ec1fb6c711b$var$UpcastComplex64AndMap = {}));
const $f1b02ec1fb6c711b$var$upcastTypeMap = {
    'float32': $f1b02ec1fb6c711b$var$UpcastFloat32AndMap,
    'int32': $f1b02ec1fb6c711b$var$UpcastInt32AndMap,
    'bool': $f1b02ec1fb6c711b$var$UpcastBoolAndMap,
    'complex64': $f1b02ec1fb6c711b$var$UpcastComplex64AndMap
};
function $f1b02ec1fb6c711b$export$7bcca02d1a156bdf(typeA, typeB) {
    if (typeA === 'string' || typeB === 'string') {
        if (typeA === 'string' && typeB === 'string') return 'string';
        throw new Error(`Can not upcast ${typeA} with ${typeB}`);
    }
    return $f1b02ec1fb6c711b$var$upcastTypeMap[typeA][typeB];
}
function $f1b02ec1fb6c711b$export$3479b4fbed3c0d8d(type) {
    return $f1b02ec1fb6c711b$export$7bcca02d1a156bdf(type, 'int32');
}
function $f1b02ec1fb6c711b$export$12371c78da2a116a(values) {
    return values != null && typeof values === 'object' && 'texture' in values && values.texture instanceof WebGLTexture;
}
function $f1b02ec1fb6c711b$export$db4071ca636ae03b(values) {
    return typeof GPUBuffer !== 'undefined' && values != null && typeof values === 'object' && 'buffer' in values && values.buffer instanceof GPUBuffer;
}

});



parcelRegister("fJy9j", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("e6Ey6");

var $egPzb = parcelRequire("egPzb");

var $tdutJ = parcelRequire("tdutJ");
const $b7458c52a95e24cd$var$ENV = (0, $tdutJ.env)();
/**
 * This file contains environment-related flag registrations.
 */ /** Whether to enable debug mode. */ $b7458c52a95e24cd$var$ENV.registerFlag('DEBUG', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.");
});
/** Whether we are in a browser (as versus, say, node.js) environment. */ $b7458c52a95e24cd$var$ENV.registerFlag('IS_BROWSER', ()=>$egPzb.isBrowser());
/** Whether we are in a browser (as versus, say, node.js) environment. */ $b7458c52a95e24cd$var$ENV.registerFlag('IS_NODE', ()=>false);
/** Whether this browser is Chrome. */ $b7458c52a95e24cd$var$ENV.registerFlag('IS_CHROME', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
/** Whether this browser is Safari. */ $b7458c52a95e24cd$var$ENV.registerFlag('IS_SAFARI', ()=>typeof navigator !== 'undefined' && navigator != null && navigator.userAgent != null && /Safari/.test(navigator.userAgent) && /Apple/.test(navigator.vendor));
/**
 * True when the environment is "production" where we disable safety checks
 * to gain performance.
 */ $b7458c52a95e24cd$var$ENV.registerFlag('PROD', ()=>false);
/**
 * Whether to do sanity checks when inferring a shape from user-provided
 * values, used when creating a new tensor.
 */ $b7458c52a95e24cd$var$ENV.registerFlag('TENSORLIKE_CHECK_SHAPE_CONSISTENCY', ()=>$b7458c52a95e24cd$var$ENV.getBool('DEBUG'));
/** Whether deprecation warnings are enabled. */ $b7458c52a95e24cd$var$ENV.registerFlag('DEPRECATION_WARNINGS_ENABLED', ()=>true);
/** True if running unit tests. */ $b7458c52a95e24cd$var$ENV.registerFlag('IS_TEST', ()=>false);
/** Whether to check computation result for errors. */ $b7458c52a95e24cd$var$ENV.registerFlag('CHECK_COMPUTATION_FOR_ERRORS', ()=>$b7458c52a95e24cd$var$ENV.getBool('DEBUG'));
/** Whether the backend needs to wrap input to imageBitmap. */ $b7458c52a95e24cd$var$ENV.registerFlag('WRAP_TO_IMAGEBITMAP', ()=>false);
/** Whether to enable canvas2d willReadFrequently for GPU backends */ $b7458c52a95e24cd$var$ENV.registerFlag('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU', ()=>false);
/** Whether to use setTimeoutCustom */ $b7458c52a95e24cd$var$ENV.registerFlag('USE_SETTIMEOUTCUSTOM', ()=>false);

});
parcelRegister("egPzb", function(module, exports) {

$parcel$export(module.exports, "mockIsMobile", function () { return $a63a8f55a7e531fd$export$f55f7bd5cb259cb2; });
$parcel$export(module.exports, "isMobile", function () { return $a63a8f55a7e531fd$export$d0a8044dce8ff2fc; });
$parcel$export(module.exports, "isBrowser", function () { return $a63a8f55a7e531fd$export$4e09c449d6c407f7; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line:no-any
function $a63a8f55a7e531fd$var$_isNavigatorDefined() {
    return typeof navigator !== 'undefined' && navigator != null;
}
let $a63a8f55a7e531fd$var$isMobileMockValue;
function $a63a8f55a7e531fd$export$f55f7bd5cb259cb2(value) {
    $a63a8f55a7e531fd$var$isMobileMockValue = value;
}
function $a63a8f55a7e531fd$export$d0a8044dce8ff2fc(nav) {
    if ($a63a8f55a7e531fd$var$isMobileMockValue !== undefined) return $a63a8f55a7e531fd$var$isMobileMockValue;
    if (nav || $a63a8f55a7e531fd$var$_isNavigatorDefined()) {
        if (!nav) nav = navigator;
        if (nav.product === 'ReactNative') return true;
        const a = nav.userAgent || nav.vendor || // tslint:disable-next-line:no-any
        (typeof window !== 'undefined' ? window.opera : '');
        // Use `navigator.userAgentData.mobile` as fallback.
        if (!a) {
            // tslint:disable-next-line:no-any
            const navAny = nav;
            return navAny.userAgentData && navAny.userAgentData.mobile;
        }
        // tslint:disable-next-line:max-line-length
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || // tslint:disable-next-line:max-line-length
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
    }
    return false;
}
function $a63a8f55a7e531fd$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' && window.document != null || //@ts-ignore
    typeof WorkerGlobalScope !== 'undefined';
}

});


parcelRegister("1T16V", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("fJy9j");

var $tdutJ = parcelRequire("tdutJ");

var $3Puei = parcelRequire("3Puei");

var $djQES = parcelRequire("djQES");

var $jp6Sy = parcelRequire("jp6Sy");

var $axMwq = parcelRequire("axMwq");
class $15fbca0f8175126b$export$c812b315576f1552 {
    constructor(){
        // For setTimeoutCustom
        this.messageName = 'setTimeoutCustom';
        this.functionRefs = [];
        this.handledMessageCount = 0;
        this.hasEventListener = false;
    }
    fetch(path, init) {
        return fetch(path, init);
    }
    now() {
        return performance.now();
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Browser's encoder only supports utf-8, but got ${encoding}`);
        if (this.textEncoder == null) this.textEncoder = new TextEncoder();
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        return new TextDecoder(encoding).decode(bytes);
    }
    // If the setTimeout nesting level is greater than 5 and timeout is less
    // than 4ms, timeout will be clamped to 4ms, which hurts the perf.
    // Interleaving window.postMessage and setTimeout will trick the browser and
    // avoid the clamp.
    setTimeoutCustom(functionRef, delay) {
        if (typeof window === 'undefined' || !(0, $tdutJ.env)().getBool('USE_SETTIMEOUTCUSTOM')) {
            setTimeout(functionRef, delay);
            return;
        }
        this.functionRefs.push(functionRef);
        setTimeout(()=>{
            window.postMessage({
                name: this.messageName,
                index: this.functionRefs.length - 1
            }, '*');
        }, delay);
        if (!this.hasEventListener) {
            this.hasEventListener = true;
            window.addEventListener('message', (event)=>{
                if (event.source === window && event.data.name === this.messageName) {
                    event.stopPropagation();
                    const functionRef = this.functionRefs[event.data.index];
                    functionRef();
                    this.handledMessageCount++;
                    if (this.handledMessageCount === this.functionRefs.length) {
                        this.functionRefs = [];
                        this.handledMessageCount = 0;
                    }
                }
            }, true);
        }
    }
    isTypedArray(a) {
        return (0, $axMwq.isTypedArrayBrowser)(a);
    }
}
if ((0, $tdutJ.env)().get('IS_BROWSER')) {
    (0, $tdutJ.env)().setPlatform('browser', new $15fbca0f8175126b$export$c812b315576f1552());
    // Register LocalStorage IOHandler
    try {
        (0, $jp6Sy.ModelStoreManagerRegistry).registerManager((0, $djQES.BrowserLocalStorage).URL_SCHEME, new (0, $djQES.BrowserLocalStorageManager)());
    } catch (err) {}
    // Register IndexedDB IOHandler
    try {
        (0, $jp6Sy.ModelStoreManagerRegistry).registerManager((0, $3Puei.BrowserIndexedDB).URL_SCHEME, new (0, $3Puei.BrowserIndexedDBManager)());
    } catch (err) {}
}

});
parcelRegister("3Puei", function(module, exports) {

$parcel$export(module.exports, "BrowserIndexedDB", function () { return $2c9d957616cbf1c3$export$2c670ce804876090; });
$parcel$export(module.exports, "BrowserIndexedDBManager", function () { return $2c9d957616cbf1c3$export$4b0775e2ff88802; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("fJy9j");

var $tdutJ = parcelRequire("tdutJ");

var $lxNMC = parcelRequire("lxNMC");

var $9NeiV = parcelRequire("9NeiV");

var $3CPgX = parcelRequire("3CPgX");
const $2c9d957616cbf1c3$var$DATABASE_NAME = 'tensorflowjs';
const $2c9d957616cbf1c3$var$DATABASE_VERSION = 1;
// Model data and ModelArtifactsInfo (metadata) are stored in two separate
// stores for efficient access of the list of stored models and their metadata.
// 1. The object store for model data: topology, weights and weight manifests.
const $2c9d957616cbf1c3$var$MODEL_STORE_NAME = 'models_store';
// 2. The object store for ModelArtifactsInfo, including meta-information such
//    as the type of topology (JSON vs binary), byte size of the topology, byte
//    size of the weights, etc.
const $2c9d957616cbf1c3$var$INFO_STORE_NAME = 'model_info_store';
async function $2c9d957616cbf1c3$export$24b6df48b2529372() {
    const idbFactory = $2c9d957616cbf1c3$var$getIndexedDBFactory();
    return new Promise((resolve, reject)=>{
        const deleteRequest = idbFactory.deleteDatabase($2c9d957616cbf1c3$var$DATABASE_NAME);
        deleteRequest.onsuccess = ()=>resolve();
        deleteRequest.onerror = (error)=>reject(error);
    });
}
function $2c9d957616cbf1c3$var$getIndexedDBFactory() {
    if (!(0, $tdutJ.env)().getBool('IS_BROWSER')) // TODO(cais): Add more info about what IOHandler subtypes are available.
    //   Maybe point to a doc page on the web and/or automatically determine
    //   the available IOHandlers and print them in the error message.
    throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
    // tslint:disable-next-line:no-any
    const theWindow = typeof window === 'undefined' ? self : window;
    const factory = theWindow.indexedDB || theWindow.mozIndexedDB || theWindow.webkitIndexedDB || theWindow.msIndexedDB || theWindow.shimIndexedDB;
    if (factory == null) throw new Error('The current browser does not appear to support IndexedDB.');
    return factory;
}
function $2c9d957616cbf1c3$var$setUpDatabase(openRequest) {
    const db = openRequest.result;
    db.createObjectStore($2c9d957616cbf1c3$var$MODEL_STORE_NAME, {
        keyPath: 'modelPath'
    });
    db.createObjectStore($2c9d957616cbf1c3$var$INFO_STORE_NAME, {
        keyPath: 'modelPath'
    });
}
/**
 * IOHandler subclass: Browser IndexedDB.
 *
 * See the doc string of `browserIndexedDB` for more details.
 */ class $2c9d957616cbf1c3$export$2c670ce804876090 {
    constructor(modelPath){
        this.indexedDB = $2c9d957616cbf1c3$var$getIndexedDBFactory();
        if (modelPath == null || !modelPath) throw new Error('For IndexedDB, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
    }
    async save(modelArtifacts) {
        // TODO(cais): Support saving GraphDef models.
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        return this.databaseAction(this.modelPath, modelArtifacts);
    }
    async load() {
        return this.databaseAction(this.modelPath);
    }
    /**
     * Perform database action to put model artifacts into or read model artifacts
     * from IndexedDB object store.
     *
     * Whether the action is put or get depends on whether `modelArtifacts` is
     * specified. If it is specified, the action will be put; otherwise the action
     * will be get.
     *
     * @param modelPath A unique string path for the model.
     * @param modelArtifacts If specified, it will be the model artifacts to be
     *   stored in IndexedDB.
     * @returns A `Promise` of `SaveResult`, if the action is put, or a `Promise`
     *   of `ModelArtifacts`, if the action is get.
     */ databaseAction(modelPath, modelArtifacts) {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($2c9d957616cbf1c3$var$DATABASE_NAME, $2c9d957616cbf1c3$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$2c9d957616cbf1c3$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                if (modelArtifacts == null) {
                    // Read model out from object store.
                    const modelTx = db.transaction($2c9d957616cbf1c3$var$MODEL_STORE_NAME, 'readonly');
                    const modelStore = modelTx.objectStore($2c9d957616cbf1c3$var$MODEL_STORE_NAME);
                    const getRequest = modelStore.get(this.modelPath);
                    getRequest.onsuccess = ()=>{
                        if (getRequest.result == null) {
                            db.close();
                            return reject(new Error(`Cannot find model with path '${this.modelPath}' ` + `in IndexedDB.`));
                        } else resolve(getRequest.result.modelArtifacts);
                    };
                    getRequest.onerror = (error)=>{
                        db.close();
                        return reject(getRequest.error);
                    };
                    modelTx.oncomplete = ()=>db.close();
                } else {
                    // Put model into object store.
                    // Concatenate all the model weights into a single ArrayBuffer. Large
                    // models (~1GB) have problems saving if they are not concatenated.
                    // TODO(mattSoulanille): Save large models to multiple indexeddb
                    // records.
                    modelArtifacts.weightData = (0, $3CPgX.CompositeArrayBuffer).join(modelArtifacts.weightData);
                    const modelArtifactsInfo = (0, $lxNMC.getModelArtifactsInfoForJSON)(modelArtifacts);
                    // First, put ModelArtifactsInfo into info store.
                    const infoTx = db.transaction($2c9d957616cbf1c3$var$INFO_STORE_NAME, 'readwrite');
                    let infoStore = infoTx.objectStore($2c9d957616cbf1c3$var$INFO_STORE_NAME);
                    let putInfoRequest;
                    try {
                        putInfoRequest = infoStore.put({
                            modelPath: this.modelPath,
                            modelArtifactsInfo: modelArtifactsInfo
                        });
                    } catch (error) {
                        return reject(error);
                    }
                    let modelTx;
                    putInfoRequest.onsuccess = ()=>{
                        // Second, put model data into model store.
                        modelTx = db.transaction($2c9d957616cbf1c3$var$MODEL_STORE_NAME, 'readwrite');
                        const modelStore = modelTx.objectStore($2c9d957616cbf1c3$var$MODEL_STORE_NAME);
                        let putModelRequest;
                        try {
                            putModelRequest = modelStore.put({
                                modelPath: this.modelPath,
                                modelArtifacts: modelArtifacts,
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        } catch (error) {
                            // Sometimes, the serialized value is too large to store.
                            return reject(error);
                        }
                        putModelRequest.onsuccess = ()=>resolve({
                                modelArtifactsInfo: modelArtifactsInfo
                            });
                        putModelRequest.onerror = (error)=>{
                            // If the put-model request fails, roll back the info entry as
                            // well.
                            infoStore = infoTx.objectStore($2c9d957616cbf1c3$var$INFO_STORE_NAME);
                            const deleteInfoRequest = infoStore.delete(this.modelPath);
                            deleteInfoRequest.onsuccess = ()=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                            deleteInfoRequest.onerror = (error)=>{
                                db.close();
                                return reject(putModelRequest.error);
                            };
                        };
                    };
                    putInfoRequest.onerror = (error)=>{
                        db.close();
                        return reject(putInfoRequest.error);
                    };
                    infoTx.oncomplete = ()=>{
                        if (modelTx == null) db.close();
                        else modelTx.oncomplete = ()=>db.close();
                    };
                }
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}
$2c9d957616cbf1c3$export$2c670ce804876090.URL_SCHEME = 'indexeddb://';
const $2c9d957616cbf1c3$export$7375c81acb8edf6e = (url)=>{
    if (!(0, $tdutJ.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($2c9d957616cbf1c3$export$2c670ce804876090.URL_SCHEME)) return $2c9d957616cbf1c3$export$a4d8901e5a950049(url.slice($2c9d957616cbf1c3$export$2c670ce804876090.URL_SCHEME.length));
        else return null;
    }
};
(0, $9NeiV.IORouterRegistry).registerSaveRouter($2c9d957616cbf1c3$export$7375c81acb8edf6e);
(0, $9NeiV.IORouterRegistry).registerLoadRouter($2c9d957616cbf1c3$export$7375c81acb8edf6e);
function $2c9d957616cbf1c3$export$a4d8901e5a950049(modelPath) {
    return new $2c9d957616cbf1c3$export$2c670ce804876090(modelPath);
}
function $2c9d957616cbf1c3$var$maybeStripScheme(key) {
    return key.startsWith($2c9d957616cbf1c3$export$2c670ce804876090.URL_SCHEME) ? key.slice($2c9d957616cbf1c3$export$2c670ce804876090.URL_SCHEME.length) : key;
}
class $2c9d957616cbf1c3$export$4b0775e2ff88802 {
    constructor(){
        this.indexedDB = $2c9d957616cbf1c3$var$getIndexedDBFactory();
    }
    async listModels() {
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($2c9d957616cbf1c3$var$DATABASE_NAME, $2c9d957616cbf1c3$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$2c9d957616cbf1c3$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const tx = db.transaction($2c9d957616cbf1c3$var$INFO_STORE_NAME, 'readonly');
                const store = tx.objectStore($2c9d957616cbf1c3$var$INFO_STORE_NAME);
                // tslint:disable:max-line-length
                // Need to cast `store` as `any` here because TypeScript's DOM
                // library does not have the `getAll()` method even though the
                // method is supported in the latest version of most mainstream
                // browsers:
                // https://developer.mozilla.org/en-US/docs/Web/API/IDBObjectStore/getAll
                // tslint:enable:max-line-length
                // tslint:disable-next-line:no-any
                const getAllInfoRequest = store.getAll();
                getAllInfoRequest.onsuccess = ()=>{
                    const out = {};
                    for (const item of getAllInfoRequest.result)out[item.modelPath] = item.modelArtifactsInfo;
                    resolve(out);
                };
                getAllInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getAllInfoRequest.error);
                };
                tx.oncomplete = ()=>db.close();
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
    async removeModel(path) {
        path = $2c9d957616cbf1c3$var$maybeStripScheme(path);
        return new Promise((resolve, reject)=>{
            const openRequest = this.indexedDB.open($2c9d957616cbf1c3$var$DATABASE_NAME, $2c9d957616cbf1c3$var$DATABASE_VERSION);
            openRequest.onupgradeneeded = ()=>$2c9d957616cbf1c3$var$setUpDatabase(openRequest);
            openRequest.onsuccess = ()=>{
                const db = openRequest.result;
                const infoTx = db.transaction($2c9d957616cbf1c3$var$INFO_STORE_NAME, 'readwrite');
                const infoStore = infoTx.objectStore($2c9d957616cbf1c3$var$INFO_STORE_NAME);
                const getInfoRequest = infoStore.get(path);
                let modelTx;
                getInfoRequest.onsuccess = ()=>{
                    if (getInfoRequest.result == null) {
                        db.close();
                        return reject(new Error(`Cannot find model with path '${path}' ` + `in IndexedDB.`));
                    } else {
                        // First, delete the entry in the info store.
                        const deleteInfoRequest = infoStore.delete(path);
                        const deleteModelData = ()=>{
                            // Second, delete the entry in the model store.
                            modelTx = db.transaction($2c9d957616cbf1c3$var$MODEL_STORE_NAME, 'readwrite');
                            const modelStore = modelTx.objectStore($2c9d957616cbf1c3$var$MODEL_STORE_NAME);
                            const deleteModelRequest = modelStore.delete(path);
                            deleteModelRequest.onsuccess = ()=>resolve(getInfoRequest.result.modelArtifactsInfo);
                            deleteModelRequest.onerror = (error)=>reject(getInfoRequest.error);
                        };
                        // Proceed with deleting model data regardless of whether deletion
                        // of info data succeeds or not.
                        deleteInfoRequest.onsuccess = deleteModelData;
                        deleteInfoRequest.onerror = (error)=>{
                            deleteModelData();
                            db.close();
                            return reject(getInfoRequest.error);
                        };
                    }
                };
                getInfoRequest.onerror = (error)=>{
                    db.close();
                    return reject(getInfoRequest.error);
                };
                infoTx.oncomplete = ()=>{
                    if (modelTx == null) db.close();
                    else modelTx.oncomplete = ()=>db.close();
                };
            };
            openRequest.onerror = (error)=>reject(openRequest.error);
        });
    }
}

});
parcelRegister("lxNMC", function(module, exports) {

$parcel$export(module.exports, "encodeWeights", function () { return $faf34bf0f42cdeca$export$6c50c12dbd6168b; });
$parcel$export(module.exports, "decodeWeights", function () { return $faf34bf0f42cdeca$export$7a14c2428d4f4a2e; });
$parcel$export(module.exports, "decodeWeightsStream", function () { return $faf34bf0f42cdeca$export$6c19531ae9ba1204; });
$parcel$export(module.exports, "arrayBufferToBase64String", function () { return $faf34bf0f42cdeca$export$28e753ea3e93cabf; });
$parcel$export(module.exports, "base64StringToArrayBuffer", function () { return $faf34bf0f42cdeca$export$aa941b9d243f1be4; });
$parcel$export(module.exports, "concatenateArrayBuffers", function () { return $faf34bf0f42cdeca$export$9a3e9c78eb778da8; });
$parcel$export(module.exports, "basename", function () { return $faf34bf0f42cdeca$export$9bf319d8f74f51d1; });
$parcel$export(module.exports, "getModelJSONForModelArtifacts", function () { return $faf34bf0f42cdeca$export$a725daa2cfaa7bd5; });
$parcel$export(module.exports, "getModelArtifactsForJSONSync", function () { return $faf34bf0f42cdeca$export$ebf48c0f134e5c8; });
$parcel$export(module.exports, "getModelArtifactsForJSON", function () { return $faf34bf0f42cdeca$export$b867c14eedd5b8a2; });
$parcel$export(module.exports, "getModelArtifactsInfoForJSON", function () { return $faf34bf0f42cdeca$export$ece8b449d7d29272; });
$parcel$export(module.exports, "getWeightSpecs", function () { return $faf34bf0f42cdeca$export$9f3fe06e8e8def44; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dyCpE = parcelRequire("dyCpE");

var $eZfvk = parcelRequire("eZfvk");

var $eOiOM = parcelRequire("eOiOM");

var $ijLlc = parcelRequire("ijLlc");

var $3CPgX = parcelRequire("3CPgX");

var $d7Nxs = parcelRequire("d7Nxs");

var $tdutJ = parcelRequire("tdutJ");

var $2bytI = parcelRequire("2bytI");
var $faf34bf0f42cdeca$require$Buffer = $2bytI.Buffer;
/** Number of bytes reserved for the length of the string. (32bit integer). */ const $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH = 4;
async function $faf34bf0f42cdeca$export$6c50c12dbd6168b(tensors, group) {
    // TODO(adarob, cais): Support quantization.
    const specs = [];
    const dataPromises = [];
    const names = Array.isArray(tensors) ? tensors.map((tensor)=>tensor.name) : Object.keys(tensors);
    for(let i = 0; i < names.length; ++i){
        const name = names[i];
        const t = Array.isArray(tensors) ? tensors[i].tensor : tensors[name];
        if (t.dtype !== 'float32' && t.dtype !== 'int32' && t.dtype !== 'bool' && t.dtype !== 'string' && t.dtype !== 'complex64') throw new Error(`Unsupported dtype in weight '${name}': ${t.dtype}`);
        const spec = {
            name: name,
            shape: t.shape,
            dtype: t.dtype
        };
        if (t.dtype === 'string') {
            const utf8bytes = new Promise(async (resolve)=>{
                const vals = await t.bytes();
                const totalNumBytes = vals.reduce((p, c)=>p + c.length, 0) + $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH * vals.length;
                const bytes = new Uint8Array(totalNumBytes);
                let offset = 0;
                for(let i = 0; i < vals.length; i++){
                    const val = vals[i];
                    const bytesOfLength = new Uint8Array(new Uint32Array([
                        val.length
                    ]).buffer);
                    bytes.set(bytesOfLength, offset);
                    offset += $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH;
                    bytes.set(val, offset);
                    offset += val.length;
                }
                resolve(bytes);
            });
            dataPromises.push(utf8bytes);
        } else dataPromises.push(t.data());
        if (group != null) spec.group = group;
        specs.push(spec);
    }
    const tensorValues = await Promise.all(dataPromises);
    return {
        data: $faf34bf0f42cdeca$export$b9f790e5e2031778(tensorValues),
        specs: specs
    };
}
function $faf34bf0f42cdeca$export$7a14c2428d4f4a2e(weightData, specs) {
    // TODO(adarob, cais): Support quantization.
    const compositeBuffer = new (0, $3CPgX.CompositeArrayBuffer)(weightData);
    const out = {};
    let offset = 0;
    for (const spec of specs){
        const byteLength = $faf34bf0f42cdeca$var$getWeightBytelength(spec, (start, end)=>{
            return compositeBuffer.slice(offset + start, offset + end);
        });
        out[spec.name] = $faf34bf0f42cdeca$var$decodeWeight(spec, compositeBuffer.slice(offset, offset + byteLength));
        offset += byteLength;
    }
    return out;
}
function $faf34bf0f42cdeca$var$getWeightBytelength(spec, slice) {
    const size = (0, $eOiOM.sizeFromShape)(spec.shape);
    let bytesPerValue;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        bytesPerValue = (0, $ijLlc.DTYPE_VALUE_SIZE_MAP)[quantization.dtype];
    } else if (spec.dtype === 'string') {
        // Can not statically determine string length.
        let byteLength = 0;
        for(let i = 0; i < size; i++)byteLength += $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH + new Uint32Array(slice(byteLength, byteLength + $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH))[0];
        return byteLength;
    } else bytesPerValue = (0, $ijLlc.DTYPE_VALUE_SIZE_MAP)[spec.dtype];
    return size * bytesPerValue;
}
async function $faf34bf0f42cdeca$var$getWeightBytelengthAsync(spec, slice) {
    const size = (0, $eOiOM.sizeFromShape)(spec.shape);
    let bytesPerValue;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        bytesPerValue = (0, $ijLlc.DTYPE_VALUE_SIZE_MAP)[quantization.dtype];
    } else if (spec.dtype === 'string') {
        // Can not statically determine string length.
        let byteLength = 0;
        for(let i = 0; i < size; i++)byteLength += $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH + new Uint32Array(await slice(byteLength, byteLength + $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH))[0];
        return byteLength;
    } else bytesPerValue = (0, $ijLlc.DTYPE_VALUE_SIZE_MAP)[spec.dtype];
    return size * bytesPerValue;
}
function $faf34bf0f42cdeca$var$decodeWeight(spec, byteBuffer) {
    const name = spec.name;
    const dtype = spec.dtype;
    const shape = spec.shape;
    const size = (0, $eOiOM.sizeFromShape)(shape);
    let values;
    let offset = 0;
    if ('quantization' in spec) {
        const quantization = spec.quantization;
        if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
            if (!('min' in quantization && 'scale' in quantization)) throw new Error(`Weight ${spec.name} with quantization ${quantization.dtype} ` + `doesn't have corresponding metadata min and scale.`);
        } else if (quantization.dtype === 'float16') {
            if (dtype !== 'float32') throw new Error(`Weight ${spec.name} is quantized with ${quantization.dtype} ` + `which only supports weights of type float32 not ${dtype}.`);
        } else throw new Error(`Weight ${spec.name} has unknown ` + `quantization dtype ${quantization.dtype}. ` + `Supported quantization dtypes are: ` + `'uint8', 'uint16', and 'float16'.`);
        const quantizationSizeFactor = (0, $ijLlc.DTYPE_VALUE_SIZE_MAP)[quantization.dtype];
        const quantizedArray = quantization.dtype === 'uint8' ? new Uint8Array(byteBuffer) : new Uint16Array(byteBuffer);
        if (dtype === 'float32') {
            if (quantization.dtype === 'uint8' || quantization.dtype === 'uint16') {
                values = new Float32Array(quantizedArray.length);
                for(let i = 0; i < quantizedArray.length; i++){
                    const v = quantizedArray[i];
                    values[i] = v * quantization.scale + quantization.min;
                }
            } else if (quantization.dtype === 'float16') {
                // TODO: This is inefficient. Make getFloat16Decoder efficient.
                const float16Decode = $faf34bf0f42cdeca$export$6f94974d2b5810f7();
                values = float16Decode(quantizedArray);
            } else throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type float32.`);
        } else if (dtype === 'int32') {
            if (quantization.dtype !== 'uint8' && quantization.dtype !== 'uint16') throw new Error(`Unsupported quantization type ${quantization.dtype} ` + `for weight type int32.`);
            values = new Int32Array(quantizedArray.length);
            for(let i = 0; i < quantizedArray.length; i++){
                const v = quantizedArray[i];
                values[i] = Math.round(v * quantization.scale + quantization.min);
            }
        } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
        offset += size * quantizationSizeFactor;
    } else if (dtype === 'string') {
        const size = (0, $eOiOM.sizeFromShape)(spec.shape);
        values = [];
        for(let i = 0; i < size; i++){
            const byteLength = new Uint32Array(byteBuffer.slice(offset, offset + $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH))[0];
            offset += $faf34bf0f42cdeca$var$NUM_BYTES_STRING_LENGTH;
            const bytes = new Uint8Array(byteBuffer.slice(offset, offset + byteLength));
            values.push(bytes);
            offset += byteLength;
        }
    } else {
        const dtypeFactor = (0, $ijLlc.DTYPE_VALUE_SIZE_MAP)[dtype];
        if (dtype === 'float32') values = new Float32Array(byteBuffer);
        else if (dtype === 'int32') values = new Int32Array(byteBuffer);
        else if (dtype === 'bool') values = new Uint8Array(byteBuffer);
        else if (dtype === 'complex64') {
            values = new Float32Array(byteBuffer);
            const real = new Float32Array(values.length / 2);
            const image = new Float32Array(values.length / 2);
            for(let i = 0; i < real.length; i++){
                real[i] = values[i * 2];
                image[i] = values[i * 2 + 1];
            }
            const realTensor = (0, $eZfvk.tensor)(real, shape, 'float32');
            const imageTensor = (0, $eZfvk.tensor)(image, shape, 'float32');
            const complexTensor = (0, $dyCpE.complex)(realTensor, imageTensor);
            realTensor.dispose();
            imageTensor.dispose();
            return complexTensor;
        } else throw new Error(`Unsupported dtype in weight '${name}': ${dtype}`);
        offset += size * dtypeFactor;
    }
    return (0, $eZfvk.tensor)(values, shape, dtype);
}
async function $faf34bf0f42cdeca$var$readToLength(reader, initialData, length) {
    let data = new Uint8Array(initialData);
    while(data.byteLength < length){
        const { done: done, value: value } = await reader.read();
        if (done && value == null) {
            const missing = length - data.byteLength;
            throw new Error(`Reader is done but ${missing} bytes are still expected`);
        }
        // TODO: Don't create a new array every loop.
        const newData = new Uint8Array(data.length + value.byteLength);
        newData.set(data, 0);
        newData.set(new Uint8Array(value), data.length);
        data = newData;
    }
    return data.buffer;
}
async function $faf34bf0f42cdeca$export$6c19531ae9ba1204(weightStream, specs) {
    const tensors = {};
    const reader = weightStream.getReader();
    let data = new ArrayBuffer(0);
    for (const spec of specs){
        const byteLength = await $faf34bf0f42cdeca$var$getWeightBytelengthAsync(spec, async (start, end)=>{
            data = await $faf34bf0f42cdeca$var$readToLength(reader, data, end);
            return data.slice(start, end);
        });
        data = await $faf34bf0f42cdeca$var$readToLength(reader, data, byteLength);
        // Slice the tensor out
        const tensorData = data.slice(0, byteLength);
        data = data.slice(byteLength);
        const weightTensor = $faf34bf0f42cdeca$var$decodeWeight(spec, tensorData);
        tensors[spec.name] = weightTensor;
        // TODO(mattsoulanille): Better way to call uploadToGPU.
        // TODO(mattsoulanille): Make this work for webgl too.
        if ((0, $d7Nxs.getBackend)() === 'webgpu') {
            const b = (0, $d7Nxs.backend)();
            if ('uploadToGPU' in b && (0, $eOiOM.sizeFromShape)(weightTensor.shape) >= (0, $tdutJ.env)().get('WEBGPU_CPU_HANDOFF_SIZE_THRESHOLD')) b.uploadToGPU(weightTensor.dataId);
        }
    }
    return tensors;
}
function $faf34bf0f42cdeca$export$b9f790e5e2031778(xs) {
    // TODO(adarob, cais): Support quantization.
    if (xs === null) throw new Error(`Invalid input value: ${JSON.stringify(xs)}`);
    let totalByteLength = 0;
    // `normalizedXs` is here for this reason: a `TypedArray`'s `buffer'
    // can have a different byte length from that of the `TypedArray` itself,
    // for example, when the `TypedArray` is created from an offset in an
    // `ArrayBuffer`. `normliazedXs` holds `TypedArray`s whose `buffer`s match
    // the `TypedArray` in byte length. If an element of `xs` does not show
    // this property, a new `TypedArray` that satisfy this property will be
    // constructed and pushed into `normalizedXs`.
    const normalizedXs = [];
    xs.forEach((x)=>{
        totalByteLength += x.byteLength;
        // tslint:disable:no-any
        normalizedXs.push(x.byteLength === x.buffer.byteLength ? x : new x.constructor(x));
        if (!(x instanceof Float32Array || x instanceof Int32Array || x instanceof Uint8Array)) throw new Error(`Unsupported TypedArray subtype: ${x.constructor.name}`);
    // tslint:enable:no-any
    });
    const y = new Uint8Array(totalByteLength);
    let offset = 0;
    normalizedXs.forEach((x)=>{
        y.set(new Uint8Array(x.buffer), offset);
        offset += x.byteLength;
    });
    return y.buffer;
}
// Use Buffer on Node.js instead of Blob/atob/btoa
const $faf34bf0f42cdeca$var$useNodeBuffer = typeof $faf34bf0f42cdeca$require$Buffer !== 'undefined' && (typeof Blob === 'undefined' || typeof atob === 'undefined' || typeof btoa === 'undefined');
function $faf34bf0f42cdeca$export$42600be9c932993b(str) {
    if ($faf34bf0f42cdeca$var$useNodeBuffer) return $faf34bf0f42cdeca$require$Buffer.byteLength(str, 'utf8');
    return new Blob([
        str
    ]).size;
}
function $faf34bf0f42cdeca$export$28e753ea3e93cabf(buffer) {
    if ($faf34bf0f42cdeca$var$useNodeBuffer) return $faf34bf0f42cdeca$require$Buffer.from(buffer).toString('base64');
    const buf = new Uint8Array(buffer);
    let s = '';
    for(let i = 0, l = buf.length; i < l; i++)s += String.fromCharCode(buf[i]);
    return btoa(s);
}
function $faf34bf0f42cdeca$export$aa941b9d243f1be4(str) {
    if ($faf34bf0f42cdeca$var$useNodeBuffer) {
        const buf = $faf34bf0f42cdeca$require$Buffer.from(str, 'base64');
        return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength);
    }
    const s = atob(str);
    const buffer = new Uint8Array(s.length);
    for(let i = 0; i < s.length; ++i)buffer.set([
        s.charCodeAt(i)
    ], i);
    return buffer.buffer;
}
function $faf34bf0f42cdeca$export$9a3e9c78eb778da8(buffers) {
    return (0, $3CPgX.CompositeArrayBuffer).join(buffers);
}
function $faf34bf0f42cdeca$export$9bf319d8f74f51d1(path) {
    const SEPARATOR = '/';
    path = path.trim();
    while(path.endsWith(SEPARATOR))path = path.slice(0, path.length - 1);
    const items = path.split(SEPARATOR);
    return items[items.length - 1];
}
function $faf34bf0f42cdeca$export$a725daa2cfaa7bd5(artifacts, manifest) {
    const result = {
        modelTopology: artifacts.modelTopology,
        format: artifacts.format,
        generatedBy: artifacts.generatedBy,
        convertedBy: artifacts.convertedBy,
        weightsManifest: manifest
    };
    if (artifacts.signature != null) result.signature = artifacts.signature;
    if (artifacts.userDefinedMetadata != null) result.userDefinedMetadata = artifacts.userDefinedMetadata;
    if (artifacts.modelInitializer != null) result.modelInitializer = artifacts.modelInitializer;
    if (artifacts.initializerSignature != null) result.initializerSignature = artifacts.initializerSignature;
    if (artifacts.trainingConfig != null) result.trainingConfig = artifacts.trainingConfig;
    return result;
}
function $faf34bf0f42cdeca$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData) {
    const modelArtifacts = {
        modelTopology: modelJSON.modelTopology,
        format: modelJSON.format,
        generatedBy: modelJSON.generatedBy,
        convertedBy: modelJSON.convertedBy
    };
    if (modelJSON.trainingConfig != null) modelArtifacts.trainingConfig = modelJSON.trainingConfig;
    if (modelJSON.weightsManifest != null) {
        if (!weightSpecs) throw new Error('modelJSON has weightsManifest but weightSpecs is null');
        if (!weightData) throw new Error('modelJSON has weightsManifest but weightData is null');
        modelArtifacts.weightSpecs = weightSpecs;
        modelArtifacts.weightData = weightData;
    }
    if (modelJSON.signature != null) modelArtifacts.signature = modelJSON.signature;
    if (modelJSON.userDefinedMetadata != null) modelArtifacts.userDefinedMetadata = modelJSON.userDefinedMetadata;
    if (modelJSON.modelInitializer != null) modelArtifacts.modelInitializer = modelJSON.modelInitializer;
    if (modelJSON.initializerSignature != null) modelArtifacts.initializerSignature = modelJSON.initializerSignature;
    return modelArtifacts;
}
async function $faf34bf0f42cdeca$export$b867c14eedd5b8a2(modelJSON, loadWeights) {
    let weightSpecs;
    let weightData;
    if (modelJSON.weightsManifest != null) [weightSpecs, weightData] = await loadWeights(modelJSON.weightsManifest);
    return $faf34bf0f42cdeca$export$ebf48c0f134e5c8(modelJSON, weightSpecs, weightData);
}
function $faf34bf0f42cdeca$export$ece8b449d7d29272(modelArtifacts) {
    if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error('Expected JSON model topology, received ArrayBuffer.');
    return {
        dateSaved: new Date(),
        modelTopologyType: 'JSON',
        modelTopologyBytes: modelArtifacts.modelTopology == null ? 0 : $faf34bf0f42cdeca$export$42600be9c932993b(JSON.stringify(modelArtifacts.modelTopology)),
        weightSpecsBytes: modelArtifacts.weightSpecs == null ? 0 : $faf34bf0f42cdeca$export$42600be9c932993b(JSON.stringify(modelArtifacts.weightSpecs)),
        weightDataBytes: modelArtifacts.weightData == null ? 0 : new (0, $3CPgX.CompositeArrayBuffer)(modelArtifacts.weightData).byteLength
    };
}
function $faf34bf0f42cdeca$export$9f3fe06e8e8def44(weightsManifest) {
    const weightSpecs = [];
    for (const entry of weightsManifest)weightSpecs.push(...entry.weights);
    return weightSpecs;
}
/**
 * Computes mantisa table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 2048 mantissa lookup values.
 */ function $faf34bf0f42cdeca$var$computeFloat16MantisaTable() {
    const convertMantissa = (i)=>{
        let m = i << 13;
        let e = 0;
        while((m & 0x00800000) === 0){
            e -= 0x00800000;
            m <<= 1;
        }
        m &= -8388609;
        e += 0x38800000;
        return m | e;
    };
    const mantisaTable = new Uint32Array(2048);
    mantisaTable[0] = 0;
    for(let i = 1; i < 1024; i++)mantisaTable[i] = convertMantissa(i);
    for(let i = 1024; i < 2048; i++)mantisaTable[i] = 0x38000000 + (i - 1024 << 13);
    return mantisaTable;
}
/**
 * Computes exponent table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 64 exponent lookup values.
 */ function $faf34bf0f42cdeca$var$computeFloat16ExponentTable() {
    const exponentTable = new Uint32Array(64);
    exponentTable[0] = 0;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 31; i++)exponentTable[i] = i << 23;
    for(let i = 33; i < 63; i++)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    return exponentTable;
}
/**
 * Computes offset table for casting Float16 to Float32
 * See http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
 *
 * @returns Uint32Array, 6d offset values.
 */ function $faf34bf0f42cdeca$var$computeFloat16OffsetTable() {
    const offsetTable = new Uint32Array(64);
    for(let i = 0; i < 64; i++)offsetTable[i] = 1024;
    offsetTable[0] = offsetTable[32] = 0;
    return offsetTable;
}
function $faf34bf0f42cdeca$export$6f94974d2b5810f7() {
    // Algorithm is based off of
    // http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
    // Cache lookup tables
    const mantisaTable = $faf34bf0f42cdeca$var$computeFloat16MantisaTable();
    const exponentTable = $faf34bf0f42cdeca$var$computeFloat16ExponentTable();
    const offsetTable = $faf34bf0f42cdeca$var$computeFloat16OffsetTable();
    return (quantizedArray)=>{
        const buffer = new ArrayBuffer(4 * quantizedArray.length);
        const bufferUint32View = new Uint32Array(buffer);
        for(let index = 0; index < quantizedArray.length; index++){
            const float16Bits = quantizedArray[index];
            const float32Bits = mantisaTable[offsetTable[float16Bits >> 10] + (float16Bits & 0x3ff)] + exponentTable[float16Bits >> 10];
            bufferUint32View[index] = float32Bits;
        }
        return new Float32Array(buffer);
    };
}

});
parcelRegister("dyCpE", function(module, exports) {

$parcel$export(module.exports, "complex", function () { return $9dec3f50340f6c1f$export$83a0e34f1302825b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Converts two real numbers to a complex number.
 *
 * Given a tensor `real` representing the real part of a complex number, and a
 * tensor `imag` representing the imaginary part of a complex number, this
 * operation returns complex numbers elementwise of the form [r0, i0, r1, i1],
 * where r represents the real part and i represents the imag part.
 *
 * The input tensors real and imag must have the same shape.
 *
 * ```js
 * const real = tf.tensor1d([2.25, 3.25]);
 * const imag = tf.tensor1d([4.75, 5.75]);
 * const complex = tf.complex(real, imag);
 *
 * complex.print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $9dec3f50340f6c1f$var$complex_(real, imag) {
    const $real = (0, $x4eLk.convertToTensor)(real, 'real', 'complex');
    const $imag = (0, $x4eLk.convertToTensor)(imag, 'imag', 'complex');
    $eOiOM.assertShapesMatch($real.shape, $imag.shape, `real and imag shapes, ${$real.shape} and ${$imag.shape}, ` + `must match in call to tf.complex().`);
    const inputs = {
        real: $real,
        imag: $imag
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Complex), inputs);
}
const $9dec3f50340f6c1f$export$83a0e34f1302825b = /* @__PURE__ */ (0, $6afhl.op)({
    complex_: $9dec3f50340f6c1f$var$complex_
});

});
parcelRegister("x4eLk", function(module, exports) {

$parcel$export(module.exports, "inferShape", function () { return $06365e952c0dab94$export$467a8ad638b9ad20; });
$parcel$export(module.exports, "convertToTensor", function () { return $06365e952c0dab94$export$ede379c4c939d71a; });
$parcel$export(module.exports, "convertToTensorArray", function () { return $06365e952c0dab94$export$758e66616b4d410b; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $tdutJ = parcelRequire("tdutJ");

var $3pVUH = parcelRequire("3pVUH");

var $kKv2E = parcelRequire("kKv2E");

var $eOiOM = parcelRequire("eOiOM");
var $lBDHD = parcelRequire("lBDHD");

var $eOiOM = parcelRequire("eOiOM");
function $06365e952c0dab94$export$467a8ad638b9ad20(val, dtype) {
    let firstElem = val;
    if ((0, $lBDHD.isTypedArray)(val)) return dtype === 'string' ? [] : [
        val.length
    ];
    if ((0, $kKv2E.isWebGLData)(val)) {
        const usedChannels = val.channels || 'RGBA';
        return [
            val.height,
            val.width * usedChannels.length
        ];
    } else if ((0, $kKv2E.isWebGPUData)(val)) return [
        val.buffer.size / (dtype == null ? 4 : (0, $eOiOM.bytesPerElement)(dtype))
    ];
    if (!Array.isArray(val)) return []; // Scalar.
    const shape = [];
    while(Array.isArray(firstElem) || (0, $lBDHD.isTypedArray)(firstElem) && dtype !== 'string'){
        shape.push(firstElem.length);
        firstElem = firstElem[0];
    }
    if (Array.isArray(val) && (0, $tdutJ.env)().getBool('TENSORLIKE_CHECK_SHAPE_CONSISTENCY')) $06365e952c0dab94$var$deepAssertShapeConsistency(val, shape, []);
    return shape;
}
function $06365e952c0dab94$var$deepAssertShapeConsistency(val, shape, indices) {
    indices = indices || [];
    if (!Array.isArray(val) && !(0, $lBDHD.isTypedArray)(val)) {
        (0, $eOiOM.assert)(shape.length === 0, ()=>`Element arr[${indices.join('][')}] is a primitive, ` + `but should be an array/TypedArray of ${shape[0]} elements`);
        return;
    }
    (0, $eOiOM.assert)(shape.length > 0, ()=>`Element arr[${indices.join('][')}] should be a primitive, ` + `but is an array of ${val.length} elements`);
    (0, $eOiOM.assert)(val.length === shape[0], ()=>`Element arr[${indices.join('][')}] should have ${shape[0]} ` + `elements, but has ${val.length} elements`);
    const subShape = shape.slice(1);
    for(let i = 0; i < val.length; ++i)$06365e952c0dab94$var$deepAssertShapeConsistency(val[i], subShape, indices.concat(i));
}
function $06365e952c0dab94$var$assertDtype(expectedDtype, actualDType, argName, functionName) {
    if (expectedDtype === 'string_or_numeric') return;
    if (expectedDtype == null) throw new Error(`Expected dtype cannot be null.`);
    if (expectedDtype !== 'numeric' && expectedDtype !== actualDType || expectedDtype === 'numeric' && actualDType === 'string') throw new Error(`Argument '${argName}' passed to '${functionName}' must ` + `be ${expectedDtype} tensor, but got ${actualDType} tensor`);
}
function $06365e952c0dab94$export$ede379c4c939d71a(x, argName, functionName, parseAsDtype = 'numeric') {
    if (x instanceof (0, $3pVUH.getGlobalTensorClass)()) {
        $06365e952c0dab94$var$assertDtype(parseAsDtype, x.dtype, argName, functionName);
        return x;
    }
    let inferredDtype = (0, $eOiOM.inferDtype)(x);
    // If the user expects a bool/int/float, use that info to update the
    // inferredDtype when it is not a string.
    if (inferredDtype !== 'string' && [
        'bool',
        'int32',
        'float32'
    ].indexOf(parseAsDtype) >= 0) inferredDtype = parseAsDtype;
    $06365e952c0dab94$var$assertDtype(parseAsDtype, inferredDtype, argName, functionName);
    if (x == null || !(0, $lBDHD.isTypedArray)(x) && !Array.isArray(x) && typeof x !== 'number' && typeof x !== 'boolean' && typeof x !== 'string') {
        const type = x == null ? 'null' : x.constructor.name;
        throw new Error(`Argument '${argName}' passed to '${functionName}' must be a ` + `Tensor or TensorLike, but got '${type}'`);
    }
    const inferredShape = $06365e952c0dab94$export$467a8ad638b9ad20(x, inferredDtype);
    if (!(0, $lBDHD.isTypedArray)(x) && !Array.isArray(x)) x = [
        x
    ];
    const skipTypedArray = true;
    const values = inferredDtype !== 'string' ? (0, $lBDHD.toTypedArray)(x, inferredDtype) : (0, $lBDHD.flatten)(x, [], skipTypedArray);
    return (0, $e6Ey6.ENGINE).makeTensor(values, inferredShape, inferredDtype);
}
function $06365e952c0dab94$export$758e66616b4d410b(arg, argName, functionName, parseAsDtype = 'numeric') {
    if (!Array.isArray(arg)) throw new Error(`Argument ${argName} passed to ${functionName} must be a ` + '`Tensor[]` or `TensorLike[]`');
    const tensors = arg;
    return tensors.map((t, i)=>$06365e952c0dab94$export$ede379c4c939d71a(t, `${argName}[${i}]`, functionName, parseAsDtype));
}

});

parcelRegister("6afhl", function(module, exports) {

$parcel$export(module.exports, "OP_SCOPE_SUFFIX", function () { return $47cf8749e3493438$export$93114f1494faf9bb; });
$parcel$export(module.exports, "op", function () { return $47cf8749e3493438$export$f59964a629598e2; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $eOiOM = parcelRequire("eOiOM");
const $47cf8749e3493438$export$93114f1494faf9bb = '__op';
function $47cf8749e3493438$export$f59964a629598e2(f) {
    const keys = Object.keys(f);
    if (keys.length !== 1) throw new Error(`Please provide an object with a single key ` + `(operation name) mapping to a function. Got an object with ` + `${keys.length} keys.`);
    let opName = keys[0];
    const fn = f[opName];
    // Strip the underscore from the end of the function name.
    if (opName.endsWith('_')) opName = opName.substring(0, opName.length - 1);
    // add an __op suffix to distinguish ops from kernels in tf.profile
    opName = opName + $47cf8749e3493438$export$93114f1494faf9bb;
    // tslint:disable-next-line:no-any
    const f2 = (...args)=>{
        (0, $e6Ey6.ENGINE).startScope(opName);
        try {
            const result = fn(...args);
            if ((0, $eOiOM.isPromise)(result)) console.error('Cannot return a Promise inside of tidy.');
            (0, $e6Ey6.ENGINE).endScope(result);
            return result;
        } catch (ex) {
            (0, $e6Ey6.ENGINE).endScope(null);
            throw ex;
        }
    };
    Object.defineProperty(f2, 'name', {
        value: opName,
        configurable: true
    });
    // tslint:disable-next-line:no-any
    return f2;
}

});


parcelRegister("eZfvk", function(module, exports) {

$parcel$export(module.exports, "tensor", function () { return $ae92ca0b08a83c14$export$65df3ad1ad888abb; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $cxc40 = parcelRequire("cxc40");
function $ae92ca0b08a83c14$export$65df3ad1ad888abb(values, shape, dtype) {
    const inferredShape = (0, $x4eLk.inferShape)(values, dtype);
    return (0, $cxc40.makeTensor)(values, shape, inferredShape, dtype);
}

});
parcelRegister("cxc40", function(module, exports) {

$parcel$export(module.exports, "makeTensor", function () { return $9201ecaac983f5c4$export$f41686c891d7ebce; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $kKv2E = parcelRequire("kKv2E");

var $eOiOM = parcelRequire("eOiOM");
var $lBDHD = parcelRequire("lBDHD");
function $9201ecaac983f5c4$export$f41686c891d7ebce(values, shape, inferredShape, dtype) {
    if (dtype == null) dtype = (0, $eOiOM.inferDtype)(values);
    else if (dtype === 'complex64') throw new Error(`Cannot construct a complex64 tensor directly. ` + `Please use tf.complex(real, imag).`);
    if ((0, $kKv2E.isWebGPUData)(values) || (0, $kKv2E.isWebGLData)(values)) {
        if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Creating tensor from GPU data only supports ` + `'float32'|'int32' dtype, while the dtype is ${dtype}.`);
        return (0, $e6Ey6.ENGINE).backend.createTensorFromGPUData(values, shape || inferredShape, dtype);
    }
    if (!(0, $lBDHD.isTypedArray)(values) && !Array.isArray(values) && typeof values !== 'number' && typeof values !== 'boolean' && typeof values !== 'string') throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
    // Verify that the shape matches the inferred shape.
    if (shape != null) {
        (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
        const providedSize = (0, $eOiOM.sizeFromShape)(shape);
        const inferredSize = (0, $eOiOM.sizeFromShape)(inferredShape);
        (0, $eOiOM.assert)(providedSize === inferredSize, ()=>`Based on the provided shape, [${shape}], the tensor should have ` + `${providedSize} values but has ${inferredSize}`);
        for(let i = 0; i < inferredShape.length; ++i){
            const inferred = inferredShape[i];
            const flatDimsDontMatch = i === inferredShape.length - 1 ? inferred !== (0, $eOiOM.sizeFromShape)(shape.slice(i)) : true;
            (0, $eOiOM.assert)(inferredShape[i] === shape[i] || !flatDimsDontMatch, ()=>`Error creating a new Tensor. Inferred shape ` + `(${inferredShape}) does not match the provided ` + `shape (${shape}). `);
        }
    }
    if (!(0, $lBDHD.isTypedArray)(values) && !Array.isArray(values)) values = [
        values
    ];
    shape = shape || inferredShape;
    values = dtype !== 'string' ? (0, $lBDHD.toTypedArray)(values, dtype) : (0, $lBDHD.flatten)(values, [], true);
    return (0, $e6Ey6.ENGINE).makeTensor(values, shape, dtype);
}

});


parcelRegister("ijLlc", function(module, exports) {

$parcel$export(module.exports, "DTYPE_VALUE_SIZE_MAP", function () { return $d55eb9491633b9b8$export$8103dee73e5eaa46; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /* Type definitions for exporting and importing of models. */ /**
 * A map from Tensor dtype to number of bytes per element of the Tensor.
 */ const $d55eb9491633b9b8$export$8103dee73e5eaa46 = {
    'float32': 4,
    'float16': 2,
    'int32': 4,
    'uint16': 2,
    'uint8': 1,
    'bool': 1,
    'complex64': 8
};

});

parcelRegister("3CPgX", function(module, exports) {

$parcel$export(module.exports, "CompositeArrayBuffer", function () { return $2a3cb15ddb58852d$export$fd7a5551e5344016; });

var $lBDHD = parcelRequire("lBDHD");
class $2a3cb15ddb58852d$export$fd7a5551e5344016 {
    /**
     * Concatenate a number of ArrayBuffers into one.
     *
     * @param buffers An array of ArrayBuffers to concatenate, or a single
     *     ArrayBuffer.
     * @returns Result of concatenating `buffers` in order.
     */ static join(buffers) {
        return new $2a3cb15ddb58852d$export$fd7a5551e5344016(buffers).slice();
    }
    constructor(buffers){
        this.shards = [];
        this.previousShardIndex = 0;
        if (buffers == null) return;
        // Normalize the `buffers` input to be `ArrayBuffer[]`.
        if (!(buffers instanceof Array)) buffers = [
            buffers
        ];
        buffers = buffers.map((bufferOrTypedArray)=>{
            if ($lBDHD.isTypedArray(bufferOrTypedArray)) return bufferOrTypedArray.buffer;
            return bufferOrTypedArray;
        });
        // Skip setting up shards if there are no buffers.
        if (buffers.length === 0) return;
        this.bufferUniformSize = buffers[0].byteLength;
        let start = 0;
        for(let i = 0; i < buffers.length; i++){
            const buffer = buffers[i];
            // Check that all buffers except the last one have the same length.
            if (i !== buffers.length - 1 && buffer.byteLength !== this.bufferUniformSize) // Unset the buffer uniform size, since the buffer sizes are not
            // uniform.
            this.bufferUniformSize = undefined;
            // Create the shards, including their start and end points.
            const end = start + buffer.byteLength;
            this.shards.push({
                buffer: buffer,
                start: start,
                end: end
            });
            start = end;
        }
        // Set the byteLength
        if (this.shards.length === 0) this.byteLength = 0;
        this.byteLength = this.shards[this.shards.length - 1].end;
    }
    slice(start = 0, end = this.byteLength) {
        // If there are no shards, then the CompositeArrayBuffer was initialized
        // with no data.
        if (this.shards.length === 0) return new ArrayBuffer(0);
        // NaN is treated as zero for slicing. This matches ArrayBuffer's behavior.
        start = isNaN(Number(start)) ? 0 : start;
        end = isNaN(Number(end)) ? 0 : end;
        // Fix the bounds to within the array.
        start = Math.max(0, start);
        end = Math.min(this.byteLength, end);
        if (end <= start) return new ArrayBuffer(0);
        const startShardIndex = this.findShardForByte(start);
        if (startShardIndex === -1) // This should not happen since the start and end indices are always
        // within 0 and the composite array's length.
        throw new Error(`Could not find start shard for byte ${start}`);
        const size = end - start;
        const outputBuffer = new ArrayBuffer(size);
        const outputArray = new Uint8Array(outputBuffer);
        let sliced = 0;
        for(let i = startShardIndex; i < this.shards.length; i++){
            const shard = this.shards[i];
            const globalStart = start + sliced;
            const localStart = globalStart - shard.start;
            const outputStart = sliced;
            const globalEnd = Math.min(end, shard.end);
            const localEnd = globalEnd - shard.start;
            const outputSlice = new Uint8Array(shard.buffer, localStart, localEnd - localStart);
            outputArray.set(outputSlice, outputStart);
            sliced += outputSlice.length;
            if (end < shard.end) break;
        }
        return outputBuffer;
    }
    /**
     * Get the index of the shard that contains the byte at `byteIndex`.
     */ findShardForByte(byteIndex) {
        if (this.shards.length === 0 || byteIndex < 0 || byteIndex >= this.byteLength) return -1;
        // If the buffers have a uniform size, compute the shard directly.
        if (this.bufferUniformSize != null) {
            this.previousShardIndex = Math.floor(byteIndex / this.bufferUniformSize);
            return this.previousShardIndex;
        }
        // If the buffers don't have a uniform size, we need to search for the
        // shard. That means we need a function to check where the byteIndex lies
        // relative to a given shard.
        function check(shard) {
            if (byteIndex < shard.start) return -1;
            if (byteIndex >= shard.end) return 1;
            return 0;
        }
        // For efficiency, try the previous shard first.
        if (check(this.shards[this.previousShardIndex]) === 0) return this.previousShardIndex;
        // Otherwise, use a generic search function.
        // This should almost never end up being used in practice since the weight
        // entries should always be in order.
        const index = $2a3cb15ddb58852d$export$d76128d007d19019(this.shards, check);
        if (index === -1) return -1;
        this.previousShardIndex = index;
        return this.previousShardIndex;
    }
}
function $2a3cb15ddb58852d$export$d76128d007d19019(sortedArray, compare) {
    // Binary search
    let min = 0;
    let max = sortedArray.length;
    while(min <= max){
        const middle = Math.floor((max - min) / 2) + min;
        const side = compare(sortedArray[middle]);
        if (side === 0) return middle;
        else if (side < 0) max = middle;
        else min = middle + 1;
    }
    return -1;
}

});

parcelRegister("d7Nxs", function(module, exports) {

$parcel$export(module.exports, "engine", function () { return $98e25b2aeb270983$export$d3c662a6136faebb; });
$parcel$export(module.exports, "memory", function () { return $98e25b2aeb270983$export$827b61424e8f52d2; });
$parcel$export(module.exports, "tidy", function () { return $98e25b2aeb270983$export$b841c6a213a653eb; });
$parcel$export(module.exports, "dispose", function () { return $98e25b2aeb270983$export$fcfbbcec2cb820d5; });
$parcel$export(module.exports, "keep", function () { return $98e25b2aeb270983$export$fae3166c418e0471; });
$parcel$export(module.exports, "setBackend", function () { return $98e25b2aeb270983$export$7953970fabc9c2; });
$parcel$export(module.exports, "getBackend", function () { return $98e25b2aeb270983$export$b098501f764cdf30; });
$parcel$export(module.exports, "registerBackend", function () { return $98e25b2aeb270983$export$1ac8c3a90eff05d; });
$parcel$export(module.exports, "backend", function () { return $98e25b2aeb270983$export$32a253b6f8b50fb4; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $tdutJ = parcelRequire("tdutJ");

var $3pVUH = parcelRequire("3pVUH");

var $gpWQN = parcelRequire("gpWQN");
function $98e25b2aeb270983$export$1e73b1267274f27e() {
    (0, $tdutJ.env)().set('PROD', true);
}
function $98e25b2aeb270983$export$ef8a131e8a882a3a() {
    (0, $tdutJ.env)().set('DEBUG', true);
}
function $98e25b2aeb270983$export$cb100329fdb11914() {
    (0, $tdutJ.env)().set('DEPRECATION_WARNINGS_ENABLED', false);
    console.warn(`TensorFlow.js deprecation warnings have been disabled.`);
}
function $98e25b2aeb270983$export$e46eea6a629d2da5(msg) {
    if ((0, $tdutJ.env)().getBool('DEPRECATION_WARNINGS_ENABLED')) console.warn(msg + ' You can disable deprecation warnings with ' + 'tf.disableDeprecationWarnings().');
}
(0, $3pVUH.setDeprecationWarningFn)($98e25b2aeb270983$export$e46eea6a629d2da5);
function $98e25b2aeb270983$export$f22ce7a2fa538c48() {
    (0, $e6Ey6.ENGINE).disposeVariables();
}
function $98e25b2aeb270983$export$d3c662a6136faebb() {
    return 0, $e6Ey6.ENGINE;
}
function $98e25b2aeb270983$export$827b61424e8f52d2() {
    return (0, $e6Ey6.ENGINE).memory();
}
function $98e25b2aeb270983$export$4882ae973e0491e(f) {
    return (0, $e6Ey6.ENGINE).profile(f);
}
function $98e25b2aeb270983$export$b841c6a213a653eb(nameOrFn, fn) {
    return (0, $e6Ey6.ENGINE).tidy(nameOrFn, fn);
}
function $98e25b2aeb270983$export$fcfbbcec2cb820d5(container) {
    const tensors = (0, $gpWQN.getTensorsInContainer)(container);
    tensors.forEach((tensor)=>tensor.dispose());
}
function $98e25b2aeb270983$export$fae3166c418e0471(result) {
    return (0, $e6Ey6.ENGINE).keep(result);
}
function $98e25b2aeb270983$export$2da9be4cfdb689b1(f) {
    return (0, $e6Ey6.ENGINE).time(f);
}
function $98e25b2aeb270983$export$7953970fabc9c2(backendName) {
    return (0, $e6Ey6.ENGINE).setBackend(backendName);
}
function $98e25b2aeb270983$export$28ee1007e174a2a6() {
    return (0, $e6Ey6.ENGINE).ready();
}
function $98e25b2aeb270983$export$b098501f764cdf30() {
    return (0, $e6Ey6.ENGINE).backendName;
}
function $98e25b2aeb270983$export$c299110fbe92c80c(name) {
    (0, $e6Ey6.ENGINE).removeBackend(name);
}
function $98e25b2aeb270983$export$f94fbc07ea8e852e(name) {
    return (0, $e6Ey6.ENGINE).findBackend(name);
}
function $98e25b2aeb270983$export$e4a6d214466a2c7b(name) {
    return (0, $e6Ey6.ENGINE).findBackendFactory(name);
}
function $98e25b2aeb270983$export$1ac8c3a90eff05d(name, factory, priority = 1) {
    return (0, $e6Ey6.ENGINE).registerBackend(name, factory, priority);
}
function $98e25b2aeb270983$export$32a253b6f8b50fb4() {
    return (0, $e6Ey6.ENGINE).backend;
}
function $98e25b2aeb270983$export$5f05d56a0f2349cc(platformName, platform) {
    (0, $tdutJ.env)().setPlatform(platformName, platform);
}

});

parcelRegister("2bytI", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $19775a84a38a0486$export$a143d493d941bafc; }, function (v) { return $19775a84a38a0486$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $19775a84a38a0486$export$f99ded8fe4b79145; }, function (v) { return $19775a84a38a0486$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $19775a84a38a0486$export$a143d493d941bafc;
var $19775a84a38a0486$export$e4cf37d7f6fb9e0a;
var $19775a84a38a0486$export$f99ded8fe4b79145;
var $19775a84a38a0486$export$599f31c3813fae4d;
'use strict';

var $2jR6a = parcelRequire("2jR6a");

var $kH4Ua = parcelRequire("kH4Ua");
const $19775a84a38a0486$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$19775a84a38a0486$export$a143d493d941bafc = $19775a84a38a0486$var$Buffer;
$19775a84a38a0486$export$e4cf37d7f6fb9e0a = $19775a84a38a0486$var$SlowBuffer;
$19775a84a38a0486$export$f99ded8fe4b79145 = 50;
const $19775a84a38a0486$var$K_MAX_LENGTH = 0x7fffffff;
$19775a84a38a0486$export$599f31c3813fae4d = $19775a84a38a0486$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $19775a84a38a0486$var$Buffer.TYPED_ARRAY_SUPPORT = $19775a84a38a0486$var$typedArraySupport();
if (!$19775a84a38a0486$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $19775a84a38a0486$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($19775a84a38a0486$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$19775a84a38a0486$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($19775a84a38a0486$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$19775a84a38a0486$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $19775a84a38a0486$var$createBuffer(length) {
    if (length > $19775a84a38a0486$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $19775a84a38a0486$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $19775a84a38a0486$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $19775a84a38a0486$var$allocUnsafe(arg);
    }
    return $19775a84a38a0486$var$from(arg, encodingOrOffset, length);
}
$19775a84a38a0486$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $19775a84a38a0486$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $19775a84a38a0486$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $19775a84a38a0486$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($19775a84a38a0486$var$isInstance(value, ArrayBuffer) || value && $19775a84a38a0486$var$isInstance(value.buffer, ArrayBuffer)) return $19775a84a38a0486$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($19775a84a38a0486$var$isInstance(value, SharedArrayBuffer) || value && $19775a84a38a0486$var$isInstance(value.buffer, SharedArrayBuffer))) return $19775a84a38a0486$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $19775a84a38a0486$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $19775a84a38a0486$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $19775a84a38a0486$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $19775a84a38a0486$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $19775a84a38a0486$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($19775a84a38a0486$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($19775a84a38a0486$var$Buffer, Uint8Array);
function $19775a84a38a0486$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $19775a84a38a0486$var$alloc(size, fill, encoding) {
    $19775a84a38a0486$var$assertSize(size);
    if (size <= 0) return $19775a84a38a0486$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $19775a84a38a0486$var$createBuffer(size).fill(fill, encoding) : $19775a84a38a0486$var$createBuffer(size).fill(fill);
    return $19775a84a38a0486$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $19775a84a38a0486$var$Buffer.alloc = function(size, fill, encoding) {
    return $19775a84a38a0486$var$alloc(size, fill, encoding);
};
function $19775a84a38a0486$var$allocUnsafe(size) {
    $19775a84a38a0486$var$assertSize(size);
    return $19775a84a38a0486$var$createBuffer(size < 0 ? 0 : $19775a84a38a0486$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $19775a84a38a0486$var$Buffer.allocUnsafe = function(size) {
    return $19775a84a38a0486$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $19775a84a38a0486$var$Buffer.allocUnsafeSlow = function(size) {
    return $19775a84a38a0486$var$allocUnsafe(size);
};
function $19775a84a38a0486$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$19775a84a38a0486$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $19775a84a38a0486$var$byteLength(string, encoding) | 0;
    let buf = $19775a84a38a0486$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $19775a84a38a0486$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $19775a84a38a0486$var$checked(array.length) | 0;
    const buf = $19775a84a38a0486$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $19775a84a38a0486$var$fromArrayView(arrayView) {
    if ($19775a84a38a0486$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $19775a84a38a0486$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $19775a84a38a0486$var$fromArrayLike(arrayView);
}
function $19775a84a38a0486$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $19775a84a38a0486$var$Buffer.prototype);
    return buf;
}
function $19775a84a38a0486$var$fromObject(obj) {
    if ($19775a84a38a0486$var$Buffer.isBuffer(obj)) {
        const len = $19775a84a38a0486$var$checked(obj.length) | 0;
        const buf = $19775a84a38a0486$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $19775a84a38a0486$var$numberIsNaN(obj.length)) return $19775a84a38a0486$var$createBuffer(0);
        return $19775a84a38a0486$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $19775a84a38a0486$var$fromArrayLike(obj.data);
}
function $19775a84a38a0486$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $19775a84a38a0486$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $19775a84a38a0486$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $19775a84a38a0486$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $19775a84a38a0486$var$Buffer.alloc(+length);
}
$19775a84a38a0486$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $19775a84a38a0486$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$19775a84a38a0486$var$Buffer.compare = function compare(a, b) {
    if ($19775a84a38a0486$var$isInstance(a, Uint8Array)) a = $19775a84a38a0486$var$Buffer.from(a, a.offset, a.byteLength);
    if ($19775a84a38a0486$var$isInstance(b, Uint8Array)) b = $19775a84a38a0486$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$19775a84a38a0486$var$Buffer.isBuffer(a) || !$19775a84a38a0486$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$19775a84a38a0486$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$19775a84a38a0486$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $19775a84a38a0486$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $19775a84a38a0486$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($19775a84a38a0486$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$19775a84a38a0486$var$Buffer.isBuffer(buf)) buf = $19775a84a38a0486$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$19775a84a38a0486$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $19775a84a38a0486$var$byteLength(string, encoding) {
    if ($19775a84a38a0486$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $19775a84a38a0486$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $19775a84a38a0486$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $19775a84a38a0486$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $19775a84a38a0486$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$19775a84a38a0486$var$Buffer.byteLength = $19775a84a38a0486$var$byteLength;
function $19775a84a38a0486$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $19775a84a38a0486$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $19775a84a38a0486$var$utf8Slice(this, start, end);
        case 'ascii':
            return $19775a84a38a0486$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $19775a84a38a0486$var$latin1Slice(this, start, end);
        case 'base64':
            return $19775a84a38a0486$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $19775a84a38a0486$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$19775a84a38a0486$var$Buffer.prototype._isBuffer = true;
function $19775a84a38a0486$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$19775a84a38a0486$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$19775a84a38a0486$var$swap(this, i, i + 1);
    return this;
};
$19775a84a38a0486$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $19775a84a38a0486$var$swap(this, i, i + 3);
        $19775a84a38a0486$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$19775a84a38a0486$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $19775a84a38a0486$var$swap(this, i, i + 7);
        $19775a84a38a0486$var$swap(this, i + 1, i + 6);
        $19775a84a38a0486$var$swap(this, i + 2, i + 5);
        $19775a84a38a0486$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$19775a84a38a0486$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $19775a84a38a0486$var$utf8Slice(this, 0, length);
    return $19775a84a38a0486$var$slowToString.apply(this, arguments);
};
$19775a84a38a0486$var$Buffer.prototype.toLocaleString = $19775a84a38a0486$var$Buffer.prototype.toString;
$19775a84a38a0486$var$Buffer.prototype.equals = function equals(b) {
    if (!$19775a84a38a0486$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $19775a84a38a0486$var$Buffer.compare(this, b) === 0;
};
$19775a84a38a0486$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $19775a84a38a0486$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($19775a84a38a0486$var$customInspectSymbol) $19775a84a38a0486$var$Buffer.prototype[$19775a84a38a0486$var$customInspectSymbol] = $19775a84a38a0486$var$Buffer.prototype.inspect;
$19775a84a38a0486$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($19775a84a38a0486$var$isInstance(target, Uint8Array)) target = $19775a84a38a0486$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$19775a84a38a0486$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $19775a84a38a0486$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($19775a84a38a0486$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $19775a84a38a0486$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($19775a84a38a0486$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $19775a84a38a0486$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $19775a84a38a0486$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $19775a84a38a0486$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$19775a84a38a0486$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$19775a84a38a0486$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $19775a84a38a0486$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$19775a84a38a0486$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $19775a84a38a0486$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $19775a84a38a0486$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($19775a84a38a0486$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $19775a84a38a0486$var$utf8Write(buf, string, offset, length) {
    return $19775a84a38a0486$var$blitBuffer($19775a84a38a0486$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $19775a84a38a0486$var$asciiWrite(buf, string, offset, length) {
    return $19775a84a38a0486$var$blitBuffer($19775a84a38a0486$var$asciiToBytes(string), buf, offset, length);
}
function $19775a84a38a0486$var$base64Write(buf, string, offset, length) {
    return $19775a84a38a0486$var$blitBuffer($19775a84a38a0486$var$base64ToBytes(string), buf, offset, length);
}
function $19775a84a38a0486$var$ucs2Write(buf, string, offset, length) {
    return $19775a84a38a0486$var$blitBuffer($19775a84a38a0486$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$19775a84a38a0486$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $19775a84a38a0486$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $19775a84a38a0486$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $19775a84a38a0486$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $19775a84a38a0486$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $19775a84a38a0486$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$19775a84a38a0486$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $19775a84a38a0486$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $2jR6a.fromByteArray(buf);
    else return $2jR6a.fromByteArray(buf.slice(start, end));
}
function $19775a84a38a0486$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $19775a84a38a0486$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $19775a84a38a0486$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $19775a84a38a0486$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $19775a84a38a0486$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $19775a84a38a0486$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $19775a84a38a0486$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $19775a84a38a0486$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $19775a84a38a0486$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $19775a84a38a0486$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $19775a84a38a0486$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$19775a84a38a0486$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $19775a84a38a0486$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $19775a84a38a0486$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$19775a84a38a0486$var$Buffer.prototype.readUintLE = $19775a84a38a0486$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$19775a84a38a0486$var$Buffer.prototype.readUintBE = $19775a84a38a0486$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$19775a84a38a0486$var$Buffer.prototype.readUint8 = $19775a84a38a0486$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$19775a84a38a0486$var$Buffer.prototype.readUint16LE = $19775a84a38a0486$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$19775a84a38a0486$var$Buffer.prototype.readUint16BE = $19775a84a38a0486$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$19775a84a38a0486$var$Buffer.prototype.readUint32LE = $19775a84a38a0486$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$19775a84a38a0486$var$Buffer.prototype.readUint32BE = $19775a84a38a0486$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$19775a84a38a0486$var$Buffer.prototype.readBigUInt64LE = $19775a84a38a0486$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $19775a84a38a0486$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $19775a84a38a0486$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$19775a84a38a0486$var$Buffer.prototype.readBigUInt64BE = $19775a84a38a0486$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $19775a84a38a0486$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $19775a84a38a0486$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$19775a84a38a0486$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$19775a84a38a0486$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$19775a84a38a0486$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$19775a84a38a0486$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$19775a84a38a0486$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$19775a84a38a0486$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$19775a84a38a0486$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$19775a84a38a0486$var$Buffer.prototype.readBigInt64LE = $19775a84a38a0486$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $19775a84a38a0486$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $19775a84a38a0486$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$19775a84a38a0486$var$Buffer.prototype.readBigInt64BE = $19775a84a38a0486$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $19775a84a38a0486$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $19775a84a38a0486$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$19775a84a38a0486$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 4, this.length);
    return $kH4Ua.read(this, offset, true, 23, 4);
};
$19775a84a38a0486$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 4, this.length);
    return $kH4Ua.read(this, offset, false, 23, 4);
};
$19775a84a38a0486$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 8, this.length);
    return $kH4Ua.read(this, offset, true, 52, 8);
};
$19775a84a38a0486$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkOffset(offset, 8, this.length);
    return $kH4Ua.read(this, offset, false, 52, 8);
};
function $19775a84a38a0486$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$19775a84a38a0486$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$19775a84a38a0486$var$Buffer.prototype.writeUintLE = $19775a84a38a0486$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $19775a84a38a0486$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$19775a84a38a0486$var$Buffer.prototype.writeUintBE = $19775a84a38a0486$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $19775a84a38a0486$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$19775a84a38a0486$var$Buffer.prototype.writeUint8 = $19775a84a38a0486$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$19775a84a38a0486$var$Buffer.prototype.writeUint16LE = $19775a84a38a0486$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$19775a84a38a0486$var$Buffer.prototype.writeUint16BE = $19775a84a38a0486$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$19775a84a38a0486$var$Buffer.prototype.writeUint32LE = $19775a84a38a0486$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$19775a84a38a0486$var$Buffer.prototype.writeUint32BE = $19775a84a38a0486$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $19775a84a38a0486$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $19775a84a38a0486$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $19775a84a38a0486$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $19775a84a38a0486$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$19775a84a38a0486$var$Buffer.prototype.writeBigUInt64LE = $19775a84a38a0486$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $19775a84a38a0486$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$19775a84a38a0486$var$Buffer.prototype.writeBigUInt64BE = $19775a84a38a0486$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $19775a84a38a0486$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$19775a84a38a0486$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $19775a84a38a0486$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$19775a84a38a0486$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $19775a84a38a0486$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$19775a84a38a0486$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$19775a84a38a0486$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$19775a84a38a0486$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$19775a84a38a0486$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$19775a84a38a0486$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$19775a84a38a0486$var$Buffer.prototype.writeBigInt64LE = $19775a84a38a0486$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $19775a84a38a0486$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$19775a84a38a0486$var$Buffer.prototype.writeBigInt64BE = $19775a84a38a0486$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $19775a84a38a0486$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $19775a84a38a0486$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $19775a84a38a0486$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $kH4Ua.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$19775a84a38a0486$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $19775a84a38a0486$var$writeFloat(this, value, offset, true, noAssert);
};
$19775a84a38a0486$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $19775a84a38a0486$var$writeFloat(this, value, offset, false, noAssert);
};
function $19775a84a38a0486$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $19775a84a38a0486$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $kH4Ua.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$19775a84a38a0486$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $19775a84a38a0486$var$writeDouble(this, value, offset, true, noAssert);
};
$19775a84a38a0486$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $19775a84a38a0486$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$19775a84a38a0486$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$19775a84a38a0486$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$19775a84a38a0486$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$19775a84a38a0486$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $19775a84a38a0486$var$Buffer.isBuffer(val) ? val : $19775a84a38a0486$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $19775a84a38a0486$var$errors = {};
function $19775a84a38a0486$var$E(sym, getMessage, Base) {
    $19775a84a38a0486$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$19775a84a38a0486$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$19775a84a38a0486$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$19775a84a38a0486$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $19775a84a38a0486$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $19775a84a38a0486$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $19775a84a38a0486$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $19775a84a38a0486$var$checkBounds(buf, offset, byteLength) {
    $19775a84a38a0486$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $19775a84a38a0486$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $19775a84a38a0486$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $19775a84a38a0486$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $19775a84a38a0486$var$checkBounds(buf, offset, byteLength);
}
function $19775a84a38a0486$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $19775a84a38a0486$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $19775a84a38a0486$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $19775a84a38a0486$var$validateNumber(value, type);
        throw new $19775a84a38a0486$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $19775a84a38a0486$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $19775a84a38a0486$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $19775a84a38a0486$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $19775a84a38a0486$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($19775a84a38a0486$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $19775a84a38a0486$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $19775a84a38a0486$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $19775a84a38a0486$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $19775a84a38a0486$var$base64ToBytes(str) {
    return $2jR6a.toByteArray($19775a84a38a0486$var$base64clean(str));
}
function $19775a84a38a0486$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $19775a84a38a0486$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $19775a84a38a0486$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $19775a84a38a0486$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $19775a84a38a0486$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $19775a84a38a0486$var$BufferBigIntNotDefined : fn;
}
function $19775a84a38a0486$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("2jR6a", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $1b068b5d9b148592$export$d622b2ad8d90c771; }, function (v) { return $1b068b5d9b148592$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $1b068b5d9b148592$export$6100ba28696e12de; }, function (v) { return $1b068b5d9b148592$export$6100ba28696e12de = v; });
var $1b068b5d9b148592$export$a48f0734ac7c2329;
var $1b068b5d9b148592$export$d622b2ad8d90c771;
var $1b068b5d9b148592$export$6100ba28696e12de;
'use strict';
$1b068b5d9b148592$export$a48f0734ac7c2329 = $1b068b5d9b148592$var$byteLength;
$1b068b5d9b148592$export$d622b2ad8d90c771 = $1b068b5d9b148592$var$toByteArray;
$1b068b5d9b148592$export$6100ba28696e12de = $1b068b5d9b148592$var$fromByteArray;
var $1b068b5d9b148592$var$lookup = [];
var $1b068b5d9b148592$var$revLookup = [];
var $1b068b5d9b148592$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $1b068b5d9b148592$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $1b068b5d9b148592$var$i = 0, $1b068b5d9b148592$var$len = $1b068b5d9b148592$var$code.length; $1b068b5d9b148592$var$i < $1b068b5d9b148592$var$len; ++$1b068b5d9b148592$var$i){
    $1b068b5d9b148592$var$lookup[$1b068b5d9b148592$var$i] = $1b068b5d9b148592$var$code[$1b068b5d9b148592$var$i];
    $1b068b5d9b148592$var$revLookup[$1b068b5d9b148592$var$code.charCodeAt($1b068b5d9b148592$var$i)] = $1b068b5d9b148592$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$1b068b5d9b148592$var$revLookup['-'.charCodeAt(0)] = 62;
$1b068b5d9b148592$var$revLookup['_'.charCodeAt(0)] = 63;
function $1b068b5d9b148592$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $1b068b5d9b148592$var$byteLength(b64) {
    var lens = $1b068b5d9b148592$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1b068b5d9b148592$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1b068b5d9b148592$var$toByteArray(b64) {
    var tmp;
    var lens = $1b068b5d9b148592$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $1b068b5d9b148592$var$Arr($1b068b5d9b148592$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i)] << 18 | $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i)] << 2 | $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i)] << 10 | $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $1b068b5d9b148592$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $1b068b5d9b148592$var$tripletToBase64(num) {
    return $1b068b5d9b148592$var$lookup[num >> 18 & 0x3F] + $1b068b5d9b148592$var$lookup[num >> 12 & 0x3F] + $1b068b5d9b148592$var$lookup[num >> 6 & 0x3F] + $1b068b5d9b148592$var$lookup[num & 0x3F];
}
function $1b068b5d9b148592$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($1b068b5d9b148592$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $1b068b5d9b148592$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($1b068b5d9b148592$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($1b068b5d9b148592$var$lookup[tmp >> 2] + $1b068b5d9b148592$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($1b068b5d9b148592$var$lookup[tmp >> 10] + $1b068b5d9b148592$var$lookup[tmp >> 4 & 0x3F] + $1b068b5d9b148592$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("kH4Ua", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $f10ba0d7443c95b2$export$aafa59e2e03f2942; }, function (v) { return $f10ba0d7443c95b2$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $f10ba0d7443c95b2$export$68d8715fc104d294; }, function (v) { return $f10ba0d7443c95b2$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f10ba0d7443c95b2$export$aafa59e2e03f2942;
var $f10ba0d7443c95b2$export$68d8715fc104d294;
$f10ba0d7443c95b2$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f10ba0d7443c95b2$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("9NeiV", function(module, exports) {

$parcel$export(module.exports, "IORouterRegistry", function () { return $7213c935ebf1a91f$export$512275d398c0bdcd; });
$parcel$export(module.exports, "registerSaveRouter", function () { return $7213c935ebf1a91f$export$94da4683f36f634e; });
$parcel$export(module.exports, "registerLoadRouter", function () { return $7213c935ebf1a91f$export$8bf64df3d1fb9866; });
$parcel$export(module.exports, "getSaveHandlers", function () { return $7213c935ebf1a91f$export$88af18fd9ddb62ff; });
$parcel$export(module.exports, "getLoadHandlers", function () { return $7213c935ebf1a91f$export$90c6c4d24103fa9a; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $7213c935ebf1a91f$export$512275d398c0bdcd {
    constructor(){
        this.saveRouters = [];
        this.loadRouters = [];
    }
    static getInstance() {
        if ($7213c935ebf1a91f$export$512275d398c0bdcd.instance == null) $7213c935ebf1a91f$export$512275d398c0bdcd.instance = new $7213c935ebf1a91f$export$512275d398c0bdcd();
        return $7213c935ebf1a91f$export$512275d398c0bdcd.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerSaveRouter(saveRouter) {
        $7213c935ebf1a91f$export$512275d398c0bdcd.getInstance().saveRouters.push(saveRouter);
    }
    /**
     * Register a load-handler router.
     *
     * @param loadRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `load` method defined or `null`.
     */ static registerLoadRouter(loadRouter) {
        $7213c935ebf1a91f$export$512275d398c0bdcd.getInstance().loadRouters.push(loadRouter);
    }
    /**
     * Look up IOHandler for saving, given a URL-like string.
     *
     * @param url
     * @returns If only one match is found, an instance of IOHandler with the
     * `save` method defined. If no match is found, `null`.
     * @throws Error, if more than one match is found.
     */ static getSaveHandlers(url) {
        return $7213c935ebf1a91f$export$512275d398c0bdcd.getHandlers(url, 'save');
    }
    /**
     * Look up IOHandler for loading, given a URL-like string.
     *
     * @param url
     * @param loadOptions Optional, custom load options.
     * @returns All valid handlers for `url`, given the currently registered
     *   handler routers.
     */ static getLoadHandlers(url, loadOptions) {
        return $7213c935ebf1a91f$export$512275d398c0bdcd.getHandlers(url, 'load', loadOptions);
    }
    static getHandlers(url, handlerType, loadOptions) {
        const validHandlers = [];
        const routers = handlerType === 'load' ? $7213c935ebf1a91f$export$512275d398c0bdcd.getInstance().loadRouters : $7213c935ebf1a91f$export$512275d398c0bdcd.getInstance().saveRouters;
        routers.forEach((router)=>{
            const handler = router(url, loadOptions);
            if (handler !== null) validHandlers.push(handler);
        });
        return validHandlers;
    }
}
const $7213c935ebf1a91f$export$94da4683f36f634e = (loudRouter)=>$7213c935ebf1a91f$export$512275d398c0bdcd.registerSaveRouter(loudRouter);
const $7213c935ebf1a91f$export$8bf64df3d1fb9866 = (loudRouter)=>$7213c935ebf1a91f$export$512275d398c0bdcd.registerLoadRouter(loudRouter);
const $7213c935ebf1a91f$export$88af18fd9ddb62ff = (url)=>$7213c935ebf1a91f$export$512275d398c0bdcd.getSaveHandlers(url);
const $7213c935ebf1a91f$export$90c6c4d24103fa9a = (url, loadOptions)=>$7213c935ebf1a91f$export$512275d398c0bdcd.getLoadHandlers(url, loadOptions);

});


parcelRegister("djQES", function(module, exports) {

$parcel$export(module.exports, "BrowserLocalStorage", function () { return $9b25e58bc2246205$export$8984a84f7aef20de; });
$parcel$export(module.exports, "BrowserLocalStorageManager", function () { return $9b25e58bc2246205$export$bb7e7fb445a616f4; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("fJy9j");

var $tdutJ = parcelRequire("tdutJ");

var $eOiOM = parcelRequire("eOiOM");

var $lxNMC = parcelRequire("lxNMC");

var $3CPgX = parcelRequire("3CPgX");

var $9NeiV = parcelRequire("9NeiV");
const $9b25e58bc2246205$var$PATH_SEPARATOR = '/';
const $9b25e58bc2246205$var$PATH_PREFIX = 'tensorflowjs_models';
const $9b25e58bc2246205$var$INFO_SUFFIX = 'info';
const $9b25e58bc2246205$var$MODEL_TOPOLOGY_SUFFIX = 'model_topology';
const $9b25e58bc2246205$var$WEIGHT_SPECS_SUFFIX = 'weight_specs';
const $9b25e58bc2246205$var$WEIGHT_DATA_SUFFIX = 'weight_data';
const $9b25e58bc2246205$var$MODEL_METADATA_SUFFIX = 'model_metadata';
function $9b25e58bc2246205$export$af2a48c9611db360() {
    if (!(0, $tdutJ.env)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') throw new Error("purgeLocalStorageModels() cannot proceed because local storage is unavailable in the current environment.");
    const LS = window.localStorage;
    const purgedModelPaths = [];
    for(let i = 0; i < LS.length; ++i){
        const key = LS.key(i);
        const prefix = $9b25e58bc2246205$var$PATH_PREFIX + $9b25e58bc2246205$var$PATH_SEPARATOR;
        if (key.startsWith(prefix) && key.length > prefix.length) {
            LS.removeItem(key);
            const modelName = $9b25e58bc2246205$var$getModelPathFromKey(key);
            if (purgedModelPaths.indexOf(modelName) === -1) purgedModelPaths.push(modelName);
        }
    }
    return purgedModelPaths;
}
function $9b25e58bc2246205$var$getModelKeys(path) {
    return {
        info: [
            $9b25e58bc2246205$var$PATH_PREFIX,
            path,
            $9b25e58bc2246205$var$INFO_SUFFIX
        ].join($9b25e58bc2246205$var$PATH_SEPARATOR),
        topology: [
            $9b25e58bc2246205$var$PATH_PREFIX,
            path,
            $9b25e58bc2246205$var$MODEL_TOPOLOGY_SUFFIX
        ].join($9b25e58bc2246205$var$PATH_SEPARATOR),
        weightSpecs: [
            $9b25e58bc2246205$var$PATH_PREFIX,
            path,
            $9b25e58bc2246205$var$WEIGHT_SPECS_SUFFIX
        ].join($9b25e58bc2246205$var$PATH_SEPARATOR),
        weightData: [
            $9b25e58bc2246205$var$PATH_PREFIX,
            path,
            $9b25e58bc2246205$var$WEIGHT_DATA_SUFFIX
        ].join($9b25e58bc2246205$var$PATH_SEPARATOR),
        modelMetadata: [
            $9b25e58bc2246205$var$PATH_PREFIX,
            path,
            $9b25e58bc2246205$var$MODEL_METADATA_SUFFIX
        ].join($9b25e58bc2246205$var$PATH_SEPARATOR)
    };
}
function $9b25e58bc2246205$var$removeItems(keys) {
    for (const key of Object.values(keys))window.localStorage.removeItem(key);
}
/**
 * Get model path from a local-storage key.
 *
 * E.g., 'tensorflowjs_models/my/model/1/info' --> 'my/model/1'
 *
 * @param key
 */ function $9b25e58bc2246205$var$getModelPathFromKey(key) {
    const items = key.split($9b25e58bc2246205$var$PATH_SEPARATOR);
    if (items.length < 3) throw new Error(`Invalid key format: ${key}`);
    return items.slice(1, items.length - 1).join($9b25e58bc2246205$var$PATH_SEPARATOR);
}
function $9b25e58bc2246205$var$maybeStripScheme(key) {
    return key.startsWith($9b25e58bc2246205$export$8984a84f7aef20de.URL_SCHEME) ? key.slice($9b25e58bc2246205$export$8984a84f7aef20de.URL_SCHEME.length) : key;
}
/**
 * IOHandler subclass: Browser Local Storage.
 *
 * See the doc string to `browserLocalStorage` for more details.
 */ class $9b25e58bc2246205$export$8984a84f7aef20de {
    constructor(modelPath){
        if (!(0, $tdutJ.env)().getBool('IS_BROWSER') || typeof window === 'undefined' || typeof window.localStorage === 'undefined') // TODO(cais): Add more info about what IOHandler subtypes are
        // available.
        //   Maybe point to a doc page on the web and/or automatically determine
        //   the available IOHandlers and print them in the error message.
        throw new Error('The current environment does not support local storage.');
        this.LS = window.localStorage;
        if (modelPath == null || !modelPath) throw new Error('For local storage, modelPath must not be null, undefined or empty.');
        this.modelPath = modelPath;
        this.keys = $9b25e58bc2246205$var$getModelKeys(this.modelPath);
    }
    /**
     * Save model artifacts to browser local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @param modelArtifacts The model artifacts to be stored.
     * @returns An instance of SaveResult.
     */ async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        else {
            const topology = JSON.stringify(modelArtifacts.modelTopology);
            const weightSpecs = JSON.stringify(modelArtifacts.weightSpecs);
            const modelArtifactsInfo = (0, $lxNMC.getModelArtifactsInfoForJSON)(modelArtifacts);
            // TODO(mattsoulanille): Support saving models over 2GB that exceed
            // Chrome's ArrayBuffer size limit.
            const weightBuffer = (0, $3CPgX.CompositeArrayBuffer).join(modelArtifacts.weightData);
            try {
                this.LS.setItem(this.keys.info, JSON.stringify(modelArtifactsInfo));
                this.LS.setItem(this.keys.topology, topology);
                this.LS.setItem(this.keys.weightSpecs, weightSpecs);
                this.LS.setItem(this.keys.weightData, (0, $lxNMC.arrayBufferToBase64String)(weightBuffer));
                // Note that JSON.stringify doesn't write out keys that have undefined
                // values, so for some keys, we set undefined instead of a null-ish
                // value.
                const metadata = {
                    format: modelArtifacts.format,
                    generatedBy: modelArtifacts.generatedBy,
                    convertedBy: modelArtifacts.convertedBy,
                    signature: modelArtifacts.signature != null ? modelArtifacts.signature : undefined,
                    userDefinedMetadata: modelArtifacts.userDefinedMetadata != null ? modelArtifacts.userDefinedMetadata : undefined,
                    modelInitializer: modelArtifacts.modelInitializer != null ? modelArtifacts.modelInitializer : undefined,
                    initializerSignature: modelArtifacts.initializerSignature != null ? modelArtifacts.initializerSignature : undefined,
                    trainingConfig: modelArtifacts.trainingConfig != null ? modelArtifacts.trainingConfig : undefined
                };
                this.LS.setItem(this.keys.modelMetadata, JSON.stringify(metadata));
                return {
                    modelArtifactsInfo: modelArtifactsInfo
                };
            } catch (err) {
                // If saving failed, clean up all items saved so far.
                $9b25e58bc2246205$var$removeItems(this.keys);
                throw new Error(`Failed to save model '${this.modelPath}' to local storage: ` + `size quota being exceeded is a possible cause of this failure: ` + `modelTopologyBytes=${modelArtifactsInfo.modelTopologyBytes}, ` + `weightSpecsBytes=${modelArtifactsInfo.weightSpecsBytes}, ` + `weightDataBytes=${modelArtifactsInfo.weightDataBytes}.`);
            }
        }
    }
    /**
     * Load a model from local storage.
     *
     * See the documentation to `browserLocalStorage` for details on the saved
     * artifacts.
     *
     * @returns The loaded model (if loading succeeds).
     */ async load() {
        const info = JSON.parse(this.LS.getItem(this.keys.info));
        if (info == null) throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
        if (info.modelTopologyType !== 'JSON') throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
        const out = {};
        // Load topology.
        const topology = JSON.parse(this.LS.getItem(this.keys.topology));
        if (topology == null) throw new Error(`In local storage, the topology of model '${this.modelPath}' ` + `is missing.`);
        out.modelTopology = topology;
        // Load weight specs.
        const weightSpecs = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
        if (weightSpecs == null) throw new Error(`In local storage, the weight specs of model '${this.modelPath}' ` + `are missing.`);
        out.weightSpecs = weightSpecs;
        // Load meta-data fields.
        const metadataString = this.LS.getItem(this.keys.modelMetadata);
        if (metadataString != null) {
            const metadata = JSON.parse(metadataString);
            out.format = metadata.format;
            out.generatedBy = metadata.generatedBy;
            out.convertedBy = metadata.convertedBy;
            if (metadata.signature != null) out.signature = metadata.signature;
            if (metadata.userDefinedMetadata != null) out.userDefinedMetadata = metadata.userDefinedMetadata;
            if (metadata.modelInitializer != null) out.modelInitializer = metadata.modelInitializer;
            if (metadata.initializerSignature != null) out.initializerSignature = metadata.initializerSignature;
            if (metadata.trainingConfig != null) out.trainingConfig = metadata.trainingConfig;
        }
        // Load weight data.
        const weightDataBase64 = this.LS.getItem(this.keys.weightData);
        if (weightDataBase64 == null) throw new Error(`In local storage, the binary weight values of model ` + `'${this.modelPath}' are missing.`);
        out.weightData = (0, $lxNMC.base64StringToArrayBuffer)(weightDataBase64);
        return out;
    }
}
$9b25e58bc2246205$export$8984a84f7aef20de.URL_SCHEME = 'localstorage://';
const $9b25e58bc2246205$export$64ff64fd6b1180ae = (url)=>{
    if (!(0, $tdutJ.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($9b25e58bc2246205$export$8984a84f7aef20de.URL_SCHEME)) return $9b25e58bc2246205$export$96d8dd89e6c22307(url.slice($9b25e58bc2246205$export$8984a84f7aef20de.URL_SCHEME.length));
        else return null;
    }
};
(0, $9NeiV.IORouterRegistry).registerSaveRouter($9b25e58bc2246205$export$64ff64fd6b1180ae);
(0, $9NeiV.IORouterRegistry).registerLoadRouter($9b25e58bc2246205$export$64ff64fd6b1180ae);
function $9b25e58bc2246205$export$96d8dd89e6c22307(modelPath) {
    return new $9b25e58bc2246205$export$8984a84f7aef20de(modelPath);
}
class $9b25e58bc2246205$export$bb7e7fb445a616f4 {
    constructor(){
        (0, $eOiOM.assert)((0, $tdutJ.env)().getBool('IS_BROWSER'), ()=>'Current environment is not a web browser');
        (0, $eOiOM.assert)(typeof window === 'undefined' || typeof window.localStorage !== 'undefined', ()=>'Current browser does not appear to support localStorage');
        this.LS = window.localStorage;
    }
    async listModels() {
        const out = {};
        const prefix = $9b25e58bc2246205$var$PATH_PREFIX + $9b25e58bc2246205$var$PATH_SEPARATOR;
        const suffix = $9b25e58bc2246205$var$PATH_SEPARATOR + $9b25e58bc2246205$var$INFO_SUFFIX;
        for(let i = 0; i < this.LS.length; ++i){
            const key = this.LS.key(i);
            if (key.startsWith(prefix) && key.endsWith(suffix)) {
                const modelPath = $9b25e58bc2246205$var$getModelPathFromKey(key);
                out[modelPath] = JSON.parse(this.LS.getItem(key));
            }
        }
        return out;
    }
    async removeModel(path) {
        path = $9b25e58bc2246205$var$maybeStripScheme(path);
        const keys = $9b25e58bc2246205$var$getModelKeys(path);
        if (this.LS.getItem(keys.info) == null) throw new Error(`Cannot find model at path '${path}'`);
        const info = JSON.parse(this.LS.getItem(keys.info));
        $9b25e58bc2246205$var$removeItems(keys);
        return info;
    }
}

});

parcelRegister("jp6Sy", function(module, exports) {

$parcel$export(module.exports, "ModelStoreManagerRegistry", function () { return $e205b01ac758ef50$export$ccf7f72dec8f0028; });
$parcel$export(module.exports, "listModels", function () { return $e205b01ac758ef50$export$8d63af86d795ece4; });
$parcel$export(module.exports, "removeModel", function () { return $e205b01ac758ef50$export$e71037184d1ad0fd; });
$parcel$export(module.exports, "copyModel", function () { return $e205b01ac758ef50$export$b5971478866000ed; });
$parcel$export(module.exports, "moveModel", function () { return $e205b01ac758ef50$export$598f168272f4fec2; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Classes and functions for model management across multiple storage mediums.
 *
 * Supported client actions:
 * - Listing models on all registered storage mediums.
 * - Remove model by URL from any registered storage mediums, by using URL
 *   string.
 * - Moving or copying model from one path to another in the same medium or from
 *   one medium to another, by using URL strings.
 */ 
var $eOiOM = parcelRequire("eOiOM");

var $9NeiV = parcelRequire("9NeiV");
const $e205b01ac758ef50$var$URL_SCHEME_SUFFIX = '://';
class $e205b01ac758ef50$export$ccf7f72dec8f0028 {
    constructor(){
        this.managers = {};
    }
    static getInstance() {
        if ($e205b01ac758ef50$export$ccf7f72dec8f0028.instance == null) $e205b01ac758ef50$export$ccf7f72dec8f0028.instance = new $e205b01ac758ef50$export$ccf7f72dec8f0028();
        return $e205b01ac758ef50$export$ccf7f72dec8f0028.instance;
    }
    /**
     * Register a save-handler router.
     *
     * @param saveRouter A function that maps a URL-like string onto an instance
     * of `IOHandler` with the `save` method defined or `null`.
     */ static registerManager(scheme, manager) {
        (0, $eOiOM.assert)(scheme != null, ()=>'scheme must not be undefined or null.');
        if (scheme.endsWith($e205b01ac758ef50$var$URL_SCHEME_SUFFIX)) scheme = scheme.slice(0, scheme.indexOf($e205b01ac758ef50$var$URL_SCHEME_SUFFIX));
        (0, $eOiOM.assert)(scheme.length > 0, ()=>'scheme must not be an empty string.');
        const registry = $e205b01ac758ef50$export$ccf7f72dec8f0028.getInstance();
        (0, $eOiOM.assert)(registry.managers[scheme] == null, ()=>`A model store manager is already registered for scheme '${scheme}'.`);
        registry.managers[scheme] = manager;
    }
    static getManager(scheme) {
        const manager = $e205b01ac758ef50$export$ccf7f72dec8f0028.getInstance().managers[scheme];
        if (manager == null) throw new Error(`Cannot find model manager for scheme '${scheme}'`);
        return manager;
    }
    static getSchemes() {
        return Object.keys($e205b01ac758ef50$export$ccf7f72dec8f0028.getInstance().managers);
    }
}
/**
 * Helper method for parsing a URL string into a scheme and a path.
 *
 * @param url E.g., 'localstorage://my-model'
 * @returns A dictionary with two fields: scheme and path.
 *   Scheme: e.g., 'localstorage' in the example above.
 *   Path: e.g., 'my-model' in the example above.
 */ function $e205b01ac758ef50$var$parseURL(url) {
    if (url.indexOf($e205b01ac758ef50$var$URL_SCHEME_SUFFIX) === -1) throw new Error(`The url string provided does not contain a scheme. ` + `Supported schemes are: ` + `${$e205b01ac758ef50$export$ccf7f72dec8f0028.getSchemes().join(',')}`);
    return {
        scheme: url.split($e205b01ac758ef50$var$URL_SCHEME_SUFFIX)[0],
        path: url.split($e205b01ac758ef50$var$URL_SCHEME_SUFFIX)[1]
    };
}
async function $e205b01ac758ef50$var$cloneModelInternal(sourceURL, destURL, deleteSource = false) {
    (0, $eOiOM.assert)(sourceURL !== destURL, ()=>`Old path and new path are the same: '${sourceURL}'`);
    const loadHandlers = (0, $9NeiV.IORouterRegistry).getLoadHandlers(sourceURL);
    (0, $eOiOM.assert)(loadHandlers.length > 0, ()=>`Copying failed because no load handler is found for source URL ${sourceURL}.`);
    (0, $eOiOM.assert)(loadHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `load handlers for source URL ${sourceURL}.`);
    const loadHandler = loadHandlers[0];
    const saveHandlers = (0, $9NeiV.IORouterRegistry).getSaveHandlers(destURL);
    (0, $eOiOM.assert)(saveHandlers.length > 0, ()=>`Copying failed because no save handler is found for destination ` + `URL ${destURL}.`);
    (0, $eOiOM.assert)(saveHandlers.length < 2, ()=>`Copying failed because more than one (${loadHandlers.length}) ` + `save handlers for destination URL ${destURL}.`);
    const saveHandler = saveHandlers[0];
    const sourceScheme = $e205b01ac758ef50$var$parseURL(sourceURL).scheme;
    const sourcePath = $e205b01ac758ef50$var$parseURL(sourceURL).path;
    const sameMedium = sourceScheme === $e205b01ac758ef50$var$parseURL(sourceURL).scheme;
    const modelArtifacts = await loadHandler.load();
    // If moving within the same storage medium, remove the old model as soon as
    // the loading is done. Without doing this, it is possible that the combined
    // size of the two models will cause the cloning to fail.
    if (deleteSource && sameMedium) await $e205b01ac758ef50$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    const saveResult = await saveHandler.save(modelArtifacts);
    // If moving between mediums, the deletion is done after the save succeeds.
    // This guards against the case in which saving to the destination medium
    // fails.
    if (deleteSource && !sameMedium) await $e205b01ac758ef50$export$ccf7f72dec8f0028.getManager(sourceScheme).removeModel(sourcePath);
    return saveResult.modelArtifactsInfo;
}
/**
 * List all models stored in registered storage mediums.
 *
 * For a web browser environment, the registered mediums are Local Storage and
 * IndexedDB.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @returns A `Promise` of a dictionary mapping URLs of existing models to
 * their model artifacts info. URLs include medium-specific schemes, e.g.,
 *   'indexeddb://my/model/1'. Model artifacts info include type of the
 * model's topology, byte sizes of the topology, weights, etc.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $e205b01ac758ef50$export$8d63af86d795ece4() {
    const schemes = $e205b01ac758ef50$export$ccf7f72dec8f0028.getSchemes();
    const out = {};
    for (const scheme of schemes){
        const schemeOut = await $e205b01ac758ef50$export$ccf7f72dec8f0028.getManager(scheme).listModels();
        for(const path in schemeOut){
            const url = scheme + $e205b01ac758ef50$var$URL_SCHEME_SUFFIX + path;
            out[url] = schemeOut[path];
        }
    }
    return out;
}
/**
 * Remove a model specified by URL from a registered storage medium.
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Delete the model.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 * ```
 *
 * @param url A URL to a stored model, with a scheme prefix, e.g.,
 *   'localstorage://my-model-1', 'indexeddb://my/model/2'.
 * @returns ModelArtifactsInfo of the deleted model (if and only if deletion
 *   is successful).
 * @throws Error if deletion fails, e.g., if no model exists at `path`.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $e205b01ac758ef50$export$e71037184d1ad0fd(url) {
    const schemeAndPath = $e205b01ac758ef50$var$parseURL(url);
    const manager = $e205b01ac758ef50$export$ccf7f72dec8f0028.getManager(schemeAndPath.scheme);
    return manager.removeModel(schemeAndPath.path);
}
/**
 * Copy a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Copying within a storage medium, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Copying between two storage mediums, e.g.,
 *    `tf.io.copyModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Copy the model, from Local Storage to IndexedDB.
 * await tf.io.copyModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove both models.
 * await tf.io.removeModel('localstorage://demo/management/model1');
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of copying.
 * @param destURL Destination URL of copying.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if copying fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $e205b01ac758ef50$export$b5971478866000ed(sourceURL, destURL) {
    const deleteSource = false;
    return $e205b01ac758ef50$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}
/**
 * Move a model from one URL to another.
 *
 * This function supports:
 *
 * 1. Moving within a storage medium, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'localstorage://model-2')`
 * 2. Moving between two storage mediums, e.g.,
 *    `tf.io.moveModel('localstorage://model-1', 'indexeddb://model-1')`
 *
 * ```js
 * // First create and save a model.
 * const model = tf.sequential();
 * model.add(tf.layers.dense(
 *     {units: 1, inputShape: [10], activation: 'sigmoid'}));
 * await model.save('localstorage://demo/management/model1');
 *
 * // Then list existing models.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Move the model, from Local Storage to IndexedDB.
 * await tf.io.moveModel(
 *     'localstorage://demo/management/model1',
 *     'indexeddb://demo/management/model1');
 *
 * // List models again.
 * console.log(JSON.stringify(await tf.io.listModels()));
 *
 * // Remove the moved model.
 * await tf.io.removeModel('indexeddb://demo/management/model1');
 * ```
 *
 * @param sourceURL Source URL of moving.
 * @param destURL Destination URL of moving.
 * @returns ModelArtifactsInfo of the copied model (if and only if copying
 *   is successful).
 * @throws Error if moving fails, e.g., if no model exists at `sourceURL`, or
 *   if `oldPath` and `newPath` are identical.
 *
 * @doc {
 *   heading: 'Models',
 *   subheading: 'Management',
 *   namespace: 'io',
 *   ignoreCI: true
 * }
 */ async function $e205b01ac758ef50$export$598f168272f4fec2(sourceURL, destURL) {
    const deleteSource = true;
    return $e205b01ac758ef50$var$cloneModelInternal(sourceURL, destURL, deleteSource);
}

});


parcelRegister("8RL6x", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $tdutJ = parcelRequire("tdutJ");

var $3O3MM = parcelRequire("3O3MM");

const $6747cff35a4be014$export$fc0623918121e18f = {
    // tslint:disable-next-line:no-require-imports
    importFetch: ()=>(parcelRequire("9XjBr"))
};
let $6747cff35a4be014$var$systemFetch;
function $6747cff35a4be014$export$ab67f817cc7ff6dc() {
    $6747cff35a4be014$var$systemFetch = null;
}
function $6747cff35a4be014$export$fec6b32271d1a551(fetchFn) {
    $6747cff35a4be014$var$systemFetch = fetchFn;
}
function $6747cff35a4be014$export$f53da9ce5ba19de0() {
    return $6747cff35a4be014$var$systemFetch;
}

class $6747cff35a4be014$export$7befb6c3de272049 {
    constructor(){
        // tslint:disable-next-line:no-require-imports
        this.util = (parcelRequire("9XjBr"));
        // According to the spec, the built-in encoder can do only UTF-8 encoding.
        // https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder/TextEncoder
        this.textEncoder = new this.util.TextEncoder();
    }
    fetch(path, requestInits) {
        if ((0, $tdutJ.env)().global.fetch != null) return (0, $tdutJ.env)().global.fetch(path, requestInits);
        if ($6747cff35a4be014$var$systemFetch == null) $6747cff35a4be014$var$systemFetch = $6747cff35a4be014$export$fc0623918121e18f.importFetch();
        return $6747cff35a4be014$var$systemFetch(path, requestInits);
    }
    now() {
        const time = $3O3MM.hrtime();
        return time[0] * 1000 + time[1] / 1000000;
    }
    encode(text, encoding) {
        if (encoding !== 'utf-8' && encoding !== 'utf8') throw new Error(`Node built-in encoder only supports utf-8, but got ${encoding}`);
        return this.textEncoder.encode(text);
    }
    decode(bytes, encoding) {
        if (bytes.length === 0) return '';
        return new this.util.TextDecoder(encoding).decode(bytes);
    }
    isTypedArray(a) {
        return this.util.types.isFloat32Array(a) || this.util.types.isInt32Array(a) || this.util.types.isUint8Array(a) || this.util.types.isUint8ClampedArray(a);
    }
}
if ((0, $tdutJ.env)().get('IS_NODE') && !(0, $tdutJ.env)().get('IS_BROWSER')) (0, $tdutJ.env)().setPlatform('node', new $6747cff35a4be014$export$7befb6c3de272049());

});

parcelRegister("5siju", function(module, exports) {

$parcel$export(module.exports, "buffer", function () { return $3f8dc5e6648c55d5$export$ab1029bcae9ddb4a; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3pVUH = parcelRequire("3pVUH");

var $eOiOM = parcelRequire("eOiOM");
function $3f8dc5e6648c55d5$export$ab1029bcae9ddb4a(shape, dtype = 'float32', values) {
    dtype = dtype || 'float32';
    $eOiOM.assertNonNegativeIntegerDimensions(shape);
    return new (0, $3pVUH.TensorBuffer)(shape, dtype, values);
}

});

parcelRegister("fxiHg", function(module, exports) {

$parcel$export(module.exports, "cast", function () { return $b4f870e18e03c176$export$f2db7d5238e1d23f; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Casts a `tf.Tensor` to a new dtype.
 *
 * ```js
 * const x = tf.tensor1d([1.5, 2.5, 3]);
 * tf.cast(x, 'int32').print();
 * ```
 * @param x The input tensor to be casted.
 * @param dtype The dtype to cast the input tensor to.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $b4f870e18e03c176$var$cast_(x, dtype) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'cast');
    // Sanity checks.
    if (!$eOiOM.isValidDtype(dtype)) throw new Error(`Failed to cast to unknown dtype ${dtype}`);
    if (dtype === 'string' && $x.dtype !== 'string' || dtype !== 'string' && $x.dtype === 'string') throw new Error('Only strings can be casted to strings');
    const inputs = {
        x: $x
    };
    const attrs = {
        dtype: dtype
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Cast), inputs, attrs);
}
const $b4f870e18e03c176$export$f2db7d5238e1d23f = /* @__PURE__ */ (0, $6afhl.op)({
    cast_: $b4f870e18e03c176$var$cast_
});

});

parcelRegister("ek4FP", function(module, exports) {

$parcel$export(module.exports, "clone", function () { return $a6d68f0a812728bd$export$9cd59f9826255e47; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Creates a new tensor with the same values and shape as the specified
 * tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 *
 * x.clone().print();
 * ```
 *
 * @param x The tensor to clone.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $a6d68f0a812728bd$var$clone_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'clone', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    // Note this op is called tf.identity in python. Hence the kernel name used
    // here.
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Identity), inputs);
}
const $a6d68f0a812728bd$export$9cd59f9826255e47 = /* @__PURE__ */ (0, $6afhl.op)({
    clone_: $a6d68f0a812728bd$var$clone_
});

});

parcelRegister("iM8Nn", function(module, exports) {

$parcel$export(module.exports, "print", function () { return $dab3884458a9b048$export$c2d084dc44961371; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Prints information about the `tf.Tensor` including its data.
 *
 * ```js
 * const verbose = true;
 * tf.tensor2d([1, 2, 3, 4], [2, 2]).print(verbose);
 * ```
 * @param x The tensor to be printed.
 * @param verbose Whether to print verbose information about the ` Tensor`,
 * including dtype and size.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $dab3884458a9b048$export$c2d084dc44961371(x, verbose = false) {
    console.log(x.toString(verbose));
}

});


parcelRegister("8WiHb", function(module, exports) {

$parcel$export(module.exports, "registerOptimizers", function () { return $68223e09464a0001$export$9a85654c75805c9a; });
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fmImY = parcelRequire("fmImY");

var $kl14K = parcelRequire("kl14K");

var $j1H1O = parcelRequire("j1H1O");

var $46rlf = parcelRequire("46rlf");

var $bK23H = parcelRequire("bK23H");

var $glgZq = parcelRequire("glgZq");

var $bQqzj = parcelRequire("bQqzj");

var $ki3lz = parcelRequire("ki3lz");
const $68223e09464a0001$var$OPTIMIZERS = [
    (0, $fmImY.AdadeltaOptimizer),
    (0, $kl14K.AdagradOptimizer),
    (0, $j1H1O.AdamOptimizer),
    (0, $46rlf.AdamaxOptimizer),
    (0, $bK23H.MomentumOptimizer),
    (0, $glgZq.RMSPropOptimizer),
    (0, $bQqzj.SGDOptimizer)
];
function $68223e09464a0001$export$9a85654c75805c9a() {
    for (const optimizer of $68223e09464a0001$var$OPTIMIZERS)(0, $ki3lz.registerClass)(optimizer);
}

});
parcelRegister("fmImY", function(module, exports) {

$parcel$export(module.exports, "AdadeltaOptimizer", function () { return $b2fb53f62283b357$export$d80a766c536c9aaf; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $6Ab5n = parcelRequire("6Ab5n");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $cztsD = parcelRequire("cztsD");

var $2jiJm = parcelRequire("2jiJm");
class $b2fb53f62283b357$export$d80a766c536c9aaf extends (0, $2jiJm.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adadelta';
    }
    constructor(learningRate, rho, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.rho = rho;
        this.epsilon = epsilon;
        this.accumulatedGrads = [];
        this.accumulatedUpdates = [];
        if (epsilon == null) this.epsilon = (0, $e6Ey6.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $e6Ey6.ENGINE).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedGrads[i] == null) this.accumulatedGrads[i] = {
                originalName: `${name}/accum_grad`,
                variable: (0, $d7Nxs.tidy)(()=>(0, $cztsD.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedUpdates[i] == null) this.accumulatedUpdates[i] = {
                originalName: `${name}/accum_var`,
                variable: (0, $d7Nxs.tidy)(()=>(0, $cztsD.zerosLike)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            const accumulatedUpdate = this.accumulatedUpdates[i].variable;
            (0, $d7Nxs.tidy)(()=>{
                const newAccumulatedGrad = (0, $6Ab5n.add)((0, $5hAos.mul)(accumulatedGrad, this.rho), (0, $5hAos.mul)((0, $5MB84.square)(gradient), 1 - this.rho));
                const updates = (0, $5hAos.mul)((0, $dIChU.div)((0, $g3lev.sqrt)((0, $6Ab5n.add)(accumulatedUpdate, this.epsilon)), (0, $g3lev.sqrt)((0, $6Ab5n.add)(accumulatedGrad, this.epsilon))), gradient);
                const newAccumulatedUpdate = (0, $6Ab5n.add)((0, $5hAos.mul)(accumulatedUpdate, this.rho), (0, $5hAos.mul)((0, $5MB84.square)(updates), 1 - this.rho));
                accumulatedGrad.assign(newAccumulatedGrad);
                accumulatedUpdate.assign(newAccumulatedUpdate);
                const newValue = (0, $6Ab5n.add)((0, $5hAos.mul)(updates, -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedUpdates != null) {
            (0, $d7Nxs.dispose)(this.accumulatedGrads.map((v)=>v.variable));
            (0, $d7Nxs.dispose)(this.accumulatedUpdates.map((v)=>v.variable));
        }
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedGrads,
            ...this.accumulatedUpdates
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedGrads = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedUpdates = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'rho': this.rho,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['rho'], config['epsilon']);
    }
}

});
parcelRegister("6Ab5n", function(module, exports) {

$parcel$export(module.exports, "add", function () { return $4caeb43d4fee63ee$export$e16d8520af44a096; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Adds two `tf.Tensor`s element-wise, A + B. Supports broadcasting.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 *
 * ```js
 * // Broadcast add a with b.
 * const a = tf.scalar(5);
 * const b = tf.tensor1d([10, 20, 30, 40]);
 *
 * a.add(b).print();  // or tf.add(a, b)
 * ```
 * @param a The first `tf.Tensor` to add.
 * @param b The second `tf.Tensor` to add. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $4caeb43d4fee63ee$var$add_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'add');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'add');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Add), inputs);
}
const $4caeb43d4fee63ee$export$e16d8520af44a096 = /* @__PURE__ */ (0, $6afhl.op)({
    add_: $4caeb43d4fee63ee$var$add_
});

});

parcelRegister("dIChU", function(module, exports) {

$parcel$export(module.exports, "div", function () { return $9fcd1593e6f65b3b$export$159d9494db57879b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $es4Jq = parcelRequire("es4Jq");

var $6afhl = parcelRequire("6afhl");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.div(b).print();  // or tf.div(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $9fcd1593e6f65b3b$var$div_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'div');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'div');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    if ($a.dtype === 'int32' && $b.dtype === 'int32') return (0, $es4Jq.floorDiv)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.RealDiv), inputs, attrs);
}
const $9fcd1593e6f65b3b$export$159d9494db57879b = /* @__PURE__ */ (0, $6afhl.op)({
    div_: $9fcd1593e6f65b3b$var$div_
});

});
parcelRegister("es4Jq", function(module, exports) {

$parcel$export(module.exports, "floorDiv", function () { return $a85759ce833bf25a$export$112397bc52715a8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting.
 * The result is rounded with floor function.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.floorDiv(b).print();  // or tf.div(a, b)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 *
 * a.floorDiv(b).print();  // or tf.floorDiv(a, b)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $a85759ce833bf25a$var$floorDiv_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'floorDiv');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'floorDiv');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FloorDiv), inputs);
}
const $a85759ce833bf25a$export$112397bc52715a8 = /* @__PURE__ */ (0, $6afhl.op)({
    floorDiv_: $a85759ce833bf25a$var$floorDiv_
});

});


parcelRegister("5hAos", function(module, exports) {

$parcel$export(module.exports, "mul", function () { return $3d8ac53e9f63a5e7$export$6e3a27864ab166fe; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Multiplies two `tf.Tensor`s element-wise, A * B. Supports broadcasting.
 *
 * We also expose `tf.mulStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.tensor1d([2, 3, 4, 5]);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 *
 * ```js
 * // Broadcast mul a with b.
 * const a = tf.tensor1d([1, 2, 3, 4]);
 * const b = tf.scalar(5);
 *
 * a.mul(b).print();  // or tf.mul(a, b)
 * ```
 * @param a The first tensor to multiply.
 * @param b The second tensor to multiply. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $3d8ac53e9f63a5e7$var$mul_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'mul');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'mul');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Multiply), inputs);
}
const $3d8ac53e9f63a5e7$export$6e3a27864ab166fe = /* @__PURE__ */ (0, $6afhl.op)({
    mul_: $3d8ac53e9f63a5e7$var$mul_
});

});

parcelRegister("g3lev", function(module, exports) {

$parcel$export(module.exports, "sqrt", function () { return $bafd659841022eb0$export$eba8049fb5020b81; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes square root of the input `tf.Tensor` element-wise: `y = sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.sqrt().print();  // or tf.sqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $bafd659841022eb0$var$sqrt_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'sqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Sqrt), inputs);
}
const $bafd659841022eb0$export$eba8049fb5020b81 = /* @__PURE__ */ (0, $6afhl.op)({
    sqrt_: $bafd659841022eb0$var$sqrt_
});

});

parcelRegister("5MB84", function(module, exports) {

$parcel$export(module.exports, "square", function () { return $435e3c81dcc8a90b$export$dd4f28cef696bc7d; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes square of `x` element-wise: `x ^ 2`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.sqrt(2), -1]);
 *
 * x.square().print();  // or tf.square(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $435e3c81dcc8a90b$var$square_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'square');
    const attrs = {};
    return (0, $e6Ey6.ENGINE).runKernel('Square', {
        x: $x
    }, attrs);
}
const $435e3c81dcc8a90b$export$dd4f28cef696bc7d = /* @__PURE__ */ (0, $6afhl.op)({
    square_: $435e3c81dcc8a90b$var$square_
});

});

parcelRegister("cztsD", function(module, exports) {

$parcel$export(module.exports, "zerosLike", function () { return $926f9b3e91d14bd9$export$cb1f824e7733584d; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Creates a `tf.Tensor` with all elements set to 0 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.zerosLike(x).print();
 * ```
 *
 * @param x The tensor of required shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $926f9b3e91d14bd9$var$zerosLike_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'zerosLike');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ZerosLike), inputs);
}
const $926f9b3e91d14bd9$export$cb1f824e7733584d = /* @__PURE__ */ (0, $6afhl.op)({
    zerosLike_: $926f9b3e91d14bd9$var$zerosLike_
});

});

parcelRegister("2jiJm", function(module, exports) {

$parcel$export(module.exports, "Optimizer", function () { return $1aebe29ff65a9801$export$69ae9293516e70f0; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $d7Nxs = parcelRequire("d7Nxs");

var $1Npyr = parcelRequire("1Npyr");

var $7hONX = parcelRequire("7hONX");

var $ki3lz = parcelRequire("ki3lz");
class $1aebe29ff65a9801$export$69ae9293516e70f0 extends (0, $ki3lz.Serializable) {
    /**
     * Executes `f()` and minimizes the scalar output of `f()` by computing
     * gradients of y with respect to the list of trainable variables provided by
     * `varList`. If no list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to minimize.
     * @param returnCost Whether to return the scalar cost value produced by
     * executing `f()`.
     * @param varList An optional list of variables to update. If specified, only
     * the trainable variables in varList will be updated by minimize. Defaults to
     * all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ minimize(f, returnCost = false, varList) {
        const { value: value, grads: grads } = this.computeGradients(f, varList);
        if (varList != null) {
            const gradArray = varList.map((v)=>({
                    name: v.name,
                    tensor: grads[v.name]
                }));
            this.applyGradients(gradArray);
        } else this.applyGradients(grads);
        // Dispose gradients.
        (0, $d7Nxs.dispose)(grads);
        if (returnCost) return value;
        else {
            value.dispose();
            return null;
        }
    }
    /**
     * The number of iterations that this optimizer instance has been invoked for.
     */ get iterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return this.iterations_;
    }
    incrementIterations() {
        this.iterations_ = this.iterations + 1;
    }
    /**
     * Executes f() and computes the gradient of the scalar output of f() with
     * respect to the list of trainable variables provided by `varList`. If no
     * list is provided, it defaults to all trainable variables.
     *
     * @param f The function to execute and whose output to use for computing
     * gradients with respect to variables.
     * @param varList An optional list of variables to compute gradients with
     * respect to. If specified, only the trainable variables in varList will have
     * gradients computed with respect to. Defaults to all trainable variables.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers'}
     */ computeGradients(f, varList) {
        return (0, $1Npyr.variableGrads)(f, varList);
    }
    /**
     * Dispose the variables (if any) owned by this optimizer instance.
     */ dispose() {
        if (this.iterations_ != null) (0, $d7Nxs.dispose)(this.iterations_);
    }
    async saveIterations() {
        if (this.iterations_ == null) this.iterations_ = 0;
        return {
            name: 'iter',
            // TODO(cais): Use 'int64' type when available.
            tensor: (0, $7hONX.scalar)(this.iterations_, 'int32')
        };
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for this optimizer yet.');
    }
    async setWeights(weightValues) {
        throw new Error(`setWeights() is not implemented for this optimizer class ` + `${this.getClassName()}`);
    }
    /**
     * Extract the first element of the weight values and set it
     * as the iterations counter variable of this instance of optimizer.
     *
     * @param weightValues
     * @returns Weight values with the first element consumed and excluded.
     */ async extractIterations(weightValues) {
        this.iterations_ = (await weightValues[0].tensor.data())[0];
        return weightValues.slice(1);
    }
}
Object.defineProperty($1aebe29ff65a9801$export$69ae9293516e70f0, Symbol.hasInstance, {
    value: (instance)=>{
        return instance.minimize != null && instance.computeGradients != null && instance.applyGradients != null;
    }
});

});
parcelRegister("1Npyr", function(module, exports) {

$parcel$export(module.exports, "variableGrads", function () { return $14ee309f59168690$export$c756d9ed08b9677f; });
$parcel$export(module.exports, "customGrad", function () { return $14ee309f59168690$export$5519f0eeb00c44e5; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $3pVUH = parcelRequire("3pVUH");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");
/**
 * Provided `f(x)`, returns another function `g(x, dy?)`, which gives the
 * gradient of `f(x)` with respect to `x`.
 *
 * If `dy` is provided, the gradient of `f(x).mul(dy).sum()` with respect to
 * `x` is computed instead. `f(x)` must take a single tensor `x` and return a
 * single tensor `y`. If `f()` takes multiple inputs, use `tf.grads` instead.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.grad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * g(x).print();
 * ```
 *
 * ```js
 * // f(x) = x ^ 3
 * const f = x => x.pow(tf.scalar(3, 'int32'));
 * // f'(x) = 3x ^ 2
 * const g = tf.grad(f);
 * // f''(x) = 6x
 * const gg = tf.grad(g);
 *
 * const x = tf.tensor1d([2, 3]);
 * gg(x).print();
 * ```
 *
 * @param f The function f(x), to compute gradient for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $14ee309f59168690$export$c24429b22bb73814(f) {
    $eOiOM.assert($eOiOM.isFunction(f), ()=>'The f passed in grad(f) must be a function');
    return (x, dy)=>{
        // x can be of any dtype, thus null as the last argument.
        const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'tf.grad', 'string_or_numeric');
        const $dy = dy != null ? (0, $x4eLk.convertToTensor)(dy, 'dy', 'tf.grad') : null;
        return (0, $e6Ey6.ENGINE).tidy(()=>{
            const { value: value, grads: grads } = (0, $e6Ey6.ENGINE).gradients(()=>f($x), [
                $x
            ], $dy);
            if ($dy != null) $eOiOM.assertShapesMatch(value.shape, $dy.shape, "The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)");
            $14ee309f59168690$var$checkGrads(grads);
            return grads[0];
        });
    };
}
/**
 * Provided `f(x1, x2,...)`, returns another function `g([x1, x2,...], dy?)`,
 * which gives an array of gradients of `f()` with respect to each input
 * [`x1`,`x2`,...].
 *
 * If `dy` is passed when calling `g()`, the gradient of
 * `f(x1,...).mul(dy).sum()` with respect to each input is computed instead.
 * The provided `f` must take one or more tensors and return a single tensor
 * `y`. If `f()` takes a single input, we recommend using `tf.grad` instead.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df / da = b, df / db = a
 * const g = tf.grads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const [da, db] = g([a, b]);
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @param f The function `f(x1, x2,...)` to compute gradients for.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $14ee309f59168690$export$3f3749f5340c73f2(f) {
    $eOiOM.assert($eOiOM.isFunction(f), ()=>'The f passed in grads(f) must be a function');
    return (args, dy)=>{
        $eOiOM.assert(Array.isArray(args), ()=>"The args passed in grads(f)(args) must be an array of `Tensor`s or `TensorLike`s");
        // args can be of any dtype, thus null as the last argument.
        const $args = (0, $x4eLk.convertToTensorArray)(args, 'args', 'tf.grads', 'string_or_numeric');
        const $dy = dy != null ? (0, $x4eLk.convertToTensor)(dy, 'dy', 'tf.grads') : null;
        return (0, $e6Ey6.ENGINE).tidy(()=>{
            const { value: value, grads: grads } = (0, $e6Ey6.ENGINE).gradients(()=>f(...$args), $args, $dy);
            if ($dy != null) $eOiOM.assertShapesMatch(value.shape, $dy.shape, "The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
            $14ee309f59168690$var$checkGrads(grads);
            return grads;
        });
    };
}
/**
 * Like `tf.grad`, but also returns the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grad: The gradient of `f(x)` w.r.t. `x` (result of `tf.grad`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(x) = x ^ 2
 * const f = x => x.square();
 * // f'(x) = 2x
 * const g = tf.valueAndGrad(f);
 *
 * const x = tf.tensor1d([2, 3]);
 * const {value, grad} = g(x);
 *
 * console.log('value');
 * value.print();
 * console.log('grad');
 * grad.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $14ee309f59168690$export$9fbe39d4dcb3921e(f) {
    $eOiOM.assert($eOiOM.isFunction(f), ()=>'The f passed in valueAndGrad(f) must be a function');
    return (x, dy)=>{
        $eOiOM.assert(x instanceof (0, $3pVUH.Tensor), ()=>'The x passed in valueAndGrad(f)(x) must be a tensor');
        $eOiOM.assert(dy == null || dy instanceof (0, $3pVUH.Tensor), ()=>'The dy passed in valueAndGrad(f)(x, dy) must be a tensor');
        const { grads: grads, value: value } = (0, $e6Ey6.ENGINE).gradients(()=>f(x), [
            x
        ], dy);
        $14ee309f59168690$var$checkGrads(grads);
        return {
            grad: grads[0],
            value: value
        };
    };
}
/**
 * Like `tf.grads`, but returns also the value of `f()`. Useful when `f()`
 * returns a metric you want to show.
 *
 * The result is a rich object with the following properties:
 * - grads: The gradients of `f()` w.r.t. each input (result of `tf.grads`).
 * - value: The value returned by `f(x)`.
 *
 * ```js
 * // f(a, b) = a * b
 * const f = (a, b) => a.mul(b);
 * // df/da = b, df/db = a
 * const g = tf.valueAndGrads(f);
 *
 * const a = tf.tensor1d([2, 3]);
 * const b = tf.tensor1d([-2, -3]);
 * const {value, grads} = g([a, b]);
 *
 * const [da, db] = grads;
 *
 * console.log('value');
 * value.print();
 *
 * console.log('da');
 * da.print();
 * console.log('db');
 * db.print();
 * ```
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $14ee309f59168690$export$c03281a254ef3cf0(f) {
    $eOiOM.assert($eOiOM.isFunction(f), ()=>'The f passed in valueAndGrads(f) must be a function');
    return (args, dy)=>{
        $eOiOM.assert(Array.isArray(args) && args.every((arg)=>arg instanceof (0, $3pVUH.Tensor)), ()=>"The args passed in valueAndGrads(f)(args) must be array of tensors");
        $eOiOM.assert(dy == null || dy instanceof (0, $3pVUH.Tensor), ()=>'The dy passed in valueAndGrads(f)(args, dy) must be a tensor');
        const res = (0, $e6Ey6.ENGINE).gradients(()=>f(...args), args, dy);
        if (dy != null) $eOiOM.assertShapesMatch(res.value.shape, dy.shape, "The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])");
        $14ee309f59168690$var$checkGrads(res.grads);
        return res;
    };
}
/**
 * Computes and returns the gradient of f(x) with respect to the list of
 * trainable variables provided by `varList`. If no list is provided, it
 * defaults to all trainable variables.
 *
 * ```js
 * const a = tf.variable(tf.tensor1d([3, 4]));
 * const b = tf.variable(tf.tensor1d([5, 6]));
 * const x = tf.tensor1d([1, 2]);
 *
 * // f(a, b) = a * x ^ 2 + b * x
 * const f = () => a.mul(x.square()).add(b.mul(x)).sum();
 * // df/da = x ^ 2, df/db = x
 * const {value, grads} = tf.variableGrads(f);
 *
 * Object.keys(grads).forEach(varName => grads[varName].print());
 * ```
 *
 * @param f The function to execute. f() should return a scalar.
 * @param varList The list of variables to compute the gradients with respect
 *     to. Defaults to all trainable variables.
 * @returns An object with the following keys and values:
 *   - `value`: The value of the function `f`.
 *   - `grads`: A map from the names of the variables to the gradients.
 *     If the `varList` argument is provided explicitly and contains a subset of
 *     non-trainable variables, this map in the return value will contain keys
 *     that map the names of the non-trainable variables to `null`.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $14ee309f59168690$export$c756d9ed08b9677f(f, varList) {
    $eOiOM.assert($eOiOM.isFunction(f), ()=>'The f passed in variableGrads(f) must be a function');
    $eOiOM.assert(varList == null || Array.isArray(varList) && varList.every((v)=>v instanceof (0, $3pVUH.Variable)), ()=>"The varList passed in variableGrads(f, varList) must be an array of variables");
    const specifiedVarList = varList != null;
    if (!specifiedVarList) {
        // Get all of the trainable variables.
        varList = [];
        for(const varName in (0, $e6Ey6.ENGINE).registeredVariables)varList.push((0, $e6Ey6.ENGINE).registeredVariables[varName]);
    }
    const specifiedNonTrainable = specifiedVarList ? varList.filter((variable)=>!variable.trainable) : null;
    // Prune non-trainable variables.
    const originalVarCount = varList.length;
    varList = varList.filter((variable)=>variable.trainable);
    $eOiOM.assert(varList.length > 0, ()=>`variableGrads() expects at least one of the input variables to ` + `be trainable, but none of the ${originalVarCount} variables is ` + `trainable.`);
    const allowNoGradients = true;
    const { value: value, grads: grads } = (0, $e6Ey6.ENGINE).gradients(f, varList, null, allowNoGradients);
    $eOiOM.assert(grads.some((g)=>g != null), ()=>"Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize().");
    $eOiOM.assert(value.rank === 0, ()=>`The f passed in variableGrads(f) must return a scalar, but it ` + `returned a rank-${value.rank} tensor`);
    const namedGrads = {};
    varList.forEach((v, i)=>{
        if (grads[i] != null) namedGrads[v.name] = grads[i];
    });
    if (specifiedNonTrainable != null) // If varList is explicitly provided and contains non-trainable values,
    // add them to the returned gradients with `null` values.
    specifiedNonTrainable.forEach((v)=>namedGrads[v.name] = null);
    return {
        value: value,
        grads: namedGrads
    };
}
/**
 * Overrides the gradient computation of a function `f`.
 *
 * Takes a function
 * `f(...inputs, save) => {value: Tensor, gradFunc: (dy, saved) => Tensor[]}`
 * and returns another function `g(...inputs)` which takes the same inputs as
 * `f`. When called, `g` returns `f().value`. In backward mode, custom gradients
 * with respect to each input of `f` are computed using `f().gradFunc`.
 *
 * The `save` function passed to `f` should be used for saving tensors needed
 * in the gradient. And the `saved` passed to the `gradFunc` is a
 * `NamedTensorMap`, which contains those saved tensors.
 *
 * ```js
 * const customOp = tf.customGrad((x, save) => {
 *   // Save x to make sure it's available later for the gradient.
 *   save([x]);
 *   // Override gradient of our custom x ^ 2 op to be dy * abs(x);
 *   return {
 *     value: x.square(),
 *     // Note `saved.x` which points to the `x` we saved earlier.
 *     gradFunc: (dy, saved) => [dy.mul(saved[0].abs())]
 *   };
 * });
 *
 * const x = tf.tensor1d([-1, -2, 3]);
 * const dx = tf.grad(x => customOp(x));
 *
 * console.log(`f(x):`);
 * customOp(x).print();
 * console.log(`f'(x):`);
 * dx(x).print();
 * ```
 *
 * @param f The function to evaluate in forward mode, which should return
 *     `{value: Tensor, gradFunc: (dy, saved) => Tensor[]}`, where `gradFunc`
 *     returns the custom gradients of `f` with respect to its inputs.
 *
 * @doc {heading: 'Training', subheading: 'Gradients'}
 */ function $14ee309f59168690$export$5519f0eeb00c44e5(f) {
    return (0, $e6Ey6.ENGINE).customGrad(f);
}
function $14ee309f59168690$var$checkGrads(grads) {
    const numNullGradients = grads.filter((g)=>g == null).length;
    if (numNullGradients > 0) throw new Error(`Cannot compute gradient of y=f(x) with respect to x. Make sure that
    the f you passed encloses all operations that lead from x to y.`);
}

});

parcelRegister("7hONX", function(module, exports) {

$parcel$export(module.exports, "scalar", function () { return $54e187b73bf3d64f$export$7de3fcd3cdba2a46; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lBDHD = parcelRequire("lBDHD");

var $cxc40 = parcelRequire("cxc40");
function $54e187b73bf3d64f$export$7de3fcd3cdba2a46(value, dtype) {
    if (((0, $lBDHD.isTypedArray)(value) && dtype !== 'string' || Array.isArray(value)) && dtype !== 'complex64') throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
    if (dtype === 'string' && (0, $lBDHD.isTypedArray)(value) && !(value instanceof Uint8Array)) throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
    const shape = [];
    const inferredShape = [];
    return (0, $cxc40.makeTensor)(value, shape, inferredShape, dtype);
}

});

parcelRegister("ki3lz", function(module, exports) {

$parcel$export(module.exports, "Serializable", function () { return $ec5815bc24909660$export$64782a6a7800f48c; });
$parcel$export(module.exports, "SerializationMap", function () { return $ec5815bc24909660$export$3a868b20f0f2f6c0; });
$parcel$export(module.exports, "registerClass", function () { return $ec5815bc24909660$export$a3f7d716dc76cb2e; });
$parcel$export(module.exports, "getRegisteredName", function () { return $ec5815bc24909660$export$33f51542dd5bdf78; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
/**
 * Maps to mapping between the custom object and its name.
 *
 * After registering a custom class, these two maps will add key-value pairs
 * for the class object and the registered name.
 *
 * Therefore we can get the relative registered name by calling
 * getRegisteredName() function.
 *
 * For example:
 * GLOBAL_CUSTOM_OBJECT: {key=registeredName: value=corresponding
 * CustomObjectClass}
 *
 * GLOBAL_CUSTOM_NAMES: {key=CustomObjectClass: value=corresponding
 * registeredName}
 *
 */ const $ec5815bc24909660$var$GLOBAL_CUSTOM_OBJECT = new Map();
const $ec5815bc24909660$var$GLOBAL_CUSTOM_NAMES = new Map();
class $ec5815bc24909660$export$64782a6a7800f48c {
    /**
     * Return the class name for this class to use in serialization contexts.
     *
     * Generally speaking this will be the same thing that constructor.name
     * would have returned.  However, the class name needs to be robust
     * against minification for serialization/deserialization to work properly.
     *
     * There's also places such as initializers.VarianceScaling, where
     * implementation details between different languages led to different
     * class hierarchies and a non-leaf node is used for serialization purposes.
     */ getClassName() {
        return this.constructor.className;
    }
    /**
     * Creates an instance of T from a ConfigDict.
     *
     * This works for most descendants of serializable.  A few need to
     * provide special handling.
     * @param cls A Constructor for the class to instantiate.
     * @param config The Configuration for the object.
     */ /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
class $ec5815bc24909660$export$3a868b20f0f2f6c0 {
    constructor(){
        this.classNameMap = {};
    }
    /**
     * Returns the singleton instance of the map.
     */ static getMap() {
        if ($ec5815bc24909660$export$3a868b20f0f2f6c0.instance == null) $ec5815bc24909660$export$3a868b20f0f2f6c0.instance = new $ec5815bc24909660$export$3a868b20f0f2f6c0();
        return $ec5815bc24909660$export$3a868b20f0f2f6c0.instance;
    }
    /**
     * Registers the class as serializable.
     */ static register(cls) {
        $ec5815bc24909660$export$3a868b20f0f2f6c0.getMap().classNameMap[cls.className] = [
            cls,
            cls.fromConfig
        ];
    }
}
function $ec5815bc24909660$export$a3f7d716dc76cb2e(cls, pkg, name) {
    (0, $eOiOM.assert)(cls.className != null, ()=>`Class being registered does not have the static className ` + `property defined.`);
    (0, $eOiOM.assert)(typeof cls.className === 'string', ()=>`className is required to be a string, but got type ` + typeof cls.className);
    (0, $eOiOM.assert)(cls.className.length > 0, ()=>`Class being registered has an empty-string as its className, ` + `which is disallowed.`);
    if (typeof pkg === 'undefined') pkg = 'Custom';
    if (typeof name === 'undefined') name = cls.className;
    const className = name;
    const registerName = pkg + '>' + className;
    $ec5815bc24909660$export$3a868b20f0f2f6c0.register(cls);
    $ec5815bc24909660$var$GLOBAL_CUSTOM_OBJECT.set(registerName, cls);
    $ec5815bc24909660$var$GLOBAL_CUSTOM_NAMES.set(cls, registerName);
    return cls;
}
function $ec5815bc24909660$export$33f51542dd5bdf78(cls) {
    if ($ec5815bc24909660$var$GLOBAL_CUSTOM_NAMES.has(cls)) return $ec5815bc24909660$var$GLOBAL_CUSTOM_NAMES.get(cls);
    else return cls.className;
}

});



parcelRegister("kl14K", function(module, exports) {

$parcel$export(module.exports, "AdagradOptimizer", function () { return $ece69a618a0d4476$export$fa35e48f6f1caa57; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $6Ab5n = parcelRequire("6Ab5n");

var $dIChU = parcelRequire("dIChU");

var $2d2dF = parcelRequire("2d2dF");

var $5hAos = parcelRequire("5hAos");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $2jiJm = parcelRequire("2jiJm");
class $ece69a618a0d4476$export$fa35e48f6f1caa57 extends (0, $2jiJm.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adagrad';
    }
    constructor(learningRate, initialAccumulatorValue = 0.1){
        super();
        this.learningRate = learningRate;
        this.initialAccumulatorValue = initialAccumulatorValue;
        this.accumulatedGrads = [];
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $e6Ey6.ENGINE).registeredVariables[name];
            if (this.accumulatedGrads[i] == null) {
                const trainable = false;
                this.accumulatedGrads[i] = {
                    originalName: `${name}/accumulator`,
                    variable: (0, $d7Nxs.tidy)(()=>(0, $2d2dF.fill)(value.shape, this.initialAccumulatorValue).variable(trainable))
                };
            }
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedGrad = this.accumulatedGrads[i].variable;
            (0, $d7Nxs.tidy)(()=>{
                const newAccumulatedGrad = (0, $6Ab5n.add)(accumulatedGrad, (0, $5MB84.square)(gradient));
                accumulatedGrad.assign(newAccumulatedGrad);
                const newValue = (0, $6Ab5n.add)((0, $5hAos.mul)((0, $dIChU.div)(gradient, (0, $g3lev.sqrt)((0, $6Ab5n.add)(newAccumulatedGrad, (0, $e6Ey6.ENGINE).backend.epsilon()))), -this.learningRate), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedGrads != null) (0, $d7Nxs.dispose)(this.accumulatedGrads.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulatedGrads.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulatedGrads = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'initialAccumulatorValue': this.initialAccumulatorValue
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['initialAccumulatorValue']);
    }
}

});
parcelRegister("2d2dF", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $19be8467ce217725$export$9563e054e6f787fb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $eOiOM = parcelRequire("eOiOM");
/**
 * Creates a `tf.Tensor` filled with a scalar value.
 *
 * ```js
 * tf.fill([2, 2], 4).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param value The scalar value to fill the tensor with.
 * @param dtype The type of an element in the resulting tensor. Defaults to
 *     'float32' if the given param value is a number, otherwise 'string'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $19be8467ce217725$export$9563e054e6f787fb(shape, value, dtype) {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    dtype = dtype || (0, $eOiOM.inferDtype)(value);
    const attrs = {
        shape: shape,
        value: value,
        dtype: dtype
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Fill), {}, attrs);
}

});


parcelRegister("j1H1O", function(module, exports) {

$parcel$export(module.exports, "AdamOptimizer", function () { return $dd9f7ccd95ac370a$export$de1938eb5fee8ee2; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $6Ab5n = parcelRequire("6Ab5n");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $eCViQ = parcelRequire("eCViQ");

var $7hONX = parcelRequire("7hONX");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");

var $cztsD = parcelRequire("cztsD");

var $2jiJm = parcelRequire("2jiJm");
class $dd9f7ccd95ac370a$export$de1938eb5fee8ee2 extends (0, $2jiJm.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adam';
    }
    constructor(learningRate, beta1, beta2, epsilon = null){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.accumulatedFirstMoment = [];
        this.accumulatedSecondMoment = [];
        (0, $d7Nxs.tidy)(()=>{
            // accB* will be updated by batch.
            this.accBeta1 = (0, $7hONX.scalar)(beta1).variable();
            this.accBeta2 = (0, $7hONX.scalar)(beta2).variable();
        });
        if (epsilon == null) this.epsilon = (0, $e6Ey6.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        (0, $d7Nxs.tidy)(()=>{
            const oneMinusAccBeta1 = (0, $5jGN9.sub)(1, this.accBeta1);
            const oneMinusAccBeta2 = (0, $5jGN9.sub)(1, this.accBeta2);
            varNames.forEach((name, i)=>{
                const value = (0, $e6Ey6.ENGINE).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $d7Nxs.tidy)(()=>(0, $cztsD.zerosLike)(value).variable(trainable))
                };
                if (this.accumulatedSecondMoment[i] == null) this.accumulatedSecondMoment[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $d7Nxs.tidy)(()=>(0, $cztsD.zerosLike)(value).variable(trainable))
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const secondMoment = this.accumulatedSecondMoment[i].variable;
                const newFirstMoment = (0, $6Ab5n.add)((0, $5hAos.mul)(firstMoment, this.beta1), (0, $5hAos.mul)(gradient, 1 - this.beta1));
                const newSecondMoment = (0, $6Ab5n.add)((0, $5hAos.mul)(secondMoment, this.beta2), (0, $5hAos.mul)((0, $5MB84.square)(gradient), 1 - this.beta2));
                const biasCorrectedFirstMoment = (0, $dIChU.div)(newFirstMoment, oneMinusAccBeta1);
                const biasCorrectedSecondMoment = (0, $dIChU.div)(newSecondMoment, oneMinusAccBeta2);
                firstMoment.assign(newFirstMoment);
                secondMoment.assign(newSecondMoment);
                const newValue = (0, $6Ab5n.add)((0, $5hAos.mul)((0, $dIChU.div)(biasCorrectedFirstMoment, (0, $6Ab5n.add)((0, $g3lev.sqrt)(biasCorrectedSecondMoment), this.epsilon)), -this.learningRate), value);
                value.assign(newValue);
            });
            this.accBeta1.assign((0, $5hAos.mul)(this.accBeta1, this.beta1));
            this.accBeta2.assign((0, $5hAos.mul)(this.accBeta2, this.beta2));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.accBeta2.dispose();
        if (this.accumulatedFirstMoment != null) (0, $d7Nxs.dispose)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedSecondMoment != null) (0, $d7Nxs.dispose)(this.accumulatedSecondMoment.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedFirstMoment,
            ...this.accumulatedSecondMoment
        ];
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        (0, $d7Nxs.tidy)(()=>{
            this.accBeta1.assign((0, $eCViQ.pow)(this.beta1, this.iterations_ + 1));
            this.accBeta2.assign((0, $eCViQ.pow)(this.beta2, this.iterations_ + 1));
        });
        const variableCount = weightValues.length / 2;
        const trainable = false;
        this.accumulatedFirstMoment = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedSecondMoment = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon']);
    }
}

});
parcelRegister("eCViQ", function(module, exports) {

$parcel$export(module.exports, "pow", function () { return $aa61107ae158e199$export$9c297f60e22e3389; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the power of one `tf.Tensor` to another. Supports broadcasting.
 *
 * Given a `tf.Tensor` x and a `tf.Tensor` y, this operation computes x^y for
 * corresponding elements in x and y. The result's dtype will be the upcasted
 * type of the `base` and `exp` dtypes.
 *
 * ```js
 * const a = tf.tensor([[2, 3], [4, 5]])
 * const b = tf.tensor([[1, 2], [3, 0]]).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 *
 * ```js
 * const a = tf.tensor([[1, 2], [3, 4]])
 * const b = tf.tensor(2).toInt();
 *
 * a.pow(b).print();  // or tf.pow(a, b)
 * ```
 * We also expose `powStrict` which has the same signature as this op and
 * asserts that `base` and `exp` are the same shape (does not broadcast).
 *
 * @param base The base `tf.Tensor` to pow element-wise.
 * @param exp The exponent `tf.Tensor` to pow element-wise.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $aa61107ae158e199$var$pow_(base, exp) {
    let $base = (0, $x4eLk.convertToTensor)(base, 'base', 'pow');
    let $exp = (0, $x4eLk.convertToTensor)(exp, 'exp', 'pow');
    [$base, $exp] = (0, $gpWQN.makeTypesMatch)($base, $exp);
    const inputs = {
        a: $base,
        b: $exp
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Pow), inputs);
}
const $aa61107ae158e199$export$9c297f60e22e3389 = /* @__PURE__ */ (0, $6afhl.op)({
    pow_: $aa61107ae158e199$var$pow_
});

});

parcelRegister("5jGN9", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $3defeba211695d01$export$f93b5905241a7cca; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Subtracts two `tf.Tensor`s element-wise, A - B. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 *
 * ```js
 * // Broadcast subtract a with b.
 * const a = tf.tensor1d([10, 20, 30, 40]);
 * const b = tf.scalar(5);
 *
 * a.sub(b).print();  // or tf.sub(a, b)
 * ```
 * @param a The first `tf.Tensor` to subtract from.
 * @param b The second `tf.Tensor` to be subtracted. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $3defeba211695d01$var$sub_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'sub');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'sub');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Sub), inputs);
}
const $3defeba211695d01$export$f93b5905241a7cca = /* @__PURE__ */ (0, $6afhl.op)({
    sub_: $3defeba211695d01$var$sub_
});

});


parcelRegister("46rlf", function(module, exports) {

$parcel$export(module.exports, "AdamaxOptimizer", function () { return $2fccee6ffa46ab0a$export$69957d0bff775eb6; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $57D4R = parcelRequire("57D4R");

var $6Ab5n = parcelRequire("6Ab5n");

var $dIChU = parcelRequire("dIChU");

var $jRQ3p = parcelRequire("jRQ3p");

var $5hAos = parcelRequire("5hAos");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");

var $cztsD = parcelRequire("cztsD");

var $2jiJm = parcelRequire("2jiJm");
class $2fccee6ffa46ab0a$export$69957d0bff775eb6 extends (0, $2jiJm.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Adamax';
    }
    constructor(learningRate, beta1, beta2, epsilon = null, decay = 0.0){
        super();
        this.learningRate = learningRate;
        this.beta1 = beta1;
        this.beta2 = beta2;
        this.epsilon = epsilon;
        this.decay = decay;
        this.accumulatedFirstMoment = [];
        this.accumulatedWeightedInfNorm = [];
        (0, $d7Nxs.tidy)(()=>{
            this.iteration = (0, $7hONX.scalar)(0).variable();
            this.accBeta1 = (0, $7hONX.scalar)(beta1).variable();
        });
        if (epsilon == null) this.epsilon = (0, $e6Ey6.ENGINE).backend.epsilon();
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        (0, $d7Nxs.tidy)(()=>{
            const oneMinusAccBeta1 = (0, $5jGN9.sub)(1, this.accBeta1);
            const lr = (0, $dIChU.div)(-this.learningRate, (0, $6Ab5n.add)((0, $5hAos.mul)(this.iteration, this.decay), 1));
            variableNames.forEach((name, i)=>{
                const value = (0, $e6Ey6.ENGINE).registeredVariables[name];
                const trainable = false;
                if (this.accumulatedFirstMoment[i] == null) this.accumulatedFirstMoment[i] = {
                    originalName: `${name}/m`,
                    variable: (0, $cztsD.zerosLike)(value).variable(trainable)
                };
                if (this.accumulatedWeightedInfNorm[i] == null) this.accumulatedWeightedInfNorm[i] = {
                    originalName: `${name}/v`,
                    variable: (0, $cztsD.zerosLike)(value).variable(trainable)
                };
                const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
                if (gradient == null) return;
                const firstMoment = this.accumulatedFirstMoment[i].variable;
                const weightedInfNorm = this.accumulatedWeightedInfNorm[i].variable;
                const newFirstMoment = (0, $6Ab5n.add)((0, $5hAos.mul)(firstMoment, this.beta1), (0, $5hAos.mul)(gradient, 1 - this.beta1));
                const ut0 = (0, $5hAos.mul)(weightedInfNorm, this.beta2);
                const ut1 = (0, $57D4R.abs)(gradient);
                const newWeightedInfNorm = (0, $jRQ3p.maximum)(ut0, ut1);
                firstMoment.assign(newFirstMoment);
                weightedInfNorm.assign(newWeightedInfNorm);
                const newValue = (0, $6Ab5n.add)((0, $5hAos.mul)((0, $dIChU.div)(lr, oneMinusAccBeta1), (0, $dIChU.div)(newFirstMoment, (0, $6Ab5n.add)(newWeightedInfNorm, this.epsilon))), value);
                value.assign(newValue);
            });
            this.iteration.assign((0, $6Ab5n.add)(this.iteration, 1));
            this.accBeta1.assign((0, $5hAos.mul)(this.accBeta1, this.beta1));
        });
        this.incrementIterations();
    }
    dispose() {
        this.accBeta1.dispose();
        this.iteration.dispose();
        if (this.accumulatedFirstMoment != null) (0, $d7Nxs.dispose)(this.accumulatedFirstMoment.map((v)=>v.variable));
        if (this.accumulatedWeightedInfNorm != null) (0, $d7Nxs.dispose)(this.accumulatedWeightedInfNorm.map((v)=>v.variable));
    }
    async getWeights() {
        throw new Error('getWeights() is not implemented for Adamax yet.');
    }
    async setWeights(weightValues) {
        throw new Error('setWeights() is not implemented for Adamax yet.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'beta1': this.beta1,
            'beta2': this.beta2,
            'epsilon': this.epsilon,
            'decay': this.decay
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon'], config['decay']);
    }
}

});
parcelRegister("57D4R", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $3babeb2514e44869$export$2335f513bbd82c6d; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes absolute value element-wise: `abs(x)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.abs().print();  // or tf.abs(x)
 * ```
 * @param x The input `tf.Tensor`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $3babeb2514e44869$var$abs_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'abs');
    if ($x.dtype === 'complex64') {
        const inputs = {
            x: $x
        };
        return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ComplexAbs), inputs);
    } else {
        const inputs = {
            x: $x
        };
        return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Abs), inputs);
    }
}
const $3babeb2514e44869$export$2335f513bbd82c6d = /* @__PURE__ */ (0, $6afhl.op)({
    abs_: $3babeb2514e44869$var$abs_
});

});

parcelRegister("jRQ3p", function(module, exports) {

$parcel$export(module.exports, "maximum", function () { return $e76b58651392e871$export$b25e0be55f42c9a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $fxiHg = parcelRequire("fxiHg");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the max of a and b (`a > b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `tf.maximumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * ```js
 * // Broadcast maximum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.maximum(b).print();  // or tf.maximum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $e76b58651392e871$var$maximum_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'maximum');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'maximum');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $fxiHg.cast)($a, 'int32');
        $b = (0, $fxiHg.cast)($b, 'int32');
    }
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Maximum), inputs);
}
const $e76b58651392e871$export$b25e0be55f42c9a = /* @__PURE__ */ (0, $6afhl.op)({
    maximum_: $e76b58651392e871$var$maximum_
});

});
parcelRegister("5mf1d", function(module, exports) {

$parcel$export(module.exports, "getBroadcastDims", function () { return $3e6aa8343dbd1092$export$fc823784344690e0; });
$parcel$export(module.exports, "getReductionAxes", function () { return $3e6aa8343dbd1092$export$9f11ec258a9b2804; });
$parcel$export(module.exports, "assertAndGetBroadcastShape", function () { return $3e6aa8343dbd1092$export$a3e2a38a57ec8318; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Returns the dimensions in the input shape that are broadcasted to
 * produce the provided output shape.
 *
 * The returned dimensions are 0-indexed and sorted. An example:
 * inShape = [4, 1, 3]
 * outShape = [5, 4, 3, 3]
 * result = [1]. Dimension 1 (2nd dimension of input) gets broadcasted 1 => 3.
 */ function $3e6aa8343dbd1092$export$fc823784344690e0(inShape, outShape) {
    const inRank = inShape.length;
    const dims = [];
    for(let i = 0; i < inRank; i++){
        const dim = inRank - 1 - i;
        const a = inShape[dim] || 1;
        const b = outShape[outShape.length - 1 - i] || 1;
        if (b > 1 && a === 1) dims.unshift(dim);
    }
    return dims;
}
function $3e6aa8343dbd1092$export$9f11ec258a9b2804(inShape, outShape) {
    const result = [];
    for(let i = 0; i < outShape.length; i++){
        const inDim = inShape[inShape.length - i - 1];
        const outAxis = outShape.length - i - 1;
        const outDim = outShape[outAxis];
        if (inDim == null || inDim === 1 && outDim > 1) result.unshift(outAxis);
    }
    return result;
}
function $3e6aa8343dbd1092$export$a3e2a38a57ec8318(shapeA, shapeB) {
    const l = Math.max(shapeA.length, shapeB.length);
    const result = new Array(l);
    for(let i = 0; i < l; i++){
        let a = shapeA[shapeA.length - i - 1];
        if (a == null) a = 1;
        let b = shapeB[shapeB.length - i - 1];
        if (b == null) b = 1;
        if (a === 1) result[l - i - 1] = b;
        else if (b === 1) result[l - i - 1] = a;
        else if (a !== b) {
            const errMsg = `Operands could not be broadcast together with shapes ` + `${shapeA} and ${shapeB}.`;
            throw Error(errMsg);
        } else result[l - i - 1] = a;
    }
    return result;
}

});



parcelRegister("bK23H", function(module, exports) {

$parcel$export(module.exports, "MomentumOptimizer", function () { return $88c59660e75479a0$export$1db7ecf1f8312c6; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $6Ab5n = parcelRequire("6Ab5n");

var $5hAos = parcelRequire("5hAos");

var $7hONX = parcelRequire("7hONX");

var $cztsD = parcelRequire("cztsD");

var $bQqzj = parcelRequire("bQqzj");
class $88c59660e75479a0$export$1db7ecf1f8312c6 extends (0, $bQqzj.SGDOptimizer) {
    /** @nocollapse */ // Name matters for Python compatibility.
    static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'Momentum';
    }
    constructor(learningRate, momentum, useNesterov = false){
        super(learningRate);
        this.learningRate = learningRate;
        this.momentum = momentum;
        this.useNesterov = useNesterov;
        this.accumulations = [];
        this.m = (0, $7hONX.scalar)(this.momentum);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $e6Ey6.ENGINE).registeredVariables[name];
            if (this.accumulations[i] == null) {
                const trainable = false;
                this.accumulations[i] = {
                    originalName: `${name}/momentum`,
                    variable: (0, $d7Nxs.tidy)(()=>(0, $cztsD.zerosLike)(value).variable(trainable))
                };
            }
            const accumulation = this.accumulations[i].variable;
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            (0, $d7Nxs.tidy)(()=>{
                let newValue;
                const newAccumulation = (0, $6Ab5n.add)((0, $5hAos.mul)(this.m, accumulation), gradient);
                if (this.useNesterov) newValue = (0, $6Ab5n.add)((0, $5hAos.mul)(this.c, (0, $6Ab5n.add)(gradient, (0, $5hAos.mul)(newAccumulation, this.m))), value);
                else newValue = (0, $6Ab5n.add)((0, $5hAos.mul)(this.c, newAccumulation), value);
                accumulation.assign(newAccumulation);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    dispose() {
        this.m.dispose();
        if (this.accumulations != null) (0, $d7Nxs.dispose)(this.accumulations.map((v)=>v.variable));
    }
    /**
     * Sets the momentum of the optimizer.
     *
     * @param momentum
     */ setMomentum(momentum) {
        this.momentum = momentum;
    }
    async getWeights() {
        // Order matters for Python compatibility.
        return [
            await this.saveIterations()
        ].concat(this.accumulations.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const trainable = false;
        this.accumulations = weightValues.map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'momentum': this.momentum,
            'useNesterov': this.useNesterov
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['momentum'], config['useNesterov']);
    }
}

});
parcelRegister("bQqzj", function(module, exports) {

$parcel$export(module.exports, "SGDOptimizer", function () { return $89f928fd7edf85dc$export$97318dd520e1bd4f; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $6Ab5n = parcelRequire("6Ab5n");

var $5hAos = parcelRequire("5hAos");

var $7hONX = parcelRequire("7hONX");

var $2jiJm = parcelRequire("2jiJm");
class $89f928fd7edf85dc$export$97318dd520e1bd4f extends (0, $2jiJm.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'SGD';
    }
    constructor(learningRate){
        super();
        this.learningRate = learningRate;
        this.setLearningRate(learningRate);
    }
    applyGradients(variableGradients) {
        const varNames = Array.isArray(variableGradients) ? variableGradients.map((v)=>v.name) : Object.keys(variableGradients);
        varNames.forEach((name, i)=>{
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const value = (0, $e6Ey6.ENGINE).registeredVariables[name];
            (0, $d7Nxs.tidy)(()=>{
                const newValue = (0, $6Ab5n.add)((0, $5hAos.mul)(this.c, gradient), value);
                value.assign(newValue);
            });
        });
        this.incrementIterations();
    }
    /**
     * Sets the learning rate of the optimizer.
     */ setLearningRate(learningRate) {
        this.learningRate = learningRate;
        if (this.c != null) this.c.dispose();
        this.c = (0, $d7Nxs.keep)((0, $7hONX.scalar)(-learningRate));
    }
    dispose() {
        this.c.dispose();
    }
    async getWeights() {
        return [
            await this.saveIterations()
        ];
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        if (weightValues.length !== 0) throw new Error('SGD optimizer does not have settable weights.');
    }
    getConfig() {
        return {
            'learningRate': this.learningRate
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate']);
    }
}

});


parcelRegister("glgZq", function(module, exports) {

$parcel$export(module.exports, "RMSPropOptimizer", function () { return $be5bc951fcd465e3$export$6e668138ce08e3bf; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $6Ab5n = parcelRequire("6Ab5n");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");

var $cztsD = parcelRequire("cztsD");

var $2jiJm = parcelRequire("2jiJm");
class $be5bc951fcd465e3$export$6e668138ce08e3bf extends (0, $2jiJm.Optimizer) {
    /** @nocollapse */ static get className() {
        // Name matters for Python compatibility.
        // This is a getter instead of a property because when it's a property, it
        // prevents the entire class from being tree-shaken.
        return 'RMSProp';
    }
    constructor(learningRate, decay = 0.9, momentum = 0.0, epsilon = null, centered = false){
        super();
        this.learningRate = learningRate;
        this.decay = decay;
        this.momentum = momentum;
        this.epsilon = epsilon;
        this.accumulatedMeanSquares = [];
        this.accumulatedMoments = [];
        this.accumulatedMeanGrads = [];
        this.centered = centered;
        if (epsilon == null) this.epsilon = (0, $e6Ey6.ENGINE).backend.epsilon();
        if (learningRate == null) throw new Error(`learningRate for RMSPropOptimizer must be defined.`);
    }
    applyGradients(variableGradients) {
        const variableNames = Array.isArray(variableGradients) ? variableGradients.map((item)=>item.name) : Object.keys(variableGradients);
        variableNames.forEach((name, i)=>{
            const value = (0, $e6Ey6.ENGINE).registeredVariables[name];
            const trainable = false;
            if (this.accumulatedMeanSquares[i] == null) this.accumulatedMeanSquares[i] = {
                originalName: `${name}/rms`,
                variable: (0, $d7Nxs.tidy)(()=>(0, $cztsD.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedMoments[i] == null) this.accumulatedMoments[i] = {
                originalName: `${name}/momentum`,
                variable: (0, $d7Nxs.tidy)(()=>(0, $cztsD.zerosLike)(value).variable(trainable))
            };
            if (this.accumulatedMeanGrads[i] == null && this.centered) this.accumulatedMeanGrads[i] = {
                originalName: `${name}/mg`,
                variable: (0, $d7Nxs.tidy)(()=>(0, $cztsD.zerosLike)(value).variable(trainable))
            };
            const gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];
            if (gradient == null) return;
            const accumulatedMeanSquare = this.accumulatedMeanSquares[i].variable;
            const accumulatedMoments = this.accumulatedMoments[i].variable;
            (0, $d7Nxs.tidy)(()=>{
                const newAccumulatedMeanSquare = (0, $6Ab5n.add)((0, $5hAos.mul)(accumulatedMeanSquare, this.decay), (0, $5hAos.mul)((0, $5MB84.square)(gradient), 1 - this.decay));
                if (this.centered) {
                    const accumulatedMeanGrad = this.accumulatedMeanGrads[i].variable;
                    // Centered gradient
                    const newAccumulatedMeanGrad = (0, $6Ab5n.add)((0, $5hAos.mul)(accumulatedMeanGrad, this.decay), (0, $5hAos.mul)(gradient, 1 - this.decay));
                    const gradContribution = (0, $dIChU.div)((0, $5hAos.mul)(gradient, this.learningRate), (0, $g3lev.sqrt)((0, $5jGN9.sub)(newAccumulatedMeanSquare, (0, $6Ab5n.add)((0, $5MB84.square)(newAccumulatedMeanGrad), this.epsilon))));
                    const newAccumulatedMoments = (0, $6Ab5n.add)((0, $5hAos.mul)(accumulatedMoments, this.momentum), gradContribution);
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMeanGrad.assign(newAccumulatedMeanGrad);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $5jGN9.sub)(value, newAccumulatedMoments);
                    value.assign(newValue);
                } else {
                    // Plain gradient
                    const newAccumulatedMeanSquare = (0, $6Ab5n.add)((0, $5hAos.mul)(accumulatedMeanSquare, this.decay), (0, $5hAos.mul)((0, $5MB84.square)(gradient), 1 - this.decay));
                    const newAccumulatedMoments = (0, $6Ab5n.add)((0, $5hAos.mul)(accumulatedMoments, this.momentum), (0, $dIChU.div)((0, $5hAos.mul)(gradient, this.learningRate), (0, $g3lev.sqrt)((0, $6Ab5n.add)(newAccumulatedMeanSquare, this.epsilon))));
                    accumulatedMeanSquare.assign(newAccumulatedMeanSquare);
                    accumulatedMoments.assign(newAccumulatedMoments);
                    const newValue = (0, $5jGN9.sub)(value, newAccumulatedMoments);
                    value.assign(newValue);
                }
            });
        });
        this.incrementIterations();
    }
    dispose() {
        if (this.accumulatedMeanSquares != null) (0, $d7Nxs.dispose)(this.accumulatedMeanSquares.map((v)=>v.variable));
        if (this.accumulatedMeanGrads != null && this.centered) (0, $d7Nxs.dispose)(this.accumulatedMeanGrads.map((v)=>v.variable));
        if (this.accumulatedMoments != null) (0, $d7Nxs.dispose)(this.accumulatedMoments.map((v)=>v.variable));
    }
    async getWeights() {
        // Order matters for Python compatibility.
        const variables = [
            ...this.accumulatedMeanSquares,
            ...this.accumulatedMoments
        ];
        if (this.centered) variables.push(...this.accumulatedMeanGrads);
        return [
            await this.saveIterations()
        ].concat(variables.map((v)=>({
                name: v.originalName,
                tensor: v.variable
            })));
    }
    async setWeights(weightValues) {
        weightValues = await this.extractIterations(weightValues);
        const variableCount = this.centered ? weightValues.length / 3 : weightValues.length / 2;
        const trainable = false;
        this.accumulatedMeanSquares = weightValues.slice(0, variableCount).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        this.accumulatedMoments = weightValues.slice(variableCount, variableCount * 2).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
        if (this.centered) this.accumulatedMeanGrads = weightValues.slice(variableCount * 2, variableCount * 3).map((v)=>({
                originalName: v.name,
                variable: v.tensor.variable(trainable)
            }));
    }
    getConfig() {
        return {
            'learningRate': this.learningRate,
            'decay': this.decay,
            'momentum': this.momentum,
            'epsilon': this.epsilon,
            'centered': this.centered
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config['learningRate'], config['decay'], config['momentum'], config['epsilon'], config['centered']);
    }
}

});


parcelRegister("c3y0I", function(module, exports) {

$parcel$export(module.exports, "all", function () { return $8c70259d1553bfc7$export$84bf76cd7afc7469; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the logical and of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.all().print();  // or tf.all(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.all(axis).print();  // or tf.all(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $8c70259d1553bfc7$var$all_(x, axis = null, keepDims = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'all', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.All), inputs, attrs);
}
const $8c70259d1553bfc7$export$84bf76cd7afc7469 = /* @__PURE__ */ (0, $6afhl.op)({
    all_: $8c70259d1553bfc7$var$all_
});

});

parcelRegister("dODwI", function(module, exports) {

$parcel$export(module.exports, "any", function () { return $a0ee9b06bb933c24$export$4154a199d7d90455; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the logical or of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 1, 1], 'bool');
 *
 * x.any().print();  // or tf.any(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 1, 0, 0], [2, 2], 'bool');
 *
 * const axis = 1;
 * x.any(axis).print();  // or tf.any(x, axis)
 * ```
 *
 * @param x The input tensor. Must be of dtype bool.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $a0ee9b06bb933c24$var$any_(x, axis = null, keepDims = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'any', 'bool');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Any), inputs, attrs);
}
const $a0ee9b06bb933c24$export$4154a199d7d90455 = /* @__PURE__ */ (0, $6afhl.op)({
    any_: $a0ee9b06bb933c24$var$any_
});

});

parcelRegister("kRlq3", function(module, exports) {

$parcel$export(module.exports, "argMax", function () { return $f2f95f527412b21e$export$7980a683c1b852b4; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the indices of the maximum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMax().print();  // or tf.argMax(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMax(axis).print();  // or tf.argMax(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $f2f95f527412b21e$var$argMax_(x, axis = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'argMax');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ArgMax), inputs, attrs);
}
const $f2f95f527412b21e$export$7980a683c1b852b4 = /* @__PURE__ */ (0, $6afhl.op)({
    argMax_: $f2f95f527412b21e$var$argMax_
});

});

parcelRegister("4LG6a", function(module, exports) {

$parcel$export(module.exports, "avgPool", function () { return $378c351b01f7da61$export$d5c65a2abd3d97dc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $fxiHg = parcelRequire("fxiHg");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the 2D average pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *         https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $378c351b01f7da61$var$avgPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'avgPool', 'float32');
    const dilations = 1;
    $eOiOM.assert($g0V2M.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $eOiOM.assert(x4D.rank === 4, ()=>`Error in avgPool: x must be rank 4 but got rank ${x4D.rank}.`);
    $g0V2M.checkPadOnDimRoundingMode('avgPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.AvgPool), inputs, attrs);
    res = (0, $fxiHg.cast)(res, $x.dtype);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $378c351b01f7da61$export$d5c65a2abd3d97dc = /* @__PURE__ */ (0, $6afhl.op)({
    avgPool_: $378c351b01f7da61$var$avgPool_
});

});
parcelRegister("g0V2M", function(module, exports) {

$parcel$export(module.exports, "computeDilation2DInfo", function () { return $ba88e5222583fcff$export$24e8a5cb688b9852; });
$parcel$export(module.exports, "convertConv2DDataFormat", function () { return $ba88e5222583fcff$export$1641c6bb3eb9a5b4; });
$parcel$export(module.exports, "computeConv2DInfo", function () { return $ba88e5222583fcff$export$fdd37387e0a3c672; });
$parcel$export(module.exports, "computePool2DInfo", function () { return $ba88e5222583fcff$export$67e321f77840205c; });
$parcel$export(module.exports, "computePool3DInfo", function () { return $ba88e5222583fcff$export$1382473b2833755b; });
$parcel$export(module.exports, "computeConv3DInfo", function () { return $ba88e5222583fcff$export$e4819ceef3994d7b; });
$parcel$export(module.exports, "computeDefaultPad", function () { return $ba88e5222583fcff$export$670354fdcb16da70; });
$parcel$export(module.exports, "tupleValuesAreOne", function () { return $ba88e5222583fcff$export$f16174446c2d5b2a; });
$parcel$export(module.exports, "eitherStridesOrDilationsAreOne", function () { return $ba88e5222583fcff$export$1e13dbff91e2f5ca; });
$parcel$export(module.exports, "stridesOrDilationsArePositive", function () { return $ba88e5222583fcff$export$6f24ba18d950c7e3; });
$parcel$export(module.exports, "checkPadOnDimRoundingMode", function () { return $ba88e5222583fcff$export$1b3400c26a44af8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
function $ba88e5222583fcff$export$24e8a5cb688b9852(inputShape, filterShape, strides, pad, dataFormat = 'NHWC', dilations) {
    // `computerConv2DInfo` require filterShape to be in the dimension of:
    // `[filterHeight, filterWidth, depth, outDepth]`, dilation2d doesn't have
    // outDepth, it should have the same depth as the input.
    // Input shape: [batch, height, width, inChannels]
    const inputChannels = inputShape[3];
    const $filterShape = [
        ...filterShape,
        inputChannels
    ];
    const $dataFormat = $ba88e5222583fcff$export$1641c6bb3eb9a5b4(dataFormat);
    return $ba88e5222583fcff$export$fdd37387e0a3c672(inputShape, $filterShape, strides, dilations, pad, null, null, $dataFormat);
}
function $ba88e5222583fcff$export$67e321f77840205c(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'channelsLast') {
    const [filterHeight, filterWidth] = $ba88e5222583fcff$var$parseTupleParam(filterSize);
    let filterShape;
    if (dataFormat === 'channelsLast') filterShape = [
        filterHeight,
        filterWidth,
        inShape[3],
        inShape[3]
    ];
    else if (dataFormat === 'channelsFirst') filterShape = [
        filterHeight,
        filterWidth,
        inShape[1],
        inShape[1]
    ];
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $ba88e5222583fcff$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, false, dataFormat);
}
function $ba88e5222583fcff$export$1382473b2833755b(inShape, filterSize, strides, dilations, pad, roundingMode, dataFormat = 'NDHWC') {
    const [filterDepth, filterHeight, filterWidth] = $ba88e5222583fcff$var$parse3TupleParam(filterSize);
    let filterShape;
    let $dataFormat;
    if (dataFormat === 'NDHWC') {
        $dataFormat = 'channelsLast';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[4],
            inShape[4]
        ];
    } else if (dataFormat === 'NCDHW') {
        $dataFormat = 'channelsFirst';
        filterShape = [
            filterDepth,
            filterHeight,
            filterWidth,
            inShape[1],
            inShape[1]
        ];
    } else throw new Error(`Unknown dataFormat ${dataFormat}`);
    return $ba88e5222583fcff$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, false, $dataFormat, roundingMode);
}
function $ba88e5222583fcff$export$fdd37387e0a3c672(inShape, filterShape, strides, dilations, pad, roundingMode, depthwise = false, dataFormat = 'channelsLast') {
    let [batchSize, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideHeight, strideWidth] = $ba88e5222583fcff$var$parseTupleParam(strides);
    const [dilationHeight, dilationWidth] = $ba88e5222583fcff$var$parseTupleParam(dilations);
    const effectiveFilterHeight = $ba88e5222583fcff$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $ba88e5222583fcff$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outHeight: outHeight, outWidth: outWidth } = $ba88e5222583fcff$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, effectiveFilterHeight, effectiveFilterWidth, roundingMode, dataFormat);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $ba88e5222583fcff$export$e4819ceef3994d7b(inShape, filterShape, strides, dilations, pad, depthwise = false, dataFormat = 'channelsLast', roundingMode) {
    let [batchSize, inDepth, inHeight, inWidth, inChannels] = [
        -1,
        -1,
        -1,
        -1,
        -1
    ];
    if (dataFormat === 'channelsLast') [batchSize, inDepth, inHeight, inWidth, inChannels] = inShape;
    else if (dataFormat === 'channelsFirst') [batchSize, inChannels, inDepth, inHeight, inWidth] = inShape;
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
    const [filterDepth, filterHeight, filterWidth, , filterChannels] = filterShape;
    const [strideDepth, strideHeight, strideWidth] = $ba88e5222583fcff$var$parse3TupleParam(strides);
    const [dilationDepth, dilationHeight, dilationWidth] = $ba88e5222583fcff$var$parse3TupleParam(dilations);
    const effectiveFilterDepth = $ba88e5222583fcff$var$getEffectiveFilterSize(filterDepth, dilationDepth);
    const effectiveFilterHeight = $ba88e5222583fcff$var$getEffectiveFilterSize(filterHeight, dilationHeight);
    const effectiveFilterWidth = $ba88e5222583fcff$var$getEffectiveFilterSize(filterWidth, dilationWidth);
    const { padInfo: padInfo, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth } = $ba88e5222583fcff$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, effectiveFilterDepth, effectiveFilterHeight, effectiveFilterWidth, roundingMode);
    const outChannels = depthwise ? filterChannels * inChannels : filterChannels;
    let outShape;
    if (dataFormat === 'channelsFirst') outShape = [
        batchSize,
        outChannels,
        outDepth,
        outHeight,
        outWidth
    ];
    else if (dataFormat === 'channelsLast') outShape = [
        batchSize,
        outDepth,
        outHeight,
        outWidth,
        outChannels
    ];
    return {
        batchSize: batchSize,
        dataFormat: dataFormat,
        inDepth: inDepth,
        inHeight: inHeight,
        inWidth: inWidth,
        inChannels: inChannels,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth,
        outChannels: outChannels,
        padInfo: padInfo,
        strideDepth: strideDepth,
        strideHeight: strideHeight,
        strideWidth: strideWidth,
        filterDepth: filterDepth,
        filterHeight: filterHeight,
        filterWidth: filterWidth,
        effectiveFilterDepth: effectiveFilterDepth,
        effectiveFilterHeight: effectiveFilterHeight,
        effectiveFilterWidth: effectiveFilterWidth,
        dilationDepth: dilationDepth,
        dilationHeight: dilationHeight,
        dilationWidth: dilationWidth,
        inShape: inShape,
        outShape: outShape,
        filterShape: filterShape
    };
}
function $ba88e5222583fcff$var$computeOutputShape2D(inShape, fieldSize, stride, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $ba88e5222583fcff$export$670354fdcb16da70(inShape, fieldSize, stride);
    const inputRows = inShape[0];
    const inputCols = inShape[1];
    const outputRows = $ba88e5222583fcff$var$round((inputRows - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    const outputCols = $ba88e5222583fcff$var$round((inputCols - fieldSize + 2 * zeroPad) / stride + 1, roundingMode);
    return [
        outputRows,
        outputCols
    ];
}
function $ba88e5222583fcff$var$computeOutputShape4D(inShape, filterShape, outChannels, strides, zeroPad, roundingMode) {
    if (zeroPad == null) zeroPad = $ba88e5222583fcff$export$670354fdcb16da70(inShape, filterShape[0], strides[0]);
    const outShape = [
        0,
        0,
        0,
        outChannels
    ];
    for(let index = 0; index < 3; index++)if (inShape[index] + 2 * zeroPad >= filterShape[index]) outShape[index] = $ba88e5222583fcff$var$round((inShape[index] - filterShape[index] + 2 * zeroPad) / strides[index] + 1, roundingMode);
    return outShape;
}
function $ba88e5222583fcff$export$670354fdcb16da70(inputShape, fieldSize, stride, dilation = 1) {
    const effectiveFieldSize = $ba88e5222583fcff$var$getEffectiveFilterSize(fieldSize, dilation);
    return Math.floor((inputShape[0] * (stride - 1) - stride + effectiveFieldSize) / 2);
}
function $ba88e5222583fcff$var$parseTupleParam(param) {
    if (typeof param === 'number') return [
        param,
        param,
        param
    ];
    if (param.length === 2) return [
        param[0],
        param[1],
        1
    ];
    return param;
}
function $ba88e5222583fcff$var$parse3TupleParam(param) {
    return typeof param === 'number' ? [
        param,
        param,
        param
    ] : param;
}
/* See https://www.tensorflow.org/api_docs/python/tf/nn/atrous_conv2d
 * Atrous convolution is equivalent to standard convolution with upsampled
 * filters with effective_filter_height =
 * filter_height + (filter_height - 1) * (dilation - 1)
 * and effective_filter_width =
 * filter_width + (filter_width - 1) * (dilation - 1),
 * produced by inserting dilation - 1 zeros along consecutive elements across
 * the filters' spatial dimensions.
 * When there is a dilation, this converts a filter dimension to the
 * effective filter dimension, so it can be used in a standard convolution.
 */ function $ba88e5222583fcff$var$getEffectiveFilterSize(filterSize, dilation) {
    if (dilation <= 1) return filterSize;
    return filterSize + (filterSize - 1) * (dilation - 1);
}
function $ba88e5222583fcff$var$getPadAndOutInfo(pad, inHeight, inWidth, strideHeight, strideWidth, filterHeight, filterWidth, roundingMode, dataFormat) {
    let padInfo;
    let outHeight;
    let outWidth;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            type: padType
        };
        const outShape = $ba88e5222583fcff$var$computeOutputShape2D([
            inHeight,
            inWidth
        ], filterHeight, strideHeight, pad, roundingMode);
        outHeight = outShape[0];
        outWidth = outShape[1];
    } else if (pad === 'same') {
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongHeight = Math.max(0, (outHeight - 1) * strideHeight + filterHeight - inHeight);
        const padAlongWidth = Math.max(0, (outWidth - 1) * strideWidth + filterWidth - inWidth);
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: 'SAME'
        };
    } else if (pad === 'valid') {
        padInfo = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            type: 'VALID'
        };
        outHeight = Math.ceil((inHeight - filterHeight + 1) / strideHeight);
        outWidth = Math.ceil((inWidth - filterWidth + 1) / strideWidth);
    } else if (typeof pad === 'object') {
        const top = dataFormat === 'channelsLast' ? pad[1][0] : pad[2][0];
        const bottom = dataFormat === 'channelsLast' ? pad[1][1] : pad[2][1];
        const left = dataFormat === 'channelsLast' ? pad[2][0] : pad[3][0];
        const right = dataFormat === 'channelsLast' ? pad[2][1] : pad[3][1];
        const padType = top === 0 && bottom === 0 && left === 0 && right === 0 ? 'VALID' : 'EXPLICIT';
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            type: padType
        };
        outHeight = $ba88e5222583fcff$var$round((inHeight - filterHeight + top + bottom) / strideHeight + 1, roundingMode);
        outWidth = $ba88e5222583fcff$var$round((inWidth - filterWidth + left + right) / strideWidth + 1, roundingMode);
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
function $ba88e5222583fcff$var$get3DPadAndOutInfo(pad, inDepth, inHeight, inWidth, strideDepth, strideHeight, strideWidth, filterDepth, filterHeight, filterWidth, roundingMode) {
    let padInfo;
    let outDepth;
    let outHeight;
    let outWidth;
    if (pad === 'valid') pad = 0;
    if (typeof pad === 'number') {
        const padType = pad === 0 ? 'VALID' : 'NUMBER';
        padInfo = {
            top: pad,
            bottom: pad,
            left: pad,
            right: pad,
            front: pad,
            back: pad,
            type: padType
        };
        const outShape = $ba88e5222583fcff$var$computeOutputShape4D([
            inDepth,
            inHeight,
            inWidth,
            1
        ], [
            filterDepth,
            filterHeight,
            filterWidth
        ], 1, [
            strideDepth,
            strideHeight,
            strideWidth
        ], pad, roundingMode);
        outDepth = outShape[0];
        outHeight = outShape[1];
        outWidth = outShape[2];
    } else if (pad === 'same') {
        outDepth = Math.ceil(inDepth / strideDepth);
        outHeight = Math.ceil(inHeight / strideHeight);
        outWidth = Math.ceil(inWidth / strideWidth);
        const padAlongDepth = (outDepth - 1) * strideDepth + filterDepth - inDepth;
        const padAlongHeight = (outHeight - 1) * strideHeight + filterHeight - inHeight;
        const padAlongWidth = (outWidth - 1) * strideWidth + filterWidth - inWidth;
        const front = Math.floor(padAlongDepth / 2);
        const back = padAlongDepth - front;
        const top = Math.floor(padAlongHeight / 2);
        const bottom = padAlongHeight - top;
        const left = Math.floor(padAlongWidth / 2);
        const right = padAlongWidth - left;
        padInfo = {
            top: top,
            bottom: bottom,
            left: left,
            right: right,
            front: front,
            back: back,
            type: 'SAME'
        };
    } else throw Error(`Unknown padding parameter: ${pad}`);
    return {
        padInfo: padInfo,
        outDepth: outDepth,
        outHeight: outHeight,
        outWidth: outWidth
    };
}
/**
 * Rounds a value depending on the rounding mode
 * @param value
 * @param roundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $ba88e5222583fcff$var$round(value, roundingMode) {
    if (!roundingMode) return Math.trunc(value);
    switch(roundingMode){
        case 'round':
            // used for Caffe Conv
            return Math.round(value);
        case 'ceil':
            // used for Caffe Pool
            return Math.ceil(value);
        case 'floor':
            return Math.floor(value);
        default:
            throw new Error(`Unknown roundingMode ${roundingMode}`);
    }
}
function $ba88e5222583fcff$export$f16174446c2d5b2a(param) {
    const [dimA, dimB, dimC] = $ba88e5222583fcff$var$parseTupleParam(param);
    return dimA === 1 && dimB === 1 && dimC === 1;
}
function $ba88e5222583fcff$export$1e13dbff91e2f5ca(strides, dilations) {
    return $ba88e5222583fcff$export$f16174446c2d5b2a(strides) || $ba88e5222583fcff$export$f16174446c2d5b2a(dilations);
}
function $ba88e5222583fcff$export$6f24ba18d950c7e3(values) {
    return $ba88e5222583fcff$var$parseTupleParam(values).every((value)=>value > 0);
}
function $ba88e5222583fcff$export$1641c6bb3eb9a5b4(dataFormat) {
    if (dataFormat === 'NHWC') return 'channelsLast';
    else if (dataFormat === 'NCHW') return 'channelsFirst';
    else throw new Error(`Unknown dataFormat ${dataFormat}`);
}
function $ba88e5222583fcff$export$1b3400c26a44af8(opDesc, pad, dimRoundingMode) {
    if (dimRoundingMode != null) {
        if (typeof pad === 'string') throw Error(`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'number') $eOiOM.assert($eOiOM.isInt(pad), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${pad}.`);
        else if (typeof pad === 'object') pad.forEach((p)=>{
            p.forEach((v)=>{
                $eOiOM.assert($eOiOM.isInt(v), ()=>`Error in ${opDesc}: pad must be an integer when using ` + `dimRoundingMode ${dimRoundingMode} but got pad ${v}.`);
            });
        });
        else throw Error(`Error in ${opDesc}: Unknown padding parameter: ${pad}`);
    }
}

});

parcelRegister("8nMOl", function(module, exports) {

$parcel$export(module.exports, "reshape", function () { return $61a6558a9132ac5b$export$9eaad88cf88cee2b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Reshapes a `tf.Tensor` to a given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * If one component of shape is the special value -1, the size of that
 * dimension is computed so that the total size remains constant. In
 * particular, a shape of [-1] flattens into 1-D. At most one component of
 * shape can be -1.
 *
 * If shape is 1-D or higher, then the operation returns a tensor with shape
 * shape filled with the values of tensor. In this case, the number of
 * elements implied by shape must be the same as the number of elements in
 * tensor.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.reshape([2, 2]).print();
 * ```
 *
 * @param x The input tensor to be reshaped.
 * @param shape An array of integers defining the output tensor shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $61a6558a9132ac5b$var$reshape_(x, shape) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'reshape', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        shape: shape
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Reshape), inputs, attrs);
}
const $61a6558a9132ac5b$export$9eaad88cf88cee2b = /* @__PURE__ */ (0, $6afhl.op)({
    reshape_: $61a6558a9132ac5b$var$reshape_
});

});


parcelRegister("dTgsp", function(module, exports) {

$parcel$export(module.exports, "avgPool3d", function () { return $a1cd2d74e2322aae$export$ee1b0efb53eb29c3; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $fxiHg = parcelRequire("fxiHg");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the 3D average pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.avgPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $a1cd2d74e2322aae$var$avgPool3d_(x, filterSize, strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'avgPool3d', 'float32');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $eOiOM.assert(x5D.rank === 5, ()=>`Error in avgPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $eOiOM.assert(dataFormat === 'NDHWC', ()=>`Error in avgPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    $eOiOM.assert(typeof strides === 'number' && strides > 0 || Array.isArray(strides) && strides[0] > 0 && strides[1] > 0 && strides[2] > 0, ()=>`Error in avgPool3d: Stride must be > 0, but got '${strides}'`);
    (0, $g0V2M.checkPadOnDimRoundingMode)('avgPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    let res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.AvgPool3D), inputs, attrs);
    res = (0, $fxiHg.cast)(res, x5D.dtype);
    if (reshapedTo5D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $a1cd2d74e2322aae$export$ee1b0efb53eb29c3 = /* @__PURE__ */ (0, $6afhl.op)({
    avgPool3d_: $a1cd2d74e2322aae$var$avgPool3d_
});

});

parcelRegister("dEVRx", function(module, exports) {

$parcel$export(module.exports, "fromUint8ToStringArray", function () { return $9f1be519674f91d1$export$debaff328bdca650; });
$parcel$export(module.exports, "fromStringArrayToUint8", function () { return $9f1be519674f91d1$export$ce1f4ec5bdd0ab9a; });
$parcel$export(module.exports, "slice_util", function () { return (parcelRequire("iEcDD")); });
$parcel$export(module.exports, "upcastType", function () { return (parcelRequire("kKv2E")).upcastType; });
$parcel$export(module.exports, "segment_util", function () { return (parcelRequire("hOi6c")); });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lBDHD = parcelRequire("lBDHD");

var $bC6Qi = parcelRequire("bC6Qi");

var $5mf1d = parcelRequire("5mf1d");

var $aa5Ox = parcelRequire("aa5Ox");

var $g0V2M = parcelRequire("g0V2M");

var $a7HBS = parcelRequire("a7HBS");

var $iaqkB = parcelRequire("iaqkB");

var $76jCP = parcelRequire("76jCP");

var $g2skz = parcelRequire("g2skz");

var $iEcDD = parcelRequire("iEcDD");

var $kKv2E = parcelRequire("kKv2E");

var $eIcNJ = parcelRequire("eIcNJ");

var $i07oL = parcelRequire("i07oL");

var $bjlpb = parcelRequire("bjlpb");

var $hyHdD = parcelRequire("hyHdD");

var $2wK3w = parcelRequire("2wK3w");

var $1UMed = parcelRequire("1UMed");

var $8Tale = parcelRequire("8Tale");

var $leoEe = parcelRequire("leoEe");

var $i9Nqj = parcelRequire("i9Nqj");

var $hK9HE = parcelRequire("hK9HE");

var $2FTlH = parcelRequire("2FTlH");

var $7egzK = parcelRequire("7egzK");

var $kYitN = parcelRequire("kYitN");

var $hOi6c = parcelRequire("hOi6c");
function $9f1be519674f91d1$export$debaff328bdca650(vals) {
    try {
        // Decode the bytes into string.
        return vals.map((val)=>(0, $lBDHD.decodeString)(val));
    } catch (err) {
        throw new Error(`Failed to decode encoded string bytes into utf-8, error: ${err}`);
    }
}
function $9f1be519674f91d1$export$ce1f4ec5bdd0ab9a(strings) {
    return strings.map((s)=>(0, $lBDHD.encodeString)(s));
}
$parcel$exportWildcard(module.exports, $bC6Qi);
$parcel$exportWildcard(module.exports, $5mf1d);
$parcel$exportWildcard(module.exports, $aa5Ox);
$parcel$exportWildcard(module.exports, $g0V2M);
$parcel$exportWildcard(module.exports, $a7HBS);
$parcel$exportWildcard(module.exports, $iaqkB);
$parcel$exportWildcard(module.exports, $76jCP);
$parcel$exportWildcard(module.exports, $g2skz);
$parcel$exportWildcard(module.exports, $eIcNJ);
$parcel$exportWildcard(module.exports, $i07oL);
$parcel$exportWildcard(module.exports, $bjlpb);
$parcel$exportWildcard(module.exports, $hyHdD);
$parcel$exportWildcard(module.exports, $2wK3w);
$parcel$exportWildcard(module.exports, $1UMed);
$parcel$exportWildcard(module.exports, $8Tale);
$parcel$exportWildcard(module.exports, $leoEe);
$parcel$exportWildcard(module.exports, $i9Nqj);
$parcel$exportWildcard(module.exports, $hK9HE);
$parcel$exportWildcard(module.exports, $2FTlH);
$parcel$exportWildcard(module.exports, $7egzK);
$parcel$exportWildcard(module.exports, $kYitN);

});
parcelRegister("bC6Qi", function(module, exports) {

$parcel$export(module.exports, "axesAreInnerMostDims", function () { return $87488d1be6a24668$export$fcf762ecdaba1fc1; });
$parcel$export(module.exports, "combineLocations", function () { return $87488d1be6a24668$export$6cfee5a53150f612; });
$parcel$export(module.exports, "computeOutAndReduceShapes", function () { return $87488d1be6a24668$export$68ecd7df33283881; });
$parcel$export(module.exports, "expandShapeToKeepDim", function () { return $87488d1be6a24668$export$e35db9afe008d7e3; });
$parcel$export(module.exports, "assertAxesAreInnerMostDims", function () { return $87488d1be6a24668$export$f83b6b93f3b44c9c; });
$parcel$export(module.exports, "getAxesPermutation", function () { return $87488d1be6a24668$export$d2a6288eef79b310; });
$parcel$export(module.exports, "getUndoAxesPermutation", function () { return $87488d1be6a24668$export$2975b40e45f30ba8; });
$parcel$export(module.exports, "getInnerMostAxes", function () { return $87488d1be6a24668$export$b62922ed36931ab6; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
function $87488d1be6a24668$export$fcf762ecdaba1fc1(axes, rank) {
    for(let i = 0; i < axes.length; ++i){
        if (axes[axes.length - i - 1] !== rank - 1 - i) return false;
    }
    return true;
}
function $87488d1be6a24668$export$6cfee5a53150f612(outputLoc, reduceLoc, axes) {
    const rank = outputLoc.length + reduceLoc.length;
    const loc = [];
    let outIdx = 0;
    let reduceIdx = 0;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) loc.push(outputLoc[outIdx++]);
    else loc.push(reduceLoc[reduceIdx++]);
    return loc;
}
function $87488d1be6a24668$export$68ecd7df33283881(aShape, axes) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (axes.indexOf(dim) === -1) outShape.push(aShape[dim]);
    const reduceShape = axes.map((dim)=>aShape[dim]);
    return [
        outShape,
        reduceShape
    ];
}
function $87488d1be6a24668$export$e35db9afe008d7e3(shape, axes) {
    const reduceSubShape = axes.map((x)=>1);
    return $87488d1be6a24668$export$6cfee5a53150f612(shape, reduceSubShape, axes);
}
function $87488d1be6a24668$export$f83b6b93f3b44c9c(msg, axes, rank) {
    $eOiOM.assert($87488d1be6a24668$export$fcf762ecdaba1fc1(axes, rank), ()=>`${msg} supports only inner-most axes for now. ` + `Got axes ${axes} and rank-${rank} input.`);
}
function $87488d1be6a24668$export$d2a6288eef79b310(axes, rank) {
    if ($87488d1be6a24668$export$fcf762ecdaba1fc1(axes, rank)) return null;
    const result = [];
    for(let i = 0; i < rank; ++i)if (axes.indexOf(i) === -1) result.push(i);
    axes.forEach((axis)=>result.push(axis));
    return result;
}
function $87488d1be6a24668$export$2975b40e45f30ba8(axes) {
    return axes.map((axis, i)=>[
            i,
            axis
        ]).sort((a, b)=>a[1] - b[1]).map((x)=>x[0]);
}
function $87488d1be6a24668$export$b62922ed36931ab6(numAxes, rank) {
    const res = [];
    for(let i = rank - numAxes; i < rank; ++i)res.push(i);
    return res;
}

});

parcelRegister("aa5Ox", function(module, exports) {

$parcel$export(module.exports, "assertParamsConsistent", function () { return $765f591fbb3e74fa$export$ce1cccab5e7518dd; });
$parcel$export(module.exports, "computeOutShape", function () { return $765f591fbb3e74fa$export$22fa6b3b1305508e; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
function $765f591fbb3e74fa$export$ce1cccab5e7518dd(shapes, axis) {
    const rank = shapes[0].length;
    shapes.forEach((shape, i)=>{
        $eOiOM.assert(shape.length === rank, ()=>`Error in concat${rank}D: rank of tensors[${i}] must be the same ` + `as the rank of the rest (${rank})`);
    });
    $eOiOM.assert(axis >= 0 && axis < rank, ()=>`Error in concat${rank}D: axis must be between 0 and ${rank - 1}.`);
    const firstShape = shapes[0];
    shapes.forEach((shape, i)=>{
        for(let r = 0; r < rank; r++)$eOiOM.assert(r === axis || shape[r] === firstShape[r], ()=>`Error in concat${rank}D: Shape of tensors[${i}] (${shape}) ` + `does not match the shape of the rest (${firstShape}) ` + `along the non-concatenated axis ${i}.`);
    });
}
function $765f591fbb3e74fa$export$22fa6b3b1305508e(shapes, axis) {
    const outputShape = shapes[0].slice();
    for(let i = 1; i < shapes.length; i++)outputShape[axis] += shapes[i][axis];
    return outputShape;
}

});

parcelRegister("a7HBS", function(module, exports) {

$parcel$export(module.exports, "getFusedDyActivation", function () { return $75ec62db67446ffe$export$a1905aed55f51aef; });
$parcel$export(module.exports, "getFusedBiasGradient", function () { return $75ec62db67446ffe$export$1a797e236ae09d1f; });
$parcel$export(module.exports, "applyActivation", function () { return $75ec62db67446ffe$export$a0f250a2ba84196; });
$parcel$export(module.exports, "shouldFuse", function () { return $75ec62db67446ffe$export$4904add493b957ab; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5mf1d = parcelRequire("5mf1d");

var $4YAd3 = parcelRequire("4YAd3");

var $kFoUG = parcelRequire("kFoUG");

var $5hAos = parcelRequire("5hAos");

var $8b5dq = parcelRequire("8b5dq");

var $aQaR3 = parcelRequire("aQaR3");

var $4zQqN = parcelRequire("4zQqN");

var $8nMOl = parcelRequire("8nMOl");

var $dzpno = parcelRequire("dzpno");

var $1LynW = parcelRequire("1LynW");

var $fPnAL = parcelRequire("fPnAL");
function $75ec62db67446ffe$export$a1905aed55f51aef(dy, y, activation) {
    if (activation == null || activation === 'linear') return dy;
    if (activation === 'relu') return (0, $5hAos.mul)(dy, (0, $1LynW.step)(y));
    throw new Error(`Cannot compute gradient for fused activation ${activation}.`);
}
function $75ec62db67446ffe$export$1a797e236ae09d1f(bias, dyActivation) {
    let res = dyActivation;
    const reduceAxes = $5mf1d.getReductionAxes(bias.shape, dyActivation.shape);
    if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
    return (0, $8nMOl.reshape)(res, bias.shape);
}
function $75ec62db67446ffe$export$a0f250a2ba84196(x, activation, preluActivationWeights, leakyreluAlpha) {
    if (activation === 'linear') return x;
    else if (activation === 'relu') return (0, $aQaR3.relu)(x);
    else if (activation === 'elu') return (0, $4YAd3.elu)(x);
    else if (activation === 'relu6') return (0, $4zQqN.relu6)(x);
    else if (activation === 'prelu') return (0, $8b5dq.prelu)(x, preluActivationWeights);
    else if (activation === 'leakyrelu') return (0, $kFoUG.leakyRelu)(x, leakyreluAlpha);
    else if (activation === 'sigmoid') return (0, $dzpno.sigmoid)(x);
    throw new Error(`Unknown fused activation ${activation}.`);
}
const $75ec62db67446ffe$export$4904add493b957ab = (gradientDepth, activation)=>{
    const gradientMode = gradientDepth > 0;
    return !gradientMode || activation === 'linear';
};

});
parcelRegister("4YAd3", function(module, exports) {

$parcel$export(module.exports, "elu", function () { return $39f8da7ec2e0d568$export$796b583dd79d8524; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes exponential linear element-wise: `x > 0 ? x : (e ^ x) - 1`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 1, -3, 2]);
 *
 * x.elu().print();  // or tf.elu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $39f8da7ec2e0d568$var$elu_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'elu', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Elu), inputs);
}
const $39f8da7ec2e0d568$export$796b583dd79d8524 = /* @__PURE__ */ (0, $6afhl.op)({
    elu_: $39f8da7ec2e0d568$var$elu_
});

});

parcelRegister("kFoUG", function(module, exports) {

$parcel$export(module.exports, "leakyRelu", function () { return $f0baf63f67da68f4$export$23a860e40a2c6b61; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes leaky rectified linear element-wise.
 *
 * See
 * [http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf](
 *     http://web.stanford.edu/~awni/papers/relu_hybrid_icml2013_final.pdf)
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.leakyRelu(0.1).print();  // or tf.leakyRelu(x, 0.1)
 * ```
 * @param x The input tensor.
 * @param alpha The scaling factor for negative values, defaults to 0.2.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $f0baf63f67da68f4$var$leakyRelu_(x, alpha = 0.2) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'leakyRelu');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.LeakyRelu), inputs, attrs);
}
const $f0baf63f67da68f4$export$23a860e40a2c6b61 = /* @__PURE__ */ (0, $6afhl.op)({
    leakyRelu_: $f0baf63f67da68f4$var$leakyRelu_
});

});

parcelRegister("8b5dq", function(module, exports) {

$parcel$export(module.exports, "prelu", function () { return $5f43658257c4c61b$export$5882f235222e6729; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes leaky rectified linear element-wise with parametric alphas.
 *
 * `x < 0 ? alpha * x : f(x) = x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 * const alpha = tf.scalar(0.1);
 *
 * x.prelu(alpha).print();  // or tf.prelu(x, alpha)
 * ```
 * @param x The input tensor.
 * @param alpha Scaling factor for negative values.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5f43658257c4c61b$var$prelu_(x, alpha) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'prelu');
    const $alpha = (0, $x4eLk.convertToTensor)(alpha, 'alpha', 'prelu');
    const inputs = {
        x: $x,
        alpha: $alpha
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Prelu), inputs);
}
const $5f43658257c4c61b$export$5882f235222e6729 = /* @__PURE__ */ (0, $6afhl.op)({
    prelu_: $5f43658257c4c61b$var$prelu_
});

});

parcelRegister("aQaR3", function(module, exports) {

$parcel$export(module.exports, "relu", function () { return $7e472e3890dcee9a$export$16d1e4612cc0139f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes rectified linear element-wise: `max(x, 0)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.relu().print();  // or tf.relu(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $7e472e3890dcee9a$var$relu_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'relu');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Relu), inputs);
}
const $7e472e3890dcee9a$export$16d1e4612cc0139f = /* @__PURE__ */ (0, $6afhl.op)({
    relu_: $7e472e3890dcee9a$var$relu_
});

});

parcelRegister("4zQqN", function(module, exports) {

$parcel$export(module.exports, "relu6", function () { return $35531a0a6f0c16e1$export$4a62bcb95e9c44c4; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes rectified linear 6 element-wise: `min(max(x, 0), 6)`.
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 8]);
 *
 * x.relu6().print();  // or tf.relu6(x)
 * ```
 * @param x The input tensor. If the dtype is `bool`, the output dtype will be
 *     `int32`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $35531a0a6f0c16e1$var$relu6_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'relu6');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Relu6), inputs);
}
const $35531a0a6f0c16e1$export$4a62bcb95e9c44c4 = /* @__PURE__ */ (0, $6afhl.op)({
    relu6_: $35531a0a6f0c16e1$var$relu6_
});

});

parcelRegister("dzpno", function(module, exports) {

$parcel$export(module.exports, "sigmoid", function () { return $9e123a6de69a6a1a$export$3b295495ca3cad7c; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes sigmoid element-wise, `1 / (1 + exp(-x))`
 *
 * ```js
 * const x = tf.tensor1d([0, -1, 2, -3]);
 *
 * x.sigmoid().print();  // or tf.sigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $9e123a6de69a6a1a$var$sigmoid_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'sigmoid', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Sigmoid), inputs);
}
const $9e123a6de69a6a1a$export$3b295495ca3cad7c = /* @__PURE__ */ (0, $6afhl.op)({
    sigmoid_: $9e123a6de69a6a1a$var$sigmoid_
});

});

parcelRegister("1LynW", function(module, exports) {

$parcel$export(module.exports, "step", function () { return $1494da6c76ea81a0$export$35d34bc0ed591a92; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes step of the input `tf.Tensor` element-wise: `x > 0 ? 1 : alpha`
 *
 * ```js
 * const x = tf.tensor1d([0, 2, -1, -3]);
 *
 * x.step(.5).print();  // or tf.step(x, .5)
 * ```
 * @param x The input tensor.
 * @param alpha The gradient when input is negative. Defaults to 0.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $1494da6c76ea81a0$var$step_(x, alpha = 0.0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'step');
    const inputs = {
        x: $x
    };
    const attrs = {
        alpha: alpha
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Step), inputs, attrs);
}
const $1494da6c76ea81a0$export$35d34bc0ed591a92 = /* @__PURE__ */ (0, $6afhl.op)({
    step_: $1494da6c76ea81a0$var$step_
});

});

parcelRegister("fPnAL", function(module, exports) {

$parcel$export(module.exports, "sum", function () { return $b85deb4e0dafbfeb$export$8a63f25cc62965f1; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $fxiHg = parcelRequire("fxiHg");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the sum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If axes has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.sum().print();  // or tf.sum(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.sum(axis).print();  // or tf.sum(x, axis)
 * ```
 *
 * @param x The input tensor to compute the sum over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $b85deb4e0dafbfeb$var$sum_(x, axis = null, keepDims = false) {
    let $x = (0, $x4eLk.convertToTensor)(x, 'x', 'sum');
    if ($x.dtype === 'bool') $x = (0, $fxiHg.cast)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Sum), inputs, attrs);
}
const $b85deb4e0dafbfeb$export$8a63f25cc62965f1 = /* @__PURE__ */ (0, $6afhl.op)({
    sum_: $b85deb4e0dafbfeb$var$sum_
});

});


parcelRegister("iaqkB", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
});

parcelRegister("76jCP", function(module, exports) {

$parcel$export(module.exports, "RowPartitionType", function () { return $52b851209e47d1eb$export$c56fa138ccffd243; });
$parcel$export(module.exports, "combineRaggedTensorToTensorShapes", function () { return $52b851209e47d1eb$export$ab67507eda6e05cb; });
$parcel$export(module.exports, "getRowPartitionTypesHelper", function () { return $52b851209e47d1eb$export$b8324e259bdd3daf; });
$parcel$export(module.exports, "getRaggedRank", function () { return $52b851209e47d1eb$export$1cdd548e021d4109; });
$parcel$export(module.exports, "validateDefaultValueShape", function () { return $52b851209e47d1eb$export$4170394182a906f5; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $52b851209e47d1eb$export$c56fa138ccffd243;
(function(RowPartitionType) {
    RowPartitionType[RowPartitionType["FIRST_DIM_SIZE"] = 0] = "FIRST_DIM_SIZE";
    RowPartitionType[RowPartitionType["VALUE_ROWIDS"] = 1] = "VALUE_ROWIDS";
    RowPartitionType[RowPartitionType["ROW_LENGTHS"] = 2] = "ROW_LENGTHS";
    RowPartitionType[RowPartitionType["ROW_SPLITS"] = 3] = "ROW_SPLITS";
    RowPartitionType[RowPartitionType["ROW_LIMITS"] = 4] = "ROW_LIMITS";
    RowPartitionType[RowPartitionType["ROW_STARTS"] = 5] = "ROW_STARTS";
})($52b851209e47d1eb$export$c56fa138ccffd243 || ($52b851209e47d1eb$export$c56fa138ccffd243 = {}));
function $52b851209e47d1eb$export$ab67507eda6e05cb(raggedRank, shape, valueShape) {
    // Test for consistency of valueShape and shape specified.
    // If shape is unspecified and valueShape is specified, then copy
    // over the size from the valueShape dimension.
    let outputShape = new Array();
    if (valueShape == null && shape == null) return outputShape;
    if (shape == null) // Here, value_shape must be of known size.
    while(outputShape.length < raggedRank + valueShape.length)outputShape.push(-1);
    else outputShape = shape.slice();
    if (valueShape == null) return outputShape;
    // At this point, valueShape and output_shape have known ranks.
    if (raggedRank + valueShape.length !== outputShape.length) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.rank = ${raggedRank + valueShape.length}, but shape.rank = ${outputShape.length}`);
    for(let i = 1; i < valueShape.length; ++i){
        const valueDim = valueShape[i];
        const outputShapeDimIndex = outputShape[outputShape.length - valueShape.length + i];
        const outputShapeDim = outputShape[outputShapeDimIndex];
        if (valueDim >= 0) {
            if (outputShapeDim >= 0) {
                if (outputShapeDim !== valueDim) throw new Error(`rt input.shape and shape=${shape} are incompatible: rt input.shape[${i + raggedRank}] = ${valueDim} but shape[${i + raggedRank}] = ${outputShapeDim}`);
            } else outputShape[outputShapeDimIndex] = valueDim;
        }
    }
    return outputShape;
}
function $52b851209e47d1eb$export$b8324e259bdd3daf(rowPartitionTypeStrings) {
    const stringToType = {
        'FIRST_DIM_SIZE': $52b851209e47d1eb$export$c56fa138ccffd243.FIRST_DIM_SIZE,
        'VALUE_ROWIDS': $52b851209e47d1eb$export$c56fa138ccffd243.VALUE_ROWIDS,
        'ROW_LENGTHS': $52b851209e47d1eb$export$c56fa138ccffd243.ROW_LENGTHS,
        'ROW_SPLITS': $52b851209e47d1eb$export$c56fa138ccffd243.ROW_SPLITS,
        'ROW_LIMITS': $52b851209e47d1eb$export$c56fa138ccffd243.ROW_LIMITS,
        'ROW_STARTS': $52b851209e47d1eb$export$c56fa138ccffd243.ROW_STARTS
    };
    const result = [];
    for (const typeStr of rowPartitionTypeStrings){
        if (typeStr in stringToType) result.push(stringToType[typeStr]);
        else break;
    }
    return result;
}
function $52b851209e47d1eb$export$1cdd548e021d4109(rowPartitionTypes) {
    if (rowPartitionTypes.length === 0) return 0;
    if (rowPartitionTypes[0] === $52b851209e47d1eb$export$c56fa138ccffd243.FIRST_DIM_SIZE) return rowPartitionTypes.length - 1;
    return rowPartitionTypes.length;
}
function $52b851209e47d1eb$export$4170394182a906f5(defaultValueShape, valueShape) {
    if (defaultValueShape == null || valueShape == null) return;
    const defaultNDims = defaultValueShape.length;
    const valuesNDims = valueShape.length;
    if (defaultNDims >= valuesNDims) throw new Error(`defaultValue.shape=${defaultValueShape} and ragged tensor flatValues.shape=${valueShape}, are incompatible: defaultValue.rank = ${defaultNDims} must be less than ragged tensor input flatValues.rank = ${valuesNDims})`);
    for(let i = 0; i < Math.min(defaultNDims, valuesNDims - 1); ++i){
        const defaultDim = defaultValueShape[i];
        const valueDim = valueShape[i + 1];
        if (defaultDim >= 0 && valueDim >= 0 && defaultDim !== 1 && defaultDim !== valueDim) throw new Error(`defaultValue.shape=${defaultValueShape}, and ragged tensor input flatValues.shape=${valueShape} are incompatible: defaultValue.shape[${i - defaultValueShape.length}] = ${defaultDim} but ragged tensor input.flatValues.shape[${i - defaultValueShape.length}] = ${valueDim}`);
    }
}

});

parcelRegister("g2skz", function(module, exports) {

$parcel$export(module.exports, "PARALLELIZE_THRESHOLD", function () { return $bad2cf28e84f0ff1$export$ee3544492fe530f6; });
$parcel$export(module.exports, "computeOptimalWindowSize", function () { return $bad2cf28e84f0ff1$export$ee795473f4c8fb04; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inputs of size above this threshold will be parallelized by calling multiple
 * shader programs.
 */ 
var $eOiOM = parcelRequire("eOiOM");
const $bad2cf28e84f0ff1$export$ee3544492fe530f6 = 30;
function $bad2cf28e84f0ff1$export$ee795473f4c8fb04(inSize) {
    if (inSize <= $bad2cf28e84f0ff1$export$ee3544492fe530f6) return inSize;
    return (0, $eOiOM.nearestDivisor)(inSize, Math.floor(Math.sqrt(inSize)));
}

});

parcelRegister("iEcDD", function(module, exports) {

$parcel$export(module.exports, "assertParamsValid", function () { return $d935c418012fa4cd$export$1da6c8ba17e84239; });
$parcel$export(module.exports, "maskToAxes", function () { return $d935c418012fa4cd$export$ce8be3e704107015; });
$parcel$export(module.exports, "computeOutShape", function () { return $d935c418012fa4cd$export$22fa6b3b1305508e; });
$parcel$export(module.exports, "stridesWithElidedDims", function () { return $d935c418012fa4cd$export$7f5fa1173bdb6e15; });
$parcel$export(module.exports, "getNormalizedAxes", function () { return $d935c418012fa4cd$export$895fe9252fb79d1; });
$parcel$export(module.exports, "startIndicesWithElidedDims", function () { return $d935c418012fa4cd$export$a9f0de12634a4ce3; });
$parcel$export(module.exports, "stopIndicesWithElidedDims", function () { return $d935c418012fa4cd$export$19a416bd7e87244f; });
$parcel$export(module.exports, "startForAxis", function () { return $d935c418012fa4cd$export$643aca61b9318da8; });
$parcel$export(module.exports, "stopForAxis", function () { return $d935c418012fa4cd$export$612a961a199ffe65; });
$parcel$export(module.exports, "stridesForAxis", function () { return $d935c418012fa4cd$export$9e3fd91f45c1f07f; });
$parcel$export(module.exports, "isSliceContinous", function () { return $d935c418012fa4cd$export$9dc11bd6855e72c6; });
$parcel$export(module.exports, "computeFlatOffset", function () { return $d935c418012fa4cd$export$b01553f5da8f819c; });
$parcel$export(module.exports, "parseSliceParams", function () { return $d935c418012fa4cd$export$8448a0604fef5d62; });
$parcel$export(module.exports, "sliceInfo", function () { return $d935c418012fa4cd$export$54d224865abb6767; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
const $d935c418012fa4cd$var$NEW_AXIS = -2;
const $d935c418012fa4cd$var$SHRINK_AXIS = -1;
function $d935c418012fa4cd$export$1da6c8ba17e84239(input, begin, size) {
    const inputRank = input.shape.length;
    $eOiOM.assert(inputRank === begin.length, ()=>`Error in slice${inputRank}D: Length of begin ${begin} must ` + `match the rank of the array (${inputRank}).`);
    $eOiOM.assert(inputRank === size.length, ()=>`Error in slice${inputRank}D: Length of size ${size} must ` + `match the rank of the array (${inputRank}).`);
    for(let i = 0; i < inputRank; ++i)$eOiOM.assert(begin[i] + size[i] <= input.shape[i], ()=>`Error in slice${inputRank}D: begin[${i}] + size[${i}] ` + `(${begin[i] + size[i]}) would overflow input.shape[${i}] (${input.shape[i]})`);
}
function $d935c418012fa4cd$export$ce8be3e704107015(mask) {
    const axes = [];
    let axis = 0;
    while(mask > 0){
        if (mask & 1) axes.push(axis);
        mask /= 2;
        axis++;
    }
    return axes;
}
function $d935c418012fa4cd$export$22fa6b3b1305508e(begin, end, strides) {
    const size = [];
    for(let axis = 0; axis < begin.length; axis++)size[axis] = Math.ceil((end[axis] - begin[axis]) / strides[axis]);
    return size;
}
function $d935c418012fa4cd$export$7f5fa1173bdb6e15(strides, ellipsisInsertionIndex, numElidedAxes, inputShape) {
    const newStrides = [
        ...strides
    ];
    for(let i = newStrides.length; i < inputShape.length; i++)newStrides.push(1);
    for(let i = 0; i < numElidedAxes; i++)if (i === 0) newStrides[ellipsisInsertionIndex] = 1;
    else {
        newStrides.splice(ellipsisInsertionIndex, 0 /* num elements to delete */ , 1 /* element to add */ );
        newStrides.pop();
    }
    return newStrides;
}
function $d935c418012fa4cd$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, normalizedAxis) {
    if (normalizedAxis <= ellipsisInsertionIndex) return normalizedAxis;
    return normalizedAxis - (numElidedAxes - 1);
}
function $d935c418012fa4cd$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex) {
    const elidedAxes = [];
    for(let i = 0; i < numElidedAxes; i++)elidedAxes.push(ellipsisInsertionIndex + i);
    return elidedAxes;
}
function $d935c418012fa4cd$export$895fe9252fb79d1(inputShape, ellipsisAxes, numInterpolatedAxes, begin, end, strides, beginMask, endMask, ellipsisMask) {
    const inputRank = inputShape.length;
    let normalizedBegin = new Array(inputRank), normalizedEnd = new Array(inputRank), normalizedStrides = new Array(inputRank);
    if (ellipsisAxes.length && numInterpolatedAxes > 0) {
        const fullIndex = ellipsisAxes[0];
        // The ellipsis applies to the masked index as well as any dimensions
        // that are interpolated.
        const numElidedAxes = numInterpolatedAxes + 1;
        normalizedBegin = $d935c418012fa4cd$export$a9f0de12634a4ce3(beginMask, fullIndex, numElidedAxes, begin, inputShape);
        normalizedEnd = $d935c418012fa4cd$export$19a416bd7e87244f(endMask, fullIndex, numElidedAxes, end, inputShape);
        normalizedStrides = $d935c418012fa4cd$export$7f5fa1173bdb6e15(strides, fullIndex, numElidedAxes, inputShape);
    } else for(let axis = 0; axis < inputRank; axis++){
        normalizedBegin[axis] = $d935c418012fa4cd$export$643aca61b9318da8(beginMask, begin, strides, inputShape, axis, ellipsisMask);
        normalizedEnd[axis] = $d935c418012fa4cd$export$612a961a199ffe65(endMask, end, strides, inputShape, axis, ellipsisMask);
        normalizedStrides[axis] = $d935c418012fa4cd$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask);
    }
    return {
        begin: normalizedBegin,
        end: normalizedEnd,
        strides: normalizedStrides
    };
}
function $d935c418012fa4cd$export$a9f0de12634a4ce3(beginMask, ellipsisInsertionIndex, numElidedAxes, originalBegin, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $d935c418012fa4cd$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = 0;
    else {
        const originalAxis = $d935c418012fa4cd$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalBegin[originalAxis];
        if (beginMask & 1 << originalAxis) originalValue = 0;
        newIndices[axis] = originalValue;
    }
    return newIndices;
}
function $d935c418012fa4cd$export$19a416bd7e87244f(endMask, ellipsisInsertionIndex, numElidedAxes, originalEnd, inputShape) {
    const newIndices = [
        ...inputShape
    ];
    const elidedAxes = $d935c418012fa4cd$var$getElidedAxes(numElidedAxes, ellipsisInsertionIndex);
    for(let axis = 0; axis < newIndices.length; axis++)if (elidedAxes.indexOf(axis) > -1) newIndices[axis] = Number.MAX_SAFE_INTEGER;
    else {
        const originalAxis = $d935c418012fa4cd$var$unnormalizeAxis(ellipsisInsertionIndex, numElidedAxes, axis);
        let originalValue = originalEnd[originalAxis];
        if (endMask & 1 << originalAxis) originalValue = Number.MAX_SAFE_INTEGER;
        newIndices[axis] = originalValue;
    }
    for(let i = 0; i < newIndices.length; i++){
        // Handle negative indices
        const axisSize = inputShape[i];
        if (newIndices[i] < 0) newIndices[i] += axisSize;
        newIndices[i] = $eOiOM.clamp(0, newIndices[i], inputShape[i]);
    }
    return newIndices;
}
function $d935c418012fa4cd$export$9e3fd91f45c1f07f(strides, axis, ellipsisMask) {
    let stride = strides[axis];
    if (ellipsisMask & 1 << axis || stride == null) stride = 1;
    return stride;
}
function $d935c418012fa4cd$export$643aca61b9318da8(beginMask, startIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let start = startIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or the begin index is not set
    // for the axis.
    if (beginMask & 1 << axis || ellipsisMask & 1 << axis || start == null) {
        if (stride > 0) // Forward iteration - use the first element. These values will get
        // clamped below (Note: We could have set them to 0 and axis_size-1, but
        // use lowest() and max() to maintain symmetry with StopForAxis())
        start = Number.MIN_SAFE_INTEGER;
        else // Backward iteration - use the last element.
        start = Number.MAX_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (start < 0) start += axisSize;
    // Clamping
    start = $eOiOM.clamp(0, start, axisSize - 1);
    return start;
}
function $d935c418012fa4cd$export$612a961a199ffe65(endMask, stopIndices, strides, inputShape, axis, ellipsisMask) {
    // Begin with the specified index
    let stop = stopIndices[axis];
    const stride = strides[axis] || 1;
    // Check the axis bit from right of masked axes, or if the stop index is not
    // set for this axis.
    if (endMask & 1 << axis || ellipsisMask & 1 << axis || stop == null) {
        if (stride > 0) // Forward iteration - use the last element. These values will get
        // clamped below
        stop = Number.MAX_SAFE_INTEGER;
        else // Backward iteration - use the first element.
        stop = Number.MIN_SAFE_INTEGER;
    }
    // Handle negative indices
    const axisSize = inputShape[axis];
    if (stop < 0) stop += axisSize;
    // Clamping
    // Because the end index points one past the last element, we need slightly
    // different clamping ranges depending on the direction.
    if (stride > 0) // Forward iteration
    stop = $eOiOM.clamp(0, stop, axisSize);
    else // Backward iteration
    stop = $eOiOM.clamp(-1, stop, axisSize - 1);
    return stop;
}
function $d935c418012fa4cd$export$9dc11bd6855e72c6(shape, begin, size) {
    // Index of the first axis that has size > 1.
    let firstNonOneAxis = size.length;
    for(let i = 0; i < size.length; i++)if (size[i] > 1) {
        firstNonOneAxis = i;
        break;
    }
    for(let i = firstNonOneAxis + 1; i < size.length; i++){
        if (begin[i] > 0 || size[i] !== shape[i]) return false;
    }
    return true;
}
function $d935c418012fa4cd$export$b01553f5da8f819c(begin, strides) {
    let flatOffset = begin.length > 0 ? begin[begin.length - 1] : 1;
    for(let i = 0; i < begin.length - 1; i++)flatOffset += begin[i] * strides[i];
    return flatOffset;
}
function $d935c418012fa4cd$export$8448a0604fef5d62(x, begin, size) {
    // The following logic allows for more ergonomic calls.
    let begin_;
    const xRank = x.shape.length;
    if (typeof begin === 'number') begin_ = [
        begin,
        ...new Array(xRank - 1).fill(0)
    ];
    else if (begin.length < xRank) begin_ = begin.concat(new Array(xRank - begin.length).fill(0));
    else begin_ = begin.slice();
    begin_.forEach((d)=>{
        $eOiOM.assert(d !== -1, ()=>'slice() does not support negative begin indexing.');
    });
    let size_;
    if (size == null) size_ = new Array(xRank).fill(-1);
    else if (typeof size === 'number') size_ = [
        size,
        ...new Array(xRank - 1).fill(-1)
    ];
    else if (size.length < xRank) size_ = size.concat(new Array(xRank - size.length).fill(-1));
    else size_ = size;
    size_ = size_.map((d, i)=>{
        if (d >= 0) return d;
        else {
            $eOiOM.assert(d === -1, ()=>`Negative size values should be exactly -1 but got ` + `${d} for the slice() size at index ${i}.`);
            return x.shape[i] - begin_[i];
        }
    });
    return [
        begin_,
        size_
    ];
}
function $d935c418012fa4cd$export$54d224865abb6767(xShape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
    let stridesNonNull;
    if (strides == null) {
        stridesNonNull = new Array(begin.length);
        stridesNonNull.fill(1);
    } else stridesNonNull = strides;
    // Only one non-zero bit is allowed in ellipsisMask, which means ellipsisMask
    // is a power of 2. Use bit compares to ensure ellipsisMask is 0 or a power
    // of 2. When i is a power of 2, i & (i - 1) is always 0.
    // Also ref:
    // https://stackoverflow.com/questions/600293/how-to-check-if-a-number-is-a-power-of-2
    if (ellipsisMask != null && (ellipsisMask & ellipsisMask - 1) !== 0) throw new Error('Multiple ellipses in slice is not allowed.');
    // Step 1: Account for ellipsis and new axis.
    // Check for ellipsis and count how many non-newaxis there are after.
    let ellipsisSeen = false;
    const sparseSpec = {
        dims: stridesNonNull.length,
        numAddAxisAfterEllipsis: 0,
        begin: begin.slice(),
        end: end.slice(),
        strides: stridesNonNull.slice(),
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    for(let i = 0; i < sparseSpec.dims; i++){
        if (ellipsisSeen && (1 << i & newAxisMask) !== 0) sparseSpec.numAddAxisAfterEllipsis++;
        if (1 << i & ellipsisMask) ellipsisSeen = true;
    }
    // If no ellipsis insert one at the end.
    if (!ellipsisSeen) {
        sparseSpec.ellipsisMask |= 1 << sparseSpec.dims;
        sparseSpec.dims++; // this effects loop iteration below
    }
    // Step 2: Make a sparse spec into a full index spec.
    //
    // The sparse spec deos not correspond to the number of dimensions.
    // Make a dense spec that cooresponds to the number of dimensions.
    //
    // For example suppose foo[...,3:] on foo.shape = [2, 2, 3] then we need to
    // produce the missing beginMask for the first two dimensions i.e. from
    // beginMaskSpec = 0, endMaskSpec = 2, we achieve beginMask = 6 (110),
    // endMask = 7 (111).
    const denseSpec = {
        dims: xShape.length,
        beginMask: 0,
        endMask: 0,
        beginValid: false,
        endValid: false
    };
    $d935c418012fa4cd$var$buildDenseSpec(sparseSpec, denseSpec);
    // Step 3: Make implicit ranges (non-zero beginMasks and endMasks) explicit
    // and bounds check.
    let isIdentity = true;
    let sliceDim0 = true;
    let isSimpleSlice = true;
    const processingShape = [];
    const finalShape = [];
    for(let i = 0; i < xShape.length; ++i){
        if (denseSpec.strides[i] === 0) throw Error(`strides[${i}] must be non-zero`);
        const shrinkI = !!(denseSpec.shrinkAxisMask & 1 << i);
        const dimI = xShape[i];
        if (dimI === -1) {
            processingShape.push(shrinkI ? 1 : -1);
            continue;
        }
        const masks = [
            denseSpec.beginMask & 1 << i,
            denseSpec.endMask & 1 << i
        ];
        const validRange = [
            denseSpec.strides[i] > 0 ? 0 : -1,
            denseSpec.strides[i] > 0 ? dimI : dimI - 1
        ];
        if (shrinkI && denseSpec.strides[i] <= 0) throw Error('only stride 1 allowed on non-range indexing.');
        isSimpleSlice = isSimpleSlice && denseSpec.strides[i] === 1;
        const beginAndEndMasked = !!(denseSpec.beginMask & 1 << i && denseSpec.endMask & 1 << i);
        if (denseSpec.beginValid && denseSpec.endValid) {
            if (shrinkI) {
                // If we are shrinking, the end index is now possibly incorrect. In
                // particular foo[-1] produces sparseBegin = -1, sparseEnd = 0.
                // and canonical puts these to n-1 and 0, which implies a degenerate
                // interval. Fortunately, it is now safe to re-create end as begin + 1.
                const xFwd = denseSpec.begin[i] < 0 ? dimI + denseSpec.begin[i] : denseSpec.begin[i];
                denseSpec.begin[i] = xFwd;
                denseSpec.end[i] = denseSpec.begin[i] + 1;
                if (xFwd < 0 || xFwd >= dimI) throw Error(`slice index ${denseSpec.begin[i]} of dimension ${i} out of bounds.`);
            } else {
                denseSpec.begin[i] = $d935c418012fa4cd$var$canonical(denseSpec.begin[i], 0, denseSpec.strides[i], dimI, masks, validRange);
                denseSpec.end[i] = $d935c418012fa4cd$var$canonical(denseSpec.end[i], 1, denseSpec.strides[i], dimI, masks, validRange);
            }
            // Update optimization values
            const takeAllInDimension = denseSpec.strides[i] === 1 && denseSpec.begin[i] === 0 && denseSpec.end[i] === dimI;
            isIdentity = isIdentity && takeAllInDimension;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || takeAllInDimension);
        } else {
            isIdentity = isIdentity && denseSpec.strides[i] === 1 && beginAndEndMasked;
            sliceDim0 = sliceDim0 && (i === 0 && denseSpec.strides[i] === 1 || beginAndEndMasked);
        }
        // Compute the processing shape (the intermediate Eigen will produce)
        let intervalLength;
        let knownInterval = false;
        if (denseSpec.beginValid && denseSpec.endValid) {
            intervalLength = denseSpec.end[i] - denseSpec.begin[i];
            knownInterval = true;
        } else if (shrinkI) {
            // The dimension is still known as 1 for the processingShape, but will be
            // discarded for the final shape.
            intervalLength = 1;
            knownInterval = true;
        } else if (beginAndEndMasked) // Even if we don't have values for begin or end, we do know that this
        // dimension covers the whole interval. If we have shape information for
        // this dimension, that tells us the interval length.
        {
            if (dimI >= 0) {
                if (denseSpec.strides[i] < 0) intervalLength = -dimI;
                else intervalLength = dimI;
                knownInterval = true;
            }
        }
        if (knownInterval) {
            let sizeI;
            // Hold zero if the interval is degenerate, otherwise account for
            // remainder
            if (intervalLength === 0 || intervalLength < 0 !== denseSpec.strides[i] < 0) sizeI = 0;
            else sizeI = Math.trunc(intervalLength / denseSpec.strides[i]) + (intervalLength % denseSpec.strides[i] !== 0 ? 1 : 0);
            processingShape.push(sizeI);
        } else processingShape.push(-1);
    }
    // Step 4: Compute the final shape
    //
    // newAxis will increase dimension by 1 (with a one-size dimension)
    // slices like foo[3, ...] will reduce dimension by 1.
    // This cannot be done earlier, because it depends on Step 3.
    for(let denseDim = 0; denseDim < denseSpec.finalShapeGatherIndices.length; ++denseDim){
        const gatherIndex = denseSpec.finalShapeGatherIndices[denseDim];
        if (gatherIndex >= 0) finalShape.push(processingShape[gatherIndex]);
        else if (gatherIndex === $d935c418012fa4cd$var$NEW_AXIS) finalShape.push(1);
    }
    const finalShapeSparse = finalShape.filter((dim, i)=>denseSpec.finalShapeGatherIndices[i] !== $d935c418012fa4cd$var$NEW_AXIS);
    return {
        finalShapeSparse: finalShapeSparse,
        finalShape: finalShape,
        isIdentity: isIdentity,
        sliceDim0: sliceDim0,
        isSimpleSlice: isSimpleSlice,
        begin: denseSpec.begin,
        end: denseSpec.end,
        strides: denseSpec.strides
    };
}
function $d935c418012fa4cd$var$buildDenseSpec(sparse, dense) {
    dense.beginMask = 0;
    dense.endMask = 0;
    dense.shrinkAxisMask = 0;
    let fullIndex = 0;
    dense.beginValid = sparse.begin != null;
    dense.endValid = sparse.end != null;
    dense.begin = new Array(dense.dims);
    dense.end = new Array(dense.dims);
    dense.strides = new Array(dense.dims);
    dense.finalShapeGatherIndices = [];
    dense.finalShapeGatherIndicesSparse = [];
    dense.inputShapeGatherIndicesSparse = new Array(dense.dims);
    for(let i = 0; i < sparse.dims; i++){
        if (1 << i & sparse.ellipsisMask) {
            // Only the bit that has ellipsis will fall in this condition.
            // Expand the ellipsis into the appropriate indices
            // Note: this only works because we guaranteed one ellipsis.
            const nextIndex = Math.min(dense.dims - (sparse.dims - i) + 1 + sparse.numAddAxisAfterEllipsis, dense.dims);
            for(; fullIndex < nextIndex; fullIndex++){
                // newAxis aren't real axis so you have to skip.
                dense.begin[fullIndex] = 0;
                dense.end[fullIndex] = 0;
                dense.strides[fullIndex] = 1;
                dense.beginMask |= 1 << fullIndex;
                dense.endMask |= 1 << fullIndex;
                dense.finalShapeGatherIndices.push(fullIndex);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            }
        } else if (1 << i & sparse.newAxisMask) {
            // Only the bit that has newAxis will fall in this condition.
            dense.finalShapeGatherIndices.push($d935c418012fa4cd$var$NEW_AXIS);
            dense.finalShapeGatherIndicesSparse.push(-1);
        } else {
            if (fullIndex === dense.begin.length) throw Error(`Index out of range using input dim ${fullIndex}; input ` + `has only ${dense.dims} dims, ${dense.begin.length}.`);
            // Gather slicing spec into appropriate index.
            if (sparse.begin != null) dense.begin[fullIndex] = sparse.begin[i];
            if (sparse.end != null) dense.end[fullIndex] = sparse.end[i];
            dense.strides[fullIndex] = sparse.strides[i];
            if (sparse.beginMask & 1 << i) dense.beginMask |= 1 << fullIndex;
            if (sparse.endMask & 1 << i) dense.endMask |= 1 << fullIndex;
            // If shrink, record where to get the dimensionality from (i.e. newAxis)
            // creates a fake 1 size dimension. Also remember shrink axis (now in
            // dense form) so we can ignore dense.end below.
            if (sparse.shrinkAxisMask & 1 << i) {
                dense.finalShapeGatherIndices.push($d935c418012fa4cd$var$SHRINK_AXIS);
                dense.finalShapeGatherIndicesSparse.push(-1);
                dense.shrinkAxisMask |= 1 << fullIndex;
            } else {
                dense.finalShapeGatherIndices.push(fullIndex);
                // Remember that where in the sparse shape the dense dim comes from.
                dense.finalShapeGatherIndicesSparse.push(i);
            }
            dense.inputShapeGatherIndicesSparse[fullIndex] = i;
            fullIndex++;
        }
    }
}
function $d935c418012fa4cd$var$canonical(x, c, strideI, dimI, masks, validRange) {
    if (masks[c]) return strideI > 0 ? validRange[c] : validRange[c + 1 & 1];
    else {
        const xFwd = x < 0 ? dimI + x : x; // make negative indices positive
        return xFwd < validRange[0] ? validRange[0] : xFwd > validRange[1] ? validRange[1] : xFwd;
    }
}

});

parcelRegister("eIcNJ", function(module, exports) {

$parcel$export(module.exports, "getImageCenter", function () { return $ab5f1acd648a458c$export$3c8762d0dab347aa; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Returns the image center in pixels.
function $ab5f1acd648a458c$export$3c8762d0dab347aa(center, imageHeight, imageWidth) {
    const centerX = imageWidth * (typeof center === 'number' ? center : center[0]);
    const centerY = imageHeight * (typeof center === 'number' ? center : center[1]);
    return [
        centerX,
        centerY
    ];
}

});

parcelRegister("i07oL", function(module, exports) {

$parcel$export(module.exports, "getReshaped", function () { return $d1adf73b4f484330$export$4a6fd6a82dc667e2; });
$parcel$export(module.exports, "getPermuted", function () { return $d1adf73b4f484330$export$4def7dccf4cfc2e9; });
$parcel$export(module.exports, "getReshapedPermuted", function () { return $d1adf73b4f484330$export$2435a8b57f99e080; });
$parcel$export(module.exports, "getSliceBeginCoords", function () { return $d1adf73b4f484330$export$b9a01540baa98f86; });
$parcel$export(module.exports, "getSliceSize", function () { return $d1adf73b4f484330$export$2457416ec9e0c8d3; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Gets the new shape of the input Tensor after it's been reshaped
 * to:
 * [blockShape[0], ..., blockShape[M-1], batch / prod(blockShape),
 * inputShape[1], ..., inputShape[N-1]]
 *
 * See step 1: https://www.tensorflow.org/api_docs/python/tf/batch_to_space_nd
 */ function $d1adf73b4f484330$export$4a6fd6a82dc667e2(inputShape, blockShape, prod, batchToSpace = true) {
    let reshaped = [];
    if (batchToSpace) {
        reshaped = reshaped.concat(blockShape.slice(0));
        reshaped.push(inputShape[0] / prod);
        reshaped = reshaped.concat(inputShape.slice(1));
    } else {
        reshaped = reshaped.concat(inputShape[0]);
        const spatialLength = blockShape.length;
        for(let i = 0; i < spatialLength; ++i)reshaped = reshaped.concat([
            inputShape[i + 1] / blockShape[i],
            blockShape[i]
        ]);
        reshaped = reshaped.concat(inputShape.slice(spatialLength + 1));
    }
    return reshaped;
}
function $d1adf73b4f484330$export$4def7dccf4cfc2e9(reshapedRank, blockShapeRank, batchToSpace = true) {
    const permuted = [];
    if (batchToSpace) {
        permuted.push(blockShapeRank);
        for(let i = blockShapeRank + 1; i < reshapedRank; ++i)if (i <= 2 * blockShapeRank) {
            permuted.push(i);
            permuted.push(i - (blockShapeRank + 1));
        } else permuted.push(i);
    } else {
        const permutedBeforeBatch = [];
        const permutedAfterBatch = [];
        for(let i = 1; i < reshapedRank; ++i)if (i >= blockShapeRank * 2 + 1 || i % 2 === 1) permutedAfterBatch.push(i);
        else permutedBeforeBatch.push(i);
        permuted.push(...permutedBeforeBatch);
        permuted.push(0);
        permuted.push(...permutedAfterBatch);
    }
    return permuted;
}
function $d1adf73b4f484330$export$2435a8b57f99e080(inputShape, blockShape, prod, batchToSpace = true) {
    const reshapedPermuted = [];
    if (batchToSpace) reshapedPermuted.push(inputShape[0] / prod);
    else reshapedPermuted.push(inputShape[0] * prod);
    for(let i = 1; i < inputShape.length; ++i)if (i <= blockShape.length) {
        if (batchToSpace) reshapedPermuted.push(blockShape[i - 1] * inputShape[i]);
        else reshapedPermuted.push(inputShape[i] / blockShape[i - 1]);
    } else reshapedPermuted.push(inputShape[i]);
    return reshapedPermuted;
}
function $d1adf73b4f484330$export$b9a01540baa98f86(crops, blockShape) {
    const sliceBeginCoords = [
        0
    ];
    for(let i = 0; i < blockShape; ++i)sliceBeginCoords.push(crops[i][0]);
    return sliceBeginCoords;
}
function $d1adf73b4f484330$export$2457416ec9e0c8d3(uncroppedShape, crops, blockShape) {
    const sliceSize = uncroppedShape.slice(0, 1);
    for(let i = 0; i < blockShape; ++i)sliceSize.push(uncroppedShape[i + 1] - crops[i][0] - crops[i][1]);
    return sliceSize;
}

});

parcelRegister("bjlpb", function(module, exports) {

$parcel$export(module.exports, "prepareAndValidate", function () { return $83c212aafb3b5b76$export$6bb34ea9be10068f; });

var $eOiOM = parcelRequire("eOiOM");
function $83c212aafb3b5b76$export$6bb34ea9be10068f(tensor, indices) {
    const tensorRank = tensor.shape.length;
    const indicesRank = indices.shape.length;
    if (tensorRank < 1) throw new Error('tf.gatherND() expects the input to be rank 1 or higher,' + ` but the rank was ${tensorRank}.`);
    if (indicesRank < 1) throw new Error('tf.gatherND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indicesRank}.`);
    if (indices.dtype !== 'int32') throw new Error('tf.gatherND() expects the indices to be int32 type,' + ` but the dtype was ${indices.dtype}.`);
    if (indices.shape[indicesRank - 1] > tensorRank) throw new Error('index innermost dimension length must be <= tensor rank; saw: ' + `${indices.shape[indicesRank - 1]} vs. ${tensorRank}`);
    if ((0, $eOiOM.sizeFromShape)(tensor.shape) === 0) throw new Error('Requested more than 0 entries, but input is empty.' + ` Input shape: ${tensor.shape}.`);
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    // The result shape is
    //   indices.shape[:-1] + params.shape[indices.shape[-1]:]
    let nResult = 1;
    for(let i = 0; i < indicesShape.length - 1; ++i)nResult *= indicesShape[i];
    const inputShape = tensor.shape;
    const resultShape = indicesShape.slice();
    resultShape.pop();
    let sliceSize = 1;
    for(let i = sliceRank; i < tensorRank; ++i){
        sliceSize *= inputShape[i];
        resultShape.push(inputShape[i]);
    }
    const strides = [
        ...(0, $eOiOM.computeStrides)(tensor.shape).map((stride)=>stride / sliceSize),
        1
    ].slice(0, sliceRank);
    return [
        resultShape,
        nResult,
        sliceSize,
        strides
    ];
}

});

parcelRegister("hyHdD", function(module, exports) {

$parcel$export(module.exports, "validateUpdateShape", function () { return $cc8723074412e8da$export$9d843bc97e7022ed; });
$parcel$export(module.exports, "validateInput", function () { return $cc8723074412e8da$export$4d09d4ac8ba225dd; });
$parcel$export(module.exports, "calculateShapes", function () { return $cc8723074412e8da$export$4dc1a8917bf18661; });

var $eOiOM = parcelRequire("eOiOM");
function $cc8723074412e8da$export$9d843bc97e7022ed(shape, indices, updates) {
    const sliceDim = indices.rank > 1 ? indices.shape[indices.rank - 1] : 1;
    const batchDim = indices.rank > 1 ? indices.rank - 1 : 1;
    const shapeError = 'Must have updates.shape = indices.shape[:batchDim] + ' + `shape[sliceDim:], got updates.shape: ${updates.shape}` + `, indices.shape: ${indices.shape}, shape: ${shape}` + `, sliceDim: ${sliceDim}, and batchDim: ${batchDim}.`;
    if (updates.rank < batchDim) throw new Error(shapeError + ` update.rank < ${batchDim}. `);
    if (shape.length < sliceDim + (updates.rank - batchDim)) throw new Error(shapeError + ` Output shape length < ${sliceDim + (updates.rank - batchDim)}`);
    if (updates.rank !== batchDim + shape.length - sliceDim) throw new Error(shapeError + ` update.rank != ${batchDim + shape.length - sliceDim}`);
    for(let d = 0; d < batchDim; ++d){
        if (updates.shape[d] !== indices.shape[d]) throw new Error(shapeError + ` updates.shape[${d}] (${updates.shape[d]}) != indices.shape[${d}] (${indices.shape[d]}).`);
    }
    for(let d = 0; d < updates.rank - batchDim; ++d){
        if (updates.shape[d + batchDim] !== shape[d + sliceDim]) throw new Error(shapeError + ` updates.shape[${d + batchDim}] (${updates.shape[d + batchDim]}) != shape[${d + batchDim}] (${shape[d + batchDim]})`);
    }
}
function $cc8723074412e8da$export$4d09d4ac8ba225dd(updates, indices, shape) {
    if (indices.rank < 1) throw new Error('tf.scatterND() expects the indices to be rank 1 or higher,' + ` but the rank was ${indices.rank}.`);
    if (updates.rank < 1) throw new Error('tf.scatterND() expects the updates to be rank 1 or higher,' + ` but the rank was ${updates.rank}.`);
    if (indices.dtype !== 'int32') throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${indices.dtype}`);
    if (shape.length < 1) throw new Error(`Output rank must be greater or equal to 1, but got shape: ${shape}`);
    if (shape.length === 0) {
        if (indices.size === 0) throw new Error(`Indices specified for empty output. indices shape: ${indices.shape}`);
        if (updates.size === 0) throw new Error(`Updates specified for empty output. updates shape: ${updates.shape}`);
    }
    $cc8723074412e8da$export$9d843bc97e7022ed(shape, indices, updates);
}
function $cc8723074412e8da$export$4dc1a8917bf18661(updates, indices, shape) {
    // Calculate the number of dimensions in indices
    const indicesRank = indices.shape.length;
    const sliceRank = indicesRank > 1 ? indices.shape[indicesRank - 1] : 1;
    // Calculate the number of elements that make up each slice of our updated
    // tensor. This allows us to work with flattened tensors and copy over whole
    // slices at a time.
    const totalNd = shape.length;
    let sliceSize = 1;
    for(let i = sliceRank; i < totalNd; ++i)sliceSize *= shape[i];
    const safeSliceDim = sliceRank < 1 ? 1 : sliceRank;
    const numUpdates = (0, $eOiOM.sizeFromShape)(indices.shape) / safeSliceDim;
    const strides = [
        ...(0, $eOiOM.computeStrides)(shape.slice(0, sliceRank)),
        1
    ];
    const outputSize = (0, $eOiOM.sizeFromShape)(shape);
    return {
        sliceRank: sliceRank,
        numUpdates: numUpdates,
        sliceSize: sliceSize,
        strides: strides,
        outputSize: outputSize
    };
}

});

parcelRegister("2wK3w", function(module, exports) {

$parcel$export(module.exports, "SELU_SCALEALPHA", function () { return $1d724baa3693a314$export$49dc487a025ce2d0; });
$parcel$export(module.exports, "SELU_SCALE", function () { return $1d724baa3693a314$export$e6ebc294ea9ea7e7; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $1d724baa3693a314$export$49dc487a025ce2d0 = 1.7580993408473768599402175208123;
const $1d724baa3693a314$export$e6ebc294ea9ea7e7 = 1.0507009873554804934193349852946;

});

parcelRegister("1UMed", function(module, exports) {

$parcel$export(module.exports, "ERF_P", function () { return $16506e85fd67e3bf$export$5588b9ca3e514e43; });
$parcel$export(module.exports, "ERF_A1", function () { return $16506e85fd67e3bf$export$2ac384940e9cdd31; });
$parcel$export(module.exports, "ERF_A2", function () { return $16506e85fd67e3bf$export$db2d4485da836713; });
$parcel$export(module.exports, "ERF_A3", function () { return $16506e85fd67e3bf$export$644ec7b31d43803f; });
$parcel$export(module.exports, "ERF_A4", function () { return $16506e85fd67e3bf$export$904f8b3bbafadf78; });
$parcel$export(module.exports, "ERF_A5", function () { return $16506e85fd67e3bf$export$e40fe2da7629526; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $16506e85fd67e3bf$export$5588b9ca3e514e43 = 0.3275911;
const $16506e85fd67e3bf$export$2ac384940e9cdd31 = 0.254829592;
const $16506e85fd67e3bf$export$db2d4485da836713 = -0.284496736;
const $16506e85fd67e3bf$export$644ec7b31d43803f = 1.421413741;
const $16506e85fd67e3bf$export$904f8b3bbafadf78 = -1.453152027;
const $16506e85fd67e3bf$export$e40fe2da7629526 = 1.061405429;

});

parcelRegister("leoEe", function(module, exports) {

$parcel$export(module.exports, "mergeRealAndImagArrays", function () { return $f74e0652bf659e6f$export$e54cb13fcd32a531; });
$parcel$export(module.exports, "splitRealAndImagArrays", function () { return $f74e0652bf659e6f$export$fa0ac0984ed1da1c; });
$parcel$export(module.exports, "complexWithEvenIndex", function () { return $f74e0652bf659e6f$export$270b4351d25667e0; });
$parcel$export(module.exports, "complexWithOddIndex", function () { return $f74e0652bf659e6f$export$36193f08102303b4; });
$parcel$export(module.exports, "getComplexWithIndex", function () { return $f74e0652bf659e6f$export$628d071452d50aaf; });
$parcel$export(module.exports, "assignToTypedArray", function () { return $f74e0652bf659e6f$export$b7f57c25a82b9fba; });
$parcel$export(module.exports, "exponents", function () { return $f74e0652bf659e6f$export$7d98ee6b5f9e9f08; });
$parcel$export(module.exports, "exponent", function () { return $f74e0652bf659e6f$export$abde88043842a778; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Merges real and imaginary Float32Arrays into a single complex Float32Array.
 *
 * The memory layout is interleaved as follows:
 * real: [r0, r1, r2]
 * imag: [i0, i1, i2]
 * complex: [r0, i0, r1, i1, r2, i2]
 *
 * This is the inverse of splitRealAndImagArrays.
 *
 * @param real The real values of the complex tensor values.
 * @param imag The imag values of the complex tensor values.
 * @returns A complex tensor as a Float32Array with merged values.
 */ function $f74e0652bf659e6f$export$e54cb13fcd32a531(real, imag) {
    if (real.length !== imag.length) throw new Error(`Cannot merge real and imag arrays of different lengths. real:` + `${real.length}, imag: ${imag.length}.`);
    const result = new Float32Array(real.length * 2);
    for(let i = 0; i < result.length; i += 2){
        result[i] = real[i / 2];
        result[i + 1] = imag[i / 2];
    }
    return result;
}
function $f74e0652bf659e6f$export$fa0ac0984ed1da1c(complex) {
    const real = new Float32Array(complex.length / 2);
    const imag = new Float32Array(complex.length / 2);
    for(let i = 0; i < complex.length; i += 2){
        real[i / 2] = complex[i];
        imag[i / 2] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $f74e0652bf659e6f$export$270b4351d25667e0(complex) {
    const len = Math.ceil(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 0; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $f74e0652bf659e6f$export$36193f08102303b4(complex) {
    const len = Math.floor(complex.length / 4);
    const real = new Float32Array(len);
    const imag = new Float32Array(len);
    for(let i = 2; i < complex.length; i += 4){
        real[Math.floor(i / 4)] = complex[i];
        imag[Math.floor(i / 4)] = complex[i + 1];
    }
    return {
        real: real,
        imag: imag
    };
}
function $f74e0652bf659e6f$export$628d071452d50aaf(complex, index) {
    const real = complex[index * 2];
    const imag = complex[index * 2 + 1];
    return {
        real: real,
        imag: imag
    };
}
function $f74e0652bf659e6f$export$b7f57c25a82b9fba(data, real, imag, index) {
    data[index * 2] = real;
    data[index * 2 + 1] = imag;
}
function $f74e0652bf659e6f$export$7d98ee6b5f9e9f08(n, inverse) {
    const real = new Float32Array(n / 2);
    const imag = new Float32Array(n / 2);
    for(let i = 0; i < Math.ceil(n / 2); i++){
        const x = (inverse ? 2 : -2) * Math.PI * (i / n);
        real[i] = Math.cos(x);
        imag[i] = Math.sin(x);
    }
    return {
        real: real,
        imag: imag
    };
}
function $f74e0652bf659e6f$export$abde88043842a778(k, n, inverse) {
    const x = (inverse ? 2 : -2) * Math.PI * (k / n);
    const real = Math.cos(x);
    const imag = Math.sin(x);
    return {
        real: real,
        imag: imag
    };
}

});

parcelRegister("i9Nqj", function(module, exports) {

$parcel$export(module.exports, "decodeEinsumEquation", function () { return $d37f67b0e0640c57$export$2f615958577142db; });
$parcel$export(module.exports, "getEinsumPermutation", function () { return $d37f67b0e0640c57$export$ce55bd5175fdcdbf; });
$parcel$export(module.exports, "checkEinsumDimSizes", function () { return $d37f67b0e0640c57$export$40ac7c38e2986bbe; });
$parcel$export(module.exports, "getEinsumComputePath", function () { return $d37f67b0e0640c57$export$3f6835c0d48b762d; });
$parcel$export(module.exports, "isIdentityPermutation", function () { return $d37f67b0e0640c57$export$6a8a32f5fc3d978e; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
const $d37f67b0e0640c57$var$ARROW = '->';
const $d37f67b0e0640c57$var$ARROW_REGEX = /->/g;
const $d37f67b0e0640c57$var$COMMA = ',';
const $d37f67b0e0640c57$var$ELLIPSIS = '...';
function $d37f67b0e0640c57$export$2f615958577142db(equation, numTensors) {
    equation = equation.replace(/\s/g, ''); // Remove witespace in equation.
    const numArrows = (equation.length - equation.replace($d37f67b0e0640c57$var$ARROW_REGEX, '').length) / $d37f67b0e0640c57$var$ARROW.length;
    if (numArrows < 1) throw new Error('Equations without an arrow are not supported.');
    else if (numArrows > 1) throw new Error(`Equation must contain exactly one arrow ("${$d37f67b0e0640c57$var$ARROW}").`);
    const [inputString, outputString] = equation.split($d37f67b0e0640c57$var$ARROW);
    (0, $eOiOM.assert)(inputString.indexOf($d37f67b0e0640c57$var$ELLIPSIS) === -1, ()=>`The ellipsis notation ("${$d37f67b0e0640c57$var$ELLIPSIS}") is not supported yet.`);
    const inputTerms = inputString.split($d37f67b0e0640c57$var$COMMA);
    const numInputs = inputTerms.length;
    if (numTensors !== numInputs) throw new Error(`Expected ${numInputs} input tensors, received ${numTensors}`);
    if (numInputs > 2) throw new Error('Support for more than 2 input tensors is not implemented yet.');
    const allDims = [];
    for(let i = 0; i < outputString.length; ++i){
        const dimName = outputString[i];
        if (!inputTerms.some((inputTerm)=>inputTerm.indexOf(dimName) !== -1)) throw new Error(`Output subscripts contain the label ${dimName} ` + `not present in the input subscripts.`);
        if (allDims.indexOf(dimName) === -1) allDims.push(dimName);
    }
    for(let i = 0; i < inputString.length; ++i){
        const dimName = inputString[i];
        if (allDims.indexOf(dimName) === -1 && dimName !== $d37f67b0e0640c57$var$COMMA) allDims.push(dimName);
    }
    const idDims = new Array(inputTerms.length);
    for(let i = 0; i < numInputs; ++i){
        if (new Set(inputTerms[i].split('')).size !== inputTerms[i].length) throw new Error(`Found duplicate axes in input component ${inputTerms[i]}. ` + `Support for duplicate axes in input is not implemented yet.`);
        idDims[i] = [];
        for(let j = 0; j < inputTerms[i].length; ++j)idDims[i].push(allDims.indexOf(inputTerms[i][j]));
    }
    const numDims = allDims.length; // Number of unique dimensions.
    const numOutDims = outputString.length; // Number of output dimensions.
    const summedDims = []; // Dimensions being summed over.
    for(let i = numOutDims; i < numDims; ++i)summedDims.push(i);
    return {
        allDims: allDims,
        summedDims: summedDims,
        idDims: idDims
    };
}
function $d37f67b0e0640c57$export$ce55bd5175fdcdbf(nDims, idDims) {
    let permutationIndices = new Array(nDims);
    permutationIndices.fill(-1);
    for(let i = 0; i < idDims.length; ++i)permutationIndices[idDims[i]] = i;
    const expandDims = [];
    for(let i = 0; i < nDims; ++i)if (permutationIndices[i] === -1) expandDims.push(i);
    permutationIndices = permutationIndices.filter((d)=>d !== -1);
    return {
        permutationIndices: permutationIndices,
        expandDims: expandDims
    };
}
function $d37f67b0e0640c57$export$40ac7c38e2986bbe(nDims, idDims, tensors) {
    const dimSizes = new Array(nDims);
    for(let i = 0; i < tensors.length; ++i){
        const shape = tensors[i].shape;
        for(let j = 0; j < idDims[i].length; ++j)if (dimSizes[idDims[i][j]] === undefined) dimSizes[idDims[i][j]] = shape[j];
        else (0, $eOiOM.assert)(dimSizes[idDims[i][j]] === shape[j], ()=>`Expected dimension ${dimSizes[idDims[i][j]]} at axis ${j} ` + `of input shaped ${JSON.stringify(shape)}, ` + `but got dimension ${shape[j]}`);
    }
}
function $d37f67b0e0640c57$export$3f6835c0d48b762d(summedDims, idDims) {
    const path = summedDims;
    const steps = [];
    let nSteps = 0;
    if (summedDims.length === 0) // Einsum that involes no summing: e.g., transpose and outer product.
    path.push(-1);
    nSteps = summedDims.length + 1;
    for(let i = 0; i < nSteps; ++i)steps.push([]);
    const computedTermIndices = [];
    for(let i = 0; i < path.length; ++i){
        const summedDim = path[i];
        const termIndices = $d37f67b0e0640c57$var$findTermsWithDim(idDims, summedDim);
        for (const termIndex of termIndices)if (computedTermIndices.indexOf(termIndex) === -1) {
            steps[i].push(termIndex);
            computedTermIndices.push(termIndex);
        }
    }
    return {
        path: path,
        steps: steps
    };
}
function $d37f67b0e0640c57$export$6a8a32f5fc3d978e(perm) {
    return perm.every((dim, index)=>dim === index);
}
function $d37f67b0e0640c57$var$findTermsWithDim(idDims, dim) {
    const termIndices = [];
    for(let i = 0; i < idDims.length; ++i)if (idDims[i].length === 0 || idDims[i].indexOf(dim) !== -1 || dim === -1) termIndices.push(i);
    return termIndices;
}

});

parcelRegister("hK9HE", function(module, exports) {

$parcel$export(module.exports, "prepareSplitSize", function () { return $ceae4258e407b3a4$export$b45a3b30df9d4b49; });

var $eOiOM = parcelRequire("eOiOM");
function $ceae4258e407b3a4$export$b45a3b30df9d4b49(x, numOrSizeSplits, axis = 0) {
    let splitSizes = [];
    if (typeof numOrSizeSplits === 'number') {
        (0, $eOiOM.assert)(x.shape[axis] % numOrSizeSplits === 0, ()=>'Number of splits must evenly divide the axis.');
        splitSizes = new Array(numOrSizeSplits).fill(x.shape[axis] / numOrSizeSplits);
    } else {
        const numOfNegs = numOrSizeSplits.reduce((count, value)=>{
            if (value === -1) count += 1;
            return count;
        }, 0);
        (0, $eOiOM.assert)(numOfNegs <= 1, ()=>'There should be only one negative value in split array.');
        const negIndex = numOrSizeSplits.indexOf(-1);
        // Allow the number of split array to be -1, which indicates the rest
        // of dimension is allocated to that split.
        if (negIndex !== -1) {
            const total = numOrSizeSplits.reduce((a, b)=>b > 0 ? a + b : a);
            numOrSizeSplits[negIndex] = x.shape[axis] - total;
        }
        (0, $eOiOM.assert)(x.shape[axis] === numOrSizeSplits.reduce((a, b)=>a + b), ()=>'The sum of sizes must match the size of the axis dimension.');
        splitSizes = numOrSizeSplits;
    }
    return splitSizes;
}

});

parcelRegister("2FTlH", function(module, exports) {

$parcel$export(module.exports, "getSparseFillEmptyRowsIndicesDenseShapeMismatch", function () { return $1f2a58494b2b3c57$export$afc2f2dec50723b1; });
$parcel$export(module.exports, "getSparseFillEmptyRowsNegativeIndexErrorMessage", function () { return $1f2a58494b2b3c57$export$69038529bd45dbce; });
$parcel$export(module.exports, "getSparseFillEmptyRowsOutOfRangeIndexErrorMessage", function () { return $1f2a58494b2b3c57$export$4179b115ac384c01; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse fill empty rows indices, dense shape mismatch error message.
 *
 * @param indicesLength The first dimension of indices.
 */ function $1f2a58494b2b3c57$export$afc2f2dec50723b1(indicesLength) {
    return `Received SparseTensor with denseShape[0] = 0 but
  indices.shape[0] = ${indicesLength}`;
}
function $1f2a58494b2b3c57$export$69038529bd45dbce(index, value) {
    return `indices(${index}, 0) is invalid: ${value} < 0`;
}
function $1f2a58494b2b3c57$export$4179b115ac384c01(index, value, limit) {
    return `indices(${index}, 0) is invalid: ${value} >= ${limit}`;
}

});

parcelRegister("7egzK", function(module, exports) {

$parcel$export(module.exports, "getSparseReshapeMultipleNegativeOneOutputDimErrorMessage", function () { return $5436b2c397eccba3$export$22b04105649d1e3d; });
$parcel$export(module.exports, "getSparseReshapeNegativeOutputDimErrorMessage", function () { return $5436b2c397eccba3$export$3350ee0ca4641eae; });
$parcel$export(module.exports, "getSparseReshapeEmptyTensorZeroOutputDimErrorMessage", function () { return $5436b2c397eccba3$export$632a7731cfb4dc4b; });
$parcel$export(module.exports, "getSparseReshapeInputOutputMultipleErrorMessage", function () { return $5436b2c397eccba3$export$6996eb40ec18f24; });
$parcel$export(module.exports, "getSparseReshapeInputOutputMismatchErrorMessage", function () { return $5436b2c397eccba3$export$7c74c1672e7ca2d1; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
function $5436b2c397eccba3$export$22b04105649d1e3d(dim1, dim2) {
    return `only one output dimension may be -1, not both ${dim1} and ${dim2}`;
}
function $5436b2c397eccba3$export$3350ee0ca4641eae(dim, value) {
    return `size ${dim} must be non-negative, not ${value}`;
}
function $5436b2c397eccba3$export$632a7731cfb4dc4b() {
    return "reshape cannot infer the missing input size for an empty tensor unless all specified input sizes are non-zero";
}
function $5436b2c397eccba3$export$6996eb40ec18f24(inputShape, outputShape) {
    const inputSize = (0, $eOiOM.sizeFromShape)(inputShape);
    const outputSize = (0, $eOiOM.sizeFromShape)(outputShape);
    return `Input to reshape is a SparseTensor with ${inputSize}
  dense values, but the requested shape requires a multiple of ${outputSize}. inputShape=${inputShape} outputShape= ${outputShape}`;
}
function $5436b2c397eccba3$export$7c74c1672e7ca2d1(inputShape, outputShape) {
    const inputSize = (0, $eOiOM.sizeFromShape)(inputShape);
    const outputSize = (0, $eOiOM.sizeFromShape)(outputShape);
    return `Input to reshape is a tensor with ${inputSize} dense values, but the requested shape has ${outputSize}. inputShape=${inputShape} outputShape=${outputShape}`;
}

});

parcelRegister("kYitN", function(module, exports) {

$parcel$export(module.exports, "getSparseSegmentReductionNegativeSegmentIdsErrorMessage", function () { return $f447beebab537d56$export$cb1b83ffdf66736; });
$parcel$export(module.exports, "getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage", function () { return $f447beebab537d56$export$6f5af72ace1661e1; });
$parcel$export(module.exports, "getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage", function () { return $f447beebab537d56$export$bdc282d2ae15e823; });
$parcel$export(module.exports, "getSparseSegmentReductionIndicesOutOfRangeErrorMessage", function () { return $f447beebab537d56$export$c470f477911f1cb7; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Generates sparse segment reduction negative segment ids error message.
 *
 */ function $f447beebab537d56$export$cb1b83ffdf66736() {
    return `segment ids must be >= 0`;
}
function $f447beebab537d56$export$6f5af72ace1661e1() {
    return `segment ids are not increasing`;
}
function $f447beebab537d56$export$bdc282d2ae15e823(segmentId, outputRows) {
    return `Segment id ${segmentId} out of range [0, ${outputRows}), possibly because segmentIds input is not sorted.`;
}
function $f447beebab537d56$export$c470f477911f1cb7(index, indexValue, inputRows) {
    return `Bad: indices[${index}] == ${indexValue} out of range [0, ${inputRows})`;
}

});

parcelRegister("hOi6c", function(module, exports) {

$parcel$export(module.exports, "segOpComputeOptimalWindowSize", function () { return $cf752543c79a7ccd$export$6ef0c7b128709ff; });
$parcel$export(module.exports, "computeOutShape", function () { return $cf752543c79a7ccd$export$22fa6b3b1305508e; });
$parcel$export(module.exports, "collectGatherOpShapeInfo", function () { return $cf752543c79a7ccd$export$fa9ad97afacf8191; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");

var $g2skz = parcelRequire("g2skz");
function $cf752543c79a7ccd$export$6ef0c7b128709ff(inSize, numSegments) {
    let done = false;
    let res;
    if (inSize <= (0, $g2skz.PARALLELIZE_THRESHOLD)) {
        res = inSize;
        done = true;
    } else res = (0, $eOiOM.nearestDivisor)(inSize, Math.floor(Math.sqrt(inSize)));
    while(!done)if (res > numSegments || res === inSize) done = true;
    else res = (0, $eOiOM.nearestDivisor)(inSize, res + 1);
    return res;
}
function $cf752543c79a7ccd$export$22fa6b3b1305508e(aShape, axis, numSegments) {
    const outShape = [];
    const rank = aShape.length;
    for(let dim = 0; dim < rank; dim++)if (dim !== axis) outShape.push(aShape[dim]);
    else outShape.push(numSegments);
    return outShape;
}
function $cf752543c79a7ccd$export$fa9ad97afacf8191(x, indices, axis, batchDims) {
    const indicesRank = indices.shape.length;
    const xRank = x.shape.length;
    if (batchDims !== 0) {
        if (batchDims < -indicesRank || batchDims > indicesRank) throw new Error(`Expect batchDims in the range of [-${indicesRank}, ${indicesRank}], but got ${batchDims}`);
    }
    if (batchDims < 0) batchDims += indicesRank;
    if (batchDims > xRank) throw new Error(`batchDims (${batchDims}) must be less than rank(x) (
    ${xRank}).`);
    if (axis < batchDims) throw new Error(`batchDims (${batchDims}) must be less than or equal to axis (${axis}).`);
    for(let i = 0; i < batchDims; ++i){
        if (x.shape[i] !== indices.shape[i]) throw new Error(`x.shape[${i}]: ${x.shape[i]} should be equal to indices.shape[${i}]: ${indices.shape[i]}.`);
    }
    const dimSize = x.shape[axis];
    const outputShape = [];
    let batchSize = 1;
    let outerSize = 1;
    let sliceSize = 1;
    for(let i = 0; i < batchDims; ++i){
        outputShape.push(x.shape[i]);
        batchSize *= x.shape[i];
    }
    for(let i = batchDims; i < axis; i++){
        outputShape.push(x.shape[i]);
        outerSize *= x.shape[i];
    }
    for(let i = batchDims; i < indicesRank; i++)outputShape.push(indices.shape[i]);
    for(let i = axis + 1; i < xRank; i++){
        outputShape.push(x.shape[i]);
        sliceSize *= x.shape[i];
    }
    return {
        batchSize: batchSize,
        sliceSize: sliceSize,
        outerSize: outerSize,
        dimSize: dimSize,
        outputShape: outputShape
    };
}

});


parcelRegister("cgFzb", function(module, exports) {

$parcel$export(module.exports, "batchNorm2d", function () { return $8ee738df3c644698$export$4104d1fc5afa918a; });

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $dOyXd = parcelRequire("dOyXd");

var $6afhl = parcelRequire("6afhl");
/**
 * Batch normalization, strictly for 2D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $8ee738df3c644698$var$batchNorm2d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $x4eLk.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $x4eLk.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $x4eLk.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $x4eLk.convertToTensor)(offset, 'offset', 'batchNorm');
    $eOiOM.assert($x.rank === 2, ()=>`Error in batchNorm2D: x must be rank 2 but got rank ` + `${$x.rank}.`);
    $eOiOM.assert($mean.rank === 2 || $mean.rank === 1, ()=>`Error in batchNorm2D: mean must be rank 2 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $eOiOM.assert($variance.rank === 2 || $variance.rank === 1, ()=>`Error in batchNorm2D: variance must be rank 2 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $eOiOM.assert($scale.rank === 2 || $scale.rank === 1, ()=>`Error in batchNorm2D: scale must be rank 2 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $eOiOM.assert($offset.rank === 2 || $offset.rank === 1, ()=>`Error in batchNorm2D: offset must be rank 2 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $dOyXd.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $8ee738df3c644698$export$4104d1fc5afa918a = /* @__PURE__ */ (0, $6afhl.op)({
    batchNorm2d_: $8ee738df3c644698$var$batchNorm2d_
});

});
parcelRegister("dOyXd", function(module, exports) {

$parcel$export(module.exports, "batchNorm", function () { return $a0eb0f0c8fefb176$export$8ea8088e6d0cdd02; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $l1sUi = parcelRequire("l1sUi");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Batch normalization.
 *
 * As described in
 * [http://arxiv.org/abs/1502.03167](http://arxiv.org/abs/1502.03167).
 *
 * Mean, variance, scale, and offset can be of two shapes:
 *   - The same shape as the input.
 *   - In the common case, the depth dimension is the last dimension of x, so
 *     the values would be a `tf.Tensor1D` of shape [depth].
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that parameters passed are of given rank
 *   - `tf.batchNorm2d`
 *   - `tf.batchNorm3d`
 *   - `tf.batchNorm4d`
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $a0eb0f0c8fefb176$var$batchNorm_(x, mean, variance, offset, scale, varianceEpsilon) {
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $x4eLk.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $x4eLk.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $x4eLk.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $x4eLk.convertToTensor)(offset, 'offset', 'batchNorm');
    $eOiOM.assert($mean.rank === $variance.rank, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    $eOiOM.assert($offset == null || $mean.rank === $offset.rank, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    $eOiOM.assert($scale == null || $mean.rank === $scale.rank, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    const x4D = (0, $l1sUi.xAs4D)($x);
    const inputs = {
        x: x4D,
        scale: $scale,
        offset: $offset,
        mean: $mean,
        variance: $variance
    };
    const attrs = {
        varianceEpsilon: varianceEpsilon
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FusedBatchNorm), inputs, attrs);
    return (0, $8nMOl.reshape)(res, $x.shape);
}
const $a0eb0f0c8fefb176$export$8ea8088e6d0cdd02 = /* @__PURE__ */ (0, $6afhl.op)({
    batchNorm_: $a0eb0f0c8fefb176$var$batchNorm_
});

});
parcelRegister("l1sUi", function(module, exports) {

$parcel$export(module.exports, "xAs4D", function () { return $f4e01d499e39241f$export$b76c765a8a7b5836; });

var $8nMOl = parcelRequire("8nMOl");
function $f4e01d499e39241f$export$b76c765a8a7b5836(x) {
    let x4D;
    if (x.rank === 0 || x.rank === 1) x4D = (0, $8nMOl.reshape)(x, [
        1,
        1,
        1,
        x.size
    ]);
    else if (x.rank === 2) x4D = (0, $8nMOl.reshape)(x, [
        1,
        1,
        x.shape[0],
        x.shape[1]
    ]);
    else if (x.rank === 3) x4D = (0, $8nMOl.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    else x4D = x;
    return x4D;
}

});



parcelRegister("hBBSw", function(module, exports) {

$parcel$export(module.exports, "batchNorm3d", function () { return $cd134640f6ade12c$export$76211212fb57f1fa; });

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $dOyXd = parcelRequire("dOyXd");

var $6afhl = parcelRequire("6afhl");
/**
 * Batch normalization, strictly for 3D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $cd134640f6ade12c$var$batchNorm3d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $x4eLk.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $x4eLk.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $x4eLk.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $x4eLk.convertToTensor)(offset, 'offset', 'batchNorm');
    $eOiOM.assert($x.rank === 3, ()=>`Error in batchNorm3D: x must be rank 3 but got rank ` + `${$x.rank}.`);
    $eOiOM.assert($mean.rank === 3 || $mean.rank === 1, ()=>`Error in batchNorm3D: mean must be rank 3 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $eOiOM.assert($variance.rank === 3 || $variance.rank === 1, ()=>`Error in batchNorm3D: variance must be rank 3 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $eOiOM.assert($scale.rank === 3 || $scale.rank === 1, ()=>`Error in batchNorm3D: scale must be rank 3 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $eOiOM.assert($offset.rank === 3 || $offset.rank === 1, ()=>`Error in batchNorm3D: offset must be rank 3 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $dOyXd.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $cd134640f6ade12c$export$76211212fb57f1fa = /* @__PURE__ */ (0, $6afhl.op)({
    batchNorm3d_: $cd134640f6ade12c$var$batchNorm3d_
});

});

parcelRegister("5JMTM", function(module, exports) {

$parcel$export(module.exports, "batchNorm4d", function () { return $42d715f7804c3de4$export$4573a348ef14e569; });

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $dOyXd = parcelRequire("dOyXd");

var $6afhl = parcelRequire("6afhl");
/**
 * Batch normalization, strictly for 4D. For the more relaxed version, see
 * `tf.batchNorm`.
 *
 * @param x The input Tensor.
 * @param mean A mean Tensor.
 * @param variance A variance Tensor.
 * @param offset An offset Tensor.
 * @param scale A scale Tensor.
 * @param varianceEpsilon A small float number to avoid dividing by 0.
 */ function $42d715f7804c3de4$var$batchNorm4d_(x, mean, variance, offset, scale, varianceEpsilon) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'batchNorm');
    const $mean = (0, $x4eLk.convertToTensor)(mean, 'mean', 'batchNorm');
    const $variance = (0, $x4eLk.convertToTensor)(variance, 'variance', 'batchNorm');
    let $scale;
    if (scale != null) $scale = (0, $x4eLk.convertToTensor)(scale, 'scale', 'batchNorm');
    let $offset;
    if (offset != null) $offset = (0, $x4eLk.convertToTensor)(offset, 'offset', 'batchNorm');
    $eOiOM.assert($x.rank === 4, ()=>`Error in batchNorm4D: x must be rank 4 but got rank ` + `${$x.rank}.`);
    $eOiOM.assert($mean.rank === 4 || $mean.rank === 1, ()=>`Error in batchNorm4D: mean must be rank 4 or rank 1 but ` + `got rank ${$mean.rank}.`);
    $eOiOM.assert($variance.rank === 4 || $variance.rank === 1, ()=>`Error in batchNorm4D: variance must be rank 4 or rank 1 ` + `but got rank ${$variance.rank}.`);
    if ($scale != null) $eOiOM.assert($scale.rank === 4 || $scale.rank === 1, ()=>`Error in batchNorm4D: scale must be rank 4 or rank 1 ` + `but got rank ${$scale.rank}.`);
    if ($offset != null) $eOiOM.assert($offset.rank === 4 || $offset.rank === 1, ()=>`Error in batchNorm4D: offset must be rank 4 or rank 1 ` + `but got rank ${$offset.rank}.`);
    return (0, $dOyXd.batchNorm)($x, $mean, $variance, $offset, $scale, varianceEpsilon);
}
const $42d715f7804c3de4$export$4573a348ef14e569 = /* @__PURE__ */ (0, $6afhl.op)({
    batchNorm4d_: $42d715f7804c3de4$var$batchNorm4d_
});

});

parcelRegister("bMTXt", function(module, exports) {

$parcel$export(module.exports, "broadcastTo", function () { return $894f958e5e567ad8$export$ec9086aff2624eab; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $ek4FP = parcelRequire("ek4FP");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Broadcast an array to a compatible shape NumPy-style.
 *
 * The tensor's shape is compared to the broadcast shape from end to beginning.
 * Ones are prepended to the tensor's shape until it has the same length as
 * the broadcast shape. If input.shape[i]==shape[i], the (i+1)-th axis is
 * already broadcast-compatible. If input.shape[i]==1 and shape[i]==N, then
 * the input tensor is tiled N times along that axis (using tf.tile).
 *
 * @param input The tensor that is to be broadcasted.
 * @param shape The input is to be broadcast to this shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $894f958e5e567ad8$var$broadcastTo_(x, shape) {
    let input = (0, $x4eLk.convertToTensor)(x, 'broadcastTo', 'x');
    const xShape = input.shape;
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    if (shape.length < input.rank) throw new Error(`broadcastTo(): shape.length=${shape.length} < input.rank=${input.rank}.`);
    if (shape.length > input.rank) {
        const newShape = input.shape.slice();
        while(newShape.length < shape.length)newShape.unshift(1);
        input = (0, $8nMOl.reshape)(input, newShape);
    }
    const inputShape = input.shape;
    const reps = Array.from(shape);
    for(let i = shape.length - 1; i >= 0; i--){
        if (inputShape[i] === shape[i]) reps[i] = 1;
        else if (input.shape[i] !== 1) throw new Error(`broadcastTo(): [${xShape}] cannot be broadcast to [${shape}].`);
    }
    const axes = reps.map((n, i)=>n > 1 ? i : -1).filter((i)=>i >= 0);
    if (axes.length === 0) return (0, $ek4FP.clone)(input);
    // TODO call broadcastTo kernel directly once backends implement broadcstTo
    const inputs = {
        x: input
    };
    const attrs = {
        reps: reps
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Tile), inputs, attrs);
}
const $894f958e5e567ad8$export$ec9086aff2624eab = /* @__PURE__ */ (0, $6afhl.op)({
    broadcastTo_: $894f958e5e567ad8$var$broadcastTo_
});

});

parcelRegister("iVJWR", function(module, exports) {

$parcel$export(module.exports, "fromPixelsAsync", function () { return $dc813140d67e61aa$export$6b17f27238fa6bff; });
$parcel$export(module.exports, "toPixels", function () { return $dc813140d67e61aa$export$89b6cc959998e12e; });
$parcel$export(module.exports, "draw", function () { return $dc813140d67e61aa$export$e529deb2bfd496dc; });
$parcel$export(module.exports, "fromPixels", function () { return $dc813140d67e61aa$export$5a3bc84b10e77d32; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $tdutJ = parcelRequire("tdutJ");

var $9BGT9 = parcelRequire("9BGT9");

var $fPoI0 = parcelRequire("fPoI0");

var $3pVUH = parcelRequire("3pVUH");

var $x4eLk = parcelRequire("x4eLk");

var $fxiHg = parcelRequire("fxiHg");

var $6afhl = parcelRequire("6afhl");

var $alqbU = parcelRequire("alqbU");
let $dc813140d67e61aa$var$fromPixels2DContext;
let $dc813140d67e61aa$var$hasToPixelsWarned = false;
/**
 * Creates a `tf.Tensor` from an image.
 *
 * ```js
 * const image = new ImageData(1, 1);
 * image.data[0] = 100;
 * image.data[1] = 150;
 * image.data[2] = 200;
 * image.data[3] = 255;
 *
 * tf.browser.fromPixels(image).print();
 * ```
 *
 * @param pixels The input image to construct the tensor from. The
 * supported image types are all 4-channel. You can also pass in an image
 * object with following attributes:
 * `{data: Uint8Array; width: number; height: number}`
 * @param numChannels The number of channels of the output tensor. A
 * numChannels value less than 4 allows you to ignore channels. Defaults to
 * 3 (ignores alpha channel of input image).
 *
 * @returns A Tensor3D with the shape `[height, width, numChannels]`.
 *
 * Note: fromPixels can be lossy in some cases, same image may result in
 * slightly different tensor values, if rendered by different rendering
 * engines. This means that results from different browsers, or even same
 * browser with CPU and GPU rendering engines can be different. See discussion
 * in details:
 * https://github.com/tensorflow/tfjs/issues/5482
 *
 * @doc {heading: 'Browser', namespace: 'browser', ignoreCI: true}
 */ function $dc813140d67e61aa$var$fromPixels_(pixels, numChannels = 3) {
    // Sanity checks.
    if (numChannels > 4) throw new Error('Cannot construct Tensor with more than 4 channels from pixels.');
    if (pixels == null) throw new Error('pixels passed to tf.browser.fromPixels() can not be null');
    let isPixelData = false;
    let isImageData = false;
    let isVideo = false;
    let isImage = false;
    let isCanvasLike = false;
    let isImageBitmap = false;
    if (pixels.data instanceof Uint8Array) isPixelData = true;
    else if (typeof ImageData !== 'undefined' && pixels instanceof ImageData) isImageData = true;
    else if (typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement) isVideo = true;
    else if (typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement) isImage = true;
    else if (pixels.getContext != null) isCanvasLike = true;
    else if (typeof ImageBitmap !== 'undefined' && pixels instanceof ImageBitmap) isImageBitmap = true;
    else throw new Error('pixels passed to tf.browser.fromPixels() must be either an ' + `HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData ` + `in browser, or OffscreenCanvas, ImageData in webworker` + ` or {data: Uint32Array, width: number, height: number}, ` + `but was ${pixels.constructor.name}`);
    // If the current backend has 'FromPixels' registered, it has a more
    // efficient way of handling pixel uploads, so we call that.
    const kernel = (0, $fPoI0.getKernel)((0, $9BGT9.FromPixels), (0, $e6Ey6.ENGINE).backendName);
    if (kernel != null) {
        const inputs = {
            pixels: pixels
        };
        const attrs = {
            numChannels: numChannels
        };
        return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FromPixels), inputs, attrs);
    }
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    let vals;
    if (isCanvasLike) vals = // tslint:disable-next-line:no-any
    pixels.getContext('2d').getImageData(0, 0, width, height).data;
    else if (isImageData || isPixelData) vals = pixels.data;
    else if (isImage || isVideo || isImageBitmap) {
        if ($dc813140d67e61aa$var$fromPixels2DContext == null) {
            if (typeof document === 'undefined') {
                if (typeof OffscreenCanvas !== 'undefined' && typeof OffscreenCanvasRenderingContext2D !== 'undefined') // @ts-ignore
                $dc813140d67e61aa$var$fromPixels2DContext = new OffscreenCanvas(1, 1).getContext('2d');
                else throw new Error("Cannot parse input in current context. Reason: OffscreenCanvas Context2D rendering is not supported.");
            } else $dc813140d67e61aa$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: true
            });
        }
        $dc813140d67e61aa$var$fromPixels2DContext.canvas.width = width;
        $dc813140d67e61aa$var$fromPixels2DContext.canvas.height = height;
        $dc813140d67e61aa$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        vals = $dc813140d67e61aa$var$fromPixels2DContext.getImageData(0, 0, width, height).data;
    }
    let values;
    if (numChannels === 4) values = new Int32Array(vals);
    else {
        const numPixels = width * height;
        values = new Int32Array(numPixels * numChannels);
        for(let i = 0; i < numPixels; i++)for(let channel = 0; channel < numChannels; ++channel)values[i * numChannels + channel] = vals[i * 4 + channel];
    }
    const outShape = [
        height,
        width,
        numChannels
    ];
    return (0, $alqbU.tensor3d)(values, outShape, 'int32');
}
// Helper functions for |fromPixelsAsync| to check whether the input can
// be wrapped into imageBitmap.
function $dc813140d67e61aa$var$isPixelData(pixels) {
    return pixels != null && pixels.data instanceof Uint8Array;
}
function $dc813140d67e61aa$var$isImageBitmapFullySupported() {
    return typeof window !== 'undefined' && typeof ImageBitmap !== 'undefined' && window.hasOwnProperty('createImageBitmap');
}
function $dc813140d67e61aa$var$isNonEmptyPixels(pixels) {
    return pixels != null && pixels.width !== 0 && pixels.height !== 0;
}
function $dc813140d67e61aa$var$canWrapPixelsToImageBitmap(pixels) {
    return $dc813140d67e61aa$var$isImageBitmapFullySupported() && !(pixels instanceof ImageBitmap) && $dc813140d67e61aa$var$isNonEmptyPixels(pixels) && !$dc813140d67e61aa$var$isPixelData(pixels);
}
async function $dc813140d67e61aa$export$6b17f27238fa6bff(pixels, numChannels = 3) {
    let inputs = null;
    // Check whether the backend needs to wrap |pixels| to imageBitmap and
    // whether |pixels| can be wrapped to imageBitmap.
    if ((0, $tdutJ.env)().getBool('WRAP_TO_IMAGEBITMAP') && $dc813140d67e61aa$var$canWrapPixelsToImageBitmap(pixels)) {
        // Force the imageBitmap creation to not do any premultiply alpha
        // ops.
        let imageBitmap;
        try {
            // wrap in try-catch block, because createImageBitmap may not work
            // properly in some browsers, e.g.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1335594
            // tslint:disable-next-line: no-any
            imageBitmap = await createImageBitmap(pixels, {
                premultiplyAlpha: 'none'
            });
        } catch (e) {
            imageBitmap = null;
        }
        // createImageBitmap will clip the source size.
        // In some cases, the input will have larger size than its content.
        // E.g. new Image(10, 10) but with 1 x 1 content. Using
        // createImageBitmap will clip the size from 10 x 10 to 1 x 1, which
        // is not correct. We should avoid wrapping such resouce to
        // imageBitmap.
        if (imageBitmap != null && imageBitmap.width === pixels.width && imageBitmap.height === pixels.height) inputs = imageBitmap;
        else inputs = pixels;
    } else inputs = pixels;
    return $dc813140d67e61aa$var$fromPixels_(inputs, numChannels);
}
function $dc813140d67e61aa$var$validateImgTensor(img) {
    if (img.rank !== 2 && img.rank !== 3) throw new Error(`toPixels only supports rank 2 or 3 tensors, got rank ${img.rank}.`);
    const depth = img.rank === 2 ? 1 : img.shape[2];
    if (depth > 4 || depth === 2) throw new Error(`toPixels only supports depth of size ` + `1, 3 or 4 but got ${depth}`);
    if (img.dtype !== 'float32' && img.dtype !== 'int32') throw new Error(`Unsupported type for toPixels: ${img.dtype}.` + ` Please use float32 or int32 tensors.`);
}
function $dc813140d67e61aa$var$validateImageOptions(imageOptions) {
    const alpha = (imageOptions === null || imageOptions === void 0 ? void 0 : imageOptions.alpha) || 1;
    if (alpha > 1 || alpha < 0) throw new Error(`Alpha value ${alpha} is suppoed to be in range [0 - 1].`);
}
async function $dc813140d67e61aa$export$89b6cc959998e12e(img, canvas) {
    let $img = (0, $x4eLk.convertToTensor)(img, 'img', 'toPixels');
    if (!(img instanceof (0, $3pVUH.Tensor))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $fxiHg.cast)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    $dc813140d67e61aa$var$validateImgTensor($img);
    const [height, width] = $img.shape.slice(0, 2);
    const depth = $img.rank === 2 ? 1 : $img.shape[2];
    const data = await $img.data();
    const multiplier = $img.dtype === 'float32' ? 255 : 1;
    const bytes = new Uint8ClampedArray(width * height * 4);
    for(let i = 0; i < height * width; ++i){
        const rgba = [
            0,
            0,
            0,
            255
        ];
        for(let d = 0; d < depth; d++){
            const value = data[i * depth + d];
            if ($img.dtype === 'float32') {
                if (value < 0 || value > 1) throw new Error(`Tensor values for a float32 Tensor must be in the ` + `range [0 - 1] but encountered ${value}.`);
            } else if ($img.dtype === 'int32') {
                if (value < 0 || value > 255) throw new Error(`Tensor values for a int32 Tensor must be in the ` + `range [0 - 255] but encountered ${value}.`);
            }
            if (depth === 1) {
                rgba[0] = value * multiplier;
                rgba[1] = value * multiplier;
                rgba[2] = value * multiplier;
            } else rgba[d] = value * multiplier;
        }
        const j = i * 4;
        bytes[j + 0] = Math.round(rgba[0]);
        bytes[j + 1] = Math.round(rgba[1]);
        bytes[j + 2] = Math.round(rgba[2]);
        bytes[j + 3] = Math.round(rgba[3]);
    }
    if (canvas != null) {
        if (!$dc813140d67e61aa$var$hasToPixelsWarned) {
            const kernel = (0, $fPoI0.getKernel)((0, $9BGT9.Draw), (0, $e6Ey6.ENGINE).backendName);
            if (kernel != null) {
                console.warn("tf.browser.toPixels is not efficient to draw tensor on canvas. Please try tf.browser.draw instead.");
                $dc813140d67e61aa$var$hasToPixelsWarned = true;
            }
        }
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        const imageData = new ImageData(bytes, width, height);
        ctx.putImageData(imageData, 0, 0);
    }
    if ($img !== img) $img.dispose();
    return bytes;
}
function $dc813140d67e61aa$export$e529deb2bfd496dc(image, canvas, options) {
    let $img = (0, $x4eLk.convertToTensor)(image, 'img', 'draw');
    if (!(image instanceof (0, $3pVUH.Tensor))) {
        // Assume int32 if user passed a native array.
        const originalImgTensor = $img;
        $img = (0, $fxiHg.cast)(originalImgTensor, 'int32');
        originalImgTensor.dispose();
    }
    $dc813140d67e61aa$var$validateImgTensor($img);
    $dc813140d67e61aa$var$validateImageOptions(options === null || options === void 0 ? void 0 : options.imageOptions);
    const inputs = {
        image: $img
    };
    const attrs = {
        canvas: canvas,
        options: options
    };
    (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Draw), inputs, attrs);
}
const $dc813140d67e61aa$export$5a3bc84b10e77d32 = /* @__PURE__ */ (0, $6afhl.op)({
    fromPixels_: $dc813140d67e61aa$var$fromPixels_
});

});
parcelRegister("alqbU", function(module, exports) {

$parcel$export(module.exports, "tensor3d", function () { return $78802e88ca3bdf2e$export$aa36a9de53c6d912; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $cxc40 = parcelRequire("cxc40");
function $78802e88ca3bdf2e$export$aa36a9de53c6d912(values, shape, dtype) {
    (0, $eOiOM.assertNonNull)(values);
    if (shape != null && shape.length !== 3) throw new Error('tensor3d() requires shape to have three numbers');
    const inferredShape = (0, $x4eLk.inferShape)(values, dtype);
    if (inferredShape.length !== 3 && inferredShape.length !== 1) throw new Error('tensor3d() requires values to be number[][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
    return (0, $cxc40.makeTensor)(values, shape, inferredShape, dtype);
}

});


parcelRegister("iAQYk", function(module, exports) {

$parcel$export(module.exports, "clipByValue", function () { return $d894aded938e720e$export$fa97baf70ad024c0; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $2d2dF = parcelRequire("2d2dF");

var $6afhl = parcelRequire("6afhl");
/**
 * Clips values element-wise. `max(min(x, clipValueMax), clipValueMin)`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.clipByValue(-2, 3).print();  // or tf.clipByValue(x, -2, 3)
 * ```
 * @param x The input tensor.
 * @param clipValueMin Lower bound of range to be clipped to.
 * @param clipValueMax Upper bound of range to be clipped to.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d894aded938e720e$var$clipByValue_(x, clipValueMin, clipValueMax) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'clipByValue');
    $eOiOM.assert(clipValueMin <= clipValueMax, ()=>`Error in clip: min (${clipValueMin}) must be ` + `less than or equal to max (${clipValueMax}).`);
    if (clipValueMin === clipValueMax) return (0, $2d2dF.fill)($x.shape, clipValueMin, $x.dtype);
    const inputs = {
        x: $x
    };
    const attrs = {
        clipValueMin: clipValueMin,
        clipValueMax: clipValueMax
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ClipByValue), inputs, attrs);
}
const $d894aded938e720e$export$fa97baf70ad024c0 = /* @__PURE__ */ (0, $6afhl.op)({
    clipByValue_: $d894aded938e720e$var$clipByValue_
});

});

parcelRegister("1goxr", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $0eba51dbfb616294$export$ee1b3e54f0441b22; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $ek4FP = parcelRequire("ek4FP");

var $6afhl = parcelRequire("6afhl");
/**
 * Concatenates a list of `tf.Tensor`s along a given axis.
 *
 * The tensors ranks and types must match, and their sizes must match in all
 * dimensions except `axis`.
 *
 * Also available are stricter rank-specific methods that assert that
 * `tensors` are of the given rank:
 *   - `tf.concat1d`
 *   - `tf.concat2d`
 *   - `tf.concat3d`
 *   - `tf.concat4d`
 *
 * Except `tf.concat1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * a.concat(b).print();  // or a.concat(b)
 * ```
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.concat([a, b, c]).print();
 * ```
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [10, 20]]);
 * const b = tf.tensor2d([[3, 4], [30, 40]]);
 * const axis = 1;
 * tf.concat([a, b], axis).print();
 * ```
 * @param tensors A list of tensors to concatenate.
 * @param axis The axis to concatenate along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $0eba51dbfb616294$var$concat_(tensors, axis = 0) {
    (0, $eOiOM.assert)(tensors.length >= 1, ()=>'Pass at least one tensor to concat');
    const $tensors = (0, $x4eLk.convertToTensorArray)(tensors, 'tensors', 'concat', 'string_or_numeric');
    if ($tensors[0].dtype === 'complex64') $tensors.forEach((tensor)=>{
        if (tensor.dtype !== 'complex64') throw new Error(`Cannot concatenate complex64 tensors with a tensor
          with dtype ${tensor.dtype}. `);
    });
    if ($tensors.length === 1) return (0, $ek4FP.clone)($tensors[0]);
    const inputs = $tensors;
    const attr = {
        axis: axis
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Concat), inputs, attr);
}
const $0eba51dbfb616294$export$ee1b3e54f0441b22 = /* @__PURE__ */ (0, $6afhl.op)({
    concat_: $0eba51dbfb616294$var$concat_
});

});

parcelRegister("j5YCL", function(module, exports) {

$parcel$export(module.exports, "concat1d", function () { return $de6d82a25d877a6b$export$1e0bfb2ad280a475; });

var $1goxr = parcelRequire("1goxr");

var $6afhl = parcelRequire("6afhl");
/**
 * Concatenates a list of`tf.Tensor1D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(3) = |r1, g1, b1|
 * B: shape(2) = |r2, g2|
 * C = tf.concat1d([A, B]) == |r1, g1, b1, r2, g2|
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @return The concatenated array.
 */ function $de6d82a25d877a6b$var$concat1d_(tensors) {
    return (0, $1goxr.concat)(tensors, 0 /* axis */ );
}
const $de6d82a25d877a6b$export$1e0bfb2ad280a475 = /* @__PURE__ */ (0, $6afhl.op)({
    concat1d_: $de6d82a25d877a6b$var$concat1d_
});

});

parcelRegister("kEtq4", function(module, exports) {

$parcel$export(module.exports, "concat2d", function () { return $f08e5d2a0d052e4d$export$ba044983349051fd; });

var $1goxr = parcelRequire("1goxr");

var $6afhl = parcelRequire("6afhl");
/**
 * Concatenates a list of`tf.Tensor2D`s along an axis. See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *
 * B: shape(2, 3) = | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * C = tf.concat2d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 3) = | r1, g1, b1 |
 *                  | r2, g2, b2 |
 *                  | r3, g3, b3 |
 *                  | r4, g4, b4 |
 *
 * if axis = 1:
 * C = shape(2, 6) = | r1, g1, b1, r3, g3, b3 |
 *                   | r2, g2, b2, r4, g4, b4 |
 *
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concatenate along.
 * @return The concatenated array.
 */ function $f08e5d2a0d052e4d$var$concat2d_(tensors, axis) {
    return (0, $1goxr.concat)(tensors, axis);
}
const $f08e5d2a0d052e4d$export$ba044983349051fd = /* @__PURE__ */ (0, $6afhl.op)({
    concat2d_: $f08e5d2a0d052e4d$var$concat2d_
});

});

parcelRegister("601hZ", function(module, exports) {

$parcel$export(module.exports, "concat3d", function () { return $45e3be304a16fe55$export$23e0f187dd67babf; });

var $1goxr = parcelRequire("1goxr");

var $6afhl = parcelRequire("6afhl");
/**
 * Concatenates a list of `tf.Tensor3D`s along an axis.
 * See `concat` for details.
 *
 * For example, if:
 * A: shape(2, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *
 * B: shape(2, 1, 3) = | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * C = tf.concat3d([A, B], axis)
 *
 * if axis = 0:
 * C: shape(4, 1, 3) = | r1, g1, b1 |
 *                     | r2, g2, b2 |
 *                     | r3, g3, b3 |
 *                     | r4, g4, b4 |
 *
 * if axis = 1:
 * C: shape(2, 2, 3) = | r1, g1, b1, r3, g3, b3 |
 *                     | r2, g2, b2, r4, g4, b4 |
 *
 * if axis = 2:
 * C = shape(2, 1, 6) = | r1, g1, b1, r3, g3, b3 |
 *                      | r2, g2, b2, r4, g4, b4 |
 *
 * @param tensors A list of`tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $45e3be304a16fe55$var$concat3d_(tensors, axis) {
    return (0, $1goxr.concat)(tensors, axis);
}
const $45e3be304a16fe55$export$23e0f187dd67babf = /* @__PURE__ */ (0, $6afhl.op)({
    concat3d_: $45e3be304a16fe55$var$concat3d_
});

});

parcelRegister("30mc4", function(module, exports) {

$parcel$export(module.exports, "concat4d", function () { return $23029667e7c2d2d8$export$731e01cced6c0a23; });

var $1goxr = parcelRequire("1goxr");

var $6afhl = parcelRequire("6afhl");
/**
 * Concatenates a list of `tf.Tensor4D`s along an axis.
 * See `concat` for details.
 *
 * @param tensors A list of `tf.Tensor`s to concatenate.
 * @param axis The axis to concate along.
 * @return The concatenated array.
 */ function $23029667e7c2d2d8$var$concat4d_(tensors, axis) {
    return (0, $1goxr.concat)(tensors, axis);
}
const $23029667e7c2d2d8$export$731e01cced6c0a23 = /* @__PURE__ */ (0, $6afhl.op)({
    concat4d_: $23029667e7c2d2d8$var$concat4d_
});

});

parcelRegister("7vGQw", function(module, exports) {

$parcel$export(module.exports, "conv1d", function () { return $01693c8c564c4dfa$export$d8aa844fa36b350e; });

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $9JluG = parcelRequire("9JluG");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes a 1D convolution over the input x.
 *
 * @param x The input tensor, of rank 3 or rank 2, of shape
 *     `[batch, width, inChannels]`. If rank 2, batch of 1 is assumed.
 * @param filter The filter, rank 3, of shape
 *     `[filterWidth, inDepth, outDepth]`.
 * @param stride The number of entries by which the filter is moved right at
 *     each step.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from "NWC", "NCW". Defaults to "NWC",
 *     the data is stored in the order of [batch, in_width, in_channels]. Only
 *     "NWC" is currently supported.
 * @param dilation The dilation rate in which we sample input values in
 *     atrous convolution. Defaults to `1`. If it is greater than 1, then
 *     stride must be `1`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $01693c8c564c4dfa$var$conv1d_(x, filter, stride, pad, dataFormat = 'NWC', dilation = 1, dimRoundingMode) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'conv1d');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'conv1d');
    let x3D = $x;
    let reshapedTo3D = false;
    if ($x.rank === 2) {
        reshapedTo3D = true;
        x3D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1]
        ]);
    }
    $eOiOM.assert(x3D.rank === 3, ()=>`Error in conv1d: input must be rank 3, but got rank ${x3D.rank}.`);
    $eOiOM.assert($filter.rank === 3, ()=>`Error in conv1d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $g0V2M.checkPadOnDimRoundingMode('conv1d', pad, dimRoundingMode);
    $eOiOM.assert(x3D.shape[2] === $filter.shape[1], ()=>`Error in conv1d: depth of input (${x3D.shape[2]}) must match ` + `input depth for filter ${$filter.shape[1]}.`);
    $eOiOM.assert($g0V2M.eitherStridesOrDilationsAreOne(stride, dilation), ()=>'Error in conv1D: Either stride or dilation must be 1. ' + `Got stride ${stride} and dilation '${dilation}'`);
    $eOiOM.assert($g0V2M.stridesOrDilationsArePositive(dilation), ()=>'Error in conv1D: Dilated rates should be larger than 0.');
    $eOiOM.assert($g0V2M.stridesOrDilationsArePositive(stride), ()=>'Error in conv1D: Stride should be larger than 0.');
    $eOiOM.assert(dataFormat === 'NWC', ()=>`Error in conv1d: got dataFormat of ${dataFormat} but only NWC is currently supported.`);
    const filter4D = (0, $8nMOl.reshape)($filter, [
        1,
        $filter.shape[0],
        $filter.shape[1],
        $filter.shape[2]
    ]);
    const input4D = (0, $8nMOl.reshape)(x3D, [
        x3D.shape[0],
        1,
        x3D.shape[1],
        x3D.shape[2]
    ]);
    const strides = [
        1,
        stride
    ];
    const dilations = [
        1,
        dilation
    ];
    const conv2dDataFormat = 'NHWC';
    const res = (0, $9JluG.conv2d)(input4D, filter4D, strides, pad, conv2dDataFormat, dilations, dimRoundingMode);
    if (reshapedTo3D) return (0, $8nMOl.reshape)(res, [
        res.shape[2],
        res.shape[3]
    ]);
    return (0, $8nMOl.reshape)(res, [
        res.shape[0],
        res.shape[2],
        res.shape[3]
    ]);
}
const $01693c8c564c4dfa$export$d8aa844fa36b350e = /* @__PURE__ */ (0, $6afhl.op)({
    conv1d_: $01693c8c564c4dfa$var$conv1d_
});

});
parcelRegister("9JluG", function(module, exports) {

$parcel$export(module.exports, "conv2d", function () { return $7158fd41ee467f64$export$188f9215482e3db8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes a 2D convolution over the input x.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $7158fd41ee467f64$var$conv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $eOiOM.assert(x4D.rank === 4, ()=>`Error in conv2d: input must be rank 4, but got rank ${x4D.rank}.`);
    $eOiOM.assert($filter.rank === 4, ()=>`Error in conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $g0V2M.checkPadOnDimRoundingMode('conv2d', pad, dimRoundingMode);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $eOiOM.assert(inDepth === $filter.shape[2], ()=>`Error in conv2d: depth of input (${inDepth}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $eOiOM.assert($g0V2M.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $eOiOM.assert($g0V2M.stridesOrDilationsArePositive(dilations), ()=>'Error in conv2D: Dilated rates should be larger than 0.');
    $eOiOM.assert($g0V2M.stridesOrDilationsArePositive(strides), ()=>'Error in conv2D: Strides should be larger than 0.');
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Conv2D), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $7158fd41ee467f64$export$188f9215482e3db8 = /* @__PURE__ */ (0, $6afhl.op)({
    conv2d_: $7158fd41ee467f64$var$conv2d_
});

});


parcelRegister("gVSKY", function(module, exports) {

$parcel$export(module.exports, "conv2dTranspose", function () { return $c53c71b9b5eaa2c4$export$d5e924cbc07fb966; });

var $x4eLk = parcelRequire("x4eLk");

var $1iZpR = parcelRequire("1iZpR");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the transposed 2D convolution of an image, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 4 or rank 3, of shape
 *   `[batch, height, width, inDepth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 4 or rank 3:
 *     `[batch, height, width, outDepth]`. If rank 3, batch of 1 is assumed.
 * @param strides The strides of the original convolution:
 *     `[strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $c53c71b9b5eaa2c4$var$conv2dTranspose_(x, filter, outputShape, strides, pad, dimRoundingMode) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'conv2dTranspose');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'conv2dTranspose');
    return (0, $1iZpR.conv2DBackpropInput)(outputShape, $x, $filter, strides, pad, 'NHWC', dimRoundingMode);
}
const $c53c71b9b5eaa2c4$export$d5e924cbc07fb966 = /* @__PURE__ */ (0, $6afhl.op)({
    conv2dTranspose_: $c53c71b9b5eaa2c4$var$conv2dTranspose_
});

});
parcelRegister("1iZpR", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInput", function () { return $0f371cdcd3175b61$export$633310eed0c26e72; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the derivative of the input of a 2D convolution.
 *
 * @param xShape The shape of the input: [batch, height, width, inDepth].
 * If length of 3, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 4 or rank 3 of shape
 *   `[batch, outHeight, outWidth, outDepth]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $0f371cdcd3175b61$var$conv2DBackpropInput_(xShape, dy, filter, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    $eOiOM.assert(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape4D = xShape;
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $8nMOl.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
        xShape4D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2]
        ];
    }
    $eOiOM.assert(xShape4D.length === 4, ()=>`Error in conv2dDerInput: inShape must be length 4, but got length ` + `${xShape4D.length}.`);
    $eOiOM.assert(dy4D.rank === 4, ()=>`Error in conv2dDerInput: dy must be rank 4, but got ` + `rank ${dy4D.rank}`);
    $eOiOM.assert(filter.rank === 4, ()=>`Error in conv2dDerInput: filter must be rank 4, but got ` + `rank ${filter.rank}`);
    const inDepth = dataFormat === 'NHWC' ? xShape4D[3] : xShape4D[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $eOiOM.assert(inDepth === filter.shape[2], ()=>`Error in conv2dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[2]}.`);
    $eOiOM.assert(outDepth === filter.shape[3], ()=>`Error in conv2dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[3]}.`);
    $g0V2M.checkPadOnDimRoundingMode('conv2dDerInput', pad, dimRoundingMode);
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        inputShape: xShape4D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Conv2DBackpropInput), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $0f371cdcd3175b61$export$633310eed0c26e72 = /* @__PURE__ */ (0, $6afhl.op)({
    conv2DBackpropInput_: $0f371cdcd3175b61$var$conv2DBackpropInput_
});

});


parcelRegister("4B9eF", function(module, exports) {

$parcel$export(module.exports, "conv3d", function () { return $3591c81bd40e9fe8$export$c476b02bcf7b2def; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes a 3D convolution over the input x.
 *
 * @param x The input tensor, of rank 5 or rank 4, of shape
 *     `[batch, depth, height, width, channels]`. If rank 4,
 * batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inChannels, outChannels]`.
 *      inChannels must match between input and filter.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat: An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationDepth, dilationHeight,
 *     dilationWidth]` in which we sample input values across the height
 *     and width dimensions in atrous convolution. Defaults to `[1, 1, 1]`.
 *     If `dilations` is a single number, then
 *     `dilationDepth == dilationHeight == dilationWidth`. If it is greater
 *     than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $3591c81bd40e9fe8$var$conv3d_(x, filter, strides, pad, dataFormat = 'NDHWC', dilations = [
    1,
    1,
    1
]) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'conv3d');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'conv3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $eOiOM.assert(x5D.rank === 5, ()=>`Error in conv3d: input must be rank 5, but got rank ${x5D.rank}.`);
    $eOiOM.assert($filter.rank === 5, ()=>`Error in conv3d: filter must be rank 5, but got rank ` + `${$filter.rank}.`);
    $eOiOM.assert(x5D.shape[4] === $filter.shape[3], ()=>`Error in conv3d: depth of input (${x5D.shape[4]}) must match ` + `input depth for filter ${$filter.shape[3]}.`);
    $eOiOM.assert((0, $g0V2M.eitherStridesOrDilationsAreOne)(strides, dilations), ()=>'Error in conv3D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $eOiOM.assert(dataFormat === 'NDHWC', ()=>`Error in conv3d: got dataFormat of ${dataFormat} but only NDHWC is currently supported.`);
    $eOiOM.assert((0, $g0V2M.stridesOrDilationsArePositive)(dilations), ()=>'Error in conv3D: Dilated rates should be larger than 0.');
    $eOiOM.assert((0, $g0V2M.stridesOrDilationsArePositive)(strides), ()=>'Error in conv3D: Strides should be larger than 0.');
    const inputs = {
        x: x5D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Conv3D), inputs, attrs);
    if (reshapedTo5D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $3591c81bd40e9fe8$export$c476b02bcf7b2def = /* @__PURE__ */ (0, $6afhl.op)({
    conv3d_: $3591c81bd40e9fe8$var$conv3d_
});

});

parcelRegister("lqPND", function(module, exports) {

$parcel$export(module.exports, "conv3dTranspose", function () { return $f9a43502ca7216d1$export$5eac62031b3f449f; });

var $x4eLk = parcelRequire("x4eLk");

var $RWsOw = parcelRequire("RWsOw");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the transposed 3D convolution of a volume, also known as a
 * deconvolution.
 *
 * @param x The input image, of rank 5 or rank 4, of shape
 *   `[batch, depth, height, width, inDepth]`. If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 4, of shape
 *     `[depth, filterHeight, filterWidth, outDepth, inDepth]`.
 *     `inDepth` must match `inDepth` in `x`.
 * @param outputShape Output shape, of rank 5 or rank 4:
 *     `[batch, depth, height, width, outDepth]`. If rank 3, batch of 1 is
 *    assumed.
 * @param strides The strides of the original convolution:
 *     `[strideDepth, strideHeight, strideWidth]`.
 * @param pad  The type of padding algorithm used in the non-transpose version
 *    of the op.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $f9a43502ca7216d1$var$conv3dTranspose_(x, filter, outputShape, strides, pad) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'conv3dTranspose');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'conv3dTranspose');
    return (0, $RWsOw.conv3DBackpropInput)(outputShape, $x, $filter, strides, pad);
}
const $f9a43502ca7216d1$export$5eac62031b3f449f = /* @__PURE__ */ (0, $6afhl.op)({
    conv3dTranspose_: $f9a43502ca7216d1$var$conv3dTranspose_
});

});
parcelRegister("RWsOw", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropInput", function () { return $0a224d086e0b98dd$export$deb6d1ca1fa2977b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the derivative of the input of a 3D convolution.
 *
 * @param xShape The shape of the input: [batch, depth, height, width,
 * in_channels]. If length of 4, batch of 1 is assumed.
 * @param dy The derivative of the output, of rank 5 or rank 4 of shape
 *   `[batch, outDepth, outHeight, outWidth, in_channels]`.
 * If rank 4, batch of 1 is assumed.
 * @param filter The filter, rank 5, of shape
 *     `[filterDepth, filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideDepth, strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm used:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 */ function $0a224d086e0b98dd$var$conv3DBackpropInput_(xShape, dy, filter, strides, pad) {
    $eOiOM.assert(xShape.length === dy.rank, ()=>`Length of inShape ` + `(${xShape.length}) and rank of dy (${dy.rank}) must match`);
    let xShape5D = xShape;
    let dy5D = dy;
    let reshapedTo5D = false;
    if (dy.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $8nMOl.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2],
            dy.shape[3]
        ]);
        xShape5D = [
            1,
            xShape[0],
            xShape[1],
            xShape[2],
            xShape[3]
        ];
    }
    const inDepth = xShape5D[4];
    const outDepth = dy5D.shape[4];
    $eOiOM.assert(xShape5D.length === 5, ()=>`Error in conv3dDerInput: inShape must be length 5, but got length ` + `${xShape5D.length}.`);
    $eOiOM.assert(dy5D.rank === 5, ()=>`Error in conv3dDerInput: dy must be rank 5, but got ` + `rank ${dy5D.rank}`);
    $eOiOM.assert(filter.rank === 5, ()=>`Error in conv3dDerInput: filter must be rank 5, but got ` + `rank ${filter.rank}`);
    $eOiOM.assert(inDepth === filter.shape[3], ()=>`Error in conv3dDerInput: depth of input (${inDepth}) must ` + `match input depth for filter ${filter.shape[3]}.`);
    $eOiOM.assert(outDepth === filter.shape[4], ()=>`Error in conv3dDerInput: depth of output (${outDepth}) must ` + `match output depth for filter ${filter.shape[4]}.`);
    const inputs = {
        dy: dy5D,
        filter: filter
    };
    const attrs = {
        pad: pad,
        strides: strides,
        inputShape: xShape5D
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Conv3DBackpropInputV2), inputs, attrs);
    if (reshapedTo5D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $0a224d086e0b98dd$export$deb6d1ca1fa2977b = /* @__PURE__ */ (0, $6afhl.op)({
    conv3DBackpropInput_: $0a224d086e0b98dd$var$conv3DBackpropInput_
});

});


parcelRegister("dzBZ1", function(module, exports) {

$parcel$export(module.exports, "denseBincount", function () { return $9e1c01ed890536ab$export$436934e6cf1946f1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1 or rank 2.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 * @param binaryOutput Optional. Whether the kernel should count the appearance
 *     or number of occurrences. Defaults to False.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $9e1c01ed890536ab$var$denseBincount_(x, weights, size, binaryOutput = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'denseBincount');
    const $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'denseBincount');
    $eOiOM.assert($x.dtype === 'int32', ()=>`Error in denseBincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $eOiOM.assert($x.rank <= 2, ()=>`Error in denseBincount: input must be at most rank 2, but got ` + `rank ${$x.rank}.`);
    $eOiOM.assert(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $eOiOM.assert($weights.size === $x.size || $weights.size === 0, ()=>`Error in denseBincount: weights must have the same shape as x or ` + `0-length, but got x shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size,
        binaryOutput: binaryOutput
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.DenseBincount), inputs, attrs);
}
const $9e1c01ed890536ab$export$436934e6cf1946f1 = /* @__PURE__ */ (0, $6afhl.op)({
    denseBincount_: $9e1c01ed890536ab$var$denseBincount_
});

});

parcelRegister("kQqya", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2d", function () { return $f2cd4241fa3b6e32$export$48a8ad9494a8fad8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Depthwise 2D convolution.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $f2cd4241fa3b6e32$var$depthwiseConv2d_(x, filter, strides, pad, dataFormat = 'NHWC', dilations = [
    1,
    1
], dimRoundingMode) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $eOiOM.assert(x4D.rank === 4, ()=>`Error in depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $eOiOM.assert($filter.rank === 4, ()=>`Error in depthwiseConv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    const inChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $eOiOM.assert(inChannels === $filter.shape[2], ()=>`Error in depthwiseConv2d: number of input channels ` + `(${inChannels}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    $g0V2M.checkPadOnDimRoundingMode('depthwiseConv2d', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.DepthwiseConv2dNative), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $f2cd4241fa3b6e32$export$48a8ad9494a8fad8 = /* @__PURE__ */ (0, $6afhl.op)({
    depthwiseConv2d_: $f2cd4241fa3b6e32$var$depthwiseConv2d_
});

});

parcelRegister("e1QJV", function(module, exports) {

$parcel$export(module.exports, "dropout", function () { return $a36a11b204103781$export$fe05aa12367b4e47; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3pVUH = parcelRequire("3pVUH");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6Ab5n = parcelRequire("6Ab5n");

var $dIChU = parcelRequire("dIChU");

var $5n3K3 = parcelRequire("5n3K3");

var $3k4XX = parcelRequire("3k4XX");

var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $9ORo6 = parcelRequire("9ORo6");
/**
 * Computes dropout.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 2, 1]);
 * const rate = 0.75;
 * const output = tf.dropout(x, rate);
 * output.print();
 * ```
 *
 * @param x A floating point Tensor or TensorLike.
 * @param rate A float in the range [0, 1). The probability that each element
 *   of x is discarded.
 * @param noiseShape An array of numbers of type int32, representing the
 * shape for randomly generated keep/drop flags. If the noiseShape has null
 * value, it will be automatically replaced with the x's relative dimension
 * size. Optional.
 * @param seed Used to create random seeds. Optional.
 * @returns A Tensor of the same shape of x.
 *
 * @doc {heading: 'Operations', subheading: 'Dropout'}
 */ function $a36a11b204103781$var$dropout_(x, rate, noiseShape, seed) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'dropout');
    $eOiOM.assert($x.dtype === 'float32', ()=>`x has to be a floating point tensor since it's going to be ` + `scaled, but got a ${$x.dtype} tensor instead.`);
    $eOiOM.assert(rate >= 0 && rate < 1, ()=>`rate must be a float in the range [0, 1), but got ${rate}.`);
    if (rate === 0) return x instanceof (0, $3pVUH.Tensor) ? $x.clone() : $x;
    const $noiseShape = (0, $5n3K3.getNoiseShape)($x, noiseShape);
    const keepProb = 1 - rate;
    const multiplier = (0, $dIChU.div)((0, $3k4XX.floor)((0, $6Ab5n.add)((0, $9ORo6.randomUniform)($noiseShape, 0, 1, 'float32', seed), keepProb)), keepProb);
    return (0, $5hAos.mul)($x, multiplier);
}
const $a36a11b204103781$export$fe05aa12367b4e47 = /* @__PURE__ */ (0, $6afhl.op)({
    dropout_: $a36a11b204103781$var$dropout_
});

});
parcelRegister("5n3K3", function(module, exports) {

$parcel$export(module.exports, "getNoiseShape", function () { return $01025ada05df9e8b$export$5cc59b1f6d856c8e; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
function $01025ada05df9e8b$export$5cc59b1f6d856c8e(x, noiseShape) {
    if (noiseShape == null) return x.shape.slice();
    if ($eOiOM.arraysEqual(x.shape, noiseShape)) return noiseShape;
    if (x.shape.length === noiseShape.length) {
        const newDimension = [];
        for(let i = 0; i < x.shape.length; i++)if (noiseShape[i] == null && x.shape[i] != null) newDimension.push(x.shape[i]);
        else newDimension.push(noiseShape[i]);
        return newDimension;
    }
    return noiseShape;
}

});

parcelRegister("3k4XX", function(module, exports) {

$parcel$export(module.exports, "floor", function () { return $26b71784c1888a5a$export$a3fe094919f356fd; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes floor of input `tf.Tensor` element-wise: `floor(x)`.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.floor().print();  // or tf.floor(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $26b71784c1888a5a$var$floor_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'floor', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Floor), inputs);
}
const $26b71784c1888a5a$export$a3fe094919f356fd = /* @__PURE__ */ (0, $6afhl.op)({
    floor_: $26b71784c1888a5a$var$floor_
});

});

parcelRegister("9ORo6", function(module, exports) {

$parcel$export(module.exports, "randomUniform", function () { return $726232477f9bda6f$export$bd6fd37822e292fa; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");

var $5siju = parcelRequire("5siju");

var $6afhl = parcelRequire("6afhl");

var $5ZlCt = parcelRequire("5ZlCt");
/**
 * Creates a `tf.Tensor` with values sampled from a uniform distribution.
 *
 * The generated values follow a uniform distribution in the range [minval,
 * maxval). The lower bound minval is included in the range, while the upper
 * bound maxval is excluded.
 *
 * ```js
 * tf.randomUniform([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval The lower bound on the range of random values to generate.
 *   Defaults to 0.
 * @param maxval The upper bound on the range of random values to generate.
 *   Defaults to 1.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 * @param seed An optional int. Defaults to 0. If seed is set to be non-zero,
 *   the random number generator is seeded by the given seed. Otherwise, it is
 *   seeded by a random seed.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $726232477f9bda6f$var$randomUniform_(shape, minval = 0, maxval = 1, dtype = 'float32', seed) {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    const res = (0, $5siju.buffer)(shape, dtype);
    const random = new (0, $5ZlCt.UniformRandom)(minval, maxval, null, seed);
    for(let i = 0; i < res.values.length; i++)res.values[i] = random.nextValue();
    return res.toTensor();
}
const $726232477f9bda6f$export$bd6fd37822e292fa = /* @__PURE__ */ (0, $6afhl.op)({
    randomUniform_: $726232477f9bda6f$var$randomUniform_
});

});
parcelRegister("5ZlCt", function(module, exports) {

$parcel$export(module.exports, "MPRandGauss", function () { return $45c36b759e3a9631$export$d23b64058df0188a; });
$parcel$export(module.exports, "RandGamma", function () { return $45c36b759e3a9631$export$bffe1ad508acdb18; });
$parcel$export(module.exports, "UniformRandom", function () { return $45c36b759e3a9631$export$1e4a6d1367ace404; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $23NWZ = parcelRequire("23NWZ");

var $51pql = parcelRequire("51pql");
class $45c36b759e3a9631$export$d23b64058df0188a {
    constructor(mean, stdDeviation, dtype, truncated, seed){
        this.mean = mean;
        this.stdDev = stdDeviation;
        this.dtype = dtype;
        this.nextVal = NaN;
        this.truncated = truncated;
        if (this.truncated) {
            this.upper = this.mean + this.stdDev * 2;
            this.lower = this.mean - this.stdDev * 2;
        }
        const seedValue = seed ? seed : Math.random();
        this.random = $23NWZ.alea(seedValue.toString());
    }
    /** Returns next sample from a Gaussian distribution. */ nextValue() {
        if (!isNaN(this.nextVal)) {
            const value = this.nextVal;
            this.nextVal = NaN;
            return value;
        }
        let resultX, resultY;
        let isValid = false;
        while(!isValid){
            let v1, v2, s;
            do {
                v1 = 2 * this.random() - 1;
                v2 = 2 * this.random() - 1;
                s = v1 * v1 + v2 * v2;
            }while (s >= 1 || s === 0);
            const mul = Math.sqrt(-2 * Math.log(s) / s);
            resultX = this.mean + this.stdDev * v1 * mul;
            resultY = this.mean + this.stdDev * v2 * mul;
            if (!this.truncated || this.isValidTruncated(resultX)) isValid = true;
        }
        if (!this.truncated || this.isValidTruncated(resultY)) this.nextVal = this.convertValue(resultY);
        return this.convertValue(resultX);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype == null || this.dtype === 'float32') return value;
        return Math.round(value);
    }
    /** Returns true if less than 2-standard-deviations from the mean. */ isValidTruncated(value) {
        return value <= this.upper && value >= this.lower;
    }
}
class $45c36b759e3a9631$export$bffe1ad508acdb18 {
    constructor(alpha, beta, dtype, seed){
        this.alpha = alpha;
        this.beta = 1 / beta; // convert rate to scale parameter
        this.dtype = dtype;
        const seedValue = seed ? seed : Math.random();
        this.randu = $23NWZ.alea(seedValue.toString());
        this.randn = new $45c36b759e3a9631$export$d23b64058df0188a(0, 1, dtype, false, this.randu());
        if (alpha < 1) this.d = alpha + 2 / 3;
        else this.d = alpha - 1 / 3;
        this.c = 1 / Math.sqrt(9 * this.d);
    }
    /** Returns next sample from a gamma distribution. */ nextValue() {
        let x2, v0, v1, x, u, v;
        while(true){
            do {
                x = this.randn.nextValue();
                v = 1 + this.c * x;
            }while (v <= 0);
            v *= v * v;
            x2 = x * x;
            v0 = 1 - 0.331 * x2 * x2;
            v1 = 0.5 * x2 + this.d * (1 - v + Math.log(v));
            u = this.randu();
            if (u < v0 || Math.log(u) < v1) break;
        }
        v = 1 / this.beta * this.d * v;
        if (this.alpha < 1) v *= Math.pow(this.randu(), 1 / this.alpha);
        return this.convertValue(v);
    }
    /** Handles proper rounding for non-floating-point numbers. */ convertValue(value) {
        if (this.dtype === 'float32') return value;
        return Math.round(value);
    }
}
class $45c36b759e3a9631$export$1e4a6d1367ace404 {
    constructor(min = 0, max = 1, dtype, seed){
        /** Handles proper rounding for non floating point numbers. */ this.canReturnFloat = ()=>this.dtype == null || this.dtype === 'float32';
        this.min = min;
        this.range = max - min;
        this.dtype = dtype;
        if (seed == null) seed = Math.random();
        if (typeof seed === 'number') seed = seed.toString();
        if (!this.canReturnFloat() && this.range <= 1) throw new Error(`The difference between ${min} - ${max} <= 1 and dtype is not float`);
        this.random = $23NWZ.alea(seed);
    }
    convertValue(value) {
        if (this.canReturnFloat()) return value;
        return Math.round(value);
    }
    nextValue() {
        return this.convertValue(this.min + this.range * this.random());
    }
}
function $45c36b759e3a9631$export$5f38b2eb2df54d68(values) {
    // https://en.wikipedia.org/wiki/Jarque%E2%80%93Bera_test
    const n = values.length;
    const s = $45c36b759e3a9631$var$skewness(values);
    const k = $45c36b759e3a9631$var$kurtosis(values);
    const jb = n / 6 * (Math.pow(s, 2) + 0.25 * Math.pow(k - 3, 2));
    // JB test requires 2-degress of freedom from Chi-Square @ 0.95:
    // http://www.itl.nist.gov/div898/handbook/eda/section3/eda3674.htm
    const CHI_SQUARE_2DEG = 5.991;
    if (jb > CHI_SQUARE_2DEG) throw new Error(`Invalid p-value for JB: ${jb}`);
}
function $45c36b759e3a9631$export$3286e17febe230d(actual, expectedMean, expectedStdDev, epsilon) {
    if (epsilon == null) epsilon = (0, $51pql.testEpsilon)();
    const actualMean = $45c36b759e3a9631$var$mean(actual);
    (0, $51pql.expectNumbersClose)(actualMean, expectedMean, epsilon);
    (0, $51pql.expectNumbersClose)($45c36b759e3a9631$var$standardDeviation(actual, actualMean), expectedStdDev, epsilon);
}
function $45c36b759e3a9631$var$mean(values) {
    let sum = 0;
    for(let i = 0; i < values.length; i++)sum += values[i];
    return sum / values.length;
}
function $45c36b759e3a9631$var$standardDeviation(values, mean) {
    let squareDiffSum = 0;
    for(let i = 0; i < values.length; i++){
        const diff = values[i] - mean;
        squareDiffSum += diff * diff;
    }
    return Math.sqrt(squareDiffSum / values.length);
}
function $45c36b759e3a9631$var$kurtosis(values) {
    // https://en.wikipedia.org/wiki/Kurtosis
    const valuesMean = $45c36b759e3a9631$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum4 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum4 += Math.pow(v, 4);
    }
    return 1 / n * sum4 / Math.pow(1 / n * sum2, 2);
}
function $45c36b759e3a9631$var$skewness(values) {
    // https://en.wikipedia.org/wiki/Skewness
    const valuesMean = $45c36b759e3a9631$var$mean(values);
    const n = values.length;
    let sum2 = 0;
    let sum3 = 0;
    for(let i = 0; i < n; i++){
        const v = values[i] - valuesMean;
        sum2 += Math.pow(v, 2);
        sum3 += Math.pow(v, 3);
    }
    return 1 / n * sum3 / Math.pow(1 / (n - 1) * sum2, 1.5);
}

});
parcelRegister("51pql", function(module, exports) {

$parcel$export(module.exports, "testEpsilon", function () { return $3a80c468480eebc6$export$e73bb4a504595b05; });
$parcel$export(module.exports, "expectNumbersClose", function () { return $3a80c468480eebc6$export$a09d1668dd6f88b6; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");
var $lBDHD = parcelRequire("lBDHD");
const $3a80c468480eebc6$var$TEST_EPSILON_FLOAT32 = 1e-3;
const $3a80c468480eebc6$export$a86b4427e7a62065 = 1e-1;
function $3a80c468480eebc6$export$33c766a1062be5b2(actual, expected, epsilon) {
    if (epsilon == null) epsilon = $3a80c468480eebc6$export$e73bb4a504595b05();
    return $3a80c468480eebc6$var$expectArraysPredicate(actual, expected, (a, b)=>$3a80c468480eebc6$var$areClose(a, b, epsilon));
}
function $3a80c468480eebc6$export$e73bb4a504595b05() {
    return (0, $e6Ey6.ENGINE).backend.floatPrecision() === 32 ? $3a80c468480eebc6$var$TEST_EPSILON_FLOAT32 : $3a80c468480eebc6$export$a86b4427e7a62065;
}
function $3a80c468480eebc6$var$expectArraysPredicate(actual, expected, predicate) {
    let checkClassType = true;
    if ((0, $lBDHD.isTypedArray)(actual) || (0, $lBDHD.isTypedArray)(expected)) checkClassType = false;
    if ((0, $lBDHD.isTypedArray)(actual) && (0, $lBDHD.isTypedArray)(expected)) checkClassType = true;
    if (checkClassType) {
        const aType = actual.constructor.name;
        const bType = expected.constructor.name;
        if (aType !== bType) throw new Error(`Arrays are of different type. Actual: ${aType}. ` + `Expected: ${bType}`);
    }
    if (Array.isArray(actual) && Array.isArray(expected)) {
        const actualShape = (0, $x4eLk.inferShape)(actual);
        const expectedShape = (0, $x4eLk.inferShape)(expected);
        if (!(0, $eOiOM.arraysEqual)(actualShape, expectedShape)) throw new Error(`Arrays have different shapes. ` + `Actual: [${actualShape}]. Expected: [${expectedShape}]`);
    }
    const actualFlat = (0, $lBDHD.isTypedArray)(actual) ? actual : (0, $lBDHD.flatten)(actual);
    const expectedFlat = (0, $lBDHD.isTypedArray)(expected) ? expected : (0, $lBDHD.flatten)(expected);
    if (actualFlat.length !== expectedFlat.length) throw new Error(`Arrays have different lengths actual: ${actualFlat.length} vs ` + `expected: ${expectedFlat.length}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    for(let i = 0; i < expectedFlat.length; ++i){
        const a = actualFlat[i];
        const e = expectedFlat[i];
        if (!predicate(a, e)) throw new Error(`Arrays differ: actual[${i}] = ${a}, expected[${i}] = ${e}.\n` + `Actual:   ${actualFlat}.\n` + `Expected: ${expectedFlat}.`);
    }
    if (typeof expect !== 'undefined') expect().nothing();
}
function $3a80c468480eebc6$export$f1ce55133f3520c4(fn, done) {
    fn().then(()=>done.fail(), ()=>done());
    if (typeof expect !== 'undefined') expect().nothing();
}
function $3a80c468480eebc6$export$347f1ed9dcafca0d(actual, expected) {
    const exp = typeof expected === 'string' || typeof expected === 'number' || typeof expected === 'boolean' ? [
        expected
    ] : expected;
    if ((0, $eOiOM.isString)(actual) || (0, $eOiOM.isString)(actual[0]) || (0, $eOiOM.isString)(expected) || (0, $eOiOM.isString)(expected[0])) // tslint:disable-next-line: triple-equals
    return $3a80c468480eebc6$var$expectArraysPredicate(actual, exp, (a, b)=>a == b);
    return $3a80c468480eebc6$var$expectArraysPredicate(actual, expected, (a, b)=>$3a80c468480eebc6$var$areClose(a, b, 0));
}
function $3a80c468480eebc6$export$a09d1668dd6f88b6(a, e, epsilon) {
    if (epsilon == null) epsilon = $3a80c468480eebc6$export$e73bb4a504595b05();
    if (!$3a80c468480eebc6$var$areClose(a, e, epsilon)) throw new Error(`Numbers differ: actual === ${a}, expected === ${e}`);
    if (typeof expect !== 'undefined') expect().nothing();
}
function $3a80c468480eebc6$var$areClose(a, e, epsilon) {
    if (!isFinite(a) && !isFinite(e)) return true;
    if (isNaN(a) || isNaN(e) || Math.abs(a - e) > epsilon) return false;
    return true;
}
function $3a80c468480eebc6$export$1af4797b1eac800b(actual, low, high) {
    for(let i = 0; i < actual.length; i++){
        if (actual[i] < low || actual[i] > high) throw new Error(`Value out of range:${actual[i]} low: ${low}, high: ${high}`);
    }
}
function $3a80c468480eebc6$export$28801b43871bdbc0(actual, expected) {
    // Safari does not like comparing ArrayBuffers directly. Wrapping in
    // a Float32Array solves this issue.
    const actualArray = new Float32Array(actual);
    const expectedArray = new Float32Array(expected);
    if (actualArray.length !== expectedArray.length) throw new Error('Expected ArrayBuffer to be of length ' + `${expectedArray.length}, but it was ${actualArray.length}`);
    for(let i = 0; i < expectedArray.length; i++){
        if (actualArray[i] !== expectedArray[i]) throw new Error(`Expected ArrayBuffer value at ${i} to be ` + `${expectedArray[i]} but got ${actualArray[i]} instead`);
    }
}
function $3a80c468480eebc6$export$a3027a992fa03b9e(a) {
    for(let i = 0; i < a.length; i++){
        const val = a[i];
        if (Array.isArray(val)) $3a80c468480eebc6$export$a3027a992fa03b9e(val);
        else a[i] = (0, $lBDHD.encodeString)(val);
    }
    return a;
}
function $3a80c468480eebc6$export$f4f3d816544d7e44(source) {
    const video = document.createElement('video');
    if ('playsInline' in video) // tslint:disable-next-line:no-any
    video.playsInline = true;
    video.muted = true;
    video.loop = true;
    video.style.position = 'fixed';
    video.style.left = '0px';
    video.style.top = '0px';
    video.preload = 'auto';
    video.appendChild(source);
    return new Promise((resolve)=>{
        video.addEventListener('loadeddata', (_)=>resolve(video));
        video.load();
    });
}
async function $3a80c468480eebc6$export$899fbdb5fa08b653(video) {
    await video.play();
    if ('requestVideoFrameCallback' in video) await new Promise((resolve)=>{
        // tslint:disable-next-line:no-any
        video.requestVideoFrameCallback(resolve);
    });
}

});




parcelRegister("28GAP", function(module, exports) {

$parcel$export(module.exports, "equal", function () { return $18ed5e3247ac3f64$export$411ce8e5a71e3069; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of (a == b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.equal(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $18ed5e3247ac3f64$var$equal_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'equal', 'string_or_numeric');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'equal', 'string_or_numeric');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Equal), inputs);
}
const $18ed5e3247ac3f64$export$411ce8e5a71e3069 = /* @__PURE__ */ (0, $6afhl.op)({
    equal_: $18ed5e3247ac3f64$var$equal_
});

});

parcelRegister("86rqz", function(module, exports) {

$parcel$export(module.exports, "erf", function () { return $5e6428d58838bdcc$export$d3896f355fc09423; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $fxiHg = parcelRequire("fxiHg");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes Gauss error function of the input `tf.Tensor` element-wise:
 * `erf(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.erf().print(); // or tf.erf(x);
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $5e6428d58838bdcc$var$erf_(x) {
    let $x = (0, $x4eLk.convertToTensor)(x, 'x', 'erf');
    $eOiOM.assert($x.dtype === 'int32' || $x.dtype === 'float32', ()=>'Input dtype must be `int32` or `float32`.');
    if ($x.dtype === 'int32') $x = (0, $fxiHg.cast)($x, 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Erf), inputs);
}
const $5e6428d58838bdcc$export$d3896f355fc09423 = /* @__PURE__ */ (0, $6afhl.op)({
    erf_: $5e6428d58838bdcc$var$erf_
});

});

parcelRegister("1lCoz", function(module, exports) {

$parcel$export(module.exports, "exp", function () { return $0fb589183af5f7aa$export$b310ec824aaee37f; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes exponential of the input `tf.Tensor` element-wise. `e ^ x`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.exp().print();  // or tf.exp(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0fb589183af5f7aa$var$exp_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'exp');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Exp), inputs);
}
const $0fb589183af5f7aa$export$b310ec824aaee37f = /* @__PURE__ */ (0, $6afhl.op)({
    exp_: $0fb589183af5f7aa$var$exp_
});

});

parcelRegister("fO4kJ", function(module, exports) {

$parcel$export(module.exports, "expandDims", function () { return $b81ee30914a8fb84$export$d660d8ed21f46635; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns a `tf.Tensor` that has expanded rank, by inserting a dimension
 * into the tensor's shape.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const axis = 1;
 * x.expandDims(axis).print();
 * ```
 *
 * @param x The input tensor whose dimensions are to be expanded.
 * @param axis The dimension index at which to insert shape of `1`. Defaults
 *     to 0 (the first dimension).
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $b81ee30914a8fb84$var$expandDims_(x, axis = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'expandDims', 'string_or_numeric');
    $eOiOM.assert(axis <= $x.rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = {
        input: $x
    };
    const attrs = {
        dim: axis
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ExpandDims), inputs, attrs);
}
const $b81ee30914a8fb84$export$d660d8ed21f46635 = /* @__PURE__ */ (0, $6afhl.op)({
    expandDims_: $b81ee30914a8fb84$var$expandDims_
});

});

parcelRegister("8YZZT", function(module, exports) {

$parcel$export(module.exports, "eye", function () { return $68a404ad04d197b6$export$4e18cf730a59887e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5siju = parcelRequire("5siju");

var $fO4kJ = parcelRequire("fO4kJ");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");

var $dolPi = parcelRequire("dolPi");
/**
 * Create an identity matrix.
 *
 * @param numRows Number of rows.
 * @param numColumns Number of columns. Defaults to `numRows`.
 * @param batchShape If provided, will add the batch shape to the beginning
 *   of the shape of the returned `tf.Tensor` by repeating the identity
 *   matrix.
 * @param dtype Data type.
 * @returns Identity matrix of the specified size and data type, possibly
 *   with batch repetition if `batchShape` is specified.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $68a404ad04d197b6$var$eye_(numRows, numColumns, batchShape, dtype = 'float32') {
    if (numColumns == null) numColumns = numRows;
    const buff = (0, $5siju.buffer)([
        numRows,
        numColumns
    ], dtype);
    const n = numRows <= numColumns ? numRows : numColumns;
    for(let i = 0; i < n; ++i)buff.set(1, i, i);
    const out = (0, $8nMOl.reshape)(buff.toTensor(), [
        numRows,
        numColumns
    ]);
    if (batchShape == null) return out;
    else {
        if (batchShape.length === 1) return (0, $dolPi.tile)((0, $fO4kJ.expandDims)(out, 0), [
            batchShape[0],
            1,
            1
        ]);
        else if (batchShape.length === 2) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $dolPi.tile)((0, $fO4kJ.expandDims)((0, $fO4kJ.expandDims)(out, 0), 0), [
            batchShape[0],
            batchShape[1],
            1,
            1
        ]);
        else if (batchShape.length === 3) // tslint:disable-next-line:no-unnecessary-type-assertion
        return (0, $dolPi.tile)((0, $fO4kJ.expandDims)((0, $fO4kJ.expandDims)((0, $fO4kJ.expandDims)(out, 0), 0), 0), [
            batchShape[0],
            batchShape[1],
            batchShape[2],
            1,
            1
        ]);
        else throw new Error(`eye() currently supports only 1D and 2D ` + // tslint:disable-next-line:no-any
        `batchShapes, but received ${batchShape.length}D.`);
    }
}
const $68a404ad04d197b6$export$4e18cf730a59887e = /* @__PURE__ */ (0, $6afhl.op)({
    eye_: $68a404ad04d197b6$var$eye_
});

});
parcelRegister("dolPi", function(module, exports) {

$parcel$export(module.exports, "tile", function () { return $9bfe72880d8a3d8b$export$3c17558da18e4d75; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Construct a tensor by repeating it the number of times given by reps.
 *
 * This operation creates a new tensor by replicating `input` `reps`
 * times. The output tensor's `i`th dimension has `input.shape[i] *
 * reps[i]` elements, and the values of `input` are replicated
 * `reps[i]` times along the `i`th dimension. For example, tiling
 * `[a, b, c, d]` by `[2]` produces `[a, b, c, d, a, b, c, d]`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 *
 * a.tile([2]).print();    // or tf.tile(a, [2])
 * ```
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.tile([1, 2]).print();  // or tf.tile(a, [1,2])
 * ```
 * @param x The tensor to tile.
 * @param reps Determines the number of replications per dimension.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $9bfe72880d8a3d8b$var$tile_(x, reps) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'tile', 'string_or_numeric');
    $eOiOM.assert($x.rank === reps.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of reps ${reps}.`);
    const inputs = {
        x: $x
    };
    const attrs = {
        reps: reps
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Tile), inputs, attrs);
}
const $9bfe72880d8a3d8b$export$3c17558da18e4d75 = /* @__PURE__ */ (0, $6afhl.op)({
    tile_: $9bfe72880d8a3d8b$var$tile_
});

});


parcelRegister("eJ7TQ", function(module, exports) {

$parcel$export(module.exports, "conv2d", function () { return (parcelRequire("1eOPb")).conv2d; });
$parcel$export(module.exports, "depthwiseConv2d", function () { return (parcelRequire("jskui")).depthwiseConv2d; });
$parcel$export(module.exports, "matMul", function () { return (parcelRequire("9xwD6")).matMul; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eOPb = parcelRequire("1eOPb");

var $jskui = parcelRequire("jskui");

var $9xwD6 = parcelRequire("9xwD6");

});
parcelRegister("1eOPb", function(module, exports) {

$parcel$export(module.exports, "conv2d", function () { return $0e6e85ec42bc10ee$export$188f9215482e3db8; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $1Npyr = parcelRequire("1Npyr");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6Ab5n = parcelRequire("6Ab5n");

var $5mf1d = parcelRequire("5mf1d");

var $9JluG = parcelRequire("9JluG");

var $6jqyV = parcelRequire("6jqyV");

var $1iZpR = parcelRequire("1iZpR");

var $g0V2M = parcelRequire("g0V2M");

var $a7HBS = parcelRequire("a7HBS");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes a 2D convolution over the input x, optionally fused with adding a
 * bias and applying an activation.
 *
 * ```js
 * const inputDepth = 2;
 * const inShape = [2, 2, 2, inputDepth];
 * const outputDepth = 2;
 * const fSize = 1;
 * const pad = 0;
 * const strides = 1;
 *
 * const x = tf.tensor4d( [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
 * 16], inShape);
 * const w = tf.tensor4d([-1, 1, -2, 0.5], [fSize, fSize, inputDepth,
 * outputDepth]);
 *
 * tf.fused.conv2d({ x, filter: w, strides, pad, dataFormat: 'NHWC',
 * dilations: [1, 1], bias: tf.scalar(5), activation: 'relu' }).print();
 * ```
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter, rank 4, of shape
 *     `[filterHeight, filterWidth, inDepth, outDepth]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid` output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`) to be
 *     applied
 *      after biasAdd.
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $0e6e85ec42bc10ee$var$fusedConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    activation = activation || 'linear';
    if ((0, $a7HBS.shouldFuse)((0, $e6Ey6.ENGINE).state.gradientDepth, activation) === false) {
        // TODO: Transpose bias and preluActivationWeights properly for NCHW
        // format before computation.
        $eOiOM.assert(dataFormat === 'NHWC', ()=>`Error in fused conv2d: got dataFormat of ${dataFormat} but ` + `only NHWC is currently supported for the case of gradient depth ` + `is 0 and the activation is not linear.`);
        let result = (0, $9JluG.conv2d)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $6Ab5n.add)(result, bias);
        return (0, $a7HBS.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'conv2d', 'float32');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'conv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $eOiOM.assert(x4D.rank === 4, ()=>`Error in fused conv2d: input must be rank 4, but got rank ` + `${x4D.rank}.`);
    $eOiOM.assert($filter.rank === 4, ()=>`Error in fused conv2d: filter must be rank 4, but got rank ` + `${$filter.rank}.`);
    $g0V2M.checkPadOnDimRoundingMode('fused conv2d', pad, dimRoundingMode);
    const inputChannels = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    $eOiOM.assert($filter.shape[2] === inputChannels, ()=>`Error in conv2d: depth of input (${inputChannels}) must match ` + `input depth for filter ${$filter.shape[2]}.`);
    $eOiOM.assert($g0V2M.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in conv2D: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $g0V2M.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode);
    let $bias;
    if (bias != null) {
        $bias = (0, $x4eLk.convertToTensor)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $gpWQN.makeTypesMatch)($bias, $x);
        // According to TensorFlow, the bias is supposed be a 1-D tensor or a
        // scalar.
        //
        // 3-D or 4-D bias is not disabled for NHWC format, because they are
        // currently being used in some cases. For examplem in our code base,
        // https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/fused_conv2d_test.ts#L1972.
        if (dataFormat === 'NHWC') $5mf1d.assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
        else {
            $eOiOM.assert($bias.shape.length <= 1, ()=>`Error in fused conv2d: only supports scalar or 1-D Tensor ` + `bias for NCHW format but got the bias of ` + `rank-${$bias.shape.length}.`);
            $eOiOM.assert($bias.shape.length === 0 || $bias.shape[0] === convInfo.outChannels || $bias.shape[0] === 1, ()=>`Error in fused conv2d: bias shape (${$bias.shape}) is not ` + `compatible with the number of output channels ` + `(${convInfo.outChannels})`);
        }
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) {
        // PReLU's activation weights could be a scalar, a 1-D tensor or a 3-D
        // tensor.
        const alphaShape = preluActivationWeights.shape;
        $eOiOM.assert(alphaShape.length <= 1 || alphaShape.length === 3, ()=>`Error in fused conv2d: only supports scalar, 1-D Tensor or ` + `3-D Tensor PReLU activation weights but got a tensor of ` + `rank-${alphaShape.length}.`);
        if (alphaShape.length === 1) // Whether the data format is NCHW or NHWC, the 1-D PReLU activation
        // weights tensor should be aligned with the output channels of conv2d
        // result.
        $eOiOM.assert(alphaShape[0] === 1 || alphaShape[0] === convInfo.outChannels, ()=>`Error in fused conv2d: PReLU activation weights ` + `(${alphaShape}) is not compatible with the number of output ` + `channels (${convInfo.outChannels}).`);
        else if (alphaShape.length === 3) // Whether the data format is NCHW or NHWC, the PReLU activation weights
        // tensor should has the compatible shape with the result of conv2d.
        try {
            $5mf1d.assertAndGetBroadcastShape(alphaShape, convInfo.outShape);
        } catch (e) {
            const errMsg = `Error in fused conv2d: PReLU activation weights (${alphaShape}) ` + `is not compatible with the output shape of the conv2d ` + `(${convInfo.outShape}).`;
            throw Error(errMsg);
        }
        $preluActivationWeights = (0, $x4eLk.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused conv2d');
    }
    const grad = (dy, saved)=>{
        $eOiOM.assert(dataFormat === 'NHWC', ()=>`Error in gradient of fused conv2D: got dataFormat of ${dataFormat} but only NHWC is currently supported.`);
        const [$filter, x4D, y, $bias] = saved;
        const dyActivation = (0, $a7HBS.getFusedDyActivation)(dy, y, activation);
        $eOiOM.assert($g0V2M.tupleValuesAreOne(dilations), ()=>'Error in gradient of fused conv2D: ' + `dilation rates greater than 1 ` + `are not yet supported in gradients. Got dilations '${dilations}'`);
        const xDer = (0, $1iZpR.conv2DBackpropInput)(x4D.shape, dyActivation, $filter, strides, pad);
        const filterDer = (0, $6jqyV.conv2DBackpropFilter)(x4D, dyActivation, $filter.shape, strides, pad);
        const der = [
            xDer,
            filterDer
        ];
        if ($bias != null) {
            const biasDer = (0, $a7HBS.getFusedBiasGradient)($bias, dyActivation);
            der.push(biasDer);
        }
        return der;
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $1Npyr.customGrad)((x4D, filter, save)=>{
            let res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FusedConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $8nMOl.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $1Npyr.customGrad)((x4D, filter, bias, save)=>{
            let res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FusedConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $8nMOl.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $0e6e85ec42bc10ee$export$188f9215482e3db8 = /* @__PURE__ */ (0, $6afhl.op)({
    fusedConv2d_: $0e6e85ec42bc10ee$var$fusedConv2d_
});

});
parcelRegister("6jqyV", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropFilter", function () { return $49891f2461a17ce1$export$652a30c9379f3de7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the derivative of the filter of a 2D convolution.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     [batch, height, width, inChannels]. If rank 3, batch of 1 is assumed.
 * @param dy The dy image, of rank 4 or rank 3, of shape
 *     [batch, height, width, outDepth]. If rank 3, batch of 1 is assumed.
 * @param filterShape The shape of the filter, length 4,
 *     [filterHeight, filterWidth, inDepth, outDepth].
 * @param strides The strides of the convolution: [strideHeight,
 * strideWidth].
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels].
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $49891f2461a17ce1$var$conv2DBackpropFilter_(x, dy, filterShape, strides, pad, dataFormat = 'NHWC', dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $8nMOl.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $8nMOl.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    $eOiOM.assert(x4D.rank === 4, ()=>`Error in conv2dDerFilter: input must be rank 4, but got shape ` + `${x4D.shape}.`);
    $eOiOM.assert(dy4D.rank === 4, ()=>`Error in conv2dDerFilter: dy must be rank 4, but got shape ` + `${dy4D.shape}.`);
    $eOiOM.assert(filterShape.length === 4, ()=>`Error in conv2dDerFilter: filterShape must be length 4, but got ` + `${filterShape}.`);
    const inDepth = dataFormat === 'NHWC' ? x4D.shape[3] : x4D.shape[1];
    const outDepth = dataFormat === 'NHWC' ? dy4D.shape[3] : dy4D.shape[1];
    $eOiOM.assert(inDepth === filterShape[2], ()=>`Error in conv2dDerFilter: depth of input ${inDepth}) must ` + `match input depth in filter (${filterShape[2]}.`);
    $eOiOM.assert(outDepth === filterShape[3], ()=>`Error in conv2dDerFilter: depth of dy (${outDepth}) must ` + `match output depth for filter (${filterShape[3]}).`);
    $g0V2M.checkPadOnDimRoundingMode('conv2dDerFilter', pad, dimRoundingMode);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dimRoundingMode: dimRoundingMode,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Conv2DBackpropFilter), inputs, attrs);
}
const $49891f2461a17ce1$export$652a30c9379f3de7 = /* @__PURE__ */ (0, $6afhl.op)({
    conv2DBackpropFilter_: $49891f2461a17ce1$var$conv2DBackpropFilter_
});

});


parcelRegister("jskui", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2d", function () { return $e2a08648e386e837$export$48a8ad9494a8fad8; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $1Npyr = parcelRequire("1Npyr");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6Ab5n = parcelRequire("6Ab5n");

var $5mf1d = parcelRequire("5mf1d");

var $g0V2M = parcelRequire("g0V2M");

var $kQqya = parcelRequire("kQqya");

var $1V6Ii = parcelRequire("1V6Ii");

var $ltsWA = parcelRequire("ltsWA");

var $a7HBS = parcelRequire("a7HBS");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes depthwise 2D convolution, optionally fused with adding a
 * bias and applying an activation.
 *
 * Given a 4D `input` array and a `filter` array of shape
 * `[filterHeight, filterWidth, inChannels, channelMultiplier]` containing
 * `inChannels` convolutional filters of depth 1, this op applies a
 * different filter to each input channel (expanding from 1 channel to
 * `channelMultiplier` channels for each), then concatenates the results
 * together. The output has `inChannels * channelMultiplier` channels.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/depthwise_conv2d)
 * for more details.
 *
 * @param obj An object with the following properties:
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param filter The filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param bias Tensor to be added to the result.
 * @param activation Name of activation kernel (defaults to `linear`).
 * @param preluActivationWeights Tensor of prelu weights to be applied as part
 *     of a `prelu` activation, typically the same shape as `x`.
 * @param leakyreluAlpha Optional. Alpha to be applied as part of a `leakyrelu`
 *     activation.
 */ function $e2a08648e386e837$var$fusedDepthwiseConv2d_({ x: x, filter: filter, strides: strides, pad: pad, dataFormat: dataFormat = 'NHWC', dilations: dilations = [
    1,
    1
], dimRoundingMode: dimRoundingMode, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha }) {
    if ((0, $a7HBS.shouldFuse)((0, $e6Ey6.ENGINE).state.gradientDepth, activation) === false) {
        let result = (0, $kQqya.depthwiseConv2d)(x, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
        if (bias != null) result = (0, $6Ab5n.add)(result, bias);
        return (0, $a7HBS.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'depthwiseConv2d', 'float32');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'depthwiseConv2d', 'float32');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $eOiOM.assert(x4D.rank === 4, ()=>`Error in fused depthwiseConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $eOiOM.assert($filter.rank === 4, ()=>`Error in fused depthwiseConv2d: filter must be rank 4, ` + `but got rank ${$filter.rank}.`);
    $eOiOM.assert(x4D.shape[3] === $filter.shape[2], ()=>`Error in fused depthwiseConv2d: number of input channels ` + `(${x4D.shape[3]}) must match the inChannels dimension in ` + `filter ${$filter.shape[2]}.`);
    if (dilations == null) dilations = [
        1,
        1
    ];
    $eOiOM.assert($g0V2M.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in fused depthwiseConv2d: Either strides or dilations must ' + `be 1. Got strides ${strides} and dilations '${dilations}'`);
    $g0V2M.checkPadOnDimRoundingMode('fused depthwiseConv2d', pad, dimRoundingMode);
    const convInfo = $g0V2M.computeConv2DInfo(x4D.shape, $filter.shape, strides, dilations, pad, dimRoundingMode, true);
    let $bias;
    if (bias != null) {
        $bias = (0, $x4eLk.convertToTensor)(bias, 'bias', 'fused conv2d');
        [$bias] = (0, $gpWQN.makeTypesMatch)($bias, $x);
        $5mf1d.assertAndGetBroadcastShape(convInfo.outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $x4eLk.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused depthwiseConv2d');
    const grad = (dy, saved)=>{
        $eOiOM.assert($g0V2M.tupleValuesAreOne(dilations), ()=>'Error in gradient of fused depthwiseConv2d: dilation rates ' + `greater than 1 are not yet supported. Got dilations ` + `'${dilations}'`);
        const [$filter, x4D, y, bias] = saved;
        const dyActivation = (0, $a7HBS.getFusedDyActivation)(dy, y, activation);
        const xDer = (0, $ltsWA.depthwiseConv2dNativeBackpropInput)(x4D.shape, dyActivation, $filter, strides, pad, dilations, dimRoundingMode);
        const filterDer = (0, $1V6Ii.depthwiseConv2dNativeBackpropFilter)(x4D, dyActivation, $filter.shape, strides, pad, dilations, dimRoundingMode);
        if (bias != null) {
            const biasDer = (0, $a7HBS.getFusedBiasGradient)($bias, dyActivation);
            return [
                xDer,
                filterDer,
                biasDer
            ];
        }
        return [
            xDer,
            filterDer
        ];
    };
    const inputs = {
        x: x4D,
        filter: $filter,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        dimRoundingMode: dimRoundingMode,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $1Npyr.customGrad)((x4D, filter, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FusedDepthwiseConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $8nMOl.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOp(x4D, $filter);
    } else {
        const customOpWithBias = (0, $1Npyr.customGrad)((x4D, filter, bias, save)=>{
            // tslint:disable-next-line: no-unnecessary-type-assertion
            let res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FusedDepthwiseConv2D), inputs, attrs);
            save([
                filter,
                x4D,
                res,
                bias
            ]);
            if (reshapedTo4D) // tslint:disable-next-line: no-unnecessary-type-assertion
            res = (0, $8nMOl.reshape)(res, [
                res.shape[1],
                res.shape[2],
                res.shape[3]
            ]);
            return {
                value: res,
                gradFunc: grad
            };
        });
        return customOpWithBias(x4D, $filter, $bias);
    }
}
const $e2a08648e386e837$export$48a8ad9494a8fad8 = /* @__PURE__ */ (0, $6afhl.op)({
    fusedDepthwiseConv2d_: $e2a08648e386e837$var$fusedDepthwiseConv2d_
});

});
parcelRegister("1V6Ii", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropFilter", function () { return $166052783fd7b940$export$cc0ae65e9edc7e1a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
function $166052783fd7b940$var$depthwiseConv2dNativeBackpropFilter_(x, dy, filterShape, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let x4D = x;
    if (x.rank === 3) x4D = (0, $8nMOl.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2]
    ]);
    let dy4D = dy;
    if (dy4D.rank === 3) dy4D = (0, $8nMOl.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2]
    ]);
    const inputs = {
        x: x4D,
        dy: dy4D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.DepthwiseConv2dNativeBackpropFilter), inputs, attrs);
}
const $166052783fd7b940$export$cc0ae65e9edc7e1a = (0, $6afhl.op)({
    depthwiseConv2dNativeBackpropFilter_: $166052783fd7b940$var$depthwiseConv2dNativeBackpropFilter_
});

});

parcelRegister("ltsWA", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropInput", function () { return $fa22c20fe0a59626$export$37e2ab95a4a4c24b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
function $fa22c20fe0a59626$var$depthwiseConv2dNativeBackpropInput_(xShape, dy, filter, strides, pad, dilations = [
    1,
    1
], dimRoundingMode) {
    let dy4D = dy;
    let reshapedTo4D = false;
    if (dy.rank === 3) {
        reshapedTo4D = true;
        dy4D = (0, $8nMOl.reshape)(dy, [
            1,
            dy.shape[0],
            dy.shape[1],
            dy.shape[2]
        ]);
    }
    const inputs = {
        dy: dy4D,
        filter: filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dilations: dilations,
        inputShape: xShape
    };
    const res = // tslint:disable-next-line: no-unnecessary-type-assertion
    (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.DepthwiseConv2dNativeBackpropInput), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $fa22c20fe0a59626$export$37e2ab95a4a4c24b = (0, $6afhl.op)({
    depthwiseConv2dNativeBackpropInput_: $fa22c20fe0a59626$var$depthwiseConv2dNativeBackpropInput_
});

});


parcelRegister("9xwD6", function(module, exports) {

$parcel$export(module.exports, "matMul", function () { return $6f2081af7194abf5$export$6706882a873e9a8f; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $1Npyr = parcelRequire("1Npyr");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6Ab5n = parcelRequire("6Ab5n");

var $5mf1d = parcelRequire("5mf1d");

var $a7HBS = parcelRequire("a7HBS");

var $VLFo8 = parcelRequire("VLFo8");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the dot product of two matrices with optional activation and bias.
 *
 * ```js
 * const a = tf.tensor2d([-1, -2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const bias = tf.tensor2d([1, 2], [1, 2]);
 *
 * tf.fused.matMul({a, b, bias, activation: 'relu'}).print();
 * ```
 *
 * @param obj An object with the following properties:
 * - `a` First matrix in dot product operation.
 * - `b` Second matrix in dot product operation.
 * - `transposeA` If true, `a` is transposed before multiplication.
 * - `transposeB` If true, `b` is transposed before multiplication.
 * - `bias` Matrix to be added to the result.
 * - `activation` Name of activation kernel (defaults to `linear`).
 * - `preluActivationWeights` Tensor of prelu weights.
 * - `leakyreluAlpha` Alpha of leakyrelu.
 */ function $6f2081af7194abf5$var$fusedMatMul_({ a: a, b: b, transposeA: transposeA = false, transposeB: transposeB = false, bias: bias, activation: activation = 'linear', preluActivationWeights: preluActivationWeights, leakyreluAlpha: leakyreluAlpha = 0.2 }) {
    if ((0, $a7HBS.shouldFuse)((0, $e6Ey6.ENGINE).state.gradientDepth, activation) === false) {
        let result = (0, $VLFo8.matMul)(a, b, transposeA, transposeB);
        if (bias != null) result = (0, $6Ab5n.add)(result, bias);
        return (0, $a7HBS.applyActivation)(result, activation, preluActivationWeights, leakyreluAlpha);
    }
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'fused matMul');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'fused matMul');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const innerShapeA = transposeA ? $a.shape[$a.rank - 2] : $a.shape[$a.rank - 1];
    const innerShapeB = transposeB ? $b.shape[$b.rank - 1] : $b.shape[$b.rank - 2];
    const outerShapeA = transposeA ? $a.shape[$a.rank - 1] : $a.shape[$a.rank - 2];
    const outerShapeB = transposeB ? $b.shape[$b.rank - 2] : $b.shape[$b.rank - 1];
    const outerDimsA = $a.shape.slice(0, -2);
    const outerDimsB = $b.shape.slice(0, -2);
    const batchDimA = $eOiOM.sizeFromShape(outerDimsA);
    const batchDimB = $eOiOM.sizeFromShape(outerDimsB);
    $eOiOM.assert(innerShapeA === innerShapeB, ()=>`Error in fused matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${$a.shape} and ` + `${$b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const outShapeOuterDims = $5mf1d.assertAndGetBroadcastShape($a.shape.slice(0, -2), $b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    const a3D = transposeA ? (0, $8nMOl.reshape)($a, [
        batchDimA,
        innerShapeA,
        outerShapeA
    ]) : (0, $8nMOl.reshape)($a, [
        batchDimA,
        outerShapeA,
        innerShapeA
    ]);
    const b3D = transposeB ? (0, $8nMOl.reshape)($b, [
        batchDimB,
        outerShapeB,
        innerShapeB
    ]) : (0, $8nMOl.reshape)($b, [
        batchDimB,
        innerShapeB,
        outerShapeB
    ]);
    let $bias;
    if (bias != null) {
        $bias = (0, $x4eLk.convertToTensor)(bias, 'bias', 'fused matMul');
        [$bias] = (0, $gpWQN.makeTypesMatch)($bias, $a);
        $5mf1d.assertAndGetBroadcastShape(outShape, $bias.shape);
    }
    let $preluActivationWeights;
    if (preluActivationWeights != null) $preluActivationWeights = (0, $x4eLk.convertToTensor)(preluActivationWeights, 'prelu weights', 'fused matMul');
    const grad = (dy, saved)=>{
        const [a3D, b3D, y, $bias] = saved;
        // we reshape dy because the result of the forward is not
        // necessarily going to be a 3d tensor due to a reshape done at the end of
        // the customOp.
        const dyActivation = (0, $a7HBS.getFusedDyActivation)((0, $8nMOl.reshape)(dy, y.shape), y, activation);
        let aDer;
        let bDer;
        if (!transposeA && !transposeB) {
            aDer = (0, $VLFo8.matMul)(dyActivation, b3D, false, true);
            bDer = (0, $VLFo8.matMul)(a3D, dyActivation, true, false);
        } else if (!transposeA && transposeB) {
            aDer = (0, $VLFo8.matMul)(dyActivation, b3D, false, false);
            bDer = (0, $VLFo8.matMul)(dyActivation, a3D, true, false);
        } else if (transposeA && !transposeB) {
            aDer = (0, $VLFo8.matMul)(b3D, dyActivation, false, true);
            bDer = (0, $VLFo8.matMul)(a3D, dyActivation, false, false);
        } else {
            aDer = (0, $VLFo8.matMul)(b3D, dyActivation, true, true);
            bDer = (0, $VLFo8.matMul)(dyActivation, a3D, true, true);
        }
        if (bias != null) {
            const biasDer = (0, $a7HBS.getFusedBiasGradient)($bias, dyActivation);
            return [
                aDer,
                bDer,
                biasDer
            ];
        } else return [
            aDer,
            bDer
        ];
    };
    const inputs = {
        a: a3D,
        b: b3D,
        bias: $bias,
        preluActivationWeights: $preluActivationWeights
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB,
        activation: activation,
        leakyreluAlpha: leakyreluAlpha
    };
    // Depending on the the params passed in we will have different number of
    // inputs and thus a a different number of elements in the gradient.
    if (bias == null) {
        const customOp = (0, $1Npyr.customGrad)((a3D, b3D, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9._FusedMatMul), inputs, attrs);
            save([
                a3D,
                b3D,
                res
            ]);
            return {
                value: (0, $8nMOl.reshape)(res, outShape),
                gradFunc: grad
            };
        });
        return customOp(a3D, b3D);
    } else {
        const customOpWithBias = (0, $1Npyr.customGrad)((a3D, b3D, $bias, save)=>{
            const res = // tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9._FusedMatMul), inputs, attrs);
            save([
                a3D,
                b3D,
                res,
                $bias
            ]);
            return {
                value: (0, $8nMOl.reshape)(res, outShape),
                gradFunc: grad
            };
        });
        return customOpWithBias(a3D, b3D, $bias);
    }
}
const $6f2081af7194abf5$export$6706882a873e9a8f = /* @__PURE__ */ (0, $6afhl.op)({
    fusedMatMul_: $6f2081af7194abf5$var$fusedMatMul_
});

});
parcelRegister("VLFo8", function(module, exports) {

$parcel$export(module.exports, "matMul", function () { return $0ada4c91ec432981$export$6706882a873e9a8f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the dot product of two matrices, A * B. These must be matrices.
 *
 * ```js
 * const a = tf.tensor2d([1, 2], [1, 2]);
 * const b = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * a.matMul(b).print();  // or tf.matMul(a, b)
 * ```
 * @param a First matrix in dot product operation.
 * @param b Second matrix in dot product operation.
 * @param transposeA If true, `a` is transposed before multiplication.
 * @param transposeB If true, `b` is transposed before multiplication.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $0ada4c91ec432981$var$matMul_(a, b, transposeA = false, transposeB = false) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'matMul');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'matMul');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {
        transposeA: transposeA,
        transposeB: transposeB
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.BatchMatMul), inputs, attrs);
}
const $0ada4c91ec432981$export$6706882a873e9a8f = /* @__PURE__ */ (0, $6afhl.op)({
    matMul_: $0ada4c91ec432981$var$matMul_
});

});



parcelRegister("eFeE9", function(module, exports) {

$parcel$export(module.exports, "gather", function () { return $aad04188d0f7f9d4$export$9e05546f00427e8; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Gather slices from tensor `x`'s axis `axis` according to `indices`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const indices = tf.tensor1d([1, 3, 3], 'int32');
 *
 * x.gather(indices).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 * const indices = tf.tensor1d([1, 1, 0], 'int32');
 *
 * x.gather(indices).print();
 * ```
 * @param x The input tensor whose slices are to be gathered.
 * @param indices The indices of the values to extract.
 * @param axis The axis over which to select values. Defaults to 0.
 * @param batchDims Optional. The number of batch dimensions. It must be less
 *     than or equal to rank(indices). Defaults to 0.
 *     The output tensor will have shape of
 *     `x.shape[:axis] + indices.shape[batchDims:] + x.shape[axis + 1:]`
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $aad04188d0f7f9d4$var$gather_(x, indices, axis = 0, batchDims = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'gather');
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'gather', 'int32');
    const inputs = {
        x: $x,
        indices: $indices
    };
    const attrs = {
        axis: axis,
        batchDims: batchDims
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.GatherV2), inputs, attrs);
}
const $aad04188d0f7f9d4$export$9e05546f00427e8 = /* @__PURE__ */ (0, $6afhl.op)({
    gather_: $aad04188d0f7f9d4$var$gather_
});

});

parcelRegister("lOlhm", function(module, exports) {

$parcel$export(module.exports, "greater", function () { return $fe0ec60b345f01ca$export$9dca161faaf6308b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of (a > b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greater(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $fe0ec60b345f01ca$var$greater_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'greater', 'string_or_numeric');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'greater', 'string_or_numeric');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Greater), inputs);
}
const $fe0ec60b345f01ca$export$9dca161faaf6308b = /* @__PURE__ */ (0, $6afhl.op)({
    greater_: $fe0ec60b345f01ca$var$greater_
});

});

parcelRegister("kKLvn", function(module, exports) {

$parcel$export(module.exports, "greaterEqual", function () { return $f1bcf4084fbe61fe$export$c2fd4164cadc1fa2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of (a >= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.greaterEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $f1bcf4084fbe61fe$var$greaterEqual_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'greaterEqual', 'string_or_numeric');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'greaterEqual', 'string_or_numeric');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.GreaterEqual), inputs);
}
const $f1bcf4084fbe61fe$export$c2fd4164cadc1fa2 = /* @__PURE__ */ (0, $6afhl.op)({
    greaterEqual_: $f1bcf4084fbe61fe$var$greaterEqual_
});

});

parcelRegister("4I5dI", function(module, exports) {

$parcel$export(module.exports, "spectral", function () { return $36df5220d6ceb213$export$e0ccf6166915bd59; });
$parcel$export(module.exports, "signal", function () { return $36df5220d6ceb213$export$e2ef10f86a8d60e8; });
$parcel$export(module.exports, "image", function () { return $36df5220d6ceb213$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "linalg", function () { return $36df5220d6ceb213$export$dbc5be37a4415193; });
$parcel$export(module.exports, "losses", function () { return $36df5220d6ceb213$export$24b113a95118cbdc; });
$parcel$export(module.exports, "sparse", function () { return $36df5220d6ceb213$export$b6b7e189aa5d134c; });
$parcel$export(module.exports, "string", function () { return $36df5220d6ceb213$export$22b082955e083ec3; });
$parcel$export(module.exports, "abs", function () { return (parcelRequire("57D4R")).abs; });
$parcel$export(module.exports, "acos", function () { return (parcelRequire("bls8e")).acos; });
$parcel$export(module.exports, "acosh", function () { return (parcelRequire("17EGz")).acosh; });
$parcel$export(module.exports, "add", function () { return (parcelRequire("6Ab5n")).add; });
$parcel$export(module.exports, "addN", function () { return (parcelRequire("1oXel")).addN; });
$parcel$export(module.exports, "all", function () { return (parcelRequire("c3y0I")).all; });
$parcel$export(module.exports, "any", function () { return (parcelRequire("dODwI")).any; });
$parcel$export(module.exports, "argMax", function () { return (parcelRequire("kRlq3")).argMax; });
$parcel$export(module.exports, "argMin", function () { return (parcelRequire("j70Qn")).argMin; });
$parcel$export(module.exports, "asin", function () { return (parcelRequire("lz3uk")).asin; });
$parcel$export(module.exports, "asinh", function () { return (parcelRequire("93aRU")).asinh; });
$parcel$export(module.exports, "atan", function () { return (parcelRequire("5n4it")).atan; });
$parcel$export(module.exports, "atan2", function () { return (parcelRequire("aLZ6G")).atan2; });
$parcel$export(module.exports, "atanh", function () { return (parcelRequire("aCXEC")).atanh; });
$parcel$export(module.exports, "avgPool", function () { return (parcelRequire("4LG6a")).avgPool; });
$parcel$export(module.exports, "avgPool3d", function () { return (parcelRequire("dTgsp")).avgPool3d; });
$parcel$export(module.exports, "basicLSTMCell", function () { return (parcelRequire("8I3cQ")).basicLSTMCell; });
$parcel$export(module.exports, "batchToSpaceND", function () { return (parcelRequire("7rVXz")).batchToSpaceND; });
$parcel$export(module.exports, "batchNorm", function () { return (parcelRequire("dOyXd")).batchNorm; });
$parcel$export(module.exports, "batchNorm2d", function () { return (parcelRequire("cgFzb")).batchNorm2d; });
$parcel$export(module.exports, "batchNorm3d", function () { return (parcelRequire("hBBSw")).batchNorm3d; });
$parcel$export(module.exports, "batchNorm4d", function () { return (parcelRequire("5JMTM")).batchNorm4d; });
$parcel$export(module.exports, "bincount", function () { return (parcelRequire("jqlcD")).bincount; });
$parcel$export(module.exports, "bitwiseAnd", function () { return (parcelRequire("3dUR6")).bitwiseAnd; });
$parcel$export(module.exports, "broadcastArgs", function () { return (parcelRequire("jJSUM")).broadcastArgs; });
$parcel$export(module.exports, "broadcastTo", function () { return (parcelRequire("bMTXt")).broadcastTo; });
$parcel$export(module.exports, "buffer", function () { return (parcelRequire("5siju")).buffer; });
$parcel$export(module.exports, "cast", function () { return (parcelRequire("fxiHg")).cast; });
$parcel$export(module.exports, "ceil", function () { return (parcelRequire("6tPaz")).ceil; });
$parcel$export(module.exports, "clipByValue", function () { return (parcelRequire("iAQYk")).clipByValue; });
$parcel$export(module.exports, "clone", function () { return (parcelRequire("ek4FP")).clone; });
$parcel$export(module.exports, "complex", function () { return (parcelRequire("dyCpE")).complex; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("1goxr")).concat; });
$parcel$export(module.exports, "concat1d", function () { return (parcelRequire("j5YCL")).concat1d; });
$parcel$export(module.exports, "concat2d", function () { return (parcelRequire("kEtq4")).concat2d; });
$parcel$export(module.exports, "concat3d", function () { return (parcelRequire("601hZ")).concat3d; });
$parcel$export(module.exports, "concat4d", function () { return (parcelRequire("30mc4")).concat4d; });
$parcel$export(module.exports, "conv1d", function () { return (parcelRequire("7vGQw")).conv1d; });
$parcel$export(module.exports, "conv2d", function () { return (parcelRequire("9JluG")).conv2d; });
$parcel$export(module.exports, "conv2dTranspose", function () { return (parcelRequire("gVSKY")).conv2dTranspose; });
$parcel$export(module.exports, "conv3d", function () { return (parcelRequire("4B9eF")).conv3d; });
$parcel$export(module.exports, "conv3dTranspose", function () { return (parcelRequire("lqPND")).conv3dTranspose; });
$parcel$export(module.exports, "cos", function () { return (parcelRequire("71JL9")).cos; });
$parcel$export(module.exports, "cosh", function () { return (parcelRequire("Riay5")).cosh; });
$parcel$export(module.exports, "cumprod", function () { return (parcelRequire("8By4p")).cumprod; });
$parcel$export(module.exports, "cumsum", function () { return (parcelRequire("ec6xM")).cumsum; });
$parcel$export(module.exports, "denseBincount", function () { return (parcelRequire("dzBZ1")).denseBincount; });
$parcel$export(module.exports, "depthToSpace", function () { return (parcelRequire("3Gf0o")).depthToSpace; });
$parcel$export(module.exports, "depthwiseConv2d", function () { return (parcelRequire("kQqya")).depthwiseConv2d; });
$parcel$export(module.exports, "diag", function () { return (parcelRequire("8QKGt")).diag; });
$parcel$export(module.exports, "dilation2d", function () { return (parcelRequire("bP8B9")).dilation2d; });
$parcel$export(module.exports, "div", function () { return (parcelRequire("dIChU")).div; });
$parcel$export(module.exports, "divNoNan", function () { return (parcelRequire("dosDM")).divNoNan; });
$parcel$export(module.exports, "dot", function () { return (parcelRequire("3bsW7")).dot; });
$parcel$export(module.exports, "einsum", function () { return (parcelRequire("lR4Fq")).einsum; });
$parcel$export(module.exports, "elu", function () { return (parcelRequire("4YAd3")).elu; });
$parcel$export(module.exports, "ensureShape", function () { return (parcelRequire("1WZha")).ensureShape; });
$parcel$export(module.exports, "equal", function () { return (parcelRequire("28GAP")).equal; });
$parcel$export(module.exports, "erf", function () { return (parcelRequire("86rqz")).erf; });
$parcel$export(module.exports, "euclideanNorm", function () { return (parcelRequire("chOKV")).euclideanNorm; });
$parcel$export(module.exports, "exp", function () { return (parcelRequire("1lCoz")).exp; });
$parcel$export(module.exports, "expandDims", function () { return (parcelRequire("fO4kJ")).expandDims; });
$parcel$export(module.exports, "expm1", function () { return (parcelRequire("9rV09")).expm1; });
$parcel$export(module.exports, "eye", function () { return (parcelRequire("8YZZT")).eye; });
$parcel$export(module.exports, "fill", function () { return (parcelRequire("2d2dF")).fill; });
$parcel$export(module.exports, "floor", function () { return (parcelRequire("3k4XX")).floor; });
$parcel$export(module.exports, "floorDiv", function () { return (parcelRequire("es4Jq")).floorDiv; });
$parcel$export(module.exports, "gather", function () { return (parcelRequire("eFeE9")).gather; });
$parcel$export(module.exports, "greater", function () { return (parcelRequire("lOlhm")).greater; });
$parcel$export(module.exports, "greaterEqual", function () { return (parcelRequire("kKLvn")).greaterEqual; });
$parcel$export(module.exports, "imag", function () { return (parcelRequire("iXiJh")).imag; });
$parcel$export(module.exports, "isFinite", function () { return (parcelRequire("gfUfq")).isFinite; });
$parcel$export(module.exports, "isInf", function () { return (parcelRequire("cJ2yP")).isInf; });
$parcel$export(module.exports, "isNaN", function () { return (parcelRequire("gZu1q")).isNaN; });
$parcel$export(module.exports, "leakyRelu", function () { return (parcelRequire("kFoUG")).leakyRelu; });
$parcel$export(module.exports, "less", function () { return (parcelRequire("lWf8B")).less; });
$parcel$export(module.exports, "lessEqual", function () { return (parcelRequire("bvcEy")).lessEqual; });
$parcel$export(module.exports, "linspace", function () { return (parcelRequire("5qjef")).linspace; });
$parcel$export(module.exports, "localResponseNormalization", function () { return (parcelRequire("iTgel")).localResponseNormalization; });
$parcel$export(module.exports, "log", function () { return (parcelRequire("1gLFX")).log; });
$parcel$export(module.exports, "log1p", function () { return (parcelRequire("ifd1X")).log1p; });
$parcel$export(module.exports, "logSigmoid", function () { return (parcelRequire("bBSSu")).logSigmoid; });
$parcel$export(module.exports, "logSoftmax", function () { return (parcelRequire("2vk2B")).logSoftmax; });
$parcel$export(module.exports, "logSumExp", function () { return (parcelRequire("1UrMu")).logSumExp; });
$parcel$export(module.exports, "logicalAnd", function () { return (parcelRequire("gXTMu")).logicalAnd; });
$parcel$export(module.exports, "logicalNot", function () { return (parcelRequire("4DHH8")).logicalNot; });
$parcel$export(module.exports, "logicalOr", function () { return (parcelRequire("jc4ZI")).logicalOr; });
$parcel$export(module.exports, "logicalXor", function () { return (parcelRequire("dqaBh")).logicalXor; });
$parcel$export(module.exports, "lowerBound", function () { return (parcelRequire("dzP95")).lowerBound; });
$parcel$export(module.exports, "matMul", function () { return (parcelRequire("VLFo8")).matMul; });
$parcel$export(module.exports, "max", function () { return (parcelRequire("9GR6N")).max; });
$parcel$export(module.exports, "maxPool", function () { return (parcelRequire("kHqOQ")).maxPool; });
$parcel$export(module.exports, "maxPool3d", function () { return (parcelRequire("hG9Ff")).maxPool3d; });
$parcel$export(module.exports, "maxPoolWithArgmax", function () { return (parcelRequire("3oGWc")).maxPoolWithArgmax; });
$parcel$export(module.exports, "maximum", function () { return (parcelRequire("jRQ3p")).maximum; });
$parcel$export(module.exports, "mean", function () { return (parcelRequire("3TgHP")).mean; });
$parcel$export(module.exports, "meshgrid", function () { return (parcelRequire("3vCK6")).meshgrid; });
$parcel$export(module.exports, "min", function () { return (parcelRequire("1KFHq")).min; });
$parcel$export(module.exports, "minimum", function () { return (parcelRequire("7es6p")).minimum; });
$parcel$export(module.exports, "mirrorPad", function () { return (parcelRequire("67dM3")).mirrorPad; });
$parcel$export(module.exports, "mod", function () { return (parcelRequire("2na7s")).mod; });
$parcel$export(module.exports, "moments", function () { return (parcelRequire("lImqN")).moments; });
$parcel$export(module.exports, "mul", function () { return (parcelRequire("5hAos")).mul; });
$parcel$export(module.exports, "multiRNNCell", function () { return (parcelRequire("f6xls")).multiRNNCell; });
$parcel$export(module.exports, "multinomial", function () { return (parcelRequire("yqHIQ")).multinomial; });
$parcel$export(module.exports, "neg", function () { return (parcelRequire("jMlCE")).neg; });
$parcel$export(module.exports, "notEqual", function () { return (parcelRequire("8BIHZ")).notEqual; });
$parcel$export(module.exports, "oneHot", function () { return (parcelRequire("7k013")).oneHot; });
$parcel$export(module.exports, "ones", function () { return (parcelRequire("K2k22")).ones; });
$parcel$export(module.exports, "onesLike", function () { return (parcelRequire("6zg0w")).onesLike; });
$parcel$export(module.exports, "outerProduct", function () { return (parcelRequire("3ng4n")).outerProduct; });
$parcel$export(module.exports, "pad", function () { return (parcelRequire("9XHOJ")).pad; });
$parcel$export(module.exports, "pad1d", function () { return (parcelRequire("3Knho")).pad1d; });
$parcel$export(module.exports, "pad2d", function () { return (parcelRequire("2PSTi")).pad2d; });
$parcel$export(module.exports, "pad3d", function () { return (parcelRequire("e1qwx")).pad3d; });
$parcel$export(module.exports, "pad4d", function () { return (parcelRequire("bK59X")).pad4d; });
$parcel$export(module.exports, "pool", function () { return (parcelRequire("3igQ1")).pool; });
$parcel$export(module.exports, "pow", function () { return (parcelRequire("eCViQ")).pow; });
$parcel$export(module.exports, "prelu", function () { return (parcelRequire("8b5dq")).prelu; });
$parcel$export(module.exports, "print", function () { return (parcelRequire("iM8Nn")).print; });
$parcel$export(module.exports, "prod", function () { return (parcelRequire("b2Mw2")).prod; });
$parcel$export(module.exports, "raggedGather", function () { return (parcelRequire("7zltL")).raggedGather; });
$parcel$export(module.exports, "raggedRange", function () { return (parcelRequire("ldadP")).raggedRange; });
$parcel$export(module.exports, "raggedTensorToTensor", function () { return (parcelRequire("2JU1C")).raggedTensorToTensor; });
$parcel$export(module.exports, "rand", function () { return (parcelRequire("7cmbr")).rand; });
$parcel$export(module.exports, "randomGamma", function () { return (parcelRequire("guGiy")).randomGamma; });
$parcel$export(module.exports, "randomNormal", function () { return (parcelRequire("kaIUV")).randomNormal; });
$parcel$export(module.exports, "randomStandardNormal", function () { return (parcelRequire("4CqNZ")).randomStandardNormal; });
$parcel$export(module.exports, "randomUniform", function () { return (parcelRequire("9ORo6")).randomUniform; });
$parcel$export(module.exports, "randomUniformInt", function () { return (parcelRequire("FKlDG")).randomUniformInt; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("kh5mA")).range; });
$parcel$export(module.exports, "real", function () { return (parcelRequire("6gKdw")).real; });
$parcel$export(module.exports, "reciprocal", function () { return (parcelRequire("1Lp6R")).reciprocal; });
$parcel$export(module.exports, "relu", function () { return (parcelRequire("aQaR3")).relu; });
$parcel$export(module.exports, "relu6", function () { return (parcelRequire("4zQqN")).relu6; });
$parcel$export(module.exports, "reshape", function () { return (parcelRequire("8nMOl")).reshape; });
$parcel$export(module.exports, "reverse", function () { return (parcelRequire("5ApPj")).reverse; });
$parcel$export(module.exports, "reverse1d", function () { return (parcelRequire("eXcSV")).reverse1d; });
$parcel$export(module.exports, "reverse2d", function () { return (parcelRequire("8rz6Z")).reverse2d; });
$parcel$export(module.exports, "reverse3d", function () { return (parcelRequire("l8lrM")).reverse3d; });
$parcel$export(module.exports, "reverse4d", function () { return (parcelRequire("eDKO8")).reverse4d; });
$parcel$export(module.exports, "round", function () { return (parcelRequire("eo7jM")).round; });
$parcel$export(module.exports, "rsqrt", function () { return (parcelRequire("6M9ry")).rsqrt; });
$parcel$export(module.exports, "scalar", function () { return (parcelRequire("7hONX")).scalar; });
$parcel$export(module.exports, "selu", function () { return (parcelRequire("6DicT")).selu; });
$parcel$export(module.exports, "separableConv2d", function () { return (parcelRequire("2ICVg")).separableConv2d; });
$parcel$export(module.exports, "setdiff1dAsync", function () { return (parcelRequire("eC6Gd")).setdiff1dAsync; });
$parcel$export(module.exports, "sigmoid", function () { return (parcelRequire("dzpno")).sigmoid; });
$parcel$export(module.exports, "sign", function () { return (parcelRequire("gMq2C")).sign; });
$parcel$export(module.exports, "sin", function () { return (parcelRequire("6zQIj")).sin; });
$parcel$export(module.exports, "sinh", function () { return (parcelRequire("fbZFd")).sinh; });
$parcel$export(module.exports, "slice", function () { return (parcelRequire("l7afw")).slice; });
$parcel$export(module.exports, "slice1d", function () { return (parcelRequire("c8zsf")).slice1d; });
$parcel$export(module.exports, "slice2d", function () { return (parcelRequire("kzTOv")).slice2d; });
$parcel$export(module.exports, "slice3d", function () { return (parcelRequire("gaDoi")).slice3d; });
$parcel$export(module.exports, "slice4d", function () { return (parcelRequire("6aiGU")).slice4d; });
$parcel$export(module.exports, "softmax", function () { return (parcelRequire("2J1JW")).softmax; });
$parcel$export(module.exports, "softplus", function () { return (parcelRequire("11Nx5")).softplus; });
$parcel$export(module.exports, "spaceToBatchND", function () { return (parcelRequire("9l6gk")).spaceToBatchND; });
$parcel$export(module.exports, "fft", function () { return (parcelRequire("acdVt")).fft; });
$parcel$export(module.exports, "ifft", function () { return (parcelRequire("69IWw")).ifft; });
$parcel$export(module.exports, "irfft", function () { return (parcelRequire("mrJGu")).irfft; });
$parcel$export(module.exports, "rfft", function () { return (parcelRequire("22B8v")).rfft; });
$parcel$export(module.exports, "split", function () { return (parcelRequire("crriC")).split; });
$parcel$export(module.exports, "sqrt", function () { return (parcelRequire("g3lev")).sqrt; });
$parcel$export(module.exports, "square", function () { return (parcelRequire("5MB84")).square; });
$parcel$export(module.exports, "squaredDifference", function () { return (parcelRequire("fqiRx")).squaredDifference; });
$parcel$export(module.exports, "squeeze", function () { return (parcelRequire("gP42y")).squeeze; });
$parcel$export(module.exports, "stack", function () { return (parcelRequire("lq9U1")).stack; });
$parcel$export(module.exports, "step", function () { return (parcelRequire("1LynW")).step; });
$parcel$export(module.exports, "stridedSlice", function () { return (parcelRequire("6Ygvg")).stridedSlice; });
$parcel$export(module.exports, "sub", function () { return (parcelRequire("5jGN9")).sub; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("fPnAL")).sum; });
$parcel$export(module.exports, "tan", function () { return (parcelRequire("dEDAz")).tan; });
$parcel$export(module.exports, "tanh", function () { return (parcelRequire("cJm46")).tanh; });
$parcel$export(module.exports, "tensor", function () { return (parcelRequire("eZfvk")).tensor; });
$parcel$export(module.exports, "tensor1d", function () { return (parcelRequire("8tOOR")).tensor1d; });
$parcel$export(module.exports, "tensor2d", function () { return (parcelRequire("9NdGd")).tensor2d; });
$parcel$export(module.exports, "tensor3d", function () { return (parcelRequire("alqbU")).tensor3d; });
$parcel$export(module.exports, "tensor4d", function () { return (parcelRequire("3XeZf")).tensor4d; });
$parcel$export(module.exports, "tensor5d", function () { return (parcelRequire("elLea")).tensor5d; });
$parcel$export(module.exports, "tensor6d", function () { return (parcelRequire("lmWT0")).tensor6d; });
$parcel$export(module.exports, "tensorScatterUpdate", function () { return (parcelRequire("cdxCY")).tensorScatterUpdate; });
$parcel$export(module.exports, "tile", function () { return (parcelRequire("dolPi")).tile; });
$parcel$export(module.exports, "topk", function () { return (parcelRequire("7vZaO")).topk; });
$parcel$export(module.exports, "truncatedNormal", function () { return (parcelRequire("9VTJm")).truncatedNormal; });
$parcel$export(module.exports, "unique", function () { return (parcelRequire("f7XaS")).unique; });
$parcel$export(module.exports, "unsortedSegmentSum", function () { return (parcelRequire("2uE72")).unsortedSegmentSum; });
$parcel$export(module.exports, "unstack", function () { return (parcelRequire("3mzDh")).unstack; });
$parcel$export(module.exports, "upperBound", function () { return (parcelRequire("gYvpj")).upperBound; });
$parcel$export(module.exports, "variable", function () { return (parcelRequire("ftQEj")).variable; });
$parcel$export(module.exports, "where", function () { return (parcelRequire("3A1QZ")).where; });
$parcel$export(module.exports, "whereAsync", function () { return (parcelRequire("aR8Ls")).whereAsync; });
$parcel$export(module.exports, "zeros", function () { return (parcelRequire("lxzgt")).zeros; });
$parcel$export(module.exports, "zerosLike", function () { return (parcelRequire("cztsD")).zerosLike; });
$parcel$export(module.exports, "op", function () { return (parcelRequire("6afhl")).op; });
$parcel$export(module.exports, "OP_SCOPE_SUFFIX", function () { return (parcelRequire("6afhl")).OP_SCOPE_SUFFIX; });
$parcel$export(module.exports, "fused", function () { return (parcelRequire("eJ7TQ")); });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Modularized ops.

var $57D4R = parcelRequire("57D4R");

var $bls8e = parcelRequire("bls8e");

var $17EGz = parcelRequire("17EGz");

var $6Ab5n = parcelRequire("6Ab5n");

var $1oXel = parcelRequire("1oXel");

var $c3y0I = parcelRequire("c3y0I");

var $dODwI = parcelRequire("dODwI");

var $kRlq3 = parcelRequire("kRlq3");

var $j70Qn = parcelRequire("j70Qn");

var $lz3uk = parcelRequire("lz3uk");

var $93aRU = parcelRequire("93aRU");

var $5n4it = parcelRequire("5n4it");

var $aLZ6G = parcelRequire("aLZ6G");

var $aCXEC = parcelRequire("aCXEC");

var $4LG6a = parcelRequire("4LG6a");

var $dTgsp = parcelRequire("dTgsp");

var $8I3cQ = parcelRequire("8I3cQ");

var $7rVXz = parcelRequire("7rVXz");

var $dOyXd = parcelRequire("dOyXd");

var $cgFzb = parcelRequire("cgFzb");

var $hBBSw = parcelRequire("hBBSw");

var $5JMTM = parcelRequire("5JMTM");

var $jqlcD = parcelRequire("jqlcD");

var $3dUR6 = parcelRequire("3dUR6");

var $jJSUM = parcelRequire("jJSUM");

var $bMTXt = parcelRequire("bMTXt");

var $5siju = parcelRequire("5siju");

var $fxiHg = parcelRequire("fxiHg");

var $6tPaz = parcelRequire("6tPaz");

var $iAQYk = parcelRequire("iAQYk");

var $ek4FP = parcelRequire("ek4FP");

var $dyCpE = parcelRequire("dyCpE");

var $1goxr = parcelRequire("1goxr");

var $j5YCL = parcelRequire("j5YCL");

var $kEtq4 = parcelRequire("kEtq4");

var $601hZ = parcelRequire("601hZ");

var $30mc4 = parcelRequire("30mc4");

var $7vGQw = parcelRequire("7vGQw");

var $9JluG = parcelRequire("9JluG");

var $gVSKY = parcelRequire("gVSKY");

var $4B9eF = parcelRequire("4B9eF");

var $lqPND = parcelRequire("lqPND");

var $71JL9 = parcelRequire("71JL9");

var $Riay5 = parcelRequire("Riay5");

var $8By4p = parcelRequire("8By4p");

var $ec6xM = parcelRequire("ec6xM");

var $dzBZ1 = parcelRequire("dzBZ1");

var $3Gf0o = parcelRequire("3Gf0o");

var $kQqya = parcelRequire("kQqya");

var $8QKGt = parcelRequire("8QKGt");

var $bP8B9 = parcelRequire("bP8B9");

var $dIChU = parcelRequire("dIChU");

var $dosDM = parcelRequire("dosDM");

var $3bsW7 = parcelRequire("3bsW7");

var $lR4Fq = parcelRequire("lR4Fq");

var $4YAd3 = parcelRequire("4YAd3");

var $1WZha = parcelRequire("1WZha");

var $28GAP = parcelRequire("28GAP");

var $86rqz = parcelRequire("86rqz");

var $chOKV = parcelRequire("chOKV");

var $1lCoz = parcelRequire("1lCoz");

var $fO4kJ = parcelRequire("fO4kJ");

var $9rV09 = parcelRequire("9rV09");

var $8YZZT = parcelRequire("8YZZT");

var $2d2dF = parcelRequire("2d2dF");

var $3k4XX = parcelRequire("3k4XX");

var $es4Jq = parcelRequire("es4Jq");

var $eFeE9 = parcelRequire("eFeE9");

var $lOlhm = parcelRequire("lOlhm");

var $kKLvn = parcelRequire("kKLvn");

var $iXiJh = parcelRequire("iXiJh");

var $gfUfq = parcelRequire("gfUfq");

var $cJ2yP = parcelRequire("cJ2yP");

var $gZu1q = parcelRequire("gZu1q");

var $kFoUG = parcelRequire("kFoUG");

var $lWf8B = parcelRequire("lWf8B");

var $bvcEy = parcelRequire("bvcEy");

var $5qjef = parcelRequire("5qjef");

var $iTgel = parcelRequire("iTgel");

var $1gLFX = parcelRequire("1gLFX");

var $ifd1X = parcelRequire("ifd1X");

var $bBSSu = parcelRequire("bBSSu");

var $2vk2B = parcelRequire("2vk2B");

var $1UrMu = parcelRequire("1UrMu");

var $gXTMu = parcelRequire("gXTMu");

var $4DHH8 = parcelRequire("4DHH8");

var $jc4ZI = parcelRequire("jc4ZI");

var $dqaBh = parcelRequire("dqaBh");

var $dzP95 = parcelRequire("dzP95");

var $VLFo8 = parcelRequire("VLFo8");

var $9GR6N = parcelRequire("9GR6N");

var $kHqOQ = parcelRequire("kHqOQ");

var $hG9Ff = parcelRequire("hG9Ff");

var $3oGWc = parcelRequire("3oGWc");

var $jRQ3p = parcelRequire("jRQ3p");

var $3TgHP = parcelRequire("3TgHP");

var $3vCK6 = parcelRequire("3vCK6");

var $1KFHq = parcelRequire("1KFHq");

var $7es6p = parcelRequire("7es6p");

var $67dM3 = parcelRequire("67dM3");

var $2na7s = parcelRequire("2na7s");

var $lImqN = parcelRequire("lImqN");

var $5hAos = parcelRequire("5hAos");

var $f6xls = parcelRequire("f6xls");

var $yqHIQ = parcelRequire("yqHIQ");

var $jMlCE = parcelRequire("jMlCE");

var $8BIHZ = parcelRequire("8BIHZ");

var $7k013 = parcelRequire("7k013");

var $K2k22 = parcelRequire("K2k22");

var $6zg0w = parcelRequire("6zg0w");

var $3ng4n = parcelRequire("3ng4n");

var $9XHOJ = parcelRequire("9XHOJ");

var $3Knho = parcelRequire("3Knho");

var $2PSTi = parcelRequire("2PSTi");

var $e1qwx = parcelRequire("e1qwx");

var $bK59X = parcelRequire("bK59X");

var $3igQ1 = parcelRequire("3igQ1");

var $eCViQ = parcelRequire("eCViQ");

var $8b5dq = parcelRequire("8b5dq");

var $iM8Nn = parcelRequire("iM8Nn");

var $b2Mw2 = parcelRequire("b2Mw2");

var $7zltL = parcelRequire("7zltL");

var $ldadP = parcelRequire("ldadP");

var $2JU1C = parcelRequire("2JU1C");

var $7cmbr = parcelRequire("7cmbr");

var $guGiy = parcelRequire("guGiy");

var $kaIUV = parcelRequire("kaIUV");

var $4CqNZ = parcelRequire("4CqNZ");

var $9ORo6 = parcelRequire("9ORo6");

var $FKlDG = parcelRequire("FKlDG");

var $kh5mA = parcelRequire("kh5mA");

var $6gKdw = parcelRequire("6gKdw");

var $1Lp6R = parcelRequire("1Lp6R");

var $aQaR3 = parcelRequire("aQaR3");

var $4zQqN = parcelRequire("4zQqN");

var $8nMOl = parcelRequire("8nMOl");

var $5ApPj = parcelRequire("5ApPj");

var $eXcSV = parcelRequire("eXcSV");

var $8rz6Z = parcelRequire("8rz6Z");

var $l8lrM = parcelRequire("l8lrM");

var $eDKO8 = parcelRequire("eDKO8");

var $eo7jM = parcelRequire("eo7jM");

var $6M9ry = parcelRequire("6M9ry");

var $7hONX = parcelRequire("7hONX");

var $6DicT = parcelRequire("6DicT");

var $2ICVg = parcelRequire("2ICVg");

var $eC6Gd = parcelRequire("eC6Gd");

var $dzpno = parcelRequire("dzpno");

var $gMq2C = parcelRequire("gMq2C");

var $6zQIj = parcelRequire("6zQIj");

var $fbZFd = parcelRequire("fbZFd");

var $l7afw = parcelRequire("l7afw");

var $c8zsf = parcelRequire("c8zsf");

var $kzTOv = parcelRequire("kzTOv");

var $gaDoi = parcelRequire("gaDoi");

var $6aiGU = parcelRequire("6aiGU");

var $2J1JW = parcelRequire("2J1JW");

var $11Nx5 = parcelRequire("11Nx5");

var $9l6gk = parcelRequire("9l6gk");

var $acdVt = parcelRequire("acdVt");

var $69IWw = parcelRequire("69IWw");

var $mrJGu = parcelRequire("mrJGu");

var $22B8v = parcelRequire("22B8v");

var $crriC = parcelRequire("crriC");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $fqiRx = parcelRequire("fqiRx");

var $gP42y = parcelRequire("gP42y");

var $lq9U1 = parcelRequire("lq9U1");

var $1LynW = parcelRequire("1LynW");

var $6Ygvg = parcelRequire("6Ygvg");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");

var $dEDAz = parcelRequire("dEDAz");

var $cJm46 = parcelRequire("cJm46");

var $eZfvk = parcelRequire("eZfvk");

var $8tOOR = parcelRequire("8tOOR");

var $9NdGd = parcelRequire("9NdGd");

var $alqbU = parcelRequire("alqbU");

var $3XeZf = parcelRequire("3XeZf");

var $elLea = parcelRequire("elLea");

var $lmWT0 = parcelRequire("lmWT0");

var $cdxCY = parcelRequire("cdxCY");

var $dolPi = parcelRequire("dolPi");

var $7vZaO = parcelRequire("7vZaO");

var $9VTJm = parcelRequire("9VTJm");

var $f7XaS = parcelRequire("f7XaS");

var $2uE72 = parcelRequire("2uE72");

var $3mzDh = parcelRequire("3mzDh");

var $gYvpj = parcelRequire("gYvpj");

var $ftQEj = parcelRequire("ftQEj");

var $3A1QZ = parcelRequire("3A1QZ");

var $aR8Ls = parcelRequire("aR8Ls");

var $lxzgt = parcelRequire("lxzgt");

var $cztsD = parcelRequire("cztsD");

var $4dHgV = parcelRequire("4dHgV");

var $9c2so = parcelRequire("9c2so");

var $d5YNe = parcelRequire("d5YNe");

var $dFPio = parcelRequire("dFPio");

var $97sGc = parcelRequire("97sGc");

var $V8cuc = parcelRequire("V8cuc");

var $4a6Xi = parcelRequire("4a6Xi");

var $9xwK0 = parcelRequire("9xwK0");

var $e1QJV = parcelRequire("e1QJV");

var $acgMJ = parcelRequire("acgMJ");

var $3NwTy = parcelRequire("3NwTy");

var $6afhl = parcelRequire("6afhl");

var $eJ7TQ = parcelRequire("eJ7TQ");

var $Ylp0b = parcelRequire("Ylp0b");

var $38ZlN = parcelRequire("38ZlN");

var $ijWLs = parcelRequire("ijWLs");

var $g1WMw = parcelRequire("g1WMw");

var $4F2NW = parcelRequire("4F2NW");

var $l44Td = parcelRequire("l44Td");

var $7XMW0 = parcelRequire("7XMW0");

var $gVs16 = parcelRequire("gVs16");

var $ljsAL = parcelRequire("ljsAL");

var $k87r6 = parcelRequire("k87r6");

var $l9d7h = parcelRequire("l9d7h");

var $9vpdF = parcelRequire("9vpdF");

var $bDram = parcelRequire("bDram");

var $6QfYA = parcelRequire("6QfYA");

var $f7xFe = parcelRequire("f7xFe");

var $9biDE = parcelRequire("9biDE");

var $3dpoM = parcelRequire("3dpoM");

var $gp22D = parcelRequire("gp22D");

var $1qrB4 = parcelRequire("1qrB4");

var $jnFDJ = parcelRequire("jnFDJ");

var $egwAq = parcelRequire("egwAq");

var $aDtWR = parcelRequire("aDtWR");

var $e3TnG = parcelRequire("e3TnG");

var $lWhFs = parcelRequire("lWhFs");

var $3bKD7 = parcelRequire("3bKD7");

var $bJALc = parcelRequire("bJALc");

var $jKo44 = parcelRequire("jKo44");

var $1wkM8 = parcelRequire("1wkM8");

var $eXYo2 = parcelRequire("eXYo2");

var $luPsK = parcelRequire("luPsK");

var $jSpBE = parcelRequire("jSpBE");

var $gXK2O = parcelRequire("gXK2O");

var $fjCAr = parcelRequire("fjCAr");

var $dtYdH = parcelRequire("dtYdH");

var $4fH8f = parcelRequire("4fH8f");

var $dCJkA = parcelRequire("dCJkA");

var $l8UtL = parcelRequire("l8UtL");

var $cBmEp = parcelRequire("cBmEp");

var $fG6j4 = parcelRequire("fG6j4");
const $36df5220d6ceb213$export$e0ccf6166915bd59 = {
    fft: $acdVt.fft,
    ifft: $69IWw.ifft,
    rfft: $22B8v.rfft,
    irfft: $mrJGu.irfft
};
const $36df5220d6ceb213$export$e2ef10f86a8d60e8 = {
    hammingWindow: $Ylp0b.hammingWindow,
    hannWindow: $38ZlN.hannWindow,
    frame: $ijWLs.frame,
    stft: $g1WMw.stft
};
const $36df5220d6ceb213$export$5c452ff88e35e47d = {
    flipLeftRight: $l44Td.flipLeftRight,
    grayscaleToRGB: $7XMW0.grayscaleToRGB,
    resizeNearestNeighbor: $3dpoM.resizeNearestNeighbor,
    resizeBilinear: $9biDE.resizeBilinear,
    rgbToGrayscale: $gVs16.rgbToGrayscale,
    rotateWithOffset: $ljsAL.rotateWithOffset,
    cropAndResize: $4F2NW.cropAndResize,
    nonMaxSuppression: $k87r6.nonMaxSuppression,
    nonMaxSuppressionAsync: $l9d7h.nonMaxSuppressionAsync,
    nonMaxSuppressionWithScore: $9vpdF.nonMaxSuppressionWithScore,
    nonMaxSuppressionWithScoreAsync: $bDram.nonMaxSuppressionWithScoreAsync,
    nonMaxSuppressionPadded: $6QfYA.nonMaxSuppressionPadded,
    nonMaxSuppressionPaddedAsync: $f7xFe.nonMaxSuppressionPaddedAsync,
    threshold: $gp22D.threshold,
    transform: $1qrB4.transform
};
const $36df5220d6ceb213$export$dbc5be37a4415193 = {
    bandPart: $jnFDJ.bandPart,
    gramSchmidt: $egwAq.gramSchmidt,
    qr: $aDtWR.qr
};
const $36df5220d6ceb213$export$24b113a95118cbdc = {
    absoluteDifference: $e3TnG.absoluteDifference,
    computeWeightedLoss: $lWhFs.computeWeightedLoss,
    cosineDistance: $3bKD7.cosineDistance,
    hingeLoss: $bJALc.hingeLoss,
    huberLoss: $jKo44.huberLoss,
    logLoss: $1wkM8.logLoss,
    meanSquaredError: $eXYo2.meanSquaredError,
    sigmoidCrossEntropy: $luPsK.sigmoidCrossEntropy,
    softmaxCrossEntropy: $jSpBE.softmaxCrossEntropy
};
const $36df5220d6ceb213$export$b6b7e189aa5d134c = {
    sparseFillEmptyRows: $gXK2O.sparseFillEmptyRows,
    sparseReshape: $fjCAr.sparseReshape,
    sparseSegmentMean: $dtYdH.sparseSegmentMean,
    sparseSegmentSum: $4fH8f.sparseSegmentSum
};
// tslint:disable-next-line:variable-name
const $36df5220d6ceb213$export$22b082955e083ec3 = {
    stringNGrams: $dCJkA.stringNGrams,
    stringSplit: $l8UtL.stringSplit,
    stringToHashBucketFast: $cBmEp.stringToHashBucketFast,
    staticRegexReplace: $fG6j4.staticRegexReplace
};
$parcel$exportWildcard(module.exports, $4dHgV);
$parcel$exportWildcard(module.exports, $9c2so);
$parcel$exportWildcard(module.exports, $d5YNe);
$parcel$exportWildcard(module.exports, $dFPio);
$parcel$exportWildcard(module.exports, $97sGc);
$parcel$exportWildcard(module.exports, $V8cuc);
$parcel$exportWildcard(module.exports, $4a6Xi);
$parcel$exportWildcard(module.exports, $9xwK0);
$parcel$exportWildcard(module.exports, $e1QJV);
$parcel$exportWildcard(module.exports, $acgMJ);
$parcel$exportWildcard(module.exports, $3NwTy);

});
parcelRegister("bls8e", function(module, exports) {

$parcel$export(module.exports, "acos", function () { return $84277a45182ac91f$export$fd6306be3fde5b04; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes acos of the input `tf.Tensor` element-wise: `acos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.acos().print();  // or tf.acos(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $84277a45182ac91f$var$acos_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'acos');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Acos), inputs);
}
const $84277a45182ac91f$export$fd6306be3fde5b04 = /* @__PURE__ */ (0, $6afhl.op)({
    acos_: $84277a45182ac91f$var$acos_
});

});

parcelRegister("17EGz", function(module, exports) {

$parcel$export(module.exports, "acosh", function () { return $0d16013aee407f4d$export$b26caf0f29211d08; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the inverse hyperbolic cos of the input `tf.Tensor` element-wise:
 * `acosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([10, 1, 3, 5.7]);
 *
 * x.acosh().print();  // or tf.acosh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0d16013aee407f4d$var$acosh_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'acosh');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Acosh), inputs);
}
const $0d16013aee407f4d$export$b26caf0f29211d08 = /* @__PURE__ */ (0, $6afhl.op)({
    acosh_: $0d16013aee407f4d$var$acosh_
});

});

parcelRegister("1oXel", function(module, exports) {

$parcel$export(module.exports, "addN", function () { return $1055fa433d7952b0$export$37b75d0026f96b8d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Adds a list of `tf.Tensor`s element-wise, each with the same shape and dtype.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 *
 * tf.addN([a, b, c]).print();
 * ```
 * @param tensors A list of tensors with the same shape and dtype.
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $1055fa433d7952b0$var$addN_(tensors) {
    $eOiOM.assert(Array.isArray(tensors), ()=>'The argument passed to tf.addN() must be a list of tensors');
    $eOiOM.assert(tensors.length >= 1, ()=>`Must pass at least one tensor to tf.addN(), but got ` + `${tensors.length}`);
    const $tensors = tensors.map((t, i)=>(0, $x4eLk.convertToTensor)(t, `tensors${i}`, 'addN'));
    const firstTensor = $tensors[0];
    $tensors.forEach((t)=>{
        if (t.dtype !== firstTensor.dtype) throw new Error('All tensors passed to tf.addN() must have the same dtype');
    });
    $tensors.forEach((t)=>{
        if (!$eOiOM.arraysEqual(t.shape, firstTensor.shape)) throw new Error('All tensors passed to tf.addN() must have the same shape');
    });
    const inputs = $tensors;
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.AddN), inputs);
}
const $1055fa433d7952b0$export$37b75d0026f96b8d = /* @__PURE__ */ (0, $6afhl.op)({
    addN_: $1055fa433d7952b0$var$addN_
});

});

parcelRegister("j70Qn", function(module, exports) {

$parcel$export(module.exports, "argMin", function () { return $de9f5352d47ef334$export$ec99a91cddfb29a2; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the indices of the minimum values along an `axis`.
 *
 * The result has the same shape as `input` with the dimension along `axis`
 * removed.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.argMin().print();  // or tf.argMin(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 4, 3], [2, 2]);
 *
 * const axis = 1;
 * x.argMin(axis).print();  // or tf.argMin(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension to reduce. Defaults to 0 (outer-most dimension).
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $de9f5352d47ef334$var$argMin_(x, axis = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'argMin');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ArgMin), inputs, attrs);
}
const $de9f5352d47ef334$export$ec99a91cddfb29a2 = /* @__PURE__ */ (0, $6afhl.op)({
    argMin_: $de9f5352d47ef334$var$argMin_
});

});

parcelRegister("lz3uk", function(module, exports) {

$parcel$export(module.exports, "asin", function () { return $fb2f928e4bcd94ed$export$41726bdb1fc63f; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes asin of the input `tf.Tensor` element-wise: `asin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asin().print();  // or tf.asin(x)
 * ```
 * @param x The input tensor.
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $fb2f928e4bcd94ed$var$asin_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'asin');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Asin), inputs);
}
const $fb2f928e4bcd94ed$export$41726bdb1fc63f = /* @__PURE__ */ (0, $6afhl.op)({
    asin_: $fb2f928e4bcd94ed$var$asin_
});

});

parcelRegister("93aRU", function(module, exports) {

$parcel$export(module.exports, "asinh", function () { return $696cd32330df853b$export$839d8a01b6af4fc0; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes inverse hyperbolic sin of the input `tf.Tensor` element-wise:
 * `asinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.asinh().print();  // or tf.asinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $696cd32330df853b$var$asinh_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'asinh');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Asinh), inputs);
}
const $696cd32330df853b$export$839d8a01b6af4fc0 = /* @__PURE__ */ (0, $6afhl.op)({
    asinh_: $696cd32330df853b$var$asinh_
});

});

parcelRegister("5n4it", function(module, exports) {

$parcel$export(module.exports, "atan", function () { return $3e926f03e010ade1$export$628dc4eed22b0fbd; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes atan of the input `tf.Tensor` element-wise: `atan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.atan().print();  // or tf.atan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $3e926f03e010ade1$var$atan_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'atan');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Atan), inputs);
}
const $3e926f03e010ade1$export$628dc4eed22b0fbd = /* @__PURE__ */ (0, $6afhl.op)({
    atan_: $3e926f03e010ade1$var$atan_
});

});

parcelRegister("aLZ6G", function(module, exports) {

$parcel$export(module.exports, "atan2", function () { return $7d7db1b9aeda2ef9$export$b8b770ee6a0d9760; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes arctangent of `tf.Tensor`s a / b element-wise: `atan2(a, b)`.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1.0, 1.0, -1.0, .7]);
 * const b = tf.tensor1d([2.0, 13.0, 3.5, .21]);
 *
 * tf.atan2(a, b).print()
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $7d7db1b9aeda2ef9$var$atan2_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'atan2');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'atan2');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Atan2), inputs);
}
const $7d7db1b9aeda2ef9$export$b8b770ee6a0d9760 = /* @__PURE__ */ (0, $6afhl.op)({
    atan2_: $7d7db1b9aeda2ef9$var$atan2_
});

});

parcelRegister("aCXEC", function(module, exports) {

$parcel$export(module.exports, "atanh", function () { return $7bcbba0dcf24ff61$export$21ea955025ceb08b; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes inverse hyperbolic tan of the input `tf.Tensor` element-wise:
 * `atanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, .1, -.1, .7]);
 *
 * x.atanh().print();  // or tf.atanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $7bcbba0dcf24ff61$var$atanh_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'atanh');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Atanh), inputs);
}
const $7bcbba0dcf24ff61$export$21ea955025ceb08b = /* @__PURE__ */ (0, $6afhl.op)({
    atanh_: $7bcbba0dcf24ff61$var$atanh_
});

});

parcelRegister("8I3cQ", function(module, exports) {

$parcel$export(module.exports, "basicLSTMCell", function () { return $6574eb774555b1c1$export$5f13ab10a3272278; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $6Ab5n = parcelRequire("6Ab5n");

var $1goxr = parcelRequire("1goxr");

var $VLFo8 = parcelRequire("VLFo8");

var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $dzpno = parcelRequire("dzpno");

var $l7afw = parcelRequire("l7afw");

var $cJm46 = parcelRequire("cJm46");
/**
 * Computes the next state and output of a BasicLSTMCell.
 *
 * Returns `[newC, newH]`.
 *
 * Derived from tf.contrib.rnn.BasicLSTMCell.
 *
 * @param forgetBias Forget bias for the cell.
 * @param lstmKernel The weights for the cell.
 * @param lstmBias The bias for the cell.
 * @param data The input to the cell.
 * @param c Previous cell state.
 * @param h Previous cell output.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $6574eb774555b1c1$var$basicLSTMCell_(forgetBias, lstmKernel, lstmBias, data, c, h) {
    const $forgetBias = (0, $x4eLk.convertToTensor)(forgetBias, 'forgetBias', 'basicLSTMCell');
    const $lstmKernel = (0, $x4eLk.convertToTensor)(lstmKernel, 'lstmKernel', 'basicLSTMCell');
    const $lstmBias = (0, $x4eLk.convertToTensor)(lstmBias, 'lstmBias', 'basicLSTMCell');
    const $data = (0, $x4eLk.convertToTensor)(data, 'data', 'basicLSTMCell');
    const $c = (0, $x4eLk.convertToTensor)(c, 'c', 'basicLSTMCell');
    const $h = (0, $x4eLk.convertToTensor)(h, 'h', 'basicLSTMCell');
    const combined = (0, $1goxr.concat)([
        $data,
        $h
    ], 1);
    const weighted = (0, $VLFo8.matMul)(combined, $lstmKernel);
    const res = (0, $6Ab5n.add)(weighted, $lstmBias);
    // i = input_gate, j = new_input, f = forget_gate, o = output_gate
    const batchSize = res.shape[0];
    const sliceCols = res.shape[1] / 4;
    const sliceSize = [
        batchSize,
        sliceCols
    ];
    const i = (0, $l7afw.slice)(res, [
        0,
        0
    ], sliceSize);
    const j = (0, $l7afw.slice)(res, [
        0,
        sliceCols
    ], sliceSize);
    const f = (0, $l7afw.slice)(res, [
        0,
        sliceCols * 2
    ], sliceSize);
    const o = (0, $l7afw.slice)(res, [
        0,
        sliceCols * 3
    ], sliceSize);
    const newC = (0, $6Ab5n.add)((0, $5hAos.mul)((0, $dzpno.sigmoid)(i), (0, $cJm46.tanh)(j)), (0, $5hAos.mul)($c, (0, $dzpno.sigmoid)((0, $6Ab5n.add)($forgetBias, f))));
    const newH = (0, $5hAos.mul)((0, $cJm46.tanh)(newC), (0, $dzpno.sigmoid)(o));
    return [
        newC,
        newH
    ];
}
const $6574eb774555b1c1$export$5f13ab10a3272278 = /* @__PURE__ */ (0, $6afhl.op)({
    basicLSTMCell_: $6574eb774555b1c1$var$basicLSTMCell_
});

});
parcelRegister("l7afw", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $f5f233b4a7bb9c4a$export$58adb3bec8346d0f; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Extracts a slice from a `tf.Tensor` starting at coordinates `begin`
 * and is of size `size`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `x` is of the given rank:
 *   - `tf.slice1d`
 *   - `tf.slice2d`
 *   - `tf.slice3d`
 *   - `tf.slice4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.slice([1], [2]).print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * x.slice([1, 0], [1, 2]).print();
 * ```
 * @param x The input `tf.Tensor` to slice from.
 * @param begin The coordinates to start the slice from. The length can be
 *     less than the rank of x - the rest of the axes will have implicit 0 as
 *     start. Can also be a single number, in which case it specifies the
 *     first axis.
 * @param size The size of the slice. The length can be less than the rank of
 *     x - the rest of the axes will have implicit -1. A value of -1 requests
 *     the rest of the dimensions in the axis. Can also be a single number,
 *     in which case it specifies the size of the first axis.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $f5f233b4a7bb9c4a$var$slice_(x, begin, size) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'slice', 'string_or_numeric');
    if ($x.rank === 0) throw new Error('Slicing scalar is not possible');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        size: size
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Slice), inputs, attrs);
}
const $f5f233b4a7bb9c4a$export$58adb3bec8346d0f = /* @__PURE__ */ (0, $6afhl.op)({
    slice_: $f5f233b4a7bb9c4a$var$slice_
});

});

parcelRegister("cJm46", function(module, exports) {

$parcel$export(module.exports, "tanh", function () { return $944acdaece872591$export$7128670e45beef9a; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes hyperbolic tangent of the input `tf.Tensor` element-wise: `tanh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, 70]);
 *
 * x.tanh().print();  // or tf.tanh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $944acdaece872591$var$tanh_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'tanh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Tanh), inputs);
}
const $944acdaece872591$export$7128670e45beef9a = /* @__PURE__ */ (0, $6afhl.op)({
    tanh_: $944acdaece872591$var$tanh_
});

});


parcelRegister("7rVXz", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceND", function () { return $56c803a0f10b2049$export$ea37d960c1808536; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * This operation reshapes the "batch" dimension 0 into `M + 1` dimensions of
 * shape `blockShape + [batch]`, interleaves these blocks back into the grid
 * defined by the spatial dimensions `[1, ..., M]`, to obtain a result with
 * the same rank as the input. The spatial dimensions of this intermediate
 * result are then optionally cropped according to `crops` to produce the
 * output. This is the reverse of `tf.spaceToBatchND`. See below for a precise
 * description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [4, 1, 1, 1]);
 * const blockShape = [2, 2];
 * const crops = [[0, 0], [0, 0]];
 *
 * x.batchToSpaceND(blockShape, crops).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param crops A 2-D array.  Must have shape `[M, 2]`, all values must be >= 0.
 * `crops[i] = [cropStart, cropEnd]` specifies the amount to crop from input
 * dimension `i + 1`, which corresponds to spatial dimension `i`. It is required
 * that `cropStart[i] + cropEnd[i] <= blockShape[i] * inputShape[i + 1]`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Reshape `x` to `reshaped` of shape: `[blockShape[0], ...,
 * blockShape[M-1], batch / prod(blockShape), x.shape[1], ...,
 * x.shape[N-1]]`
 *
 * 2. Permute dimensions of `reshaped` to produce `permuted` of shape `[batch /
 * prod(blockShape),x.shape[1], blockShape[0], ..., x.shape[M],
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 3. Reshape `permuted` to produce `reshapedPermuted` of shape `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0], ..., x.shape[M] *
 * blockShape[M-1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * 4. Crop the start and end of dimensions `[1, ..., M]` of `reshapedPermuted`
 * according to `crops` to produce the output of shape: `[batch /
 * prod(blockShape),x.shape[1] * blockShape[0] - crops[0,0] - crops[0,1],
 * ..., x.shape[M] * blockShape[M-1] - crops[M-1,0] -
 * crops[M-1,1],x.shape[M+1], ..., x.shape[N-1]]`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $56c803a0f10b2049$var$batchToSpaceND_(x, blockShape, crops) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'batchToSpaceND');
    const prod = blockShape.reduce((a, b)=>a * b);
    $eOiOM.assert($x.rank >= 1 + blockShape.length, ()=>`input rank is ${$x.rank} but should be > than blockShape.length ${blockShape.length}`);
    $eOiOM.assert(crops.length === blockShape.length, ()=>`crops.length is ${crops.length} but should be equal to blockShape.length  ${blockShape.length}`);
    $eOiOM.assert($x.shape[0] % prod === 0, ()=>`input tensor batch is ${$x.shape[0]} but is not divisible by the product of ` + `the elements of blockShape ${blockShape.join(' * ')} === ${prod}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        crops: crops
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.BatchToSpaceND), inputs, attrs);
}
const $56c803a0f10b2049$export$ea37d960c1808536 = /* @__PURE__ */ (0, $6afhl.op)({
    batchToSpaceND_: $56c803a0f10b2049$var$batchToSpaceND_
});

});

parcelRegister("jqlcD", function(module, exports) {

$parcel$export(module.exports, "bincount", function () { return $e240e47006e51e7e$export$7e474bab088ed182; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Outputs a vector with length `size` and the same dtype as `weights`.
 *
 * If `weights` are empty, then index `i` stores the number of times the value
 * `i` is counted in `x`. If `weights` are non-empty, then index `i` stores the
 * sum of the value in `weights` at each index where the corresponding value in
 * `x` is `i`.
 *
 * Values in `x` outside of the range [0, size) are ignored.
 *
 * @param x The input int tensor, rank 1.
 * @param weights The weights tensor, must have the same shape as x, or a
 *     length-0 Tensor, in which case it acts as all weights equal to 1.
 * @param size Non-negative integer.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $e240e47006e51e7e$var$bincount_(x, weights, size) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'bincount');
    const $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'bincount');
    $eOiOM.assert($x.dtype === 'int32', ()=>`Error in bincount: input ` + `dtype must be int32, but got ${$x.dtype}`);
    $eOiOM.assert(size >= 0, ()=>`size must be non-negative, but got ${size}.`);
    $eOiOM.assert($weights.size === $x.size || $weights.size === 0, ()=>`Error in bincount: weights must have the same size as input or` + `0-length, but got input shape: ${$x.shape}, weights shape: ` + `${$weights.shape}.`);
    const inputs = {
        x: $x,
        weights: $weights
    };
    const attrs = {
        size: size
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Bincount), inputs, attrs);
}
const $e240e47006e51e7e$export$7e474bab088ed182 = /* @__PURE__ */ (0, $6afhl.op)({
    bincount_: $e240e47006e51e7e$var$bincount_
});

});

parcelRegister("3dUR6", function(module, exports) {

$parcel$export(module.exports, "bitwiseAnd", function () { return $258eb04cd41d58ea$export$84529b0ad3b42cd1; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Bitwise `AND` operation for input tensors.
 *
 * Given two input tensors, returns a new tensor
 * with the `AND` calculated values.
 *
 * The method supports int32 values
 *
 *
 * ```js
 * const x = tf.tensor1d([0, 5, 3, 14], 'int32');
 * const y = tf.tensor1d([5, 0, 7, 11], 'int32');
 * tf.bitwiseAnd(x, y).print();
 * ```
 *
 * @param x The input tensor to be calculated.
 * @param y The input tensor to be calculated.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $258eb04cd41d58ea$var$bitwiseAnd_(x, y) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'bitwiseAnd');
    const $y = (0, $x4eLk.convertToTensor)(y, 'y', 'bitwiseAnd');
    if (!(0, $eOiOM.arraysEqual)($x.shape, $y.shape)) throw new Error(`BitwiseAnd: Tensors must have the same shape. x: ${$x.shape}, y: ${$y.shape}`);
    if ($x.dtype !== 'int32' || $y.dtype !== 'int32') throw new Error(`BitwiseAnd: Only supports 'int32' values in tensor, found type of x: ${$x.dtype} and type of y: ${$y.dtype}`);
    const inputs = {
        a: $x,
        b: $y
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.BitwiseAnd), inputs);
}
const $258eb04cd41d58ea$export$84529b0ad3b42cd1 = /* @__PURE__ */ (0, $6afhl.op)({
    bitwiseAnd_: $258eb04cd41d58ea$var$bitwiseAnd_
});

});

parcelRegister("jJSUM", function(module, exports) {

$parcel$export(module.exports, "broadcastArgs", function () { return $e5ecd13b7fdd4f54$export$d226d344aedce941; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Return the shape of s0 op s1 with broadcast.
 *
 * compute r0, the broadcasted shape as a tensor.
 * s0, s1 and r0 are all integer vectors.
 *
 * This function returns the shape of the result of an operation between
 * two tensors of size s0 and s1 performed with broadcast.
 *
 * @param s0 A tensor representing a shape
 * @param s1 A tensor representing a shape
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $e5ecd13b7fdd4f54$var$broadcastArgs_(s0, s1) {
    const shape1Input = (0, $x4eLk.convertToTensor)(s0, 's0', 'broadcastArgs', 'int32');
    const shape2Input = (0, $x4eLk.convertToTensor)(s1, 's1', 'broadcastArgs', 'int32');
    if (shape1Input.rank !== 1) throw new Error('broadcastArgs(): first input must be a vector (rank=1). ' + `Has rank ${shape1Input.rank}`);
    if (shape2Input.rank !== 1) throw new Error('broadcastArgs(): second input must be a vector (rank=1). ' + `Has rank ${shape2Input.rank}`);
    const inputs = {
        s0: shape1Input,
        s1: shape2Input
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.BroadcastArgs), inputs);
}
const $e5ecd13b7fdd4f54$export$d226d344aedce941 = /* @__PURE__ */ (0, $6afhl.op)({
    broadcastArgs_: $e5ecd13b7fdd4f54$var$broadcastArgs_
});

});

parcelRegister("6tPaz", function(module, exports) {

$parcel$export(module.exports, "ceil", function () { return $4b7d24b9c2a8ca8c$export$803ce6b71a0a94b2; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes ceiling of input `tf.Tensor` element-wise: `ceil(x)`
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.ceil().print();  // or tf.ceil(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $4b7d24b9c2a8ca8c$var$ceil_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'ceil', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Ceil), inputs);
}
const $4b7d24b9c2a8ca8c$export$803ce6b71a0a94b2 = /* @__PURE__ */ (0, $6afhl.op)({
    ceil_: $4b7d24b9c2a8ca8c$var$ceil_
});

});

parcelRegister("71JL9", function(module, exports) {

$parcel$export(module.exports, "cos", function () { return $51dc1f492bba9f97$export$50d414a77b60d802; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes cos of the input `tf.Tensor` element-wise: `cos(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.cos().print();  // or tf.cos(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $51dc1f492bba9f97$var$cos_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'cos', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Cos), inputs);
}
const $51dc1f492bba9f97$export$50d414a77b60d802 = /* @__PURE__ */ (0, $6afhl.op)({
    cos_: $51dc1f492bba9f97$var$cos_
});

});

parcelRegister("Riay5", function(module, exports) {

$parcel$export(module.exports, "cosh", function () { return $0a030b5d880fda3b$export$2e2fd1ad24e4d350; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes hyperbolic cos of the input `tf.Tensor` element-wise: `cosh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.cosh().print();  // or tf.cosh(x)
 * ```
 * @param x The input tensor. Must be float32 type.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0a030b5d880fda3b$var$cosh_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'cosh', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Cosh), inputs);
}
const $0a030b5d880fda3b$export$2e2fd1ad24e4d350 = /* @__PURE__ */ (0, $6afhl.op)({
    cosh_: $0a030b5d880fda3b$var$cosh_
});

});

parcelRegister("8By4p", function(module, exports) {

$parcel$export(module.exports, "cumprod", function () { return $643c350d873bde14$export$dc7513e907e94b8d; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the cumulative product of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumprod().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumprod().print();
 * ```
 *
 * @param x The input tensor to cumulatively multiply.
 * @param axis The axis along which to multiply. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative product. Optional.
 *     Defaults to false. If set to true then the product of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to multiply in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $643c350d873bde14$var$cumprod_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'cumprod');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Cumprod), inputs, attrs);
}
const $643c350d873bde14$export$dc7513e907e94b8d = /* @__PURE__ */ (0, $6afhl.op)({
    cumprod_: $643c350d873bde14$var$cumprod_
});

});

parcelRegister("ec6xM", function(module, exports) {

$parcel$export(module.exports, "cumsum", function () { return $a5574328efd1e7c8$export$71990b1e1c4912fe; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the cumulative sum of a `tf.Tensor` along `axis`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4]);
 * x.cumsum().print();
 * ```
 * ```js
 * const x = tf.tensor([[1, 2], [3, 4]]);
 * x.cumsum().print();
 * ```
 *
 * @param x The input tensor to be summed.
 * @param axis The axis along which to sum. Optional. Defaults to 0.
 * @param exclusive Whether to perform exclusive cumulative sum. Optional.
 *     Defaults to false. If set to true then the sum of each tensor entry
 *     does not include its own value, but only the values previous to it
 *     along the specified axis.
 * @param reverse Whether to sum in the opposite direction. Optional.
 *     Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Scan'}
 */ function $a5574328efd1e7c8$var$cumsum_(x, axis = 0, exclusive = false, reverse = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'cumsum');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        exclusive: exclusive,
        reverse: reverse
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Cumsum), inputs, attrs);
}
const $a5574328efd1e7c8$export$71990b1e1c4912fe = /* @__PURE__ */ (0, $6afhl.op)({
    cumsum_: $a5574328efd1e7c8$var$cumsum_
});

});

parcelRegister("3Gf0o", function(module, exports) {

$parcel$export(module.exports, "depthToSpace", function () { return $2ae0ef1aa61caa3a$export$3b50daec0f185f12; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Rearranges data from depth into blocks of spatial data. More specifically,
 * this op outputs a copy of the input tensor where values from the `depth`
 * dimension are moved in spatial blocks to the `height` and `width` dimensions.
 * The attr `blockSize` indicates the input block size and how the data is
 * moved.
 *
 *  - Chunks of data of size `blockSize * blockSize` from depth are rearranged
 * into non-overlapping blocks of size `blockSize x blockSize`
 *
 *  - The width the output tensor is `inputWidth * blockSize`, whereas the
 * height is `inputHeight * blockSize`
 *
 *  - The Y, X coordinates within each block of the output image are determined
 * by the high order component of the input channel index
 *
 *  - The depth of the input tensor must be divisible by `blockSize *
 * blockSize`
 *
 * The `dataFormat` attr specifies the layout of the input and output tensors
 * with the following options: "NHWC": [ `batch, height, width, channels` ]
 * "NCHW": [ `batch, channels, height, width` ]
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 1, 1, 4]);
 * const blockSize = 2;
 * const dataFormat = "NHWC";
 *
 * tf.depthToSpace(x, blockSize, dataFormat).print();
 * ```
 *
 * @param x The input tensor of rank 4
 * @param blockSIze  An `int` that is `>= 2`. The size of the spatial block
 * @param dataFormat An optional string from: "NHWC", "NCHW". Defaults to "NHWC"
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $2ae0ef1aa61caa3a$var$depthToSpace_(x, blockSize, dataFormat = 'NHWC') {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'depthToSpace', 'float32');
    const inputHeight = dataFormat === 'NHWC' ? $x.shape[1] : $x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? $x.shape[2] : $x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? $x.shape[3] : $x.shape[1];
    $eOiOM.assert(blockSize > 1, ()=>`blockSize should be > 1 for depthToSpace, but was: ${blockSize}`);
    $eOiOM.assert(inputHeight * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputHeight} and ${blockSize}  for depthToSpace with input shape
    ${$x.shape}`);
    $eOiOM.assert(inputWidth * blockSize >= 0, ()=>`Negative dimension size caused by overflow when multiplying
    ${inputWidth} and ${blockSize} for depthToSpace with input shape
        ${$x.shape}`);
    $eOiOM.assert(inputDepth % (blockSize * blockSize) === 0, ()=>`Dimension size must be evenly divisible by ${blockSize * blockSize} but is ${inputDepth} for depthToSpace with input shape ${$x.shape}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockSize: blockSize,
        dataFormat: dataFormat
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.DepthToSpace), inputs, attrs);
}
const $2ae0ef1aa61caa3a$export$3b50daec0f185f12 = /* @__PURE__ */ (0, $6afhl.op)({
    depthToSpace_: $2ae0ef1aa61caa3a$var$depthToSpace_
});

});

parcelRegister("8QKGt", function(module, exports) {

$parcel$export(module.exports, "diag", function () { return $01a9aae96da9c259$export$c042e7c2f59bc046; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns a diagonal tensor with given diagonal values.
 *
 * Given a diagonal, this operation returns a tensor with the diagonal and
 * everything else padded with zeros.
 *
 * Assume the input has dimensions `[D1,..., Dk]`, then the output is a tensor
 * of rank 2k with dimensions `[D1,..., Dk, D1,..., Dk]`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * tf.diag(x).print()
 * ```
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [4, 2])
 *
 * tf.diag(x).print()
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $01a9aae96da9c259$var$diag_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'diag');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Diag), inputs);
}
const $01a9aae96da9c259$export$c042e7c2f59bc046 = /* @__PURE__ */ (0, $6afhl.op)({
    diag_: $01a9aae96da9c259$var$diag_
});

});

parcelRegister("bP8B9", function(module, exports) {

$parcel$export(module.exports, "dilation2d", function () { return $0238b212c5f7e23b$export$d9b8f675671875b9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the grayscale dilation over the input `x`.
 *
 * @param x The input tensor, rank 3 or rank 4 of shape
 *     `[batch, height, width, depth]`. If rank 3, batch of 1 is assumed.
 * @param filter The filter tensor, rank 3, of shape
 *     `[filterHeight, filterWidth, depth]`.
 * @param strides The strides of the sliding window for each dimension of the
 *     input tensor: `[strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dataFormat Specify the data format of the input and output data.
 *      Defaults to 'NHWC'. Only 'NHWC' is currently supported. With the
 *      default format "NHWC", the data is stored in the order of: [batch,
 *      height, width, channels].
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     for atrous morphological dilation. Defaults to `[1, 1]`. If `dilations`
 *     is a single number, then `dilationHeight == dilationWidth`. If it is
 *     greater than 1, then all values of `strides` must be 1.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $0238b212c5f7e23b$var$dilation2d_(x, filter, strides, pad, dilations = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'dilation2d');
    const $filter = (0, $x4eLk.convertToTensor)(filter, 'filter', 'dilation2d');
    $eOiOM.assert($x.rank === 3 || $x.rank === 4, ()=>`Error in dilation2d: input must be rank 3 or 4, but got rank ` + `${$x.rank}.`);
    $eOiOM.assert($filter.rank === 3, ()=>`Error in dilation2d: filter must be rank 3, but got rank ` + `${$filter.rank}.`);
    $eOiOM.assert(dataFormat === 'NHWC', ()=>`Error in dilation2d: Only NHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
        reshapedTo4D = true;
    }
    $eOiOM.assert(x4D.shape[3] === $filter.shape[2], ()=>`Error in dilation2d:  input and filter must have the same depth: ${x4D.shape[3]} vs ${$filter.shape[2]}`);
    const inputs = {
        x: x4D,
        filter: $filter
    };
    const attrs = {
        strides: strides,
        pad: pad,
        dilations: dilations
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Dilation2D), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $0238b212c5f7e23b$export$d9b8f675671875b9 = /* @__PURE__ */ (0, $6afhl.op)({
    dilation2d_: $0238b212c5f7e23b$var$dilation2d_
});

});

parcelRegister("dosDM", function(module, exports) {

$parcel$export(module.exports, "divNoNan", function () { return $9c03bba9d69c1243$export$9c5df3eb9e56f19e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $dIChU = parcelRequire("dIChU");

var $28GAP = parcelRequire("28GAP");

var $6afhl = parcelRequire("6afhl");

var $3A1QZ = parcelRequire("3A1QZ");

var $cztsD = parcelRequire("cztsD");
/**
 * Divides two `tf.Tensor`s element-wise, A / B. Supports broadcasting. Return 0
 * if denominator is 0.
 *
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 9, 16]);
 * const b = tf.tensor1d([1, 2, 3, 4]);
 * const c = tf.tensor1d([0, 0, 0, 0]);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * ```js
 * // Broadcast div a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(2);
 * const c = tf.scalar(0);
 *
 * a.divNoNan(b).print();  // or tf.divNoNan(a, b)
 * a.divNoNan(c).print();  // or tf.divNoNan(a, c)
 * ```
 *
 * @param a The first tensor as the numerator.
 * @param b The second tensor as the denominator. Must have the same dtype as
 * `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $9c03bba9d69c1243$var$divNoNan_(a, b) {
    // TODO: Make this into its own kernel.
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'div');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'div');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const divResult = (0, $dIChU.div)($a, $b);
    const zeros = (0, $cztsD.zerosLike)(divResult);
    const bEqualsZero = (0, $28GAP.equal)($b, zeros);
    return (0, $3A1QZ.where)(bEqualsZero, zeros, divResult);
}
const $9c03bba9d69c1243$export$9c5df3eb9e56f19e = /* @__PURE__ */ (0, $6afhl.op)({
    divNoNan_: $9c03bba9d69c1243$var$divNoNan_
});

});
parcelRegister("3A1QZ", function(module, exports) {

$parcel$export(module.exports, "where", function () { return $29b62c003f142c09$export$9c59b80dda569a6e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $bMTXt = parcelRequire("bMTXt");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the elements, either `a` or `b` depending on the `condition`.
 *
 * If the condition is true, select from `a`, otherwise select from `b`.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const a = tf.tensor1d([1 , 2, 3]);
 * const b = tf.tensor1d([-1, -2, -3]);
 *
 * a.where(cond, b).print();
 * ```
 *
 * @param condition The input condition. Must be of dtype bool.
 * @param a If `condition` is rank 1, `a` may have a higher rank but
 *     its first dimension must match the size of `condition`.
 * @param b A tensor with the same dtype as `a` and with shape that is
 *     compatible with `a`.
 * @return A tensor with same dtype as `a` and `b`, and shape that is
 *     broadcastable from `a` and `b`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $29b62c003f142c09$var$where_(condition, a, b) {
    const $a = (0, $x4eLk.convertToTensor)(a, 'a', 'where');
    const $b = (0, $x4eLk.convertToTensor)(b, 'b', 'where');
    const $condition = (0, $x4eLk.convertToTensor)(condition, 'condition', 'where', 'bool');
    // TODO: move this logic to forward function when the broadcastTo op is
    // implemented in WASM.
    // Find the broadcastable shape for $condition, $a, and $b.
    const broadcastShape = (0, $5mf1d.assertAndGetBroadcastShape)((0, $5mf1d.assertAndGetBroadcastShape)($condition.shape, $a.shape), $b.shape);
    const $broadcastedCondition = (0, $bMTXt.broadcastTo)($condition, broadcastShape);
    const $broadcastedA = (0, $bMTXt.broadcastTo)($a, broadcastShape);
    const $broadcastedB = (0, $bMTXt.broadcastTo)($b, broadcastShape);
    const inputs = {
        condition: $broadcastedCondition,
        t: $broadcastedA,
        e: $broadcastedB
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Select), inputs);
}
const $29b62c003f142c09$export$9c59b80dda569a6e = /* @__PURE__ */ (0, $6afhl.op)({
    where_: $29b62c003f142c09$var$where_
});

});


parcelRegister("3bsW7", function(module, exports) {

$parcel$export(module.exports, "dot", function () { return $2518d85887c64d35$export$94132a0e348806d4; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $VLFo8 = parcelRequire("VLFo8");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the dot product of two matrices and/or vectors, `t1` and `t2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor2d([[1, 2], [3, 4]]);
 * const c = tf.tensor2d([[1, 2, 3], [4, 5, 6]]);
 *
 * a.dot(b).print();  // or tf.dot(a, b)
 * b.dot(a).print();
 * b.dot(c).print();
 * ```
 * @param t1 The first tensor in the dot operation.
 * @param t2 The second tensor in the dot operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $2518d85887c64d35$var$dot_(t1, t2) {
    const $t1 = (0, $x4eLk.convertToTensor)(t1, 't1', 'dot');
    const $t2 = (0, $x4eLk.convertToTensor)(t2, 't2', 'dot');
    $eOiOM.assert(($t1.rank === 1 || $t1.rank === 2) && ($t2.rank === 1 || $t2.rank === 2), ()=>`Error in dot: inputs must all be rank 1 or 2, but got ranks ` + `${$t1.rank} and ${$t2.rank}.`);
    const t1Inner = $t1.rank === 1 ? $t1.size : $t1.shape[1];
    const t2Inner = $t2.rank === 1 ? $t2.size : $t2.shape[0];
    $eOiOM.assert(t1Inner === t2Inner, ()=>`Error in dot: inner dimensions of inputs must match, but got ` + `${t1Inner} and ${t2Inner}.`);
    if ($t1.rank === 1 && $t2.rank === 1) {
        const t12D = (0, $8nMOl.reshape)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $8nMOl.reshape)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $VLFo8.matMul)(t12D, t22D);
        return (0, $8nMOl.reshape)(t1t2, []);
    } else if ($t1.rank === 1 && $t2.rank === 2) {
        const t12D = (0, $8nMOl.reshape)($t1, [
            1,
            -1
        ]);
        const t22D = (0, $8nMOl.reshape)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $VLFo8.matMul)(t12D, t22D);
        return (0, $8nMOl.reshape)(t1t2, [
            t1t2.size
        ]);
    } else if ($t1.rank === 2 && $t2.rank === 1) {
        const t22D = (0, $8nMOl.reshape)($t2, [
            -1,
            1
        ]);
        const t1t2 = (0, $VLFo8.matMul)($t1, t22D);
        return (0, $8nMOl.reshape)(t1t2, [
            t1t2.size
        ]);
    } else {
        const t22D = (0, $8nMOl.reshape)($t2, [
            $t2.shape[0],
            $t2.shape[1]
        ]);
        const t1t2 = (0, $VLFo8.matMul)($t1, t22D);
        return t1t2;
    }
}
const $2518d85887c64d35$export$94132a0e348806d4 = /* @__PURE__ */ (0, $6afhl.op)({
    dot_: $2518d85887c64d35$var$dot_
});

});

parcelRegister("lR4Fq", function(module, exports) {

$parcel$export(module.exports, "einsum", function () { return $fe922b08b90426fe$export$27265e7daac5c403; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
function $fe922b08b90426fe$export$f6fde01e521435e1(equation, ...tensors) {
    const $tensors = tensors.map((t, i)=>(0, $x4eLk.convertToTensor)(t, `tensors${i}`, 'einsum'));
    const attrs = {
        equation: equation
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Einsum), $tensors, attrs);
}
const $fe922b08b90426fe$export$27265e7daac5c403 = /* @__PURE__ */ (0, $6afhl.op)({
    einsum_: $fe922b08b90426fe$export$f6fde01e521435e1
});

});

parcelRegister("1WZha", function(module, exports) {

$parcel$export(module.exports, "ensureShape", function () { return $16babd5757af9a6c$export$6699c34d603c5978; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Checks the input tensor mathes the given shape.
 *
 * Given an input tensor, returns a new tensor with the same values as the
 * input tensor with shape `shape`.
 *
 * The method supports the null value in tensor. It will still check the shapes,
 * and null is a placeholder.
 *
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const y = tf.tensor1d([1, null, 3, 4]);
 * const z = tf.tensor2d([1, 2, 3, 4], [2,2]);
 * tf.ensureShape(x, [4]).print();
 * tf.ensureShape(y, [4]).print();
 * tf.ensureShape(z, [null, 2]).print();
 * ```
 *
 * @param x The input tensor to be ensured.
 * @param shape A TensorShape representing the shape of this tensor, an array
 *     or null.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $16babd5757af9a6c$var$ensureShape_(x, shape) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'ensureShape', 'string_or_numeric');
    if (!(0, $eOiOM.arraysEqualWithNull)($x.shape, shape)) throw new Error(`EnsureShape: Shape of tensor ${$x.shape} is not compatible with expected shape ${shape}`);
    return x;
}
const $16babd5757af9a6c$export$6699c34d603c5978 = /* @__PURE__ */ (0, $6afhl.op)({
    ensureShape_: $16babd5757af9a6c$var$ensureShape_
});

});

parcelRegister("chOKV", function(module, exports) {

$parcel$export(module.exports, "euclideanNorm", function () { return $8f1e71a0619d5cde$export$38d83b337e7c2edd; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $d5YNe = parcelRequire("d5YNe");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the Euclidean norm of scalar, vectors, and matrices.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.euclideanNorm().print();  // or tf.euclideanNorm(x)
 * ```
 *
 * @param x The input array.
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. euclideanNorm(x) is equivalent
 * to euclideanNorm(x.reshape([-1])). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $8f1e71a0619d5cde$var$euclideanNorm_(x, axis = null, keepDims = false) {
    return (0, $d5YNe.norm)(x, 'euclidean', axis, keepDims);
}
const $8f1e71a0619d5cde$export$38d83b337e7c2edd = /* @__PURE__ */ (0, $6afhl.op)({
    euclideanNorm_: $8f1e71a0619d5cde$var$euclideanNorm_
});

});
parcelRegister("d5YNe", function(module, exports) {

$parcel$export(module.exports, "norm", function () { return $988ae63c9852d145$export$1991ecd29cc92c6b; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $57D4R = parcelRequire("57D4R");

var $bC6Qi = parcelRequire("bC6Qi");

var $9GR6N = parcelRequire("9GR6N");

var $1KFHq = parcelRequire("1KFHq");

var $6afhl = parcelRequire("6afhl");

var $eCViQ = parcelRequire("eCViQ");

var $8nMOl = parcelRequire("8nMOl");

var $7hONX = parcelRequire("7hONX");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $fPnAL = parcelRequire("fPnAL");
/**
 * Computes the norm of scalar, vectors, and matrices.
 * This function can compute several different vector norms (the 1-norm, the
 * Euclidean or 2-norm, the inf-norm, and in general the p-norm for p > 0)
 * and matrix norms (Frobenius, 1-norm, and inf-norm).
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.norm().print();  // or tf.norm(x)
 * ```
 *
 * @param x The input array.
 * @param ord Optional. Order of the norm. Supported norm types are
 * following:
 *
 *  | ord        | norm for matrices         | norm for vectors
 *  |------------|---------------------------|---------------------
 *  |'euclidean' |Frobenius norm             |2-norm
 *  |'fro'       |Frobenius norm	           |
 *  |Infinity    |max(sum(abs(x), axis=1))   |max(abs(x))
 *  |-Infinity   |min(sum(abs(x), axis=1))   |min(abs(x))
 *  |1           |max(sum(abs(x), axis=0))   |sum(abs(x))
 *  |2           |                           |sum(abs(x)^2)^(1/2)
 *
 * @param axis Optional. If axis is null (the default), the input is
 * considered a vector and a single vector norm is computed over the entire
 * set of values in the Tensor, i.e. norm(x, ord) is equivalent
 * to norm(x.reshape([-1]), ord). If axis is an integer, the input
 * is considered a batch of vectors, and axis determines the axis in x
 * over which to compute vector norms. If axis is a 2-tuple of integer it is
 * considered a batch of matrices and axis determines the axes in NDArray
 * over which to compute a matrix norm.
 * @param keepDims Optional. If true, the norm has the same dimensionality
 * as the input.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $988ae63c9852d145$var$norm_(x, ord = 'euclidean', axis = null, keepDims = false) {
    x = (0, $x4eLk.convertToTensor)(x, 'x', 'norm');
    const norm = $988ae63c9852d145$var$normImpl(x, ord, axis);
    let keepDimsShape = norm.shape;
    if (keepDims) {
        const axes = (0, $eOiOM.parseAxisParam)(axis, x.shape);
        keepDimsShape = $bC6Qi.expandShapeToKeepDim(norm.shape, axes);
    }
    return (0, $8nMOl.reshape)(norm, keepDimsShape);
}
function $988ae63c9852d145$var$normImpl(x, p, axis = null) {
    if (x.rank === 0) return (0, $57D4R.abs)(x);
    // consider vector when no axis is specified
    if (x.rank !== 1 && axis === null) return $988ae63c9852d145$var$normImpl((0, $8nMOl.reshape)(x, [
        -1
    ]), p, axis);
    // vector
    if (x.rank === 1 || typeof axis === 'number' || Array.isArray(axis) && axis.length === 1) {
        if (p === 1) return (0, $fPnAL.sum)((0, $57D4R.abs)(x), axis);
        if (p === Infinity) return (0, $9GR6N.max)((0, $57D4R.abs)(x), axis);
        if (p === -Infinity) return (0, $1KFHq.min)((0, $57D4R.abs)(x), axis);
        if (p === 'euclidean' || p === 2) // norm(x, 2) = sum(abs(xi) ^ 2) ^ 1/2
        return (0, $g3lev.sqrt)((0, $fPnAL.sum)((0, $eCViQ.pow)((0, $57D4R.abs)(x), (0, $7hONX.scalar)(2, 'int32')), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    // matrix (assumption axis[0] < axis[1])
    if (Array.isArray(axis) && axis.length === 2) {
        if (p === 1) return (0, $9GR6N.max)((0, $fPnAL.sum)((0, $57D4R.abs)(x), axis[0]), axis[1] - 1);
        if (p === Infinity) return (0, $9GR6N.max)((0, $fPnAL.sum)((0, $57D4R.abs)(x), axis[1]), axis[0]);
        if (p === -Infinity) return (0, $1KFHq.min)((0, $fPnAL.sum)((0, $57D4R.abs)(x), axis[1]), axis[0]);
        if (p === 'fro' || p === 'euclidean') // norm(x) = sqrt(sum(pow(x, 2)))
        return (0, $g3lev.sqrt)((0, $fPnAL.sum)((0, $5MB84.square)(x), axis));
        throw new Error(`Error in norm: invalid ord value: ${p}`);
    }
    throw new Error(`Error in norm: invalid axis: ${axis}`);
}
const $988ae63c9852d145$export$1991ecd29cc92c6b = /* @__PURE__ */ (0, $6afhl.op)({
    norm_: $988ae63c9852d145$var$norm_
});

});
parcelRegister("9GR6N", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $70e13b8ab4b69061$export$8960430cfd85939f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the maximum of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.max().print();  // or tf.max(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.max(axis).print();  // or tf.max(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $70e13b8ab4b69061$var$max_(x, axis = null, keepDims = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'max');
    const inputs = {
        x: $x
    };
    const attrs = {
        reductionIndices: axis,
        keepDims: keepDims
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Max), inputs, attrs);
}
const $70e13b8ab4b69061$export$8960430cfd85939f = /* @__PURE__ */ (0, $6afhl.op)({
    max_: $70e13b8ab4b69061$var$max_
});

});

parcelRegister("1KFHq", function(module, exports) {

$parcel$export(module.exports, "min", function () { return $146a6efb66382ac2$export$96ec731ed4dcb222; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the minimum value from the input.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axes`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axes` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.min().print();  // or tf.min(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.min(axis).print();  // or tf.min(x, axis)
 * ```
 *
 * @param x The input Tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $146a6efb66382ac2$var$min_(x, axis = null, keepDims = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'min');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Min), inputs, attrs);
}
const $146a6efb66382ac2$export$96ec731ed4dcb222 = /* @__PURE__ */ (0, $6afhl.op)({
    min_: $146a6efb66382ac2$var$min_
});

});



parcelRegister("9rV09", function(module, exports) {

$parcel$export(module.exports, "expm1", function () { return $6e12d9fc04f7d18a$export$b6c0a80d46d3391d; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes exponential of the input `tf.Tensor` minus one element-wise.
 * `e ^ x - 1`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, -3]);
 *
 * x.expm1().print();  // or tf.expm1(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $6e12d9fc04f7d18a$var$expm1_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'expm1');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Expm1), inputs);
}
const $6e12d9fc04f7d18a$export$b6c0a80d46d3391d = /* @__PURE__ */ (0, $6afhl.op)({
    expm1_: $6e12d9fc04f7d18a$var$expm1_
});

});

parcelRegister("iXiJh", function(module, exports) {

$parcel$export(module.exports, "imag", function () { return $dccc43f3fe6f6869$export$d78fab5778ab392b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the imaginary part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the imaginary part of each element in input considered as a complex number.
 * If input is real, a tensor of all zeros is returned.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.imag(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $dccc43f3fe6f6869$var$imag_(input) {
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'imag');
    const inputs = {
        input: $input
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Imag), inputs);
}
const $dccc43f3fe6f6869$export$d78fab5778ab392b = /* @__PURE__ */ (0, $6afhl.op)({
    imag_: $dccc43f3fe6f6869$var$imag_
});

});

parcelRegister("gfUfq", function(module, exports) {

$parcel$export(module.exports, "isFinite", function () { return $bd59adb3bd880289$export$65f0b13f2f82375a; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns which elements of x are finite.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isFinite().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $bd59adb3bd880289$var$isFinite_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'isFinite');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.IsFinite), inputs);
}
const $bd59adb3bd880289$export$65f0b13f2f82375a = /* @__PURE__ */ (0, $6afhl.op)({
    isFinite_: $bd59adb3bd880289$var$isFinite_
});

});

parcelRegister("cJ2yP", function(module, exports) {

$parcel$export(module.exports, "isInf", function () { return $943bac7f10abd61e$export$e5d3415c656f7096; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns which elements of x are Infinity or -Infinity.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isInf().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $943bac7f10abd61e$var$isInf_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'isInf');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.IsInf), inputs);
}
const $943bac7f10abd61e$export$e5d3415c656f7096 = /* @__PURE__ */ (0, $6afhl.op)({
    isInf_: $943bac7f10abd61e$var$isInf_
});

});

parcelRegister("gZu1q", function(module, exports) {

$parcel$export(module.exports, "isNaN", function () { return $0331300692795368$export$c9f5652083b8129d; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns which elements of x are NaN.
 *
 * ```js
 * const x = tf.tensor1d([NaN, Infinity, -Infinity, 0, 1]);
 *
 * x.isNaN().print();  // or tf.isNaN(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0331300692795368$var$isNaN_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'isNaN');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.IsNan), inputs);
}
const $0331300692795368$export$c9f5652083b8129d = /* @__PURE__ */ (0, $6afhl.op)({
    isNaN_: $0331300692795368$var$isNaN_
});

});

parcelRegister("lWf8B", function(module, exports) {

$parcel$export(module.exports, "less", function () { return $ff8ac1c9032610da$export$bb1a638da8ad190f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of (a < b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.less(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $ff8ac1c9032610da$var$less_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'less', 'string_or_numeric');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'less', 'string_or_numeric');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Less), inputs);
}
const $ff8ac1c9032610da$export$bb1a638da8ad190f = /* @__PURE__ */ (0, $6afhl.op)({
    less_: $ff8ac1c9032610da$var$less_
});

});

parcelRegister("bvcEy", function(module, exports) {

$parcel$export(module.exports, "lessEqual", function () { return $85fc67945f1b3cf4$export$c24ad19a692bb92; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of (a <= b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([2, 2, 2]);
 *
 * a.lessEqual(b).print();
 * ```
 *
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $85fc67945f1b3cf4$var$lessEqual_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'lessEqual', 'string_or_numeric');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'lessEqual', 'string_or_numeric');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.LessEqual), inputs);
}
const $85fc67945f1b3cf4$export$c24ad19a692bb92 = /* @__PURE__ */ (0, $6afhl.op)({
    lessEqual_: $85fc67945f1b3cf4$var$lessEqual_
});

});

parcelRegister("5qjef", function(module, exports) {

$parcel$export(module.exports, "linspace", function () { return $3f2e4be7df9607e6$export$71255ea3f595147c; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");
function $3f2e4be7df9607e6$export$71255ea3f595147c(start, stop, num) {
    if (num <= 0) throw new Error('The number of values should be positive.');
    const attrs = {
        start: start,
        stop: stop,
        num: num
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.LinSpace), {}, attrs);
}

});

parcelRegister("iTgel", function(module, exports) {

$parcel$export(module.exports, "localResponseNormalization", function () { return $dc09f4133f5823b4$export$b6127073705f6321; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Normalizes the activation of a local neighborhood across or within
 * channels.
 *
 * @param x The input tensor. The 4-D input tensor is treated as a 3-D array
 *     of 1D vectors (along the last dimension), and each vector is
 *     normalized independently.
 * @param depthRadius The number of adjacent channels in the 1D normalization
 *     window.
 * @param bias A constant bias term for the basis.
 * @param alpha A scale factor, usually positive.
 * @param beta An exponent.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $dc09f4133f5823b4$var$localResponseNormalization_(x, depthRadius = 5, bias = 1, alpha = 1, beta = 0.5) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'localResponseNormalization');
    $eOiOM.assert($x.rank === 4 || $x.rank === 3, ()=>`Error in localResponseNormalization: x must be rank 3 or 4 but got
               rank ${$x.rank}.`);
    $eOiOM.assert($eOiOM.isInt(depthRadius), ()=>`Error in localResponseNormalization: depthRadius must be an ` + `integer but got depthRadius ${depthRadius}.`);
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    const inputs = {
        x: x4D
    };
    const attrs = {
        depthRadius: depthRadius,
        bias: bias,
        alpha: alpha,
        beta: beta
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.LRN), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    else return res;
}
const $dc09f4133f5823b4$export$b6127073705f6321 = /* @__PURE__ */ (0, $6afhl.op)({
    localResponseNormalization_: $dc09f4133f5823b4$var$localResponseNormalization_
});

});

parcelRegister("1gLFX", function(module, exports) {

$parcel$export(module.exports, "log", function () { return $0ecc44765a1f94a4$export$bef1f36f5486a6a3; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes natural logarithm of the input `tf.Tensor` element-wise: `ln(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E]);
 *
 * x.log().print();  // or tf.log(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0ecc44765a1f94a4$var$log_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'log', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Log), inputs);
}
const $0ecc44765a1f94a4$export$bef1f36f5486a6a3 = /* @__PURE__ */ (0, $6afhl.op)({
    log_: $0ecc44765a1f94a4$var$log_
});

});

parcelRegister("ifd1X", function(module, exports) {

$parcel$export(module.exports, "log1p", function () { return $d483bc51b0edb281$export$144dcf16adfb9698; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes natural logarithm of the input `tf.Tensor` plus one
 * element-wise: `ln(1 + x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, Math.E - 1]);
 *
 * x.log1p().print();  // or tf.log1p(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $d483bc51b0edb281$var$log1p_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'log1p');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Log1p), inputs);
}
const $d483bc51b0edb281$export$144dcf16adfb9698 = /* @__PURE__ */ (0, $6afhl.op)({
    log1p_: $d483bc51b0edb281$var$log1p_
});

});

parcelRegister("bBSSu", function(module, exports) {

$parcel$export(module.exports, "logSigmoid", function () { return $022e6a3180d36fa6$export$9e0b8feed033df47; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1Npyr = parcelRequire("1Npyr");

var $x4eLk = parcelRequire("x4eLk");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $6afhl = parcelRequire("6afhl");

var $dzpno = parcelRequire("dzpno");

var $11Nx5 = parcelRequire("11Nx5");
/**
 * Computes log sigmoid of the input `tf.Tensor` element-wise:
 * `logSigmoid(x)`. For numerical stability, we use `-tf.softplus(-x)`.
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.logSigmoid().print();  // or tf.logSigmoid(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $022e6a3180d36fa6$var$logSigmoid_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'logSigmoid');
    // Use a custom gradient to maintain previous implementation.
    // There is no LogSigmoid kernel in TF so we can't use engine.runKernel
    // directly
    const customOp = (0, $1Npyr.customGrad)((x)=>{
        // TODO(yassogba) we can remove the chained softplus call here only
        // after backends have modualrized softplus at which point we can call
        // engine runKernel(..., Sotfplus, ...) directly.
        const value = (0, $jMlCE.neg)((0, $11Nx5.softplus)((0, $jMlCE.neg)(x)));
        const gradFunc = (dy)=>{
            const derX = (0, $5hAos.mul)(dy, (0, $dzpno.sigmoid)((0, $jMlCE.neg)(x)));
            return derX;
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($x);
}
const $022e6a3180d36fa6$export$9e0b8feed033df47 = /* @__PURE__ */ (0, $6afhl.op)({
    logSigmoid_: $022e6a3180d36fa6$var$logSigmoid_
});

});
parcelRegister("jMlCE", function(module, exports) {

$parcel$export(module.exports, "neg", function () { return $e66345cae9611c17$export$d9493ff0dfa0fdd5; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes `-1 * x` element-wise.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, -2, 0], [2, 2]);
 *
 * x.neg().print();  // or tf.neg(x)
 * ```
 *
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $e66345cae9611c17$var$neg_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'neg');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Neg), inputs);
}
const $e66345cae9611c17$export$d9493ff0dfa0fdd5 = /* @__PURE__ */ (0, $6afhl.op)({
    neg_: $e66345cae9611c17$var$neg_
});

});

parcelRegister("11Nx5", function(module, exports) {

$parcel$export(module.exports, "softplus", function () { return $0bfc4e9628bb3720$export$76aa560a8c2b0055; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes softplus of the input `tf.Tensor` element-wise: `log(exp(x) + 1)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.softplus().print();  // or tf.softplus(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $0bfc4e9628bb3720$var$softplus_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'softplus');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Softplus), inputs);
}
const $0bfc4e9628bb3720$export$76aa560a8c2b0055 = /* @__PURE__ */ (0, $6afhl.op)({
    softplus_: $0bfc4e9628bb3720$var$softplus_
});

});


parcelRegister("2vk2B", function(module, exports) {

$parcel$export(module.exports, "logSoftmax", function () { return $1d2e05be2e1a0307$export$676379a046a2e437; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1Npyr = parcelRequire("1Npyr");

var $x4eLk = parcelRequire("x4eLk");

var $fxiHg = parcelRequire("fxiHg");

var $1lCoz = parcelRequire("1lCoz");

var $1gLFX = parcelRequire("1gLFX");

var $9GR6N = parcelRequire("9GR6N");

var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");
/**
 * Computes the log softmax.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.logSoftmax().print();  // or tf.logSoftmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param axis The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $1d2e05be2e1a0307$var$logSoftmax_(logits, axis = -1) {
    const $logits = (0, $x4eLk.convertToTensor)(logits, 'logits', 'logSoftmax');
    if (axis === -1) axis = $logits.rank - 1;
    if (axis !== $logits.rank - 1) throw Error('Log Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and axis was ${axis}`);
    // const forward: ForwardFunc<Tensor> = (backend, save) => {
    //   const keepDims = true;
    //   const xMax = max(logits, axis, true);
    //   const shifted = sub(logits, xMax);
    //   const value =
    //       sub(cast(shifted, 'float32'), log(sum(exp(shifted), axis,
    //       keepDims)));
    //   save([value]);
    //   return value;
    // };
    // Use a custom gradient for numerical stability.
    const customOp = (0, $1Npyr.customGrad)((logits, save)=>{
        const keepDims = true;
        const xMax = (0, $9GR6N.max)(logits, axis, true);
        const shifted = (0, $5jGN9.sub)(logits, xMax);
        const value = (0, $5jGN9.sub)((0, $fxiHg.cast)(shifted, 'float32'), (0, $1gLFX.log)((0, $fPnAL.sum)((0, $1lCoz.exp)(shifted), axis, keepDims)));
        save([
            value
        ]);
        const gradFunc = (dy, saved)=>{
            const [value] = saved;
            const keepDims = true;
            const softmax = (0, $1lCoz.exp)(value);
            return (0, $5jGN9.sub)(dy, (0, $5hAos.mul)((0, $fPnAL.sum)(dy, axis, keepDims), softmax));
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp($logits);
// TODO Use Engine.runKernel when CPU/WebGL/WASM backends implement this.
// const inputs: LogSoftmaxInputs = {logits: $logits};
// const attrs: LogSoftmaxAttrs = {axis};
// return ENGINE.runKernel(
//            LogSoftmax, inputs as unknown as NamedTensorMap,
//            attrs as unknown as NamedAttrMap);
}
const $1d2e05be2e1a0307$export$676379a046a2e437 = /* @__PURE__ */ (0, $6afhl.op)({
    logSoftmax_: $1d2e05be2e1a0307$var$logSoftmax_
});

});

parcelRegister("1UrMu", function(module, exports) {

$parcel$export(module.exports, "logSumExp", function () { return $164092287a86141e$export$e20aca1e89397787; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6Ab5n = parcelRequire("6Ab5n");

var $bC6Qi = parcelRequire("bC6Qi");

var $1lCoz = parcelRequire("1lCoz");

var $1gLFX = parcelRequire("1gLFX");

var $9GR6N = parcelRequire("9GR6N");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");
/**
 * Computes the log(sum(exp(elements across the reduction dimensions))).
 *
 * Reduces the input along the dimensions given in `axis`. Unless `keepDims`
 * is true, the rank of the array is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and an array with a
 * single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.logSumExp().print();  // or tf.logSumExp(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.logSumExp(axis).print();  // or tf.logSumExp(a, axis)
 * ```
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. If null (the default),
 *     reduces all dimensions.
 * @param keepDims If true, retains reduced dimensions with length
 *     of 1. Defaults to false.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $164092287a86141e$var$logSumExp_(x, axis = null, keepDims = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'logSumExp');
    const axes = (0, $eOiOM.parseAxisParam)(axis, $x.shape);
    const xMax = (0, $9GR6N.max)($x, axes, true);
    const a = (0, $5jGN9.sub)($x, xMax);
    const b = (0, $1lCoz.exp)(a);
    const c = (0, $fPnAL.sum)(b, axes);
    const d = (0, $1gLFX.log)(c);
    const res = (0, $6Ab5n.add)((0, $8nMOl.reshape)(xMax, d.shape), d);
    if (keepDims) {
        const newShape = (0, $bC6Qi.expandShapeToKeepDim)(res.shape, axes);
        return (0, $8nMOl.reshape)(res, newShape);
    }
    return res;
}
const $164092287a86141e$export$e20aca1e89397787 = /* @__PURE__ */ (0, $6afhl.op)({
    logSumExp_: $164092287a86141e$var$logSumExp_
});

});

parcelRegister("gXTMu", function(module, exports) {

$parcel$export(module.exports, "logicalAnd", function () { return $032ff55edf38e8e0$export$db5dd0ef9d505f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of `a AND b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalAnd(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $032ff55edf38e8e0$var$logicalAnd_(a, b) {
    const $a = (0, $x4eLk.convertToTensor)(a, 'a', 'logicalAnd', 'bool');
    const $b = (0, $x4eLk.convertToTensor)(b, 'b', 'logicalAnd', 'bool');
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.LogicalAnd), inputs);
}
const $032ff55edf38e8e0$export$db5dd0ef9d505f = /* @__PURE__ */ (0, $6afhl.op)({
    logicalAnd_: $032ff55edf38e8e0$var$logicalAnd_
});

});

parcelRegister("4DHH8", function(module, exports) {

$parcel$export(module.exports, "logicalNot", function () { return $360cb2d0823f7295$export$c836ff7b605b1617; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of `NOT x` element-wise.
 *
 * ```js
 * const a = tf.tensor1d([false, true], 'bool');
 *
 * a.logicalNot().print();
 * ```
 *
 * @param x The input tensor. Must be of dtype 'bool'.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $360cb2d0823f7295$var$logicalNot_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'logicalNot', 'bool');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.LogicalNot), inputs);
}
const $360cb2d0823f7295$export$c836ff7b605b1617 = /* @__PURE__ */ (0, $6afhl.op)({
    logicalNot_: $360cb2d0823f7295$var$logicalNot_
});

});

parcelRegister("jc4ZI", function(module, exports) {

$parcel$export(module.exports, "logicalOr", function () { return $df930314c7da0f27$export$e2a73975983cadd8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of `a OR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalOr(b).print();
 * ```
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $df930314c7da0f27$var$logicalOr_(a, b) {
    const $a = (0, $x4eLk.convertToTensor)(a, 'a', 'logicalOr', 'bool');
    const $b = (0, $x4eLk.convertToTensor)(b, 'b', 'logicalOr', 'bool');
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.LogicalOr), inputs);
}
const $df930314c7da0f27$export$e2a73975983cadd8 = /* @__PURE__ */ (0, $6afhl.op)({
    logicalOr_: $df930314c7da0f27$var$logicalOr_
});

});

parcelRegister("dqaBh", function(module, exports) {

$parcel$export(module.exports, "logicalXor", function () { return $9c55ed0dc5f45789$export$20f90b62b30dbaef; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $gXTMu = parcelRequire("gXTMu");

var $4DHH8 = parcelRequire("4DHH8");

var $jc4ZI = parcelRequire("jc4ZI");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of `a XOR b` element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([false, false, true, true], 'bool');
 * const b = tf.tensor1d([false, true, false, true], 'bool');
 *
 * a.logicalXor(b).print();
 * ```
 *
 * @param a The first input tensor. Must be of dtype bool.
 * @param b The second input tensor. Must be of dtype bool.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $9c55ed0dc5f45789$var$logicalXor_(a, b) {
    const $a = (0, $x4eLk.convertToTensor)(a, 'a', 'logicalXor', 'bool');
    const $b = (0, $x4eLk.convertToTensor)(b, 'b', 'logicalXor', 'bool');
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    // x ^ y = (x | y) & ~(x & y)
    return (0, $gXTMu.logicalAnd)((0, $jc4ZI.logicalOr)(a, b), (0, $4DHH8.logicalNot)((0, $gXTMu.logicalAnd)(a, b)));
}
const $9c55ed0dc5f45789$export$20f90b62b30dbaef = /* @__PURE__ */ (0, $6afhl.op)({
    logicalXor_: $9c55ed0dc5f45789$var$logicalXor_
});

});

parcelRegister("dzP95", function(module, exports) {

$parcel$export(module.exports, "lowerBound", function () { return $9e2637ad17ee69b5$export$450bb71ab40039dc; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $V8cuc = parcelRequire("V8cuc");
function $9e2637ad17ee69b5$export$450bb71ab40039dc(sortedSequence, values) {
    return (0, $V8cuc.searchSorted)(sortedSequence, values, 'left');
}

});
parcelRegister("V8cuc", function(module, exports) {

$parcel$export(module.exports, "searchSorted", function () { return $0abbaf6972027c82$export$56fad8d65b0adbdd; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
const $0abbaf6972027c82$var$INT32_MAX = 2147483648;
/**
 * Searches for where a value would go in a sorted sequence.
 *
 * This is not a method for checking containment (like javascript in).
 *
 * The typical use case for this operation is "binning", "bucketing", or
 * "discretizing". The values are assigned to bucket-indices based on the edges
 * listed in 'sortedSequence'. This operation returns the bucket-index for each
 * value.
 *
 * The side argument controls which index is returned if a value lands exactly
 * on an edge.
 *
 * The axis is not settable for this operation. It always operates on the
 * innermost dimension (axis=-1). The operation will accept any number of outer
 * dimensions.
 *
 * Note: This operation assumes that 'sortedSequence' is sorted along the
 * innermost axis, maybe using 'sort(..., axis=-1)'. If the sequence is not
 * sorted no error is raised and the content of the returned tensor is not well
 * defined.
 *
 * ```js
 * const edges = tf.tensor1d([-1, 3.3, 9.1, 10.0]);
 * let values = tf.tensor1d([0.0, 4.1, 12.0]);
 * const result1 = tf.searchSorted(edges, values, 'left');
 * result1.print(); // [1, 2, 4]
 *
 * const seq = tf.tensor1d([0, 3, 9, 10, 10]);
 * values = tf.tensor1d([0, 4, 10]);
 * const result2 = tf.searchSorted(seq, values, 'left');
 * result2.print(); // [0, 2, 3]
 * const result3 = tf.searchSorted(seq, values, 'right');
 * result3.print(); // [1, 2, 5]
 *
 * const sortedSequence = tf.tensor2d([[0., 3., 8., 9., 10.],
 *                                     [1., 2., 3., 4., 5.]]);
 * values = tf.tensor2d([[9.8, 2.1, 4.3],
 *                       [0.1, 6.6, 4.5, ]]);
 * const result4 = tf.searchSorted(sortedSequence, values, 'left');
 * result4.print(); // [[4, 1, 2], [0, 5, 4]]
 * ```
 * @param sortedSequence: N-D. Sorted sequence.
 * @param values: N-D. Search values.
 * @param side: 'left'|'right'. Defaults to 'left'. 'left' corresponds to lower
 *     bound and 'right' to upper bound.
 * @return An N-D int32 tensor the size of values containing the result of
 *     applying either lower bound or upper bound (depending on side) to each
 *     value. The result is not a global index to the entire Tensor, but the
 *     index in the last dimension.
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $0abbaf6972027c82$var$searchSorted_(sortedSequence, values, side = 'left') {
    const $sortedSequence = (0, $x4eLk.convertToTensor)(sortedSequence, 'sortedSequence', 'searchSorted');
    const $values = (0, $x4eLk.convertToTensor)(values, 'values', 'searchSorted');
    const sequenceSize = $sortedSequence.shape[$sortedSequence.shape.length - 1];
    const valuesSize = $values.shape[$values.shape.length - 1];
    const $sortedSequence2D = (0, $8nMOl.reshape)($sortedSequence, [
        -1,
        sequenceSize
    ]);
    const $values2D = (0, $8nMOl.reshape)($values, [
        -1,
        valuesSize
    ]);
    if ($sortedSequence2D.rank < 2) throw new Error(`Sorted input argument must be at least 2-dimensional`);
    if ($sortedSequence2D.shape[0] !== $values2D.shape[0]) throw new Error(`Leading dimension of 'sortedSequence' and 'values' must match.`);
    if ((0, $eOiOM.sizeFromShape)($values2D.shape) >= $0abbaf6972027c82$var$INT32_MAX) throw new Error(`values tensor size must less than ${$0abbaf6972027c82$var$INT32_MAX}`);
    if ($sortedSequence2D.shape[1] >= $0abbaf6972027c82$var$INT32_MAX) throw new Error(`trailing dim_size must less than ${$0abbaf6972027c82$var$INT32_MAX} for int32 output type, was ${$sortedSequence2D.shape[1]}`);
    const inputs = {
        sortedSequence: $sortedSequence2D,
        values: $values2D
    };
    const attrs = {
        side: side
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SearchSorted), inputs, attrs);
}
const $0abbaf6972027c82$export$56fad8d65b0adbdd = /* @__PURE__ */ (0, $6afhl.op)({
    searchSorted_: $0abbaf6972027c82$var$searchSorted_
});

});


parcelRegister("kHqOQ", function(module, exports) {

$parcel$export(module.exports, "maxPool", function () { return $f11ca084425ab14e$export$e4aadcf115842782; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the 2D max pooling of an image.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilations` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $f11ca084425ab14e$var$maxPool_(x, filterSize, strides, pad, dimRoundingMode) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'maxPool');
    const dilations = 1;
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $eOiOM.assert(x4D.rank === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x4D.rank}.`);
    $eOiOM.assert($g0V2M.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    $g0V2M.checkPadOnDimRoundingMode('maxPool', pad, dimRoundingMode);
    const inputs = {
        x: x4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.MaxPool), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $f11ca084425ab14e$export$e4aadcf115842782 = /* @__PURE__ */ (0, $6afhl.op)({
    maxPool_: $f11ca084425ab14e$var$maxPool_
});

});

parcelRegister("hG9Ff", function(module, exports) {

$parcel$export(module.exports, "maxPool3d", function () { return $cdeddb0cc9910db9$export$822a6e53be1125f9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the 3D max pooling.
 *
 * ```js
 * const x = tf.tensor5d([1, 2, 3, 4, 5, 6, 7, 8], [1, 2, 2, 2, 1]);
 * const result = tf.maxPool3d(x, 2, 1, 'valid');
 * result.print();
 * ```
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     `[batch, depth, height, width, inChannels]`.
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     If `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`.
 *     If `strides` is a single number,
 *     then `strideDepth == strideHeight == strideWidth`.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1*1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $cdeddb0cc9910db9$var$maxPool3d_(x, filterSize = [
    1,
    1,
    1
], strides, pad, dimRoundingMode, dataFormat = 'NDHWC') {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'maxPool3d');
    let x5D = $x;
    let reshapedTo5D = false;
    if ($x.rank === 4) {
        reshapedTo5D = true;
        x5D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2],
            $x.shape[3]
        ]);
    }
    $eOiOM.assert(x5D.rank === 5, ()=>`Error in maxPool3d: x must be rank 5 but got rank ${x5D.rank}.`);
    $eOiOM.assert(dataFormat === 'NDHWC', ()=>`Error in maxPool3d: Only NDHWC is currently supported, ` + `but got dataFormat of ${dataFormat}`);
    (0, $g0V2M.checkPadOnDimRoundingMode)('maxPool3d', pad, dimRoundingMode);
    const inputs = {
        x: x5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode,
        dataFormat: dataFormat
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.MaxPool3D), inputs, attrs);
    if (reshapedTo5D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $cdeddb0cc9910db9$export$822a6e53be1125f9 = /* @__PURE__ */ (0, $6afhl.op)({
    maxPool3d_: $cdeddb0cc9910db9$var$maxPool3d_
});

});

parcelRegister("3oGWc", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmax", function () { return $2794eb83a64e2151$export$3d8b1b819d23351e; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the 2D max pooling of an image with Argmax index.
 * The indices in argmax are flattened, so that a maximum value at position `[b,
 * y, x, c]` becomes flattened index: `(y * width + x) * channels + c` if
 * include_batch_in_index is False; `((b * height + y) * width + x) * channels
 * +c` if include_batch_in_index is True.
 *
 * The indices returned are always in `[0, height) x [0, width)` before
 * flattening.
 *
 * @param x The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dataFormat An optional string from: "NDHWC", "NCDHW". Defaults to
 *     "NDHWC". Specify the data format of the input and output data. With the
 *     default format "NDHWC", the data is stored in the order of: [batch,
 *     depth, height, width, channels]. Only "NDHWC" is currently supported.
 * @param pad The type of padding algorithm.
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param includeBatchIndex Defaults to False. Whether to include batch
 *    dimension in flattened index of argmax.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $2794eb83a64e2151$var$maxPoolWithArgmax_(x, filterSize, strides, pad, includeBatchInIndex = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'maxPoolWithArgmax');
    const inputs = {
        x: $x
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        includeBatchInIndex: includeBatchInIndex
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.MaxPoolWithArgmax), inputs, attrs);
    return {
        result: result[0],
        indexes: result[1]
    };
}
const $2794eb83a64e2151$export$3d8b1b819d23351e = /* @__PURE__ */ (0, $6afhl.op)({
    maxPoolWithArgmax_: $2794eb83a64e2151$var$maxPoolWithArgmax_
});

});

parcelRegister("3TgHP", function(module, exports) {

$parcel$export(module.exports, "mean", function () { return $2d53779f629200a3$export$1ce691f85baaa52; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the mean of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces `x` along the dimensions given in `axis`. Unless `keepDims` is
 * true, the rank of the `tf.Tensor` is reduced by 1 for each entry in `axis`.
 * If `keepDims` is true, the reduced dimensions are retained with length 1.
 * If `axis` has no entries, all dimensions are reduced, and a `tf.Tensor` with
 * a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.mean().print();  // or tf.mean(a)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.mean(axis).print();  // or tf.mean(x, axis)
 * ```
 *
 * @param x The input tensor.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $2d53779f629200a3$var$mean_(x, axis = null, keepDims = false) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'mean');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Mean), inputs, attrs);
}
const $2d53779f629200a3$export$1ce691f85baaa52 = /* @__PURE__ */ (0, $6afhl.op)({
    mean_: $2d53779f629200a3$var$mean_
});

});

parcelRegister("3vCK6", function(module, exports) {

$parcel$export(module.exports, "meshgrid", function () { return $28e251d2d9ba15a6$export$2fab8e71e5fefc1a; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $VLFo8 = parcelRequire("VLFo8");

var $K2k22 = parcelRequire("K2k22");

var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");
function $28e251d2d9ba15a6$export$2fab8e71e5fefc1a(x, y, { indexing: indexing = 'xy' } = {}) {
    if (indexing !== 'xy' && indexing !== 'ij') throw new TypeError(`${indexing} is not a valid third argument to meshgrid`);
    if (x === undefined) return [];
    let $x = (0, $x4eLk.convertToTensor)(x, 'x', 'meshgrid', x instanceof (0, $3pVUH.Tensor) ? x.dtype : 'float32');
    if (y === undefined) return [
        $x
    ];
    let $y = (0, $x4eLk.convertToTensor)(y, 'y', 'meshgrid', y instanceof (0, $3pVUH.Tensor) ? y.dtype : 'float32');
    const w = (0, $eOiOM.sizeFromShape)($x.shape);
    const h = (0, $eOiOM.sizeFromShape)($y.shape);
    if (indexing === 'xy') {
        $x = (0, $8nMOl.reshape)($x, [
            1,
            -1
        ]);
        $y = (0, $8nMOl.reshape)($y, [
            -1,
            1
        ]);
        return [
            (0, $VLFo8.matMul)((0, $K2k22.ones)([
                h,
                1
            ], $x.dtype), $x),
            (0, $VLFo8.matMul)($y, (0, $K2k22.ones)([
                1,
                w
            ], $y.dtype))
        ];
    }
    $x = (0, $8nMOl.reshape)($x, [
        -1,
        1
    ]);
    $y = (0, $8nMOl.reshape)($y, [
        1,
        -1
    ]);
    return [
        (0, $VLFo8.matMul)($x, (0, $K2k22.ones)([
            1,
            h
        ], $x.dtype)),
        (0, $VLFo8.matMul)((0, $K2k22.ones)([
            w,
            1
        ], $y.dtype), $y)
    ];
}

});
parcelRegister("K2k22", function(module, exports) {

$parcel$export(module.exports, "ones", function () { return $08a6191ccdba60b0$export$21041dee6b8001b0; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $eOiOM = parcelRequire("eOiOM");

var $eOiOM = parcelRequire("eOiOM");

var $dyCpE = parcelRequire("dyCpE");

var $lxzgt = parcelRequire("lxzgt");
function $08a6191ccdba60b0$export$21041dee6b8001b0(shape, dtype = 'float32') {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    if (dtype === 'complex64') {
        const real = $08a6191ccdba60b0$export$21041dee6b8001b0(shape, 'float32');
        const imag = (0, $lxzgt.zeros)(shape, 'float32');
        return (0, $dyCpE.complex)(real, imag);
    }
    const values = (0, $eOiOM.makeOnesTypedArray)((0, $eOiOM.sizeFromShape)(shape), dtype);
    return (0, $e6Ey6.ENGINE).makeTensor(values, shape, dtype);
}

});
parcelRegister("lxzgt", function(module, exports) {

$parcel$export(module.exports, "zeros", function () { return $fae808e23ab4797e$export$4445a00dafa2633b; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $eOiOM = parcelRequire("eOiOM");

var $dyCpE = parcelRequire("dyCpE");
function $fae808e23ab4797e$export$4445a00dafa2633b(shape, dtype = 'float32') {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    if (dtype === 'complex64') {
        const real = $fae808e23ab4797e$export$4445a00dafa2633b(shape, 'float32');
        const imag = $fae808e23ab4797e$export$4445a00dafa2633b(shape, 'float32');
        return (0, $dyCpE.complex)(real, imag);
    }
    const values = (0, $eOiOM.makeZerosTypedArray)((0, $eOiOM.sizeFromShape)(shape), dtype);
    return (0, $e6Ey6.ENGINE).makeTensor(values, shape, dtype);
}

});



parcelRegister("7es6p", function(module, exports) {

$parcel$export(module.exports, "minimum", function () { return $543fa3c69e238b2b$export$916782c1f0ddb132; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $fxiHg = parcelRequire("fxiHg");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the min of a and b (`a < b ? a : b`) element-wise.
 * Supports broadcasting.
 *
 * We also expose `minimumStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * ```js
 * // Broadcast minimum a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.minimum(b).print();  // or tf.minimum(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $543fa3c69e238b2b$var$minimum_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'minimum');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'minimum');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    if ($a.dtype === 'bool') {
        $a = (0, $fxiHg.cast)($a, 'int32');
        $b = (0, $fxiHg.cast)($b, 'int32');
    }
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Minimum), inputs);
}
const $543fa3c69e238b2b$export$916782c1f0ddb132 = /* @__PURE__ */ (0, $6afhl.op)({
    minimum_: $543fa3c69e238b2b$var$minimum_
});

});

parcelRegister("67dM3", function(module, exports) {

$parcel$export(module.exports, "mirrorPad", function () { return $473e14c41ce0baaf$export$c0b11600e90b86ae; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Pads a `tf.Tensor` using mirror padding.
 *
 * This operation implements the `REFLECT` and `SYMMETRIC` modes of pad.
 *
 * ```js
 * const x = tf.range(0, 9).reshape([1, 1, 3, 3]);
 * x.mirrorPad([[0, 0], [0, 0], [2, 2], [2, 2]], 'reflect').print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * In "reflect" mode, the padded regions do not include the borders,
 * while in "symmetric" mode the padded regions do include the borders.
 * For example, if the input is `[1, 2, 3]` and paddings is `[0, 2]`,
 * then the output is `[1, 2, 3, 2, 1]` in "reflect" mode, and
 * `[1, 2, 3, 3, 2]` in "symmetric" mode.
 * If `mode` is "reflect" then both `paddings[D, 0]` and `paddings[D, 1]`
 * must be no greater than `x.shape[D] - 1`. If mode is "symmetric"
 * then both `paddings[D, 0]` and `paddings[D, 1]` must be no greater than
 * `x.shape[D]`
 * @param mode String to specify padding mode. Can be `'reflect' | 'symmetric'`
 */ /** @doc {heading: 'Tensors', subheading: 'Transformations'} */ function $473e14c41ce0baaf$var$mirrorPad_(x, paddings, mode) {
    $eOiOM.assert(mode === 'reflect' || mode === 'symmetric', ()=>`Invalid mode. Mode must be either reflect or symmetric. ` + `Got ${mode}.`);
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'mirrorPad');
    if ($x.rank === 0) throw new Error("mirrorPad(scalar) is not defined. Pass non-scalar to mirrorPad");
    $eOiOM.assert(paddings.length === $x.rank, ()=>`Padding doesn't match input. Must be ${$x.rank}. ` + `Got ${paddings.length}.`);
    const shapeOffset = mode === 'reflect' ? 1 : 0;
    for(let i = 0; i < $x.rank; i++){
        $eOiOM.assert(paddings[i].length === 2, ()=>`Invalid number of paddings. Must be length of 2 each.`);
        $eOiOM.assert(paddings[i][0] >= 0 && paddings[i][0] <= $x.shape[i] - shapeOffset && paddings[i][1] >= 0 && paddings[i][1] <= $x.shape[i] - shapeOffset, ()=>`Padding in dimension ${i} cannot be greater than or equal ` + `to ${$x.shape[i] - shapeOffset} or less than 0 for input of ` + `shape ${$x.shape}`);
    }
    const attrs = {
        paddings: paddings,
        mode: mode
    };
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.MirrorPad), inputs, attrs);
}
const $473e14c41ce0baaf$export$c0b11600e90b86ae = /* @__PURE__ */ (0, $6afhl.op)({
    mirrorPad_: $473e14c41ce0baaf$var$mirrorPad_
});

});

parcelRegister("2na7s", function(module, exports) {

$parcel$export(module.exports, "mod", function () { return $1ba5943bf75332d6$export$842a2cf37af977e1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the mod of a and b element-wise.
 * `floor(x / y) * y + mod(x, y) = x`
 * Supports broadcasting.
 *
 * We also expose `tf.modStrict` which has the same signature as this op and
 * asserts that `a` and `b` are the same shape (does not broadcast).
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * ```js
 * // Broadcast a mod b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.mod(b).print();  // or tf.mod(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $1ba5943bf75332d6$var$mod_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'mod');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'mod');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Mod), inputs);
}
const $1ba5943bf75332d6$export$842a2cf37af977e1 = /* @__PURE__ */ (0, $6afhl.op)({
    mod_: $1ba5943bf75332d6$var$mod_
});

});

parcelRegister("lImqN", function(module, exports) {

$parcel$export(module.exports, "moments", function () { return $fcef1b64213bf863$export$19ef085469537740; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $bC6Qi = parcelRequire("bC6Qi");

var $fxiHg = parcelRequire("fxiHg");

var $3TgHP = parcelRequire("3TgHP");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");
/**
 * Calculates the mean and variance of `x`. The mean and variance are
 * calculated by aggregating the contents of `x` across `axes`. If `x` is
 * 1-D and `axes = [0]` this is just the mean and variance of a vector.
 *
 * @param x The input tensor.
 * @param axis The dimension(s) along with to compute mean and
 *     variance. By default it reduces all dimensions.
 * @param keepDims If true, the moments have the same dimensionality as the
 *     input.
 * @return An object with two keys: `mean` and `variance`.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $fcef1b64213bf863$var$moments_(x, axis = null, keepDims = false) {
    x = (0, $x4eLk.convertToTensor)(x, 'x', 'moments');
    const axes = (0, $eOiOM.parseAxisParam)(axis, x.shape);
    const xMean = (0, $3TgHP.mean)(x, axes, keepDims);
    let keepDimsShape = xMean.shape;
    if (!keepDims) keepDimsShape = (0, $bC6Qi.expandShapeToKeepDim)(xMean.shape, axes);
    const devSquared = (0, $5MB84.square)((0, $5jGN9.sub)((0, $fxiHg.cast)(x, 'float32'), (0, $8nMOl.reshape)(xMean, keepDimsShape)));
    const variance = (0, $3TgHP.mean)(devSquared, axes, keepDims);
    return {
        mean: xMean,
        variance: variance
    };
}
const $fcef1b64213bf863$export$19ef085469537740 = /* @__PURE__ */ (0, $6afhl.op)({
    moments_: $fcef1b64213bf863$var$moments_
});

});

parcelRegister("f6xls", function(module, exports) {

$parcel$export(module.exports, "multiRNNCell", function () { return $aff1483787ad2e2d$export$cc05b5217b9b924f; });

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the next states and outputs of a stack of LSTMCells.
 *
 * Each cell output is used as input to the next cell.
 *
 * Returns `[cellState, cellOutput]`.
 *
 * Derived from tf.contrib.rn.MultiRNNCell.
 *
 * @param lstmCells Array of LSTMCell functions.
 * @param data The input to the cell.
 * @param c Array of previous cell states.
 * @param h Array of previous cell outputs.
 *
 * @doc {heading: 'Operations', subheading: 'RNN'}
 */ function $aff1483787ad2e2d$var$multiRNNCell_(lstmCells, data, c, h) {
    const $data = (0, $x4eLk.convertToTensor)(data, 'data', 'multiRNNCell');
    const $c = (0, $x4eLk.convertToTensorArray)(c, 'c', 'multiRNNCell');
    const $h = (0, $x4eLk.convertToTensorArray)(h, 'h', 'multiRNNCell');
    let input = $data;
    const newStates = [];
    for(let i = 0; i < lstmCells.length; i++){
        const output = lstmCells[i](input, $c[i], $h[i]);
        newStates.push(output[0]);
        newStates.push(output[1]);
        input = output[1];
    }
    const newC = [];
    const newH = [];
    for(let i = 0; i < newStates.length; i += 2){
        newC.push(newStates[i]);
        newH.push(newStates[i + 1]);
    }
    return [
        newC,
        newH
    ];
}
const $aff1483787ad2e2d$export$cc05b5217b9b924f = /* @__PURE__ */ (0, $6afhl.op)({
    multiRNNCell_: $aff1483787ad2e2d$var$multiRNNCell_
});

});

parcelRegister("yqHIQ", function(module, exports) {

$parcel$export(module.exports, "multinomial", function () { return $0677e3fcfab43479$export$f4d580f3101a1c7e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Creates a `tf.Tensor` with values drawn from a multinomial distribution.
 *
 * ```js
 * const probs = tf.tensor([.75, .25]);
 * tf.multinomial(probs, 3).print();
 * ```
 *
 * @param logits 1D array with unnormalized log-probabilities, or
 *     2D array of shape `[batchSize, numOutcomes]`. See the `normalized`
 *     parameter.
 * @param numSamples Number of samples to draw for each row slice.
 * @param seed The seed number.
 * @param normalized Whether the provided `logits` are normalized true
 *     probabilities (sum to 1). Defaults to false.
 * @return 1D array of shape `[numSamples]`, or 2D array of shape
 *     `[batchSize, numSamples]`, depending on the rank of the input.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $0677e3fcfab43479$var$multinomial_(logits, numSamples, seed, normalized = false) {
    const $logits = (0, $x4eLk.convertToTensor)(logits, 'logits', 'multinomial');
    const numOutcomes = $logits.size;
    const origRank = $logits.rank;
    if (numOutcomes < 2) throw new Error(`Error in multinomial: you need at least 2 outcomes, but got ` + `${numOutcomes}.`);
    if (origRank > 2) throw new Error(`Rank of probabilities must be 1 or 2, but is ${origRank}`);
    // TODO(lina128): Investigate correct seed behavior. The code seems not allow
    // setting see to 0.
    seed = seed || Math.random();
    // The kernel only accepts (and returns) rank 2 tensors.
    const logits2D = origRank === 1 ? (0, $8nMOl.reshape)($logits, [
        1,
        -1
    ]) : $logits;
    const inputs = {
        logits: logits2D
    };
    const attrs = {
        numSamples: numSamples,
        seed: seed,
        normalized: normalized
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Multinomial), inputs, attrs);
    // tslint:disable-next-line:no-unnecessary-type-assertion
    return origRank === 1 ? (0, $8nMOl.reshape)(res, [
        res.size
    ]) : res;
}
const $0677e3fcfab43479$export$f4d580f3101a1c7e = /* @__PURE__ */ (0, $6afhl.op)({
    multinomial_: $0677e3fcfab43479$var$multinomial_
});

});

parcelRegister("8BIHZ", function(module, exports) {

$parcel$export(module.exports, "notEqual", function () { return $6444759790d44e3c$export$53a6892c50694894; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the truth value of (a != b) element-wise. Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([0, 2, 3]);
 *
 * a.notEqual(b).print();
 * ```
 * @param a The first input tensor.
 * @param b The second input tensor. Must have the same dtype as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ function $6444759790d44e3c$var$notEqual_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'notEqual', 'string_or_numeric');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'notEqual', 'string_or_numeric');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.NotEqual), inputs);
}
const $6444759790d44e3c$export$53a6892c50694894 = /* @__PURE__ */ (0, $6afhl.op)({
    notEqual_: $6444759790d44e3c$var$notEqual_
});

});

parcelRegister("7k013", function(module, exports) {

$parcel$export(module.exports, "oneHot", function () { return $554a69d8e9058504$export$341b5490a776d041; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Creates a one-hot `tf.Tensor`. The locations represented by `indices` take
 * value `onValue` (defaults to 1), while all other locations take value
 * `offValue` (defaults to 0). If `indices` is rank `R`, the output has rank
 * `R+1` with the last axis of size `depth`.
 * `indices` used to encode prediction class must start from 0. For example,
 *  if you have 3 classes of data, class 1 should be encoded as 0, class 2
 *  should be 1, and class 3 should be 2.
 *
 * ```js
 * tf.oneHot(tf.tensor1d([0, 1], 'int32'), 3).print();
 * ```
 *
 * @param indices `tf.Tensor` of indices with dtype `int32`. Indices must
 * start from 0.
 * @param depth The depth of the one hot dimension.
 * @param onValue A number used to fill in the output when the index matches
 * the location.
 * @param offValue A number used to fill in the output when the index does
 *     not match the location.
 * @param dtype The dtype of the output tensor, default to 'int32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $554a69d8e9058504$var$oneHot_(indices, depth, onValue = 1, offValue = 0, dtype = 'int32') {
    if (depth < 2) throw new Error(`Error in oneHot: depth must be >=2, but it is ${depth}`);
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'oneHot', 'int32');
    const inputs = {
        indices: $indices
    };
    const attrs = {
        dtype: dtype,
        depth: depth,
        onValue: onValue,
        offValue: offValue
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.OneHot), inputs, attrs);
}
const $554a69d8e9058504$export$341b5490a776d041 = /* @__PURE__ */ (0, $6afhl.op)({
    oneHot_: $554a69d8e9058504$var$oneHot_
});

});

parcelRegister("6zg0w", function(module, exports) {

$parcel$export(module.exports, "onesLike", function () { return $4c826db629dfd13b$export$fb6afd6214fee9e9; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Creates a `tf.Tensor` with all elements set to 1 with the same shape as the
 * given tensor.
 *
 * ```js
 * const x = tf.tensor([1, 2]);
 * tf.onesLike(x).print();
 * ```
 * @param x A tensor.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $4c826db629dfd13b$var$onesLike_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'onesLike');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.OnesLike), inputs);
}
const $4c826db629dfd13b$export$fb6afd6214fee9e9 = /* @__PURE__ */ (0, $6afhl.op)({
    onesLike_: $4c826db629dfd13b$var$onesLike_
});

});

parcelRegister("3ng4n", function(module, exports) {

$parcel$export(module.exports, "outerProduct", function () { return $274ffc2883b9c3de$export$8481b38c75c91cc7; });

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $VLFo8 = parcelRequire("VLFo8");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the outer product of two vectors, `v1` and `v2`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 * const b = tf.tensor1d([3, 4, 5]);
 *
 * tf.outerProduct(a, b).print();
 * ```
 * @param v1 The first vector in the outer product operation.
 * @param v2 The second vector in the outer product operation.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $274ffc2883b9c3de$var$outerProduct_(v1, v2) {
    const $v1 = (0, $x4eLk.convertToTensor)(v1, 'v1', 'outerProduct');
    const $v2 = (0, $x4eLk.convertToTensor)(v2, 'v2', 'outerProduct');
    $eOiOM.assert($v1.rank === 1 && $v2.rank === 1, ()=>`Error in outerProduct: inputs must be rank 1, but got ranks ` + `${$v1.rank} and ${$v2.rank}.`);
    const v12D = (0, $8nMOl.reshape)($v1, [
        -1,
        1
    ]);
    const v22D = (0, $8nMOl.reshape)($v2, [
        1,
        -1
    ]);
    return (0, $VLFo8.matMul)(v12D, v22D);
}
const $274ffc2883b9c3de$export$8481b38c75c91cc7 = /* @__PURE__ */ (0, $6afhl.op)({
    outerProduct_: $274ffc2883b9c3de$var$outerProduct_
});

});

parcelRegister("9XHOJ", function(module, exports) {

$parcel$export(module.exports, "pad", function () { return $740b9cee49232493$export$5d04458e2a6c373e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Pads a `tf.Tensor` with a given value and paddings.
 *
 * This operation implements `CONSTANT` mode. For `REFLECT` and `SYMMETRIC`,
 * refer to `tf.mirrorPad`.
 *
 * Also available are stricter rank-specific methods with the same signature
 * as this method that assert that `paddings` is of given length.
 *   - `tf.pad1d`
 *   - `tf.pad2d`
 *   - `tf.pad3d`
 *   - `tf.pad4d`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * x.pad([[1, 2]]).print();
 * ```
 * @param x The tensor to pad.
 * @param paddings An array of length `R` (the rank of the tensor), where
 * each element is a length-2 tuple of ints `[padBefore, padAfter]`,
 * specifying how much to pad along each dimension of the tensor.
 * @param constantValue The pad value to use. Defaults to 0.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $740b9cee49232493$var$pad_(x, paddings, constantValue = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'pad');
    if ($x.rank === 0) throw new Error('pad(scalar) is not defined. Pass non-scalar to pad');
    const attrs = {
        paddings: paddings,
        constantValue: constantValue
    };
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.PadV2), inputs, attrs);
}
const $740b9cee49232493$export$5d04458e2a6c373e = /* @__PURE__ */ (0, $6afhl.op)({
    pad_: $740b9cee49232493$var$pad_
});

});

parcelRegister("3Knho", function(module, exports) {

$parcel$export(module.exports, "pad1d", function () { return $2ba7b9d455a652c0$export$be67ff622a7fd5; });

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $9XHOJ = parcelRequire("9XHOJ");
/**
 * Pads a `tf.Tensor1D` with a given value and paddings. See `pad` for details.
 */ function $2ba7b9d455a652c0$var$pad1d_(x, paddings, constantValue = 0) {
    (0, $eOiOM.assert)(paddings.length === 2, ()=>'Invalid number of paddings. Must be length of 2.');
    return (0, $9XHOJ.pad)(x, [
        paddings
    ], constantValue);
}
const $2ba7b9d455a652c0$export$be67ff622a7fd5 = /* @__PURE__ */ (0, $6afhl.op)({
    pad1d_: $2ba7b9d455a652c0$var$pad1d_
});

});

parcelRegister("2PSTi", function(module, exports) {

$parcel$export(module.exports, "pad2d", function () { return $210aec5af642d64a$export$38e9137d79715c2d; });

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $9XHOJ = parcelRequire("9XHOJ");
/**
 * Pads a `tf.Tensor2D` with a given value and paddings. See `pad` for details.
 */ function $210aec5af642d64a$var$pad2d_(x, paddings, constantValue = 0) {
    (0, $eOiOM.assert)(paddings.length === 2 && paddings[0].length === 2 && paddings[1].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $9XHOJ.pad)(x, paddings, constantValue);
}
const $210aec5af642d64a$export$38e9137d79715c2d = /* @__PURE__ */ (0, $6afhl.op)({
    pad2d_: $210aec5af642d64a$var$pad2d_
});

});

parcelRegister("e1qwx", function(module, exports) {

$parcel$export(module.exports, "pad3d", function () { return $a355bbbe97c410d1$export$880821ebecb16ceb; });

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $9XHOJ = parcelRequire("9XHOJ");
/**
 * Pads a `tf.Tensor3D` with a given value and paddings. See `pad` for details.
 */ function $a355bbbe97c410d1$var$pad3d_(x, paddings, constantValue = 0) {
    (0, $eOiOM.assert)(paddings.length === 3 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $9XHOJ.pad)(x, paddings, constantValue);
}
const $a355bbbe97c410d1$export$880821ebecb16ceb = /* @__PURE__ */ (0, $6afhl.op)({
    pad3d_: $a355bbbe97c410d1$var$pad3d_
});

});

parcelRegister("bK59X", function(module, exports) {

$parcel$export(module.exports, "pad4d", function () { return $88c7fe2af448ba07$export$4aef6fb43f1346f4; });

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $9XHOJ = parcelRequire("9XHOJ");
/**
 * Pads a `tf.Tensor4D` with a given value and paddings. See `pad` for details.
 */ function $88c7fe2af448ba07$var$pad4d_(x, paddings, constantValue = 0) {
    (0, $eOiOM.assert)(paddings.length === 4 && paddings[0].length === 2 && paddings[1].length === 2 && paddings[2].length === 2 && paddings[3].length === 2, ()=>'Invalid number of paddings. Must be length of 2 each.');
    return (0, $9XHOJ.pad)(x, paddings, constantValue);
}
const $88c7fe2af448ba07$export$4aef6fb43f1346f4 = /* @__PURE__ */ (0, $6afhl.op)({
    pad4d_: $88c7fe2af448ba07$var$pad4d_
});

});

parcelRegister("3igQ1", function(module, exports) {

$parcel$export(module.exports, "pool", function () { return $26601d33e2b142bc$export$7a0e2789ec54f0db; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $4LG6a = parcelRequire("4LG6a");

var $7rVXz = parcelRequire("7rVXz");

var $g0V2M = parcelRequire("g0V2M");

var $kHqOQ = parcelRequire("kHqOQ");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");

var $9l6gk = parcelRequire("9l6gk");
/**
 * Performs an N-D pooling operation
 *
 * @param input The input tensor, of rank 4 or rank 3 of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param windowShape The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param poolingType The type of pooling, either 'max' or 'avg'.
 * @param pad The type of padding algorithm:
 *    - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *    - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *    - For more info, see this guide:
 *     [https://www.tensorflow.org/api_guides/python/nn#Convolution](
 *         https://www.tensorflow.org/api_guides/python/nn#Convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in dilated pooling. Defaults to `[1, 1]`. If `dilationRate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $26601d33e2b142bc$var$pool_(input, windowShape, poolingType, pad, dilations, strides, dimRoundingMode) {
    if (dilations == null) dilations = [
        1,
        1
    ];
    if (strides == null) strides = 1;
    if (pad === 0) pad = 'valid';
    const $x = (0, $x4eLk.convertToTensor)(input, 'x', 'maxPool');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    $eOiOM.assert($g0V2M.eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in pool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = $g0V2M.computePool2DInfo(x4D.shape, windowShape, strides, dilations, pad);
    const dilation = [
        convInfo.dilationHeight,
        convInfo.dilationWidth
    ];
    // The following implementation does batchToSpace(pool(spaceToBatch(x)))
    // whenever dilation > 1 since the TF kernels do not support dilation > 1.
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L1037
    let basePadding;
    if (pad === 'same') basePadding = $26601d33e2b142bc$var$withSpaceToBatchBasePaddings([
        convInfo.filterHeight,
        convInfo.filterWidth
    ], dilation);
    else basePadding = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    const isDilationOne = dilation[0] === 1 && dilation[1] === 1;
    const [adjustedPadding, adjustedCrops] = $26601d33e2b142bc$var$requiredSpaceToBatchPaddings([
        convInfo.inHeight,
        convInfo.inWidth
    ], dilation, basePadding);
    const convertedPad = isDilationOne ? pad : 'valid';
    const convertedX = isDilationOne ? x4D : (0, $9l6gk.spaceToBatchND)(x4D, dilation, adjustedPadding);
    const forwardOp = poolingType === 'avg' ? ()=>(0, $4LG6a.avgPool)(convertedX, windowShape, strides, convertedPad, dimRoundingMode) : ()=>(0, $kHqOQ.maxPool)(convertedX, windowShape, strides, convertedPad, dimRoundingMode);
    const y = forwardOp();
    const res = isDilationOne ? y : (0, $7rVXz.batchToSpaceND)(y, dilation, adjustedCrops);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
// Helper function to compute crops and paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/array_ops.py#L2184
function $26601d33e2b142bc$var$requiredSpaceToBatchPaddings(inputShape, blockShape, basePadding) {
    const padStart = basePadding.map((b)=>b[0]);
    const origPadEnd = basePadding.map((b)=>b[1]);
    const fullInputShape = inputShape.concat(padStart, origPadEnd);
    const padEndExtra = blockShape.map((b, i)=>(b - fullInputShape[i] % b) % b);
    const padEnd = origPadEnd.map((s, i)=>s + padEndExtra[i]);
    const paddings = blockShape.map((_, i)=>[
            padStart[i],
            padEnd[i]
        ]);
    const crops = blockShape.map((_, i)=>[
            0,
            padEndExtra[i]
        ]);
    return [
        paddings,
        crops
    ];
}
// Helper function to compute base paddings for pool with dilation > 1.
// tslint:disable-next-line:max-line-length
// https://github.com/tensorflow/tensorflow/blob/50f6bb67dc98c9b74630b6047aae7a4f8a40fd02/tensorflow/python/ops/nn_ops.py#L524
function $26601d33e2b142bc$var$withSpaceToBatchBasePaddings(filterShape, dilation) {
    // Spatial dimensions of the filters and the upsampled filters in which we
    // introduce (rate - 1) zeros between consecutive filter values.
    const dilatedFilterShape = filterShape.map((s, i)=>{
        return s + (s - 1) * (dilation[i] - 1);
    });
    const padExtraShape = dilatedFilterShape.map((s)=>s - 1);
    // When padding is odd, we pad more at end, following the same
    // convention as conv2d.
    const padExtraStart = padExtraShape.map((s)=>Math.floor(s / 2));
    const padExtraEnd = padExtraShape.map((s, i)=>s - padExtraStart[i]);
    return padExtraShape.map((_, i)=>{
        return [
            padExtraStart[i],
            padExtraEnd[i]
        ];
    });
}
const $26601d33e2b142bc$export$7a0e2789ec54f0db = /* @__PURE__ */ (0, $6afhl.op)({
    pool_: $26601d33e2b142bc$var$pool_
});

});
parcelRegister("9l6gk", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchND", function () { return $6ccaeeca3e2bd042$export$effb9d7cae92012f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * This operation divides "spatial" dimensions `[1, ..., M]` of the input into
 * a grid of blocks of shape `blockShape`, and interleaves these blocks with
 * the "batch" dimension (0) such that in the output, the spatial
 * dimensions `[1, ..., M]` correspond to the position within the grid,
 * and the batch dimension combines both the position within a spatial block
 * and the original batch position. Prior to division into blocks,
 * the spatial dimensions of the input are optionally zero padded
 * according to `paddings`. See below for a precise description.
 *
 * ```js
 * const x = tf.tensor4d([1, 2, 3, 4], [1, 2, 2, 1]);
 * const blockShape = [2, 2];
 * const paddings = [[0, 0], [0, 0]];
 *
 * x.spaceToBatchND(blockShape, paddings).print();
 * ```
 *
 * @param x A `tf.Tensor`. N-D with `x.shape` = `[batch] + spatialShape +
 * remainingShape`, where spatialShape has `M` dimensions.
 * @param blockShape A 1-D array. Must have shape `[M]`, all values must
 * be >= 1.
 * @param paddings A 2-D array. Must have shape `[M, 2]`, all values must be >=
 *     0. `paddings[i] = [padStart, padEnd]` specifies the amount to zero-pad
 * from input dimension `i + 1`, which corresponds to spatial dimension `i`. It
 * is required that
 * `(inputShape[i + 1] + padStart + padEnd) % blockShape[i] === 0`
 *
 * This operation is equivalent to the following steps:
 *
 * 1. Zero-pad the start and end of dimensions `[1, ..., M]` of the input
 * according to `paddings` to produce `padded` of shape paddedShape.
 *
 * 2. Reshape `padded` to `reshapedPadded` of shape:
 * `[batch] + [paddedShape[1] / blockShape[0], blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1], blockShape[M-1]] + remainingShape`
 *
 * 3. Permute dimensions of `reshapedPadded` to produce `permutedReshapedPadded`
 * of shape: `blockShape + [batch] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * 4. Reshape `permutedReshapedPadded` to flatten `blockShape` into the
 * batch dimension, producing an output tensor of shape:
 * `[batch * prod(blockShape)] + [paddedShape[1] / blockShape[0], ...,
 * paddedShape[M] / blockShape[M-1]] + remainingShape`
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $6ccaeeca3e2bd042$var$spaceToBatchND_(x, blockShape, paddings) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'spaceToBatchND');
    $eOiOM.assert($x.rank >= 1 + blockShape.length, ()=>`input rank ${$x.rank} should be > than [blockShape] ${blockShape.length}`);
    $eOiOM.assert(paddings.length === blockShape.length, ()=>`paddings.shape[0] ${paddings.length} must be equal to [blockShape] ${blockShape.length}`);
    $eOiOM.assert($x.shape.reduce((a, b, i)=>{
        if (i > 0 && i <= blockShape.length) return a && (b + paddings[i - 1][0] + paddings[i - 1][1]) % blockShape[i - 1] === 0;
        return a;
    }, true), ()=>`input spatial dimensions ${$x.shape.slice(1)} with paddings ${paddings.toString()} must be divisible by blockShapes ${blockShape.toString()}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        blockShape: blockShape,
        paddings: paddings
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SpaceToBatchND), inputs, attrs);
}
const $6ccaeeca3e2bd042$export$effb9d7cae92012f = /* @__PURE__ */ (0, $6afhl.op)({
    spaceToBatchND_: $6ccaeeca3e2bd042$var$spaceToBatchND_
});

});


parcelRegister("b2Mw2", function(module, exports) {

$parcel$export(module.exports, "prod", function () { return $80a583da4c1accde$export$5e143010dea16c85; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $fxiHg = parcelRequire("fxiHg");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the product of elements across dimensions of a `tf.Tensor`.
 *
 * Reduces the input along the dimensions given in `axes`. Unless `keepDims`
 * is true, the rank of the `tf.Tensor` is reduced by 1 for each entry in
 * `axes`. If `keepDims` is true, the reduced dimensions are retained with
 * length 1. If `axes` has no entries, all dimensions are reduced, and a
 * `tf.Tensor` with a single element is returned.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3]);
 *
 * x.prod().print();  // or tf.prod(x)
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.prod(axis).print();  // or tf.prod(x, axis)
 * ```
 *
 * @param x The input tensor to compute the product over. If the dtype is `bool`
 *   it will be converted to `int32` and the output dtype will be `int32`.
 * @param axis The dimension(s) to reduce. By default it reduces
 *     all dimensions.
 * @param keepDims If true, retains reduced dimensions with size 1.
 *
 * @doc {heading: 'Operations', subheading: 'Reduction'}
 */ function $80a583da4c1accde$var$prod_(x, axis = null, keepDims = false) {
    let $x = (0, $x4eLk.convertToTensor)(x, 'x', 'prod');
    if ($x.dtype === 'bool') // bool is not an allowed type for the underlying kernel.
    $x = (0, $fxiHg.cast)($x, 'int32');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis,
        keepDims: keepDims
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Prod), inputs, attrs);
}
const $80a583da4c1accde$export$5e143010dea16c85 = /* @__PURE__ */ (0, $6afhl.op)({
    prod_: $80a583da4c1accde$var$prod_
});

});

parcelRegister("7zltL", function(module, exports) {

$parcel$export(module.exports, "raggedGather", function () { return $582c7699b3987c02$export$e7118f605df251dd; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
function $582c7699b3987c02$var$raggedGather_(paramsNestedSplits, paramsDenseValues, indices, outputRaggedRank) {
    const $paramsNestedSplits = paramsNestedSplits.map((t, i)=>(0, $x4eLk.convertToTensor)(t, `tensors${i}`, 'raggedGather', 'int32'));
    const $paramsDenseValues = (0, $x4eLk.convertToTensor)(paramsDenseValues, 'paramsDenseValues', 'raggedGather');
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'raggedGather', 'int32');
    const inputs = {
        paramsNestedSplits: $paramsNestedSplits,
        paramsDenseValues: $paramsDenseValues,
        indices: $indices
    };
    const attrs = {
        outputRaggedRank: outputRaggedRank
    };
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.RaggedGather), inputs, attrs);
    return {
        outputNestedSplits: result.slice(0, result.length - 1),
        outputDenseValues: result[result.length - 1]
    };
}
const $582c7699b3987c02$export$e7118f605df251dd = /* @__PURE__ */ (0, $6afhl.op)({
    raggedGather_: $582c7699b3987c02$var$raggedGather_
});

});

parcelRegister("ldadP", function(module, exports) {

$parcel$export(module.exports, "raggedRange", function () { return $f712bdc5ce95dd33$export$a173be400c6762b5; });
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns a RaggedTensor result composed from rtDenseValues and rtNestedSplits,
 * such that result[i] = [starts[i], starts[i] + deltas[i], ..., limits[i]]).
 *
 * @param starts: A Tensor. Must be one of the following types:
 *     'float32', 'int32'. The starts of each range.
 * @param limits: A Tensor. Must have the same type as starts. The limits of
 *     each range.
 * @param deltas: A Tensor. Must have the same type as starts. The deltas of
 *     each range.
 * @return A map with the following properties:
 *     - rtNestedSplits: A Tensor of type 'int32'.
 *     - rtDenseValues: A Tensor. Has the same type as starts.
 */ function $f712bdc5ce95dd33$var$raggedRange_(starts, limits, deltas) {
    const $starts = (0, $x4eLk.convertToTensor)(starts, 'starts', 'raggedRange');
    const $limits = (0, $x4eLk.convertToTensor)(limits, 'limits', 'raggedRange', $starts.dtype);
    const $deltas = (0, $x4eLk.convertToTensor)(deltas, 'deltas', 'raggedRange', $starts.dtype);
    const inputs = {
        starts: $starts,
        limits: $limits,
        deltas: $deltas
    };
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.RaggedRange), inputs);
    return {
        rtNestedSplits: result[0],
        rtDenseValues: result[1]
    };
}
const $f712bdc5ce95dd33$export$a173be400c6762b5 = /* @__PURE__ */ (0, $6afhl.op)({
    raggedRange_: $f712bdc5ce95dd33$var$raggedRange_
});

});

parcelRegister("2JU1C", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensor", function () { return $1feb3e28fd115872$export$621e390307cbbaa1; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Create a dense tensor from a ragged tensor, possibly altering its shape.
 *
 * The raggedTensorToTensor op creates a dense tensor from am array of row
 * partition tensors, a value vector, and default values. If the shape is
 * unspecified, the minimal shape required to contain all the elements in the
 * ragged tensor (the natural shape) will be used. If some dimensions are left
 * unspecified, then the size of the natural shape is used in that dimension.
 *
 * The defaultValue will be broadcast to the output shape. After that, the
 * values from the ragged tensor overwrite the default values. Note that the
 * defaultValue must have less dimensions than the value.
 *
 * The row partition tensors are in the order of the dimensions. At present, the
 * types can be: "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *   "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *   "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then it
 * is preceded by "FIRST_DIM_SIZE".
 * ```
 * @param shape: A Tensor. Must be one of the following types: 'int32'. The
 *     desired shape of the output tensor. If left unspecified (empty), the
 *     minimal shape required to contain all the elements in the ragged tensor
 *     (the natural shape) will be used. If some dimensions are left
 *     unspecified, then the size of the natural shape is used in that
 *     dimension.
 *
 *     Note that dense dimensions cannot be modified by the shape argument.
 *     Trying to change the size of a dense dimension will cause the op to fail.
 *     Examples: natural shape: [4, 5, 6] shape: -1 output shape: [4, 5, 6]
 *
 *     natural shape: [4, 5, 6] shape: [3, -1, 2] output shape: [3, 5, 2]
 *
 *     natural shape: [4, 5, 6] shape: [3, 7, 2] output shape: [3, 7, 2]
 * @param values: A Tensor. A 1D tensor representing the values of the ragged
 *     tensor.
 * @param defaultValue: A Tensor. Must have the same type as values. The
 *     defaultValue when the shape is larger than the ragged tensor. The
 *     defaultValue is broadcast until it is the shape of the output tensor,
 *     and then overwritten by values in the ragged tensor. The default value
 *     must be compatible with this broadcast operation, and must have fewer
 *     dimensions than the value tensor.
 * @param rowPartitionTensors: A list of at least 1 Tensor objects with the same
 *     type in: 'int32'.
 * @param rowPartitionTypes: A list of strings. The types of the row partition
 *     tensors. At present, these can be:
 *     "ROW_SPLITS": the row_splits tensor from the ragged tensor.
 *     "VALUE_ROWIDS": the value_rowids tensor from the ragged tensor.
 *     "FIRST_DIM_SIZE": if value_rowids is used for the first dimension, then
 *         it is preceded by "FIRST_DIM_SIZE". The tensors are in the order of
 *         the dimensions.
 * @return A Tensor. Has the same type as values.
 * @doc {heading: 'Operations', subheading: 'Ragged'}
 */ function $1feb3e28fd115872$var$raggedTensorToTensor_(shape, values, defaultValue, rowPartitionTensors, rowPartitionTypes) {
    const $shape = (0, $x4eLk.convertToTensor)(shape, 'shape', 'raggedTensorToTensor', 'int32');
    const $values = (0, $x4eLk.convertToTensor)(values, 'values', 'raggedTensorToTensor');
    const $defaultValue = (0, $x4eLk.convertToTensor)(defaultValue, 'defaultValue', 'raggedTensorToTensor', $values.dtype);
    const $rowPartitionTensors = rowPartitionTensors.map((t, i)=>(0, $x4eLk.convertToTensor)(t, `tensors${i}`, 'raggedTensorToTensor', 'int32'));
    const inputs = {
        shape: $shape,
        values: $values,
        defaultValue: $defaultValue,
        rowPartitionTensors: $rowPartitionTensors
    };
    const attrs = {
        rowPartitionTypes: rowPartitionTypes
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.RaggedTensorToTensor), inputs, attrs);
}
const $1feb3e28fd115872$export$621e390307cbbaa1 = /* @__PURE__ */ (0, $6afhl.op)({
    raggedTensorToTensor_: $1feb3e28fd115872$var$raggedTensorToTensor_
});

});

parcelRegister("7cmbr", function(module, exports) {

$parcel$export(module.exports, "rand", function () { return $53dadc95fc880c30$export$bb0a9c36cf454ea0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $eOiOM = parcelRequire("eOiOM");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Creates a `tf.Tensor` with values sampled from a random number generator
 * function defined by the user.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param randFunction A random number generator function which is called
 * for each element in the output tensor.
 * @param dtype The data type of the output tensor. Defaults to 'float32'.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $53dadc95fc880c30$var$rand_(shape, randFunction, dtype) {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    const size = (0, $eOiOM.sizeFromShape)(shape);
    let values = null;
    if (dtype == null || dtype === 'float32') values = new Float32Array(size);
    else if (dtype === 'int32') values = new Int32Array(size);
    else if (dtype === 'bool') values = new Uint8Array(size);
    else throw new Error(`Unknown data type ${dtype}`);
    for(let i = 0; i < size; i++)values[i] = randFunction();
    return (0, $e6Ey6.ENGINE).makeTensor(values, shape, dtype);
}
const $53dadc95fc880c30$export$bb0a9c36cf454ea0 = /* @__PURE__ */ (0, $6afhl.op)({
    rand_: $53dadc95fc880c30$var$rand_
});

});

parcelRegister("guGiy", function(module, exports) {

$parcel$export(module.exports, "randomGamma", function () { return $c020423aa13afc5a$export$63a8048b65295cb7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");

var $5siju = parcelRequire("5siju");

var $6afhl = parcelRequire("6afhl");

var $5ZlCt = parcelRequire("5ZlCt");
/**
 * Creates a `tf.Tensor` with values sampled from a gamma distribution.
 *
 * ```js
 * tf.randomGamma([2, 2], 1).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param alpha The shape parameter of the gamma distribution.
 * @param beta The inverse scale parameter of the gamma distribution. Defaults
 *     to 1.
 * @param dtype The data type of the output. Defaults to float32.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $c020423aa13afc5a$var$randomGamma_(shape, alpha, beta = 1, dtype = 'float32', seed) {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    if (beta == null) beta = 1;
    if (dtype == null) dtype = 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new Error(`Unsupported data type ${dtype}`);
    const rgamma = new (0, $5ZlCt.RandGamma)(alpha, beta, dtype, seed);
    const res = (0, $5siju.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = rgamma.nextValue();
    return res.toTensor();
}
const $c020423aa13afc5a$export$63a8048b65295cb7 = /* @__PURE__ */ (0, $6afhl.op)({
    randomGamma_: $c020423aa13afc5a$var$randomGamma_
});

});

parcelRegister("kaIUV", function(module, exports) {

$parcel$export(module.exports, "randomNormal", function () { return $eaf795714ca4c8de$export$a0ac5549a8bec918; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");

var $5siju = parcelRequire("5siju");

var $6afhl = parcelRequire("6afhl");

var $5ZlCt = parcelRequire("5ZlCt");
/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * ```js
 * tf.randomNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $eaf795714ca4c8de$var$randomNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    const randGauss = new (0, $5ZlCt.MPRandGauss)(mean, stdDev, dtype, false, seed);
    const res = (0, $5siju.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $eaf795714ca4c8de$export$a0ac5549a8bec918 = /* @__PURE__ */ (0, $6afhl.op)({
    randomNormal_: $eaf795714ca4c8de$var$randomNormal_
});

});

parcelRegister("4CqNZ", function(module, exports) {

$parcel$export(module.exports, "randomStandardNormal", function () { return $35cf8101e1f32d42$export$5a8aa20f8ebaee69; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6afhl = parcelRequire("6afhl");

var $kaIUV = parcelRequire("kaIUV");
/**
 * Creates a `tf.Tensor` with values sampled from a normal distribution.
 *
 * The generated values will have mean 0 and standard deviation 1.
 *
 * ```js
 * tf.randomStandardNormal([2, 2]).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param dtype The data type of the output.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $35cf8101e1f32d42$var$randomStandardNormal_(shape, dtype, seed) {
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type ${dtype}`);
    return (0, $kaIUV.randomNormal)(shape, 0, 1, dtype, seed);
}
const $35cf8101e1f32d42$export$5a8aa20f8ebaee69 = /* @__PURE__ */ (0, $6afhl.op)({
    randomStandardNormal_: $35cf8101e1f32d42$var$randomStandardNormal_
});

});

parcelRegister("FKlDG", function(module, exports) {

$parcel$export(module.exports, "randomUniformInt", function () { return $07d7c83355621e23$export$134fe7f07fd7b492; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6afhl = parcelRequire("6afhl");

var $9ORo6 = parcelRequire("9ORo6");
/**
 * Creates a `tf.Tensor` with integers sampled from a uniform distribution.
 *
 * The generated values are uniform integers in the range [minval, maxval). The
 * lower bound minval is included in the range, while the upper bound maxval is
 * excluded.
 *
 * ```js
 * tf.randomUniformInt([2, 2], 0, 10).print();
 * ```
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param minval Inclusive lower bound on the generated integers.
 * @param maxval Exclusive upper bound on the generated integers.
 * @param seed An optional int. Defaults to 0. If seed is set to be non-zero,
 *   the random number generator is seeded by the given seed. Otherwise, it is
 *   seeded by a random seed.
 *
 * @doc {heading: 'Tensors', subheading: 'Random'}
 */ function $07d7c83355621e23$var$randomUniformInt_(shape, minval, maxval, seed) {
    // TODO(mattsoulanille): Handle optional seed2 input.
    return (0, $9ORo6.randomUniform)(shape, minval, maxval, 'int32', seed);
}
const $07d7c83355621e23$export$134fe7f07fd7b492 = /* @__PURE__ */ (0, $6afhl.op)({
    randomUniformInt_: $07d7c83355621e23$var$randomUniformInt_
});

});

parcelRegister("kh5mA", function(module, exports) {

$parcel$export(module.exports, "range", function () { return $ec298e3a76e6c8e2$export$d02631cccf789723; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");
function $ec298e3a76e6c8e2$export$d02631cccf789723(start, stop, step = 1, dtype = 'float32') {
    if (step === 0) throw new Error('Cannot have a step of zero');
    const attrs = {
        start: start,
        stop: stop,
        step: step,
        dtype: dtype
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Range), {} /* inputs */ , attrs);
}

});

parcelRegister("6gKdw", function(module, exports) {

$parcel$export(module.exports, "real", function () { return $4908167a6fec3c8a$export$9fc57fb453bdbd67; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns the real part of a complex (or real) tensor.
 *
 * Given a tensor input, this operation returns a tensor of type float that is
 * the real part of each element in input considered as a complex number.
 *
 * If the input is real, it simply makes a clone.
 *
 * ```js
 * const x = tf.complex([-2.25, 3.25], [4.75, 5.75]);
 * tf.real(x).print();
 * ```
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $4908167a6fec3c8a$var$real_(input) {
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'real');
    const inputs = {
        input: $input
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Real), inputs);
}
const $4908167a6fec3c8a$export$9fc57fb453bdbd67 = /* @__PURE__ */ (0, $6afhl.op)({
    real_: $4908167a6fec3c8a$var$real_
});

});

parcelRegister("1Lp6R", function(module, exports) {

$parcel$export(module.exports, "reciprocal", function () { return $148da87798a0ea43$export$163bc8c839a1ac04; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes reciprocal of x element-wise: `1 / x`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, 2]);
 *
 * x.reciprocal().print();  // or tf.reciprocal(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $148da87798a0ea43$var$reciprocal_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'reciprocal');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Reciprocal), inputs);
}
const $148da87798a0ea43$export$163bc8c839a1ac04 = /* @__PURE__ */ (0, $6afhl.op)({
    reciprocal_: $148da87798a0ea43$var$reciprocal_
});

});

parcelRegister("5ApPj", function(module, exports) {

$parcel$export(module.exports, "reverse", function () { return $4114592a19ff0d65$export$66c1ae025e96b4bc; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Reverses a `tf.Tensor` along a specified axis.
 *
 * Also available are stricter rank-specific methods that assert that `x` is
 * of the given rank:
 *   - `tf.reverse1d`
 *   - `tf.reverse2d`
 *   - `tf.reverse3d`
 *   - `tf.reverse4d`
 *
 * Except `tf.reverse1d` (which does not have axis param), all methods have
 * same signature as this method.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 *
 * x.reverse().print();
 * ```
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * const axis = 1;
 * x.reverse(axis).print();
 * ```
 * @param x The input tensor to be reversed.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $4114592a19ff0d65$var$reverse_(x, axis) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'reverse');
    const inputs = {
        x: $x
    };
    const attrs = {
        dims: axis
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Reverse), inputs, attrs);
}
const $4114592a19ff0d65$export$66c1ae025e96b4bc = /* @__PURE__ */ (0, $6afhl.op)({
    reverse_: $4114592a19ff0d65$var$reverse_
});

});

parcelRegister("eXcSV", function(module, exports) {

$parcel$export(module.exports, "reverse1d", function () { return $ae3092090bb9b938$export$ec29ded9cbde7103; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $5ApPj = parcelRequire("5ApPj");
/**
 * Reverses a `tf.Tensor1D`.
 *
 * @param x The input tensor.
 */ function $ae3092090bb9b938$var$reverse1d_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'reverse');
    $eOiOM.assert($x.rank === 1, ()=>`Error in reverse1D: x must be rank 1 but got rank ${$x.rank}.`);
    return (0, $5ApPj.reverse)($x, 0);
}
const $ae3092090bb9b938$export$ec29ded9cbde7103 = /* @__PURE__ */ (0, $6afhl.op)({
    reverse1d_: $ae3092090bb9b938$var$reverse1d_
});

});

parcelRegister("8rz6Z", function(module, exports) {

$parcel$export(module.exports, "reverse2d", function () { return $625c14c998a7f2f6$export$12170f5f8cb48014; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $5ApPj = parcelRequire("5ApPj");
/**
 * Reverses a `tf.Tensor2D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $625c14c998a7f2f6$var$reverse2d_(x, axis) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'reverse');
    $eOiOM.assert($x.rank === 2, ()=>`Error in reverse2D: x must be rank 2 but got rank ${$x.rank}.`);
    return (0, $5ApPj.reverse)($x, axis);
}
const $625c14c998a7f2f6$export$12170f5f8cb48014 = /* @__PURE__ */ (0, $6afhl.op)({
    reverse2d_: $625c14c998a7f2f6$var$reverse2d_
});

});

parcelRegister("l8lrM", function(module, exports) {

$parcel$export(module.exports, "reverse3d", function () { return $f62afb44e36b19b5$export$1ecb65b2ca41f0e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $5ApPj = parcelRequire("5ApPj");
/**
 * Reverses a `tf.Tensor3D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $f62afb44e36b19b5$var$reverse3d_(x, axis) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'reverse');
    $eOiOM.assert($x.rank === 3, ()=>`Error in reverse3D: x must be rank 3 but got rank ${$x.rank}.`);
    return (0, $5ApPj.reverse)($x, axis);
}
const $f62afb44e36b19b5$export$1ecb65b2ca41f0e = /* @__PURE__ */ (0, $6afhl.op)({
    reverse3d_: $f62afb44e36b19b5$var$reverse3d_
});

});

parcelRegister("eDKO8", function(module, exports) {

$parcel$export(module.exports, "reverse4d", function () { return $aa8904383833c77c$export$76a1df46e0e42da4; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $5ApPj = parcelRequire("5ApPj");
/**
 * Reverses a `tf.Tensor4D` along a specified axis.
 *
 * @param x The input tensor.
 * @param axis The set of dimensions to reverse. Must be in the
 *     range [-rank(x), rank(x)). Defaults to all axes.
 */ function $aa8904383833c77c$var$reverse4d_(x, axis) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'reverse');
    $eOiOM.assert($x.rank === 4, ()=>`Error in reverse4D: x must be rank 4 but got rank ${$x.rank}.`);
    return (0, $5ApPj.reverse)($x, axis);
}
const $aa8904383833c77c$export$76a1df46e0e42da4 = /* @__PURE__ */ (0, $6afhl.op)({
    reverse4d_: $aa8904383833c77c$var$reverse4d_
});

});

parcelRegister("eo7jM", function(module, exports) {

$parcel$export(module.exports, "round", function () { return $a798fbc731808eff$export$2077e0241d6afd3c; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes round of input `tf.Tensor` element-wise: `round(x)`.
 * It implements banker's rounding.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3]);
 *
 * x.round().print();  // or tf.round(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $a798fbc731808eff$var$round_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'round');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Round), inputs);
}
const $a798fbc731808eff$export$2077e0241d6afd3c = /* @__PURE__ */ (0, $6afhl.op)({
    round_: $a798fbc731808eff$var$round_
});

});

parcelRegister("6M9ry", function(module, exports) {

$parcel$export(module.exports, "rsqrt", function () { return $4eee8d108ad3475a$export$1cc01d192953037e; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes reciprocal of square root of the input `tf.Tensor` element-wise:
 * `y = 1 / sqrt(x)`
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 4, -1]);
 *
 * x.rsqrt().print();  // or tf.rsqrt(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $4eee8d108ad3475a$var$rsqrt_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'rsqrt', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Rsqrt), inputs);
}
const $4eee8d108ad3475a$export$1cc01d192953037e = /* @__PURE__ */ (0, $6afhl.op)({
    rsqrt_: $4eee8d108ad3475a$var$rsqrt_
});

});

parcelRegister("6DicT", function(module, exports) {

$parcel$export(module.exports, "selu", function () { return $4d44822286695a8d$export$a5f8240d9e99b438; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes scaled exponential linear element-wise.
 *
 * `x < 0 ? scale * alpha * (exp(x) - 1) : scale * x`
 *
 * ```js
 * const x = tf.tensor1d([-1, 2, -3, 4]);
 *
 * x.selu().print();  // or tf.selu(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $4d44822286695a8d$var$selu_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'selu');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Selu), inputs);
}
const $4d44822286695a8d$export$a5f8240d9e99b438 = /* @__PURE__ */ (0, $6afhl.op)({
    selu_: $4d44822286695a8d$var$selu_
});

});

parcelRegister("2ICVg", function(module, exports) {

$parcel$export(module.exports, "separableConv2d", function () { return $1fade20a68c6aa4f$export$2586c92899c2d0fb; });

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $9JluG = parcelRequire("9JluG");

var $kQqya = parcelRequire("kQqya");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * 2-D convolution with separable filters.
 *
 * Performs a depthwise convolution that acts separately on channels followed
 * by a pointwise convolution that mixes channels. Note that this is
 * separability between dimensions [1, 2] and 3, not spatial separability
 * between dimensions 1 and 2.
 *
 * See
 * [https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d](
 *     https://www.tensorflow.org/api_docs/python/tf/nn/separable_conv2d)
 * for more details.
 *
 * @param x The input tensor, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is
 * assumed.
 * @param depthwiseFilter The depthwise filter tensor, rank 4, of shape
 *     `[filterHeight, filterWidth, inChannels, channelMultiplier]`. This is
 *     the filter used in the first step.
 * @param pointwiseFilter The pointwise filter tensor, rank 4, of shape
 *     `[1, 1, inChannels * channelMultiplier, outChannels]`. This is
 *     the filter used in the second step.
 * @param strides The strides of the convolution: `[strideHeight,
 * strideWidth]`. If strides is a single number, then `strideHeight ==
 * strideWidth`.
 * @param pad The type of padding algorithm.
 *   - `same` and stride 1: output will be of same size as input,
 *       regardless of filter size.
 *   - `valid`: output will be smaller than input if filter is larger
 *       than 1x1.
 *   - For more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dilations The dilation rates: `[dilationHeight, dilationWidth]`
 *     in which we sample input values across the height and width dimensions
 *     in atrous convolution. Defaults to `[1, 1]`. If `rate` is a single
 *     number, then `dilationHeight == dilationWidth`. If it is greater than
 *     1, then all values of `strides` must be 1.
 * @param dataFormat: An optional string from: "NHWC", "NCHW". Defaults to
 *     "NHWC". Specify the data format of the input and output data. With the
 *     default format "NHWC", the data is stored in the order of: [batch,
 *     height, width, channels]. Only "NHWC" is currently supported.
 *
 * @doc {heading: 'Operations', subheading: 'Convolution'}
 */ function $1fade20a68c6aa4f$var$separableConv2d_(x, depthwiseFilter, pointwiseFilter, strides, pad, dilation = [
    1,
    1
], dataFormat = 'NHWC') {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'separableConv2d');
    const $depthwiseFilter = (0, $x4eLk.convertToTensor)(depthwiseFilter, 'depthwiseFilter', 'separableConv2d');
    const $pointwiseFilter = (0, $x4eLk.convertToTensor)(pointwiseFilter, 'pointwiseFilter', 'separableConv2d');
    let x4D = $x;
    let reshapedTo4D = false;
    if ($x.rank === 3) {
        reshapedTo4D = true;
        x4D = (0, $8nMOl.reshape)($x, [
            1,
            $x.shape[0],
            $x.shape[1],
            $x.shape[2]
        ]);
    }
    if (dataFormat === 'NCHW') throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
    $eOiOM.assert(x4D.rank === 4, ()=>`Error in separableConv2d: input must be rank 4, but got ` + `rank ${x4D.rank}.`);
    $eOiOM.assert($depthwiseFilter.rank === 4, ()=>`Error in separableConv2d: depthwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $eOiOM.assert($pointwiseFilter.rank === 4, ()=>`Error in separableConv2d: pointwise filter must be rank 4, but ` + `got rank ${$depthwiseFilter.rank}.`);
    $eOiOM.assert($pointwiseFilter.shape[0] === 1, ()=>`Error in separableConv2d: the first dimension of pointwise filter ` + ` must be 1, but got ${$pointwiseFilter.shape[0]}.`);
    $eOiOM.assert($pointwiseFilter.shape[1] === 1, ()=>`Error in separableConv2d: the second dimension of pointwise ` + `filter must be 1, but got ${$pointwiseFilter.shape[1]}.`);
    const inChannels = $depthwiseFilter.shape[2];
    const channelMultiplier = $depthwiseFilter.shape[3];
    $eOiOM.assert($pointwiseFilter.shape[2] === inChannels * channelMultiplier, ()=>`Error in separableConv2d: the third dimension of pointwise filter ` + `must be ${inChannels * channelMultiplier}, ` + `but got ${$pointwiseFilter.shape[2]}.`);
    const depthwise = (0, $kQqya.depthwiseConv2d)(x4D, $depthwiseFilter, strides, pad, dataFormat, dilation);
    const pointwiseStride = 1;
    const res = (0, $9JluG.conv2d)(depthwise, $pointwiseFilter, pointwiseStride, 'valid', dataFormat);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $1fade20a68c6aa4f$export$2586c92899c2d0fb = /* @__PURE__ */ (0, $6afhl.op)({
    separableConv2d_: $1fade20a68c6aa4f$var$separableConv2d_
});

});

parcelRegister("eC6Gd", function(module, exports) {

$parcel$export(module.exports, "setdiff1dAsync", function () { return $aa39cbc652921653$export$cd50e5d116ec1774; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3pVUH = parcelRequire("3pVUH");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");
/**
 * Computes the difference between two lists of numbers.
 *
 * Given a Tensor `x` and a Tensor `y`, this operation returns a Tensor `out`
 * that represents all values that are in `x` but not in `y`. The returned
 * Tensor `out` is sorted in the same order that the numbers appear in `x`
 * (duplicates are preserved). This operation also returns a Tensor indices that
 * represents the position of each out element in `x`. In other words:
 *
 * `out[i] = x[idx[i]] for i in [0, 1, ..., out.length - 1]`
 *
 * ```js
 * const x = [1, 2, 3, 4, 5, 6];
 * const y = [1, 3, 5];
 *
 * const [out, indices] = await tf.setdiff1dAsync(x, y);
 * out.print(); // [2, 4, 6]
 * indices.print(); // [1, 3, 5]
 * ```
 *
 * @param x 1-D Tensor. Values to keep.
 * @param y 1-D Tensor. Must have the same type as x. Values to exclude in the
 *     output.
 * @returns Promise of Tensor tuple [out, indices].
 *  out: Tensor with the same type as x.
 *  indices: A Tensor of type int32.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ async function $aa39cbc652921653$var$setdiff1dAsync_(x, y) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'setdiff1d');
    const $y = (0, $x4eLk.convertToTensor)(y, 'y', 'setdiff1d');
    $eOiOM.assert($x.dtype === $y.dtype, ()=>`x and y should have the same dtype, but got x (${$x.dtype}) and y (${$y.dtype}).`);
    $eOiOM.assert($x.rank === 1, ()=>`x should be 1D tensor, but got x (${$x.shape}).`);
    $eOiOM.assert($y.rank === 1, ()=>`y should be 1D tensor, but got y (${$y.shape}).`);
    const xVals = await $x.data();
    const yVals = await $y.data();
    const ySet = new Set(yVals);
    let outputSize = 0;
    for(let i = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) outputSize++;
    const buffer = new (0, $3pVUH.TensorBuffer)([
        outputSize
    ], $x.dtype);
    const indices = new (0, $3pVUH.TensorBuffer)([
        outputSize
    ], 'int32');
    for(let i = 0, p = 0; i < xVals.length; i++)if (!ySet.has(xVals[i])) {
        buffer.values[p] = xVals[i];
        indices.values[p] = i;
        p++;
    }
    return [
        buffer.toTensor(),
        indices.toTensor()
    ];
}
const $aa39cbc652921653$export$cd50e5d116ec1774 = $aa39cbc652921653$var$setdiff1dAsync_;

});

parcelRegister("gMq2C", function(module, exports) {

$parcel$export(module.exports, "sign", function () { return $c3755445fda9974b$export$c5552dfdbc7cec71; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns an element-wise indication of the sign of a number.
 *
 * ```js
 * const x = tf.tensor1d([.6, 1.1, -3.3, NaN, 0]);
 *
 * x.sign().print();  // or tf.sign(x)
 * ```
 * @param x The input Tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $c3755445fda9974b$var$sign_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'sign');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Sign), inputs);
}
const $c3755445fda9974b$export$c5552dfdbc7cec71 = /* @__PURE__ */ (0, $6afhl.op)({
    sign_: $c3755445fda9974b$var$sign_
});

});

parcelRegister("6zQIj", function(module, exports) {

$parcel$export(module.exports, "sin", function () { return $4c9ee6ce79f72d07$export$5de3937cb4b592ed; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes sin of the input Tensor element-wise: `sin(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.sin().print();  // or tf.sin(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $4c9ee6ce79f72d07$var$sin_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'sin', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Sin), inputs);
}
const $4c9ee6ce79f72d07$export$5de3937cb4b592ed = /* @__PURE__ */ (0, $6afhl.op)({
    sin_: $4c9ee6ce79f72d07$var$sin_
});

});

parcelRegister("fbZFd", function(module, exports) {

$parcel$export(module.exports, "sinh", function () { return $b0f7b73c818bc647$export$545004b505d7c555; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes hyperbolic sin of the input `tf.Tensor` element-wise: `sinh(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, 1, -1, .7]);
 *
 * x.sinh().print();  // or tf.sinh(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $b0f7b73c818bc647$var$sinh_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'sinh');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Sinh), inputs);
}
const $b0f7b73c818bc647$export$545004b505d7c555 = /* @__PURE__ */ (0, $6afhl.op)({
    sinh_: $b0f7b73c818bc647$var$sinh_
});

});

parcelRegister("c8zsf", function(module, exports) {

$parcel$export(module.exports, "slice1d", function () { return $8d61bbf5bd785c51$export$95433662b275eb82; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $l7afw = parcelRequire("l7afw");
/**
 * Extracts a 1D slice from 1D array starting at coordinates `begin` and is
 * of length `size`. See `slice` for details.
 */ function $8d61bbf5bd785c51$var$slice1d_(x, begin, size) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'slice1d');
    $eOiOM.assert($x.rank === 1, ()=>`slice1d expects a rank-1 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $l7afw.slice)($x, [
        begin
    ], [
        size
    ]);
}
const $8d61bbf5bd785c51$export$95433662b275eb82 = /* @__PURE__ */ (0, $6afhl.op)({
    slice1d_: $8d61bbf5bd785c51$var$slice1d_
});

});

parcelRegister("kzTOv", function(module, exports) {

$parcel$export(module.exports, "slice2d", function () { return $efb25ef2297c9e9f$export$e5c6a6611cb43a9d; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $l7afw = parcelRequire("l7afw");
/**
 * Extracts a 2D slice from a 2D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $efb25ef2297c9e9f$var$slice2d_(x, begin, size) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'slice2d');
    $eOiOM.assert($x.rank === 2, ()=>`slice2d expects a rank-2 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $l7afw.slice)($x, begin, size);
}
const $efb25ef2297c9e9f$export$e5c6a6611cb43a9d = /* @__PURE__ */ (0, $6afhl.op)({
    slice2d_: $efb25ef2297c9e9f$var$slice2d_
});

});

parcelRegister("gaDoi", function(module, exports) {

$parcel$export(module.exports, "slice3d", function () { return $bc5c22bc49a2cc54$export$dec56af20749d733; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $l7afw = parcelRequire("l7afw");
/**
 * Extracts a 3D slice from a 3D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $bc5c22bc49a2cc54$var$slice3d_(x, begin, size) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'slice3d');
    $eOiOM.assert($x.rank === 3, ()=>`slice3d expects a rank-3 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $l7afw.slice)($x, begin, size);
}
const $bc5c22bc49a2cc54$export$dec56af20749d733 = /* @__PURE__ */ (0, $6afhl.op)({
    slice3d_: $bc5c22bc49a2cc54$var$slice3d_
});

});

parcelRegister("6aiGU", function(module, exports) {

$parcel$export(module.exports, "slice4d", function () { return $47d22ce537a558f6$export$9833e35e879da26c; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $l7afw = parcelRequire("l7afw");
/**
 * Extracts a 4D slice from a 4D array starting at coordinates `begin` and
 * is of size `size`. See `slice` for details.
 */ function $47d22ce537a558f6$var$slice4d_(x, begin, size) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'slice4d');
    $eOiOM.assert($x.rank === 4, ()=>`slice4d expects a rank-4 tensor, but got a rank-${$x.rank} tensor`);
    return (0, $l7afw.slice)($x, begin, size);
}
const $47d22ce537a558f6$export$9833e35e879da26c = /* @__PURE__ */ (0, $6afhl.op)({
    slice4d_: $47d22ce537a558f6$var$slice4d_
});

});

parcelRegister("2J1JW", function(module, exports) {

$parcel$export(module.exports, "softmax", function () { return $1fc12242f135da97$export$e008137e76238601; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the softmax normalized vector given the logits.
 *
 * ```js
 * const a = tf.tensor1d([1, 2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * ```js
 * const a = tf.tensor2d([2, 4, 6, 1, 2, 3], [2, 3]);
 *
 * a.softmax().print();  // or tf.softmax(a)
 * ```
 *
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $1fc12242f135da97$var$softmax_(logits, dim = -1) {
    const $logits = (0, $x4eLk.convertToTensor)(logits, 'logits', 'softmax', 'float32');
    if (dim === -1) dim = $logits.rank - 1;
    if (dim !== $logits.rank - 1) throw Error('Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${$logits.rank} and dim was ${dim}`);
    const inputs = {
        logits: $logits
    };
    const attrs = {
        dim: dim
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Softmax), inputs, attrs);
}
const $1fc12242f135da97$export$e008137e76238601 = /* @__PURE__ */ (0, $6afhl.op)({
    softmax_: $1fc12242f135da97$var$softmax_
});

});

parcelRegister("acdVt", function(module, exports) {

$parcel$export(module.exports, "fft", function () { return $76c5d3c75b49e3a1$export$a535ef183b6128fa; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the inner-most
 * dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.fft().print();  // tf.spectral.fft(x).print();
 * ```
 * @param input The complex input to compute an fft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $76c5d3c75b49e3a1$var$fft_(input) {
    (0, $eOiOM.assert)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.fft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FFT), inputs);
}
const $76c5d3c75b49e3a1$export$a535ef183b6128fa = /* @__PURE__ */ (0, $6afhl.op)({
    fft_: $76c5d3c75b49e3a1$var$fft_
});

});

parcelRegister("69IWw", function(module, exports) {

$parcel$export(module.exports, "ifft", function () { return $47b6721013813017$export$776649b0bf8ce1fd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Inverse fast Fourier transform.
 *
 * Computes the inverse 1-dimensional discrete Fourier transform over the
 * inner-most dimension of input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([1, 2, 3]);
 * const x = tf.complex(real, imag);
 *
 * x.ifft().print();  // tf.spectral.ifft(x).print();
 * ```
 * @param input The complex input to compute an ifft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $47b6721013813017$var$ifft_(input) {
    (0, $eOiOM.assert)(input.dtype === 'complex64', ()=>`The dtype for tf.spectral.ifft() must be complex64 ` + `but got ${input.dtype}.`);
    const inputs = {
        input: input
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.IFFT), inputs);
}
const $47b6721013813017$export$776649b0bf8ce1fd = /* @__PURE__ */ (0, $6afhl.op)({
    ifft_: $47b6721013813017$var$ifft_
});

});

parcelRegister("mrJGu", function(module, exports) {

$parcel$export(module.exports, "irfft", function () { return $043791f324034c30$export$f47f4e5bcd3d6a66; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dyCpE = parcelRequire("dyCpE");

var $1goxr = parcelRequire("1goxr");

var $iXiJh = parcelRequire("iXiJh");

var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $6gKdw = parcelRequire("6gKdw");

var $8nMOl = parcelRequire("8nMOl");

var $5ApPj = parcelRequire("5ApPj");

var $7hONX = parcelRequire("7hONX");

var $l7afw = parcelRequire("l7afw");

var $69IWw = parcelRequire("69IWw");
/**
 * Inversed real value input fast Fourier transform.
 *
 * Computes the 1-dimensional inversed discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 * const imag = tf.tensor1d([0, 0, 0]);
 * const x = tf.complex(real, imag);
 *
 * x.irfft().print();
 * ```
 * @param input The real value input to compute an irfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $043791f324034c30$var$irfft_(input) {
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let ret;
    if (innerDimensionSize <= 2) {
        const complexInput = (0, $8nMOl.reshape)(input, [
            batch,
            innerDimensionSize
        ]);
        ret = (0, $69IWw.ifft)(complexInput);
    } else {
        // The length of unique components of the DFT of a real-valued signal
        // is 2 * (input_len - 1)
        const outputShape = [
            batch,
            2 * (innerDimensionSize - 1)
        ];
        const realInput = (0, $8nMOl.reshape)((0, $6gKdw.real)(input), [
            batch,
            innerDimensionSize
        ]);
        const imagInput = (0, $8nMOl.reshape)((0, $iXiJh.imag)(input), [
            batch,
            innerDimensionSize
        ]);
        const realConjugate = (0, $5ApPj.reverse)((0, $l7afw.slice)(realInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1);
        const imagConjugate = (0, $5hAos.mul)((0, $5ApPj.reverse)((0, $l7afw.slice)(imagInput, [
            0,
            1
        ], [
            batch,
            innerDimensionSize - 2
        ]), 1), (0, $7hONX.scalar)(-1));
        const r = (0, $1goxr.concat)([
            realInput,
            realConjugate
        ], 1);
        const i = (0, $1goxr.concat)([
            imagInput,
            imagConjugate
        ], 1);
        const complexInput = (0, $8nMOl.reshape)((0, $dyCpE.complex)(r, i), [
            outputShape[0],
            outputShape[1]
        ]);
        ret = (0, $69IWw.ifft)(complexInput);
    }
    ret = (0, $6gKdw.real)(ret);
    // reshape the result if the input is 3D tensor.
    if (input.rank === 3 && input.shape[0] !== 0) {
        const temp = ret;
        const batch = input.shape[0];
        ret = (0, $8nMOl.reshape)(ret, [
            batch,
            ret.shape[0] / batch,
            ret.shape[1]
        ]);
        temp.dispose();
    }
    return ret;
}
const $043791f324034c30$export$f47f4e5bcd3d6a66 = /* @__PURE__ */ (0, $6afhl.op)({
    irfft_: $043791f324034c30$var$irfft_
});

});

parcelRegister("22B8v", function(module, exports) {

$parcel$export(module.exports, "rfft", function () { return $17c8932aae5330fd$export$72aff1768917e9e5; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");

var $dyCpE = parcelRequire("dyCpE");

var $1goxr = parcelRequire("1goxr");

var $iXiJh = parcelRequire("iXiJh");

var $6afhl = parcelRequire("6afhl");

var $6gKdw = parcelRequire("6gKdw");

var $8nMOl = parcelRequire("8nMOl");

var $l7afw = parcelRequire("l7afw");

var $crriC = parcelRequire("crriC");

var $lxzgt = parcelRequire("lxzgt");

var $cztsD = parcelRequire("cztsD");

var $acdVt = parcelRequire("acdVt");
/**
 * Real value input fast Fourier transform.
 *
 * Computes the 1-dimensional discrete Fourier transform over the
 * inner-most dimension of the real input.
 *
 * ```js
 * const real = tf.tensor1d([1, 2, 3]);
 *
 * real.rfft().print();
 * ```
 * @param input The real value input to compute an rfft over.
 *
 * @doc {heading: 'Operations', subheading: 'Spectral', namespace: 'spectral'}
 */ function $17c8932aae5330fd$var$rfft_(input, fftLength) {
    (0, $eOiOM.assert)(input.dtype === 'float32', ()=>`The dtype for rfft() must be real value but got ${input.dtype}`);
    let innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = input.size / innerDimensionSize;
    let adjustedInput;
    if (fftLength != null && fftLength < innerDimensionSize) {
        // Need to crop
        const begin = input.shape.map((v)=>0);
        const size = input.shape.map((v)=>v);
        size[input.shape.length - 1] = fftLength;
        adjustedInput = (0, $l7afw.slice)(input, begin, size);
        innerDimensionSize = fftLength;
    } else if (fftLength != null && fftLength > innerDimensionSize) {
        // Need to pad with zeros
        const zerosShape = input.shape.map((v)=>v);
        zerosShape[input.shape.length - 1] = fftLength - innerDimensionSize;
        adjustedInput = (0, $1goxr.concat)([
            input,
            (0, $lxzgt.zeros)(zerosShape)
        ], input.shape.length - 1);
        innerDimensionSize = fftLength;
    } else adjustedInput = input;
    // Complement the input with zero imaginary numbers.
    const zerosInput = (0, $cztsD.zerosLike)(adjustedInput);
    const complexInput = (0, $8nMOl.reshape)((0, $dyCpE.complex)(adjustedInput, zerosInput), [
        batch,
        innerDimensionSize
    ]);
    const ret = (0, $acdVt.fft)(complexInput);
    // Exclude complex conjugations. These conjugations are put symmetrically.
    const half = Math.floor(innerDimensionSize / 2) + 1;
    const realValues = (0, $6gKdw.real)(ret);
    const imagValues = (0, $iXiJh.imag)(ret);
    const realComplexConjugate = (0, $crriC.split)(realValues, [
        half,
        innerDimensionSize - half
    ], realValues.shape.length - 1);
    const imagComplexConjugate = (0, $crriC.split)(imagValues, [
        half,
        innerDimensionSize - half
    ], imagValues.shape.length - 1);
    const outputShape = adjustedInput.shape.slice();
    outputShape[adjustedInput.shape.length - 1] = half;
    return (0, $8nMOl.reshape)((0, $dyCpE.complex)(realComplexConjugate[0], imagComplexConjugate[0]), outputShape);
}
const $17c8932aae5330fd$export$72aff1768917e9e5 = /* @__PURE__ */ (0, $6afhl.op)({
    rfft_: $17c8932aae5330fd$var$rfft_
});

});
parcelRegister("crriC", function(module, exports) {

$parcel$export(module.exports, "split", function () { return $90ed2ebc580a2335$export$65980d18b75784e2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Splits a `tf.Tensor` into sub tensors.
 *
 * If `numOrSizeSplits` is a number, splits `x` along dimension `axis`
 * into `numOrSizeSplits` smaller tensors.
 * Requires that `numOrSizeSplits` evenly divides `x.shape[axis]`.
 *
 * If `numOrSizeSplits` is a number array, splits `x` into
 * `numOrSizeSplits.length` pieces. The shape of the `i`-th piece has the
 * same size as `x` except along dimension `axis` where the size is
 * `numOrSizeSplits[i]`.
 *
 * ```js
 * const x = tf.tensor2d([1, 2, 3, 4, 5, 6, 7, 8], [2, 4]);
 * const [a, b] = tf.split(x, 2, 1);
 * a.print();
 * b.print();
 *
 * const [c, d, e] = tf.split(x, [1, 2, 1], 1);
 * c.print();
 * d.print();
 * e.print();
 * ```
 *
 * @param x The input tensor to split.
 * @param numOrSizeSplits Either an integer indicating the number of
 * splits along the axis or an array of integers containing the sizes of
 * each output tensor along the axis. If a number then it must evenly divide
 * `x.shape[axis]`; otherwise the sum of sizes must match `x.shape[axis]`.
 * Can contain one -1 indicating that dimension is to be inferred.
 * @param axis The dimension along which to split. Defaults to 0 (the first
 * dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $90ed2ebc580a2335$var$split_(x, numOrSizeSplits, axis = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'split');
    const inputs = {
        x: $x
    };
    const attr = {
        numOrSizeSplits: numOrSizeSplits,
        axis: axis
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SplitV), inputs, attr);
}
const $90ed2ebc580a2335$export$65980d18b75784e2 = /* @__PURE__ */ (0, $6afhl.op)({
    split_: $90ed2ebc580a2335$var$split_
});

});


parcelRegister("fqiRx", function(module, exports) {

$parcel$export(module.exports, "squaredDifference", function () { return $b3a7ea6e0aa0b791$export$b178697fb6d0b37f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $5mf1d = parcelRequire("5mf1d");

var $6afhl = parcelRequire("6afhl");
/**
 * Returns (a - b) * (a - b) element-wise.
 * Supports broadcasting.
 *
 * ```js
 * const a = tf.tensor1d([1, 4, 3, 16]);
 * const b = tf.tensor1d([1, 2, 9, 4]);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * ```js
 * // Broadcast squared difference  a with b.
 * const a = tf.tensor1d([2, 4, 6, 8]);
 * const b = tf.scalar(5);
 *
 * a.squaredDifference(b).print();  // or tf.squaredDifference(a, b)
 * ```
 *
 * @param a The first tensor.
 * @param b The second tensor. Must have the same type as `a`.
 *
 * @doc {heading: 'Operations', subheading: 'Arithmetic'}
 */ function $b3a7ea6e0aa0b791$var$squaredDifference_(a, b) {
    let $a = (0, $x4eLk.convertToTensor)(a, 'a', 'squaredDifference');
    let $b = (0, $x4eLk.convertToTensor)(b, 'b', 'squaredDifference');
    [$a, $b] = (0, $gpWQN.makeTypesMatch)($a, $b);
    (0, $5mf1d.assertAndGetBroadcastShape)($a.shape, $b.shape);
    const inputs = {
        a: $a,
        b: $b
    };
    const attrs = {};
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SquaredDifference), inputs, attrs);
}
const $b3a7ea6e0aa0b791$export$b178697fb6d0b37f = /* @__PURE__ */ (0, $6afhl.op)({
    squaredDifference_: $b3a7ea6e0aa0b791$var$squaredDifference_
});

});

parcelRegister("gP42y", function(module, exports) {

$parcel$export(module.exports, "squeeze", function () { return $c3f48b11c8f59679$export$889c931173b77c2f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Removes dimensions of size 1 from the shape of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor([1, 2, 3, 4], [1, 1, 4]);
 * x.squeeze().print();
 * ```
 *
 * @param x The input tensor to be squeezed.
 * @param axis An optional list of numbers. If specified, only
 *     squeezes the dimensions listed. The dimension index starts at 0. It
 * is an error to squeeze a dimension that is not 1.
 *
 * @doc {heading: 'Tensors', subheading: 'Transformations'}
 */ function $c3f48b11c8f59679$var$squeeze_(x, axis) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'squeeze', 'string_or_numeric');
    return (0, $8nMOl.reshape)($x, (0, $eOiOM.squeezeShape)($x.shape, axis).newShape);
}
const $c3f48b11c8f59679$export$889c931173b77c2f = /* @__PURE__ */ (0, $6afhl.op)({
    squeeze_: $c3f48b11c8f59679$var$squeeze_
});

});

parcelRegister("lq9U1", function(module, exports) {

$parcel$export(module.exports, "stack", function () { return $f983b52209b35d59$export$a57ab32f40f83ea9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Stacks a list of rank-`R` `tf.Tensor`s into one rank-`(R+1)` `tf.Tensor`.
 *
 * ```js
 * const a = tf.tensor1d([1, 2]);
 * const b = tf.tensor1d([3, 4]);
 * const c = tf.tensor1d([5, 6]);
 * tf.stack([a, b, c]).print();
 * ```
 *
 * @param tensors A list of tensor objects with the same shape and dtype.
 * @param axis The axis to stack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $f983b52209b35d59$var$stack_(tensors, axis = 0) {
    const $tensors = (0, $x4eLk.convertToTensorArray)(tensors, 'tensors', 'stack', 'string_or_numeric');
    $eOiOM.assert($tensors.length >= 1, ()=>'Pass at least one tensor to tf.stack');
    if ($tensors.length > 0) $eOiOM.assert(axis <= $tensors[0].rank, ()=>'Axis must be <= rank of the tensor');
    const inputs = $tensors;
    const attrs = {
        axis: axis
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Pack), inputs, attrs);
}
const $f983b52209b35d59$export$a57ab32f40f83ea9 = /* @__PURE__ */ (0, $6afhl.op)({
    stack_: $f983b52209b35d59$var$stack_
});

});

parcelRegister("6Ygvg", function(module, exports) {

$parcel$export(module.exports, "stridedSlice", function () { return $513525df04201ec4$export$4ae57224f3b0605c; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Extracts a strided slice of a tensor.
 *
 * Roughly speaking, this op extracts a slice of size (end-begin)/stride from
 * the given input tensor (x). Starting at the location specified by begin the
 * slice continues by adding stride to the index until all dimensions are not
 * less than end. Note that a stride can be negative, which causes a reverse
 * slice.
 *
 * ```js
 * const t = tf.tensor3d([1, 1, 1 ,2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6],
 *    [3, 2, 3]);
 * t.stridedSlice([1, 0, 0], [2, 1, 3], [1, 1, 1]).print()  // [[[3, 3, 3]]]
 * t.stridedSlice([1, 0, 0], [2, 2, 3], [1, 1, 1]).print()  // [[[3, 3, 3],
 *                                                     // [4, 4, 4]]]
 * t.stridedSlice([1, -1, 0], [2, -3, 3], [1, -1, 1]).print() // [[[4, 4, 4],
 *                                                     // [3, 3, 3]]]
 * ```
 *
 * @param x The tensor to stride slice.
 * @param begin The coordinates to start the slice from.
 * @param end: The coordinates to end the slice at.
 * @param strides: The size of the slice.
 * @param beginMask: If the ith bit of beginMask is set, begin[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param endMask: If the ith bit of endMask is set, end[i] is ignored
 *      and the fullest possible range in that dimension is used instead.
 * @param shrinkAxisMask: a bitmask where bit i implies that
 * the ith specification should shrink the dimensionality. begin and end must
 * imply a slice of size 1 in the dimension.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $513525df04201ec4$var$stridedSlice_(x, begin, end, strides, beginMask = 0, endMask = 0, ellipsisMask = 0, newAxisMask = 0, shrinkAxisMask = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'stridedSlice', 'string_or_numeric');
    const inputs = {
        x: $x
    };
    const attrs = {
        begin: begin,
        end: end,
        strides: strides,
        beginMask: beginMask,
        endMask: endMask,
        ellipsisMask: ellipsisMask,
        newAxisMask: newAxisMask,
        shrinkAxisMask: shrinkAxisMask
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.StridedSlice), inputs, attrs);
}
const $513525df04201ec4$export$4ae57224f3b0605c = /* @__PURE__ */ (0, $6afhl.op)({
    stridedSlice_: $513525df04201ec4$var$stridedSlice_
});

});

parcelRegister("dEDAz", function(module, exports) {

$parcel$export(module.exports, "tan", function () { return $9f0db84b9ef5695b$export$fcdd3b0b3246a325; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes tan of the input `tf.Tensor` element-wise, `tan(x)`
 *
 * ```js
 * const x = tf.tensor1d([0, Math.PI / 2, Math.PI * 3 / 4]);
 *
 * x.tan().print();  // or tf.tan(x)
 * ```
 * @param x The input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Basic math'}
 */ function $9f0db84b9ef5695b$var$tan_(x) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'tan', 'float32');
    const inputs = {
        x: $x
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Tan), inputs);
}
const $9f0db84b9ef5695b$export$fcdd3b0b3246a325 = /* @__PURE__ */ (0, $6afhl.op)({
    tan_: $9f0db84b9ef5695b$var$tan_
});

});

parcelRegister("8tOOR", function(module, exports) {

$parcel$export(module.exports, "tensor1d", function () { return $62c873d0e1a62372$export$8133e3bf3cd8f464; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $cxc40 = parcelRequire("cxc40");
function $62c873d0e1a62372$export$8133e3bf3cd8f464(values, dtype) {
    (0, $eOiOM.assertNonNull)(values);
    const inferredShape = (0, $x4eLk.inferShape)(values, dtype);
    if (inferredShape.length !== 1) throw new Error('tensor1d() requires values to be a flat/TypedArray');
    const shape = null;
    return (0, $cxc40.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("9NdGd", function(module, exports) {

$parcel$export(module.exports, "tensor2d", function () { return $72134d35663e6d15$export$b5469a65e8732256; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $cxc40 = parcelRequire("cxc40");
function $72134d35663e6d15$export$b5469a65e8732256(values, shape, dtype) {
    (0, $eOiOM.assertNonNull)(values);
    if (shape != null && shape.length !== 2) throw new Error('tensor2d() requires shape to have two numbers');
    const inferredShape = (0, $x4eLk.inferShape)(values, dtype);
    if (inferredShape.length !== 2 && inferredShape.length !== 1) throw new Error('tensor2d() requires values to be number[][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
    return (0, $cxc40.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("3XeZf", function(module, exports) {

$parcel$export(module.exports, "tensor4d", function () { return $2e1281e14bbaed3d$export$b43603ce4e7542a7; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $cxc40 = parcelRequire("cxc40");
function $2e1281e14bbaed3d$export$b43603ce4e7542a7(values, shape, dtype) {
    (0, $eOiOM.assertNonNull)(values);
    if (shape != null && shape.length !== 4) throw new Error('tensor4d() requires shape to have four numbers');
    const inferredShape = (0, $x4eLk.inferShape)(values, dtype);
    if (inferredShape.length !== 4 && inferredShape.length !== 1) throw new Error('tensor4d() requires values to be number[][][][] or flat/TypedArray');
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
    return (0, $cxc40.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("elLea", function(module, exports) {

$parcel$export(module.exports, "tensor5d", function () { return $a727a93d88098660$export$ab0278981fc9e727; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $cxc40 = parcelRequire("cxc40");
function $a727a93d88098660$export$ab0278981fc9e727(values, shape, dtype) {
    (0, $eOiOM.assertNonNull)(values);
    if (shape != null && shape.length !== 5) throw new Error('tensor5d() requires shape to have five numbers');
    const inferredShape = (0, $x4eLk.inferShape)(values, dtype);
    if (inferredShape.length !== 5 && inferredShape.length !== 1) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
    return (0, $cxc40.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("lmWT0", function(module, exports) {

$parcel$export(module.exports, "tensor6d", function () { return $f8e954a1573849cc$export$7b9f27dd2306a502; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $cxc40 = parcelRequire("cxc40");
function $f8e954a1573849cc$export$7b9f27dd2306a502(values, shape, dtype) {
    (0, $eOiOM.assertNonNull)(values);
    if (shape != null && shape.length !== 6) throw new Error('tensor6d() requires shape to have six numbers');
    const inferredShape = (0, $x4eLk.inferShape)(values, dtype);
    if (inferredShape.length !== 6 && inferredShape.length !== 1) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");
    if (inferredShape.length === 1 && shape == null) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
    shape = shape || inferredShape;
    return (0, $cxc40.makeTensor)(values, shape, inferredShape, dtype);
}

});

parcelRegister("cdxCY", function(module, exports) {

$parcel$export(module.exports, "tensorScatterUpdate", function () { return $8e50c8ab816d3f61$export$d3ac02769385eb36; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");

var $hyHdD = parcelRequire("hyHdD");
/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices to the passed in tensor according to
 * indices. This operator is the similar to scatterNd op, except that the
 * udpates are scattered on an existing tensor (as opposed to a zero-tensor).
 *
 * If indices contains duplicates, then we pick the last update for the index.
 *
 * If an out of bound index is found on CPU, an error is returned.
 *
 * Warning: There are some GPU specific semantics for this operation.
 *  - If an out of bound index is found, the index is ignored.
 *  - The order in which updates are applied is nondeterministic, so the output
 * will be nondeterministic if indices contains duplicates.
 * ```js
 * const shape = [8];
 * const tensor = tf.ones(shape);
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 *
 * tf.tensorScatterUpdate(tensor, indices, updates).print();
 *    //[1, 11, 1, 10, 9, 1, 1, 12]
 * ```
 *
 * @param tensor A Tensor. Tensor to copy/update.
 * @param indices The tensor contains the indices into the output tensor, must
 *     have at least 2 axes: (num_updates, index_depth).
 * @param updates The tensor contains the value for the indices.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $8e50c8ab816d3f61$var$tensorScatterUpdate_(tensor, indices, updates) {
    const $tensor = (0, $x4eLk.convertToTensor)(tensor, 'tensor', 'tensorScatterupdate');
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'tensorScatterupdate', 'int32');
    const $updates = (0, $x4eLk.convertToTensor)(updates, 'updates', 'tensorScatterupdate');
    $hyHdD.validateInput($updates, $indices, $tensor.shape);
    if ($tensor.dtype !== $updates.dtype) throw new Error(`tensor and updates must have the same dtype, instead they are ${$tensor.dtype} and ${$updates.dtype}.`);
    const inputs = {
        tensor: $tensor,
        indices: $indices,
        updates: $updates
    };
    const attrs = {};
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.TensorScatterUpdate), inputs, attrs);
}
const $8e50c8ab816d3f61$export$d3ac02769385eb36 = (0, $6afhl.op)({
    tensorScatterUpdate_: $8e50c8ab816d3f61$var$tensorScatterUpdate_
});

});

parcelRegister("7vZaO", function(module, exports) {

$parcel$export(module.exports, "topk", function () { return $578ae1661b14c9c4$export$4e6b28a600f8b4df; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Finds the values and indices of the `k` largest entries along the last
 * dimension.
 *
 * If the input is a vector (rank=1), finds the k largest entries in the vector
 * and outputs their values and indices as vectors. Thus values[j] is the j-th
 * largest entry in input, and its index is indices[j].
 * For higher rank inputs, computes the top k entries along the last dimension.
 *
 * If two elements are equal, the lower-index element appears first.
 *
 * ```js
 * const a = tf.tensor2d([[1, 5], [4, 3]]);
 * const {values, indices} = tf.topk(a);
 * values.print();
 * indices.print();
 * ```
 * @param x 1-D or higher `tf.Tensor` with last dimension being at least `k`.
 * @param k Number of top elements to look for along the last dimension.
 * @param sorted If true, the resulting `k` elements will be sorted by the
 *     values in descending order.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $578ae1661b14c9c4$var$topk_(x, k = 1, sorted = true) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'topk');
    if ($x.rank === 0) throw new Error('topk() expects the input to be of rank 1 or higher');
    const lastDim = $x.shape[$x.shape.length - 1];
    if (k < 0) throw new Error(`'k' passed to topk() must be >= 0 but got ${k}`);
    if (k > lastDim) throw new Error(`'k' passed to topk() must be <= the last dimension (${lastDim}) ` + `but got ${k}`);
    const inputs = {
        x: $x
    };
    const attrs = {
        k: k,
        sorted: sorted
    };
    const [values, indices] = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.TopK), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $578ae1661b14c9c4$export$4e6b28a600f8b4df = /* @__PURE__ */ (0, $6afhl.op)({
    topk_: $578ae1661b14c9c4$var$topk_
});

});

parcelRegister("9VTJm", function(module, exports) {

$parcel$export(module.exports, "truncatedNormal", function () { return $73b4aae00822c5a8$export$8ad5625727f3fa1d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");

var $5siju = parcelRequire("5siju");

var $6afhl = parcelRequire("6afhl");

var $5ZlCt = parcelRequire("5ZlCt");
/**
 * Creates a `tf.Tensor` with values sampled from a truncated normal
 * distribution.
 *
 * ```js
 * tf.truncatedNormal([2, 2]).print();
 * ```
 *
 * The generated values follow a normal distribution with specified mean and
 * standard deviation, except that values whose magnitude is more than 2
 * standard deviations from the mean are dropped and re-picked.
 *
 * @param shape An array of integers defining the output tensor shape.
 * @param mean The mean of the normal distribution.
 * @param stdDev The standard deviation of the normal distribution.
 * @param dtype The data type of the output tensor.
 * @param seed The seed for the random number generator.
 *
 * @doc {heading: 'Tensors', subheading: 'Creation'}
 */ function $73b4aae00822c5a8$var$truncatedNormal_(shape, mean = 0, stdDev = 1, dtype, seed) {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    if (dtype != null && dtype === 'bool') throw new Error(`Unsupported data type $ { dtype }`);
    const randGauss = new (0, $5ZlCt.MPRandGauss)(mean, stdDev, dtype, true, seed);
    const res = (0, $5siju.buffer)(shape, dtype);
    for(let i = 0; i < res.values.length; i++)res.values[i] = randGauss.nextValue();
    return res.toTensor();
}
const $73b4aae00822c5a8$export$8ad5625727f3fa1d = /* @__PURE__ */ (0, $6afhl.op)({
    truncatedNormal_: $73b4aae00822c5a8$var$truncatedNormal_
});

});

parcelRegister("f7XaS", function(module, exports) {

$parcel$export(module.exports, "unique", function () { return $b03569469ea2f8a6$export$7a5d5c156e7dc406; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Finds unique elements along an axis of a tensor.
 *
 * It returns a tensor `values` containing all of the unique elements along the
 * `axis` of the given tensor `x` in the same order that they occur along the
 * `axis` in `x`; `x` does not need to be sorted. It also returns a tensor
 * `indices` the same size as the number of the elements in `x` along the `axis`
 * dimension. It contains the index in the unique output `values`.
 *
 * ```js
 * // A 1-D tensor
 * const a = tf.tensor1d([1, 1, 2, 4, 4, 4, 7, 8, 8]);
 * const {values, indices} = tf.unique(a);
 * values.print();   // [1, 2, 4, 7, 8,]
 * indices.print();  // [0, 0, 1, 2, 2, 2, 3, 4, 4]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=0
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 0)
 * values.print();   // [[1, 0, 0],
 *                   //  [2, 0, 0]]
 * indices.print();  // [0, 0, 1]
 * ```
 *
 * ```js
 * // A 2-D tensor with axis=1
 * //
 * // 'a' is: [[1, 0, 0],
 * //          [1, 0, 0],
 * //          [2, 0, 0]]
 * const a = tf.tensor2d([[1, 0, 0], [1, 0, 0], [2, 0, 0]]);
 * const {values, indices} = tf.unique(a, 1)
 * values.print();   // [[1, 0],
 *                   //  [1, 0],
 *                   //  [2, 0]]
 * indices.print();  // [0, 1, 1]
 * ```
 * @param x A tensor (int32, string, bool).
 * @param axis The axis of the tensor to find the unique elements.
 * @returns [uniqueElements, indices] (see above for details)
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ function $b03569469ea2f8a6$var$unique_(x, axis = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'unique', 'string_or_numeric');
    (0, $eOiOM.assert)($x.rank > 0, ()=>'The input tensor must be at least 1D');
    const inputs = {
        x: $x
    };
    const attrs = {
        axis: axis
    };
    const [values, indices] = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Unique), inputs, attrs);
    return {
        values: values,
        indices: indices
    };
}
const $b03569469ea2f8a6$export$7a5d5c156e7dc406 = /* @__PURE__ */ (0, $6afhl.op)({
    unique_: $b03569469ea2f8a6$var$unique_
});

});

parcelRegister("2uE72", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSum", function () { return $1d0d7fa2d9c24612$export$ba7c4d144d85a309; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the sum along segments of a `tf.Tensor`.
 *
 * ```js
 * const x = tf.tensor1d([1, 2, 3, 4]);
 * const segmentIds = tf.tensor1d([1, 2, 0, 1], 'int32');
 * const numSegments = 3;
 *
 * x.unsortedSegmentSum(segmentIds, numSegments).print()
 * //or tf.unsortedSegmentSum(x, segmentIds, numSegments)
 * ```
 * @param x The `tf.Tensor` that will be summed along its segments.
 * @param segmentIds A `tf.Tensor1D` whose rank is equal to the rank of `x`'s
 * dimension along the `axis`.  Maps each element of `x` to a segment.
 * @param numSegments The number of distinct `segmentIds`.
 *
 * @doc {heading: 'Operations', subheading: 'Segment'}
 */ function $1d0d7fa2d9c24612$var$unsortedSegmentSum_(x, segmentIds, numSegments) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'unsortedSegmentSum');
    const $segmentIds = (0, $x4eLk.convertToTensor)(segmentIds, 'segmentIds', 'unsortedSegmentSum', 'int32');
    (0, $eOiOM.assert)((0, $eOiOM.isInt)(numSegments), ()=>'numSegments must be of dtype int');
    const inputs = {
        x: $x,
        segmentIds: $segmentIds
    };
    const attrs = {
        numSegments: numSegments
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.UnsortedSegmentSum), inputs, attrs);
}
const $1d0d7fa2d9c24612$export$ba7c4d144d85a309 = /* @__PURE__ */ (0, $6afhl.op)({
    unsortedSegmentSum_: $1d0d7fa2d9c24612$var$unsortedSegmentSum_
});

});

parcelRegister("3mzDh", function(module, exports) {

$parcel$export(module.exports, "unstack", function () { return $272f1113fcefefaa$export$3c05285afa115eec; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Unstacks a `tf.Tensor` of rank-`R` into a list of rank-`(R-1)` `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4], [2, 2]);
 *
 * tf.unstack(a).forEach(tensor => tensor.print());
 * ```
 *
 * @param x A tensor object.
 * @param axis The axis to unstack along. Defaults to 0 (the first dim).
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ function $272f1113fcefefaa$var$unstack_(x, axis = 0) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'unstack', 'string_or_numeric');
    $eOiOM.assert(axis >= -$x.shape.length && axis < $x.shape.length, ()=>`Axis = ${axis} is not in [-${$x.shape.length}, ${$x.shape.length})`);
    const inputs = {
        value: $x
    };
    const attrs = {
        axis: axis
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Unpack), inputs, attrs);
}
const $272f1113fcefefaa$export$3c05285afa115eec = /* @__PURE__ */ (0, $6afhl.op)({
    unstack_: $272f1113fcefefaa$var$unstack_
});

});

parcelRegister("gYvpj", function(module, exports) {

$parcel$export(module.exports, "upperBound", function () { return $c5ba9cc2b626326c$export$1e7f253df265a2ba; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $V8cuc = parcelRequire("V8cuc");
function $c5ba9cc2b626326c$export$1e7f253df265a2ba(sortedSequence, values) {
    return (0, $V8cuc.searchSorted)(sortedSequence, values, 'right');
}

});

parcelRegister("ftQEj", function(module, exports) {

$parcel$export(module.exports, "variable", function () { return $b4526781abedd0e1$export$3a9d57cefcd2c285; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");
function $b4526781abedd0e1$export$3a9d57cefcd2c285(initialValue, trainable = true, name, dtype) {
    return (0, $e6Ey6.ENGINE).makeVariable(initialValue, trainable, name, dtype);
}

});

parcelRegister("aR8Ls", function(module, exports) {

$parcel$export(module.exports, "whereAsync", function () { return $7e75a70f49579661$export$b95962138b7a377d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4vdaQ = parcelRequire("4vdaQ");

var $x4eLk = parcelRequire("x4eLk");
/**
 * Returns the coordinates of true elements of condition.
 *
 * The coordinates are returned in a 2-D tensor where the first dimension (rows)
 * represents the number of true elements, and the second dimension (columns)
 * represents the coordinates of the true elements. Keep in mind, the shape of
 * the output tensor can vary depending on how many true values there are in
 * input. Indices are output in row-major order. The resulting tensor has the
 * shape `[numTrueElems, condition.rank]`.
 *
 * This is analogous to calling the python `tf.where(cond)` without an x or y.
 *
 * ```js
 * const cond = tf.tensor1d([false, false, true], 'bool');
 * const result = await tf.whereAsync(cond);
 * result.print();
 * ```
 *
 * @doc {heading: 'Operations', subheading: 'Logical'}
 */ async function $7e75a70f49579661$var$whereAsync_(condition) {
    const $condition = (0, $x4eLk.convertToTensor)(condition, 'condition', 'whereAsync', 'bool');
    const vals = await $condition.data();
    const res = (0, $4vdaQ.whereImpl)($condition.shape, vals);
    if (condition !== $condition) $condition.dispose();
    return res;
}
const $7e75a70f49579661$export$b95962138b7a377d = $7e75a70f49579661$var$whereAsync_;

});
parcelRegister("4vdaQ", function(module, exports) {

$parcel$export(module.exports, "whereImpl", function () { return $347446c04f55c9a5$export$3a1005f93c3f4453; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the Where kernel shared between cpu and webgl */ 
var $5siju = parcelRequire("5siju");
function $347446c04f55c9a5$export$3a1005f93c3f4453(condShape, condVals) {
    const indices = [];
    for(let i = 0; i < condVals.length; i++)if (condVals[i]) indices.push(i);
    const inBuffer = (0, $5siju.buffer)(condShape, 'int32');
    const out = (0, $5siju.buffer)([
        indices.length,
        condShape.length
    ], 'int32');
    for(let i = 0; i < indices.length; i++){
        const loc = inBuffer.indexToLoc(indices[i]);
        const offset = i * condShape.length;
        out.values.set(loc, offset);
    }
    return out.toTensor();
}

});


parcelRegister("4dHgV", function(module, exports) {

$parcel$export(module.exports, "booleanMaskAsync", function () { return $3129f1383b11f3ff$export$358a56c181f796b3; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $eFeE9 = parcelRequire("eFeE9");

var $8nMOl = parcelRequire("8nMOl");

var $gP42y = parcelRequire("gP42y");

var $aR8Ls = parcelRequire("aR8Ls");
/**
 * Apply boolean mask to tensor.
 *
 * ```js
 * const tensor = tf.tensor2d([1, 2, 3, 4, 5, 6], [3, 2]);
 * const mask = tf.tensor1d([1, 0, 1], 'bool');
 * const result = await tf.booleanMaskAsync(tensor, mask);
 * result.print();
 * ```
 *
 * @param tensor N-D tensor.
 * @param mask K-D boolean tensor, K <= N and K must be known statically.
 * @param axis A 0-D int Tensor representing the axis in tensor to mask from.
 *     By default, axis is 0 which will mask from the first dimension.
 *     Otherwise K + axis <= N.
 *
 * @doc {heading: 'Tensors', subheading: 'Slicing and Joining'}
 */ async function $3129f1383b11f3ff$var$booleanMaskAsync_(tensor, mask, axis) {
    const $tensor = (0, $x4eLk.convertToTensor)(tensor, 'tensor', 'boolMask');
    const $mask = (0, $x4eLk.convertToTensor)(mask, 'mask', 'boolMask', 'bool');
    const axisFrom = axis == null ? 0 : axis;
    const maskDim = $mask.rank;
    const tensorShape = $tensor.shape;
    $eOiOM.assert(maskDim > 0, ()=>'mask cannot be scalar');
    $eOiOM.assertShapesMatch(tensorShape.slice(axisFrom, axisFrom + maskDim), $mask.shape, `mask's shape must match the first K dimensions of tensor's shape,`);
    let leadingSize = 1;
    for(let i = axisFrom; i < axisFrom + maskDim; i++)leadingSize *= tensorShape[i];
    const targetTensorShape = tensorShape.slice(0, axisFrom).concat([
        leadingSize
    ], tensorShape.slice(axisFrom + maskDim));
    const reshapedTensor = (0, $8nMOl.reshape)($tensor, targetTensorShape);
    const reshapedMask = (0, $8nMOl.reshape)($mask, [
        -1
    ]);
    const positivePositions = await (0, $aR8Ls.whereAsync)(reshapedMask);
    const indices = (0, $gP42y.squeeze)(positivePositions, [
        1
    ]);
    const res = (0, $eFeE9.gather)(reshapedTensor, indices, axisFrom);
    // Ensure no memory leak.
    if (tensor !== $tensor) $tensor.dispose();
    if (mask !== $mask) $mask.dispose();
    indices.dispose();
    reshapedTensor.dispose();
    reshapedMask.dispose();
    positivePositions.dispose();
    return res;
}
const $3129f1383b11f3ff$export$358a56c181f796b3 = $3129f1383b11f3ff$var$booleanMaskAsync_;

});

parcelRegister("9c2so", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $6b1723efdd9815e3$export$9cb09a71b7d66923; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $dyCpE = parcelRequire("dyCpE");

var $iXiJh = parcelRequire("iXiJh");

var $jMlCE = parcelRequire("jMlCE");

var $6afhl = parcelRequire("6afhl");

var $6gKdw = parcelRequire("6gKdw");
/**
 * Transposes the `tf.Tensor`. Permutes the dimensions according to `perm`.
 *
 * The returned `tf.Tensor`'s dimension `i` will correspond to the input
 * dimension `perm[i]`. If `perm` is not given, it is set to `[n-1...0]`,
 * where `n` is the rank of the input `tf.Tensor`. Hence by default, this
 * operation performs a regular matrix transpose on 2-D input `tf.Tensor`s.
 *
 * ```js
 * const a = tf.tensor2d([1, 2, 3, 4, 5, 6], [2, 3]);
 *
 * a.transpose().print();  // or tf.transpose(a)
 * ```
 *
 * @param x The tensor to transpose.
 * @param perm The permutation of the dimensions of a.
 * @param conjugate Will conjugate complex input if true.
 *
 * @doc {heading: 'Operations', subheading: 'Matrices'}
 */ function $6b1723efdd9815e3$var$transpose_(x, perm, conjugate) {
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'transpose');
    if (perm == null) perm = $x.shape.map((s, i)=>i).reverse();
    $eOiOM.assert($x.rank === perm.length, ()=>`Error in transpose: rank of input ${$x.rank} ` + `must match length of perm ${perm}.`);
    perm.forEach((axis)=>{
        $eOiOM.assert(axis >= 0 && axis < $x.rank, ()=>`All entries in 'perm' must be between 0 and ${$x.rank - 1}` + ` but got ${perm}`);
    });
    if ($x.rank <= 1) return $x.clone();
    const inputs = {
        x: $x
    };
    const attrs = {
        perm: perm
    };
    if ($x.dtype === 'complex64') return (0, $d7Nxs.tidy)(()=>{
        let $real = (0, $6gKdw.real)($x);
        let $imag = (0, $iXiJh.imag)($x);
        $real = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Transpose), {
            x: $real
        }, attrs);
        $imag = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Transpose), {
            x: $imag
        }, attrs);
        if (conjugate) $imag = (0, $jMlCE.neg)($imag);
        return (0, $dyCpE.complex)($real, $imag);
    });
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Transpose), inputs, attrs);
}
const $6b1723efdd9815e3$export$9cb09a71b7d66923 = /* @__PURE__ */ (0, $6afhl.op)({
    transpose_: $6b1723efdd9815e3$var$transpose_
});

});

parcelRegister("dFPio", function(module, exports) {

$parcel$export(module.exports, "movingAverage", function () { return $9f46e4edc77dd140$export$e0ccbd22a5b3aab6; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gpWQN = parcelRequire("gpWQN");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6Ab5n = parcelRequire("6Ab5n");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $eCViQ = parcelRequire("eCViQ");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");
/**
 * Compute the moving average of a variable.
 *
 * Without zeroDebias, the moving average operation is defined by:
 *   `v += delta`
 * where
 *   `delta = (1 - decay) * (x - v)`
 *
 * With zeroDebias (default), the `delta` term is scaled to debias the
 * effect of the (assumed) zero-initialization of `v`.
 *   `delta /= (1 - decay ^ step)`
 *
 * For more details on the zero-debiasing algorithm, see:
 *   https://arxiv.org/abs/1412.6980
 *
 * Note that this function is completely stateless and does not keep track of
 * step count. The step count needs to be maintained by the caller and passed
 * in as `step`.
 *
 * @param v The current moving average value.
 * @param x New input value, must have the same shape and dtype as `v`.
 * @param decay The decay factor. Typical values are 0.95 and 0.99.
 * @param step Step count.
 * @param zeroDebias: Whether zeroDebias is to be performed (default: `true`).
 * @returns The new moving average value.
 *
 * @doc {heading: 'Operations', subheading: 'Moving Average'}
 */ function $9f46e4edc77dd140$var$movingAverage_(v, x, decay, step, zeroDebias = true) {
    const $v = (0, $x4eLk.convertToTensor)(v, 'v', 'movingAverage');
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'movingAverage');
    const $decay = (0, $x4eLk.convertToTensor)(decay, 'decay', 'movingAverage');
    (0, $gpWQN.assertTypesMatch)($v, $x);
    $eOiOM.assert($eOiOM.arraysEqual($v.shape, $x.shape), ()=>'Shape mismatch in v and x');
    const one = (0, $7hONX.scalar)(1);
    const oneMinusDecay = (0, $5jGN9.sub)(one, $decay);
    let update = (0, $5hAos.mul)((0, $5jGN9.sub)($x, $v), oneMinusDecay);
    if (zeroDebias) {
        $eOiOM.assert(step != null, ()=>'When using zeroDebias: true, step is required.');
        const $step = (0, $x4eLk.convertToTensor)(step, 'step', 'movingAverage');
        update = (0, $dIChU.div)(update, (0, $5jGN9.sub)(one, (0, $eCViQ.pow)($decay, $step)));
    }
    return (0, $6Ab5n.add)($v, update);
}
const $9f46e4edc77dd140$export$e0ccbd22a5b3aab6 = /* @__PURE__ */ (0, $6afhl.op)({
    movingAverage_: $9f46e4edc77dd140$var$movingAverage_
});

});

parcelRegister("97sGc", function(module, exports) {

$parcel$export(module.exports, "scatterND", function () { return $6a3b03b0cdf96db3$export$5349ba4fee4e4c76; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $hyHdD = parcelRequire("hyHdD");
/**
 * Creates a new tensor by applying sparse updates to individual
 * values or slices within a zero tensor of the given shape tensor according to
 * indices. This operator is the inverse of the `tf.gatherND` operator which
 * extracts values or slices from a given tensor.
 *
 * ```js
 * const indices = tf.tensor2d([4, 3, 1, 7], [4, 1], 'int32');
 * const updates = tf.tensor1d([9, 10, 11, 12]);
 * const shape = [8];
 * tf.scatterND(indices, updates, shape).print() //[0, 11, 0, 10, 9, 0, 0, 12]
 * ```
 *
 * @param indices The tensor contains the indices into the output tensor.
 * @param updates The tensor contains the value for the indices.
 * @param shape: The shape of the output tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $6a3b03b0cdf96db3$var$scatterND_(indices, updates, shape) {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(shape);
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'scatterND', 'int32');
    const $updates = (0, $x4eLk.convertToTensor)(updates, 'updates', 'scatterND');
    $hyHdD.validateInput($updates, $indices, shape);
    const inputs = {
        indices: $indices,
        updates: $updates
    };
    const attrs = {
        shape: shape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ScatterNd), inputs, attrs);
}
const $6a3b03b0cdf96db3$export$5349ba4fee4e4c76 = /* @__PURE__ */ (0, $6afhl.op)({
    scatterND_: $6a3b03b0cdf96db3$var$scatterND_
});

});

parcelRegister("4a6Xi", function(module, exports) {

$parcel$export(module.exports, "sparseToDense", function () { return $307d7dc85380cdc9$export$1be4b823dd1a3080; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $555nj = parcelRequire("555nj");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Converts a sparse representation into a dense tensor.
 *
 * Builds an array dense with shape outputShape such that:
 *
 * // If sparseIndices is scalar
 * dense[i] = (i == sparseIndices ? sparseValues : defaultValue)
 *
 * // If sparseIndices is a vector, then for each i
 * dense[sparseIndices[i]] = sparseValues[i]
 *
 * // If sparseIndices is an n by d matrix, then for each i in [0, n)
 * dense[sparseIndices[i][0], ..., sparseIndices[i][d-1]] = sparseValues[i]
 * All other values in dense are set to defaultValue. If sparseValues is a
 * scalar, all sparse indices are set to this single value.
 *
 * If indices are repeated the final value is summed over all values for those
 * indices.
 *
 * ```js
 * const indices = tf.tensor1d([4, 5, 6, 1, 2, 3], 'int32');
 * const values = tf.tensor1d([10, 11, 12, 13, 14, 15], 'float32');
 * const shape = [8];
 * tf.sparseToDense(indices, values, shape).print();
 * ```
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape Shape of the dense output tensor. The type is inferred.
 * @param defaultValue Scalar. Value to set for indices not specified in
 * sparseIndices. Defaults to zero.
 *
 * @doc {heading: 'Operations', subheading: 'Normalization'}
 */ function $307d7dc85380cdc9$var$sparseToDense_(sparseIndices, sparseValues, outputShape, defaultValue = 0) {
    (0, $eOiOM.assertNonNegativeIntegerDimensions)(outputShape);
    const $sparseIndices = (0, $x4eLk.convertToTensor)(sparseIndices, 'sparseIndices', 'sparseToDense', 'int32');
    const $sparseValues = (0, $x4eLk.convertToTensor)(sparseValues, 'sparseValues', 'sparseToDense', 'string_or_numeric');
    const $defaultValue = (0, $x4eLk.convertToTensor)(defaultValue, 'defaultValue', 'sparseToDense', $sparseValues.dtype);
    $555nj.validateInput($sparseIndices, $sparseValues, outputShape, $defaultValue);
    const inputs = {
        sparseIndices: $sparseIndices,
        sparseValues: $sparseValues,
        defaultValue: $defaultValue
    };
    const attrs = {
        outputShape: outputShape
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SparseToDense), inputs, attrs);
}
const $307d7dc85380cdc9$export$1be4b823dd1a3080 = /* @__PURE__ */ (0, $6afhl.op)({
    sparseToDense_: $307d7dc85380cdc9$var$sparseToDense_
});

});
parcelRegister("555nj", function(module, exports) {

$parcel$export(module.exports, "validateInput", function () { return $3b3196c0917ce9d8$export$4d09d4ac8ba225dd; });
/**
 * Validate sparseToDense inputs.
 *
 * @param sparseIndices A 0-D, 1-D, or 2-D Tensor of type int32.
 * sparseIndices[i] contains the complete index where sparseValues[i] will be
 * placed.
 * @param sparseValues A 0-D or 1-D Tensor. Values
 * corresponding to each row of sparseIndices, or a scalar value to be used for
 * all sparse indices.
 * @param outputShape number[]. Shape of the dense output tensor.
 * @param validateIndices boolean. indice validation is not supported, error
 * will be thrown if it is set.
 */ function $3b3196c0917ce9d8$export$4d09d4ac8ba225dd(sparseIndices, sparseValues, outputShape, defaultValues) {
    if (sparseIndices.dtype !== 'int32') throw new Error('tf.sparseToDense() expects the indices to be int32 type,' + ` but the dtype was ${sparseIndices.dtype}.`);
    if (sparseIndices.rank > 2) throw new Error('sparseIndices should be a scalar, vector, or matrix,' + ` but got shape ${sparseIndices.shape}.`);
    const numElems = sparseIndices.rank > 0 ? sparseIndices.shape[0] : 1;
    const numDims = sparseIndices.rank > 1 ? sparseIndices.shape[1] : 1;
    if (outputShape.length !== numDims) throw new Error('outputShape has incorrect number of elements:,' + ` ${outputShape.length}, should be: ${numDims}.`);
    const numValues = sparseValues.size;
    if (!(sparseValues.rank === 0 || sparseValues.rank === 1 && numValues === numElems)) throw new Error('sparseValues has incorrect shape ' + `${sparseValues.shape}, should be [] or [${numElems}]`);
    if (sparseValues.dtype !== defaultValues.dtype) throw new Error('sparseValues.dtype must match defaultValues.dtype');
}

});


parcelRegister("9xwK0", function(module, exports) {

$parcel$export(module.exports, "gatherND", function () { return $6f2097d184467baf$export$15ec1b40f43d319f; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Gather slices from input tensor into a Tensor with shape specified by
 * `indices`.
 *
 * `indices` is a K-dimensional integer tensor, best thought of as a
 * (K-1)-dimensional tensor of indices into input, where each element defines a
 * slice of input:
 * output[\\(i_0, ..., i_{K-2}\\)] = input[indices[\\(i_0, ..., i_{K-2}\\)]]
 *
 * Whereas in `tf.gather`, `indices` defines slices into the first dimension of
 * input, in `tf.gatherND`, `indices` defines slices into the first N dimensions
 * of input, where N = indices.shape[-1].
 *
 * The last dimension of indices can be at most the rank of input:
 * indices.shape[-1] <= input.rank
 *
 * The last dimension of `indices` corresponds to elements
 * (if indices.shape[-1] == input.rank) or slices
 * (if indices.shape[-1] < input.rank) along dimension indices.shape[-1] of
 * input.
 * The output tensor has shape
 * indices.shape[:-1] + input.shape[indices.shape[-1]:]
 *
 * Note that on CPU, if an out of bound index is found, an error is returned. On
 * GPU, if an out of bound index is found, a 0 is stored in the corresponding
 * output value.
 *
 * ```js
 * const indices = tf.tensor2d([0, 1, 1, 0], [2,2], 'int32');
 * const input = tf.tensor2d([9, 10, 11, 12], [2, 2]);
 * tf.gatherND(input, indices).print() // [10, 11]
 * ```
 *
 * @param x The tensor from which to gather values.
 * @param indices Index tensor, must be of type int32.
 *
 * @doc {heading: 'Operations', subheading: 'Slicing and Joining'}
 */ function $6f2097d184467baf$var$gatherND_(x, indices) {
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'gatherND', 'int32');
    const $x = (0, $x4eLk.convertToTensor)(x, 'x', 'gatherND', 'string_or_numeric');
    const inputs = {
        params: $x,
        indices: $indices
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.GatherNd), inputs);
}
const $6f2097d184467baf$export$15ec1b40f43d319f = /* @__PURE__ */ (0, $6afhl.op)({
    gatherND_: $6f2097d184467baf$var$gatherND_
});

});

parcelRegister("acgMJ", function(module, exports) {

$parcel$export(module.exports, "enclosingPowerOfTwo", function () { return $76c80b888ffc3c4a$export$6fc2fe3b19043bf3; });
$parcel$export(module.exports, "cosineWindow", function () { return $76c80b888ffc3c4a$export$e875398ce092ee45; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8tOOR = parcelRequire("8tOOR");
function $76c80b888ffc3c4a$export$6fc2fe3b19043bf3(value) {
    // Return 2**N for integer N such that 2**N >= value.
    return Math.floor(Math.pow(2, Math.ceil(Math.log(value) / Math.log(2.0))));
}
function $76c80b888ffc3c4a$export$e875398ce092ee45(windowLength, a, b) {
    const even = 1 - windowLength % 2;
    const newValues = new Float32Array(windowLength);
    for(let i = 0; i < windowLength; ++i){
        const cosArg = 2.0 * Math.PI * i / (windowLength + even - 1);
        newValues[i] = a - b * Math.cos(cosArg);
    }
    return (0, $8tOOR.tensor1d)(newValues, 'float32');
}

});

parcelRegister("3NwTy", function(module, exports) {

$parcel$export(module.exports, "inTopKAsync", function () { return $2c3f76f30640164d$export$395be9a27e7de9f0; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $eZfvk = parcelRequire("eZfvk");
/**
 * Returns whether the targets are in the top K predictions.
 *
 * ```js
 * const predictions = tf.tensor2d([[20, 10, 40, 30], [30, 50, -20, 10]]);
 * const targets = tf.tensor1d([2, 0]);
 * const precision = await tf.inTopKAsync(predictions, targets);
 * precision.print();
 * ```
 * @param predictions 2-D or higher `tf.Tensor` with last dimension being
 *     at least `k`.
 * @param targets 1-D or higher `tf.Tensor`.
 * @param k Optional Number of top elements to look at for computing precision,
 *     default to 1.
 *
 * @doc {heading: 'Operations', subheading: 'Evaluation'}
 */ async function $2c3f76f30640164d$var$inTopKAsync_(predictions, targets, k = 1) {
    const $predictions = (0, $x4eLk.convertToTensor)(predictions, 'predictions', 'inTopK');
    const $targets = (0, $x4eLk.convertToTensor)(targets, 'targets', 'inTopK');
    (0, $eOiOM.assert)($predictions.rank > 1, ()=>'inTopK() expects the predictions to be of rank 2 or higher, ' + `but got ${$predictions.rank}`);
    (0, $eOiOM.assert)($predictions.rank - 1 === $targets.rank, ()=>`predictions rank should be 1 larger than ` + `targets rank, but got predictions rank ` + `${$predictions.rank} and targets rank ${$targets.rank}`);
    (0, $eOiOM.assertShapesMatch)($predictions.shape.slice(0, $predictions.shape.length - 1), $targets.shape, `predictions's shape should be align with the targets' shape, ` + 'except the last dimension.');
    const lastDim = $predictions.shape[$predictions.shape.length - 1];
    (0, $eOiOM.assert)(k > 0 && k <= lastDim, ()=>`'k' passed to inTopK() must be > 0 && <= the predictions last ` + `dimension (${lastDim}), but got ${k}`);
    const predictionsVals = await $predictions.data();
    const targetsVals = await $targets.data();
    // Reshape predictionsVals into a 2d tensor [batch, lastDim]
    // and look up topK along lastDim.
    const [batch, size] = [
        predictionsVals.length / lastDim,
        lastDim
    ];
    const precision = (0, $eOiOM.getTypedArrayFromDType)('bool', batch);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = predictionsVals.subarray(offset, offset + size);
        const valAndInd = [];
        for(let i = 0; i < vals.length; i++)valAndInd.push({
            value: vals[i],
            index: i
        });
        valAndInd.sort((a, b)=>b.value - a.value);
        precision[b] = 0;
        for(let i = 0; i < k; i++)if (valAndInd[i].index === targetsVals[b]) {
            precision[b] = 1;
            break;
        }
    }
    if (predictions !== $predictions) $predictions.dispose();
    if (targets !== $targets) $targets.dispose();
    // Output precision has the same shape as targets.
    return (0, $eZfvk.tensor)(precision, $targets.shape, 'bool');
}
const $2c3f76f30640164d$export$395be9a27e7de9f0 = $2c3f76f30640164d$var$inTopKAsync_;

});

parcelRegister("Ylp0b", function(module, exports) {

$parcel$export(module.exports, "hammingWindow", function () { return $0b5634c1172b68a4$export$941eafcc99b559fa; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6afhl = parcelRequire("6afhl");

var $acgMJ = parcelRequire("acgMJ");
/**
 * Generate a hamming window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hammingWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $0b5634c1172b68a4$var$hammingWindow_(windowLength) {
    return (0, $acgMJ.cosineWindow)(windowLength, 0.54, 0.46);
}
const $0b5634c1172b68a4$export$941eafcc99b559fa = /* @__PURE__ */ (0, $6afhl.op)({
    hammingWindow_: $0b5634c1172b68a4$var$hammingWindow_
});

});

parcelRegister("38ZlN", function(module, exports) {

$parcel$export(module.exports, "hannWindow", function () { return $24a1b563e667d6f6$export$f498cfeee84e5e59; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6afhl = parcelRequire("6afhl");

var $acgMJ = parcelRequire("acgMJ");
/**
 * Generate a Hann window.
 *
 * See: https://en.wikipedia.org/wiki/Window_function#Hann_and_Hamming_windows
 *
 * ```js
 * tf.signal.hannWindow(10).print();
 * ```
 * @param The length of window
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $24a1b563e667d6f6$var$hannWindow_(windowLength) {
    return (0, $acgMJ.cosineWindow)(windowLength, 0.5, 0.5);
}
const $24a1b563e667d6f6$export$f498cfeee84e5e59 = /* @__PURE__ */ (0, $6afhl.op)({
    hannWindow_: $24a1b563e667d6f6$var$hannWindow_
});

});

parcelRegister("ijWLs", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $d56795b6ed015cd4$export$2cef06c20297c17d; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1goxr = parcelRequire("1goxr");

var $2d2dF = parcelRequire("2d2dF");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");

var $l7afw = parcelRequire("l7afw");

var $9NdGd = parcelRequire("9NdGd");
/**
 * Expands input into frames of frameLength.
 * Slides a window size with frameStep.
 *
 * ```js
 * tf.signal.frame([1, 2, 3], 2, 1).print();
 * ```
 * @param signal The input tensor to be expanded
 * @param frameLength Length of each frame
 * @param frameStep The frame hop size in samples.
 * @param padEnd Whether to pad the end of signal with padValue.
 * @param padValue A number to use where the input signal does
 *     not exist when padEnd is True.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $d56795b6ed015cd4$var$frame_(signal, frameLength, frameStep, padEnd = false, padValue = 0) {
    let start = 0;
    const output = [];
    while(start + frameLength <= signal.size){
        output.push((0, $l7afw.slice)(signal, start, frameLength));
        start += frameStep;
    }
    if (padEnd) while(start < signal.size){
        const padLen = start + frameLength - signal.size;
        const pad = (0, $1goxr.concat)([
            (0, $l7afw.slice)(signal, start, frameLength - padLen),
            (0, $2d2dF.fill)([
                padLen
            ], padValue)
        ]);
        output.push(pad);
        start += frameStep;
    }
    if (output.length === 0) return (0, $9NdGd.tensor2d)([], [
        0,
        frameLength
    ]);
    return (0, $8nMOl.reshape)((0, $1goxr.concat)(output), [
        output.length,
        frameLength
    ]);
}
const $d56795b6ed015cd4$export$2cef06c20297c17d = /* @__PURE__ */ (0, $6afhl.op)({
    frame_: $d56795b6ed015cd4$var$frame_
});

});

parcelRegister("g1WMw", function(module, exports) {

$parcel$export(module.exports, "stft", function () { return $baba5629ee7e7c70$export$eb1cf9b274257b4a; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $acgMJ = parcelRequire("acgMJ");

var $22B8v = parcelRequire("22B8v");

var $ijWLs = parcelRequire("ijWLs");

var $38ZlN = parcelRequire("38ZlN");
/**
 * Computes the Short-time Fourier Transform of signals
 * See: https://en.wikipedia.org/wiki/Short-time_Fourier_transform
 *
 * ```js
 * const input = tf.tensor1d([1, 1, 1, 1, 1])
 * tf.signal.stft(input, 3, 1).print();
 * ```
 * @param signal 1-dimensional real value tensor.
 * @param frameLength The window length of samples.
 * @param frameStep The number of samples to step.
 * @param fftLength The size of the FFT to apply.
 * @param windowFn A callable that takes a window length and returns 1-d tensor.
 *
 * @doc {heading: 'Operations', subheading: 'Signal', namespace: 'signal'}
 */ function $baba5629ee7e7c70$var$stft_(signal, frameLength, frameStep, fftLength, windowFn = (0, $38ZlN.hannWindow)) {
    if (fftLength == null) fftLength = (0, $acgMJ.enclosingPowerOfTwo)(frameLength);
    const framedSignal = (0, $ijWLs.frame)(signal, frameLength, frameStep);
    const windowedSignal = (0, $5hAos.mul)(framedSignal, windowFn(frameLength));
    return (0, $22B8v.rfft)(windowedSignal, fftLength);
}
const $baba5629ee7e7c70$export$eb1cf9b274257b4a = /* @__PURE__ */ (0, $6afhl.op)({
    stft_: $baba5629ee7e7c70$var$stft_
});

});

parcelRegister("4F2NW", function(module, exports) {

$parcel$export(module.exports, "cropAndResize", function () { return $364d2ab2af340e48$export$6f0f0090e1f6cd3c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Extracts crops from the input image tensor and resizes them using bilinear
 * sampling or nearest neighbor sampling (possibly with aspect ratio change)
 * to a common output size specified by cropSize.
 *
 * @param image 4d tensor of shape `[batch,imageHeight,imageWidth, depth]`,
 *     where imageHeight and imageWidth must be positive, specifying the
 *     batch of images from which to take crops
 * @param boxes 2d float32 tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the normalized
 *     coordinates of the box in the `boxInd[i]`th image in the batch
 * @param boxInd 1d int32 tensor of shape `[numBoxes]` with values in range
 *     `[0, batch)` that specifies the image that the `i`-th box refers to.
 * @param cropSize 1d int32 tensor of 2 elements `[cropHeigh, cropWidth]`
 *     specifying the size to which all crops are resized to.
 * @param method Optional string from `'bilinear' | 'nearest'`,
 *     defaults to bilinear, which specifies the sampling method for resizing
 * @param extrapolationValue A threshold for deciding when to remove boxes based
 *     on score. Defaults to 0.
 * @return A 4D tensor of the shape `[numBoxes,cropHeight,cropWidth,depth]`
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $364d2ab2af340e48$var$cropAndResize_(image, boxes, boxInd, cropSize, method = 'bilinear', extrapolationValue = 0) {
    const $image = (0, $x4eLk.convertToTensor)(image, 'image', 'cropAndResize');
    const $boxes = (0, $x4eLk.convertToTensor)(boxes, 'boxes', 'cropAndResize', 'float32');
    const $boxInd = (0, $x4eLk.convertToTensor)(boxInd, 'boxInd', 'cropAndResize', 'int32');
    const numBoxes = $boxes.shape[0];
    $eOiOM.assert($image.rank === 4, ()=>'Error in cropAndResize: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $eOiOM.assert($boxes.rank === 2 && $boxes.shape[1] === 4, ()=>`Error in cropAndResize: boxes must be have size [${numBoxes},4] ` + `but had shape ${$boxes.shape}.`);
    $eOiOM.assert($boxInd.rank === 1 && $boxInd.shape[0] === numBoxes, ()=>`Error in cropAndResize: boxInd must be have size [${numBoxes}] ` + `but had shape ${$boxes.shape}.`);
    $eOiOM.assert(cropSize.length === 2, ()=>`Error in cropAndResize: cropSize must be of length 2, but got ` + `length ${cropSize.length}.`);
    $eOiOM.assert(cropSize[0] >= 1 && cropSize[1] >= 1, ()=>`cropSize must be atleast [1,1], but was ${cropSize}`);
    $eOiOM.assert(method === 'bilinear' || method === 'nearest', ()=>`method must be bilinear or nearest, but was ${method}`);
    const inputs = {
        image: $image,
        boxes: $boxes,
        boxInd: $boxInd
    };
    const attrs = {
        method: method,
        extrapolationValue: extrapolationValue,
        cropSize: cropSize
    };
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.CropAndResize), inputs, attrs);
    return res;
}
const $364d2ab2af340e48$export$6f0f0090e1f6cd3c = /* @__PURE__ */ (0, $6afhl.op)({
    cropAndResize_: $364d2ab2af340e48$var$cropAndResize_
});

});

parcelRegister("l44Td", function(module, exports) {

$parcel$export(module.exports, "flipLeftRight", function () { return $f55dc3af6d20b5eb$export$8358b9c43b687b22; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Flips the image left to right. Currently available in the CPU, WebGL, and
 * WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 */ /** @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'} */ function $f55dc3af6d20b5eb$var$flipLeftRight_(image) {
    const $image = (0, $x4eLk.convertToTensor)(image, 'image', 'flipLeftRight', 'float32');
    $eOiOM.assert($image.rank === 4, ()=>'Error in flipLeftRight: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.FlipLeftRight), inputs, {});
    return res;
}
const $f55dc3af6d20b5eb$export$8358b9c43b687b22 = /* @__PURE__ */ (0, $6afhl.op)({
    flipLeftRight_: $f55dc3af6d20b5eb$var$flipLeftRight_
});

});

parcelRegister("7XMW0", function(module, exports) {

$parcel$export(module.exports, "grayscaleToRGB", function () { return $5cc4008058851793$export$f68e334bfd7e4be6; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $dolPi = parcelRequire("dolPi");
/**
 * Converts images from grayscale to RGB format.
 *
 * @param image A grayscale tensor to convert. The `image`'s last dimension must
 *     be size 1 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $5cc4008058851793$var$grayscaleToRGB_(image) {
    const $image = (0, $x4eLk.convertToTensor)(image, 'image', 'grayscaleToRGB');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $eOiOM.assert($image.rank >= 2, ()=>'Error in grayscaleToRGB: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $eOiOM.assert(lastDims === 1, ()=>'Error in grayscaleToRGB: last dimension of a grayscale image ' + `should be size 1, but got size ${lastDims}.`);
    const reps = new Array($image.rank);
    reps.fill(1, 0, lastDimsIdx);
    reps[lastDimsIdx] = 3;
    return (0, $dolPi.tile)($image, reps);
}
const $5cc4008058851793$export$f68e334bfd7e4be6 = /* @__PURE__ */ (0, $6afhl.op)({
    grayscaleToRGB_: $5cc4008058851793$var$grayscaleToRGB_
});

});

parcelRegister("gVs16", function(module, exports) {

$parcel$export(module.exports, "rgbToGrayscale", function () { return $c527b3c6e477670e$export$490c4fde2e852c50; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $fxiHg = parcelRequire("fxiHg");

var $lR4Fq = parcelRequire("lR4Fq");

var $fO4kJ = parcelRequire("fO4kJ");

var $6afhl = parcelRequire("6afhl");

var $8tOOR = parcelRequire("8tOOR");
/**
 * Converts images from RGB format to grayscale.
 *
 * @param image A RGB tensor to convert. The `image`'s last dimension must
 *     be size 3 with at least a two-dimensional shape.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $c527b3c6e477670e$var$rgbToGrayscale_(image) {
    const $image = (0, $x4eLk.convertToTensor)(image, 'image', 'RGBToGrayscale');
    const lastDimsIdx = $image.rank - 1;
    const lastDims = $image.shape[lastDimsIdx];
    $eOiOM.assert($image.rank >= 2, ()=>'Error in RGBToGrayscale: images must be at least rank 2, ' + `but got rank ${$image.rank}.`);
    $eOiOM.assert(lastDims === 3, ()=>'Error in RGBToGrayscale: last dimension of an RGB image ' + `should be size 3, but got size ${lastDims}.`);
    // Remember original dtype so we can convert back if needed
    const origDtype = $image.dtype;
    const fltImage = (0, $fxiHg.cast)($image, 'float32');
    const rgbWeights = (0, $8tOOR.tensor1d)([
        0.2989,
        0.5870,
        0.1140
    ]);
    let grayFloat;
    switch($image.rank){
        case 2:
            grayFloat = (0, $lR4Fq.einsum)('ij,j->i', fltImage, rgbWeights);
            break;
        case 3:
            grayFloat = (0, $lR4Fq.einsum)('ijk,k->ij', fltImage, rgbWeights);
            break;
        case 4:
            grayFloat = (0, $lR4Fq.einsum)('ijkl,l->ijk', fltImage, rgbWeights);
            break;
        case 5:
            grayFloat = (0, $lR4Fq.einsum)('ijklm,m->ijkl', fltImage, rgbWeights);
            break;
        case 6:
            grayFloat = (0, $lR4Fq.einsum)('ijklmn,n->ijklm', fltImage, rgbWeights);
            break;
        default:
            throw new Error('Not a valid tensor rank.');
    }
    grayFloat = (0, $fO4kJ.expandDims)(grayFloat, -1);
    return (0, $fxiHg.cast)(grayFloat, origDtype);
}
const $c527b3c6e477670e$export$490c4fde2e852c50 = /* @__PURE__ */ (0, $6afhl.op)({
    rgbToGrayscale_: $c527b3c6e477670e$var$rgbToGrayscale_
});

});

parcelRegister("ljsAL", function(module, exports) {

$parcel$export(module.exports, "rotateWithOffset", function () { return $f8418d1c186b7626$export$66462c489f5f29d2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Rotates the input image tensor counter-clockwise with an optional offset
 * center of rotation. Currently available in the CPU, WebGL, and WASM backends.
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param radians The amount of rotation.
 * @param fillValue The value to fill in the empty space leftover
 *     after rotation. Can be either a single grayscale value (0-255), or an
 *     array of three numbers `[red, green, blue]` specifying the red, green,
 *     and blue channels. Defaults to `0` (black).
 * @param center The center of rotation. Can be either a single value (0-1), or
 *     an array of two numbers `[centerX, centerY]`. Defaults to `0.5` (rotates
 *     the image around its center).
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $f8418d1c186b7626$var$rotateWithOffset_(image, radians, fillValue = 0, center = 0.5) {
    const $image = (0, $x4eLk.convertToTensor)(image, 'image', 'rotateWithOffset', 'float32');
    $eOiOM.assert($image.rank === 4, ()=>'Error in rotateWithOffset: image must be rank 4,' + `but got rank ${$image.rank}.`);
    const inputs = {
        image: $image
    };
    const attrs = {
        radians: radians,
        fillValue: fillValue,
        center: center
    };
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.RotateWithOffset), inputs, attrs);
    return res;
}
const $f8418d1c186b7626$export$66462c489f5f29d2 = /* @__PURE__ */ (0, $6afhl.op)({
    rotateWithOffset_: $f8418d1c186b7626$var$rotateWithOffset_
});

});

parcelRegister("k87r6", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppression", function () { return $ea7a52a600543dd8$export$b7d265b19ca1d628; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $bRfAq = parcelRequire("bRfAq");

var $6afhl = parcelRequire("6afhl");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $ea7a52a600543dd8$var$nonMaxSuppression_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $x4eLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression', 'float32');
    const $scores = (0, $x4eLk.convertToTensor)(scores, 'scores', 'nonMaxSuppression', 'float32');
    const inputs = (0, $bRfAq.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.NonMaxSuppressionV3), {
        boxes: $boxes,
        scores: $scores
    }, attrs);
}
const $ea7a52a600543dd8$export$b7d265b19ca1d628 = /* @__PURE__ */ (0, $6afhl.op)({
    nonMaxSuppression_: $ea7a52a600543dd8$var$nonMaxSuppression_
});

});
parcelRegister("bRfAq", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppSanityCheck", function () { return $8a20bc1db81f22c2$export$ccf61bcb3b4e6ac6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
function $8a20bc1db81f22c2$export$ccf61bcb3b4e6ac6(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    if (iouThreshold == null) iouThreshold = 0.5;
    if (scoreThreshold == null) scoreThreshold = Number.NEGATIVE_INFINITY;
    if (softNmsSigma == null) softNmsSigma = 0.0;
    const numBoxes = boxes.shape[0];
    maxOutputSize = Math.min(maxOutputSize, numBoxes);
    $eOiOM.assert(0 <= iouThreshold && iouThreshold <= 1, ()=>`iouThreshold must be in [0, 1], but was '${iouThreshold}'`);
    $eOiOM.assert(boxes.rank === 2, ()=>`boxes must be a 2D tensor, but was of rank '${boxes.rank}'`);
    $eOiOM.assert(boxes.shape[1] === 4, ()=>`boxes must have 4 columns, but 2nd dimension was ${boxes.shape[1]}`);
    $eOiOM.assert(scores.rank === 1, ()=>'scores must be a 1D tensor');
    $eOiOM.assert(scores.shape[0] === numBoxes, ()=>`scores has incompatible shape with boxes. Expected ${numBoxes}, ` + `but was ${scores.shape[0]}`);
    $eOiOM.assert(0 <= softNmsSigma && softNmsSigma <= 1, ()=>`softNmsSigma must be in [0, 1], but was '${softNmsSigma}'`);
    return {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}

});


parcelRegister("l9d7h", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionAsync", function () { return $f6549ce3d1c4dfac$export$cc6d94dffac2ee1a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9cC6a = parcelRequire("9cC6a");

var $x4eLk = parcelRequire("x4eLk");

var $bRfAq = parcelRequire("bRfAq");

var $8tOOR = parcelRequire("8tOOR");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This is the async version of `nonMaxSuppression`
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @return A 1D tensor with the selected box indices.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $f6549ce3d1c4dfac$var$nonMaxSuppressionAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY) {
    const $boxes = (0, $x4eLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $x4eLk.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const inputs = (0, $bRfAq.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold);
    maxOutputSize = inputs.maxOutputSize;
    iouThreshold = inputs.iouThreshold;
    scoreThreshold = inputs.scoreThreshold;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices } = (0, $9cC6a.nonMaxSuppressionV3Impl)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return (0, $8tOOR.tensor1d)(selectedIndices, 'int32');
}
const $f6549ce3d1c4dfac$export$cc6d94dffac2ee1a = $f6549ce3d1c4dfac$var$nonMaxSuppressionAsync_;

});
parcelRegister("9cC6a", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Impl", function () { return $6b32c9a0b184b61f$export$89e22275998c2878; });
$parcel$export(module.exports, "nonMaxSuppressionV4Impl", function () { return $6b32c9a0b184b61f$export$697e7a8cdfefe3a; });
$parcel$export(module.exports, "nonMaxSuppressionV5Impl", function () { return $6b32c9a0b184b61f$export$4ff849794bce73c5; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $i4BIU = parcelRequire("i4BIU");
function $6b32c9a0b184b61f$export$89e22275998c2878(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold) {
    return $6b32c9a0b184b61f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ );
}
function $6b32c9a0b184b61f$export$697e7a8cdfefe3a(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize) {
    return $6b32c9a0b184b61f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, 0 /* softNmsSigma */ , false, padToMaxOutputSize /* padToMaxOutputSize */ , true);
}
function $6b32c9a0b184b61f$export$4ff849794bce73c5(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma) {
    return $6b32c9a0b184b61f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, true);
}
function $6b32c9a0b184b61f$var$nonMaxSuppressionImpl_(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma, returnScoresTensor = false, padToMaxOutputSize = false, returnValidOutputs = false) {
    // The list is sorted in ascending order, so that we can always pop the
    // candidate with the largest score in O(1) time.
    const candidates = [];
    for(let i = 0; i < scores.length; i++)if (scores[i] > scoreThreshold) candidates.push({
        score: scores[i],
        boxIndex: i,
        suppressBeginIndex: 0
    });
    candidates.sort($6b32c9a0b184b61f$var$ascendingComparator);
    // If softNmsSigma is 0, the outcome of this algorithm is exactly same as
    // before.
    const scale = softNmsSigma > 0 ? -0.5 / softNmsSigma : 0.0;
    const selectedIndices = [];
    const selectedScores = [];
    while(selectedIndices.length < maxOutputSize && candidates.length > 0){
        const candidate = candidates.pop();
        const { score: originalScore, boxIndex: boxIndex, suppressBeginIndex: suppressBeginIndex } = candidate;
        if (originalScore < scoreThreshold) break;
        // Overlapping boxes are likely to have similar scores, therefore we
        // iterate through the previously selected boxes backwards in order to
        // see if candidate's score should be suppressed. We use
        // suppressBeginIndex to track and ensure a candidate can be suppressed
        // by a selected box no more than once. Also, if the overlap exceeds
        // iouThreshold, we simply ignore the candidate.
        let ignoreCandidate = false;
        for(let j = selectedIndices.length - 1; j >= suppressBeginIndex; --j){
            const iou = $6b32c9a0b184b61f$var$intersectionOverUnion(boxes, boxIndex, selectedIndices[j]);
            if (iou >= iouThreshold) {
                ignoreCandidate = true;
                break;
            }
            candidate.score = candidate.score * $6b32c9a0b184b61f$var$suppressWeight(iouThreshold, scale, iou);
            if (candidate.score <= scoreThreshold) break;
        }
        // At this point, if `candidate.score` has not dropped below
        // `scoreThreshold`, then we know that we went through all of the
        // previous selections and can safely update `suppressBeginIndex` to the
        // end of the selected array. Then we can re-insert the candidate with
        // the updated score and suppressBeginIndex back in the candidate list.
        // If on the other hand, `candidate.score` has dropped below the score
        // threshold, we will not add it back to the candidates list.
        candidate.suppressBeginIndex = selectedIndices.length;
        if (!ignoreCandidate) {
            // Candidate has passed all the tests, and is not suppressed, so
            // select the candidate.
            if (candidate.score === originalScore) {
                selectedIndices.push(boxIndex);
                selectedScores.push(candidate.score);
            } else if (candidate.score > scoreThreshold) // Candidate's score is suppressed but is still high enough to be
            // considered, so add back to the candidates list.
            (0, $i4BIU.binaryInsert)(candidates, candidate, $6b32c9a0b184b61f$var$ascendingComparator);
        }
    }
    // NonMaxSuppressionV4 feature: padding output to maxOutputSize.
    const validOutputs = selectedIndices.length;
    const elemsToPad = maxOutputSize - validOutputs;
    if (padToMaxOutputSize && elemsToPad > 0) {
        selectedIndices.push(...new Array(elemsToPad).fill(0));
        selectedScores.push(...new Array(elemsToPad).fill(0.0));
    }
    const result = {
        selectedIndices: selectedIndices
    };
    if (returnScoresTensor) result['selectedScores'] = selectedScores;
    if (returnValidOutputs) result['validOutputs'] = validOutputs;
    return result;
}
function $6b32c9a0b184b61f$var$intersectionOverUnion(boxes, i, j) {
    const iCoord = boxes.subarray(i * 4, i * 4 + 4);
    const jCoord = boxes.subarray(j * 4, j * 4 + 4);
    const yminI = Math.min(iCoord[0], iCoord[2]);
    const xminI = Math.min(iCoord[1], iCoord[3]);
    const ymaxI = Math.max(iCoord[0], iCoord[2]);
    const xmaxI = Math.max(iCoord[1], iCoord[3]);
    const yminJ = Math.min(jCoord[0], jCoord[2]);
    const xminJ = Math.min(jCoord[1], jCoord[3]);
    const ymaxJ = Math.max(jCoord[0], jCoord[2]);
    const xmaxJ = Math.max(jCoord[1], jCoord[3]);
    const areaI = (ymaxI - yminI) * (xmaxI - xminI);
    const areaJ = (ymaxJ - yminJ) * (xmaxJ - xminJ);
    if (areaI <= 0 || areaJ <= 0) return 0.0;
    const intersectionYmin = Math.max(yminI, yminJ);
    const intersectionXmin = Math.max(xminI, xminJ);
    const intersectionYmax = Math.min(ymaxI, ymaxJ);
    const intersectionXmax = Math.min(xmaxI, xmaxJ);
    const intersectionArea = Math.max(intersectionYmax - intersectionYmin, 0.0) * Math.max(intersectionXmax - intersectionXmin, 0.0);
    return intersectionArea / (areaI + areaJ - intersectionArea);
}
// A Gaussian penalty function, this method always returns values in [0, 1].
// The weight is a function of similarity, the more overlap two boxes are, the
// smaller the weight is,meaning highly overlapping boxes will be significantly
// penalized. On the other hand, a non-overlapping box will not be penalized.
function $6b32c9a0b184b61f$var$suppressWeight(iouThreshold, scale, iou) {
    const weight = Math.exp(scale * iou * iou);
    return iou <= iouThreshold ? weight : 0.0;
}
function $6b32c9a0b184b61f$var$ascendingComparator(c1, c2) {
    // For objects with same scores, we make the object with the larger index go
    // first. In an array that pops from the end, this means that the object with
    // the smaller index will be popped first. This ensures the same output as
    // the TensorFlow python version.
    return c1.score - c2.score || c1.score === c2.score && c2.boxIndex - c1.boxIndex;
}

});
parcelRegister("i4BIU", function(module, exports) {

$parcel$export(module.exports, "binaryInsert", function () { return $d285dcc745e44656$export$a64fad5e27f22af5; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Inserts a value into a sorted array. This method allows duplicate, meaning it
 * allows inserting duplicate value, in which case, the element will be inserted
 * at the lowest index of the value.
 * @param arr The array to modify.
 * @param element The element to insert.
 * @param comparator Optional. If no comparator is specified, elements are
 * compared using array_util.defaultComparator, which is suitable for Strings
 * and Numbers in ascending arrays. If the array contains multiple instances of
 * the target value, the left-most instance will be returned. To provide a
 * comparator, it should take 2 arguments to compare and return a negative,
 * zero, or a positive number.
 */ function $d285dcc745e44656$export$a64fad5e27f22af5(arr, element, comparator) {
    const index = $d285dcc745e44656$export$2e0ae67339d5f1ac(arr, element, comparator);
    const insertionPoint = index < 0 ? -(index + 1) : index;
    arr.splice(insertionPoint, 0, element);
}
function $d285dcc745e44656$export$2e0ae67339d5f1ac(arr, target, comparator) {
    return $d285dcc745e44656$var$binarySearch_(arr, target, comparator || $d285dcc745e44656$var$defaultComparator);
}
/**
 * Compares its two arguments for order.
 * @param a The first element to be compared.
 * @param b The second element to be compared.
 * @return A negative number, zero, or a positive number as the first
 *     argument is less than, equal to, or greater than the second.
 */ function $d285dcc745e44656$var$defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $d285dcc745e44656$var$binarySearch_(arr, target, comparator) {
    let left = 0;
    let right = arr.length;
    let middle = 0;
    let found = false;
    while(left < right){
        middle = left + (right - left >>> 1);
        const compareResult = comparator(target, arr[middle]);
        if (compareResult > 0) left = middle + 1;
        else {
            right = middle;
            // If compareResult is 0, the value is found. We record it is found,
            // and then keep looking because there may be duplicate.
            found = !compareResult;
        }
    }
    return found ? left : -left - 1;
}

});



parcelRegister("9vpdF", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionWithScore", function () { return $6eba9256c150af9e$export$d65fe1460f8c5b4e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $bRfAq = parcelRequire("bRfAq");

var $6afhl = parcelRequire("6afhl");
/**
 * Performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $6eba9256c150af9e$var$nonMaxSuppressionWithScore_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $x4eLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $x4eLk.convertToTensor)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $bRfAq.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.NonMaxSuppressionV5), inputs, attrs);
    return {
        selectedIndices: result[0],
        selectedScores: result[1]
    };
}
const $6eba9256c150af9e$export$d65fe1460f8c5b4e = /* @__PURE__ */ (0, $6afhl.op)({
    nonMaxSuppressionWithScore_: $6eba9256c150af9e$var$nonMaxSuppressionWithScore_
});

});

parcelRegister("bDram", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionWithScoreAsync", function () { return $878868d86c95154d$export$d1826570c883f7cf; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9cC6a = parcelRequire("9cC6a");

var $x4eLk = parcelRequire("x4eLk");

var $bRfAq = parcelRequire("bRfAq");

var $8tOOR = parcelRequire("8tOOR");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union).
 *
 * This op also supports a Soft-NMS mode (cf.
 * Bodla et al, https://arxiv.org/abs/1704.04503) where boxes reduce the score
 * of other overlapping boxes, therefore favoring different regions of the image
 * with high scores. To enable this Soft-NMS mode, set the `softNmsSigma`
 * parameter to be larger than 0.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param softNmsSigma A float representing the sigma parameter for Soft NMS.
 *     When sigma is 0, it falls back to nonMaxSuppression.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - selectedScores: A 1D tensor with the corresponding scores for each
 *       selected box.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $878868d86c95154d$var$nonMaxSuppressionWithScoreAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, softNmsSigma = 0.0) {
    const $boxes = (0, $x4eLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $x4eLk.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $bRfAq.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    maxOutputSize = params.maxOutputSize;
    iouThreshold = params.iouThreshold;
    scoreThreshold = params.scoreThreshold;
    softNmsSigma = params.softNmsSigma;
    const boxesAndScores = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    const boxesVals = boxesAndScores[0];
    const scoresVals = boxesAndScores[1];
    // We call a cpu based impl directly with the typedarray data  here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = (0, $9cC6a.nonMaxSuppressionV5Impl)(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $8tOOR.tensor1d)(selectedIndices, 'int32'),
        selectedScores: (0, $8tOOR.tensor1d)(selectedScores)
    };
}
const $878868d86c95154d$export$d1826570c883f7cf = $878868d86c95154d$var$nonMaxSuppressionWithScoreAsync_;

});

parcelRegister("6QfYA", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionPadded", function () { return $4fb3fdee3fc6f678$export$d8d10e31c41c95dc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $bRfAq = parcelRequire("bRfAq");

var $6afhl = parcelRequire("6afhl");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $4fb3fdee3fc6f678$var$nonMaxSuppressionPadded_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $x4eLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppression');
    const $scores = (0, $x4eLk.convertToTensor)(scores, 'scores', 'nonMaxSuppression');
    const params = (0, $bRfAq.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const inputs = {
        boxes: $boxes,
        scores: $scores
    };
    const attrs = {
        maxOutputSize: $maxOutputSize,
        iouThreshold: $iouThreshold,
        scoreThreshold: $scoreThreshold,
        padToMaxOutputSize: padToMaxOutputSize
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.NonMaxSuppressionV4), inputs, attrs);
    return {
        selectedIndices: result[0],
        validOutputs: result[1]
    };
}
const $4fb3fdee3fc6f678$export$d8d10e31c41c95dc = /* @__PURE__ */ (0, $6afhl.op)({
    nonMaxSuppressionPadded_: $4fb3fdee3fc6f678$var$nonMaxSuppressionPadded_
});

});

parcelRegister("f7xFe", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionPaddedAsync", function () { return $b0219f7307a61a3e$export$4c5691f9710b88a8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9cC6a = parcelRequire("9cC6a");

var $x4eLk = parcelRequire("x4eLk");

var $bRfAq = parcelRequire("bRfAq");

var $7hONX = parcelRequire("7hONX");

var $8tOOR = parcelRequire("8tOOR");
/**
 * Asynchronously performs non maximum suppression of bounding boxes based on
 * iou (intersection over union), with an option to pad results.
 *
 * @param boxes a 2d tensor of shape `[numBoxes, 4]`. Each entry is
 *     `[y1, x1, y2, x2]`, where `(y1, x1)` and `(y2, x2)` are the corners of
 *     the bounding box.
 * @param scores a 1d tensor providing the box scores of shape `[numBoxes]`.
 * @param maxOutputSize The maximum number of boxes to be selected.
 * @param iouThreshold A float representing the threshold for deciding whether
 *     boxes overlap too much with respect to IOU. Must be between [0, 1].
 *     Defaults to 0.5 (50% box overlap).
 * @param scoreThreshold A threshold for deciding when to remove boxes based
 *     on score. Defaults to -inf, which means any score is accepted.
 * @param padToMaxOutputSize Defaults to false. If true, size of output
 *     `selectedIndices` is padded to maxOutputSize.
 * @return A map with the following properties:
 *     - selectedIndices: A 1D tensor with the selected box indices.
 *     - validOutputs: A scalar denoting how many elements in `selectedIndices`
 *       are valid. Valid elements occur first, then padding.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ async function $b0219f7307a61a3e$var$nonMaxSuppressionPaddedAsync_(boxes, scores, maxOutputSize, iouThreshold = 0.5, scoreThreshold = Number.NEGATIVE_INFINITY, padToMaxOutputSize = false) {
    const $boxes = (0, $x4eLk.convertToTensor)(boxes, 'boxes', 'nonMaxSuppressionAsync');
    const $scores = (0, $x4eLk.convertToTensor)(scores, 'scores', 'nonMaxSuppressionAsync');
    const params = (0, $bRfAq.nonMaxSuppSanityCheck)($boxes, $scores, maxOutputSize, iouThreshold, scoreThreshold, null);
    const $maxOutputSize = params.maxOutputSize;
    const $iouThreshold = params.iouThreshold;
    const $scoreThreshold = params.scoreThreshold;
    const [boxesVals, scoresVals] = await Promise.all([
        $boxes.data(),
        $scores.data()
    ]);
    // We call a cpu based impl directly with the typedarray data here rather
    // than a kernel because all kernels are synchronous (and thus cannot await
    // .data()).
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = (0, $9cC6a.nonMaxSuppressionV4Impl)(boxesVals, scoresVals, $maxOutputSize, $iouThreshold, $scoreThreshold, padToMaxOutputSize);
    if ($boxes !== boxes) $boxes.dispose();
    if ($scores !== scores) $scores.dispose();
    return {
        selectedIndices: (0, $8tOOR.tensor1d)(selectedIndices, 'int32'),
        validOutputs: (0, $7hONX.scalar)(validOutputs, 'int32')
    };
}
const $b0219f7307a61a3e$export$4c5691f9710b88a8 = $b0219f7307a61a3e$var$nonMaxSuppressionPaddedAsync_;

});

parcelRegister("9biDE", function(module, exports) {

$parcel$export(module.exports, "resizeBilinear", function () { return $6af399598733161a$export$1f1cbc7da93d06a0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Bilinear resize a single 3D image or a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to `false`. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixel centers
 *     are at 0.5, which would make the floating point coordinates of the top
 *     left pixel 0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $6af399598733161a$var$resizeBilinear_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $x4eLk.convertToTensor)(images, 'images', 'resizeBilinear');
    $eOiOM.assert($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeBilinear: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $eOiOM.assert(size.length === 2, ()=>`Error in resizeBilinear: new shape must 2D, but got shape ` + `${size}.`);
    $eOiOM.assert(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeBilinear: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $8nMOl.reshape)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ResizeBilinear), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $6af399598733161a$export$1f1cbc7da93d06a0 = /* @__PURE__ */ (0, $6afhl.op)({
    resizeBilinear_: $6af399598733161a$var$resizeBilinear_
});

});

parcelRegister("3dpoM", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighbor", function () { return $257649a521982504$export$74a902ae74ac2560; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * NearestNeighbor resize a batch of 3D images to a new shape.
 *
 * @param images The images, of rank 4 or rank 3, of shape
 *     `[batch, height, width, inChannels]`. If rank 3, batch of 1 is assumed.
 * @param size The new shape `[newHeight, newWidth]` to resize the
 *     images to. Each channel is resized individually.
 * @param alignCorners Defaults to False. If true, rescale
 *     input by `(new_height - 1) / (height - 1)`, which exactly aligns the 4
 *     corners of images and resized images. If false, rescale by
 *     `new_height / height`. Treat similarly the width dimension.
 * @param halfPixelCenters Defaults to `false`. Whether to assume pixels are of
 *      half the actual dimensions, and yield more accurate resizes. This flag
 *      would also make the floating point coordinates of the top left pixel
 *      0.5, 0.5.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $257649a521982504$var$resizeNearestNeighbor_(images, size, alignCorners = false, halfPixelCenters = false) {
    const $images = (0, $x4eLk.convertToTensor)(images, 'images', 'resizeNearestNeighbor');
    $eOiOM.assert($images.rank === 3 || $images.rank === 4, ()=>`Error in resizeNearestNeighbor: x must be rank 3 or 4, but got ` + `rank ${$images.rank}.`);
    $eOiOM.assert(size.length === 2, ()=>`Error in resizeNearestNeighbor: new shape must 2D, but got shape ` + `${size}.`);
    $eOiOM.assert($images.dtype === 'float32' || $images.dtype === 'int32', ()=>'`images` must have `int32` or `float32` as dtype');
    $eOiOM.assert(halfPixelCenters === false || alignCorners === false, ()=>`Error in resizeNearestNeighbor: If halfPixelCenters is true, ` + `alignCorners must be false.`);
    let batchImages = $images;
    let reshapedTo4D = false;
    if ($images.rank === 3) {
        reshapedTo4D = true;
        batchImages = (0, $8nMOl.reshape)($images, [
            1,
            $images.shape[0],
            $images.shape[1],
            $images.shape[2]
        ]);
    }
    const [] = size;
    const inputs = {
        images: batchImages
    };
    const attrs = {
        alignCorners: alignCorners,
        halfPixelCenters: halfPixelCenters,
        size: size
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ResizeNearestNeighbor), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $257649a521982504$export$74a902ae74ac2560 = /* @__PURE__ */ (0, $6afhl.op)({
    resizeNearestNeighbor_: $257649a521982504$var$resizeNearestNeighbor_
});

});

parcelRegister("gp22D", function(module, exports) {

$parcel$export(module.exports, "threshold", function () { return $bf10908b7061d5d2$export$454d09aca5f3ea63; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8tOOR = parcelRequire("8tOOR");

var $6afhl = parcelRequire("6afhl");

var $fxiHg = parcelRequire("fxiHg");

var $crriC = parcelRequire("crriC");

var $jqlcD = parcelRequire("jqlcD");

var $bvcEy = parcelRequire("bvcEy");

var $lOlhm = parcelRequire("lOlhm");

var $fPnAL = parcelRequire("fPnAL");

var $6Ab5n = parcelRequire("6Ab5n");

var $5hAos = parcelRequire("5hAos");

var $dIChU = parcelRequire("dIChU");

var $5jGN9 = parcelRequire("5jGN9");

var $eo7jM = parcelRequire("eo7jM");

var $3A1QZ = parcelRequire("3A1QZ");

var $2d2dF = parcelRequire("2d2dF");

var $l7afw = parcelRequire("l7afw");

var $kh5mA = parcelRequire("kh5mA");

var $eZfvk = parcelRequire("eZfvk");

var $eOiOM = parcelRequire("eOiOM");

var $x4eLk = parcelRequire("x4eLk");
/**
 * Performs image binarization with corresponding threshold
 * (depends on the method)value, which creates a binary image from a grayscale.
 * @param image 3d tensor of shape [imageHeight,imageWidth, depth],
 * where imageHeight and imageWidth must be positive.The image color
 * range should be [0, 255].
 * @param method Optional string from `'binary' | 'otsu'`
 * which specifies the method for thresholding. Defaults to 'binary'.
 * @param inverted Optional boolean whichspecifies
 * if colours should be inverted. Defaults to false.
 * @param threshValue Optional number which defines threshold value from 0 to 1.
 * Defaults to 0.5.
 * @return A 3d tensor of shape [imageHeight,imageWidth, depth], which
 * contains binarized image.
 */ function $bf10908b7061d5d2$var$threshold_(image, method = 'binary', inverted = false, threshValue = 0.5) {
    const $image = (0, $x4eLk.convertToTensor)(image, 'image', 'threshold');
    /* 0.2989, 0.5870, 0.1140 are represent luma coefficients in CCIR601.
    Reference for converting between RGB and grayscale: https://en.wikipedia.org/wiki/Luma_%28video%29  */ const RED_INTENCITY_COEF = 0.2989;
    const GREEN_INTENCITY_COEF = 0.5870;
    const BLUE_INTENCITY_COEF = 0.1140;
    const totalPixelsInImage = $image.shape[0] * $image.shape[1];
    let $threshold = (0, $5hAos.mul)((0, $8tOOR.tensor1d)([
        threshValue
    ]), 255);
    let r, g, b, grayscale;
    $eOiOM.assert($image.rank === 3, ()=>'Error in threshold: image must be rank 3,' + `but got rank ${$image.rank}.`);
    $eOiOM.assert($image.shape[2] === 3 || $image.shape[2] === 1, ()=>"Error in threshold: image color channel must be equal to 3 or 1" + `but got ${$image.shape[2]}.`);
    $eOiOM.assert($image.dtype === 'int32' || $image.dtype === 'float32', ()=>'Error in dtype: image dtype must be int32 or float32,' + `but got dtype ${$image.dtype}.`);
    $eOiOM.assert(method === 'otsu' || method === 'binary', ()=>`Method must be binary or otsu, but was ${method}`);
    if ($image.shape[2] === 3) {
        [r, g, b] = (0, $crriC.split)($image, [
            1,
            1,
            1
        ], -1);
        const $r = (0, $5hAos.mul)(r, RED_INTENCITY_COEF);
        const $g = (0, $5hAos.mul)(g, GREEN_INTENCITY_COEF);
        const $b = (0, $5hAos.mul)(b, BLUE_INTENCITY_COEF);
        grayscale = (0, $6Ab5n.add)((0, $6Ab5n.add)($r, $g), $b);
    } else grayscale = image;
    if (method === 'otsu') {
        const $histogram = (0, $jqlcD.bincount)((0, $fxiHg.cast)((0, $eo7jM.round)(grayscale), 'int32'), (0, $eZfvk.tensor)([]), 256);
        $threshold = $bf10908b7061d5d2$var$otsu($histogram, totalPixelsInImage);
    }
    const invCondition = inverted ? (0, $bvcEy.lessEqual)(grayscale, $threshold) : (0, $lOlhm.greater)(grayscale, $threshold);
    const result = (0, $fxiHg.cast)((0, $5hAos.mul)(invCondition, 255), 'int32');
    return result;
}
function $bf10908b7061d5d2$var$otsu(histogram, total) {
    let bestThresh = (0, $8tOOR.tensor1d)([
        -1
    ]);
    let bestInBetVar = (0, $8tOOR.tensor1d)([
        0
    ]);
    let cInBetVar = (0, $8tOOR.tensor1d)([
        0
    ]);
    let classFirst, classSecond, meanFirst, meanSec, weightForeground, weightBack;
    for(let index = 0; index < histogram.size - 1; index++){
        classFirst = (0, $l7afw.slice)(histogram, 0, index + 1);
        classSecond = (0, $l7afw.slice)(histogram, index + 1);
        weightForeground = (0, $dIChU.div)((0, $fPnAL.sum)(classFirst), total);
        weightBack = (0, $dIChU.div)((0, $fPnAL.sum)(classSecond), total);
        const meanFirstDivA = (0, $fPnAL.sum)((0, $5hAos.mul)(classFirst, (0, $kh5mA.range)(0, classFirst.size)));
        meanFirst = (0, $dIChU.div)(meanFirstDivA, (0, $fPnAL.sum)(classFirst));
        const meanSecFill = (0, $2d2dF.fill)(classSecond.shape, classFirst.size);
        const meanSecAdd = (0, $6Ab5n.add)((0, $kh5mA.range)(0, classSecond.size), meanSecFill);
        const meanSecMul = (0, $5hAos.mul)(classSecond, meanSecAdd);
        meanSec = (0, $dIChU.div)((0, $fPnAL.sum)(meanSecMul), (0, $fPnAL.sum)(classSecond));
        const cInBetVarSubA = (0, $5jGN9.sub)(meanFirst, meanSec);
        const cInBetVarSubB = (0, $5jGN9.sub)(meanFirst, meanSec);
        const cInBetVarMul = (0, $5hAos.mul)(weightForeground, weightBack);
        cInBetVar = (0, $5hAos.mul)((0, $5hAos.mul)(cInBetVarMul, cInBetVarSubA), cInBetVarSubB);
        const condition = (0, $lOlhm.greater)(cInBetVar, bestInBetVar);
        bestInBetVar = (0, $3A1QZ.where)(condition, cInBetVar, bestInBetVar);
        bestThresh = (0, $3A1QZ.where)(condition, (0, $8tOOR.tensor1d)([
            index
        ]), bestThresh);
    }
    return bestThresh;
}
const $bf10908b7061d5d2$export$454d09aca5f3ea63 = /* @__PURE__ */ (0, $6afhl.op)({
    threshold_: $bf10908b7061d5d2$var$threshold_
});

});

parcelRegister("1qrB4", function(module, exports) {

$parcel$export(module.exports, "transform", function () { return $109da056154cbad5$export$51186ad6e864892a; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");
/**
 * Applies the given transform(s) to the image(s).
 *
 * @param image 4d tensor of shape `[batch, imageHeight, imageWidth, depth]`.
 * @param transforms Projective transform matrix/matrices. A tensor1d of length
 *     8 or tensor of size N x 8. If one row of transforms is [a0, a1, a2, b0,
 *     b1, b2, c0, c1], then it maps the output point (x, y) to a transformed
 *     input point (x', y') = ((a0 x + a1 y + a2) / k, (b0 x + b1 y + b2) / k),
 *     where k = c0 x + c1 y + 1. The transforms are inverted compared to the
 *     transform mapping input points to output points.
 * @param interpolation Interpolation mode.
 *     Supported values: 'nearest', 'bilinear'. Default to 'nearest'.
 * @param fillMode Points outside the boundaries of the input are filled
 *     according to the given mode, one of 'constant', 'reflect', 'wrap',
 *     'nearest'. Default to 'constant'.
 *     'reflect': (d c b a | a b c d | d c b a ) The input is extended by
 *     reflecting about the edge of the last pixel.
 *     'constant': (k k k k | a b c d | k k k k) The input is extended by
 *     filling all values beyond the edge with the same constant value k.
 *     'wrap': (a b c d | a b c d | a b c d) The input is extended by
 *     wrapping around to the opposite edge.
 *     'nearest': (a a a a | a b c d | d d d d) The input is extended by
 *     the nearest pixel.
 * @param fillValue A float represents the value to be filled outside the
 *     boundaries when fillMode is 'constant'.
 * @param Output dimension after the transform, [height, width]. If undefined,
 *     output is the same size as input image.
 *
 * @doc {heading: 'Operations', subheading: 'Images', namespace: 'image'}
 */ function $109da056154cbad5$var$transform_(image, transforms, interpolation = 'nearest', fillMode = 'constant', fillValue = 0, outputShape) {
    const $image = (0, $x4eLk.convertToTensor)(image, 'image', 'transform', 'float32');
    const $transforms = (0, $x4eLk.convertToTensor)(transforms, 'transforms', 'transform', 'float32');
    $eOiOM.assert($image.rank === 4, ()=>'Error in transform: image must be rank 4,' + `but got rank ${$image.rank}.`);
    $eOiOM.assert($transforms.rank === 2 && ($transforms.shape[0] === $image.shape[0] || $transforms.shape[0] === 1) && $transforms.shape[1] === 8, ()=>`Error in transform: Input transform should be batch x 8 or 1 x 8`);
    $eOiOM.assert(outputShape == null || outputShape.length === 2, ()=>'Error in transform: outputShape must be [height, width] or null, ' + `but got ${outputShape}.`);
    const inputs = {
        image: $image,
        transforms: $transforms
    };
    const attrs = {
        interpolation: interpolation,
        fillMode: fillMode,
        fillValue: fillValue,
        outputShape: outputShape
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Transform), inputs, attrs);
}
const $109da056154cbad5$export$51186ad6e864892a = /* @__PURE__ */ (0, $6afhl.op)({
    transform_: $109da056154cbad5$var$transform_
});

});

parcelRegister("jnFDJ", function(module, exports) {

$parcel$export(module.exports, "bandPart", function () { return $e1c077185ea1db11$export$8a3da9cb9e5610a0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $kKLvn = parcelRequire("kKLvn");

var $lWf8B = parcelRequire("lWf8B");

var $bvcEy = parcelRequire("bvcEy");

var $gXTMu = parcelRequire("gXTMu");

var $7es6p = parcelRequire("7es6p");

var $jMlCE = parcelRequire("jMlCE");

var $6afhl = parcelRequire("6afhl");

var $kh5mA = parcelRequire("kh5mA");

var $8nMOl = parcelRequire("8nMOl");

var $lq9U1 = parcelRequire("lq9U1");

var $5jGN9 = parcelRequire("5jGN9");

var $3mzDh = parcelRequire("3mzDh");

var $3A1QZ = parcelRequire("3A1QZ");

var $lxzgt = parcelRequire("lxzgt");
/**
 * Copy a tensor setting everything outside a central band in each innermost
 * matrix to zero.
 *
 * The band part is computed as follows: Assume input has `k` dimensions
 * `[I, J, K, ..., M, N]`, then the output is a tensor with the same shape where
 * `band[i, j, k, ..., m, n] = in_band(m, n) * input[i, j, k, ..., m, n]`.
 * The indicator function
 * `in_band(m, n) = (num_lower < 0 || (m-n) <= num_lower)`
 * `&& (num_upper < 0 || (n-m) <= num_upper)`
 *
 * ```js
 * const x = tf.tensor2d([[ 0,  1,  2, 3],
 *                        [-1,  0,  1, 2],
 *                        [-2, -1,  0, 1],
 *                        [-3, -2, -1, 0]]);
 * let y = tf.linalg.bandPart(x, 1, -1);
 * y.print(); // [[ 0,  1,  2, 3],
 *            //  [-1,  0,  1, 2],
 *            //  [ 0, -1,  0, 1],
 *            //  [ 0, 0 , -1, 0]]
 * let z = tf.linalg.bandPart(x, 2, 1);
 * z.print(); // [[ 0,  1,  0, 0],
 *            //  [-1,  0,  1, 0],
 *            //  [-2, -1,  0, 1],
 *            //  [ 0, -2, -1, 0]]
 * ```
 *
 * @param x Rank `k` tensor
 * @param numLower Number of subdiagonals to keep.
 *   If negative, keep entire lower triangle.
 * @param numUpper Number of subdiagonals to keep.
 *   If negative, keep entire upper triangle.
 * @returns Rank `k` tensor of the same shape as input.
 *   The extracted banded tensor.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $e1c077185ea1db11$var$bandPart_(a, numLower, numUpper) {
    const $a = (0, $x4eLk.convertToTensor)(a, 'a', 'bandPart');
    (0, $eOiOM.assert)($a.rank >= 2, ()=>`bandPart(): Rank must be at least 2, got ${$a.rank}.`);
    const shape = $a.shape;
    const [M, N] = $a.shape.slice(-2);
    let $numLower;
    let $numUpper;
    if (typeof numLower === 'number') {
        (0, $eOiOM.assert)(numLower % 1 === 0, ()=>`bandPart(): numLower must be an integer, got ${numLower}.`);
        (0, $eOiOM.assert)(numLower <= M, ()=>`bandPart(): numLower (${numLower})` + ` must not be greater than the number of rows (${M}).`);
        $numLower = (0, $x4eLk.convertToTensor)(numLower < 0 ? M : numLower, 'numLower', 'bandPart');
    } else {
        (0, $eOiOM.assert)(numLower.dtype === 'int32', ()=>`bandPart(): numLower's dtype must be an int32.`);
        // If numLower is a Scalar, checking `numLower <= M` could hurt performance,
        // but minimum(numLower, M) could avoid unexpected results.
        $numLower = (0, $3A1QZ.where)((0, $lWf8B.less)(numLower, 0), M, (0, $7es6p.minimum)(numLower, M));
    }
    if (typeof numUpper === 'number') {
        (0, $eOiOM.assert)(numUpper % 1 === 0, ()=>`bandPart(): numUpper must be an integer, got ${numUpper}.`);
        (0, $eOiOM.assert)(numUpper <= N, ()=>`bandPart(): numUpper (${numUpper})` + ` must not be greater than the number of columns (${N}).`);
        $numUpper = (0, $x4eLk.convertToTensor)(numUpper < 0 ? N : numUpper, 'numUpper', 'bandPart');
    } else {
        (0, $eOiOM.assert)(numUpper.dtype === 'int32', ()=>`bandPart(): numUpper's dtype must be an int32.`);
        $numUpper = (0, $3A1QZ.where)((0, $lWf8B.less)(numUpper, 0), N, (0, $7es6p.minimum)(numUpper, N));
    }
    const i = (0, $8nMOl.reshape)((0, $kh5mA.range)(0, M, 1, 'int32'), [
        -1,
        1
    ]);
    const j = (0, $kh5mA.range)(0, N, 1, 'int32');
    const ij = (0, $5jGN9.sub)(i, j);
    const inBand = (0, $gXTMu.logicalAnd)((0, $bvcEy.lessEqual)(ij, $numLower), (0, $kKLvn.greaterEqual)(ij, (0, $jMlCE.neg)($numUpper)));
    const zero = (0, $lxzgt.zeros)([
        M,
        N
    ], $a.dtype);
    return (0, $8nMOl.reshape)((0, $lq9U1.stack)((0, $3mzDh.unstack)((0, $8nMOl.reshape)($a, [
        -1,
        M,
        N
    ])).map((mat)=>(0, $3A1QZ.where)(inBand, mat, zero))), shape);
}
const $e1c077185ea1db11$export$8a3da9cb9e5610a0 = /* @__PURE__ */ (0, $6afhl.op)({
    bandPart_: $e1c077185ea1db11$var$bandPart_
});

});

parcelRegister("egwAq", function(module, exports) {

$parcel$export(module.exports, "gramSchmidt", function () { return $a62bd64c3d799f27$export$d505610386a600de; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $eOiOM = parcelRequire("eOiOM");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $d5YNe = parcelRequire("d5YNe");

var $6afhl = parcelRequire("6afhl");

var $crriC = parcelRequire("crriC");

var $gP42y = parcelRequire("gP42y");

var $lq9U1 = parcelRequire("lq9U1");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");
/**
 * Gram-Schmidt orthogonalization.
 *
 * ```js
 * const x = tf.tensor2d([[1, 2], [3, 4]]);
 * let y = tf.linalg.gramSchmidt(x);
 * y.print();
 * console.log('Orthogonalized:');
 * y.dot(y.transpose()).print();  // should be nearly the identity matrix.
 * console.log('First row direction maintained:');
 * const data = await y.array();
 * console.log(data[0][1] / data[0][0]);  // should be nearly 2.
 * ```
 *
 * @param xs The vectors to be orthogonalized, in one of the two following
 *   formats:
 *   - An Array of `tf.Tensor1D`.
 *   - A `tf.Tensor2D`, i.e., a matrix, in which case the vectors are the rows
 *     of `xs`.
 *   In each case, all the vectors must have the same length and the length
 *   must be greater than or equal to the number of vectors.
 * @returns The orthogonalized and normalized vectors or matrix.
 *   Orthogonalization means that the vectors or the rows of the matrix
 *   are orthogonal (zero inner products). Normalization means that each
 *   vector or each row of the matrix has an L2 norm that equals `1`.
 *
 * @doc {heading:'Operations', subheading:'Linear Algebra', namespace:'linalg'}
 */ function $a62bd64c3d799f27$var$gramSchmidt_(xs) {
    let inputIsTensor2D;
    if (Array.isArray(xs)) {
        inputIsTensor2D = false;
        (0, $eOiOM.assert)(xs != null && xs.length > 0, ()=>"Gram-Schmidt process: input must not be null, undefined, or empty");
        const dim = xs[0].shape[0];
        for(let i = 1; i < xs.length; ++i)(0, $eOiOM.assert)(xs[i].shape[0] === dim, ()=>'Gram-Schmidt: Non-unique lengths found in the input vectors: ' + `(${xs[i].shape[0]} vs. ${dim})`);
    } else {
        inputIsTensor2D = true;
        xs = (0, $crriC.split)(xs, xs.shape[0], 0).map((x)=>(0, $gP42y.squeeze)(x, [
                0
            ]));
    }
    (0, $eOiOM.assert)(xs.length <= xs[0].shape[0], ()=>`Gram-Schmidt: Number of vectors (${xs.length}) exceeds ` + `number of dimensions (${xs[0].shape[0]}).`);
    const ys = [];
    const xs1d = xs;
    for(let i = 0; i < xs.length; ++i)ys.push((0, $e6Ey6.ENGINE).tidy(()=>{
        let x = xs1d[i];
        if (i > 0) for(let j = 0; j < i; ++j){
            const proj = (0, $5hAos.mul)((0, $fPnAL.sum)((0, $5hAos.mul)(ys[j], x)), ys[j]);
            x = (0, $5jGN9.sub)(x, proj);
        }
        return (0, $dIChU.div)(x, (0, $d5YNe.norm)(x, 'euclidean'));
    }));
    if (inputIsTensor2D) return (0, $lq9U1.stack)(ys, 0);
    else return ys;
}
const $a62bd64c3d799f27$export$d505610386a600de = /* @__PURE__ */ (0, $6afhl.op)({
    gramSchmidt_: $a62bd64c3d799f27$var$gramSchmidt_
});

});

parcelRegister("aDtWR", function(module, exports) {

$parcel$export(module.exports, "qr", function () { return $7be4c70a8bf97b6a$export$7c27fb47516129d9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $d7Nxs = parcelRequire("d7Nxs");

var $eOiOM = parcelRequire("eOiOM");

var $ek4FP = parcelRequire("ek4FP");

var $1goxr = parcelRequire("1goxr");

var $dIChU = parcelRequire("dIChU");

var $8YZZT = parcelRequire("8YZZT");

var $lOlhm = parcelRequire("lOlhm");

var $VLFo8 = parcelRequire("VLFo8");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $d5YNe = parcelRequire("d5YNe");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");

var $l7afw = parcelRequire("l7afw");

var $lq9U1 = parcelRequire("lq9U1");

var $5jGN9 = parcelRequire("5jGN9");

var $9NdGd = parcelRequire("9NdGd");

var $9c2so = parcelRequire("9c2so");

var $3mzDh = parcelRequire("3mzDh");

var $3A1QZ = parcelRequire("3A1QZ");
/**
 * Compute QR decomposition of m-by-n matrix using Householder transformation.
 *
 * Implementation based on
 *   [http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf]
 * (http://www.cs.cornell.edu/~bindel/class/cs6210-f09/lec18.pdf)
 *
 * ```js
 * const a = tf.tensor2d([[1, 2], [3, 4]]);
 * let [q, r] = tf.linalg.qr(a);
 * console.log('Q');
 * q.print();
 * console.log('R');
 * r.print();
 * console.log('Orthogonalized');
 * q.dot(q.transpose()).print()  // should be nearly the identity matrix.
 * console.log('Reconstructed');
 * q.dot(r).print(); // should be nearly [[1, 2], [3, 4]];
 * ```
 *
 * @param x The `tf.Tensor` to be QR-decomposed. Must have rank >= 2. Suppose
 *   it has the shape `[..., M, N]`.
 * @param fullMatrices An optional boolean parameter. Defaults to `false`.
 *   If `true`, compute full-sized `Q`. If `false` (the default),
 *   compute only the leading N columns of `Q` and `R`.
 * @returns An `Array` of two `tf.Tensor`s: `[Q, R]`. `Q` is a unitary matrix,
 *   i.e., its columns all have unit norm and are mutually orthogonal.
 *   If `M >= N`,
 *     If `fullMatrices` is `false` (default),
 *       - `Q` has a shape of `[..., M, N]`,
 *       - `R` has a shape of `[..., N, N]`.
 *     If `fullMatrices` is `true` (default),
 *       - `Q` has a shape of `[..., M, M]`,
 *       - `R` has a shape of `[..., M, N]`.
 *   If `M < N`,
 *     - `Q` has a shape of `[..., M, M]`,
 *     - `R` has a shape of `[..., M, N]`.
 * @throws If the rank of `x` is less than 2.
 *
 * @doc {heading:'Operations',
 *       subheading:'Linear Algebra',
 *       namespace:'linalg'}
 */ function $7be4c70a8bf97b6a$var$qr_(x, fullMatrices = false) {
    (0, $eOiOM.assert)(x.rank >= 2, ()=>`qr() requires input tensor to have a rank >= 2, but got rank ${x.rank}`);
    if (x.rank === 2) return $7be4c70a8bf97b6a$var$qr2d(x, fullMatrices);
    else {
        // Rank > 2.
        // TODO(cais): Below we split the input into individual 2D tensors,
        //   perform QR decomposition on them and then stack the results back
        //   together. We should explore whether this can be parallelized.
        const outerDimsProd = x.shape.slice(0, x.shape.length - 2).reduce((value, prev)=>value * prev);
        const x2ds = (0, $3mzDh.unstack)((0, $8nMOl.reshape)(x, [
            outerDimsProd,
            x.shape[x.shape.length - 2],
            x.shape[x.shape.length - 1]
        ]), 0);
        const q2ds = [];
        const r2ds = [];
        x2ds.forEach((x2d)=>{
            const [q2d, r2d] = $7be4c70a8bf97b6a$var$qr2d(x2d, fullMatrices);
            q2ds.push(q2d);
            r2ds.push(r2d);
        });
        const q = (0, $8nMOl.reshape)((0, $lq9U1.stack)(q2ds, 0), x.shape);
        const r = (0, $8nMOl.reshape)((0, $lq9U1.stack)(r2ds, 0), x.shape);
        return [
            q,
            r
        ];
    }
}
function $7be4c70a8bf97b6a$var$qr2d(x, fullMatrices = false) {
    return (0, $e6Ey6.ENGINE).tidy(()=>{
        (0, $eOiOM.assert)(x.shape.length === 2, ()=>`qr2d() requires a 2D Tensor, but got a ${x.shape.length}D Tensor.`);
        const m = x.shape[0];
        const n = x.shape[1];
        let q = (0, $8YZZT.eye)(m); // Orthogonal transform so far.
        let r = (0, $ek4FP.clone)(x); // Transformed matrix so far.
        const one2D = (0, $9NdGd.tensor2d)([
            [
                1
            ]
        ], [
            1,
            1
        ]);
        let w = (0, $ek4FP.clone)(one2D);
        const iters = m >= n ? n : m;
        for(let j = 0; j < iters; ++j){
            // This tidy within the for-loop ensures we clean up temporary
            // tensors as soon as they are no longer needed.
            const rTemp = r;
            const wTemp = w;
            const qTemp = q;
            [w, r, q] = (0, $e6Ey6.ENGINE).tidy(()=>{
                // Find H = I - tau * w * w', to put zeros below R(j, j).
                const rjEnd1 = (0, $l7afw.slice)(r, [
                    j,
                    j
                ], [
                    m - j,
                    1
                ]);
                const normX = (0, $d5YNe.norm)(rjEnd1);
                const rjj = (0, $l7afw.slice)(r, [
                    j,
                    j
                ], [
                    1,
                    1
                ]);
                // The sign() function returns 0 on 0, which causes division by zero.
                const s = (0, $3A1QZ.where)((0, $lOlhm.greater)(rjj, 0), (0, $9NdGd.tensor2d)([
                    [
                        -1
                    ]
                ]), (0, $9NdGd.tensor2d)([
                    [
                        1
                    ]
                ]));
                const u1 = (0, $5jGN9.sub)(rjj, (0, $5hAos.mul)(s, normX));
                const wPre = (0, $dIChU.div)(rjEnd1, u1);
                if (wPre.shape[0] === 1) w = (0, $ek4FP.clone)(one2D);
                else w = (0, $1goxr.concat)([
                    one2D,
                    (0, $l7afw.slice)(wPre, [
                        1,
                        0
                    ], [
                        wPre.shape[0] - 1,
                        wPre.shape[1]
                    ])
                ], 0);
                const tau = (0, $jMlCE.neg)((0, $dIChU.div)((0, $VLFo8.matMul)(s, u1), normX));
                // -- R := HR, Q := QH.
                const rjEndAll = (0, $l7afw.slice)(r, [
                    j,
                    0
                ], [
                    m - j,
                    n
                ]);
                const tauTimesW = (0, $5hAos.mul)(tau, w);
                const wT = (0, $9c2so.transpose)(w);
                if (j === 0) r = (0, $5jGN9.sub)(rjEndAll, (0, $VLFo8.matMul)(tauTimesW, (0, $VLFo8.matMul)(wT, rjEndAll)));
                else {
                    const rTimesTau = (0, $5jGN9.sub)(rjEndAll, (0, $VLFo8.matMul)(tauTimesW, (0, $VLFo8.matMul)(wT, rjEndAll)));
                    r = (0, $1goxr.concat)([
                        (0, $l7afw.slice)(r, [
                            0,
                            0
                        ], [
                            j,
                            n
                        ]),
                        rTimesTau
                    ], 0);
                }
                const tawTimesWT = (0, $9c2so.transpose)(tauTimesW);
                const qAllJEnd = (0, $l7afw.slice)(q, [
                    0,
                    j
                ], [
                    m,
                    q.shape[1] - j
                ]);
                if (j === 0) q = (0, $5jGN9.sub)(qAllJEnd, (0, $VLFo8.matMul)((0, $VLFo8.matMul)(qAllJEnd, w), tawTimesWT));
                else {
                    const qTimesTau = (0, $5jGN9.sub)(qAllJEnd, (0, $VLFo8.matMul)((0, $VLFo8.matMul)(qAllJEnd, w), tawTimesWT));
                    q = (0, $1goxr.concat)([
                        (0, $l7afw.slice)(q, [
                            0,
                            0
                        ], [
                            m,
                            j
                        ]),
                        qTimesTau
                    ], 1);
                }
                return [
                    w,
                    r,
                    q
                ];
            });
            (0, $d7Nxs.dispose)([
                rTemp,
                wTemp,
                qTemp
            ]);
        }
        if (!fullMatrices && m > n) {
            q = (0, $l7afw.slice)(q, [
                0,
                0
            ], [
                m,
                n
            ]);
            r = (0, $l7afw.slice)(r, [
                0,
                0
            ], [
                n,
                n
            ]);
        }
        return [
            q,
            r
        ];
    });
}
const $7be4c70a8bf97b6a$export$7c27fb47516129d9 = /* @__PURE__ */ (0, $6afhl.op)({
    qr_: $7be4c70a8bf97b6a$var$qr_
});

});

parcelRegister("e3TnG", function(module, exports) {

$parcel$export(module.exports, "absoluteDifference", function () { return $a3cc4e0299a9807e$export$d81f35aebafd8971; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $57D4R = parcelRequire("57D4R");

var $k5WDh = parcelRequire("k5WDh");

var $6afhl = parcelRequire("6afhl");

var $5jGN9 = parcelRequire("5jGN9");

var $lWhFs = parcelRequire("lWhFs");
/**
 * Computes the absolute difference loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $a3cc4e0299a9807e$var$absoluteDifference_(labels, predictions, weights, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $x4eLk.convertToTensor)(labels, 'labels', 'absoluteDifference');
    const $predictions = (0, $x4eLk.convertToTensor)(predictions, 'predictions', 'absoluteDifference');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'absoluteDifference');
    (0, $eOiOM.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in absoluteDifference: ');
    const losses = (0, $57D4R.abs)((0, $5jGN9.sub)($labels, $predictions));
    return (0, $lWhFs.computeWeightedLoss)(losses, $weights, reduction);
}
const $a3cc4e0299a9807e$export$d81f35aebafd8971 = /* @__PURE__ */ (0, $6afhl.op)({
    absoluteDifference_: $a3cc4e0299a9807e$var$absoluteDifference_
});

});
parcelRegister("k5WDh", function(module, exports) {

$parcel$export(module.exports, "Reduction", function () { return $ea11c17569c6a067$export$cc9fa7113d70efba; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ var $ea11c17569c6a067$export$cc9fa7113d70efba;
(function(Reduction) {
    Reduction[Reduction["NONE"] = 0] = "NONE";
    Reduction[Reduction["MEAN"] = 1] = "MEAN";
    Reduction[Reduction["SUM"] = 2] = "SUM";
    Reduction[Reduction["SUM_BY_NONZERO_WEIGHTS"] = 3] = "SUM_BY_NONZERO_WEIGHTS";
})($ea11c17569c6a067$export$cc9fa7113d70efba || ($ea11c17569c6a067$export$cc9fa7113d70efba = {}));

});

parcelRegister("lWhFs", function(module, exports) {

$parcel$export(module.exports, "computeWeightedLoss", function () { return $ff8cb8351b53d832$export$23bdc4cea2e28782; });

var $x4eLk = parcelRequire("x4eLk");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $k5WDh = parcelRequire("k5WDh");

var $3TgHP = parcelRequire("3TgHP");

var $5hAos = parcelRequire("5hAos");

var $8BIHZ = parcelRequire("8BIHZ");

var $K2k22 = parcelRequire("K2k22");

var $6afhl = parcelRequire("6afhl");

var $7hONX = parcelRequire("7hONX");

var $fPnAL = parcelRequire("fPnAL");
/**
 * Computes the weighted loss between two tensors.
 *
 * @param losses Tensor of shape `[batch_size, d1, ..., dN]`.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `losses`, and must be broadcastable to `losses` (i.e., all
 *    dimensions must be either `1`, or the same as the corresponding
 *    `losses` dimension).
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $ff8cb8351b53d832$var$computeWeightedLoss_(losses, weights, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $losses = (0, $x4eLk.convertToTensor)(losses, 'losses', 'computeWeightedLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'computeWeightedLoss');
    const weightedLoss = $weights == null ? $losses : (0, $5hAos.mul)($losses, $weights);
    if (reduction === (0, $k5WDh.Reduction).NONE) return weightedLoss;
    if (reduction === (0, $k5WDh.Reduction).SUM) return (0, $fPnAL.sum)(weightedLoss);
    if (reduction === (0, $k5WDh.Reduction).MEAN) {
        if ($weights == null) return (0, $3TgHP.mean)(weightedLoss);
        else {
            const broadcastFactor = $losses.size / $weights.size;
            const result = (0, $dIChU.div)((0, $fPnAL.sum)(weightedLoss), (0, $fPnAL.sum)($weights));
            return broadcastFactor > 1 ? (0, $dIChU.div)(result, (0, $7hONX.scalar)(broadcastFactor)) : result;
        }
    }
    if (reduction === (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
        if ($weights == null) return (0, $dIChU.div)((0, $fPnAL.sum)(weightedLoss), (0, $7hONX.scalar)($losses.size));
        else {
            const broadcastedWeights = (0, $5hAos.mul)($weights, (0, $K2k22.ones)($losses.shape));
            const numNonZeros = (0, $fxiHg.cast)((0, $fPnAL.sum)((0, $8BIHZ.notEqual)(broadcastedWeights, (0, $7hONX.scalar)(0))), 'float32');
            return (0, $dIChU.div)((0, $fPnAL.sum)(weightedLoss), numNonZeros);
        }
    }
    throw Error(`Unknown reduction: ${reduction}`);
}
const $ff8cb8351b53d832$export$23bdc4cea2e28782 = /* @__PURE__ */ (0, $6afhl.op)({
    computeWeightedLoss_: $ff8cb8351b53d832$var$computeWeightedLoss_
});

});


parcelRegister("3bKD7", function(module, exports) {

$parcel$export(module.exports, "cosineDistance", function () { return $252691e8d0b068a2$export$6168ae03858f836b; });

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $k5WDh = parcelRequire("k5WDh");

var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");

var $lWhFs = parcelRequire("lWhFs");
/**
 * Computes the cosine distance loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param axis The dimension along which the cosine distance is computed.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $252691e8d0b068a2$var$cosineDistance_(labels, predictions, axis, weights, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $x4eLk.convertToTensor)(labels, 'labels', 'cosineDistance');
    const $predictions = (0, $x4eLk.convertToTensor)(predictions, 'predictions', 'cosineDistance');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'cosineDistance');
    (0, $eOiOM.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in cosineDistance: ');
    const one = (0, $7hONX.scalar)(1);
    const losses = (0, $5jGN9.sub)(one, (0, $fPnAL.sum)((0, $5hAos.mul)($labels, $predictions), axis, true));
    return (0, $lWhFs.computeWeightedLoss)(losses, $weights, reduction);
}
const $252691e8d0b068a2$export$6168ae03858f836b = /* @__PURE__ */ (0, $6afhl.op)({
    cosineDistance_: $252691e8d0b068a2$var$cosineDistance_
});

});

parcelRegister("bJALc", function(module, exports) {

$parcel$export(module.exports, "hingeLoss", function () { return $88b06981327fafb0$export$fc7754731492f43f; });

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $k5WDh = parcelRequire("k5WDh");

var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $aQaR3 = parcelRequire("aQaR3");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");

var $lWhFs = parcelRequire("lWhFs");
/**
 * Computes the Hinge loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $88b06981327fafb0$var$hingeLoss_(labels, predictions, weights, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $labels = (0, $x4eLk.convertToTensor)(labels, 'labels', 'hingeLoss');
    const $predictions = (0, $x4eLk.convertToTensor)(predictions, 'predictions', 'hingeLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'hingeLoss');
    (0, $eOiOM.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in hingeLoss: ');
    const one = (0, $7hONX.scalar)(1);
    // Convert binary labels to (-1, 1)
    $labels = (0, $5jGN9.sub)((0, $5hAos.mul)((0, $7hONX.scalar)(2), $labels), one);
    const losses = (0, $aQaR3.relu)((0, $5jGN9.sub)(one, (0, $5hAos.mul)($labels, $predictions)));
    return (0, $lWhFs.computeWeightedLoss)(losses, $weights, reduction);
}
const $88b06981327fafb0$export$fc7754731492f43f = /* @__PURE__ */ (0, $6afhl.op)({
    hingeLoss_: $88b06981327fafb0$var$hingeLoss_
});

});

parcelRegister("jKo44", function(module, exports) {

$parcel$export(module.exports, "huberLoss", function () { return $e604faf283da27a8$export$ad2dd557b367bf2b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $57D4R = parcelRequire("57D4R");

var $6Ab5n = parcelRequire("6Ab5n");

var $k5WDh = parcelRequire("k5WDh");

var $7es6p = parcelRequire("7es6p");

var $5hAos = parcelRequire("5hAos");

var $6afhl = parcelRequire("6afhl");

var $7hONX = parcelRequire("7hONX");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");

var $lWhFs = parcelRequire("lWhFs");
/**
 * Computes the Huber loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param delta Point where Huber loss changes from quadratic to linear.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`.
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $e604faf283da27a8$var$huberLoss_(labels, predictions, weights, delta = 1.0, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $x4eLk.convertToTensor)(labels, 'labels', 'huberLoss');
    const $predictions = (0, $x4eLk.convertToTensor)(predictions, 'predictions', 'huberLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'huberLoss');
    (0, $eOiOM.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in huberLoss: ');
    const deltaScalar = (0, $7hONX.scalar)(delta);
    const error = (0, $57D4R.abs)((0, $5jGN9.sub)($predictions, $labels));
    const quadratic = (0, $7es6p.minimum)(error, deltaScalar);
    const linear = (0, $5jGN9.sub)(error, quadratic);
    const losses = (0, $6Ab5n.add)((0, $5hAos.mul)((0, $7hONX.scalar)(0.5), (0, $5MB84.square)(quadratic)), (0, $5hAos.mul)(deltaScalar, linear));
    return (0, $lWhFs.computeWeightedLoss)(losses, $weights, reduction);
}
const $e604faf283da27a8$export$ad2dd557b367bf2b = /* @__PURE__ */ (0, $6afhl.op)({
    huberLoss_: $e604faf283da27a8$var$huberLoss_
});

});

parcelRegister("1wkM8", function(module, exports) {

$parcel$export(module.exports, "logLoss", function () { return $11b8e52b38ca03ac$export$5ca6937b99935214; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6Ab5n = parcelRequire("6Ab5n");

var $1gLFX = parcelRequire("1gLFX");

var $k5WDh = parcelRequire("k5WDh");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $6afhl = parcelRequire("6afhl");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");

var $lWhFs = parcelRequire("lWhFs");
/**
 * Computes the log loss between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param epsilon A small increment to avoid taking log of zero
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $11b8e52b38ca03ac$var$logLoss_(labels, predictions, weights, epsilon = 1e-7, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $x4eLk.convertToTensor)(labels, 'labels', 'logLoss');
    const $predictions = (0, $x4eLk.convertToTensor)(predictions, 'predictions', 'logLoss');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'logLoss');
    (0, $eOiOM.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in logLoss: ');
    const one = (0, $7hONX.scalar)(1);
    const epsilonScalar = (0, $7hONX.scalar)(epsilon);
    const l1 = (0, $jMlCE.neg)((0, $5hAos.mul)($labels, (0, $1gLFX.log)((0, $6Ab5n.add)($predictions, epsilonScalar))));
    const l2 = (0, $5hAos.mul)((0, $5jGN9.sub)(one, $labels), (0, $1gLFX.log)((0, $6Ab5n.add)((0, $5jGN9.sub)(one, $predictions), epsilonScalar)));
    const losses = (0, $5jGN9.sub)(l1, l2);
    return (0, $lWhFs.computeWeightedLoss)(losses, $weights, reduction);
}
const $11b8e52b38ca03ac$export$5ca6937b99935214 = /* @__PURE__ */ (0, $6afhl.op)({
    logLoss_: $11b8e52b38ca03ac$var$logLoss_
});

});

parcelRegister("eXYo2", function(module, exports) {

$parcel$export(module.exports, "meanSquaredError", function () { return $ae556ae9b0003148$export$33de16355e97f7fb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $k5WDh = parcelRequire("k5WDh");

var $6afhl = parcelRequire("6afhl");

var $fqiRx = parcelRequire("fqiRx");

var $lWhFs = parcelRequire("lWhFs");
/**
 * Computes the mean squared error between two tensors.
 *
 * @param labels The ground truth output tensor, same dimensions as
 *    'predictions'.
 * @param predictions The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc {heading: 'Training', subheading: 'Losses', namespace: 'losses'}
 */ function $ae556ae9b0003148$var$meanSquaredError_(labels, predictions, weights, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    const $labels = (0, $x4eLk.convertToTensor)(labels, 'labels', 'meanSquaredError');
    const $predictions = (0, $x4eLk.convertToTensor)(predictions, 'predictions', 'meanSquaredError');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'meanSquaredError');
    (0, $eOiOM.assertShapesMatch)($labels.shape, $predictions.shape, 'Error in meanSquaredError: ');
    const losses = (0, $fqiRx.squaredDifference)($labels, $predictions);
    return (0, $lWhFs.computeWeightedLoss)(losses, $weights, reduction);
}
const $ae556ae9b0003148$export$33de16355e97f7fb = /* @__PURE__ */ (0, $6afhl.op)({
    meanSquaredError_: $ae556ae9b0003148$var$meanSquaredError_
});

});

parcelRegister("luPsK", function(module, exports) {

$parcel$export(module.exports, "sigmoidCrossEntropy", function () { return $fa6451bc6d93af71$export$d099e04c73e0aede; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $57D4R = parcelRequire("57D4R");

var $6Ab5n = parcelRequire("6Ab5n");

var $1lCoz = parcelRequire("1lCoz");

var $ifd1X = parcelRequire("ifd1X");

var $k5WDh = parcelRequire("k5WDh");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $6afhl = parcelRequire("6afhl");

var $aQaR3 = parcelRequire("aQaR3");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");

var $lWhFs = parcelRequire("lWhFs");
function $fa6451bc6d93af71$var$sigmoidCrossEntropyWithLogits_(labels, logits) {
    const $labels = (0, $x4eLk.convertToTensor)(labels, 'labels', 'sigmoidCrossEntropyWithLogits');
    const $logits = (0, $x4eLk.convertToTensor)(logits, 'logits', 'sigmoidCrossEntropyWithLogits');
    (0, $eOiOM.assertShapesMatch)($labels.shape, $logits.shape, 'Error in sigmoidCrossEntropyWithLogits: ');
    /**
     * Implementation Details:
     *
     * For brevity, let `x = logits`, `z = labels`.  The logistic loss is
     *     z * -log(sigmoid(x)) + (1 - z) * -log(1 - sigmoid(x))
     *   = z * -log(1 / (1 + exp(-x))) + (1 - z) * -log(exp(-x) / (1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (-log(exp(-x)) + log(1 + exp(-x)))
     *   = z * log(1 + exp(-x)) + (1 - z) * (x + log(1 + exp(-x))
     *   = (1 - z) * x + log(1 + exp(-x))
     *   = x - x * z + log(1 + exp(-x))
     *
     *   For x < 0, to avoid overflow in exp(-x), we reformulate the above
     *     x - x * z + log(1 + exp(-x))
     *   = log(exp(x)) - x * z + log(1 + exp(-x))
     *   = - x * z + log(1 + exp(x))
     *
     * Hence, to ensure stability and avoid overflow, the implementation uses
     * this equivalent formulation:
     *     max(x, 0) - x * z + log(1 + exp(-abs(x)))
     */ const maxOutput = (0, $aQaR3.relu)($logits);
    const outputXTarget = (0, $5hAos.mul)($logits, $labels);
    const sigmoidOutput = (0, $ifd1X.log1p)((0, $1lCoz.exp)((0, $jMlCE.neg)((0, $57D4R.abs)($logits))));
    return (0, $6Ab5n.add)((0, $5jGN9.sub)(maxOutput, outputXTarget), sigmoidOutput);
}
/**
 * Computes the sigmoid cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newMulticlassLabels = multiclassLabels * (1 - labelSmoothing)
 *                         + 0.5 * labelSmoothing
 *
 * @param multiClassLabels The ground truth output tensor of shape
 * [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or the same rank as
 *    `labels`, and must be broadcastable to `labels` (i.e., all dimensions
 *    must be either `1`, or the same as the corresponding `losses`
 *    dimension).
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $fa6451bc6d93af71$var$sigmoidCrossEntropy_(multiClassLabels, logits, weights, labelSmoothing = 0, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $multiClassLabels = (0, $x4eLk.convertToTensor)(multiClassLabels, 'multiClassLabels', 'sigmoidCrossEntropy');
    const $logits = (0, $x4eLk.convertToTensor)(logits, 'logits', 'sigmoidCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'sigmoidCrossEntropy');
    (0, $eOiOM.assertShapesMatch)($multiClassLabels.shape, $logits.shape, 'Error in sigmoidCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $7hONX.scalar)(labelSmoothing);
        const one = (0, $7hONX.scalar)(1);
        const half = (0, $7hONX.scalar)(0.5);
        $multiClassLabels = (0, $6Ab5n.add)((0, $5hAos.mul)($multiClassLabels, (0, $5jGN9.sub)(one, labelSmoothingScalar)), (0, $5hAos.mul)(half, labelSmoothingScalar));
    }
    const losses = $fa6451bc6d93af71$var$sigmoidCrossEntropyWithLogits_($multiClassLabels, $logits);
    return (0, $lWhFs.computeWeightedLoss)(losses, $weights, reduction);
}
const $fa6451bc6d93af71$export$d099e04c73e0aede = /* @__PURE__ */ (0, $6afhl.op)({
    sigmoidCrossEntropy_: $fa6451bc6d93af71$var$sigmoidCrossEntropy_
});

});

parcelRegister("jSpBE", function(module, exports) {

$parcel$export(module.exports, "softmaxCrossEntropy", function () { return $e786ec5d55652efe$export$38869aa02829577; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1Npyr = parcelRequire("1Npyr");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6Ab5n = parcelRequire("6Ab5n");

var $bC6Qi = parcelRequire("bC6Qi");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $1lCoz = parcelRequire("1lCoz");

var $1UrMu = parcelRequire("1UrMu");

var $k5WDh = parcelRequire("k5WDh");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");

var $lWhFs = parcelRequire("lWhFs");
/**
 * Computes softmax cross entropy between logits and labels.
 *
 * Measures the probability error in discrete classification tasks in which
 * the classes are mutually exclusive (each entry is in exactly one class).
 * For example, each CIFAR-10 image is labeled with one and only one label: an
 * image can be a dog or a truck, but not both.
 *
 * `NOTE`: While the classes are mutually exclusive, their probabilities need
 * not be. All that is required is that each row of labels is a valid
 * probability distribution. If they are not, the computation of the gradient
 * will be incorrect.
 *
 * `WARNING`: This op expects unscaled logits, since it performs a softmax on
 * logits internally for efficiency. Do not call this op with the output of
 * softmax, as it will produce incorrect results.
 *
 * logits and labels must have the same shape, e.g. [batch_size, num_classes]
 * and the same dtype.
 * @param labels The labels array.
 * @param logits The logits array.
 * @param dim The dimension softmax would be performed on. Defaults to `-1`
 *     which indicates the last dimension.
 */ function $e786ec5d55652efe$var$softmaxCrossEntropyWithLogits_(labels, logits, dim = -1) {
    if (dim === -1) dim = logits.rank - 1;
    if (dim !== logits.rank - 1) throw Error(`Softmax cross entropy along a non-last dimension is not yet ` + `supported. Labels / logits was rank ${logits.rank} ` + `and dim was ${dim}`);
    // Use a custom gradient for numerical stability.
    const customOp = (0, $1Npyr.customGrad)((labels, logits, save)=>{
        // Reference:
        //   1. http://cs231n.github.io/linear-classify/#softmax
        //   2. https://blog.feedly.com/tricks-of-the-trade-logsumexp/
        const keepDims = true;
        const lse = (0, $1UrMu.logSumExp)(logits, [
            dim
        ], keepDims);
        const logResult = (0, $5jGN9.sub)((0, $fxiHg.cast)(logits, 'float32'), lse);
        save([
            labels,
            logResult
        ]);
        const costVector = (0, $jMlCE.neg)((0, $5hAos.mul)(logResult, labels));
        const value = (0, $fPnAL.sum)(costVector, [
            dim
        ]);
        const gradFunc = (dy, saved)=>{
            const [labels, logResult] = saved;
            const dyShape = (0, $bC6Qi.expandShapeToKeepDim)(dy.shape, [
                dim
            ]);
            return [
                (0, $5hAos.mul)((0, $8nMOl.reshape)(dy, dyShape), (0, $5jGN9.sub)((0, $fxiHg.cast)(labels, 'float32'), (0, $1lCoz.exp)(logResult))),
                (0, $5hAos.mul)((0, $8nMOl.reshape)(dy, dyShape), (0, $5jGN9.sub)((0, $1lCoz.exp)(logResult), (0, $fxiHg.cast)(labels, 'float32')))
            ];
        };
        return {
            value: value,
            gradFunc: gradFunc
        };
    });
    return customOp(labels, logits);
}
/**
 * Computes the softmax cross entropy loss between two tensors.
 *
 * If labelSmoothing is nonzero, smooth the labels towards 1/2:
 *
 *   newOnehotLabels = onehotLabels * (1 - labelSmoothing)
 *                         + labelSmoothing / numClasses
 *
 * @param onehotLabels One hot encoded labels
 *    [batch_size, num_classes], same dimensions as 'predictions'.
 * @param logits The predicted outputs.
 * @param weights Tensor whose rank is either 0, or 1, and must be
 *    broadcastable to `loss`  of shape [batch_size]
 * @param labelSmoothing If greater than 0, then smooth the labels.
 * @param reduction Type of reduction to apply to loss. Should be of type
 *    `Reduction`
 *
 * @doc { heading: 'Training', subheading: 'Losses', namespace: 'losses' }
 */ function $e786ec5d55652efe$var$softmaxCrossEntropy_(onehotLabels, logits, weights, labelSmoothing = 0, reduction = (0, $k5WDh.Reduction).SUM_BY_NONZERO_WEIGHTS) {
    let $onehotLabels = (0, $x4eLk.convertToTensor)(onehotLabels, 'onehotLabels', 'softmaxCrossEntropy');
    const $logits = (0, $x4eLk.convertToTensor)(logits, 'logits', 'softmaxCrossEntropy');
    let $weights = null;
    if (weights != null) $weights = (0, $x4eLk.convertToTensor)(weights, 'weights', 'softmaxCrossEntropy');
    (0, $eOiOM.assertShapesMatch)($onehotLabels.shape, $logits.shape, 'Error in softmaxCrossEntropy: ');
    if (labelSmoothing > 0) {
        const labelSmoothingScalar = (0, $7hONX.scalar)(labelSmoothing);
        const one = (0, $7hONX.scalar)(1);
        const numClasses = (0, $7hONX.scalar)($onehotLabels.shape[1]);
        $onehotLabels = (0, $6Ab5n.add)((0, $5hAos.mul)($onehotLabels, (0, $5jGN9.sub)(one, labelSmoothingScalar)), (0, $dIChU.div)(labelSmoothingScalar, numClasses));
    }
    const losses = $e786ec5d55652efe$var$softmaxCrossEntropyWithLogits_($onehotLabels, $logits);
    return (0, $lWhFs.computeWeightedLoss)(losses, $weights, reduction);
}
const $e786ec5d55652efe$export$38869aa02829577 = /* @__PURE__ */ (0, $6afhl.op)({
    softmaxCrossEntropy_: $e786ec5d55652efe$var$softmaxCrossEntropy_
});

});

parcelRegister("gXK2O", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRows", function () { return $c595df76bd6605ae$export$c82a1904a15b5028; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * The input SparseTensor is represented via the map of inputs {`indices`,
 * `values`, `denseShape`}. The output SparseTensor has the same `denseShape`
 * but with indices `outputIndices` and values `outputValues`. This op inserts a
 * single entry for every row that doesn't have any values. The index is created
 * as `[row, 0, ..., 0]` and the inserted value is `defaultValue`.
 *
 * For example, suppose `spInput` has shape [5, 6] and non-empty values:
 * [0, 1]: a
 * [0, 3]: b
 * [2, 0]: c
 * [3, 1]: d
 *
 * Rows 1 and 4 are empty, so the output will be of shape [5, 6] with values:
 * [0, 1]: a
 * [0, 3]: b
 * [1, 0]: `defaultValue`
 * [2, 0]: c
 * [3, 1]: d
 * [4, 0]: `defaultValue`
 *
 * The output SparseTensor will be in row-major order and will have the same
 * shape as the input.
 *
 * This op also returns an indicator vector shaped [dense_shape[0]] such that
 * emptyRowIndicator[i] = True iff row i was an empty row.
 *
 * And a reverse index map vector shaped [indices.shape[0]] that is used during
 * backpropagation, reverseIndexMap[i] = outi s.t. indices[i, j] ==
 * outputIndices[outi, j] for all j
 *
 * ```js
 * const result = tf.sparse.sparseFillEmptyRows(
 *   [[0, 0], [1, 0], [1, 3], [1, 4], [3, 2], [3, 3]],
 *   [0, 10, 13, 14, 32, 33], [5, 6], -1);
 * console.log(result);
 * result['outputIndices'].print(); // [[0, 0], [1, 0], [1, 3], [1, 4],
 *                                  //  [2, 0], [3, 2], [3, 3], [4, 0]]
 * result['outputValues'].print(); // [0, 10, 13, 14,-1, 32, 33, -1]
 * result['emptyRowIndicator'].print(); // [false, false, true, false, true]
 * result['reverseIndexMap'].print(); // [0, 1, 2, 3, 5, 6]
 * ```
 * @param indices: 2-D. The indices of the sparse tensor.
 * @param values: 1-D. The values of the sparse tensor.
 * @param denseShape: 1-D. The shape of the sparse tensor.
 * @param defaultValue: 0-D. Default value to insert into location [row, 0, ...,
 *     0] for rows missing from the input sparse tensor.
 * @return A map with the following properties:
 *     - outputIndices
 *     - outputValues: 1-D. The values of the filled sparse tensor.
 *     - emptyRowIndicator: 1-D. Whether the dense row was missing in the input
 * sparse tensor.
 *     - reverseIndexMap: 1-D. A map from the input indices to the output
 * indices.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $c595df76bd6605ae$var$sparseFillEmptyRows_(indices, values, denseShape, defaultValue) {
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'sparseFillEmptyRows', 'int32');
    const $values = (0, $x4eLk.convertToTensor)(values, 'values', 'sparseFillEmptyRows');
    const $denseShape = (0, $x4eLk.convertToTensor)(denseShape, 'denseShape', 'sparseFillEmptyRows', 'int32');
    const $defaultValue = (0, $x4eLk.convertToTensor)(defaultValue, 'defaultValue', 'sparseFillEmptyRows', $values.dtype);
    if ($indices.rank !== 2) throw new Error(`Indices should be Tensor2D but received shape
        ${$indices.shape}`);
    if ($values.rank !== 1) throw new Error(`Values should be Tensor1D but received shape ${$values.shape}`);
    if ($denseShape.rank !== 1) throw new Error(`Dense shape should be Tensor1D but received shape ${$denseShape.shape}`);
    if ($defaultValue.rank !== 0) throw new Error(`Default value should be a scalar but received shape ${$defaultValue.shape}`);
    const inputs = {
        indices: $indices,
        values: $values,
        denseShape: $denseShape,
        defaultValue: $defaultValue
    };
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SparseFillEmptyRows), inputs);
    return {
        outputIndices: result[0],
        outputValues: result[1],
        emptyRowIndicator: result[2],
        reverseIndexMap: result[3]
    };
}
const $c595df76bd6605ae$export$c82a1904a15b5028 = /* @__PURE__ */ (0, $6afhl.op)({
    sparseFillEmptyRows_: $c595df76bd6605ae$var$sparseFillEmptyRows_
});

});

parcelRegister("fjCAr", function(module, exports) {

$parcel$export(module.exports, "sparseReshape", function () { return $b2668fe71efdaeb3$export$1408c45865e11fc6; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * This operation has the same semantics as reshape on the represented dense
 * tensor. The `inputIndices` are recomputed based on the requested `newShape`.
 * If one component of `newShape` is the special value -1, the size of that
 * dimension is computed so that the total dense size remains constant. At most
 * one component of `newShape` can be -1. The number of dense elements implied
 * by `newShape` must be the same as the number of dense elements originally
 * implied by `inputShape`. Reshaping does not affect the order of values in the
 * SparseTensor. If the input tensor has rank R_in and N non-empty values, and
 * `newShape` has length R_out, then `inputIndices` has shape [N, R_in],
 * `inputShape` has length R_in, `outputIndices` has shape [N, R_out], and
 * `outputShape` has length R_out.
 *
 * ```js
 * const result = tf.sparse.sparseReshape(
 *   [[0, 0, 0], [0, 0, 1], [0, 1, 0], [1, 0, 0], [1, 2, 3]],
 *   [2, 3, 6], [9, -1]);
 * console.log(result);
 * result['outputIndices'].print(); //[[0, 0], [0, 1], [1, 2], [4, 2], [8, 1]]
 * result['outputShape'].print(); // [9, 4]
 * ```
 * @param inputIndices: 2-D. N x R_in matrix with the indices of non-empty
 * values in a SparseTensor.
 * @param inputShape: 1-D. R_in Tensor1D with the input SparseTensor's dense
 * shape.
 * @param newShape: 1-D. R_out Tensor1D with the requested new dense shape.
 * @return A map with the following properties:
 *     - outputIndices: 2-D. N x R_out matrix with the updated indices of
 *       non-empty values in the output SparseTensor.
 *     - outputShape: 1-D. R_out vector with the full dense shape of the output
 *       SparseTensor. This is the same as newShape but with any -1 dimensions
 *        filled in.
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $b2668fe71efdaeb3$var$sparseReshape_(inputIndices, inputShape, newShape) {
    const $inputIndices = (0, $x4eLk.convertToTensor)(inputIndices, 'inputIndices', 'sparseReshape', 'int32');
    const $inputShape = (0, $x4eLk.convertToTensor)(inputShape, 'inputShape', 'sparseReshape', 'int32');
    const $newShape = (0, $x4eLk.convertToTensor)(newShape, 'newShape', 'sparseReshape', 'int32');
    if ($inputIndices.rank !== 2) throw new Error(`Input indices should be Tensor2D but received shape
        ${$inputIndices.shape}`);
    if ($inputShape.rank !== 1) throw new Error(`Input shape should be Tensor1D but received shape ${$inputShape.shape}`);
    if ($newShape.rank !== 1) throw new Error(`New shape should be Tensor1D but received shape ${$newShape.shape}`);
    const inputs = {
        inputIndices: $inputIndices,
        inputShape: $inputShape,
        newShape: $newShape
    };
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SparseReshape), inputs);
    return {
        outputIndices: result[0],
        outputShape: result[1]
    };
}
const $b2668fe71efdaeb3$export$1408c45865e11fc6 = /* @__PURE__ */ (0, $6afhl.op)({
    sparseReshape_: $b2668fe71efdaeb3$var$sparseReshape_
});

});

parcelRegister("dtYdH", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentMean", function () { return $9d0cb2391eb5ece1$export$dbc0c9096869d04e; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the mean along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [6,7,8,9]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentMean(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1], 'int32'),
 *                                             tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentMean(c,
 *                                             tf.tensor1d([0, 1, 2], 'int32'),
 *                                             tf.tensor1d([0, 1, 1], 'int32'));
 * result3.print(); // [[1.0, 2.0, 3.0, 4.0], [2.5, 2.5, 2.5, 2.5]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $9d0cb2391eb5ece1$var$sparseSegmentMean_(data, indices, segmentIds) {
    const $data = (0, $x4eLk.convertToTensor)(data, 'data', 'sparseSegmentMean');
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'sparseSegmentMean', 'int32');
    const $segmentIds = (0, $x4eLk.convertToTensor)(segmentIds, 'segmentIds', 'sparseSegmentMean', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
          ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
          ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SparseSegmentMean), inputs);
}
const $9d0cb2391eb5ece1$export$dbc0c9096869d04e = /* @__PURE__ */ (0, $6afhl.op)({
    sparseSegmentMean_: $9d0cb2391eb5ece1$var$sparseSegmentMean_
});

});

parcelRegister("4fH8f", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentSum", function () { return $318a05496a4ad5bd$export$2255ce53fc777865; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the sum along sparse segments of a tensor.
 *
 * ```js
 * const c = tf.tensor2d([[1,2,3,4], [-1,-2,-3,-4], [5,6,7,8]]);
 * // Select two rows, one segment.
 * const result1 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 0], 'int32'));
 * result1.print(); // [[0, 0, 0, 0]]
 *
 * // Select two rows, two segments.
 * const result2 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1], 'int32'),
 *                                           tf.tensor1d([0, 1], 'int32'));
 * result2.print(); // [[1, 2, 3, 4], [-1, -2, -3, -4]]
 *
 * // Select all rows, two segments.
 * const result3 = tf.sparse.sparseSegmentSum(c,
 *                                           tf.tensor1d([0, 1, 2], 'int32'),
 *                                           tf.tensor1d([0, 0, 1], 'int32'));
 * result3.print(); // [[0, 0, 0, 0], [5, 6, 7, 8]]
 * ```
 * @param data: A Tensor of at least one dimension with data that will be
 *     assembled in the output.
 * @param indices: A 1-D Tensor with indices into data. Has same rank as
 *     segmentIds.
 * @param segmentIds: A 1-D Tensor with indices into the output Tensor. Values
 *     should be sorted and can be repeated.
 * @return Has same shape as data, except for dimension 0 which has equal to
 *         the number of segments.
 *
 * @doc {heading: 'Operations', subheading: 'Sparse'}
 */ function $318a05496a4ad5bd$var$sparseSegmentSum_(data, indices, segmentIds) {
    const $data = (0, $x4eLk.convertToTensor)(data, 'data', 'sparseSegmentSum');
    const $indices = (0, $x4eLk.convertToTensor)(indices, 'indices', 'sparseSegmentSum', 'int32');
    const $segmentIds = (0, $x4eLk.convertToTensor)(segmentIds, 'segmentIds', 'sparseSegmentSum', 'int32');
    if ($data.rank < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if ($indices.rank !== 1) throw new Error(`Indices should be Tensor1D but received shape
         ${$indices.shape}`);
    if ($segmentIds.rank !== 1) throw new Error(`Segment ids should be Tensor1D but received shape
         ${$segmentIds.shape}`);
    const inputs = {
        data: $data,
        indices: $indices,
        segmentIds: $segmentIds
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.SparseSegmentSum), inputs);
}
const $318a05496a4ad5bd$export$2255ce53fc777865 = /* @__PURE__ */ (0, $6afhl.op)({
    sparseSegmentSum_: $318a05496a4ad5bd$var$sparseSegmentSum_
});

});

parcelRegister("dCJkA", function(module, exports) {

$parcel$export(module.exports, "stringNGrams", function () { return $9eb1fcc44ad9b3ca$export$3490514dcc63b044; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Creates ngrams from ragged string data.
 *
 * This op accepts a ragged tensor with 1 ragged dimension containing only
 * strings and outputs a ragged tensor with 1 ragged dimension containing ngrams
 * of that string, joined along the innermost axis.
 *
 * ```js
 * const result = tf.string.stringNGrams(
 *   ['a', 'b', 'c', 'd'], tf.tensor1d([0, 2, 4], 'int32'),
 *   '|', [1, 2], 'LP', 'RP', -1, false);
 * result['nGrams'].print(); // ['a', 'b', 'LP|a', 'a|b', 'b|RP',
 *                           //  'c', 'd', 'LP|c', 'c|d', 'd|RP']
 * result['nGramsSplits'].print(); // [0, 5, 10]
 * ```
 * @param data: The values tensor of the ragged string tensor to make ngrams out
 *     of. Must be a 1D string tensor.
 * @param dataSplits: The splits tensor of the ragged string tensor to make
 *     ngrams out of.
 * @param separator: The string to append between elements of the token. Use ""
 *     for no separator.
 * @param nGramWidths: The sizes of the ngrams to create.
 * @param leftPad: The string to use to pad the left side of the ngram sequence.
 *     Only used if pad_width !== 0.
 * @param rightPad: The string to use to pad the right side of the ngram
 *     sequence. Only used if pad_width !== 0.
 * @param padWidth: The number of padding elements to add to each side of each
 *     sequence. Note that padding will never be greater than `nGramWidths`-1
 *     regardless of this value. If `padWidth`=-1, then add max(`nGramWidths`)-1
 *     elements.
 * @param preserveShortSequences: If true, then ensure that at least one ngram
 *     is generated for each input sequence. In particular, if an input sequence
 *     is shorter than min(ngramWidth) + 2*padWidth, then generate a single
 *     ngram containing the entire sequence. If false, then no ngrams are
 *     generated for these short input sequences.
 * @return A map with the following properties:
 *     - nGrams: The values tensor of the output ngrams ragged tensor.
 *     - nGramsSplits: The splits tensor of the output ngrams ragged tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $9eb1fcc44ad9b3ca$var$stringNGrams_(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    const $data = (0, $x4eLk.convertToTensor)(data, 'data', 'stringNGrams', 'string');
    if ($data.dtype !== 'string') throw new Error('Data must be of datatype string');
    if ($data.shape.length !== 1) throw new Error(`Data must be a vector, saw: ${$data.shape}`);
    const $dataSplits = (0, $x4eLk.convertToTensor)(dataSplits, 'dataSplits', 'stringNGrams');
    if ($dataSplits.dtype !== 'int32') throw new Error('Data splits must be of datatype int32');
    const attrs = {
        separator: separator,
        nGramWidths: nGramWidths,
        leftPad: leftPad,
        rightPad: rightPad,
        padWidth: padWidth,
        preserveShortSequences: preserveShortSequences
    };
    const inputs = {
        data: $data,
        dataSplits: $dataSplits
    };
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.StringNGrams), inputs, attrs);
    return {
        nGrams: result[0],
        nGramsSplits: result[1]
    };
}
const $9eb1fcc44ad9b3ca$export$3490514dcc63b044 = /* @__PURE__ */ (0, $6afhl.op)({
    stringNGrams_: $9eb1fcc44ad9b3ca$var$stringNGrams_
});

});

parcelRegister("l8UtL", function(module, exports) {

$parcel$export(module.exports, "stringSplit", function () { return $f64627e4c706770f$export$aa7f8babb17e7672; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Split elements of `input` based on `delimiter` into a SparseTensor .
 *
 * Let N be the size of source (typically N will be the batch size). Split each
 * element of `input` based on `delimiter` and return a SparseTensor containing
 * the splitted tokens. Empty tokens are ignored if `skipEmpty` is set to True.
 *
 * `delimiter` can be empty, or a string of split characters. If `delimiter` is
 * an empty string, each element of `input` is split into individual
 * character strings. Otherwise every character of `delimiter` is a potential
 * split point.
 *
 * ```js
 * const result = tf.string.stringSplit(['hello world',  'a b c'], ' ');
 * result['indices'].print(); // [[0, 0], [0, 1], [1, 0], [1, 1], [1, 2]]
 * result['values'].print(); // ['hello', 'world', 'a', 'b', 'c']
 * result['shape'].print(); // [2, 3]
 * ```
 * @param input: 1-D. Strings to split.
 * @param delimiter: 0-D. Delimiter characters, or empty string.
 * @param skipEmpty: Optional. If true, skip the empty strings from the result.
 *     Defaults to true.
 * @return A map with the following properties:
 *     - indices: A dense matrix of int32 representing the indices of the sparse
 *       tensor.
 *     - values: A vector of strings corresponding to the splited values.
 *     - shape: a length-2 vector of int32 representing the shape of the sparse
 * tensor, where the first value is N and the second value is the maximum number
 * of tokens in a single input entry.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $f64627e4c706770f$var$stringSplit_(input, delimiter, skipEmpty = true) {
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'stringSplit', 'string');
    const $delimiter = (0, $x4eLk.convertToTensor)(delimiter, 'delimiter', 'stringSplit', 'string');
    if ($input.rank !== 1) throw new Error(`Input should be Tensor1D but received shape ${$input.shape}`);
    if ($delimiter.rank !== 0) throw new Error(`Delimiter should be a scalar but received shape ${$delimiter.shape}`);
    const attrs = {
        skipEmpty: skipEmpty
    };
    const inputs = {
        input: $input,
        delimiter: $delimiter
    };
    const result = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.StringSplit), inputs, attrs);
    return {
        indices: result[0],
        values: result[1],
        shape: result[2]
    };
}
const $f64627e4c706770f$export$aa7f8babb17e7672 = /* @__PURE__ */ (0, $6afhl.op)({
    stringSplit_: $f64627e4c706770f$var$stringSplit_
});

});

parcelRegister("cBmEp", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFast", function () { return $92ca82bac33d4819$export$6195616d6fd0c848; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Converts each string in the input Tensor to its hash mod by a number of
 * buckets.
 *
 * The hash function is deterministic on the content of the string within the
 * process and will never change. However, it is not suitable for cryptography.
 * This function may be used when CPU time is scarce and inputs are trusted or
 * unimportant. There is a risk of adversaries constructing inputs that all hash
 * to the same bucket.
 *
 * ```js
 * const result = tf.string.stringToHashBucketFast(
 *   ['Hello', 'TensorFlow', '2.x'], 3);
 * result.print(); // [0, 2, 2]
 * ```
 * @param input: The strings to assign a hash bucket.
 * @param numBuckets: The number of buckets.
 * @return A Tensor of the same shape as the input tensor.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $92ca82bac33d4819$var$stringToHashBucketFast_(input, numBuckets) {
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'stringToHashBucketFast', 'string');
    const attrs = {
        numBuckets: numBuckets
    };
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const inputs = {
        input: $input
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.StringToHashBucketFast), inputs, attrs);
}
const $92ca82bac33d4819$export$6195616d6fd0c848 = /* @__PURE__ */ (0, $6afhl.op)({
    stringToHashBucketFast_: $92ca82bac33d4819$var$stringToHashBucketFast_
});

});

parcelRegister("fG6j4", function(module, exports) {

$parcel$export(module.exports, "staticRegexReplace", function () { return $b69faba09897a630$export$2bdfdc7ae087914d; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $6afhl = parcelRequire("6afhl");
/**
 * Replace the match of a `pattern` in `input` with `rewrite`.
 *
 * ```js
 * const result = tf.string.staticRegexReplace(
 *     ['format       this   spacing      better'], ' +', ' ');
 * result.print(); // ['format this spacing better']
 * ```
 * @param input: A Tensor of type string. The text to be processed.
 * @param pattern: A string. The regular expression to match the input.
 * @param rewrite: A string. The rewrite to be applied to the matched
 *     expression.
 * @param replaceGlobal: An optional bool. Defaults to True. If True, the
 *     replacement is global, otherwise the replacement is done only on the
 *     first match.
 * @return A Tensor of type string.
 *
 * @doc {heading: 'Operations', subheading: 'String'}
 */ function $b69faba09897a630$var$staticRegexReplace_(input, pattern, rewrite, replaceGlobal = true) {
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'staticRegexReplace', 'string');
    const attrs = {
        pattern: pattern,
        rewrite: rewrite,
        replaceGlobal: replaceGlobal
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.StaticRegexReplace), {
        x: $input
    }, attrs);
}
const $b69faba09897a630$export$2bdfdc7ae087914d = /* @__PURE__ */ (0, $6afhl.op)({
    staticRegexReplace_: $b69faba09897a630$var$staticRegexReplace_
});

});


parcelRegister("feqcJ", function(module, exports) {

$parcel$export(module.exports, "copyModel", function () { return (parcelRequire("jp6Sy")).copyModel; });
$parcel$export(module.exports, "listModels", function () { return (parcelRequire("jp6Sy")).listModels; });
$parcel$export(module.exports, "moveModel", function () { return (parcelRequire("jp6Sy")).moveModel; });
$parcel$export(module.exports, "removeModel", function () { return (parcelRequire("jp6Sy")).removeModel; });
$parcel$export(module.exports, "browserFiles", function () { return (parcelRequire("YgQlR")).browserFiles; });
$parcel$export(module.exports, "browserHTTPRequest", function () { return (parcelRequire("fMy7x")).browserHTTPRequest; });
$parcel$export(module.exports, "CompositeArrayBuffer", function () { return (parcelRequire("3CPgX")).CompositeArrayBuffer; });
$parcel$export(module.exports, "concatenateArrayBuffers", function () { return (parcelRequire("lxNMC")).concatenateArrayBuffers; });
$parcel$export(module.exports, "decodeWeights", function () { return (parcelRequire("lxNMC")).decodeWeights; });
$parcel$export(module.exports, "decodeWeightsStream", function () { return (parcelRequire("lxNMC")).decodeWeightsStream; });
$parcel$export(module.exports, "encodeWeights", function () { return (parcelRequire("lxNMC")).encodeWeights; });
$parcel$export(module.exports, "fromMemory", function () { return (parcelRequire("aJcgk")).fromMemory; });
$parcel$export(module.exports, "fromMemorySync", function () { return (parcelRequire("aJcgk")).fromMemorySync; });
$parcel$export(module.exports, "getLoadHandlers", function () { return (parcelRequire("9NeiV")).getLoadHandlers; });
$parcel$export(module.exports, "getModelArtifactsForJSON", function () { return (parcelRequire("lxNMC")).getModelArtifactsForJSON; });
$parcel$export(module.exports, "getModelArtifactsForJSONSync", function () { return (parcelRequire("lxNMC")).getModelArtifactsForJSONSync; });
$parcel$export(module.exports, "getModelArtifactsInfoForJSON", function () { return (parcelRequire("lxNMC")).getModelArtifactsInfoForJSON; });
$parcel$export(module.exports, "getSaveHandlers", function () { return (parcelRequire("9NeiV")).getSaveHandlers; });
$parcel$export(module.exports, "getWeightSpecs", function () { return (parcelRequire("lxNMC")).getWeightSpecs; });
$parcel$export(module.exports, "http", function () { return (parcelRequire("fMy7x")).http; });
$parcel$export(module.exports, "isHTTPScheme", function () { return (parcelRequire("fMy7x")).isHTTPScheme; });
$parcel$export(module.exports, "loadWeights", function () { return (parcelRequire("9RHWQ")).loadWeights; });
$parcel$export(module.exports, "registerLoadRouter", function () { return (parcelRequire("9NeiV")).registerLoadRouter; });
$parcel$export(module.exports, "registerSaveRouter", function () { return (parcelRequire("9NeiV")).registerSaveRouter; });
$parcel$export(module.exports, "weightsLoaderFactory", function () { return (parcelRequire("9RHWQ")).weightsLoaderFactory; });
$parcel$export(module.exports, "withSaveHandler", function () { return (parcelRequire("aJcgk")).withSaveHandler; });
$parcel$export(module.exports, "withSaveHandlerSync", function () { return (parcelRequire("aJcgk")).withSaveHandlerSync; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Importing local_storage and indexed_db is necessary for the routers to be
// registered.
parcelRequire("3Puei");
parcelRequire("djQES");

var $YgQlR = parcelRequire("YgQlR");

var $fMy7x = parcelRequire("fMy7x");

var $lxNMC = parcelRequire("lxNMC");

var $aJcgk = parcelRequire("aJcgk");

var $9NeiV = parcelRequire("9NeiV");

var $9RHWQ = parcelRequire("9RHWQ");

var $3CPgX = parcelRequire("3CPgX");

var $jp6Sy = parcelRequire("jp6Sy");

});
parcelRegister("YgQlR", function(module, exports) {

$parcel$export(module.exports, "browserFiles", function () { return $0b52ab74ac2462c9$export$6729643cf069471c; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandlers related to files, such as browser-triggered file downloads,
 * user-selected files in browser.
 */ parcelRequire("fJy9j");

var $tdutJ = parcelRequire("tdutJ");

var $lxNMC = parcelRequire("lxNMC");

var $9NeiV = parcelRequire("9NeiV");

var $3CPgX = parcelRequire("3CPgX");
const $0b52ab74ac2462c9$var$DEFAULT_FILE_NAME_PREFIX = 'model';
const $0b52ab74ac2462c9$var$DEFAULT_JSON_EXTENSION_NAME = '.json';
const $0b52ab74ac2462c9$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME = '.weights.bin';
function $0b52ab74ac2462c9$var$defer(f) {
    return new Promise((resolve)=>setTimeout(resolve)).then(f);
}
class $0b52ab74ac2462c9$export$cc3c076530f2848f {
    constructor(fileNamePrefix){
        if (!(0, $tdutJ.env)().getBool('IS_BROWSER')) // TODO(cais): Provide info on what IOHandlers are available under the
        //   current environment.
        throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
        if (fileNamePrefix.startsWith($0b52ab74ac2462c9$export$cc3c076530f2848f.URL_SCHEME)) fileNamePrefix = fileNamePrefix.slice($0b52ab74ac2462c9$export$cc3c076530f2848f.URL_SCHEME.length);
        if (fileNamePrefix == null || fileNamePrefix.length === 0) fileNamePrefix = $0b52ab74ac2462c9$var$DEFAULT_FILE_NAME_PREFIX;
        this.modelJsonFileName = fileNamePrefix + $0b52ab74ac2462c9$var$DEFAULT_JSON_EXTENSION_NAME;
        this.weightDataFileName = fileNamePrefix + $0b52ab74ac2462c9$var$DEFAULT_WEIGHT_DATA_EXTENSION_NAME;
    }
    async save(modelArtifacts) {
        if (typeof document === 'undefined') throw new Error("Browser downloads are not supported in this environment since `document` is not present");
        // TODO(mattsoulanille): Support saving models over 2GB that exceed
        // Chrome's ArrayBuffer size limit.
        const weightBuffer = (0, $3CPgX.CompositeArrayBuffer).join(modelArtifacts.weightData);
        const weightsURL = window.URL.createObjectURL(new Blob([
            weightBuffer
        ], {
            type: 'application/octet-stream'
        }));
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet.");
        else {
            const weightsManifest = [
                {
                    paths: [
                        './' + this.weightDataFileName
                    ],
                    weights: modelArtifacts.weightSpecs
                }
            ];
            const modelJSON = (0, $lxNMC.getModelJSONForModelArtifacts)(modelArtifacts, weightsManifest);
            const modelJsonURL = window.URL.createObjectURL(new Blob([
                JSON.stringify(modelJSON)
            ], {
                type: 'application/json'
            }));
            // If anchor elements are not provided, create them without attaching them
            // to parents, so that the downloaded file names can be controlled.
            const jsonAnchor = this.modelJsonAnchor == null ? document.createElement('a') : this.modelJsonAnchor;
            jsonAnchor.download = this.modelJsonFileName;
            jsonAnchor.href = modelJsonURL;
            // Trigger downloads by evoking a click event on the download anchors.
            // When multiple downloads are started synchronously, Firefox will only
            // save the last one.
            await $0b52ab74ac2462c9$var$defer(()=>jsonAnchor.dispatchEvent(new MouseEvent('click')));
            if (modelArtifacts.weightData != null) {
                const weightDataAnchor = this.weightDataAnchor == null ? document.createElement('a') : this.weightDataAnchor;
                weightDataAnchor.download = this.weightDataFileName;
                weightDataAnchor.href = weightsURL;
                await $0b52ab74ac2462c9$var$defer(()=>weightDataAnchor.dispatchEvent(new MouseEvent('click')));
            }
            return {
                modelArtifactsInfo: (0, $lxNMC.getModelArtifactsInfoForJSON)(modelArtifacts)
            };
        }
    }
}
$0b52ab74ac2462c9$export$cc3c076530f2848f.URL_SCHEME = 'downloads://';
class $0b52ab74ac2462c9$var$BrowserFiles {
    constructor(files){
        if (files == null || files.length < 1) throw new Error(`When calling browserFiles, at least 1 file is required, ` + `but received ${files}`);
        this.jsonFile = files[0];
        this.weightsFiles = files.slice(1);
    }
    async load() {
        return new Promise((resolve, reject)=>{
            const jsonReader = new FileReader();
            jsonReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const modelJSON = JSON.parse(event.target.result);
                const modelTopology = modelJSON.modelTopology;
                if (modelTopology == null) {
                    reject(new Error(`modelTopology field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                const weightsManifest = modelJSON.weightsManifest;
                if (weightsManifest == null) {
                    reject(new Error(`weightManifest field is missing from file ${this.jsonFile.name}`));
                    return;
                }
                if (this.weightsFiles.length === 0) {
                    resolve({
                        modelTopology: modelTopology
                    });
                    return;
                }
                const modelArtifactsPromise = (0, $lxNMC.getModelArtifactsForJSON)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
                resolve(modelArtifactsPromise);
            };
            jsonReader.onerror = (error)=>reject(`Failed to read model topology and weights manifest JSON ` + `from file '${this.jsonFile.name}'. BrowserFiles supports loading ` + `Keras-style tf.Model artifacts only.`);
            jsonReader.readAsText(this.jsonFile);
        });
    }
    loadWeights(weightsManifest) {
        const weightSpecs = [];
        const paths = [];
        for (const entry of weightsManifest){
            weightSpecs.push(...entry.weights);
            paths.push(...entry.paths);
        }
        const pathToFile = this.checkManifestAndWeightFiles(weightsManifest);
        const promises = paths.map((path)=>this.loadWeightsFile(path, pathToFile[path]));
        return Promise.all(promises).then((buffers)=>[
                weightSpecs,
                buffers
            ]);
    }
    loadWeightsFile(path, file) {
        return new Promise((resolve, reject)=>{
            const weightFileReader = new FileReader();
            weightFileReader.onload = (event)=>{
                // tslint:disable-next-line:no-any
                const weightData = event.target.result;
                resolve(weightData);
            };
            weightFileReader.onerror = (error)=>reject(`Failed to weights data from file of path '${path}'.`);
            weightFileReader.readAsArrayBuffer(file);
        });
    }
    /**
     * Check the compatibility between weights manifest and weight files.
     */ checkManifestAndWeightFiles(manifest) {
        const basenames = [];
        const fileNames = this.weightsFiles.map((file)=>(0, $lxNMC.basename)(file.name));
        const pathToFile = {};
        for (const group of manifest)group.paths.forEach((path)=>{
            const pathBasename = (0, $lxNMC.basename)(path);
            if (basenames.indexOf(pathBasename) !== -1) throw new Error(`Duplicate file basename found in weights manifest: ` + `'${pathBasename}'`);
            basenames.push(pathBasename);
            if (fileNames.indexOf(pathBasename) === -1) throw new Error(`Weight file with basename '${pathBasename}' is not provided.`);
            else pathToFile[path] = this.weightsFiles[fileNames.indexOf(pathBasename)];
        });
        if (basenames.length !== this.weightsFiles.length) throw new Error(`Mismatch in the number of files in weights manifest ` + `(${basenames.length}) and the number of weight files provided ` + `(${this.weightsFiles.length}).`);
        return pathToFile;
    }
}
const $0b52ab74ac2462c9$export$6149c5f14395749b = (url)=>{
    if (!(0, $tdutJ.env)().getBool('IS_BROWSER')) return null;
    else {
        if (!Array.isArray(url) && url.startsWith($0b52ab74ac2462c9$export$cc3c076530f2848f.URL_SCHEME)) return $0b52ab74ac2462c9$export$8fbc9551c735f788(url.slice($0b52ab74ac2462c9$export$cc3c076530f2848f.URL_SCHEME.length));
        else return null;
    }
};
(0, $9NeiV.IORouterRegistry).registerSaveRouter($0b52ab74ac2462c9$export$6149c5f14395749b);
function $0b52ab74ac2462c9$export$8fbc9551c735f788(fileNamePrefix = 'model') {
    return new $0b52ab74ac2462c9$export$cc3c076530f2848f(fileNamePrefix);
}
function $0b52ab74ac2462c9$export$6729643cf069471c(files) {
    return new $0b52ab74ac2462c9$var$BrowserFiles(files);
}

});

parcelRegister("fMy7x", function(module, exports) {

$parcel$export(module.exports, "isHTTPScheme", function () { return $b7d5ce5ba53ad334$export$18a721ae4733601b; });
$parcel$export(module.exports, "http", function () { return $b7d5ce5ba53ad334$export$7d6f1c8842f9f527; });
$parcel$export(module.exports, "browserHTTPRequest", function () { return $b7d5ce5ba53ad334$export$624ff5bc4e3a9d72; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * IOHandler implementations based on HTTP requests in the web browser.
 *
 * Uses [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
 */ 
var $tdutJ = parcelRequire("tdutJ");

var $eOiOM = parcelRequire("eOiOM");

var $lxNMC = parcelRequire("lxNMC");

var $3CPgX = parcelRequire("3CPgX");

var $9NeiV = parcelRequire("9NeiV");

var $9RHWQ = parcelRequire("9RHWQ");
const $b7d5ce5ba53ad334$var$OCTET_STREAM_MIME_TYPE = 'application/octet-stream';
const $b7d5ce5ba53ad334$var$JSON_TYPE = 'application/json';
class $b7d5ce5ba53ad334$export$3df08bb5d0f8b499 {
    constructor(path, loadOptions){
        this.DEFAULT_METHOD = 'POST';
        if (loadOptions == null) loadOptions = {};
        this.weightPathPrefix = loadOptions.weightPathPrefix;
        this.weightUrlConverter = loadOptions.weightUrlConverter;
        if (loadOptions.fetchFunc != null) {
            (0, $eOiOM.assert)(typeof loadOptions.fetchFunc === 'function', ()=>"Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)");
            this.fetch = loadOptions.fetchFunc;
        } else this.fetch = (0, $tdutJ.env)().platform.fetch;
        (0, $eOiOM.assert)(path != null && path.length > 0, ()=>"URL path for http must not be null, undefined or empty.");
        if (Array.isArray(path)) (0, $eOiOM.assert)(path.length === 2, ()=>'URL paths for http must have a length of 2, ' + `(actual length is ${path.length}).`);
        this.path = path;
        if (loadOptions.requestInit != null && loadOptions.requestInit.body != null) throw new Error('requestInit is expected to have no pre-existing body, but has one.');
        this.requestInit = loadOptions.requestInit || {};
        this.loadOptions = loadOptions;
    }
    async save(modelArtifacts) {
        if (modelArtifacts.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
        const init = Object.assign({
            method: this.DEFAULT_METHOD
        }, this.requestInit);
        init.body = new FormData();
        const weightsManifest = [
            {
                paths: [
                    './model.weights.bin'
                ],
                weights: modelArtifacts.weightSpecs
            }
        ];
        const modelTopologyAndWeightManifest = (0, $lxNMC.getModelJSONForModelArtifacts)(modelArtifacts, weightsManifest);
        init.body.append('model.json', new Blob([
            JSON.stringify(modelTopologyAndWeightManifest)
        ], {
            type: $b7d5ce5ba53ad334$var$JSON_TYPE
        }), 'model.json');
        if (modelArtifacts.weightData != null) {
            // TODO(mattsoulanille): Support saving models over 2GB that exceed
            // Chrome's ArrayBuffer size limit.
            const weightBuffer = (0, $3CPgX.CompositeArrayBuffer).join(modelArtifacts.weightData);
            init.body.append('model.weights.bin', new Blob([
                weightBuffer
            ], {
                type: $b7d5ce5ba53ad334$var$OCTET_STREAM_MIME_TYPE
            }), 'model.weights.bin');
        }
        const response = await this.fetch(this.path, init);
        if (response.ok) return {
            modelArtifactsInfo: (0, $lxNMC.getModelArtifactsInfoForJSON)(modelArtifacts),
            responses: [
                response
            ]
        };
        else throw new Error(`BrowserHTTPRequest.save() failed due to HTTP response status ` + `${response.status}.`);
    }
    async loadModelJSON() {
        const modelConfigRequest = await this.fetch(this.path, this.requestInit);
        if (!modelConfigRequest.ok) throw new Error(`Request to ${this.path} failed with status code ` + `${modelConfigRequest.status}. Please verify this URL points to ` + `the model JSON of the model to load.`);
        let modelJSON;
        try {
            modelJSON = await modelConfigRequest.json();
        } catch (e) {
            let message = `Failed to parse model JSON of response from ${this.path}.`;
            // TODO(nsthorat): Remove this after some time when we're comfortable that
            // .pb files are mostly gone.
            if (this.path.endsWith('.pb')) message += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository.";
            else message += " Please make sure the server is serving valid JSON for this request.";
            throw new Error(message);
        }
        // We do not allow both modelTopology and weightsManifest to be missing.
        const modelTopology = modelJSON.modelTopology;
        const weightsManifest = modelJSON.weightsManifest;
        if (modelTopology == null && weightsManifest == null) throw new Error(`The JSON from HTTP path ${this.path} contains neither model ` + `topology or manifest for weights.`);
        return modelJSON;
    }
    /**
     * Load model artifacts via HTTP request(s).
     *
     * See the documentation to `tf.io.http` for details on the saved
     * artifacts.
     *
     * @returns The loaded model artifacts (if loading succeeds).
     */ async load() {
        if (this.loadOptions.streamWeights) return this.loadStream();
        const modelJSON = await this.loadModelJSON();
        return (0, $lxNMC.getModelArtifactsForJSON)(modelJSON, (weightsManifest)=>this.loadWeights(weightsManifest));
    }
    async loadStream() {
        const modelJSON = await this.loadModelJSON();
        const fetchURLs = await this.getWeightUrls(modelJSON.weightsManifest);
        const weightSpecs = (0, $lxNMC.getWeightSpecs)(modelJSON.weightsManifest);
        const stream = ()=>(0, $9RHWQ.streamWeights)(fetchURLs, this.loadOptions);
        return Object.assign(Object.assign({}, modelJSON), {
            weightSpecs: weightSpecs,
            getWeightStream: stream
        });
    }
    async getWeightUrls(weightsManifest) {
        const weightPath = Array.isArray(this.path) ? this.path[1] : this.path;
        const [prefix, suffix] = $b7d5ce5ba53ad334$export$7a5253c0f62e0150(weightPath);
        const pathPrefix = this.weightPathPrefix || prefix;
        const fetchURLs = [];
        const urlPromises = [];
        for (const weightsGroup of weightsManifest){
            for (const path of weightsGroup.paths)if (this.weightUrlConverter != null) urlPromises.push(this.weightUrlConverter(path));
            else fetchURLs.push(pathPrefix + path + suffix);
        }
        if (this.weightUrlConverter) fetchURLs.push(...await Promise.all(urlPromises));
        return fetchURLs;
    }
    async loadWeights(weightsManifest) {
        const fetchURLs = await this.getWeightUrls(weightsManifest);
        const weightSpecs = (0, $lxNMC.getWeightSpecs)(weightsManifest);
        const buffers = await (0, $9RHWQ.loadWeightsAsArrayBuffer)(fetchURLs, this.loadOptions);
        return [
            weightSpecs,
            buffers
        ];
    }
}
$b7d5ce5ba53ad334$export$3df08bb5d0f8b499.URL_SCHEME_REGEX = /^https?:\/\//;
function $b7d5ce5ba53ad334$export$7a5253c0f62e0150(url) {
    const lastSlash = url.lastIndexOf('/');
    const lastSearchParam = url.lastIndexOf('?');
    const prefix = url.substring(0, lastSlash);
    const suffix = lastSearchParam > lastSlash ? url.substring(lastSearchParam) : '';
    return [
        prefix + '/',
        suffix
    ];
}
function $b7d5ce5ba53ad334$export$18a721ae4733601b(url) {
    return url.match($b7d5ce5ba53ad334$export$3df08bb5d0f8b499.URL_SCHEME_REGEX) != null;
}
const $b7d5ce5ba53ad334$export$696b487c8ad531d2 = (url, loadOptions)=>{
    if (typeof fetch === 'undefined' && (loadOptions == null || loadOptions.fetchFunc == null)) // `http` uses `fetch` or `node-fetch`, if one wants to use it in
    // an environment that is not the browser or node they have to setup a
    // global fetch polyfill.
    return null;
    else {
        let isHTTP = true;
        if (Array.isArray(url)) isHTTP = url.every((urlItem)=>$b7d5ce5ba53ad334$export$18a721ae4733601b(urlItem));
        else isHTTP = $b7d5ce5ba53ad334$export$18a721ae4733601b(url);
        if (isHTTP) return $b7d5ce5ba53ad334$export$7d6f1c8842f9f527(url, loadOptions);
    }
    return null;
};
(0, $9NeiV.IORouterRegistry).registerSaveRouter($b7d5ce5ba53ad334$export$696b487c8ad531d2);
(0, $9NeiV.IORouterRegistry).registerLoadRouter($b7d5ce5ba53ad334$export$696b487c8ad531d2);
function $b7d5ce5ba53ad334$export$7d6f1c8842f9f527(path, loadOptions) {
    return new $b7d5ce5ba53ad334$export$3df08bb5d0f8b499(path, loadOptions);
}
function $b7d5ce5ba53ad334$export$624ff5bc4e3a9d72(path, loadOptions) {
    return $b7d5ce5ba53ad334$export$7d6f1c8842f9f527(path, loadOptions);
}

});
parcelRegister("9RHWQ", function(module, exports) {

$parcel$export(module.exports, "loadWeightsAsArrayBuffer", function () { return $72eb27732b4b639f$export$6873c1a1d3325bf7; });
$parcel$export(module.exports, "streamWeights", function () { return $72eb27732b4b639f$export$4fc61cabab0a1e7e; });
$parcel$export(module.exports, "loadWeights", function () { return $72eb27732b4b639f$export$55f7d42d35356096; });
$parcel$export(module.exports, "weightsLoaderFactory", function () { return $72eb27732b4b639f$export$635f986c4ab6ebe2; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $tdutJ = parcelRequire("tdutJ");

var $eOiOM = parcelRequire("eOiOM");

var $3CPgX = parcelRequire("3CPgX");

var $lxNMC = parcelRequire("lxNMC");

var $2wydx = parcelRequire("2wydx");

var $ijLlc = parcelRequire("ijLlc");
async function $72eb27732b4b639f$export$6873c1a1d3325bf7(fetchURLs, loadOptions) {
    if (loadOptions == null) loadOptions = {};
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $tdutJ.env)().platform.fetch : loadOptions.fetchFunc;
    // Create the requests for all of the weights in parallel.
    const requests = fetchURLs.map((fetchURL)=>fetchFunc(fetchURL, loadOptions.requestInit, {
            isBinary: true
        }));
    const fetchStartFraction = 0;
    const fetchEndFraction = 0.5;
    const responses = loadOptions.onProgress == null ? await Promise.all(requests) : await (0, $2wydx.monitorPromisesProgress)(requests, loadOptions.onProgress, fetchStartFraction, fetchEndFraction);
    const bufferPromises = responses.map((response)=>response.arrayBuffer());
    const bufferStartFraction = 0.5;
    const bufferEndFraction = 1;
    const buffers = loadOptions.onProgress == null ? await Promise.all(bufferPromises) : await (0, $2wydx.monitorPromisesProgress)(bufferPromises, loadOptions.onProgress, bufferStartFraction, bufferEndFraction);
    return buffers;
}
function $72eb27732b4b639f$export$4fc61cabab0a1e7e(fetchURLs, loadOptions) {
    var _a;
    const fetchFunc = loadOptions.fetchFunc == null ? (0, $tdutJ.env)().platform.fetch : loadOptions.fetchFunc;
    let fetchIndex = 0;
    let chunkReader;
    (_a = loadOptions.onProgress) === null || _a === void 0 || _a.call(loadOptions, 0);
    return new ReadableStream({
        pull: async (controller)=>{
            var _a;
            while(fetchIndex < fetchURLs.length){
                if (!chunkReader) {
                    const body = (await fetchFunc(fetchURLs[fetchIndex], loadOptions.requestInit, {
                        isBinary: true
                    })).body;
                    chunkReader = body.getReader();
                }
                const { done: done, value: value } = await chunkReader.read();
                if (done) {
                    fetchIndex++;
                    chunkReader = undefined;
                    (_a = loadOptions.onProgress) === null || _a === void 0 || _a.call(loadOptions, fetchIndex / fetchURLs.length);
                    continue;
                }
                controller.enqueue(value);
                return;
            }
            controller.close();
        }
    });
}
async function $72eb27732b4b639f$export$55f7d42d35356096(manifest, filePathPrefix = '', weightNames, requestInit) {
    // TODO(nsthorat): Groups are currently fetched atomically. If you need a
    // single weight from a group, the whole group will be fetched. At a future
    // date, we should support fetching only the individual shards within a
    // group that are needed to reconstruct the requested weight.
    // TODO(cais): Use `decodeWeights` for implementation.
    const fetchWeights = (fetchUrls)=>$72eb27732b4b639f$export$6873c1a1d3325bf7(fetchUrls, {
            requestInit: requestInit
        });
    const loadWeights1 = $72eb27732b4b639f$export$635f986c4ab6ebe2(fetchWeights);
    return loadWeights1(manifest, filePathPrefix, weightNames);
}
function $72eb27732b4b639f$export$635f986c4ab6ebe2(fetchWeightsFunction) {
    return async (manifest, filePathPrefix = '', weightNames)=>{
        // Collect all the groups, weights, and their relative offsets to be
        // fetched.
        const groupIndicesToFetchMap = manifest.map(()=>false);
        const groupWeightsToFetch = {};
        const weightsFound = weightNames != null ? weightNames.map(()=>false) : [];
        const allManifestWeightNames = [];
        manifest.forEach((manifestGroupConfig, groupIndex)=>{
            let groupOffset = 0;
            manifestGroupConfig.weights.forEach((weightsEntry)=>{
                const rawDtype = 'quantization' in weightsEntry ? weightsEntry.quantization.dtype : weightsEntry.dtype;
                const weightsBytes = (0, $ijLlc.DTYPE_VALUE_SIZE_MAP)[rawDtype] * $eOiOM.sizeFromShape(weightsEntry.shape);
                const enqueueWeightsForFetchingFn = ()=>{
                    groupIndicesToFetchMap[groupIndex] = true;
                    if (groupWeightsToFetch[groupIndex] == null) groupWeightsToFetch[groupIndex] = [];
                    groupWeightsToFetch[groupIndex].push({
                        manifestEntry: weightsEntry,
                        groupOffset: groupOffset,
                        sizeBytes: weightsBytes
                    });
                };
                if (weightNames != null) weightNames.forEach((weightName, weightIndex)=>{
                    if (weightName === weightsEntry.name) {
                        enqueueWeightsForFetchingFn();
                        weightsFound[weightIndex] = true;
                    }
                });
                else enqueueWeightsForFetchingFn();
                allManifestWeightNames.push(weightsEntry.name);
                groupOffset += weightsBytes;
            });
        });
        if (!weightsFound.every((found)=>found)) {
            const weightsNotFound = weightNames.filter((_, i)=>!weightsFound[i]);
            throw new Error(`Could not find weights in manifest with names: ` + `${weightsNotFound.join(', ')}. \n` + `Manifest JSON has weights with names: ` + `${allManifestWeightNames.join(', ')}.`);
        }
        // Convert the one-hot boolean groupId => shouldFetch map to a list of group
        // IDs.
        const groupIndicesToFetch = groupIndicesToFetchMap.reduce((accumulator, shouldFetch, i)=>{
            if (shouldFetch) accumulator.push(i);
            return accumulator;
        }, []);
        const fetchUrls = [];
        groupIndicesToFetch.forEach((i)=>{
            manifest[i].paths.forEach((filepath)=>{
                const fetchUrl = filePathPrefix + (!filePathPrefix.endsWith('/') ? '/' : '') + filepath;
                fetchUrls.push(fetchUrl);
            });
        });
        const buffers = await fetchWeightsFunction(fetchUrls);
        const weightsTensorMap = {};
        let bufferIndexOffset = 0;
        groupIndicesToFetch.forEach((i)=>{
            const numBuffers = manifest[i].paths.length;
            const weightsBuffer = new (0, $3CPgX.CompositeArrayBuffer)(buffers.slice(bufferIndexOffset, bufferIndexOffset + numBuffers));
            const weightsEntries = groupWeightsToFetch[i];
            weightsEntries.forEach((weightsEntry)=>{
                const byteBuffer = weightsBuffer.slice(weightsEntry.groupOffset, weightsEntry.groupOffset + weightsEntry.sizeBytes);
                const nameToTensorMap = (0, $lxNMC.decodeWeights)(byteBuffer, [
                    weightsEntry.manifestEntry
                ]);
                for(const name in nameToTensorMap)weightsTensorMap[name] = nameToTensorMap[name];
            });
            bufferIndexOffset += numBuffers;
        });
        return weightsTensorMap;
    };
}

});
parcelRegister("2wydx", function(module, exports) {

$parcel$export(module.exports, "monitorPromisesProgress", function () { return $1d691ccce0378d86$export$b88cae388b9e062e; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eOiOM = parcelRequire("eOiOM");
function $1d691ccce0378d86$export$b88cae388b9e062e(promises, onProgress, startFraction, endFraction) {
    checkPromises(promises);
    startFraction = startFraction == null ? 0 : startFraction;
    endFraction = endFraction == null ? 1 : endFraction;
    checkFraction(startFraction, endFraction);
    let resolvedPromise = 0;
    const registerMonitor = (promise)=>{
        promise.then((value)=>{
            const fraction = startFraction + ++resolvedPromise / promises.length * (endFraction - startFraction);
            // pass fraction as parameter to callback function.
            onProgress(fraction);
            return value;
        });
        return promise;
    };
    function checkPromises(promises) {
        (0, $eOiOM.assert)(promises != null && Array.isArray(promises) && promises.length > 0, ()=>'promises must be a none empty array');
    }
    function checkFraction(startFraction, endFraction) {
        (0, $eOiOM.assert)(startFraction >= 0 && startFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got startFraction ${startFraction}`);
        (0, $eOiOM.assert)(endFraction >= 0 && endFraction <= 1, ()=>`Progress fraction must be in range [0, 1], but ` + `got endFraction ${endFraction}`);
        (0, $eOiOM.assert)(endFraction >= startFraction, ()=>`startFraction must be no more than endFraction, but ` + `got startFraction ${startFraction} and endFraction ` + `${endFraction}`);
    }
    return Promise.all(promises.map(registerMonitor));
}

});



parcelRegister("aJcgk", function(module, exports) {

$parcel$export(module.exports, "fromMemory", function () { return $7cf79e6a948814ef$export$89ba941c7951a2e8; });
$parcel$export(module.exports, "fromMemorySync", function () { return $7cf79e6a948814ef$export$c22472cb1d774f45; });
$parcel$export(module.exports, "withSaveHandler", function () { return $7cf79e6a948814ef$export$fa4a26428614aae7; });
$parcel$export(module.exports, "withSaveHandlerSync", function () { return $7cf79e6a948814ef$export$53913891eb9f0585; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $7cf79e6a948814ef$var$PassthroughLoader {
    constructor(modelArtifacts){
        this.modelArtifacts = modelArtifacts;
    }
    load() {
        return this.modelArtifacts;
    }
}
class $7cf79e6a948814ef$var$PassthroughSaver {
    constructor(saveHandler){
        this.saveHandler = saveHandler;
    }
    save(modelArtifacts) {
        return this.saveHandler(modelArtifacts);
    }
}
class $7cf79e6a948814ef$var$PassthroughAsync {
    constructor(handler){
        if (handler.load) this.load = ()=>Promise.resolve(handler.load());
        if (handler.save) this.save = (modelArtifacts)=>Promise.resolve(handler.save(modelArtifacts));
    }
}
function $7cf79e6a948814ef$export$89ba941c7951a2e8(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    const args = arguments;
    return new $7cf79e6a948814ef$var$PassthroughAsync($7cf79e6a948814ef$export$c22472cb1d774f45(...args));
}
function $7cf79e6a948814ef$export$c22472cb1d774f45(modelArtifacts, weightSpecs, weightData, trainingConfig) {
    if (arguments.length === 1) {
        const isModelArtifacts = modelArtifacts.modelTopology != null || modelArtifacts.weightSpecs != null;
        if (isModelArtifacts) return new $7cf79e6a948814ef$var$PassthroughLoader(modelArtifacts);
        else {
            // Legacy support: with only modelTopology.
            // TODO(cais): Remove this deprecated API.
            console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
            return new $7cf79e6a948814ef$var$PassthroughLoader({
                modelTopology: modelArtifacts
            });
        }
    } else {
        // Legacy support.
        // TODO(cais): Remove this deprecated API.
        console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release.");
        return new $7cf79e6a948814ef$var$PassthroughLoader({
            modelTopology: modelArtifacts,
            weightSpecs: weightSpecs,
            weightData: weightData,
            trainingConfig: trainingConfig
        });
    }
}
function $7cf79e6a948814ef$export$fa4a26428614aae7(saveHandler) {
    return new $7cf79e6a948814ef$var$PassthroughSaver(saveHandler);
}
function $7cf79e6a948814ef$export$53913891eb9f0585(saveHandler) {
    return new $7cf79e6a948814ef$var$PassthroughSaver(saveHandler);
}

});


parcelRegister("iEnT2", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Impl", function () { return (parcelRequire("9cC6a")).nonMaxSuppressionV3Impl; });
$parcel$export(module.exports, "nonMaxSuppressionV4Impl", function () { return (parcelRequire("9cC6a")).nonMaxSuppressionV4Impl; });
$parcel$export(module.exports, "nonMaxSuppressionV5Impl", function () { return (parcelRequire("9cC6a")).nonMaxSuppressionV5Impl; });
$parcel$export(module.exports, "whereImpl", function () { return (parcelRequire("4vdaQ")).whereImpl; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9cC6a = parcelRequire("9cC6a");

var $4vdaQ = parcelRequire("4vdaQ");

});

parcelRegister("k22sw", function(module, exports) {

$parcel$export(module.exports, "nextFrame", function () { return $e955e6dcd169910d$export$68d2d147c928d1dd; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $e955e6dcd169910d$var$delayCallback = (()=>{
    if (typeof requestAnimationFrame !== 'undefined') return requestAnimationFrame;
    else if (typeof setImmediate !== 'undefined') return setImmediate;
    return (f)=>f(); // no delays
})();
/**
 * Returns a promise that resolves when a requestAnimationFrame has completed.
 *
 * On Node.js this uses setImmediate instead of requestAnimationFrame.
 *
 * This is simply a sugar method so that users can do the following:
 * `await tf.nextFrame();`
 *
 * @doc {heading: 'Performance', subheading: 'Timing'}
 */ function $e955e6dcd169910d$export$68d2d147c928d1dd() {
    return new Promise((resolve)=>$e955e6dcd169910d$var$delayCallback(()=>resolve()));
}

});

parcelRegister("1d10n", function(module, exports) {

$parcel$export(module.exports, "train", function () { return $0e17c8eb1b883941$export$9af937cf8bcbf96; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fz9g7 = parcelRequire("fz9g7");
const $0e17c8eb1b883941$export$9af937cf8bcbf96 = (0, $fz9g7.OptimizerConstructors);

});
parcelRegister("fz9g7", function(module, exports) {

$parcel$export(module.exports, "OptimizerConstructors", function () { return $b5514e8d06519047$export$1babc3d7b10c0cf6; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fmImY = parcelRequire("fmImY");

var $kl14K = parcelRequire("kl14K");

var $j1H1O = parcelRequire("j1H1O");

var $46rlf = parcelRequire("46rlf");

var $bK23H = parcelRequire("bK23H");

var $glgZq = parcelRequire("glgZq");

var $bQqzj = parcelRequire("bQqzj");
class $b5514e8d06519047$export$1babc3d7b10c0cf6 {
    /**
     * Constructs a `tf.SGDOptimizer` that uses stochastic gradient descent.
     *
     * ```js
     * // Fit a quadratic function by learning the coefficients a, b, c.
     * const xs = tf.tensor1d([0, 1, 2, 3]);
     * const ys = tf.tensor1d([1.1, 5.9, 16.8, 33.9]);
     *
     * const a = tf.scalar(Math.random()).variable();
     * const b = tf.scalar(Math.random()).variable();
     * const c = tf.scalar(Math.random()).variable();
     *
     * // y = a * x^2 + b * x + c.
     * const f = x => a.mul(x.square()).add(b.mul(x)).add(c);
     * const loss = (pred, label) => pred.sub(label).square().mean();
     *
     * const learningRate = 0.01;
     * const optimizer = tf.train.sgd(learningRate);
     *
     * // Train the model.
     * for (let i = 0; i < 10; i++) {
     *   optimizer.minimize(() => loss(f(xs), ys));
     * }
     *
     * // Make predictions.
     * console.log(
     *     `a: ${a.dataSync()}, b: ${b.dataSync()}, c: ${c.dataSync()}`);
     * const preds = f(xs).dataSync();
     * preds.forEach((pred, i) => {
     *   console.log(`x: ${i}, pred: ${pred}`);
     * });
     * ```
     *
     * @param learningRate The learning rate to use for the SGD algorithm.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static sgd(learningRate) {
        return new (0, $bQqzj.SGDOptimizer)(learningRate);
    }
    /**
     * Constructs a `tf.MomentumOptimizer` that uses momentum gradient
     * descent.
     *
     * See
     * [http://proceedings.mlr.press/v28/sutskever13.pdf](
     * http://proceedings.mlr.press/v28/sutskever13.pdf)
     *
     * @param learningRate The learning rate to use for the Momentum gradient
     * descent algorithm.
     * @param momentum The momentum to use for the momentum gradient descent
     * algorithm.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static momentum(learningRate, momentum, useNesterov = false) {
        return new (0, $bK23H.MomentumOptimizer)(learningRate, momentum, useNesterov);
    }
    /**
     * Constructs a `tf.RMSPropOptimizer` that uses RMSProp gradient
     * descent. This implementation uses plain momentum and is not centered
     * version of RMSProp.
     *
     * See
     * [http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf](
     * http://www.cs.toronto.edu/~tijmen/csc321/slides/lecture_slides_lec6.pdf)
     *
     * @param learningRate The learning rate to use for the RMSProp gradient
     * descent algorithm.
     * @param decay The discounting factor for the history/coming gradient.
     * @param momentum The momentum to use for the RMSProp gradient descent
     * algorithm.
     * @param epsilon Small value to avoid zero denominator.
     * @param centered If true, gradients are normalized by the estimated
     * variance of the gradient.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static rmsprop(learningRate, decay = .9, momentum = 0.0, epsilon = null, centered = false) {
        return new (0, $glgZq.RMSPropOptimizer)(learningRate, decay, momentum, epsilon, centered);
    }
    /**
     * Constructs a `tf.AdamOptimizer` that uses the Adam algorithm.
     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
     *
     * @param learningRate The learning rate to use for the Adam gradient
     * descent algorithm.
     * @param beta1 The exponential decay rate for the 1st moment estimates.
     * @param beta2 The exponential decay rate for the 2nd moment estimates.
     * @param epsilon A small constant for numerical stability.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adam(learningRate = 0.001, beta1 = 0.9, beta2 = 0.999, epsilon = null) {
        return new (0, $j1H1O.AdamOptimizer)(learningRate, beta1, beta2, epsilon);
    }
    /**
     * Constructs a `tf.AdadeltaOptimizer` that uses the Adadelta algorithm.
     * See [https://arxiv.org/abs/1212.5701](https://arxiv.org/abs/1212.5701)
     *
     * @param learningRate The learning rate to use for the Adadelta gradient
     * descent algorithm.
     * @param rho The learning rate decay over each update.
     * @param epsilon A constant epsilon used to better condition the grad
     * update.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adadelta(learningRate = .001, rho = .95, epsilon = null) {
        return new (0, $fmImY.AdadeltaOptimizer)(learningRate, rho, epsilon);
    }
    /**
     * Constructs a `tf.AdamaxOptimizer` that uses the Adamax algorithm.
     * See [https://arxiv.org/abs/1412.6980](https://arxiv.org/abs/1412.6980)
     *
     * @param learningRate The learning rate to use for the Adamax gradient
     * descent algorithm.
     * @param beta1 The exponential decay rate for the 1st moment estimates.
     * @param beta2 The exponential decay rate for the 2nd moment estimates.
     * @param epsilon A small constant for numerical stability.
     * @param decay The learning rate decay over each update.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adamax(learningRate = 0.002, beta1 = 0.9, beta2 = 0.999, epsilon = null, decay = 0.0) {
        return new (0, $46rlf.AdamaxOptimizer)(learningRate, beta1, beta2, epsilon, decay);
    }
    /**
     * Constructs a `tf.AdagradOptimizer` that uses the Adagrad algorithm.
     * See
     * [http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf](
     * http://www.jmlr.org/papers/volume12/duchi11a/duchi11a.pdf)
     * or
     * [http://ruder.io/optimizing-gradient-descent/index.html#adagrad](
     * http://ruder.io/optimizing-gradient-descent/index.html#adagrad)
     *
     * @param learningRate The learning rate to use for the Adagrad gradient
     * descent algorithm.
     * @param initialAccumulatorValue Starting value for the accumulators, must be
     * positive.
     *
     * @doc {heading: 'Training', subheading: 'Optimizers', namespace: 'train'}
     */ static adagrad(learningRate, initialAccumulatorValue = 0.1) {
        return new (0, $kl14K.AdagradOptimizer)(learningRate, initialAccumulatorValue);
    }
}

});


parcelRegister("3YsQX", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $2e4d5b59315c09d2$export$83d89fbfd8236492; });
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $2e4d5b59315c09d2$export$83d89fbfd8236492 = '4.22.0';

});


parcelRegister("icUUP", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $rllkM = parcelRequire("rllkM");

var $1JhK7 = parcelRequire("1JhK7");

var $ezBIP = parcelRequire("ezBIP");

var $gTd20 = parcelRequire("gTd20");

var $dIadG = parcelRequire("dIadG");

var $i7Nxu = parcelRequire("i7Nxu");

var $4wc4f = parcelRequire("4wc4f");

var $dgvxO = parcelRequire("dgvxO");

var $bCsDT = parcelRequire("bCsDT");

var $frXMV = parcelRequire("frXMV");

var $ad8jZ = parcelRequire("ad8jZ");

var $hiQC0 = parcelRequire("hiQC0");

var $czOCR = parcelRequire("czOCR");

var $f54hp = parcelRequire("f54hp");

var $6ovws = parcelRequire("6ovws");

var $5LBH4 = parcelRequire("5LBH4");

var $9Uvrv = parcelRequire("9Uvrv");

var $1lEh2 = parcelRequire("1lEh2");

var $55bss = parcelRequire("55bss");

var $T3raD = parcelRequire("T3raD");

var $i0c8l = parcelRequire("i0c8l");

var $kRriT = parcelRequire("kRriT");

var $ud4wZ = parcelRequire("ud4wZ");

var $26TSd = parcelRequire("26TSd");

var $50TxE = parcelRequire("50TxE");

var $hGIXx = parcelRequire("hGIXx");

var $60A84 = parcelRequire("60A84");

var $avjqm = parcelRequire("avjqm");

var $3ApNZ = parcelRequire("3ApNZ");

var $dP0HV = parcelRequire("dP0HV");

var $jjBYf = parcelRequire("jjBYf");

var $cezvv = parcelRequire("cezvv");

var $8fLvL = parcelRequire("8fLvL");

var $iczlk = parcelRequire("iczlk");

var $cJdmI = parcelRequire("cJdmI");

var $h7fys = parcelRequire("h7fys");

var $8OIjQ = parcelRequire("8OIjQ");

var $5kJik = parcelRequire("5kJik");

var $YF584 = parcelRequire("YF584");

var $9eiMB = parcelRequire("9eiMB");

var $alfB0 = parcelRequire("alfB0");

var $dCpHR = parcelRequire("dCpHR");

var $cleCk = parcelRequire("cleCk");

var $feiyV = parcelRequire("feiyV");

var $9yA2B = parcelRequire("9yA2B");

var $3eHQS = parcelRequire("3eHQS");

var $5koS4 = parcelRequire("5koS4");

var $1yzBF = parcelRequire("1yzBF");

var $8gAYp = parcelRequire("8gAYp");

var $df8gL = parcelRequire("df8gL");

var $lGqDP = parcelRequire("lGqDP");

var $jWnNq = parcelRequire("jWnNq");

var $1j9mV = parcelRequire("1j9mV");

var $86HcU = parcelRequire("86HcU");

var $8oXFM = parcelRequire("8oXFM");

var $gbBGR = parcelRequire("gbBGR");

var $3zkDA = parcelRequire("3zkDA");

var $iMQ1j = parcelRequire("iMQ1j");

var $7IKzh = parcelRequire("7IKzh");

var $Nhe0O = parcelRequire("Nhe0O");

var $u0lvY = parcelRequire("u0lvY");

var $6duc0 = parcelRequire("6duc0");

var $dyR92 = parcelRequire("dyR92");

var $cgUTR = parcelRequire("cgUTR");

var $hLoD7 = parcelRequire("hLoD7");

var $c4B8c = parcelRequire("c4B8c");

var $7veHN = parcelRequire("7veHN");

var $3DZXD = parcelRequire("3DZXD");

var $h07Yz = parcelRequire("h07Yz");

var $7zlgF = parcelRequire("7zlgF");

var $5fcly = parcelRequire("5fcly");

var $6uGOz = parcelRequire("6uGOz");

var $kOC2k = parcelRequire("kOC2k");

var $5Kw7u = parcelRequire("5Kw7u");

var $iJsSS = parcelRequire("iJsSS");

var $bMsVO = parcelRequire("bMsVO");

var $7Vlrw = parcelRequire("7Vlrw");

var $lid4f = parcelRequire("lid4f");

var $cjIa4 = parcelRequire("cjIa4");

var $5lCGJ = parcelRequire("5lCGJ");

var $73K5P = parcelRequire("73K5P");

var $cW9bw = parcelRequire("cW9bw");

var $ewUq8 = parcelRequire("ewUq8");

var $iGSFW = parcelRequire("iGSFW");

var $3snla = parcelRequire("3snla");

var $lLprS = parcelRequire("lLprS");

var $3704a = parcelRequire("3704a");

var $dYAuB = parcelRequire("dYAuB");

var $dFksd = parcelRequire("dFksd");

var $eXUdv = parcelRequire("eXUdv");

var $4MzBX = parcelRequire("4MzBX");

var $hnzJ9 = parcelRequire("hnzJ9");

var $5q0kk = parcelRequire("5q0kk");

var $ewIME = parcelRequire("ewIME");

var $k3Xj4 = parcelRequire("k3Xj4");

var $lvjR0 = parcelRequire("lvjR0");

var $lgVUp = parcelRequire("lgVUp");

var $7eShb = parcelRequire("7eShb");

var $8DGBP = parcelRequire("8DGBP");

var $f69uZ = parcelRequire("f69uZ");

var $akKed = parcelRequire("akKed");

var $fPoI0 = parcelRequire("fPoI0");
// Export all kernel configs here so that the package can auto register them
const $d4157f3a26fc1b8d$var$gradConfigs = [
    (0, $rllkM.absGradConfig),
    (0, $1JhK7.acosGradConfig),
    (0, $ezBIP.acoshGradConfig),
    (0, $gTd20.addGradConfig),
    (0, $dIadG.addNGradConfig),
    (0, $i7Nxu.argMaxGradConfig),
    (0, $4wc4f.argMinGradConfig),
    (0, $dgvxO.asinGradConfig),
    (0, $bCsDT.asinhGradConfig),
    (0, $frXMV.atan2GradConfig),
    (0, $ad8jZ.atanGradConfig),
    (0, $hiQC0.atanhGradConfig),
    (0, $czOCR.avgPool3DGradConfig),
    (0, $f54hp.avgPoolGradConfig),
    (0, $6ovws.batchMatMulGradConfig),
    (0, $5LBH4.batchToSpaceNDGradConfig),
    (0, $9Uvrv.broadcastToGradConfig),
    (0, $1lEh2.castGradConfig),
    (0, $55bss.ceilGradConfig),
    (0, $T3raD.clipByValueGradConfig),
    (0, $i0c8l.complexAbsGradConfig),
    (0, $kRriT.concatGradConfig),
    (0, $26TSd.conv2DBackpropInputGradConfig),
    (0, $ud4wZ.conv2DGradConfig),
    (0, $50TxE.conv3DGradConfig),
    (0, $hGIXx.cosGradConfig),
    (0, $60A84.coshGradConfig),
    (0, $avjqm.cumsumGradConfig),
    (0, $3ApNZ.depthwiseConv2dNativeGradConfig),
    (0, $dP0HV.dilation2dGradConfig),
    (0, $3DZXD.divGradConfig),
    (0, $jjBYf.eluGradConfig),
    (0, $cezvv.erfGradConfig),
    (0, $8fLvL.expGradConfig),
    (0, $iczlk.expandDimsGradConfig),
    (0, $cJdmI.expm1GradConfig),
    (0, $8OIjQ.floorDivGradConfig),
    (0, $h7fys.floorGradConfig),
    (0, $5kJik.fusedBatchNormGradConfig),
    (0, $YF584.gatherGradConfig),
    (0, $9eiMB.greaterEqualGradConfig),
    (0, $alfB0.identityGradConfig),
    (0, $dCpHR.isFiniteGradConfig),
    (0, $cleCk.isInfGradConfig),
    (0, $feiyV.isNanGradConfig),
    (0, $9yA2B.leakyReluGradConfig),
    (0, $3eHQS.log1pGradConfig),
    (0, $5koS4.logGradConfig),
    (0, $1yzBF.logSoftmaxGradConfig),
    (0, $8gAYp.lrnGradConfig),
    (0, $df8gL.maxGradConfig),
    (0, $df8gL.maxGradConfig),
    (0, $lGqDP.maximumGradConfig),
    (0, $jWnNq.maxPool3DGradConfig),
    (0, $1j9mV.maxPoolGradConfig),
    (0, $86HcU.meanGradConfig),
    (0, $8oXFM.minGradConfig),
    (0, $gbBGR.minimumGradConfig),
    (0, $3zkDA.mirrorPadGradConfig),
    (0, $iMQ1j.modGradConfig),
    (0, $7IKzh.multiplyGradConfig),
    (0, $Nhe0O.negGradConfig),
    (0, $u0lvY.oneHotGradConfig),
    (0, $6duc0.onesLikeGradConfig),
    (0, $dyR92.packGradConfig),
    (0, $cgUTR.padV2GradConfig),
    (0, $cgUTR.padV2GradConfig),
    (0, $hLoD7.powGradConfig),
    (0, $c4B8c.preluGradConfig),
    (0, $7veHN.prodGradConfig),
    (0, $h07Yz.reciprocalGradConfig),
    (0, $7zlgF.relu6GradConfig),
    (0, $5fcly.reluGradConfig),
    (0, $6uGOz.reshapeGradConfig),
    (0, $kOC2k.resizeBilinearGradConfig),
    (0, $5Kw7u.resizeNearestNeighborGradConfig),
    (0, $iJsSS.reverseGradConfig),
    (0, $bMsVO.roundGradConfig),
    (0, $7Vlrw.rsqrtGradConfig),
    (0, $lid4f.selectGradConfig),
    (0, $cjIa4.seluGradConfig),
    (0, $5lCGJ.sigmoidGradConfig),
    (0, $73K5P.signGradConfig),
    (0, $cW9bw.sinGradConfig),
    (0, $ewUq8.sinhGradConfig),
    (0, $iGSFW.sliceGradConfig),
    (0, $3snla.softmaxGradConfig),
    (0, $lLprS.softplusGradConfig),
    (0, $3704a.spaceToBatchNDGradConfig),
    (0, $3704a.spaceToBatchNDGradConfig),
    (0, $dYAuB.splitVGradConfig),
    (0, $dYAuB.splitVGradConfig),
    (0, $dFksd.sqrtGradConfig),
    (0, $4MzBX.squaredDifferenceGradConfig),
    (0, $eXUdv.squareGradConfig),
    (0, $hnzJ9.stepGradConfig),
    (0, $5q0kk.subGradConfig),
    (0, $ewIME.sumGradConfig),
    (0, $k3Xj4.tanGradConfig),
    (0, $lvjR0.tanhGradConfig),
    (0, $lgVUp.tileGradConfig),
    (0, $7eShb.transposeGradConfig),
    (0, $8DGBP.unpackGradConfig),
    (0, $f69uZ.unsortedSegmentSumGradConfig),
    (0, $akKed.zerosLikeGradConfig)
];
for (const gradientConfig of $d4157f3a26fc1b8d$var$gradConfigs)(0, $fPoI0.registerGradient)(gradientConfig);

});
parcelRegister("rllkM", function(module, exports) {

$parcel$export(module.exports, "absGradConfig", function () { return $05231406b8cf1bc3$export$8311873a6069f3c6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $5hAos = parcelRequire("5hAos");

var $1LynW = parcelRequire("1LynW");
const $05231406b8cf1bc3$export$8311873a6069f3c6 = {
    kernelName: (0, $9BGT9.Abs),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)(dy, (0, $1LynW.step)((0, $fxiHg.cast)(x, 'float32'), -1))
        };
    }
};

});

parcelRegister("1JhK7", function(module, exports) {

$parcel$export(module.exports, "acosGradConfig", function () { return $1427c1cca818976c$export$25410aeefefd68e9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $jMlCE = parcelRequire("jMlCE");

var $7hONX = parcelRequire("7hONX");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");
const $1427c1cca818976c$export$25410aeefefd68e9 = {
    kernelName: (0, $9BGT9.Acos),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $5MB84.square)((0, $fxiHg.cast)(x, 'float32'));
                const b = (0, $g3lev.sqrt)((0, $5jGN9.sub)((0, $7hONX.scalar)(1), a));
                return (0, $jMlCE.neg)((0, $dIChU.div)(dy, b));
            }
        };
    }
};

});

parcelRegister("ezBIP", function(module, exports) {

$parcel$export(module.exports, "acoshGradConfig", function () { return $a9c19867e3b3f050$export$2ec6994297162d56; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");
const $a9c19867e3b3f050$export$2ec6994297162d56 = {
    kernelName: (0, $9BGT9.Acosh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $g3lev.sqrt)((0, $5jGN9.sub)((0, $5MB84.square)((0, $fxiHg.cast)(x, 'float32')), 1));
                return (0, $dIChU.div)(dy, a);
            }
        };
    }
};

});

parcelRegister("gTd20", function(module, exports) {

$parcel$export(module.exports, "addGradConfig", function () { return $c4bbe4274b6e803a$export$817a98e7fbc08f69; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5mf1d = parcelRequire("5mf1d");

var $8nMOl = parcelRequire("8nMOl");

var $fPnAL = parcelRequire("fPnAL");
const $c4bbe4274b6e803a$export$817a98e7fbc08f69 = {
    kernelName: (0, $9BGT9.Add),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $5mf1d.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            let res = dy;
            const reduceAxes = $5mf1d.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
            return (0, $8nMOl.reshape)(res, a.shape);
        };
        const derB = ()=>{
            let res = dy;
            const reduceAxes = $5mf1d.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
            return (0, $8nMOl.reshape)(res, b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("dIadG", function(module, exports) {

$parcel$export(module.exports, "addNGradConfig", function () { return $9fb74fd324e76950$export$9dda03cc9e4ef85c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");
const $9fb74fd324e76950$export$9dda03cc9e4ef85c = {
    kernelName: (0, $9BGT9.AddN),
    saveAllInputs: true,
    gradFunc: (dy, saved)=>{
        const ders = {};
        saved.forEach((_, i)=>{
            ders[i] = ()=>dy.clone();
        });
        return ders;
    }
};

});

parcelRegister("i7Nxu", function(module, exports) {

$parcel$export(module.exports, "argMaxGradConfig", function () { return $d31f4ee27e99ea65$export$1d99392d6c64a702; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $d31f4ee27e99ea65$export$1d99392d6c64a702 = {
    kernelName: (0, $9BGT9.ArgMax),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $cztsD.zerosLike)(x)
        };
    }
};

});

parcelRegister("4wc4f", function(module, exports) {

$parcel$export(module.exports, "argMinGradConfig", function () { return $34a382f2d8a1d162$export$af12a090c1c7b332; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $34a382f2d8a1d162$export$af12a090c1c7b332 = {
    kernelName: (0, $9BGT9.ArgMin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $cztsD.zerosLike)(x)
        };
    }
};

});

parcelRegister("dgvxO", function(module, exports) {

$parcel$export(module.exports, "asinGradConfig", function () { return $9a853d055269666d$export$3f8c1d33cc0ed430; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $7hONX = parcelRequire("7hONX");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");
const $9a853d055269666d$export$3f8c1d33cc0ed430 = {
    kernelName: (0, $9BGT9.Asin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $dIChU.div)(dy, (0, $g3lev.sqrt)((0, $5jGN9.sub)((0, $7hONX.scalar)(1), (0, $5MB84.square)((0, $fxiHg.cast)(x, 'float32')))))
        };
    }
};

});

parcelRegister("bCsDT", function(module, exports) {

$parcel$export(module.exports, "asinhGradConfig", function () { return $8759761c09a653b3$export$375f857062067cfd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $6Ab5n = parcelRequire("6Ab5n");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $7hONX = parcelRequire("7hONX");

var $g3lev = parcelRequire("g3lev");

var $5MB84 = parcelRequire("5MB84");
const $8759761c09a653b3$export$375f857062067cfd = {
    kernelName: (0, $9BGT9.Asinh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const a = (0, $g3lev.sqrt)((0, $6Ab5n.add)((0, $7hONX.scalar)(1), (0, $5MB84.square)((0, $fxiHg.cast)(x, 'float32'))));
                return (0, $dIChU.div)(dy, a);
            }
        };
    }
};

});

parcelRegister("frXMV", function(module, exports) {

$parcel$export(module.exports, "atan2GradConfig", function () { return $b3f7c1543c48c464$export$cdf09477d70d7ce9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $6Ab5n = parcelRequire("6Ab5n");

var $5mf1d = parcelRequire("5mf1d");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $8nMOl = parcelRequire("8nMOl");

var $5MB84 = parcelRequire("5MB84");

var $fPnAL = parcelRequire("fPnAL");
const $b3f7c1543c48c464$export$cdf09477d70d7ce9 = {
    kernelName: (0, $9BGT9.Atan2),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $5mf1d.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const d = (0, $6Ab5n.add)((0, $5MB84.square)(a), (0, $5MB84.square)(b));
            let res = (0, $5hAos.mul)(dy, (0, $dIChU.div)(b, d));
            const reduceAxes = (0, $5mf1d.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
            return (0, $8nMOl.reshape)(res, a.shape);
        };
        const derB = ()=>{
            const d = (0, $6Ab5n.add)((0, $5MB84.square)(a), (0, $5MB84.square)(b));
            let res = (0, $jMlCE.neg)((0, $5hAos.mul)(dy, (0, $dIChU.div)(a, d)));
            const reduceAxes = (0, $5mf1d.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
            return (0, $8nMOl.reshape)(res, b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("ad8jZ", function(module, exports) {

$parcel$export(module.exports, "atanGradConfig", function () { return $76f192c0ab54c5db$export$87ed559988dd857; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $6Ab5n = parcelRequire("6Ab5n");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $5MB84 = parcelRequire("5MB84");
const $76f192c0ab54c5db$export$87ed559988dd857 = {
    kernelName: (0, $9BGT9.Atan),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $dIChU.div)(dy, (0, $6Ab5n.add)((0, $5MB84.square)((0, $fxiHg.cast)(x, 'float32')), 1))
        };
    }
};

});

parcelRegister("hiQC0", function(module, exports) {

$parcel$export(module.exports, "atanhGradConfig", function () { return $c98cedc1fce6177d$export$465efa1ebdf13d21; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");

var $7hONX = parcelRequire("7hONX");
const $c98cedc1fce6177d$export$465efa1ebdf13d21 = {
    kernelName: (0, $9BGT9.Atanh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $dIChU.div)(dy, (0, $5jGN9.sub)((0, $7hONX.scalar)(1), (0, $5MB84.square)((0, $fxiHg.cast)(x, 'float32'))))
        };
    }
};

});

parcelRegister("czOCR", function(module, exports) {

$parcel$export(module.exports, "avgPool3DGradConfig", function () { return $9280062660f79ee4$export$1eeb8780807d0508; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cgjBd = parcelRequire("cgjBd");
const $9280062660f79ee4$export$1eeb8780807d0508 = {
    kernelName: (0, $9BGT9.AvgPool3D),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            x: ()=>(0, $cgjBd.avgPool3dGrad)(dy, x, filterSize, strides, pad, dimRoundingMode)
        };
    }
};

});
parcelRegister("cgjBd", function(module, exports) {

$parcel$export(module.exports, "avgPool3dGrad", function () { return $8ed62ea991267622$export$e8424a7f676b4e30; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the backprop of a 3d avg pool.
 *
 * @param dy The dy error, of rank 5 of shape
 *     [batchSize, depth, height, width, channels].
 * assumed.
 * @param input The original input image, of rank 5 or rank4 of shape
 *     [batchSize, depth, height, width, channels].
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $8ed62ea991267622$var$avgPool3dGrad_(dy, input, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $x4eLk.convertToTensor)(dy, 'dy', 'avgPool3dGrad');
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'avgPool3dGrad');
    let dy5D = $dy;
    let input5D = $input;
    let reshapedTo5D = false;
    if ($input.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $8nMOl.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2],
            $dy.shape[3]
        ]);
        input5D = (0, $8nMOl.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2],
            $input.shape[3]
        ]);
    }
    $eOiOM.assert(dy5D.rank === 5, ()=>`Error in avgPool3dGrad: dy must be rank 5 but got rank ` + `${dy5D.rank}.`);
    $eOiOM.assert(input5D.rank === 5, ()=>`Error in avgPool3dGrad: input must be rank 5 but got rank ` + `${input5D.rank}.`);
    (0, $g0V2M.checkPadOnDimRoundingMode)('avgPool3dGrad', pad, dimRoundingMode);
    const inputs = {
        dy: dy5D,
        input: input5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.AvgPool3DGrad), inputs, attrs);
    if (reshapedTo5D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $8ed62ea991267622$export$e8424a7f676b4e30 = /* @__PURE__ */ (0, $6afhl.op)({
    avgPool3dGrad_: $8ed62ea991267622$var$avgPool3dGrad_
});

});


parcelRegister("f54hp", function(module, exports) {

$parcel$export(module.exports, "avgPoolGradConfig", function () { return $afaaa484477312a6$export$ac3f8709351ab225; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $8uxp2 = parcelRequire("8uxp2");
const $afaaa484477312a6$export$ac3f8709351ab225 = {
    kernelName: (0, $9BGT9.AvgPool),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
        return {
            x: ()=>(0, $8uxp2.avgPoolGrad)(dy, x, filterSize, strides, pad)
        };
    }
};

});
parcelRegister("8uxp2", function(module, exports) {

$parcel$export(module.exports, "avgPoolGrad", function () { return $62eb092fe7c52afe$export$2f098171d1c79aea; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the backprop of an 2D avg pool.
 *
 * @param dy The dy error, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param input The input image, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm used in the forward prop of the op.
 *     'same', 'valid', for more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *         https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 */ function $62eb092fe7c52afe$var$avgPoolGrad_(dy, input, filterSize, strides, pad) {
    const $dy = (0, $x4eLk.convertToTensor)(dy, 'dy', 'avgPoolGrad');
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'avgPoolGrad');
    $eOiOM.assert($input.rank === $dy.rank, ()=>`Rank of input (${$input.rank}) does not match rank of dy (${$dy.rank})`);
    let input4D = $input;
    let dy4D = $dy;
    let reshapedTo4D = false;
    if ($input.rank === 3) {
        reshapedTo4D = true;
        input4D = (0, $8nMOl.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2]
        ]);
        dy4D = (0, $8nMOl.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2]
        ]);
    }
    $eOiOM.assert(dy4D.rank === 4, ()=>`Error in avgPoolGrad: dy must be rank 4 but got rank ` + `${dy4D.rank}.`);
    $eOiOM.assert(input4D.rank === 4, ()=>`Error in avgPoolGrad: input must be rank 4 but got rank ` + `${input4D.rank}.`);
    const inputs = {
        dy: dy4D,
        input: input4D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.AvgPoolGrad), inputs, attrs);
    if (reshapedTo4D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3]
    ]);
    return res;
}
const $62eb092fe7c52afe$export$2f098171d1c79aea = /* @__PURE__ */ (0, $6afhl.op)({
    avgPoolGrad_: $62eb092fe7c52afe$var$avgPoolGrad_
});

});


parcelRegister("6ovws", function(module, exports) {

$parcel$export(module.exports, "batchMatMulGradConfig", function () { return $4a7d6fb09092d310$export$88221f1a5167c38c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $VLFo8 = parcelRequire("VLFo8");
const $4a7d6fb09092d310$export$88221f1a5167c38c = {
    kernelName: (0, $9BGT9.BatchMatMul),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [a, b] = saved;
        const { transposeA: transposeA, transposeB: transposeB } = attrs;
        if (!transposeA && !transposeB) return {
            a: ()=>(0, $VLFo8.matMul)(dy, b, false, true),
            b: ()=>(0, $VLFo8.matMul)(a, dy, true, false)
        };
        else if (!transposeA && transposeB) return {
            a: ()=>(0, $VLFo8.matMul)(dy, b, false, false),
            b: ()=>(0, $VLFo8.matMul)(dy, a, true, false)
        };
        else if (transposeA && !transposeB) return {
            a: ()=>(0, $VLFo8.matMul)(b, dy, false, true),
            b: ()=>(0, $VLFo8.matMul)(a, dy, false, false)
        };
        else return {
            a: ()=>(0, $VLFo8.matMul)(b, dy, true, true),
            b: ()=>(0, $VLFo8.matMul)(dy, a, true, true)
        };
    }
};

});

parcelRegister("5LBH4", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceNDGradConfig", function () { return $432e94b845d73516$export$b6582e1705c4f42d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $9l6gk = parcelRequire("9l6gk");
const $432e94b845d73516$export$b6582e1705c4f42d = {
    kernelName: (0, $9BGT9.BatchToSpaceND),
    gradFunc: (dy, saved, attrs)=>{
        const { blockShape: blockShape, crops: crops } = attrs;
        return {
            x: ()=>(0, $9l6gk.spaceToBatchND)(dy, blockShape, crops)
        };
    }
};

});

parcelRegister("9Uvrv", function(module, exports) {

$parcel$export(module.exports, "broadcastToGradConfig", function () { return $7371bbe2f4fa6a77$export$1fc1d8b1fdae546a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fPnAL = parcelRequire("fPnAL");
const $7371bbe2f4fa6a77$export$1fc1d8b1fdae546a = {
    kernelName: (0, $9BGT9.BroadcastTo),
    gradFunc: (dy, saved, attrs)=>{
        const broadCastToAttrs = attrs;
        const inputShape = broadCastToAttrs.inputShape;
        const outputShape = broadCastToAttrs.shape;
        const reps = Array.from(outputShape);
        for(let i = inputShape.length - 1; i >= 0; i--){
            if (inputShape[i] === outputShape[i]) reps[i] = 1;
            else if (inputShape[i] !== 1) throw new Error(`broadcastTo(): [${inputShape}] cannot be broadcast to [${outputShape}].`);
        }
        const axes = [];
        for(let i = 0; i < reps.length; i++)if (reps[i] > 1) axes.push(i);
        return {
            x: ()=>(0, $fPnAL.sum)(dy, axes, true)
        };
    }
};

});

parcelRegister("1lEh2", function(module, exports) {

$parcel$export(module.exports, "castGradConfig", function () { return $0fb6fe2b4bb7e534$export$77a4f6320d798df2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");
const $0fb6fe2b4bb7e534$export$77a4f6320d798df2 = {
    kernelName: (0, $9BGT9.Cast),
    gradFunc: (dy)=>{
        return {
            x: ()=>dy.clone()
        };
    }
};

});

parcelRegister("55bss", function(module, exports) {

$parcel$export(module.exports, "ceilGradConfig", function () { return $3b364ead48ebd5f0$export$1789d8956379862a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $3b364ead48ebd5f0$export$1789d8956379862a = {
    kernelName: (0, $9BGT9.Ceil),
    gradFunc: (dy)=>{
        // TODO(manrajgrover): Return null for gradients when backprop supports it.
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("T3raD", function(module, exports) {

$parcel$export(module.exports, "clipByValueGradConfig", function () { return $0a57cdbb783a8348$export$3f1764b1eedfe2cb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $kKLvn = parcelRequire("kKLvn");

var $bvcEy = parcelRequire("bvcEy");

var $gXTMu = parcelRequire("gXTMu");

var $3A1QZ = parcelRequire("3A1QZ");

var $cztsD = parcelRequire("cztsD");
const $0a57cdbb783a8348$export$3f1764b1eedfe2cb = {
    kernelName: (0, $9BGT9.ClipByValue),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
        return {
            x: ()=>(0, $3A1QZ.where)((0, $gXTMu.logicalAnd)((0, $kKLvn.greaterEqual)(x, clipValueMin), (0, $bvcEy.lessEqual)(x, clipValueMax)), dy, (0, $cztsD.zerosLike)(dy))
        };
    }
};

});

parcelRegister("i0c8l", function(module, exports) {

$parcel$export(module.exports, "complexAbsGradConfig", function () { return $d1b1a38d5923c7da$export$b8ff856642294896; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $rllkM = parcelRequire("rllkM");
const $d1b1a38d5923c7da$export$b8ff856642294896 = {
    kernelName: (0, $9BGT9.ComplexAbs),
    inputsToSave: [
        'x'
    ],
    gradFunc: (0, $rllkM.absGradConfig).gradFunc
};

});

parcelRegister("kRriT", function(module, exports) {

$parcel$export(module.exports, "concatGradConfig", function () { return $f2fdefd09fcf5bf3$export$ddda159860ceb06e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $crriC = parcelRequire("crriC");

var $eOiOM = parcelRequire("eOiOM");
const $f2fdefd09fcf5bf3$export$ddda159860ceb06e = {
    kernelName: (0, $9BGT9.Concat),
    saveAllInputs: true,
    gradFunc: (dy, saved, attrs)=>{
        const shapes = saved.map((t)=>t.shape);
        const { axis: axis } = attrs;
        const $axis = (0, $eOiOM.parseAxisParam)(axis, saved[0].shape)[0];
        const sizeSplits = shapes.map((s)=>s[$axis]);
        const derTensors = (0, $crriC.split)(dy, sizeSplits, $axis);
        return derTensors.map((t)=>()=>t);
    }
};

});

parcelRegister("ud4wZ", function(module, exports) {

$parcel$export(module.exports, "conv2DGradConfig", function () { return $05acf14ccb021945$export$2fd622114dede0fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $6jqyV = parcelRequire("6jqyV");

var $1iZpR = parcelRequire("1iZpR");

var $g0V2M = parcelRequire("g0V2M");

var $eOiOM = parcelRequire("eOiOM");
const $05acf14ccb021945$export$2fd622114dede0fc = {
    kernelName: (0, $9BGT9.Conv2D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x4D, $filter] = saved;
        const { dilations: dilations, strides: strides, pad: pad, dataFormat: dataFormat } = attrs;
        $eOiOM.assert($g0V2M.tupleValuesAreOne(dilations), ()=>'Error in gradient of conv2D: dilation rates greater than 1 ' + `are not yet supported in gradients. Got dilations '${dilations}'`);
        return {
            x: ()=>(0, $1iZpR.conv2DBackpropInput)(x4D.shape, dy, $filter, strides, pad, dataFormat),
            filter: ()=>(0, $6jqyV.conv2DBackpropFilter)(x4D, dy, $filter.shape, strides, pad, dataFormat)
        };
    }
};

});

parcelRegister("26TSd", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInputGradConfig", function () { return $18977b9a50c2f32b$export$cdb8a95f3d598a0d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $9JluG = parcelRequire("9JluG");

var $6jqyV = parcelRequire("6jqyV");
const $18977b9a50c2f32b$export$cdb8a95f3d598a0d = {
    kernelName: (0, $9BGT9.Conv2DBackpropInput),
    inputsToSave: [
        'dy',
        'filter'
    ],
    gradFunc: (ddx, saved, attrs)=>{
        const [dy, filter] = saved;
        const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            dy: ()=>(0, $9JluG.conv2d)(ddx, filter, strides, pad, dataFormat, 1 /* dilations */ , dimRoundingMode),
            filter: ()=>(0, $6jqyV.conv2DBackpropFilter)(ddx, dy, filter.shape, strides, pad, dataFormat, dimRoundingMode)
        };
    }
};

});

parcelRegister("50TxE", function(module, exports) {

$parcel$export(module.exports, "conv3DGradConfig", function () { return $3a6809418e775ba3$export$2456b335ba19aa7b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $adN3b = parcelRequire("adN3b");

var $RWsOw = parcelRequire("RWsOw");

var $g0V2M = parcelRequire("g0V2M");

var $eOiOM = parcelRequire("eOiOM");
const $3a6809418e775ba3$export$2456b335ba19aa7b = {
    kernelName: (0, $9BGT9.Conv3D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { dilations: dilations, strides: strides, pad: pad } = attrs;
        $eOiOM.assert((0, $g0V2M.tupleValuesAreOne)(dilations), ()=>'Error in gradient of conv3D: dilation rates greater than 1 are ' + `not yet supported in gradients. Got dilations '${dilations}'`);
        const [x5D, $filter] = saved;
        return {
            x: ()=>(0, $RWsOw.conv3DBackpropInput)(x5D.shape, dy, $filter, strides, pad),
            filter: ()=>(0, $adN3b.conv3DBackpropFilter)(x5D, dy, $filter.shape, strides, pad)
        };
    }
};

});
parcelRegister("adN3b", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropFilter", function () { return $77112aa4bd9cfd70$export$6119875a1cee531e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the derivative of the filter of a 3D convolution.
 *
 * @param x The input tensor, of rank 5 or rank 4 of shape
 *     [batch, depth, height, width, inChannels]. If rank 4, batch of 1 is
 *     assumed.
 * @param dy The dy image, of rank 5 or rank 4, of shape
 *     [batch, depth, height, width, outDepth]. If rank 4, batch of 1 is
 *     assumed.
 * @param filterShape The shape of the filter, length 5,
 *     [filterDepth, filterHeight, filterWidth, inDepth, outDepth].
 * @param strides The strides of the convolution: [strideDepth, strideHeight,
 * strideWidth].
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 */ function $77112aa4bd9cfd70$var$conv3DBackpropFilter_(x, dy, filterShape, strides, pad) {
    let x5D = x;
    if (x.rank === 4) x5D = (0, $8nMOl.reshape)(x, [
        1,
        x.shape[0],
        x.shape[1],
        x.shape[2],
        x.shape[3]
    ]);
    let dy5D = dy;
    if (dy5D.rank === 4) dy5D = (0, $8nMOl.reshape)(dy, [
        1,
        dy.shape[0],
        dy.shape[1],
        dy.shape[2],
        dy.shape[3]
    ]);
    $eOiOM.assert(x5D.rank === 5, ()=>`Error in conv3dDerFilter: input must be rank 5, but got shape ` + `${x5D.shape}.`);
    $eOiOM.assert(dy5D.rank === 5, ()=>`Error in conv3dDerFilter: dy must be rank 5, but got shape ` + `${dy5D.shape}.`);
    $eOiOM.assert(filterShape.length === 5, ()=>`Error in conv3dDerFilter: filterShape must be length 5, but got ` + `${filterShape}.`);
    $eOiOM.assert(x5D.shape[4] === filterShape[3], ()=>`Error in conv3dDerFilter: depth of input ${x5D.shape[4]}) must ` + `match input depth in filter (${filterShape[3]}.`);
    $eOiOM.assert(dy5D.shape[4] === filterShape[4], ()=>`Error in conv3dDerFilter: depth of dy (${dy5D.shape[4]}) must ` + `match output depth for filter (${filterShape[4]}).`);
    const inputs = {
        x: x5D,
        dy: dy5D
    };
    const attrs = {
        strides: strides,
        pad: pad,
        filterShape: filterShape
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Conv3DBackpropFilterV2), inputs, attrs);
}
const $77112aa4bd9cfd70$export$6119875a1cee531e = /* @__PURE__ */ (0, $6afhl.op)({
    conv3DBackpropFilter_: $77112aa4bd9cfd70$var$conv3DBackpropFilter_
});

});


parcelRegister("hGIXx", function(module, exports) {

$parcel$export(module.exports, "cosGradConfig", function () { return $ce093be1c246da9a$export$fc646268baa57098; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $6zQIj = parcelRequire("6zQIj");
const $ce093be1c246da9a$export$fc646268baa57098 = {
    kernelName: (0, $9BGT9.Cos),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)((0, $jMlCE.neg)((0, $6zQIj.sin)((0, $fxiHg.cast)(x, 'float32'))), dy)
        };
    }
};

});

parcelRegister("60A84", function(module, exports) {

$parcel$export(module.exports, "coshGradConfig", function () { return $45fec4a76b4f8464$export$bcde595585c16638; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $5hAos = parcelRequire("5hAos");

var $fbZFd = parcelRequire("fbZFd");
const $45fec4a76b4f8464$export$bcde595585c16638 = {
    kernelName: (0, $9BGT9.Cosh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)((0, $fbZFd.sinh)((0, $fxiHg.cast)(x, 'float32')), dy)
        };
    }
};

});

parcelRegister("avjqm", function(module, exports) {

$parcel$export(module.exports, "cumsumGradConfig", function () { return $7a5bddda62cf1e19$export$9f1ba0cc8e88cb76; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $bC6Qi = parcelRequire("bC6Qi");

var $ec6xM = parcelRequire("ec6xM");

var $9c2so = parcelRequire("9c2so");
const $7a5bddda62cf1e19$export$9f1ba0cc8e88cb76 = {
    kernelName: (0, $9BGT9.Cumsum),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
        return {
            x: ()=>{
                const permutation = (0, $bC6Qi.getAxesPermutation)([
                    axis
                ], x.rank);
                let out = (0, $ec6xM.cumsum)(dy, axis, exclusive, !reverse);
                if (permutation != null) out = (0, $9c2so.transpose)(out, permutation);
                return out;
            }
        };
    }
};

});

parcelRegister("3ApNZ", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeGradConfig", function () { return $29c8c0436b028bc4$export$66192798aa3d6196; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $g0V2M = parcelRequire("g0V2M");

var $1V6Ii = parcelRequire("1V6Ii");

var $ltsWA = parcelRequire("ltsWA");

var $eOiOM = parcelRequire("eOiOM");
const $29c8c0436b028bc4$export$66192798aa3d6196 = {
    kernelName: (0, $9BGT9.DepthwiseConv2dNative),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { dilations: dilations, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        const $dilations = dilations == null ? [
            1,
            1
        ] : dilations;
        $eOiOM.assert($g0V2M.tupleValuesAreOne($dilations), ()=>'Error in gradient of depthwiseConv2dNative: dilation rates ' + `greater than 1 are not yet supported. Got dilations ` + `'${$dilations}'`);
        const [x, filter] = saved;
        $eOiOM.assert(x.rank === 4, ()=>`Error in gradient of depthwiseConv2dNative: input must be ` + `rank 4, but got rank ${x.rank}.`);
        $eOiOM.assert(filter.rank === 4, ()=>`Error in gradient of depthwiseConv2dNative: filter must be ` + `rank 4, but got rank ${filter.rank}.`);
        $eOiOM.assert(x.shape[3] === filter.shape[2], ()=>`Error in gradient of depthwiseConv2d: number of input ` + `channels (${x.shape[3]}) must match the inChannels dimension ` + `in filter ${filter.shape[2]}.`);
        $eOiOM.assert($g0V2M.eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in gradient of depthwiseConv2d: Either strides or ' + `dilations must be  1. Got strides ${strides} and dilations ` + `'${$dilations}'.`);
        $g0V2M.checkPadOnDimRoundingMode('depthwiseConv2d', pad, dimRoundingMode);
        return {
            x: ()=>(0, $ltsWA.depthwiseConv2dNativeBackpropInput)(x.shape, dy, filter, strides, pad, $dilations, dimRoundingMode),
            filter: ()=>(0, $1V6Ii.depthwiseConv2dNativeBackpropFilter)(x, dy, filter.shape, strides, pad, $dilations, dimRoundingMode)
        };
    }
};

});

parcelRegister("dP0HV", function(module, exports) {

$parcel$export(module.exports, "dilation2dGradConfig", function () { return $a1009647d39c268a$export$3d2aed5cf11b13ba; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");
const $a1009647d39c268a$export$3d2aed5cf11b13ba = {
    kernelName: (0, $9BGT9.Dilation2D),
    inputsToSave: [
        'x',
        'filter'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, filter] = saved;
        const inputInputs = {
            x: x,
            filter: filter,
            dy: dy
        };
        const filterInputs = {
            x: x,
            filter: filter,
            dy: dy
        };
        return {
            x: ()=>(0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Dilation2DBackpropInput), inputInputs, attrs),
            filter: ()=>(0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.Dilation2DBackpropFilter), filterInputs, attrs)
        };
    }
};

});

parcelRegister("jjBYf", function(module, exports) {

$parcel$export(module.exports, "eluGradConfig", function () { return $e0fd3edf549717f2$export$59bb07dd04647a1d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");
const $e0fd3edf549717f2$export$59bb07dd04647a1d = {
    kernelName: (0, $9BGT9.Elu),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        const inputs = {
            dy: dy,
            y: y
        };
        return {
            x: ()=>(0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.EluGrad), inputs)
        };
    }
};

});

parcelRegister("cezvv", function(module, exports) {

$parcel$export(module.exports, "erfGradConfig", function () { return $8e8255d372346103$export$80bb9a361ec8d601; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $1lCoz = parcelRequire("1lCoz");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $5MB84 = parcelRequire("5MB84");
const $8e8255d372346103$export$80bb9a361ec8d601 = {
    kernelName: (0, $9BGT9.Erf),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        const a = (0, $5hAos.mul)((0, $1lCoz.exp)((0, $jMlCE.neg)((0, $5MB84.square)(x))), 2 / Math.sqrt(Math.PI));
        return {
            x: ()=>(0, $5hAos.mul)(dy, a)
        };
    }
};

});

parcelRegister("8fLvL", function(module, exports) {

$parcel$export(module.exports, "expGradConfig", function () { return $6024943a7fa3fa3c$export$e3362b875cf81ebc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5hAos = parcelRequire("5hAos");
const $6024943a7fa3fa3c$export$e3362b875cf81ebc = {
    kernelName: (0, $9BGT9.Exp),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $5hAos.mul)(dy, y)
        };
    }
};

});

parcelRegister("iczlk", function(module, exports) {

$parcel$export(module.exports, "expandDimsGradConfig", function () { return $d404c35942b5c8c3$export$27394e9fa8330490; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $8nMOl = parcelRequire("8nMOl");
const $d404c35942b5c8c3$export$27394e9fa8330490 = {
    kernelName: (0, $9BGT9.ExpandDims),
    inputsToSave: [
        'input'
    ],
    gradFunc: (dy, saved)=>{
        const [input] = saved;
        return {
            input: ()=>(0, $8nMOl.reshape)(dy, input.shape)
        };
    }
};

});

parcelRegister("cJdmI", function(module, exports) {

$parcel$export(module.exports, "expm1GradConfig", function () { return $94440e1d153a67c5$export$758f509582468c75; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $1lCoz = parcelRequire("1lCoz");

var $5hAos = parcelRequire("5hAos");
const $94440e1d153a67c5$export$758f509582468c75 = {
    kernelName: (0, $9BGT9.Expm1),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)(dy, (0, $1lCoz.exp)(x))
        };
    }
};

});

parcelRegister("h7fys", function(module, exports) {

$parcel$export(module.exports, "floorGradConfig", function () { return $c75f27f5e39b9f91$export$2a943001dbfa8fd1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $c75f27f5e39b9f91$export$2a943001dbfa8fd1 = {
    kernelName: (0, $9BGT9.Floor),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("8OIjQ", function(module, exports) {

$parcel$export(module.exports, "floorDivGradConfig", function () { return $66b55f1aefa6ad2e$export$1f5798c5c4ca3f10; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5mf1d = parcelRequire("5mf1d");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $8nMOl = parcelRequire("8nMOl");

var $5MB84 = parcelRequire("5MB84");

var $fPnAL = parcelRequire("fPnAL");
const $66b55f1aefa6ad2e$export$1f5798c5c4ca3f10 = {
    kernelName: (0, $9BGT9.FloorDiv),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $5mf1d.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $dIChU.div)(dy, (0, $fxiHg.cast)(b, 'float32'));
            const reduceAxes = (0, $5mf1d.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $8nMOl.reshape)((0, $fPnAL.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            let res = (0, $5hAos.mul)(dy, (0, $fxiHg.cast)(a, 'float32'));
            const reduceAxes = (0, $5mf1d.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $8nMOl.reshape)((0, $fPnAL.sum)(res, reduceAxes), b.shape);
            const tmp = (0, $5MB84.square)(b);
            return (0, $jMlCE.neg)((0, $dIChU.div)(res, (0, $fxiHg.cast)(tmp, 'float32')));
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("5kJik", function(module, exports) {

$parcel$export(module.exports, "fusedBatchNormGradConfig", function () { return $3e21f498ec779eab$export$3b83e7a588d720e9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $6Ab5n = parcelRequire("6Ab5n");

var $5mf1d = parcelRequire("5mf1d");

var $5hAos = parcelRequire("5hAos");

var $8nMOl = parcelRequire("8nMOl");

var $6M9ry = parcelRequire("6M9ry");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");

var $dolPi = parcelRequire("dolPi");
const $3e21f498ec779eab$export$3b83e7a588d720e9 = {
    kernelName: (0, $9BGT9.FusedBatchNorm),
    inputsToSave: [
        'x',
        'mean',
        'variance',
        'scale'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const { varianceEpsilon: varianceEpsilon } = attrs;
        const [x, mean, variance, scale] = saved;
        const scaleValue = scale == null ? (0, $7hONX.scalar)(1) : scale;
        const reductionAxes = (0, $5mf1d.getReductionAxes)(mean.shape, x.shape);
        const tileShape = [];
        if (mean.rank === 1) {
            for(let i = 0; i < x.shape.length - 1; ++i)tileShape.push(x.shape[i]);
            tileShape.push(1);
        }
        const xMinusMean = (0, $5jGN9.sub)(x, mean);
        const dyTimesScaleValue = (0, $5hAos.mul)(dy, scaleValue);
        const oneOverSqrtVariance = (0, $6M9ry.rsqrt)((0, $6Ab5n.add)(variance, (0, $7hONX.scalar)(varianceEpsilon)));
        const minusHalfRCube = (0, $5hAos.mul)((0, $5hAos.mul)((0, $5hAos.mul)(oneOverSqrtVariance, oneOverSqrtVariance), oneOverSqrtVariance), (0, $7hONX.scalar)(-0.5));
        const derX = ()=>{
            if (mean.rank === 1) return (0, $8nMOl.reshape)((0, $5hAos.mul)((0, $5hAos.mul)(dy, (0, $dolPi.tile)((0, $8nMOl.reshape)(oneOverSqrtVariance, [
                1,
                1,
                1,
                mean.shape[0]
            ]), tileShape)), scaleValue), x.shape);
            else return (0, $8nMOl.reshape)((0, $5hAos.mul)((0, $5hAos.mul)(dy, oneOverSqrtVariance), scaleValue), x.shape);
        };
        const derMean = ()=>{
            let meanDer = (0, $5hAos.mul)((0, $5hAos.mul)(oneOverSqrtVariance, (0, $7hONX.scalar)(-1)), dyTimesScaleValue);
            if (mean.rank === 1) meanDer = (0, $fPnAL.sum)(meanDer, reductionAxes);
            return (0, $8nMOl.reshape)(meanDer, mean.shape);
        };
        const derVariance = ()=>{
            let varianceDer = (0, $5hAos.mul)((0, $5hAos.mul)(minusHalfRCube, xMinusMean), dyTimesScaleValue);
            if (mean.rank === 1) varianceDer = (0, $fPnAL.sum)(varianceDer, reductionAxes);
            return (0, $8nMOl.reshape)(varianceDer, mean.shape);
        };
        const derScale = ()=>{
            const xMinusMean2TimesRsqrt = (0, $5hAos.mul)(xMinusMean, oneOverSqrtVariance);
            let scaleDer = (0, $5hAos.mul)(dy, xMinusMean2TimesRsqrt);
            if (mean.rank === 1) scaleDer = (0, $fPnAL.sum)(scaleDer, reductionAxes);
            return (0, $8nMOl.reshape)(scaleDer, mean.shape);
        };
        const derOffset = ()=>{
            let offsetDer = dy;
            if (mean.rank === 1) offsetDer = (0, $fPnAL.sum)(offsetDer, reductionAxes);
            return (0, $8nMOl.reshape)(offsetDer, mean.shape);
        };
        return {
            x: derX,
            mean: derMean,
            variance: derVariance,
            scale: derScale,
            offset: derOffset
        };
    }
};

});

parcelRegister("YF584", function(module, exports) {

$parcel$export(module.exports, "gatherGradConfig", function () { return $0b6578aff2c59889$export$793739cdccafd2d1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $bC6Qi = parcelRequire("bC6Qi");

var $8nMOl = parcelRequire("8nMOl");

var $lq9U1 = parcelRequire("lq9U1");

var $9c2so = parcelRequire("9c2so");

var $2uE72 = parcelRequire("2uE72");

var $eOiOM = parcelRequire("eOiOM");
const $0b6578aff2c59889$export$793739cdccafd2d1 = {
    kernelName: (0, $9BGT9.GatherV2),
    inputsToSave: [
        'x',
        'indices'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, indices] = saved;
        const { axis: axis, batchDims: batchDims } = attrs;
        const parsedAxis = (0, $eOiOM.parseAxisParam)(axis, x.shape)[0];
        const derXBatch = (x, indices, dy)=>{
            return ()=>{
                const paramsShape = x.shape;
                const indicesSize = indices.size;
                const outerShape = paramsShape.slice(0, parsedAxis);
                const outerDims = outerShape.length;
                const innerShape = paramsShape.slice(axis, paramsShape.length).slice(1);
                const innerDims = innerShape.length;
                const outerAxesIndices = $0b6578aff2c59889$var$arrayRange(0, outerDims);
                const innerAxesIndices = $0b6578aff2c59889$var$arrayRange(outerDims + 1, outerDims + 1 + innerDims);
                const valuesShape = $0b6578aff2c59889$var$arrayConcat([
                    outerShape,
                    [
                        indicesSize
                    ],
                    innerShape
                ]);
                const values = (0, $8nMOl.reshape)(dy, valuesShape);
                const reshapedIndices = (0, $8nMOl.reshape)(indices, [
                    indicesSize
                ]);
                const transposeDims = $0b6578aff2c59889$var$arrayConcat([
                    [
                        outerDims
                    ],
                    outerAxesIndices,
                    innerAxesIndices
                ]);
                const valuesTranspose = (0, $9c2so.transpose)(values, transposeDims);
                let paramsGrad = (0, $2uE72.unsortedSegmentSum)(valuesTranspose, reshapedIndices, x.shape[parsedAxis]);
                const invertTransposeDims = (0, $bC6Qi.getUndoAxesPermutation)(transposeDims);
                paramsGrad = (0, $9c2so.transpose)(paramsGrad, invertTransposeDims);
                return paramsGrad;
            };
        };
        if (batchDims === 1) {
            const batchSize = x.shape[0];
            const xBatch = x.split(batchSize, 0);
            const derXBatched = ()=>{
                const stacked = (0, $lq9U1.stack)(xBatch.map((x, i)=>{
                    return derXBatch(x, indices.slice(i, 1), dy.slice(i, 1))();
                }));
                return stacked.reshape(x.shape);
            };
            return {
                x: derXBatched,
                indices: ()=>indices
            };
        } else return {
            x: derXBatch(x, indices, dy),
            indices: ()=>indices
        };
    }
};
function $0b6578aff2c59889$var$arrayRange(start, stop) {
    const result = [];
    for(let i = start; i < stop; ++i)result.push(i);
    return result;
}
function $0b6578aff2c59889$var$arrayConcat(arrays) {
    const result = [];
    for(let i = 0; i < arrays.length; ++i)for(let j = 0; j < arrays[i].length; ++j)result.push(arrays[i][j]);
    return result;
}

});

parcelRegister("9eiMB", function(module, exports) {

$parcel$export(module.exports, "greaterEqualGradConfig", function () { return $6b83fdc2769b3622$export$fba648816411e438; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $6b83fdc2769b3622$export$fba648816411e438 = {
    kernelName: (0, $9BGT9.GreaterEqual),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        return {
            a: ()=>(0, $cztsD.zerosLike)(a),
            b: ()=>(0, $cztsD.zerosLike)(b)
        };
    }
};

});

parcelRegister("alfB0", function(module, exports) {

$parcel$export(module.exports, "identityGradConfig", function () { return $7877f696800f1714$export$bddb155b34767c3a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");
const $7877f696800f1714$export$bddb155b34767c3a = {
    kernelName: (0, $9BGT9.Identity),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $fxiHg.cast)(dy, 'float32')
        };
    }
};

});

parcelRegister("dCpHR", function(module, exports) {

$parcel$export(module.exports, "isFiniteGradConfig", function () { return $9ea2c3b6dc0c42d8$export$108f33db0f535e77; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $9ea2c3b6dc0c42d8$export$108f33db0f535e77 = {
    kernelName: (0, $9BGT9.IsFinite),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("cleCk", function(module, exports) {

$parcel$export(module.exports, "isInfGradConfig", function () { return $8fc2c8e36fb65f3d$export$af7d3cc575a3d37d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $8fc2c8e36fb65f3d$export$af7d3cc575a3d37d = {
    kernelName: (0, $9BGT9.IsInf),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("feiyV", function(module, exports) {

$parcel$export(module.exports, "isNanGradConfig", function () { return $b1668fe32d074a1e$export$a2997336d9064f51; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $b1668fe32d074a1e$export$a2997336d9064f51 = {
    kernelName: (0, $9BGT9.IsNan),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("9yA2B", function(module, exports) {

$parcel$export(module.exports, "leakyReluGradConfig", function () { return $6f533f038f9094d0$export$8aba4169a7423780; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $lOlhm = parcelRequire("lOlhm");

var $5hAos = parcelRequire("5hAos");

var $3A1QZ = parcelRequire("3A1QZ");
const $6f533f038f9094d0$export$8aba4169a7423780 = {
    kernelName: (0, $9BGT9.LeakyRelu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { alpha: alpha } = attrs;
        const mask = (0, $lOlhm.greater)(x, 0);
        // Returns `gradients * (features > 0) + alpha * gradients * (features <=
        // 0)`.
        return {
            x: ()=>(0, $3A1QZ.where)(mask, dy, (0, $5hAos.mul)(dy, alpha))
        };
    }
};

});

parcelRegister("3eHQS", function(module, exports) {

$parcel$export(module.exports, "log1pGradConfig", function () { return $25b4b1f4e01ed181$export$2a0e1acd37a49488; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $6Ab5n = parcelRequire("6Ab5n");

var $dIChU = parcelRequire("dIChU");
const $25b4b1f4e01ed181$export$2a0e1acd37a49488 = {
    kernelName: (0, $9BGT9.Log1p),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $dIChU.div)(dy, (0, $6Ab5n.add)(x, 1))
        };
    }
};

});

parcelRegister("5koS4", function(module, exports) {

$parcel$export(module.exports, "logGradConfig", function () { return $3e121ce9017707cd$export$a6f98c34c79ddc6c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");
const $3e121ce9017707cd$export$a6f98c34c79ddc6c = {
    kernelName: (0, $9BGT9.Log),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $dIChU.div)(dy, (0, $fxiHg.cast)(x, 'float32'))
        };
    }
};

});

parcelRegister("1yzBF", function(module, exports) {

$parcel$export(module.exports, "logSoftmaxGradConfig", function () { return $1224961cf5cf91fe$export$556818e7703f08a6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $1lCoz = parcelRequire("1lCoz");

var $5hAos = parcelRequire("5hAos");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");
const $1224961cf5cf91fe$export$556818e7703f08a6 = {
    kernelName: (0, $9BGT9.LogSoftmax),
    inputsToSave: [],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [value] = saved;
        const { axis: axis } = attrs;
        return {
            logits: ()=>{
                const keepDims = true;
                const softmax = (0, $1lCoz.exp)(value);
                return (0, $5jGN9.sub)(dy, (0, $5hAos.mul)((0, $fPnAL.sum)(dy, axis, keepDims), softmax));
            }
        };
    }
};

});

parcelRegister("8gAYp", function(module, exports) {

$parcel$export(module.exports, "lrnGradConfig", function () { return $604c7f8395ad0a5e$export$9250622395b66a34; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5dLOG = parcelRequire("5dLOG");
const $604c7f8395ad0a5e$export$9250622395b66a34 = {
    kernelName: (0, $9BGT9.LRN),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
        return {
            x: ()=>(0, $5dLOG.localResponseNormalizationBackprop)(x, y, dy, depthRadius, bias, alpha, beta)
        };
    }
};

});
parcelRegister("5dLOG", function(module, exports) {

$parcel$export(module.exports, "localResponseNormalizationBackprop", function () { return $3cd341fcb1ff7416$export$855c82875e6b50cd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $6afhl = parcelRequire("6afhl");
function $3cd341fcb1ff7416$var$localResponseNormalizationBackprop_(x, y, dy, depthRadius = 5, bias = 1, alpha = 1, beta = 0.5) {
    const inputs = {
        x: x,
        y: y,
        dy: dy
    };
    const attrs = {
        depthRadius: depthRadius,
        bias: bias,
        alpha: alpha,
        beta: beta
    };
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.LRNGrad), inputs, attrs);
}
const $3cd341fcb1ff7416$export$855c82875e6b50cd = (0, $6afhl.op)({
    localResponseNormalizationBackprop_: $3cd341fcb1ff7416$var$localResponseNormalizationBackprop_
});

});


parcelRegister("df8gL", function(module, exports) {

$parcel$export(module.exports, "maxGradConfig", function () { return $9a43173561450d0d$export$c8c367f50d71c477; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $2ssbp = parcelRequire("2ssbp");
const $9a43173561450d0d$export$c8c367f50d71c477 = {
    kernelName: (0, $9BGT9.Max),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const maxAttrs = attrs;
        const { reductionIndices: reductionIndices } = maxAttrs;
        const x = saved[0];
        const y = saved[1];
        const origAxes = $eOiOM.parseAxisParam(reductionIndices, x.shape);
        const maxGrad = (0, $2ssbp.gradForMinAndMax)(dy, y, x, origAxes);
        return {
            x: ()=>{
                return maxGrad['x']();
            }
        };
    }
};

});
parcelRegister("2ssbp", function(module, exports) {

$parcel$export(module.exports, "gradForMinAndMax", function () { return $1ca40eda5739b2a1$export$c166528825895f87; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bC6Qi = parcelRequire("bC6Qi");

var $fxiHg = parcelRequire("fxiHg");

var $28GAP = parcelRequire("28GAP");

var $5hAos = parcelRequire("5hAos");

var $8nMOl = parcelRequire("8nMOl");
function $1ca40eda5739b2a1$export$c166528825895f87(dy, y, xOrig, origAxes) {
    if (y.rank < xOrig.rank) y = (0, $8nMOl.reshape)(y, $bC6Qi.expandShapeToKeepDim(y.shape, origAxes));
    if (dy.rank < xOrig.rank) dy = (0, $8nMOl.reshape)(dy, $bC6Qi.expandShapeToKeepDim(dy.shape, origAxes));
    return {
        x: ()=>{
            const dx = (0, $5hAos.mul)(dy, (0, $fxiHg.cast)((0, $28GAP.equal)(xOrig, y), dy.dtype));
            return dx;
        }
    };
}

});


parcelRegister("lGqDP", function(module, exports) {

$parcel$export(module.exports, "maximumGradConfig", function () { return $fc922fa6d72ab09c$export$b394285cea805997; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $kKLvn = parcelRequire("kKLvn");

var $lWf8B = parcelRequire("lWf8B");

var $5hAos = parcelRequire("5hAos");
const $fc922fa6d72ab09c$export$b394285cea805997 = {
    kernelName: (0, $9BGT9.Maximum),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const derA = ()=>(0, $5hAos.mul)(dy, (0, $fxiHg.cast)((0, $kKLvn.greaterEqual)(a, b), 'float32'));
        const derB = ()=>(0, $5hAos.mul)(dy, (0, $fxiHg.cast)((0, $lWf8B.less)(a, b), 'float32'));
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("jWnNq", function(module, exports) {

$parcel$export(module.exports, "maxPool3DGradConfig", function () { return $e845e4875e74ab67$export$5201426bb10bd5eb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $enJWh = parcelRequire("enJWh");
const $e845e4875e74ab67$export$5201426bb10bd5eb = {
    kernelName: (0, $9BGT9.MaxPool3D),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
        return {
            x: ()=>(0, $enJWh.maxPool3dGrad)(dy, x, y, filterSize, strides, pad, dimRoundingMode)
        };
    }
};

});
parcelRegister("enJWh", function(module, exports) {

$parcel$export(module.exports, "maxPool3dGrad", function () { return $a786d92f7a796652$export$aa5e236dfd3a66ef; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");

var $8nMOl = parcelRequire("8nMOl");
/**
 * Computes the backprop of a 3d max pool.
 *
 * @param dy The dy error, of rank 5 of shape
 *     [batchSize, depth, height, width, channels].
 * assumed.
 * @param input The original input image, of rank 5 or rank 4 of shape
 *     [batchSize, depth, height, width, channels].
 * @param output The original output image, of rank 5 of shape
 *     [batchSize, outDepth, outHeight, outWidth, channels].
 * @param filterSize The filter size:
 *     `[filterDepth, filterHeight, filterWidth]`.
 *     `filterSize` is a single number,
 *     then `filterDepth == filterHeight == filterWidth`.
 * @param strides The strides of the pooling:
 *     `[strideDepth, strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad A string from: 'same', 'valid'. The type of padding algorithm
 *     used in the forward prop of the op.
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $a786d92f7a796652$var$maxPool3dGrad_(dy, input, output, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $x4eLk.convertToTensor)(dy, 'dy', 'maxPool3dGrad');
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'maxPool3dGrad');
    const $output = (0, $x4eLk.convertToTensor)(output, 'output', 'maxPool3dGrad');
    let dy5D = $dy;
    let input5D = $input;
    let output5D = $output;
    let reshapedTo5D = false;
    if ($input.rank === 4) {
        reshapedTo5D = true;
        dy5D = (0, $8nMOl.reshape)($dy, [
            1,
            $dy.shape[0],
            $dy.shape[1],
            $dy.shape[2],
            $dy.shape[3]
        ]);
        input5D = (0, $8nMOl.reshape)($input, [
            1,
            $input.shape[0],
            $input.shape[1],
            $input.shape[2],
            $input.shape[3]
        ]);
        output5D = (0, $8nMOl.reshape)($output, [
            1,
            $output.shape[0],
            $output.shape[1],
            $output.shape[2],
            $output.shape[3]
        ]);
    }
    $eOiOM.assert(dy5D.rank === 5, ()=>`Error in maxPool3dGrad: dy must be rank 5 but got rank ` + `${dy5D.rank}.`);
    $eOiOM.assert(input5D.rank === 5, ()=>`Error in maxPool3dGrad: input must be rank 5 but got rank ` + `${input5D.rank}.`);
    $eOiOM.assert(output5D.rank === 5, ()=>`Error in maxPool3dGrad: output must be rank 5 but got rank ` + `${output5D.rank}.`);
    (0, $g0V2M.checkPadOnDimRoundingMode)('maxPool3dGrad', pad, dimRoundingMode);
    const inputs = {
        dy: dy5D,
        input: input5D,
        output: output5D
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    const res = (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.MaxPool3DGrad), inputs, attrs);
    if (reshapedTo5D) return (0, $8nMOl.reshape)(res, [
        res.shape[1],
        res.shape[2],
        res.shape[3],
        res.shape[4]
    ]);
    return res;
}
const $a786d92f7a796652$export$aa5e236dfd3a66ef = /* @__PURE__ */ (0, $6afhl.op)({
    maxPool3dGrad_: $a786d92f7a796652$var$maxPool3dGrad_
});

});


parcelRegister("1j9mV", function(module, exports) {

$parcel$export(module.exports, "maxPoolGradConfig", function () { return $0f3ed53bb9d01629$export$e01a7f8dbee29127; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $idQxt = parcelRequire("idQxt");
const $0f3ed53bb9d01629$export$e01a7f8dbee29127 = {
    kernelName: (0, $9BGT9.MaxPool),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x, y] = saved;
        const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
        return {
            x: ()=>(0, $idQxt.maxPoolGrad)(dy, x, y, filterSize, strides, pad)
        };
    }
};

});
parcelRegister("idQxt", function(module, exports) {

$parcel$export(module.exports, "maxPoolGrad", function () { return $d442320acc99b2c2$export$85dfd1121f049514; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");

var $x4eLk = parcelRequire("x4eLk");

var $eOiOM = parcelRequire("eOiOM");

var $g0V2M = parcelRequire("g0V2M");

var $6afhl = parcelRequire("6afhl");
/**
 * Computes the backprop of a 2D max pool.
 *
 * @param dy The dy error, of rank 4 or rank 3 of shape
 *     [batchSize, height, width, channels]. If rank 3, batch of 1 is
 * assumed.
 * @param input The original input image, of rank 4, of shape
 *     [batchSize, height, width, channels].
 * @param output The original output image, of rank 4, of shape
 *     [batchSize, outHeight, outWidth, channels].
 * @param filterSize The filter size: `[filterHeight, filterWidth]`. If
 *     `filterSize` is a single number, then `filterHeight == filterWidth`.
 * @param strides The strides of the pooling: `[strideHeight, strideWidth]`. If
 *     `strides` is a single number, then `strideHeight == strideWidth`.
 * @param pad The type of padding algorithm used in the forward prop of the op.
 *     'same', 'valid', for more info, see this guide:
 *     [https://www.tensorflow.org/api_docs/python/tf/nn/convolution](
 *          https://www.tensorflow.org/api_docs/python/tf/nn/convolution)
 * @param dimRoundingMode A string from: 'ceil', 'round', 'floor'. If none is
 *     provided, it will default to truncate.
 */ function $d442320acc99b2c2$var$maxPoolGrad_(dy, input, output, filterSize, strides, pad, dimRoundingMode) {
    const $dy = (0, $x4eLk.convertToTensor)(dy, 'dy', 'maxPoolGrad');
    const $input = (0, $x4eLk.convertToTensor)(input, 'input', 'maxPoolGrad');
    const $output = (0, $x4eLk.convertToTensor)(output, 'output', 'maxPoolGrad');
    $eOiOM.assert($input.rank === $dy.rank, ()=>`Rank of input (${$input.rank}) does not match rank of dy ` + `(${$dy.rank})`);
    $eOiOM.assert($dy.rank === 4, ()=>`Error in maxPoolGrad: dy must be rank 4 but got rank ` + `${$dy.rank}.`);
    $eOiOM.assert($input.rank === 4, ()=>`Error in maxPoolGrad: input must be rank 4 but got rank ` + `${$input.rank}.`);
    $g0V2M.checkPadOnDimRoundingMode('maxPoolGrad', pad, dimRoundingMode);
    const inputs = {
        dy: $dy,
        input: $input,
        output: $output
    };
    const attrs = {
        filterSize: filterSize,
        strides: strides,
        pad: pad,
        dimRoundingMode: dimRoundingMode
    };
    // tslint:disable-next-line: no-unnecessary-type-assertion
    return (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.MaxPoolGrad), inputs, attrs);
}
const $d442320acc99b2c2$export$85dfd1121f049514 = /* @__PURE__ */ (0, $6afhl.op)({
    maxPoolGrad_: $d442320acc99b2c2$var$maxPoolGrad_
});

});


parcelRegister("86HcU", function(module, exports) {

$parcel$export(module.exports, "meanGradConfig", function () { return $5e7066563aea2de7$export$ac394d88e62d3236; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $bC6Qi = parcelRequire("bC6Qi");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $K2k22 = parcelRequire("K2k22");

var $8nMOl = parcelRequire("8nMOl");

var $eOiOM = parcelRequire("eOiOM");
const $5e7066563aea2de7$export$ac394d88e62d3236 = {
    kernelName: (0, $9BGT9.Mean),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis } = attrs;
        const axes = $eOiOM.parseAxisParam(axis, x.shape);
        const shapes = (0, $bC6Qi.computeOutAndReduceShapes)(x.shape, axes);
        const reduceShape = shapes[1];
        const reduceSize = $eOiOM.sizeFromShape(reduceShape);
        const derX = ()=>{
            const expandedDyShape = x.shape.slice();
            axes.forEach((axis)=>{
                expandedDyShape[axis] = 1;
            });
            const expandedDy = (0, $8nMOl.reshape)(dy, expandedDyShape);
            const res = (0, $dIChU.div)((0, $5hAos.mul)(expandedDy, (0, $K2k22.ones)(x.shape, 'float32')), reduceSize);
            return res;
        };
        return {
            x: derX
        };
    }
};

});

parcelRegister("8oXFM", function(module, exports) {

$parcel$export(module.exports, "minGradConfig", function () { return $61deda6d1fa3ec5e$export$414be41faed05c5f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $eOiOM = parcelRequire("eOiOM");

var $2ssbp = parcelRequire("2ssbp");
const $61deda6d1fa3ec5e$export$414be41faed05c5f = {
    kernelName: (0, $9BGT9.Min),
    inputsToSave: [
        'x'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const minAttrs = attrs;
        const { axis: axis } = minAttrs;
        const [x, y] = saved;
        const origAxes = $eOiOM.parseAxisParam(axis, x.shape);
        const minGrad = (0, $2ssbp.gradForMinAndMax)(dy, y, x, origAxes);
        return {
            x: ()=>{
                return minGrad['x']();
            }
        };
    }
};

});

parcelRegister("gbBGR", function(module, exports) {

$parcel$export(module.exports, "minimumGradConfig", function () { return $bc8ae8f3bb70ac57$export$6c859b9b59a13286; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $lOlhm = parcelRequire("lOlhm");

var $bvcEy = parcelRequire("bvcEy");

var $5hAos = parcelRequire("5hAos");
const $bc8ae8f3bb70ac57$export$6c859b9b59a13286 = {
    kernelName: (0, $9BGT9.Minimum),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const derA = ()=>(0, $5hAos.mul)(dy, (0, $fxiHg.cast)((0, $bvcEy.lessEqual)(a, b), 'float32'));
        const derB = ()=>(0, $5hAos.mul)(dy, (0, $fxiHg.cast)((0, $lOlhm.greater)(a, b), 'float32'));
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("3zkDA", function(module, exports) {

$parcel$export(module.exports, "mirrorPadGradConfig", function () { return $2994a62da691cb4b$export$83a1d4320d554b59; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $l7afw = parcelRequire("l7afw");
const $2994a62da691cb4b$export$83a1d4320d554b59 = {
    kernelName: (0, $9BGT9.MirrorPad),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        // Pad introduces values around the original tensor, so the gradient
        // slices the original shape out of the gradient.
        const x = saved[0];
        const { paddings: paddings } = attrs;
        const begin = paddings.map((p)=>p[0]);
        return {
            x: ()=>(0, $l7afw.slice)(dy, begin, x.shape)
        };
    }
};

});

parcelRegister("iMQ1j", function(module, exports) {

$parcel$export(module.exports, "modGradConfig", function () { return $dad50fd3a05f9cd3$export$6ef350a1f32ed6e2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5mf1d = parcelRequire("5mf1d");

var $dIChU = parcelRequire("dIChU");

var $3k4XX = parcelRequire("3k4XX");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $8nMOl = parcelRequire("8nMOl");

var $fPnAL = parcelRequire("fPnAL");
const $dad50fd3a05f9cd3$export$6ef350a1f32ed6e2 = {
    kernelName: (0, $9BGT9.Mod),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $5mf1d.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const reduceAxes = (0, $5mf1d.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $8nMOl.reshape)((0, $fPnAL.sum)(dy, reduceAxes), a.shape);
            return dy;
        };
        const derB = ()=>{
            const res = (0, $5hAos.mul)(dy, (0, $jMlCE.neg)((0, $3k4XX.floor)((0, $dIChU.div)(a, b))));
            const reduceAxes = (0, $5mf1d.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) return (0, $8nMOl.reshape)((0, $fPnAL.sum)(res, reduceAxes), b.shape);
            return res;
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("7IKzh", function(module, exports) {

$parcel$export(module.exports, "multiplyGradConfig", function () { return $59f0c3e74c66c7cc$export$13098dd2211fc557; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5mf1d = parcelRequire("5mf1d");

var $fxiHg = parcelRequire("fxiHg");

var $5hAos = parcelRequire("5hAos");

var $8nMOl = parcelRequire("8nMOl");

var $fPnAL = parcelRequire("fPnAL");
const $59f0c3e74c66c7cc$export$13098dd2211fc557 = {
    kernelName: (0, $9BGT9.Multiply),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = (0, $5mf1d.assertAndGetBroadcastShape)(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $5hAos.mul)(dy, (0, $fxiHg.cast)(b, 'float32'));
            const reduceAxes = (0, $5mf1d.getReductionAxes)(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $8nMOl.reshape)((0, $fPnAL.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            const res = (0, $5hAos.mul)(dy, (0, $fxiHg.cast)(a, 'float32'));
            const reduceAxes = (0, $5mf1d.getReductionAxes)(b.shape, outShape);
            if (reduceAxes.length > 0) return (0, $8nMOl.reshape)((0, $fPnAL.sum)(res, reduceAxes), b.shape);
            return res;
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("Nhe0O", function(module, exports) {

$parcel$export(module.exports, "negGradConfig", function () { return $0941f03e92f2a78c$export$9c8adee9ba64cfc3; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $jMlCE = parcelRequire("jMlCE");
const $0941f03e92f2a78c$export$9c8adee9ba64cfc3 = {
    kernelName: (0, $9BGT9.Neg),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $jMlCE.neg)(dy)
        };
    }
};

});

parcelRegister("u0lvY", function(module, exports) {

$parcel$export(module.exports, "oneHotGradConfig", function () { return $05a3122ae58c1d70$export$fec82556b8ba1992; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $lxzgt = parcelRequire("lxzgt");
const $05a3122ae58c1d70$export$fec82556b8ba1992 = {
    kernelName: (0, $9BGT9.OneHot),
    inputsToSave: [
        'indices'
    ],
    gradFunc: (dy, saved)=>{
        const indices = saved[0];
        return {
            indices: ()=>(0, $lxzgt.zeros)(indices.shape, 'float32')
        };
    }
};

});

parcelRegister("6duc0", function(module, exports) {

$parcel$export(module.exports, "onesLikeGradConfig", function () { return $486b6097933b43ee$export$693d483aaf035f85; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $486b6097933b43ee$export$693d483aaf035f85 = {
    kernelName: (0, $9BGT9.OnesLike),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("dyR92", function(module, exports) {

$parcel$export(module.exports, "packGradConfig", function () { return $9df7acce09243ce6$export$2deaaffbc5347dbd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $3mzDh = parcelRequire("3mzDh");
const $9df7acce09243ce6$export$2deaaffbc5347dbd = {
    kernelName: (0, $9BGT9.Pack),
    saveAllInputs: true,
    gradFunc: (dy, saved, attrs)=>{
        const { axis: axis } = attrs;
        const derTensors = (0, $3mzDh.unstack)(dy, axis);
        return derTensors.map((t)=>()=>t);
    }
};

});

parcelRegister("cgUTR", function(module, exports) {

$parcel$export(module.exports, "padV2GradConfig", function () { return $8ef31dd5d698de63$export$beb610947bf972b5; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $l7afw = parcelRequire("l7afw");
const $8ef31dd5d698de63$export$beb610947bf972b5 = {
    kernelName: (0, $9BGT9.PadV2),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        // Pad introduces values around the original tensor, so the gradient
        // slices the original shape out of the gradient.
        const x = saved[0];
        const { paddings: paddings } = attrs;
        const begin = paddings.map((p)=>p[0]);
        return {
            x: ()=>(0, $l7afw.slice)(dy, begin, x.shape)
        };
    }
};

});

parcelRegister("hLoD7", function(module, exports) {

$parcel$export(module.exports, "powGradConfig", function () { return $cee9ee6e16da95db$export$2ca042d8bad66ff; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5mf1d = parcelRequire("5mf1d");

var $fxiHg = parcelRequire("fxiHg");

var $lOlhm = parcelRequire("lOlhm");

var $1gLFX = parcelRequire("1gLFX");

var $5hAos = parcelRequire("5hAos");

var $eCViQ = parcelRequire("eCViQ");

var $8nMOl = parcelRequire("8nMOl");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");

var $3A1QZ = parcelRequire("3A1QZ");

var $cztsD = parcelRequire("cztsD");
const $cee9ee6e16da95db$export$2ca042d8bad66ff = {
    kernelName: (0, $9BGT9.Pow),
    inputsToSave: [
        'a',
        'b'
    ],
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [a, b, y] = saved;
        const base = a;
        const exp = b;
        const outShape = $5mf1d.assertAndGetBroadcastShape(base.shape, exp.shape);
        const derBase = ()=>{
            const expFloat = (0, $fxiHg.cast)(exp, 'float32');
            let res = (0, $5hAos.mul)(dy, (0, $5hAos.mul)(expFloat, (0, $eCViQ.pow)(base, (0, $5jGN9.sub)(expFloat, (0, $7hONX.scalar)(1)))));
            const reduceAxes = $5mf1d.getReductionAxes(base.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
            return (0, $8nMOl.reshape)(res, base.shape);
        };
        const derExp = ()=>{
            const condition = (0, $lOlhm.greater)(base, 0);
            const logBase = (0, $3A1QZ.where)(condition, (0, $1gLFX.log)(base), (0, $cztsD.zerosLike)(base));
            let res = (0, $5hAos.mul)(dy, (0, $5hAos.mul)(y, logBase));
            const reduceAxes = $5mf1d.getReductionAxes(exp.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
            return (0, $8nMOl.reshape)(res, exp.shape);
        };
        return {
            a: derBase,
            b: derExp
        };
    }
};

});

parcelRegister("c4B8c", function(module, exports) {

$parcel$export(module.exports, "preluGradConfig", function () { return $8ca2a946361473ef$export$737d9f7a914424e7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5mf1d = parcelRequire("5mf1d");

var $lOlhm = parcelRequire("lOlhm");

var $5hAos = parcelRequire("5hAos");

var $8nMOl = parcelRequire("8nMOl");

var $fPnAL = parcelRequire("fPnAL");

var $3A1QZ = parcelRequire("3A1QZ");

var $cztsD = parcelRequire("cztsD");
const $8ca2a946361473ef$export$737d9f7a914424e7 = {
    kernelName: (0, $9BGT9.Prelu),
    inputsToSave: [
        'x',
        'alpha'
    ],
    gradFunc: (dy, saved)=>{
        const [x, alpha] = saved;
        const mask = (0, $lOlhm.greater)(x, 0);
        return {
            x: ()=>(0, $3A1QZ.where)(mask, dy, (0, $5hAos.mul)(dy, alpha)),
            alpha: ()=>{
                let res = (0, $3A1QZ.where)(mask, (0, $cztsD.zerosLike)(dy), (0, $5hAos.mul)(dy, x));
                const reduceAxes = (0, $5mf1d.getReductionAxes)(alpha.shape, dy.shape);
                if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
                return (0, $8nMOl.reshape)(res, alpha.shape);
            }
        };
    }
};

});

parcelRegister("7veHN", function(module, exports) {

$parcel$export(module.exports, "prodGradConfig", function () { return $5766d5d9fe7326e4$export$18b8f1986a9cc9fb; });
/**
 * @license
 * Copyright 2022 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dEVRx = parcelRequire("dEVRx");

var $9BGT9 = parcelRequire("9BGT9");

var $8By4p = parcelRequire("8By4p");

var $5hAos = parcelRequire("5hAos");

var $8nMOl = parcelRequire("8nMOl");

var $9c2so = parcelRequire("9c2so");
// Gradient for product operation on a single axis.
function $5766d5d9fe7326e4$var$prodGradFn_(x, dy, axis) {
    // The gradient tensor (dy) has a set of axes removed, so we create re-shaped
    // versions (of size 1) for the removed axis; this supports broadcasting over
    // those dimensions.
    const expandedYShape = x.shape.slice();
    expandedYShape[axis] = 1;
    // The actual gradient computation.
    const expandedDy = (0, $8nMOl.reshape)(dy, expandedYShape);
    const xCumProd = (0, $8By4p.cumprod)(x, axis, true, false);
    const xCumRevProd = (0, $8By4p.cumprod)(x, axis, true, true);
    const dx = (0, $5hAos.mul)(xCumProd, xCumRevProd);
    return (0, $5hAos.mul)(expandedDy, dx);
}
// Support gradients when the product is done on many axes at once.
// This done py pushing all the axes on which the product is applied into a
// single axis.
function $5766d5d9fe7326e4$var$prodsGradFn_(x, dy, axis) {
    // Move all axes for doing prod over to the end of the tensor.
    const xRank = x.shape.length;
    const finalProdAxis = xRank - axis.length;
    const xPermutation = (0, $dEVRx).getAxesPermutation(axis, xRank);
    let permutedX = x;
    if (xPermutation != null) permutedX = (0, $9c2so.transpose)(x, xPermutation);
    // Reshape all the prod dimensions into a single one, and do compute prod
    // gradients on that.
    const newShape = permutedX.shape.slice();
    const removedShape = newShape.splice(xRank - axis.length, axis.length);
    const endPartShape = removedShape.reduce((p, c)=>p * c, 1);
    newShape.push(endPartShape);
    const reshapedPermutedX = permutedX.reshape(newShape);
    let prodGrad = $5766d5d9fe7326e4$var$prodGradFn_(reshapedPermutedX, dy, finalProdAxis);
    // Undo the re-shaping now we have the dx vector, and permute back to
    // original axes order.
    prodGrad = prodGrad.reshape(permutedX.shape);
    if (xPermutation != null) {
        const undoPermutation = (0, $dEVRx).getUndoAxesPermutation(xPermutation);
        prodGrad = (0, $9c2so.transpose)(prodGrad, undoPermutation);
    }
    return prodGrad;
}
const $5766d5d9fe7326e4$export$18b8f1986a9cc9fb = {
    kernelName: (0, $9BGT9.Prod),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { axis: axis } = attrs;
        let axisArr = [];
        if (axis === undefined || axis === null) axisArr = x.shape.map((_, i)=>i);
        else if (typeof axis === 'number') axisArr = [
            axis
        ];
        else axisArr = axis;
        return {
            x: ()=>$5766d5d9fe7326e4$var$prodsGradFn_(x, dy, axisArr)
        };
    }
};

});

parcelRegister("3DZXD", function(module, exports) {

$parcel$export(module.exports, "divGradConfig", function () { return $2a7513c1c7a3c257$export$9c51f12fdbfaf1a1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5mf1d = parcelRequire("5mf1d");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $8nMOl = parcelRequire("8nMOl");

var $5MB84 = parcelRequire("5MB84");

var $fPnAL = parcelRequire("fPnAL");
const $2a7513c1c7a3c257$export$9c51f12fdbfaf1a1 = {
    kernelName: (0, $9BGT9.RealDiv),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $5mf1d.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            const res = (0, $dIChU.div)(dy, (0, $fxiHg.cast)(b, 'float32'));
            const reduceAxes = $5mf1d.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) return (0, $8nMOl.reshape)((0, $fPnAL.sum)(res, reduceAxes), a.shape);
            return res;
        };
        const derB = ()=>{
            let res = (0, $5hAos.mul)(dy, (0, $fxiHg.cast)(a, 'float32'));
            const reduceAxes = $5mf1d.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $8nMOl.reshape)((0, $fPnAL.sum)(res, reduceAxes), b.shape);
            const tmp = (0, $5MB84.square)(b);
            return (0, $jMlCE.neg)((0, $dIChU.div)(res, (0, $fxiHg.cast)(tmp, 'float32')));
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("h07Yz", function(module, exports) {

$parcel$export(module.exports, "reciprocalGradConfig", function () { return $c6089f9cbeaa8b94$export$ae80392febfc338b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $dIChU = parcelRequire("dIChU");

var $jMlCE = parcelRequire("jMlCE");

var $5MB84 = parcelRequire("5MB84");
const $c6089f9cbeaa8b94$export$ae80392febfc338b = {
    kernelName: (0, $9BGT9.Reciprocal),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $dIChU.div)(dy, (0, $jMlCE.neg)((0, $5MB84.square)(x)))
        };
    }
};

});

parcelRegister("7zlgF", function(module, exports) {

$parcel$export(module.exports, "relu6GradConfig", function () { return $582c4c9d366accd0$export$41de35156decb8c9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $bvcEy = parcelRequire("bvcEy");

var $5hAos = parcelRequire("5hAos");

var $1LynW = parcelRequire("1LynW");
const $582c4c9d366accd0$export$41de35156decb8c9 = {
    kernelName: (0, $9BGT9.Relu6),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        const mask = (0, $5hAos.mul)((0, $bvcEy.lessEqual)(x, 6), (0, $1LynW.step)(x));
        return {
            x: ()=>(0, $5hAos.mul)(dy, (0, $fxiHg.cast)(mask, 'float32'))
        };
    }
};

});

parcelRegister("5fcly", function(module, exports) {

$parcel$export(module.exports, "reluGradConfig", function () { return $3d17ee40df65f33e$export$a206627c8f00ffd0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $5hAos = parcelRequire("5hAos");

var $1LynW = parcelRequire("1LynW");
const $3d17ee40df65f33e$export$a206627c8f00ffd0 = {
    kernelName: (0, $9BGT9.Relu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)(dy, (0, $fxiHg.cast)((0, $1LynW.step)(x), 'float32'))
        };
    }
};

});

parcelRegister("6uGOz", function(module, exports) {

$parcel$export(module.exports, "reshapeGradConfig", function () { return $4ba6c17fe9ee38fe$export$24950d669898f1bd; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $8nMOl = parcelRequire("8nMOl");
const $4ba6c17fe9ee38fe$export$24950d669898f1bd = {
    kernelName: (0, $9BGT9.Reshape),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $8nMOl.reshape)(dy, x.shape)
        };
    }
};

});

parcelRegister("kOC2k", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearGradConfig", function () { return $f275fb6e5bfcc373$export$51f84ca614e84763; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");
const $f275fb6e5bfcc373$export$51f84ca614e84763 = {
    kernelName: (0, $9BGT9.ResizeBilinear),
    inputsToSave: [
        'images'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [images] = saved;
        const inputs = {
            dy: dy,
            images: images
        };
        const imagesDer = ()=>// tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ResizeBilinearGrad), inputs, attrs);
        return {
            images: imagesDer
        };
    }
};

});

parcelRegister("5Kw7u", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborGradConfig", function () { return $42fa29f245599616$export$2b08d810b5090fe1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $e6Ey6 = parcelRequire("e6Ey6");

var $9BGT9 = parcelRequire("9BGT9");
const $42fa29f245599616$export$2b08d810b5090fe1 = {
    kernelName: (0, $9BGT9.ResizeNearestNeighbor),
    inputsToSave: [
        'images'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [images] = saved;
        const inputs = {
            dy: dy,
            images: images
        };
        const imagesDer = ()=>// tslint:disable-next-line: no-unnecessary-type-assertion
            (0, $e6Ey6.ENGINE).runKernel((0, $9BGT9.ResizeNearestNeighborGrad), inputs, attrs);
        return {
            images: imagesDer
        };
    }
};

});

parcelRegister("iJsSS", function(module, exports) {

$parcel$export(module.exports, "reverseGradConfig", function () { return $da32d5bc3b6aead2$export$f990078b2a817279; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5ApPj = parcelRequire("5ApPj");

var $eOiOM = parcelRequire("eOiOM");
const $da32d5bc3b6aead2$export$f990078b2a817279 = {
    kernelName: (0, $9BGT9.Reverse),
    gradFunc: (dy, saved, attrs)=>{
        const { dims: dims } = attrs;
        const axes = (0, $eOiOM.parseAxisParam)(dims, dy.shape);
        return {
            x: ()=>(0, $5ApPj.reverse)(dy, axes)
        };
    }
};

});

parcelRegister("bMsVO", function(module, exports) {

$parcel$export(module.exports, "roundGradConfig", function () { return $893a9e90ddb3b988$export$f26d18fb6c60d7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $893a9e90ddb3b988$export$f26d18fb6c60d7 = {
    kernelName: (0, $9BGT9.Round),
    gradFunc: (dy)=>{
        // TODO(nsthorat): Let gradients be null for cases where we want to stop
        // backpropgation.
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("7Vlrw", function(module, exports) {

$parcel$export(module.exports, "rsqrtGradConfig", function () { return $5c4e7d607b71db69$export$925fbc88de33c42d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $jMlCE = parcelRequire("jMlCE");

var $eCViQ = parcelRequire("eCViQ");
const $5c4e7d607b71db69$export$925fbc88de33c42d = {
    kernelName: (0, $9BGT9.Rsqrt),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $jMlCE.neg)((0, $dIChU.div)(dy, (0, $5hAos.mul)((0, $eCViQ.pow)(x, 1.5), 2)))
        };
    }
};

});

parcelRegister("lid4f", function(module, exports) {

$parcel$export(module.exports, "selectGradConfig", function () { return $f8056a598ad97da5$export$b017819c6a2a1f57; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $4DHH8 = parcelRequire("4DHH8");

var $5hAos = parcelRequire("5hAos");

var $cztsD = parcelRequire("cztsD");
const $f8056a598ad97da5$export$b017819c6a2a1f57 = {
    kernelName: (0, $9BGT9.Select),
    inputsToSave: [
        'condition'
    ],
    gradFunc: (dy, saved)=>{
        const [condition] = saved;
        return {
            // TODO(julianoks): Return null for condition gradient
            // when backprop supports it.
            condition: ()=>(0, $fxiHg.cast)((0, $cztsD.zerosLike)(condition), 'float32'),
            t: ()=>(0, $5hAos.mul)(dy, (0, $fxiHg.cast)(condition, dy.dtype)),
            e: ()=>(0, $5hAos.mul)(dy, (0, $fxiHg.cast)((0, $4DHH8.logicalNot)(condition), dy.dtype))
        };
    }
};

});

parcelRegister("cjIa4", function(module, exports) {

$parcel$export(module.exports, "seluGradConfig", function () { return $8f7983eebb19126d$export$e1936da196fc058a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $1lCoz = parcelRequire("1lCoz");

var $lOlhm = parcelRequire("lOlhm");

var $5hAos = parcelRequire("5hAos");

var $7hONX = parcelRequire("7hONX");

var $2wK3w = parcelRequire("2wK3w");

var $3A1QZ = parcelRequire("3A1QZ");
const $8f7983eebb19126d$export$e1936da196fc058a = {
    kernelName: (0, $9BGT9.Selu),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>{
                const mask = (0, $lOlhm.greater)(x, (0, $7hONX.scalar)(0));
                const scaleAlpha = (0, $7hONX.scalar)((0, $2wK3w.SELU_SCALEALPHA));
                const scale = (0, $7hONX.scalar)((0, $2wK3w.SELU_SCALE));
                const greaterThanZeroDer = (0, $5hAos.mul)(dy, scale);
                const lessEqualZeroDer = (0, $5hAos.mul)((0, $5hAos.mul)(dy, scaleAlpha), (0, $1lCoz.exp)((0, $fxiHg.cast)(x, 'float32')));
                return (0, $3A1QZ.where)(mask, greaterThanZeroDer, lessEqualZeroDer);
            }
        };
    }
};

});

parcelRegister("5lCGJ", function(module, exports) {

$parcel$export(module.exports, "sigmoidGradConfig", function () { return $3e4cec9daa5684ac$export$a5acbf5a3558774b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5hAos = parcelRequire("5hAos");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");
const $3e4cec9daa5684ac$export$a5acbf5a3558774b = {
    kernelName: (0, $9BGT9.Sigmoid),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $5hAos.mul)(dy, (0, $5hAos.mul)(y, (0, $5jGN9.sub)((0, $7hONX.scalar)(1), y)))
        };
    }
};

});

parcelRegister("73K5P", function(module, exports) {

$parcel$export(module.exports, "signGradConfig", function () { return $523c9153b3075e9f$export$1d075457cdd4d64; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $523c9153b3075e9f$export$1d075457cdd4d64 = {
    kernelName: (0, $9BGT9.Sign),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("cW9bw", function(module, exports) {

$parcel$export(module.exports, "sinGradConfig", function () { return $96b206bb3aa9e450$export$e555a7ac73c36c03; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $71JL9 = parcelRequire("71JL9");

var $5hAos = parcelRequire("5hAos");
const $96b206bb3aa9e450$export$e555a7ac73c36c03 = {
    kernelName: (0, $9BGT9.Sin),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)((0, $71JL9.cos)((0, $fxiHg.cast)(x, 'float32')), dy)
        };
    }
};

});

parcelRegister("ewUq8", function(module, exports) {

$parcel$export(module.exports, "sinhGradConfig", function () { return $a93fd1ca115da110$export$441b7b34bae5ccc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $Riay5 = parcelRequire("Riay5");

var $5hAos = parcelRequire("5hAos");
const $a93fd1ca115da110$export$441b7b34bae5ccc = {
    kernelName: (0, $9BGT9.Sinh),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)((0, $Riay5.cosh)((0, $fxiHg.cast)(x, 'float32')), dy)
        };
    }
};

});

parcelRegister("iGSFW", function(module, exports) {

$parcel$export(module.exports, "sliceGradConfig", function () { return $d9b68faaec4a8294$export$df7b8be23ca4ae36; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $9XHOJ = parcelRequire("9XHOJ");

var $iEcDD = parcelRequire("iEcDD");
const $d9b68faaec4a8294$export$df7b8be23ca4ae36 = {
    kernelName: (0, $9BGT9.Slice),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { begin: begin, size: size } = attrs;
        const inputShape = x.shape;
        const [begin_, size_] = (0, $iEcDD.parseSliceParams)(x, begin, size);
        // Create an Nx2 padding where the first column represents how many
        // zeros are prepended (at start) for each dimension, and the second
        // column indicates how many zeros are appended (at end).
        // The number of zeros to append is the shape of the input
        // elementwise-subtracted by both the begin vector and sizes vector.
        const paddings = [];
        for(let i = 0; i < dy.rank; i++)paddings.push([
            begin_[i],
            inputShape[i] - begin_[i] - size_[i]
        ]);
        return {
            x: ()=>(0, $9XHOJ.pad)(dy, paddings)
        };
    }
};

});

parcelRegister("3snla", function(module, exports) {

$parcel$export(module.exports, "softmaxGradConfig", function () { return $2846178607c4e0dd$export$986b1eccb1e11659; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5hAos = parcelRequire("5hAos");

var $5jGN9 = parcelRequire("5jGN9");

var $fPnAL = parcelRequire("fPnAL");
const $2846178607c4e0dd$export$986b1eccb1e11659 = {
    kernelName: (0, $9BGT9.Softmax),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [y] = saved;
        const { dim: dim } = attrs;
        const keepDims = true;
        const dyTimesY = (0, $5hAos.mul)(dy, y);
        return {
            logits: ()=>(0, $5jGN9.sub)(dyTimesY, (0, $5hAos.mul)((0, $fPnAL.sum)(dyTimesY, [
                    dim
                ], keepDims), y))
        };
    }
};

});

parcelRegister("lLprS", function(module, exports) {

$parcel$export(module.exports, "softplusGradConfig", function () { return $fd81ba533defabfe$export$25385fb73a9df5f0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5hAos = parcelRequire("5hAos");

var $dzpno = parcelRequire("dzpno");
const $fd81ba533defabfe$export$25385fb73a9df5f0 = {
    kernelName: (0, $9BGT9.Softplus),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)(dy, (0, $dzpno.sigmoid)(x))
        };
    }
};

});

parcelRegister("3704a", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchNDGradConfig", function () { return $244213ae5ac406e5$export$384e163073b8980c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $7rVXz = parcelRequire("7rVXz");
const $244213ae5ac406e5$export$384e163073b8980c = {
    kernelName: (0, $9BGT9.SpaceToBatchND),
    gradFunc: (dy, saved, attrs)=>{
        const { blockShape: blockShape, paddings: paddings } = attrs;
        return {
            x: ()=>(0, $7rVXz.batchToSpaceND)(dy, blockShape, paddings)
        };
    }
};

});

parcelRegister("dYAuB", function(module, exports) {

$parcel$export(module.exports, "splitVGradConfig", function () { return $a2cd2fa37429000c$export$4ad3bd16fe45e539; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $1goxr = parcelRequire("1goxr");
const $a2cd2fa37429000c$export$4ad3bd16fe45e539 = {
    kernelName: (0, $9BGT9.SplitV),
    gradFunc: (dy, saved, attrs)=>{
        const { axis: axis } = attrs;
        return {
            x: ()=>(0, $1goxr.concat)(dy, axis)
        };
    }
};

});

parcelRegister("dFksd", function(module, exports) {

$parcel$export(module.exports, "sqrtGradConfig", function () { return $9f2ef871273d8340$export$e33c4e6eabff8df2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $dIChU = parcelRequire("dIChU");

var $5hAos = parcelRequire("5hAos");

var $g3lev = parcelRequire("g3lev");
const $9f2ef871273d8340$export$e33c4e6eabff8df2 = {
    kernelName: (0, $9BGT9.Sqrt),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $dIChU.div)(dy, (0, $5hAos.mul)((0, $g3lev.sqrt)((0, $fxiHg.cast)(x, 'float32')), 2))
        };
    }
};

});

parcelRegister("eXUdv", function(module, exports) {

$parcel$export(module.exports, "squareGradConfig", function () { return $02cfc6f303864b7b$export$3fb060af275bf525; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fxiHg = parcelRequire("fxiHg");

var $5hAos = parcelRequire("5hAos");
const $02cfc6f303864b7b$export$3fb060af275bf525 = {
    kernelName: (0, $9BGT9.Square),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $5hAos.mul)(dy, (0, $5hAos.mul)((0, $fxiHg.cast)(x, 'float32'), 2))
        };
    }
};

});

parcelRegister("4MzBX", function(module, exports) {

$parcel$export(module.exports, "squaredDifferenceGradConfig", function () { return $37b744c83e2790a0$export$ac87edeb32ba1ce1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5hAos = parcelRequire("5hAos");

var $7hONX = parcelRequire("7hONX");

var $5jGN9 = parcelRequire("5jGN9");
const $37b744c83e2790a0$export$ac87edeb32ba1ce1 = {
    kernelName: (0, $9BGT9.SquaredDifference),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const two = (0, $7hONX.scalar)(2);
        const derA = ()=>(0, $5hAos.mul)(dy, (0, $5hAos.mul)(two, (0, $5jGN9.sub)(a, b)));
        const derB = ()=>(0, $5hAos.mul)(dy, (0, $5hAos.mul)(two, (0, $5jGN9.sub)(b, a)));
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("hnzJ9", function(module, exports) {

$parcel$export(module.exports, "stepGradConfig", function () { return $ca704c579eee6cf3$export$51a8fd534d085770; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $ca704c579eee6cf3$export$51a8fd534d085770 = {
    kernelName: (0, $9BGT9.Step),
    gradFunc: (dy)=>{
        // TODO(manrajgrover): Return null for gradients when backprop supports
        // it.
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});

parcelRegister("5q0kk", function(module, exports) {

$parcel$export(module.exports, "subGradConfig", function () { return $3f1fa25ec9377878$export$7fa26ec41cd14ac; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5mf1d = parcelRequire("5mf1d");

var $jMlCE = parcelRequire("jMlCE");

var $8nMOl = parcelRequire("8nMOl");

var $fPnAL = parcelRequire("fPnAL");
const $3f1fa25ec9377878$export$7fa26ec41cd14ac = {
    kernelName: (0, $9BGT9.Sub),
    inputsToSave: [
        'a',
        'b'
    ],
    gradFunc: (dy, saved)=>{
        const [a, b] = saved;
        const outShape = $5mf1d.assertAndGetBroadcastShape(a.shape, b.shape);
        const derA = ()=>{
            let res = dy;
            const reduceAxes = $5mf1d.getReductionAxes(a.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
            return (0, $8nMOl.reshape)(res, a.shape);
        };
        const derB = ()=>{
            let res = dy;
            const reduceAxes = $5mf1d.getReductionAxes(b.shape, outShape);
            if (reduceAxes.length > 0) res = (0, $fPnAL.sum)(res, reduceAxes);
            return (0, $8nMOl.reshape)((0, $jMlCE.neg)(res), b.shape);
        };
        return {
            a: derA,
            b: derB
        };
    }
};

});

parcelRegister("ewIME", function(module, exports) {

$parcel$export(module.exports, "sumGradConfig", function () { return $a936caf54b1ee82e$export$5b5372b406109dcd; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5hAos = parcelRequire("5hAos");

var $K2k22 = parcelRequire("K2k22");

var $8nMOl = parcelRequire("8nMOl");

var $eOiOM = parcelRequire("eOiOM");
const $a936caf54b1ee82e$export$5b5372b406109dcd = {
    kernelName: (0, $9BGT9.Sum),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const expandedDyShape = x.shape.slice();
        const { axis: axis } = attrs;
        const axes = (0, $eOiOM.parseAxisParam)(axis, x.shape);
        axes.forEach((axis)=>{
            expandedDyShape[axis] = 1;
        });
        const expandedDy = (0, $8nMOl.reshape)(dy, expandedDyShape);
        const derX = (0, $5hAos.mul)(expandedDy, (0, $K2k22.ones)(x.shape, 'float32'));
        return {
            x: ()=>derX
        };
    }
};

});

parcelRegister("k3Xj4", function(module, exports) {

$parcel$export(module.exports, "tanGradConfig", function () { return $e9b217825b9e228a$export$26050e3e7c704591; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $71JL9 = parcelRequire("71JL9");

var $dIChU = parcelRequire("dIChU");

var $5MB84 = parcelRequire("5MB84");
const $e9b217825b9e228a$export$26050e3e7c704591 = {
    kernelName: (0, $9BGT9.Tan),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved)=>{
        const [x] = saved;
        return {
            x: ()=>(0, $dIChU.div)(dy, (0, $5MB84.square)((0, $71JL9.cos)(x)))
        };
    }
};

});

parcelRegister("lvjR0", function(module, exports) {

$parcel$export(module.exports, "tanhGradConfig", function () { return $fa7be4cd3374b03a$export$50a7f4d5b41706bd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $5hAos = parcelRequire("5hAos");

var $7hONX = parcelRequire("7hONX");

var $5MB84 = parcelRequire("5MB84");

var $5jGN9 = parcelRequire("5jGN9");
const $fa7be4cd3374b03a$export$50a7f4d5b41706bd = {
    kernelName: (0, $9BGT9.Tanh),
    outputsToSave: [
        true
    ],
    gradFunc: (dy, saved)=>{
        const [y] = saved;
        return {
            x: ()=>(0, $5hAos.mul)((0, $5jGN9.sub)((0, $7hONX.scalar)(1), (0, $5MB84.square)(y)), dy)
        };
    }
};

});

parcelRegister("lgVUp", function(module, exports) {

$parcel$export(module.exports, "tileGradConfig", function () { return $f7c803153018f63a$export$fd5cce480fa5176f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $6Ab5n = parcelRequire("6Ab5n");

var $l7afw = parcelRequire("l7afw");

var $cztsD = parcelRequire("cztsD");
const $f7c803153018f63a$export$fd5cce480fa5176f = {
    kernelName: (0, $9BGT9.Tile),
    inputsToSave: [
        'x'
    ],
    gradFunc: (dy, saved, attrs)=>{
        const [x] = saved;
        const { reps: reps } = attrs;
        const derX = ()=>{
            let xGrad = (0, $cztsD.zerosLike)(x);
            // TODO(cais): Maybe reduce memory footprint by avoiding repeated
            // slicing.
            if (x.rank === 1) for(let i = 0; i < reps[0]; ++i)xGrad = (0, $6Ab5n.add)(xGrad, (0, $l7afw.slice)(dy, [
                i * x.shape[0]
            ], [
                x.shape[0]
            ]));
            else if (x.rank === 2) {
                for(let i = 0; i < reps[0]; ++i)for(let j = 0; j < reps[1]; ++j)xGrad = (0, $6Ab5n.add)(xGrad, (0, $l7afw.slice)(dy, [
                    i * x.shape[0],
                    j * x.shape[1]
                ], [
                    x.shape[0],
                    x.shape[1]
                ]));
            } else if (x.rank === 3) for(let i = 0; i < reps[0]; ++i){
                for(let j = 0; j < reps[1]; ++j)for(let k = 0; k < reps[2]; ++k)xGrad = (0, $6Ab5n.add)(xGrad, (0, $l7afw.slice)(dy, [
                    i * x.shape[0],
                    j * x.shape[1],
                    k * x.shape[2]
                ], [
                    x.shape[0],
                    x.shape[1],
                    x.shape[2]
                ]));
            }
            else if (x.rank === 4) {
                for(let i = 0; i < reps[0]; ++i)for(let j = 0; j < reps[1]; ++j){
                    for(let k = 0; k < reps[2]; ++k)for(let l = 0; l < reps[3]; ++l)xGrad = (0, $6Ab5n.add)(xGrad, (0, $l7afw.slice)(dy, [
                        i * x.shape[0],
                        j * x.shape[1],
                        k * x.shape[2],
                        l * x.shape[3]
                    ], [
                        x.shape[0],
                        x.shape[1],
                        x.shape[2],
                        x.shape[3]
                    ]));
                }
            } else throw new Error(`Gradient for tile operation is not implemented for rank-` + `${x.rank} tensors yet.`);
            return xGrad;
        };
        return {
            x: derX
        };
    }
};

});

parcelRegister("7eShb", function(module, exports) {

$parcel$export(module.exports, "transposeGradConfig", function () { return $5453f15140b32240$export$c40368da30e9b1df; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $bC6Qi = parcelRequire("bC6Qi");

var $9c2so = parcelRequire("9c2so");
const $5453f15140b32240$export$c40368da30e9b1df = {
    kernelName: (0, $9BGT9.Transpose),
    gradFunc: (dy, saved, attrs)=>{
        const transposeAttrs = attrs;
        const { perm: perm } = transposeAttrs;
        const undoPerm = $bC6Qi.getUndoAxesPermutation(perm);
        return {
            x: ()=>(0, $9c2so.transpose)(dy, undoPerm)
        };
    }
};

});

parcelRegister("8DGBP", function(module, exports) {

$parcel$export(module.exports, "unpackGradConfig", function () { return $64a304857cb36383$export$e778502f377d32a9; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $lq9U1 = parcelRequire("lq9U1");
const $64a304857cb36383$export$e778502f377d32a9 = {
    kernelName: (0, $9BGT9.Unpack),
    gradFunc: (dy, saved, attrs)=>{
        const unpackAttrs = attrs;
        const { axis: axis } = unpackAttrs;
        return {
            value: ()=>(0, $lq9U1.stack)(dy, axis)
        };
    }
};

});

parcelRegister("f69uZ", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSumGradConfig", function () { return $afdec8d05bc83017$export$b02449f948377b8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $fO4kJ = parcelRequire("fO4kJ");

var $eFeE9 = parcelRequire("eFeE9");

var $kKLvn = parcelRequire("kKLvn");

var $gXTMu = parcelRequire("gXTMu");

var $jRQ3p = parcelRequire("jRQ3p");

var $K2k22 = parcelRequire("K2k22");

var $7hONX = parcelRequire("7hONX");

var $3A1QZ = parcelRequire("3A1QZ");

var $cztsD = parcelRequire("cztsD");
const $afdec8d05bc83017$export$b02449f948377b8 = {
    kernelName: (0, $9BGT9.UnsortedSegmentSum),
    inputsToSave: [
        'segmentIds'
    ],
    gradFunc: (dy, saved)=>{
        const [segmentIds] = saved;
        const derX = ()=>{
            return $afdec8d05bc83017$var$gatherDropNegatives(dy, segmentIds);
        };
        return {
            x: derX
        };
    }
};
function $afdec8d05bc83017$var$gatherDropNegatives(x, indices) {
    // Helper function for unsorted segment ops. Gathers params for
    // positive segment ids and gathers 0 for inputs with negative segment id.
    // Mirrors _GatherDropNegatives from tensorflow/python/ops/math_grad.py
    const zeroClippedIndices = (0, $jRQ3p.maximum)(indices, (0, $cztsD.zerosLike)(indices));
    const gathered = (0, $eFeE9.gather)(x, zeroClippedIndices);
    let isPositive = (0, $kKLvn.greaterEqual)(indices, (0, $7hONX.scalar)(0, 'int32'));
    const numIters = gathered.rank - isPositive.rank;
    for(let i = 0; i < numIters; ++i)isPositive = (0, $fO4kJ.expandDims)(isPositive, i + 1);
    isPositive = (0, $gXTMu.logicalAnd)(isPositive, (0, $K2k22.ones)(gathered.shape, 'bool'));
    const zeroSlice = (0, $cztsD.zerosLike)(gathered);
    return (0, $3A1QZ.where)(isPositive, gathered, zeroSlice);
}

});

parcelRegister("akKed", function(module, exports) {

$parcel$export(module.exports, "zerosLikeGradConfig", function () { return $785fa19c4d05f194$export$33fce8206ddf321b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9BGT9 = parcelRequire("9BGT9");

var $cztsD = parcelRequire("cztsD");
const $785fa19c4d05f194$export$33fce8206ddf321b = {
    kernelName: (0, $9BGT9.ZerosLike),
    gradFunc: (dy)=>{
        return {
            x: ()=>(0, $cztsD.zerosLike)(dy)
        };
    }
};

});


parcelRegister("6ly9j", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8oST8");
parcelRequire("wavfW");
parcelRequire("j3LgY");
parcelRequire("4hiiB");
parcelRequire("aCABw");
parcelRequire("hp3YZ");
parcelRequire("hWZTT");
parcelRequire("a485L");
parcelRequire("iOVxe");
parcelRequire("2PI1K");
parcelRequire("4EqSw");
parcelRequire("3pq51");
parcelRequire("bhpa6");
parcelRequire("8UlSB");
parcelRequire("7E6Ia");
parcelRequire("DEybE");
parcelRequire("aOygo");
parcelRequire("c5JU5");
parcelRequire("hzLpa");
parcelRequire("edA7U");
parcelRequire("eB5Zc");
parcelRequire("f5vKf");
parcelRequire("ltF1K");
parcelRequire("lI22O");
parcelRequire("aklqu");
parcelRequire("1hs2a");
parcelRequire("kZ6vP");
parcelRequire("9idPj");
parcelRequire("4QsJ5");
parcelRequire("hAfte");
parcelRequire("kzYmu");
parcelRequire("KIcQe");
parcelRequire("cea48");
parcelRequire("dOAsV");
parcelRequire("7CVH0");
parcelRequire("ibLxF");
parcelRequire("gRPJ5");
parcelRequire("bnnGB");
parcelRequire("c1cMu");
parcelRequire("cuFW5");
parcelRequire("a0GBD");
parcelRequire("2MOcR");
parcelRequire("rKfBc");
parcelRequire("3PwhE");
parcelRequire("59Q9s");
parcelRequire("5uhdJ");
parcelRequire("cvFxr");
parcelRequire("kSfdJ");
parcelRequire("cRTtH");
parcelRequire("hxlvT");
parcelRequire("heLKG");
parcelRequire("enc1E");
parcelRequire("9QUBK");
parcelRequire("lfz2n");
parcelRequire("9FE1G");
parcelRequire("2OVfc");
parcelRequire("fXgwf");
parcelRequire("2D46K");
parcelRequire("47UzA");
parcelRequire("fbdIM");
parcelRequire("arOBb");
parcelRequire("icsTy");
parcelRequire("2PoLI");
parcelRequire("lXWJL");
parcelRequire("6OSl9");
parcelRequire("7viSo");
parcelRequire("7gzgj");
parcelRequire("h0rsb");
parcelRequire("6mVlI");
parcelRequire("2vwzr");
parcelRequire("b5I5N");
parcelRequire("4u6GU");
parcelRequire("auZxJ");
parcelRequire("9Txqa");
parcelRequire("7yu5Y");
parcelRequire("437r9");
parcelRequire("fpVvr");
parcelRequire("13Ild");
parcelRequire("dzI8W");
parcelRequire("ixuRc");
parcelRequire("7KIdK");
parcelRequire("1tCKQ");
parcelRequire("ih4RV");
parcelRequire("brYkQ");
parcelRequire("gJ1Yl");
parcelRequire("g2bHw");
parcelRequire("HPokL");
parcelRequire("jqt5q");
parcelRequire("6JEGv");
parcelRequire("fAIvD");
parcelRequire("7MKc5");
parcelRequire("e4OF0");
parcelRequire("95eir");
parcelRequire("fvLXS");
parcelRequire("hJ2jx");
parcelRequire("1cjAs");
parcelRequire("l9UEq");
parcelRequire("kT7zI");
parcelRequire("lUx2u");
parcelRequire("9D6Y0");
parcelRequire("4nqS8");
parcelRequire("7SccM");
parcelRequire("2Cm9Y");
parcelRequire("2Q1NW");
parcelRequire("8oNbK");
parcelRequire("hyPaC");
parcelRequire("2GEP9");
parcelRequire("dUNlU");
parcelRequire("62Joi");
parcelRequire("jluEs");
parcelRequire("1cZfS");
parcelRequire("cMS41");
parcelRequire("l3hF4");
parcelRequire("5FvU1");
parcelRequire("2g6mn");
parcelRequire("lvHE9");
parcelRequire("cERYO");
parcelRequire("4Qhsi");
parcelRequire("lQaQC");
parcelRequire("9Lyh8");
parcelRequire("baGPk");
parcelRequire("2D30W");
parcelRequire("67NfU");
parcelRequire("fbn0g");
parcelRequire("aYQsx");
parcelRequire("gIvkD");
parcelRequire("29BiX");
parcelRequire("8lalu");
parcelRequire("7YQsO");
parcelRequire("hxKxP");
parcelRequire("cfzpV");
parcelRequire("1uOIn");
parcelRequire("1FoNY");
parcelRequire("cLH3m");
parcelRequire("looox");
parcelRequire("lcW2d");
parcelRequire("7dGKu");

});
parcelRegister("8oST8", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $57D4R = parcelRequire("57D4R");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.abs = function() {
    this.throwIfDisposed();
    return (0, $57D4R.abs)(this);
};

});

parcelRegister("wavfW", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $bls8e = parcelRequire("bls8e");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.acos = function() {
    this.throwIfDisposed();
    return (0, $bls8e.acos)(this);
};

});

parcelRegister("j3LgY", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $17EGz = parcelRequire("17EGz");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.acosh = function() {
    this.throwIfDisposed();
    return (0, $17EGz.acosh)(this);
};

});

parcelRegister("4hiiB", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6Ab5n = parcelRequire("6Ab5n");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.add = function(b) {
    this.throwIfDisposed();
    return (0, $6Ab5n.add)(this, b);
};

});

parcelRegister("aCABw", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $c3y0I = parcelRequire("c3y0I");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.all = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $c3y0I.all)(this, axis, keepDims);
};

});

parcelRegister("hp3YZ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dODwI = parcelRequire("dODwI");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.any = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $dODwI.any)(this, axis, keepDims);
};

});

parcelRegister("hWZTT", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kRlq3 = parcelRequire("kRlq3");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.argMax = function(axis) {
    this.throwIfDisposed();
    return (0, $kRlq3.argMax)(this, axis);
};

});

parcelRegister("a485L", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $j70Qn = parcelRequire("j70Qn");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.argMin = function(axis) {
    this.throwIfDisposed();
    return (0, $j70Qn.argMin)(this, axis);
};

});

parcelRegister("iOVxe", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");

var $eOiOM = parcelRequire("eOiOM");
/**
 * Converts a size-1 `tf.Tensor` to a `tf.Scalar`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.asScalar = function() {
    this.throwIfDisposed();
    (0, $eOiOM.assert)(this.size === 1, ()=>'The array must have only 1 element.');
    return (0, $8nMOl.reshape)(this, []);
};

});

parcelRegister("2PI1K", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $fxiHg = parcelRequire("fxiHg");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Casts a `tf.Tensor` to a specified dtype.
 *
 * @param dtype Data-type to cast the tensor to.
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.asType = function(dtype) {
    this.throwIfDisposed();
    return (0, $fxiHg.cast)(this, dtype);
};

});

parcelRegister("4EqSw", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor1D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.as1D = function() {
    this.throwIfDisposed();
    return (0, $8nMOl.reshape)(this, [
        this.size
    ]);
};

});

parcelRegister("3pq51", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor2D`.
 *
 * @param rows Number of rows in `tf.Tensor2D`.
 * @param columns Number of columns in `tf.Tensor2D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.as2D = function(rows, columns) {
    this.throwIfDisposed();
    return (0, $8nMOl.reshape)(this, [
        rows,
        columns
    ]);
};

});

parcelRegister("bhpa6", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor3D`.
 *
 * @param rows Number of rows in `tf.Tensor3D`.
 * @param columns Number of columns in `tf.Tensor3D`.
 * @param depth Depth of `tf.Tensor3D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.as3D = function(rows, columns, depth) {
    this.throwIfDisposed();
    return (0, $8nMOl.reshape)(this, [
        rows,
        columns,
        depth
    ]);
};

});

parcelRegister("8UlSB", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor4D`.
 *
 * @param rows Number of rows in `tf.Tensor4D`.
 * @param columns Number of columns in `tf.Tensor4D`.
 * @param depth Depth of `tf.Tensor4D`.
 * @param depth2 4th dimension of `tf.Tensor4D`.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.as4D = function(rows, columns, depth, depth2) {
    this.throwIfDisposed();
    return (0, $8nMOl.reshape)(this, [
        rows,
        columns,
        depth,
        depth2
    ]);
};

});

parcelRegister("7E6Ia", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Converts a `tf.Tensor` to a `tf.Tensor5D`.
 *
 * @param rows Number of rows in `tf.Tensor5D`.
 * @param columns Number of columns in `tf.Tensor5D`.
 * @param depth Depth of `tf.Tensor5D`.
 * @param depth2 4th dimension of `tf.Tensor5D`.
 * @param depth3 5th dimension of 'tf.Tensor5D'
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.as5D = function(rows, columns, depth, depth2, depth3) {
    this.throwIfDisposed();
    return (0, $8nMOl.reshape)(this, [
        rows,
        columns,
        depth,
        depth2,
        depth3
    ]);
};

});

parcelRegister("DEybE", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $lz3uk = parcelRequire("lz3uk");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.asin = function() {
    this.throwIfDisposed();
    return (0, $lz3uk.asin)(this);
};

});

parcelRegister("aOygo", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $93aRU = parcelRequire("93aRU");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.asinh = function() {
    this.throwIfDisposed();
    return (0, $93aRU.asinh)(this);
};

});

parcelRegister("c5JU5", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $5n4it = parcelRequire("5n4it");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.atan = function() {
    this.throwIfDisposed();
    return (0, $5n4it.atan)(this);
};

});

parcelRegister("hzLpa", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aLZ6G = parcelRequire("aLZ6G");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.atan2 = function(b) {
    this.throwIfDisposed();
    return (0, $aLZ6G.atan2)(this, b);
};

});

parcelRegister("edA7U", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $aCXEC = parcelRequire("aCXEC");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.atanh = function() {
    this.throwIfDisposed();
    return (0, $aCXEC.atanh)(this);
};

});

parcelRegister("eB5Zc", function(module, exports) {

var $4LG6a = parcelRequire("4LG6a");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.avgPool = function(filterSize, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $4LG6a.avgPool)(this, filterSize, strides, pad, dimRoundingMode);
};

});

parcelRegister("f5vKf", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7rVXz = parcelRequire("7rVXz");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.batchToSpaceND = function(blockShape, crops) {
    this.throwIfDisposed();
    return (0, $7rVXz.batchToSpaceND)(this, blockShape, crops);
};

});

parcelRegister("ltF1K", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dOyXd = parcelRequire("dOyXd");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.batchNorm = function(mean, variance, offset, scale, varianceEpsilon) {
    this.throwIfDisposed();
    return (0, $dOyXd.batchNorm)(this, mean, variance, offset, scale, varianceEpsilon);
};

});

parcelRegister("lI22O", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bMTXt = parcelRequire("bMTXt");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.broadcastTo = function(shape) {
    this.throwIfDisposed();
    return (0, $bMTXt.broadcastTo)(this, shape);
};

});

parcelRegister("aklqu", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $fxiHg = parcelRequire("fxiHg");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.cast = function(dtype) {
    this.throwIfDisposed();
    return (0, $fxiHg.cast)(this, dtype);
};

});

parcelRegister("1hs2a", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $6tPaz = parcelRequire("6tPaz");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.ceil = function() {
    this.throwIfDisposed();
    return (0, $6tPaz.ceil)(this);
};

});

parcelRegister("kZ6vP", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $iAQYk = parcelRequire("iAQYk");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.clipByValue = function(min, max) {
    this.throwIfDisposed();
    return (0, $iAQYk.clipByValue)(this, min, max);
};

});

parcelRegister("9idPj", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1goxr = parcelRequire("1goxr");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.concat = function(x, axis) {
    this.throwIfDisposed();
    if (x instanceof (0, $3pVUH.Tensor)) x = [
        x
    ];
    return (0, $1goxr.concat)([
        this,
        ...x
    ], axis);
};

});

parcelRegister("4QsJ5", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7vGQw = parcelRequire("7vGQw");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.conv1d = function(filter, stride, pad, dataFormat, dilation, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $7vGQw.conv1d)(this, filter, stride, pad, dataFormat, dilation, dimRoundingMode);
};

});

parcelRegister("hAfte", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gVSKY = parcelRequire("gVSKY");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.conv2dTranspose = function(filter, outputShape, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $gVSKY.conv2dTranspose)(this, filter, outputShape, strides, pad, dimRoundingMode);
};

});

parcelRegister("kzYmu", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9JluG = parcelRequire("9JluG");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.conv2d = function(filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $9JluG.conv2d)(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
};

});

parcelRegister("KIcQe", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $71JL9 = parcelRequire("71JL9");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.cos = function() {
    this.throwIfDisposed();
    return (0, $71JL9.cos)(this);
};

});

parcelRegister("cea48", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $Riay5 = parcelRequire("Riay5");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.cosh = function() {
    this.throwIfDisposed();
    return (0, $Riay5.cosh)(this);
};

});

parcelRegister("dOAsV", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8By4p = parcelRequire("8By4p");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.cumprod = function(axis, exclusive, reverse) {
    this.throwIfDisposed();
    return (0, $8By4p.cumprod)(this, axis, exclusive, reverse);
};

});

parcelRegister("7CVH0", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $ec6xM = parcelRequire("ec6xM");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.cumsum = function(axis, exclusive, reverse) {
    this.throwIfDisposed();
    return (0, $ec6xM.cumsum)(this, axis, exclusive, reverse);
};

});

parcelRegister("ibLxF", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3Gf0o = parcelRequire("3Gf0o");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.depthToSpace = function(blockSize, dataFormat) {
    this.throwIfDisposed();
    return (0, $3Gf0o.depthToSpace)(this, blockSize, dataFormat);
};

});

parcelRegister("gRPJ5", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kQqya = parcelRequire("kQqya");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.depthwiseConv2d = function(filter, strides, pad, dataFormat, dilations, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $kQqya.depthwiseConv2d)(this, filter, strides, pad, dataFormat, dilations, dimRoundingMode);
};

});

parcelRegister("bnnGB", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bP8B9 = parcelRequire("bP8B9");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.dilation2d = function(filter, strides, pad, dilations, dataFormat) {
    this.throwIfDisposed();
    return (0, $bP8B9.dilation2d)(this, filter, strides, pad, dilations, dataFormat);
};

});

parcelRegister("c1cMu", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dosDM = parcelRequire("dosDM");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.divNoNan = function(b) {
    this.throwIfDisposed();
    return (0, $dosDM.divNoNan)(this, b);
};

});

parcelRegister("cuFW5", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dIChU = parcelRequire("dIChU");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.div = function(b) {
    this.throwIfDisposed();
    return (0, $dIChU.div)(this, b);
};

});

parcelRegister("a0GBD", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3bsW7 = parcelRequire("3bsW7");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.dot = function(b) {
    this.throwIfDisposed();
    return (0, $3bsW7.dot)(this, b);
};

});

parcelRegister("2MOcR", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4YAd3 = parcelRequire("4YAd3");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.elu = function() {
    this.throwIfDisposed();
    return (0, $4YAd3.elu)(this);
};

});

parcelRegister("rKfBc", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $28GAP = parcelRequire("28GAP");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.equal = function(b) {
    this.throwIfDisposed();
    return (0, $28GAP.equal)(this, b);
};

});

parcelRegister("3PwhE", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $86rqz = parcelRequire("86rqz");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.erf = function() {
    this.throwIfDisposed();
    return (0, $86rqz.erf)(this);
};

});

parcelRegister("59Q9s", function(module, exports) {
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $chOKV = parcelRequire("chOKV");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.euclideanNorm = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $chOKV.euclideanNorm)(this, axis, keepDims);
};

});

parcelRegister("5uhdJ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $1lCoz = parcelRequire("1lCoz");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.exp = function() {
    this.throwIfDisposed();
    return (0, $1lCoz.exp)(this);
};

});

parcelRegister("cvFxr", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fO4kJ = parcelRequire("fO4kJ");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.expandDims = function(axis) {
    this.throwIfDisposed();
    return (0, $fO4kJ.expandDims)(this, axis);
};

});

parcelRegister("kSfdJ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $9rV09 = parcelRequire("9rV09");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.expm1 = function() {
    this.throwIfDisposed();
    return (0, $9rV09.expm1)(this);
};

});

parcelRegister("cRTtH", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.
parcelRequire("4I5dI");
var $acdVt = parcelRequire("acdVt");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.fft = function() {
    this.throwIfDisposed();
    return (0, $acdVt.fft)(this);
};

});

parcelRegister("hxlvT", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Flatten a Tensor to a 1D array.
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.flatten = function() {
    this.throwIfDisposed();
    return (0, $8nMOl.reshape)(this, [
        this.size
    ]);
};

});

parcelRegister("heLKG", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $3k4XX = parcelRequire("3k4XX");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.floor = function() {
    this.throwIfDisposed();
    return (0, $3k4XX.floor)(this);
};

});

parcelRegister("enc1E", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $es4Jq = parcelRequire("es4Jq");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.floorDiv = function(b) {
    this.throwIfDisposed();
    return (0, $es4Jq.floorDiv)(this, b);
};

});

parcelRegister("9QUBK", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eFeE9 = parcelRequire("eFeE9");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.gather = function(indices, axis, batchDims) {
    this.throwIfDisposed();
    return (0, $eFeE9.gather)(this, indices, axis, batchDims);
};

});

parcelRegister("lfz2n", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kKLvn = parcelRequire("kKLvn");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.greaterEqual = function(b) {
    this.throwIfDisposed();
    return (0, $kKLvn.greaterEqual)(this, b);
};

});

parcelRegister("9FE1G", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lOlhm = parcelRequire("lOlhm");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.greater = function(b) {
    this.throwIfDisposed();
    return (0, $lOlhm.greater)(this, b);
};

});

parcelRegister("2OVfc", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.
parcelRequire("4I5dI");
var $69IWw = parcelRequire("69IWw");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.ifft = function() {
    this.throwIfDisposed();
    return (0, $69IWw.ifft)(this);
};

});

parcelRegister("fXgwf", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.
parcelRequire("4I5dI");
var $mrJGu = parcelRequire("mrJGu");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.irfft = function() {
    this.throwIfDisposed();
    return (0, $mrJGu.irfft)(this);
};

});

parcelRegister("2D46K", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $gfUfq = parcelRequire("gfUfq");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.isFinite = function() {
    this.throwIfDisposed();
    return (0, $gfUfq.isFinite)(this);
};

});

parcelRegister("47UzA", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $cJ2yP = parcelRequire("cJ2yP");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.isInf = function() {
    this.throwIfDisposed();
    return (0, $cJ2yP.isInf)(this);
};

});

parcelRegister("fbdIM", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $gZu1q = parcelRequire("gZu1q");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.isNaN = function() {
    this.throwIfDisposed();
    return (0, $gZu1q.isNaN)(this);
};

});

parcelRegister("arOBb", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $kFoUG = parcelRequire("kFoUG");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.leakyRelu = function(alpha) {
    this.throwIfDisposed();
    return (0, $kFoUG.leakyRelu)(this, alpha);
};

});

parcelRegister("icsTy", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bvcEy = parcelRequire("bvcEy");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.lessEqual = function(b) {
    this.throwIfDisposed();
    return (0, $bvcEy.lessEqual)(this, b);
};

});

parcelRegister("2PoLI", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lWf8B = parcelRequire("lWf8B");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.less = function(b) {
    this.throwIfDisposed();
    return (0, $lWf8B.less)(this, b);
};

});

parcelRegister("lXWJL", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $iTgel = parcelRequire("iTgel");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.localResponseNormalization = function(depthRadius, bias, alpha, beta) {
    this.throwIfDisposed();
    return (0, $iTgel.localResponseNormalization)(this, depthRadius, bias, alpha, beta);
};

});

parcelRegister("6OSl9", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $bBSSu = parcelRequire("bBSSu");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.logSigmoid = function() {
    this.throwIfDisposed();
    return (0, $bBSSu.logSigmoid)(this);
};

});

parcelRegister("7viSo", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $2vk2B = parcelRequire("2vk2B");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.logSoftmax = function(axis) {
    this.throwIfDisposed();
    return (0, $2vk2B.logSoftmax)(this, axis);
};

});

parcelRegister("7gzgj", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1UrMu = parcelRequire("1UrMu");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.logSumExp = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $1UrMu.logSumExp)(this, axis, keepDims);
};

});

parcelRegister("h0rsb", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $1gLFX = parcelRequire("1gLFX");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.log = function() {
    this.throwIfDisposed();
    return (0, $1gLFX.log)(this);
};

});

parcelRegister("6mVlI", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $ifd1X = parcelRequire("ifd1X");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.log1p = function() {
    this.throwIfDisposed();
    return (0, $ifd1X.log1p)(this);
};

});

parcelRegister("2vwzr", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gXTMu = parcelRequire("gXTMu");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.logicalAnd = function(b) {
    this.throwIfDisposed();
    return (0, $gXTMu.logicalAnd)(this, b);
};

});

parcelRegister("b5I5N", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4DHH8 = parcelRequire("4DHH8");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.logicalNot = function() {
    this.throwIfDisposed();
    return (0, $4DHH8.logicalNot)(this);
};

});

parcelRegister("4u6GU", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jc4ZI = parcelRequire("jc4ZI");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.logicalOr = function(b) {
    this.throwIfDisposed();
    return (0, $jc4ZI.logicalOr)(this, b);
};

});

parcelRegister("auZxJ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dqaBh = parcelRequire("dqaBh");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.logicalXor = function(b) {
    this.throwIfDisposed();
    return (0, $dqaBh.logicalXor)(this, b);
};

});

parcelRegister("9Txqa", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $VLFo8 = parcelRequire("VLFo8");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.matMul = function(b, transposeA, transposeB) {
    this.throwIfDisposed();
    return (0, $VLFo8.matMul)(this, b, transposeA, transposeB);
};

});

parcelRegister("7yu5Y", function(module, exports) {

var $kHqOQ = parcelRequire("kHqOQ");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.maxPool = function(filterSize, strides, pad, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $kHqOQ.maxPool)(this, filterSize, strides, pad, dimRoundingMode);
};

});

parcelRegister("437r9", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9GR6N = parcelRequire("9GR6N");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.max = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $9GR6N.max)(this, axis, keepDims);
};

});

parcelRegister("fpVvr", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jRQ3p = parcelRequire("jRQ3p");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.maximum = function(b) {
    this.throwIfDisposed();
    return (0, $jRQ3p.maximum)(this, b);
};

});

parcelRegister("13Ild", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3TgHP = parcelRequire("3TgHP");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.mean = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $3TgHP.mean)(this, axis, keepDims);
};

});

parcelRegister("dzI8W", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1KFHq = parcelRequire("1KFHq");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.min = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $1KFHq.min)(this, axis, keepDims);
};

});

parcelRegister("ixuRc", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7es6p = parcelRequire("7es6p");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.minimum = function(b) {
    this.throwIfDisposed();
    return (0, $7es6p.minimum)(this, b);
};

});

parcelRegister("7KIdK", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $67dM3 = parcelRequire("67dM3");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.mirrorPad = function(paddings, mode) {
    this.throwIfDisposed();
    return (0, $67dM3.mirrorPad)(this, paddings, mode);
};

});

parcelRegister("1tCKQ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2na7s = parcelRequire("2na7s");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.mod = function(b) {
    this.throwIfDisposed();
    return (0, $2na7s.mod)(this, b);
};

});

parcelRegister("ih4RV", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5hAos = parcelRequire("5hAos");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.mul = function(b) {
    this.throwIfDisposed();
    return (0, $5hAos.mul)(this, b);
};

});

parcelRegister("brYkQ", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $jMlCE = parcelRequire("jMlCE");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.neg = function() {
    this.throwIfDisposed();
    return (0, $jMlCE.neg)(this);
};

});

parcelRegister("gJ1Yl", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $d5YNe = parcelRequire("d5YNe");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.norm = function(ord, axis, keepDims) {
    this.throwIfDisposed();
    return (0, $d5YNe.norm)(this, ord, axis, keepDims);
};

});

parcelRegister("g2bHw", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8BIHZ = parcelRequire("8BIHZ");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.notEqual = function(b) {
    this.throwIfDisposed();
    return (0, $8BIHZ.notEqual)(this, b);
};

});

parcelRegister("HPokL", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7k013 = parcelRequire("7k013");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.oneHot = function(depth, onValue = 1, offValue = 0) {
    this.throwIfDisposed();
    return (0, $7k013.oneHot)(this, depth, onValue, offValue);
};

});

parcelRegister("jqt5q", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $6zg0w = parcelRequire("6zg0w");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.onesLike = function() {
    this.throwIfDisposed();
    return (0, $6zg0w.onesLike)(this);
};

});

parcelRegister("6JEGv", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9XHOJ = parcelRequire("9XHOJ");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.pad = function(paddings, constantValue) {
    this.throwIfDisposed();
    return (0, $9XHOJ.pad)(this, paddings, constantValue);
};

});

parcelRegister("fAIvD", function(module, exports) {

var $3igQ1 = parcelRequire("3igQ1");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.pool = function(windowShape, poolingType, padding, dilationRate, strides, dimRoundingMode) {
    this.throwIfDisposed();
    return (0, $3igQ1.pool)(this, windowShape, poolingType, padding, dilationRate, strides, dimRoundingMode);
};

});

parcelRegister("7MKc5", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $eCViQ = parcelRequire("eCViQ");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.pow = function(exp) {
    this.throwIfDisposed();
    return (0, $eCViQ.pow)(this, exp);
};

});

parcelRegister("e4OF0", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8b5dq = parcelRequire("8b5dq");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.prelu = function(alpha) {
    this.throwIfDisposed();
    return (0, $8b5dq.prelu)(this, alpha);
};

});

parcelRegister("95eir", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $b2Mw2 = parcelRequire("b2Mw2");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.prod = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $b2Mw2.prod)(this, axis, keepDims);
};

});

parcelRegister("fvLXS", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $1Lp6R = parcelRequire("1Lp6R");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.reciprocal = function() {
    this.throwIfDisposed();
    return (0, $1Lp6R.reciprocal)(this);
};

});

parcelRegister("hJ2jx", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $aQaR3 = parcelRequire("aQaR3");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.relu = function() {
    this.throwIfDisposed();
    return (0, $aQaR3.relu)(this);
};

});

parcelRegister("1cjAs", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $4zQqN = parcelRequire("4zQqN");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.relu6 = function() {
    this.throwIfDisposed();
    return (0, $4zQqN.relu6)(this);
};

});

parcelRegister("l9UEq", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Reshapes the tensor into the shape of the provided tensor.
 *
 * @param x The tensor of required shape.
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.reshapeAs = function(x) {
    this.throwIfDisposed();
    return (0, $8nMOl.reshape)(this, x.shape);
};

});

parcelRegister("kT7zI", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8nMOl = parcelRequire("8nMOl");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.reshape = function(shape) {
    this.throwIfDisposed();
    return (0, $8nMOl.reshape)(this, shape);
};

});

parcelRegister("lUx2u", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9biDE = parcelRequire("9biDE");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.resizeBilinear = function(newShape2D, alignCorners, halfPixelCenters) {
    this.throwIfDisposed();
    return (0, $9biDE.resizeBilinear)(this, newShape2D, alignCorners, halfPixelCenters);
};

});

parcelRegister("9D6Y0", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3dpoM = parcelRequire("3dpoM");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.resizeNearestNeighbor = function(newShape2D, alignCorners, halfFloatCenters) {
    this.throwIfDisposed();
    return (0, $3dpoM.resizeNearestNeighbor)(this, newShape2D, alignCorners, halfFloatCenters);
};

});

parcelRegister("4nqS8", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5ApPj = parcelRequire("5ApPj");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.reverse = function(axis) {
    this.throwIfDisposed();
    return (0, $5ApPj.reverse)(this, axis);
};

});

parcelRegister("7SccM", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.
parcelRequire("4I5dI");
var $22B8v = parcelRequire("22B8v");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.rfft = function() {
    this.throwIfDisposed();
    return (0, $22B8v.rfft)(this);
};

});

parcelRegister("2Cm9Y", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $eo7jM = parcelRequire("eo7jM");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.round = function() {
    this.throwIfDisposed();
    return (0, $eo7jM.round)(this);
};

});

parcelRegister("2Q1NW", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $6M9ry = parcelRequire("6M9ry");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.rsqrt = function() {
    this.throwIfDisposed();
    return (0, $6M9ry.rsqrt)(this);
};

});

parcelRegister("8oNbK", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $6DicT = parcelRequire("6DicT");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.selu = function() {
    this.throwIfDisposed();
    return (0, $6DicT.selu)(this);
};

});

parcelRegister("hyPaC", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2ICVg = parcelRequire("2ICVg");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.separableConv2d = function(depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat) {
    this.throwIfDisposed();
    return (0, $2ICVg.separableConv2d)(this, depthwiseFilter, pointwiseFilter, strides, pad, dilation, dataFormat);
};

});

parcelRegister("2GEP9", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $dzpno = parcelRequire("dzpno");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.sigmoid = function() {
    this.throwIfDisposed();
    return (0, $dzpno.sigmoid)(this);
};

});

parcelRegister("dUNlU", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $gMq2C = parcelRequire("gMq2C");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.sign = function() {
    this.throwIfDisposed();
    return (0, $gMq2C.sign)(this);
};

});

parcelRegister("62Joi", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $6zQIj = parcelRequire("6zQIj");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.sin = function() {
    this.throwIfDisposed();
    return (0, $6zQIj.sin)(this);
};

});

parcelRegister("jluEs", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $fbZFd = parcelRequire("fbZFd");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.sinh = function() {
    this.throwIfDisposed();
    return (0, $fbZFd.sinh)(this);
};

});

parcelRegister("1cZfS", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $l7afw = parcelRequire("l7afw");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.slice = function(begin, size) {
    this.throwIfDisposed();
    return (0, $l7afw.slice)(this, begin, size);
};

});

parcelRegister("cMS41", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $2J1JW = parcelRequire("2J1JW");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.softmax = function(dim) {
    this.throwIfDisposed();
    return (0, $2J1JW.softmax)(this, dim);
};

});

parcelRegister("l3hF4", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $11Nx5 = parcelRequire("11Nx5");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.softplus = function() {
    this.throwIfDisposed();
    return (0, $11Nx5.softplus)(this);
};

});

parcelRegister("5FvU1", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9l6gk = parcelRequire("9l6gk");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.spaceToBatchND = function(blockShape, paddings) {
    this.throwIfDisposed();
    return (0, $9l6gk.spaceToBatchND)(this, blockShape, paddings);
};

});

parcelRegister("2g6mn", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $crriC = parcelRequire("crriC");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.split = function(numOrSizeSplits, axis) {
    this.throwIfDisposed();
    return (0, $crriC.split)(this, numOrSizeSplits, axis);
};

});

parcelRegister("lvHE9", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $g3lev = parcelRequire("g3lev");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.sqrt = function() {
    this.throwIfDisposed();
    return (0, $g3lev.sqrt)(this);
};

});

parcelRegister("cERYO", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $5MB84 = parcelRequire("5MB84");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.square = function() {
    this.throwIfDisposed();
    return (0, $5MB84.square)(this);
};

});

parcelRegister("4Qhsi", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fqiRx = parcelRequire("fqiRx");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.squaredDifference = function(b) {
    this.throwIfDisposed();
    return (0, $fqiRx.squaredDifference)(this, b);
};

});

parcelRegister("lQaQC", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gP42y = parcelRequire("gP42y");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.squeeze = function(axis) {
    this.throwIfDisposed();
    return (0, $gP42y.squeeze)(this, axis);
};

});

parcelRegister("9Lyh8", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $lq9U1 = parcelRequire("lq9U1");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.stack = function(x, axis) {
    this.throwIfDisposed();
    const tensorsToBeStacked = x instanceof (0, $3pVUH.Tensor) ? [
        this,
        x
    ] : [
        this,
        ...x
    ];
    return (0, $lq9U1.stack)(tensorsToBeStacked, axis);
};

});

parcelRegister("baGPk", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $1LynW = parcelRequire("1LynW");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.step = function(alpha) {
    this.throwIfDisposed();
    return (0, $1LynW.step)(this, alpha);
};

});

parcelRegister("2D30W", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $6Ygvg = parcelRequire("6Ygvg");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.stridedSlice = function(begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask) {
    this.throwIfDisposed();
    return (0, $6Ygvg.stridedSlice)(this, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
};

});

parcelRegister("67NfU", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5jGN9 = parcelRequire("5jGN9");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.sub = function(b) {
    this.throwIfDisposed();
    return (0, $5jGN9.sub)(this, b);
};

});

parcelRegister("fbn0g", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $fPnAL = parcelRequire("fPnAL");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.sum = function(axis, keepDims) {
    this.throwIfDisposed();
    return (0, $fPnAL.sum)(this, axis, keepDims);
};

});

parcelRegister("aYQsx", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $dEDAz = parcelRequire("dEDAz");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.tan = function() {
    this.throwIfDisposed();
    return (0, $dEDAz.tan)(this);
};

});

parcelRegister("gIvkD", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $cJm46 = parcelRequire("cJm46");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.tanh = function() {
    this.throwIfDisposed();
    return (0, $cJm46.tanh)(this);
};

});

parcelRegister("29BiX", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $dolPi = parcelRequire("dolPi");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.tile = function(reps) {
    this.throwIfDisposed();
    return (0, $dolPi.tile)(this, reps);
};

});

parcelRegister("8lalu", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $fxiHg = parcelRequire("fxiHg");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Casts the array to type `bool`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.toBool = function() {
    this.throwIfDisposed();
    return (0, $fxiHg.cast)(this, 'bool');
};

});

parcelRegister("7YQsO", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $fxiHg = parcelRequire("fxiHg");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Casts the array to type `float32`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.toFloat = function() {
    this.throwIfDisposed();
    return (0, $fxiHg.cast)(this, 'float32');
};

});

parcelRegister("hxKxP", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $fxiHg = parcelRequire("fxiHg");

var $3pVUH = parcelRequire("3pVUH");
/**
 * Casts the array to type `int32`
 *
 * @doc {heading: 'Tensors', subheading: 'Classes'}
 */ (0, $3pVUH.getGlobalTensorClass)().prototype.toInt = function() {
    this.throwIfDisposed();
    return (0, $fxiHg.cast)(this, 'int32');
};

});

parcelRegister("cfzpV", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $7vZaO = parcelRequire("7vZaO");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.topk = function(k, sorted) {
    this.throwIfDisposed();
    return (0, $7vZaO.topk)(this, k, sorted);
};

});

parcelRegister("1uOIn", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $9c2so = parcelRequire("9c2so");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.transpose = function(perm) {
    this.throwIfDisposed();
    return (0, $9c2so.transpose)(this, perm);
};

});

parcelRegister("1FoNY", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $f7XaS = parcelRequire("f7XaS");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.unique = function(axis) {
    this.throwIfDisposed();
    return (0, $f7XaS.unique)(this, axis);
};

});

parcelRegister("cLH3m", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $2uE72 = parcelRequire("2uE72");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.unsortedSegmentSum = function(segmentIds, numSegments) {
    this.throwIfDisposed();
    return (0, $2uE72.unsortedSegmentSum)(this, segmentIds, numSegments);
};

});

parcelRegister("looox", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3mzDh = parcelRequire("3mzDh");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.unstack = function(axis) {
    this.throwIfDisposed();
    return (0, $3mzDh.unstack)(this, axis);
};

});

parcelRegister("lcW2d", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $3A1QZ = parcelRequire("3A1QZ");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.where = function(condition, x) {
    this.throwIfDisposed();
    return (0, $3A1QZ.where)(condition, this, x);
};

});

parcelRegister("7dGKu", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // TODO update import path once op is modularized.

var $cztsD = parcelRequire("cztsD");

var $3pVUH = parcelRequire("3pVUH");
(0, $3pVUH.getGlobalTensorClass)().prototype.zerosLike = function() {
    this.throwIfDisposed();
    return (0, $cztsD.zerosLike)(this);
};

});


parcelRegister("dCUqA", function(module, exports) {

$parcel$export(module.exports, "loadLayersModel", function () { return (parcelRequire("1dKdw")).loadLayersModel; });
$parcel$export(module.exports, "sequential", function () { return (parcelRequire("hCaeT")).sequential; });
$parcel$export(module.exports, "version_layers", function () { return (parcelRequire("kw5Gh")).version; });
$parcel$export(module.exports, "layers", function () { return (parcelRequire("9W3RU")); });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("uO4W5");
parcelRequire("8AHkS");
parcelRequire("icUUP");

var $7wepf = parcelRequire("7wepf");

var $3Gcyp = parcelRequire("3Gcyp");

var $9W3RU = parcelRequire("9W3RU");

var $60Zce = parcelRequire("60Zce");

var $dqJqc = parcelRequire("dqJqc");

var $2pJRH = parcelRequire("2pJRH");

var $801Oz = parcelRequire("801Oz");

var $fRyjC = parcelRequire("fRyjC");

var $jWpeh = parcelRequire("jWpeh");

var $czFC2 = parcelRequire("czFC2");
parcelRequire("hCaeT");
var $1dKdw = parcelRequire("1dKdw");
var $hCaeT = parcelRequire("hCaeT");

var $2QjI9 = parcelRequire("2QjI9");

var $1dKdw = parcelRequire("1dKdw");

var $pKVrB = parcelRequire("pKVrB");

var $kw5Gh = parcelRequire("kw5Gh");

});
parcelRegister("uO4W5", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");

var $iyRtt = parcelRequire("iyRtt");
const $05c9a6068358a700$export$83401e34d5e11bf4 = (0, $tdutJ.env)();
/** The max number of entries for the caches of layers' topological sort. */ $05c9a6068358a700$export$83401e34d5e11bf4.registerFlag('TOPOLOGICAL_SORT_CACHE_MAX_ENTRIES', ()=>100, (0, $iyRtt.updateCacheMaxEntries));

});
parcelRegister("iyRtt", function(module, exports) {

$parcel$export(module.exports, "FeedDict", function () { return $d834e1de87b668b6$export$1f554ac52b4b6917; });
$parcel$export(module.exports, "updateCacheMaxEntries", function () { return $d834e1de87b668b6$export$2dc27e9d70f80ac7; });
$parcel$export(module.exports, "execute", function () { return $d834e1de87b668b6$export$51396ec711da548b; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Executor: Evaluates SymbolicTensor based on feeds.
 */ parcelRequire("8AHkS");
var $fxiHg = parcelRequire("fxiHg");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $kubuc = parcelRequire("kubuc");

var $blw3h = parcelRequire("blw3h");

var $jYx5u = parcelRequire("jYx5u");

var $lusky = parcelRequire("lusky");

var $jWpeh = parcelRequire("jWpeh");
/**
 * Helper function to check the dtype and shape compatibility of a feed value.
 */ function $d834e1de87b668b6$var$assertFeedCompatibility(key, val) {
    // Check dtype compatibility.
    if (key.dtype == null || key.dtype === val.dtype) //  a.  If types match, return val tensor as is.
    return val;
    try {
        //  b. Attempt to convert to expected type.
        return (0, $fxiHg.cast)(val, key.dtype);
    } catch (err) {
        //  c. If conversion fails, return helpful error.
        throw new (0, $kubuc.ValueError)(`The dtype of the feed (${val.dtype}) can not be cast to the dtype ` + `of the key '${key.name}' (${key.dtype}).`);
    }
}
class $d834e1de87b668b6$export$1f554ac52b4b6917 {
    /**
     * Constructor, optionally does copy-construction.
     * @param feeds An Array of `Feed`s, or another `FeedDict`, in which case
     *   copy-construction will be performed.
     */ constructor(feeds){
        this.id2Value = {};
        this.id2Mask = {};
        this.name2Id = {};
        if (feeds instanceof $d834e1de87b668b6$export$1f554ac52b4b6917) for(const id in feeds.id2Value){
            this.id2Value[id] = feeds.id2Value[id];
            if (id in feeds.id2Mask) this.id2Mask[id] = feeds.id2Mask[id];
        }
        else {
            if (feeds == null) return;
            for (const feed of feeds)this.add(feed.key, feed.value);
        }
    }
    /**
     * Add a key-value pair to the FeedDict.
     *
     * @param key The key of the feed.
     * @param value The value of the tensor feed.
     * @param mask The value of the mask feed (optional).
     * @returns This `FeedDict`.
     * @throws ValueError: If the key `SymbolicTensor` already exists in the
     *   `FeedDict`.
     */ add(key, value, mask) {
        if (this.id2Value[key.id] == null) {
            this.id2Value[key.id] = $d834e1de87b668b6$var$assertFeedCompatibility(key, value);
            this.name2Id[key.name] = key.id;
            if (mask != null) this.id2Mask[key.id] = mask;
        } else throw new (0, $kubuc.ValueError)(`Duplicate key: name=${key.name}, id=${key.id}`);
        return this;
    }
    /**
     * Add a Feed to the FeedDict.
     * @param feed The new `Feed` to add.
     * @returns This `FeedDict`.
     */ addFeed(feed) {
        this.add(feed.key, feed.value);
    }
    /**
     * Probe whether a key already exists in the FeedDict.
     * @param key
     */ hasKey(key) {
        return this.id2Value[key.id] != null;
    }
    /**
     * Get all the SymbolicTensor available in this FeedDict.
     */ names() {
        return Object.keys(this.name2Id);
    }
    /**
     * Get the feed value for given key.
     * @param key The SymbolicTensor, or its name (as a string), of which the
     *     value is sought.
     * @returns If `key` exists, the corresponding feed value.
     * @throws ValueError: If `key` does not exist in this `FeedDict`.
     */ getValue(key) {
        if (key instanceof (0, $jWpeh.SymbolicTensor)) {
            if (this.id2Value[key.id] == null) throw new (0, $kubuc.ValueError)(`Nonexistent key: ${key.name}`);
            else return this.id2Value[key.id];
        } else {
            const id = this.name2Id[key];
            if (id == null) throw new (0, $kubuc.ValueError)(`Feed dict has no SymbolicTensor name: ${key}`);
            return this.id2Value[id];
        }
    }
    /**
     * Get the feed mask for given key.
     * @param key The SymbolicTensor, or its name (as a string), of which the
     *     value is sought.
     * @returns If `key` exists, the corresponding feed mask.
     * @throws ValueError: If `key` does not exist in this `FeedDict`.
     */ getMask(key) {
        if (key instanceof (0, $jWpeh.SymbolicTensor)) {
            if (this.id2Value[key.id] == null) throw new (0, $kubuc.ValueError)(`Nonexistent key: ${key.name}`);
            else return this.id2Mask[key.id];
        } else {
            const id = this.name2Id[key];
            if (id == null) throw new (0, $kubuc.ValueError)(`Feed dict has no SymbolicTensor name: ${key}`);
            return this.id2Mask[id];
        }
    }
    /** Dispose all mask Tensors held by this object. */ disposeMasks() {
        if (this.id2Mask != null) (0, $d7Nxs.dispose)(this.id2Mask);
    }
}
const $d834e1de87b668b6$export$44a630df56e5b996 = new (0, $blw3h.LruCache)();
const $d834e1de87b668b6$export$f790425d308658ea = new (0, $blw3h.LruCache)();
function $d834e1de87b668b6$export$2dc27e9d70f80ac7(maxEntries) {
    if ($d834e1de87b668b6$export$44a630df56e5b996 != null) $d834e1de87b668b6$export$44a630df56e5b996.setMaxEntries(maxEntries);
    if ($d834e1de87b668b6$export$f790425d308658ea != null) $d834e1de87b668b6$export$f790425d308658ea.setMaxEntries(maxEntries);
}
function $d834e1de87b668b6$export$51396ec711da548b(fetches, feedDict, kwargs, probe) {
    const training = kwargs == null ? false : kwargs['training'];
    const arrayFetches = Array.isArray(fetches);
    const fetchArray = arrayFetches ? fetches : [
        fetches
    ];
    const outputNames = fetchArray.map((t)=>t.name);
    const finalOutputs = [];
    const feedNames = feedDict.names();
    for (const outputName of outputNames)if (feedNames.indexOf(outputName) !== -1) finalOutputs.push(feedDict.getValue(outputName));
    else finalOutputs.push(null);
    if (probe != null) {
        // For optional probing of memory footprint during execution.
        probe.maxNumTensors = -Infinity;
        probe.minNumTensors = Infinity;
    }
    // Check cache.
    const fetchAndFeedKey = outputNames.join(',') + '|' + feedDict.names().sort().join(',');
    let sorted = $d834e1de87b668b6$export$44a630df56e5b996.get(fetchAndFeedKey);
    let recipientCounts;
    if (sorted == null) {
        // Cache doesn't contain the desired combination of fetches. Compute
        // topological sort for the combination for the first time.
        const out = $d834e1de87b668b6$var$getTopologicalSortAndRecipientCounts(fetchArray, feedDict);
        sorted = out.sorted;
        recipientCounts = out.recipientCounts;
        // Store results in cache for future use.
        $d834e1de87b668b6$export$44a630df56e5b996.put(fetchAndFeedKey, sorted);
        $d834e1de87b668b6$export$f790425d308658ea.put(fetchAndFeedKey, recipientCounts);
    }
    recipientCounts = {};
    if (!training) Object.assign(recipientCounts, $d834e1de87b668b6$export$f790425d308658ea.get(fetchAndFeedKey));
    const internalFeedDict = new $d834e1de87b668b6$export$1f554ac52b4b6917(feedDict);
    // Start iterative execution on the topologically-sorted SymbolicTensors.
    for(let i = 0; i < sorted.length; ++i){
        if (probe != null) {
            // For optional probing of memory usage during execution.
            const numTensors = (0, $d7Nxs.memory)().numTensors;
            if (numTensors > probe.maxNumTensors) probe.maxNumTensors = numTensors;
            if (numTensors < probe.minNumTensors) probe.minNumTensors = numTensors;
        }
        const symbolic = sorted[i];
        const srcLayer = symbolic.sourceLayer;
        if (srcLayer instanceof (0, $lusky.InputLayer)) continue;
        const inputValues = [];
        const inputMasks = [];
        const tensorsToDispose = [];
        let maskExists = false;
        for (const input of symbolic.inputs){
            const value = internalFeedDict.getValue(input);
            const mask = internalFeedDict.getMask(input);
            inputValues.push(value);
            inputMasks.push(mask);
            if (mask != null) maskExists = true;
            if (!training) {
                recipientCounts[input.name]--;
                if (recipientCounts[input.name] === 0 && !feedDict.hasKey(input) && outputNames.indexOf(input.name) === -1 && !value.isDisposed && input.sourceLayer.stateful !== true) tensorsToDispose.push(value);
            }
        }
        if (maskExists) {
            kwargs = kwargs || {};
            kwargs['mask'] = inputMasks[0];
        }
        const outputTensors = (0, $jYx5u.toList)(srcLayer.apply(inputValues, kwargs));
        let outputMask = null;
        if (srcLayer.supportsMasking) outputMask = srcLayer.computeMask(inputValues, inputMasks);
        const layerOutputs = $d834e1de87b668b6$var$getNodeOutputs(symbolic);
        const outputSymbolicTensors = Array.isArray(layerOutputs) ? layerOutputs : [
            layerOutputs
        ];
        for(let i = 0; i < outputSymbolicTensors.length; ++i){
            if (!internalFeedDict.hasKey(outputSymbolicTensors[i])) internalFeedDict.add(outputSymbolicTensors[i], outputTensors[i], Array.isArray(outputMask) ? outputMask[0] : outputMask);
            const index = outputNames.indexOf(outputSymbolicTensors[i].name);
            if (index !== -1) finalOutputs[index] = outputTensors[i];
        }
        if (!training) // Clean up Tensors that are no longer needed.
        (0, $d7Nxs.dispose)(tensorsToDispose);
    }
    // NOTE(cais): Unlike intermediate tensors, we don't discard mask
    // tensors as we go, because these tensors are sometimes passed over a
    // series of mutliple layers, i.e., not obeying the immediate input
    // relations in the graph. If this becomes a memory-usage concern,
    // we can improve this in the future.
    internalFeedDict.disposeMasks();
    return arrayFetches ? finalOutputs : finalOutputs[0];
}
/**
 * Sort the `SymbolicTensor`s topologically, for an array of fetches.
 *
 * This function calls getTopologicalSortAndRecipientCountsForOneFetch and
 * merges their results.
 *
 * @param fetch The array of fetches requested. Must be a non-empty array.
 * @param feedDict The dictionary of fed values.
 * @returns sorted: Topologically-sorted array of SymbolicTensors.
 *   recipientCounts: Recipient counts for all SymbolicTensors in `sorted`.
 */ function $d834e1de87b668b6$var$getTopologicalSortAndRecipientCounts(fetches, feedDict) {
    (0, $lBDHD).assert(fetches != null && fetches.length > 0, ()=>`Expected at least one fetch, got none`);
    let finalSorted = [];
    let finalRecipientMap = {};
    if (fetches.length === 1) {
        // Special-casing 1 fetch for efficiency.
        const out = $d834e1de87b668b6$export$a8bd8d591d4e6bd9(fetches[0], feedDict);
        finalSorted = out.sorted;
        finalRecipientMap = out.recipientMap;
    } else {
        const visited = new Set();
        for (const fetch of fetches){
            const { sorted: sorted, recipientMap: recipientMap } = $d834e1de87b668b6$export$a8bd8d591d4e6bd9(fetch, feedDict);
            // Merge sorted SymbolicTensor Arrays.
            for (const symbolicTensor of sorted)if (!visited.has(symbolicTensor.name)) {
                finalSorted.push(symbolicTensor);
                visited.add(symbolicTensor.name);
            }
            // Merge recipient maps.
            for(const name in recipientMap){
                if (finalRecipientMap[name] == null) finalRecipientMap[name] = new Set();
                recipientMap[name].forEach((recipient)=>finalRecipientMap[name].add(recipient));
            }
        }
    }
    return {
        sorted: finalSorted,
        recipientCounts: $d834e1de87b668b6$var$recipientMap2Counts(finalRecipientMap)
    };
}
function $d834e1de87b668b6$var$recipientMap2Counts(recipientMap) {
    const recipientCounts = {};
    for(const name in recipientMap)recipientCounts[name] = recipientMap[name].size;
    return recipientCounts;
}
function $d834e1de87b668b6$export$a8bd8d591d4e6bd9(fetch, feedDict) {
    const visited = new Set();
    const sorted = [];
    const recipientMap = {};
    // Put keys of the feedDict into visited first, so they don't have to be
    // walked. This is needed in case where there are feeds for intermediate
    // SymbolicTensors of the graph.
    for (const key of feedDict.names())visited.add(key);
    const stack = [];
    const marks = [];
    // Initial population of stack and marks.
    stack.push(fetch);
    while(stack.length > 0){
        const top = stack[stack.length - 1];
        if (visited.has(top.name)) {
            stack.pop();
            continue;
        }
        const topIsMarked = marks[marks.length - 1] === stack.length - 1;
        if (top.inputs.length === 0 || topIsMarked) {
            // Input SymbolicTensor or all children have been visited.
            stack.pop();
            sorted.push(top);
            visited.add(top.name);
            if (topIsMarked) marks.pop();
        } else {
            // A non-input SymbolicTensor whose upstream SymbolicTensors haven't
            // been visited yet. Push them onto the stack.
            marks.push(stack.length - 1);
            for (const input of top.inputs){
                // Increment the recipient count. Note that this needs to happen
                // regardless of whether the SymbolicTensor has been visited before.
                if (recipientMap[input.name] == null) recipientMap[input.name] = new Set();
                recipientMap[input.name].add(top.name);
                if (visited.has(input.name)) continue; // Avoid repeated visits to the same SymbolicTensor.
                stack.push(input);
            }
        }
    }
    return {
        sorted: sorted,
        recipientMap: recipientMap
    };
}
/**
 * Get the symbolic output tensors of the node to which a given fetch belongs.
 * @param fetch The fetched symbolic tensor.
 * @returns The Array of symbolic tensors output by the node to which `fetch`
 *   belongs.
 */ function $d834e1de87b668b6$var$getNodeOutputs(fetch) {
    let layerOutputs;
    if (fetch.sourceLayer.inboundNodes.length === 1) layerOutputs = fetch.sourceLayer.output;
    else {
        let nodeIndex = null;
        for(let i = 0; i < fetch.sourceLayer.inboundNodes.length; ++i){
            for (const outputTensor of fetch.sourceLayer.inboundNodes[i].outputTensors)if (outputTensor.id === fetch.id) {
                nodeIndex = i;
                break;
            }
        }
        layerOutputs = fetch.sourceLayer.getOutputAt(nodeIndex);
    }
    return layerOutputs;
}

});
parcelRegister("kubuc", function(module, exports) {

$parcel$export(module.exports, "AttributeError", function () { return $ee9f84e55ff42e5d$export$3869bf0637a5d0ff; });
$parcel$export(module.exports, "RuntimeError", function () { return $ee9f84e55ff42e5d$export$4a24a86bdbcf02bb; });
$parcel$export(module.exports, "ValueError", function () { return $ee9f84e55ff42e5d$export$54d4c18dc78a26d4; });
$parcel$export(module.exports, "NotImplementedError", function () { return $ee9f84e55ff42e5d$export$e162153238934121; });
$parcel$export(module.exports, "AssertionError", function () { return $ee9f84e55ff42e5d$export$7750cdfb4db2c3d; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Explicit error types.
 *
 * See the following link for more information about why the code includes
 * calls to setPrototypeOf:
 *
 * https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
 */ // tslint:enable
/**
 * Equivalent of Python's AttributeError.
 */ class $ee9f84e55ff42e5d$export$3869bf0637a5d0ff extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $ee9f84e55ff42e5d$export$3869bf0637a5d0ff.prototype);
    }
}
class $ee9f84e55ff42e5d$export$4a24a86bdbcf02bb extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $ee9f84e55ff42e5d$export$4a24a86bdbcf02bb.prototype);
    }
}
class $ee9f84e55ff42e5d$export$54d4c18dc78a26d4 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $ee9f84e55ff42e5d$export$54d4c18dc78a26d4.prototype);
    }
}
class $ee9f84e55ff42e5d$export$e162153238934121 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $ee9f84e55ff42e5d$export$e162153238934121.prototype);
    }
}
class $ee9f84e55ff42e5d$export$7750cdfb4db2c3d extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $ee9f84e55ff42e5d$export$7750cdfb4db2c3d.prototype);
    }
}
class $ee9f84e55ff42e5d$export$efa5eacb1304c464 extends Error {
    constructor(message){
        super(message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, $ee9f84e55ff42e5d$export$efa5eacb1304c464.prototype);
    }
}

});

parcelRegister("blw3h", function(module, exports) {

$parcel$export(module.exports, "LruCache", function () { return $842a84b7db5de04d$export$ec63a4108685a0aa; });
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * LruCache: A mapping from the String to T. If the number of the entries is
 * exceeding the `maxEntries`, the LruCache will delete the least recently
 * used entry.
 */ class $842a84b7db5de04d$export$ec63a4108685a0aa {
    constructor(maxEntries){
        this.maxEntries = maxEntries || 100;
        this.cache = new Map();
    }
    /**
     * Get the entry for the key and mark it as used recently.
     */ get(key) {
        let entry;
        if (this.cache.has(key)) {
            entry = this.cache.get(key);
            this.cache.delete(key);
            this.cache.set(key, entry);
        }
        return entry;
    }
    /**
     * Put the entry into the cache. If the key already existed, mark the key as
     * used recently.
     */ put(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxEntries) {
            const keyToDelete = this.cache.keys().next().value;
            this.cache.delete(keyToDelete);
        }
        this.cache.set(key, value);
    }
    /**
     * Get the MaxEntries of the cache.
     */ getMaxEntries() {
        return this.maxEntries;
    }
    /**
     * Set the MaxEntries of the cache. If the maxEntries is decreased, reduce
     * entries in the cache.
     */ setMaxEntries(maxEntries) {
        if (maxEntries < 0) throw new Error(`The maxEntries of LRU caches must be at least 0, but got ${maxEntries}.`);
        if (this.maxEntries > maxEntries) for(let i = 0; i < this.maxEntries - maxEntries; i++){
            const keyToDelete = this.cache.keys().next().value;
            this.cache.delete(keyToDelete);
        }
        this.maxEntries = maxEntries;
    }
}

});

parcelRegister("jYx5u", function(module, exports) {

$parcel$export(module.exports, "pyListRepeat", function () { return $e8ad496a1e463ad0$export$f24d1f1e6cb42785; });
$parcel$export(module.exports, "assert", function () { return $e8ad496a1e463ad0$export$a7a9523472993e97; });
$parcel$export(module.exports, "count", function () { return $e8ad496a1e463ad0$export$85b9a36db797e02b; });
$parcel$export(module.exports, "singletonOrArray", function () { return $e8ad496a1e463ad0$export$8366660815493a21; });
$parcel$export(module.exports, "toList", function () { return $e8ad496a1e463ad0$export$effcdbd76139450; });
$parcel$export(module.exports, "toSnakeCase", function () { return $e8ad496a1e463ad0$export$cc8b315fc368b20a; });
$parcel$export(module.exports, "toCamelCase", function () { return $e8ad496a1e463ad0$export$86f54f62aa7a7514; });
$parcel$export(module.exports, "serializeKerasObject", function () { return $e8ad496a1e463ad0$export$78f846918d17a884; });
$parcel$export(module.exports, "deserializeKerasObject", function () { return $e8ad496a1e463ad0$export$c33061eb381c60f9; });
$parcel$export(module.exports, "reverseNumberCompare", function () { return $e8ad496a1e463ad0$export$964007bb9b7e1f75; });
$parcel$export(module.exports, "unique", function () { return $e8ad496a1e463ad0$export$7a5d5c156e7dc406; });
$parcel$export(module.exports, "isObjectEmpty", function () { return $e8ad496a1e463ad0$export$23cfe696632d10f4; });
$parcel$export(module.exports, "checkStringTypeUnionValue", function () { return $e8ad496a1e463ad0$export$f49e87e6cde0274b; });
$parcel$export(module.exports, "checkArrayTypeAndLength", function () { return $e8ad496a1e463ad0$export$9c1c2eaf0ddbb1d3; });
$parcel$export(module.exports, "assertPositiveInteger", function () { return $e8ad496a1e463ad0$export$7ac3b6580cbed983; });
$parcel$export(module.exports, "debounce", function () { return $e8ad496a1e463ad0$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "mapActivationToFusedKernel", function () { return $e8ad496a1e463ad0$export$aa3e0e68e0c6329f; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: utils/generic_utils.py */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $kubuc = parcelRequire("kubuc");
function $e8ad496a1e463ad0$export$f24d1f1e6cb42785(value, numValues) {
    if (Array.isArray(value)) {
        // tslint:disable-next-line:no-any
        let newArray = [];
        for(let i = 0; i < numValues; i++)newArray = newArray.concat(value);
        return newArray;
    } else {
        const newArray = new Array(numValues);
        newArray.fill(value);
        return newArray;
    }
}
function $e8ad496a1e463ad0$export$a7a9523472993e97(val, message) {
    if (!val) throw new (0, $kubuc.AssertionError)(message);
}
function $e8ad496a1e463ad0$export$85b9a36db797e02b(array, refernce) {
    let counter = 0;
    for (const item of array)if (item === refernce) counter++;
    return counter;
}
function $e8ad496a1e463ad0$export$8366660815493a21(xs) {
    if (xs.length === 1) return xs[0];
    return xs;
}
function $e8ad496a1e463ad0$export$effcdbd76139450(x) {
    if (Array.isArray(x)) return x;
    return [
        x
    ];
}
function $e8ad496a1e463ad0$export$a75d309e098886ab(objs) {
    const objectList = $e8ad496a1e463ad0$export$effcdbd76139450(objs);
    let retVal = '';
    for (const obj of objectList){
        if (obj.id == null) throw new (0, $kubuc.ValueError)(`Object ${obj} passed to objectListUid without an id`);
        if (retVal !== '') retVal = retVal + ', ';
        retVal = `${retVal}${Math.abs(obj.id)}`;
    }
    return retVal;
}
function $e8ad496a1e463ad0$export$cc8b315fc368b20a(name) {
    const intermediate = name.replace(/(.)([A-Z][a-z0-9]+)/g, '$1_$2');
    const insecure = intermediate.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
    /*
     If the class is private the name starts with "_" which is not secure
     for creating scopes. We prefix the name with "private" in this case.
     */ if (insecure[0] !== '_') return insecure;
    return 'private' + insecure;
}
function $e8ad496a1e463ad0$export$86f54f62aa7a7514(identifier) {
    // quick return for empty string or single character strings
    if (identifier.length <= 1) return identifier;
    // Check for the underscore indicating snake_case
    if (identifier.indexOf('_') === -1) return identifier;
    return identifier.replace(/[_]+(\w|$)/g, (m, p1)=>p1.toUpperCase());
}
// tslint:disable-next-line:no-any
let $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS = {};
function $e8ad496a1e463ad0$export$78f846918d17a884(instance) {
    if (instance === null || instance === undefined) return null;
    const dict = {};
    dict['className'] = instance.getClassName();
    dict['config'] = instance.getConfig();
    return dict;
}
/**
 * Replace ndarray-style scalar objects in serialization objects with numbers.
 *
 * Background: In some versions of tf.keras, certain scalar values in the HDF5
 * model save file can be serialized as: `{'type': 'ndarray', 'value': num}`,
 * where in `num` is a plain number. This method converts such serialization
 * to a `number`.
 *
 * @param config The keras-format serialization object to be processed
 *   (in place).
 */ function $e8ad496a1e463ad0$var$convertNDArrayScalarsInConfig(config) {
    if (config == null || typeof config !== 'object') return;
    else if (Array.isArray(config)) config.forEach((configItem)=>$e8ad496a1e463ad0$var$convertNDArrayScalarsInConfig(configItem));
    else {
        const fields = Object.keys(config);
        for (const field of fields){
            const value = config[field];
            if (value != null && typeof value === 'object') {
                if (!Array.isArray(value) && value['type'] === 'ndarray' && typeof value['value'] === 'number') config[field] = value['value'];
                else $e8ad496a1e463ad0$var$convertNDArrayScalarsInConfig(value);
            }
        }
    }
}
function $e8ad496a1e463ad0$export$c33061eb381c60f9(identifier, moduleObjects = {}, customObjects = {}, printableModuleName = 'object', fastWeightInit = false) {
    // tslint:enable
    if (typeof identifier === 'string') {
        const functionName = identifier;
        let fn;
        if (functionName in customObjects) fn = customObjects[functionName];
        else if (functionName in $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS) fn = $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS[functionName];
        else {
            fn = moduleObjects[functionName];
            if (fn == null) throw new (0, $kubuc.ValueError)(`Unknown ${printableModuleName}: ${identifier}. ` + `This may be due to one of the following reasons:\n` + `1. The ${printableModuleName} is defined in Python, in which ` + `case it needs to be ported to TensorFlow.js or your JavaScript ` + `code.\n` + `2. The custom ${printableModuleName} is defined in JavaScript, ` + `but is not registered properly with ` + `tf.serialization.registerClass().`);
        }
        return fn;
    } else {
        // In this case we are dealing with a Keras config dictionary.
        const config = identifier;
        if (config['className'] == null || config['config'] == null) throw new (0, $kubuc.ValueError)(`${printableModuleName}: Improper config format: ` + `${JSON.stringify(config)}.\n` + `'className' and 'config' must set.`);
        const className = config['className'];
        let cls, fromConfig;
        if (className in customObjects) [cls, fromConfig] = customObjects[className];
        else if (className in $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS) [cls, fromConfig] = $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS['className'];
        else if (className in moduleObjects) [cls, fromConfig] = moduleObjects[className];
        if (cls == null) throw new (0, $kubuc.ValueError)(`Unknown ${printableModuleName}: ${className}. ` + `This may be due to one of the following reasons:\n` + `1. The ${printableModuleName} is defined in Python, in which ` + `case it needs to be ported to TensorFlow.js or your JavaScript ` + `code.\n` + `2. The custom ${printableModuleName} is defined in JavaScript, ` + `but is not registered properly with ` + `tf.serialization.registerClass().`);
        if (fromConfig != null) {
            // Porting notes: Instead of checking to see whether fromConfig accepts
            // customObjects, we create a customObjects dictionary and tack it on to
            // config['config'] as config['config'].customObjects. Objects can use it,
            // if they want.
            // tslint:disable-next-line:no-any
            const customObjectsCombined = {};
            for (const key of Object.keys($e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS))customObjectsCombined[key] = $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS[key];
            for (const key of Object.keys(customObjects))customObjectsCombined[key] = customObjects[key];
            // Add the customObjects to config
            const nestedConfig = config['config'];
            nestedConfig['customObjects'] = customObjectsCombined;
            const backupCustomObjects = Object.assign({}, $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS);
            for (const key of Object.keys(customObjects))$e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS[key] = customObjects[key];
            $e8ad496a1e463ad0$var$convertNDArrayScalarsInConfig(config['config']);
            const returnObj = fromConfig(cls, config['config'], customObjects, fastWeightInit);
            $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS = Object.assign({}, backupCustomObjects);
            return returnObj;
        } else {
            // Then `cls` may be a function returning a class.
            // In this case by convention `config` holds
            // the kwargs of the function.
            const backupCustomObjects = Object.assign({}, $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS);
            for (const key of Object.keys(customObjects))$e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS[key] = customObjects[key];
            // In python this is **config['config'], for tfjs-layers we require
            // classes that use this fall-through construction method to take
            // a config interface that mimics the expansion of named parameters.
            const returnObj = new cls(config['config']);
            $e8ad496a1e463ad0$var$_GLOBAL_CUSTOM_OBJECTS = Object.assign({}, backupCustomObjects);
            return returnObj;
        }
    }
}
function $e8ad496a1e463ad0$export$d40c4ae552b5068b(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function $e8ad496a1e463ad0$export$964007bb9b7e1f75(a, b) {
    return -1 * $e8ad496a1e463ad0$export$d40c4ae552b5068b(a, b);
}
function $e8ad496a1e463ad0$export$1502380f22ccb6a5(dtype) {
    switch(dtype){
        case 'float32':
            return 'float32';
        default:
            throw new (0, $kubuc.ValueError)(`Invalid dtype: ${dtype}`);
    }
}
function $e8ad496a1e463ad0$export$cc4775daf8d91b53(xs, ys) {
    if (xs == null || ys == null) return xs === ys;
    if (xs.length !== ys.length) return false;
    for(let i = 0; i < xs.length; ++i){
        if (xs[i] !== ys[i]) return false;
    }
    return true;
}
function $e8ad496a1e463ad0$export$7a5d5c156e7dc406(xs) {
    if (xs == null) return xs;
    const out = [];
    // TODO(cais): Maybe improve performance by sorting.
    for (const x of xs)if (out.indexOf(x) === -1) out.push(x);
    return out;
}
function $e8ad496a1e463ad0$export$23cfe696632d10f4(obj) {
    if (obj == null) throw new (0, $kubuc.ValueError)(`Invalid value in obj: ${JSON.stringify(obj)}`);
    for(const key in obj){
        if (obj.hasOwnProperty(key)) return false;
    }
    return true;
}
function $e8ad496a1e463ad0$export$f49e87e6cde0274b(values, label, value) {
    if (value == null) return;
    if (values.indexOf(value) < 0) throw new (0, $kubuc.ValueError)(`${value} is not a valid ${label}.  Valid values are ${values} or null/undefined.`);
}
function $e8ad496a1e463ad0$export$9c1c2eaf0ddbb1d3(x, expectedType, minLength = 0, maxLength = Infinity) {
    $e8ad496a1e463ad0$export$a7a9523472993e97(minLength >= 0);
    $e8ad496a1e463ad0$export$a7a9523472993e97(maxLength >= minLength);
    return Array.isArray(x) && x.length >= minLength && x.length <= maxLength && x.every((e)=>typeof e === expectedType);
}
function $e8ad496a1e463ad0$export$7ac3b6580cbed983(value, name) {
    if (Array.isArray(value)) {
        (0, $lBDHD).assert(value.length > 0, ()=>`${name} is unexpectedly an empty array.`);
        value.forEach((v, i)=>$e8ad496a1e463ad0$export$7ac3b6580cbed983(v, `element ${i + 1} of ${name}`));
    } else (0, $lBDHD).assert(Number.isInteger(value) && value > 0, ()=>`Expected ${name} to be a positive integer, but got ` + `${$e8ad496a1e463ad0$export$7a0c59ae8d81831f(value)}.`);
}
function $e8ad496a1e463ad0$export$7a0c59ae8d81831f(value) {
    if (value === null) return 'null';
    else if (Array.isArray(value)) return '[' + value.map((v)=>$e8ad496a1e463ad0$export$7a0c59ae8d81831f(v)).join(',') + ']';
    else if (typeof value === 'string') return `"${value}"`;
    else return `${value}`;
}
function $e8ad496a1e463ad0$export$61fc7d43ac8f84b0(f, waitMs, nowFunc) {
    let lastTime = nowFunc != null ? nowFunc() : (0, $lBDHD).now();
    let lastResult;
    const f2 = (...args)=>{
        const now = nowFunc != null ? nowFunc() : (0, $lBDHD).now();
        if (now - lastTime < waitMs) return lastResult;
        lastTime = now;
        lastResult = f(...args);
        return lastResult;
    };
    return f2;
}
function $e8ad496a1e463ad0$export$aa3e0e68e0c6329f(activationName) {
    if (activationName === 'relu') return 'relu';
    if (activationName === 'linear') return 'linear';
    if (activationName === 'elu') return 'elu';
    return null;
}
function $e8ad496a1e463ad0$export$a670de672a83f477(...arrayOfValues) {
    $e8ad496a1e463ad0$export$a7a9523472993e97(arrayOfValues.length > 0, 'arrayOfValues is empty');
    for (const values of arrayOfValues){
        $e8ad496a1e463ad0$export$a7a9523472993e97(Array.isArray(values), 'one of the values is not an array');
        $e8ad496a1e463ad0$export$a7a9523472993e97(values.length > 0, 'one of the values is empty');
    }
    return arrayOfValues.reduce((products, values)=>{
        if (products.length === 0) return values.map((value)=>[
                value
            ]);
        return values.map((value)=>{
            return products.map((prevValue)=>[
                    ...prevValue,
                    value
                ]);
        }).reduce((flattenedProduct, unflattenedProduct)=>{
            return flattenedProduct.concat(unflattenedProduct);
        }, []);
    }, []);
}

});

parcelRegister("lusky", function(module, exports) {

$parcel$export(module.exports, "InputLayer", function () { return $fa526027869c2c53$export$191123fdb608c9b4; });
$parcel$export(module.exports, "Input", function () { return $fa526027869c2c53$export$f5b8910cec6cf069; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $ki3lz = parcelRequire("ki3lz");

var $cExd6 = parcelRequire("cExd6");

var $kubuc = parcelRequire("kubuc");

var $jWpeh = parcelRequire("jWpeh");
class $fa526027869c2c53$export$191123fdb608c9b4 extends (0, $jWpeh.Layer) {
    constructor(args){
        super({
            dtype: args.dtype,
            name: args.name != null ? args.name : (0, $cExd6.getUid)('input').toString()
        });
        // Normalize config.batchSize and config.sparse
        if (args.batchSize == null) args.batchSize = null;
        if (args.sparse == null) args.sparse = false;
        this.trainable = false;
        this.built = true;
        this.sparse = args.sparse;
        if (args.inputShape != null && args.batchInputShape != null) throw new (0, $kubuc.ValueError)("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");
        let batchInputShape = args.batchInputShape;
        if (batchInputShape == null) {
            if (args.inputShape == null) throw new (0, $kubuc.ValueError)("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");
            else batchInputShape = [
                args.batchSize
            ].concat(args.inputShape);
        } else {
            // TODO(michaelterry): Backport to PyKeras
            if (args.batchSize != null) throw new (0, $kubuc.ValueError)("Cannot specify batchSize if batchInputShape is specified when creating an InputLayer.");
        }
        const dtype = args.dtype || 'float32';
        this.batchInputShape = batchInputShape;
        this.dtype = dtype;
        // TODO(michaelterry): Backport this to PyKeras?
        this.inputSpec = [
            {
                shape: batchInputShape
            }
        ];
        const inputTensor = new (0, $jWpeh.SymbolicTensor)(this.dtype, this.batchInputShape, this, [], {}, this.name);
        inputTensor.nodeIndex = 0;
        inputTensor.tensorIndex = 0;
        // Create an input node to add to this.outboundNode.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new (0, $jWpeh.Node)({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: [
                inputTensor
            ],
            outputTensors: [
                inputTensor
            ],
            inputMasks: [
                null
            ],
            outputMasks: [
                null
            ],
            inputShapes: [
                batchInputShape
            ],
            outputShapes: [
                batchInputShape
            ]
        });
    }
    apply(inputs, kwargs) {
        throw new (0, $kubuc.ValueError)('Cannot pass any input to an ' + `InputLayer's apply() method. InputLayer name: ${this.name}`);
    }
    dispose() {
        // dispose() for InputLayer is overridden as no-op.
        return {
            refCountAfterDispose: this._refCount,
            numDisposedVariables: 0
        };
    }
    getConfig() {
        return {
            batchInputShape: this.batchInputShape,
            dtype: this.dtype,
            sparse: this.sparse,
            name: this.name
        };
    }
}
/** @nocollapse */ $fa526027869c2c53$export$191123fdb608c9b4.className = 'InputLayer';
(0, $ki3lz).registerClass($fa526027869c2c53$export$191123fdb608c9b4);
function $fa526027869c2c53$export$f5b8910cec6cf069(config) {
    if (config.batchShape == null && config.shape == null) throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");
    if (config.batchShape != null && config.shape != null) // TODO(michaelterry): Backport to PyKeras.
    throw new (0, $kubuc.ValueError)("Please provide either a `shape` or `batchShape` argument to Input, but not both.");
    let batchShape = config.batchShape;
    if (config.shape != null && batchShape == null) batchShape = [
        null
    ].concat(config.shape);
    let dtype = config.dtype;
    if (dtype == null) dtype = 'float32';
    const inputLayer = new $fa526027869c2c53$export$191123fdb608c9b4({
        batchInputShape: batchShape,
        name: config.name,
        dtype: dtype,
        sparse: config.sparse
    });
    const outputs = inputLayer.inboundNodes[0].outputTensors;
    return outputs[0];
}

});
parcelRegister("cExd6", function(module, exports) {

$parcel$export(module.exports, "getNextUniqueTensorId", function () { return $9362fb5b4f0b1732$export$b7ad53ecc0eccaf; });
$parcel$export(module.exports, "getUid", function () { return $9362fb5b4f0b1732$export$5e82334337e0f204; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Utilities related to persistent state in the backend.
 */ /**
 * An ID to track `tf.SymbolicTensor`s and derived classes.
 * Required in different places in engine/topology.ts to identify unique
 * tensors.
 */ let $9362fb5b4f0b1732$var$_nextUniqueTensorId = 0;
function $9362fb5b4f0b1732$export$b7ad53ecc0eccaf() {
    return $9362fb5b4f0b1732$var$_nextUniqueTensorId++;
}
const $9362fb5b4f0b1732$var$_uidPrefixes = {};
function $9362fb5b4f0b1732$export$5e82334337e0f204(prefix = '') {
    if (!(prefix in $9362fb5b4f0b1732$var$_uidPrefixes)) $9362fb5b4f0b1732$var$_uidPrefixes[prefix] = 0;
    $9362fb5b4f0b1732$var$_uidPrefixes[prefix] += 1;
    return prefix + $9362fb5b4f0b1732$var$_uidPrefixes[prefix].toString();
}

});

parcelRegister("jWpeh", function(module, exports) {

$parcel$export(module.exports, "InputSpec", function () { return $e8470124cada40d0$export$7705ee67def9d40a; });
$parcel$export(module.exports, "SymbolicTensor", function () { return $e8470124cada40d0$export$c6d6977640680568; });
$parcel$export(module.exports, "Node", function () { return $e8470124cada40d0$export$85c928794f8d04d4; });
$parcel$export(module.exports, "Layer", function () { return $e8470124cada40d0$export$936d0764594b6eb3; });
$parcel$export(module.exports, "getSourceInputs", function () { return $e8470124cada40d0$export$6d61b4ed0b6fb596; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/engine/topology.py */ parcelRequire("8AHkS");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $cExd6 = parcelRequire("cExd6");

var $1Xyaa = parcelRequire("1Xyaa");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $jYx5u = parcelRequire("jYx5u");

var $bMNfZ = parcelRequire("bMNfZ");

var $7iQkf = parcelRequire("7iQkf");

var $pKVrB = parcelRequire("pKVrB");
class $e8470124cada40d0$export$7705ee67def9d40a {
    constructor(args){
        this.dtype = args.dtype;
        this.shape = args.shape;
        /*
          TODO(michaelterry): Could throw error if ndim and shape are both defined
            (then backport).
        */ if (args.shape != null) this.ndim = args.shape.length;
        else this.ndim = args.ndim;
        this.maxNDim = args.maxNDim;
        this.minNDim = args.minNDim;
        this.axes = args.axes || {};
    }
}
class $e8470124cada40d0$export$c6d6977640680568 {
    /**
     *
     * @param dtype
     * @param shape
     * @param sourceLayer The Layer that produced this symbolic tensor.
     * @param inputs The inputs passed to sourceLayer's __call__() method.
     * @param nodeIndex
     * @param tensorIndex
     * @param callArgs The keyword arguments passed to the __call__() method.
     * @param name
     * @param outputTensorIndex The index of this tensor in the list of outputs
     *   returned by apply().
     */ constructor(dtype, shape, sourceLayer, inputs, callArgs, name, outputTensorIndex){
        this.dtype = dtype;
        this.shape = shape;
        this.sourceLayer = sourceLayer;
        this.inputs = inputs;
        this.callArgs = callArgs;
        this.outputTensorIndex = outputTensorIndex;
        this.id = (0, $cExd6.getNextUniqueTensorId)();
        if (name != null) {
            this.originalName = (0, $1Xyaa.getScopedTensorName)(name);
            this.name = (0, $1Xyaa.getUniqueTensorName)(this.originalName);
        }
        this.rank = shape.length;
    }
}
let $e8470124cada40d0$var$_nextNodeID = 0;
class $e8470124cada40d0$export$85c928794f8d04d4 {
    constructor(args, // TODO(michaelterry): Define actual type for this.
    callArgs){
        this.callArgs = callArgs;
        this.id = $e8470124cada40d0$var$_nextNodeID++;
        /*
          Layer instance (NOT a list).
          this is the layer that takes a list of input tensors
          and turns them into a list of output tensors.
          the current node will be added to
          the inboundNodes of outboundLayer.
        */ this.outboundLayer = args.outboundLayer;
        /*
            The following 3 properties describe where
            the input tensors come from: which layers,
            and for each layer, which node and which
            tensor output of each node.
        */ // List of layer instances.
        this.inboundLayers = args.inboundLayers;
        // List of integers, 1:1 mapping with inboundLayers.
        this.nodeIndices = args.nodeIndices;
        // List of integers, 1:1 mapping with inboundLayers.
        this.tensorIndices = args.tensorIndices;
        /*
            Following 2 properties:
            tensor inputs and outputs of outboundLayer.
        */ // List of tensors. 1:1 mapping with inboundLayers.
        this.inputTensors = args.inputTensors;
        // List of tensors, created by outboundLayer.call().
        this.outputTensors = args.outputTensors;
        /*
            Following 2 properties: input and output masks.
            List of tensors, 1:1 mapping with inputTensor.
        */ this.inputMasks = args.inputMasks;
        // List of tensors, created by outboundLayer.computeMask().
        this.outputMasks = args.outputMasks;
        // Following 2 properties: input and output shapes.
        // List of shape tuples, shapes of inputTensors.
        this.inputShapes = args.inputShapes;
        // List of shape tuples, shapes of outputTensors.
        this.outputShapes = args.outputShapes;
        // Add nodes to all layers involved.
        for (const layer of args.inboundLayers)if (layer != null) layer.outboundNodes.push(this);
        args.outboundLayer.inboundNodes.push(this);
    }
    getConfig() {
        const inboundNames = [];
        for (const layer of this.inboundLayers)if (layer != null) inboundNames.push(layer.name);
        else inboundNames.push(null);
        return {
            outboundLayer: this.outboundLayer ? this.outboundLayer.name : null,
            inboundLayers: inboundNames,
            nodeIndices: this.nodeIndices,
            tensorIndices: this.tensorIndices
        };
    }
}
let $e8470124cada40d0$var$_nextLayerID = 0;
class $e8470124cada40d0$export$936d0764594b6eb3 extends (0, $ki3lz).Serializable {
    constructor(args = {}){
        super();
        this._callHook = null;
        this._addedWeightNames = [];
        // Porting Notes: PyKeras does not have this property in this base Layer
        //   class. Instead lets Layer subclass set it dynamically and checks the
        //   value with `hasattr`. In tfjs-layers, we let this be a member of this
        //   base class.
        this._stateful = false;
        this.id = $e8470124cada40d0$var$_nextLayerID++;
        this.activityRegularizer = null;
        this.inputSpec = null;
        this.supportsMasking = false;
        // These properties will be set upon call of this.build()
        this._trainableWeights = [];
        this._nonTrainableWeights = [];
        this._losses = [];
        this._updates = [];
        this._built = false;
        /*
          These lists will be filled via successive calls
          to this.addInboundNode().
         */ this.inboundNodes = [];
        this.outboundNodes = [];
        let name = args.name;
        if (!name) {
            const prefix = this.getClassName();
            name = $jYx5u.toSnakeCase(prefix) + '_' + (0, $cExd6.getUid)(prefix);
        }
        this.name = name;
        this.trainable_ = args.trainable == null ? true : args.trainable;
        if (args.inputShape != null || args.batchInputShape != null) {
            /*
              In this case we will later create an input layer
              to insert before the current layer
             */ let batchInputShape;
            if (args.batchInputShape != null) batchInputShape = args.batchInputShape;
            else if (args.inputShape != null) {
                let batchSize = null;
                if (args.batchSize != null) batchSize = args.batchSize;
                batchInputShape = [
                    batchSize
                ].concat(args.inputShape);
            }
            this.batchInputShape = batchInputShape;
            // Set dtype.
            let dtype = args.dtype;
            if (dtype == null) dtype = args.inputDType;
            if (dtype == null) dtype = 'float32';
            this.dtype = dtype;
        }
        if (args.weights != null) this.initialWeights = args.weights;
        else this.initialWeights = null;
        // The value of `_refCount` is initialized to null. When the layer is used
        // in a symbolic way for the first time, it will be set to 1.
        this._refCount = null;
        this.fastWeightInitDuringBuild = false;
    }
    /**
     * Converts a layer and its index to a unique (immutable type) name.
     * This function is used internally with `this.containerNodes`.
     * @param layer The layer.
     * @param nodeIndex The layer's position (e.g. via enumerate) in a list of
     *   nodes.
     *
     * @returns The unique name.
     */ static nodeKey(layer, nodeIndex) {
        return layer.name + '_ib-' + nodeIndex.toString();
    }
    /**
     * Returns this.inboundNode at index nodeIndex.
     *
     * Porting note: This is a replacement for _get_node_attribute_at_index()
     * @param nodeIndex
     * @param attrName The name of the attribute related to request for this node.
     */ getNodeAtIndex(nodeIndex, attrName) {
        if (this.inboundNodes.length === 0) throw new (0, $kubuc.RuntimeError)('The layer has never been called ' + `and thus has no defined ${attrName}.`);
        if (this.inboundNodes.length <= nodeIndex) throw new (0, $kubuc.ValueError)(`Asked to get ${attrName} at node ${nodeIndex}, ` + `but the layer has only ${this.inboundNodes.length} inbound nodes.`);
        return this.inboundNodes[nodeIndex];
    }
    /**
     * Retrieves the input tensor(s) of a layer at a given node.
     *
     * @param nodeIndex Integer, index of the node from which to retrieve the
     *   attribute. E.g. `nodeIndex=0` will correspond to the first time the layer
     *   was called.
     *
     * @return A tensor (or list of tensors if the layer has multiple inputs).
     */ getInputAt(nodeIndex) {
        return $jYx5u.singletonOrArray(this.getNodeAtIndex(nodeIndex, 'input').inputTensors);
    }
    /**
     * Retrieves the output tensor(s) of a layer at a given node.
     *
     * @param nodeIndex Integer, index of the node from which to retrieve the
     *   attribute. E.g. `nodeIndex=0` will correspond to the first time the layer
     *   was called.
     *
     * @return A tensor (or list of tensors if the layer has multiple outputs).
     */ getOutputAt(nodeIndex) {
        return $jYx5u.singletonOrArray(this.getNodeAtIndex(nodeIndex, 'output').outputTensors);
    }
    // Properties
    /**
     * Retrieves the input tensor(s) of a layer.
     *
     * Only applicable if the layer has exactly one inbound node,
     * i.e. if it is connected to one incoming layer.
     *
     * @return Input tensor or list of input tensors.
     *
     * @exception AttributeError if the layer is connected to more than one
     *   incoming layers.
     */ get input() {
        if (this.inboundNodes.length > 1) throw new (0, $kubuc.AttributeError)(`Layer ${this.name}` + ' has multiple inbound nodes, ' + 'hence the notion of "layer input" ' + 'is ill-defined. ' + 'Use `getInputAt(nodeIndex)` instead.');
        else if (this.inboundNodes.length === 0) throw new (0, $kubuc.AttributeError)(`Layer ${this.name}` + ' is not connected, no input to return.');
        return $jYx5u.singletonOrArray(this.getNodeAtIndex(0, 'input').inputTensors);
    }
    /**
     * Retrieves the output tensor(s) of a layer.
     *
     * Only applicable if the layer has exactly one inbound node,
     * i.e. if it is connected to one incoming layer.
     *
     * @return Output tensor or list of output tensors.
     *
     * @exception AttributeError if the layer is connected to more than one
     *   incoming layers.
     */ get output() {
        if (this.inboundNodes.length === 0) throw new (0, $kubuc.AttributeError)(`Layer ${this.name}` + ' has no inbound nodes.');
        if (this.inboundNodes.length > 1) throw new (0, $kubuc.AttributeError)(`Layer ${this.name}` + ' has multiple inbound nodes, ' + 'hence the notion of "layer output" ' + 'is ill-defined. ' + 'Use `getOutputAt(nodeIndex)` instead.');
        return $jYx5u.singletonOrArray(this.getNodeAtIndex(0, 'output').outputTensors);
    }
    get losses() {
        return this._losses;
    }
    /**
     * Retrieves the Layer's current loss values.
     *
     * Used for regularizers during training.
     */ calculateLosses() {
        // Porting Node: This is an augmentation to Layer.loss in PyKeras.
        //   In PyKeras, Layer.loss returns symbolic tensors. Here a concrete
        //   Tensor (specifically Scalar) values are returned. This is due to the
        //   imperative backend.
        return this.losses.map((lossFn)=>lossFn());
    }
    get updates() {
        return this._updates;
    }
    get built() {
        return this._built;
    }
    set built(built) {
        this._built = built;
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this._trainableWeights.forEach((w)=>w.trainable = trainable);
        this.trainable_ = trainable;
    }
    get trainableWeights() {
        if (this.trainable_) return this._trainableWeights.filter((w)=>w.trainable);
        else return [];
    }
    set trainableWeights(weights) {
        this._trainableWeights = weights;
    }
    get nonTrainableWeights() {
        if (this.trainable) return this._trainableWeights.filter((w)=>!w.trainable).concat(this._nonTrainableWeights);
        else return this._trainableWeights.concat(this._nonTrainableWeights);
    }
    set nonTrainableWeights(weights) {
        this._nonTrainableWeights = weights;
    }
    /**
     * The concatenation of the lists trainableWeights and nonTrainableWeights
     * (in this order).
     */ get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights);
    }
    get stateful() {
        return this._stateful;
    }
    /**
     * Reset the states of the layer.
     *
     * This method of the base Layer class is essentially a no-op.
     * Subclasses that are stateful (e.g., stateful RNNs) should override this
     * method.
     */ resetStates() {
        if (!this.stateful) throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.");
    }
    /**
     * Checks compatibility between the layer and provided inputs.
     *
     * This checks that the tensor(s) `input`
     * verify the input assumptions of the layer
     * (if any). If not, exceptions are raised.
     *
     * @param inputs Input tensor or list of input tensors.
     *
     * @exception ValueError in case of mismatch between
     *   the provided inputs and the expectations of the layer.
     */ assertInputCompatibility(inputs) {
        const inputsList = $jYx5u.toList(inputs);
        if (this.inputSpec == null || this.inputSpec.length === 0) return;
        const inputSpec = $jYx5u.toList(this.inputSpec);
        if (inputsList.length !== inputSpec.length) throw new (0, $kubuc.ValueError)(`Layer ${this.name} expects ${inputSpec.length} inputs, ` + `but it received ${inputsList.length} input tensors. ` + `Input received: ${inputs}`);
        for(let inputIndex = 0; inputIndex < inputsList.length; inputIndex++){
            const x = inputsList[inputIndex];
            const spec = inputSpec[inputIndex];
            if (spec == null) continue;
            // Check ndim.
            const ndim = x.rank;
            if (spec.ndim != null) {
                if (ndim !== spec.ndim) throw new (0, $kubuc.ValueError)(`Input ${inputIndex} is incompatible with layer ${this.name}: ` + `expected ndim=${spec.ndim}, found ndim=${ndim}`);
            }
            if (spec.maxNDim != null) {
                if (ndim > spec.maxNDim) throw new (0, $kubuc.ValueError)(`Input ${inputIndex} is incompatible with layer ${this.name}` + `: expected max_ndim=${spec.maxNDim}, found ndim=${ndim}`);
            }
            if (spec.minNDim != null) {
                if (ndim < spec.minNDim) throw new (0, $kubuc.ValueError)(`Input ${inputIndex} is incompatible with layer ${this.name}` + `: expected min_ndim=${spec.minNDim}, found ndim=${ndim}.`);
            }
            // Check dtype.
            if (spec.dtype != null) {
                if (x.dtype !== spec.dtype) throw new (0, $kubuc.ValueError)(`Input ${inputIndex} is incompatible with layer ${this.name} ` + `: expected dtype=${spec.dtype}, found dtype=${x.dtype}.`);
            }
            // Check specific shape axes.
            if (spec.axes) {
                const xShape = x.shape;
                for(const key in spec.axes){
                    const axis = Number(key);
                    const value = spec.axes[key];
                    // Perform Python-style slicing in case axis < 0;
                    // TODO(cais): Use https://github.com/alvivi/typescript-underscore to
                    // ensure type safety through Underscore calls.
                    const xShapeAtAxis = axis >= 0 ? xShape[axis] : xShape[xShape.length + axis];
                    if (value != null && [
                        value,
                        null
                    ].indexOf(xShapeAtAxis) === -1) throw new (0, $kubuc.ValueError)(`Input ${inputIndex} is incompatible with layer ` + `${this.name}: expected axis ${axis} of input shape to ` + `have value ${value} but got shape ${xShape}.`);
                }
            }
            // Check shape.
            if (spec.shape != null) for(let i = 0; i < spec.shape.length; ++i){
                const specDim = spec.shape[i];
                const dim = x.shape[i];
                if (specDim != null && dim != null) {
                    if (specDim !== dim) throw new (0, $kubuc.ValueError)(`Input ${inputIndex} is incompatible with layer ` + `${this.name}: expected shape=${spec.shape}, ` + `found shape=${x.shape}.`);
                }
            }
        }
    }
    /**
     * This is where the layer's logic lives.
     *
     * @param inputs Input tensor, or list/tuple of input tensors.
     * @param kwargs Additional keyword arguments.
     *
     * @return A tensor or list/tuple of tensors.
     */ call(inputs, kwargs) {
        return inputs;
    }
    invokeCallHook(inputs, kwargs) {
        if (this._callHook != null) this._callHook(inputs, kwargs);
    }
    /**
     * Set call hook.
     * This is currently used for testing only.
     * @param callHook
     */ setCallHook(callHook) {
        this._callHook = callHook;
    }
    /**
     * Clear call hook.
     * This is currently used for testing only.
     */ clearCallHook() {
        this._callHook = null;
    }
    /**
     * Builds or executes a `Layer`'s logic.
     *
     * When called with `tf.Tensor`(s), execute the `Layer`'s computation and
     * return Tensor(s). For example:
     *
     * ```js
     * const denseLayer = tf.layers.dense({
     *   units: 1,
     *   kernelInitializer: 'zeros',
     *   useBias: false
     * });
     *
     * // Invoke the layer's apply() method with a `tf.Tensor` (with concrete
     * // numeric values).
     * const input = tf.ones([2, 2]);
     * const output = denseLayer.apply(input);
     *
     * // The output's value is expected to be [[0], [0]], due to the fact that
     * // the dense layer has a kernel initialized to all-zeros and does not have
     * // a bias.
     * output.print();
     * ```
     *
     * When called with `tf.SymbolicTensor`(s), this will prepare the layer for
     * future execution.  This entails internal book-keeping on shapes of
     * expected Tensors, wiring layers together, and initializing weights.
     *
     * Calling `apply` with `tf.SymbolicTensor`s are typically used during the
     * building of non-`tf.Sequential` models. For example:
     *
     * ```js
     * const flattenLayer = tf.layers.flatten();
     * const denseLayer = tf.layers.dense({units: 1});
     *
     * // Use tf.layers.input() to obtain a SymbolicTensor as input to apply().
     * const input = tf.input({shape: [2, 2]});
     * const output1 = flattenLayer.apply(input);
     *
     * // output1.shape is [null, 4]. The first dimension is the undetermined
     * // batch size. The second dimension comes from flattening the [2, 2]
     * // shape.
     * console.log(JSON.stringify(output1.shape));
     *
     * // The output SymbolicTensor of the flatten layer can be used to call
     * // the apply() of the dense layer:
     * const output2 = denseLayer.apply(output1);
     *
     * // output2.shape is [null, 1]. The first dimension is the undetermined
     * // batch size. The second dimension matches the number of units of the
     * // dense layer.
     * console.log(JSON.stringify(output2.shape));
     *
     * // The input and output can be used to construct a model that consists
     * // of the flatten and dense layers.
     * const model = tf.model({inputs: input, outputs: output2});
     * ```
     *
     * @param inputs a `tf.Tensor` or `tf.SymbolicTensor` or an Array of them.
     * @param kwargs Additional keyword arguments to be passed to `call()`.
     *
     * @return Output of the layer's `call` method.
     *
     * @exception ValueError error in case the layer is missing shape information
     *   for its `build` call.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ // Porting Note: This is a replacement for __call__() in Python.
    apply(inputs, kwargs) {
        kwargs = kwargs || {};
        this.assertNotDisposed();
        // Ensure inputs are all the same type.
        const inputsList = $jYx5u.toList(inputs);
        const allAreSymbolic = $e8470124cada40d0$var$checkAllSymbolic(inputs);
        const noneAreSymbolic = $e8470124cada40d0$var$checkNoneSymbolic(inputs);
        if (allAreSymbolic === noneAreSymbolic) throw new (0, $kubuc.ValueError)("Arguments to apply() must be all SymbolicTensors or all Tensors");
        // TODO(michaelterry): nameScope() may not be necessary.
        return (0, $1Xyaa.nameScope)(this.name, ()=>{
            // Handle laying building (weight creating, input spec locking).
            if (!this.built) {
                /*
                  Throw exceptions in case the input is not compatible
                  with the inputSpec specified in the layer constructor.
                 */ this.assertInputCompatibility(inputs);
                // Collect input shapes to build layer.
                const inputShapes = [];
                for (const xElem of $jYx5u.toList(inputs))inputShapes.push(xElem.shape);
                this.build($jYx5u.singletonOrArray(inputShapes));
                this.built = true;
                // Load weights that were specified at layer instantiation.
                if (this.initialWeights) this.setWeights(this.initialWeights);
                if (this._refCount === null && noneAreSymbolic) // The first use of this layer is a non-symbolic call, set ref count
                // to 1 so the Layer can be properly disposed if its dispose() method
                // is called.
                this._refCount = 1;
            }
            /*
              Throw exceptions in case the input is not compatible
              with the inputSpec set at build time.
            */ this.assertInputCompatibility(inputs);
            // Handle mask propagation.
            // TODO(michaelterry): Mask propagation not currently implemented.
            // Actually call the layer, collecting output(s), mask(s), and shape(s).
            if (noneAreSymbolic) {
                let output = this.call(inputs, kwargs);
                // Apply masks to the output tensors if the layer supports it.
                if (this.supportsMasking) // TODO(mattsoulanille): pass the input tensors' masks to computeMask
                this.setMaskMetadata(inputs, output);
                // If the layer returns tensors from its inputs, unmodified,
                // we copy them to avoid loss of tensor metadata.
                const outputList = $jYx5u.toList(output);
                const outputListCopy = [];
                // TODO(michaelterry): This copying may not be necessary given our eager
                // backend.
                for (let x of outputList){
                    if (inputsList.indexOf(x) !== -1) x = x.clone();
                    outputListCopy.push(x);
                }
                output = $jYx5u.singletonOrArray(outputListCopy);
                if (this.activityRegularizer != null) throw new (0, $kubuc.NotImplementedError)("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
                // TODO(michaelterry): Call addInboundNode()?
                return output;
            } else {
                const inputShape = $e8470124cada40d0$var$collectInputShape(inputs);
                const outputShape = this.computeOutputShape(inputShape);
                let output;
                const outputDType = $e8470124cada40d0$var$guessOutputDType(inputs);
                this.warnOnIncompatibleInputShape(Array.isArray(inputs) ? inputShape[0] : inputShape);
                if (outputShape != null && outputShape.length > 0 && Array.isArray(outputShape[0])) // We have multiple output shapes. Create multiple output tensors.
                output = outputShape.map((shape, index)=>new $e8470124cada40d0$export$c6d6977640680568(outputDType, shape, this, $jYx5u.toList(inputs), kwargs, this.name, index));
                else output = new $e8470124cada40d0$export$c6d6977640680568(outputDType, outputShape, this, $jYx5u.toList(inputs), kwargs, this.name);
                /*
                  Add an inbound node to the layer, so that it keeps track
                  of the call and of all new variables created during the call.
                  This also updates the layer history of the output tensor(s).
                  If the input tensor(s) had no previous history,
                  this does nothing.
                */ this.addInboundNode(inputs, output, null, null, inputShape, outputShape, kwargs);
                this._refCount++;
                if (this.activityRegularizer != null) throw new (0, $kubuc.NotImplementedError)("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
                return output;
            }
        });
    }
    /**
     * Check compatibility between input shape and this layer's batchInputShape.
     *
     * Print warning if any incompatibility is found.
     *
     * @param inputShape Input shape to be checked.
     */ warnOnIncompatibleInputShape(inputShape) {
        if (this.batchInputShape == null) return;
        else if (inputShape.length !== this.batchInputShape.length) console.warn(`The rank of the input tensor provided (shape: ` + `${JSON.stringify(inputShape)}) does not match that of the ` + `batchInputShape (${JSON.stringify(this.batchInputShape)}) ` + `of the layer ${this.name}`);
        else {
            let dimMismatch = false;
            this.batchInputShape.forEach((dimension, i)=>{
                if (dimension != null && inputShape[i] != null && inputShape[i] !== dimension) dimMismatch = true;
            });
            if (dimMismatch) console.warn(`The shape of the input tensor ` + `(${JSON.stringify(inputShape)}) does not ` + `match the expectation of layer ${this.name}: ` + `${JSON.stringify(this.batchInputShape)}`);
        }
    }
    /**
     * Retrieves the output shape(s) of a layer.
     *
     * Only applicable if the layer has only one inbound node, or if all inbound
     * nodes have the same output shape.
     *
     * @returns Output shape or shapes.
     * @throws AttributeError: if the layer is connected to more than one incoming
     *   nodes.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ get outputShape() {
        if (this.inboundNodes == null || this.inboundNodes.length === 0) throw new (0, $kubuc.AttributeError)(`The layer ${this.name} has never been called and thus has no ` + `defined output shape.`);
        const allOutputShapes = [];
        for (const node of this.inboundNodes){
            const shapeString = JSON.stringify(node.outputShapes);
            if (allOutputShapes.indexOf(shapeString) === -1) allOutputShapes.push(shapeString);
        }
        if (allOutputShapes.length === 1) {
            const outputShapes = this.inboundNodes[0].outputShapes;
            if (Array.isArray(outputShapes) && Array.isArray(outputShapes[0]) && outputShapes.length === 1) return outputShapes[0];
            else return outputShapes;
        } else throw new (0, $kubuc.AttributeError)(`The layer ${this.name} has multiple inbound nodes with different ` + `output shapes. Hence the notion of "output shape" is ill-defined ` + `for the layer.`);
    }
    /**
     * Counts the total number of numbers (e.g., float32, int32) in the
     * weights.
     *
     * @returns An integer count.
     * @throws RuntimeError: If the layer is not built yet (in which case its
     *   weights are not defined yet.)
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ countParams() {
        if (!this.built) throw new (0, $kubuc.RuntimeError)(`You tried to call countParams() on ${this.name}, ` + `but the layer is not built yet. Build it first by calling ` + `build(batchInputShape).`);
        return $7iQkf.countParamsInWeights(this.weights);
    }
    /**
     * Creates the layer weights.
     *
     * Must be implemented on all layers that have weights.
     *
     * Called when apply() is called to construct the weights.
     *
     * @param inputShape A `Shape` or array of `Shape` (unused).
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ build(inputShape) {
        this.built = true;
    }
    /**
     * Returns the current values of the weights of the layer.
     *
     * @param trainableOnly Whether to get the values of only trainable weights.
     * @returns Weight values as an `Array` of `tf.Tensor`s.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ getWeights(trainableOnly = false) {
        return (0, $pKVrB.batchGetValue)(trainableOnly ? this.trainableWeights : this.weights);
    }
    /**
     * Sets the weights of the layer, from Tensors.
     *
     * @param weights a list of Tensors. The number of arrays and their shape
     *   must match number of the dimensions of the weights of the layer (i.e.
     *   it should match the output of `getWeights`).
     *
     * @exception ValueError If the provided weights list does not match the
     *   layer's specifications.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ setWeights(weights) {
        (0, $d7Nxs.tidy)(()=>{
            const params = this.weights;
            if (params.length !== weights.length) // TODO(cais): Restore the following and use `providedWeights`, instead
            // of `weights` in the error message, once the deeplearn.js bug is
            // fixed: https://github.com/PAIR-code/deeplearnjs/issues/498 const
            // providedWeights = JSON.stringify(weights).slice(0, 50);
            throw new (0, $kubuc.ValueError)(`You called setWeights(weights) on layer "${this.name}" ` + `with a weight list of length ${weights.length}, ` + `but the layer was expecting ${params.length} weights. ` + `Provided weights: ${weights}...`);
            if (params.length === 0) return;
            const weightValueTuples = [];
            const paramValues = (0, $pKVrB.batchGetValue)(params);
            for(let i = 0; i < paramValues.length; ++i){
                const pv = paramValues[i];
                const p = params[i];
                const w = weights[i];
                if (!(0, $lBDHD).arraysEqual(pv.shape, w.shape)) throw new (0, $kubuc.ValueError)(`Layer weight shape ${pv.shape} ` + `not compatible with provided weight shape ${w.shape}`);
                weightValueTuples.push([
                    p,
                    w
                ]);
            }
            (0, $pKVrB.batchSetValue)(weightValueTuples);
        });
    }
    /**
     * Adds a weight variable to the layer.
     *
     * @param name Name of the new weight variable.
     * @param shape The shape of the weight.
     * @param dtype The dtype of the weight.
     * @param initializer An initializer instance.
     * @param regularizer A regularizer instance.
     * @param trainable Whether the weight should be trained via backprop or not
     *   (assuming that the layer itself is also trainable).
     * @param constraint An optional trainable.
     * @return The created weight variable.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ addWeight(name, shape, dtype, initializer, regularizer, trainable, constraint, getInitializerFunc) {
        // Reject duplicate weight names.
        if (this._addedWeightNames.indexOf(name) !== -1) throw new (0, $kubuc.ValueError)(`Duplicate weight name ${name} for layer ${this.name}`);
        this._addedWeightNames.push(name);
        if (dtype == null) dtype = 'float32';
        if (this.fastWeightInitDuringBuild) initializer = getInitializerFunc != null ? getInitializerFunc() : (0, $lHlnu.getInitializer)('zeros');
        const initValue = initializer.apply(shape, dtype);
        const weight = new (0, $pKVrB.LayerVariable)(initValue, dtype, name, trainable, constraint);
        initValue.dispose();
        // Request backend not to dispose the weights of the model on scope() exit.
        if (regularizer != null) this.addLoss(()=>regularizer.apply(weight.read()));
        if (trainable == null) trainable = true;
        if (trainable) this._trainableWeights.push(weight);
        else this._nonTrainableWeights.push(weight);
        return weight;
    }
    /**
     * Set the fast-weight-initialization flag.
     *
     * In cases where the initialized weight values will be immediately
     * overwritten by loaded weight values during model loading, setting
     * the flag to `true` saves unnecessary calls to potentially expensive
     * initializers and speeds up the loading process.
     *
     * @param value Target value of the flag.
     */ setFastWeightInitDuringBuild(value) {
        this.fastWeightInitDuringBuild = value;
    }
    /**
     * Add losses to the layer.
     *
     * The loss may potentially be conditional on some inputs tensors,
     * for instance activity losses are conditional on the layer's inputs.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ addLoss(losses) {
        if (losses == null || Array.isArray(losses) && losses.length === 0) return;
        // Update this.losses
        losses = $jYx5u.toList(losses);
        if (this._losses !== undefined && this._losses !== null) this.losses.push(...losses);
    }
    /**
     * Computes the output shape of the layer.
     *
     * Assumes that the layer will be built to match that input shape provided.
     *
     * @param inputShape A shape (tuple of integers) or a list of shape tuples
     *   (one per output tensor of the layer). Shape tuples can include null for
     *   free dimensions, instead of an integer.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ computeOutputShape(inputShape) {
        return inputShape;
    }
    /**
     * Computes an output mask tensor.
     *
     * @param inputs Tensor or list of tensors.
     * @param mask Tensor or list of tensors.
     *
     * @return null or a tensor (or list of tensors, one per output tensor of the
     * layer).
     */ computeMask(inputs, mask) {
        if (!this.supportsMasking) {
            if (mask != null) {
                if (Array.isArray(mask)) mask.forEach((maskElement)=>{
                    if (maskElement != null) throw new TypeError(`Layer ${this.name} does not support masking, ` + 'but was passed an inputMask.');
                });
                else throw new TypeError(`Layer ${this.name} does not support masking, ` + 'but was passed an inputMask.');
            }
            // masking not explicitly supported: return null as mask
            return null;
        }
        // if masking is explictly supported, by default
        // carry over the input mask
        return mask;
    }
    setMaskMetadata(inputs, outputs, previousMask) {
        if (!this.supportsMasking) return;
        const outputMasks = this.computeMask(inputs, previousMask);
        const outputsList = $jYx5u.toList(outputs);
        const outputMasksList = $jYx5u.toList(outputMasks);
        if (outputsList.length !== outputMasksList.length) throw new Error(`${this.name} outputs ${outputsList.length} tensors ` + `but ${outputsList.length} masks for those tensors`);
        for(let i = 0; i < outputsList.length; i++)outputsList[i].kerasMask = outputMasksList[i];
    }
    /**
     * Internal method to create an inbound node for the layer.
     *
     * @param inputTensors List of input tensors.
     * @param outputTensors List of output tensors.
     * @param inputMasks List of input masks (a mask can be a tensor, or null).
     * @param outputMasks List of output masks (a mask can be a tensor, or null).
     * @param inputShapes List of input shape tuples.
     * @param outputShapes List of output shape tuples.
     * @param kwargs Dictionary of keyword arguments that were passed to the
     *   `call` method of the layer at the call that created the node.
     */ addInboundNode(inputTensors, outputTensors, inputMasks, outputMasks, inputShapes, outputShapes, kwargs = null) {
        const inputTensorList = $jYx5u.toList(inputTensors);
        outputTensors = $jYx5u.toList(outputTensors);
        inputMasks = $jYx5u.toList(inputMasks);
        outputMasks = $jYx5u.toList(outputMasks);
        inputShapes = $bMNfZ.normalizeShapeList(inputShapes);
        outputShapes = $bMNfZ.normalizeShapeList(outputShapes);
        // Collect input tensor(s) coordinates.
        const inboundLayers = [];
        const nodeIndices = [];
        const tensorIndices = [];
        for (const x of inputTensorList){
            /*
             * TODO(michaelterry): Keras adds this value to tensors; it's not
             * clear whether we'll use this or not.
             */ inboundLayers.push(x.sourceLayer);
            nodeIndices.push(x.nodeIndex);
            tensorIndices.push(x.tensorIndex);
        }
        // Create node, add it to inbound nodes.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new $e8470124cada40d0$export$85c928794f8d04d4({
            outboundLayer: this,
            inboundLayers: inboundLayers,
            nodeIndices: nodeIndices,
            tensorIndices: tensorIndices,
            inputTensors: inputTensorList,
            outputTensors: outputTensors,
            inputMasks: inputMasks,
            outputMasks: outputMasks,
            inputShapes: inputShapes,
            outputShapes: outputShapes
        }, kwargs);
        // Update tensor history
        for(let i = 0; i < outputTensors.length; i++){
            // TODO(michaelterry: _uses_learning_phase not tracked.
            outputTensors[i].sourceLayer = this;
            outputTensors[i].nodeIndex = this.inboundNodes.length - 1;
            outputTensors[i].tensorIndex = i;
        }
    }
    /**
     * Returns the config of the layer.
     *
     * A layer config is a TS dictionary (serializable)
     * containing the configuration of a layer.
     * The same layer can be reinstantiated later
     * (without its trained weights) from this configuration.
     *
     * The config of a layer does not include connectivity
     * information, nor the layer class name.  These are handled
     * by 'Container' (one layer of abstraction above).
     *
     * Porting Note: The TS dictionary follows TS naming standards for
     * keys, and uses tfjs-layers type-safe Enums.  Serialization methods
     * should use a helper function to convert to the pythonic storage
     * standard. (see serialization_utils.convertTsToPythonic)
     *
     * @returns TS dictionary of configuration.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ getConfig() {
        const config = {
            name: this.name,
            trainable: this.trainable
        };
        if (this.batchInputShape != null) config['batchInputShape'] = this.batchInputShape;
        if (this.dtype != null) config['dtype'] = this.dtype;
        return config;
    }
    /**
     * Dispose the weight variables that this Layer instance holds.
     *
     * @returns {number} Number of disposed variables.
     */ disposeWeights() {
        this.weights.forEach((weight)=>weight.dispose());
        return this.weights.length;
    }
    assertNotDisposed() {
        if (this._refCount === 0) throw new Error(`Layer '${this.name}' is already disposed.`);
    }
    /**
     * Attempt to dispose layer's weights.
     *
     * This method decreases the reference count of the Layer object by 1.
     *
     * A Layer is reference-counted. Its reference count is incremented by 1
     * the first item its `apply()` method is called and when it becomes a part
     * of a new `Node` (through calling the `apply()` method on a
     * `tf.SymbolicTensor`).
     *
     * If the reference count of a Layer becomes 0, all the weights will be
     * disposed and the underlying memory (e.g., the textures allocated in WebGL)
     * will be freed.
     *
     * Note: If the reference count is greater than 0 after the decrement, the
     * weights of the Layer will *not* be disposed.
     *
     * After a Layer is disposed, it cannot be used in calls such as `apply()`,
     * `getWeights()` or `setWeights()` anymore.
     *
     * @returns A DisposeResult Object with the following fields:
     *   - refCountAfterDispose: The reference count of the Container after this
     *     `dispose()` call.
     *   - numDisposedVariables: Number of `tf.Variable`s (i.e., weights) disposed
     *     during this `dispose()` call.
     * @throws {Error} If the layer is not built yet, or if the layer has already
     *   been disposed.
     *
     * @doc {heading: 'Models', 'subheading': 'Classes'}
     */ dispose() {
        if (!this.built) throw new Error(`Cannot dispose Layer ${this.name} because it has not been ` + `built yet.`);
        if (this._refCount === null) throw new Error(`Cannot dispose Layer ${this.name} because it has not been used ` + `yet.`);
        this.assertNotDisposed();
        let numDisposedVariables = 0;
        if (--this._refCount === 0) numDisposedVariables = this.disposeWeights();
        return {
            refCountAfterDispose: this._refCount,
            numDisposedVariables: numDisposedVariables
        };
    }
}
/**
 * Collects the input shape(s) of a list of `tf.Tensor`s or
 * `tf.SymbolicTensor`s.
 *
 * TODO(michaelterry): Update PyKeras docs (backport).
 *
 * @param inputTensors List of input tensors (or single input tensor).
 *
 * @return List of shape tuples (or single tuple), one tuple per input.
 */ function $e8470124cada40d0$var$collectInputShape(inputTensors) {
    inputTensors = $jYx5u.toList(inputTensors);
    const shapes = [];
    for (const x of inputTensors)shapes.push(x.shape);
    return $jYx5u.singletonOrArray(shapes);
}
/**
 * Guesses output dtype based on inputs.
 *
 * At present, just returns 'float32' for any input.
 *
 * @param inputTensors List of input tensors (or single input tensor).
 *
 * @return The guessed DType. At present, always returns 'float32'.
 */ function $e8470124cada40d0$var$guessOutputDType(inputTensors) {
    return 'float32';
}
function $e8470124cada40d0$export$6d61b4ed0b6fb596(tensor, layer, nodeIndex) {
    if (layer == null || nodeIndex != null && nodeIndex > 0) {
        layer = tensor.sourceLayer;
        nodeIndex = tensor.nodeIndex;
    }
    if (layer.inboundNodes.length === 0) return [
        tensor
    ];
    else {
        const node = layer.inboundNodes[nodeIndex];
        if (node.inboundLayers.length === 0) return node.inputTensors;
        else {
            const sourceTensors = [];
            for(let i = 0; i < node.inboundLayers.length; i++){
                const x = node.inputTensors[i];
                const layer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const previousSources = $e8470124cada40d0$export$6d61b4ed0b6fb596(x, layer, nodeIndex);
                // Avoid input redundancy.
                for (const x of previousSources)if (sourceTensors.indexOf(x) === -1) sourceTensors.push(x);
            }
            return sourceTensors;
        }
    }
}
function $e8470124cada40d0$var$checkAllSymbolic(tensors) {
    let allAreSymbolic = true;
    for (const tensor of $jYx5u.toList(tensors))if (!(tensor instanceof $e8470124cada40d0$export$c6d6977640680568)) {
        allAreSymbolic = false;
        break;
    }
    return allAreSymbolic;
}
function $e8470124cada40d0$var$checkNoneSymbolic(tensors) {
    let noneAreSymbolic = true;
    for (const tensor of $jYx5u.toList(tensors))if (tensor instanceof $e8470124cada40d0$export$c6d6977640680568) {
        noneAreSymbolic = false;
        break;
    }
    return noneAreSymbolic;
}

});
parcelRegister("1Xyaa", function(module, exports) {

$parcel$export(module.exports, "checkDataFormat", function () { return $16d5cd3494e82707$export$f5f6472a2b993816; });
$parcel$export(module.exports, "checkInterpolationFormat", function () { return $16d5cd3494e82707$export$2c8c51ca0cb16cd2; });
$parcel$export(module.exports, "checkPaddingMode", function () { return $16d5cd3494e82707$export$a6c1e84f1d33d64d; });
$parcel$export(module.exports, "checkPoolMode", function () { return $16d5cd3494e82707$export$4ac7885ddd005702; });
$parcel$export(module.exports, "nameScope", function () { return $16d5cd3494e82707$export$e820b4f57a8e33d1; });
$parcel$export(module.exports, "getScopedTensorName", function () { return $16d5cd3494e82707$export$ff30fd7baa750729; });
$parcel$export(module.exports, "getUniqueTensorName", function () { return $16d5cd3494e82707$export$9227bff0c10d827e; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Common functions for TensorFlow.js Layers.
 */ 
var $46TaI = parcelRequire("46TaI");

var $jYx5u = parcelRequire("jYx5u");
// A map from the requested scoped name of a Tensor to the number of Tensors
// wanting that name so far.  This allows enforcing name uniqueness by appending
// an incrementing index, e.g. scope/name, scope/name_1, scope/name_2, etc.
const $16d5cd3494e82707$var$nameMap = new Map();
function $16d5cd3494e82707$export$f5f6472a2b993816(value) {
    (0, $jYx5u.checkStringTypeUnionValue)((0, $46TaI.VALID_DATA_FORMAT_VALUES), 'DataFormat', value);
}
function $16d5cd3494e82707$export$2c8c51ca0cb16cd2(value) {
    (0, $jYx5u.checkStringTypeUnionValue)((0, $46TaI.VALID_INTERPOLATION_FORMAT_VALUES), 'InterpolationFormat', value);
}
function $16d5cd3494e82707$export$a6c1e84f1d33d64d(value) {
    (0, $jYx5u.checkStringTypeUnionValue)((0, $46TaI.VALID_PADDING_MODE_VALUES), 'PaddingMode', value);
}
function $16d5cd3494e82707$export$4ac7885ddd005702(value) {
    (0, $jYx5u.checkStringTypeUnionValue)((0, $46TaI.VALID_POOL_MODE_VALUES), 'PoolMode', value);
}
const $16d5cd3494e82707$var$_nameScopeStack = [];
const $16d5cd3494e82707$var$_nameScopeDivider = '/';
function $16d5cd3494e82707$export$e820b4f57a8e33d1(name, fn) {
    $16d5cd3494e82707$var$_nameScopeStack.push(name);
    try {
        const val = fn();
        $16d5cd3494e82707$var$_nameScopeStack.pop();
        return val;
    } catch (e) {
        $16d5cd3494e82707$var$_nameScopeStack.pop();
        throw e;
    }
}
/**
 * Get the current namescope as a flat, concatenated string.
 */ function $16d5cd3494e82707$var$currentNameScopePrefix() {
    if ($16d5cd3494e82707$var$_nameScopeStack.length === 0) return '';
    else return $16d5cd3494e82707$var$_nameScopeStack.join($16d5cd3494e82707$var$_nameScopeDivider) + $16d5cd3494e82707$var$_nameScopeDivider;
}
function $16d5cd3494e82707$export$ff30fd7baa750729(tensorName) {
    if (!$16d5cd3494e82707$export$f372abc09dacf0d5(tensorName)) throw new Error('Not a valid tensor name: \'' + tensorName + '\'');
    return $16d5cd3494e82707$var$currentNameScopePrefix() + tensorName;
}
function $16d5cd3494e82707$export$9227bff0c10d827e(scopedName) {
    if (!$16d5cd3494e82707$export$f372abc09dacf0d5(scopedName)) throw new Error('Not a valid tensor name: \'' + scopedName + '\'');
    if (!$16d5cd3494e82707$var$nameMap.has(scopedName)) $16d5cd3494e82707$var$nameMap.set(scopedName, 0);
    const index = $16d5cd3494e82707$var$nameMap.get(scopedName);
    $16d5cd3494e82707$var$nameMap.set(scopedName, $16d5cd3494e82707$var$nameMap.get(scopedName) + 1);
    if (index > 0) {
        const result = `${scopedName}_${index}`;
        // Mark the composed name as used in case someone wants
        // to call getUniqueTensorName("name_1").
        $16d5cd3494e82707$var$nameMap.set(result, 1);
        return result;
    } else return scopedName;
}
const $16d5cd3494e82707$var$tensorNameRegex = new RegExp(/^[A-Za-z0-9][-A-Za-z0-9\._\/]*$/);
function $16d5cd3494e82707$export$f372abc09dacf0d5(name) {
    return !!name.match($16d5cd3494e82707$var$tensorNameRegex);
}

});
parcelRegister("46TaI", function(module, exports) {

$parcel$export(module.exports, "VALID_DATA_FORMAT_VALUES", function () { return $2fe284ee13368677$export$57a9e614626b5380; });
$parcel$export(module.exports, "VALID_INTERPOLATION_FORMAT_VALUES", function () { return $2fe284ee13368677$export$b8823bf7d44e4d59; });
$parcel$export(module.exports, "VALID_PADDING_MODE_VALUES", function () { return $2fe284ee13368677$export$48aea51acf1bce87; });
$parcel$export(module.exports, "VALID_POOL_MODE_VALUES", function () { return $2fe284ee13368677$export$f450a7a6767a84d4; });
$parcel$export(module.exports, "VALID_BIDIRECTIONAL_MERGE_MODES", function () { return $2fe284ee13368677$export$954d8bae11304008; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const $2fe284ee13368677$export$57a9e614626b5380 = [
    'channelsFirst',
    'channelsLast'
];
const $2fe284ee13368677$export$b8823bf7d44e4d59 = [
    'nearest',
    'bilinear'
];
const $2fe284ee13368677$export$48aea51acf1bce87 = [
    'valid',
    'same',
    'causal'
];
const $2fe284ee13368677$export$f450a7a6767a84d4 = [
    'max',
    'avg'
];
const $2fe284ee13368677$export$954d8bae11304008 = [
    'sum',
    'mul',
    'concat',
    'ave'
];
const $2fe284ee13368677$export$96db941b47dbf9ff = [
    'temporal'
];

});


parcelRegister("lHlnu", function(module, exports) {

$parcel$export(module.exports, "Initializer", function () { return $fcbe32599a4b3690$export$9e14a7677ef1423c; });
$parcel$export(module.exports, "Zeros", function () { return $fcbe32599a4b3690$export$7a572cb9dc6aa81b; });
$parcel$export(module.exports, "Ones", function () { return $fcbe32599a4b3690$export$30750dcb47d2f6b; });
$parcel$export(module.exports, "Constant", function () { return $fcbe32599a4b3690$export$3c508fb3f8ac1ad4; });
$parcel$export(module.exports, "RandomUniform", function () { return $fcbe32599a4b3690$export$29e2b6f5e4b82e2f; });
$parcel$export(module.exports, "RandomNormal", function () { return $fcbe32599a4b3690$export$66e863738cfcc40; });
$parcel$export(module.exports, "TruncatedNormal", function () { return $fcbe32599a4b3690$export$5f0e8a39027050d5; });
$parcel$export(module.exports, "Identity", function () { return $fcbe32599a4b3690$export$544bf02140fa9a77; });
$parcel$export(module.exports, "VarianceScaling", function () { return $fcbe32599a4b3690$export$c2ba607ca0c6b5b3; });
$parcel$export(module.exports, "GlorotUniform", function () { return $fcbe32599a4b3690$export$c820ee55503e6df3; });
$parcel$export(module.exports, "GlorotNormal", function () { return $fcbe32599a4b3690$export$dcc636dfa962cdc9; });
$parcel$export(module.exports, "HeNormal", function () { return $fcbe32599a4b3690$export$399f315e5cbd5eed; });
$parcel$export(module.exports, "HeUniform", function () { return $fcbe32599a4b3690$export$4799f50fbef71375; });
$parcel$export(module.exports, "LeCunNormal", function () { return $fcbe32599a4b3690$export$f0843b4cb97b93f5; });
$parcel$export(module.exports, "LeCunUniform", function () { return $fcbe32599a4b3690$export$41b487c9c7cedfae; });
$parcel$export(module.exports, "Orthogonal", function () { return $fcbe32599a4b3690$export$7d101801017ddeaf; });
$parcel$export(module.exports, "serializeInitializer", function () { return $fcbe32599a4b3690$export$68de06a18c23bdbc; });
$parcel$export(module.exports, "getInitializer", function () { return $fcbe32599a4b3690$export$558b7d1a338df84b; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $8YZZT = parcelRequire("8YZZT");
var $4I5dI = parcelRequire("4I5dI");
var $5hAos = parcelRequire("5hAos");
var $K2k22 = parcelRequire("K2k22");
var $9ORo6 = parcelRequire("9ORo6");
var $7hONX = parcelRequire("7hONX");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");
var $9VTJm = parcelRequire("9VTJm");
var $lBDHD = parcelRequire("lBDHD");
var $lxzgt = parcelRequire("lxzgt");

var $4AyI5 = parcelRequire("4AyI5");

var $1Xyaa = parcelRequire("1Xyaa");

var $kubuc = parcelRequire("kubuc");

var $9deC8 = parcelRequire("9deC8");

var $jYx5u = parcelRequire("jYx5u");

var $4SWqG = parcelRequire("4SWqG");
function $fcbe32599a4b3690$export$c2c5543c407dbda7(value) {
    (0, $jYx5u.checkStringTypeUnionValue)((0, $9deC8.VALID_FAN_MODE_VALUES), 'FanMode', value);
}
function $fcbe32599a4b3690$export$46d720aa775f5a50(value) {
    (0, $jYx5u.checkStringTypeUnionValue)((0, $9deC8.VALID_DISTRIBUTION_VALUES), 'Distribution', value);
}
class $fcbe32599a4b3690$export$9e14a7677ef1423c extends (0, $ki3lz).Serializable {
    fromConfigUsesCustomObjects() {
        return false;
    }
    getConfig() {
        return {};
    }
}
class $fcbe32599a4b3690$export$7a572cb9dc6aa81b extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    apply(shape, dtype) {
        return (0, $lxzgt.zeros)(shape, dtype);
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$7a572cb9dc6aa81b.className = 'Zeros';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$7a572cb9dc6aa81b);
class $fcbe32599a4b3690$export$30750dcb47d2f6b extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    apply(shape, dtype) {
        return (0, $K2k22.ones)(shape, dtype);
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$30750dcb47d2f6b.className = 'Ones';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$30750dcb47d2f6b);
class $fcbe32599a4b3690$export$3c508fb3f8ac1ad4 extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    constructor(args){
        super();
        if (typeof args !== 'object') throw new (0, $kubuc.ValueError)(`Expected argument of type ConstantConfig but got ${args}`);
        if (args.value === undefined) throw new (0, $kubuc.ValueError)(`config must have value set but got ${args}`);
        this.value = args.value;
    }
    apply(shape, dtype) {
        return (0, $d7Nxs.tidy)(()=>(0, $5hAos.mul)((0, $7hONX.scalar)(this.value), (0, $K2k22.ones)(shape, dtype)));
    }
    getConfig() {
        return {
            value: this.value
        };
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$3c508fb3f8ac1ad4.className = 'Constant';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$3c508fb3f8ac1ad4);
class $fcbe32599a4b3690$export$29e2b6f5e4b82e2f extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MINVAL = -0.05;
        this.DEFAULT_MAXVAL = 0.05;
        this.minval = args.minval || this.DEFAULT_MINVAL;
        this.maxval = args.maxval || this.DEFAULT_MAXVAL;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        return (0, $9ORo6.randomUniform)(shape, this.minval, this.maxval, dtype, this.seed);
    }
    getConfig() {
        return {
            minval: this.minval,
            maxval: this.maxval,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$29e2b6f5e4b82e2f.className = 'RandomUniform';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$29e2b6f5e4b82e2f);
class $fcbe32599a4b3690$export$66e863738cfcc40 extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MEAN = 0.;
        this.DEFAULT_STDDEV = 0.05;
        this.mean = args.mean || this.DEFAULT_MEAN;
        this.stddev = args.stddev || this.DEFAULT_STDDEV;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        dtype = dtype || 'float32';
        if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $kubuc.NotImplementedError)(`randomNormal does not support dType ${dtype}.`);
        return $4AyI5.randomNormal(shape, this.mean, this.stddev, dtype, this.seed);
    }
    getConfig() {
        return {
            mean: this.mean,
            stddev: this.stddev,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$66e863738cfcc40.className = 'RandomNormal';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$66e863738cfcc40);
class $fcbe32599a4b3690$export$5f0e8a39027050d5 extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_MEAN = 0.;
        this.DEFAULT_STDDEV = 0.05;
        this.mean = args.mean || this.DEFAULT_MEAN;
        this.stddev = args.stddev || this.DEFAULT_STDDEV;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        dtype = dtype || 'float32';
        if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $kubuc.NotImplementedError)(`truncatedNormal does not support dType ${dtype}.`);
        return (0, $9VTJm.truncatedNormal)(shape, this.mean, this.stddev, dtype, this.seed);
    }
    getConfig() {
        return {
            mean: this.mean,
            stddev: this.stddev,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$5f0e8a39027050d5.className = 'TruncatedNormal';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$5f0e8a39027050d5);
class $fcbe32599a4b3690$export$544bf02140fa9a77 extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.gain = args.gain != null ? args.gain : 1.0;
    }
    apply(shape, dtype) {
        return (0, $d7Nxs.tidy)(()=>{
            if (shape.length !== 2 || shape[0] !== shape[1]) throw new (0, $kubuc.ValueError)("Identity matrix initializer can only be used for 2D square matrices.");
            else return (0, $5hAos.mul)(this.gain, (0, $8YZZT.eye)(shape[0]));
        });
    }
    getConfig() {
        return {
            gain: this.gain
        };
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$544bf02140fa9a77.className = 'Identity';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$544bf02140fa9a77);
/**
 * Computes the number of input and output units for a weight shape.
 * @param shape Shape of weight.
 * @param dataFormat data format to use for convolution kernels.
 *   Note that all kernels in Keras are standardized on the
 *   CHANNEL_LAST ordering (even when inputs are set to CHANNEL_FIRST).
 * @return An length-2 array: fanIn, fanOut.
 */ function $fcbe32599a4b3690$var$computeFans(shape, dataFormat = 'channelsLast') {
    let fanIn;
    let fanOut;
    (0, $1Xyaa.checkDataFormat)(dataFormat);
    if (shape.length === 2) {
        fanIn = shape[0];
        fanOut = shape[1];
    } else if ([
        3,
        4,
        5
    ].indexOf(shape.length) !== -1) {
        if (dataFormat === 'channelsFirst') {
            const receptiveFieldSize = (0, $4SWqG.arrayProd)(shape, 2);
            fanIn = shape[1] * receptiveFieldSize;
            fanOut = shape[0] * receptiveFieldSize;
        } else if (dataFormat === 'channelsLast') {
            const receptiveFieldSize = (0, $4SWqG.arrayProd)(shape, 0, shape.length - 2);
            fanIn = shape[shape.length - 2] * receptiveFieldSize;
            fanOut = shape[shape.length - 1] * receptiveFieldSize;
        }
    } else {
        const shapeProd = (0, $4SWqG.arrayProd)(shape);
        fanIn = Math.sqrt(shapeProd);
        fanOut = Math.sqrt(shapeProd);
    }
    return [
        fanIn,
        fanOut
    ];
}
class $fcbe32599a4b3690$export$c2ba607ca0c6b5b3 extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    /**
     * Constructor of VarianceScaling.
     * @throws ValueError for invalid value in scale.
     */ constructor(args){
        super();
        if (args.scale < 0.0) throw new (0, $kubuc.ValueError)(`scale must be a positive float. Got: ${args.scale}`);
        this.scale = args.scale == null ? 1.0 : args.scale;
        this.mode = args.mode == null ? 'fanIn' : args.mode;
        $fcbe32599a4b3690$export$c2c5543c407dbda7(this.mode);
        this.distribution = args.distribution == null ? 'normal' : args.distribution;
        $fcbe32599a4b3690$export$46d720aa775f5a50(this.distribution);
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        const fans = $fcbe32599a4b3690$var$computeFans(shape);
        const fanIn = fans[0];
        const fanOut = fans[1];
        let scale = this.scale;
        if (this.mode === 'fanIn') scale /= Math.max(1, fanIn);
        else if (this.mode === 'fanOut') scale /= Math.max(1, fanOut);
        else scale /= Math.max(1, (fanIn + fanOut) / 2);
        if (this.distribution === 'normal') {
            const stddev = Math.sqrt(scale);
            dtype = dtype || 'float32';
            if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $kubuc.NotImplementedError)(`${this.getClassName()} does not support dType ${dtype}.`);
            return (0, $9VTJm.truncatedNormal)(shape, 0, stddev, dtype, this.seed);
        } else {
            const limit = Math.sqrt(3 * scale);
            return (0, $9ORo6.randomUniform)(shape, -limit, limit, dtype, this.seed);
        }
    }
    getConfig() {
        return {
            scale: this.scale,
            mode: this.mode,
            distribution: this.distribution,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$c2ba607ca0c6b5b3.className = 'VarianceScaling';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$c2ba607ca0c6b5b3);
class $fcbe32599a4b3690$export$c820ee55503e6df3 extends $fcbe32599a4b3690$export$c2ba607ca0c6b5b3 {
    /**
     * Constructor of GlorotUniform
     * @param scale
     * @param mode
     * @param distribution
     * @param seed
     */ constructor(args){
        super({
            scale: 1.0,
            mode: 'fanAvg',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, GlorotUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $fcbe32599a4b3690$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$c820ee55503e6df3.className = 'GlorotUniform';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$c820ee55503e6df3);
class $fcbe32599a4b3690$export$dcc636dfa962cdc9 extends $fcbe32599a4b3690$export$c2ba607ca0c6b5b3 {
    /**
     * Constructor of GlorotNormal.
     * @param scale
     * @param mode
     * @param distribution
     * @param seed
     */ constructor(args){
        super({
            scale: 1.0,
            mode: 'fanAvg',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, GlorotNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $fcbe32599a4b3690$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$dcc636dfa962cdc9.className = 'GlorotNormal';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$dcc636dfa962cdc9);
class $fcbe32599a4b3690$export$399f315e5cbd5eed extends $fcbe32599a4b3690$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 2.0,
            mode: 'fanIn',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, HeNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $fcbe32599a4b3690$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$399f315e5cbd5eed.className = 'HeNormal';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$399f315e5cbd5eed);
class $fcbe32599a4b3690$export$4799f50fbef71375 extends $fcbe32599a4b3690$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 2.0,
            mode: 'fanIn',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, HeUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $fcbe32599a4b3690$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$4799f50fbef71375.className = 'HeUniform';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$4799f50fbef71375);
class $fcbe32599a4b3690$export$f0843b4cb97b93f5 extends $fcbe32599a4b3690$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 1.0,
            mode: 'fanIn',
            distribution: 'normal',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, LeCunNormal is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $fcbe32599a4b3690$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$f0843b4cb97b93f5.className = 'LeCunNormal';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$f0843b4cb97b93f5);
class $fcbe32599a4b3690$export$41b487c9c7cedfae extends $fcbe32599a4b3690$export$c2ba607ca0c6b5b3 {
    constructor(args){
        super({
            scale: 1.0,
            mode: 'fanIn',
            distribution: 'uniform',
            seed: args == null ? null : args.seed
        });
    }
    getClassName() {
        // In Python Keras, LeCunUniform is not a class, but a helper method
        // that creates a VarianceScaling object. Use 'VarianceScaling' as
        // class name to be compatible with that.
        return $fcbe32599a4b3690$export$c2ba607ca0c6b5b3.className;
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$41b487c9c7cedfae.className = 'LeCunUniform';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$41b487c9c7cedfae);
class $fcbe32599a4b3690$export$7d101801017ddeaf extends $fcbe32599a4b3690$export$9e14a7677ef1423c {
    constructor(args){
        super();
        this.DEFAULT_GAIN = 1;
        this.ELEMENTS_WARN_SLOW = 2000;
        this.gain = args.gain == null ? this.DEFAULT_GAIN : args.gain;
        this.seed = args.seed;
    }
    apply(shape, dtype) {
        return (0, $d7Nxs.tidy)(()=>{
            if (shape.length < 2) throw new (0, $kubuc.NotImplementedError)('Shape must be at least 2D.');
            if (dtype !== 'int32' && dtype !== 'float32' && dtype !== undefined) throw new TypeError(`Unsupported data type ${dtype}.`);
            dtype;
            // flatten the input shape with the last dimension remaining its
            // original shape so it works for conv2d
            const numRows = (0, $lBDHD).sizeFromShape(shape.slice(0, -1));
            const numCols = shape[shape.length - 1];
            const numElements = numRows * numCols;
            if (numElements > this.ELEMENTS_WARN_SLOW) console.warn(`Orthogonal initializer is being called on a matrix with more ` + `than ${this.ELEMENTS_WARN_SLOW} (${numElements}) elements: ` + `Slowness may result.`);
            const flatShape = [
                Math.max(numCols, numRows),
                Math.min(numCols, numRows)
            ];
            // Generate a random matrix
            const randNormalMat = $4AyI5.randomNormal(flatShape, 0, 1, dtype, this.seed);
            // Compute QR factorization
            const qr = (0, $4I5dI.linalg).qr(randNormalMat, false);
            let qMat = qr[0];
            const rMat = qr[1];
            // Make Q uniform
            const diag = rMat.flatten().stridedSlice([
                0
            ], [
                Math.min(numCols, numRows) * Math.min(numCols, numRows)
            ], [
                Math.min(numCols, numRows) + 1
            ]);
            qMat = (0, $5hAos.mul)(qMat, diag.sign());
            if (numRows < numCols) qMat = qMat.transpose();
            return (0, $5hAos.mul)((0, $7hONX.scalar)(this.gain), qMat.reshape(shape));
        });
    }
    getConfig() {
        return {
            gain: this.gain,
            seed: this.seed
        };
    }
}
/** @nocollapse */ $fcbe32599a4b3690$export$7d101801017ddeaf.className = 'Orthogonal';
(0, $ki3lz).registerClass($fcbe32599a4b3690$export$7d101801017ddeaf);
const $fcbe32599a4b3690$export$10005499b3b3c1de = {
    'constant': 'Constant',
    'glorotNormal': 'GlorotNormal',
    'glorotUniform': 'GlorotUniform',
    'heNormal': 'HeNormal',
    'heUniform': 'HeUniform',
    'identity': 'Identity',
    'leCunNormal': 'LeCunNormal',
    'leCunUniform': 'LeCunUniform',
    'ones': 'Ones',
    'orthogonal': 'Orthogonal',
    'randomNormal': 'RandomNormal',
    'randomUniform': 'RandomUniform',
    'truncatedNormal': 'TruncatedNormal',
    'varianceScaling': 'VarianceScaling',
    'zeros': 'Zeros'
};
function $fcbe32599a4b3690$var$deserializeInitializer(config, customObjects = {}) {
    return (0, $jYx5u.deserializeKerasObject)(config, (0, $ki3lz).SerializationMap.getMap().classNameMap, customObjects, 'initializer');
}
function $fcbe32599a4b3690$export$68de06a18c23bdbc(initializer) {
    return (0, $jYx5u.serializeKerasObject)(initializer);
}
function $fcbe32599a4b3690$export$558b7d1a338df84b(identifier) {
    if (typeof identifier === 'string') {
        const className = identifier in $fcbe32599a4b3690$export$10005499b3b3c1de ? $fcbe32599a4b3690$export$10005499b3b3c1de[identifier] : identifier;
        /* We have four 'helper' classes for common initializers that
        all get serialized as 'VarianceScaling' and shouldn't go through
        the deserializeInitializer pathway. */ if (className === 'GlorotNormal') return new $fcbe32599a4b3690$export$dcc636dfa962cdc9();
        else if (className === 'GlorotUniform') return new $fcbe32599a4b3690$export$c820ee55503e6df3();
        else if (className === 'HeNormal') return new $fcbe32599a4b3690$export$399f315e5cbd5eed();
        else if (className === 'HeUniform') return new $fcbe32599a4b3690$export$4799f50fbef71375();
        else if (className === 'LeCunNormal') return new $fcbe32599a4b3690$export$f0843b4cb97b93f5();
        else if (className === 'LeCunUniform') return new $fcbe32599a4b3690$export$41b487c9c7cedfae();
        else {
            const config = {};
            config['className'] = className;
            config['config'] = {};
            return $fcbe32599a4b3690$var$deserializeInitializer(config);
        }
    } else if (identifier instanceof $fcbe32599a4b3690$export$9e14a7677ef1423c) return identifier;
    else return $fcbe32599a4b3690$var$deserializeInitializer(identifier);
}

});
parcelRegister("4AyI5", function(module, exports) {

$parcel$export(module.exports, "cast", function () { return $357572e9b26eb4b3$export$f2db7d5238e1d23f; });
$parcel$export(module.exports, "expandDims", function () { return $357572e9b26eb4b3$export$d660d8ed21f46635; });
$parcel$export(module.exports, "repeat", function () { return $357572e9b26eb4b3$export$76d90c956114f2c2; });
$parcel$export(module.exports, "tile", function () { return $357572e9b26eb4b3$export$3c17558da18e4d75; });
$parcel$export(module.exports, "flatten", function () { return $357572e9b26eb4b3$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "batchFlatten", function () { return $357572e9b26eb4b3$export$6d182438241cb7ab; });
$parcel$export(module.exports, "sliceAlongFirstAxis", function () { return $357572e9b26eb4b3$export$4f266636a9634575; });
$parcel$export(module.exports, "sliceAlongAxis", function () { return $357572e9b26eb4b3$export$4f25f657b7083746; });
$parcel$export(module.exports, "concatenate", function () { return $357572e9b26eb4b3$export$375c71d43969527d; });
$parcel$export(module.exports, "concatAlongFirstAxis", function () { return $357572e9b26eb4b3$export$2c8a4d3eab2092a2; });
$parcel$export(module.exports, "randomNormal", function () { return $357572e9b26eb4b3$export$a0ac5549a8bec918; });
$parcel$export(module.exports, "dot", function () { return $357572e9b26eb4b3$export$94132a0e348806d4; });
$parcel$export(module.exports, "gather", function () { return $357572e9b26eb4b3$export$9e05546f00427e8; });
$parcel$export(module.exports, "square", function () { return $357572e9b26eb4b3$export$dd4f28cef696bc7d; });
$parcel$export(module.exports, "biasAdd", function () { return $357572e9b26eb4b3$export$917ce53bce63bd4b; });
$parcel$export(module.exports, "elu", function () { return $357572e9b26eb4b3$export$796b583dd79d8524; });
$parcel$export(module.exports, "softsign", function () { return $357572e9b26eb4b3$export$6def925d7f33a45c; });
$parcel$export(module.exports, "dropout", function () { return $357572e9b26eb4b3$export$fe05aa12367b4e47; });
$parcel$export(module.exports, "hardSigmoid", function () { return $357572e9b26eb4b3$export$150f2d52960480ef; });
$parcel$export(module.exports, "inTrainPhase", function () { return $357572e9b26eb4b3$export$5a6eea8e1dcefeb7; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * deeplearn.js backend.
 */ parcelRequire("8AHkS");
var $57D4R = parcelRequire("57D4R");
var $6Ab5n = parcelRequire("6Ab5n");
var $fxiHg = parcelRequire("fxiHg");
var $iAQYk = parcelRequire("iAQYk");
var $1goxr = parcelRequire("1goxr");
var $j5YCL = parcelRequire("j5YCL");
var $kEtq4 = parcelRequire("kEtq4");
var $601hZ = parcelRequire("601hZ");
var $30mc4 = parcelRequire("30mc4");
var $dIChU = parcelRequire("dIChU");
var $e1QJV = parcelRequire("e1QJV");
var $4YAd3 = parcelRequire("4YAd3");
var $28GAP = parcelRequire("28GAP");
var $eJ7TQ = parcelRequire("eJ7TQ");
var $eFeE9 = parcelRequire("eFeE9");
var $lOlhm = parcelRequire("lOlhm");
var $5hAos = parcelRequire("5hAos");
var $7k013 = parcelRequire("7k013");
var $6zg0w = parcelRequire("6zg0w");
var $eCViQ = parcelRequire("eCViQ");
var $kaIUV = parcelRequire("kaIUV");
var $8nMOl = parcelRequire("8nMOl");
var $7hONX = parcelRequire("7hONX");
var $d7Nxs = parcelRequire("d7Nxs");
var $l7afw = parcelRequire("l7afw");
var $c8zsf = parcelRequire("c8zsf");
var $kzTOv = parcelRequire("kzTOv");
var $gaDoi = parcelRequire("gaDoi");
var $6aiGU = parcelRequire("6aiGU");
var $8tOOR = parcelRequire("8tOOR");
var $dolPi = parcelRequire("dolPi");
var $9c2so = parcelRequire("9c2so");
var $3A1QZ = parcelRequire("3A1QZ");
var $cztsD = parcelRequire("cztsD");

var $1Xyaa = parcelRequire("1Xyaa");

var $kubuc = parcelRequire("kubuc");

var $4SWqG = parcelRequire("4SWqG");

var $69VqB = parcelRequire("69VqB");
// tslint:enable
/* Setting and getting backend from deeplearn.js. */ // Default deeplearn.js backend is WebGL (GPU).
let $357572e9b26eb4b3$var$backend = 'webgl';
function $357572e9b26eb4b3$export$7953970fabc9c2(requestedBackend) {
    $d7Nxs.setBackend(requestedBackend);
    $357572e9b26eb4b3$var$backend = requestedBackend;
}
function $357572e9b26eb4b3$export$b098501f764cdf30() {
    return $357572e9b26eb4b3$var$backend;
}
function $357572e9b26eb4b3$export$c3a33bdbf7249794() {
    return false;
}
function $357572e9b26eb4b3$export$230bf2dc3171638d(x) {
    const shape = x.shape;
    if (shape.length > 0) return shape.reduce((a, b)=>a * b);
    else // Scalar.
    return 1;
}
function $357572e9b26eb4b3$export$f2db7d5238e1d23f(x, dtype) {
    return $fxiHg.cast(x, dtype);
}
function $357572e9b26eb4b3$export$d660d8ed21f46635(x, axis = -1) {
    const outShape = x.shape.slice();
    if (axis < 0) axis = outShape.length + axis + 1;
    outShape.splice(axis, 0, 1);
    return $8nMOl.reshape(x, outShape);
}
function $357572e9b26eb4b3$export$76d90c956114f2c2(x, n) {
    return (0, $d7Nxs.tidy)(()=>{
        if (x.shape.length !== 2) throw new (0, $kubuc.ValueError)(`repeat() expects a rank-2 tensor, but received a ` + `rank-${x.shape.length} tensor.`);
        const y = $357572e9b26eb4b3$export$d660d8ed21f46635(x, 1);
        return $357572e9b26eb4b3$export$3c17558da18e4d75(y, [
            1,
            n,
            1
        ]);
    });
}
function $357572e9b26eb4b3$export$bffa455ba8c619a6(x) {
    const newShape = [
        $4SWqG.arrayProd(x.shape)
    ];
    return $8nMOl.reshape(x, newShape);
}
function $357572e9b26eb4b3$export$6d182438241cb7ab(x) {
    if (x.rank <= 1) throw new (0, $kubuc.ValueError)(`batchFlatten requires a minimum rank of 2. Got rank: ${x.rank}.`);
    const newShape = [
        x.shape[0],
        $4SWqG.arrayProd(x.shape, 1)
    ];
    return $8nMOl.reshape(x, newShape);
}
function $357572e9b26eb4b3$export$4f266636a9634575(array, start, size) {
    return (0, $d7Nxs.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $c8zsf.slice1d(array, start, size);
            case 2:
                return $kzTOv.slice2d(array, [
                    start,
                    0
                ], [
                    size,
                    array.shape[1]
                ]);
            case 3:
                return $gaDoi.slice3d(array, [
                    start,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2]
                ]);
            case 4:
                return $6aiGU.slice4d(array, [
                    start,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3]
                ]);
            case 5:
                return $l7afw.slice(array, [
                    start,
                    0,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3],
                    array.shape[4]
                ]);
            case 6:
                return $l7afw.slice(array, [
                    start,
                    0,
                    0,
                    0,
                    0,
                    0
                ], [
                    size,
                    array.shape[1],
                    array.shape[2],
                    array.shape[3],
                    array.shape[4],
                    array.shape[5]
                ]);
            default:
                throw new (0, $kubuc.ValueError)(`sliceAlongFirstAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $357572e9b26eb4b3$export$7eb01d0ca77de013(array, start, size) {
    return (0, $d7Nxs.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $c8zsf.slice1d(array, start, size);
            case 2:
                return $kzTOv.slice2d(array, [
                    0,
                    start
                ], [
                    array.shape[0],
                    size
                ]);
            case 3:
                return $gaDoi.slice3d(array, [
                    0,
                    0,
                    start
                ], [
                    array.shape[0],
                    array.shape[1],
                    size
                ]);
            case 4:
                return $6aiGU.slice4d(array, [
                    0,
                    0,
                    0,
                    start
                ], [
                    array.shape[0],
                    array.shape[1],
                    array.shape[2],
                    size
                ]);
            default:
                throw new (0, $kubuc.ValueError)(`sliceAlongLastAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $357572e9b26eb4b3$export$4f25f657b7083746(array, start, size, axis) {
    return (0, $d7Nxs.tidy)(()=>{
        switch(array.rank){
            case 1:
                return $c8zsf.slice1d(array, start, size);
            case 2:
                switch(axis){
                    case 1:
                        return $357572e9b26eb4b3$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $357572e9b26eb4b3$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $kubuc.ValueError)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            case 3:
                switch(axis){
                    case 1:
                        return $357572e9b26eb4b3$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $gaDoi.slice3d(array, [
                            0,
                            start,
                            0
                        ], [
                            array.shape[0],
                            size,
                            array.shape[2]
                        ]);
                    case 3:
                        return $357572e9b26eb4b3$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $kubuc.ValueError)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            case 4:
                switch(axis){
                    case 1:
                        return $357572e9b26eb4b3$export$4f266636a9634575(array, start, size);
                    case 2:
                        return $6aiGU.slice4d(array, [
                            0,
                            start,
                            0,
                            0
                        ], [
                            array.shape[0],
                            size,
                            array.shape[2],
                            array.shape[3]
                        ]);
                    case 3:
                        return $6aiGU.slice4d(array, [
                            0,
                            0,
                            start,
                            0
                        ], [
                            array.shape[0],
                            array.shape[1],
                            size,
                            array.shape[3]
                        ]);
                    case 4:
                        return $357572e9b26eb4b3$export$7eb01d0ca77de013(array, start, size);
                    default:
                        throw new (0, $kubuc.ValueError)(`The axis is not within the rank of the tensor ` + `${axis}`);
                }
            default:
                throw new (0, $kubuc.ValueError)(`sliceAlongLastAxis() received an unsupported tensor rank: ` + `${array.rank}`);
        }
    });
}
function $357572e9b26eb4b3$export$375c71d43969527d(tensors, axis = -1) {
    let rank;
    if (axis < 0) {
        rank = tensors[0].rank;
        if (rank !== 0) axis = rank;
        else axis = 0;
    }
    if (axis === tensors[0].rank) // Porting Note: This is necessary because tfc.concat() requires axis to be
    //   in the interval [-rank, rank).
    axis = -1;
    // Porting Note: Sparse concat is not supported yet.
    return $1goxr.concat(tensors, axis);
}
function $357572e9b26eb4b3$export$2c8a4d3eab2092a2(a, b) {
    switch(a.rank){
        case 1:
            return $j5YCL.concat1d([
                a,
                b
            ]);
        case 2:
            return $kEtq4.concat2d([
                a,
                b
            ], 0);
        case 3:
            return $601hZ.concat3d([
                a,
                b
            ], 0);
        case 4:
            return $30mc4.concat4d([
                a,
                b
            ], 0);
        default:
            throw new (0, $kubuc.ValueError)(`concatAlongFirstAxis() received an unsupported ` + `tensor rank: ${a.rank}`);
    }
}
function $357572e9b26eb4b3$export$3c17558da18e4d75(x, n) {
    if (!Array.isArray(n)) n = [
        n
    ];
    if (x.rank !== n.length) throw new (0, $kubuc.ValueError)(`The length of input n (${n.length}) does not match ` + `the number of dimensions in input x (${x.rank})`);
    return $dolPi.tile(x, n);
}
function $357572e9b26eb4b3$export$a0ac5549a8bec918(shape, mean = 0.0, stddev = 1.0, dtype, seed) {
    return $kaIUV.randomNormal(shape, mean, stddev, dtype, seed);
}
function $357572e9b26eb4b3$export$94132a0e348806d4(a, b, activation, bias) {
    if (a.rank < 2 || b.rank < 2) throw new (0, $kubuc.NotImplementedError)(`dot requires both inputs to be rank >= 2` + ` but got x shape = ${a.shape} and y shape = ${b.shape}`);
    if (b.rank >= 3) {
        const xLastDim = a.shape.slice(-1)[0];
        const ySecondLastDim = b.shape.slice(-2)[0];
        if (xLastDim !== ySecondLastDim) throw new (0, $kubuc.NotImplementedError)(`If rank y >= 3, then the second last dim` + ` of y must equal the last dim of x but got x shape = ${a.shape} and ` + ` y shape = ${b.shape}`);
    }
    // Handle basic 2D x 2D case.
    if (a.rank === 2 && b.rank === 2) {
        const transposeA = false;
        const transposeB = false;
        // tfc.fused.matMul only fuses certain activation functions. Unsupported
        // activation functions are treated as 'linear' activations, which is
        // equivalent to a no-op.
        return $eJ7TQ.matMul({
            a: a,
            b: b,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias ? $357572e9b26eb4b3$var$reshapeBias(a.rank, bias, (0, $69VqB.imageDataFormat)()) : null,
            activation: activation
        });
    } else {
        // Reshape x into the analogous 2D Tensor.
        const aFirstDims = a.shape.slice(); // Holds all but the last dim of x.
        const aLastDim = aFirstDims.pop();
        a = $8nMOl.reshape(a, [
            -1,
            aLastDim
        ]);
        // Reshape y into the analogous 2D Tensor, and keep track of the
        // required dimensions to reproduce the output shape.
        const bShape = b.shape.slice();
        const bLastDim = bShape.pop();
        const ySecondLastDim = bShape.pop();
        const yOtherDims = [
            ...bShape,
            bLastDim
        ];
        // permutation should be like [r-2, 0, 1, 2, ... r-4, r-3, r-1]
        // where r is the rank of y.
        const perm = Array.from({
            length: b.rank
        }, (_, i)=>{
            if (i === 0) return b.rank - 2;
            else if (i <= b.rank - 2) return i - 1;
            return i;
        });
        b = $8nMOl.reshape($9c2so.transpose(b, perm), [
            ySecondLastDim,
            -1
        ]);
        // Multiply x and y as 2D Tensors, and then reshape back to original.
        const outputShape = [
            ...aFirstDims,
            ...yOtherDims
        ];
        const transposeA = false;
        const transposeB = false;
        return $8nMOl.reshape($eJ7TQ.matMul({
            a: a,
            b: b,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias ? $357572e9b26eb4b3$var$reshapeBias(a.rank, bias, (0, $69VqB.imageDataFormat)()) : null,
            activation: activation
        }), outputShape);
    }
}
function $357572e9b26eb4b3$export$c5552dfdbc7cec71(x) {
    // TODO(cais): Move to the core.
    return (0, $d7Nxs.tidy)(()=>{
        const zerosLikeX = (0, $cztsD.zerosLike)(x);
        const onesLikeX = (0, $6zg0w.onesLike)(x);
        return (0, $3A1QZ.where)($28GAP.equal(x, zerosLikeX), zerosLikeX, (0, $3A1QZ.where)($lOlhm.greater(x, (0, $cztsD.zerosLike)(x)), onesLikeX, $5hAos.mul(-1, onesLikeX)));
    });
}
function $357572e9b26eb4b3$export$341b5490a776d041(indices, numClasses) {
    return (0, $d7Nxs.tidy)(()=>{
        if (indices.rank !== 1) throw new Error("Only 1D one-hot tensors are supported in the deeplearn backend, at present.");
        indices = $fxiHg.cast(indices, 'int32');
        return $fxiHg.cast($7k013.oneHot(indices, numClasses), 'float32');
    });
}
function $357572e9b26eb4b3$export$9e05546f00427e8(reference, indices, axis) {
    return (0, $d7Nxs.tidy)(()=>{
        if (Array.isArray(indices)) indices = (0, $8tOOR.tensor1d)(indices, 'int32');
        else indices = $fxiHg.cast(indices, 'int32');
        return $eFeE9.gather(reference, indices, axis);
    });
}
function $357572e9b26eb4b3$export$dd4f28cef696bc7d(x) {
    return $5hAos.mul(x, x);
}
function $357572e9b26eb4b3$export$9c297f60e22e3389(x, a) {
    return (0, $d7Nxs.tidy)(()=>{
        if (typeof a === 'number') a = (0, $7hONX.scalar)(Math.round(a), 'int32');
        if (a.dtype !== 'int32') throw new (0, $kubuc.NotImplementedError)(`Non-int32 dtype (${a.dtype}) is not supported by pow() yet`);
        return $eCViQ.pow(x, a);
    });
}
/**
 * Reshapes bias tensor according to rank of x.
 */ function $357572e9b26eb4b3$var$reshapeBias(xRank, bias, dataFormat) {
    const biasShape = bias.shape;
    if (bias.rank !== 1 && bias.rank !== xRank) throw new (0, $kubuc.ValueError)(`Unexpected bias dimensions: ${bias.rank}` + `; expected it to be 1 or ${xRank}`);
    if (xRank === 5) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $8nMOl.reshape(bias, [
                1,
                biasShape[0],
                1,
                1,
                1
            ]);
            else return $8nMOl.reshape(bias, [
                1,
                biasShape[3],
                biasShape[0],
                biasShape[1],
                biasShape[2]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $8nMOl.reshape(bias, [
                1,
                1,
                1,
                1,
                biasShape[0]
            ]);
            else return $8nMOl.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank === 4) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $8nMOl.reshape(bias, [
                1,
                biasShape[0],
                1,
                1
            ]);
            else return $8nMOl.reshape(bias, [
                1,
                biasShape[2],
                biasShape[0],
                biasShape[1]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $8nMOl.reshape(bias, [
                1,
                1,
                1,
                biasShape[0]
            ]);
            else return $8nMOl.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank === 3) {
        if (dataFormat === 'channelsFirst') {
            if (biasShape.length === 1) return $8nMOl.reshape(bias, [
                1,
                biasShape[0],
                1
            ]);
            else return $8nMOl.reshape(bias, [
                1,
                biasShape[1],
                biasShape[0]
            ]);
        } else if (dataFormat === 'channelsLast') {
            if (biasShape.length === 1) return $8nMOl.reshape(bias, [
                1,
                1,
                biasShape[0]
            ]);
            else return $8nMOl.reshape(bias, [
                1
            ].concat(biasShape));
        }
    } else if (xRank < 3) return bias;
    throw new (0, $kubuc.ValueError)(`Unsupported input rank by biasAdd: ${bias.rank}`);
}
function $357572e9b26eb4b3$export$917ce53bce63bd4b(x, bias, dataFormat) {
    return (0, $d7Nxs.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $69VqB.imageDataFormat)();
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        return $6Ab5n.add(x, $357572e9b26eb4b3$var$reshapeBias(x.rank, bias, dataFormat));
    });
}
function $357572e9b26eb4b3$export$796b583dd79d8524(x, alpha = 1) {
    // TODO(cais): Add support for alpha values other than 1.
    if (alpha !== 1) throw new (0, $kubuc.NotImplementedError)(`Support for alpha values other than 1 (${alpha}) is not implemented ` + `yet.`);
    return $4YAd3.elu(x);
}
function $357572e9b26eb4b3$export$6def925d7f33a45c(x) {
    return (0, $d7Nxs.tidy)(()=>$dIChU.div(x, $6Ab5n.add($57D4R.abs(x), 1)));
}
function $357572e9b26eb4b3$export$fe05aa12367b4e47(x, level, noiseShape, seed) {
    return (0, $d7Nxs.tidy)(()=>$e1QJV.dropout(x, level, noiseShape, seed));
}
function $357572e9b26eb4b3$export$150f2d52960480ef(x) {
    return (0, $d7Nxs.tidy)(()=>{
        const y = $6Ab5n.add(.5, $5hAos.mul(.2, x));
        return $iAQYk.clipByValue(y, 0, 1);
    });
}
function $357572e9b26eb4b3$export$5a6eea8e1dcefeb7(x, alt, training = false) {
    return training ? x() : alt();
}

});
parcelRegister("4SWqG", function(module, exports) {

$parcel$export(module.exports, "isInteger", function () { return $38e9876cf86e703b$export$a287f47fed4544b8; });
$parcel$export(module.exports, "arrayProd", function () { return $38e9876cf86e703b$export$3b5d61e59fec5e86; });
$parcel$export(module.exports, "min", function () { return $38e9876cf86e703b$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $38e9876cf86e703b$export$8960430cfd85939f; });
$parcel$export(module.exports, "range", function () { return $38e9876cf86e703b$export$d02631cccf789723; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Math utility functions.
 *
 * This file contains some frequently used math function that operates on
 * number[] or Float32Array and return a number. Many of these functions are
 * not-so-thick wrappers around TF.js Core functions. But they offer the
 * convenience of
 * 1) not having to convert the inputs into Tensors,
 * 2) not having to convert the returned Tensors to numbers.
 */ 
var $kubuc = parcelRequire("kubuc");
function $38e9876cf86e703b$export$a287f47fed4544b8(x) {
    return x === parseInt(x.toString(), 10);
}
function $38e9876cf86e703b$export$3b5d61e59fec5e86(array, begin, end) {
    if (begin == null) begin = 0;
    if (end == null) end = array.length;
    let prod = 1;
    for(let i = begin; i < end; ++i)prod *= array[i];
    return prod;
}
function $38e9876cf86e703b$export$96ec731ed4dcb222(array) {
    // same behavior as tf.min()
    if (array.length === 0) return Number.NaN;
    let min = Number.POSITIVE_INFINITY;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        if (value < min) min = value;
    }
    return min;
}
function $38e9876cf86e703b$export$8960430cfd85939f(array) {
    // same behavior as tf.max()
    if (array.length === 0) return Number.NaN;
    let max = Number.NEGATIVE_INFINITY;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        if (value > max) max = value;
    }
    return max;
}
function $38e9876cf86e703b$export$8a63f25cc62965f1(array) {
    let sum = 0;
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        sum += value;
    }
    return sum;
}
function $38e9876cf86e703b$export$1ce691f85baaa52(array) {
    return $38e9876cf86e703b$export$8a63f25cc62965f1(array) / array.length;
}
function $38e9876cf86e703b$export$9b77da0927470c3d(array) {
    const meanValue = $38e9876cf86e703b$export$1ce691f85baaa52(array);
    const demeaned = array.map((value)=>value - meanValue);
    let sumSquare = 0;
    for(let i = 0; i < demeaned.length; i++){
        const value = demeaned[i];
        sumSquare += value * value;
    }
    return sumSquare / array.length;
}
function $38e9876cf86e703b$export$9c490b34b2f16a34(array) {
    const arraySorted = array.slice().sort((a, b)=>a - b);
    const lowIdx = Math.floor((arraySorted.length - 1) / 2);
    const highIdx = Math.ceil((arraySorted.length - 1) / 2);
    if (lowIdx === highIdx) return arraySorted[lowIdx];
    return (arraySorted[lowIdx] + arraySorted[highIdx]) / 2;
}
function $38e9876cf86e703b$export$d02631cccf789723(begin, end) {
    if (end < begin) throw new (0, $kubuc.ValueError)(`end (${end}) < begin (${begin}) is forbidden.`);
    const out = [];
    for(let i = begin; i < end; ++i)out.push(i);
    return out;
}

});

parcelRegister("69VqB", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return $47c02156d14598dd$export$6c421550c66a327d; });
$parcel$export(module.exports, "imageDataFormat", function () { return $47c02156d14598dd$export$9cb785636e5e0d8; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");
let $47c02156d14598dd$var$_epsilon;
function $47c02156d14598dd$export$6c421550c66a327d() {
    if ($47c02156d14598dd$var$_epsilon == null) $47c02156d14598dd$var$_epsilon = (0, $d7Nxs.backend)().epsilon();
    return $47c02156d14598dd$var$_epsilon;
}
function $47c02156d14598dd$export$15daaec7a0b3c780(e) {
    $47c02156d14598dd$var$_epsilon = e;
}
function $47c02156d14598dd$export$9cb785636e5e0d8() {
    return 'channelsLast';
}

});


parcelRegister("9deC8", function(module, exports) {

$parcel$export(module.exports, "VALID_FAN_MODE_VALUES", function () { return $6b50aa00b4a83e33$export$6f4ea9ac290c463f; });
$parcel$export(module.exports, "VALID_DISTRIBUTION_VALUES", function () { return $6b50aa00b4a83e33$export$a0651197744e50ce; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ const $6b50aa00b4a83e33$export$6f4ea9ac290c463f = [
    'fanIn',
    'fanOut',
    'fanAvg'
];
const $6b50aa00b4a83e33$export$a0651197744e50ce = [
    'normal',
    'uniform',
    'truncatedNormal'
];
const $6b50aa00b4a83e33$export$989dbab10a7a8537 = [
    'Zeros',
    'Ones',
    'Constant',
    'RandomNormal',
    'RandomUniform',
    'TruncatedNormal',
    'VarianceScaling',
    'Orthogonal',
    'Identity'
];

});


parcelRegister("bMNfZ", function(module, exports) {

$parcel$export(module.exports, "isArrayOfShapes", function () { return $894a62ca4df2ead7$export$3297ca286d903db0; });
$parcel$export(module.exports, "normalizeShapeList", function () { return $894a62ca4df2ead7$export$4cdd3da5579ac4c4; });
$parcel$export(module.exports, "getExactlyOneTensor", function () { return $894a62ca4df2ead7$export$5327fe015af69a7b; });
$parcel$export(module.exports, "getExactlyOneShape", function () { return $894a62ca4df2ead7$export$25c35af872e8abca; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $kubuc = parcelRequire("kubuc");
function $894a62ca4df2ead7$export$3297ca286d903db0(x) {
    return Array.isArray(x) && Array.isArray(x[0]);
}
function $894a62ca4df2ead7$export$4cdd3da5579ac4c4(x) {
    if (x.length === 0) return [];
    if (!Array.isArray(x[0])) return [
        x
    ];
    return x;
}
function $894a62ca4df2ead7$export$5327fe015af69a7b(xs) {
    let x;
    if (Array.isArray(xs)) {
        if (xs.length !== 1) throw new (0, $kubuc.ValueError)(`Expected Tensor length to be 1; got ${xs.length}`);
        x = xs[0];
    } else x = xs;
    return x;
}
function $894a62ca4df2ead7$export$25c35af872e8abca(shapes) {
    if (Array.isArray(shapes) && Array.isArray(shapes[0])) {
        if (shapes.length === 1) {
            shapes;
            return shapes[0];
        } else throw new (0, $kubuc.ValueError)(`Expected exactly 1 Shape; got ${shapes.length}`);
    } else return shapes;
}

});

parcelRegister("7iQkf", function(module, exports) {

$parcel$export(module.exports, "countParamsInWeights", function () { return $5512cda227b15274$export$2a41d41251f01d03; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Count the elements in an Array of LayerVariables.
 *
 * @param weights: The LayerVariables of which the constituent numbers are to
 *   be counted.
 * @returns A count of the elements in all the LayerVariables
 */ function $5512cda227b15274$export$2a41d41251f01d03(weights) {
    let count = 0;
    for (const weight of weights)if (weight.shape.length === 0) count += 1;
    else count += weight.shape.reduce((a, b)=>a * b);
    return count;
}

});

parcelRegister("pKVrB", function(module, exports) {

$parcel$export(module.exports, "LayerVariable", function () { return $04d6bc585df55916$export$25de78a5a5bf7257; });
$parcel$export(module.exports, "batchGetValue", function () { return $04d6bc585df55916$export$3702262f615cc9f0; });
$parcel$export(module.exports, "batchSetValue", function () { return $04d6bc585df55916$export$6b1a34257a4982e4; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $8YZZT = parcelRequire("8YZZT");
var $K2k22 = parcelRequire("K2k22");
var $6zg0w = parcelRequire("6zg0w");
var $kaIUV = parcelRequire("kaIUV");
var $9ORo6 = parcelRequire("9ORo6");
var $5jGN9 = parcelRequire("5jGN9");
var $9VTJm = parcelRequire("9VTJm");
var $ftQEj = parcelRequire("ftQEj");
var $1Npyr = parcelRequire("1Npyr");
var $lxzgt = parcelRequire("lxzgt");
var $cztsD = parcelRequire("cztsD");

var $cExd6 = parcelRequire("cExd6");

var $1Xyaa = parcelRequire("1Xyaa");

var $kubuc = parcelRequire("kubuc");
const $04d6bc585df55916$var$DEFAULT_VARIABLE_NAME_PREFIX = 'Variable';
class $04d6bc585df55916$export$25de78a5a5bf7257 {
    /**
     * Construct Variable from a `tf.Tensor`.
     *
     * If not explicitly named, the Variable will be given a name with the
     * prefix 'Variable'. Variable names are unique. In the case of name
     * collision, suffixies '_<num>' will be added to the name.
     *
     * @param val Initial value of the Variable.
     * @param name Name of the variable. If `null` or `undefined` is provided, it
     *   will default a name with the prefix 'Variable'.
     * @param constraint Optional, projection function to be applied to the
     * variable after optimize updates
     * @throws ValueError if `name` is `null` or `undefined`.
     */ constructor(val, dtype = 'float32', name = $04d6bc585df55916$var$DEFAULT_VARIABLE_NAME_PREFIX, trainable = true, constraint = null){
        this.dtype = dtype == null ? 'float32' : dtype;
        this.shape = val.shape;
        this.id = (0, $cExd6.getNextUniqueTensorId)();
        name = name == null ? $04d6bc585df55916$var$DEFAULT_VARIABLE_NAME_PREFIX : name;
        this.originalName = (0, $1Xyaa.getScopedTensorName)(name);
        this.name = (0, $1Xyaa.getUniqueTensorName)(this.originalName);
        this.trainable_ = trainable;
        this.constraint = constraint;
        this.val = $ftQEj.variable(val, this.trainable_, this.name, this.dtype);
    }
    /**
     * Get a snapshot of the Variable's value.
     *
     * The returned value is a snapshot of the Variable's value at the time of
     * the invocation. Future mutations in the value of the tensor will only
     * be reflected by future calls to this method.
     */ read() {
        this.assertNotDisposed();
        return this.val;
    }
    /**
     * Update the value of the Variable.
     *
     * @param newVal: The new value to update to. Must be consistent with the
     *   dtype and shape of the Variable.
     * @return This Variable.
     */ write(newVal) {
        // TODO(cais): Once  TF.js Core supports Tensor.dtype, check dtype match.
        this.assertNotDisposed();
        $04d6bc585df55916$var$checkShapesMatch(this.val, newVal);
        // Skip updating if this is the exact same tensor.
        if (this.val.id !== newVal.id) {
            this.val.assign(newVal);
            if (this.constraint != null) this.val.assign(this.constraint.apply(this.val));
        }
        return this;
    }
    /**
     * Dispose this LayersVariable instance from memory.
     */ dispose() {
        this.assertNotDisposed();
        this.val.dispose();
    }
    assertNotDisposed() {
        if (this.val.isDisposed) throw new Error(`LayersVariable ${this.name} is already disposed.`);
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this.trainable_ = trainable;
        this.val.trainable = trainable;
    }
}
function $04d6bc585df55916$var$checkShapesMatch(x, y) {
    if (x.shape.toString() !== y.shape.toString()) throw new Error('Shape mismatch: ' + JSON.stringify(x.shape) + ' vs. ' + JSON.stringify(y.shape));
}
function $04d6bc585df55916$export$3a9d57cefcd2c285(x, dtype, name, constraint) {
    return new $04d6bc585df55916$export$25de78a5a5bf7257(x, dtype, name, true, constraint);
}
function $04d6bc585df55916$export$b57b9b034d1223d7(shape, dtype, name) {
    // TODO(cais): Implement logic for dtype.
    return new $04d6bc585df55916$export$25de78a5a5bf7257($lxzgt.zeros(shape), dtype, name);
}
function $04d6bc585df55916$export$cb1f824e7733584d(x, dtype, name) {
    return new $04d6bc585df55916$export$25de78a5a5bf7257($cztsD.zerosLike(x), dtype, name);
}
function $04d6bc585df55916$export$f21b2d0b36d5e3a3(shape, dtype, name) {
    // TODO(cais): Implement logic for dtype.
    const allocated = $K2k22.ones(shape);
    return new $04d6bc585df55916$export$25de78a5a5bf7257(allocated, dtype, name);
}
function $04d6bc585df55916$export$fb6afd6214fee9e9(x, dtype, name) {
    const allocated = $6zg0w.onesLike(x);
    return new $04d6bc585df55916$export$25de78a5a5bf7257(allocated, dtype, name);
}
function $04d6bc585df55916$export$a48ae747268ddcb4(size, dtype, name) {
    return new $04d6bc585df55916$export$25de78a5a5bf7257($8YZZT.eye(size), dtype, name);
}
function $04d6bc585df55916$export$53e488f964846878(shape, minval, maxval, dtype, seed, name = 'randomUniform') {
    return new $04d6bc585df55916$export$25de78a5a5bf7257($9ORo6.randomUniform(shape, minval, maxval, dtype), dtype, name);
}
function $04d6bc585df55916$export$6a7d47f4711fe0f5(shape, mean = 0.0, stddev = 1.0, dtype, seed, name = 'truncatedNormal') {
    // TODO(cais): Implement logic for dtype and seed once they are supported
    // by deeplearn.js.
    dtype = dtype || 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $kubuc.NotImplementedError)(`randomNormal does not support dType ${dtype}.`);
    return new $04d6bc585df55916$export$25de78a5a5bf7257($9VTJm.truncatedNormal(shape, mean, stddev, dtype, seed), dtype, name);
}
function $04d6bc585df55916$export$3f33dee25c54e076(shape, mean = 0.0, stddev = 1.0, dtype, seed, name = 'randomNormal') {
    dtype = dtype || 'float32';
    if (dtype !== 'float32' && dtype !== 'int32') throw new (0, $kubuc.NotImplementedError)(`randomNormalVariable does not support dType ${dtype}.`);
    return new $04d6bc585df55916$export$25de78a5a5bf7257($kaIUV.randomNormal(shape, mean, stddev, dtype, seed), dtype, name);
}
function $04d6bc585df55916$export$722fbec263ad908a(x, xNew) {
    return x.write(xNew);
}
function $04d6bc585df55916$export$35b829383d705ade(x, increment) {
    return x.write($6Ab5n.add(x.read(), increment));
}
function $04d6bc585df55916$export$f213ae8d294bd578(x, decrement) {
    return x.write($5jGN9.sub(x.read(), decrement));
}
function $04d6bc585df55916$export$3702262f615cc9f0(xs) {
    return xs.map((x)=>x.read());
}
function $04d6bc585df55916$export$6b1a34257a4982e4(variablesAndValues) {
    variablesAndValues.forEach((variableAndValue)=>{
        const variable = variableAndValue[0];
        variable.write(variableAndValue[1]);
    });
}
function $04d6bc585df55916$export$fc5727d09955ec17(lossFn, variables) {
    // TODO(cais): The return type signature can be simplified if deeplearn makes
    //   the corresponding type public.
    const variableList = variables.map((variable)=>variable.read());
    const valudAndGrads = (0, $1Npyr.variableGrads)(lossFn, variableList);
    return variables.map((variable)=>valudAndGrads.grads[variable.name]);
}

});





parcelRegister("7wepf", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // tslint:disable-next-line:max-line-length

var $ghUz9 = parcelRequire("ghUz9");
function $5796b255dd37673f$export$72d88ae287ab22e0(args) {
    return new (0, $ghUz9.MaxNorm)(args);
}
function $5796b255dd37673f$export$4a1c05456842cde3(args) {
    return new (0, $ghUz9.UnitNorm)(args);
}
function $5796b255dd37673f$export$38cf945efb543ffe() {
    return new (0, $ghUz9.NonNeg)();
}
function $5796b255dd37673f$export$a7a432272dbc707f(config) {
    return new (0, $ghUz9.MinMaxNorm)(config);
}

});
parcelRegister("ghUz9", function(module, exports) {

$parcel$export(module.exports, "MaxNorm", function () { return $bdba1cb7d28b9cc6$export$9bae576b4abeeb5b; });
$parcel$export(module.exports, "UnitNorm", function () { return $bdba1cb7d28b9cc6$export$d308398b296446e8; });
$parcel$export(module.exports, "NonNeg", function () { return $bdba1cb7d28b9cc6$export$e401f85674f409b; });
$parcel$export(module.exports, "MinMaxNorm", function () { return $bdba1cb7d28b9cc6$export$b6619aa7a63dac34; });
$parcel$export(module.exports, "serializeConstraint", function () { return $bdba1cb7d28b9cc6$export$e449710617725987; });
$parcel$export(module.exports, "getConstraint", function () { return $bdba1cb7d28b9cc6$export$492f40394cb58978; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/contraints.py */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $iAQYk = parcelRequire("iAQYk");
var $dIChU = parcelRequire("dIChU");
var $5hAos = parcelRequire("5hAos");
var $aQaR3 = parcelRequire("aQaR3");
var $ki3lz = parcelRequire("ki3lz");
var $g3lev = parcelRequire("g3lev");
var $fPnAL = parcelRequire("fPnAL");
var $d7Nxs = parcelRequire("d7Nxs");

var $69VqB = parcelRequire("69VqB");

var $jYx5u = parcelRequire("jYx5u");
/**
 * Helper function used by many of the Constraints to find the L2Norms.
 */ function $bdba1cb7d28b9cc6$var$calcL2Norms(w, axis) {
    return (0, $d7Nxs.tidy)(()=>$g3lev.sqrt($fPnAL.sum($5hAos.mul(w, w), axis, true)));
}
class $bdba1cb7d28b9cc6$export$aec1359a0a40a615 extends (0, $ki3lz).Serializable {
    getConfig() {
        return {};
    }
}
class $bdba1cb7d28b9cc6$export$9bae576b4abeeb5b extends $bdba1cb7d28b9cc6$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultMaxValue = 2;
        this.defaultAxis = 0;
        this.maxValue = args.maxValue != null ? args.maxValue : this.defaultMaxValue;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $d7Nxs.tidy)(()=>{
            const norms = $bdba1cb7d28b9cc6$var$calcL2Norms(w, this.axis);
            const desired = $iAQYk.clipByValue(norms, 0, this.maxValue);
            return $5hAos.mul(w, $dIChU.div(desired, $6Ab5n.add((0, $69VqB.epsilon)(), norms)));
        });
    }
    getConfig() {
        return {
            maxValue: this.maxValue,
            axis: this.axis
        };
    }
}
/** @nocollapse */ $bdba1cb7d28b9cc6$export$9bae576b4abeeb5b.className = 'MaxNorm';
(0, $ki3lz).registerClass($bdba1cb7d28b9cc6$export$9bae576b4abeeb5b);
class $bdba1cb7d28b9cc6$export$d308398b296446e8 extends $bdba1cb7d28b9cc6$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultAxis = 0;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $d7Nxs.tidy)(()=>$dIChU.div(w, $6Ab5n.add((0, $69VqB.epsilon)(), $bdba1cb7d28b9cc6$var$calcL2Norms(w, this.axis))));
    }
    getConfig() {
        return {
            axis: this.axis
        };
    }
}
/** @nocollapse */ $bdba1cb7d28b9cc6$export$d308398b296446e8.className = 'UnitNorm';
(0, $ki3lz).registerClass($bdba1cb7d28b9cc6$export$d308398b296446e8);
class $bdba1cb7d28b9cc6$export$e401f85674f409b extends $bdba1cb7d28b9cc6$export$aec1359a0a40a615 {
    apply(w) {
        return $aQaR3.relu(w);
    }
}
/** @nocollapse */ $bdba1cb7d28b9cc6$export$e401f85674f409b.className = 'NonNeg';
(0, $ki3lz).registerClass($bdba1cb7d28b9cc6$export$e401f85674f409b);
class $bdba1cb7d28b9cc6$export$b6619aa7a63dac34 extends $bdba1cb7d28b9cc6$export$aec1359a0a40a615 {
    constructor(args){
        super();
        this.defaultMinValue = 0.0;
        this.defaultMaxValue = 1.0;
        this.defaultRate = 1.0;
        this.defaultAxis = 0;
        this.minValue = args.minValue != null ? args.minValue : this.defaultMinValue;
        this.maxValue = args.maxValue != null ? args.maxValue : this.defaultMaxValue;
        this.rate = args.rate != null ? args.rate : this.defaultRate;
        this.axis = args.axis != null ? args.axis : this.defaultAxis;
    }
    apply(w) {
        return (0, $d7Nxs.tidy)(()=>{
            const norms = $bdba1cb7d28b9cc6$var$calcL2Norms(w, this.axis);
            const desired = $6Ab5n.add($5hAos.mul(this.rate, $iAQYk.clipByValue(norms, this.minValue, this.maxValue)), $5hAos.mul(1.0 - this.rate, norms));
            return $5hAos.mul(w, $dIChU.div(desired, $6Ab5n.add((0, $69VqB.epsilon)(), norms)));
        });
    }
    getConfig() {
        return {
            minValue: this.minValue,
            maxValue: this.maxValue,
            rate: this.rate,
            axis: this.axis
        };
    }
}
/** @nocollapse */ $bdba1cb7d28b9cc6$export$b6619aa7a63dac34.className = 'MinMaxNorm';
(0, $ki3lz).registerClass($bdba1cb7d28b9cc6$export$b6619aa7a63dac34);
const $bdba1cb7d28b9cc6$export$78360a76bbd2e9aa = {
    'maxNorm': 'MaxNorm',
    'minMaxNorm': 'MinMaxNorm',
    'nonNeg': 'NonNeg',
    'unitNorm': 'UnitNorm'
};
function $bdba1cb7d28b9cc6$export$e449710617725987(constraint) {
    return (0, $jYx5u.serializeKerasObject)(constraint);
}
function $bdba1cb7d28b9cc6$export$20c8aa8a8b337f29(config, customObjects = {}) {
    return (0, $jYx5u.deserializeKerasObject)(config, (0, $ki3lz).SerializationMap.getMap().classNameMap, customObjects, 'constraint');
}
function $bdba1cb7d28b9cc6$export$492f40394cb58978(identifier) {
    if (identifier == null) return null;
    if (typeof identifier === 'string') {
        const className = identifier in $bdba1cb7d28b9cc6$export$78360a76bbd2e9aa ? $bdba1cb7d28b9cc6$export$78360a76bbd2e9aa[identifier] : identifier;
        const config = {
            className: className,
            config: {}
        };
        return $bdba1cb7d28b9cc6$export$20c8aa8a8b337f29(config);
    } else if (identifier instanceof $bdba1cb7d28b9cc6$export$aec1359a0a40a615) return identifier;
    else return $bdba1cb7d28b9cc6$export$20c8aa8a8b337f29(identifier);
}

});


parcelRegister("3Gcyp", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // tslint:disable-next-line:max-line-length

var $lHlnu = parcelRequire("lHlnu");
function $2adf08487c6cc1bd$export$4445a00dafa2633b() {
    return new (0, $lHlnu.Zeros)();
}
function $2adf08487c6cc1bd$export$21041dee6b8001b0() {
    return new (0, $lHlnu.Ones)();
}
function $2adf08487c6cc1bd$export$c983f826f44ff86(args) {
    return new (0, $lHlnu.Constant)(args);
}
function $2adf08487c6cc1bd$export$bd6fd37822e292fa(args) {
    return new (0, $lHlnu.RandomUniform)(args);
}
function $2adf08487c6cc1bd$export$a0ac5549a8bec918(args) {
    return new (0, $lHlnu.RandomNormal)(args);
}
function $2adf08487c6cc1bd$export$8ad5625727f3fa1d(args) {
    return new (0, $lHlnu.TruncatedNormal)(args);
}
function $2adf08487c6cc1bd$export$f0954fd7d5368655(args) {
    return new (0, $lHlnu.Identity)(args);
}
function $2adf08487c6cc1bd$export$206fc9a68431980(config) {
    return new (0, $lHlnu.VarianceScaling)(config);
}
function $2adf08487c6cc1bd$export$28a06568c84ecf15(args) {
    return new (0, $lHlnu.GlorotUniform)(args);
}
function $2adf08487c6cc1bd$export$92c012eb6ea18446(args) {
    return new (0, $lHlnu.GlorotNormal)(args);
}
function $2adf08487c6cc1bd$export$61e5648a74c4c89d(args) {
    return new (0, $lHlnu.HeNormal)(args);
}
function $2adf08487c6cc1bd$export$89cebdcf433bb1f3(args) {
    return new (0, $lHlnu.HeUniform)(args);
}
function $2adf08487c6cc1bd$export$e6506404c2021f85(args) {
    return new (0, $lHlnu.LeCunNormal)(args);
}
function $2adf08487c6cc1bd$export$fbc1aa9dab0cc647(args) {
    return new (0, $lHlnu.LeCunUniform)(args);
}
function $2adf08487c6cc1bd$export$92fddceccd4ce8b5(args) {
    return new (0, $lHlnu.Orthogonal)(args);
}

});

parcelRegister("9W3RU", function(module, exports) {

$parcel$export(module.exports, "inputLayer", function () { return $73bc8808db8fb1f3$export$d13ae670ceaa55be; });
$parcel$export(module.exports, "elu", function () { return $73bc8808db8fb1f3$export$796b583dd79d8524; });
$parcel$export(module.exports, "reLU", function () { return $73bc8808db8fb1f3$export$a65e70706ebcefb3; });
$parcel$export(module.exports, "leakyReLU", function () { return $73bc8808db8fb1f3$export$22dc2b3e145b90ac; });
$parcel$export(module.exports, "prelu", function () { return $73bc8808db8fb1f3$export$5882f235222e6729; });
$parcel$export(module.exports, "softmax", function () { return $73bc8808db8fb1f3$export$e008137e76238601; });
$parcel$export(module.exports, "thresholdedReLU", function () { return $73bc8808db8fb1f3$export$39138c8eaf72c4cb; });
$parcel$export(module.exports, "conv1d", function () { return $73bc8808db8fb1f3$export$d8aa844fa36b350e; });
$parcel$export(module.exports, "conv2d", function () { return $73bc8808db8fb1f3$export$188f9215482e3db8; });
$parcel$export(module.exports, "conv2dTranspose", function () { return $73bc8808db8fb1f3$export$d5e924cbc07fb966; });
$parcel$export(module.exports, "conv3d", function () { return $73bc8808db8fb1f3$export$c476b02bcf7b2def; });
$parcel$export(module.exports, "conv3dTranspose", function () { return $73bc8808db8fb1f3$export$5eac62031b3f449f; });
$parcel$export(module.exports, "separableConv2d", function () { return $73bc8808db8fb1f3$export$2586c92899c2d0fb; });
$parcel$export(module.exports, "cropping2D", function () { return $73bc8808db8fb1f3$export$285835edada5f19f; });
$parcel$export(module.exports, "upSampling2d", function () { return $73bc8808db8fb1f3$export$1bc6b6356b35b9d0; });
$parcel$export(module.exports, "depthwiseConv2d", function () { return $73bc8808db8fb1f3$export$48a8ad9494a8fad8; });
$parcel$export(module.exports, "activation", function () { return $73bc8808db8fb1f3$export$80175f455852d1e4; });
$parcel$export(module.exports, "dense", function () { return $73bc8808db8fb1f3$export$467fe43f0f8da2cc; });
$parcel$export(module.exports, "dropout", function () { return $73bc8808db8fb1f3$export$fe05aa12367b4e47; });
$parcel$export(module.exports, "spatialDropout1d", function () { return $73bc8808db8fb1f3$export$6ab26addce721936; });
$parcel$export(module.exports, "flatten", function () { return $73bc8808db8fb1f3$export$bffa455ba8c619a6; });
$parcel$export(module.exports, "repeatVector", function () { return $73bc8808db8fb1f3$export$1dcc9b52fbdb892c; });
$parcel$export(module.exports, "reshape", function () { return $73bc8808db8fb1f3$export$9eaad88cf88cee2b; });
$parcel$export(module.exports, "permute", function () { return $73bc8808db8fb1f3$export$95e62ad65da8b7d2; });
$parcel$export(module.exports, "embedding", function () { return $73bc8808db8fb1f3$export$ffae51527c311cac; });
$parcel$export(module.exports, "add", function () { return $73bc8808db8fb1f3$export$e16d8520af44a096; });
$parcel$export(module.exports, "average", function () { return $73bc8808db8fb1f3$export$cc6710ee5f037d57; });
$parcel$export(module.exports, "concatenate", function () { return $73bc8808db8fb1f3$export$375c71d43969527d; });
$parcel$export(module.exports, "maximum", function () { return $73bc8808db8fb1f3$export$b25e0be55f42c9a; });
$parcel$export(module.exports, "minimum", function () { return $73bc8808db8fb1f3$export$916782c1f0ddb132; });
$parcel$export(module.exports, "multiply", function () { return $73bc8808db8fb1f3$export$2060d2db72cce88f; });
$parcel$export(module.exports, "dot", function () { return $73bc8808db8fb1f3$export$94132a0e348806d4; });
$parcel$export(module.exports, "batchNormalization", function () { return $73bc8808db8fb1f3$export$598a795b5a50c0b5; });
$parcel$export(module.exports, "layerNormalization", function () { return $73bc8808db8fb1f3$export$d46ad5357bc3d7f6; });
$parcel$export(module.exports, "zeroPadding2d", function () { return $73bc8808db8fb1f3$export$34e2ef2c537eafd4; });
$parcel$export(module.exports, "averagePooling1d", function () { return $73bc8808db8fb1f3$export$e308d3e6c3deb4b5; });
$parcel$export(module.exports, "avgPool1d", function () { return $73bc8808db8fb1f3$export$b44f2e4690260fec; });
$parcel$export(module.exports, "avgPooling1d", function () { return $73bc8808db8fb1f3$export$42629f014f8228f7; });
$parcel$export(module.exports, "averagePooling2d", function () { return $73bc8808db8fb1f3$export$d5f09f295e795be0; });
$parcel$export(module.exports, "avgPool2d", function () { return $73bc8808db8fb1f3$export$18e398525949757; });
$parcel$export(module.exports, "avgPooling2d", function () { return $73bc8808db8fb1f3$export$3009909165cde72c; });
$parcel$export(module.exports, "averagePooling3d", function () { return $73bc8808db8fb1f3$export$a60791858ca3b1a2; });
$parcel$export(module.exports, "avgPool3d", function () { return $73bc8808db8fb1f3$export$ee1b0efb53eb29c3; });
$parcel$export(module.exports, "avgPooling3d", function () { return $73bc8808db8fb1f3$export$149ead6bf7dd851c; });
$parcel$export(module.exports, "globalAveragePooling1d", function () { return $73bc8808db8fb1f3$export$30e0dcdbab04acb; });
$parcel$export(module.exports, "globalAveragePooling2d", function () { return $73bc8808db8fb1f3$export$4ff10070d09b111d; });
$parcel$export(module.exports, "globalMaxPooling1d", function () { return $73bc8808db8fb1f3$export$52aa533ccda11c4c; });
$parcel$export(module.exports, "globalMaxPooling2d", function () { return $73bc8808db8fb1f3$export$e1bfae148b2f4ec8; });
$parcel$export(module.exports, "maxPooling1d", function () { return $73bc8808db8fb1f3$export$c49c691c8f72af06; });
$parcel$export(module.exports, "maxPooling2d", function () { return $73bc8808db8fb1f3$export$fcf913567033698f; });
$parcel$export(module.exports, "maxPooling3d", function () { return $73bc8808db8fb1f3$export$64421faebeee5ef8; });
$parcel$export(module.exports, "gru", function () { return $73bc8808db8fb1f3$export$e12d2defa419b53a; });
$parcel$export(module.exports, "gruCell", function () { return $73bc8808db8fb1f3$export$d3685ad59ec626a6; });
$parcel$export(module.exports, "lstm", function () { return $73bc8808db8fb1f3$export$fe5a22aa5359fc69; });
$parcel$export(module.exports, "lstmCell", function () { return $73bc8808db8fb1f3$export$79425027c2dd20e6; });
$parcel$export(module.exports, "simpleRNN", function () { return $73bc8808db8fb1f3$export$5ccbc90d85639fb9; });
$parcel$export(module.exports, "simpleRNNCell", function () { return $73bc8808db8fb1f3$export$8e8d4a6c4528553; });
$parcel$export(module.exports, "convLstm2d", function () { return $73bc8808db8fb1f3$export$807c24c535353095; });
$parcel$export(module.exports, "convLstm2dCell", function () { return $73bc8808db8fb1f3$export$e8d3b2ad5b300a03; });
$parcel$export(module.exports, "rnn", function () { return $73bc8808db8fb1f3$export$3e66d5ce8f778ebc; });
$parcel$export(module.exports, "stackedRNNCells", function () { return $73bc8808db8fb1f3$export$d977f05737668a6; });
$parcel$export(module.exports, "bidirectional", function () { return $73bc8808db8fb1f3$export$ad322fa54f969043; });
$parcel$export(module.exports, "timeDistributed", function () { return $73bc8808db8fb1f3$export$8b8f46f74cfe04dc; });
$parcel$export(module.exports, "globalMaxPool1d", function () { return $73bc8808db8fb1f3$export$2efd4c09521df503; });
$parcel$export(module.exports, "globalMaxPool2d", function () { return $73bc8808db8fb1f3$export$4a73421a2f7eceac; });
$parcel$export(module.exports, "maxPool1d", function () { return $73bc8808db8fb1f3$export$b4ce5850fd040d92; });
$parcel$export(module.exports, "maxPool2d", function () { return $73bc8808db8fb1f3$export$cb09112eb789ff08; });
$parcel$export(module.exports, "gaussianNoise", function () { return $73bc8808db8fb1f3$export$cd62c6b94cb3c213; });
$parcel$export(module.exports, "gaussianDropout", function () { return $73bc8808db8fb1f3$export$bc128cd40ed5bfda; });
$parcel$export(module.exports, "alphaDropout", function () { return $73bc8808db8fb1f3$export$d73d2c7da153e772; });
$parcel$export(module.exports, "masking", function () { return $73bc8808db8fb1f3$export$2918598f73ee1e32; });
$parcel$export(module.exports, "rescaling", function () { return $73bc8808db8fb1f3$export$a512ecbbed70f3e; });
$parcel$export(module.exports, "centerCrop", function () { return $73bc8808db8fb1f3$export$22e2caf9ef2c32c0; });
$parcel$export(module.exports, "resizing", function () { return $73bc8808db8fb1f3$export$51be41c2a8dd482c; });
$parcel$export(module.exports, "categoryEncoding", function () { return $73bc8808db8fb1f3$export$5fd5c67c8b5e540b; });
$parcel$export(module.exports, "randomWidth", function () { return $73bc8808db8fb1f3$export$6fdd63ba3cdc7680; });
$parcel$export(module.exports, "Layer", function () { return (parcelRequire("jWpeh")).Layer; });
$parcel$export(module.exports, "RNN", function () { return (parcelRequire("2QjI9")).RNN; });
$parcel$export(module.exports, "RNNCell", function () { return (parcelRequire("2QjI9")).RNNCell; });
$parcel$export(module.exports, "input", function () { return (parcelRequire("hCaeT")).input; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $lusky = parcelRequire("lusky");

var $jWpeh = parcelRequire("jWpeh");

var $hCaeT = parcelRequire("hCaeT");

var $b99dv = parcelRequire("b99dv");

var $es1va = parcelRequire("es1va");

var $3jlGK = parcelRequire("3jlGK");

var $9SBfE = parcelRequire("9SBfE");

var $d6Kyz = parcelRequire("d6Kyz");

var $dMo41 = parcelRequire("dMo41");

var $iKmOy = parcelRequire("iKmOy");

var $e3ZDe = parcelRequire("e3ZDe");

var $6tWVg = parcelRequire("6tWVg");

var $1IQ24 = parcelRequire("1IQ24");

var $gz9kz = parcelRequire("gz9kz");

var $2QjI9 = parcelRequire("2QjI9");

var $ijvBj = parcelRequire("ijvBj");

var $5Om3j = parcelRequire("5Om3j");

var $iMD5O = parcelRequire("iMD5O");

var $5eBzR = parcelRequire("5eBzR");

var $cIle0 = parcelRequire("cIle0");

var $8bDuy = parcelRequire("8bDuy");
function $73bc8808db8fb1f3$export$d13ae670ceaa55be(args) {
    return new (0, $lusky.InputLayer)(args);
}
function $73bc8808db8fb1f3$export$796b583dd79d8524(args) {
    return new (0, $b99dv.ELU)(args);
}
function $73bc8808db8fb1f3$export$a65e70706ebcefb3(args) {
    return new (0, $b99dv.ReLU)(args);
}
function $73bc8808db8fb1f3$export$22dc2b3e145b90ac(args) {
    return new (0, $b99dv.LeakyReLU)(args);
}
function $73bc8808db8fb1f3$export$5882f235222e6729(args) {
    return new (0, $b99dv.PReLU)(args);
}
function $73bc8808db8fb1f3$export$e008137e76238601(args) {
    return new (0, $b99dv.Softmax)(args);
}
function $73bc8808db8fb1f3$export$39138c8eaf72c4cb(args) {
    return new (0, $b99dv.ThresholdedReLU)(args);
}
function $73bc8808db8fb1f3$export$d8aa844fa36b350e(args) {
    return new (0, $es1va.Conv1D)(args);
}
function $73bc8808db8fb1f3$export$188f9215482e3db8(args) {
    return new (0, $es1va.Conv2D)(args);
}
function $73bc8808db8fb1f3$export$d5e924cbc07fb966(args) {
    return new (0, $es1va.Conv2DTranspose)(args);
}
function $73bc8808db8fb1f3$export$c476b02bcf7b2def(args) {
    return new (0, $es1va.Conv3D)(args);
}
function $73bc8808db8fb1f3$export$5eac62031b3f449f(args) {
    return new (0, $es1va.Conv3DTranspose)(args);
}
function $73bc8808db8fb1f3$export$2586c92899c2d0fb(args) {
    return new (0, $es1va.SeparableConv2D)(args);
}
function $73bc8808db8fb1f3$export$285835edada5f19f(args) {
    return new (0, $es1va.Cropping2D)(args);
}
function $73bc8808db8fb1f3$export$1bc6b6356b35b9d0(args) {
    return new (0, $es1va.UpSampling2D)(args);
}
function $73bc8808db8fb1f3$export$48a8ad9494a8fad8(args) {
    return new (0, $3jlGK.DepthwiseConv2D)(args);
}
function $73bc8808db8fb1f3$export$80175f455852d1e4(args) {
    return new (0, $d6Kyz.Activation)(args);
}
function $73bc8808db8fb1f3$export$467fe43f0f8da2cc(args) {
    return new (0, $d6Kyz.Dense)(args);
}
function $73bc8808db8fb1f3$export$fe05aa12367b4e47(args) {
    return new (0, $d6Kyz.Dropout)(args);
}
function $73bc8808db8fb1f3$export$6ab26addce721936(args) {
    return new (0, $d6Kyz.SpatialDropout1D)(args);
}
function $73bc8808db8fb1f3$export$bffa455ba8c619a6(args) {
    return new (0, $d6Kyz.Flatten)(args);
}
function $73bc8808db8fb1f3$export$1dcc9b52fbdb892c(args) {
    return new (0, $d6Kyz.RepeatVector)(args);
}
function $73bc8808db8fb1f3$export$9eaad88cf88cee2b(args) {
    return new (0, $d6Kyz.Reshape)(args);
}
function $73bc8808db8fb1f3$export$95e62ad65da8b7d2(args) {
    return new (0, $d6Kyz.Permute)(args);
}
function $73bc8808db8fb1f3$export$ffae51527c311cac(args) {
    return new (0, $dMo41.Embedding)(args);
}
function $73bc8808db8fb1f3$export$e16d8520af44a096(args) {
    return new (0, $iKmOy.Add)(args);
}
function $73bc8808db8fb1f3$export$cc6710ee5f037d57(args) {
    return new (0, $iKmOy.Average)(args);
}
function $73bc8808db8fb1f3$export$375c71d43969527d(args) {
    return new (0, $iKmOy.Concatenate)(args);
}
function $73bc8808db8fb1f3$export$b25e0be55f42c9a(args) {
    return new (0, $iKmOy.Maximum)(args);
}
function $73bc8808db8fb1f3$export$916782c1f0ddb132(args) {
    return new (0, $iKmOy.Minimum)(args);
}
function $73bc8808db8fb1f3$export$2060d2db72cce88f(args) {
    return new (0, $iKmOy.Multiply)(args);
}
function $73bc8808db8fb1f3$export$94132a0e348806d4(args) {
    return new (0, $iKmOy.Dot)(args);
}
function $73bc8808db8fb1f3$export$598a795b5a50c0b5(args) {
    return new (0, $6tWVg.BatchNormalization)(args);
}
function $73bc8808db8fb1f3$export$d46ad5357bc3d7f6(args) {
    return new (0, $6tWVg.LayerNormalization)(args);
}
function $73bc8808db8fb1f3$export$34e2ef2c537eafd4(args) {
    return new (0, $1IQ24.ZeroPadding2D)(args);
}
function $73bc8808db8fb1f3$export$e308d3e6c3deb4b5(args) {
    return new (0, $gz9kz.AveragePooling1D)(args);
}
function $73bc8808db8fb1f3$export$b44f2e4690260fec(args) {
    return $73bc8808db8fb1f3$export$e308d3e6c3deb4b5(args);
}
function $73bc8808db8fb1f3$export$42629f014f8228f7(args) {
    return $73bc8808db8fb1f3$export$e308d3e6c3deb4b5(args);
}
function $73bc8808db8fb1f3$export$d5f09f295e795be0(args) {
    return new (0, $gz9kz.AveragePooling2D)(args);
}
function $73bc8808db8fb1f3$export$18e398525949757(args) {
    return $73bc8808db8fb1f3$export$d5f09f295e795be0(args);
}
function $73bc8808db8fb1f3$export$3009909165cde72c(args) {
    return $73bc8808db8fb1f3$export$d5f09f295e795be0(args);
}
function $73bc8808db8fb1f3$export$a60791858ca3b1a2(args) {
    return new (0, $gz9kz.AveragePooling3D)(args);
}
function $73bc8808db8fb1f3$export$ee1b0efb53eb29c3(args) {
    return $73bc8808db8fb1f3$export$a60791858ca3b1a2(args);
}
function $73bc8808db8fb1f3$export$149ead6bf7dd851c(args) {
    return $73bc8808db8fb1f3$export$a60791858ca3b1a2(args);
}
function $73bc8808db8fb1f3$export$30e0dcdbab04acb(args) {
    return new (0, $gz9kz.GlobalAveragePooling1D)(args);
}
function $73bc8808db8fb1f3$export$4ff10070d09b111d(args) {
    return new (0, $gz9kz.GlobalAveragePooling2D)(args);
}
function $73bc8808db8fb1f3$export$52aa533ccda11c4c(args) {
    return new (0, $gz9kz.GlobalMaxPooling1D)(args);
}
function $73bc8808db8fb1f3$export$e1bfae148b2f4ec8(args) {
    return new (0, $gz9kz.GlobalMaxPooling2D)(args);
}
function $73bc8808db8fb1f3$export$c49c691c8f72af06(args) {
    return new (0, $gz9kz.MaxPooling1D)(args);
}
function $73bc8808db8fb1f3$export$fcf913567033698f(args) {
    return new (0, $gz9kz.MaxPooling2D)(args);
}
function $73bc8808db8fb1f3$export$64421faebeee5ef8(args) {
    return new (0, $gz9kz.MaxPooling3D)(args);
}
function $73bc8808db8fb1f3$export$e12d2defa419b53a(args) {
    return new (0, $2QjI9.GRU)(args);
}
function $73bc8808db8fb1f3$export$d3685ad59ec626a6(args) {
    return new (0, $2QjI9.GRUCell)(args);
}
function $73bc8808db8fb1f3$export$fe5a22aa5359fc69(args) {
    return new (0, $2QjI9.LSTM)(args);
}
function $73bc8808db8fb1f3$export$79425027c2dd20e6(args) {
    return new (0, $2QjI9.LSTMCell)(args);
}
function $73bc8808db8fb1f3$export$5ccbc90d85639fb9(args) {
    return new (0, $2QjI9.SimpleRNN)(args);
}
function $73bc8808db8fb1f3$export$8e8d4a6c4528553(args) {
    return new (0, $2QjI9.SimpleRNNCell)(args);
}
function $73bc8808db8fb1f3$export$807c24c535353095(args) {
    return new (0, $9SBfE.ConvLSTM2D)(args);
}
function $73bc8808db8fb1f3$export$e8d3b2ad5b300a03(args) {
    return new (0, $9SBfE.ConvLSTM2DCell)(args);
}
function $73bc8808db8fb1f3$export$3e66d5ce8f778ebc(args) {
    return new (0, $2QjI9.RNN)(args);
}
function $73bc8808db8fb1f3$export$d977f05737668a6(args) {
    return new (0, $2QjI9.StackedRNNCells)(args);
}
function $73bc8808db8fb1f3$export$ad322fa54f969043(args) {
    return new (0, $ijvBj.Bidirectional)(args);
}
function $73bc8808db8fb1f3$export$8b8f46f74cfe04dc(args) {
    return new (0, $ijvBj.TimeDistributed)(args);
}
const $73bc8808db8fb1f3$export$2efd4c09521df503 = $73bc8808db8fb1f3$export$52aa533ccda11c4c;
const $73bc8808db8fb1f3$export$4a73421a2f7eceac = $73bc8808db8fb1f3$export$e1bfae148b2f4ec8;
const $73bc8808db8fb1f3$export$b4ce5850fd040d92 = $73bc8808db8fb1f3$export$c49c691c8f72af06;
const $73bc8808db8fb1f3$export$cb09112eb789ff08 = $73bc8808db8fb1f3$export$fcf913567033698f;
function $73bc8808db8fb1f3$export$cd62c6b94cb3c213(args) {
    return new (0, $e3ZDe.GaussianNoise)(args);
}
function $73bc8808db8fb1f3$export$bc128cd40ed5bfda(args) {
    return new (0, $e3ZDe.GaussianDropout)(args);
}
function $73bc8808db8fb1f3$export$d73d2c7da153e772(args) {
    return new (0, $e3ZDe.AlphaDropout)(args);
}
function $73bc8808db8fb1f3$export$2918598f73ee1e32(args) {
    return new (0, $d6Kyz.Masking)(args);
}
function $73bc8808db8fb1f3$export$a512ecbbed70f3e(args) {
    return new (0, $5Om3j.Rescaling)(args);
}
function $73bc8808db8fb1f3$export$22e2caf9ef2c32c0(args) {
    return new (0, $iMD5O.CenterCrop)(args);
}
function $73bc8808db8fb1f3$export$51be41c2a8dd482c(args) {
    return new (0, $cIle0.Resizing)(args);
}
function $73bc8808db8fb1f3$export$5fd5c67c8b5e540b(args) {
    return new (0, $5eBzR.CategoryEncoding)(args);
}
function $73bc8808db8fb1f3$export$6fdd63ba3cdc7680(args) {
    return new (0, $8bDuy.RandomWidth)(args);
}

});
parcelRegister("hCaeT", function(module, exports) {

$parcel$export(module.exports, "sequential", function () { return $cd2ded97c31309a1$export$3c7b24ce1c81e349; });
$parcel$export(module.exports, "input", function () { return $cd2ded97c31309a1$export$b7e3ae3d7c15e42e; });
$parcel$export(module.exports, "loadLayersModel", function () { return (parcelRequire("1dKdw")).loadLayersModel; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Exported functions.
 */ 
var $801Oz = parcelRequire("801Oz");

var $lusky = parcelRequire("lusky");

var $czFC2 = parcelRequire("czFC2");

var $1dKdw = parcelRequire("1dKdw");
function $cd2ded97c31309a1$export$39a8f6bed6e94390(args) {
    return new (0, $czFC2.LayersModel)(args);
}
function $cd2ded97c31309a1$export$3c7b24ce1c81e349(config) {
    return new (0, $1dKdw.Sequential)(config);
}
function $cd2ded97c31309a1$export$b7e3ae3d7c15e42e(config) {
    return (0, $lusky.Input)(config);
}
function $cd2ded97c31309a1$export$e4ead4e2d6e9b3fd(verbosityLevel, callbackConstructor) {
    (0, $801Oz.CallbackConstructorRegistry).registerCallbackConstructor(verbosityLevel, callbackConstructor);
}

});
parcelRegister("801Oz", function(module, exports) {

$parcel$export(module.exports, "BaseCallback", function () { return $5d2fbb3050b39738$export$ac023a7995700a90; });
$parcel$export(module.exports, "standardizeCallbacks", function () { return $5d2fbb3050b39738$export$8ea03bd28ba7b2ff; });
$parcel$export(module.exports, "CallbackConstructorRegistry", function () { return $5d2fbb3050b39738$export$3b4f51c3fa9f338c; });
$parcel$export(module.exports, "configureCallbacks", function () { return $5d2fbb3050b39738$export$18b2cd3db6266dd9; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/callbacks.py */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $dIChU = parcelRequire("dIChU");
var $d7Nxs = parcelRequire("d7Nxs");
var $5hAos = parcelRequire("5hAos");
var $k22sw = parcelRequire("k22sw");
var $lBDHD = parcelRequire("lBDHD");

var $kubuc = parcelRequire("kubuc");

var $lcd3O = parcelRequire("lcd3O");

var $jYx5u = parcelRequire("jYx5u");
var $5d2fbb3050b39738$export$7770e64db700cbdd;
(function(ModelLoggingVerbosity) {
    ModelLoggingVerbosity[ModelLoggingVerbosity["SILENT"] = 0] = "SILENT";
    ModelLoggingVerbosity[ModelLoggingVerbosity["VERBOSE"] = 1] = "VERBOSE";
})($5d2fbb3050b39738$export$7770e64db700cbdd || ($5d2fbb3050b39738$export$7770e64db700cbdd = {}));
const $5d2fbb3050b39738$export$2966f81b7af02452 = 125;
class $5d2fbb3050b39738$export$ac023a7995700a90 {
    constructor(){
        // TODO(michaelterry): This type is a best guess.
        this.validationData = null;
    }
    setParams(params) {
        this.params = params;
    }
    async onEpochBegin(epoch, logs) {}
    async onEpochEnd(epoch, logs) {}
    async onBatchBegin(batch, logs) {}
    async onBatchEnd(batch, logs) {}
    async onTrainBegin(logs) {}
    async onTrainEnd(logs) {}
    // LayersModel needs to call Callback.setModel(), but cannot actually depend
    // on Callback because that creates a cyclic dependency.  Providing this no-op
    // method on BaseCallback breaks the cycle: this way LayersModel can depend on
    // BaseCallback but not on Callback.  The argument is typed as `Container`
    // (the superclass of LayersModel) to avoid recapitulating the cycle. Callback
    // overrides this method and enforces that the argument is really a
    // LayersModel.
    setModel(model) {
    // Do nothing. Use Callback instead of BaseCallback to track the model.
    }
}
class $5d2fbb3050b39738$export$435cb83c816395fd {
    // TODO(cais): When the need arises, uncomment the following lines and
    // implement the queue for time values.
    // private deltaTBatch: number;
    // private deltaTsBatchBegin: Array<number>;
    // private deltaTsBatchEnd: Array<number>;
    /**
     * Constructor of CallbackList.
     * @param callbacks Array of `Callback` instances.
     * @param queueLength Queue length for keeping running statistics over
     *   callback execution time.
     */ constructor(callbacks, queueLength = 10){
        // TODO(cais): Make use of queueLength when implementing the queue for time
        // values.
        if (callbacks == null) callbacks = [];
        this.callbacks = callbacks;
        this.queueLength = queueLength;
    }
    append(callback) {
        this.callbacks.push(callback);
    }
    setParams(params) {
        for (const callback of this.callbacks)callback.setParams(params);
    }
    setModel(model) {
        for (const callback of this.callbacks)callback.setModel(model);
    }
    /**
     * Called at the start of an epoch.
     * @param epoch Index of epoch.
     * @param logs Dictionary of logs.
     */ async onEpochBegin(epoch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onEpochBegin(epoch, logs);
    }
    /**
     * Called at the end of an epoch.
     * @param epoch Index of epoch.
     * @param logs Dictionary of logs.
     */ async onEpochEnd(epoch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onEpochEnd(epoch, logs);
    }
    /**
     * Called  right before processing a batch.
     * @param batch Index of batch within the current epoch.
     * @param logs Dictionary of logs.
     */ async onBatchBegin(batch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onBatchBegin(batch, logs);
    }
    /**
     * Called at the end of a batch.
     * @param batch Index of batch within the current epoch.
     * @param logs Dictionary of logs.
     */ async onBatchEnd(batch, logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onBatchEnd(batch, logs);
    }
    /**
     * Called at the beginning of training.
     * @param logs Dictionary of logs.
     */ async onTrainBegin(logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onTrainBegin(logs);
    }
    /**
     * Called at the end of training.
     * @param logs Dictionary of logs.
     */ async onTrainEnd(logs) {
        if (logs == null) logs = {};
        for (const callback of this.callbacks)await callback.onTrainEnd(logs);
    }
}
class $5d2fbb3050b39738$export$bf796c2da54a4a40 extends $5d2fbb3050b39738$export$ac023a7995700a90 {
    constructor(){
        super();
    }
    async onEpochBegin(epoch) {
        this.seen = 0;
        this.totals = {};
    }
    async onBatchEnd(batch, logs) {
        if (logs == null) logs = {};
        const batchSize = logs['size'] == null ? 0 : logs['size'];
        this.seen += batchSize;
        for(const key in logs){
            const value = logs[key];
            if (typeof value === 'number') {
                if (!this.totals.hasOwnProperty(key)) this.totals[key] = 0;
                this.totals[key] = this.totals[key] + value * batchSize;
            } else {
                let oldTotalsToDispose;
                if (key in this.totals) oldTotalsToDispose = this.totals[key];
                else this.totals[key] = 0;
                const total = (0, $d7Nxs.tidy)(()=>(0, $6Ab5n.add)(this.totals[key], (0, $5hAos.mul)(value, batchSize)));
                this.totals[key] = total;
                if (oldTotalsToDispose != null) oldTotalsToDispose.dispose();
            }
        }
    }
    async onEpochEnd(epoch, logs) {
        if (logs != null) for (const key of this.params['metrics']){
            if (this.totals[key] == null) continue;
            if (typeof this.totals[key] === 'number') logs[key] = this.totals[key] / this.seen;
            else (0, $d7Nxs.tidy)(()=>{
                const log = (0, $5hAos.mul)((0, $dIChU.div)(1, this.seen), this.totals[key]);
                logs[key] = log;
                this.totals[key].dispose();
                (0, $d7Nxs.keep)(logs[key]);
            });
        }
    }
}
class $5d2fbb3050b39738$export$84202caead5689ba extends $5d2fbb3050b39738$export$ac023a7995700a90 {
    async onTrainBegin(logs) {
        this.epoch = [];
        this.history = {};
    }
    async onEpochEnd(epoch, logs) {
        if (logs == null) logs = {};
        this.epoch.push(epoch);
        for(const key in logs){
            if (this.history[key] == null) this.history[key] = [];
            this.history[key].push(logs[key]);
        }
    }
    /**
     * Await the values of all losses and metrics.
     */ async syncData() {
        const promises = [];
        const keys = [];
        const indices = [];
        for(const key in this.history){
            const valueArray = this.history[key];
            for(let i = 0; i < valueArray.length; ++i)if (typeof valueArray[i] !== 'number') {
                const valueScalar = valueArray[i];
                promises.push(valueScalar.data());
                keys.push(key);
                indices.push(i);
            }
        }
        const values = await Promise.all(promises);
        for(let n = 0; n < values.length; ++n){
            const tensorToDispose = this.history[keys[n]][indices[n]];
            tensorToDispose.dispose();
            this.history[keys[n]][indices[n]] = values[n][0];
        }
    }
}
class $5d2fbb3050b39738$export$5682c09493042ec8 extends $5d2fbb3050b39738$export$ac023a7995700a90 {
    constructor(args, yieldEvery){
        super();
        this.currentEpoch = 0;
        this.nowFunc = args.nowFunc;
        this.nextFrameFunc = args.nextFrameFunc || (0, $k22sw.nextFrame);
        this.yieldEvery = yieldEvery || 'auto';
        if (this.yieldEvery === 'auto') this.yieldEvery = $5d2fbb3050b39738$export$2966f81b7af02452;
        if (this.yieldEvery === 'never' && args.onYield != null) throw new Error("yieldEvery is `never` but you provided an `onYield` callback. Either change `yieldEvery` or remove the callback");
        if ((0, $lBDHD).isNumber(this.yieldEvery)) // Decorate `maybeWait` so it will be called at most once every
        // `yieldEvery` ms.
        this.maybeWait = $jYx5u.debounce(this.maybeWait.bind(this), this.yieldEvery, this.nowFunc);
        this.trainBegin = args.onTrainBegin;
        this.trainEnd = args.onTrainEnd;
        this.epochBegin = args.onEpochBegin;
        this.epochEnd = args.onEpochEnd;
        this.batchBegin = args.onBatchBegin;
        this.batchEnd = args.onBatchEnd;
        this.yield = args.onYield;
    }
    async maybeWait(epoch, batch, logs) {
        const ps = [];
        if (this.yield != null) {
            await (0, $lcd3O.resolveScalarsInLogs)(logs);
            ps.push(this.yield(epoch, batch, logs));
        }
        ps.push(this.nextFrameFunc());
        await Promise.all(ps);
    }
    async onEpochBegin(epoch, logs) {
        this.currentEpoch = epoch;
        if (this.epochBegin != null) {
            await (0, $lcd3O.resolveScalarsInLogs)(logs);
            await this.epochBegin(epoch, logs);
        }
    }
    async onEpochEnd(epoch, logs) {
        const ps = [];
        if (this.epochEnd != null) {
            await (0, $lcd3O.resolveScalarsInLogs)(logs);
            ps.push(this.epochEnd(epoch, logs));
        }
        if (this.yieldEvery === 'epoch') ps.push(this.nextFrameFunc());
        await Promise.all(ps);
    }
    async onBatchBegin(batch, logs) {
        if (this.batchBegin != null) {
            await (0, $lcd3O.resolveScalarsInLogs)(logs);
            await this.batchBegin(batch, logs);
        }
    }
    async onBatchEnd(batch, logs) {
        const ps = [];
        if (this.batchEnd != null) {
            await (0, $lcd3O.resolveScalarsInLogs)(logs);
            ps.push(this.batchEnd(batch, logs));
        }
        if (this.yieldEvery === 'batch') ps.push(this.nextFrameFunc());
        else if ((0, $lBDHD).isNumber(this.yieldEvery)) ps.push(this.maybeWait(this.currentEpoch, batch, logs));
        await Promise.all(ps);
    }
    async onTrainBegin(logs) {
        if (this.trainBegin != null) {
            await (0, $lcd3O.resolveScalarsInLogs)(logs);
            await this.trainBegin(logs);
        }
    }
    async onTrainEnd(logs) {
        if (this.trainEnd != null) {
            await (0, $lcd3O.resolveScalarsInLogs)(logs);
            await this.trainEnd(logs);
        }
    }
}
function $5d2fbb3050b39738$export$8ea03bd28ba7b2ff(callbacks, yieldEvery) {
    if (callbacks == null) callbacks = {};
    if (callbacks instanceof $5d2fbb3050b39738$export$ac023a7995700a90) return [
        callbacks
    ];
    if (Array.isArray(callbacks) && callbacks[0] instanceof $5d2fbb3050b39738$export$ac023a7995700a90) return callbacks;
    // Convert custom callback configs to custom callback objects.
    const callbackConfigs = $jYx5u.toList(callbacks);
    return callbackConfigs.map((callbackConfig)=>new $5d2fbb3050b39738$export$5682c09493042ec8(callbackConfig, yieldEvery));
}
/**
 * A global registry for callback constructors to be used during
 * LayersModel.fit().
 */ class $5d2fbb3050b39738$export$3b4f51c3fa9f338c {
    /**
     * Blocks public access to constructor.
     */ constructor(){}
    /**
     * Register a tf.LayersModel.fit() callback constructor.
     *
     * The registered callback constructor will be used to instantiate
     * callbacks for every tf.LayersModel.fit() call afterwards.
     *
     * @param verbosityLevel Level of verbosity at which the `callbackConstructor`
     *   is to be reigstered.
     * @param callbackConstructor A no-arg constructor for `tf.Callback`.
     * @throws Error, if the same callbackConstructor has been registered before,
     *   either at the same or a different `verbosityLevel`.
     */ static registerCallbackConstructor(verbosityLevel, callbackConstructor) {
        (0, $lBDHD).assert(verbosityLevel >= 0 && Number.isInteger(verbosityLevel), ()=>`Verbosity level is expected to be an integer >= 0, ` + `but got ${verbosityLevel}`);
        $5d2fbb3050b39738$export$3b4f51c3fa9f338c.checkForDuplicate(callbackConstructor);
        if ($5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors[verbosityLevel] == null) $5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors[verbosityLevel] = [];
        $5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors[verbosityLevel].push(callbackConstructor);
    }
    static checkForDuplicate(callbackConstructor) {
        for(const levelName in $5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors){
            const constructors = $5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors[+levelName];
            constructors.forEach((ctor)=>{
                if (ctor === callbackConstructor) throw new (0, $kubuc.ValueError)('Duplicate callback constructor.');
            });
        }
    }
    /**
     * Clear all registered callback constructors.
     */ static clear() {
        $5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors = {};
    }
    /**
     * Create callbacks using the registered callback constructors.
     *
     * Given `verbosityLevel`, all constructors registered at that level or above
     * will be called and the instantiated callbacks will be used.
     *
     * @param verbosityLevel: Level of verbosity.
     */ static createCallbacks(verbosityLevel) {
        const constructors = [];
        for(const levelName in $5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors){
            const level = +levelName;
            if (verbosityLevel >= level) constructors.push(...$5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors[level]);
        }
        return constructors.map((ctor)=>new ctor());
    }
}
$5d2fbb3050b39738$export$3b4f51c3fa9f338c.constructors = {};
function $5d2fbb3050b39738$export$18b2cd3db6266dd9(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics) {
    const history = new $5d2fbb3050b39738$export$84202caead5689ba();
    const actualCallbacks = [
        new $5d2fbb3050b39738$export$bf796c2da54a4a40(),
        ...$5d2fbb3050b39738$export$3b4f51c3fa9f338c.createCallbacks(verbose)
    ];
    if (callbacks != null) actualCallbacks.push(...callbacks);
    actualCallbacks.push(history);
    const callbackList = new $5d2fbb3050b39738$export$435cb83c816395fd(actualCallbacks);
    // TODO(cais): Figure out when this LayersModel instance can have a
    // dynamically
    //   set property called 'callback_model' as in PyKeras.
    callbackList.setParams({
        epochs: epochs,
        initialEpoch: initialEpoch,
        samples: numTrainSamples,
        steps: stepsPerEpoch,
        batchSize: batchSize,
        verbose: verbose,
        doValidation: doValidation,
        metrics: callbackMetrics
    });
    return {
        callbackList: callbackList,
        history: history
    };
}

});
parcelRegister("lcd3O", function(module, exports) {

$parcel$export(module.exports, "resolveScalarsInLogs", function () { return $f6e4d9808d39d044$export$edec74c62c989297; });
$parcel$export(module.exports, "disposeTensorsInLogs", function () { return $f6e4d9808d39d044$export$f4920d82017cd044; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");
async function $f6e4d9808d39d044$export$edec74c62c989297(logs) {
    if (logs == null) return;
    const promises = [];
    const keys = [];
    const scalarsToDispose = [];
    for(const key in logs){
        const value = logs[key];
        if (typeof value !== 'number') {
            const valueScalar = value;
            promises.push(valueScalar.data());
            keys.push(key);
            scalarsToDispose.push(valueScalar);
        }
    }
    if (promises.length > 0) {
        const values = await Promise.all(promises);
        for(let i = 0; i < values.length; ++i)logs[keys[i]] = values[i][0];
        // Dispose the original scalar tensors.
        (0, $d7Nxs.dispose)(scalarsToDispose);
    }
}
function $f6e4d9808d39d044$export$f4920d82017cd044(logs) {
    if (logs == null) return;
    for(const key in logs){
        const value = logs[key];
        if (typeof value !== 'number') value.dispose();
    }
}

});


parcelRegister("czFC2", function(module, exports) {

$parcel$export(module.exports, "LayersModel", function () { return $9279084e18d7cb75$export$f8e130845653852b; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source: engine/training.py */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $1goxr = parcelRequire("1goxr");
var $d7Nxs = parcelRequire("d7Nxs");
var $dIChU = parcelRequire("dIChU");
var $feqcJ = parcelRequire("feqcJ");
var $3TgHP = parcelRequire("3TgHP");
var $5hAos = parcelRequire("5hAos");
var $2jiJm = parcelRequire("2jiJm");
var $7hONX = parcelRequire("7hONX");
var $ki3lz = parcelRequire("ki3lz");
var $3pVUH = parcelRequire("3pVUH");
var $8tOOR = parcelRequire("8tOOR");
var $lBDHD = parcelRequire("lBDHD");

var $4AyI5 = parcelRequire("4AyI5");

var $801Oz = parcelRequire("801Oz");

var $1Xyaa = parcelRequire("1Xyaa");

var $kubuc = parcelRequire("kubuc");

var $4v3Le = parcelRequire("4v3Le");

var $lcd3O = parcelRequire("lcd3O");

var $lg9tU = parcelRequire("lg9tU");

var $j6iTL = parcelRequire("j6iTL");

var $4Sjwz = parcelRequire("4Sjwz");

var $4tZ6g = parcelRequire("4tZ6g");

var $jYx5u = parcelRequire("jYx5u");

var $lKxUo = parcelRequire("lKxUo");

var $4SWqG = parcelRequire("4SWqG");

var $3r0Ja = parcelRequire("3r0Ja");

var $kw5Gh = parcelRequire("kw5Gh");

var $3foX0 = parcelRequire("3foX0");

var $iyRtt = parcelRequire("iyRtt");

var $iR99G = parcelRequire("iR99G");

var $a7zeb = parcelRequire("a7zeb");

var $10YKi = parcelRequire("10YKi");
function $9279084e18d7cb75$export$73ccac4188109750(x) {
    return x instanceof (0, $3pVUH.Tensor);
}
function $9279084e18d7cb75$export$d011a650f00557e2(x) {
    return Array.isArray(x);
}
function $9279084e18d7cb75$export$6af9d9020dbc362d(x) {
    return !$9279084e18d7cb75$export$73ccac4188109750(x) && !$9279084e18d7cb75$export$d011a650f00557e2(x);
}
function $9279084e18d7cb75$export$69dd7486f5c87261(data, names, shapes, checkBatchAxis = true, exceptionPrefix = '') {
    if (names == null || names.length === 0) {
        // Check for the case where the model expected no data, but some data got
        // sent.
        if (data != null) {
            let gotUnexpectedData = false;
            if ($9279084e18d7cb75$export$d011a650f00557e2(data) && data.length > 0) gotUnexpectedData = true;
            else if ($9279084e18d7cb75$export$6af9d9020dbc362d(data)) {
                for(const key in data)if (data.hasOwnProperty(key)) {
                    gotUnexpectedData = true;
                    break;
                }
            } else // `data` is a singleton Tensor in this case.
            gotUnexpectedData = true;
            if (gotUnexpectedData) throw new (0, $kubuc.ValueError)(`Error when checking model ${exceptionPrefix} expected no data, ` + `but got ${data}`);
        }
        return [];
    }
    if (data == null) return names.map((name)=>null);
    let arrays;
    if ($9279084e18d7cb75$export$6af9d9020dbc362d(data)) {
        data;
        arrays = [];
        for (const name of names){
            if (data[name] == null) throw new (0, $kubuc.ValueError)(`No data provided for "${name}". Need data for each key in: ` + `${names}`);
            arrays.push(data[name]);
        }
    } else if ($9279084e18d7cb75$export$d011a650f00557e2(data)) {
        data;
        if (data.length !== names.length) throw new (0, $kubuc.ValueError)(`Error when checking model ${exceptionPrefix}: the Array of ` + `Tensors that you are passing to your model is not the size the ` + `model expected. Expected to see ${names.length} Tensor(s), but ` + `instead got the following list of Tensor(s): ${data}`);
        arrays = data;
    } else {
        data;
        if (names.length > 1) throw new (0, $kubuc.ValueError)(`The model ${exceptionPrefix} expects ${names.length} Tensor(s), ` + `but only received one Tensor. Found: Tensor with shape ${data.shape}`);
        arrays = [
            data
        ];
    }
    arrays = (0, $a7zeb.ensureTensorsRank2OrHigher)(arrays);
    // Check shape compatibility.
    if (shapes != null) for(let i = 0; i < names.length; ++i){
        if (shapes[i] == null) continue;
        const array = arrays[i];
        if (array.shape.length !== shapes[i].length) throw new (0, $kubuc.ValueError)(`Error when checking ${exceptionPrefix}: expected ${names[i]} ` + `to have ${shapes[i].length} dimension(s). but got array with ` + `shape ${array.shape}`);
        for(let j = 0; j < shapes[i].length; ++j){
            if (j === 0 && !checkBatchAxis) continue;
            const dim = array.shape[j];
            const refDim = shapes[i][j];
            if (refDim != null && refDim >= 0 && dim !== refDim) throw new (0, $kubuc.ValueError)(`${exceptionPrefix} expected a batch of elements where each ` + `example has shape [${shapes[i].slice(1, shapes[i].length)}] ` + `(i.e.,tensor shape [*,${shapes[i].slice(1, shapes[i].length)}])` + ` but the ${exceptionPrefix} received an input with ${array.shape[0]}` + ` examples, each with shape [${array.shape.slice(1, array.shape.length)}]` + ` (tensor shape [${array.shape}])`);
        }
    }
    return arrays;
}
function $9279084e18d7cb75$export$4b125fd48a812392(inputs, targets, weights) {
    const setX = (0, $jYx5u.unique)(inputs.map((input)=>input.shape[0]));
    setX.sort();
    const setY = (0, $jYx5u.unique)(targets.map((target)=>target.shape[0]));
    setY.sort();
    // TODO(cais): Check `weights` as well.
    if (setX.length > 1) throw new (0, $kubuc.ValueError)(`All input Tensors (x) should have the same number of samples. ` + `Got array shapes: ` + `${JSON.stringify(inputs.map((input)=>input.shape))}`);
    if (setY.length > 1) throw new (0, $kubuc.ValueError)(`All target Tensors (y) should have the same number of samples. ` + `Got array shapes: ` + `${JSON.stringify(targets.map((target)=>target.shape))}`);
    if (setX.length > 0 && setY.length > 0 && !(0, $lBDHD).arraysEqual(setX, setY)) throw new (0, $kubuc.ValueError)(`Input Tensors should have the same number of samples as target ` + `Tensors. Found ${setX[0]} input sample(s) and ${setY[0]} target ` + `sample(s).`);
}
/**
 * Validation on the compatibility of targes and loss functions.
 *
 * This helps prevent users from using loss functions incorrectly.
 *
 * @param targets `Array` of `tf.Tensor`s of targets.
 * @param lossFns `Array` of loss functions.
 * @param outputShapes `Array` of shapes of model outputs.
 */ function $9279084e18d7cb75$var$checkLossAndTargetCompatibility(targets, lossFns, outputShapes) {
    // TODO(cais): Dedicated test coverage?
    const keyLosses = [
        $lg9tU.meanSquaredError,
        $lg9tU.binaryCrossentropy,
        $lg9tU.categoricalCrossentropy
    ];
    for(let i = 0; i < targets.length; ++i){
        const y = targets[i];
        const loss = lossFns[i];
        const shape = outputShapes[i];
        if (loss == null) continue;
        if (loss === $lg9tU.categoricalCrossentropy) {
            if (y.shape[y.shape.length - 1] === 1) throw new (0, $kubuc.ValueError)(`You are passing a target array of shape ${y.shape} while using ` + `a loss 'categorical_crossentropy'. 'categorical_crossentropy'` + `expects targets to be binary matrices (1s and 0s) of shape ` + `[samples, classes].`);
        }
        if (keyLosses.indexOf(loss) !== -1) {
            const slicedYShape = y.shape.slice(1);
            const slicedShape = shape.slice(1);
            for(let j = 0; j < slicedYShape.length; ++j){
                const targetDim = slicedYShape[j];
                const outDim = slicedShape[j];
                if (outDim != null && targetDim !== outDim) throw new (0, $kubuc.ValueError)(`A target Tensor with shape ${y.shape} was passed for an ` + `output of shape ${shape}, while using a loss function that ` + `expects targets to have the same shape as the output.`);
            }
        }
    }
}
/**
 * Check inputs provided by the user.
 *
 * Porting Note: This corresponds to _standardize_input_data() in Python
 *   Keras. Because of the strong typing in TF.js, we do not need to convert
 *   the data. Specifically:
 *   1) in PyKeras, `data` can be `DataFrame` instances from pandas, for
 *      example. We don't need to worry about that here because there is no
 *      widely popular javascript/typesdcript equivalent of pandas (so far).
 *      If one becomes available in the future, we can add support.
 *   2) in PyKeras, inputs can be Python dict. But here we are stipulating
 * that the data is either a single `tf.Tensor` or an Array of `tf.Tensor`s. We
 * may add support for `Object` data inputs in the future when the need
 * arises.
 *
 * Instead, we perform basic checks for number of parameters and shapes.
 *
 * @param data: The input data.
 * @param names: Name for the inputs, from the model.
 * @param shapes: Expected shapes for the input data, from the model.
 * @param checkBatchAxis: Whether the size along the batch axis (i.e., the
 *   first dimension) will be checked for matching.
 * @param exceptionPrefix: Execption prefix message, used in generating error
 *   messages.
 * @throws ValueError: on incorrect number of inputs or mismatches in shapes.
 */ function $9279084e18d7cb75$var$checkInputData(data, names, shapes, checkBatchAxis = true, exceptionPrefix = '') {
    let arrays;
    if (Array.isArray(data)) {
        if (data.length !== names.length) throw new (0, $kubuc.ValueError)(`Error when checking model ${exceptionPrefix}: the Array of ` + `Tensors that you are passing to your model is not the size the ` + `the model expected. Expected to see ${names.length} Tensor(s),` + ` but instead got ${data.length} Tensors(s).`);
        arrays = data;
    } else {
        if (names.length > 1) throw new (0, $kubuc.ValueError)(`The model expects ${names.length} ${exceptionPrefix} Tensors, ` + `but only received one Tensor. Found: array with shape ` + `${JSON.stringify(data.shape)}.`);
        arrays = [
            data
        ];
    }
    if (shapes != null) for(let i = 0; i < names.length; ++i){
        if (shapes[i] == null) continue;
        const array = arrays[i];
        if (array.shape.length !== shapes[i].length) throw new (0, $kubuc.ValueError)(`Error when checking ${exceptionPrefix}: expected ${names[i]} ` + `to have ${shapes[i].length} dimension(s), but got array with ` + `shape ${JSON.stringify(array.shape)}`);
        for(let j = 0; j < shapes[i].length; ++j){
            if (j === 0 && !checkBatchAxis) continue;
            const dim = array.shape[j];
            const refDim = shapes[i][j];
            if (refDim != null) {
                if (refDim !== dim) throw new (0, $kubuc.ValueError)(`Error when checking ${exceptionPrefix}: expected ` + `${names[i]} to have shape ${JSON.stringify(shapes[i])} but ` + `got array with shape ${JSON.stringify(array.shape)}.`);
            }
        }
    }
}
function $9279084e18d7cb75$export$f17c6a7c45a213ae(metrics, outputNames) {
    if (metrics == null || Array.isArray(metrics) && metrics.length === 0) return outputNames.map((name)=>[]);
    let wrappedMetrics;
    if (typeof metrics === 'string' || typeof metrics === 'function') wrappedMetrics = [
        metrics
    ];
    else if (Array.isArray(metrics) || typeof metrics === 'object') wrappedMetrics = metrics;
    else throw new TypeError('Type of metrics argument not understood. Expected an string,' + `function, Array, or Object, found: ${metrics}`);
    if (Array.isArray(wrappedMetrics)) // We then apply all metrics to all outputs.
    return outputNames.map((name)=>wrappedMetrics);
    else {
        // In this case, metrics is a dict.
        const nestedMetrics = [];
        for (const name of outputNames){
            let outputMetrics = wrappedMetrics.hasOwnProperty(name) ? wrappedMetrics[name] : [];
            if (!Array.isArray(outputMetrics)) outputMetrics = [
                outputMetrics
            ];
            nestedMetrics.push(outputMetrics);
        }
        return nestedMetrics;
    }
}
const $9279084e18d7cb75$var$LAYERS_MODEL_FORMAT_NAME = 'layers-model';
/**
 * A `tf.LayersModel` is a directed, acyclic graph of `tf.Layer`s plus methods
 * for training, evaluation, prediction and saving.
 *
 * `tf.LayersModel` is the basic unit of training, inference and evaluation in
 * TensorFlow.js. To create a `tf.LayersModel`, use `tf.LayersModel`.
 *
 * See also:
 *   `tf.Sequential`, `tf.loadLayersModel`.
 *
 * @doc {heading: 'Models', subheading: 'Classes'}
 */ class $9279084e18d7cb75$export$f8e130845653852b extends (0, $3foX0.Container) {
    constructor(args){
        super(args);
        this.isTraining = false;
    }
    /**
     * Print a text summary of the model's layers.
     *
     * The summary includes
     * - Name and type of all layers that comprise the model.
     * - Output shape(s) of the layers
     * - Number of weight parameters of each layer
     * - If the model has non-sequential-like topology, the inputs each layer
     *   receives
     * - The total number of trainable and non-trainable parameters of the model.
     *
     * ```js
     * const input1 = tf.input({shape: [10]});
     * const input2 = tf.input({shape: [20]});
     * const dense1 = tf.layers.dense({units: 4}).apply(input1);
     * const dense2 = tf.layers.dense({units: 8}).apply(input2);
     * const concat = tf.layers.concatenate().apply([dense1, dense2]);
     * const output =
     *     tf.layers.dense({units: 3, activation: 'softmax'}).apply(concat);
     *
     * const model = tf.model({inputs: [input1, input2], outputs: output});
     * model.summary();
     * ```
     *
     * @param lineLength Custom line length, in number of characters.
     * @param positions Custom widths of each of the columns, as either
     *   fractions of `lineLength` (e.g., `[0.5, 0.75, 1]`) or absolute number
     *   of characters (e.g., `[30, 50, 65]`). Each number corresponds to
     *   right-most (i.e., ending) position of a column.
     * @param printFn Custom print function. Can be used to replace the default
     *   `console.log`. For example, you can use `x => {}` to mute the printed
     *   messages in the console.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ summary(lineLength, positions, printFn = console.log) {
        if (!this.built) throw new (0, $kubuc.ValueError)(`This model has never been called, thus its weights have not been ` + `created yet. So no summary can be displayed. Build the model ` + `first (e.g., by calling it on some test data).`);
        (0, $lKxUo.printSummary)(this, lineLength, positions, printFn);
    }
    /**
     * Configures and prepares the model for training and evaluation.  Compiling
     * outfits the model with an optimizer, loss, and/or metrics.  Calling `fit`
     * or `evaluate` on an un-compiled model will throw an error.
     *
     * @param args a `ModelCompileArgs` specifying the loss, optimizer, and
     * metrics to be used for fitting and evaluating this model.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ compile(args) {
        if (args.loss == null) args.loss = [];
        this.loss = args.loss;
        if (typeof args.optimizer === 'string') {
            this.optimizer_ = $4Sjwz.getOptimizer(args.optimizer);
            this.isOptimizerOwned = true;
        } else {
            if (!(args.optimizer instanceof (0, $2jiJm.Optimizer))) throw new (0, $kubuc.ValueError)(`User-defined optimizer must be an instance of tf.Optimizer.`);
            this.optimizer_ = args.optimizer;
            this.isOptimizerOwned = false;
        }
        // TODO(cais): Add lossWeights.
        // TODO(cais): Add sampleWeightMode.
        // Prepare loss functions.
        let lossFunctions = [];
        if (!Array.isArray(args.loss) && typeof args.loss !== 'string' && typeof args.loss !== 'function') {
            args.loss = args.loss;
            for(const name in args.loss){
                if (this.outputNames.indexOf(name) === -1) throw new (0, $kubuc.ValueError)(`Unknown entry in loss dictionary: "${name}". ` + `Only expected the following keys: ${this.outputNames}`);
            }
            for (const name of this.outputNames){
                if (args.loss[name] == null) console.warn(`Output "${name}" is missing from loss dictionary. We assume ` + `this was done on purpose, and we will not be expecting data ` + `to be passed to ${name} during training`);
                lossFunctions.push($lg9tU.get(args.loss[name]));
            }
        } else if (Array.isArray(args.loss)) {
            if (args.loss.length !== this.outputs.length) throw new (0, $kubuc.ValueError)(`When passing an Array as loss, it should have one entry per ` + `model output. The model has ${this.outputs.length} output(s), ` + `but you passed loss=${args.loss}.`);
            const theLosses = args.loss;
            lossFunctions = theLosses.map((l)=>$lg9tU.get(l));
        } else {
            const lossFunction = $lg9tU.get(args.loss);
            this.outputs.forEach((_)=>{
                lossFunctions.push(lossFunction);
            });
        }
        this.lossFunctions = lossFunctions;
        this.feedOutputNames = [];
        this.feedOutputShapes = [];
        this.feedLossFns = [];
        for(let i = 0; i < this.outputs.length; ++i){
            // TODO(cais): Logic for skipping target(s).
            const shape = this.internalOutputShapes[i];
            const name = this.outputNames[i];
            this.feedOutputNames.push(name);
            this.feedOutputShapes.push(shape);
            this.feedLossFns.push(this.lossFunctions[i]);
        }
        // TODO(cais): Add logic for output masks.
        // TODO(cais): Add logic for sample weights.
        const skipTargetIndices = [];
        // Prepare metrics.
        this.metrics = args.metrics;
        // TODO(cais): Add weightedMetrics.
        this.metricsNames = [
            'loss'
        ];
        this.metricsTensors = [];
        // Compute total loss.
        // Porting Note: In PyKeras, metrics_tensors are symbolic tensor objects.
        //   Here, metricsTensors are TypeScript functions. This difference is due
        //   to the difference in symbolic/imperative property of the backends.
        (0, $1Xyaa.nameScope)('loss', ()=>{
            for(let i = 0; i < this.outputs.length; ++i){
                if (skipTargetIndices.indexOf(i) !== -1) continue;
                // TODO(cais): Add weightedLoss, sampleWeight and mask.
                //   The following line should be weightedLoss
                const weightedLoss = this.lossFunctions[i];
                if (this.outputs.length > 1) {
                    this.metricsTensors.push([
                        weightedLoss,
                        i
                    ]);
                    this.metricsNames.push(this.outputNames[i] + '_loss');
                }
            }
        // Porting Note: Due to the imperative nature of the backend, we calculate
        //   the regularizer penalties in the totalLossFunction, instead of here.
        });
        const nestedMetrics = $9279084e18d7cb75$export$f17c6a7c45a213ae(args.metrics, this.outputNames);
        // TODO(cais): Add nestedWeightedMetrics.
        /**
         * Helper function used in loop below.
         */ const appendMetric = (outputIndex, metricName, metricTensor)=>{
            if (this.outputNames.length > 1) metricName = this.outputNames[outputIndex] + '_' + metricName;
            this.metricsNames.push(metricName);
            this.metricsTensors.push([
                metricTensor,
                outputIndex
            ]);
        };
        (0, $1Xyaa.nameScope)('metric', ()=>{
            for(let i = 0; i < this.outputs.length; ++i){
                if (skipTargetIndices.indexOf(i) !== -1) continue;
                const outputMetrics = nestedMetrics[i];
                // TODO(cais): Add weights and outputWeightedMetrics.
                // TODO(cais): Add optional arg `weights` to the following function.
                const handleMetrics = (metrics)=>{
                    const metricNamePrefix = '';
                    let metricName;
                    let accFn;
                    let weightedMetricFn;
                    //  TODO(cais): Use 'weights_' for weighted metrics.
                    for (const metric of metrics){
                        if (typeof metric === 'string' && [
                            'accuracy',
                            'acc',
                            'crossentropy',
                            'ce'
                        ].indexOf(metric) !== -1) {
                            const outputShape = this.internalOutputShapes[i];
                            if (outputShape[outputShape.length - 1] === 1 || this.lossFunctions[i] === $lg9tU.binaryCrossentropy) {
                                // case: binary accuracy/crossentropy.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $j6iTL.binaryAccuracy;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $j6iTL.binaryCrossentropy;
                            } else if (this.lossFunctions[i] === $lg9tU.sparseCategoricalCrossentropy) {
                                // case: categorical accuracy / crossentropy with sparse
                                // targets.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $j6iTL.sparseCategoricalAccuracy;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $j6iTL.sparseCategoricalCrossentropy;
                            } else {
                                // case: categorical accuracy / crossentropy.
                                if ([
                                    'accuracy',
                                    'acc'
                                ].indexOf(metric) !== -1) accFn = $j6iTL.categoricalAccuracy;
                                else if ([
                                    'crossentropy',
                                    'ce'
                                ].indexOf(metric) !== -1) accFn = $j6iTL.categoricalCrossentropy;
                            }
                            let suffix;
                            if ([
                                'accuracy',
                                'acc'
                            ].indexOf(metric) !== -1) suffix = 'acc';
                            else if ([
                                'crossentropy',
                                'ce'
                            ].indexOf(metric) !== -1) suffix = 'ce';
                            // TODO(cais): Add weighting actually.
                            weightedMetricFn = accFn;
                            metricName = metricNamePrefix + suffix;
                        } else {
                            const metricFn = $j6iTL.get(metric);
                            // TODO(cais): Add weighting actually.
                            weightedMetricFn = metricFn;
                            metricName = metricNamePrefix + $j6iTL.getLossOrMetricName(metric);
                        }
                        // TODO(cais): Add weighting and masking to metricResult.
                        let metricResult;
                        (0, $1Xyaa.nameScope)(metricName, ()=>{
                            metricResult = weightedMetricFn;
                        });
                        appendMetric(i, metricName, metricResult);
                    }
                };
                handleMetrics(outputMetrics);
            // TODO(cais): Call handleMetrics with weights.
            }
        });
        // Porting Notes: Given the imperative backend of tfjs-core,
        //   there is no need for constructing the symbolic graph and placeholders.
        this.collectedTrainableWeights = this.trainableWeights;
    }
    /**
     * Check trainable weights count consistency.
     *
     * This will raise a warning if `this.trainableWeights` and
     * `this.collectedTrainableWeights` are inconsistent (i.e., have different
     * numbers of parameters).
     * Inconsistency will typically arise when one modifies `model.trainable`
     * without calling `model.compile()` again.
     */ checkTrainableWeightsConsistency() {
        if (this.collectedTrainableWeights == null) return;
        if (this.trainableWeights.length !== this.collectedTrainableWeights.length) console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?");
    }
    /**
     * Returns the loss value & metrics values for the model in test mode.
     *
     * Loss and metrics are specified during `compile()`, which needs to happen
     * before calls to `evaluate()`.
     *
     * Computation is done in batches.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const result = model.evaluate(
     *     tf.ones([8, 10]), tf.ones([8, 1]), {batchSize: 4});
     * result.print();
     * ```
     *
     * @param x `tf.Tensor` of test data, or an `Array` of `tf.Tensor`s if the
     * model has multiple inputs.
     * @param y `tf.Tensor` of target data, or an `Array` of `tf.Tensor`s if the
     * model has multiple outputs.
     * @param args A `ModelEvaluateArgs`, containing optional fields.
     *
     * @return `Scalar` test loss (if the model has a single output and no
     *   metrics) or `Array` of `Scalar`s (if the model has multiple outputs
     *   and/or metrics). The attribute `model.metricsNames`
     *   will give you the display labels for the scalar outputs.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ evaluate(x, y, args = {}) {
        const batchSize = args.batchSize == null ? 32 : args.batchSize;
        (0, $a7zeb.checkBatchSize)(batchSize);
        // TODO(cais): Standardize `config.sampleWeights` as well.
        // Validate user data.
        const checkBatchAxis = true;
        const standardizedOuts = this.standardizeUserDataXY(x, y, checkBatchAxis, batchSize);
        try {
            // TODO(cais): If uses `useLearningPhase`, set the corresponding element
            // of the input to 0.
            const ins = standardizedOuts[0].concat(standardizedOuts[1]);
            this.makeTestFunction();
            const f = this.testFunction;
            const testOuts = this.testLoop(f, ins, batchSize, args.verbose, args.steps);
            return (0, $jYx5u.singletonOrArray)(testOuts);
        } finally{
            (0, $a7zeb.disposeNewTensors)(standardizedOuts[0], x);
            (0, $a7zeb.disposeNewTensors)(standardizedOuts[1], y);
        }
    }
    // TODO(cais): Add code snippet below once real dataset objects are
    //   available.
    /**
     * Evaluate model using a dataset object.
     *
     * Note: Unlike `evaluate()`, this method is asynchronous (`async`).
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for evaluation. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs. Of the two items in the array, the
     *   first is the input feature(s) and the second is the output target(s).
     * @param args A configuration object for the dataset-based evaluation.
     * @returns Loss and metric values as an Array of `Scalar` objects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async evaluateDataset(dataset, args) {
        this.makeTestFunction();
        return (0, $iR99G.evaluateDataset)(this, dataset, args);
    }
    /**
     * Get number of samples provided for training, evaluation or prediction.
     *
     * @param ins Input `tf.Tensor`.
     * @param batchSize Integer batch size, optional.
     * @param steps Total number of steps (batches of samples) before
     * declaring loop finished. Optional.
     * @param stepsName The public API's parameter name for `steps`.
     * @returns Number of samples provided.
     */ checkNumSamples(ins, batchSize, steps, stepsName = 'steps') {
        let numSamples;
        if (steps != null) {
            numSamples = null;
            if (batchSize != null) throw new (0, $kubuc.ValueError)(`If ${stepsName} is set, batchSize must be null or undefined.` + `Got batchSize = ${batchSize}`);
        } else if (ins != null) {
            if (Array.isArray(ins)) numSamples = ins[0].shape[0];
            else numSamples = ins.shape[0];
        } else throw new (0, $kubuc.ValueError)(`Either the input data should have a defined shape, or ` + `${stepsName} shoud be specified.`);
        return numSamples;
    }
    /**
     * Execute internal tensors of the model with input data feed.
     * @param inputs Input data feed. Must match the inputs of the model.
     * @param outputs Names of the output tensors to be fetched. Must match
     *   names of the SymbolicTensors that belong to the graph.
     * @returns Fetched values for `outputs`.
     */ execute(inputs, outputs) {
        if (Array.isArray(outputs) && outputs.length === 0) throw new (0, $kubuc.ValueError)('`outputs` is an empty Array, which is not allowed.');
        const outputsIsArray = Array.isArray(outputs);
        const outputNames = outputsIsArray ? outputs : [
            outputs
        ];
        const outputSymbolicTensors = this.retrieveSymbolicTensors(outputNames);
        // Format the input into a FeedDict.
        const feedDict = new (0, $iyRtt.FeedDict)();
        if (inputs instanceof (0, $3pVUH.Tensor)) inputs = [
            inputs
        ];
        if (Array.isArray(inputs)) {
            if (inputs.length !== this.inputs.length) throw new (0, $kubuc.ValueError)(`The number of inputs provided (${inputs.length}) ` + `does not match the number of inputs of this model ` + `(${this.inputs.length}).`);
            for(let i = 0; i < this.inputs.length; ++i)feedDict.add(this.inputs[i], inputs[i]);
        } else for (const input of this.inputs){
            const tensorValue = inputs[input.name];
            if (tensorValue == null) throw new (0, $kubuc.ValueError)(`No value is provided for the model's input ${input.name}`);
            feedDict.add(input, tensorValue);
        }
        // Run execution.
        const executeOutputs = (0, $iyRtt.execute)(outputSymbolicTensors, feedDict);
        return outputsIsArray ? executeOutputs : executeOutputs[0];
    }
    /**
     * Retrieve the model's internal symbolic tensors from symbolic-tensor names.
     */ retrieveSymbolicTensors(symbolicTensorNames) {
        const outputSymbolicTensors = (0, $jYx5u.pyListRepeat)(null, symbolicTensorNames.length);
        let outputsRemaining = symbolicTensorNames.length;
        for (const layer of this.layers){
            const layerOutputs = Array.isArray(layer.output) ? layer.output : [
                layer.output
            ];
            const layerOutputNames = layerOutputs.map((output)=>output.name);
            for(let i = 0; i < symbolicTensorNames.length; ++i){
                const index = layerOutputNames.indexOf(symbolicTensorNames[i]);
                if (index !== -1) {
                    outputSymbolicTensors[i] = layerOutputs[index];
                    outputsRemaining--;
                }
                if (outputsRemaining === 0) break;
            }
            if (outputsRemaining === 0) break;
        }
        if (outputsRemaining > 0) {
            const remainingNames = [];
            outputSymbolicTensors.forEach((tensor, i)=>{
                if (tensor == null) remainingNames.push(symbolicTensorNames[i]);
            });
            throw new (0, $kubuc.ValueError)(`Cannot find SymbolicTensors for output name(s): ` + `${JSON.stringify(remainingNames)}`);
        }
        return outputSymbolicTensors;
    }
    /**
     * Helper method to loop over some data in batches.
     *
     * Porting Note: Not using the functional approach in the Python equivalent
     *   due to the imperative backend.
     * Porting Note: Does not support step mode currently.
     *
     * @param ins: input data
     * @param batchSize: integer batch size.
     * @param verbose: verbosity model
     * @returns: Predictions as `tf.Tensor` (if a single output) or an `Array` of
     *   `tf.Tensor` (if multipe outputs).
     */ predictLoop(ins, batchSize = 32, verbose = false) {
        return $d7Nxs.tidy(()=>{
            const numSamples = this.checkNumSamples(ins);
            if (verbose) throw new (0, $kubuc.NotImplementedError)('Verbose predictLoop() is not implemented yet.');
            // Sample-based predictions.
            // Porting Note: Tensor currently does not support sliced assignments as
            //   in numpy, e.g., x[1:3] = y. Therefore we use concatenation while
            //   iterating over the batches.
            const batches = (0, $a7zeb.makeBatches)(numSamples, batchSize);
            const outsBatches = this.outputs.map((output)=>[]);
            // TODO(cais): Can the scope() be pushed down inside the for loop?
            for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                const batchOuts = $d7Nxs.tidy(()=>{
                    const batchStart = batches[batchIndex][0];
                    const batchEnd = batches[batchIndex][1];
                    // TODO(cais): Take care of the case of the last element is a flag for
                    //   training/test.
                    const insBatch = (0, $a7zeb.sliceArrays)(ins, batchStart, batchEnd);
                    // Construct the feeds for execute();
                    const feeds = [];
                    if (Array.isArray(insBatch)) for(let i = 0; i < insBatch.length; ++i)feeds.push({
                        key: this.inputs[i],
                        value: insBatch[i]
                    });
                    else feeds.push({
                        key: this.inputs[0],
                        value: insBatch
                    });
                    const feedDict = new (0, $iyRtt.FeedDict)(feeds);
                    return (0, $iyRtt.execute)(this.outputs, feedDict);
                });
                batchOuts.forEach((batchOut, i)=>outsBatches[i].push(batchOut));
            }
            return (0, $jYx5u.singletonOrArray)(outsBatches.map((batches)=>$1goxr.concat(batches, 0)));
        });
    }
    /**
     * Generates output predictions for the input samples.
     *
     * Computation is done in batches.
     *
     * Note: the "step" mode of predict() is currently not supported.
     *   This is because the TensorFlow.js core backend is imperative only.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predict(tf.ones([8, 10]), {batchSize: 4}).print();
     * ```
     *
     * @param x The input data, as a Tensor, or an `Array` of `tf.Tensor`s if
     *   the model has multiple inputs.
     * @param args A `ModelPredictArgs` object containing optional fields.
     *
     * @return Prediction results as a `tf.Tensor`(s).
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and the model's expectations, or in case a stateful model receives a
     *   number of samples that is not a multiple of the batch size.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(x, args = {}) {
        const xsRank2OrHigher = (0, $a7zeb.ensureTensorsRank2OrHigher)(x);
        $9279084e18d7cb75$var$checkInputData(xsRank2OrHigher, this.inputNames, this.feedInputShapes, false);
        try {
            // TODO(cais): Take care of stateful models.
            //   if (this.stateful) ...
            // TODO(cais): Take care of the learning_phase boolean flag.
            //   if (this.useLearningPhase) ...
            const batchSize = args.batchSize == null ? 32 : args.batchSize;
            (0, $a7zeb.checkBatchSize)(batchSize);
            return this.predictLoop(xsRank2OrHigher, batchSize);
        } finally{
            (0, $a7zeb.disposeNewTensors)(xsRank2OrHigher, x);
        }
    }
    /**
     * Returns predictions for a single batch of samples.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predictOnBatch(tf.ones([8, 10])).print();
     * ```
     * @param x: Input samples, as a Tensor (for models with exactly one
     *   input) or an array of Tensors (for models with more than one input).
     * @return Tensor(s) of predictions
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predictOnBatch(x) {
        $9279084e18d7cb75$var$checkInputData(x, this.inputNames, this.feedInputShapes, true);
        // TODO(cais): Take care of the learning_phase boolean flag.
        //   if (this.useLearningPhase) ...
        const batchSize = (Array.isArray(x) ? x[0] : x).shape[0];
        return this.predictLoop(x, batchSize);
    }
    standardizeUserDataXY(x, y, checkBatchAxis = true, batchSize) {
        // TODO(cais): Add sampleWeight, classWeight
        if (this.optimizer_ == null) throw new (0, $kubuc.RuntimeError)("You must compile a model before training/testing. Use LayersModel.compile(modelCompileArgs).");
        const outputShapes = [];
        for(let i = 0; i < this.feedOutputShapes.length; ++i){
            const outputShape = this.feedOutputShapes[i];
            const lossFn = this.feedLossFns[i];
            if (lossFn === $lg9tU.sparseCategoricalCrossentropy) outputShapes.push(outputShape.slice(0, outputShape.length - 1).concat([
                1
            ]));
            else // Porting Note: Because of strong typing `lossFn` must be a function.
            outputShapes.push(outputShape);
        }
        x = $9279084e18d7cb75$export$69dd7486f5c87261(x, this.feedInputNames, this.feedInputShapes, false, 'input');
        y = $9279084e18d7cb75$export$69dd7486f5c87261(y, this.feedOutputNames, outputShapes, false, 'target');
        // TODO(cais): Standardize sampleWeights & classWeights.
        $9279084e18d7cb75$export$4b125fd48a812392(x, y, null);
        // TODO(cais): Check sampleWeights as well.
        $9279084e18d7cb75$var$checkLossAndTargetCompatibility(y, this.feedLossFns, this.feedOutputShapes);
        if (this.stateful && batchSize != null && batchSize > 0) {
            if (x[0].shape[0] % batchSize !== 0) throw new (0, $kubuc.ValueError)(`In a stateful network, you should only pass inputs with a ` + `number of samples that is divisible by the batch size ` + `${batchSize}. Found: ${x[0].shape[0]} sample(s).`);
        }
        return [
            x,
            y
        ];
    }
    async standardizeUserData(x, y, sampleWeight, classWeight, checkBatchAxis = true, batchSize) {
        const [standardXs, standardYs] = this.standardizeUserDataXY(x, y, checkBatchAxis, batchSize);
        // TODO(cais): Handle sampleWeights.
        if (sampleWeight != null) throw new Error('sample weight is not supported yet.');
        let standardSampleWeights = null;
        if (classWeight != null) {
            const classWeights = (0, $10YKi.standardizeClassWeights)(classWeight, this.outputNames);
            standardSampleWeights = [];
            for(let i = 0; i < classWeights.length; ++i)standardSampleWeights.push(await (0, $10YKi.standardizeWeights)(standardYs[i], null, classWeights[i]));
        }
        // TODO(cais): Deal with the case of model.stateful == true.
        return [
            standardXs,
            standardYs,
            standardSampleWeights
        ];
    }
    /**
     * Loop over some test data in batches.
     * @param f A Function returning a list of tensors.
     * @param ins Array of tensors to be fed to `f`.
     * @param batchSize Integer batch size or `null` / `undefined`.
     * @param verbose verbosity mode.
     * @param steps Total number of steps (batches of samples) before
     * declaring test finished. Ignored with the default value of `null` /
     * `undefined`.
     * @returns Array of Scalars.
     */ testLoop(f, ins, batchSize, verbose = 0, steps) {
        return $d7Nxs.tidy(()=>{
            const numSamples = this.checkNumSamples(ins, batchSize, steps, 'steps');
            const outs = [];
            if (verbose > 0) throw new (0, $kubuc.NotImplementedError)('Verbose mode is not implemented yet.');
            // TODO(cais): Use `indicesForConversionToDense' to prevent slow down.
            if (steps != null) throw new (0, $kubuc.NotImplementedError)('steps mode in testLoop() is not implemented yet');
            else {
                const batches = (0, $a7zeb.makeBatches)(numSamples, batchSize);
                const indexArray = (0, $8tOOR.tensor1d)((0, $4SWqG.range)(0, numSamples));
                for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                    const batchStart = batches[batchIndex][0];
                    const batchEnd = batches[batchIndex][1];
                    const batchIds = $4AyI5.sliceAlongFirstAxis(indexArray, batchStart, batchEnd - batchStart);
                    // TODO(cais): In ins, train flag can be a number, instead of an
                    //   Tensor? Do we need to handle this in tfjs-layers?
                    const insBatch = (0, $a7zeb.sliceArraysByIndices)(ins, batchIds);
                    const batchOuts = f(insBatch);
                    if (batchIndex === 0) for(let i = 0; i < batchOuts.length; ++i)outs.push((0, $7hONX.scalar)(0));
                    for(let i = 0; i < batchOuts.length; ++i){
                        const batchOut = batchOuts[i];
                        outs[i] = $6Ab5n.add(outs[i], $5hAos.mul(batchEnd - batchStart, batchOut));
                    }
                }
                for(let i = 0; i < outs.length; ++i)outs[i] = $dIChU.div(outs[i], numSamples);
            }
            return outs;
        });
    }
    getDedupedMetricsNames() {
        const outLabels = this.metricsNames;
        // Rename duplicated metrics names (can happen with an output layer
        // shared among multiple dataflows).
        const dedupedOutLabels = [];
        for(let i = 0; i < outLabels.length; ++i){
            const label = outLabels[i];
            let newLabel = label;
            if ((0, $jYx5u.count)(outLabels, label) > 1) {
                const dupIndex = (0, $jYx5u.count)(outLabels.slice(0, i), label);
                newLabel += `_${dupIndex}`;
            }
            dedupedOutLabels.push(newLabel);
        }
        return dedupedOutLabels;
    }
    /**
     * Creates a function that performs the following actions:
     *
     * 1. computes the losses
     * 2. sums them to get the total loss
     * 3. call the optimizer computes the gradients of the LayersModel's
     *    trainable weights w.r.t. the total loss and update the variables
     * 4. calculates the metrics
     * 5. returns the values of the losses and metrics.
     */ makeTrainFunction() {
        return (data)=>{
            const lossValues = [];
            const inputs = data.slice(0, this.inputs.length);
            const targets = data.slice(this.inputs.length, this.inputs.length + this.outputs.length);
            const sampleWeights = data.slice(this.inputs.length + this.outputs.length, this.inputs.length + this.outputs.length * 2);
            const metricsValues = [];
            // Create a function that computes the total loss based on the
            // inputs. This function is used for obtaining gradients through
            // backprop.
            const totalLossFunction = ()=>{
                const feeds = [];
                for(let i = 0; i < this.inputs.length; ++i)feeds.push({
                    key: this.inputs[i],
                    value: inputs[i]
                });
                const feedDict = new (0, $iyRtt.FeedDict)(feeds);
                const outputs = (0, $iyRtt.execute)(this.outputs, feedDict, {
                    'training': true
                });
                // TODO(cais): Take care of the case of multiple outputs from a
                //   single layer?
                let totalLoss;
                for(let i = 0; i < this.lossFunctions.length; ++i){
                    const lossFunction = this.lossFunctions[i];
                    let loss = lossFunction(targets[i], outputs[i]);
                    if (sampleWeights[i] != null) loss = (0, $10YKi.computeWeightedLoss)(loss, sampleWeights[i]);
                    // TODO(cais): push Scalar instead.
                    const meanLoss = $3TgHP.mean(loss);
                    // TODO(cais): Use a scope() instead, to avoid ownership.
                    lossValues.push(meanLoss);
                    if (i === 0) totalLoss = loss;
                    else totalLoss = $6Ab5n.add(totalLoss, loss);
                }
                // Compute the metrics.
                // TODO(cais): These should probably be calculated outside
                //   totalLossFunction to benefit speed?
                for(let i = 0; i < this.metricsTensors.length; ++i){
                    let weightedMetric;
                    if (this.outputs.length > 1 && i < this.outputs.length) weightedMetric = lossValues[i];
                    else {
                        const metric = this.metricsTensors[i][0];
                        const outputIndex = this.metricsTensors[i][1];
                        weightedMetric = $3TgHP.mean(metric(targets[outputIndex], outputs[outputIndex]));
                    }
                    $d7Nxs.keep(weightedMetric);
                    // TODO(cais): Use a scope() instead, to avoid ownership.
                    metricsValues.push(weightedMetric);
                }
                totalLoss = $3TgHP.mean(totalLoss);
                // Add regularizer penalties.
                this.calculateLosses().forEach((regularizerLoss)=>{
                    totalLoss = $6Ab5n.add(totalLoss, regularizerLoss);
                });
                return totalLoss;
            };
            const variables = this.collectedTrainableWeights.map((param)=>param.read());
            const returnCost = true;
            const totalLossValue = this.optimizer_.minimize(totalLossFunction, returnCost, variables);
            return [
                totalLossValue
            ].concat(metricsValues);
        };
    }
    /**
     * Create a function which, when invoked with an array of `tf.Tensor`s as a
     * batch of inputs, returns the prespecified loss and metrics of the model
     * under the batch of input data.
     */ makeTestFunction() {
        this.testFunction = (data)=>{
            return $d7Nxs.tidy(()=>{
                const valOutputs = [];
                let totalLoss;
                const inputs = data.slice(0, this.inputs.length);
                const targets = data.slice(this.inputs.length, this.inputs.length + this.outputs.length);
                const feeds = [];
                for(let i = 0; i < this.inputs.length; ++i)feeds.push({
                    key: this.inputs[i],
                    value: inputs[i]
                });
                const feedDict = new (0, $iyRtt.FeedDict)(feeds);
                const outputs = (0, $iyRtt.execute)(this.outputs, feedDict);
                // Compute total loss.
                for(let i = 0; i < this.lossFunctions.length; ++i){
                    const lossFunction = this.lossFunctions[i];
                    // TODO(cais): Add sample weighting and replace the simple
                    // averaging.
                    const loss = $3TgHP.mean(lossFunction(targets[i], outputs[i]));
                    if (i === 0) totalLoss = loss;
                    else totalLoss = $6Ab5n.add(totalLoss, loss);
                    valOutputs.push(totalLoss);
                }
                // Compute the metrics.
                for(let i = 0; i < this.metricsTensors.length; ++i){
                    const metric = this.metricsTensors[i][0];
                    const outputIndex = this.metricsTensors[i][1];
                    // TODO(cais): Replace K.mean() with a proper weighting function.
                    const meanMetric = $3TgHP.mean(metric(targets[outputIndex], outputs[outputIndex]));
                    valOutputs.push(meanMetric);
                }
                return valOutputs;
            });
        };
    }
    /**
     * Trains the model for a fixed number of epochs (iterations on a
     * dataset).
     *
     * ```js
     * const model = tf.sequential({
     *     layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * for (let i = 1; i < 5 ; ++i) {
     *   const h = await model.fit(tf.ones([8, 10]), tf.ones([8, 1]), {
     *       batchSize: 4,
     *       epochs: 3
     *   });
     *   console.log("Loss after Epoch " + i + " : " + h.history.loss[0]);
     * }
     * ```
     *
     * @param x `tf.Tensor` of training data, or an array of `tf.Tensor`s if the
     * model has multiple inputs. If all inputs in the model are named, you
     * can also pass a dictionary mapping input names to `tf.Tensor`s.
     * @param y `tf.Tensor` of target (label) data, or an array of `tf.Tensor`s if
     * the model has multiple outputs. If all outputs in the model are named,
     * you can also pass a dictionary mapping output names to `tf.Tensor`s.
     * @param args A `ModelFitArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @exception ValueError In case of mismatch between the provided input
     * data and what the model expects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fit(x, y, args = {}) {
        if (this.isTraining) throw new Error('Cannot start training because another fit() call is ongoing.');
        this.isTraining = true;
        let inputs;
        let targets;
        let originalInputs;
        let originalTargets;
        let inputValX;
        let inputValY;
        let valX;
        let valY;
        let sampleWeights;
        try {
            const batchSize = args.batchSize == null ? 32 : args.batchSize;
            (0, $a7zeb.checkBatchSize)(batchSize);
            // Validate user data.
            // TODO(cais): Support sampleWeight.
            const checkBatchAxis = false;
            const standardizedOuts = await this.standardizeUserData(x, y, args.sampleWeight, args.classWeight, checkBatchAxis, batchSize);
            inputs = standardizedOuts[0];
            targets = standardizedOuts[1];
            sampleWeights = standardizedOuts[2];
            // Prepare validation data.
            let doValidation = false;
            let valIns;
            if (args.validationData != null && args.validationData.length > 0) {
                doValidation = true;
                if (args.validationData.length === 2) {
                    // config.validationData consists of valX and valY.
                    inputValX = args.validationData[0];
                    inputValY = args.validationData[1];
                } else if (args.validationData.length === 3) throw new (0, $kubuc.NotImplementedError)('validationData including sample weights is not supported yet.');
                else throw new (0, $kubuc.ValueError)(`When passing validation data, it must contain 2 (valX, valY) ` + `or 3 (valX, valY, valSampleWeight) items; ` + `${args.validationData} is invalid.`);
                const checkBatchAxis = true;
                const valStandardized = await this.standardizeUserData(inputValX, inputValY, null, /** Unused sample weights. */ null, /** Unused class weights. */ checkBatchAxis, batchSize);
                valX = valStandardized[0];
                valY = valStandardized[1];
                valIns = valX.concat(valY);
            // TODO(cais): Add useLearningPhase data properly.
            } else if (args.validationSplit != null && args.validationSplit > 0 && args.validationSplit < 1) {
                doValidation = true;
                // Porting Note: In tfjs-layers, inputs[0] is always a Tensor.
                const splitAt = Math.floor(inputs[0].shape[0] * (1 - args.validationSplit));
                const originalBatchSize = inputs[0].shape[0];
                valX = (0, $a7zeb.sliceArrays)(inputs, splitAt, originalBatchSize);
                originalInputs = inputs;
                inputs = (0, $a7zeb.sliceArrays)(inputs, 0, splitAt);
                valY = (0, $a7zeb.sliceArrays)(targets, splitAt, originalBatchSize);
                originalTargets = targets;
                targets = (0, $a7zeb.sliceArrays)(targets, 0, splitAt);
                // TODO(cais): Once sampleWeights becomes available, slice it to get
                //   valSampleWeights.
                valIns = valX.concat(valY);
            // TODO(cais): Add useLearningPhase data properly.
            } else if (args.validationSteps != null) doValidation = true;
            const ins = inputs.concat(targets).concat(sampleWeights);
            this.checkTrainableWeightsConsistency();
            // TODO(cais): Handle use_learning_phase and learning_phase?
            // Porting Note: Here we see a key deviation of tfjs-layers from
            // Keras.
            //  Due to the imperative nature of tfjs-layers' backend (tfjs-core),
            //  we do not construct symbolic computation graphs to embody the
            //  training process. Instead, we define a function that performs the
            //  training action. In PyKeras, the data (inputs and targets) are fed
            //  through graph placeholders. In tfjs-layers, the data are fed as
            //  function arguments. Since the function are defined below in the
            //  scope, we don't have equivalents of PyKeras's
            //  `_make_train_funciton`.
            const trainFunction = this.makeTrainFunction();
            const outLabels = this.getDedupedMetricsNames();
            let valFunction;
            let callbackMetrics;
            if (doValidation) {
                this.makeTestFunction();
                valFunction = this.testFunction;
                callbackMetrics = outLabels.slice().concat(outLabels.map((n)=>'val_' + n));
            } else {
                valFunction = null;
                valIns = [];
                callbackMetrics = outLabels.slice();
            }
            const callbacks = (0, $801Oz.standardizeCallbacks)(args.callbacks, args.yieldEvery);
            const out = await this.fitLoop(trainFunction, ins, outLabels, batchSize, args.epochs, args.verbose, callbacks, valFunction, valIns, args.shuffle, callbackMetrics, args.initialEpoch, null, null);
            return out;
        } finally{
            this.isTraining = false;
            // Memory clean up.
            (0, $a7zeb.disposeNewTensors)(inputs, x);
            (0, $a7zeb.disposeNewTensors)(targets, y);
            (0, $a7zeb.disposeNewTensors)(originalInputs, x);
            (0, $a7zeb.disposeNewTensors)(originalTargets, y);
            (0, $a7zeb.disposeNewTensors)(valX, inputValX);
            (0, $a7zeb.disposeNewTensors)(valY, inputValY);
            if (sampleWeights != null) $d7Nxs.dispose(sampleWeights);
        }
    // TODO(cais): Add value to outLabels.
    }
    /**
     * Abstract fit function for `f(ins)`.
     * @param f A Function returning a list of tensors. For training, this
     *   function is expected to perform the updates to the variables.
     * @param ins List of tensors to be fed to `f`.
     * @param outLabels List of strings, display names of the outputs of `f`.
     * @param batchSize Integer batch size or `== null` if unknown. Default : 32.
     * @param epochs Number of times to iterate over the data. Default : 1.
     * @param verbose Verbosity mode: 0, 1, or 2. Default: 1.
     * @param callbacks List of callbacks to be called during training.
     * @param valF Function to call for validation.
     * @param valIns List of tensors to be fed to `valF`.
     * @param shuffle Whether to shuffle the data at the beginning of every
     * epoch. Default : true.
     * @param callbackMetrics List of strings, the display names of the metrics
     *   passed to the callbacks. They should be the concatenation of the
     *   display names of the outputs of `f` and the list of display names
     *   of the outputs of `valF`.
     * @param initialEpoch Epoch at which to start training (useful for
     *   resuming a previous training run). Default : 0.
     * @param stepsPerEpoch Total number of steps (batches on samples) before
     *   declaring one epoch finished and starting the next epoch. Ignored with
     *   the default value of `undefined` or `null`.
     * @param validationSteps Number of steps to run validation for (only if
     *   doing validation from data tensors). Not applicable for tfjs-layers.
     * @returns A `History` object.
     */ async fitLoop(f, ins, outLabels, batchSize, epochs, verbose, callbacks, valF, valIns, shuffle, callbackMetrics, initialEpoch, stepsPerEpoch, validationSteps) {
        if (batchSize == null) batchSize = 32;
        if (epochs == null) epochs = 1;
        if (shuffle == null) shuffle = true;
        if (initialEpoch == null) initialEpoch = 0;
        // TODO(cais): Change const to let below when implementing validation.
        let doValidation = false;
        if (valF != null && valIns != null) doValidation = true;
        if (validationSteps != null) {
            doValidation = true;
            if (stepsPerEpoch == null) throw new (0, $kubuc.ValueError)("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");
        }
        const numTrainSamples = this.checkNumSamples(ins, batchSize, stepsPerEpoch, 'steps_per_epoch');
        let indexArray;
        if (numTrainSamples != null) indexArray = (0, $4SWqG.range)(0, numTrainSamples);
        if (verbose == null) verbose = 1;
        const { callbackList: callbackList, history: history } = (0, $801Oz.configureCallbacks)(callbacks, verbose, epochs, initialEpoch, numTrainSamples, stepsPerEpoch, batchSize, doValidation, callbackMetrics);
        callbackList.setModel(this);
        this.history = history;
        await callbackList.onTrainBegin();
        this.stopTraining_ = false;
        // TODO(cais): Take care of callbacks.validation_data as in PyKeras.
        // TODO(cais): Pre-convert feeds for performance as in PyKeras.
        for(let epoch = initialEpoch; epoch < epochs; ++epoch){
            await callbackList.onEpochBegin(epoch);
            const epochLogs = {};
            if (stepsPerEpoch != null) throw new (0, $kubuc.NotImplementedError)('stepsPerEpoch mode is not implemented yet.');
            else {
                if (shuffle === 'batch') throw new (0, $kubuc.NotImplementedError)("batch shuffling is not implemneted yet");
                else if (shuffle) (0, $lBDHD).shuffle(indexArray);
                // Convert the potentially shuffled indices to Tensor1D, to avoid the
                // cost of repeated creation of Array1Ds later on.
                const epochIndexArray1D = (0, $8tOOR.tensor1d)(indexArray);
                const batches = (0, $a7zeb.makeBatches)(numTrainSamples, batchSize);
                for(let batchIndex = 0; batchIndex < batches.length; ++batchIndex){
                    const batchLogs = {};
                    await callbackList.onBatchBegin(batchIndex, batchLogs);
                    $d7Nxs.tidy(()=>{
                        const batchStart = batches[batchIndex][0];
                        const batchEnd = batches[batchIndex][1];
                        const batchIds = $4AyI5.sliceAlongFirstAxis(epochIndexArray1D, batchStart, batchEnd - batchStart);
                        batchLogs['batch'] = batchIndex;
                        batchLogs['size'] = batchEnd - batchStart;
                        // TODO(cais): In ins, train flag can be a number, instead of an
                        //   Tensor? Do we need to handle this in tfjs-layers?
                        const insBatch = (0, $a7zeb.sliceArraysByIndices)(ins, batchIds);
                        const outs = f(insBatch);
                        for(let i = 0; i < outLabels.length; ++i){
                            const label = outLabels[i];
                            const out = outs[i];
                            batchLogs[label] = out;
                            $d7Nxs.keep(out);
                        // TODO(cais): Use scope() to avoid ownership.
                        }
                        if (batchIndex === batches.length - 1) {
                            if (doValidation) {
                                const valOuts = this.testLoop(valF, valIns, batchSize);
                                // Porting Notes: In tfjs-layers, valOuts is always an Array.
                                for(let i = 0; i < outLabels.length; ++i){
                                    const label = outLabels[i];
                                    const out = valOuts[i];
                                    $d7Nxs.keep(out);
                                    // TODO(cais): Use scope() to avoid ownership.
                                    epochLogs['val_' + label] = out;
                                }
                            }
                        }
                    });
                    await callbackList.onBatchEnd(batchIndex, batchLogs);
                    (0, $lcd3O.disposeTensorsInLogs)(batchLogs);
                    if (this.stopTraining_) break;
                // TODO(cais): return outs as list of Tensor.
                }
                epochIndexArray1D.dispose();
            }
            // TODO(cais): Run validation at the end of the epoch.
            await callbackList.onEpochEnd(epoch, epochLogs);
            if (this.stopTraining_) break;
        }
        await callbackList.onTrainEnd();
        await this.history.syncData();
        return this.history;
    }
    // TODO(cais): Add code snippet below when it's possible to instantiate
    //   actual dataset objects.
    /**
     * Trains the model using a dataset object.
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for training. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs.
     *   Of the two items in the array, the first is the input feature(s) and
     *   the second is the output target(s).
     * @param args A `ModelFitDatasetArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fitDataset(dataset, args) {
        return (0, $iR99G.fitDataset)(this, dataset, args);
    }
    /**
     * Runs a single gradient update on a single batch of data.
     *
     * This method differs from `fit()` and `fitDataset()` in the following
     * regards:
     *   - It operates on exactly one batch of data.
     *   - It returns only the loss and metric values, instead of
     *     returning the batch-by-batch loss and metric values.
     *   - It doesn't support fine-grained options such as verbosity and
     *     callbacks.
     *
     * @param x Input data. It could be one of the following:
     *   - A `tf.Tensor`, or an Array of `tf.Tensor`s (in case the model has
     *     multiple inputs).
     *   - An Object mapping input names to corresponding `tf.Tensor` (if the
     *     model has named inputs).
     * @param y Target data. It could be either a `tf.Tensor` or multiple
     *   `tf.Tensor`s. It should be consistent with `x`.
     * @returns Training loss or losses (in case the model has
     *   multiple outputs), along with metrics (if any), as numbers.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async trainOnBatch(x, y) {
        // TODO(cais): Support sampleWeight and classWeight.
        // TODO(cais): Support Dataset objects.
        const standardizeOut = await this.standardizeUserData(x, y);
        const inputs = standardizeOut[0];
        const targets = standardizeOut[1];
        const trainFunction = this.makeTrainFunction();
        const losses = trainFunction(inputs.concat(targets));
        const lossValues = [];
        for (const loss of losses){
            const v = await loss.data();
            lossValues.push(v[0]);
        }
        $d7Nxs.dispose(losses);
        (0, $a7zeb.disposeNewTensors)(standardizeOut[0], x);
        (0, $a7zeb.disposeNewTensors)(standardizeOut[1], y);
        return (0, $jYx5u.singletonOrArray)(lossValues);
    }
    /**
     * Extract weight values of the model.
     *
     * @param config: An instance of `io.SaveConfig`, which specifies
     * model-saving options such as whether only trainable weights are to be
     * saved.
     * @returns A `NamedTensorMap` mapping original weight names (i.e.,
     *   non-uniqueified weight names) to their values.
     */ getNamedWeights(config) {
        const namedWeights = [];
        const trainableOnly = config != null && config.trainableOnly;
        const weights = trainableOnly ? this.trainableWeights : this.weights;
        const weightValues = this.getWeights(trainableOnly);
        for(let i = 0; i < weights.length; ++i){
            if (trainableOnly && !weights[i].trainable) continue;
            namedWeights.push({
                name: weights[i].originalName,
                tensor: weightValues[i]
            });
        }
        return namedWeights;
    }
    /**
     * Setter used for force stopping of LayersModel.fit() (i.e., training).
     *
     * Example:
     *
     * ```js
     * const input = tf.input({shape: [10]});
     * const output = tf.layers.dense({units: 1}).apply(input);
     * const model = tf.model({inputs: [input], outputs: [output]});
     * model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
     * const xs = tf.ones([8, 10]);
     * const ys = tf.zeros([8, 1]);
     *
     * const history = await model.fit(xs, ys, {
     *   epochs: 10,
     *   callbacks: {
     *     onEpochEnd: async (epoch, logs) => {
     *       if (epoch === 2) {
     *         model.stopTraining = true;
     *       }
     *     }
     *   }
     * });
     *
     * // There should be only 3 values in the loss array, instead of 10
     * values,
     * // due to the stopping after 3 epochs.
     * console.log(history.history.loss);
     * ```
     */ set stopTraining(stop) {
        this.stopTraining_ = stop;
    }
    get stopTraining() {
        return this.stopTraining_;
    }
    get optimizer() {
        return this.optimizer_;
    }
    set optimizer(optimizer) {
        if (this.optimizer_ !== optimizer) {
            this.optimizer_ = optimizer;
            this.isOptimizerOwned = false;
        }
    }
    dispose() {
        const result = super.dispose();
        if (result.refCountAfterDispose === 0 && this.optimizer != null && this.isOptimizerOwned) {
            const numTensorsBeforeOptmizerDisposal = $d7Nxs.memory().numTensors;
            this.optimizer_.dispose();
            result.numDisposedVariables += numTensorsBeforeOptmizerDisposal - $d7Nxs.memory().numTensors;
        }
        return result;
    }
    getLossIdentifiers() {
        let lossNames;
        if (typeof this.loss === 'string') lossNames = (0, $jYx5u.toSnakeCase)(this.loss);
        else if (Array.isArray(this.loss)) {
            for (const loss of this.loss){
                if (typeof loss !== 'string') throw new Error('Serialization of non-string loss is not supported.');
            }
            lossNames = this.loss.map((name)=>(0, $jYx5u.toSnakeCase)(name));
        } else {
            const outputNames = Object.keys(this.loss);
            lossNames = {};
            const losses = this.loss;
            for (const outputName of outputNames){
                if (typeof losses[outputName] === 'string') lossNames[outputName] = (0, $jYx5u.toSnakeCase)(losses[outputName]);
                else throw new Error('Serialization of non-string loss is not supported.');
            }
        }
        return lossNames;
    }
    getMetricIdentifiers() {
        if (typeof this.metrics === 'string' || typeof this.metrics === 'function') return [
            (0, $jYx5u.toSnakeCase)($j6iTL.getLossOrMetricName(this.metrics))
        ];
        else if (Array.isArray(this.metrics)) return this.metrics.map((metric)=>(0, $jYx5u.toSnakeCase)($j6iTL.getLossOrMetricName(metric)));
        else {
            const metricsIdentifiers = {};
            for(const key in this.metrics)metricsIdentifiers[key] = (0, $jYx5u.toSnakeCase)($j6iTL.getLossOrMetricName(this.metrics[key]));
            return metricsIdentifiers;
        }
    }
    getTrainingConfig() {
        return {
            loss: this.getLossIdentifiers(),
            metrics: this.getMetricIdentifiers(),
            optimizer_config: {
                class_name: this.optimizer.getClassName(),
                config: this.optimizer.getConfig()
            }
        };
    // TODO(cais): Add weight_metrics when they are supported.
    // TODO(cais): Add sample_weight_mode when it's supported.
    // TODO(cais): Add loss_weights when it's supported.
    }
    loadTrainingConfig(trainingConfig) {
        if (trainingConfig.weighted_metrics != null) throw new Error('Loading weight_metrics is not supported yet.');
        if (trainingConfig.loss_weights != null) throw new Error('Loading loss_weights is not supported yet.');
        if (trainingConfig.sample_weight_mode != null) throw new Error('Loading sample_weight_mode is not supported yet.');
        const tsConfig = (0, $3r0Ja.convertPythonicToTs)(trainingConfig.optimizer_config);
        const optimizer = (0, $4v3Le.deserialize)(tsConfig);
        let loss;
        if (typeof trainingConfig.loss === 'string') loss = (0, $jYx5u.toCamelCase)(trainingConfig.loss);
        else if (Array.isArray(trainingConfig.loss)) loss = trainingConfig.loss.map((lossEntry)=>(0, $jYx5u.toCamelCase)(lossEntry));
        else if (trainingConfig.loss != null) {
            loss = {};
            for(const key in trainingConfig.loss)loss[key] = (0, $jYx5u.toCamelCase)(trainingConfig.loss[key]);
        }
        let metrics;
        if (Array.isArray(trainingConfig.metrics)) metrics = trainingConfig.metrics.map((metric)=>(0, $jYx5u.toCamelCase)(metric));
        else if (trainingConfig.metrics != null) {
            metrics = {};
            for(const key in trainingConfig.metrics)metrics[key] = (0, $jYx5u.toCamelCase)(trainingConfig.metrics[key]);
        }
        this.compile({
            loss: loss,
            metrics: metrics,
            optimizer: optimizer
        });
    }
    /**
     * Save the configuration and/or weights of the LayersModel.
     *
     * An `IOHandler` is an object that has a `save` method of the proper
     * signature defined. The `save` method manages the storing or
     * transmission of serialized data ("artifacts") that represent the
     * model's topology and weights onto or via a specific medium, such as
     * file downloads, local storage, IndexedDB in the web browser and HTTP
     * requests to a server. TensorFlow.js provides `IOHandler`
     * implementations for a number of frequently used saving mediums, such as
     * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
     * for more details.
     *
     * This method also allows you to refer to certain types of `IOHandler`s
     * as URL-like string shortcuts, such as 'localstorage://' and
     * 'indexeddb://'.
     *
     * Example 1: Save `model`'s topology and weights to browser [local
     * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
     * then load it back.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * console.log('Prediction from original model:');
     * model.predict(tf.ones([1, 3])).print();
     *
     * const saveResults = await model.save('localstorage://my-model-1');
     *
     * const loadedModel = await tf.loadLayersModel('localstorage://my-model-1');
     * console.log('Prediction from loaded model:');
     * loadedModel.predict(tf.ones([1, 3])).print();
     * ```
     *
     * Example 2. Saving `model`'s topology and weights to browser
     * [IndexedDB](https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API);
     * then load it back.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * console.log('Prediction from original model:');
     * model.predict(tf.ones([1, 3])).print();
     *
     * const saveResults = await model.save('indexeddb://my-model-1');
     *
     * const loadedModel = await tf.loadLayersModel('indexeddb://my-model-1');
     * console.log('Prediction from loaded model:');
     * loadedModel.predict(tf.ones([1, 3])).print();
     * ```
     *
     * Example 3. Saving `model`'s topology and weights as two files
     * (`my-model-1.json` and `my-model-1.weights.bin`) downloaded from
     * browser.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * const saveResults = await model.save('downloads://my-model-1');
     * ```
     *
     * Example 4. Send  `model`'s topology and weights to an HTTP server.
     * See the documentation of `tf.io.http` for more details
     * including specifying request parameters and implementation of the
     * server.
     *
     * ```js
     * const model = tf.sequential(
     *     {layers: [tf.layers.dense({units: 1, inputShape: [3]})]});
     * const saveResults = await model.save('http://my-server/model/upload');
     * ```
     *
     * @param handlerOrURL An instance of `IOHandler` or a URL-like,
     * scheme-based string shortcut for `IOHandler`.
     * @param config Options for saving the model.
     * @returns A `Promise` of `SaveResult`, which summarizes the result of
     * the saving, such as byte sizes of the saved artifacts for the model's
     *   topology and weight values.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async save(handlerOrURL, config) {
        if (typeof handlerOrURL === 'string') {
            const handlers = (0, $feqcJ).getSaveHandlers(handlerOrURL);
            if (handlers.length === 0) throw new (0, $kubuc.ValueError)(`Cannot find any save handlers for URL '${handlerOrURL}'`);
            else if (handlers.length > 1) throw new (0, $kubuc.ValueError)(`Found more than one (${handlers.length}) save handlers for ` + `URL '${handlerOrURL}'`);
            handlerOrURL = handlers[0];
        }
        if (handlerOrURL.save == null) throw new (0, $kubuc.ValueError)("LayersModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        const weightDataAndSpecs = await (0, $feqcJ).encodeWeights(this.getNamedWeights(config));
        const returnString = false;
        const unusedArg = null;
        const modelConfig = this.toJSON(unusedArg, returnString);
        const modelArtifacts = {
            modelTopology: modelConfig,
            format: $9279084e18d7cb75$var$LAYERS_MODEL_FORMAT_NAME,
            generatedBy: `TensorFlow.js tfjs-layers v${(0, $kw5Gh.version)}`,
            convertedBy: null
        };
        const includeOptimizer = config == null ? false : config.includeOptimizer;
        if (includeOptimizer && this.optimizer != null) {
            modelArtifacts.trainingConfig = this.getTrainingConfig();
            const weightType = 'optimizer';
            const { data: optimizerWeightData, specs: optimizerWeightSpecs } = await (0, $feqcJ).encodeWeights(await this.optimizer.getWeights(), weightType);
            weightDataAndSpecs.specs.push(...optimizerWeightSpecs);
            weightDataAndSpecs.data = (0, $feqcJ).concatenateArrayBuffers([
                weightDataAndSpecs.data,
                optimizerWeightData
            ]);
        }
        if (this.userDefinedMetadata != null) {
            // Check serialized size of user-defined metadata.
            const checkSize = true;
            (0, $4tZ6g.checkUserDefinedMetadata)(this.userDefinedMetadata, this.name, checkSize);
            modelArtifacts.userDefinedMetadata = this.userDefinedMetadata;
        }
        modelArtifacts.weightData = weightDataAndSpecs.data;
        modelArtifacts.weightSpecs = weightDataAndSpecs.specs;
        return handlerOrURL.save(modelArtifacts);
    }
    /**
     * Set user-defined metadata.
     *
     * The set metadata will be serialized together with the topology
     * and weights of the model during `save()` calls.
     *
     * @param setUserDefinedMetadata
     */ setUserDefinedMetadata(userDefinedMetadata) {
        (0, $4tZ6g.checkUserDefinedMetadata)(userDefinedMetadata, this.name);
        this.userDefinedMetadata = userDefinedMetadata;
    }
    /**
     * Get user-defined metadata.
     *
     * The metadata is supplied via one of the two routes:
     *   1. By calling `setUserDefinedMetadata()`.
     *   2. Loaded during model loading (if the model is constructed
     *      via `tf.loadLayersModel()`.)
     *
     * If no user-defined metadata is available from either of the
     * two routes, this function will return `undefined`.
     */ getUserDefinedMetadata() {
        return this.userDefinedMetadata;
    }
}
// The class name is 'Model' rather than 'LayersModel' for backwards
// compatibility since this class name shows up in the serialization format.
/** @nocollapse */ $9279084e18d7cb75$export$f8e130845653852b.className = 'Model';
(0, $ki3lz).registerClass($9279084e18d7cb75$export$f8e130845653852b);
/**
 * A `tf.Functional` is an alias to `tf.LayersModel`.
 *
 * See also:
 *   `tf.LayersModel`, `tf.Sequential`, `tf.loadLayersModel`.
 */ /** @doc {heading: 'Models', subheading: 'Classes'} */ class $9279084e18d7cb75$export$ab287cb77f6ba7e extends $9279084e18d7cb75$export$f8e130845653852b {
}
$9279084e18d7cb75$export$ab287cb77f6ba7e.className = 'Functional';
(0, $ki3lz).registerClass($9279084e18d7cb75$export$ab287cb77f6ba7e);

});
parcelRegister("4v3Le", function(module, exports) {

$parcel$export(module.exports, "deserialize", function () { return $346cf97f5d6ed349$export$efcd34ab6248d3cd; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source layers/__init__.py */ parcelRequire("8AHkS");
var $ki3lz = parcelRequire("ki3lz");

var $jYx5u = parcelRequire("jYx5u");
function $346cf97f5d6ed349$export$efcd34ab6248d3cd(config, customObjects = {}, fastWeightInit = false) {
    return (0, $jYx5u.deserializeKerasObject)(config, (0, $ki3lz).SerializationMap.getMap().classNameMap, customObjects, 'layer', fastWeightInit);
}

});

parcelRegister("lg9tU", function(module, exports) {

$parcel$export(module.exports, "l2Normalize", function () { return $f7a27266370ca61e$export$56804db0f45bf789; });
$parcel$export(module.exports, "meanSquaredError", function () { return $f7a27266370ca61e$export$33de16355e97f7fb; });
$parcel$export(module.exports, "meanAbsoluteError", function () { return $f7a27266370ca61e$export$607988531ba584e6; });
$parcel$export(module.exports, "meanAbsolutePercentageError", function () { return $f7a27266370ca61e$export$29f745e8786a84d; });
$parcel$export(module.exports, "categoricalCrossentropy", function () { return $f7a27266370ca61e$export$3d5544849562b631; });
$parcel$export(module.exports, "sparseCategoricalCrossentropy", function () { return $f7a27266370ca61e$export$d02551222e9364f0; });
$parcel$export(module.exports, "binaryCrossentropy", function () { return $f7a27266370ca61e$export$f9fa66c6bf49fbe1; });
$parcel$export(module.exports, "cosineProximity", function () { return $f7a27266370ca61e$export$a39f0fc1fa1caacd; });
$parcel$export(module.exports, "lossesMap", function () { return $f7a27266370ca61e$export$80c8fb006fb174f5; });
$parcel$export(module.exports, "get", function () { return $f7a27266370ca61e$export$3988ae62b71be9a3; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original Source: losses.py */ parcelRequire("8AHkS");
var $57D4R = parcelRequire("57D4R");
var $6Ab5n = parcelRequire("6Ab5n");
var $fxiHg = parcelRequire("fxiHg");
var $iAQYk = parcelRequire("iAQYk");
var $dIChU = parcelRequire("dIChU");
var $1lCoz = parcelRequire("1lCoz");
var $2d2dF = parcelRequire("2d2dF");
var $3k4XX = parcelRequire("3k4XX");
var $1gLFX = parcelRequire("1gLFX");
var $ifd1X = parcelRequire("ifd1X");
var $9GR6N = parcelRequire("9GR6N");
var $jRQ3p = parcelRequire("jRQ3p");
var $3TgHP = parcelRequire("3TgHP");
var $5hAos = parcelRequire("5hAos");
var $jMlCE = parcelRequire("jMlCE");
var $7k013 = parcelRequire("7k013");
var $aQaR3 = parcelRequire("aQaR3");
var $8nMOl = parcelRequire("8nMOl");
var $2J1JW = parcelRequire("2J1JW");
var $11Nx5 = parcelRequire("11Nx5");
var $g3lev = parcelRequire("g3lev");
var $5jGN9 = parcelRequire("5jGN9");
var $fPnAL = parcelRequire("fPnAL");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $69VqB = parcelRequire("69VqB");

var $4AyI5 = parcelRequire("4AyI5");

var $kubuc = parcelRequire("kubuc");
function $f7a27266370ca61e$export$56804db0f45bf789(x, axis) {
    return (0, $d7Nxs.tidy)(()=>{
        if (x.dtype !== 'float32') x = $fxiHg.cast(x, 'float32');
        const squareSum = $fPnAL.sum($4AyI5.square(x), axis, true);
        const epsilonTensor = $2d2dF.fill(squareSum.shape, (0, $69VqB.epsilon)());
        const norm = $g3lev.sqrt($jRQ3p.maximum(squareSum, epsilonTensor));
        return $dIChU.div(x, norm);
    });
}
function $f7a27266370ca61e$export$33de16355e97f7fb(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>$3TgHP.mean($4AyI5.square($5jGN9.sub(yPred, yTrue)), -1));
}
function $f7a27266370ca61e$export$607988531ba584e6(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>$3TgHP.mean($57D4R.abs($5jGN9.sub(yPred, yTrue)), -1));
}
function $f7a27266370ca61e$export$29f745e8786a84d(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const diff = $5jGN9.sub(yTrue, yPred);
        const clippedTrue = $iAQYk.clipByValue($57D4R.abs(yTrue), (0, $69VqB.epsilon)(), Number.MAX_VALUE);
        const absResult = $57D4R.abs($dIChU.div(diff, clippedTrue));
        return $5hAos.mul(100, $3TgHP.mean(absResult, -1));
    });
}
function $f7a27266370ca61e$export$6f3c2909d4934f8e(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const clippedPred = $iAQYk.clipByValue(yPred, (0, $69VqB.epsilon)(), Number.MAX_VALUE);
        const firstLog = $1gLFX.log($6Ab5n.add(1, clippedPred));
        const clippedTrue = $iAQYk.clipByValue(yTrue, (0, $69VqB.epsilon)(), Number.MAX_VALUE);
        const secondLog = $1gLFX.log($6Ab5n.add(1, clippedTrue));
        return $3TgHP.mean($4AyI5.square($5jGN9.sub(firstLog, secondLog)), -1);
    });
}
function $f7a27266370ca61e$export$6e9184938bd4bdfd(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const maxResult = $jRQ3p.maximum(0, $5jGN9.sub(1, $5hAos.mul(yTrue, yPred)));
        return $3TgHP.mean($4AyI5.square(maxResult), -1);
    });
}
function $f7a27266370ca61e$export$321a3d0bf2c75(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const maxResult = $jRQ3p.maximum(0, $5jGN9.sub(1, $5hAos.mul(yTrue, yPred)));
        return $3TgHP.mean(maxResult, -1);
    });
}
function $f7a27266370ca61e$export$21844282d987078(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const pos = $fPnAL.sum($5hAos.mul(yTrue, yPred), -1);
        const neg = $9GR6N.max($5hAos.mul($5jGN9.sub(1, yTrue), yPred), -1);
        return $jRQ3p.maximum(0, $6Ab5n.add(1, $5jGN9.sub(neg, pos)));
    });
}
function $f7a27266370ca61e$export$d3a5506af1f5d4c0(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const log2 = Math.log(2);
        const predictionDiff = $5jGN9.sub(yPred, yTrue);
        const logcoshResult = $5jGN9.sub($6Ab5n.add(predictionDiff, $11Nx5.softplus($5hAos.mul(-2, predictionDiff))), log2);
        return $3TgHP.mean(logcoshResult, -1);
    });
}
function $f7a27266370ca61e$export$3d5544849562b631(target, output, fromLogits = false) {
    return (0, $d7Nxs.tidy)(()=>{
        if (fromLogits) output = $2J1JW.softmax(output);
        else {
            // scale preds so that the class probabilities of each sample sum to 1.
            const outputSum = $fPnAL.sum(output, output.shape.length - 1, true);
            output = $dIChU.div(output, outputSum);
        }
        output = $iAQYk.clipByValue(output, (0, $69VqB.epsilon)(), 1 - (0, $69VqB.epsilon)());
        return $jMlCE.neg($fPnAL.sum($5hAos.mul($fxiHg.cast(target, 'float32'), $1gLFX.log(output)), output.shape.length - 1));
    });
}
function $f7a27266370ca61e$export$d02551222e9364f0(target, output, fromLogits = false) {
    return (0, $d7Nxs.tidy)(()=>{
        const flatTarget = $fxiHg.cast($3k4XX.floor($4AyI5.flatten(target)), 'int32');
        output = $iAQYk.clipByValue(output, (0, $69VqB.epsilon)(), 1 - (0, $69VqB.epsilon)());
        const outputShape = output.shape;
        const oneHotTarget = $8nMOl.reshape($7k013.oneHot(flatTarget, outputShape[outputShape.length - 1]), outputShape);
        return $f7a27266370ca61e$export$3d5544849562b631(oneHotTarget, output, fromLogits);
    });
}
function $f7a27266370ca61e$export$ba12332959c7f31a(labels, logits) {
    if (!(0, $lBDHD).arraysEqual(labels.shape, logits.shape)) throw new (0, $kubuc.ValueError)(`logits and labels must have the same shape, but got shapes ` + `${JSON.stringify(labels.shape)} and ${JSON.stringify(logits.shape)}`);
    return (0, $d7Nxs.tidy)(()=>{
        // The logistic loss formula from above is
        //   x - x * z + log(1 + exp(-x))
        // For x < 0, a more numerically stable formula is
        //   -x * z + log(1 + exp(x))
        // Note that these two expressions can be combined into the following:
        //   max(x, 0) - x * z + log(1 + exp(-abs(x)))
        const reluLogits = $aQaR3.relu(logits);
        const negAbsLogits = $jMlCE.neg($57D4R.abs(logits));
        return $6Ab5n.add($5jGN9.sub(reluLogits, $5hAos.mul(logits, labels)), $ifd1X.log1p($1lCoz.exp(negAbsLogits)));
    });
}
function $f7a27266370ca61e$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        let y;
        y = $iAQYk.clipByValue(yPred, (0, $69VqB.epsilon)(), 1 - (0, $69VqB.epsilon)());
        y = $1gLFX.log($dIChU.div(y, $5jGN9.sub(1, y)));
        return $3TgHP.mean($f7a27266370ca61e$export$ba12332959c7f31a(yTrue, y), -1);
    });
}
function $f7a27266370ca61e$export$ca6ae4762880179a(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const clippedTrue = $iAQYk.clipByValue(yTrue, (0, $69VqB.epsilon)(), 1);
        const clippedPred = $iAQYk.clipByValue(yPred, (0, $69VqB.epsilon)(), 1);
        return $fPnAL.sum($5hAos.mul(yTrue, $1gLFX.log($dIChU.div(clippedTrue, clippedPred))), -1);
    });
}
function $f7a27266370ca61e$export$e2342249434e96a8(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const logPred = $1gLFX.log($6Ab5n.add((0, $69VqB.epsilon)(), yPred));
        return $3TgHP.mean($5jGN9.sub(yPred, $5hAos.mul(yTrue, logPred)), -1);
    });
}
function $f7a27266370ca61e$export$a39f0fc1fa1caacd(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const trueNormalized = $f7a27266370ca61e$export$56804db0f45bf789(yTrue, -1);
        const predNormalized = $f7a27266370ca61e$export$56804db0f45bf789(yPred, -1);
        const trueXPred = $5hAos.mul(trueNormalized, predNormalized);
        return $jMlCE.neg($fPnAL.sum(trueXPred, -1));
    });
}
const $f7a27266370ca61e$export$5af2a467647891e2 = $f7a27266370ca61e$export$33de16355e97f7fb;
const $f7a27266370ca61e$export$19fa95397f41c30f = $f7a27266370ca61e$export$33de16355e97f7fb;
const $f7a27266370ca61e$export$1d5f948d69c1bb9e = $f7a27266370ca61e$export$607988531ba584e6;
const $f7a27266370ca61e$export$5763e506e192f1c3 = $f7a27266370ca61e$export$607988531ba584e6;
const $f7a27266370ca61e$export$1d9e5626781fbee = $f7a27266370ca61e$export$29f745e8786a84d;
const $f7a27266370ca61e$export$520a6d354b1a7026 = $f7a27266370ca61e$export$29f745e8786a84d;
const $f7a27266370ca61e$export$863e9fcd25a63ca1 = $f7a27266370ca61e$export$6f3c2909d4934f8e;
const $f7a27266370ca61e$export$52f45e1331da5a2d = $f7a27266370ca61e$export$6f3c2909d4934f8e;
const $f7a27266370ca61e$export$832ecf683c672b43 = $f7a27266370ca61e$export$ca6ae4762880179a;
const $f7a27266370ca61e$export$cb1c1cc0b7255a = $f7a27266370ca61e$export$ca6ae4762880179a;
const $f7a27266370ca61e$export$c2a6cd60d490c7cc = $f7a27266370ca61e$export$a39f0fc1fa1caacd;
const $f7a27266370ca61e$export$80c8fb006fb174f5 = {
    meanSquaredError: $f7a27266370ca61e$export$33de16355e97f7fb,
    meanAbsoluteError: $f7a27266370ca61e$export$607988531ba584e6,
    meanAbsolutePercentageError: $f7a27266370ca61e$export$29f745e8786a84d,
    meanSquaredLogarithmicError: $f7a27266370ca61e$export$6f3c2909d4934f8e,
    squaredHinge: $f7a27266370ca61e$export$6e9184938bd4bdfd,
    hinge: $f7a27266370ca61e$export$321a3d0bf2c75,
    categoricalHinge: $f7a27266370ca61e$export$21844282d987078,
    logcosh: $f7a27266370ca61e$export$d3a5506af1f5d4c0,
    categoricalCrossentropy: $f7a27266370ca61e$export$3d5544849562b631,
    sparseCategoricalCrossentropy: $f7a27266370ca61e$export$d02551222e9364f0,
    binaryCrossentropy: $f7a27266370ca61e$export$f9fa66c6bf49fbe1,
    kullbackLeiblerDivergence: $f7a27266370ca61e$export$ca6ae4762880179a,
    poisson: $f7a27266370ca61e$export$e2342249434e96a8,
    cosineProximity: $f7a27266370ca61e$export$a39f0fc1fa1caacd
};
function $f7a27266370ca61e$export$3988ae62b71be9a3(identifierOrFn) {
    if (typeof identifierOrFn === 'string') {
        if (identifierOrFn in $f7a27266370ca61e$export$80c8fb006fb174f5) return $f7a27266370ca61e$export$80c8fb006fb174f5[identifierOrFn];
        let errMsg = `Unknown loss ${identifierOrFn}`;
        if (identifierOrFn.toLowerCase().includes('softmaxcrossentropy')) errMsg = `Unknown loss ${identifierOrFn}. ` + 'Use "categoricalCrossentropy" as the string name for ' + 'tf.losses.softmaxCrossEntropy';
        throw new (0, $kubuc.ValueError)(errMsg);
    } else return identifierOrFn;
}

});

parcelRegister("j6iTL", function(module, exports) {

$parcel$export(module.exports, "binaryAccuracy", function () { return $de7d3cb6accdd04b$export$7b3d02e9a01c1ca; });
$parcel$export(module.exports, "categoricalAccuracy", function () { return $de7d3cb6accdd04b$export$1365401eb6b7aeeb; });
$parcel$export(module.exports, "precision", function () { return $de7d3cb6accdd04b$export$b70eeb0e623ceb0d; });
$parcel$export(module.exports, "recall", function () { return $de7d3cb6accdd04b$export$479490328e25f530; });
$parcel$export(module.exports, "binaryCrossentropy", function () { return $de7d3cb6accdd04b$export$f9fa66c6bf49fbe1; });
$parcel$export(module.exports, "sparseCategoricalAccuracy", function () { return $de7d3cb6accdd04b$export$b35c43b77daa3523; });
$parcel$export(module.exports, "r2Score", function () { return $de7d3cb6accdd04b$export$3c864af03e35a80e; });
$parcel$export(module.exports, "categoricalCrossentropy", function () { return $de7d3cb6accdd04b$export$3d5544849562b631; });
$parcel$export(module.exports, "sparseCategoricalCrossentropy", function () { return $de7d3cb6accdd04b$export$d02551222e9364f0; });
$parcel$export(module.exports, "get", function () { return $de7d3cb6accdd04b$export$3988ae62b71be9a3; });
$parcel$export(module.exports, "getLossOrMetricName", function () { return $de7d3cb6accdd04b$export$9fb8307a5eeccc76; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Built-in metrics.
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $kRlq3 = parcelRequire("kRlq3");
var $fxiHg = parcelRequire("fxiHg");
var $dIChU = parcelRequire("dIChU");
var $28GAP = parcelRequire("28GAP");
var $lOlhm = parcelRequire("lOlhm");
var $gXTMu = parcelRequire("gXTMu");
var $3TgHP = parcelRequire("3TgHP");
var $5hAos = parcelRequire("5hAos");
var $6zg0w = parcelRequire("6zg0w");
var $7hONX = parcelRequire("7hONX");
var $gP42y = parcelRequire("gP42y");
var $fPnAL = parcelRequire("fPnAL");
var $d7Nxs = parcelRequire("d7Nxs");
var $3A1QZ = parcelRequire("3A1QZ");

var $4AyI5 = parcelRequire("4AyI5");

var $kubuc = parcelRequire("kubuc");

var $lg9tU = parcelRequire("lg9tU");

var $jYx5u = parcelRequire("jYx5u");
function $de7d3cb6accdd04b$export$7b3d02e9a01c1ca(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const threshold = $5hAos.mul(.5, $6zg0w.onesLike(yPred));
        const yPredThresholded = $4AyI5.cast($lOlhm.greater(yPred, threshold), yTrue.dtype);
        return $3TgHP.mean($28GAP.equal(yTrue, yPredThresholded), -1);
    });
}
function $de7d3cb6accdd04b$export$1365401eb6b7aeeb(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>$4AyI5.cast($28GAP.equal($kRlq3.argMax(yTrue, -1), $kRlq3.argMax(yPred, -1)), 'float32'));
}
function $de7d3cb6accdd04b$var$truePositives(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        return $fxiHg.cast($fPnAL.sum($gXTMu.logicalAnd($28GAP.equal(yTrue, 1), $28GAP.equal(yPred, 1))), 'float32');
    });
}
function $de7d3cb6accdd04b$var$falseNegatives(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        return $fxiHg.cast($fPnAL.sum($gXTMu.logicalAnd($28GAP.equal(yTrue, 1), $28GAP.equal(yPred, 0))), 'float32');
    });
}
function $de7d3cb6accdd04b$var$falsePositives(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        return $fxiHg.cast($fPnAL.sum($gXTMu.logicalAnd($28GAP.equal(yTrue, 0), $28GAP.equal(yPred, 1))), 'float32');
    });
}
function $de7d3cb6accdd04b$export$b70eeb0e623ceb0d(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const tp = $de7d3cb6accdd04b$var$truePositives(yTrue, yPred);
        const fp = $de7d3cb6accdd04b$var$falsePositives(yTrue, yPred);
        const denominator = $6Ab5n.add(tp, fp);
        return $fxiHg.cast($3A1QZ.where($lOlhm.greater(denominator, 0), $dIChU.div(tp, denominator), 0), 'float32');
    });
}
function $de7d3cb6accdd04b$export$479490328e25f530(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const tp = $de7d3cb6accdd04b$var$truePositives(yTrue, yPred);
        const fn = $de7d3cb6accdd04b$var$falseNegatives(yTrue, yPred);
        const denominator = $6Ab5n.add(tp, fn);
        return $fxiHg.cast($3A1QZ.where($lOlhm.greater(denominator, 0), $dIChU.div(tp, denominator), 0), 'float32');
    });
}
function $de7d3cb6accdd04b$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return (0, $lg9tU.binaryCrossentropy)(yTrue, yPred);
}
function $de7d3cb6accdd04b$export$b35c43b77daa3523(yTrue, yPred) {
    if (yTrue.rank === yPred.rank) yTrue = $gP42y.squeeze(yTrue, [
        yTrue.rank - 1
    ]);
    yPred = $kRlq3.argMax(yPred, -1);
    if (yPred.dtype !== yTrue.dtype) yPred = $fxiHg.cast(yPred, yTrue.dtype);
    return $fxiHg.cast($28GAP.equal(yTrue, yPred), 'float32');
}
function $de7d3cb6accdd04b$export$1a189de14358fa71(yTrue, yPred) {
    throw new (0, $kubuc.NotImplementedError)();
}
function $de7d3cb6accdd04b$export$a15ee75d9e4cf4ae(yTrue, yPred) {
    throw new (0, $kubuc.NotImplementedError)();
}
function $de7d3cb6accdd04b$export$3c864af03e35a80e(yTrue, yPred) {
    return (0, $d7Nxs.tidy)(()=>{
        const sumSquaresResiduals = yTrue.sub(yPred).square().sum();
        const sumSquares = yTrue.sub(yTrue.mean()).square().sum();
        return $7hONX.scalar(1).sub(sumSquaresResiduals.div(sumSquares));
    });
}
const $de7d3cb6accdd04b$export$5af2a467647891e2 = (0, $lg9tU.meanSquaredError);
const $de7d3cb6accdd04b$export$19fa95397f41c30f = (0, $lg9tU.meanSquaredError);
const $de7d3cb6accdd04b$export$1d5f948d69c1bb9e = (0, $lg9tU.meanAbsoluteError);
const $de7d3cb6accdd04b$export$5763e506e192f1c3 = (0, $lg9tU.meanAbsoluteError);
const $de7d3cb6accdd04b$export$1d9e5626781fbee = (0, $lg9tU.meanAbsolutePercentageError);
const $de7d3cb6accdd04b$export$520a6d354b1a7026 = (0, $lg9tU.meanAbsolutePercentageError);
const $de7d3cb6accdd04b$export$3d5544849562b631 = (0, $lg9tU.categoricalCrossentropy);
const $de7d3cb6accdd04b$export$c2a6cd60d490c7cc = (0, $lg9tU.cosineProximity);
const $de7d3cb6accdd04b$export$d02551222e9364f0 = (0, $lg9tU.sparseCategoricalCrossentropy);
const $de7d3cb6accdd04b$export$17c75e85c6265c88 = {
    binaryAccuracy: $de7d3cb6accdd04b$export$7b3d02e9a01c1ca,
    categoricalAccuracy: $de7d3cb6accdd04b$export$1365401eb6b7aeeb,
    precision: $de7d3cb6accdd04b$export$b70eeb0e623ceb0d,
    categoricalCrossentropy: $de7d3cb6accdd04b$export$3d5544849562b631,
    sparseCategoricalCrossentropy: $de7d3cb6accdd04b$export$d02551222e9364f0,
    mse: $de7d3cb6accdd04b$export$5af2a467647891e2,
    MSE: $de7d3cb6accdd04b$export$19fa95397f41c30f,
    mae: $de7d3cb6accdd04b$export$1d5f948d69c1bb9e,
    MAE: $de7d3cb6accdd04b$export$5763e506e192f1c3,
    mape: $de7d3cb6accdd04b$export$1d9e5626781fbee,
    MAPE: $de7d3cb6accdd04b$export$520a6d354b1a7026,
    cosine: $de7d3cb6accdd04b$export$c2a6cd60d490c7cc
};
function $de7d3cb6accdd04b$export$3988ae62b71be9a3(identifier) {
    if (typeof identifier === 'string' && identifier in $de7d3cb6accdd04b$export$17c75e85c6265c88) return $de7d3cb6accdd04b$export$17c75e85c6265c88[identifier];
    else if (typeof identifier !== 'string' && identifier != null) return identifier;
    else throw new (0, $kubuc.ValueError)(`Unknown metric ${identifier}`);
}
function $de7d3cb6accdd04b$export$9fb8307a5eeccc76(fn) {
    $jYx5u.assert(fn !== null, `Unknown LossOrMetricFn ${fn}`);
    if (typeof fn === 'string') return fn;
    else {
        let fnName;
        for (const key of Object.keys((0, $lg9tU.lossesMap)))if ((0, $lg9tU.lossesMap)[key] === fn) {
            fnName = key;
            break;
        }
        if (fnName !== undefined) return fnName;
        for (const key of Object.keys($de7d3cb6accdd04b$export$17c75e85c6265c88))if ($de7d3cb6accdd04b$export$17c75e85c6265c88[key] === fn) {
            fnName = key;
            break;
        }
        if (fnName !== undefined) return fnName;
        return fn.name;
    }
}

});

parcelRegister("4Sjwz", function(module, exports) {

$parcel$export(module.exports, "getOptimizer", function () { return $38cb59ac5d3348e1$export$93a6cd925bf0fb14; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Optimizers.
 */ parcelRequire("8AHkS");
var $1d10n = parcelRequire("1d10n");

var $69VqB = parcelRequire("69VqB");

var $kubuc = parcelRequire("kubuc");
function $38cb59ac5d3348e1$export$93a6cd925bf0fb14(identifier) {
    const optimizerMap = {
        'Adagrad': ()=>(0, $1d10n.train).adagrad(0.01),
        'Adadelta': ()=>(0, $1d10n.train).adadelta(1, 0.95, (0, $69VqB.epsilon)()),
        'Adam': ()=>(0, $1d10n.train).adam(0.001, 0.9, 0.999, (0, $69VqB.epsilon)()),
        'Adamax': ()=>(0, $1d10n.train).adamax(0.002, 0.9, 0.999, (0, $69VqB.epsilon)(), 0),
        'RMSProp': ()=>(0, $1d10n.train).rmsprop(0.001, 0.9, 0, (0, $69VqB.epsilon)()),
        'SGD': ()=>(0, $1d10n.train).sgd(0.01)
    };
    optimizerMap['adagrad'] = optimizerMap['Adagrad'];
    optimizerMap['adadelta'] = optimizerMap['Adadelta'];
    optimizerMap['adam'] = optimizerMap['Adam'];
    optimizerMap['adamax'] = optimizerMap['Adamax'];
    optimizerMap['rmsprop'] = optimizerMap['RMSProp'];
    optimizerMap['sgd'] = optimizerMap['SGD'];
    if (identifier in optimizerMap) return optimizerMap[identifier]();
    throw new (0, $kubuc.ValueError)(`Unknown Optimizer ${identifier}`);
}

});

parcelRegister("4tZ6g", function(module, exports) {

$parcel$export(module.exports, "checkUserDefinedMetadata", function () { return $34394407e8450390$export$5c1c8db6517969f5; });
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /** Utility functions related to user-defined metadata. */ // Maximum recommended serialized size for user-defined metadata.
// Beyond this limit, a warning message will be printed during model loading and
// saving.
const $34394407e8450390$export$60e49adbc1213273 = 1048576;
function $34394407e8450390$export$5c1c8db6517969f5(userDefinedMetadata, modelName, checkSize = false) {
    if (userDefinedMetadata == null || typeof userDefinedMetadata !== 'object' || Object.getPrototypeOf(userDefinedMetadata) !== Object.prototype || !$34394407e8450390$export$62cb934243969363(userDefinedMetadata)) throw new Error('User-defined metadata is expected to be a JSON object, but is not.');
    if (checkSize) {
        const out = JSON.stringify(userDefinedMetadata);
        if (out.length > $34394407e8450390$export$60e49adbc1213273) console.warn(`User-defined metadata of model "${modelName}" is too large in ` + `size (length=${out.length} when serialized). It is not ` + `recommended to store such large objects in user-defined metadata. ` + `Please make sure its serialized length is <= ` + `${$34394407e8450390$export$60e49adbc1213273}.`);
    }
}
function $34394407e8450390$export$62cb934243969363(x) {
    if (x === null) // Note: typeof `null` is 'object', and `null` is valid in JSON.
    return true;
    else if (typeof x === 'object') {
        if (Object.getPrototypeOf(x) === Object.prototype) {
            // `x` is a JavaScript object and its prototype is Object.
            const keys = Object.keys(x);
            for (const key of keys){
                if (typeof key !== 'string') // JSON keys must be strings.
                return false;
                if (!$34394407e8450390$export$62cb934243969363(x[key])) return false;
            }
            return true;
        } else {
            // `x` is a JavaScript object but its prototype is not Object.
            if (Array.isArray(x)) {
                // `x` is a JavaScript array.
                for (const item of x){
                    if (!$34394407e8450390$export$62cb934243969363(item)) return false;
                }
                return true;
            } else // `x` is a JavaScript object and its prototype is not Object,
            // and it's not an Array. I.e., it's a complex object such as
            // `Error` and `Date`.
            return false;
        }
    } else {
        // `x` is not a JavaScript object or `null`.
        const xType = typeof x;
        return xType === 'string' || xType === 'number' || xType === 'boolean';
    }
}

});

parcelRegister("lKxUo", function(module, exports) {

$parcel$export(module.exports, "printSummary", function () { return $fd5832670add4e6b$export$9b5fcd5d170a598e; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $7iQkf = parcelRequire("7iQkf");
function $fd5832670add4e6b$export$9b5fcd5d170a598e(model, lineLength, positions, // tslint:disable-next-line:no-any
printFn = console.log) {
    const sequentialLike = $fd5832670add4e6b$var$isModelSequentialLike(model);
    // Header names for different log elements.
    const toDisplay = [
        'Layer (type)',
        'Input Shape',
        'Output shape',
        'Param #'
    ];
    if (sequentialLike) {
        lineLength = lineLength || 90;
        positions = positions || [
            0.32,
            0.61,
            0.89,
            1
        ];
    } else {
        lineLength = lineLength || 115;
        positions = positions || [
            0.24,
            0.48,
            0.70,
            0.80,
            1
        ];
    // Header names for different log elements.
    }
    if (positions[positions.length - 1] <= 1) // `positions` is relative. Convert it to absolute positioning.
    positions = positions.map((p)=>Math.floor(lineLength * p));
    let relevantNodes;
    if (!sequentialLike) {
        toDisplay.push('Receives inputs');
        relevantNodes = [];
        for(const depth in model.nodesByDepth)relevantNodes.push(...model.nodesByDepth[depth]);
    }
    printFn('_'.repeat(lineLength));
    $fd5832670add4e6b$var$printRow(toDisplay, positions, printFn);
    printFn('='.repeat(lineLength));
    const layers = model.layers;
    for(let i = 0; i < layers.length; ++i){
        if (sequentialLike) $fd5832670add4e6b$var$printLayerSummary(layers[i], positions, printFn);
        else $fd5832670add4e6b$var$printLayerSummaryWithConnections(layers[i], positions, relevantNodes, printFn);
        printFn((i === layers.length - 1 ? '=' : '_').repeat(lineLength));
    }
    // tslint:disable-next-line:no-any
    model.checkTrainableWeightsConsistency();
    const trainableCount = $fd5832670add4e6b$var$countTrainableParams(model);
    const nonTrainableCount = (0, $7iQkf.countParamsInWeights)(model.nonTrainableWeights);
    printFn(`Total params: ${trainableCount + nonTrainableCount}`);
    printFn(`Trainable params: ${trainableCount}`);
    printFn(`Non-trainable params: ${nonTrainableCount}`);
    printFn('_'.repeat(lineLength));
}
function $fd5832670add4e6b$var$countTrainableParams(model) {
    let trainableCount;
    // tslint:disable:no-any
    if (model.collectedTrainableWeights != null) trainableCount = (0, $7iQkf.countParamsInWeights)(model.collectedTrainableWeights);
    else trainableCount = (0, $7iQkf.countParamsInWeights)(model.trainableWeights);
    // tslint:enable:no-any
    return trainableCount;
}
function $fd5832670add4e6b$var$isModelSequentialLike(model) {
    let sequentialLike = true;
    const nodesByDepth = [];
    const nodes = [];
    for(const depth in model.nodesByDepth)nodesByDepth.push(model.nodesByDepth[depth]);
    for (const depthNodes of nodesByDepth){
        if (depthNodes.length > 1 || depthNodes.length === 1 && depthNodes[0].inboundLayers.length > 1) {
            sequentialLike = false;
            break;
        }
        nodes.push(...depthNodes);
    }
    if (sequentialLike) // Search for shared layers.
    for (const layer of model.layers){
        let flag = false;
        for (const node of layer.inboundNodes)if (nodes.indexOf(node) !== -1) {
            if (flag) {
                sequentialLike = false;
                break;
            } else flag = true;
        }
        if (!sequentialLike) break;
    }
    return sequentialLike;
}
function $fd5832670add4e6b$var$printRow(fields, positions, // tslint:disable-next-line:no-any
printFn = console.log) {
    let line = '';
    for(let i = 0; i < fields.length; ++i){
        if (i > 0) line = line.slice(0, line.length - 1) + ' ';
        line += fields[i];
        line = line.slice(0, positions[i]);
        line += ' '.repeat(positions[i] - line.length);
    }
    printFn(line);
}
/**
 * Prints a summary for a single Layer, without connectivity information.
 *
 * @param layer: Layer instance to print.
 */ function $fd5832670add4e6b$var$printLayerSummary(layer, positions, // tslint:disable-next-line:no-any
printFn) {
    let outputShape;
    let inputShape;
    try {
        inputShape = layer.inboundNodes.map((x)=>JSON.stringify(x.inputShapes)).join(',');
    } catch (err) {
        inputShape = 'multiple';
    }
    try {
        outputShape = JSON.stringify(layer.outputShape);
    } catch (err) {
        outputShape = 'multiple';
    }
    const name = layer.name;
    const className = layer.getClassName();
    const fields = [
        `${name} (${className})`,
        inputShape,
        outputShape,
        layer.countParams().toString()
    ];
    $fd5832670add4e6b$var$printRow(fields, positions, printFn);
}
/**
 * Prints a summary for a single Layer, with connectivity information.
 */ function $fd5832670add4e6b$var$printLayerSummaryWithConnections(layer, positions, relevantNodes, // tslint:disable-next-line:no-any
printFn) {
    let outputShape;
    let inputShape;
    try {
        inputShape = layer.inboundNodes.map((x)=>JSON.stringify(x.inputShapes)).join(',');
    } catch (err) {
        inputShape = 'multiple';
    }
    try {
        outputShape = JSON.stringify(layer.outputShape);
    } catch (err) {
        outputShape = 'multiple';
    }
    const connections = [];
    for (const node of layer.inboundNodes){
        if (relevantNodes != null && relevantNodes.length > 0 && relevantNodes.indexOf(node) === -1) continue;
        for(let i = 0; i < node.inboundLayers.length; ++i){
            const inboundLayer = node.inboundLayers[i].name;
            const inboundLayerIndex = node.nodeIndices[i];
            const inboundTensorIndex = node.tensorIndices[i];
            connections.push(`${inboundLayer}[${inboundLayerIndex}][${inboundTensorIndex}]`);
        }
    }
    const name = layer.name;
    const className = layer.getClassName();
    const firstConnection = connections.length === 0 ? '' : connections[0];
    const fields = [
        `${name} (${className})`,
        inputShape,
        outputShape,
        layer.countParams().toString(),
        firstConnection
    ];
    $fd5832670add4e6b$var$printRow(fields, positions, printFn);
    for(let i = 1; i < connections.length; ++i)$fd5832670add4e6b$var$printRow([
        '',
        '',
        '',
        '',
        connections[i]
    ], positions, printFn);
}

});

parcelRegister("3r0Ja", function(module, exports) {

$parcel$export(module.exports, "convertPythonicToTs", function () { return $2804752d6627c758$export$c0fd0796420499e6; });
$parcel$export(module.exports, "convertTsToPythonic", function () { return $2804752d6627c758$export$b63a5d81d6846026; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $jYx5u = parcelRequire("jYx5u");
// tslint:enable
/**
 * Test whether a value in an array is the name of a LayersModel or Layer.
 * @param key The key name that the value is found under. Note that the key
 *   may not be at the level immediately above the value, if the value is in a
 *   nested array.
 * @param index Index of the value in the Array that it is found in.
 * @param value The value object.
 * @returns A boolean indicating whether value is a name.
 */ function $2804752d6627c758$var$isArrayItemInputOrOutputName(key, index, value) {
    return (key === 'inboundNodes' || key === 'outputLayers' || key === 'inputLayers') && index === 0 && typeof value === 'string';
}
function $2804752d6627c758$export$c0fd0796420499e6(pythonicConfig, key) {
    if (pythonicConfig === null) return null;
    else if (typeof pythonicConfig === 'string') return $jYx5u.toCamelCase(pythonicConfig);
    else if (typeof pythonicConfig === 'number' || typeof pythonicConfig === 'boolean') return pythonicConfig;
    else if (pythonicConfig instanceof Array) {
        const tsArray = [];
        const arrayLength = pythonicConfig.length;
        for(let i = 0; i < arrayLength; ++i){
            const item = pythonicConfig[i];
            if ($2804752d6627c758$var$isArrayItemInputOrOutputName(key, i, item)) tsArray.push(item);
            else tsArray.push($2804752d6627c758$export$c0fd0796420499e6(item, key));
        }
        return tsArray;
    } else {
        const tsDict = {};
        for (const pythonicKey of Object.keys(pythonicConfig)){
            const pythonicValue = pythonicConfig[pythonicKey];
            if (pythonicKey === 'name' && typeof pythonicValue === 'string') // Special case the 'name' key with a string value. Name values, such as
            // the names of LayersModel and Layer instances, should not undergo the
            // camel-case conversion.
            tsDict[pythonicKey] = pythonicValue;
            else {
                const tsKey = $jYx5u.toCamelCase(pythonicKey);
                tsDict[tsKey] = $2804752d6627c758$export$c0fd0796420499e6(pythonicValue, tsKey);
            }
        }
        return tsDict;
    }
}
function $2804752d6627c758$export$b63a5d81d6846026(tsConfig, key) {
    if (tsConfig === null || tsConfig === undefined) return null;
    else if (typeof tsConfig === 'string') return $jYx5u.toSnakeCase(tsConfig);
    else if (typeof tsConfig === 'number' || typeof tsConfig === 'boolean') return tsConfig;
    else if (tsConfig instanceof Array) {
        const pyArray = [];
        const arrayLength = tsConfig.length;
        for(let i = 0; i < arrayLength; ++i){
            const item = tsConfig[i];
            if ($2804752d6627c758$var$isArrayItemInputOrOutputName(key, i, item)) pyArray.push(item);
            else pyArray.push($2804752d6627c758$export$b63a5d81d6846026(item, key));
        }
        return pyArray;
    } else {
        const pyDict = {};
        for (const tsKey of Object.keys(tsConfig)){
            const tsValue = tsConfig[tsKey];
            const pyKey = $jYx5u.toSnakeCase(tsKey);
            if ((tsKey === 'name' || tsKey === 'className') && typeof tsValue === 'string') // Special case the 'name' key with a string value. Name values, such as
            // the names of LayersModel and Layer instances, should not undergo the
            // snake-case conversion.
            pyDict[pyKey] = tsValue;
            else pyDict[pyKey] = $2804752d6627c758$export$b63a5d81d6846026(tsValue, tsKey);
        }
        return pyDict;
    }
}

});

parcelRegister("kw5Gh", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $eefb33f207a93346$export$83d89fbfd8236492; });
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $eefb33f207a93346$export$83d89fbfd8236492 = '4.22.0';

});

parcelRegister("3foX0", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $25d6207cfb5d469d$export$42a852a2b6b56249; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/engine/topology.py */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");

var $cExd6 = parcelRequire("cExd6");

var $kubuc = parcelRequire("kubuc");

var $4v3Le = parcelRequire("4v3Le");

var $jYx5u = parcelRequire("jYx5u");

var $3r0Ja = parcelRequire("3r0Ja");

var $bMNfZ = parcelRequire("bMNfZ");

var $pKVrB = parcelRequire("pKVrB");

var $kw5Gh = parcelRequire("kw5Gh");

var $iyRtt = parcelRequire("iyRtt");

var $lusky = parcelRequire("lusky");

var $jWpeh = parcelRequire("jWpeh");
// get weights key from tensor map in order to check if it is from keras v3.
// e.g. dense/0
const $25d6207cfb5d469d$var$isKerasSavedModelFormat = (weights)=>{
    const keys = Object.keys(weights);
    if (keys.length === 0) return false;
    const key = keys[0].split('/');
    return !isNaN(parseInt(key[key.length - 1], 10));
};
class $25d6207cfb5d469d$export$42a852a2b6b56249 extends (0, $jWpeh.Layer) {
    constructor(args){
        // No args passed to super's constructor.
        super({});
        this.containerNodes = new Set();
        this.name = args.name;
        if (this.name == null) {
            const prefix = this.getClassName().toLowerCase();
            this.name = (0, $cExd6.getUid)(prefix);
        }
        this.supportsMasking = false;
        this.trainable_ = true;
        // TODO(michaelterry): Initialize perInputLosses/Updates here.
        // Container-specific properties.
        if (Array.isArray(args.inputs)) this.inputs = args.inputs.slice();
        else this.inputs = [
            args.inputs
        ];
        if (Array.isArray(args.outputs)) this.outputs = args.outputs.slice();
        else this.outputs = [
            args.outputs
        ];
        // Check for redundancy in inputs.
        if ($jYx5u.unique(this.inputs).length !== this.inputs.length) throw new (0, $kubuc.ValueError)("The list of inputs passed to the model is redundant. All inputs should only appear once. Found: " + `${this.inputs.map((x)=>x.name)}`);
        // Check for redundancy in outputs.
        if ($jYx5u.unique(this.outputs).length !== this.outputs.length) console.warn("The list of outputs passed to the model is redundant. All outputs should only appear once. Found: " + `${this.outputs.map((x)=>x.name)}`);
        /*
          List of initial layers (1 to 1 mapping with this.inputs, hence the same
          layer might appear twice)
        */ this.inputLayers = [];
        this.inputLayersNodeIndices = [];
        this.inputLayersTensorIndices = [];
        /*
          List of layers (1 to 1 mapping with this.outputs, hence the same layer
          might appear twice)
        */ this.outputLayers = [];
        this.outputLayersNodeIndices = [];
        this.outputLayersTensorIndices = [];
        /*
          All layers in order of horizontal graph traversal. Entries are unique.
          Includes input and output layers.
        */ this.layers = [];
        /*
          References to container layers that were constructed internally. We need
          these to properly dispose of tensors from nested containers.
        */ this.internalContainerRefs = [];
        // TODO(michaelterry): Determine if caching still needed with eager
        // backend.
        /*
          This is for performance optimization when calling the Container on new
          inputs. Every time the Container is called on a set on input tensors,
          we compute the output tensors, output masks and output shapes in one pass,
          then cache them here. When one of these outputs is queried later,
          we retrieve it from there instead of recomputing it.
        */ // this.outputTensorCache = {};
        // this.outputShapeCache = {};
        // Build this.outputLayers:
        for (const x of this.outputs){
            const layer = x.sourceLayer;
            const nodeIndex = x.nodeIndex;
            const tensorIndex = x.tensorIndex;
            this.outputLayers.push(layer);
            this.outputLayersNodeIndices.push(nodeIndex);
            this.outputLayersTensorIndices.push(tensorIndex);
        }
        // TODO(michaelterry): Add output mask cache code.
        // Build this.inputLayers:
        for (const x of this.inputs){
            const layer = x.sourceLayer;
            const nodeIndex = x.nodeIndex;
            const tensorIndex = x.tensorIndex;
            /*
              It's supposed to be an input layer, so only one node
              and one tensor output.
            */ $jYx5u.assert(nodeIndex === 0, 'input layer has >1 nodes');
            $jYx5u.assert(tensorIndex === 0, 'input layer has >1 tensors');
            this.inputLayers.push(layer);
            this.inputLayersNodeIndices.push(nodeIndex);
            this.inputLayersTensorIndices.push(tensorIndex);
        }
        // Build this.inputNames and this.outputNames.
        this.inputNames = [];
        this.outputNames = [];
        this.feedInputShapes = [];
        this.feedInputNames = [];
        this.feedOutputNames = [];
        for(let i = 0; i < this.inputLayers.length; i++){
            const layer = this.inputLayers[i];
            // Check that layer is an InputLayer.
            if (!(layer instanceof (0, $lusky.InputLayer))) throw new TypeError('Input layers to a LayersModel must be InputLayer objects. ' + `Received inputs: ${args.inputs}. ` + `Input ${i} (0-based) originates ` + `from layer type ${layer.getClassName()}.`);
            this.inputNames.push(layer.name);
            this.feedInputShapes.push(layer.batchInputShape);
            this.feedInputNames.push(layer.name);
        }
        for (const layer of this.outputLayers)this.outputNames.push(layer.name);
        this.internalInputShapes = this.inputs.map((x)=>x.shape);
        this.internalOutputShapes = this.outputs.map((x)=>x.shape);
        /*
          Container_nodes: set of nodes included in the graph (not all nodes
          included in the layers are relevant to the current graph).
        */ // ids of all nodes relevant to the Container:
        const nodesDepths = {};
        // To recover nodes from their ID.
        const nodeIDToNode = {};
        const layersDepths = {};
        // To layers from their ID.
        const layerIDToLayer = {};
        const layerIndices = {};
        const nodesInDecreasingDepth = [];
        /**
         * Builds a map of the graph of layers.
         *
         * This recursively updates the map `layerIndices`,
         * the list `nodesInDecreasingDepth` and the set `containerNodes`.
         *
         * @param tensor Some tensor in a graph.
         * @param finishedNodes Set of nodes whose subgraphs have been traversed
         *         completely. Useful to prevent duplicated work.
         * @param nodesInProgress Set of nodes that are currently active on the
         *         recursion stack. Useful to detect cycles.
         * @param layer Layer from which `tensor` comes from. If not provided,
         *   will be obtained from tensor.sourceLayer.
         * @param nodeIndex Node index from which `tensor` comes from.
         * @param tensorIndex TensorIndex from which `tensor` comes from.
         *
         * @exception RuntimeError if a cycle is detected.
         */ const buildMapOfGraph = (tensor, finishedNodes, nodesInProgress, layer, nodeIndex, tensorIndex)=>{
            if (layer == null || nodeIndex == null || tensorIndex == null) {
                layer = tensor.sourceLayer;
                nodeIndex = tensor.nodeIndex;
                tensorIndex = tensor.tensorIndex;
            }
            const node = layer.inboundNodes[nodeIndex];
            // Prevent cycles.
            if (nodesInProgress.indexOf(node) !== -1) throw new (0, $kubuc.RuntimeError)(`The tensor ${tensor.name} at layer "${layer.name}" ` + 'is part of a cycle.');
            // Don't repeat work for shared subgraphs
            if (finishedNodes.indexOf(node) !== -1) return;
            // Update containerNodes.
            this.containerNodes.add($25d6207cfb5d469d$export$42a852a2b6b56249.nodeKey(layer, nodeIndex));
            // Store the traversal order for layer sorting.
            if (!(layer.id in layerIndices)) layerIndices[layer.id] = Object.keys(layerIndices).length;
            if (nodesInProgress.indexOf(node) === -1) nodesInProgress.push(node);
            // Propagate to all previous tensors connected to this node.
            const numInboundLayers = node.inboundLayers.length;
            for(let i = 0; i < numInboundLayers; i++){
                const x = node.inputTensors[i];
                const layer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const tensorIndex = node.tensorIndices[i];
                buildMapOfGraph(x, finishedNodes, nodesInProgress, layer, nodeIndex, tensorIndex);
            }
            finishedNodes.push(node);
            while(nodesInProgress.indexOf(node) >= 0)nodesInProgress.splice(nodesInProgress.indexOf(node), 1);
            nodesInDecreasingDepth.push(node);
        };
        const finishedNodes = [];
        const nodesInProgress = [];
        for (const x of this.outputs)buildMapOfGraph(x, finishedNodes, nodesInProgress);
        const reversedNodesInDecreasingDepth = nodesInDecreasingDepth.slice().reverse();
        for (const node of reversedNodesInDecreasingDepth){
            nodeIDToNode[node.id] = node;
            // If the depth is not set, the node has no outbound nodes (depth 0).
            if (!(node.id in nodesDepths)) nodesDepths[node.id] = 0;
            let depth = nodesDepths[node.id];
            // Update the depth of the corresponding layer
            const previousDepth = layersDepths[node.outboundLayer.id] == null ? 0 : layersDepths[node.outboundLayer.id];
            /*
              If we've seen this layer before at a higher depth, we should use that
              depth instead of the node depth.  This is necessary for shared layers
              that have inputs at different depth levels in the graph.
            */ depth = Math.max(depth, previousDepth);
            layersDepths[node.outboundLayer.id] = depth;
            layerIDToLayer[node.outboundLayer.id] = node.outboundLayer;
            nodesDepths[node.id] = depth;
            // Update the depth of inbound nodes.
            for(let i = 0; i < node.inboundLayers.length; i++){
                const inboundLayer = node.inboundLayers[i];
                const nodeIndex = node.nodeIndices[i];
                const inboundNode = inboundLayer.inboundNodes[nodeIndex];
                const previousDepth = nodesDepths[inboundNode.id] == null ? 0 : nodesDepths[inboundNode.id];
                nodesDepths[inboundNode.id] = Math.max(depth + 1, previousDepth);
                nodeIDToNode[inboundNode.id] = inboundNode;
            }
        }
        // Build a dict {depth: list of nodes with this depth}
        const nodesByDepth = {};
        for(const nodeID in nodesDepths){
            const depth = nodesDepths[nodeID];
            if (!(depth in nodesByDepth)) nodesByDepth[depth] = [];
            nodesByDepth[depth].push(nodeIDToNode[nodeID]);
        }
        // Build a dict {depth: list of layers with this depth}
        const layersByDepth = {};
        for(const layerID in layersDepths){
            const depth = layersDepths[layerID];
            if (!(depth in layersByDepth)) layersByDepth[depth] = [];
            layersByDepth[depth].push(layerIDToLayer[layerID]);
        }
        // Get sorted list of layer depths.
        let depthKeys = Object.keys(layersByDepth).map((x)=>parseInt(x, 10)).sort($jYx5u.reverseNumberCompare);
        // Set this.layers and this.layersByDepth.
        this.layers = [];
        for (const depth of depthKeys){
            const layersForDepth = layersByDepth[depth];
            // Container.layers needs to have a deterministic order:
            // here we order them by traversal order.
            layersForDepth.sort((a, b)=>{
                const aIndex = layerIndices[a.id];
                const bIndex = layerIndices[b.id];
                if (aIndex < bIndex) return -1;
                if (aIndex > bIndex) return 1;
                return 0;
            });
            for (const layer of layersForDepth){
                if (layer instanceof $25d6207cfb5d469d$export$42a852a2b6b56249) this.internalContainerRefs.push(layer);
                this.layers.push(layer);
            }
        }
        this.layersByDepth = layersByDepth;
        // Get sorted list of node depths;
        depthKeys = Object.keys(nodesByDepth).map((x)=>parseInt(x, 10)).sort($jYx5u.reverseNumberCompare);
        // Check that all tensors required are computable.
        // computable_tensors: all tensors in the graph
        // that can be computed from the inputs provided.
        const computableTensors = this.inputs.slice();
        // To provide a better error msg.
        const layersWithCompleteInput = [];
        for (const depth of depthKeys)for (const node of nodesByDepth[depth]){
            const layer = node.outboundLayer;
            if (layer != null) {
                for (const x of node.inputTensors){
                    if (computableTensors.indexOf(x) === -1) throw new (0, $kubuc.RuntimeError)(`Graph disconnected: cannot obtain value for tensor ${x}` + ` at layer "${layer.name}". ` + 'The following previous layers were accessed without ' + `issue: ${layersWithCompleteInput}`);
                }
                for (const x of node.outputTensors)computableTensors.push(x);
                layersWithCompleteInput.push(layer.name);
            }
        }
        // Set this.containerNodes and this.nodesByDepth.
        this.nodesByDepth = nodesByDepth;
        // Ensure name unicity, which will be crucial for serialization
        // (since serialized nodes refer to layers by their name).
        const allNames = this.layers.map((x)=>x.name);
        for (const name of allNames){
            const numOccurrences = allNames.filter((x)=>x === name).length;
            if (numOccurrences !== 1) throw new (0, $kubuc.RuntimeError)(`The name "${name}" is used ${numOccurrences} times ` + 'in the model. All layer names should be unique. Layer names: ' + JSON.stringify(allNames));
        }
        // Layer parameters.
        // The new container starts with a single inbound node
        // for its inputs, and no outbound nodes.
        // Will be appended to by future calls to apply().
        this.outboundNodes = [];
        // Will be appended to below, and by future calls to apply().
        this.inboundNodes = [];
        // Create the node linking internal inputs to internal outputs.
        // (This call has side effects.)
        // tslint:disable-next-line:no-unused-expression
        new (0, $jWpeh.Node)({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: this.inputs,
            outputTensors: this.outputs,
            inputMasks: this.inputs.map((x)=>null),
            outputMasks: this.outputs.map((x)=>null),
            inputShapes: this.inputs.map((x)=>x.shape),
            outputShapes: this.outputs.map((x)=>x.shape)
        });
        this.built = true;
        this._refCount = 1; // The ref count of a container always start at 1.
    }
    assertNotDisposed() {
        if (this._refCount === 0) throw new Error(`Container '${this.name}' is already disposed.`);
    }
    /**
     * Attempt to dispose a LayersModel's weights.
     *
     * This method decrease the reference count of the LayersModel object by 1.
     *
     * A LayersModel is reference-counted. Its reference count is incremented by 1
     * when it is first constructed and when it is used as a Layer of another
     * LayersModel.
     *
     * If the reference count of a LayersModel becomes 0, the `dispose` method of
     * all its constituent `Layer`s will be called.
     *
     * Note: If the reference count is greater than 0 after the decrement, the
     * `dispose` method of its constituent `Layer`s will *not* be called.
     *
     * After a LayersModel is disposed, it cannot be used in calls such as
     * 'predict`, `evaluate` or `fit` anymore.
     *
     * @returns A DisposeResult Object with the following fields:
     *   - refCountAfterDispose: The reference count of the LayersModel after this
     *     `dispose()` call.
     *   - numDisposedVariables: Number of `tf.Variable`s (i.e., weights) disposed
     *     during this `dispose()` call.
     * @throws {Error} If the layer is not built yet, or if the LayersModel has
     *   already been disposed.
     */ dispose() {
        this.assertNotDisposed();
        const result = {
            refCountAfterDispose: null,
            numDisposedVariables: 0
        };
        if (--this._refCount === 0) {
            for (const layer of this.layers)result.numDisposedVariables += layer.dispose().numDisposedVariables;
            // Call dispose on each internally created container layer again to ensure
            // their refCounts hit zero and their tensors are subsequently deleted.
            for (const container of this.internalContainerRefs)result.numDisposedVariables += container.dispose().numDisposedVariables;
        }
        result.refCountAfterDispose = this._refCount;
        return result;
    }
    get trainable() {
        return this.trainable_;
    }
    set trainable(trainable) {
        this.layers.forEach((layer)=>{
            // tslint:disable-next-line:no-any
            layer._trainableWeights.forEach((w)=>w.trainable = trainable);
        });
        this.trainable_ = trainable;
    }
    get trainableWeights() {
        // Porting Note: This check below is to prevent errors where the
        //   _trainableWeights inherited from the parent class (Layer) gets
        //   inadvertently used.
        if (this._trainableWeights.length > 0) throw new (0, $kubuc.ValueError)("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");
        if (!this.trainable) return [];
        let weights = [];
        for (const layer of this.layers)weights = weights.concat(layer.trainableWeights);
        return weights;
    }
    get nonTrainableWeights() {
        const weights = [];
        for (const layer of this.layers)weights.push(...layer.nonTrainableWeights);
        if (!this.trainable) {
            const trainableWeights = [];
            for (const layer of this.layers)trainableWeights.push(...layer.trainableWeights);
            return trainableWeights.concat(weights);
        }
        return weights;
    }
    get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights);
    }
    /**
     * Loads all layer weights from a JSON object.
     *
     * Porting Note: HDF5 weight files cannot be directly loaded in JavaScript /
     *   TypeScript. The utility script at `scripts/pykeras.py` offers means
     *   to convert them into JSON strings compatible with this method.
     * Porting Note: TensorFlow.js Layers supports only loading by name currently.
     *
     * @param weights A JSON mapping weight names to weight values as nested
     *   arrays of numbers, or a `NamedTensorMap`, i.e., a JSON mapping weight
     *   names to `tf.Tensor` objects.
     * @param strict Require that the provided weights exactly match those
     *   required by the container.  Default: `true`.  Passing `false` means that
     *   extra weights and missing weights will be silently ignored.
     */ loadWeights(weights, strict = true) {
        const nameToWeight = {};
        let totalWeightsCount = 0;
        const modelIsKerasSavedModelFormat = $25d6207cfb5d469d$var$isKerasSavedModelFormat(weights);
        if (modelIsKerasSavedModelFormat) this.parseWeights(weights);
        // Check if weights from keras v3.
        for (const layer of this.layers)for (const [index, weight] of layer.weights.entries()){
            // Parse the name to layerName/index.
            // e.g. dense/0, dense/1, dense_1/0, dense_1/1
            const parsedName = modelIsKerasSavedModelFormat ? `${weight.name.split('/').slice(0, -1).join('/') + '/'}${index}` : weight.originalName;
            if (nameToWeight[parsedName] != null) throw new (0, $kubuc.ValueError)(`Duplicate weight name: ${parsedName}`);
            nameToWeight[parsedName] = weight;
            totalWeightsCount++;
        }
        const weightValueTuples = [];
        for(const name in weights){
            // TF 2.2.0 added cell name to the weight name in the format of
            // layer_name/cell_name/weight_name, we need to remove
            // the inner cell name.
            let validatedName = name;
            if (nameToWeight[name] == null) {
                const tokens = name.split('/');
                const shortenNameArray = tokens.slice(0, -2).concat([
                    tokens[tokens.length - 1]
                ]);
                validatedName = shortenNameArray.join('/');
            }
            if (nameToWeight[validatedName] != null) weightValueTuples.push([
                nameToWeight[validatedName],
                weights[name]
            ]);
            else if (strict) throw new (0, $kubuc.ValueError)(`Provided weight data has no target variable: ${name}`);
            delete nameToWeight[validatedName];
        }
        if (strict) {
            // Check that all weights are set.
            const unsetNames = [];
            for(const name in nameToWeight)unsetNames.push(name);
            if (unsetNames.length > 0) throw new (0, $kubuc.ValueError)(`${unsetNames.length} of ${totalWeightsCount} weights are not set: ` + `${unsetNames}`);
        }
        (0, $pKVrB.batchSetValue)(weightValueTuples);
    }
    parseWeights(weights) {
        for(const key in Object.keys(weights)){
            const listParts = key.split('/');
            const list = [
                'vars',
                'layer_checkpoint_dependencies'
            ];
            // For keras v3, the weights name are saved based on the folder structure.
            // e.g. _backbone/_layer_checkpoint_dependencies/transformer/_self../
            // _output_dense/vars/0
            // Therefore we discard the `vars` and `layer_checkpoint_depencies` within
            // the saved name and only keeps the layer name and weights.
            // This can help to mapping the actual name of the layers and load each
            // weight accordingly.
            const newKey = listParts.map((str)=>{
                if (str.startsWith('_')) return str.slice(1);
                return str;
            }).filter((str)=>!list.includes(str)).join('/');
            if (newKey !== key) {
                weights[newKey] = weights[key];
                delete weights[key];
            }
        }
    }
    /**
     * Util shared between different serialization methods.
     * @returns LayersModel config with Keras version information added.
     */ updatedConfig() {
        const theConfig = this.getConfig();
        const modelConfig = {};
        modelConfig['className'] = this.getClassName();
        modelConfig['config'] = theConfig;
        modelConfig['kerasVersion'] = `tfjs-layers ${0, $kw5Gh.version}`;
        // TODO(nielsene): Replace something like K.backend() once
        // possible.
        modelConfig['backend'] = 'TensorFlow.js';
        return modelConfig;
    }
    /**
     * Returns a JSON string containing the network configuration.
     *
     * To load a network from a JSON save file, use
     * models.modelFromJSON(jsonString);
     * @param extraJsonArgs Unused in tfjs-layers, maintained for PyKeras
     * @param returnString Whether the return value should be stringified
     *    (default: `true`).
     * @returns a JSON string if `returnString` (default), or a JSON object if
     *   `!returnString`.
     */ // tslint:disable-next-line:no-any
    toJSON(unused, returnString = true) {
        const modelConfig = (0, $3r0Ja.convertTsToPythonic)(this.updatedConfig());
        return returnString ? JSON.stringify(modelConfig) : modelConfig;
    }
    /**
     * Call the model on new inputs.
     *
     * In this case `call` just reapplies all ops in the graph to the new inputs
     * (e.g. build a new computational graph from the provided inputs).
     *
     * @param inputs A tensor or list of tensors.
     * @param mask A mask or list of masks. A mask can be either a tensor or null
     *   (no mask).
     *
     * @return A tensor if there is a single output, or a list of tensors if there
     *   are more than one outputs.
     */ call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = $jYx5u.toList(inputs);
            const feedDict = new (0, $iyRtt.FeedDict)();
            for(let i = 0; i < this.inputs.length; ++i)feedDict.add(this.inputs[i], inputs[i]);
            return (0, $iyRtt.execute)(this.outputs, feedDict, kwargs);
        });
    }
    /**
     * Computes an output mask tensor.
     *
     * @param inputs Tensor or list of tensors.
     * @param mask Tensor or list of tensors.
     *
     * @return null or a tensor (or list of tensors, one per output tensor of the
     * layer).
     */ computeMask(inputs, mask) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = $jYx5u.toList(inputs);
            let masks;
            if (mask == null) masks = $jYx5u.pyListRepeat(null, inputs.length);
            else masks = $jYx5u.toList(mask);
            // TODO(michaelterry): Add support for mask caching.
            return this.runInternalGraph(inputs, masks)[1];
        });
    }
    /**
     * Computes the output shape of the layer.
     *
     * Assumes that the layer will be built to match that input shape provided.
     *
     * @param inputShape A shape (tuple of integers) or a list of shape tuples
     *   (one per output tensor of the layer). Shape tuples can include null for
     *   free dimensions, instead of an integer.
     */ computeOutputShape(inputShape) {
        const inputShapes = $bMNfZ.normalizeShapeList(inputShape);
        if (inputShapes.length !== this.inputLayers.length) throw new (0, $kubuc.ValueError)(`Invalid inputShape argument ${inputShape}: ` + `model has ${this.inputLayers.length} tensor inputs.`);
        // TODO(michaelterry): Add caching
        const layersToOutputShapes = {};
        for(let i = 0; i < inputShapes.length; i++){
            const layer = this.inputLayers[i];
            const inputShape = inputShapes[i];
            // It's an input layer: computeOutputShape is identity,
            // and there is only one node and one tensor output.
            const shapeKey = layer.name + '_0_0';
            layersToOutputShapes[shapeKey] = inputShape;
        }
        const depthKeys = Object.keys(this.nodesByDepth).map((x)=>parseInt(x, 10)).sort($jYx5u.reverseNumberCompare);
        // Iterate over nodes, by depth level.
        if (depthKeys.length > 1) for (const depth of depthKeys){
            const nodes = this.nodesByDepth[depth];
            for (const node of nodes){
                // This is always a single layer, never a list.
                const layer = node.outboundLayer;
                if (this.inputLayers.map((x)=>x.id).indexOf(layer.id) !== -1) continue;
                // Potentially redundant list, same size of node.inputTensors.
                const inputShapes = [];
                for(let j = 0; j < node.inboundLayers.length; j++){
                    const inboundLayer = node.inboundLayers[j];
                    const nodeIndex = node.nodeIndices[j];
                    const tensorIndex = node.tensorIndices[j];
                    const shapeKey = `${inboundLayer.name}_${nodeIndex}_${tensorIndex}`;
                    const inputShape = layersToOutputShapes[shapeKey];
                    inputShapes.push(inputShape);
                }
                const outputShape = layer.computeOutputShape($jYx5u.singletonOrArray(inputShapes));
                const outputShapes = $bMNfZ.normalizeShapeList(outputShape);
                const nodeIndex = layer.inboundNodes.indexOf(node);
                for(let j = 0; j < outputShapes.length; j++){
                    const shapeKey = `${layer.name}_${nodeIndex}_${j}`;
                    layersToOutputShapes[shapeKey] = outputShapes[j];
                }
            }
        }
        // Read final output shapes from layersToOutputShapes.
        const outputShapes = [];
        const outputShapeKeys = [];
        for(let i = 0; i < this.outputLayers.length; i++){
            const layer = this.outputLayers[i];
            const nodeIndex = this.outputLayersNodeIndices[i];
            const tensorIndex = this.outputLayersTensorIndices[i];
            const shapeKey = `${layer.name}_${nodeIndex}_${tensorIndex}`;
            outputShapeKeys.push(shapeKey);
        }
        for(let i = 0; i < outputShapeKeys.length; i++){
            const key = outputShapeKeys[i];
            $jYx5u.assert(key in layersToOutputShapes);
            outputShapes.push(layersToOutputShapes[key]);
        }
        // TODO(michaelterry): Update cache
        return $jYx5u.singletonOrArray(outputShapes);
    }
    /**
     * Computes output tensors for new inputs.
     *
     * Note:
     *   - Expects `inputs` to be a list (potentially with 1 element).
     *
     * @param inputs List of tensors
     * @param masks List of masks (tensors or null).
     * @return Three lists: outputTensors, outputMasks, outputShapes
     */ runInternalGraph(inputs, masks) {
        if (masks == null) masks = $jYx5u.pyListRepeat(null, inputs.length);
        // Dictionary mapping reference tensors to tuples
        // (computed tensor, compute mask)
        // we assume a 1:1 mapping from tensor to mask
        // TODO: raise exception when a `.computeMask()` call
        // does not return a list the same size as `call`
        const tensorMap = {};
        for(let i = 0; i < this.inputs.length; ++i){
            const x = this.inputs[i];
            const y = inputs[i];
            const mask = masks[i];
            tensorMap[x.id] = [
                y,
                mask
            ];
        }
        const depthKeys = Object.keys(this.nodesByDepth).map((x)=>parseInt(x, 10)).sort($jYx5u.reverseNumberCompare);
        for (const depth of depthKeys){
            const nodes = this.nodesByDepth[depth];
            for (const node of nodes){
                // This is always a single layer, never a list.
                const layer = node.outboundLayer;
                const referenceInputTensors = node.inputTensors;
                const referenceOutputTensors = node.outputTensors;
                // If all previous input tensors are available in tensorMap,
                // then call node.inboundLayer on them.
                // List of tuples [input, mask]:
                const computedData = new Array();
                for (const x of referenceInputTensors)if (x.id in tensorMap) computedData.push(tensorMap[x.id]);
                if (computedData.length === referenceInputTensors.length) {
                    // TODO(michaelterry): Add K.name_scope here, if we need it.
                    let kwargs = {};
                    let computedTensors;
                    let computedMasks;
                    let outputTensors;
                    let outputMasks;
                    // call layer
                    if (node.callArgs != null) kwargs = node.callArgs;
                    if (computedData.length === 1) {
                        const [computedTensor, computedMask] = computedData[0];
                        if (kwargs['mask'] == null) kwargs['mask'] = computedMask;
                        outputTensors = $jYx5u.toList(layer.call(computedTensor, kwargs));
                        outputMasks = $jYx5u.toList(layer.computeMask(computedTensor, computedMask));
                        computedTensors = [
                            computedTensor
                        ];
                        computedMasks = [
                            computedMask
                        ];
                    } else {
                        computedTensors = computedData.map((x)=>x[0]);
                        computedMasks = computedData.map((x)=>x[1]);
                        if (kwargs['mask'] == null) kwargs['mask'] = computedMasks;
                        outputTensors = $jYx5u.toList(layer.call(computedTensors, kwargs));
                        outputMasks = $jYx5u.toList(layer.computeMask(computedTensors, computedMasks));
                    }
                    if (layer.activityRegularizer) throw new (0, $kubuc.NotImplementedError)("LayersModel invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");
                    // TODO(michaelterry): Add model updates and losses
                    // Update tensor map.
                    for(let i = 0; i < referenceOutputTensors.length; ++i){
                        const x = referenceOutputTensors[i];
                        const y = outputTensors[i];
                        const mask = outputMasks[i];
                        tensorMap[x.id] = [
                            y,
                            mask
                        ];
                    }
                }
            }
        }
        const outputTensors = [];
        const outputMasks = [];
        const outputShapes = [];
        for (const x of this.outputs){
            $jYx5u.assert(x.id in tensorMap, `Could not compute output ${x.name} : ${x.id}`);
            const [tensor, mask] = tensorMap[x.id];
            outputShapes.push(tensor.shape);
            outputTensors.push(tensor);
            outputMasks.push(mask);
        }
        // TODO(michaelterry): Add support for caches.
        return [
            outputTensors,
            outputMasks,
            outputShapes
        ];
    }
    /**
     * Builds a map of internal node keys to node ordering.
     * Used in serializaion a node orderings may change as unused nodes are
     * dropped. Porting Note:  This helper method was pulled out of getConfig to
     * improve readability.
     * @param layers An array of Layers in the model.
     * @returns Map of Node Keys to index order within the layer.
     */ buildNodeConversionMap(layers) {
        const nodeConversionMap = {};
        let keptNodes;
        for (const layer of this.layers){
            keptNodes = layer instanceof $25d6207cfb5d469d$export$42a852a2b6b56249 ? 1 : 0;
            for(let originalNodeIndex = 0; originalNodeIndex < layer.inboundNodes.length; originalNodeIndex++){
                const nodeKey = $25d6207cfb5d469d$export$42a852a2b6b56249.nodeKey(layer, originalNodeIndex);
                if (this.containerNodes.has(nodeKey)) {
                    // i.e. we mark it to be saved
                    nodeConversionMap[nodeKey] = keptNodes;
                    keptNodes += 1;
                }
            }
        }
        return nodeConversionMap;
    }
    getLayer(nameOrIndex, index) {
        if (index != null) return this.findLayer(index);
        else {
            if (nameOrIndex == null) throw new (0, $kubuc.ValueError)('Provide either a layer name or layer index');
            if (typeof nameOrIndex === 'number') return this.findLayer(nameOrIndex);
        }
        for (const layer of this.layers){
            if (layer.name === nameOrIndex) return layer;
        }
        throw new (0, $kubuc.ValueError)(`No such layer: ${nameOrIndex}`);
    }
    findLayer(index) {
        if (this.layers.length <= index) throw new (0, $kubuc.ValueError)(`Was asked to retrieve layer at index ${index}, but model only ` + `has ${this.layers.length} layer(s).`);
        else return this.layers[index];
    }
    /**
     * Retrieves the Container's current loss values.
     *
     * Used for regularizers during training.
     */ calculateLosses() {
        // Porting Node: This is an augmentation to Container.loss in PyKeras.
        //   In PyKeras, Container.loss returns symbolic tensors. Here a concrete
        //   Tensor (specifically Scalar) values are returned. This is due to the
        //   imperative backend.
        return (0, $d7Nxs.tidy)(()=>{
            const losses = [];
            for (const layer of this.layers)for(let nodeIndex = 0; nodeIndex < layer.inboundNodes.length; ++nodeIndex){
                const nodeKey = $25d6207cfb5d469d$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
                if (this.containerNodes.has(nodeKey)) losses.push(...layer.calculateLosses());
            }
            // TODO(cais): Add any unconditional model-level losses?
            return losses;
        });
    }
    getConfig() {
        const config = {
            name: this.name
        };
        // Build a map from layer unique name (self._node_key)
        // to the index of the nodes that are saved in the config.
        // Only nodes in container_nodes are saved.
        const nodeConversionMap = this.buildNodeConversionMap(this.layers);
        // Serialize and save the layers in layerConfigs
        const layerConfigs = [];
        for (const layer of this.layers){
            const layerClassName = layer.getClassName();
            const layerConfig = layer.getConfig();
            const filteredInboundNodes = [];
            for(let originalNodeIndex = 0; originalNodeIndex < layer.inboundNodes.length; originalNodeIndex++){
                const node = layer.inboundNodes[originalNodeIndex];
                const nodeKey = $25d6207cfb5d469d$export$42a852a2b6b56249.nodeKey(layer, originalNodeIndex);
                let kwargs = {};
                if (this.containerNodes.has(nodeKey)) {
                    // The node is relevant to the model:
                    // add to filteredInboundNodes.
                    if (node.callArgs) try {
                        JSON.stringify(node.callArgs);
                        kwargs = node.callArgs;
                    } catch (err) {
                        console.warn(`Layer ${layer.name} was passed ` + `non-serializable keyword arguments: ` + `${node.callArgs}. They will not be included ` + `in the serialized model (and thus will be ` + `missing at deserialization time).`);
                        kwargs = {};
                    }
                    if (node.inboundLayers.length > 0) {
                        const nodeData = [];
                        for(let i = 0; i < node.inboundLayers.length; i++){
                            const inboundLayer = node.inboundLayers[i];
                            const nodeIndex = node.nodeIndices[i];
                            const tensorIndex = node.tensorIndices[i];
                            const nodeKey = $25d6207cfb5d469d$export$42a852a2b6b56249.nodeKey(inboundLayer, nodeIndex);
                            let newNodeIndex = nodeConversionMap[nodeKey];
                            if (newNodeIndex == null) newNodeIndex = 0;
                            nodeData.push([
                                inboundLayer.name,
                                newNodeIndex,
                                tensorIndex,
                                kwargs
                            ]);
                        }
                        filteredInboundNodes.push(nodeData);
                    }
                }
            }
            const dict = {};
            dict['name'] = layer.name;
            dict['className'] = layerClassName;
            dict['config'] = layerConfig;
            dict['inboundNodes'] = filteredInboundNodes;
            layerConfigs.push(dict);
        }
        config['layers'] = layerConfigs;
        // Gather info about inputs and outputs
        const modelInputs = [];
        for(let i = 0; i < this.inputLayers.length; i++){
            const layer = this.inputLayers[i];
            const nodeIndex = this.inputLayersNodeIndices[i];
            const nodeKey = $25d6207cfb5d469d$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
            if (!this.containerNodes.has(nodeKey)) continue;
            let newNodeIndex = nodeConversionMap[nodeKey];
            if (newNodeIndex === null || newNodeIndex === undefined) newNodeIndex = 0;
            const tensorIndex = this.inputLayersTensorIndices[i];
            modelInputs.push([
                layer.name,
                newNodeIndex,
                tensorIndex
            ]);
        }
        config['inputLayers'] = modelInputs;
        const modelOutputs = [];
        for(let i = 0; i < this.outputLayers.length; i++){
            const layer = this.outputLayers[i];
            const nodeIndex = this.outputLayersNodeIndices[i];
            const nodeKey = $25d6207cfb5d469d$export$42a852a2b6b56249.nodeKey(layer, nodeIndex);
            if (!this.containerNodes.has(nodeKey)) continue;
            let newNodeIndex = nodeConversionMap[nodeKey];
            if (newNodeIndex === null || newNodeIndex === undefined) newNodeIndex = 0;
            const tensorIndex = this.outputLayersTensorIndices[i];
            modelOutputs.push([
                layer.name,
                newNodeIndex,
                tensorIndex
            ]);
        }
        config['outputLayers'] = modelOutputs;
        return config;
    }
    /**
     * Instantiates a LayersModel from its config (output of `get_config()`).
     * @param cls the class to create
     * @param config LayersModel config dictionary.
     * @param customObjects An optional dictionary of custom objects.
     * @param fastWeightInit Optional flag to use fast weight initialization
     *   during deserialization. This is applicable to cases in which
     *   the initialization will be immediately overwritten by loaded weight
     *   values. Default: `false`.
     * @returns A LayersModel instance.
     * @throws ValueError: In case of improperly formatted config dict.
     */ /** @nocollapse */ static fromConfig(cls, config, customObjects = {}, fastWeightInit = false) {
        // Layer instances created during
        // the graph reconstruction process
        const createdLayers = {};
        // Dictionary mapping layer instances to
        // node data that specifies a layer call.
        // It acts as a queue that maintains any unprocessed
        // layer call until it becomes possible to process it
        // (i.e. until the input tensors to the call all exist).
        const unprocessedNodes = {};
        function addUnprocessedNode(layer, nodeData) {
            if (!(layer.name in unprocessedNodes)) unprocessedNodes[layer.name] = [
                nodeData
            ];
            else unprocessedNodes[layer.name].push(nodeData);
        }
        function processNode(layer, nodeData) {
            const inputTensors = [];
            let kwargs;
            for (const inputData of nodeData){
                const inboundLayerName = inputData[0];
                const inboundNodeIndex = inputData[1];
                const inboundTensorIndex = inputData[2];
                kwargs = inputData[3] == null ? {} : inputData[3];
                if (!(inboundLayerName in createdLayers)) {
                    addUnprocessedNode(layer, nodeData);
                    return;
                }
                const inboundLayer = createdLayers[inboundLayerName];
                if (inboundLayer.inboundNodes.length <= inboundNodeIndex) {
                    addUnprocessedNode(layer, nodeData);
                    return;
                }
                const inboundNode = inboundLayer.inboundNodes[inboundNodeIndex];
                inputTensors.push(inboundNode.outputTensors[inboundTensorIndex]);
            }
            // Call layer on its inputs, thus creating the node
            // and building the layer if needed.
            // Note: This has Eager vs Graph Implications.
            if (inputTensors.length > 0) layer.apply($jYx5u.singletonOrArray(inputTensors), kwargs); // was ** kwargs
        }
        /**
         * Deserialize a layer, then call it on appropriate inputs.
         * @param layerData: layer config dict.
         * @throws ValueError: In case of improperly formatted `layer_data`
         * dict.
         */ function processLayer(layerData) {
            const layerName = layerData['name'];
            // Instantiate layer.
            const layer = (0, $4v3Le.deserialize)(layerData, config['customObjects'] != null ? config['customObjects'] : {});
            layer.setFastWeightInitDuringBuild(fastWeightInit);
            createdLayers[layerName] = layer;
            // Gather layer inputs.
            const inboundNodesData = layerData['inboundNodes'];
            inboundNodesData.forEach((nodeData)=>{
                if (!(nodeData instanceof Array)) throw new (0, $kubuc.ValueError)(`Corrupted configuration, expected array for nodeData: ${nodeData}`);
                // We don't process nodes (i.e. make layer calls)
                // on the fly because the inbound node may not yet exist,
                // in case of layer shared at different topological depths
                // (e.g.a model such as A(B(A(B(x)))))
                addUnprocessedNode(layer, nodeData);
            });
        }
        // First, we create all layers and enqueue nodes to be processed.
        const name = config['name'];
        const layersFromConfig = config['layers'];
        for (const layerData of layersFromConfig)processLayer(layerData);
        // Then we process nodes in order of layer depth.
        // Nodes that cannot yet be processed(if the inbound node
        // does not yet exist) are re - enqueued, and the process
        // is repeated until all nodes are processed.
        while(!$jYx5u.isObjectEmpty(unprocessedNodes))for (const layerData of layersFromConfig){
            const layer = createdLayers[layerData['name']];
            if (layer.name in unprocessedNodes) {
                const currentUnprocessedNodesForLayer = unprocessedNodes[layer.name];
                delete unprocessedNodes[layer.name];
                for (const nodeData of currentUnprocessedNodesForLayer)processNode(layer, nodeData);
            }
        }
        const inputTensors = [];
        const outputTensors = [];
        const inputLayersFromConfig = config['inputLayers'];
        for (const layerData of inputLayersFromConfig){
            const layerName = layerData[0];
            const nodeIndex = layerData[1];
            const tensorIndex = layerData[2];
            $jYx5u.assert(layerName in createdLayers);
            const layer = createdLayers[layerName];
            const layerOutputTensors = layer.inboundNodes[nodeIndex].outputTensors;
            inputTensors.push(layerOutputTensors[tensorIndex]);
        }
        const outputLayersFromConfig = config['outputLayers'];
        for (const layerData of outputLayersFromConfig){
            const layerName = layerData[0];
            const nodeIndex = layerData[1];
            const tensorIndex = layerData[2];
            $jYx5u.assert(layerName in createdLayers);
            const layer = createdLayers[layerName];
            const layerOutputTensors = layer.inboundNodes[nodeIndex].outputTensors;
            outputTensors.push(layerOutputTensors[tensorIndex]);
        }
        return new cls({
            inputs: inputTensors,
            outputs: outputTensors,
            name: name
        });
    }
    /**
     * Determine whether the container is stateful.
     *
     * Porting Note: this is the equivalent of the stateful @property of
     *   the Container class in PyKeras.
     */ get stateful() {
        // Porting Note: This check is to prevent inadvertent setting of the
        //   _stateful property of the Container instance.
        if (this._stateful) throw new (0, $kubuc.ValueError)("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");
        for (const layer of this.layers){
            if (layer.stateful) return true;
        }
        return false;
    }
    /**
     * Reset the state of all stateful constituent layers (if any).
     *
     * Examples of stateful layers include RNN layers whose `stateful` property
     * is set as `true`.
     */ resetStates() {
        (0, $d7Nxs.tidy)(()=>{
            this.layers.forEach((layer)=>{
                // tslint:disable:no-any
                if (layer.stateful) layer.resetStates();
            // tslint:enable:no-any
            });
        });
    }
}

});

parcelRegister("iR99G", function(module, exports) {

$parcel$export(module.exports, "fitDataset", function () { return $dba44742a80a59f8$export$4e883c052383550c; });
$parcel$export(module.exports, "evaluateDataset", function () { return $dba44742a80a59f8$export$56e284faddc3ba42; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Interfaces and methods for training models using TensorFlow.js datasets.
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $d7Nxs = parcelRequire("d7Nxs");
var $dIChU = parcelRequire("dIChU");
var $5hAos = parcelRequire("5hAos");
var $7hONX = parcelRequire("7hONX");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $801Oz = parcelRequire("801Oz");

var $kubuc = parcelRequire("kubuc");

var $lcd3O = parcelRequire("lcd3O");

var $jYx5u = parcelRequire("jYx5u");

var $10YKi = parcelRequire("10YKi");
// Default batch size used during tensor-based validation.
const $dba44742a80a59f8$var$DEFAULT_VALIDATION_BATCH_SIZE = 32;
/**
 * Standardize the output of a dataset iterator for use by
 * LayersModel.fitDataset().
 *
 * @param model: A `tf.LayersModel` object.
 * @param iteratorOut The output of a dataset iterator. It is required to be
 *   an object of the form `{xs: TensorOrArrayOrMap, ys:
 * TensorOrArrayOrMap}`, where `TensorOrArrayOrMap` is a single `tf.Tensor`,
 * a `tf.Tensor[]`, or a flat map from string names to `tf.Tensor`s.
 * @returns A flat array of `tf.Tensor` objects: the input `tf.Tensor`s
 *   followed by the target `tf.Tensor`s.  When `tf.Tensor`s are provided
 *   as a map, the order in the resulting array is taken from the `inputNames`
 *   and `outputNames` of the model.
 */ function $dba44742a80a59f8$var$standardizeDataIteratorOutput(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, iteratorOut) {
    let xs;
    let ys;
    const iteratorOutObj = iteratorOut;
    xs = iteratorOutObj['xs'];
    ys = iteratorOutObj['ys'];
    $lBDHD.assert(xs != null && ys != null, ()=>"A Dataset iterator for fitDataset() is expected to generate objects of the form `{xs: xVal, ys: yVal}`, where the two values may be `tf.Tensor`, an array of Tensors, or a map of string to Tensor.  The provided Dataset instead generates " + `${iteratorOut}`);
    const flattenedXs = $dba44742a80a59f8$var$flattenTensorOrArrayOrMap('input', model.inputNames, xs);
    const flattenedYs = $dba44742a80a59f8$var$flattenTensorOrArrayOrMap('output', model.outputNames, ys);
    const batchSize = flattenedXs[0].shape[0];
    $lBDHD.assert(flattenedXs.length === model.inputs.length, ()=>`LayersModel has ${model.inputs.length} inputs, but the dataset ` + `provides ${flattenedXs.length} inputs.  (Expected input keys: ` + `${JSON.stringify(model.inputNames)})`);
    $lBDHD.assert(flattenedYs.length === model.outputs.length, ()=>`LayersModel has ${model.outputs.length} outputs, but the dataset ` + `provides ${flattenedYs.length} outputs.  (Expected output keys: ` + `${JSON.stringify(model.outputNames)})`);
    for(let xIndex = 0; xIndex < flattenedXs.length; xIndex++)$lBDHD.assert(flattenedXs[xIndex].shape[0] === batchSize, ()=>`Batch size mismatch: input ` + `${model.inputNames[xIndex]} has ${flattenedXs[xIndex].shape[0]}; ` + `expected  ${batchSize} based on input ${model.inputNames[0]}.`);
    for(let yIndex = 0; yIndex < flattenedYs.length; yIndex++)$lBDHD.assert(flattenedYs[yIndex].shape[0] === batchSize, ()=>`Batch size mismatch: output ` + `${model.outputNames[yIndex]} has ${flattenedYs[yIndex].shape[0]}; ` + `expected  ${batchSize} based on input ${model.inputNames[0]}.`);
    return {
        xs: flattenedXs,
        ys: flattenedYs
    };
}
function $dba44742a80a59f8$var$flattenTensorOrArrayOrMap(inputOrOutput, names, values) {
    if (values instanceof $3pVUH.Tensor) return [
        values
    ];
    else if (Array.isArray(values)) {
        $lBDHD.assert(values.length === names.length, ()=>`Received an array of ${values.length} Tensors, but expected ${names.length} to match the ${inputOrOutput} keys ${names}.`);
        return values;
    } else {
        const result = [];
        // Check that all the required keys are available.
        for (const name of names){
            if (values[name] == null) throw new (0, $kubuc.ValueError)(`The feature data generated by the dataset lacks the required ` + `${inputOrOutput} key '${name}'.`);
            result.push(values[name]);
        }
        return result;
    }
}
function $dba44742a80a59f8$var$standardizeTensorValidationData(data) {
    if (data.length === 3) throw new (0, $kubuc.NotImplementedError)('Validation with sample weights is not implemented yet.');
    return {
        xs: data[0],
        ys: data[1]
    };
}
async function $dba44742a80a59f8$export$4e883c052383550c(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, dataset, args) {
    const hasBatchesPerEpoch = args.batchesPerEpoch != null;
    $lBDHD.assert(model.optimizer != null, ()=>"You must compile a model before training/testing. Use LayersModel.compile(modelCompileConfig).");
    $lBDHD.assert(args != null, ()=>`For fitDataset(), the 2nd argument (config) is required, ` + `but it is not provided in this call.`);
    $lBDHD.assert(args.epochs != null && args.epochs > 0 && Number.isInteger(args.epochs), ()=>`For fitDataset(), config.epochs is expected to be a positive ` + `integer, but got ${args.epochs}`);
    $lBDHD.assert(!hasBatchesPerEpoch || args.batchesPerEpoch > 0 && Number.isInteger(args.batchesPerEpoch), ()=>`For fitDataset(), config.batchesPerEpoch is expected to be a ` + `positive integer if specified, but got ${args.batchesPerEpoch}`);
    $lBDHD.assert(// tslint:disable-next-line:no-any
    args['validationSplit'] == null, ()=>"`validationSplit` is not supported by `fitDataset()`. Use validationData instead.");
    if (model.isTraining) throw new Error('Cannot start training because another fit() call is ongoing.');
    model.isTraining = true;
    try {
        const doValidation = args.validationData != null;
        let valXs;
        let valYs;
        if (doValidation) {
            if ($dba44742a80a59f8$var$isDatasetObject(args.validationData)) $lBDHD.assert(args.validationBatches == null || args.validationBatches > 0 && Number.isInteger(args.validationBatches), ()=>`For fitDataset() with dataset-based validation, ` + `config.validationBatches is expected not to be provided, ` + `or to be a positive integer, ` + `but got ${args.validationBatches}`);
            else {
                const validationData = $dba44742a80a59f8$var$standardizeTensorValidationData(args.validationData);
                valXs = validationData.xs;
                valYs = validationData.ys;
            }
        }
        const trainFunction = model.makeTrainFunction();
        const outLabels = model.getDedupedMetricsNames();
        let callbackMetrics;
        if (doValidation) callbackMetrics = outLabels.slice().concat(outLabels.map((n)=>'val_' + n));
        else callbackMetrics = outLabels.slice();
        const callbacks = (0, $801Oz.standardizeCallbacks)(args.callbacks, args.yieldEvery);
        const verbose = args.verbose == null ? 1 : args.verbose;
        const { callbackList: callbackList, history: history } = (0, $801Oz.configureCallbacks)(callbacks, verbose, args.epochs, null, null, $dba44742a80a59f8$var$getStepsPerEpoch(dataset, args), null, doValidation, callbackMetrics);
        callbackList.setModel(model);
        model.history = history;
        await callbackList.onTrainBegin();
        model.stopTraining_ = false;
        let epoch = args.initialEpoch == null ? 0 : args.initialEpoch;
        let dataIterator = await dataset.iterator();
        while(epoch < args.epochs){
            const epochLogs = {};
            await callbackList.onEpochBegin(epoch);
            let stepsDone = 0;
            let batchIndex = 0;
            if (!hasBatchesPerEpoch) dataIterator = await dataset.iterator();
            while(hasBatchesPerEpoch ? stepsDone < args.batchesPerEpoch : true){
                const iteratorOut = await dataIterator.next();
                // If `batchesPerEpoch` is specified, the dataset should not be
                // exhausted until all epoches are done.
                if (hasBatchesPerEpoch && iteratorOut.done) {
                    console.warn('You provided `batchesPerEpoch` as ' + `${args.batchesPerEpoch}, ` + 'but your dataset iterator ran out of data after ' + `${stepsDone} batches; ` + 'interrupting training. Make sure that your ' + 'dataset can generate at least `batchesPerEpoch * epochs` ' + 'batches (in this case, ' + `${args.batchesPerEpoch * args.epochs} batches). ` + 'You may need to use the repeat() function when building ' + 'your dataset.');
                    break;
                }
                if (iteratorOut.value != null) {
                    const { xs: xs, ys: ys } = $dba44742a80a59f8$var$standardizeDataIteratorOutput(model, iteratorOut.value);
                    const batchLogs = {};
                    batchLogs['batch'] = batchIndex;
                    batchLogs['size'] = xs[0].shape[0];
                    await callbackList.onBatchBegin(batchIndex, batchLogs);
                    const sampleWeights = [];
                    if (args.classWeight != null) {
                        const standardClassWeights = (0, $10YKi.standardizeClassWeights)(args.classWeight, model.outputNames);
                        for(let i = 0; i < standardClassWeights.length; ++i)sampleWeights.push(await (0, $10YKi.standardizeWeights)(ys[i], null, standardClassWeights[i]));
                    }
                    // Train on batch.
                    const ins = xs.concat(ys).concat(sampleWeights);
                    const outs = trainFunction(ins);
                    $d7Nxs.dispose(ins);
                    for(let i = 0; i < outLabels.length; ++i){
                        const label = outLabels[i];
                        const out = outs[i];
                        batchLogs[label] = out;
                        $d7Nxs.keep(out);
                    }
                    await callbackList.onBatchEnd(batchIndex, batchLogs);
                    (0, $lcd3O.disposeTensorsInLogs)(batchLogs);
                    batchIndex++;
                    stepsDone++;
                }
                if (hasBatchesPerEpoch ? stepsDone >= args.batchesPerEpoch : iteratorOut.done) {
                    // Epoch finished. Perform validation.
                    if (doValidation) {
                        let valOuts;
                        if ($dba44742a80a59f8$var$isDatasetObject(args.validationData)) valOuts = (0, $jYx5u.toList)(await model.evaluateDataset(args.validationData, {
                            batches: args.validationBatches
                        }));
                        else valOuts = (0, $jYx5u.toList)(model.evaluate(valXs, valYs, {
                            batchSize: args.validationBatchSize == null ? $dba44742a80a59f8$var$DEFAULT_VALIDATION_BATCH_SIZE : args.validationBatchSize,
                            verbose: 0
                        }));
                        for(let i = 0; i < model.metricsNames.length; ++i)epochLogs[`val_${model.metricsNames[i]}`] = valOuts[i];
                    }
                    break;
                }
                if (model.stopTraining_) break;
            }
            await callbackList.onEpochEnd(epoch, epochLogs);
            epoch++;
            if (model.stopTraining_) break;
        }
        await callbackList.onTrainEnd();
        await model.history.syncData();
        return model.history;
    } finally{
        model.isTraining = false;
    }
}
/** Helper function that determines number of steps (batches) per epoch. */ function $dba44742a80a59f8$var$getStepsPerEpoch(dataset, args) {
    // Attempt to determine # of batches in an epoch.
    let stepsPerEpoch = null;
    if (args.batchesPerEpoch != null) stepsPerEpoch = args.batchesPerEpoch;
    else if (Number.isFinite(dataset.size)) stepsPerEpoch = dataset.size;
    return stepsPerEpoch;
}
// Check if provided object is a Dataset object by checking its .iterator
// element.
function $dba44742a80a59f8$var$isDatasetObject(dataset) {
    return typeof dataset.iterator === 'function';
}
// Check if provided object is a LazyIterator object by checking it's .next
// element.
function $dba44742a80a59f8$var$isLazyIteratorObject(iterator) {
    return typeof iterator.next === 'function';
}
async function $dba44742a80a59f8$export$56e284faddc3ba42(// Type `model` as `any` here to avoid circular dependency w/
// training.ts.
// tslint:disable-next-line:no-any
model, dataset, args) {
    args = args || {};
    const hasBatches = args.batches != null;
    const f = model.testFunction;
    let outs = [];
    if (args.verbose > 0) throw new (0, $kubuc.NotImplementedError)('Verbose mode is not implemented yet.');
    $lBDHD.assert(!hasBatches || args.batches > 0 && Number.isInteger(args.batches), ()=>'Test loop expects `batches` to be a positive integer, but ' + `received ${JSON.stringify(args.batches)}`);
    const dataIterator = $dba44742a80a59f8$var$isLazyIteratorObject(dataset) ? dataset : await dataset.iterator();
    // Keeps track of number of examples used in this evaluation.
    let numExamples = 0;
    let batch = 0;
    while(hasBatches ? batch < args.batches : true){
        const iteratorOut = await dataIterator.next();
        outs = $d7Nxs.tidy(()=>{
            if (iteratorOut.value) {
                // TODO(cais): Once real dataset is available, use
                //   `map(x => standardizeDataIteratorOutput(model, x).map(f)`.
                const { xs: xs, ys: ys } = $dba44742a80a59f8$var$standardizeDataIteratorOutput(model, iteratorOut.value);
                const xsAndYs = xs.concat(ys);
                const batchOuts = $d7Nxs.tidy(()=>f(xsAndYs));
                $d7Nxs.dispose(xsAndYs);
                if (batch === 0) for(let i = 0; i < batchOuts.length; ++i)outs.push((0, $7hONX.scalar)(0));
                const batchSize = xsAndYs[0].shape[0];
                for(let i = 0; i < batchOuts.length; ++i){
                    const batchOut = batchOuts[i];
                    const oldScalar = outs[i];
                    outs[i] = $d7Nxs.tidy(()=>$6Ab5n.add(outs[i], $5hAos.mul(batchSize, batchOut)));
                    if (batch > 0) $d7Nxs.dispose(oldScalar);
                }
                $d7Nxs.dispose(batchOuts);
                numExamples += batchSize;
                ++batch;
            }
            return outs;
        });
        if (iteratorOut.done) {
            if (hasBatches) console.warn("Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least `batches` " + `batches (in this case, ${args.batches} batches). ` + 'You may need to use the repeat() function when building ' + 'your dataset.');
            break;
        }
    }
    for(let i = 0; i < outs.length; ++i){
        const oldScalar = outs[i];
        outs[i] = $dIChU.div(outs[i], numExamples);
        $d7Nxs.dispose(oldScalar);
    }
    return (0, $jYx5u.singletonOrArray)(outs);
}

});
parcelRegister("10YKi", function(module, exports) {

$parcel$export(module.exports, "standardizeClassWeights", function () { return $0bd4e96128630efc$export$9122f8f77cba9cbe; });
$parcel$export(module.exports, "standardizeWeights", function () { return $0bd4e96128630efc$export$cecca6094cb0d869; });
$parcel$export(module.exports, "computeWeightedLoss", function () { return $0bd4e96128630efc$export$23bdc4cea2e28782; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $kRlq3 = parcelRequire("kRlq3");
var $ek4FP = parcelRequire("ek4FP");
var $d7Nxs = parcelRequire("d7Nxs");
var $5hAos = parcelRequire("5hAos");
var $8nMOl = parcelRequire("8nMOl");
var $8tOOR = parcelRequire("8tOOR");
function $0bd4e96128630efc$var$standardizeSampleOrClassWeights(xWeight, outputNames, weightType) {
    const numOutputs = outputNames.length;
    if (xWeight == null || Array.isArray(xWeight) && xWeight.length === 0) return outputNames.map((name)=>null);
    if (numOutputs === 1) {
        if (Array.isArray(xWeight) && xWeight.length === 1) return xWeight;
        else if (typeof xWeight === 'object' && outputNames[0] in xWeight) return [
            xWeight[outputNames[0]]
        ];
        else return [
            xWeight
        ];
    }
    if (Array.isArray(xWeight)) {
        if (xWeight.length !== numOutputs) throw new Error(`Provided ${weightType} is an array of ${xWeight.length} ` + `element(s), but the model has ${numOutputs} outputs. ` + `Make sure a set of weights is provided for each model output.`);
        return xWeight;
    } else if (typeof xWeight === 'object' && Object.keys(xWeight).length > 0 && typeof xWeight[Object.keys(xWeight)[0]] === 'object') {
        const output = [];
        outputNames.forEach((outputName)=>{
            if (outputName in xWeight) output.push(xWeight[outputName]);
            else output.push(null);
        });
        return output;
    } else throw new Error(`The model has multiple (${numOutputs}) outputs, ` + `so ${weightType} must be either an array with ` + `${numOutputs} elements or an object with ${outputNames} keys. ` + `Provided ${weightType} not understood: ${JSON.stringify(xWeight)}`);
}
function $0bd4e96128630efc$export$9122f8f77cba9cbe(classWeight, outputNames) {
    return $0bd4e96128630efc$var$standardizeSampleOrClassWeights(classWeight, outputNames, 'classWeight');
}
function $0bd4e96128630efc$export$bcbbad49dddf28d(classWeight, outputNames) {
    return $0bd4e96128630efc$var$standardizeSampleOrClassWeights(classWeight, outputNames, 'sampleWeight');
}
async function $0bd4e96128630efc$export$cecca6094cb0d869(y, sampleWeight, classWeight, sampleWeightMode) {
    if (sampleWeight != null || sampleWeightMode != null) // TODO(cais): Once 'temporal' mode is implemented, document it in the doc
    // string.
    throw new Error('Support sampleWeight is not implemented yet');
    if (classWeight != null) {
        // Apply class weights per sample.
        const yClasses = (0, $d7Nxs.tidy)(()=>{
            if (y.shape.length === 1) // Assume class indices.
            return (0, $ek4FP.clone)(y);
            else if (y.shape.length === 2) {
                if (y.shape[1] > 1) {
                    // Assume one-hot encoding of classes.
                    const axis = 1;
                    return (0, $kRlq3.argMax)(y, axis);
                } else if (y.shape[1] === 1) // Class index.
                return (0, $8nMOl.reshape)(y, [
                    y.shape[0]
                ]);
                else throw new Error(`Encountered unexpected last-dimension size (${y.shape[1]}) ` + `during handling of class weights. The size is expected to be ` + `>= 1.`);
            } else throw new Error(`Unexpected rank of target (y) tensor (${y.rank}) during ` + `handling of class weights. The rank is expected to be 1 or 2.`);
        });
        const yClassIndices = Array.from(await yClasses.data());
        (0, $d7Nxs.dispose)(yClasses);
        const classSampleWeight = [];
        yClassIndices.forEach((classIndex)=>{
            if (classWeight[classIndex] == null) throw new Error(`classWeight must contain all classes in the training data. ` + `The class ${classIndex} exists in the data but not in ` + `classWeight`);
            else classSampleWeight.push(classWeight[classIndex]);
        });
        return (0, $8tOOR.tensor1d)(classSampleWeight, 'float32');
    } else return null;
}
function $0bd4e96128630efc$export$23bdc4cea2e28782(losses, sampleWeights) {
    return (0, $5hAos.mul)(losses, sampleWeights);
}

});


parcelRegister("a7zeb", function(module, exports) {

$parcel$export(module.exports, "checkBatchSize", function () { return $75e5e251417a1086$export$2f80f09f3b9f932e; });
$parcel$export(module.exports, "sliceArrays", function () { return $75e5e251417a1086$export$45b6cbb437b1b016; });
$parcel$export(module.exports, "sliceArraysByIndices", function () { return $75e5e251417a1086$export$4a7d2c6b9b0d590; });
$parcel$export(module.exports, "makeBatches", function () { return $75e5e251417a1086$export$7ce16f2471062005; });
$parcel$export(module.exports, "ensureTensorsRank2OrHigher", function () { return $75e5e251417a1086$export$b2d45309fc343ee1; });
$parcel$export(module.exports, "disposeNewTensors", function () { return $75e5e251417a1086$export$55dac70a20481db3; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Interfaces and methods for training models using tf.Tensor objects.
 */ parcelRequire("8AHkS");
var $fxiHg = parcelRequire("fxiHg");
var $3pVUH = parcelRequire("3pVUH");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $4AyI5 = parcelRequire("4AyI5");
function $75e5e251417a1086$export$2f80f09f3b9f932e(batchSize) {
    $lBDHD.assert(batchSize > 0 && Number.isInteger(batchSize), ()=>`batchSize is required to be a positive integer, but got ${batchSize}`);
}
function $75e5e251417a1086$export$45b6cbb437b1b016(arrays, start, stop) {
    if (arrays == null) return [
        null
    ];
    else if (Array.isArray(arrays)) return arrays.map((array)=>(0, $4AyI5.sliceAlongFirstAxis)(array, start, stop - start));
    else return (0, $4AyI5.sliceAlongFirstAxis)(arrays, start, stop - start);
}
function $75e5e251417a1086$export$4a7d2c6b9b0d590(arrays, indices) {
    return $d7Nxs.tidy(()=>{
        if (arrays == null) return null;
        else if (Array.isArray(arrays)) return arrays.map((array)=>$75e5e251417a1086$export$4a7d2c6b9b0d590(array, indices));
        else // TODO(cais): indices should be a pre-constructed Tensor1D to avoid
        //   tensor1d() calls.
        return (0, $4AyI5.gather)(arrays, indices.dtype === 'int32' ? indices : $fxiHg.cast(indices, 'int32'));
    });
}
function $75e5e251417a1086$export$7ce16f2471062005(size, batchSize) {
    const output = [];
    let batchStart = 0;
    let batchEnd = null;
    while(batchStart < size){
        batchEnd = batchStart + batchSize;
        if (batchEnd >= size) batchEnd = size;
        output.push([
            batchStart,
            batchEnd
        ]);
        batchStart = batchEnd;
    }
    return output;
}
function $75e5e251417a1086$export$b2d45309fc343ee1(tensors) {
    const outs = [];
    if (tensors instanceof (0, $3pVUH.Tensor)) tensors = [
        tensors
    ];
    // Make Tensors at least 2D.
    for(let i = 0; i < tensors.length; ++i){
        const tensor = tensors[i];
        if (tensor.rank === 1) outs.push((0, $4AyI5.expandDims)(tensor, 1));
        else if (tensor.rank === 0) throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");
        else outs.push(tensor);
    }
    return outs;
}
function $75e5e251417a1086$export$55dac70a20481db3(tensors, refTensors) {
    if (tensors == null) return;
    const oldTensorIds = [];
    if (refTensors instanceof (0, $3pVUH.Tensor)) oldTensorIds.push(refTensors.id);
    else if (Array.isArray(refTensors)) refTensors.forEach((t)=>oldTensorIds.push(t.id));
    else if (refTensors != null) // `oldTensors` is a map from string name to Tensor.
    for(const name in refTensors){
        const oldTensor = refTensors[name];
        oldTensorIds.push(oldTensor.id);
    }
    const tensorsToDispose = [];
    if (tensors instanceof (0, $3pVUH.Tensor)) {
        if (oldTensorIds.indexOf(tensors.id) === -1) tensorsToDispose.push(tensors);
    } else if (Array.isArray(tensors)) tensors.forEach((t)=>{
        if (oldTensorIds.indexOf(t.id) === -1) tensorsToDispose.push(t);
    });
    else if (tensors != null) // `oldTensors` is a map from string name to Tensor.
    for(const name in tensors){
        const tensor = tensors[name];
        if (oldTensorIds.indexOf(tensor.id) === -1) tensorsToDispose.push(tensor);
    }
    tensorsToDispose.forEach((t)=>{
        if (!t.isDisposed) t.dispose();
    });
}

});


parcelRegister("1dKdw", function(module, exports) {

$parcel$export(module.exports, "loadLayersModel", function () { return $0e3adb164342c490$export$f379ad49c680b84a; });
$parcel$export(module.exports, "Sequential", function () { return $0e3adb164342c490$export$a77f6a295a72306; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source keras/models.py */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");
var $feqcJ = parcelRequire("feqcJ");
var $ki3lz = parcelRequire("ki3lz");
var $lBDHD = parcelRequire("lBDHD");

var $cExd6 = parcelRequire("cExd6");

var $lusky = parcelRequire("lusky");

var $jWpeh = parcelRequire("jWpeh");

var $czFC2 = parcelRequire("czFC2");

var $kubuc = parcelRequire("kubuc");

var $4v3Le = parcelRequire("4v3Le");

var $jYx5u = parcelRequire("jYx5u");

var $3r0Ja = parcelRequire("3r0Ja");

var $bMNfZ = parcelRequire("bMNfZ");
async function $0e3adb164342c490$export$6e76de3ed4e5bd6a(modelAndWeightsConfig, customObjects) {
    if (!('modelTopology' in modelAndWeightsConfig)) modelAndWeightsConfig = {
        modelTopology: modelAndWeightsConfig
    };
    modelAndWeightsConfig;
    let modelTopology = modelAndWeightsConfig.modelTopology;
    if (modelTopology['model_config'] != null) // If the model-topology JSON contains a 'model_config' field, then it is
    // a full model JSON (e.g., from `keras.Model.save()`), which contains
    // not only the model's architecture in its 'model_config' field, but
    // additional information such as the model's optimizer. We use only the
    // 'model_config' field currently.
    modelTopology = modelTopology['model_config'];
    const tsConfig = (0, $3r0Ja.convertPythonicToTs)(modelTopology);
    const model = (0, $4v3Le.deserialize)(tsConfig, customObjects);
    if (modelAndWeightsConfig.weightsManifest != null) {
        // Load the weight values keyed by the original tensor names in the model
        // file that was loaded.  These should match the keys of the weight
        // manifest.
        const weightValues = await (0, $feqcJ).loadWeights(modelAndWeightsConfig.weightsManifest, modelAndWeightsConfig.pathPrefix, model.weights.map((weight)=>weight.originalName));
        // Map the weights to the unique tensor names generated during model loading
        const uniqueWeightValues = {};
        for (const weight of model.weights)uniqueWeightValues[weight.originalName] = weightValues[weight.originalName];
        model.loadWeights(uniqueWeightValues);
        // Dispose temporary weight values.
        (0, $d7Nxs.dispose)(weightValues);
    }
    return model;
}
async function $0e3adb164342c490$export$f379ad49c680b84a(pathOrIOHandler, options) {
    if (options == null) options = {};
    if (typeof pathOrIOHandler === 'string') {
        const handlers = (0, $feqcJ).getLoadHandlers(pathOrIOHandler, options);
        if (handlers.length === 0) // For backward compatibility: if no load handler can be found,
        // assume it is a relative http path.
        // TODO(cais): Reformat the args into a single `LoadOptions` once the core
        // is refactored.
        handlers.push((0, $feqcJ).browserHTTPRequest(pathOrIOHandler, options));
        else if (handlers.length > 1) throw new (0, $kubuc.ValueError)(`Found more than one (${handlers.length}) load handlers for ` + `URL '${pathOrIOHandler}'`);
        pathOrIOHandler = handlers[0];
    }
    return $0e3adb164342c490$export$fe68a3692f105118(pathOrIOHandler, undefined, options);
}
async function $0e3adb164342c490$export$fe68a3692f105118(handler, customObjects, options) {
    if (options == null) options = {};
    if (handler.load == null) throw new (0, $kubuc.ValueError)("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
    const artifacts = await handler.load();
    let modelTopology = artifacts.modelTopology;
    if (modelTopology['model_config'] != null) modelTopology = modelTopology['model_config'];
    const strict = options.strict == null ? true : options.strict;
    // If weights are provided and the weight-loading mode is strict, use
    // fast weight initialization. This skips costly initializers such as
    // 'orthogonal' and saves unnecessary computation in cases where
    // the initialized weight values will immediately be overwritten by
    // loaded weight values.
    const fastWeightInit = artifacts.weightData != null && artifacts.weightSpecs != null && strict;
    const model = (0, $4v3Le.deserialize)((0, $3r0Ja.convertPythonicToTs)(modelTopology), customObjects, fastWeightInit);
    const trainingConfig = artifacts.trainingConfig;
    if (trainingConfig != null) model.loadTrainingConfig(trainingConfig);
    if (artifacts.userDefinedMetadata != null) model.setUserDefinedMetadata(artifacts.userDefinedMetadata);
    // If weightData is present, load the weights into the model.
    if (artifacts.weightData != null) {
        // Loading weights requires weightSpecs.
        if (artifacts.weightSpecs == null) throw new (0, $kubuc.ValueError)("LayersModel artifacts contains weight data, but not weight specs. Therefore loading of weights cannot proceed.");
        const { modelWeights: modelWeights, optimizerWeights: optimizerWeights } = $0e3adb164342c490$var$decodeModelAndOptimizerWeights(artifacts.weightData, artifacts.weightSpecs);
        model.loadWeights(modelWeights, strict);
        if (model.optimizer != null && optimizerWeights.length > 0) await model.optimizer.setWeights(optimizerWeights);
        // Dispose temporary weight values.
        (0, $d7Nxs.dispose)(modelWeights);
        (0, $d7Nxs.dispose)(optimizerWeights.map((w)=>w.tensor));
    }
    return model;
}
function $0e3adb164342c490$var$decodeModelAndOptimizerWeights(weightData, specs) {
    const name2Tensor = (0, $feqcJ).decodeWeights(weightData, specs);
    const modelWeights = {};
    const optimizerWeights = [];
    specs.forEach((spec)=>{
        if (spec.group === 'optimizer') optimizerWeights.push({
            name: spec.name,
            tensor: name2Tensor[spec.name]
        });
        else modelWeights[spec.name] = name2Tensor[spec.name];
    });
    return {
        modelWeights: modelWeights,
        optimizerWeights: optimizerWeights
    };
}
/**
 * A model with a stack of layers, feeding linearly from one to the next.
 *
 * `tf.sequential` is a factory function that creates an instance of
 * `tf.Sequential`.
 *
 * ```js
 *  // Define a model for linear regression.
 *  const model = tf.sequential();
 *  model.add(tf.layers.dense({units: 1, inputShape: [1]}));
 *
 *  // Prepare the model for training: Specify the loss and the optimizer.
 *  model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
 *
 *  // Generate some synthetic data for training.
 *  const xs = tf.tensor2d([1, 2, 3, 4], [4, 1]);
 *  const ys = tf.tensor2d([1, 3, 5, 7], [4, 1]);
 *
 *  // Train the model using the data then do inference on a data point the
 *  // model hasn't seen:
 *  await model.fit(xs, ys);
 *  model.predict(tf.tensor2d([5], [1, 1])).print();
 * ```
 *
 * @doc {heading: 'Models', subheading: 'Classes'}
 */ class $0e3adb164342c490$export$a77f6a295a72306 extends (0, $czFC2.LayersModel) {
    constructor(args){
        super({
            inputs: [],
            outputs: []
        });
        args = args || {};
        this.trainable = true;
        this.built = false;
        // Set model name.
        this.name = args.name != null ? args.name : (0, $cExd6.getUid)('sequential_');
        // Add to the model any layers passed to the constructor.
        if (args.layers != null) for (const layer of args.layers)this.add(layer);
    }
    // Helper function to Sequential.add  Throws if the new output shape will be
    // invalid.
    checkShape(layer) {
        const shape = layer.inboundNodes[0].outputTensors[0].shape;
        if (shape.some((x)=>x < 0)) throw new (0, $kubuc.ValueError)('Negative dimension size caused by adding layer ' + `${layer.name} with input shape [` + `${layer.inboundNodes[0].inputTensors[0].shape}]`);
    }
    /**
     * Adds a layer instance on top of the layer stack.
     *
     * ```js
     *  const model = tf.sequential();
     *  model.add(tf.layers.dense({units: 8, inputShape: [1]}));
     *  model.add(tf.layers.dense({units: 4, activation: 'relu6'}));
     *  model.add(tf.layers.dense({units: 1, activation: 'relu6'}));
     *  // Note that the untrained model is random at this point.
     *  model.predict(tf.randomNormal([10, 1])).print();
     * ```
     * @param layer Layer instance.
     *
     * @exception ValueError In case the `layer` argument does not know its
     * input shape.
     * @exception ValueError In case the `layer` argument has multiple output
     *   tensors, or is already connected somewhere else (forbidden in
     *   `Sequential` models).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ add(layer) {
        const isLayerModelInstance = layer instanceof $0e3adb164342c490$export$a77f6a295a72306 || layer instanceof (0, $czFC2.LayersModel);
        let modelLayer;
        if (isLayerModelInstance) {
            modelLayer = layer;
            if (modelLayer.outputs.length !== 1) throw new (0, $kubuc.ValueError)("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            if (modelLayer.inputs.length !== 1) throw new (0, $kubuc.ValueError)("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.");
        }
        if (this.outputs.length === 0) {
            // first layer in model: check that it is an input layer
            if (layer.inboundNodes.length === 0) {
                // create an input layer
                if (layer.batchInputShape == null) throw new (0, $kubuc.ValueError)("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");
                // Instantiate the input layer.
                const x = (0, $lusky.Input)({
                    batchShape: layer.batchInputShape,
                    dtype: layer.dtype,
                    name: layer.name + '_input'
                });
                // This will build the current layer and create the node connecting
                // the current layer to the input layer we just created.
                layer.apply(x);
            }
            if (isLayerModelInstance) {
                this.outputs = modelLayer.outputs;
                this.inputs = modelLayer.inputs;
            } else {
                if (layer.inboundNodes.length !== 1) throw new (0, $kubuc.ValueError)('A layer added to a Sequential model must not already be ' + `connected somewhere else. LayersModel received layer ${layer.name} ` + `which has ${layer.inboundNodes.length} pre-existing inbound ` + 'connections.');
                if (layer.inboundNodes[0].outputTensors.length !== 1) throw new (0, $kubuc.ValueError)("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
                this.checkShape(layer);
                this.outputs = [
                    layer.inboundNodes[0].outputTensors[0]
                ];
                this.inputs = (0, $jWpeh.getSourceInputs)(this.outputs[0]);
            }
            this.inboundNodes = [];
            // We create an input node, which we will keep updated
            // as we add more layers.
            // (This call has side effects.)
            // tslint:disable-next-line:no-unused-expression
            new (0, $jWpeh.Node)({
                outboundLayer: this,
                inboundLayers: [],
                nodeIndices: [],
                tensorIndices: [],
                inputTensors: this.inputs,
                outputTensors: this.outputs,
                // no model-level masking for now
                inputMasks: $jYx5u.pyListRepeat(null, this.inputs.length),
                outputMasks: [
                    null
                ],
                inputShapes: this.inputs.map((x)=>x.shape),
                outputShapes: this.outputs[0].shape
            });
        } else {
            const outputTensor = layer.apply(this.outputs[0]);
            if (Array.isArray(outputTensor)) throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            this.checkShape(layer);
            this.outputs = [
                outputTensor
            ];
            // update self.inbound_nodes
            this.inboundNodes[0].outputTensors = this.outputs;
            this.inboundNodes[0].outputShapes = [
                this.outputs[0].shape
            ];
        }
        this.layers.push(layer);
        this.built = false;
    }
    /**
     * Removes the last layer in the model.
     *
     * @exception TypeError if there are no layers in the model.
     */ pop() {
        if (this.layers.length === 0) throw new TypeError('There are no layers in the model.');
        this.layers.pop();
        if (this.layers.length === 0) {
            this.outputs = [];
            this.inboundNodes = [];
            this.outboundNodes = [];
        } else {
            const lastLayerIndex = this.layers.length - 1;
            this.layers[lastLayerIndex].outboundNodes = [];
            this.outputs = [
                this.layers[lastLayerIndex].output
            ];
            // update self.inbound_nodes
            this.inboundNodes[0].outputTensors = this.outputs;
            this.inboundNodes[0].outputShapes = [
                this.outputs[0].shape
            ];
        }
    }
    call(inputs, kwargs) {
        if (this.model == null) this.build();
        return this.model.call(inputs, kwargs);
    }
    build(inputShape) {
        // Call `getExactlyOneShape` without using its return value,
        // to verify that exactly one input shape is provided.
        (0, $bMNfZ.getExactlyOneShape)(inputShape);
        if (this.inputs.length === 0 || this.outputs.length === 0) throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");
        // actually create the model
        this.model = new (0, $czFC2.LayersModel)({
            inputs: this.inputs,
            outputs: this.outputs[0],
            name: this.name + '_model'
        });
        this.model.trainable = this.trainable;
        // mirror model attributes
        this.supportsMasking = this.model.supportsMasking;
        // TODO(michaelterry): Add caches
        this.inputLayers = this.model.inputLayers;
        this.inputLayersNodeIndices = this.model.inputLayersNodeIndices;
        this.inputLayersTensorIndices = this.model.inputLayersTensorIndices;
        this.outputLayers = this.model.outputLayers;
        this.outputLayersNodeIndices = this.model.outputLayersNodeIndices;
        this.outputLayersTensorIndices = this.model.outputLayersTensorIndices;
        this.nodesByDepth = this.model.nodesByDepth;
        this.containerNodes = this.model.containerNodes;
        this.outputNames = this.model.outputNames;
        this.inputNames = this.model.inputNames;
        // TODO(michaelterry): Add feedInputNames, feedInputs, if needed.
        // TODO(michaelterry): Add callbackModel if needed.
        this.built = true;
    }
    countParams() {
        if (!this.built) this.build();
        return super.countParams();
    }
    /**
     * Print a text summary of the Sequential model's layers.
     *
     * The summary includes
     * - Name and type of all layers that comprise the model.
     * - Output shape(s) of the layers
     * - Number of weight parameters of each layer
     * - The total number of trainable and non-trainable parameters of the
     * model.
     *
     * ```js
     * const model = tf.sequential();
     * model.add(
     *     tf.layers.dense({units: 100, inputShape: [10], activation: 'relu'}));
     * model.add(tf.layers.dense({units: 1, activation: 'sigmoid'}));
     *
     * model.summary();
     * ```
     *
     * @param lineLength Custom line length, in number of characters.
     * @param positions Custom widths of each of the columns, as either
     *   fractions of `lineLength` (e.g., `[0.5, 0.75, 1]`) or absolute number
     *   of characters (e.g., `[30, 50, 65]`). Each number corresponds to
     *   right-most (i.e., ending) position of a column.
     * @param printFn Custom print function. Can be used to replace the default
     *   `console.log`. For example, you can use `x => {}` to mute the printed
     *   messages in the console.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ summary(lineLength, positions, printFn = console.log) {
        if (!this.built) this.build();
        super.summary(lineLength, positions, printFn);
    }
    /**
     * Sets the weights of the model.
     *
     * @param weights Should be a list of Tensors with shapes and types matching
     *   the output of `model.getWeights()`.
     */ setWeights(weights) {
        if (this.model == null) this.build();
        this.model.setWeights(weights);
    }
    /**
     * Returns the loss value & metrics values for the model in test mode.
     *
     * Loss and metrics are specified during `compile()`, which needs to happen
     * before calls to `evaluate()`.
     *
     * Computation is done in batches.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const result = model.evaluate(tf.ones([8, 10]), tf.ones([8, 1]), {
     *   batchSize: 4,
     * });
     * result.print();
     * ```
     *
     * @param x `tf.Tensor` of test data, or an `Array` of `tf.Tensor`s if the
     * model has multiple inputs.
     * @param y `tf.Tensor` of target data, or an `Array` of `tf.Tensor`s if the
     * model has multiple outputs.
     * @param args A `ModelEvaluateConfig`, containing optional fields.
     *
     * @return `Scalar` test loss (if the model has a single output and no
     *   metrics) or `Array` of `Scalar`s (if the model has multiple outputs
     *   and/or metrics). The attribute `model.metricsNames`
     *   will give you the display labels for the scalar outputs.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ evaluate(x, y, args = {}) {
        if (!this.built) throw new (0, $kubuc.RuntimeError)('The model needs to be compiled before being used.');
        return this.model.evaluate(x, y, args);
    }
    // TODO(cais): Add code snippet below once real dataset objects are
    //   available.
    /**
     * Evaluate model using a dataset object.
     *
     * Note: Unlike `evaluate()`, this method is asynchronous (`async`).
     *
     * @param dataset A dataset object. Its `iterator()` method is expected
     *   to generate a dataset iterator object, the `next()` method of which
     *   is expected to produce data batches for evaluation. The return value
     *   of the `next()` call ought to contain a boolean `done` field and a
     *   `value` field. The `value` field is expected to be an array of two
     *   `tf.Tensor`s or an array of two nested `tf.Tensor` structures. The former
     *   case is for models with exactly one input and one output (e.g.
     *   a sequential model). The latter case is for models with multiple
     *   inputs and/or multiple outputs. Of the two items in the array, the
     *   first is the input feature(s) and the second is the output target(s).
     * @param args A configuration object for the dataset-based evaluation.
     * @returns Loss and metric values as an Array of `Scalar` objects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async evaluateDataset(dataset, args) {
        if (!this.built) throw new (0, $kubuc.RuntimeError)('The model needs to be compiled before being used.');
        return this.model.evaluateDataset(dataset, args);
    }
    /**
     * Generates output predictions for the input samples.
     *
     * Computation is done in batches.
     *
     * Note: the "step" mode of predict() is currently not supported.
     *   This is because the TensorFlow.js core backend is imperative only.
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.predict(tf.ones([2, 10])).print();
     * ```
     *
     * @param x The input data, as a Tensor, or an `Array` of `tf.Tensor`s if
     *   the model has multiple inputs.
     * @param conifg A `ModelPredictConfig` object containing optional fields.
     *
     * @return `tf.Tensor`(s) of predictions.
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and the model's expectations, or in case a stateful model receives a
     *   number of samples that is not a multiple of the batch size.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(x, args = {}) {
        if (this.model == null) this.build();
        return this.model.predict(x, args);
    }
    /**
     * Returns predictions for a single batch of samples.
     *
     * @param x: Input samples, as a Tensor, or list of Tensors (if the model
     *   has multiple inputs).
     * @return Tensor(s) of predictions
     */ predictOnBatch(x) {
        if (this.model == null) this.build();
        return this.model.predictOnBatch(x);
    }
    /**
     * See `LayersModel.compile`.
     *
     * @param args
     */ compile(args) {
        this.build();
        this.model.compile(args);
        this.optimizer_ = this.model.optimizer;
        // tslint:disable-next-line:no-any
        this.isOptimizerOwned = this.model.isOptimizerOwned;
        this.loss = this.model.loss;
        this.metrics = this.model.metrics;
        // TODO(cais): Add this.lossWeights, this.sampleWeightMode,
        //   this.weightedMetrics, this.targets.
        this.metricsTensors = this.model.metricsTensors;
        this.metricsNames = this.model.metricsNames;
    // TODO(cais): Add sampleWeights.
    }
    get optimizer() {
        return this.model == null ? undefined : this.model.optimizer;
    }
    set optimizer(optimizer) {
        this.model.optimizer = optimizer;
    }
    /**
     * Trains the model for a fixed number of epochs (iterations on a dataset).
     *
     * ```js
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [10]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const history = await model.fit(tf.ones([8, 10]), tf.ones([8, 1]), {
     *   batchSize: 4,
     *   epochs: 3
     * });
     * console.log(history.history.loss[0]);
     * ```
     *
     * @param x `tf.Tensor` of training data, or an array of `tf.Tensor`s if the
     * model has multiple inputs. If all inputs in the model are named, you can
     * also pass a dictionary mapping input names to `tf.Tensor`s.
     * @param y `tf.Tensor` of target (label) data, or an array of `tf.Tensor`s if
     * the model has multiple outputs. If all outputs in the model are named, you
     *  can also pass a dictionary mapping output names to `tf.Tensor`s.
     * @param args  A `ModelFitConfig`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @exception ValueError In case of mismatch between the provided input data
     *   and what the model expects.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async fit(x, y, args = {}) {
        if (!this.built) throw new (0, $kubuc.RuntimeError)("The model needs to be compiled before being used.");
        return this.model.fit(x, y, args);
    }
    /**
     * Trains the model using a dataset object.
     *
     * ```js
     * const xArray = [
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     *   [1, 1, 1, 1, 1, 1, 1, 1, 1],
     * ];
     * const yArray = [1, 1, 1, 1];
     * // Create a dataset from the JavaScript array.
     * const xDataset = tf.data.array(xArray);
     * const yDataset = tf.data.array(yArray);
     * // Zip combines the `x` and `y` Datasets into a single Dataset, the
     * // iterator of which will return an object containing of two tensors,
     * // corresponding to `x` and `y`.  The call to `batch(4)` will bundle
     * // four such samples into a single object, with the same keys now pointing
     * // to tensors that hold 4 examples, organized along the batch dimension.
     * // The call to `shuffle(4)` causes each iteration through the dataset to
     * // happen in a different order.  The size of the shuffle window is 4.
     * const xyDataset = tf.data.zip({xs: xDataset, ys: yDataset})
     *     .batch(4)
     *     .shuffle(4);
     * const model = tf.sequential({
     *   layers: [tf.layers.dense({units: 1, inputShape: [9]})]
     * });
     * model.compile({optimizer: 'sgd', loss: 'meanSquaredError'});
     * const history = await model.fitDataset(xyDataset, {
     *   epochs: 4,
     *   callbacks: {onEpochEnd: (epoch, logs) => console.log(logs.loss)}
     * });
     * ```
     *
     * @param dataset A dataset object. Its `iterator()` method is expected to
     *   generate a dataset iterator object, the `next()` method of which is
     *   expected to produce data batches for evaluation. The return value of the
     *   `next()` call ought to contain a boolean `done` field and a `value`
     *   field.
     *
     *   The `value` field is expected to be an object of with fields
     *   `xs` and `ys`, which point to the feature tensor and the target tensor,
     *   respectively. This case is for models with exactly one input and one
     *   output (e.g. a sequential model). For example:
     *   ```js
     *   {value: {xs: xsTensor, ys: ysTensor}, done: false}
     *   ```
     *
     *   If the model has multiple inputs, the `xs` field of `value` should
     *   be an object mapping input names to their respective feature tensors.
     *   For example:
     *   ```js
     *   {
     *     value: {
     *       xs: {
     *         input_1: xsTensor1,
     *         input_2: xsTensor2
     *       },
     *       ys: ysTensor
     *     },
     *     done: false
     *   }
     *   ```
     *   If the model has multiple outputs, the `ys` field of `value` should
     *   be an object mapping output names to their respective target tensors.
     *   For example:
     *   ```js
     *   {
     *     value: {
     *       xs: xsTensor,
     *       ys: {
     *         output_1: ysTensor1,
     *         output_2: ysTensor2
     *       },
     *     },
     *     done: false
     *   }
     *   ```
     * @param args A `ModelFitDatasetArgs`, containing optional fields.
     *
     * @return A `History` instance. Its `history` attribute contains all
     *   information collected during training.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async fitDataset(dataset, args) {
        if (!this.built) throw new (0, $kubuc.RuntimeError)("The model needs to be compiled before being used.");
        return this.model.fitDataset(dataset, args);
    }
    /**
     * Runs a single gradient update on a single batch of data.
     *
     * This method differs from `fit()` and `fitDataset()` in the following
     * regards:
     *   - It operates on exactly one batch of data.
     *   - It returns only the loss and metric values, instead of
     *     returning the batch-by-batch loss and metric values.
     *   - It doesn't support fine-grained options such as verbosity and
     *     callbacks.
     *
     * @param x Input data. It could be one of the following:
     *   - A `tf.Tensor`, or an Array of `tf.Tensor`s (in case the model has
     *     multiple inputs).
     *   - An Object mapping input names to corresponding `tf.Tensor` (if the
     *     model has named inputs).
     * @param y Target data. It could be either a `tf.Tensor` or multiple
     *   `tf.Tensor`s. It should be consistent with `x`.
     * @returns Training loss or losses (in case the model has
     *   multiple outputs), along with metrics (if any), as numbers.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async trainOnBatch(x, y) {
        return this.model.trainOnBatch(x, y);
    }
    /* See parent class for JsDoc */ /** @nocollapse */ static fromConfig(cls, config, customObjects = {}, fastWeightInit = false) {
        let configArray;
        let extraModelConfig = {};
        if (config instanceof Array) {
            if (!(config[0].className != null) || config[0]['className'] === 'Merge') throw new (0, $kubuc.ValueError)('Legacy serialization format not supported yet.');
            configArray = config;
        } else {
            (0, $lBDHD).assert(config['layers'] != null, ()=>`When the config data for a Sequential model is not an Array, ` + `it must be an Object that contains the 'layers' field.`);
            configArray = config['layers'];
            delete config['layers'];
            extraModelConfig = config;
        }
        const model = new cls(extraModelConfig);
        if (!(model instanceof $0e3adb164342c490$export$a77f6a295a72306)) throw new (0, $kubuc.NotImplementedError)(`Sequential.fromConfig called on non-Sequential input: ${model}`);
        for (const conf of configArray){
            const customObjects = undefined;
            const layer = (0, $4v3Le.deserialize)(conf, customObjects, fastWeightInit);
            if (fastWeightInit) layer.setFastWeightInitDuringBuild(true);
            model.add(layer);
        }
        return model;
    }
    /**
     * Setter used for force stopping of LayersModel.fit() (i.e., training).
     *
     * Example:
     *
     * ```js
     * const model = tf.sequential();
     * model.add(tf.layers.dense({units: 1, inputShape: [10]}));
     * model.compile({loss: 'meanSquaredError', optimizer: 'sgd'});
     * const xs = tf.ones([8, 10]);
     * const ys = tf.zeros([8, 1]);
     *
     * const history = await model.fit(xs, ys, {
     *   epochs: 10,
     *   callbacks: {
     *     onEpochEnd: async (epoch, logs) => {
     *       if (epoch === 2) {
     *         model.stopTraining = true;
     *       }
     *     }
     *   }
     * });
     *
     * // There should be only 3 values in the loss array, instead of 10 values,
     * // due to the stopping after 3 epochs.
     * console.log(history.history.loss);
     * ```
     */ set stopTraining(stop) {
        // TODO(cais): When refactoring to remove the composition pattern happens,
        // remove this method overriding.
        if (this.model == null) throw new (0, $kubuc.ValueError)("Cannot set the stopTraining property of a sequential model before it is compiled.");
        this.model.stopTraining = stop;
    }
    get stopTraining() {
        if (this.model == null) throw new (0, $kubuc.ValueError)("Cannot get the stopTraining property of a sequential model before it is compiled.");
        return this.model.stopTraining;
    }
    // TODO(cais): Override get trainableWeights() here
    // tslint:disable-next-line:no-any
    getConfig() {
        // NOTE(cais): We override the return type of getConfig() to `any` here,
        //   because the `Sequential` class is a special case among `Container`
        //   subtypes in that its getConfig() method returns an Array (not a
        //   dict).
        const layers = [];
        for (const layer of this.layers){
            const dict = {};
            dict['className'] = layer.getClassName();
            dict['config'] = layer.getConfig();
            layers.push(dict);
        }
        return {
            name: this.name,
            layers: layers
        };
    }
}
/** @nocollapse */ $0e3adb164342c490$export$a77f6a295a72306.className = 'Sequential';
(0, $ki3lz).registerClass($0e3adb164342c490$export$a77f6a295a72306);

});


parcelRegister("b99dv", function(module, exports) {

$parcel$export(module.exports, "ReLU", function () { return $81d7af40dec059cf$export$b6bead732c285ccc; });
$parcel$export(module.exports, "LeakyReLU", function () { return $81d7af40dec059cf$export$aef2e2f253bc592f; });
$parcel$export(module.exports, "PReLU", function () { return $81d7af40dec059cf$export$e8f536be4d0c9e9f; });
$parcel$export(module.exports, "ELU", function () { return $81d7af40dec059cf$export$945a5ccf96adb3b2; });
$parcel$export(module.exports, "ThresholdedReLU", function () { return $81d7af40dec059cf$export$e0ad929c946d21d1; });
$parcel$export(module.exports, "Softmax", function () { return $81d7af40dec059cf$export$350a526055d3ca6e; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 *  Advanced activation layers.
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $fxiHg = parcelRequire("fxiHg");
var $iAQYk = parcelRequire("iAQYk");
var $4YAd3 = parcelRequire("4YAd3");
var $1lCoz = parcelRequire("1lCoz");
var $lOlhm = parcelRequire("lOlhm");
var $kFoUG = parcelRequire("kFoUG");
var $1UrMu = parcelRequire("1UrMu");
var $5hAos = parcelRequire("5hAos");
var $K2k22 = parcelRequire("K2k22");
var $8b5dq = parcelRequire("8b5dq");
var $aQaR3 = parcelRequire("aQaR3");
var $7hONX = parcelRequire("7hONX");
var $ki3lz = parcelRequire("ki3lz");
var $5jGN9 = parcelRequire("5jGN9");
var $d7Nxs = parcelRequire("d7Nxs");

var $5xdqh = parcelRequire("5xdqh");

var $ghUz9 = parcelRequire("ghUz9");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $1NdPD = parcelRequire("1NdPD");

var $bMNfZ = parcelRequire("bMNfZ");
class $81d7af40dec059cf$export$b6bead732c285ccc extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.supportsMasking = true;
        if (args != null) this.maxValue = args.maxValue;
    }
    call(inputs, kwargs) {
        inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
        let output = (0, $aQaR3.relu)(inputs);
        if (this.maxValue != null) output = (0, $iAQYk.clipByValue)(output, 0, this.maxValue);
        return output;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            maxValue: this.maxValue
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $81d7af40dec059cf$export$b6bead732c285ccc.className = 'ReLU';
(0, $ki3lz).registerClass($81d7af40dec059cf$export$b6bead732c285ccc);
class $81d7af40dec059cf$export$aef2e2f253bc592f extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA = 0.3;
        if (args == null) args = {};
        this.alpha = args.alpha == null ? this.DEFAULT_ALPHA : args.alpha;
    }
    call(inputs, kwargs) {
        const x = (0, $bMNfZ.getExactlyOneTensor)(inputs);
        return (0, $kFoUG.leakyRelu)(x, this.alpha);
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            alpha: this.alpha
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $81d7af40dec059cf$export$aef2e2f253bc592f.className = 'LeakyReLU';
(0, $ki3lz).registerClass($81d7af40dec059cf$export$aef2e2f253bc592f);
class $81d7af40dec059cf$export$e8f536be4d0c9e9f extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA_INITIALIZER = 'zeros';
        if (args == null) args = {};
        this.supportsMasking = true;
        this.alphaInitializer = (0, $lHlnu.getInitializer)(args.alphaInitializer || this.DEFAULT_ALPHA_INITIALIZER);
        this.alphaRegularizer = (0, $1NdPD.getRegularizer)(args.alphaRegularizer);
        this.alphaConstraint = (0, $ghUz9.getConstraint)(args.alphaConstraint);
        if (args.sharedAxes == null) this.sharedAxes = null;
        else if (Array.isArray(args.sharedAxes)) this.sharedAxes = args.sharedAxes;
        else if (typeof args.sharedAxes === 'number') this.sharedAxes = [
            args.sharedAxes
        ];
        else throw new (0, $kubuc.ValueError)(`Expected sharedAxes to be a number or an array of numbers, ` + `but got ${args.sharedAxes}`);
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const paramShape = inputShape.slice(1);
        if (this.sharedAxes != null) for (const i of this.sharedAxes)paramShape[i - 1] = 1;
        this.alpha = this.addWeight('alpha', paramShape, 'float32', this.alphaInitializer, this.alphaRegularizer, true, this.alphaConstraint);
        // Set input spec.
        const axes = {};
        if (this.sharedAxes != null) for(let i = 1; i < inputShape.length; ++i)axes[i] = inputShape[i];
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: inputShape.length,
                axes: axes
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
        return (0, $8b5dq.prelu)(inputs, this.alpha.read());
    }
    getConfig() {
        const config = {
            alphaInitializer: (0, $lHlnu.serializeInitializer)(this.alphaInitializer),
            alphaRegularizer: (0, $1NdPD.serializeRegularizer)(this.alphaRegularizer),
            alphaConstraint: (0, $ghUz9.serializeConstraint)(this.alphaConstraint),
            sharedAxes: this.sharedAxes
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $81d7af40dec059cf$export$e8f536be4d0c9e9f.className = 'PReLU';
(0, $ki3lz).registerClass($81d7af40dec059cf$export$e8f536be4d0c9e9f);
class $81d7af40dec059cf$export$945a5ccf96adb3b2 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_ALPHA = 1.0;
        if (args == null) args = {};
        if (args.alpha != null && args.alpha !== this.DEFAULT_ALPHA) throw new (0, $kubuc.NotImplementedError)(`Non-default alpha value (${args.alpha}) is not supported by the ` + `ELU layer yet.`);
        this.alpha = args.alpha == null ? this.DEFAULT_ALPHA : args.alpha;
    }
    call(inputs, kwargs) {
        const x = (0, $bMNfZ.getExactlyOneTensor)(inputs);
        return (0, $4YAd3.elu)(x);
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            alpha: this.alpha
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $81d7af40dec059cf$export$945a5ccf96adb3b2.className = 'ELU';
(0, $ki3lz).registerClass($81d7af40dec059cf$export$945a5ccf96adb3b2);
class $81d7af40dec059cf$export$e0ad929c946d21d1 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_THETA = 1.0;
        if (args == null) args = {};
        this.theta = args.theta == null ? this.DEFAULT_THETA : args.theta;
    }
    call(inputs, kwargs) {
        const x = (0, $bMNfZ.getExactlyOneTensor)(inputs);
        return (0, $5hAos.mul)(x, (0, $fxiHg.cast)((0, $lOlhm.greater)(x, this.theta), 'float32'));
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            theta: this.theta
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $81d7af40dec059cf$export$e0ad929c946d21d1.className = 'ThresholdedReLU';
(0, $ki3lz).registerClass($81d7af40dec059cf$export$e0ad929c946d21d1);
class $81d7af40dec059cf$export$350a526055d3ca6e extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.DEFAULT_AXIS = 1.0;
        if (args == null) args = {};
        this.softmax = new (0, $5xdqh.Softmax)().apply;
        this.axis = args.axis == null ? this.DEFAULT_AXIS : args.axis;
    }
    call(inputs, kwargs) {
        // TODO(pforderique): Add tests for when `this.axis` is a number[].
        return (0, $d7Nxs.tidy)(()=>{
            let x = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            const mask = kwargs['mask'];
            if (mask != null) {
                // Since mask is 1.0 for positions we want to keep and 0.0 for masked
                // positions, this operation will create a tensor which is 0.0 for
                // positions we want to attend and -1e.9 for masked positions.
                const adder = (0, $5hAos.mul)((0, $5jGN9.sub)((0, $K2k22.ones)(x.shape), (0, $fxiHg.cast)(mask, x.dtype)), (0, $7hONX.scalar)(-1000000000));
                // Since we are adding it to the raw scores before the softmax, this
                // is effectively the same as removing these entirely.
                x = (0, $6Ab5n.add)(x, adder);
            }
            if (this.axis instanceof Array) {
                if (this.axis.length > 1) return (0, $1lCoz.exp)((0, $5jGN9.sub)(x, (0, $1UrMu.logSumExp)(x, this.axis, true)));
                else return this.softmax(x, this.axis[0]);
            }
            return this.softmax(x, this.axis);
        });
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const config = {
            axis: this.axis
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $81d7af40dec059cf$export$350a526055d3ca6e.className = 'Softmax';
(0, $ki3lz).registerClass($81d7af40dec059cf$export$350a526055d3ca6e);

});
parcelRegister("5xdqh", function(module, exports) {

$parcel$export(module.exports, "Softmax", function () { return $407a72561df5ea28$export$350a526055d3ca6e; });
$parcel$export(module.exports, "serializeActivation", function () { return $407a72561df5ea28$export$8a2c1643c67d0487; });
$parcel$export(module.exports, "getActivation", function () { return $407a72561df5ea28$export$ed84f867ffcf9364; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ // Layer activation functions
parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $dIChU = parcelRequire("dIChU");
var $86rqz = parcelRequire("86rqz");
var $2vk2B = parcelRequire("2vk2B");
var $7es6p = parcelRequire("7es6p");
var $5hAos = parcelRequire("5hAos");
var $eCViQ = parcelRequire("eCViQ");
var $aQaR3 = parcelRequire("aQaR3");
var $6DicT = parcelRequire("6DicT");
var $ki3lz = parcelRequire("ki3lz");
var $dzpno = parcelRequire("dzpno");
var $2J1JW = parcelRequire("2J1JW");
var $11Nx5 = parcelRequire("11Nx5");
var $g3lev = parcelRequire("g3lev");
var $cJm46 = parcelRequire("cJm46");
var $d7Nxs = parcelRequire("d7Nxs");

var $4AyI5 = parcelRequire("4AyI5");

var $jYx5u = parcelRequire("jYx5u");
class $407a72561df5ea28$export$d4842319833f6f14 extends (0, $ki3lz).Serializable {
    getConfig() {
        return {};
    }
}
/**
 * Exponential linear unit (ELU).
 * Reference: https://arxiv.org/abs/1511.07289
 */ class $407a72561df5ea28$export$64636e173424d83d extends $407a72561df5ea28$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x: Input.
     * @param alpha: Scaling factor the negative section.
     * @return Output of the ELU activation.
     */ apply(x, alpha = 1) {
        return $4AyI5.elu(x, alpha);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$64636e173424d83d.className = 'elu';
(0, $ki3lz).registerClass($407a72561df5ea28$export$64636e173424d83d);
/**
 * Scaled Exponential Linear Unit. (Klambauer et al., 2017).
 * Reference: Self-Normalizing Neural Networks, https://arxiv.org/abs/1706.02515
 * Notes:
 *   - To be used together with the initialization "lecunNormal".
 *   - To be used together with the dropout variant "AlphaDropout".
 */ class $407a72561df5ea28$export$6760d858e6f2594a extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return $6DicT.selu(x);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$6760d858e6f2594a.className = 'selu';
(0, $ki3lz).registerClass($407a72561df5ea28$export$6760d858e6f2594a);
/**
 *  Rectified linear unit
 */ class $407a72561df5ea28$export$9a6ff968bf961432 extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return $aQaR3.relu(x);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$9a6ff968bf961432.className = 'relu';
(0, $ki3lz).registerClass($407a72561df5ea28$export$9a6ff968bf961432);
/**
 * Rectified linear unit activation maxing out at 6.0.
 */ class $407a72561df5ea28$export$3be9e924f629054e extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return (0, $d7Nxs.tidy)(()=>$7es6p.minimum(6.0, $aQaR3.relu(x)));
    }
}
/** @nocollapse */ $407a72561df5ea28$export$3be9e924f629054e.className = 'relu6';
(0, $ki3lz).registerClass($407a72561df5ea28$export$3be9e924f629054e);
//* Linear activation (no-op) */
class $407a72561df5ea28$export$cff00ccf6e2392de extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return x;
    }
}
/** @nocollapse */ $407a72561df5ea28$export$cff00ccf6e2392de.className = 'linear';
(0, $ki3lz).registerClass($407a72561df5ea28$export$cff00ccf6e2392de);
/**
 * Sigmoid activation function.
 */ class $407a72561df5ea28$export$fde18c826dda6b1b extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return $dzpno.sigmoid(x);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$fde18c826dda6b1b.className = 'sigmoid';
(0, $ki3lz).registerClass($407a72561df5ea28$export$fde18c826dda6b1b);
/**
 * Segment-wise linear approximation of sigmoid.
 */ class $407a72561df5ea28$export$6098198c337d3dd8 extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return $4AyI5.hardSigmoid(x);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$6098198c337d3dd8.className = 'hardSigmoid';
(0, $ki3lz).registerClass($407a72561df5ea28$export$6098198c337d3dd8);
/**
 * Softplus activation function.
 */ class $407a72561df5ea28$export$c5af433747f1fd0a extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return $11Nx5.softplus(x);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$c5af433747f1fd0a.className = 'softplus';
(0, $ki3lz).registerClass($407a72561df5ea28$export$c5af433747f1fd0a);
/**
 * Softsign activation function.
 */ class $407a72561df5ea28$export$abea6258cd16deb6 extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return $4AyI5.softsign(x);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$abea6258cd16deb6.className = 'softsign';
(0, $ki3lz).registerClass($407a72561df5ea28$export$abea6258cd16deb6);
/**
 * Hyperbolic tangent function.
 */ class $407a72561df5ea28$export$893b6e865e352c83 extends $407a72561df5ea28$export$d4842319833f6f14 {
    apply(x) {
        return $cJm46.tanh(x);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$893b6e865e352c83.className = 'tanh';
(0, $ki3lz).registerClass($407a72561df5ea28$export$893b6e865e352c83);
/**
 * Softmax activation function
 */ class $407a72561df5ea28$export$350a526055d3ca6e extends $407a72561df5ea28$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @param axis Integer, axis along which the softmax normalization is applied.
     * Invalid if < 2, as softmax across 1 (the batch dimension) is assumed to be
     * an error.
     *
     * @returns a Tensor of the same shape as x
     *
     * @throws ValueError: In case `dim(x) < 2`.
     */ apply(x, axis = -1) {
        return $2J1JW.softmax(x, axis);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$350a526055d3ca6e.className = 'softmax';
(0, $ki3lz).registerClass($407a72561df5ea28$export$350a526055d3ca6e);
/**
 * Log softmax activation function
 */ class $407a72561df5ea28$export$85b5bcbd60848a10 extends $407a72561df5ea28$export$d4842319833f6f14 {
    /**
     * Calculate the activation function of log softmax:
     * log( exp(x_i) / sum(exp(x)) )
     *
     * @param x Tensor.
     * @param axis Integer, axis along which the softmax normalization is applied.
     * Invalid if < 2, as softmax across 1 (the batch dimension) is assumed to be
     * an error.
     *
     * @returns a Tensor of the same shape as x
     *
     * @throws ValueError: In case `dim(x) < 2`.
     */ apply(x, axis = -1) {
        return $2vk2B.logSoftmax(x, axis);
    }
}
/** @nocollapse */ $407a72561df5ea28$export$85b5bcbd60848a10.className = 'logSoftmax';
(0, $ki3lz).registerClass($407a72561df5ea28$export$85b5bcbd60848a10);
/**
 * Gelu activation function
 */ class $407a72561df5ea28$export$88ac613df6c4ef11 extends $407a72561df5ea28$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @returns a Tensor of the same shape as x
     */ apply(x) {
        return (0, $d7Nxs.tidy)(()=>{
            return $d7Nxs.tidy(()=>{
                const sqrtTwo = Math.sqrt(2);
                // Compute Φ(x) using the erf function
                const cdf = $5hAos.mul(0.5, $6Ab5n.add(1, $86rqz.erf($dIChU.div(x, sqrtTwo))));
                // Compute GELU(x) = x * Φ(x)
                return $5hAos.mul(x, cdf);
            });
        });
    }
}
/** @nocollapse */ $407a72561df5ea28$export$88ac613df6c4ef11.className = 'gelu';
(0, $ki3lz).registerClass($407a72561df5ea28$export$88ac613df6c4ef11);
/**
 * GeluNew activation function
 */ class $407a72561df5ea28$export$564b1c5fff9e16df extends $407a72561df5ea28$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @returns a Tensor of the same shape as x
     */ apply(x) {
        return (0, $d7Nxs.tidy)(()=>{
            return $5hAos.mul(0.5, $5hAos.mul(x, $6Ab5n.add(1, $cJm46.tanh($5hAos.mul($g3lev.sqrt($dIChU.div(2, Math.PI)), $6Ab5n.add(x, $5hAos.mul(0.044715, $eCViQ.pow(x, 3))))))));
        });
    }
}
/** @nocollapse */ $407a72561df5ea28$export$564b1c5fff9e16df.className = 'gelu_new';
(0, $ki3lz).registerClass($407a72561df5ea28$export$564b1c5fff9e16df);
/**
 * Mish activation function
 */ class $407a72561df5ea28$export$61e2977e0c740f20 extends $407a72561df5ea28$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @returns a Tensor of the same shape as x
     */ apply(x) {
        return (0, $d7Nxs.tidy)(()=>$5hAos.mul(x, $cJm46.tanh($11Nx5.softplus(x))));
    }
}
/** @nocollapse */ $407a72561df5ea28$export$61e2977e0c740f20.className = 'mish';
(0, $ki3lz).registerClass($407a72561df5ea28$export$61e2977e0c740f20);
/**
 * Swish activation function
 */ class $407a72561df5ea28$export$ca163985819ed934 extends $407a72561df5ea28$export$d4842319833f6f14 {
    /**
     * Calculate the activation function.
     *
     * @param x Tensor.
     * @param alpha Scaling factor for the sigmoid function.
     * @returns a Tensor of the same shape as x
     */ apply(x, alpha = 1) {
        return (0, $d7Nxs.tidy)(()=>$5hAos.mul($dzpno.sigmoid($5hAos.mul(x, alpha)), x));
    }
}
/** @nocollapse */ $407a72561df5ea28$export$ca163985819ed934.className = 'swish';
(0, $ki3lz).registerClass($407a72561df5ea28$export$ca163985819ed934);
function $407a72561df5ea28$export$8a2c1643c67d0487(activation) {
    return activation.getClassName();
}
function $407a72561df5ea28$export$3feed769d94b8fdf(config, customObjects = {}) {
    return (0, $jYx5u.deserializeKerasObject)(config, (0, $ki3lz).SerializationMap.getMap().classNameMap, customObjects, 'activation');
}
function $407a72561df5ea28$export$ed84f867ffcf9364(identifier) {
    if (identifier == null) {
        const config = {};
        config['className'] = 'linear';
        config['config'] = {};
        return $407a72561df5ea28$export$3feed769d94b8fdf(config);
    }
    if (typeof identifier === 'string') {
        const config = {};
        config['className'] = identifier;
        config['config'] = {};
        return $407a72561df5ea28$export$3feed769d94b8fdf(config);
    } else if (identifier instanceof $407a72561df5ea28$export$d4842319833f6f14) return identifier;
    else return $407a72561df5ea28$export$3feed769d94b8fdf(identifier);
}

});

parcelRegister("1NdPD", function(module, exports) {

$parcel$export(module.exports, "L1L2", function () { return $14e518bca3d2cff1$export$fb258565fa710653; });
$parcel$export(module.exports, "l1", function () { return $14e518bca3d2cff1$export$b35c4719d0ff29eb; });
$parcel$export(module.exports, "l2", function () { return $14e518bca3d2cff1$export$683828dad49492ec; });
$parcel$export(module.exports, "serializeRegularizer", function () { return $14e518bca3d2cff1$export$7e8cf5899b350405; });
$parcel$export(module.exports, "getRegularizer", function () { return $14e518bca3d2cff1$export$b3404716bfee324c; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* original source: keras/regularizers.py */ parcelRequire("8AHkS");
var $57D4R = parcelRequire("57D4R");
var $6Ab5n = parcelRequire("6Ab5n");
var $5hAos = parcelRequire("5hAos");
var $8nMOl = parcelRequire("8nMOl");
var $ki3lz = parcelRequire("ki3lz");
var $fPnAL = parcelRequire("fPnAL");
var $d7Nxs = parcelRequire("d7Nxs");
var $lxzgt = parcelRequire("lxzgt");

var $4AyI5 = parcelRequire("4AyI5");

var $jYx5u = parcelRequire("jYx5u");
function $14e518bca3d2cff1$var$assertObjectArgs(args) {
    if (args != null && typeof args !== 'object') throw new Error(`Argument to L1L2 regularizer's constructor is expected to be an ` + `object, but received: ${args}`);
}
class $14e518bca3d2cff1$export$49735e7db1366677 extends (0, $ki3lz).Serializable {
}
class $14e518bca3d2cff1$export$fb258565fa710653 extends $14e518bca3d2cff1$export$49735e7db1366677 {
    constructor(args){
        super();
        $14e518bca3d2cff1$var$assertObjectArgs(args);
        this.l1 = args == null || args.l1 == null ? 0.01 : args.l1;
        this.l2 = args == null || args.l2 == null ? 0.01 : args.l2;
        this.hasL1 = this.l1 !== 0;
        this.hasL2 = this.l2 !== 0;
    }
    /**
     * Porting note: Renamed from __call__.
     * @param x Variable of which to calculate the regularization score.
     */ apply(x) {
        return (0, $d7Nxs.tidy)(()=>{
            let regularization = (0, $lxzgt.zeros)([
                1
            ]);
            if (this.hasL1) regularization = (0, $6Ab5n.add)(regularization, (0, $fPnAL.sum)($5hAos.mul(this.l1, (0, $57D4R.abs)(x))));
            if (this.hasL2) regularization = (0, $6Ab5n.add)(regularization, (0, $fPnAL.sum)($5hAos.mul(this.l2, $4AyI5.square(x))));
            return $8nMOl.reshape(regularization, []);
        });
    }
    getConfig() {
        return {
            'l1': this.l1,
            'l2': this.l2
        };
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls({
            l1: config['l1'],
            l2: config['l2']
        });
    }
}
/** @nocollapse */ $14e518bca3d2cff1$export$fb258565fa710653.className = 'L1L2';
(0, $ki3lz).registerClass($14e518bca3d2cff1$export$fb258565fa710653);
function $14e518bca3d2cff1$export$b35c4719d0ff29eb(args) {
    $14e518bca3d2cff1$var$assertObjectArgs(args);
    return new $14e518bca3d2cff1$export$fb258565fa710653({
        l1: args != null ? args.l1 : null,
        l2: 0
    });
}
function $14e518bca3d2cff1$export$683828dad49492ec(args) {
    $14e518bca3d2cff1$var$assertObjectArgs(args);
    return new $14e518bca3d2cff1$export$fb258565fa710653({
        l2: args != null ? args.l2 : null,
        l1: 0
    });
}
const $14e518bca3d2cff1$export$c242128098ecbfe1 = {
    'l1l2': 'L1L2'
};
function $14e518bca3d2cff1$export$7e8cf5899b350405(constraint) {
    return (0, $jYx5u.serializeKerasObject)(constraint);
}
function $14e518bca3d2cff1$export$e53995a1d2fa3dd6(config, customObjects = {}) {
    return (0, $jYx5u.deserializeKerasObject)(config, (0, $ki3lz).SerializationMap.getMap().classNameMap, customObjects, 'regularizer');
}
function $14e518bca3d2cff1$export$b3404716bfee324c(identifier) {
    if (identifier == null) return null;
    if (typeof identifier === 'string') {
        const className = identifier in $14e518bca3d2cff1$export$c242128098ecbfe1 ? $14e518bca3d2cff1$export$c242128098ecbfe1[identifier] : identifier;
        const config = {
            className: className,
            config: {}
        };
        return $14e518bca3d2cff1$export$e53995a1d2fa3dd6(config);
    } else if (identifier instanceof $14e518bca3d2cff1$export$49735e7db1366677) return identifier;
    else return $14e518bca3d2cff1$export$e53995a1d2fa3dd6(identifier);
}

});


parcelRegister("es1va", function(module, exports) {

$parcel$export(module.exports, "preprocessConv2DInput", function () { return $a854d86ccf3d93ce$export$8434bfc73196ab6c; });
$parcel$export(module.exports, "preprocessConv3DInput", function () { return $a854d86ccf3d93ce$export$4ce11465fb76c4e6; });
$parcel$export(module.exports, "BaseConv", function () { return $a854d86ccf3d93ce$export$ed9aa941a71a9fd2; });
$parcel$export(module.exports, "Conv2D", function () { return $a854d86ccf3d93ce$export$57742e605d475795; });
$parcel$export(module.exports, "Conv3D", function () { return $a854d86ccf3d93ce$export$9d3874201dd21933; });
$parcel$export(module.exports, "Conv2DTranspose", function () { return $a854d86ccf3d93ce$export$7dbaf9916b0932fc; });
$parcel$export(module.exports, "Conv3DTranspose", function () { return $a854d86ccf3d93ce$export$56aa8cf0209e38c1; });
$parcel$export(module.exports, "SeparableConv2D", function () { return $a854d86ccf3d93ce$export$711e1c2609c1fbb3; });
$parcel$export(module.exports, "Conv1D", function () { return $a854d86ccf3d93ce$export$34a445ae5c2580eb; });
$parcel$export(module.exports, "Cropping2D", function () { return $a854d86ccf3d93ce$export$8c24c9344a3b8089; });
$parcel$export(module.exports, "UpSampling2D", function () { return $a854d86ccf3d93ce$export$4b8be6e684923935; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Convolutional Layers
 */ parcelRequire("8AHkS");
var $7vGQw = parcelRequire("7vGQw");
var $gVSKY = parcelRequire("gVSKY");
var $4B9eF = parcelRequire("4B9eF");
var $lqPND = parcelRequire("lqPND");
var $eJ7TQ = parcelRequire("eJ7TQ");
var $4I5dI = parcelRequire("4I5dI");
var $2ICVg = parcelRequire("2ICVg");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");
var $9c2so = parcelRequire("9c2so");

var $5xdqh = parcelRequire("5xdqh");

var $69VqB = parcelRequire("69VqB");

var $4AyI5 = parcelRequire("4AyI5");

var $1Xyaa = parcelRequire("1Xyaa");

var $ghUz9 = parcelRequire("ghUz9");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $1NdPD = parcelRequire("1NdPD");

var $aT5kh = parcelRequire("aT5kh");

var $jYx5u = parcelRequire("jYx5u");

var $bMNfZ = parcelRequire("bMNfZ");
function $a854d86ccf3d93ce$export$8434bfc73196ab6c(x, dataFormat) {
    // TODO(cais): Cast type to float32 if not.
    return (0, $d7Nxs.tidy)(()=>{
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        if (dataFormat === 'channelsFirst') return $9c2so.transpose(x, [
            0,
            2,
            3,
            1
        ]); // NCHW -> NHWC.
        else return x;
    });
}
function $a854d86ccf3d93ce$export$4ce11465fb76c4e6(x, dataFormat) {
    return (0, $d7Nxs.tidy)(()=>{
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        if (dataFormat === 'channelsFirst') return $9c2so.transpose(x, [
            0,
            2,
            3,
            4,
            1
        ]); // NCDHW -> NDHWC.
        else return x;
    });
}
function $a854d86ccf3d93ce$export$5e4c51f717878325(x, kernel, bias, strides = 1, padding = 'valid', dataFormat, dilationRate = 1) {
    return (0, $d7Nxs.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $69VqB.imageDataFormat)();
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        // Check the ranks of x, kernel and bias.
        if (x.shape.length !== 3) throw new (0, $kubuc.ValueError)(`The input of a conv1dWithBias operation should be 3, but is ` + `${x.shape.length} instead.`);
        if (kernel.shape.length !== 3) throw new (0, $kubuc.ValueError)(`The kernel for a conv1dWithBias operation should be 3, but is ` + `${kernel.shape.length} instead`);
        if (bias != null && bias.shape.length !== 1) throw new (0, $kubuc.ValueError)(`The bias for a conv1dWithBias operation should be 1, but is ` + `${bias.shape.length} instead`);
        // TODO(cais): Support CAUSAL padding mode.
        if (dataFormat === 'channelsFirst') x = $9c2so.transpose(x, [
            0,
            2,
            1
        ]); // NCW -> NWC.
        if (padding === 'causal') throw new (0, $kubuc.NotImplementedError)("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        let y = $7vGQw.conv1d(x, kernel, strides, padding === 'same' ? 'same' : 'valid', 'NWC', dilationRate);
        if (bias != null) y = $4AyI5.biasAdd(y, bias);
        return y;
    });
}
function $a854d86ccf3d93ce$export$d8aa844fa36b350e(x, kernel, strides = 1, padding = 'valid', dataFormat, dilationRate = 1) {
    return (0, $d7Nxs.tidy)(()=>{
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        return $a854d86ccf3d93ce$export$5e4c51f717878325(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $a854d86ccf3d93ce$export$188f9215482e3db8(x, kernel, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $d7Nxs.tidy)(()=>{
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        return $a854d86ccf3d93ce$export$8fcf8ce8bb1af9d(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $a854d86ccf3d93ce$export$8fcf8ce8bb1af9d(x, kernel, bias, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate, activation = null) {
    return (0, $d7Nxs.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $69VqB.imageDataFormat)();
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        if (x.rank !== 3 && x.rank !== 4) throw new (0, $kubuc.ValueError)(`conv2dWithBiasActivation expects input to be of rank 3 or 4, ` + `but received ${x.rank}.`);
        if (kernel.rank !== 3 && kernel.rank !== 4) throw new (0, $kubuc.ValueError)(`conv2dWithBiasActivation expects kernel to be of rank 3 or 4, ` + `but received ${x.rank}.`);
        let y = $a854d86ccf3d93ce$export$8434bfc73196ab6c(x, dataFormat);
        if (padding === 'causal') throw new (0, $kubuc.NotImplementedError)("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        y = $eJ7TQ.conv2d({
            x: y,
            filter: kernel,
            strides: strides,
            pad: padding === 'same' ? 'same' : 'valid',
            dilations: dilationRate,
            dataFormat: 'NHWC',
            bias: bias,
            activation: activation
        });
        if (dataFormat === 'channelsFirst') y = $9c2so.transpose(y, [
            0,
            3,
            1,
            2
        ]);
        return y;
    });
}
function $a854d86ccf3d93ce$export$c476b02bcf7b2def(x, kernel, strides = [
    1,
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $d7Nxs.tidy)(()=>{
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        return $a854d86ccf3d93ce$export$cffde359467c6702(x, kernel, null, strides, padding, dataFormat, dilationRate);
    });
}
function $a854d86ccf3d93ce$export$cffde359467c6702(x, kernel, bias, strides = [
    1,
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $d7Nxs.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $69VqB.imageDataFormat)();
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        if (x.rank !== 4 && x.rank !== 5) throw new (0, $kubuc.ValueError)(`conv3dWithBias expects input to be of rank 4 or 5, but received ` + `${x.rank}.`);
        if (kernel.rank !== 4 && kernel.rank !== 5) throw new (0, $kubuc.ValueError)(`conv3dWithBias expects kernel to be of rank 4 or 5, but received ` + `${x.rank}.`);
        let y = $a854d86ccf3d93ce$export$4ce11465fb76c4e6(x, dataFormat);
        if (padding === 'causal') throw new (0, $kubuc.NotImplementedError)("The support for CAUSAL padding mode in conv3dWithBias is not implemented yet.");
        y = $4B9eF.conv3d(y, kernel, strides, padding === 'same' ? 'same' : 'valid', 'NDHWC', dilationRate);
        if (bias != null) y = $4AyI5.biasAdd(y, bias);
        if (dataFormat === 'channelsFirst') y = $9c2so.transpose(y, [
            0,
            4,
            1,
            2,
            3
        ]);
        return y;
    });
}
class $a854d86ccf3d93ce$export$ed9aa941a71a9fd2 extends (0, $jWpeh.Layer) {
    constructor(rank, args){
        super(args);
        this.bias = null;
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        $a854d86ccf3d93ce$export$ed9aa941a71a9fd2.verifyArgs(args);
        this.rank = rank;
        $jYx5u.assertPositiveInteger(this.rank, 'rank');
        if (this.rank !== 1 && this.rank !== 2 && this.rank !== 3) throw new (0, $kubuc.NotImplementedError)(`Convolution layer for rank other than 1, 2, or 3 (${this.rank}) is ` + `not implemented yet.`);
        this.kernelSize = (0, $aT5kh.normalizeArray)(args.kernelSize, rank, 'kernelSize');
        this.strides = (0, $aT5kh.normalizeArray)(args.strides == null ? 1 : args.strides, rank, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        (0, $1Xyaa.checkPaddingMode)(this.padding);
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $1Xyaa.checkDataFormat)(this.dataFormat);
        this.activation = (0, $5xdqh.getActivation)(args.activation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.biasInitializer = (0, $lHlnu.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.biasConstraint = (0, $ghUz9.getConstraint)(args.biasConstraint);
        this.biasRegularizer = (0, $1NdPD.getRegularizer)(args.biasRegularizer);
        this.activityRegularizer = (0, $1NdPD.getRegularizer)(args.activityRegularizer);
        this.dilationRate = (0, $aT5kh.normalizeArray)(args.dilationRate == null ? 1 : args.dilationRate, rank, 'dilationRate');
        if (this.rank === 1 && Array.isArray(this.dilationRate) && this.dilationRate.length !== 1) throw new (0, $kubuc.ValueError)(`dilationRate must be a number or an array of a single number ` + `for 1D convolution, but received ` + `${JSON.stringify(this.dilationRate)}`);
        else if (this.rank === 2) {
            if (typeof this.dilationRate === 'number') this.dilationRate = [
                this.dilationRate,
                this.dilationRate
            ];
            else if (this.dilationRate.length !== 2) throw new (0, $kubuc.ValueError)(`dilationRate must be a number or array of two numbers for 2D ` + `convolution, but received ${JSON.stringify(this.dilationRate)}`);
        } else if (this.rank === 3) {
            if (typeof this.dilationRate === 'number') this.dilationRate = [
                this.dilationRate,
                this.dilationRate,
                this.dilationRate
            ];
            else if (this.dilationRate.length !== 3) throw new (0, $kubuc.ValueError)(`dilationRate must be a number or array of three numbers for 3D ` + `convolution, but received ${JSON.stringify(this.dilationRate)}`);
        }
    }
    static verifyArgs(args) {
        // Check config.kernelSize type and shape.
        $jYx5u.assert('kernelSize' in args, `required key 'kernelSize' not in config`);
        if (typeof args.kernelSize !== 'number' && !$jYx5u.checkArrayTypeAndLength(args.kernelSize, 'number', 1, 3)) throw new (0, $kubuc.ValueError)(`BaseConv expects config.kernelSize to be number or number[] with ` + `length 1, 2, or 3, but received ${JSON.stringify(args.kernelSize)}.`);
    }
    getConfig() {
        const config = {
            kernelSize: this.kernelSize,
            strides: this.strides,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            activation: (0, $5xdqh.serializeActivation)(this.activation),
            useBias: this.useBias,
            biasInitializer: (0, $lHlnu.serializeInitializer)(this.biasInitializer),
            biasRegularizer: (0, $1NdPD.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $1NdPD.serializeRegularizer)(this.activityRegularizer),
            biasConstraint: (0, $ghUz9.serializeConstraint)(this.biasConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $a854d86ccf3d93ce$export$d9f5537266743215 extends $a854d86ccf3d93ce$export$ed9aa941a71a9fd2 {
    constructor(rank, args){
        super(rank, args);
        this.kernel = null;
        $a854d86ccf3d93ce$export$d9f5537266743215.verifyArgs(args);
        this.filters = args.filters;
        $jYx5u.assertPositiveInteger(this.filters, 'filters');
        this.kernelInitializer = (0, $lHlnu.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.kernelConstraint = (0, $ghUz9.getConstraint)(args.kernelConstraint);
        this.kernelRegularizer = (0, $1NdPD.getRegularizer)(args.kernelRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $kubuc.ValueError)(`The channel dimension of the input should be defined. ` + `Found ${inputShape[channelAxis]}`);
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            inputDim,
            this.filters
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        this.inputSpec = [
            {
                ndim: this.rank + 2,
                axes: {
                    [channelAxis]: inputDim
                }
            }
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            let outputs;
            const biasValue = this.bias == null ? null : this.bias.read();
            const fusedActivationName = $jYx5u.mapActivationToFusedKernel(this.activation.getClassName());
            if (fusedActivationName != null && this.rank === 2) outputs = $a854d86ccf3d93ce$export$8fcf8ce8bb1af9d(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate, fusedActivationName);
            else {
                if (this.rank === 1) outputs = $a854d86ccf3d93ce$export$5e4c51f717878325(inputs, this.kernel.read(), biasValue, this.strides[0], this.padding, this.dataFormat, this.dilationRate[0]);
                else if (this.rank === 2) // TODO(cais): Move up to constructor.
                outputs = $a854d86ccf3d93ce$export$8fcf8ce8bb1af9d(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate);
                else if (this.rank === 3) outputs = $a854d86ccf3d93ce$export$cffde359467c6702(inputs, this.kernel.read(), biasValue, this.strides, this.padding, this.dataFormat, this.dilationRate);
                else throw new (0, $kubuc.NotImplementedError)('convolutions greater than 3D are not implemented yet.');
                if (this.activation != null) outputs = this.activation.apply(outputs);
            }
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const newSpace = [];
        const space = this.dataFormat === 'channelsLast' ? inputShape.slice(1, inputShape.length - 1) : inputShape.slice(2);
        for(let i = 0; i < space.length; ++i){
            const newDim = (0, $aT5kh.convOutputLength)(space[i], this.kernelSize[i], this.padding, this.strides[i], typeof this.dilationRate === 'number' ? this.dilationRate : this.dilationRate[i]);
            newSpace.push(newDim);
        }
        let outputShape = [
            inputShape[0]
        ];
        if (this.dataFormat === 'channelsLast') {
            outputShape = outputShape.concat(newSpace);
            outputShape.push(this.filters);
        } else {
            outputShape.push(this.filters);
            outputShape = outputShape.concat(newSpace);
        }
        return outputShape;
    }
    getConfig() {
        const config = {
            filters: this.filters,
            kernelInitializer: (0, $lHlnu.serializeInitializer)(this.kernelInitializer),
            kernelRegularizer: (0, $1NdPD.serializeRegularizer)(this.kernelRegularizer),
            kernelConstraint: (0, $ghUz9.serializeConstraint)(this.kernelConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    static verifyArgs(args) {
        // Check config.filters type, shape, and value.
        if (!('filters' in args) || typeof args.filters !== 'number' || args.filters < 1) throw new (0, $kubuc.ValueError)(`Convolution layer expected config.filters to be a 'number' > 0 ` + `but got ${JSON.stringify(args.filters)}`);
    }
}
class $a854d86ccf3d93ce$export$57742e605d475795 extends $a854d86ccf3d93ce$export$d9f5537266743215 {
    constructor(args){
        super(2, args);
        $a854d86ccf3d93ce$export$57742e605d475795.verifyArgs(args);
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number' && !$jYx5u.checkArrayTypeAndLength(args.kernelSize, 'number', 1, 2)) throw new (0, $kubuc.ValueError)(`Conv2D expects config.kernelSize to be number or number[] with ` + `length 1 or 2, but received ${JSON.stringify(args.kernelSize)}.`);
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$57742e605d475795.className = 'Conv2D';
(0, $ki3lz).registerClass($a854d86ccf3d93ce$export$57742e605d475795);
class $a854d86ccf3d93ce$export$9d3874201dd21933 extends $a854d86ccf3d93ce$export$d9f5537266743215 {
    constructor(args){
        super(3, args);
        $a854d86ccf3d93ce$export$9d3874201dd21933.verifyArgs(args);
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number') {
            if (!(Array.isArray(args.kernelSize) && (args.kernelSize.length === 1 || args.kernelSize.length === 3))) throw new (0, $kubuc.ValueError)(`Conv3D expects config.kernelSize to be number or` + ` [number, number, number], but received ${JSON.stringify(args.kernelSize)}.`);
        }
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$9d3874201dd21933.className = 'Conv3D';
(0, $ki3lz).registerClass($a854d86ccf3d93ce$export$9d3874201dd21933);
class $a854d86ccf3d93ce$export$7dbaf9916b0932fc extends $a854d86ccf3d93ce$export$57742e605d475795 {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 4
            })
        ];
        if (this.padding !== 'same' && this.padding !== 'valid') throw new (0, $kubuc.ValueError)(`Conv2DTranspose currently supports only padding modes 'same' ` + `and 'valid', but received padding mode ${this.padding}`);
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        if (inputShape.length !== 4) throw new (0, $kubuc.ValueError)('Input should have rank 4; Received input shape: ' + JSON.stringify(inputShape));
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $kubuc.ValueError)("The channel dimension of the inputs should be defined. Found `None`.");
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            this.filters,
            inputDim
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, 'float32', this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        // Set input spec.
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 4,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return $d7Nxs.tidy(()=>{
            let input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (input.shape.length !== 4) throw new (0, $kubuc.ValueError)(`Conv2DTranspose.call() expects input tensor to be rank-4, but ` + `received a tensor of rank-${input.shape.length}`);
            const inputShape = input.shape;
            const batchSize = inputShape[0];
            let hAxis;
            let wAxis;
            if (this.dataFormat === 'channelsFirst') {
                hAxis = 2;
                wAxis = 3;
            } else {
                hAxis = 1;
                wAxis = 2;
            }
            const height = inputShape[hAxis];
            const width = inputShape[wAxis];
            const kernelH = this.kernelSize[0];
            const kernelW = this.kernelSize[1];
            const strideH = this.strides[0];
            const strideW = this.strides[1];
            // Infer the dynamic output shape.
            const outHeight = (0, $aT5kh.deconvLength)(height, strideH, kernelH, this.padding);
            const outWidth = (0, $aT5kh.deconvLength)(width, strideW, kernelW, this.padding);
            // Porting Note: We don't branch based on `this.dataFormat` here,
            // because
            //   the tjfs-core function `conv2dTranspose` called below always
            //   assumes channelsLast.
            const outputShape = [
                batchSize,
                outHeight,
                outWidth,
                this.filters
            ];
            if (this.dataFormat !== 'channelsLast') input = $9c2so.transpose(input, [
                0,
                2,
                3,
                1
            ]);
            let outputs = $gVSKY.conv2dTranspose(input, this.kernel.read(), outputShape, this.strides, this.padding);
            if (this.dataFormat !== 'channelsLast') outputs = $9c2so.transpose(outputs, [
                0,
                3,
                1,
                2
            ]);
            if (this.bias != null) outputs = $4AyI5.biasAdd(outputs, this.bias.read(), this.dataFormat);
            if (this.activation != null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const outputShape = inputShape.slice();
        let channelAxis;
        let heightAxis;
        let widthAxis;
        if (this.dataFormat === 'channelsFirst') {
            channelAxis = 1;
            heightAxis = 2;
            widthAxis = 3;
        } else {
            channelAxis = 3;
            heightAxis = 1;
            widthAxis = 2;
        }
        const kernelH = this.kernelSize[0];
        const kernelW = this.kernelSize[1];
        const strideH = this.strides[0];
        const strideW = this.strides[1];
        outputShape[channelAxis] = this.filters;
        outputShape[heightAxis] = (0, $aT5kh.deconvLength)(outputShape[heightAxis], strideH, kernelH, this.padding);
        outputShape[widthAxis] = (0, $aT5kh.deconvLength)(outputShape[widthAxis], strideW, kernelW, this.padding);
        return outputShape;
    }
    getConfig() {
        const config = super.getConfig();
        delete config['dilationRate'];
        return config;
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$7dbaf9916b0932fc.className = 'Conv2DTranspose';
(0, $ki3lz).registerClass($a854d86ccf3d93ce$export$7dbaf9916b0932fc);
class $a854d86ccf3d93ce$export$56aa8cf0209e38c1 extends $a854d86ccf3d93ce$export$9d3874201dd21933 {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 5
            })
        ];
        if (this.padding !== 'same' && this.padding !== 'valid') throw new (0, $kubuc.ValueError)(`Conv3DTranspose currently supports only padding modes 'same' ` + `and 'valid', but received padding mode ${this.padding}`);
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        if (inputShape.length !== 5) throw new (0, $kubuc.ValueError)('Input should have rank 5; Received input shape: ' + JSON.stringify(inputShape));
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $kubuc.ValueError)("The channel dimension of the inputs should be defined. Found `None`.");
        const inputDim = inputShape[channelAxis];
        const kernelShape = this.kernelSize.concat([
            this.filters,
            inputDim
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, 'float32', this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        // Set input spec.
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 5,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return $d7Nxs.tidy(()=>{
            let input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (input.shape.length !== 5) throw new (0, $kubuc.ValueError)(`Conv3DTranspose.call() expects input tensor to be rank-4, but ` + `received a tensor of rank-${input.shape.length}`);
            const inputShape = input.shape;
            const batchSize = inputShape[0];
            let hAxis;
            let wAxis;
            let dAxis;
            if (this.dataFormat === 'channelsFirst') {
                dAxis = 2;
                hAxis = 3;
                wAxis = 4;
            } else {
                dAxis = 1;
                hAxis = 2;
                wAxis = 3;
            }
            const depth = inputShape[dAxis];
            const height = inputShape[hAxis];
            const width = inputShape[wAxis];
            const kernelD = this.kernelSize[0];
            const kernelH = this.kernelSize[1];
            const kernelW = this.kernelSize[2];
            const strideD = this.strides[0];
            const strideH = this.strides[1];
            const strideW = this.strides[2];
            // Infer the dynamic output shape.
            const outDepth = (0, $aT5kh.deconvLength)(depth, strideD, kernelD, this.padding);
            const outHeight = (0, $aT5kh.deconvLength)(height, strideH, kernelH, this.padding);
            const outWidth = (0, $aT5kh.deconvLength)(width, strideW, kernelW, this.padding);
            // Same as `conv2dTranspose`. We always assumes channelsLast.
            const outputShape = [
                batchSize,
                outDepth,
                outHeight,
                outWidth,
                this.filters
            ];
            if (this.dataFormat !== 'channelsLast') input = $9c2so.transpose(input, [
                0,
                2,
                3,
                4,
                1
            ]);
            let outputs = $lqPND.conv3dTranspose(input, this.kernel.read(), outputShape, this.strides, this.padding);
            if (this.dataFormat !== 'channelsLast') outputs = $9c2so.transpose(outputs, [
                0,
                4,
                1,
                2,
                3
            ]);
            if (this.bias !== null) outputs = $4AyI5.biasAdd(outputs, this.bias.read(), this.dataFormat);
            if (this.activation !== null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const outputShape = inputShape.slice();
        let channelAxis;
        let depthAxis;
        let heightAxis;
        let widthAxis;
        if (this.dataFormat === 'channelsFirst') {
            channelAxis = 1;
            depthAxis = 2;
            heightAxis = 3;
            widthAxis = 4;
        } else {
            channelAxis = 4;
            depthAxis = 1;
            heightAxis = 2;
            widthAxis = 3;
        }
        const kernelD = this.kernelSize[0];
        const kernelH = this.kernelSize[1];
        const kernelW = this.kernelSize[2];
        const strideD = this.strides[0];
        const strideH = this.strides[1];
        const strideW = this.strides[2];
        outputShape[channelAxis] = this.filters;
        outputShape[depthAxis] = (0, $aT5kh.deconvLength)(outputShape[depthAxis], strideD, kernelD, this.padding);
        outputShape[heightAxis] = (0, $aT5kh.deconvLength)(outputShape[heightAxis], strideH, kernelH, this.padding);
        outputShape[widthAxis] = (0, $aT5kh.deconvLength)(outputShape[widthAxis], strideW, kernelW, this.padding);
        return outputShape;
    }
    getConfig() {
        const config = super.getConfig();
        delete config['dilationRate'];
        return config;
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$56aa8cf0209e38c1.className = 'Conv3DTranspose';
(0, $ki3lz).registerClass($a854d86ccf3d93ce$export$56aa8cf0209e38c1);
class $a854d86ccf3d93ce$export$1b7b94ed9bbc01d1 extends $a854d86ccf3d93ce$export$d9f5537266743215 {
    constructor(rank, config){
        super(rank, config);
        this.DEFAULT_DEPTHWISE_INITIALIZER = 'glorotUniform';
        this.DEFAULT_POINTWISE_INITIALIZER = 'glorotUniform';
        this.depthwiseKernel = null;
        this.pointwiseKernel = null;
        if (config.filters == null) throw new (0, $kubuc.ValueError)("The `filters` configuration field is required by SeparableConv, but is unspecified.");
        if (config.kernelInitializer != null || config.kernelRegularizer != null || config.kernelConstraint != null) throw new (0, $kubuc.ValueError)("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");
        if (config.padding != null && config.padding !== 'same' && config.padding !== 'valid') throw new (0, $kubuc.ValueError)(`SeparableConv${this.rank}D supports only padding modes: ` + `'same' and 'valid', but received ${JSON.stringify(config.padding)}`);
        this.depthMultiplier = config.depthMultiplier == null ? 1 : config.depthMultiplier;
        this.depthwiseInitializer = (0, $lHlnu.getInitializer)(config.depthwiseInitializer || this.DEFAULT_DEPTHWISE_INITIALIZER);
        this.depthwiseRegularizer = (0, $1NdPD.getRegularizer)(config.depthwiseRegularizer);
        this.depthwiseConstraint = (0, $ghUz9.getConstraint)(config.depthwiseConstraint);
        this.pointwiseInitializer = (0, $lHlnu.getInitializer)(config.depthwiseInitializer || this.DEFAULT_POINTWISE_INITIALIZER);
        this.pointwiseRegularizer = (0, $1NdPD.getRegularizer)(config.pointwiseRegularizer);
        this.pointwiseConstraint = (0, $ghUz9.getConstraint)(config.pointwiseConstraint);
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        if (inputShape.length < this.rank + 2) throw new (0, $kubuc.ValueError)(`Inputs to SeparableConv${this.rank}D should have rank ` + `${this.rank + 2}, but received input shape: ` + `${JSON.stringify(inputShape)}`);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null || inputShape[channelAxis] < 0) throw new (0, $kubuc.ValueError)(`The channel dimension of the inputs should be defined, ` + `but found ${JSON.stringify(inputShape[channelAxis])}`);
        const inputDim = inputShape[channelAxis];
        const depthwiseKernelShape = this.kernelSize.concat([
            inputDim,
            this.depthMultiplier
        ]);
        const pointwiseKernelShape = [];
        for(let i = 0; i < this.rank; ++i)pointwiseKernelShape.push(1);
        pointwiseKernelShape.push(inputDim * this.depthMultiplier, this.filters);
        const trainable = true;
        this.depthwiseKernel = this.addWeight('depthwise_kernel', depthwiseKernelShape, 'float32', this.depthwiseInitializer, this.depthwiseRegularizer, trainable, this.depthwiseConstraint);
        this.pointwiseKernel = this.addWeight('pointwise_kernel', pointwiseKernelShape, 'float32', this.pointwiseInitializer, this.pointwiseRegularizer, trainable, this.pointwiseConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.filters
        ], 'float32', this.biasInitializer, this.biasRegularizer, trainable, this.biasConstraint);
        else this.bias = null;
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: this.rank + 2,
                axes: {
                    [channelAxis]: inputDim
                }
            })
        ];
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            let output;
            if (this.rank === 1) throw new (0, $kubuc.NotImplementedError)('1D separable convolution is not implemented yet.');
            else if (this.rank === 2) {
                if (this.dataFormat === 'channelsFirst') inputs = $9c2so.transpose(inputs, [
                    0,
                    2,
                    3,
                    1
                ]); // NCHW -> NHWC.
                output = $2ICVg.separableConv2d(inputs, this.depthwiseKernel.read(), this.pointwiseKernel.read(), this.strides, this.padding, this.dilationRate, 'NHWC');
            }
            if (this.useBias) output = $4AyI5.biasAdd(output, this.bias.read(), this.dataFormat);
            if (this.activation != null) output = this.activation.apply(output);
            if (this.dataFormat === 'channelsFirst') output = $9c2so.transpose(output, [
                0,
                3,
                1,
                2
            ]); // NHWC -> NCHW.
            return output;
        });
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        delete config['kernelInitializer'];
        delete config['kernelRegularizer'];
        delete config['kernelConstraint'];
        config['depthwiseInitializer'] = (0, $lHlnu.serializeInitializer)(this.depthwiseInitializer);
        config['pointwiseInitializer'] = (0, $lHlnu.serializeInitializer)(this.pointwiseInitializer);
        config['depthwiseRegularizer'] = (0, $1NdPD.serializeRegularizer)(this.depthwiseRegularizer);
        config['pointwiseRegularizer'] = (0, $1NdPD.serializeRegularizer)(this.pointwiseRegularizer);
        config['depthwiseConstraint'] = (0, $ghUz9.serializeConstraint)(this.depthwiseConstraint);
        config['pointwiseConstraint'] = (0, $ghUz9.serializeConstraint)(this.pointwiseConstraint);
        return config;
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$1b7b94ed9bbc01d1.className = 'SeparableConv';
class $a854d86ccf3d93ce$export$711e1c2609c1fbb3 extends $a854d86ccf3d93ce$export$1b7b94ed9bbc01d1 {
    constructor(args){
        super(2, args);
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$711e1c2609c1fbb3.className = 'SeparableConv2D';
(0, $ki3lz).registerClass($a854d86ccf3d93ce$export$711e1c2609c1fbb3);
class $a854d86ccf3d93ce$export$34a445ae5c2580eb extends $a854d86ccf3d93ce$export$d9f5537266743215 {
    constructor(args){
        super(1, args);
        $a854d86ccf3d93ce$export$34a445ae5c2580eb.verifyArgs(args);
        this.inputSpec = [
            {
                ndim: 3
            }
        ];
    }
    getConfig() {
        const config = super.getConfig();
        delete config['rank'];
        delete config['dataFormat'];
        return config;
    }
    static verifyArgs(args) {
        // config.kernelSize must be a number or array of numbers.
        if (typeof args.kernelSize !== 'number' && !$jYx5u.checkArrayTypeAndLength(args.kernelSize, 'number', 1, 1)) throw new (0, $kubuc.ValueError)(`Conv1D expects config.kernelSize to be number or number[] with ` + `length 1, but received ${JSON.stringify(args.kernelSize)}.`);
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$34a445ae5c2580eb.className = 'Conv1D';
(0, $ki3lz).registerClass($a854d86ccf3d93ce$export$34a445ae5c2580eb);
class $a854d86ccf3d93ce$export$8c24c9344a3b8089 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        if (typeof args.cropping === 'number') this.cropping = [
            [
                args.cropping,
                args.cropping
            ],
            [
                args.cropping,
                args.cropping
            ]
        ];
        else if (typeof args.cropping[0] === 'number') this.cropping = [
            [
                args.cropping[0],
                args.cropping[0]
            ],
            [
                args.cropping[1],
                args.cropping[1]
            ]
        ];
        else this.cropping = args.cropping;
        this.dataFormat = args.dataFormat === undefined ? 'channelsLast' : args.dataFormat;
        this.inputSpec = [
            {
                ndim: 4
            }
        ];
    }
    computeOutputShape(inputShape) {
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            inputShape[2] - this.cropping[0][0] - this.cropping[0][1],
            inputShape[3] - this.cropping[1][0] - this.cropping[1][1]
        ];
        else return [
            inputShape[0],
            inputShape[1] - this.cropping[0][0] - this.cropping[0][1],
            inputShape[2] - this.cropping[1][0] - this.cropping[1][1],
            inputShape[3]
        ];
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (this.dataFormat === 'channelsLast') {
                const hSliced = $4AyI5.sliceAlongAxis(inputs, this.cropping[0][0], inputs.shape[1] - this.cropping[0][0] - this.cropping[0][1], 2);
                return $4AyI5.sliceAlongAxis(hSliced, this.cropping[1][0], inputs.shape[2] - this.cropping[1][1] - this.cropping[1][0], 3);
            } else {
                const hSliced = $4AyI5.sliceAlongAxis(inputs, this.cropping[0][0], inputs.shape[2] - this.cropping[0][0] - this.cropping[0][1], 3);
                return $4AyI5.sliceAlongAxis(hSliced, this.cropping[1][0], inputs.shape[3] - this.cropping[1][1] - this.cropping[1][0], 4);
            }
        });
    }
    getConfig() {
        const config = {
            cropping: this.cropping,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$8c24c9344a3b8089.className = 'Cropping2D';
(0, $ki3lz).registerClass($a854d86ccf3d93ce$export$8c24c9344a3b8089);
class $a854d86ccf3d93ce$export$4b8be6e684923935 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.DEFAULT_SIZE = [
            2,
            2
        ];
        this.inputSpec = [
            {
                ndim: 4
            }
        ];
        this.size = args.size == null ? this.DEFAULT_SIZE : args.size;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $1Xyaa.checkDataFormat)(this.dataFormat);
        this.interpolation = args.interpolation == null ? 'nearest' : args.interpolation;
        (0, $1Xyaa.checkInterpolationFormat)(this.interpolation);
    }
    computeOutputShape(inputShape) {
        if (this.dataFormat === 'channelsFirst') {
            const height = inputShape[2] == null ? null : this.size[0] * inputShape[2];
            const width = inputShape[3] == null ? null : this.size[1] * inputShape[3];
            return [
                inputShape[0],
                inputShape[1],
                height,
                width
            ];
        } else {
            const height = inputShape[1] == null ? null : this.size[0] * inputShape[1];
            const width = inputShape[2] == null ? null : this.size[1] * inputShape[2];
            return [
                inputShape[0],
                height,
                width,
                inputShape[3]
            ];
        }
    }
    call(inputs, kwargs) {
        return $d7Nxs.tidy(()=>{
            let input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            const inputShape = input.shape;
            if (this.dataFormat === 'channelsFirst') {
                input = $9c2so.transpose(input, [
                    0,
                    2,
                    3,
                    1
                ]);
                const height = this.size[0] * inputShape[2];
                const width = this.size[1] * inputShape[3];
                const resized = this.interpolation === 'nearest' ? $4I5dI.image.resizeNearestNeighbor(input, [
                    height,
                    width
                ]) : $4I5dI.image.resizeBilinear(input, [
                    height,
                    width
                ]);
                return $9c2so.transpose(resized, [
                    0,
                    3,
                    1,
                    2
                ]);
            } else {
                const height = this.size[0] * inputShape[1];
                const width = this.size[1] * inputShape[2];
                return this.interpolation === 'nearest' ? $4I5dI.image.resizeNearestNeighbor(input, [
                    height,
                    width
                ]) : $4I5dI.image.resizeBilinear(input, [
                    height,
                    width
                ]);
            }
        });
    }
    getConfig() {
        const config = {
            size: this.size,
            dataFormat: this.dataFormat,
            interpolation: this.interpolation
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $a854d86ccf3d93ce$export$4b8be6e684923935.className = 'UpSampling2D';
(0, $ki3lz).registerClass($a854d86ccf3d93ce$export$4b8be6e684923935);

});
parcelRegister("aT5kh", function(module, exports) {

$parcel$export(module.exports, "normalizeArray", function () { return $7ed32c17b823d534$export$8f561980df117376; });
$parcel$export(module.exports, "convOutputLength", function () { return $7ed32c17b823d534$export$50b0adaed374172; });
$parcel$export(module.exports, "deconvLength", function () { return $7ed32c17b823d534$export$5a2f093e914c7860; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $kubuc = parcelRequire("kubuc");

var $jYx5u = parcelRequire("jYx5u");

var $4SWqG = parcelRequire("4SWqG");
function $7ed32c17b823d534$export$8f561980df117376(value, n, name) {
    if (typeof value === 'number') return (0, $jYx5u.pyListRepeat)(value, n);
    else {
        if (value.length !== n) throw new (0, $kubuc.ValueError)(`The ${name} argument must be an integer or tuple of ${n} integers.` + ` Received: ${value.length} elements.`);
        for(let i = 0; i < n; ++i){
            const singleValue = value[i];
            if (!(0, $4SWqG.isInteger)(singleValue)) throw new (0, $kubuc.ValueError)(`The ${name} argument must be an integer or tuple of ${n}` + ` integers. Received: ${JSON.stringify(value)} including a` + ` non-integer number ${singleValue}`);
        }
        return value;
    }
}
function $7ed32c17b823d534$export$50b0adaed374172(inputLength, filterSize, padding, stride, dilation = 1) {
    if (inputLength == null) return inputLength;
    const dilatedFilterSize = filterSize + (filterSize - 1) * (dilation - 1);
    let outputLength;
    if (padding === 'same') outputLength = inputLength;
    else outputLength = inputLength - dilatedFilterSize + 1;
    return Math.floor((outputLength + stride - 1) / stride);
}
function $7ed32c17b823d534$export$5a2f093e914c7860(dimSize, strideSize, kernelSize, padding) {
    if (dimSize == null) return null;
    if (padding === 'valid') dimSize = dimSize * strideSize + (0, $4SWqG.max)([
        kernelSize - strideSize,
        0
    ]);
    else if (padding === 'same') dimSize = dimSize * strideSize;
    else throw new (0, $kubuc.ValueError)(`Unsupport padding mode: ${padding}.`);
    return dimSize;
}

});


parcelRegister("3jlGK", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2D", function () { return $2693f850750a9350$export$292dab92c4661cc4; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Depthwise Convolutional Layers
 */ parcelRequire("8AHkS");
var $kQqya = parcelRequire("kQqya");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");
var $9c2so = parcelRequire("9c2so");

var $69VqB = parcelRequire("69VqB");

var $4AyI5 = parcelRequire("4AyI5");

var $1Xyaa = parcelRequire("1Xyaa");

var $ghUz9 = parcelRequire("ghUz9");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $1NdPD = parcelRequire("1NdPD");

var $aT5kh = parcelRequire("aT5kh");

var $bMNfZ = parcelRequire("bMNfZ");

var $es1va = parcelRequire("es1va");
function $2693f850750a9350$export$48a8ad9494a8fad8(x, depthwiseKernel, strides = [
    1,
    1
], padding = 'valid', dataFormat, dilationRate) {
    return (0, $d7Nxs.tidy)(()=>{
        if (dataFormat == null) dataFormat = (0, $69VqB.imageDataFormat)();
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        let y = (0, $es1va.preprocessConv2DInput)(x, dataFormat);
        if (x.rank !== 4) throw new (0, $kubuc.ValueError)(`Input for depthwiseConv2d is required to be 4-D, but is instead ` + `${x.rank}-D`);
        if (depthwiseKernel.rank !== 4) throw new (0, $kubuc.ValueError)(`depthwiseKernel is required to be 4-D, but is instead ` + `${depthwiseKernel.rank}-D`);
        y = $kQqya.depthwiseConv2d(y, depthwiseKernel, strides, padding === 'same' ? 'same' : 'valid', 'NHWC', dilationRate);
        if (dataFormat === 'channelsFirst') y = $9c2so.transpose(y, [
            0,
            3,
            1,
            2
        ]);
        return y;
    });
}
class $2693f850750a9350$export$292dab92c4661cc4 extends (0, $es1va.BaseConv) {
    constructor(args){
        super(2, args);
        this.depthwiseKernel = null;
        this.depthMultiplier = args.depthMultiplier == null ? 1 : args.depthMultiplier;
        this.depthwiseInitializer = (0, $lHlnu.getInitializer)(args.depthwiseInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.depthwiseConstraint = (0, $ghUz9.getConstraint)(args.depthwiseConstraint);
        this.depthwiseRegularizer = (0, $1NdPD.getRegularizer)(args.depthwiseRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        if (inputShape.length < 4) throw new (0, $kubuc.ValueError)(`Inputs to DepthwiseConv2D should have rank 4. ` + `Received input shape: ${JSON.stringify(inputShape)}.`);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : 3;
        if (inputShape[channelAxis] == null || inputShape[channelAxis] < 0) throw new (0, $kubuc.ValueError)('The channel dimension of the inputs to DepthwiseConv2D should ' + `be defined, but is not (${inputShape[channelAxis]}).`);
        const inputDim = inputShape[channelAxis];
        const depthwiseKernelShape = [
            this.kernelSize[0],
            this.kernelSize[1],
            inputDim,
            this.depthMultiplier
        ];
        this.depthwiseKernel = this.addWeight('depthwise_kernel', depthwiseKernelShape, null, this.depthwiseInitializer, this.depthwiseRegularizer, true, this.depthwiseConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            inputDim * this.depthMultiplier
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            let outputs = $2693f850750a9350$export$48a8ad9494a8fad8(inputs, this.depthwiseKernel.read(), this.strides, this.padding, this.dataFormat, null);
            // TODO(cais): Add support for dilation.
            if (this.useBias) outputs = $4AyI5.biasAdd(outputs, this.bias.read(), this.dataFormat);
            if (this.activation != null) outputs = this.activation.apply(outputs);
            return outputs;
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const rows = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        const cols = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        const outFilters = this.dataFormat === 'channelsFirst' ? inputShape[1] * this.depthMultiplier : inputShape[3] * this.depthMultiplier;
        const outRows = (0, $aT5kh.convOutputLength)(rows, this.kernelSize[0], this.padding, this.strides[0]);
        const outCols = (0, $aT5kh.convOutputLength)(cols, this.kernelSize[1], this.padding, this.strides[1]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            outFilters,
            outRows,
            outCols
        ];
        else // In this case, assume 'channelsLast'.
        return [
            inputShape[0],
            outRows,
            outCols,
            outFilters
        ];
    }
    getConfig() {
        const config = super.getConfig();
        config['depthMultiplier'] = this.depthMultiplier;
        config['depthwiseInitializer'] = (0, $lHlnu.serializeInitializer)(this.depthwiseInitializer);
        config['depthwiseRegularizer'] = (0, $1NdPD.serializeRegularizer)(this.depthwiseRegularizer);
        config['depthwiseConstraint'] = (0, $ghUz9.serializeConstraint)(this.depthwiseRegularizer);
        return config;
    }
}
/** @nocollapse */ $2693f850750a9350$export$292dab92c4661cc4.className = 'DepthwiseConv2D';
(0, $ki3lz).registerClass($2693f850750a9350$export$292dab92c4661cc4);

});

parcelRegister("9SBfE", function(module, exports) {

$parcel$export(module.exports, "ConvLSTM2DCell", function () { return $73160d900fdce948$export$6fd0801294342e82; });
$parcel$export(module.exports, "ConvLSTM2D", function () { return $73160d900fdce948$export$d5828f4b24c3231; });
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $9JluG = parcelRequire("9JluG");
var $d7Nxs = parcelRequire("d7Nxs");
var $5hAos = parcelRequire("5hAos");
var $K2k22 = parcelRequire("K2k22");
var $6zg0w = parcelRequire("6zg0w");
var $ki3lz = parcelRequire("ki3lz");
var $crriC = parcelRequire("crriC");
var $lBDHD = parcelRequire("lBDHD");
var $lxzgt = parcelRequire("lxzgt");

var $4AyI5 = parcelRequire("4AyI5");

var $1Xyaa = parcelRequire("1Xyaa");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $aT5kh = parcelRequire("aT5kh");

var $jYx5u = parcelRequire("jYx5u");

var $bMNfZ = parcelRequire("bMNfZ");

var $2QjI9 = parcelRequire("2QjI9");
var $73160d900fdce948$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $73160d900fdce948$var$ConvRNN2DCell extends (0, $2QjI9.RNNCell) {
}
/**
 * Base class for convolutional-recurrent layers.
 */ class $73160d900fdce948$var$ConvRNN2D extends (0, $2QjI9.RNN) {
    constructor(args){
        if (args.unroll) throw new (0, $kubuc.NotImplementedError)('Unrolling is not possible with convolutional RNNs.');
        if (Array.isArray(args.cell)) throw new (0, $kubuc.NotImplementedError)('It is not possible at the moment to stack convolutional cells.');
        super(args);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 5
            })
        ];
    }
    call(inputs, kwargs) {
        return $d7Nxs.tidy(()=>{
            if (this.cell.dropoutMask != null) {
                $d7Nxs.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $d7Nxs.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            if (kwargs && kwargs['constants']) throw new (0, $kubuc.ValueError)('ConvRNN2D cell does not support constants');
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    computeOutputShape(inputShape) {
        let outShape = this.computeSingleOutputShape(inputShape);
        if (!this.returnSequences) outShape = [
            outShape[0],
            ...outShape.slice(2)
        ];
        if (this.returnState) outShape = [
            outShape,
            ...Array(2).fill([
                inputShape[0],
                ...outShape.slice(-3)
            ])
        ];
        return outShape;
    }
    getInitialState(inputs) {
        return $d7Nxs.tidy(()=>{
            const { stateSize: stateSize } = this.cell;
            const inputShape = inputs.shape;
            const outputShape = this.computeSingleOutputShape(inputShape);
            const stateShape = [
                outputShape[0],
                ...outputShape.slice(2)
            ];
            const initialState = $lxzgt.zeros(stateShape);
            if (Array.isArray(stateSize)) return Array(stateSize.length).fill(initialState);
            return [
                initialState
            ];
        });
    }
    resetStates(states, training = false) {
        $d7Nxs.tidy(()=>{
            if (!this.stateful) throw new (0, $kubuc.AttributeError)('Cannot call resetStates() on an RNN Layer that is not stateful.');
            const inputShape = this.inputSpec[0].shape;
            const outputShape = this.computeSingleOutputShape(inputShape);
            const stateShape = [
                outputShape[0],
                ...outputShape.slice(2)
            ];
            const batchSize = inputShape[0];
            if (batchSize == null) throw new (0, $kubuc.ValueError)("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
            // Initialize state if null.
            if (this.getStates() == null) {
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map(()=>$lxzgt.zeros(stateShape));
                else this.states_ = [
                    $lxzgt.zeros(stateShape)
                ];
            } else if (states == null) {
                // Dispose old state tensors.
                $d7Nxs.dispose(this.states_);
                // For stateful RNNs, fully dispose kept old states.
                if (this.keptStates != null) {
                    $d7Nxs.dispose(this.keptStates);
                    this.keptStates = [];
                }
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map(()=>$lxzgt.zeros(stateShape));
                else this.states_[0] = $lxzgt.zeros(stateShape);
            } else {
                if (!Array.isArray(states)) states = [
                    states
                ];
                if (states.length !== this.states_.length) throw new (0, $kubuc.ValueError)(`Layer ${this.name} expects ${this.states_.length} state(s), ` + `but it received ${states.length} state value(s). Input ` + `received: ${states}`);
                if (training) // Store old state tensors for complete disposal later, i.e., during
                // the next no-arg call to this method. We do not dispose the old
                // states immediately because that BPTT (among other things) require
                // them.
                this.keptStates.push(this.states_.slice());
                else $d7Nxs.dispose(this.states_);
                for(let index = 0; index < this.states_.length; ++index){
                    const value = states[index];
                    const expectedShape = stateShape;
                    if (!(0, $lBDHD).arraysEqual(value.shape, expectedShape)) throw new (0, $kubuc.ValueError)(`State ${index} is incompatible with layer ${this.name}: ` + `expected shape=${expectedShape}, received shape=${value.shape}`);
                    this.states_[index] = value;
                }
            }
            this.states_ = this.states_.map((state)=>$d7Nxs.keep(state.clone()));
        });
    }
    computeSingleOutputShape(inputShape) {
        const { dataFormat: dataFormat, filters: filters, kernelSize: kernelSize, padding: padding, strides: strides, dilationRate: dilationRate } = this.cell;
        const isChannelsFirst = dataFormat === 'channelsFirst';
        const h = inputShape[isChannelsFirst ? 3 : 2];
        const w = inputShape[isChannelsFirst ? 4 : 3];
        const hOut = (0, $aT5kh.convOutputLength)(h, kernelSize[0], padding, strides[0], dilationRate[0]);
        const wOut = (0, $aT5kh.convOutputLength)(w, kernelSize[1], padding, strides[1], dilationRate[1]);
        const outShape = [
            ...inputShape.slice(0, 2),
            ...isChannelsFirst ? [
                filters,
                hOut,
                wOut
            ] : [
                hOut,
                wOut,
                filters
            ]
        ];
        return outShape;
    }
}
/** @nocollapse */ $73160d900fdce948$var$ConvRNN2D.className = 'ConvRNN2D';
class $73160d900fdce948$export$6fd0801294342e82 extends (0, $2QjI9.LSTMCell) {
    constructor(args){
        const { filters: filters, kernelSize: kernelSize, strides: strides, padding: padding, dataFormat: dataFormat, dilationRate: dilationRate } = args;
        super(Object.assign(Object.assign({}, args), {
            units: filters
        }));
        this.filters = filters;
        (0, $jYx5u.assertPositiveInteger)(this.filters, 'filters');
        this.kernelSize = (0, $aT5kh.normalizeArray)(kernelSize, 2, 'kernelSize');
        this.kernelSize.forEach((size)=>(0, $jYx5u.assertPositiveInteger)(size, 'kernelSize'));
        this.strides = (0, $aT5kh.normalizeArray)(strides || 1, 2, 'strides');
        this.strides.forEach((stride)=>(0, $jYx5u.assertPositiveInteger)(stride, 'strides'));
        this.padding = padding || 'valid';
        (0, $1Xyaa.checkPaddingMode)(this.padding);
        this.dataFormat = dataFormat || 'channelsLast';
        (0, $1Xyaa.checkDataFormat)(this.dataFormat);
        this.dilationRate = (0, $aT5kh.normalizeArray)(dilationRate || 1, 2, 'dilationRate');
        this.dilationRate.forEach((rate)=>(0, $jYx5u.assertPositiveInteger)(rate, 'dilationRate'));
    }
    build(inputShape) {
        var _a;
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const channelAxis = this.dataFormat === 'channelsFirst' ? 1 : inputShape.length - 1;
        if (inputShape[channelAxis] == null) throw new (0, $kubuc.ValueError)(`The channel dimension of the input should be defined. ` + `Found ${inputShape[channelAxis]}`);
        const inputDim = inputShape[channelAxis];
        const numOfKernels = 4;
        const kernelShape = this.kernelSize.concat([
            inputDim,
            this.filters * numOfKernels
        ]);
        this.kernel = this.addWeight('kernel', kernelShape, null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        const recurrentKernelShape = this.kernelSize.concat([
            this.filters,
            this.filters * numOfKernels
        ]);
        this.recurrentKernel = this.addWeight('recurrent_kernel', recurrentKernelShape, null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) {
            let biasInitializer;
            if (this.unitForgetBias) {
                const init = this.biasInitializer;
                const filters = this.filters;
                biasInitializer = new (_a = class CustomInit extends (0, $lHlnu.Initializer) {
                    apply(shape, dtype) {
                        const biasI = init.apply([
                            filters
                        ]);
                        const biasF = $K2k22.ones([
                            filters
                        ]);
                        const biasCAndO = init.apply([
                            filters * 2
                        ]);
                        return $4AyI5.concatenate([
                            biasI,
                            biasF,
                            biasCAndO
                        ]);
                    }
                }, /** @nocollapse */ _a.className = 'CustomInit', _a)();
            } else biasInitializer = this.biasInitializer;
            this.bias = this.addWeight('bias', [
                this.filters * numOfKernels
            ], null, biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        }
        this.built = true;
    }
    call(inputs, kwargs) {
        return $d7Nxs.tidy(()=>{
            if (inputs.length !== 3) throw new (0, $kubuc.ValueError)(`ConvLSTM2DCell expects 3 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            const training = kwargs['training'] || false;
            const x = inputs[0]; // Current input
            const hTMinus1 = inputs[1]; // Previous memory state.
            const cTMinus1 = inputs[2]; // Previous carry state.
            const numOfKernels = 4;
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = (0, $2QjI9.generateDropoutMask)({
                ones: ()=>$6zg0w.onesLike(x),
                rate: this.dropout,
                training: training,
                count: numOfKernels,
                dropoutFunc: this.dropoutFunc
            });
            const dropoutMask = this.dropoutMask;
            const applyDropout = (x, mask, index)=>{
                if (!mask || !mask[index]) return x;
                return $5hAos.mul(mask[index], x);
            };
            let xI = applyDropout(x, dropoutMask, 0);
            let xF = applyDropout(x, dropoutMask, 1);
            let xC = applyDropout(x, dropoutMask, 2);
            let xO = applyDropout(x, dropoutMask, 3);
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = (0, $2QjI9.generateDropoutMask)({
                ones: ()=>$6zg0w.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: numOfKernels,
                dropoutFunc: this.dropoutFunc
            });
            const recDropoutMask = this.recurrentDropoutMask;
            let hI = applyDropout(hTMinus1, recDropoutMask, 0);
            let hF = applyDropout(hTMinus1, recDropoutMask, 1);
            let hC = applyDropout(hTMinus1, recDropoutMask, 2);
            let hO = applyDropout(hTMinus1, recDropoutMask, 3);
            const kernelChannelAxis = 3;
            const [kernelI, kernelF, kernelC, kernelO] = $crriC.split(this.kernel.read(), numOfKernels, kernelChannelAxis);
            const [biasI, biasF, biasC, biasO] = this.useBias ? $crriC.split(this.bias.read(), numOfKernels) : [
                null,
                null,
                null,
                null
            ];
            xI = this.inputConv(xI, kernelI, biasI, this.padding);
            xF = this.inputConv(xF, kernelF, biasF, this.padding);
            xC = this.inputConv(xC, kernelC, biasC, this.padding);
            xO = this.inputConv(xO, kernelO, biasO, this.padding);
            const [recKernelI, recKernelF, recKernelC, recKernelO] = $crriC.split(this.recurrentKernel.read(), numOfKernels, kernelChannelAxis);
            hI = this.recurrentConv(hI, recKernelI);
            hF = this.recurrentConv(hF, recKernelF);
            hC = this.recurrentConv(hC, recKernelC);
            hO = this.recurrentConv(hO, recKernelO);
            const i = this.recurrentActivation.apply($6Ab5n.add(xI, hI));
            const f = this.recurrentActivation.apply($6Ab5n.add(xF, hF));
            const c = $6Ab5n.add($5hAos.mul(f, cTMinus1), $5hAos.mul(i, this.activation.apply($6Ab5n.add(xC, hC))));
            const h = $5hAos.mul(this.recurrentActivation.apply($6Ab5n.add(xO, hO)), this.activation.apply(c));
            return [
                h,
                h,
                c
            ];
        });
    }
    getConfig() {
        const _a = super.getConfig(), { 'units': _ } = _a, baseConfig = $73160d900fdce948$var$__rest(_a, [
            'units'
        ]);
        const config = {
            filters: this.filters,
            kernelSize: this.kernelSize,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            strides: this.strides
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
    inputConv(x, w, b, padding) {
        const out = $9JluG.conv2d(x, w, this.strides, padding || 'valid', this.dataFormat === 'channelsFirst' ? 'NCHW' : 'NHWC', this.dilationRate);
        if (b) return $4AyI5.biasAdd(out, b, this.dataFormat);
        return out;
    }
    recurrentConv(x, w) {
        const strides = 1;
        return $9JluG.conv2d(x, w, strides, 'same', this.dataFormat === 'channelsFirst' ? 'NCHW' : 'NHWC');
    }
}
/** @nocollapse */ $73160d900fdce948$export$6fd0801294342e82.className = 'ConvLSTM2DCell';
$ki3lz.registerClass($73160d900fdce948$export$6fd0801294342e82);
class $73160d900fdce948$export$d5828f4b24c3231 extends $73160d900fdce948$var$ConvRNN2D {
    constructor(args){
        const cell = new $73160d900fdce948$export$6fd0801294342e82(args);
        super(Object.assign(Object.assign({}, args), {
            cell: cell
        }));
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
/** @nocollapse */ $73160d900fdce948$export$d5828f4b24c3231.className = 'ConvLSTM2D';
$ki3lz.registerClass($73160d900fdce948$export$d5828f4b24c3231);

});
parcelRegister("2QjI9", function(module, exports) {

$parcel$export(module.exports, "standardizeArgs", function () { return $211fba51f5650b28$export$b9ab3f5c89688c2; });
$parcel$export(module.exports, "rnn", function () { return $211fba51f5650b28$export$3e66d5ce8f778ebc; });
$parcel$export(module.exports, "RNN", function () { return $211fba51f5650b28$export$2b97bcdf1d6f1b16; });
$parcel$export(module.exports, "StackedRNNCells", function () { return $211fba51f5650b28$export$966a21a552328009; });
$parcel$export(module.exports, "RNNCell", function () { return $211fba51f5650b28$export$405d8fca8f98aafd; });
$parcel$export(module.exports, "SimpleRNNCell", function () { return $211fba51f5650b28$export$c8a45b8cd42f689; });
$parcel$export(module.exports, "generateDropoutMask", function () { return $211fba51f5650b28$export$9eb0cce22b72569f; });
$parcel$export(module.exports, "SimpleRNN", function () { return $211fba51f5650b28$export$9f3b0efd8738b035; });
$parcel$export(module.exports, "GRUCell", function () { return $211fba51f5650b28$export$dad94e00e5c3737; });
$parcel$export(module.exports, "GRU", function () { return $211fba51f5650b28$export$effa27cfcc4408f4; });
$parcel$export(module.exports, "LSTMCell", function () { return $211fba51f5650b28$export$17aacc547a045ab0; });
$parcel$export(module.exports, "LSTM", function () { return $211fba51f5650b28$export$c8c9213153497ce0; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Recurrent Neural Network Layers.
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $fxiHg = parcelRequire("fxiHg");
var $d7Nxs = parcelRequire("d7Nxs");
var $fO4kJ = parcelRequire("fO4kJ");
var $5hAos = parcelRequire("5hAos");
var $jMlCE = parcelRequire("jMlCE");
var $6zg0w = parcelRequire("6zg0w");
var $5ApPj = parcelRequire("5ApPj");
var $ki3lz = parcelRequire("ki3lz");
var $crriC = parcelRequire("crriC");
var $lq9U1 = parcelRequire("lq9U1");
var $5jGN9 = parcelRequire("5jGN9");
var $fPnAL = parcelRequire("fPnAL");
var $9c2so = parcelRequire("9c2so");
var $3mzDh = parcelRequire("3mzDh");
var $lBDHD = parcelRequire("lBDHD");
var $lxzgt = parcelRequire("lxzgt");

var $5xdqh = parcelRequire("5xdqh");

var $4AyI5 = parcelRequire("4AyI5");

var $1Xyaa = parcelRequire("1Xyaa");

var $ghUz9 = parcelRequire("ghUz9");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $1NdPD = parcelRequire("1NdPD");

var $jYx5u = parcelRequire("jYx5u");

var $4SWqG = parcelRequire("4SWqG");

var $bMNfZ = parcelRequire("bMNfZ");

var $pKVrB = parcelRequire("pKVrB");

var $4v3Le = parcelRequire("4v3Le");
function $211fba51f5650b28$export$b9ab3f5c89688c2(inputs, initialState, constants, numConstants) {
    if (Array.isArray(inputs)) {
        if (initialState != null || constants != null) throw new (0, $kubuc.ValueError)("When inputs is an array, neither initialState or constants should be provided");
        if (numConstants != null) {
            constants = inputs.slice(inputs.length - numConstants, inputs.length);
            inputs = inputs.slice(0, inputs.length - numConstants);
        }
        if (inputs.length > 1) initialState = inputs.slice(1, inputs.length);
        inputs = inputs[0];
    }
    function toListOrNull(x) {
        if (x == null || Array.isArray(x)) return x;
        else return [
            x
        ];
    }
    initialState = toListOrNull(initialState);
    constants = toListOrNull(constants);
    return {
        inputs: inputs,
        initialState: initialState,
        constants: constants
    };
}
function $211fba51f5650b28$export$3e66d5ce8f778ebc(stepFunction, inputs, initialStates, goBackwards = false, mask, constants, unroll = false, needPerStepOutputs = false) {
    return $d7Nxs.tidy(()=>{
        const ndim = inputs.shape.length;
        if (ndim < 3) throw new (0, $kubuc.ValueError)(`Input should be at least 3D, but is ${ndim}D.`);
        // Transpose to time-major, i.e., from [batch, time, ...] to [time, batch,
        // ...].
        const axes = [
            1,
            0
        ].concat($4SWqG.range(2, ndim));
        inputs = $9c2so.transpose(inputs, axes);
        if (constants != null) throw new (0, $kubuc.NotImplementedError)("The rnn() functoin of the deeplearn.js backend does not support constants yet.");
        // Porting Note: the unroll option is ignored by the imperative backend.
        if (unroll) console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend.");
        if (mask != null) {
            mask = $fxiHg.cast($fxiHg.cast(mask, 'bool'), 'float32');
            if (mask.rank === ndim - 1) mask = $fO4kJ.expandDims(mask, -1);
            mask = $9c2so.transpose(mask, axes);
        }
        if (goBackwards) {
            inputs = $5ApPj.reverse(inputs, 0);
            if (mask != null) mask = $5ApPj.reverse(mask, 0);
        }
        // Porting Note: PyKeras with TensorFlow backend uses a symbolic loop
        //   (tf.while_loop). But for the imperative deeplearn.js backend, we just
        //   use the usual TypeScript control flow to iterate over the time steps in
        //   the inputs.
        // Porting Note: PyKeras patches a "_use_learning_phase" attribute to
        // outputs.
        //   This is not idiomatic in TypeScript. The info regarding whether we are
        //   in a learning (i.e., training) phase for RNN is passed in a different
        //   way.
        const perStepOutputs = [];
        let lastOutput;
        let states = initialStates;
        const timeSteps = inputs.shape[0];
        const perStepInputs = $3mzDh.unstack(inputs);
        let perStepMasks;
        if (mask != null) perStepMasks = $3mzDh.unstack(mask);
        for(let t = 0; t < timeSteps; ++t){
            const currentInput = perStepInputs[t];
            const stepOutputs = $d7Nxs.tidy(()=>stepFunction(currentInput, states));
            if (mask == null) {
                lastOutput = stepOutputs[0];
                states = stepOutputs[1];
            } else {
                const maskedOutputs = $d7Nxs.tidy(()=>{
                    const stepMask = perStepMasks[t];
                    const negStepMask = $5jGN9.sub($6zg0w.onesLike(stepMask), stepMask);
                    // TODO(cais): Would tfc.where() be better for performance?
                    const output = $6Ab5n.add($5hAos.mul(stepOutputs[0], stepMask), $5hAos.mul(states[0], negStepMask));
                    const newStates = states.map((state, i)=>{
                        return $6Ab5n.add($5hAos.mul(stepOutputs[1][i], stepMask), $5hAos.mul(state, negStepMask));
                    });
                    return {
                        output: output,
                        newStates: newStates
                    };
                });
                lastOutput = maskedOutputs.output;
                states = maskedOutputs.newStates;
            }
            if (needPerStepOutputs) perStepOutputs.push(lastOutput);
        }
        let outputs;
        if (needPerStepOutputs) {
            const axis = 1;
            outputs = $lq9U1.stack(perStepOutputs, axis);
        }
        return [
            lastOutput,
            outputs,
            states
        ];
    });
}
class $211fba51f5650b28$export$2b97bcdf1d6f1b16 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        let cell;
        if (args.cell == null) throw new (0, $kubuc.ValueError)('cell property is missing for the constructor of RNN.');
        else if (Array.isArray(args.cell)) cell = new $211fba51f5650b28$export$966a21a552328009({
            cells: args.cell
        });
        else cell = args.cell;
        if (cell.stateSize == null) throw new (0, $kubuc.ValueError)("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");
        this.cell = cell;
        this.returnSequences = args.returnSequences == null ? false : args.returnSequences;
        this.returnState = args.returnState == null ? false : args.returnState;
        this.goBackwards = args.goBackwards == null ? false : args.goBackwards;
        this._stateful = args.stateful == null ? false : args.stateful;
        this.unroll = args.unroll == null ? false : args.unroll;
        this.supportsMasking = true;
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 3
            })
        ];
        this.stateSpec = null;
        this.states_ = null;
        // TODO(cais): Add constantsSpec and numConstants.
        this.numConstants = null;
        // TODO(cais): Look into the use of initial_state in the kwargs of the
        //   constructor.
        this.keptStates = [];
    }
    // Porting Note: This is the equivalent of `RNN.states` property getter in
    //   PyKeras.
    getStates() {
        if (this.states_ == null) {
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            return $4SWqG.range(0, numStates).map((x)=>null);
        } else return this.states_;
    }
    // Porting Note: This is the equivalent of the `RNN.states` property setter in
    //   PyKeras.
    setStates(states) {
        this.states_ = states;
    }
    computeOutputShape(inputShape) {
        if ((0, $bMNfZ.isArrayOfShapes)(inputShape)) inputShape = inputShape[0];
        inputShape;
        // TODO(cais): Remove the casting once stacked RNN cells become supported.
        let stateSize = this.cell.stateSize;
        if (!Array.isArray(stateSize)) stateSize = [
            stateSize
        ];
        const outputDim = stateSize[0];
        let outputShape;
        if (this.returnSequences) outputShape = [
            inputShape[0],
            inputShape[1],
            outputDim
        ];
        else outputShape = [
            inputShape[0],
            outputDim
        ];
        if (this.returnState) {
            const stateShape = [];
            for (const dim of stateSize)stateShape.push([
                inputShape[0],
                dim
            ]);
            return [
                outputShape
            ].concat(stateShape);
        } else return outputShape;
    }
    computeMask(inputs, mask) {
        return $d7Nxs.tidy(()=>{
            if (Array.isArray(mask)) mask = mask[0];
            const outputMask = this.returnSequences ? mask : null;
            if (this.returnState) {
                const stateMask = this.states.map((s)=>null);
                return [
                    outputMask
                ].concat(stateMask);
            } else return outputMask;
        });
    }
    /**
     * Get the current state tensors of the RNN.
     *
     * If the state hasn't been set, return an array of `null`s of the correct
     * length.
     */ get states() {
        if (this.states_ == null) {
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            const output = [];
            for(let i = 0; i < numStates; ++i)output.push(null);
            return output;
        } else return this.states_;
    }
    set states(s) {
        this.states_ = s;
    }
    build(inputShape) {
        // Note inputShape will be an Array of Shapes of initial states and
        // constants if these are passed in apply().
        const constantShape = null;
        if (this.numConstants != null) throw new (0, $kubuc.NotImplementedError)('Constants support is not implemented in RNN yet.');
        if ((0, $bMNfZ.isArrayOfShapes)(inputShape)) inputShape = inputShape[0];
        inputShape;
        const batchSize = this.stateful ? inputShape[0] : null;
        const inputDim = inputShape.slice(2);
        this.inputSpec[0] = new (0, $jWpeh.InputSpec)({
            shape: [
                batchSize,
                null,
                ...inputDim
            ]
        });
        // Allow cell (if RNNCell Layer) to build before we set or validate
        // stateSpec.
        const stepInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        if (constantShape != null) throw new (0, $kubuc.NotImplementedError)('Constants support is not implemented in RNN yet.');
        else this.cell.build(stepInputShape);
        // Set or validate stateSpec.
        let stateSize;
        if (Array.isArray(this.cell.stateSize)) stateSize = this.cell.stateSize;
        else stateSize = [
            this.cell.stateSize
        ];
        if (this.stateSpec != null) {
            if (!(0, $lBDHD).arraysEqual(this.stateSpec.map((spec)=>spec.shape[spec.shape.length - 1]), stateSize)) throw new (0, $kubuc.ValueError)(`An initialState was passed that is not compatible with ` + `cell.stateSize. Received stateSpec=${this.stateSpec}; ` + `However cell.stateSize is ${this.cell.stateSize}`);
        } else this.stateSpec = stateSize.map((dim)=>new (0, $jWpeh.InputSpec)({
                shape: [
                    null,
                    dim
                ]
            }));
        if (this.stateful) this.resetStates();
    }
    /**
     * Reset the state tensors of the RNN.
     *
     * If the `states` argument is `undefined` or `null`, will set the
     * state tensor(s) of the RNN to all-zero tensors of the appropriate
     * shape(s).
     *
     * If `states` is provided, will set the state tensors of the RNN to its
     * value.
     *
     * @param states Optional externally-provided initial states.
     * @param training Whether this call is done during training. For stateful
     *   RNNs, this affects whether the old states are kept or discarded. In
     *   particular, if `training` is `true`, the old states will be kept so
     *   that subsequent backpropgataion through time (BPTT) may work properly.
     *   Else, the old states will be discarded.
     */ resetStates(states, training = false) {
        (0, $d7Nxs.tidy)(()=>{
            if (!this.stateful) throw new (0, $kubuc.AttributeError)('Cannot call resetStates() on an RNN Layer that is not stateful.');
            const batchSize = this.inputSpec[0].shape[0];
            if (batchSize == null) throw new (0, $kubuc.ValueError)("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
            // Initialize state if null.
            if (this.states_ == null) {
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map((dim)=>$lxzgt.zeros([
                        batchSize,
                        dim
                    ]));
                else this.states_ = [
                    $lxzgt.zeros([
                        batchSize,
                        this.cell.stateSize
                    ])
                ];
            } else if (states == null) {
                // Dispose old state tensors.
                $d7Nxs.dispose(this.states_);
                // For stateful RNNs, fully dispose kept old states.
                if (this.keptStates != null) {
                    $d7Nxs.dispose(this.keptStates);
                    this.keptStates = [];
                }
                if (Array.isArray(this.cell.stateSize)) this.states_ = this.cell.stateSize.map((dim)=>$lxzgt.zeros([
                        batchSize,
                        dim
                    ]));
                else this.states_[0] = $lxzgt.zeros([
                    batchSize,
                    this.cell.stateSize
                ]);
            } else {
                if (!Array.isArray(states)) states = [
                    states
                ];
                if (states.length !== this.states_.length) throw new (0, $kubuc.ValueError)(`Layer ${this.name} expects ${this.states_.length} state(s), ` + `but it received ${states.length} state value(s). Input ` + `received: ${states}`);
                if (training === true) // Store old state tensors for complete disposal later, i.e., during
                // the next no-arg call to this method. We do not dispose the old
                // states immediately because that BPTT (among other things) require
                // them.
                this.keptStates.push(this.states_.slice());
                else $d7Nxs.dispose(this.states_);
                for(let index = 0; index < this.states_.length; ++index){
                    const value = states[index];
                    const dim = Array.isArray(this.cell.stateSize) ? this.cell.stateSize[index] : this.cell.stateSize;
                    const expectedShape = [
                        batchSize,
                        dim
                    ];
                    if (!(0, $lBDHD).arraysEqual(value.shape, expectedShape)) throw new (0, $kubuc.ValueError)(`State ${index} is incompatible with layer ${this.name}: ` + `expected shape=${expectedShape}, received shape=${value.shape}`);
                    this.states_[index] = value;
                }
            }
            this.states_ = this.states_.map((state)=>$d7Nxs.keep(state.clone()));
        });
    }
    apply(inputs, kwargs) {
        // TODO(cais): Figure out whether initialState is in kwargs or inputs.
        let initialState = kwargs == null ? null : kwargs['initialState'];
        let constants = kwargs == null ? null : kwargs['constants'];
        if (kwargs == null) kwargs = {};
        const standardized = $211fba51f5650b28$export$b9ab3f5c89688c2(inputs, initialState, constants, this.numConstants);
        inputs = standardized.inputs;
        initialState = standardized.initialState;
        constants = standardized.constants;
        // If any of `initial_state` or `constants` are specified and are
        // `tf.SymbolicTensor`s, then add them to the inputs and temporarily modify
        // the input_spec to include them.
        let additionalInputs = [];
        let additionalSpecs = [];
        if (initialState != null) {
            kwargs['initialState'] = initialState;
            additionalInputs = additionalInputs.concat(initialState);
            this.stateSpec = [];
            for (const state of initialState)this.stateSpec.push(new (0, $jWpeh.InputSpec)({
                shape: state.shape
            }));
            // TODO(cais): Use the following instead.
            // this.stateSpec = initialState.map(state => new InputSpec({shape:
            // state.shape}));
            additionalSpecs = additionalSpecs.concat(this.stateSpec);
        }
        if (constants != null) {
            kwargs['constants'] = constants;
            additionalInputs = additionalInputs.concat(constants);
            // TODO(cais): Add this.constantsSpec.
            this.numConstants = constants.length;
        }
        const isTensor = additionalInputs[0] instanceof (0, $jWpeh.SymbolicTensor);
        if (isTensor) {
            // Compute full input spec, including state and constants.
            const fullInput = [
                inputs
            ].concat(additionalInputs);
            const fullInputSpec = this.inputSpec.concat(additionalSpecs);
            // Perform the call with temporarily replaced inputSpec.
            const originalInputSpec = this.inputSpec;
            this.inputSpec = fullInputSpec;
            const output = super.apply(fullInput, kwargs);
            this.inputSpec = originalInputSpec;
            return output;
        } else return super.apply(inputs, kwargs);
    }
    // tslint:disable-next-line:no-any
    call(inputs, kwargs) {
        // Input shape: `[samples, time (padded with zeros), input_dim]`.
        // Note that the .build() method of subclasses **must** define
        // this.inputSpec and this.stateSpec owith complete input shapes.
        return (0, $d7Nxs.tidy)(()=>{
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            let initialState = kwargs == null ? null : kwargs['initialState'];
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (initialState == null) {
                if (this.stateful) initialState = this.states_;
                else initialState = this.getInitialState(inputs);
            }
            const numStates = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
            if (initialState.length !== numStates) throw new (0, $kubuc.ValueError)(`RNN Layer has ${numStates} state(s) but was passed ` + `${initialState.length} initial state(s).`);
            if (this.unroll) console.warn('Ignoring unroll = true for RNN layer, due to imperative backend.');
            const cellCallKwargs = {
                training: training
            };
            // TODO(cais): Add support for constants.
            const step = (inputs, states)=>{
                // `inputs` and `states` are concatenated to form a single `Array` of
                // `tf.Tensor`s as the input to `cell.call()`.
                const outputs = this.cell.call([
                    inputs
                ].concat(states), cellCallKwargs);
                // Marshall the return value into output and new states.
                return [
                    outputs[0],
                    outputs.slice(1)
                ];
            };
            // TODO(cais): Add support for constants.
            const rnnOutputs = $211fba51f5650b28$export$3e66d5ce8f778ebc(step, inputs, initialState, this.goBackwards, mask, null, this.unroll, this.returnSequences);
            const lastOutput = rnnOutputs[0];
            const outputs = rnnOutputs[1];
            const states = rnnOutputs[2];
            if (this.stateful) this.resetStates(states, training);
            const output = this.returnSequences ? outputs : lastOutput;
            // TODO(cais): Property set learning phase flag.
            if (this.returnState) return [
                output
            ].concat(states);
            else return output;
        });
    }
    getInitialState(inputs) {
        return (0, $d7Nxs.tidy)(()=>{
            // Build an all-zero tensor of shape [samples, outputDim].
            // [Samples, timeSteps, inputDim].
            let initialState = $lxzgt.zeros(inputs.shape);
            // [Samples].
            initialState = $fPnAL.sum(initialState, [
                1,
                2
            ]);
            initialState = $4AyI5.expandDims(initialState); // [Samples, 1].
            if (Array.isArray(this.cell.stateSize)) return this.cell.stateSize.map((dim)=>dim > 1 ? $4AyI5.tile(initialState, [
                    1,
                    dim
                ]) : initialState);
            else return this.cell.stateSize > 1 ? [
                $4AyI5.tile(initialState, [
                    1,
                    this.cell.stateSize
                ])
            ] : [
                initialState
            ];
        });
    }
    get trainableWeights() {
        if (!this.trainable) return [];
        // Porting Note: In TypeScript, `this` is always an instance of `Layer`.
        return this.cell.trainableWeights;
    }
    get nonTrainableWeights() {
        // Porting Note: In TypeScript, `this` is always an instance of `Layer`.
        if (!this.trainable) return this.cell.weights;
        return this.cell.nonTrainableWeights;
    }
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.cell != null) this.cell.setFastWeightInitDuringBuild(value);
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            returnSequences: this.returnSequences,
            returnState: this.returnState,
            goBackwards: this.goBackwards,
            stateful: this.stateful,
            unroll: this.unroll
        };
        if (this.numConstants != null) config['numConstants'] = this.numConstants;
        const cellConfig = this.cell.getConfig();
        if (this.getClassName() === $211fba51f5650b28$export$2b97bcdf1d6f1b16.className) config['cell'] = {
            'className': this.cell.getClassName(),
            'config': cellConfig
        };
        // this order is necessary, to prevent cell name from replacing layer name
        return Object.assign(Object.assign(Object.assign({}, cellConfig), baseConfig), config);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const cellConfig = config['cell'];
        const cell = (0, $4v3Le.deserialize)(cellConfig, customObjects);
        return new cls(Object.assign(config, {
            cell: cell
        }));
    }
}
/** @nocollapse */ $211fba51f5650b28$export$2b97bcdf1d6f1b16.className = 'RNN';
(0, $ki3lz).registerClass($211fba51f5650b28$export$2b97bcdf1d6f1b16);
class $211fba51f5650b28$export$405d8fca8f98aafd extends (0, $jWpeh.Layer) {
}
class $211fba51f5650b28$export$c8a45b8cd42f689 extends $211fba51f5650b28$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        this.units = args.units;
        (0, $jYx5u.assertPositiveInteger)(this.units, `units`);
        this.activation = (0, $5xdqh.getActivation)(args.activation == null ? this.DEFAULT_ACTIVATION : args.activation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $lHlnu.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $lHlnu.getInitializer)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $lHlnu.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelRegularizer = (0, $1NdPD.getRegularizer)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $1NdPD.getRegularizer)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $1NdPD.getRegularizer)(args.biasRegularizer);
        this.kernelConstraint = (0, $ghUz9.getConstraint)(args.kernelConstraint);
        this.recurrentConstraint = (0, $ghUz9.getConstraint)(args.recurrentConstraint);
        this.biasConstraint = (0, $ghUz9.getConstraint)(args.biasConstraint);
        this.dropout = $4SWqG.min([
            1,
            $4SWqG.max([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $4SWqG.min([
            1,
            $4SWqG.max([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.stateSize = this.units;
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        // TODO(cais): Use regularizer.
        this.kernel = this.addWeight('kernel', [
            inputShape[inputShape.length - 1],
            this.units
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.units
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        this.built = true;
    }
    // Porting Note: PyKeras' equivalent of this method takes two tensor inputs:
    //   `inputs` and `states`. Here, the two tensors are combined into an
    //   `Tensor[]` Array as the first input argument.
    //   Similarly, PyKeras' equivalent of this method returns two values:
    //    `output` and `[output]`. Here the two are combined into one length-2
    //    `Tensor[]`, consisting of `output` repeated.
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs;
            if (inputs.length !== 2) throw new (0, $kubuc.ValueError)(`SimpleRNNCell expects 2 input Tensors, got ${inputs.length}.`);
            let prevOutput = inputs[1];
            inputs = inputs[0];
            const training = kwargs['training'] == null ? false : kwargs['training'];
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $211fba51f5650b28$export$9eb0cce22b72569f({
                ones: ()=>$6zg0w.onesLike(inputs),
                rate: this.dropout,
                training: training,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $211fba51f5650b28$export$9eb0cce22b72569f({
                ones: ()=>$6zg0w.onesLike(prevOutput),
                rate: this.recurrentDropout,
                training: training,
                dropoutFunc: this.dropoutFunc
            });
            let h;
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            if (dpMask != null) h = $4AyI5.dot($5hAos.mul(inputs, dpMask), this.kernel.read());
            else h = $4AyI5.dot(inputs, this.kernel.read());
            if (this.bias != null) h = $4AyI5.biasAdd(h, this.bias.read());
            if (recDpMask != null) prevOutput = $5hAos.mul(prevOutput, recDpMask);
            let output = $6Ab5n.add(h, $4AyI5.dot(prevOutput, this.recurrentKernel.read()));
            if (this.activation != null) output = this.activation.apply(output);
            // TODO(cais): Properly set learning phase on output tensor?
            return [
                output,
                output
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $5xdqh.serializeActivation)(this.activation),
            useBias: this.useBias,
            kernelInitializer: (0, $lHlnu.serializeInitializer)(this.kernelInitializer),
            recurrentInitializer: (0, $lHlnu.serializeInitializer)(this.recurrentInitializer),
            biasInitializer: (0, $lHlnu.serializeInitializer)(this.biasInitializer),
            kernelRegularizer: (0, $1NdPD.serializeRegularizer)(this.kernelRegularizer),
            recurrentRegularizer: (0, $1NdPD.serializeRegularizer)(this.recurrentRegularizer),
            biasRegularizer: (0, $1NdPD.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $1NdPD.serializeRegularizer)(this.activityRegularizer),
            kernelConstraint: (0, $ghUz9.serializeConstraint)(this.kernelConstraint),
            recurrentConstraint: (0, $ghUz9.serializeConstraint)(this.recurrentConstraint),
            biasConstraint: (0, $ghUz9.serializeConstraint)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
}
/** @nocollapse */ $211fba51f5650b28$export$c8a45b8cd42f689.className = 'SimpleRNNCell';
(0, $ki3lz).registerClass($211fba51f5650b28$export$c8a45b8cd42f689);
class $211fba51f5650b28$export$9f3b0efd8738b035 extends $211fba51f5650b28$export$2b97bcdf1d6f1b16 {
    constructor(args){
        args.cell = new $211fba51f5650b28$export$c8a45b8cd42f689(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $d7Nxs.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $d7Nxs.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        return new cls(config);
    }
}
/** @nocollapse */ $211fba51f5650b28$export$9f3b0efd8738b035.className = 'SimpleRNN';
(0, $ki3lz).registerClass($211fba51f5650b28$export$9f3b0efd8738b035);
class $211fba51f5650b28$export$dad94e00e5c3737 extends $211fba51f5650b28$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_RECURRENT_ACTIVATION = 'hardSigmoid';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        if (args.resetAfter) throw new (0, $kubuc.ValueError)(`GRUCell does not support reset_after parameter set to true.`);
        this.units = args.units;
        (0, $jYx5u.assertPositiveInteger)(this.units, 'units');
        this.activation = (0, $5xdqh.getActivation)(args.activation === undefined ? this.DEFAULT_ACTIVATION : args.activation);
        this.recurrentActivation = (0, $5xdqh.getActivation)(args.recurrentActivation === undefined ? this.DEFAULT_RECURRENT_ACTIVATION : args.recurrentActivation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $lHlnu.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $lHlnu.getInitializer)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $lHlnu.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelRegularizer = (0, $1NdPD.getRegularizer)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $1NdPD.getRegularizer)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $1NdPD.getRegularizer)(args.biasRegularizer);
        this.kernelConstraint = (0, $ghUz9.getConstraint)(args.kernelConstraint);
        this.recurrentConstraint = (0, $ghUz9.getConstraint)(args.recurrentConstraint);
        this.biasConstraint = (0, $ghUz9.getConstraint)(args.biasConstraint);
        this.dropout = $4SWqG.min([
            1,
            $4SWqG.max([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $4SWqG.min([
            1,
            $4SWqG.max([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.implementation = args.implementation;
        this.stateSize = this.units;
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const inputDim = inputShape[inputShape.length - 1];
        this.kernel = this.addWeight('kernel', [
            inputDim,
            this.units * 3
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units * 3
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        if (this.useBias) this.bias = this.addWeight('bias', [
            this.units * 3
        ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        else this.bias = null;
        // Porting Notes: Unlike the PyKeras implementation, we perform slicing
        //   of the weights and bias in the call() method, at execution time.
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs;
            if (inputs.length !== 2) throw new (0, $kubuc.ValueError)(`GRUCell expects 2 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            const training = kwargs['training'] == null ? false : kwargs['training'];
            let hTMinus1 = inputs[1]; // Previous memory state.
            inputs = inputs[0];
            // Note: For superior performance, TensorFlow.js always uses
            // implementation 2, regardless of the actual value of
            // config.implementation.
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $211fba51f5650b28$export$9eb0cce22b72569f({
                ones: ()=>$6zg0w.onesLike(inputs),
                rate: this.dropout,
                training: training,
                count: 3,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $211fba51f5650b28$export$9eb0cce22b72569f({
                ones: ()=>$6zg0w.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: 3,
                dropoutFunc: this.dropoutFunc
            });
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            let z;
            let r;
            let hh;
            if (0 < this.dropout && this.dropout < 1) inputs = $5hAos.mul(inputs, dpMask[0]);
            let matrixX = $4AyI5.dot(inputs, this.kernel.read());
            if (this.useBias) matrixX = $4AyI5.biasAdd(matrixX, this.bias.read());
            if (0 < this.recurrentDropout && this.recurrentDropout < 1) hTMinus1 = $5hAos.mul(hTMinus1, recDpMask[0]);
            const recurrentKernelValue = this.recurrentKernel.read();
            const [rk1, rk2] = $crriC.split(recurrentKernelValue, [
                2 * this.units,
                this.units
            ], recurrentKernelValue.rank - 1);
            const matrixInner = $4AyI5.dot(hTMinus1, rk1);
            const [xZ, xR, xH] = $crriC.split(matrixX, 3, matrixX.rank - 1);
            const [recurrentZ, recurrentR] = $crriC.split(matrixInner, 2, matrixInner.rank - 1);
            z = this.recurrentActivation.apply($6Ab5n.add(xZ, recurrentZ));
            r = this.recurrentActivation.apply($6Ab5n.add(xR, recurrentR));
            const recurrentH = $4AyI5.dot($5hAos.mul(r, hTMinus1), rk2);
            hh = this.activation.apply($6Ab5n.add(xH, recurrentH));
            const h = $6Ab5n.add($5hAos.mul(z, hTMinus1), $5hAos.mul($6Ab5n.add(1, $jMlCE.neg(z)), hh));
            // TODO(cais): Add use_learning_phase flag properly.
            return [
                h,
                h
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $5xdqh.serializeActivation)(this.activation),
            recurrentActivation: (0, $5xdqh.serializeActivation)(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: (0, $lHlnu.serializeInitializer)(this.kernelInitializer),
            recurrentInitializer: (0, $lHlnu.serializeInitializer)(this.recurrentInitializer),
            biasInitializer: (0, $lHlnu.serializeInitializer)(this.biasInitializer),
            kernelRegularizer: (0, $1NdPD.serializeRegularizer)(this.kernelRegularizer),
            recurrentRegularizer: (0, $1NdPD.serializeRegularizer)(this.recurrentRegularizer),
            biasRegularizer: (0, $1NdPD.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $1NdPD.serializeRegularizer)(this.activityRegularizer),
            kernelConstraint: (0, $ghUz9.serializeConstraint)(this.kernelConstraint),
            recurrentConstraint: (0, $ghUz9.serializeConstraint)(this.recurrentConstraint),
            biasConstraint: (0, $ghUz9.serializeConstraint)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation,
            resetAfter: false
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
}
/** @nocollapse */ $211fba51f5650b28$export$dad94e00e5c3737.className = 'GRUCell';
(0, $ki3lz).registerClass($211fba51f5650b28$export$dad94e00e5c3737);
class $211fba51f5650b28$export$effa27cfcc4408f4 extends $211fba51f5650b28$export$2b97bcdf1d6f1b16 {
    constructor(args){
        if (args.implementation === 0) console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call.");
        args.cell = new $211fba51f5650b28$export$dad94e00e5c3737(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $d7Nxs.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $d7Nxs.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        if (config['implmentation'] === 0) config['implementation'] = 1;
        return new cls(config);
    }
}
/** @nocollapse */ $211fba51f5650b28$export$effa27cfcc4408f4.className = 'GRU';
(0, $ki3lz).registerClass($211fba51f5650b28$export$effa27cfcc4408f4);
class $211fba51f5650b28$export$17aacc547a045ab0 extends $211fba51f5650b28$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.DEFAULT_ACTIVATION = 'tanh';
        this.DEFAULT_RECURRENT_ACTIVATION = 'hardSigmoid';
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_RECURRENT_INITIALIZER = 'orthogonal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        this.units = args.units;
        (0, $jYx5u.assertPositiveInteger)(this.units, 'units');
        this.activation = (0, $5xdqh.getActivation)(args.activation === undefined ? this.DEFAULT_ACTIVATION : args.activation);
        this.recurrentActivation = (0, $5xdqh.getActivation)(args.recurrentActivation === undefined ? this.DEFAULT_RECURRENT_ACTIVATION : args.recurrentActivation);
        this.useBias = args.useBias == null ? true : args.useBias;
        this.kernelInitializer = (0, $lHlnu.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.recurrentInitializer = (0, $lHlnu.getInitializer)(args.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER);
        this.biasInitializer = (0, $lHlnu.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.unitForgetBias = args.unitForgetBias;
        this.kernelRegularizer = (0, $1NdPD.getRegularizer)(args.kernelRegularizer);
        this.recurrentRegularizer = (0, $1NdPD.getRegularizer)(args.recurrentRegularizer);
        this.biasRegularizer = (0, $1NdPD.getRegularizer)(args.biasRegularizer);
        this.kernelConstraint = (0, $ghUz9.getConstraint)(args.kernelConstraint);
        this.recurrentConstraint = (0, $ghUz9.getConstraint)(args.recurrentConstraint);
        this.biasConstraint = (0, $ghUz9.getConstraint)(args.biasConstraint);
        this.dropout = $4SWqG.min([
            1,
            $4SWqG.max([
                0,
                args.dropout == null ? 0 : args.dropout
            ])
        ]);
        this.recurrentDropout = $4SWqG.min([
            1,
            $4SWqG.max([
                0,
                args.recurrentDropout == null ? 0 : args.recurrentDropout
            ])
        ]);
        this.dropoutFunc = args.dropoutFunc;
        this.implementation = args.implementation;
        this.stateSize = [
            this.units,
            this.units
        ];
        this.dropoutMask = null;
        this.recurrentDropoutMask = null;
    }
    build(inputShape) {
        var _a;
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const inputDim = inputShape[inputShape.length - 1];
        this.kernel = this.addWeight('kernel', [
            inputDim,
            this.units * 4
        ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
        this.recurrentKernel = this.addWeight('recurrent_kernel', [
            this.units,
            this.units * 4
        ], null, this.recurrentInitializer, this.recurrentRegularizer, true, this.recurrentConstraint);
        let biasInitializer;
        if (this.useBias) {
            if (this.unitForgetBias) {
                const capturedBiasInit = this.biasInitializer;
                const capturedUnits = this.units;
                biasInitializer = new (_a = class CustomInit extends (0, $lHlnu.Initializer) {
                    apply(shape, dtype) {
                        // TODO(cais): More informative variable names?
                        const bI = capturedBiasInit.apply([
                            capturedUnits
                        ]);
                        const bF = new (0, $lHlnu.Ones)().apply([
                            capturedUnits
                        ]);
                        const bCAndH = capturedBiasInit.apply([
                            capturedUnits * 2
                        ]);
                        return $4AyI5.concatAlongFirstAxis($4AyI5.concatAlongFirstAxis(bI, bF), bCAndH);
                    }
                }, /** @nocollapse */ _a.className = 'CustomInit', _a)();
            } else biasInitializer = this.biasInitializer;
            this.bias = this.addWeight('bias', [
                this.units * 4
            ], null, biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        } else this.bias = null;
        // Porting Notes: Unlike the PyKeras implementation, we perform slicing
        //   of the weights and bias in the call() method, at execution time.
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const training = kwargs['training'] == null ? false : kwargs['training'];
            inputs;
            if (inputs.length !== 3) throw new (0, $kubuc.ValueError)(`LSTMCell expects 3 input Tensors (inputs, h, c), got ` + `${inputs.length}.`);
            let hTMinus1 = inputs[1]; // Previous memory state.
            const cTMinus1 = inputs[2]; // Previous carry state.
            inputs = inputs[0];
            if (0 < this.dropout && this.dropout < 1 && this.dropoutMask == null) this.dropoutMask = $211fba51f5650b28$export$9eb0cce22b72569f({
                ones: ()=>$6zg0w.onesLike(inputs),
                rate: this.dropout,
                training: training,
                count: 4,
                dropoutFunc: this.dropoutFunc
            });
            if (0 < this.recurrentDropout && this.recurrentDropout < 1 && this.recurrentDropoutMask == null) this.recurrentDropoutMask = $211fba51f5650b28$export$9eb0cce22b72569f({
                ones: ()=>$6zg0w.onesLike(hTMinus1),
                rate: this.recurrentDropout,
                training: training,
                count: 4,
                dropoutFunc: this.dropoutFunc
            });
            const dpMask = this.dropoutMask;
            const recDpMask = this.recurrentDropoutMask;
            // Note: For superior performance, TensorFlow.js always uses
            // implementation 2 regardless of the actual value of
            // config.implementation.
            let i;
            let f;
            let c;
            let o;
            if (0 < this.dropout && this.dropout < 1) inputs = $5hAos.mul(inputs, dpMask[0]);
            let z = $4AyI5.dot(inputs, this.kernel.read());
            if (0 < this.recurrentDropout && this.recurrentDropout < 1) hTMinus1 = $5hAos.mul(hTMinus1, recDpMask[0]);
            z = $6Ab5n.add(z, $4AyI5.dot(hTMinus1, this.recurrentKernel.read()));
            if (this.useBias) z = $4AyI5.biasAdd(z, this.bias.read());
            const [z0, z1, z2, z3] = $crriC.split(z, 4, z.rank - 1);
            i = this.recurrentActivation.apply(z0);
            f = this.recurrentActivation.apply(z1);
            c = $6Ab5n.add($5hAos.mul(f, cTMinus1), $5hAos.mul(i, this.activation.apply(z2)));
            o = this.recurrentActivation.apply(z3);
            const h = $5hAos.mul(o, this.activation.apply(c));
            // TODO(cais): Add use_learning_phase flag properly.
            return [
                h,
                h,
                c
            ];
        });
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            units: this.units,
            activation: (0, $5xdqh.serializeActivation)(this.activation),
            recurrentActivation: (0, $5xdqh.serializeActivation)(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: (0, $lHlnu.serializeInitializer)(this.kernelInitializer),
            recurrentInitializer: (0, $lHlnu.serializeInitializer)(this.recurrentInitializer),
            biasInitializer: (0, $lHlnu.serializeInitializer)(this.biasInitializer),
            unitForgetBias: this.unitForgetBias,
            kernelRegularizer: (0, $1NdPD.serializeRegularizer)(this.kernelRegularizer),
            recurrentRegularizer: (0, $1NdPD.serializeRegularizer)(this.recurrentRegularizer),
            biasRegularizer: (0, $1NdPD.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $1NdPD.serializeRegularizer)(this.activityRegularizer),
            kernelConstraint: (0, $ghUz9.serializeConstraint)(this.kernelConstraint),
            recurrentConstraint: (0, $ghUz9.serializeConstraint)(this.recurrentConstraint),
            biasConstraint: (0, $ghUz9.serializeConstraint)(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
}
/** @nocollapse */ $211fba51f5650b28$export$17aacc547a045ab0.className = 'LSTMCell';
(0, $ki3lz).registerClass($211fba51f5650b28$export$17aacc547a045ab0);
class $211fba51f5650b28$export$c8c9213153497ce0 extends $211fba51f5650b28$export$2b97bcdf1d6f1b16 {
    constructor(args){
        if (args.implementation === 0) console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call.");
        args.cell = new $211fba51f5650b28$export$17aacc547a045ab0(args);
        super(args);
    // TODO(cais): Add activityRegularizer.
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            if (this.cell.dropoutMask != null) {
                $d7Nxs.dispose(this.cell.dropoutMask);
                this.cell.dropoutMask = null;
            }
            if (this.cell.recurrentDropoutMask != null) {
                $d7Nxs.dispose(this.cell.recurrentDropoutMask);
                this.cell.recurrentDropoutMask = null;
            }
            const mask = kwargs == null ? null : kwargs['mask'];
            const training = kwargs == null ? null : kwargs['training'];
            const initialState = kwargs == null ? null : kwargs['initialState'];
            return super.call(inputs, {
                mask: mask,
                training: training,
                initialState: initialState
            });
        });
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        if (config['implmentation'] === 0) config['implementation'] = 1;
        return new cls(config);
    }
}
/** @nocollapse */ $211fba51f5650b28$export$c8c9213153497ce0.className = 'LSTM';
(0, $ki3lz).registerClass($211fba51f5650b28$export$c8c9213153497ce0);
class $211fba51f5650b28$export$966a21a552328009 extends $211fba51f5650b28$export$405d8fca8f98aafd {
    constructor(args){
        super(args);
        this.cells = args.cells;
    }
    get stateSize() {
        // States are a flat list in reverse order of the cell stack.
        // This allows preserving the requirement `stack.statesize[0] ===
        // outputDim`. E.g., states of a 2-layer LSTM would be `[h2, c2, h1, c1]`,
        // assuming one LSTM has states `[h, c]`.
        const stateSize = [];
        for (const cell of this.cells.slice().reverse())if (Array.isArray(cell.stateSize)) stateSize.push(...cell.stateSize);
        else stateSize.push(cell.stateSize);
        return stateSize;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs;
            let states = inputs.slice(1);
            // Recover per-cell states.
            const nestedStates = [];
            for (const cell of this.cells.slice().reverse())if (Array.isArray(cell.stateSize)) nestedStates.push(states.splice(0, cell.stateSize.length));
            else nestedStates.push(states.splice(0, 1));
            nestedStates.reverse();
            // Call the cells in order and store the returned states.
            const newNestedStates = [];
            let callInputs;
            for(let i = 0; i < this.cells.length; ++i){
                const cell = this.cells[i];
                states = nestedStates[i];
                // TODO(cais): Take care of constants.
                if (i === 0) callInputs = [
                    inputs[0]
                ].concat(states);
                else callInputs = [
                    callInputs[0]
                ].concat(states);
                callInputs = cell.call(callInputs, kwargs);
                newNestedStates.push(callInputs.slice(1));
            }
            // Format the new states as a flat list in reverse cell order.
            states = [];
            for (const cellStates of newNestedStates.slice().reverse())states.push(...cellStates);
            return [
                callInputs[0]
            ].concat(states);
        });
    }
    build(inputShape) {
        if ((0, $bMNfZ.isArrayOfShapes)(inputShape)) // TODO(cais): Take care of input constants.
        // const constantShape = inputShape.slice(1);
        inputShape = inputShape[0];
        inputShape;
        let outputDim;
        this.cells.forEach((cell, i)=>{
            (0, $1Xyaa.nameScope)(`RNNCell_${i}`, ()=>{
                // TODO(cais): Take care of input constants.
                cell.build(inputShape);
                if (Array.isArray(cell.stateSize)) outputDim = cell.stateSize[0];
                else outputDim = cell.stateSize;
                inputShape = [
                    inputShape[0],
                    outputDim
                ];
            });
        });
        this.built = true;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const getCellConfig = (cell)=>{
            return {
                'className': cell.getClassName(),
                'config': cell.getConfig()
            };
        };
        const cellConfigs = this.cells.map(getCellConfig);
        const config = {
            'cells': cellConfigs
        };
        return Object.assign(Object.assign({}, baseConfig), config);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const cells = [];
        for (const cellConfig of config['cells'])cells.push((0, $4v3Le.deserialize)(cellConfig, customObjects));
        return new cls({
            cells: cells
        });
    }
    get trainableWeights() {
        if (!this.trainable) return [];
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.trainableWeights);
        return weights;
    }
    get nonTrainableWeights() {
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.nonTrainableWeights);
        if (!this.trainable) {
            const trainableWeights = [];
            for (const cell of this.cells)trainableWeights.push(...cell.trainableWeights);
            return trainableWeights.concat(weights);
        }
        return weights;
    }
    /**
     * Retrieve the weights of a the model.
     *
     * @returns A flat `Array` of `tf.Tensor`s.
     */ getWeights() {
        const weights = [];
        for (const cell of this.cells)weights.push(...cell.weights);
        return (0, $pKVrB.batchGetValue)(weights);
    }
    /**
     * Set the weights of the model.
     *
     * @param weights An `Array` of `tf.Tensor`s with shapes and types matching
     *     the output of `getWeights()`.
     */ setWeights(weights) {
        const tuples = [];
        for (const cell of this.cells){
            const numParams = cell.weights.length;
            const inputWeights = weights.splice(numParams);
            for(let i = 0; i < cell.weights.length; ++i)tuples.push([
                cell.weights[i],
                inputWeights[i]
            ]);
        }
        (0, $pKVrB.batchSetValue)(tuples);
    }
}
/** @nocollapse */ $211fba51f5650b28$export$966a21a552328009.className = 'StackedRNNCells';
(0, $ki3lz).registerClass($211fba51f5650b28$export$966a21a552328009);
function $211fba51f5650b28$export$9eb0cce22b72569f(args) {
    const { ones: ones, rate: rate, training: training = false, count: count = 1, dropoutFunc: dropoutFunc } = args;
    const droppedInputs = ()=>dropoutFunc != null ? dropoutFunc(ones(), rate) : $4AyI5.dropout(ones(), rate);
    const createMask = ()=>$4AyI5.inTrainPhase(droppedInputs, ones, training);
    // just in case count is provided with null or undefined
    if (!count || count <= 1) return $d7Nxs.keep(createMask().clone());
    const masks = Array(count).fill(undefined).map(createMask);
    return masks.map((m)=>$d7Nxs.keep(m.clone()));
}

});


parcelRegister("d6Kyz", function(module, exports) {

$parcel$export(module.exports, "Dropout", function () { return $98aff315ce6cd60d$export$bb75bf17e9ebd794; });
$parcel$export(module.exports, "SpatialDropout1D", function () { return $98aff315ce6cd60d$export$f86f27a3d1240824; });
$parcel$export(module.exports, "Dense", function () { return $98aff315ce6cd60d$export$7db6feeaf0335f8; });
$parcel$export(module.exports, "Flatten", function () { return $98aff315ce6cd60d$export$929ed232258ef592; });
$parcel$export(module.exports, "Activation", function () { return $98aff315ce6cd60d$export$d4842319833f6f14; });
$parcel$export(module.exports, "RepeatVector", function () { return $98aff315ce6cd60d$export$6cf81e630ba27dd9; });
$parcel$export(module.exports, "Reshape", function () { return $98aff315ce6cd60d$export$755ddd847e5abe03; });
$parcel$export(module.exports, "Permute", function () { return $98aff315ce6cd60d$export$f107458f792fb62e; });
$parcel$export(module.exports, "Masking", function () { return $98aff315ce6cd60d$export$b713323c862a70bd; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Basic Layers.
 */ parcelRequire("8AHkS");
var $dODwI = parcelRequire("dODwI");
var $fxiHg = parcelRequire("fxiHg");
var $5hAos = parcelRequire("5hAos");
var $8BIHZ = parcelRequire("8BIHZ");
var $8nMOl = parcelRequire("8nMOl");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");
var $9c2so = parcelRequire("9c2so");
var $lBDHD = parcelRequire("lBDHD");

var $5xdqh = parcelRequire("5xdqh");

var $4AyI5 = parcelRequire("4AyI5");

var $ghUz9 = parcelRequire("ghUz9");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $1NdPD = parcelRequire("1NdPD");

var $jYx5u = parcelRequire("jYx5u");

var $4SWqG = parcelRequire("4SWqG");

var $bMNfZ = parcelRequire("bMNfZ");
class $98aff315ce6cd60d$export$bb75bf17e9ebd794 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.rate = Math.max(Math.min(args.rate, 1), 0);
        // So that the scalar doesn't get tidied up between executions.
        this.noiseShape = args.noiseShape;
        this.seed = args.seed;
        this.supportsMasking = true;
    }
    getNoiseShape(input) {
        if (this.noiseShape == null) return this.noiseShape;
        const inputShape = input.shape;
        const noiseShape = [];
        for(let i = 0; i < this.noiseShape.length; ++i)noiseShape.push(this.noiseShape[i] == null ? inputShape[i] : this.noiseShape[i]);
        return noiseShape;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (0 < this.rate && this.rate < 1) {
                const training = kwargs['training'] == null ? false : kwargs['training'];
                const noiseShape = this.getNoiseShape(input);
                const output = $4AyI5.inTrainPhase(()=>$4AyI5.dropout(input, this.rate, noiseShape, this.seed), ()=>input, training);
                return output;
            }
            return inputs;
        });
    }
    getConfig() {
        const config = {
            rate: this.rate,
            noiseShape: this.noiseShape,
            seed: this.seed
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    dispose() {
        return super.dispose();
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$bb75bf17e9ebd794.className = 'Dropout';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$bb75bf17e9ebd794);
class $98aff315ce6cd60d$export$f86f27a3d1240824 extends $98aff315ce6cd60d$export$bb75bf17e9ebd794 {
    constructor(args){
        super(args);
        this.inputSpec = [
            {
                ndim: 3
            }
        ];
    }
    getNoiseShape(input) {
        const inputShape = input.shape;
        return [
            inputShape[0],
            1,
            inputShape[2]
        ];
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$f86f27a3d1240824.className = 'SpatialDropout1D';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$f86f27a3d1240824);
class $98aff315ce6cd60d$export$7db6feeaf0335f8 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        // Default activation: Linear (none).
        this.activation = null;
        this.useBias = true;
        this.kernel = null;
        this.bias = null;
        this.DEFAULT_KERNEL_INITIALIZER = 'glorotNormal';
        this.DEFAULT_BIAS_INITIALIZER = 'zeros';
        if (args.batchInputShape == null && args.inputShape == null && args.inputDim != null) {
            // This logic is copied from Layer's constructor, since we can't
            // do exactly what the Python constructor does for Dense().
            let batchSize = null;
            if (args.batchSize != null) batchSize = args.batchSize;
            this.batchInputShape = [
                batchSize,
                args.inputDim
            ];
        }
        this.units = args.units;
        (0, $jYx5u.assertPositiveInteger)(this.units, 'units');
        this.activation = (0, $5xdqh.getActivation)(args.activation);
        if (args.useBias != null) this.useBias = args.useBias;
        this.kernelInitializer = (0, $lHlnu.getInitializer)(args.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER);
        this.biasInitializer = (0, $lHlnu.getInitializer)(args.biasInitializer || this.DEFAULT_BIAS_INITIALIZER);
        this.kernelConstraint = (0, $ghUz9.getConstraint)(args.kernelConstraint);
        this.biasConstraint = (0, $ghUz9.getConstraint)(args.biasConstraint);
        this.kernelRegularizer = (0, $1NdPD.getRegularizer)(args.kernelRegularizer);
        this.biasRegularizer = (0, $1NdPD.getRegularizer)(args.biasRegularizer);
        this.activityRegularizer = (0, $1NdPD.getRegularizer)(args.activityRegularizer);
        this.supportsMasking = true;
        this.inputSpec = [
            {
                minNDim: 2
            }
        ];
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const inputLastDim = inputShape[inputShape.length - 1];
        if (this.kernel == null) {
            this.kernel = this.addWeight('kernel', [
                inputLastDim,
                this.units
            ], null, this.kernelInitializer, this.kernelRegularizer, true, this.kernelConstraint);
            if (this.useBias) this.bias = this.addWeight('bias', [
                this.units
            ], null, this.biasInitializer, this.biasRegularizer, true, this.biasConstraint);
        }
        this.inputSpec = [
            {
                minNDim: 2,
                axes: {
                    [-1]: inputLastDim
                }
            }
        ];
        this.built = true;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const outputShape = inputShape.slice();
        outputShape[outputShape.length - 1] = this.units;
        return outputShape;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Dense layer accepts only a single input.
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            const fusedActivationName = (0, $jYx5u.mapActivationToFusedKernel)(this.activation.getClassName());
            let output;
            if (fusedActivationName != null) output = $4AyI5.dot(input, this.kernel.read(), fusedActivationName, this.bias ? this.bias.read() : null);
            else {
                output = $4AyI5.dot(input, this.kernel.read());
                if (this.bias != null) output = $4AyI5.biasAdd(output, this.bias.read());
                if (this.activation != null) output = this.activation.apply(output);
            }
            return output;
        });
    }
    getConfig() {
        const config = {
            units: this.units,
            activation: (0, $5xdqh.serializeActivation)(this.activation),
            useBias: this.useBias,
            kernelInitializer: (0, $lHlnu.serializeInitializer)(this.kernelInitializer),
            biasInitializer: (0, $lHlnu.serializeInitializer)(this.biasInitializer),
            kernelRegularizer: (0, $1NdPD.serializeRegularizer)(this.kernelRegularizer),
            biasRegularizer: (0, $1NdPD.serializeRegularizer)(this.biasRegularizer),
            activityRegularizer: (0, $1NdPD.serializeRegularizer)(this.activityRegularizer),
            kernelConstraint: (0, $ghUz9.serializeConstraint)(this.kernelConstraint),
            biasConstraint: (0, $ghUz9.serializeConstraint)(this.biasConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$7db6feeaf0335f8.className = 'Dense';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$7db6feeaf0335f8);
class $98aff315ce6cd60d$export$929ed232258ef592 extends (0, $jWpeh.Layer) {
    constructor(args){
        args = args || {};
        super(args);
        this.inputSpec = [
            {
                minNDim: 3
            }
        ];
        this.dataFormat = args.dataFormat;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        for (const dim of inputShape.slice(1)){
            if (dim == null) throw new (0, $kubuc.ValueError)(`The shape of the input to "Flatten" is not fully defined ` + `(got ${inputShape.slice(1)}). Make sure to pass a complete ` + `"input_shape" or "batch_input_shape" argument to the first ` + `layer in your model.`);
        }
        return [
            inputShape[0],
            (0, $4SWqG.arrayProd)(inputShape, 1)
        ];
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            let input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (this.dataFormat === 'channelsFirst' && input.rank > 1) {
                const permutation = [
                    0
                ];
                for(let i = 2; i < input.rank; ++i)permutation.push(i);
                permutation.push(1);
                input = (0, $9c2so.transpose)(input, permutation);
            }
            return $4AyI5.batchFlatten(input);
        });
    }
    getConfig() {
        const config = {};
        if (this.dataFormat != null) config['dataFormat'] = this.dataFormat;
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$929ed232258ef592.className = 'Flatten';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$929ed232258ef592);
class $98aff315ce6cd60d$export$d4842319833f6f14 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.activation = (0, $5xdqh.getActivation)(args.activation);
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            return this.activation.apply(input);
        });
    }
    getConfig() {
        const config = {
            activation: (0, $5xdqh.serializeActivation)(this.activation)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$d4842319833f6f14.className = 'Activation';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$d4842319833f6f14);
class $98aff315ce6cd60d$export$6cf81e630ba27dd9 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.n = args.n;
        this.inputSpec = [
            {
                ndim: 2
            }
        ];
    }
    computeOutputShape(inputShape) {
        return [
            inputShape[0],
            this.n,
            inputShape[1]
        ];
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            return $4AyI5.repeat(inputs, this.n);
        });
    }
    getConfig() {
        const config = {
            n: this.n
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$6cf81e630ba27dd9.className = 'RepeatVector';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$6cf81e630ba27dd9);
class $98aff315ce6cd60d$export$755ddd847e5abe03 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.targetShape = args.targetShape;
        // Make sure that all unknown dimensions are represented as `null`.
        for(let i = 0; i < this.targetShape.length; ++i)if (this.isUnknown(this.targetShape[i])) this.targetShape[i] = null;
    }
    isUnknown(dim) {
        return dim < 0 || dim == null;
    }
    /**
     * Finds and replaces a missing dimension in output shape.
     *
     * This is a near direct port of the internal Numpy function
     * `_fix_unknown_dimension` in `numpy/core/src/multiarray/shape.c`.
     *
     * @param inputShape: Original shape of array begin reshape.
     * @param outputShape: Target shape of the array, with at most a single
     * `null` or negative number, which indicates an underdetermined dimension
     * that should be derived from `inputShape` and the known dimensions of
     *   `outputShape`.
     * @returns: The output shape with `null` replaced with its computed value.
     * @throws: ValueError: If `inputShape` and `outputShape` do not match.
     */ fixUnknownDimension(inputShape, outputShape) {
        const errorMsg = 'Total size of new array must be unchanged.';
        const finalShape = outputShape.slice();
        let known = 1;
        let unknown = null;
        for(let i = 0; i < finalShape.length; ++i){
            const dim = finalShape[i];
            if (this.isUnknown(dim)) {
                if (unknown === null) unknown = i;
                else throw new (0, $kubuc.ValueError)('Can only specifiy one unknown dimension.');
            } else known *= dim;
        }
        const originalSize = (0, $4SWqG.arrayProd)(inputShape);
        if (unknown !== null) {
            if (known === 0 || originalSize % known !== 0) throw new (0, $kubuc.ValueError)(errorMsg);
            finalShape[unknown] = originalSize / known;
        } else if (originalSize !== known) throw new (0, $kubuc.ValueError)(errorMsg);
        return finalShape;
    }
    computeOutputShape(inputShape) {
        let anyUnknownDims = false;
        for(let i = 0; i < inputShape.length; ++i)if (this.isUnknown(inputShape[i])) {
            anyUnknownDims = true;
            break;
        }
        if (anyUnknownDims) return inputShape.slice(0, 1).concat(this.targetShape);
        else return inputShape.slice(0, 1).concat(this.fixUnknownDimension(inputShape.slice(1), this.targetShape));
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            const inputShape = input.shape;
            const outputShape = inputShape.slice(0, 1).concat(this.fixUnknownDimension(inputShape.slice(1), this.targetShape));
            return (0, $8nMOl.reshape)(input, outputShape);
        });
    }
    getConfig() {
        const config = {
            targetShape: this.targetShape
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$755ddd847e5abe03.className = 'Reshape';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$755ddd847e5abe03);
class $98aff315ce6cd60d$export$f107458f792fb62e extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        if (args.dims == null) throw new Error("Required configuration field `dims` is missing during Permute constructor call.");
        if (!Array.isArray(args.dims)) throw new Error('Permute constructor requires `dims` to be an Array, but received ' + `${args.dims} instead.`);
        // Check the validity of the permutation indices.
        const expectedSortedIndices = (0, $4SWqG.range)(1, args.dims.length + 1);
        if (!(0, $lBDHD).arraysEqual(args.dims.slice().sort(), expectedSortedIndices)) throw new Error('Invalid permutation `dims`: ' + JSON.stringify(args.dims) + ' `dims` must contain consecutive integers starting from 1.');
        this.dims = args.dims;
        this.dimsIncludingBatch = [
            0
        ].concat(this.dims);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: this.dims.length + 1
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const outputShape = inputShape.slice();
        this.dims.forEach((dim, i)=>{
            outputShape[i + 1] = inputShape[dim];
        });
        return outputShape;
    }
    call(inputs, kwargs) {
        return (0, $9c2so.transpose)((0, $bMNfZ.getExactlyOneTensor)(inputs), this.dimsIncludingBatch);
    }
    getConfig() {
        const config = {
            dims: this.dims
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$f107458f792fb62e.className = 'Permute';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$f107458f792fb62e);
class $98aff315ce6cd60d$export$b713323c862a70bd extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args == null ? {} : args);
        this.supportsMasking = true;
        if (args != null) this.maskValue = args.maskValue == null ? 0 : args.maskValue;
        else this.maskValue = 0;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            maskValue: this.maskValue
        };
        Object.assign(config, baseConfig);
        return config;
    }
    computeMask(inputs, mask) {
        const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
        const axis = -1;
        return (0, $dODwI.any)((0, $8BIHZ.notEqual)(input, this.maskValue), axis);
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            const axis = -1;
            const keepDims = true;
            const booleanMask = (0, $dODwI.any)((0, $8BIHZ.notEqual)(input, this.maskValue), axis, keepDims);
            const output = (0, $5hAos.mul)(input, (0, $fxiHg.cast)(booleanMask, input.dtype));
            return output;
        });
    }
}
/** @nocollapse */ $98aff315ce6cd60d$export$b713323c862a70bd.className = 'Masking';
(0, $ki3lz).registerClass($98aff315ce6cd60d$export$b713323c862a70bd);

});

parcelRegister("dMo41", function(module, exports) {

$parcel$export(module.exports, "Embedding", function () { return $a0826ca554cad743$export$d4aa6cf23314fd52; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Embedding Layer.
 *
 * Original source: keras/constraints.py
 */ parcelRequire("8AHkS");
var $8BIHZ = parcelRequire("8BIHZ");
var $8nMOl = parcelRequire("8nMOl");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");
var $cztsD = parcelRequire("cztsD");

var $4AyI5 = parcelRequire("4AyI5");

var $ghUz9 = parcelRequire("ghUz9");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $1NdPD = parcelRequire("1NdPD");

var $jYx5u = parcelRequire("jYx5u");

var $bMNfZ = parcelRequire("bMNfZ");
class $a0826ca554cad743$export$d4aa6cf23314fd52 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.embeddings = null;
        this.DEFAULT_EMBEDDINGS_INITIALIZER = 'randomUniform';
        if (args.batchInputShape == null && args.inputShape == null) {
            // Porting Note: This logic is copied from Layer's constructor, since we
            // can't do exactly what the Python constructor does for Embedding().
            // Specifically, the super constructor can not be called after the
            // mutation of the `config` argument.
            let batchSize = null;
            if (args.batchSize != null) batchSize = args.batchSize;
            if (args.inputLength == null) // Fix super-constructor to what it would have done if
            // 'config.inputShape' were (None, )
            this.batchInputShape = [
                batchSize,
                null
            ];
            else // Fix super-constructor to what it would have done if
            // 'config.inputShape' were (config.inputLength, )
            this.batchInputShape = [
                batchSize
            ].concat($jYx5u.toList(args.inputLength));
        }
        this.inputDim = args.inputDim;
        $jYx5u.assertPositiveInteger(this.inputDim, 'inputDim');
        this.outputDim = args.outputDim;
        $jYx5u.assertPositiveInteger(this.outputDim, 'outputDim');
        this.embeddingsInitializer = (0, $lHlnu.getInitializer)(args.embeddingsInitializer || this.DEFAULT_EMBEDDINGS_INITIALIZER);
        this.embeddingsRegularizer = (0, $1NdPD.getRegularizer)(args.embeddingsRegularizer);
        this.activityRegularizer = (0, $1NdPD.getRegularizer)(args.activityRegularizer);
        this.embeddingsConstraint = (0, $ghUz9.getConstraint)(args.embeddingsConstraint);
        this.maskZero = args.maskZero;
        this.supportsMasking = args.maskZero;
        this.inputLength = args.inputLength;
    }
    build(inputShape) {
        this.embeddings = this.addWeight('embeddings', [
            this.inputDim,
            this.outputDim
        ], this.dtype, this.embeddingsInitializer, this.embeddingsRegularizer, true, this.embeddingsConstraint);
        this.built = true;
    }
    // Override warnOnIncompatibleInputShape because an embedding layer allows
    // the input to have varying ranks.
    warnOnIncompatibleInputShape(inputShape) {}
    computeMask(inputs, mask) {
        return (0, $d7Nxs.tidy)(()=>{
            if (!this.maskZero) return null;
            else {
                inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
                return (0, $8BIHZ.notEqual)(inputs, (0, $cztsD.zerosLike)(inputs));
            }
        });
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        if (this.inputLength == null) return [
            ...inputShape,
            this.outputDim
        ];
        // inputLength can be an array if input is 3D or higher.
        const inLens = $jYx5u.toList(this.inputLength);
        if (inLens.length !== inputShape.length - 1) throw new (0, $kubuc.ValueError)(`"inputLength" is ${this.inputLength}, but received ` + `input shape has shape ${inputShape}`);
        else {
            let i = 0;
            for(let k = 0; k < inLens.length; ++k){
                const s1 = inLens[k];
                const s2 = inputShape[k + 1];
                if (s1 != null && s2 != null && s1 !== s2) throw new (0, $kubuc.ValueError)(`"inputLength" is ${this.inputLength}, but received ` + `input shape has shape ${inputShape}`);
                else if (s1 == null) inLens[i] = s2;
                i++;
            }
        }
        return [
            inputShape[0],
            ...inLens,
            this.outputDim
        ];
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Embedding layer accepts only a single input.
            let input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (input.dtype !== 'int32') input = $4AyI5.cast(input, 'int32');
            const output = $4AyI5.gather(this.embeddings.read(), (0, $8nMOl.reshape)(input, [
                input.size
            ]));
            return (0, $8nMOl.reshape)(output, (0, $bMNfZ.getExactlyOneShape)(this.computeOutputShape(input.shape)));
        });
    }
    getConfig() {
        const config = {
            inputDim: this.inputDim,
            outputDim: this.outputDim,
            embeddingsInitializer: (0, $lHlnu.serializeInitializer)(this.embeddingsInitializer),
            embeddingsRegularizer: (0, $1NdPD.serializeRegularizer)(this.embeddingsRegularizer),
            activityRegularizer: (0, $1NdPD.serializeRegularizer)(this.activityRegularizer),
            embeddingsConstraint: (0, $ghUz9.serializeConstraint)(this.embeddingsConstraint),
            maskZero: this.maskZero,
            inputLength: this.inputLength
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $a0826ca554cad743$export$d4aa6cf23314fd52.className = 'Embedding';
(0, $ki3lz).registerClass($a0826ca554cad743$export$d4aa6cf23314fd52);

});

parcelRegister("iKmOy", function(module, exports) {

$parcel$export(module.exports, "Add", function () { return $da5e38505eeed8d6$export$d0265b2c425512d6; });
$parcel$export(module.exports, "Multiply", function () { return $da5e38505eeed8d6$export$f14f83b3b531d498; });
$parcel$export(module.exports, "Average", function () { return $da5e38505eeed8d6$export$7725e1a7540355cb; });
$parcel$export(module.exports, "Maximum", function () { return $da5e38505eeed8d6$export$d8d02ac92d161004; });
$parcel$export(module.exports, "Minimum", function () { return $da5e38505eeed8d6$export$23cb308301e89d6b; });
$parcel$export(module.exports, "Concatenate", function () { return $da5e38505eeed8d6$export$e55b597c359d82cd; });
$parcel$export(module.exports, "Dot", function () { return $da5e38505eeed8d6$export$d046b3c4a416f60d; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Merge Layers.
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $c3y0I = parcelRequire("c3y0I");
var $fxiHg = parcelRequire("fxiHg");
var $1goxr = parcelRequire("1goxr");
var $fO4kJ = parcelRequire("fO4kJ");
var $gXTMu = parcelRequire("gXTMu");
var $VLFo8 = parcelRequire("VLFo8");
var $jRQ3p = parcelRequire("jRQ3p");
var $7es6p = parcelRequire("7es6p");
var $5hAos = parcelRequire("5hAos");
var $6zg0w = parcelRequire("6zg0w");
var $8nMOl = parcelRequire("8nMOl");
var $ki3lz = parcelRequire("ki3lz");
var $gP42y = parcelRequire("gP42y");
var $fPnAL = parcelRequire("fPnAL");
var $d7Nxs = parcelRequire("d7Nxs");
var $9c2so = parcelRequire("9c2so");
var $lBDHD = parcelRequire("lBDHD");

var $4AyI5 = parcelRequire("4AyI5");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $lg9tU = parcelRequire("lg9tU");

var $jYx5u = parcelRequire("jYx5u");

var $4SWqG = parcelRequire("4SWqG");

var $bMNfZ = parcelRequire("bMNfZ");
class $da5e38505eeed8d6$export$70ce1d34efd3b886 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args || {});
        this.supportsMasking = true;
    }
    /**
     * Logic for merging multiple tensors, to be overridden by subclasses.
     * @param inputs
     */ mergeFunction(inputs) {
        throw new (0, $kubuc.NotImplementedError)();
    }
    /**
     * Computes the shape of the result of an elementwise operation.
     *
     * @param shape1: Shape of the first tensor.
     * @param shape2: Shape of the second tensor.
     * @returns Expected output shape when an elementwise operation is carried
     *   out on 2 tensors with shapes `shape1` and `shape2`.
     * @throws ValueError: If `shape1` and `shape2` are not compatible for
     *   element-wise operations.
     */ computeElementwiseOpOutputShape(shape1, shape2) {
        if (shape1 == null || shape2 == null) return null;
        else if (shape1.length < shape2.length) return this.computeElementwiseOpOutputShape(shape2, shape1);
        else if (shape2.length === 0) return shape1;
        const outputShape = shape1.slice(0, shape1.length - shape2.length);
        for(let k = 0; k < shape2.length; ++k){
            const i = shape1[shape1.length - shape2.length + k];
            const j = shape2[k];
            if (i == null || j == null || i < 0 || j < 0) outputShape.push(null);
            else if (i === 1) outputShape.push(j);
            else if (j === 1) outputShape.push(i);
            else {
                if (i !== j) throw new (0, $kubuc.ValueError)('Operands could not be broadcast together with shapes ' + JSON.stringify(shape1) + ' ' + JSON.stringify(shape2));
                outputShape.push(i);
            }
        }
        return outputShape;
    }
    build(inputShape) {
        // Used purely for shape validation.
        if (Array.isArray(inputShape) && !Array.isArray(inputShape[0])) // Make sure that inputShape is an Array of shape.
        inputShape = [
            (0, $bMNfZ.getExactlyOneShape)(inputShape)
        ];
        inputShape;
        if (inputShape.length < 2) throw new (0, $kubuc.ValueError)('A merge layer should be called on an Array of at least 2 inputs.' + ` Got ${inputShape.length} input(s).`);
        // Make sure that there is at most one unique batch size among the input
        // shapes.
        let batchSizes = [];
        for (const shape of inputShape)if (shape != null && shape[0] !== null) batchSizes.push(shape[0]);
        batchSizes = $jYx5u.unique(batchSizes);
        if (batchSizes.length > 1) throw new (0, $kubuc.ValueError)(`Can not merge tensors with different batch sizes. ` + `Got tensors with shapes: ${JSON.stringify(inputShape)}.`);
        let outputShape = inputShape[0] == null ? null : inputShape[0].slice(1);
        for(let i = 1; i < inputShape.length; ++i){
            const shape = inputShape[i] == null ? null : inputShape[i].slice(1);
            outputShape = this.computeElementwiseOpOutputShape(outputShape, shape);
        }
        // If the inputs have different ranks, we have to reshape them to make them
        // broadcastable.
        const allRanks = inputShape.map((shape)=>shape.length);
        if (inputShape.indexOf(null) === -1 && $jYx5u.unique(allRanks).length === 1) this.reshapeRequired = false;
        else this.reshapeRequired = true;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs;
            if (this.reshapeRequired) {
                const reshapedInputs = [];
                const inputDims = inputs.map((input)=>input.rank);
                if (inputDims.indexOf(null) === -1) {
                    // If ranks of all inputs are available, we simply expand each of them
                    // at axis=1 until all of them have the same rank.
                    const maxNDim = $4SWqG.max(inputDims);
                    for (let x of inputs){
                        const xNDim = x.rank;
                        for(let k = 0; k < maxNDim - xNDim; ++k)x = $4AyI5.expandDims(x, 1);
                        reshapedInputs.push(x);
                    }
                    return this.mergeFunction(reshapedInputs);
                } else {
                    // Transpose all inputs so that batch size is the last dimension.
                    // [batchSize, dim1, dim2, ...] -> [dim1, dim2, ..., batchSize]
                    let transposed = false;
                    for (const x of inputs){
                        const xNDim = x.rank;
                        if (xNDim == null) {
                            const xShape = x.shape;
                            const batchSize = xShape[0];
                            const newShape = xShape.slice(1).concat([
                                batchSize
                            ]);
                            let xTransposed = $8nMOl.reshape(x, [
                                batchSize
                            ].concat($4SWqG.arrayProd(xShape.slice(1))));
                            xTransposed = $9c2so.transpose(xTransposed, [
                                1,
                                0
                            ]);
                            xTransposed = $8nMOl.reshape(xTransposed, newShape);
                            reshapedInputs.push(xTransposed);
                            transposed = true;
                        } else if (xNDim > 1) {
                            const dims = $4SWqG.range(1, xNDim).concat([
                                0
                            ]);
                            reshapedInputs.push($9c2so.transpose(x, dims));
                            transposed = true;
                        } else // We don't transpose inputs if they are 1D vectors or scalars.
                        reshapedInputs.push(x);
                    }
                    let y = this.mergeFunction(reshapedInputs);
                    const yNDim = y.rank;
                    if (transposed) {
                        // If inputs have been transposed, we have to transpose the output
                        // too.
                        if (yNDim == null) {
                            const yShape = y.shape;
                            const yNDim = yShape.length;
                            const batchSize = yShape[yNDim - 1];
                            const newShape = [
                                batchSize
                            ].concat(yShape.slice(0, yShape.length - 1));
                            y = $8nMOl.reshape($9c2so.transpose($8nMOl.reshape(y, [
                                -1,
                                batchSize
                            ]), [
                                1,
                                0
                            ]), newShape);
                        } else if (yNDim > 1) {
                            const dims = [
                                yNDim - 1
                            ].concat($4SWqG.range(0, yNDim - 1));
                            y = $9c2so.transpose(y, dims);
                        }
                    }
                    return y;
                }
            } else return this.mergeFunction(inputs);
        });
    }
    computeOutputShape(inputShape) {
        inputShape;
        let outputShape;
        if (inputShape[0] == null) outputShape = null;
        else outputShape = inputShape[0].slice(1);
        for(let i = 1; i < inputShape.length; ++i){
            const shape = inputShape[i] == null ? null : inputShape[i].slice(1);
            outputShape = this.computeElementwiseOpOutputShape(outputShape, shape);
        }
        let batchSizes = [];
        for (const shape of inputShape)if (shape != null && shape[0] !== null) batchSizes.push(shape[0]);
        batchSizes = $jYx5u.unique(batchSizes);
        if (batchSizes.length === 1) outputShape = batchSizes.concat(outputShape);
        else outputShape = [
            null
        ].concat(outputShape);
        return outputShape;
    }
    computeMask(inputs, mask) {
        return $d7Nxs.tidy(()=>{
            if (mask == null) return null;
            if (!Array.isArray(mask)) throw new (0, $kubuc.ValueError)('`mask` should be an Array');
            if (!Array.isArray(inputs)) throw new (0, $kubuc.ValueError)('`inputs` should be an Array');
            if (mask.length !== inputs.length) throw new (0, $kubuc.ValueError)(`The Array 'inputs' and 'mask' are expected to have the same ` + `length, but have different lengths ` + `(${inputs.length} vs ${mask.length})`);
            if (mask.every((m)=>m == null)) return null;
            mask = mask.map((m)=>m == null ? m : $fO4kJ.expandDims(m, 0));
            let output = mask[0];
            for(let i = 1; i < mask.length - 1; ++i)output = $gXTMu.logicalAnd(output, mask[i]);
            return output;
        });
    }
}
class $da5e38505eeed8d6$export$d0265b2c425512d6 extends $da5e38505eeed8d6$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $d7Nxs.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $6Ab5n.add(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $da5e38505eeed8d6$export$d0265b2c425512d6.className = 'Add';
(0, $ki3lz).registerClass($da5e38505eeed8d6$export$d0265b2c425512d6);
function $da5e38505eeed8d6$export$e16d8520af44a096(config) {
    if (Array.isArray(config)) {
        const layer = new $da5e38505eeed8d6$export$d0265b2c425512d6({});
        return layer.apply(config);
    } else return new $da5e38505eeed8d6$export$d0265b2c425512d6(config);
}
class $da5e38505eeed8d6$export$f14f83b3b531d498 extends $da5e38505eeed8d6$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $d7Nxs.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $5hAos.mul(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $da5e38505eeed8d6$export$f14f83b3b531d498.className = 'Multiply';
(0, $ki3lz).registerClass($da5e38505eeed8d6$export$f14f83b3b531d498);
function $da5e38505eeed8d6$export$2060d2db72cce88f(config) {
    if (Array.isArray(config)) {
        const layer = new $da5e38505eeed8d6$export$f14f83b3b531d498({});
        return layer.apply(config);
    } else return new $da5e38505eeed8d6$export$f14f83b3b531d498(config);
}
class $da5e38505eeed8d6$export$7725e1a7540355cb extends $da5e38505eeed8d6$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $d7Nxs.tidy)(()=>{
            let output = inputs[0].clone();
            for(let i = 1; i < inputs.length; ++i)output = $6Ab5n.add(output, inputs[i]);
            return $5hAos.mul(1 / inputs.length, output);
        });
    }
}
/** @nocollapse */ $da5e38505eeed8d6$export$7725e1a7540355cb.className = 'Average';
(0, $ki3lz).registerClass($da5e38505eeed8d6$export$7725e1a7540355cb);
function $da5e38505eeed8d6$export$cc6710ee5f037d57(config) {
    if (Array.isArray(config)) {
        const layer = new $da5e38505eeed8d6$export$7725e1a7540355cb({});
        return layer.apply(config);
    } else return new $da5e38505eeed8d6$export$7725e1a7540355cb(config);
}
class $da5e38505eeed8d6$export$d8d02ac92d161004 extends $da5e38505eeed8d6$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $d7Nxs.tidy)(()=>{
            let output = inputs[0];
            for(let i = 1; i < inputs.length; ++i)output = $jRQ3p.maximum(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $da5e38505eeed8d6$export$d8d02ac92d161004.className = 'Maximum';
(0, $ki3lz).registerClass($da5e38505eeed8d6$export$d8d02ac92d161004);
function $da5e38505eeed8d6$export$b25e0be55f42c9a(config) {
    if (Array.isArray(config)) {
        const layer = new $da5e38505eeed8d6$export$d8d02ac92d161004({});
        return layer.apply(config);
    } else return new $da5e38505eeed8d6$export$d8d02ac92d161004(config);
}
class $da5e38505eeed8d6$export$23cb308301e89d6b extends $da5e38505eeed8d6$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
    }
    mergeFunction(inputs) {
        return (0, $d7Nxs.tidy)(()=>{
            let output = inputs[0];
            for(let i = 1; i < inputs.length; ++i)output = $7es6p.minimum(output, inputs[i]);
            return output;
        });
    }
}
/** @nocollapse */ $da5e38505eeed8d6$export$23cb308301e89d6b.className = 'Minimum';
(0, $ki3lz).registerClass($da5e38505eeed8d6$export$23cb308301e89d6b);
function $da5e38505eeed8d6$export$916782c1f0ddb132(config) {
    if (Array.isArray(config)) {
        const layer = new $da5e38505eeed8d6$export$23cb308301e89d6b({});
        return layer.apply(config);
    } else return new $da5e38505eeed8d6$export$23cb308301e89d6b(config);
}
class $da5e38505eeed8d6$export$e55b597c359d82cd extends $da5e38505eeed8d6$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
        this.DEFAULT_AXIS = -1;
        if (args == null) args = {};
        this.axis = args.axis == null ? this.DEFAULT_AXIS : args.axis;
        this.supportsMasking = true;
        this.reshapeRequired = false;
    }
    build(inputShape) {
        // Used purely for shape validation.]
        if (!(Array.isArray(inputShape) && Array.isArray(inputShape[0])) || inputShape.length === 1) throw new (0, $kubuc.ValueError)("A `Concatenate` layer should be called on a list of at least 2 inputs");
        inputShape;
        let allNoneShape = true;
        for (const shape of inputShape)if (shape != null) {
            allNoneShape = false;
            break;
        }
        if (allNoneShape) return;
        const shapeSet = [];
        for(let i = 0; i < inputShape.length; ++i){
            const shapeWithoutConcatAxis = inputShape[i].slice();
            shapeWithoutConcatAxis.splice(this.axis, 1);
            let exists = false;
            for (const shape of shapeSet)if ((0, $lBDHD).arraysEqual(shape, shapeWithoutConcatAxis)) {
                exists = true;
                break;
            }
            if (!exists) shapeSet.push(shapeWithoutConcatAxis);
        }
        if (shapeSet.length > 1) throw new (0, $kubuc.ValueError)("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: " + JSON.stringify(inputShape));
    }
    mergeFunction(inputs) {
        return (0, $d7Nxs.tidy)(()=>{
            return $4AyI5.concatenate(inputs, this.axis);
        });
    }
    computeOutputShape(inputShape) {
        if (!(Array.isArray(inputShape) && Array.isArray(inputShape[0]))) throw new (0, $kubuc.ValueError)('A `Concatenate` layer should be called on a list of inputs.');
        const inputShapes = inputShape;
        const outputShape = inputShapes[0].slice();
        const axis = this.axis < 0 ? outputShape.length + this.axis : this.axis;
        // Porting Note: the line above is because TypeScript doesn't support
        //   negative indices.
        for (const shape of inputShapes.slice(1)){
            if (outputShape[axis] == null || shape[axis] == null) {
                outputShape[axis] = null;
                break;
            }
            outputShape[axis] += shape[axis];
        }
        return outputShape;
    }
    computeMask(inputs, mask) {
        if (mask == null) return null;
        if (!Array.isArray(mask)) throw new (0, $kubuc.ValueError)('`mask` should be an array for Concatenate');
        if (!Array.isArray(inputs)) throw new (0, $kubuc.ValueError)('`inputs` should be an array for Concatenate');
        if (mask.length !== inputs.length) throw new (0, $kubuc.ValueError)(`Mismatch in the length of mask (${mask.length}) ` + `and the legnth of inputs (${inputs.length})`);
        return $d7Nxs.tidy(()=>{
            let allNullMasks = true;
            mask.forEach((m)=>{
                if (m != null) {
                    allNullMasks = false;
                    return;
                }
            });
            if (allNullMasks) return null;
            const outputMasks = [];
            for(let i = 0; i < inputs.length; ++i){
                if (mask[i] == null) // Input is unmasked. Append all 1's to masks.
                outputMasks.push($fxiHg.cast($6zg0w.onesLike(inputs[i]), 'bool'));
                else if (mask[i].rank < inputs[i].rank) // Mask is smaller than the input, expand it.
                outputMasks.push($fO4kJ.expandDims(mask[i], -1));
                else outputMasks.push(mask[i]);
            }
            const concatenatedMasks = $1goxr.concat(outputMasks, this.axis);
            return $c3y0I.all(concatenatedMasks, -1, false);
        });
    }
    getConfig() {
        const config = {
            'axis': this.axis
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $da5e38505eeed8d6$export$e55b597c359d82cd.className = 'Concatenate';
(0, $ki3lz).registerClass($da5e38505eeed8d6$export$e55b597c359d82cd);
function $da5e38505eeed8d6$export$375c71d43969527d(config) {
    if (Array.isArray(config)) {
        const layer = new $da5e38505eeed8d6$export$e55b597c359d82cd({});
        return layer.apply(config);
    } else return new $da5e38505eeed8d6$export$e55b597c359d82cd(config);
}
/**
 * Interpretable potentially negative axis index.
 *
 * For example, given axis = -1, and dim = 3, this function will return 2.
 *
 * @param axis The axis index, may be a positive, zero or negative integer.
 * @param dim Total number of dimensions, a positive integer.
 * @returns A non-negative axis index equivalent to the input `axis`.
 */ function $da5e38505eeed8d6$var$interpretAxis(axis, dim) {
    while(axis < 0)axis += dim;
    return axis;
}
function $da5e38505eeed8d6$var$batchDot(x, y, axes) {
    if (x.shape.length > 3 || y.shape.length > 3) throw new (0, $kubuc.NotImplementedError)('batchDot is not implemented for tensors of 4D or higher rank yet');
    $lBDHD.assert(x.shape.length >= 2, ()=>`batchDot requires the rank of x to be >= 2, ` + `but got ${x.shape.length}`);
    $lBDHD.assert(x.shape.length >= 2, ()=>`batchDot requires the rank of y to be >= 2, ` + `but got ${y.shape.length}`);
    if (typeof axes === 'number') axes = [
        axes,
        axes
    ];
    if (x.dtype === 'complex64' || y.dtype === 'complex64') throw new (0, $kubuc.NotImplementedError)('batchDot is not implemented for complex64-type Tensors yet.');
    const xNDim = x.shape.length;
    const yNDim = y.shape.length;
    if (axes == null) // Behave like batchMatmul by default.
    axes = [
        xNDim - 1,
        yNDim - 2
    ];
    const axesArray = axes;
    return $d7Nxs.tidy(()=>{
        let diff;
        if (xNDim > yNDim) {
            diff = xNDim - yNDim;
            const diffShape = [];
            for(let i = 0; i < diff; ++i)diffShape.push(1);
            y = $8nMOl.reshape(y, y.shape.concat(diffShape));
        } else if (yNDim > xNDim) {
            diff = yNDim - xNDim;
            const diffShape = [];
            for(let i = 0; i < diff; ++i)diffShape.push(1);
            x = $8nMOl.reshape(x, x.shape.concat(diffShape));
        } else diff = 0;
        let out;
        if (x.shape.length === 2 && y.shape.length === 2) {
            if (axesArray[0] === axesArray[1]) out = $fPnAL.sum($5hAos.mul(x, y), axesArray[0]);
            else out = $fPnAL.sum($5hAos.mul($9c2so.transpose(x, [
                1,
                0
            ]), y), axesArray[1]);
        } else {
            const adjX = axesArray[0] !== x.shape.length - 1;
            const adjY = axesArray[1] === y.shape.length - 1;
            out = $VLFo8.matMul(x, y, adjX, adjY);
        }
        if (diff > 0) {
            let idx;
            if (xNDim > yNDim) idx = xNDim + yNDim - 3;
            else idx = xNDim - 1;
            const squeezeAxes = [];
            for(let i = idx; i < idx + diff; ++i)squeezeAxes.push(i);
            out = $gP42y.squeeze(out, squeezeAxes);
        }
        if (out.shape.length === 1) out = $fO4kJ.expandDims(out, 1);
        return out;
    });
}
class $da5e38505eeed8d6$export$d046b3c4a416f60d extends $da5e38505eeed8d6$export$70ce1d34efd3b886 {
    constructor(args){
        super(args);
        this.axes = args.axes;
        this.normalize = args.normalize == null ? false : args.normalize;
        this.supportsMasking = true;
        this.reshapeRequired = false;
    }
    build(inputShape) {
        $lBDHD.assert(Array.isArray(inputShape) && inputShape.length === 2 && Array.isArray(inputShape[0]) && Array.isArray(inputShape[1]), ()=>'A `Dot` layer should be called on a list of exactly 2 inputs.');
        const shape1 = inputShape[0];
        const shape2 = inputShape[1];
        if (shape1.length > 3 || shape2.length > 3) throw new (0, $kubuc.NotImplementedError)('Dot layer does not support tensors of 4D or higher rank yet.');
        const axes = this.interpretAxes(shape1, shape2);
        if (shape1[axes[0]] !== shape2[axes[1]]) throw new (0, $kubuc.ValueError)(`Dimension incompatibility: ` + `${shape1[axes[0]]} !== ${shape2[axes[1]]}`);
    }
    mergeFunction(inputs) {
        if (inputs.length !== 2) throw new (0, $kubuc.ValueError)('A `Dot` layer must be called on exactly 2 inputs, ' + `but received ${inputs.length} input(s).`);
        let x1 = inputs[0];
        let x2 = inputs[1];
        let axes;
        if (!Array.isArray(this.axes)) axes = [
            $da5e38505eeed8d6$var$interpretAxis(this.axes, x1.shape.length),
            $da5e38505eeed8d6$var$interpretAxis(this.axes, x2.shape.length)
        ];
        else axes = this.axes.map((axis, i)=>$da5e38505eeed8d6$var$interpretAxis(axis, inputs[i].shape.length));
        if (this.normalize) {
            x1 = (0, $lg9tU.l2Normalize)(x1, axes[0]);
            x2 = (0, $lg9tU.l2Normalize)(x2, axes[1]);
        }
        return $da5e38505eeed8d6$var$batchDot(x1, x2, axes);
    }
    interpretAxes(shape1, shape2) {
        let axes;
        if (!Array.isArray(this.axes)) // `this.axes` is a single integer.
        axes = [
            $da5e38505eeed8d6$var$interpretAxis(this.axes, shape1.length),
            $da5e38505eeed8d6$var$interpretAxis(this.axes, shape2.length)
        ];
        else // `this.axes` is an Array of integers.
        axes = this.axes;
        return axes;
    }
    computeOutputShape(inputShape) {
        $lBDHD.assert(Array.isArray(inputShape) && inputShape.length === 2 && Array.isArray(inputShape[0]) && Array.isArray(inputShape[1]), ()=>'A `Dot` layer should be called on a list of exactly 2 inputs.');
        const shape1 = inputShape[0].slice();
        const shape2 = inputShape[1].slice();
        if (shape1.length > 3 || shape2.length > 3) throw new (0, $kubuc.NotImplementedError)('Dot layer does not support tensors of 4D or higher rank yet.');
        const axes = this.interpretAxes(shape1, shape2);
        shape1.splice(axes[0], 1);
        shape2.splice(axes[1], 1);
        shape2.splice(0, 1);
        const outputShape = shape1.concat(shape2);
        if (outputShape.length === 1) outputShape.push(1);
        return outputShape;
    }
    computeMask(inputs, mask) {
        return null;
    }
    getConfig() {
        const config = {
            'axes': this.axes,
            'normalize': this.normalize
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $da5e38505eeed8d6$export$d046b3c4a416f60d.className = 'Dot';
(0, $ki3lz).registerClass($da5e38505eeed8d6$export$d046b3c4a416f60d); // TODO(cais): Add functional interfaces for the merge layers.

});

parcelRegister("e3ZDe", function(module, exports) {

$parcel$export(module.exports, "GaussianNoise", function () { return $a3d12748b89f2e44$export$d18d3f770cea837e; });
$parcel$export(module.exports, "GaussianDropout", function () { return $a3d12748b89f2e44$export$c07c4bcc10d07979; });
$parcel$export(module.exports, "AlphaDropout", function () { return $a3d12748b89f2e44$export$8a44d71014be114; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Noise Layers.
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $kKLvn = parcelRequire("kKLvn");
var $5hAos = parcelRequire("5hAos");
var $9ORo6 = parcelRequire("9ORo6");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");

var $4AyI5 = parcelRequire("4AyI5");

var $jWpeh = parcelRequire("jWpeh");

var $bMNfZ = parcelRequire("bMNfZ");
class $a3d12748b89f2e44$export$d18d3f770cea837e extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.stddev = args.stddev;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            stddev: this.stddev
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            const noised = ()=>(0, $6Ab5n.add)($4AyI5.randomNormal(input.shape, 0, this.stddev), input);
            const output = $4AyI5.inTrainPhase(noised, ()=>input, kwargs['training'] || false);
            return output;
        });
    }
}
/** @nocollapse */ $a3d12748b89f2e44$export$d18d3f770cea837e.className = 'GaussianNoise';
(0, $ki3lz).registerClass($a3d12748b89f2e44$export$d18d3f770cea837e);
class $a3d12748b89f2e44$export$c07c4bcc10d07979 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.rate = args.rate;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            rate: this.rate
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (this.rate > 0 && this.rate < 1) {
                const noised = ()=>{
                    const stddev = Math.sqrt(this.rate / (1 - this.rate));
                    return (0, $5hAos.mul)(input, $4AyI5.randomNormal(input.shape, 1, stddev));
                };
                return $4AyI5.inTrainPhase(noised, ()=>input, kwargs['training'] || false);
            }
            return input;
        });
    }
}
/** @nocollapse */ $a3d12748b89f2e44$export$c07c4bcc10d07979.className = 'GaussianDropout';
(0, $ki3lz).registerClass($a3d12748b89f2e44$export$c07c4bcc10d07979);
/**
 * Applies Alpha Dropout to the input.
 *
 * As it is a regularization layer, it is only active at training time.
 *
 * Alpha Dropout is a `Dropout` that keeps mean and variance of inputs
 * to their original values, in order to ensure the self-normalizing property
 * even after this dropout.
 * Alpha Dropout fits well to Scaled Exponential Linear Units
 * by randomly setting activations to the negative saturation value.
 *
 * Arguments:
 *   - `rate`: float, drop probability (as with `Dropout`).
 *     The multiplicative noise will have
 *     standard deviation `sqrt(rate / (1 - rate))`.
 *   - `noise_shape`: A 1-D `Tensor` of type `int32`, representing the
 *     shape for randomly generated keep/drop flags.
 *
 * Input shape:
 *   Arbitrary. Use the keyword argument `inputShape`
 *   (tuple of integers, does not include the samples axis)
 *   when using this layer as the first layer in a model.
 *
 * Output shape:
 *   Same shape as input.
 *
 * References:
 *   - [Self-Normalizing Neural Networks](https://arxiv.org/abs/1706.02515)
 */ class $a3d12748b89f2e44$export$8a44d71014be114 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.supportsMasking = true;
        this.rate = args.rate;
        this.noiseShape = args.noiseShape;
    }
    _getNoiseShape(inputs) {
        return this.noiseShape || (0, $bMNfZ.getExactlyOneTensor)(inputs).shape;
    }
    computeOutputShape(inputShape) {
        return inputShape;
    }
    getConfig() {
        const baseConfig = super.getConfig();
        const config = {
            rate: this.rate
        };
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            if (this.rate < 1 && this.rate > 0) {
                const noiseShape = this._getNoiseShape(inputs);
                const droppedInputs = ()=>{
                    const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
                    const alpha = 1.6732632423543772848170429916717;
                    const scale = 1.0507009873554804934193349852946;
                    const alphaP = -alpha * scale;
                    let keptIdx = (0, $kKLvn.greaterEqual)((0, $9ORo6.randomUniform)(noiseShape), this.rate);
                    keptIdx = $4AyI5.cast(keptIdx, 'float32'); // get default dtype.
                    // Get affine transformation params.
                    const a = ((1 - this.rate) * (1 + this.rate * alphaP ** 2)) ** -0.5;
                    const b = -a * alphaP * this.rate;
                    // Apply mask.
                    const x = (0, $6Ab5n.add)((0, $5hAos.mul)(input, keptIdx), (0, $5hAos.mul)((0, $6Ab5n.add)(keptIdx, -1), alphaP));
                    return (0, $6Ab5n.add)((0, $5hAos.mul)(x, a), b);
                };
                return $4AyI5.inTrainPhase(droppedInputs, ()=>(0, $bMNfZ.getExactlyOneTensor)(inputs), kwargs['training'] || false);
            }
            return inputs;
        });
    }
}
/** @nocollapse */ $a3d12748b89f2e44$export$8a44d71014be114.className = 'AlphaDropout';
(0, $ki3lz).registerClass($a3d12748b89f2e44$export$8a44d71014be114);

});

parcelRegister("6tWVg", function(module, exports) {

$parcel$export(module.exports, "BatchNormalization", function () { return $4b8328553e93fe09$export$21e75adabb5b0994; });
$parcel$export(module.exports, "LayerNormalization", function () { return $4b8328553e93fe09$export$12bc76b160b1bdc; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Normalization layers.
 */ parcelRequire("8AHkS");
var $cgFzb = parcelRequire("cgFzb");
var $hBBSw = parcelRequire("hBBSw");
var $5JMTM = parcelRequire("5JMTM");
var $lImqN = parcelRequire("lImqN");
var $5hAos = parcelRequire("5hAos");
var $8nMOl = parcelRequire("8nMOl");
var $ki3lz = parcelRequire("ki3lz");
var $5jGN9 = parcelRequire("5jGN9");
var $d7Nxs = parcelRequire("d7Nxs");
var $dolPi = parcelRequire("dolPi");
var $lBDHD = parcelRequire("lBDHD");

var $ghUz9 = parcelRequire("ghUz9");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $lHlnu = parcelRequire("lHlnu");

var $1NdPD = parcelRequire("1NdPD");

var $jYx5u = parcelRequire("jYx5u");

var $4SWqG = parcelRequire("4SWqG");

var $bMNfZ = parcelRequire("bMNfZ");
function $4b8328553e93fe09$export$598a795b5a50c0b5(x, mean, variance, beta, gamma, epsilon = 1e-3) {
    let out;
    if (x.rank === 2) out = $cgFzb.batchNorm2d(x, mean, variance, beta, gamma, epsilon);
    else if (x.rank === 3) // TODO(cais): Check rank; give proper error message.
    out = $hBBSw.batchNorm3d(x, mean, variance, beta, gamma, epsilon);
    else if (x.rank === 4) out = $5JMTM.batchNorm4d(x, mean, variance, beta, gamma, epsilon);
    else throw new (0, $kubuc.NotImplementedError)(`batchNormalization is not implemented for array of rank ${x.rank} ` + `yet`);
    return out;
}
/**
 * Non-broadcasting batch normalization for use in training (not inference).
 *
 * The input is normalized to zero mean and unit variance along the
 * `reductionAxes`, followed by scaling with `gamma` and shifted by `beta`.
 * The result of that is returned as the first element
 * of the returned `Array`. The other two elements are the mean and variance,
 * respectively.
 *
 * @param x Input tensor to be normalized.
 * @param gamma Tensor by which to scale the input.
 * @param beta Tensor by which to center the input.
 * @param reductionAxes Axes over which to normalize.
 * @param epsilon Fuzz factor.
 * @returns An `Array` of three `Tensors`:
 *   [normalized tensor, mean of input, variance of input].
 */ function $4b8328553e93fe09$var$regularNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    return (0, $d7Nxs.tidy)(()=>{
        const meanAndVariance = $lImqN.moments(x, reductionAxes);
        const mean = meanAndVariance.mean;
        const variance = meanAndVariance.variance;
        const normed = $4b8328553e93fe09$export$598a795b5a50c0b5(x, mean, variance, beta, gamma, epsilon);
        return [
            normed,
            mean,
            variance
        ];
    });
}
/**
 * Broadcasting batch normalization for use in training (not inference).
 *
 * The input is normalized to zero mean and unit variance along the
 * `reductionAxes`, followed by scaling with `gamma` and shifted by `beta`.
 * The result of that is returned as the first element
 * of the returned `Array`. The other two elements are the mean and variance,
 * respectively.
 *
 * @param x Input tensor to be normalized.
 * @param gamma Tensor by which to scale the input.
 * @param beta Tensor by which to center the input.
 * @param reductionAxes Axes over which to normalize.
 * @param epsilon Fuzz factor.
 * @returns An `Array` of three `Tensors`:
 *   [normalized tensor, mean of input, variance of input].
 */ function $4b8328553e93fe09$var$broadcastNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    return (0, $d7Nxs.tidy)(()=>{
        const meanAndVariance = $lImqN.moments(x, reductionAxes);
        const mean = meanAndVariance.mean;
        const variance = meanAndVariance.variance;
        const targetShape = [];
        for (const axis of $4SWqG.range(0, x.rank))if (reductionAxes.indexOf(axis) !== -1) targetShape.push(1);
        else targetShape.push(x.shape[axis]);
        const broadcastMean = (0, $8nMOl.reshape)(mean, targetShape);
        const broadcastVariance = (0, $8nMOl.reshape)(variance, targetShape);
        const broadcastGamma = gamma == null ? null : (0, $8nMOl.reshape)(gamma, targetShape);
        const broadcastBeta = beta == null ? null : (0, $8nMOl.reshape)(beta, targetShape);
        const normed = $4b8328553e93fe09$export$598a795b5a50c0b5(x, broadcastMean, broadcastVariance, broadcastBeta, broadcastGamma, epsilon);
        return [
            normed,
            mean,
            variance
        ];
    });
}
function $4b8328553e93fe09$export$edbf80b9b58fbf69(x, gamma, beta, reductionAxes, epsilon = 1e-3) {
    if ((0, $lBDHD).arraysEqual(reductionAxes.slice().sort(), $4SWqG.range(0, x.rank - 1))) return $4b8328553e93fe09$var$regularNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon);
    else return $4b8328553e93fe09$var$broadcastNormalizeBatchInTraining(x, gamma, beta, reductionAxes, epsilon);
}
class $4b8328553e93fe09$export$21e75adabb5b0994 extends (0, $jWpeh.Layer) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.supportsMasking = true;
        this.axis = args.axis == null ? -1 : args.axis;
        this.momentum = args.momentum == null ? 0.99 : args.momentum;
        this.epsilon = args.epsilon == null ? 1e-3 : args.epsilon;
        this.center = args.center == null ? true : args.center;
        this.scale = args.scale == null ? true : args.scale;
        this.betaInitializer = (0, $lHlnu.getInitializer)(args.betaInitializer || 'zeros');
        this.gammaInitializer = (0, $lHlnu.getInitializer)(args.gammaInitializer || 'ones');
        this.movingMeanInitializer = (0, $lHlnu.getInitializer)(args.movingMeanInitializer || 'zeros');
        this.movingVarianceInitializer = (0, $lHlnu.getInitializer)(args.movingVarianceInitializer || 'ones');
        this.betaConstraint = (0, $ghUz9.getConstraint)(args.betaConstraint);
        this.gammaConstraint = (0, $ghUz9.getConstraint)(args.gammaConstraint);
        this.betaRegularizer = (0, $1NdPD.getRegularizer)(args.betaRegularizer);
        this.gammaRegularizer = (0, $1NdPD.getRegularizer)(args.gammaRegularizer);
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const axis = this.axis >= 0 ? this.axis : this.axis + inputShape.length;
        const dim = inputShape[axis];
        if (dim == null) throw new (0, $kubuc.ValueError)(`Axis ${axis} of input tensor should have a defined dimension but ` + `the layer received an input with shape ` + `${JSON.stringify(inputShape)}.`);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: inputShape.length,
                axes: {
                    [axis]: dim
                }
            })
        ];
        const shape = [
            dim
        ];
        if (this.scale) this.gamma = this.addWeight('gamma', shape, null, this.gammaInitializer, this.gammaRegularizer, true, this.gammaConstraint);
        if (this.center) this.beta = this.addWeight('beta', shape, null, this.betaInitializer, this.betaRegularizer, true, this.betaConstraint);
        this.movingMean = this.addWeight('moving_mean', shape, null, this.movingMeanInitializer, null, false);
        this.movingVariance = this.addWeight('moving_variance', shape, null, this.movingVarianceInitializer, null, false);
        this.built = true;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const training = kwargs['training'] == null ? false : kwargs['training'];
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            const inputShape = input.shape;
            const ndim = inputShape.length;
            const reductionAxes = $4SWqG.range(0, ndim);
            const axis = this.axis >= 0 ? this.axis : this.axis + ndim;
            reductionAxes.splice(axis, 1);
            const broadcastShape = $jYx5u.pyListRepeat(1, ndim);
            broadcastShape[axis] = inputShape[axis];
            const sortedReductionAxes = reductionAxes.slice();
            sortedReductionAxes.sort();
            const needsBroadcasting = !(0, $lBDHD).arraysEqual(sortedReductionAxes, $4SWqG.range(0, ndim).slice(0, ndim - 1));
            const normalizeInference = ()=>{
                if (needsBroadcasting) {
                    const broadcastMovingMean = (0, $8nMOl.reshape)(this.movingMean.read(), broadcastShape);
                    const broadcastMovingVariance = (0, $8nMOl.reshape)(this.movingVariance.read(), broadcastShape);
                    const broadcastBeta = this.center ? (0, $8nMOl.reshape)(this.beta.read(), broadcastShape) : null;
                    const broadcastGamma = this.scale ? (0, $8nMOl.reshape)(this.gamma.read(), broadcastShape) : null;
                    return $4b8328553e93fe09$export$598a795b5a50c0b5(input, broadcastMovingMean, broadcastMovingVariance, broadcastBeta, broadcastGamma, this.epsilon);
                } else return $4b8328553e93fe09$export$598a795b5a50c0b5(input, this.movingMean.read(), this.movingVariance.read(), this.beta == null ? null : this.beta.read(), this.gamma == null ? null : this.gamma.read(), this.epsilon);
            };
            if (!training) return normalizeInference();
            const [normedTraining, mean, variance] = $4b8328553e93fe09$export$edbf80b9b58fbf69(input, this.gamma.read(), this.beta.read(), reductionAxes, this.epsilon);
            const doMovingAverage = (variable, value, momentum)=>{
                $d7Nxs.tidy(()=>{
                    const decay = 1 - momentum;
                    const origValue = variable.read();
                    const updateDelta = $5hAos.mul($5jGN9.sub(origValue, value), decay);
                    variable.write($5jGN9.sub(origValue, updateDelta));
                });
            };
            // Perform updates to moving mean and moving variance for training.
            // Porting Note: In PyKeras, these updates to `movingMean` and
            //   `movingAverage` are done as a deferred Graph, added to the `Layer`'s
            //   `update`s using the `add_update()` method. Here we do it imperatively
            //   and encapsulate the updates in a function that is invoked
            //   immediately.
            const updateMovingMeanAndVariance = ()=>{
                doMovingAverage(this.movingMean, mean, this.momentum);
                doMovingAverage(this.movingVariance, variance, this.momentum);
            };
            updateMovingMeanAndVariance();
            return normedTraining;
        });
    }
    getConfig() {
        const config = {
            axis: this.axis,
            momentum: this.momentum,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: (0, $lHlnu.serializeInitializer)(this.betaInitializer),
            gammaInitializer: (0, $lHlnu.serializeInitializer)(this.gammaInitializer),
            movingMeanInitializer: (0, $lHlnu.serializeInitializer)(this.movingMeanInitializer),
            movingVarianceInitializer: (0, $lHlnu.serializeInitializer)(this.movingVarianceInitializer),
            betaRegularizer: (0, $1NdPD.serializeRegularizer)(this.betaRegularizer),
            gammaRegularizer: (0, $1NdPD.serializeRegularizer)(this.gammaRegularizer),
            betaConstraint: (0, $ghUz9.serializeConstraint)(this.betaConstraint),
            gammaConstraint: (0, $ghUz9.serializeConstraint)(this.gammaConstraint)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $4b8328553e93fe09$export$21e75adabb5b0994.className = 'BatchNormalization';
(0, $ki3lz).registerClass($4b8328553e93fe09$export$21e75adabb5b0994);
class $4b8328553e93fe09$export$12bc76b160b1bdc extends (0, $jWpeh.Layer) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.axis = args.axis == null ? -1 : args.axis;
        if (typeof this.axis === 'number') {
            if (!Number.isInteger(this.axis)) throw new Error(`Expected axis to be an integer, but received ${this.axis}`);
        } else if (Array.isArray(this.axis)) for (const axis of this.axis){
            if (!Number.isInteger(axis)) throw new Error(`Expected axis to be an array of integers, ` + `but received ${JSON.stringify(this.axis)}`);
        }
        else throw new Error(`Expected axis to be an integer or an array of integers, ` + `but received ${JSON.stringify(this.axis)}`);
        this.epsilon = args.epsilon == null ? 1e-3 : args.epsilon;
        this.center = args.center == null ? true : args.center;
        this.scale = args.scale == null ? true : args.scale;
        this.betaInitializer = (0, $lHlnu.getInitializer)(args.betaInitializer || 'zeros');
        this.gammaInitializer = (0, $lHlnu.getInitializer)(args.gammaInitializer || 'ones');
        this.betaRegularizer = (0, $1NdPD.getRegularizer)(args.betaRegularizer);
        this.gammaRegularizer = (0, $1NdPD.getRegularizer)(args.gammaRegularizer);
        this.supportsMasking = true;
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const nDims = inputShape.length;
        // Convert axis to array and resolve negatives.
        if (typeof this.axis === 'number') this.axis = [
            this.axis
        ];
        for(let i = 0; i < this.axis.length; ++i)if (this.axis[i] < 0) this.axis[i] += nDims;
        // Further validate axes.
        for (const axis of this.axis){
            if (axis < 0 || axis >= nDims) throw new Error(`Invalid axis: ${axis}`);
        }
        if (this.axis.length !== $jYx5u.unique(this.axis).length) throw new Error(`Found duplicate axes in: ${this.axis}`);
        const paramShape = this.axis.map((axis)=>inputShape[axis]);
        const trainable = true;
        if (this.scale) this.gamma = this.addWeight('gamma', paramShape, 'float32', this.gammaInitializer, this.gammaRegularizer, trainable);
        else this.gamma = null;
        if (this.center) this.beta = this.addWeight('beta', paramShape, 'float32', this.betaInitializer, this.betaRegularizer, trainable);
        else this.beta = null;
        this.built = true;
    }
    call(inputs, kwargs) {
        const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
        const inputShape = input.shape;
        const nDims = inputShape.length;
        return (0, $d7Nxs.tidy)(()=>{
            const keepDims = true;
            let { mean: mean, variance: variance } = (0, $lImqN.moments)(input, this.axis, keepDims);
            const broadcastShape = $jYx5u.pyListRepeat(1, nDims);
            for (const dim of this.axis)broadcastShape[dim] = inputShape[dim];
            const broadcast = (v)=>{
                if (v != null && v.shape.length !== nDims) return $8nMOl.reshape(v, broadcastShape);
                else return v;
            };
            let scale = this.scale ? broadcast(this.gamma.read()) : null;
            let offset = this.center ? broadcast(this.beta.read()) : null;
            // TODO(https://github.com/tensorflow/tfjs/issues/2120): The tiling below
            // is a workaround for the limitation of core's batchNormalization?d don't
            // support broadcasting in their gradients. In addition, the tiling is
            // necessary to ensure correctness on the browser CPU backend regardless
            // of forward or backward computation. Remove this workaround once the
            // limitation is addressed. See .
            const momentsTiling = [];
            const scaleOffsetTiling = [];
            for(let i = 0; i < nDims; ++i)if (this.axis.indexOf(i) !== -1) {
                momentsTiling.push(inputShape[i]);
                scaleOffsetTiling.push(1);
            } else {
                momentsTiling.push(1);
                scaleOffsetTiling.push(inputShape[i]);
            }
            mean = $dolPi.tile(mean, momentsTiling);
            variance = $dolPi.tile(variance, momentsTiling);
            if (scale != null) scale = $dolPi.tile(scale, scaleOffsetTiling);
            if (offset != null) offset = $dolPi.tile(offset, scaleOffsetTiling);
            return $4b8328553e93fe09$export$598a795b5a50c0b5(input, mean, variance, offset, scale, this.epsilon);
        });
    }
    getConfig() {
        const config = {
            axis: this.axis,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: (0, $lHlnu.serializeInitializer)(this.betaInitializer),
            gammaInitializer: (0, $lHlnu.serializeInitializer)(this.gammaInitializer),
            betaRegularizer: (0, $1NdPD.serializeRegularizer)(this.betaRegularizer),
            gammaRegularizer: (0, $1NdPD.serializeRegularizer)(this.gammaRegularizer)
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $4b8328553e93fe09$export$12bc76b160b1bdc.className = 'LayerNormalization';
(0, $ki3lz).registerClass($4b8328553e93fe09$export$12bc76b160b1bdc);

});

parcelRegister("1IQ24", function(module, exports) {

$parcel$export(module.exports, "ZeroPadding2D", function () { return $14124310d7edef9c$export$3ae403604f7452b3; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Padding Layers.
 */ // Porting Note: In Python Keras, the padding layers are in convolutional.py,
//   but we decided to put them in a separate file (padding.ts) for clarity.
parcelRequire("8AHkS");
var $9XHOJ = parcelRequire("9XHOJ");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");

var $69VqB = parcelRequire("69VqB");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $bMNfZ = parcelRequire("bMNfZ");
function $14124310d7edef9c$export$cea7cd04e6f6329e(x, padding) {
    return (0, $d7Nxs.tidy)(()=>{
        if (x.rank !== 3) throw new (0, $kubuc.ValueError)(`temporalPadding expects input tensor to be 3-D, but received a ` + `${x.rank}-D tensor.`);
        if (padding == null) padding = [
            1,
            1
        ];
        if (padding.length !== 2) throw new (0, $kubuc.ValueError)(`temporalPadding expects input padding pattern to be a length-2 ` + `array, but received a length-${padding.length} array.`);
        const pattern = [
            [
                0,
                0
            ],
            padding,
            [
                0,
                0
            ]
        ];
        return $9XHOJ.pad(x, pattern);
    });
}
function $14124310d7edef9c$export$c1e7b1f1a92c089a(x, padding, dataFormat) {
    return (0, $d7Nxs.tidy)(()=>{
        if (x.rank !== 4) throw new (0, $kubuc.ValueError)(`temporalPadding expects input tensor to be 4-D, but received a ` + `${x.rank}-D tensor.`);
        if (padding == null) padding = [
            [
                1,
                1
            ],
            [
                1,
                1
            ]
        ];
        if (padding.length !== 2 || padding[0].length !== 2 || padding[1].length !== 2) throw new (0, $kubuc.ValueError)("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");
        if (dataFormat == null) dataFormat = (0, $69VqB.imageDataFormat)();
        if (dataFormat !== 'channelsLast' && dataFormat !== 'channelsFirst') throw new (0, $kubuc.ValueError)(`Unknown data format: ${dataFormat}. ` + `Supported data formats are 'channelsLast' and 'channelsFirst.`);
        let pattern;
        if (dataFormat === 'channelsFirst') pattern = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            padding[0],
            padding[1]
        ];
        else pattern = [
            [
                0,
                0
            ],
            padding[0],
            padding[1],
            [
                0,
                0
            ]
        ];
        return $9XHOJ.pad(x, pattern);
    });
}
class $14124310d7edef9c$export$3ae403604f7452b3 extends (0, $jWpeh.Layer) {
    constructor(args){
        if (args == null) args = {};
        super(args);
        this.dataFormat = args.dataFormat == null ? (0, $69VqB.imageDataFormat)() : args.dataFormat;
        // TODO(cais): Maybe refactor the following logic surrounding `padding`
        //   into a helper method.
        if (args.padding == null) this.padding = [
            [
                1,
                1
            ],
            [
                1,
                1
            ]
        ];
        else if (typeof args.padding === 'number') this.padding = [
            [
                args.padding,
                args.padding
            ],
            [
                args.padding,
                args.padding
            ]
        ];
        else {
            args.padding = args.padding;
            if (args.padding.length !== 2) throw new (0, $kubuc.ValueError)(`ZeroPadding2D expects padding to be a length-2 array, but ` + `received a length-${args.padding.length} array.`);
            let heightPadding;
            let widthPadding;
            if (typeof args.padding[0] === 'number') {
                heightPadding = [
                    args.padding[0],
                    args.padding[0]
                ];
                widthPadding = [
                    args.padding[1],
                    args.padding[1]
                ];
            } else {
                args.padding = args.padding;
                if (args.padding[0].length !== 2) throw new (0, $kubuc.ValueError)(`ZeroPadding2D expects height padding to be a length-2 array, ` + `but received a length-${args.padding[0].length} array.`);
                heightPadding = args.padding[0];
                if (args.padding[1].length !== 2) throw new (0, $kubuc.ValueError)(`ZeroPadding2D expects width padding to be a length-2 array, ` + `but received a length-${args.padding[1].length} array.`);
                widthPadding = args.padding[1];
            }
            this.padding = [
                heightPadding,
                widthPadding
            ];
        }
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        let rows;
        let cols;
        if (this.dataFormat === 'channelsFirst') {
            if (inputShape[2] != null && inputShape[2] >= 0) rows = inputShape[2] + this.padding[0][0] + this.padding[0][1];
            else rows = null;
            if (inputShape[3] != null && inputShape[3] >= 0) cols = inputShape[3] + this.padding[1][0] + this.padding[1][1];
            else cols = null;
            return [
                inputShape[0],
                inputShape[1],
                rows,
                cols
            ];
        } else {
            if (inputShape[1] != null && inputShape[1] >= 0) rows = inputShape[1] + this.padding[0][0] + this.padding[0][1];
            else rows = null;
            if (inputShape[2] != null && inputShape[2] >= 0) cols = inputShape[2] + this.padding[1][0] + this.padding[1][1];
            else cols = null;
            return [
                inputShape[0],
                rows,
                cols,
                inputShape[3]
            ];
        }
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>$14124310d7edef9c$export$c1e7b1f1a92c089a((0, $bMNfZ.getExactlyOneTensor)(inputs), this.padding, this.dataFormat));
    }
    getConfig() {
        const config = {
            padding: this.padding,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
/** @nocollapse */ $14124310d7edef9c$export$3ae403604f7452b3.className = 'ZeroPadding2D';
(0, $ki3lz).registerClass($14124310d7edef9c$export$3ae403604f7452b3);

});

parcelRegister("gz9kz", function(module, exports) {

$parcel$export(module.exports, "MaxPooling1D", function () { return $c0f7272421305618$export$ee33f1d34d09a0fd; });
$parcel$export(module.exports, "AveragePooling1D", function () { return $c0f7272421305618$export$abb9a5c13378a7fc; });
$parcel$export(module.exports, "MaxPooling2D", function () { return $c0f7272421305618$export$fae6981b13a5bc64; });
$parcel$export(module.exports, "AveragePooling2D", function () { return $c0f7272421305618$export$ba5e0a247bd733ca; });
$parcel$export(module.exports, "MaxPooling3D", function () { return $c0f7272421305618$export$5a12007b35aee0a; });
$parcel$export(module.exports, "AveragePooling3D", function () { return $c0f7272421305618$export$ee30b46b17aabb8f; });
$parcel$export(module.exports, "GlobalAveragePooling1D", function () { return $c0f7272421305618$export$2c6cc528d2786e91; });
$parcel$export(module.exports, "GlobalMaxPooling1D", function () { return $c0f7272421305618$export$ab40543f12b91a51; });
$parcel$export(module.exports, "GlobalAveragePooling2D", function () { return $c0f7272421305618$export$2bd55677c48d3dfa; });
$parcel$export(module.exports, "GlobalMaxPooling2D", function () { return $c0f7272421305618$export$46257bff79157c32; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * TensorFlow.js Layers: Pooling Layers.
 */ parcelRequire("8AHkS");
var $4LG6a = parcelRequire("4LG6a");
var $dTgsp = parcelRequire("dTgsp");
var $9GR6N = parcelRequire("9GR6N");
var $kHqOQ = parcelRequire("kHqOQ");
var $hG9Ff = parcelRequire("hG9Ff");
var $3TgHP = parcelRequire("3TgHP");
var $ki3lz = parcelRequire("ki3lz");
var $gP42y = parcelRequire("gP42y");
var $d7Nxs = parcelRequire("d7Nxs");
var $9c2so = parcelRequire("9c2so");

var $69VqB = parcelRequire("69VqB");

var $4AyI5 = parcelRequire("4AyI5");

var $1Xyaa = parcelRequire("1Xyaa");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $aT5kh = parcelRequire("aT5kh");

var $jYx5u = parcelRequire("jYx5u");

var $bMNfZ = parcelRequire("bMNfZ");

var $es1va = parcelRequire("es1va");
function $c0f7272421305618$export$d27fa8d08ae02aab(x, poolSize, strides, padding, dataFormat, poolMode) {
    return (0, $d7Nxs.tidy)(()=>{
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        (0, $1Xyaa.checkPoolMode)(poolMode);
        (0, $1Xyaa.checkPaddingMode)(padding);
        if (strides == null) strides = [
            1,
            1
        ];
        if (padding == null) padding = 'valid';
        if (dataFormat == null) dataFormat = (0, $69VqB.imageDataFormat)();
        if (poolMode == null) poolMode = 'max';
        // TODO(cais): Remove the preprocessing step once deeplearn.js supports
        // dataFormat as an input argument.
        x = (0, $es1va.preprocessConv2DInput)(x, dataFormat); // x is NHWC after preprocessing.
        let y;
        const paddingString = padding === 'same' ? 'same' : 'valid';
        if (poolMode === 'max') // TODO(cais): Rank check?
        y = $kHqOQ.maxPool(x, poolSize, strides, paddingString);
        else // TODO(cais): Check the dtype and rank of x and give clear error message
        //   if those are incorrect.
        y = $4LG6a.avgPool(// TODO(cais): Rank check?
        x, poolSize, strides, paddingString);
        if (dataFormat === 'channelsFirst') y = $9c2so.transpose(y, [
            0,
            3,
            1,
            2
        ]); // NHWC -> NCHW.
        return y;
    });
}
function $c0f7272421305618$export$3712ebf21d29ff82(x, poolSize, strides, padding, dataFormat, poolMode) {
    return (0, $d7Nxs.tidy)(()=>{
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        (0, $1Xyaa.checkPoolMode)(poolMode);
        (0, $1Xyaa.checkPaddingMode)(padding);
        if (strides == null) strides = [
            1,
            1,
            1
        ];
        if (padding == null) padding = 'valid';
        if (dataFormat == null) dataFormat = (0, $69VqB.imageDataFormat)();
        if (poolMode == null) poolMode = 'max';
        // x is NDHWC after preprocessing.
        x = (0, $es1va.preprocessConv3DInput)(x, dataFormat);
        let y;
        const paddingString = padding === 'same' ? 'same' : 'valid';
        if (poolMode === 'max') y = $hG9Ff.maxPool3d(x, poolSize, strides, paddingString);
        else y = $dTgsp.avgPool3d(x, poolSize, strides, paddingString);
        if (dataFormat === 'channelsFirst') y = $9c2so.transpose(y, [
            0,
            4,
            1,
            2,
            3
        ]); // NDHWC -> NCDHW.
        return y;
    });
}
class $c0f7272421305618$export$56e907da703e3750 extends (0, $jWpeh.Layer) {
    /**
     *
     * @param args Parameters for the Pooling layer.
     *
     * config.poolSize defaults to 2.
     */ constructor(args){
        if (args.poolSize == null) args.poolSize = 2;
        super(args);
        if (typeof args.poolSize === 'number') this.poolSize = [
            args.poolSize
        ];
        else if (Array.isArray(args.poolSize) && args.poolSize.length === 1 && typeof args.poolSize[0] === 'number') this.poolSize = args.poolSize;
        else throw new (0, $kubuc.ValueError)(`poolSize for 1D convolutional layer must be a number or an ` + `Array of a single number, but received ` + `${JSON.stringify(args.poolSize)}`);
        (0, $jYx5u.assertPositiveInteger)(this.poolSize, 'poolSize');
        if (args.strides == null) this.strides = this.poolSize;
        else {
            if (typeof args.strides === 'number') this.strides = [
                args.strides
            ];
            else if (Array.isArray(args.strides) && args.strides.length === 1 && typeof args.strides[0] === 'number') this.strides = args.strides;
            else throw new (0, $kubuc.ValueError)(`strides for 1D convolutional layer must be a number or an ` + `Array of a single number, but received ` + `${JSON.stringify(args.strides)}`);
        }
        (0, $jYx5u.assertPositiveInteger)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        (0, $1Xyaa.checkPaddingMode)(this.padding);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 3
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const length = (0, $aT5kh.convOutputLength)(inputShape[1], this.poolSize[0], this.padding, this.strides[0]);
        return [
            inputShape[0],
            length,
            inputShape[2]
        ];
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            // Add dummy last dimension.
            inputs = $4AyI5.expandDims((0, $bMNfZ.getExactlyOneTensor)(inputs), 2);
            const output = this.poolingFunction((0, $bMNfZ.getExactlyOneTensor)(inputs), [
                this.poolSize[0],
                1
            ], [
                this.strides[0],
                1
            ], this.padding, 'channelsLast');
            // Remove dummy last dimension.
            return $gP42y.squeeze(output, [
                2
            ]);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $c0f7272421305618$export$ee33f1d34d09a0fd extends $c0f7272421305618$export$56e907da703e3750 {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        (0, $1Xyaa.checkPaddingMode)(padding);
        return $c0f7272421305618$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $c0f7272421305618$export$ee33f1d34d09a0fd.className = 'MaxPooling1D';
(0, $ki3lz).registerClass($c0f7272421305618$export$ee33f1d34d09a0fd);
class $c0f7272421305618$export$abb9a5c13378a7fc extends $c0f7272421305618$export$56e907da703e3750 {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        (0, $1Xyaa.checkPaddingMode)(padding);
        return $c0f7272421305618$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $c0f7272421305618$export$abb9a5c13378a7fc.className = 'AveragePooling1D';
(0, $ki3lz).registerClass($c0f7272421305618$export$abb9a5c13378a7fc);
class $c0f7272421305618$export$3f5b37e58ac9bb8f extends (0, $jWpeh.Layer) {
    constructor(args){
        if (args.poolSize == null) args.poolSize = [
            2,
            2
        ];
        super(args);
        this.poolSize = Array.isArray(args.poolSize) ? args.poolSize : [
            args.poolSize,
            args.poolSize
        ];
        if (args.strides == null) this.strides = this.poolSize;
        else if (Array.isArray(args.strides)) {
            if (args.strides.length !== 2) throw new (0, $kubuc.ValueError)(`If the strides property of a 2D pooling layer is an Array, ` + `it is expected to have a length of 2, but received length ` + `${args.strides.length}.`);
            this.strides = args.strides;
        } else // `config.strides` is a number.
        this.strides = [
            args.strides,
            args.strides
        ];
        (0, $jYx5u.assertPositiveInteger)(this.poolSize, 'poolSize');
        (0, $jYx5u.assertPositiveInteger)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $1Xyaa.checkDataFormat)(this.dataFormat);
        (0, $1Xyaa.checkPaddingMode)(this.padding);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        let rows = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        let cols = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        rows = (0, $aT5kh.convOutputLength)(rows, this.poolSize[0], this.padding, this.strides[0]);
        cols = (0, $aT5kh.convOutputLength)(cols, this.poolSize[1], this.padding, this.strides[1]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            rows,
            cols
        ];
        else return [
            inputShape[0],
            rows,
            cols,
            inputShape[3]
        ];
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            return this.poolingFunction((0, $bMNfZ.getExactlyOneTensor)(inputs), this.poolSize, this.strides, this.padding, this.dataFormat);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $c0f7272421305618$export$fae6981b13a5bc64 extends $c0f7272421305618$export$3f5b37e58ac9bb8f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        (0, $1Xyaa.checkPaddingMode)(padding);
        return $c0f7272421305618$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $c0f7272421305618$export$fae6981b13a5bc64.className = 'MaxPooling2D';
(0, $ki3lz).registerClass($c0f7272421305618$export$fae6981b13a5bc64);
class $c0f7272421305618$export$ba5e0a247bd733ca extends $c0f7272421305618$export$3f5b37e58ac9bb8f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        (0, $1Xyaa.checkPaddingMode)(padding);
        return $c0f7272421305618$export$d27fa8d08ae02aab(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $c0f7272421305618$export$ba5e0a247bd733ca.className = 'AveragePooling2D';
(0, $ki3lz).registerClass($c0f7272421305618$export$ba5e0a247bd733ca);
class $c0f7272421305618$export$d922ad75eee6c49f extends (0, $jWpeh.Layer) {
    constructor(args){
        if (args.poolSize == null) args.poolSize = [
            2,
            2,
            2
        ];
        super(args);
        this.poolSize = Array.isArray(args.poolSize) ? args.poolSize : [
            args.poolSize,
            args.poolSize,
            args.poolSize
        ];
        if (args.strides == null) this.strides = this.poolSize;
        else if (Array.isArray(args.strides)) {
            if (args.strides.length !== 3) throw new (0, $kubuc.ValueError)(`If the strides property of a 3D pooling layer is an Array, ` + `it is expected to have a length of 3, but received length ` + `${args.strides.length}.`);
            this.strides = args.strides;
        } else // `config.strides` is a number.
        this.strides = [
            args.strides,
            args.strides,
            args.strides
        ];
        (0, $jYx5u.assertPositiveInteger)(this.poolSize, 'poolSize');
        (0, $jYx5u.assertPositiveInteger)(this.strides, 'strides');
        this.padding = args.padding == null ? 'valid' : args.padding;
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $1Xyaa.checkDataFormat)(this.dataFormat);
        (0, $1Xyaa.checkPaddingMode)(this.padding);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 5
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        let depths = this.dataFormat === 'channelsFirst' ? inputShape[2] : inputShape[1];
        let rows = this.dataFormat === 'channelsFirst' ? inputShape[3] : inputShape[2];
        let cols = this.dataFormat === 'channelsFirst' ? inputShape[4] : inputShape[3];
        depths = (0, $aT5kh.convOutputLength)(depths, this.poolSize[0], this.padding, this.strides[0]);
        rows = (0, $aT5kh.convOutputLength)(rows, this.poolSize[1], this.padding, this.strides[1]);
        cols = (0, $aT5kh.convOutputLength)(cols, this.poolSize[2], this.padding, this.strides[2]);
        if (this.dataFormat === 'channelsFirst') return [
            inputShape[0],
            inputShape[1],
            depths,
            rows,
            cols
        ];
        else return [
            inputShape[0],
            depths,
            rows,
            cols,
            inputShape[4]
        ];
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            this.invokeCallHook(inputs, kwargs);
            return this.poolingFunction((0, $bMNfZ.getExactlyOneTensor)(inputs), this.poolSize, this.strides, this.padding, this.dataFormat);
        });
    }
    getConfig() {
        const config = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $c0f7272421305618$export$5a12007b35aee0a extends $c0f7272421305618$export$d922ad75eee6c49f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        (0, $1Xyaa.checkPaddingMode)(padding);
        return $c0f7272421305618$export$3712ebf21d29ff82(inputs, poolSize, strides, padding, dataFormat, 'max');
    }
}
/** @nocollapse */ $c0f7272421305618$export$5a12007b35aee0a.className = 'MaxPooling3D';
(0, $ki3lz).registerClass($c0f7272421305618$export$5a12007b35aee0a);
class $c0f7272421305618$export$ee30b46b17aabb8f extends $c0f7272421305618$export$d922ad75eee6c49f {
    constructor(args){
        super(args);
    }
    poolingFunction(inputs, poolSize, strides, padding, dataFormat) {
        (0, $1Xyaa.checkDataFormat)(dataFormat);
        (0, $1Xyaa.checkPaddingMode)(padding);
        return $c0f7272421305618$export$3712ebf21d29ff82(inputs, poolSize, strides, padding, dataFormat, 'avg');
    }
}
/** @nocollapse */ $c0f7272421305618$export$ee30b46b17aabb8f.className = 'AveragePooling3D';
(0, $ki3lz).registerClass($c0f7272421305618$export$ee30b46b17aabb8f);
class $c0f7272421305618$export$ac2acb21ca818c40 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 3
            })
        ];
    }
    computeOutputShape(inputShape) {
        return [
            inputShape[0],
            inputShape[2]
        ];
    }
    call(inputs, kwargs) {
        throw new (0, $kubuc.NotImplementedError)();
    }
}
class $c0f7272421305618$export$2c6cc528d2786e91 extends $c0f7272421305618$export$ac2acb21ca818c40 {
    constructor(args){
        super(args || {});
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            return $3TgHP.mean(input, 1);
        });
    }
}
/** @nocollapse */ $c0f7272421305618$export$2c6cc528d2786e91.className = 'GlobalAveragePooling1D';
(0, $ki3lz).registerClass($c0f7272421305618$export$2c6cc528d2786e91);
class $c0f7272421305618$export$ab40543f12b91a51 extends $c0f7272421305618$export$ac2acb21ca818c40 {
    constructor(args){
        super(args || {});
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            return $9GR6N.max(input, 1);
        });
    }
}
/** @nocollapse */ $c0f7272421305618$export$ab40543f12b91a51.className = 'GlobalMaxPooling1D';
(0, $ki3lz).registerClass($c0f7272421305618$export$ab40543f12b91a51);
class $c0f7272421305618$export$5eafa45e8fcdd59f extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.dataFormat = args.dataFormat == null ? 'channelsLast' : args.dataFormat;
        (0, $1Xyaa.checkDataFormat)(this.dataFormat);
        this.inputSpec = [
            new (0, $jWpeh.InputSpec)({
                ndim: 4
            })
        ];
    }
    computeOutputShape(inputShape) {
        inputShape;
        if (this.dataFormat === 'channelsLast') return [
            inputShape[0],
            inputShape[3]
        ];
        else return [
            inputShape[0],
            inputShape[1]
        ];
    }
    call(inputs, kwargs) {
        throw new (0, $kubuc.NotImplementedError)();
    }
    getConfig() {
        const config = {
            dataFormat: this.dataFormat
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
class $c0f7272421305618$export$2bd55677c48d3dfa extends $c0f7272421305618$export$5eafa45e8fcdd59f {
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (this.dataFormat === 'channelsLast') return $3TgHP.mean(input, [
                1,
                2
            ]);
            else return $3TgHP.mean(input, [
                2,
                3
            ]);
        });
    }
}
/** @nocollapse */ $c0f7272421305618$export$2bd55677c48d3dfa.className = 'GlobalAveragePooling2D';
(0, $ki3lz).registerClass($c0f7272421305618$export$2bd55677c48d3dfa);
class $c0f7272421305618$export$46257bff79157c32 extends $c0f7272421305618$export$5eafa45e8fcdd59f {
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (this.dataFormat === 'channelsLast') return $9GR6N.max(input, [
                1,
                2
            ]);
            else return $9GR6N.max(input, [
                2,
                3
            ]);
        });
    }
}
/** @nocollapse */ $c0f7272421305618$export$46257bff79157c32.className = 'GlobalMaxPooling2D';
(0, $ki3lz).registerClass($c0f7272421305618$export$46257bff79157c32);

});

parcelRegister("ijvBj", function(module, exports) {

$parcel$export(module.exports, "TimeDistributed", function () { return $d5528399593d7f9f$export$72d58104314bdbf3; });
$parcel$export(module.exports, "Bidirectional", function () { return $d5528399593d7f9f$export$edf712313f3d75dd; });
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Layers that augment the functionality of a base layer.
 */ parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $5hAos = parcelRequire("5hAos");
var $5ApPj = parcelRequire("5ApPj");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");

var $4AyI5 = parcelRequire("4AyI5");

var $1Xyaa = parcelRequire("1Xyaa");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $46TaI = parcelRequire("46TaI");

var $jYx5u = parcelRequire("jYx5u");

var $bMNfZ = parcelRequire("bMNfZ");

var $2QjI9 = parcelRequire("2QjI9");

var $4v3Le = parcelRequire("4v3Le");
class $d5528399593d7f9f$export$e6dfd72ab29f8598 extends (0, $jWpeh.Layer) {
    constructor(args){
        // Porting Note: In PyKeras, `self.layer` is set prior to the calling
        //   `super()`. But we can't do that here due to TypeScript's restriction.
        //   See: https://github.com/Microsoft/TypeScript/issues/8277
        //   As a result, we have to add checks in `get trainable()` and
        //   `set trainable()` below in order to prevent using `this.layer` when
        //   its value is `undefined`. The super constructor does use the getter
        //   and the setter of `this.layer`.
        super(args);
        this.layer = args.layer;
    }
    build(inputShape) {
        this.built = true;
    }
    // TODO(cais): Implement activityRegularizer getter.
    get trainable() {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        if (this.layer != null) return this.layer.trainable;
        else return false;
    }
    set trainable(value) {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        if (this.layer != null) this.layer.trainable = value;
    }
    get trainableWeights() {
        return this.layer.trainableWeights;
    }
    // TODO(cais): Implement setter for trainableWeights.
    get nonTrainableWeights() {
        return this.layer.nonTrainableWeights;
    }
    // TODO(cais): Implement setter for nonTrainableWeights.
    get updates() {
        // tslint:disable-next-line:no-any
        return this.layer._updates;
    }
    // TODO(cais): Implement getUpdatesFor().
    get losses() {
        return this.layer.losses;
    }
    // TODO(cais): Implement getLossesFor().
    getWeights() {
        return this.layer.getWeights();
    }
    setWeights(weights) {
        this.layer.setWeights(weights);
    }
    getConfig() {
        const config = {
            'layer': {
                'className': this.layer.getClassName(),
                'config': this.layer.getConfig()
            }
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.layer != null) this.layer.setFastWeightInitDuringBuild(value);
    }
    /** @nocollapse */ static fromConfig(cls, config, customObjects = {}) {
        const layerConfig = config['layer'];
        const layer = (0, $4v3Le.deserialize)(layerConfig, customObjects);
        delete config['layer'];
        const newConfig = {
            layer: layer
        };
        Object.assign(newConfig, config);
        return new cls(newConfig);
    }
}
class $d5528399593d7f9f$export$72d58104314bdbf3 extends $d5528399593d7f9f$export$e6dfd72ab29f8598 {
    constructor(args){
        super(args);
        this.supportsMasking = true;
    }
    build(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        if (inputShape.length < 3) throw new (0, $kubuc.ValueError)(`TimeDistributed layer expects an input shape >= 3D, but received ` + `input shape ${JSON.stringify(inputShape)}`);
        this.inputSpec = [
            {
                shape: inputShape
            }
        ];
        const childInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        if (!this.layer.built) {
            this.layer.build(childInputShape);
            this.layer.built = true;
        }
        super.build(inputShape);
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const childInputShape = [
            inputShape[0]
        ].concat(inputShape.slice(2));
        const childOutputShape = this.layer.computeOutputShape(childInputShape);
        const timesteps = inputShape[1];
        return [
            childOutputShape[0],
            timesteps
        ].concat(childOutputShape.slice(1));
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            // TODO(cais): Add 'training' and 'useLearningPhase' to kwargs.
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            // Porting Note: In tfjs-layers, `inputs` are always concrete tensor
            // values. Hence the inputs can't have an undetermined first (batch)
            // dimension, which is why we always use the K.rnn approach here.
            const step = (inputs, states)=>{
                // TODO(cais): Add useLearningPhase.
                // NOTE(cais): `layer.call` may return a length-1 array of Tensor in
                //   some cases (e.g., `layer` is a `Sequential` instance), which is
                //   why `getExactlyOneTensor` is used below.
                const output = (0, $bMNfZ.getExactlyOneTensor)(this.layer.call(inputs, kwargs));
                return [
                    output,
                    []
                ];
            };
            const rnnOutputs = (0, $2QjI9.rnn)(step, inputs, [], false, null, null, false, true);
            const y = rnnOutputs[1];
            // TODO(cais): Add activity regularization.
            // TODO(cais): Add useLearningPhase.
            return y;
        });
    }
}
/** @nocollapse */ $d5528399593d7f9f$export$72d58104314bdbf3.className = 'TimeDistributed';
(0, $ki3lz).registerClass($d5528399593d7f9f$export$72d58104314bdbf3);
function $d5528399593d7f9f$export$8095babf98f3d922(value) {
    $jYx5u.checkStringTypeUnionValue((0, $46TaI.VALID_BIDIRECTIONAL_MERGE_MODES), 'BidirectionalMergeMode', value);
}
const $d5528399593d7f9f$var$DEFAULT_BIDIRECTIONAL_MERGE_MODE = 'concat';
class $d5528399593d7f9f$export$edf712313f3d75dd extends $d5528399593d7f9f$export$e6dfd72ab29f8598 {
    constructor(args){
        super(args);
        // Note: When creating `this.forwardLayer`, the original Layer object
        //   (`config.layer`) ought to be cloned. This is why we call
        //   `getConfig()` followed by `deserialize()`. Without this cloning,
        //   the layer names saved during serialization will incorrectly contain
        //   the 'forward_' prefix. In Python Keras, this is done using
        //   `copy.copy` (shallow copy), which does not have a simple equivalent
        //   in JavaScript. JavaScript's `Object.assign()` does not copy
        //   methods.
        const layerConfig = args.layer.getConfig();
        const forwDict = {};
        forwDict['className'] = args.layer.getClassName();
        forwDict['config'] = layerConfig;
        this.forwardLayer = (0, $4v3Le.deserialize)(forwDict);
        layerConfig['goBackwards'] = layerConfig['goBackwards'] === true ? false : true;
        const backDict = {};
        backDict['className'] = args.layer.getClassName();
        backDict['config'] = layerConfig;
        this.backwardLayer = (0, $4v3Le.deserialize)(backDict);
        this.forwardLayer.name = 'forward_' + this.forwardLayer.name;
        this.backwardLayer.name = 'backward_' + this.backwardLayer.name;
        this.mergeMode = args.mergeMode === undefined ? $d5528399593d7f9f$var$DEFAULT_BIDIRECTIONAL_MERGE_MODE : args.mergeMode;
        $d5528399593d7f9f$export$8095babf98f3d922(this.mergeMode);
        if (args.weights) throw new (0, $kubuc.NotImplementedError)('weights support is not implemented for Bidirectional layer yet.');
        this._stateful = args.layer.stateful;
        this.returnSequences = args.layer.returnSequences;
        this.returnState = args.layer.returnState;
        this.supportsMasking = true;
        this._trainable = true;
        this.inputSpec = args.layer.inputSpec;
        this.numConstants = null;
    }
    get trainable() {
        return this._trainable;
    }
    set trainable(value) {
        // Porting Note: the check of `this.layer` here is necessary due to the
        //   way the `constructor` of this class is written (see Porting Note
        //   above).
        this._trainable = value;
        if (this.forwardLayer != null) this.forwardLayer.trainable = value;
        if (this.backwardLayer != null) this.backwardLayer.trainable = value;
    }
    getWeights() {
        return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights());
    }
    setWeights(weights) {
        const numWeights = weights.length;
        const numeightsOver2 = Math.floor(numWeights / 2);
        this.forwardLayer.setWeights(weights.slice(0, numeightsOver2));
        this.backwardLayer.setWeights(weights.slice(numeightsOver2));
    }
    computeOutputShape(inputShape) {
        let layerShapes = this.forwardLayer.computeOutputShape(inputShape);
        if (!(Array.isArray(layerShapes) && Array.isArray(layerShapes[0]))) layerShapes = [
            layerShapes
        ];
        layerShapes;
        let outputShape;
        let outputShapes;
        let stateShape;
        if (this.returnState) {
            stateShape = layerShapes.slice(1);
            outputShape = layerShapes[0];
        } else outputShape = layerShapes[0];
        outputShape;
        if (this.mergeMode === 'concat') {
            outputShape[outputShape.length - 1] *= 2;
            outputShapes = [
                outputShape
            ];
        } else if (this.mergeMode == null) outputShapes = [
            outputShape,
            outputShape.slice()
        ];
        else outputShapes = [
            outputShape
        ];
        if (this.returnState) {
            if (this.mergeMode == null) return outputShapes.concat(stateShape).concat(stateShape.slice());
            return [
                outputShape
            ].concat(stateShape).concat(stateShape.slice());
        }
        return $jYx5u.singletonOrArray(outputShapes);
    }
    apply(inputs, kwargs) {
        let initialState = kwargs == null ? null : kwargs['initialState'];
        let constants = kwargs == null ? null : kwargs['constants'];
        if (kwargs == null) kwargs = {};
        const standardized = (0, $2QjI9.standardizeArgs)(inputs, initialState, constants, this.numConstants);
        inputs = standardized.inputs;
        initialState = standardized.initialState;
        constants = standardized.constants;
        if (Array.isArray(inputs)) {
            initialState = inputs.slice(1);
            inputs = inputs[0];
        }
        if ((initialState == null || initialState.length === 0) && constants == null) return super.apply(inputs, kwargs);
        const additionalInputs = [];
        const additionalSpecs = [];
        if (initialState != null) {
            const numStates = initialState.length;
            if (numStates % 2 > 0) throw new (0, $kubuc.ValueError)("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");
            kwargs['initialState'] = initialState;
            additionalInputs.push(...initialState);
            const stateSpecs = initialState.map((state)=>new (0, $jWpeh.InputSpec)({
                    shape: state.shape
                }));
            this.forwardLayer.stateSpec = stateSpecs.slice(0, numStates / 2);
            this.backwardLayer.stateSpec = stateSpecs.slice(numStates / 2);
            additionalSpecs.push(...stateSpecs);
        }
        if (constants != null) throw new (0, $kubuc.NotImplementedError)("Support for constants in Bidirectional layers is not implemented yet.");
        const isSymbolicTensor = additionalInputs[0] instanceof (0, $jWpeh.SymbolicTensor);
        for (const tensor of additionalInputs){
            if (tensor instanceof (0, $jWpeh.SymbolicTensor) !== isSymbolicTensor) throw new (0, $kubuc.ValueError)("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors");
        }
        if (isSymbolicTensor) {
            // Compute the full input and specs, including the states.
            const fullInput = [
                inputs
            ].concat(additionalInputs);
            const fullInputSpec = this.inputSpec.concat(additionalSpecs);
            // Perform the call temporarily and replace inputSpec.
            // Note: with initial states symbolic calls and non-symbolic calls to
            // this method differ in how the initial states are passed. For
            // symbolic calls, the initial states are passed in the first arg, as
            // an Array of SymbolicTensors; for non-symbolic calls, they are
            // passed in the second arg as a part of the kwargs. Hence the need to
            // temporarily modify inputSpec here.
            // TODO(cais): Make refactoring so that this hacky code below is no
            // longer needed.
            const originalInputSpec = this.inputSpec;
            this.inputSpec = fullInputSpec;
            const output = super.apply(fullInput, kwargs);
            this.inputSpec = originalInputSpec;
            return output;
        } else return super.apply(inputs, kwargs);
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const initialState = kwargs['initialState'];
            let y;
            let yRev;
            if (initialState == null) {
                y = this.forwardLayer.call(inputs, kwargs);
                yRev = this.backwardLayer.call(inputs, kwargs);
            } else {
                const forwardState = initialState.slice(0, initialState.length / 2);
                const backwardState = initialState.slice(initialState.length / 2);
                y = this.forwardLayer.call(inputs, Object.assign(kwargs, {
                    initialState: forwardState
                }));
                yRev = this.backwardLayer.call(inputs, Object.assign(kwargs, {
                    initialState: backwardState
                }));
            }
            let states;
            if (this.returnState) {
                if (Array.isArray(y)) states = y.slice(1).concat(yRev.slice(1));
                y = y[0];
                yRev = yRev[0];
            }
            if (this.returnSequences) yRev = $5ApPj.reverse(yRev, 1);
            let output;
            if (this.mergeMode === 'concat') output = $4AyI5.concatenate([
                y,
                yRev
            ]);
            else if (this.mergeMode === 'sum') output = $6Ab5n.add(y, yRev);
            else if (this.mergeMode === 'ave') output = $5hAos.mul(.5, $6Ab5n.add(y, yRev));
            else if (this.mergeMode === 'mul') output = $5hAos.mul(y, yRev);
            else if (this.mergeMode == null) output = [
                y,
                yRev
            ];
            // TODO(cais): Properly set learning phase.
            if (this.returnState) {
                if (this.mergeMode == null) return output.concat(states);
                return [
                    output
                ].concat(states);
            }
            return output;
        });
    }
    resetStates(states) {
        this.forwardLayer.resetStates();
        this.backwardLayer.resetStates();
    }
    build(inputShape) {
        (0, $1Xyaa.nameScope)(this.forwardLayer.name, ()=>{
            this.forwardLayer.build(inputShape);
        });
        (0, $1Xyaa.nameScope)(this.backwardLayer.name, ()=>{
            this.backwardLayer.build(inputShape);
        });
        this.built = true;
    }
    computeMask(inputs, mask) {
        if (Array.isArray(mask)) mask = mask[0];
        let outputMask;
        if (this.returnSequences) {
            if (this.mergeMode == null) outputMask = [
                mask,
                mask
            ];
            else outputMask = mask;
        } else if (this.mergeMode == null) outputMask = [
            null,
            null
        ];
        else outputMask = null;
        if (this.returnState) {
            const states = this.forwardLayer.states;
            const stateMask = states.map((state)=>null);
            if (Array.isArray(outputMask)) return outputMask.concat(stateMask).concat(stateMask);
            else return [
                outputMask
            ].concat(stateMask).concat(stateMask);
        } else return outputMask;
    }
    get trainableWeights() {
        return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights);
    }
    get nonTrainableWeights() {
        return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights);
    }
    // TODO(cais): Implement constraints().
    setFastWeightInitDuringBuild(value) {
        super.setFastWeightInitDuringBuild(value);
        if (this.forwardLayer != null) this.forwardLayer.setFastWeightInitDuringBuild(value);
        if (this.backwardLayer != null) this.backwardLayer.setFastWeightInitDuringBuild(value);
    }
    getConfig() {
        const config = {
            'mergeMode': this.mergeMode
        };
        // TODO(cais): Add logic for `numConstants` once the property is added.
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    /** @nocollapse */ static fromConfig(cls, config) {
        const rnnLayer = (0, $4v3Le.deserialize)(config['layer']);
        delete config['layer'];
        // TODO(cais): Add logic for `numConstants` once the property is added.
        if (config['numConstants'] != null) throw new (0, $kubuc.NotImplementedError)(`Deserialization of a Bidirectional layer with numConstants ` + `present is not supported yet.`);
        // tslint:disable-next-line:no-any
        const newConfig = config;
        newConfig['layer'] = rnnLayer;
        return new cls(newConfig);
    }
}
/** @nocollapse */ $d5528399593d7f9f$export$edf712313f3d75dd.className = 'Bidirectional';
(0, $ki3lz).registerClass($d5528399593d7f9f$export$edf712313f3d75dd);

});

parcelRegister("5Om3j", function(module, exports) {

$parcel$export(module.exports, "Rescaling", function () { return $43b2ba65bd457a2c$export$7dddadc545bab6c4; });
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $jWpeh = parcelRequire("jWpeh");
parcelRequire("8AHkS");
var $6Ab5n = parcelRequire("6Ab5n");
var $5hAos = parcelRequire("5hAos");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");

var $bMNfZ = parcelRequire("bMNfZ");

var $4AyI5 = parcelRequire("4AyI5");
/**
 * Preprocessing Rescaling Layer
 *
 * This rescales images by a scaling and offset factor
 */ class $43b2ba65bd457a2c$export$7dddadc545bab6c4 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.scale = args.scale;
        if (args.offset) this.offset = args.offset;
        else this.offset = 0;
    }
    getConfig() {
        const config = {
            'scale': this.scale,
            'offset': this.offset
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (inputs.dtype !== 'float32') inputs = $4AyI5.cast(inputs, 'float32');
            return (0, $6Ab5n.add)((0, $5hAos.mul)(inputs, this.scale), this.offset);
        });
    }
}
/** @nocollapse */ $43b2ba65bd457a2c$export$7dddadc545bab6c4.className = 'Rescaling';
(0, $ki3lz).registerClass($43b2ba65bd457a2c$export$7dddadc545bab6c4);

});

parcelRegister("iMD5O", function(module, exports) {

$parcel$export(module.exports, "CenterCrop", function () { return $dacb08b18019c07e$export$975b110751426855; });
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $4I5dI = parcelRequire("4I5dI");
var $kh5mA = parcelRequire("kh5mA");
var $ki3lz = parcelRequire("ki3lz");
var $lq9U1 = parcelRequire("lq9U1");
var $eZfvk = parcelRequire("eZfvk");
var $d7Nxs = parcelRequire("d7Nxs");
var $3mzDh = parcelRequire("3mzDh");

var $bMNfZ = parcelRequire("bMNfZ");

var $jWpeh = parcelRequire("jWpeh");

var $4AyI5 = parcelRequire("4AyI5");
const { resizeBilinear: $dacb08b18019c07e$var$resizeBilinear, cropAndResize: $dacb08b18019c07e$var$cropAndResize } = (0, $4I5dI.image);
class $dacb08b18019c07e$export$975b110751426855 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.height = args.height;
        this.width = args.width;
    }
    centerCrop(inputs, hBuffer, wBuffer, height, width, inputHeight, inputWidth, dtype) {
        return (0, $d7Nxs.tidy)(()=>{
            let input;
            let isRank3 = false;
            const top = hBuffer / inputHeight;
            const left = wBuffer / inputWidth;
            const bottom = (height + hBuffer) / inputHeight;
            const right = (width + wBuffer) / inputWidth;
            const bound = [
                top,
                left,
                bottom,
                right
            ];
            const boxesArr = [];
            if (inputs.rank === 3) {
                isRank3 = true;
                input = (0, $lq9U1.stack)([
                    inputs
                ]);
            } else input = inputs;
            for(let i = 0; i < input.shape[0]; i++)boxesArr.push(bound);
            const boxes = (0, $eZfvk.tensor)(boxesArr, [
                boxesArr.length,
                4
            ]);
            const boxInd = (0, $kh5mA.range)(0, boxesArr.length, 1, 'int32');
            const cropSize = [
                height,
                width
            ];
            const cropped = $dacb08b18019c07e$var$cropAndResize(input, boxes, boxInd, cropSize, 'nearest');
            if (isRank3) return $4AyI5.cast((0, $bMNfZ.getExactlyOneTensor)((0, $3mzDh.unstack)(cropped)), dtype);
            return $4AyI5.cast(cropped, dtype);
        });
    }
    upsize(inputs, height, width, dtype) {
        return (0, $d7Nxs.tidy)(()=>{
            const outputs = $dacb08b18019c07e$var$resizeBilinear(inputs, [
                height,
                width
            ]);
            return $4AyI5.cast(outputs, dtype);
        });
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const rankedInputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            const dtype = rankedInputs.dtype;
            const inputShape = rankedInputs.shape;
            const inputHeight = inputShape[inputShape.length - 3];
            const inputWidth = inputShape[inputShape.length - 2];
            let hBuffer = 0;
            if (inputHeight !== this.height) hBuffer = Math.floor((inputHeight - this.height) / 2);
            let wBuffer = 0;
            if (inputWidth !== this.width) {
                wBuffer = Math.floor((inputWidth - this.width) / 2);
                if (wBuffer === 0) wBuffer = 1;
            }
            if (hBuffer >= 0 && wBuffer >= 0) return this.centerCrop(rankedInputs, hBuffer, wBuffer, this.height, this.width, inputHeight, inputWidth, dtype);
            else return this.upsize(inputs, this.height, this.width, dtype);
        });
    }
    getConfig() {
        const config = {
            'height': this.height,
            'width': this.width
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const hAxis = inputShape.length - 3;
        const wAxis = inputShape.length - 2;
        inputShape[hAxis] = this.height;
        inputShape[wAxis] = this.width;
        return inputShape;
    }
}
/** @nocollapse */ $dacb08b18019c07e$export$975b110751426855.className = 'CenterCrop';
(0, $ki3lz).registerClass($dacb08b18019c07e$export$975b110751426855);

});

parcelRegister("5eBzR", function(module, exports) {

$parcel$export(module.exports, "CategoryEncoding", function () { return $3cfb689ead45e123$export$157716bc075e0048; });
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $jWpeh = parcelRequire("jWpeh");
parcelRequire("8AHkS");
var $lOlhm = parcelRequire("lOlhm");
var $kKLvn = parcelRequire("kKLvn");
var $9GR6N = parcelRequire("9GR6N");
var $1KFHq = parcelRequire("1KFHq");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");

var $bMNfZ = parcelRequire("bMNfZ");

var $kubuc = parcelRequire("kubuc");

var $4AyI5 = parcelRequire("4AyI5");

var $92b4q = parcelRequire("92b4q");
class $3cfb689ead45e123$export$157716bc075e0048 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.numTokens = args.numTokens;
        if (args.outputMode) this.outputMode = args.outputMode;
        else this.outputMode = 'multiHot';
    }
    getConfig() {
        const config = {
            'numTokens': this.numTokens,
            'outputMode': this.outputMode
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        if (inputShape == null) return [
            this.numTokens
        ];
        if (this.outputMode === 'oneHot' && inputShape[inputShape.length - 1] !== 1) {
            inputShape.push(this.numTokens);
            return inputShape;
        }
        inputShape[inputShape.length - 1] = this.numTokens;
        return inputShape;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            inputs = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            if (inputs.dtype !== 'int32') inputs = $4AyI5.cast(inputs, 'int32');
            let countWeights;
            if (typeof kwargs['countWeights'] !== 'undefined') {
                if (this.outputMode !== 'count') throw new (0, $kubuc.ValueError)(`countWeights is not used when outputMode !== count.
              Received countWeights=${kwargs['countWeights']}`);
                countWeights = (0, $bMNfZ.getExactlyOneTensor)(kwargs['countWeights']);
            }
            const maxValue = (0, $9GR6N.max)(inputs);
            const minValue = (0, $1KFHq.min)(inputs);
            const greaterEqualMax = (0, $lOlhm.greater)(this.numTokens, maxValue).bufferSync().get(0);
            const greaterMin = (0, $kKLvn.greaterEqual)(minValue, 0).bufferSync().get(0);
            if (!(greaterEqualMax && greaterMin)) throw new (0, $kubuc.ValueError)('Input values must be between 0 < values <=' + ` numTokens with numTokens=${this.numTokens}`);
            return $92b4q.encodeCategoricalInputs(inputs, this.outputMode, this.numTokens, countWeights);
        });
    }
}
/** @nocollapse */ $3cfb689ead45e123$export$157716bc075e0048.className = 'CategoryEncoding';
(0, $ki3lz).registerClass($3cfb689ead45e123$export$157716bc075e0048);

});
parcelRegister("92b4q", function(module, exports) {

$parcel$export(module.exports, "encodeCategoricalInputs", function () { return $693ce34f5ca9dc8f$export$dd4f0cc5ab8b289d; });
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dzBZ1 = parcelRequire("dzBZ1");
var $fO4kJ = parcelRequire("fO4kJ");
var $5hAos = parcelRequire("5hAos");

var $bMNfZ = parcelRequire("bMNfZ");

var $kubuc = parcelRequire("kubuc");

var $4AyI5 = parcelRequire("4AyI5");
function $693ce34f5ca9dc8f$export$dd4f0cc5ab8b289d(inputs, outputMode, depth, weights) {
    let input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
    if (input.dtype !== 'int32') input = $4AyI5.cast(input, 'int32');
    if (outputMode === 'int') return input;
    const originalShape = input.shape;
    if (input.rank === 0) input = (0, $fO4kJ.expandDims)(input, -1);
    if (outputMode === 'oneHot') {
        if (input.shape[input.shape.length - 1] !== 1) input = (0, $fO4kJ.expandDims)(input, -1);
    }
    if (input.rank > 2) throw new (0, $kubuc.ValueError)(`When outputMode is not int, maximum output rank is 2` + ` Received outputMode ${outputMode} and input shape ${originalShape}` + ` which would result in output rank ${input.rank}.`);
    const binaryOutput = [
        'multiHot',
        'oneHot'
    ].includes(outputMode);
    const denseBincountInput = input;
    let binCounts;
    if (typeof weights !== 'undefined' && outputMode === 'count') binCounts = (0, $dzBZ1.denseBincount)(denseBincountInput, weights, depth, binaryOutput);
    else binCounts = (0, $dzBZ1.denseBincount)(denseBincountInput, [], depth, binaryOutput);
    if (outputMode !== 'tfIdf') return binCounts;
    if (weights) return (0, $5hAos.mul)(binCounts, weights);
    else throw new (0, $kubuc.ValueError)(`When outputMode is 'tfIdf', weights must be provided.`);
}

});


parcelRegister("cIle0", function(module, exports) {

$parcel$export(module.exports, "Resizing", function () { return $941a0ef0eb5fc696$export$9942248a1ae255c2; });
/**
 * @license
 * Copyright 2022 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $4I5dI = parcelRequire("4I5dI");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");

var $jWpeh = parcelRequire("jWpeh");

var $kubuc = parcelRequire("kubuc");

var $bMNfZ = parcelRequire("bMNfZ");
// tf methods unimplemented in tfjs: 'bicubic', 'area', 'lanczos3', 'lanczos5',
//                                   'gaussian', 'mitchellcubic'
const $941a0ef0eb5fc696$var$INTERPOLATION_KEYS = [
    'bilinear',
    'nearest'
];
const $941a0ef0eb5fc696$var$INTERPOLATION_METHODS = new Set($941a0ef0eb5fc696$var$INTERPOLATION_KEYS);
/**
 * Preprocessing Resizing Layer
 *
 * This resizes images by a scaling and offset factor
 */ class $941a0ef0eb5fc696$export$9942248a1ae255c2 extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.height = args.height;
        this.width = args.width;
        if (args.interpolation) {
            if ($941a0ef0eb5fc696$var$INTERPOLATION_METHODS.has(args.interpolation)) this.interpolation = args.interpolation;
            else throw new (0, $kubuc.ValueError)(`Invalid interpolation parameter: ${args.interpolation} is not implemented`);
        } else this.interpolation = 'bilinear';
        this.cropToAspectRatio = Boolean(args.cropToAspectRatio);
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const numChannels = inputShape[2];
        return [
            this.height,
            this.width,
            numChannels
        ];
    }
    getConfig() {
        const config = {
            'height': this.height,
            'width': this.width,
            'interpolation': this.interpolation,
            'cropToAspectRatio': this.cropToAspectRatio
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const size = [
                this.height,
                this.width
            ];
            if (this.interpolation === 'bilinear') return (0, $4I5dI.image).resizeBilinear(inputs, size, !this.cropToAspectRatio);
            else if (this.interpolation === 'nearest') return (0, $4I5dI.image).resizeNearestNeighbor(inputs, size, !this.cropToAspectRatio);
            else throw new Error(`Interpolation is ${this.interpolation} but only ${[
                ...$941a0ef0eb5fc696$var$INTERPOLATION_METHODS
            ]} are supported`);
        });
    }
}
/** @nocollapse */ $941a0ef0eb5fc696$export$9942248a1ae255c2.className = 'Resizing';
(0, $ki3lz).registerClass($941a0ef0eb5fc696$export$9942248a1ae255c2);

});

parcelRegister("8bDuy", function(module, exports) {

$parcel$export(module.exports, "RandomWidth", function () { return $5f5dfc0fa29cc8a4$export$d35b9a2fd40085ff; });
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $4I5dI = parcelRequire("4I5dI");
var $9ORo6 = parcelRequire("9ORo6");
var $ki3lz = parcelRequire("ki3lz");
var $d7Nxs = parcelRequire("d7Nxs");

var $bMNfZ = parcelRequire("bMNfZ");

var $kubuc = parcelRequire("kubuc");

var $c2GyQ = parcelRequire("c2GyQ");
const $5f5dfc0fa29cc8a4$var$INTERPOLATION_KEYS = [
    'bilinear',
    'nearest'
];
const $5f5dfc0fa29cc8a4$export$c4a1b8c76872ce6e = new Set($5f5dfc0fa29cc8a4$var$INTERPOLATION_KEYS);
/**
 * Preprocessing Layer with randomly varies image during training
 *
 * This layer randomly adjusts the width of a batch of images of a
 * batch of images by a random factor.
 *
 * The input should be a 3D (unbatched) or
 * 4D (batched) tensor in the `"channels_last"` image data format. Input pixel
 * values can be of any range (e.g. `[0., 1.)` or `[0, 255]`) and of integer
 * or floating point dtype. By default, the layer will output floats.
 *
 * tf methods implemented in tfjs: 'bilinear', 'nearest',
 * tf methods unimplemented in tfjs: 'bicubic', 'area', 'lanczos3', 'lanczos5',
 *                                   'gaussian', 'mitchellcubic'
 *
 */ class $5f5dfc0fa29cc8a4$export$d35b9a2fd40085ff extends (0, $c2GyQ.BaseRandomLayer) {
    constructor(args){
        super(args);
        const { factor: factor, interpolation: interpolation = 'bilinear' } = args;
        this.factor = factor;
        if (Array.isArray(this.factor) && this.factor.length === 2) {
            this.widthLower = this.factor[0];
            this.widthUpper = this.factor[1];
        } else if (!Array.isArray(this.factor) && this.factor > 0) {
            this.widthLower = -this.factor;
            this.widthUpper = this.factor;
        } else throw new (0, $kubuc.ValueError)(`Invalid factor: ${this.factor}. Must be positive number or tuple of 2 numbers`);
        if (this.widthLower < -1 || this.widthUpper < -1) throw new (0, $kubuc.ValueError)(`factor must have values larger than -1. Got: ${this.factor}`);
        if (this.widthUpper < this.widthLower) throw new (0, $kubuc.ValueError)(`factor cannot have upper bound less than lower bound.
        Got upper bound: ${this.widthUpper}.
        Got lower bound: ${this.widthLower}
      `);
        if (interpolation) {
            if ($5f5dfc0fa29cc8a4$export$c4a1b8c76872ce6e.has(interpolation)) this.interpolation = interpolation;
            else throw new (0, $kubuc.ValueError)(`Invalid interpolation parameter: ${interpolation} is not implemented`);
        }
    }
    getConfig() {
        const config = {
            'factor': this.factor,
            'interpolation': this.interpolation
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
    computeOutputShape(inputShape) {
        inputShape = (0, $bMNfZ.getExactlyOneShape)(inputShape);
        const numChannels = inputShape[2];
        return [
            this.imgHeight,
            -1,
            numChannels
        ];
    }
    call(inputs, kwargs) {
        return (0, $d7Nxs.tidy)(()=>{
            const input = (0, $bMNfZ.getExactlyOneTensor)(inputs);
            this.imgHeight = input.shape[input.shape.length - 3];
            const imgWidth = input.shape[input.shape.length - 2];
            this.widthFactor = (0, $9ORo6.randomUniform)([
                1
            ], 1.0 + this.widthLower, 1.0 + this.widthUpper, 'float32', this.randomGenerator.next());
            let adjustedWidth = this.widthFactor.dataSync()[0] * imgWidth;
            adjustedWidth = Math.round(adjustedWidth);
            const size = [
                this.imgHeight,
                adjustedWidth
            ];
            switch(this.interpolation){
                case 'bilinear':
                    return (0, $4I5dI.image).resizeBilinear(inputs, size);
                case 'nearest':
                    return (0, $4I5dI.image).resizeNearestNeighbor(inputs, size);
                default:
                    throw new Error(`Interpolation is ${this.interpolation}
          but only ${[
                        ...$5f5dfc0fa29cc8a4$export$c4a1b8c76872ce6e
                    ]} are supported`);
            }
        });
    }
}
/** @nocollapse */ $5f5dfc0fa29cc8a4$export$d35b9a2fd40085ff.className = 'RandomWidth';
(0, $ki3lz).registerClass($5f5dfc0fa29cc8a4$export$d35b9a2fd40085ff);

});
parcelRegister("c2GyQ", function(module, exports) {

$parcel$export(module.exports, "BaseRandomLayer", function () { return $8c46afae46ad42d0$export$c4beed44a310e6fd; });
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $jWpeh = parcelRequire("jWpeh");

var $aBlAx = parcelRequire("aBlAx");
class $8c46afae46ad42d0$export$c4beed44a310e6fd extends (0, $jWpeh.Layer) {
    constructor(args){
        super(args);
        this.randomGenerator = new (0, $aBlAx.RandomSeed)(args.seed);
    }
    getConfig() {
        const config = {
            'seed': this.randomGenerator.seed
        };
        const baseConfig = super.getConfig();
        Object.assign(config, baseConfig);
        return config;
    }
}
// A layer handle the random number creation and savemodel behavior.
/** @nocollapse */ $8c46afae46ad42d0$export$c4beed44a310e6fd.className = 'BaseRandomLayer';

});
parcelRegister("aBlAx", function(module, exports) {

$parcel$export(module.exports, "RandomSeed", function () { return $7b7e1b1249d8d4c2$export$2d071615d5c9266f; });
/**
 * @license
 * Copyright 2023 CodeSmith LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /**
 * Keeps track of seed and handles pseudorandomness
 * Instance created in BaseRandomLayer class
 * Utilized for random preprocessing layers
 */ class $7b7e1b1249d8d4c2$export$2d071615d5c9266f {
    constructor(seed){
        this.seed = seed;
    }
    next() {
        if (this.seed === undefined) return undefined;
        return this.seed++;
    }
}
$7b7e1b1249d8d4c2$export$2d071615d5c9266f.className = 'RandomSeed';

});




parcelRegister("60Zce", function(module, exports) {

var $lg9tU = parcelRequire("lg9tU");

var $j6iTL = parcelRequire("j6iTL");
function $46123675ce1216df$export$7b3d02e9a01c1ca(yTrue, yPred) {
    return $j6iTL.binaryAccuracy(yTrue, yPred);
}
function $46123675ce1216df$export$f9fa66c6bf49fbe1(yTrue, yPred) {
    return $j6iTL.binaryCrossentropy(yTrue, yPred);
}
function $46123675ce1216df$export$b35c43b77daa3523(yTrue, yPred) {
    return $j6iTL.sparseCategoricalAccuracy(yTrue, yPred);
}
function $46123675ce1216df$export$1365401eb6b7aeeb(yTrue, yPred) {
    return $j6iTL.categoricalAccuracy(yTrue, yPred);
}
function $46123675ce1216df$export$3d5544849562b631(yTrue, yPred) {
    return $j6iTL.categoricalCrossentropy(yTrue, yPred);
}
function $46123675ce1216df$export$b70eeb0e623ceb0d(yTrue, yPred) {
    return $j6iTL.precision(yTrue, yPred);
}
function $46123675ce1216df$export$479490328e25f530(yTrue, yPred) {
    return $j6iTL.recall(yTrue, yPred);
}
function $46123675ce1216df$export$a39f0fc1fa1caacd(yTrue, yPred) {
    return $lg9tU.cosineProximity(yTrue, yPred);
}
function $46123675ce1216df$export$607988531ba584e6(yTrue, yPred) {
    return $lg9tU.meanAbsoluteError(yTrue, yPred);
}
function $46123675ce1216df$export$29f745e8786a84d(yTrue, yPred) {
    return $lg9tU.meanAbsolutePercentageError(yTrue, yPred);
}
function $46123675ce1216df$export$520a6d354b1a7026(yTrue, yPred) {
    return $lg9tU.meanAbsolutePercentageError(yTrue, yPred);
}
function $46123675ce1216df$export$1d9e5626781fbee(yTrue, yPred) {
    return $lg9tU.meanAbsolutePercentageError(yTrue, yPred);
}
function $46123675ce1216df$export$33de16355e97f7fb(yTrue, yPred) {
    return $lg9tU.meanSquaredError(yTrue, yPred);
}
function $46123675ce1216df$export$19fa95397f41c30f(yTrue, yPred) {
    return $lg9tU.meanSquaredError(yTrue, yPred);
}
function $46123675ce1216df$export$5af2a467647891e2(yTrue, yPred) {
    return $lg9tU.meanSquaredError(yTrue, yPred);
}
function $46123675ce1216df$export$3c864af03e35a80e(yTrue, yPred) {
    return $j6iTL.r2Score(yTrue, yPred);
}

});

parcelRegister("dqJqc", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $1dKdw = parcelRequire("1dKdw");

});

parcelRegister("2pJRH", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ 
var $1NdPD = parcelRequire("1NdPD");
function $1c217e693ec1c708$export$19d549ef0ddd23b0(config) {
    return new (0, $1NdPD.L1L2)(config);
}
function $1c217e693ec1c708$export$b35c4719d0ff29eb(config) {
    return $1NdPD.l1(config);
}
function $1c217e693ec1c708$export$683828dad49492ec(config) {
    return $1NdPD.l2(config);
}

});

parcelRegister("fRyjC", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Use of this source code is governed by an MIT-style
 * license that can be found in the LICENSE file or at
 * https://opensource.org/licenses/MIT.
 * =============================================================================
 */ /* Original source: keras/callbacks.py */ 
var $801Oz = parcelRequire("801Oz");

var $czFC2 = parcelRequire("czFC2");

var $kubuc = parcelRequire("kubuc");

var $lcd3O = parcelRequire("lcd3O");
class $b8c66c991bb67037$export$78f58e2a70333412 extends (0, $801Oz.BaseCallback) {
    constructor(){
        super(...arguments);
        /** Instance of `keras.models.Model`. Reference of the model being trained. */ this.model = null;
    }
    setModel(model) {
        if (!(model instanceof (0, $czFC2.LayersModel))) throw new Error('model must be a LayersModel, not some other Container');
        this.model = model;
    }
}
function $b8c66c991bb67037$var$less(currVal, prevVal) {
    return currVal < prevVal;
}
function $b8c66c991bb67037$var$greater(currVal, prevVal) {
    return currVal > prevVal;
}
class $b8c66c991bb67037$export$be8b2554758a52cc extends $b8c66c991bb67037$export$78f58e2a70333412 {
    constructor(args){
        super();
        if (args == null) args = {};
        if (args.restoreBestWeights) throw new (0, $kubuc.NotImplementedError)('restoreBestWeights = True is not implemented in EarlyStopping yet.');
        this.monitor = args.monitor || 'val_loss';
        this.minDelta = Math.abs(args.minDelta || 0);
        this.patience = args.patience || 0;
        this.verbose = args.verbose || 0;
        this.mode = args.mode || 'auto';
        this.baseline = args.baseline;
        if ([
            'auto',
            'min',
            'max'
        ].indexOf(this.mode) === -1) {
            console.warn(`EarlyStopping mode '${this.mode}' is invalid. ` + `Falling back to mode 'auto'.`);
            this.mode = 'auto';
        }
        if (this.mode === 'min') this.monitorFunc = $b8c66c991bb67037$var$less;
        else if (this.mode === 'max') this.monitorFunc = $b8c66c991bb67037$var$greater;
        else // For mode === 'auto'.
        if (this.monitor.indexOf('acc') !== -1) this.monitorFunc = $b8c66c991bb67037$var$greater;
        else this.monitorFunc = $b8c66c991bb67037$var$less;
        if (this.monitorFunc === $b8c66c991bb67037$var$less) this.minDelta *= -1;
    }
    async onTrainBegin(logs) {
        this.wait = 0;
        this.stoppedEpoch = 0;
        if (this.baseline != null) this.best = this.baseline;
        else this.best = this.monitorFunc === $b8c66c991bb67037$var$less ? Infinity : -Infinity;
    }
    async onEpochEnd(epoch, logs) {
        await (0, $lcd3O.resolveScalarsInLogs)(logs);
        const current = this.getMonitorValue(logs);
        if (current == null) return;
        if (this.monitorFunc(current - this.minDelta, this.best)) {
            this.best = current;
            this.wait = 0;
        // TODO(cais): Logic for restoreBestWeights.
        } else {
            this.wait++;
            if (this.wait >= this.patience) {
                this.stoppedEpoch = epoch;
                this.model.stopTraining = true;
            }
        // TODO(cais): Logic for restoreBestWeights.
        }
    }
    async onTrainEnd(logs) {
        if (this.stoppedEpoch > 0 && this.verbose) console.log(`Epoch ${this.stoppedEpoch}: early stopping.`);
    }
    getMonitorValue(logs) {
        if (logs == null) logs = {};
        const monitorValue = logs[this.monitor];
        if (monitorValue == null) console.warn(`Metric for EarlyStopping ${this.monitor} is not available. ` + `Available metrics are: ${Object.keys(logs)}`);
        return monitorValue;
    }
}
function $b8c66c991bb67037$export$f951bfa445288ab1(args) {
    return new $b8c66c991bb67037$export$be8b2554758a52cc(args);
}
const $b8c66c991bb67037$export$b89c5c1b934d8237 = {
    earlyStopping: $b8c66c991bb67037$export$f951bfa445288ab1
};

});


parcelRegister("lQoXD", function(module, exports) {

$parcel$export(module.exports, "version_converter", function () { return (parcelRequire("hNaaE")).version; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("2ZbWw");

var $ciVQp = parcelRequire("ciVQp");

var $2Z8vl = parcelRequire("2Z8vl");

var $hNaaE = parcelRequire("hNaaE");

});
parcelRegister("2ZbWw", function(module, exports) {
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
const $22ca8ae5539cacc3$var$ENV = (0, $tdutJ.env)();
/** Whether to keep intermediate tensors. */ $22ca8ae5539cacc3$var$ENV.registerFlag('KEEP_INTERMEDIATE_TENSORS', ()=>false, (debugValue)=>{
    if (debugValue) console.warn("Keep intermediate tensors is ON. This will print the values of all intermediate tensors during model inference. Not all models support this mode. For details, check e2e/benchmarks/ model_config.js. This significantly impacts performance.");
});

});

parcelRegister("ciVQp", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");
var $feqcJ = parcelRequire("feqcJ");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $5cY9q = parcelRequire("5cY9q");

var $fXEIJ = parcelRequire("fXEIJ");

var $ivFPv = parcelRequire("ivFPv");

var $lxNMC = parcelRequire("lxNMC");
const $8f5409241989162f$export$a9bc79b23e178599 = '?tfjs-format=file';
const $8f5409241989162f$export$9ffb2eac80132860 = 'model.json';
class $8f5409241989162f$export$357a78c279dfa8cf {
    // Returns the version information for the tensorflow model GraphDef.
    get modelVersion() {
        return this.version;
    }
    get inputNodes() {
        return this.executor.inputNodes;
    }
    get outputNodes() {
        return this.executor.outputNodes;
    }
    get inputs() {
        return this.executor.inputs;
    }
    get outputs() {
        return this.executor.outputs;
    }
    get weights() {
        return this.executor.weightMap;
    }
    get metadata() {
        return this.artifacts.userDefinedMetadata;
    }
    get modelSignature() {
        return this.signature;
    }
    get modelStructuredOutputKeys() {
        return this.structuredOutputKeys;
    }
    /**
     * @param modelUrl url for the model, or an `io.IOHandler`.
     * @param weightManifestUrl url for the weight file generated by
     * scripts/convert.py script.
     * @param requestOption options for Request, which allows to send credentials
     * and custom headers.
     * @param onProgress Optional, progress callback function, fired periodically
     * before the load is completed.
     */ constructor(modelUrl, loadOptions = {}, tfio = (0, $feqcJ)){
        this.modelUrl = modelUrl;
        this.loadOptions = loadOptions;
        this.version = 'n/a';
        this.io = tfio;
        if (loadOptions == null) this.loadOptions = {};
        this.resourceManager = new (0, $ivFPv.ResourceManager)();
    }
    findIOHandler() {
        const path = this.modelUrl;
        if (path.load != null) // Path is an IO Handler.
        this.handler = path;
        else if (this.loadOptions.requestInit != null) this.handler = this.io.browserHTTPRequest(path, this.loadOptions);
        else {
            const handlers = this.io.getLoadHandlers(path, this.loadOptions);
            if (handlers.length === 0) // For backward compatibility: if no load handler can be found,
            // assume it is a relative http path.
            handlers.push(this.io.browserHTTPRequest(path, this.loadOptions));
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) load handlers for ` + `URL '${[
                path
            ]}'`);
            this.handler = handlers[0];
        }
    }
    /**
     * Loads the model and weight files, construct the in memory weight map and
     * compile the inference graph.
     */ load() {
        this.findIOHandler();
        if (this.handler.load == null) throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
        const loadResult = this.handler.load();
        if ((0, $lBDHD).isPromise(loadResult)) return loadResult.then((artifacts)=>{
            if (artifacts.getWeightStream == null) return this.loadSync(artifacts);
            return this.loadStreaming(artifacts);
        });
        return this.loadSync(loadResult);
    }
    /**
     * Synchronously construct the in memory weight map and
     * compile the inference graph.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ loadSync(artifacts) {
        const weightMap = this.io.decodeWeights(artifacts.weightData, artifacts.weightSpecs);
        return this.loadWithWeightMap(artifacts, weightMap);
    }
    async loadStreaming(artifacts) {
        if (artifacts.getWeightStream == null) throw new Error('Model artifacts missing streamWeights function');
        const weightMap = await (0, $lxNMC.decodeWeightsStream)(artifacts.getWeightStream(), artifacts.weightSpecs);
        return this.loadWithWeightMap(artifacts, weightMap);
    }
    loadWithWeightMap(artifacts, weightMap) {
        this.artifacts = artifacts;
        const graph = this.artifacts.modelTopology;
        let signature = this.artifacts.signature;
        if (this.artifacts.userDefinedMetadata != null) {
            const metadata = this.artifacts.userDefinedMetadata;
            if (metadata.signature != null) signature = metadata.signature;
            if (metadata.structuredOutputKeys != null) this.structuredOutputKeys = metadata.structuredOutputKeys;
        }
        this.signature = signature;
        this.version = `${graph.versions.producer}.${graph.versions.minConsumer}`;
        this.executor = new (0, $fXEIJ.GraphExecutor)((0, $5cY9q.OperationMapper).Instance.transformGraph(graph, this.signature));
        this.executor.weightMap = this.convertTensorMapToTensorsMap(weightMap);
        // Attach a model-level resourceManager to each executor to share resources,
        // such as `HashTable`.
        this.executor.resourceManager = this.resourceManager;
        if (artifacts.modelInitializer != null && artifacts.modelInitializer.node != null) {
            const initializer = (0, $5cY9q.OperationMapper).Instance.transformGraph(artifacts.modelInitializer);
            this.initializer = new (0, $fXEIJ.GraphExecutor)(initializer);
            this.initializer.weightMap = this.executor.weightMap;
            // Attach a model-level resourceManager to the initializer, the
            // hashTables created from when executing the initializer will be stored
            // in the resourceManager.
            this.initializer.resourceManager = this.resourceManager;
            this.initializerSignature = artifacts.initializerSignature;
        }
        return true;
    }
    /**
     * Save the configuration and/or weights of the GraphModel.
     *
     * An `IOHandler` is an object that has a `save` method of the proper
     * signature defined. The `save` method manages the storing or
     * transmission of serialized data ("artifacts") that represent the
     * model's topology and weights onto or via a specific medium, such as
     * file downloads, local storage, IndexedDB in the web browser and HTTP
     * requests to a server. TensorFlow.js provides `IOHandler`
     * implementations for a number of frequently used saving mediums, such as
     * `tf.io.browserDownloads` and `tf.io.browserLocalStorage`. See `tf.io`
     * for more details.
     *
     * This method also allows you to refer to certain types of `IOHandler`s
     * as URL-like string shortcuts, such as 'localstorage://' and
     * 'indexeddb://'.
     *
     * Example 1: Save `model`'s topology and weights to browser [local
     * storage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage);
     * then load it back.
     *
     * ```js
     * const modelUrl =
     *    'https://storage.googleapis.com/tfjs-models/savedmodel/mobilenet_v2_1.0_224/model.json';
     * const model = await tf.loadGraphModel(modelUrl);
     * const zeros = tf.zeros([1, 224, 224, 3]);
     * model.predict(zeros).print();
     *
     * const saveResults = await model.save('localstorage://my-model-1');
     *
     * const loadedModel = await tf.loadGraphModel('localstorage://my-model-1');
     * console.log('Prediction from loaded model:');
     * model.predict(zeros).print();
     * ```
     *
     * @param handlerOrURL An instance of `IOHandler` or a URL-like,
     * scheme-based string shortcut for `IOHandler`.
     * @param config Options for saving the model.
     * @returns A `Promise` of `SaveResult`, which summarizes the result of
     * the saving, such as byte sizes of the saved artifacts for the model's
     *   topology and weight values.
     *
     * @doc {heading: 'Models', subheading: 'Classes', ignoreCI: true}
     */ async save(handlerOrURL, config) {
        if (typeof handlerOrURL === 'string') {
            const handlers = this.io.getSaveHandlers(handlerOrURL);
            if (handlers.length === 0) throw new Error(`Cannot find any save handlers for URL '${handlerOrURL}'`);
            else if (handlers.length > 1) throw new Error(`Found more than one (${handlers.length}) save handlers for ` + `URL '${handlerOrURL}'`);
            handlerOrURL = handlers[0];
        }
        if (handlerOrURL.save == null) throw new Error("GraphModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        return handlerOrURL.save(this.artifacts);
    }
    addStructuredOutputNames(outputTensors) {
        if (this.structuredOutputKeys) {
            const outputTensorsArray = outputTensors instanceof (0, $3pVUH.Tensor) ? [
                outputTensors
            ] : outputTensors;
            const outputTensorMap = {};
            outputTensorsArray.forEach((outputTensor, i)=>outputTensorMap[this.structuredOutputKeys[i]] = outputTensor);
            return outputTensorMap;
        }
        return outputTensors;
    }
    /**
     * Execute the inference for the input tensors.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with multiple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns Inference result tensors. If the model is converted and it
     * originally had structured_outputs in tensorflow, then a NamedTensorMap
     * will be returned matching the structured_outputs. If no structured_outputs
     * are present, the output will be single `tf.Tensor` if the model has single
     * output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ predict(inputs, config) {
        const outputTensors = this.execute(inputs, this.outputNodes);
        return this.addStructuredOutputNames(outputTensors);
    }
    /**
     * Execute the inference for the input tensors in async fashion, use this
     * method when your model contains control flow ops.
     *
     * @param input The input tensors, when there is single input for the model,
     * inputs param should be a `tf.Tensor`. For models with mutliple inputs,
     * inputs params should be in either `tf.Tensor`[] if the input order is
     * fixed, or otherwise NamedTensorMap format.
     *
     * For model with multiple inputs, we recommend you use NamedTensorMap as the
     * input type, if you use `tf.Tensor`[], the order of the array needs to
     * follow the
     * order of inputNodes array. @see {@link GraphModel.inputNodes}
     *
     * You can also feed any intermediate nodes using the NamedTensorMap as the
     * input type. For example, given the graph
     *    InputNode => Intermediate => OutputNode,
     * you can execute the subgraph Intermediate => OutputNode by calling
     *    model.execute('IntermediateNode' : tf.tensor(...));
     *
     * This is useful for models that uses tf.dynamic_rnn, where the intermediate
     * state needs to be fed manually.
     *
     * For batch inference execution, the tensors for each input need to be
     * concatenated together. For example with mobilenet, the required input shape
     * is [1, 244, 244, 3], which represents the [batch, height, width, channel].
     * If we are provide a batched data of 100 images, the input tensor should be
     * in the shape of [100, 244, 244, 3].
     *
     * @param config Prediction configuration for specifying the batch size.
     * Currently the batch size option is ignored for graph model.
     *
     * @returns A Promise of inference result tensors. If the model is converted
     * and it originally had structured_outputs in tensorflow, then a
     * NamedTensorMap will be returned matching the structured_outputs. If no
     * structured_outputs are present, the output will be single `tf.Tensor` if
     * the model has single output node, otherwise Tensor[].
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async predictAsync(inputs, config) {
        const outputTensors = await this.executeAsync(inputs, this.outputNodes);
        return this.addStructuredOutputNames(outputTensors);
    }
    normalizeInputs(inputs) {
        var _a;
        if (!(inputs instanceof (0, $3pVUH.Tensor)) && !Array.isArray(inputs)) {
            // The input is already a NamedTensorMap.
            const signatureInputs = (_a = this.signature) === null || _a === void 0 ? void 0 : _a.inputs;
            if (signatureInputs != null) for(const input in signatureInputs){
                const tensor = signatureInputs[input];
                if (tensor.resourceId != null) inputs[input] = this.resourceIdToCapturedInput[tensor.resourceId];
            }
            return inputs;
        }
        inputs = Array.isArray(inputs) ? inputs : [
            inputs
        ];
        const numCapturedInputs = Object.keys(this.resourceIdToCapturedInput).length;
        if (inputs.length + numCapturedInputs !== this.inputNodes.length) throw new Error(`Input tensor count mismatch, the graph model has ${this.inputNodes.length - numCapturedInputs} non-resource placeholders, while there are ${inputs.length} input tensors provided.`);
        let inputIndex = 0;
        return this.inputNodes.reduce((map, inputName)=>{
            var _a, _b, _c;
            const resourceId = (_c = (_b = (_a = this.signature) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b[inputName]) === null || _c === void 0 ? void 0 : _c.resourceId;
            if (resourceId != null) map[inputName] = this.resourceIdToCapturedInput[resourceId];
            else map[inputName] = inputs[inputIndex++];
            return map;
        }, {});
    }
    normalizeOutputs(outputs) {
        outputs = outputs || this.outputNodes;
        return !Array.isArray(outputs) ? [
            outputs
        ] : outputs;
    }
    executeInitializerGraph() {
        if (this.initializer == null) return [];
        if (this.initializerSignature == null) return this.initializer.execute({}, []);
        else return this.initializer.execute({}, Object.keys(this.initializerSignature.outputs));
    }
    async executeInitializerGraphAsync() {
        if (this.initializer == null) return [];
        if (this.initializerSignature == null) return this.initializer.executeAsync({}, []);
        else return this.initializer.executeAsync({}, Object.keys(this.initializerSignature.outputs));
    }
    setResourceIdToCapturedInput(outputs) {
        this.resourceIdToCapturedInput = {};
        if (this.initializerSignature) {
            const signatureOutputs = this.initializerSignature.outputs;
            const outputNames = Object.keys(signatureOutputs);
            for(let i = 0; i < outputNames.length; i++){
                const outputName = outputNames[i];
                const tensorInfo = signatureOutputs[outputName];
                this.resourceIdToCapturedInput[tensorInfo.resourceId] = outputs[i];
            }
        }
    }
    /**
     * Executes inference for the model for given input tensors.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no
     * outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     *
     * @returns A single tensor if provided with a single output or no outputs
     * are provided and there is only one default output, otherwise return a
     * tensor array. The order of the tensor array is the same as the outputs
     * if provided, otherwise the order of outputNodes attribute of the model.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ execute(inputs, outputs) {
        if (this.resourceIdToCapturedInput == null) this.setResourceIdToCapturedInput(this.executeInitializerGraph());
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = this.executor.execute(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Executes inference for the model for given input tensors in async
     * fashion, use this method when your model contains control flow ops.
     * @param inputs tensor, tensor array or tensor map of the inputs for the
     * model, keyed by the input node names.
     * @param outputs output node name from the TensorFlow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     *
     * @returns A Promise of single tensor if provided with a single output or
     * no outputs are provided and there is only one default output, otherwise
     * return a tensor map.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ async executeAsync(inputs, outputs) {
        if (this.resourceIdToCapturedInput == null) this.setResourceIdToCapturedInput(await this.executeInitializerGraphAsync());
        inputs = this.normalizeInputs(inputs);
        outputs = this.normalizeOutputs(outputs);
        const result = await this.executor.executeAsync(inputs, outputs);
        return result.length > 1 ? result : result[0];
    }
    /**
     * Get intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ getIntermediateTensors() {
        return this.executor.getIntermediateTensors();
    }
    /**
     * Dispose intermediate tensors for model debugging mode (flag
     * KEEP_INTERMEDIATE_TENSORS is true).
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ disposeIntermediateTensors() {
        this.executor.disposeIntermediateTensors();
    }
    convertTensorMapToTensorsMap(map) {
        return Object.keys(map).reduce((newMap, key)=>{
            newMap[key] = [
                map[key]
            ];
            return newMap;
        }, {});
    }
    /**
     * Releases the memory used by the weight tensors and resourceManager.
     *
     * @doc {heading: 'Models', subheading: 'Classes'}
     */ dispose() {
        this.executor.dispose();
        if (this.initializer) {
            this.initializer.dispose();
            if (this.resourceIdToCapturedInput) (0, $d7Nxs.dispose)(this.resourceIdToCapturedInput);
        }
        this.resourceManager.dispose();
    }
}
async function $8f5409241989162f$export$f077572b5d896ffd(modelUrl, options = {}, tfio = (0, $feqcJ)) {
    if (modelUrl == null) throw new Error("modelUrl in loadGraphModel() cannot be null. Please provide a url or an IOHandler that loads the model");
    if (options == null) options = {};
    if (options.fromTFHub && typeof modelUrl === 'string') modelUrl = $8f5409241989162f$var$getTFHubUrl(modelUrl);
    const model = new $8f5409241989162f$export$357a78c279dfa8cf(modelUrl, options, tfio);
    await model.load();
    return model;
}
function $8f5409241989162f$export$64fa41ef6cfbfdd7(modelSource) {
    if (modelSource == null) throw new Error("modelUrl in loadGraphModelSync() cannot be null. Please provide model artifacts or an IOHandler that loads the model");
    let ioHandler;
    if (modelSource instanceof Array) {
        const [modelJSON, weights] = modelSource;
        if (!modelJSON) throw new Error('modelJSON must be the first element of the array');
        if (!weights || !(weights instanceof ArrayBuffer)) throw new Error("An ArrayBuffer of weights must be the second element of the array");
        if (!('modelTopology' in modelJSON)) throw new Error('Model JSON is missing \'modelTopology\'');
        if (!('weightsManifest' in modelJSON)) throw new Error('Model JSON is missing \'weightsManifest\'');
        const weightSpecs = (0, $feqcJ).getWeightSpecs(modelJSON.weightsManifest);
        const modelArtifacts = (0, $feqcJ).getModelArtifactsForJSONSync(modelJSON, weightSpecs, weights);
        ioHandler = (0, $feqcJ).fromMemorySync(modelArtifacts);
    } else if ('load' in modelSource) // Then modelSource is already an IOHandlerSync.
    ioHandler = modelSource;
    else if ('modelTopology' in modelSource && 'weightSpecs' in modelSource && 'weightData' in modelSource) // modelSource is of type ModelArtifacts.
    ioHandler = (0, $feqcJ).fromMemorySync(modelSource);
    else throw new Error('Unknown model format');
    const model = new $8f5409241989162f$export$357a78c279dfa8cf(ioHandler);
    model.load();
    return model;
}
function $8f5409241989162f$var$getTFHubUrl(modelUrl) {
    if (!modelUrl.endsWith('/')) modelUrl = modelUrl + '/';
    return `${modelUrl}${$8f5409241989162f$export$9ffb2eac80132860}${$8f5409241989162f$export$a9bc79b23e178599}`;
}

});
parcelRegister("5cY9q", function(module, exports) {

$parcel$export(module.exports, "OperationMapper", function () { return $3cacbb76ecda84a8$export$712e670bcbcf1315; });
$parcel$export(module.exports, "getStringParam", function () { return $3cacbb76ecda84a8$export$88878e8ea979e9e0; });
$parcel$export(module.exports, "getStringArrayParam", function () { return $3cacbb76ecda84a8$export$3ad7c1b82be1673b; });
$parcel$export(module.exports, "getNumberParam", function () { return $3cacbb76ecda84a8$export$9bb8d6def7820923; });
$parcel$export(module.exports, "getNumericArrayParam", function () { return $3cacbb76ecda84a8$export$a5181f35ff520ed9; });
$parcel$export(module.exports, "getBoolParam", function () { return $3cacbb76ecda84a8$export$2dc362e9c5612e66; });
$parcel$export(module.exports, "getBoolArrayParam", function () { return $3cacbb76ecda84a8$export$71dea7cc6cfe5d6; });
$parcel$export(module.exports, "getTensorShapeParam", function () { return $3cacbb76ecda84a8$export$2f3f0447f2b6ba0c; });
$parcel$export(module.exports, "getTensorShapeArrayParam", function () { return $3cacbb76ecda84a8$export$296050a88ff1b217; });
$parcel$export(module.exports, "getDtypeParam", function () { return $3cacbb76ecda84a8$export$8ff555328ef39a1b; });
$parcel$export(module.exports, "getDtypeArrayParam", function () { return $3cacbb76ecda84a8$export$4d8018dacba67c5a; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");

var $hvVs0 = parcelRequire("hvVs0");

var $2Z8vl = parcelRequire("2Z8vl");

var $j83KU = parcelRequire("j83KU");

var $8FvXY = parcelRequire("8FvXY");

var $bkEnB = parcelRequire("bkEnB");

var $dvmAg = parcelRequire("dvmAg");

var $huUUj = parcelRequire("huUUj");

var $jfkFY = parcelRequire("jfkFY");

var $bT6eH = parcelRequire("bT6eH");

var $eIjjB = parcelRequire("eIjjB");

var $c1KjH = parcelRequire("c1KjH");

var $lv1H7 = parcelRequire("lv1H7");

var $jDJAG = parcelRequire("jDJAG");

var $ibJ1s = parcelRequire("ibJ1s");

var $clRwT = parcelRequire("clRwT");

var $kDox3 = parcelRequire("kDox3");

var $3nItX = parcelRequire("3nItX");

var $a4KMD = parcelRequire("a4KMD");

var $8qKju = parcelRequire("8qKju");

var $8szR8 = parcelRequire("8szR8");

var $4dgkM = parcelRequire("4dgkM");

var $76upq = parcelRequire("76upq");

var $2bytI = parcelRequire("2bytI");
var $3cacbb76ecda84a8$require$Buffer = $2bytI.Buffer;
class $3cacbb76ecda84a8$export$712e670bcbcf1315 {
    // Singleton instance for the mapper
    static get Instance() {
        return this._instance || (this._instance = new this());
    }
    // Loads the op mapping from the JSON file.
    constructor(){
        const ops = [
            $8FvXY,
            $bkEnB,
            $dvmAg,
            $huUUj,
            $jfkFY,
            $bT6eH,
            $eIjjB,
            $c1KjH,
            $lv1H7,
            $jDJAG,
            $ibJ1s,
            $clRwT,
            $kDox3,
            $3nItX,
            $a4KMD,
            $8qKju,
            $8szR8,
            $4dgkM,
            $76upq
        ];
        const mappersJson = [].concat(...ops.map((op)=>op.json));
        this.opMappers = mappersJson.reduce((map, mapper)=>{
            map[mapper.tfOpName] = mapper;
            return map;
        }, {});
    }
    // Converts the model inference graph from Tensorflow GraphDef to local
    // representation for TensorFlow.js API
    transformGraph(graph, signature = {}) {
        const tfNodes = graph.node;
        const placeholders = [];
        const weights = [];
        const initNodes = [];
        const nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op.startsWith('Placeholder')) placeholders.push(map[node.name]);
            else if (node.op === 'Const') weights.push(map[node.name]);
            else if (node.input == null || node.input.length === 0) initNodes.push(map[node.name]);
            return map;
        }, {});
        let inputs = [];
        const outputs = [];
        let inputNodeNameToKey = {};
        let outputNodeNameToKey = {};
        if (signature != null) {
            inputNodeNameToKey = this.mapSignatureEntries(signature.inputs);
            outputNodeNameToKey = this.mapSignatureEntries(signature.outputs);
        }
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $j83KU.getNodeNameAndIndex)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        // if signature has not outputs set, add any node that does not have
        // outputs.
        if (Object.keys(outputNodeNameToKey).length === 0) allNodes.forEach((key)=>{
            const node = nodes[key];
            if (node.children.length === 0) outputs.push(node);
        });
        else Object.keys(outputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $j83KU.getNodeNameAndIndex)(name);
            const node = nodes[nodeName];
            if (node != null) {
                node.signatureKey = outputNodeNameToKey[name];
                outputs.push(node);
            }
        });
        if (Object.keys(inputNodeNameToKey).length > 0) Object.keys(inputNodeNameToKey).forEach((name)=>{
            const [nodeName] = (0, $j83KU.getNodeNameAndIndex)(name);
            const node = nodes[nodeName];
            if (node) {
                node.signatureKey = inputNodeNameToKey[name];
                inputs.push(node);
            }
        });
        else inputs = placeholders;
        let functions = {};
        if (graph.library != null && graph.library.function != null) functions = graph.library.function.reduce((functions, func)=>{
            functions[func.signature.name] = this.mapFunction(func);
            return functions;
        }, {});
        const result = {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature,
            functions: functions
        };
        if (initNodes.length > 0) result.initNodes = initNodes;
        return result;
    }
    mapSignatureEntries(entries) {
        return Object.keys(entries || {}).reduce((prev, curr)=>{
            prev[entries[curr].name] = curr;
            return prev;
        }, {});
    }
    mapNode(node) {
        // Unsupported ops will cause an error at run-time (not parse time), since
        // they may not be used by the actual execution subgraph.
        const mapper = (0, $2Z8vl.getRegisteredOp)(node.op) || this.opMappers[node.op] || {};
        if (node.attr == null) node.attr = {};
        const newNode = {
            name: node.name,
            op: node.op,
            category: mapper.category,
            inputNames: (node.input || []).map((input)=>input.startsWith('^') ? input.slice(1) : input),
            inputs: [],
            children: [],
            inputParams: {},
            attrParams: {},
            rawAttrs: node.attr,
            outputs: mapper.outputs
        };
        if (mapper.inputs != null) newNode.inputParams = mapper.inputs.reduce((map, param)=>{
            map[param.name] = {
                type: param.type,
                inputIndexStart: param.start,
                inputIndexEnd: param.end
            };
            return map;
        }, {});
        if (mapper.attrs != null) newNode.attrParams = mapper.attrs.reduce((map, param)=>{
            const type = param.type;
            let value = undefined;
            switch(param.type){
                case 'string':
                    value = $3cacbb76ecda84a8$export$88878e8ea979e9e0(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$88878e8ea979e9e0(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'string[]':
                    value = $3cacbb76ecda84a8$export$3ad7c1b82be1673b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$3ad7c1b82be1673b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number':
                    value = $3cacbb76ecda84a8$export$9bb8d6def7820923(node.attr, param.tfName, param.defaultValue || 0);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$9bb8d6def7820923(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'number[]':
                    value = $3cacbb76ecda84a8$export$a5181f35ff520ed9(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$a5181f35ff520ed9(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool':
                    value = $3cacbb76ecda84a8$export$2dc362e9c5612e66(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$2dc362e9c5612e66(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'bool[]':
                    value = $3cacbb76ecda84a8$export$71dea7cc6cfe5d6(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$71dea7cc6cfe5d6(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape':
                    value = $3cacbb76ecda84a8$export$2f3f0447f2b6ba0c(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$2f3f0447f2b6ba0c(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'shape[]':
                    value = $3cacbb76ecda84a8$export$296050a88ff1b217(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$296050a88ff1b217(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype':
                    value = $3cacbb76ecda84a8$export$8ff555328ef39a1b(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$8ff555328ef39a1b(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'dtype[]':
                    value = $3cacbb76ecda84a8$export$4d8018dacba67c5a(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$4d8018dacba67c5a(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'func':
                    value = $3cacbb76ecda84a8$export$aafe7fbc7c8a8284(node.attr, param.tfName, param.defaultValue);
                    if (value === undefined && !!param.tfDeprecatedName) value = $3cacbb76ecda84a8$export$aafe7fbc7c8a8284(node.attr, param.tfDeprecatedName, param.defaultValue);
                    break;
                case 'tensor':
                case 'tensors':
                    break;
                default:
                    throw new Error(`Unsupported param type: ${param.type} for op: ${node.op}`);
            }
            map[param.name] = {
                value: value,
                type: type
            };
            return map;
        }, {});
        return newNode;
    }
    // map the TFunctionDef to TFJS graph object
    mapFunction(functionDef) {
        const tfNodes = functionDef.nodeDef;
        const placeholders = [];
        const weights = [];
        let nodes = {};
        if (tfNodes != null) nodes = tfNodes.reduce((map, node)=>{
            map[node.name] = this.mapNode(node);
            if (node.op === 'Const') weights.push(map[node.name]);
            return map;
        }, {});
        const inputs = [];
        const outputs = [];
        functionDef.signature.inputArg.forEach((arg)=>{
            const [nodeName] = (0, $j83KU.getNodeNameAndIndex)(arg.name);
            const node = {
                name: nodeName,
                op: 'Placeholder',
                inputs: [],
                inputNames: [],
                category: 'graph',
                inputParams: {},
                attrParams: {
                    dtype: {
                        value: $3cacbb76ecda84a8$export$863992a6f00f04d8(arg.type),
                        type: 'dtype'
                    }
                },
                children: []
            };
            node.signatureKey = arg.name;
            inputs.push(node);
            nodes[nodeName] = node;
        });
        const allNodes = Object.keys(nodes);
        allNodes.forEach((key)=>{
            const node = nodes[key];
            node.inputNames.forEach((name, index)=>{
                const [nodeName, , outputName] = (0, $j83KU.getNodeNameAndIndex)(name);
                const inputNode = nodes[nodeName];
                if (inputNode.outputs != null) {
                    const outputIndex = inputNode.outputs.indexOf(outputName);
                    if (outputIndex !== -1) {
                        const inputName = `${nodeName}:${outputIndex}`;
                        // update the input name to use the mapped output index directly.
                        node.inputNames[index] = inputName;
                    }
                }
                node.inputs.push(inputNode);
                inputNode.children.push(node);
            });
        });
        const returnNodeMap = functionDef.ret;
        functionDef.signature.outputArg.forEach((output)=>{
            const [nodeName, index] = (0, $j83KU.getNodeNameAndIndex)(returnNodeMap[output.name]);
            const node = nodes[nodeName];
            if (node != null) {
                node.defaultOutput = index;
                outputs.push(node);
            }
        });
        const signature = this.mapArgsToSignature(functionDef);
        return {
            nodes: nodes,
            inputs: inputs,
            outputs: outputs,
            weights: weights,
            placeholders: placeholders,
            signature: signature
        };
    }
    mapArgsToSignature(functionDef) {
        return {
            methodName: functionDef.signature.name,
            inputs: functionDef.signature.inputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg);
                return map;
            }, {}),
            outputs: functionDef.signature.outputArg.reduce((map, arg)=>{
                map[arg.name] = this.mapArgToTensorInfo(arg, functionDef.ret);
                return map;
            }, {})
        };
    }
    mapArgToTensorInfo(arg, nameMap) {
        let name = arg.name;
        if (nameMap != null) name = nameMap[name];
        return {
            name: name,
            dtype: arg.type
        };
    }
}
function $3cacbb76ecda84a8$export$94fdf11bafc8de6b(text) {
    const global = (0, $tdutJ.env)().global;
    if (typeof global.atob !== 'undefined') return global.atob(text);
    else if (typeof $3cacbb76ecda84a8$require$Buffer !== 'undefined') return new $3cacbb76ecda84a8$require$Buffer(text, 'base64').toString();
    else throw new Error("Unable to decode base64 in this environment. Missing built-in atob() or Buffer()");
}
function $3cacbb76ecda84a8$export$a112ee1a9f1f58d1(s, keepCase) {
    const value = Array.isArray(s) ? String.fromCharCode.apply(null, s) : $3cacbb76ecda84a8$export$94fdf11bafc8de6b(s);
    return keepCase ? value : value.toLowerCase();
}
function $3cacbb76ecda84a8$export$88878e8ea979e9e0(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param != null) return $3cacbb76ecda84a8$export$a112ee1a9f1f58d1(param.s, keepCase);
    return def;
}
function $3cacbb76ecda84a8$export$2dc362e9c5612e66(attrs, name, def) {
    const param = attrs[name];
    return param ? param.b : def;
}
function $3cacbb76ecda84a8$export$9bb8d6def7820923(attrs, name, def) {
    const param = attrs[name] || {};
    const value = param['i'] != null ? param['i'] : param['f'] != null ? param['f'] : def;
    return typeof value === 'number' ? value : parseInt(value, 10);
}
function $3cacbb76ecda84a8$export$863992a6f00f04d8(value) {
    if (typeof value === 'string') // tslint:disable-next-line:no-any
    value = $hvVs0.DataType[value];
    switch(value){
        case $hvVs0.DataType.DT_FLOAT:
        case $hvVs0.DataType.DT_HALF:
            return 'float32';
        case $hvVs0.DataType.DT_INT32:
        case $hvVs0.DataType.DT_INT64:
        case $hvVs0.DataType.DT_INT8:
        case $hvVs0.DataType.DT_UINT8:
            return 'int32';
        case $hvVs0.DataType.DT_BOOL:
            return 'bool';
        case $hvVs0.DataType.DT_DOUBLE:
            return 'float32';
        case $hvVs0.DataType.DT_STRING:
            return 'string';
        case $hvVs0.DataType.DT_COMPLEX64:
        case $hvVs0.DataType.DT_COMPLEX128:
            return 'complex64';
        default:
            // Unknown dtype error will happen at runtime (instead of parse time),
            // since these nodes might not be used by the actual subgraph execution.
            return null;
    }
}
function $3cacbb76ecda84a8$export$aafe7fbc7c8a8284(attrs, name, def) {
    const param = attrs[name];
    if (param && param.func) return param.func.name;
    return def;
}
function $3cacbb76ecda84a8$export$8ff555328ef39a1b(attrs, name, def) {
    const param = attrs[name];
    if (param && param.type) return $3cacbb76ecda84a8$export$863992a6f00f04d8(param.type);
    return def;
}
function $3cacbb76ecda84a8$export$4d8018dacba67c5a(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.type) return param.list.type.map((v)=>$3cacbb76ecda84a8$export$863992a6f00f04d8(v));
    return def;
}
function $3cacbb76ecda84a8$export$e22e6990f4767045(shape) {
    if (shape.unknownRank) return undefined;
    if (shape.dim != null) return shape.dim.map((dim)=>typeof dim.size === 'number' ? dim.size : parseInt(dim.size, 10));
    return [];
}
function $3cacbb76ecda84a8$export$2f3f0447f2b6ba0c(attrs, name, def) {
    const param = attrs[name];
    if (param && param.shape) return $3cacbb76ecda84a8$export$e22e6990f4767045(param.shape);
    return def;
}
function $3cacbb76ecda84a8$export$a5181f35ff520ed9(attrs, name, def) {
    const param = attrs[name];
    if (param) return ((param.list.f && param.list.f.length ? param.list.f : param.list.i) || []).map((v)=>typeof v === 'number' ? v : parseInt(v, 10));
    return def;
}
function $3cacbb76ecda84a8$export$3ad7c1b82be1673b(attrs, name, def, keepCase = false) {
    const param = attrs[name];
    if (param && param.list && param.list.s) return param.list.s.map((v)=>{
        return $3cacbb76ecda84a8$export$a112ee1a9f1f58d1(v, keepCase);
    });
    return def;
}
function $3cacbb76ecda84a8$export$296050a88ff1b217(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.shape) return param.list.shape.map((v)=>{
        return $3cacbb76ecda84a8$export$e22e6990f4767045(v);
    });
    return def;
}
function $3cacbb76ecda84a8$export$71dea7cc6cfe5d6(attrs, name, def) {
    const param = attrs[name];
    if (param && param.list && param.list.b) return param.list.b;
    return def;
}

});
parcelRegister("hvVs0", function(module, exports) {

$parcel$export(module.exports, "DataType", function () { return $cc01e569cd40cbb4$export$45c69700ee30a78c; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /** DataType enum. */ var $cc01e569cd40cbb4$export$45c69700ee30a78c;
(function(DataType) {
    // These properties must be quoted since they are used by parseDtypeParam
    // in tfjs-converter/src/operations/operation_mapper.ts to look up dtypes
    // by string name. If they are not quoted, Closure will mangle their names.
    // Not a legal value for DataType.  Used to indicate a DataType field
    // has not been set.
    DataType[DataType["DT_INVALID"] = 0] = "DT_INVALID";
    // Data types that all computation devices are expected to be
    // capable to support.
    DataType[DataType["DT_FLOAT"] = 1] = "DT_FLOAT";
    DataType[DataType["DT_DOUBLE"] = 2] = "DT_DOUBLE";
    DataType[DataType["DT_INT32"] = 3] = "DT_INT32";
    DataType[DataType["DT_UINT8"] = 4] = "DT_UINT8";
    DataType[DataType["DT_INT16"] = 5] = "DT_INT16";
    DataType[DataType["DT_INT8"] = 6] = "DT_INT8";
    DataType[DataType["DT_STRING"] = 7] = "DT_STRING";
    DataType[DataType["DT_COMPLEX64"] = 8] = "DT_COMPLEX64";
    DataType[DataType["DT_INT64"] = 9] = "DT_INT64";
    DataType[DataType["DT_BOOL"] = 10] = "DT_BOOL";
    DataType[DataType["DT_QINT8"] = 11] = "DT_QINT8";
    DataType[DataType["DT_QUINT8"] = 12] = "DT_QUINT8";
    DataType[DataType["DT_QINT32"] = 13] = "DT_QINT32";
    DataType[DataType["DT_BFLOAT16"] = 14] = "DT_BFLOAT16";
    DataType[DataType["DT_QINT16"] = 15] = "DT_QINT16";
    DataType[DataType["DT_QUINT16"] = 16] = "DT_QUINT16";
    DataType[DataType["DT_UINT16"] = 17] = "DT_UINT16";
    DataType[DataType["DT_COMPLEX128"] = 18] = "DT_COMPLEX128";
    DataType[DataType["DT_HALF"] = 19] = "DT_HALF";
    DataType[DataType["DT_RESOURCE"] = 20] = "DT_RESOURCE";
    DataType[DataType["DT_VARIANT"] = 21] = "DT_VARIANT";
    DataType[DataType["DT_UINT32"] = 22] = "DT_UINT32";
    DataType[DataType["DT_UINT64"] = 23] = "DT_UINT64";
    // Do not use!  These are only for parameters.  Every enum above
    // should have a corresponding value below (verified by types_test).
    DataType[DataType["DT_FLOAT_REF"] = 101] = "DT_FLOAT_REF";
    DataType[DataType["DT_DOUBLE_REF"] = 102] = "DT_DOUBLE_REF";
    DataType[DataType["DT_INT32_REF"] = 103] = "DT_INT32_REF";
    DataType[DataType["DT_UINT8_REF"] = 104] = "DT_UINT8_REF";
    DataType[DataType["DT_INT16_REF"] = 105] = "DT_INT16_REF";
    DataType[DataType["DT_INT8_REF"] = 106] = "DT_INT8_REF";
    DataType[DataType["DT_STRING_REF"] = 107] = "DT_STRING_REF";
    DataType[DataType["DT_COMPLEX64_REF"] = 108] = "DT_COMPLEX64_REF";
    DataType[DataType["DT_INT64_REF"] = 109] = "DT_INT64_REF";
    DataType[DataType["DT_BOOL_REF"] = 110] = "DT_BOOL_REF";
    DataType[DataType["DT_QINT8_REF"] = 111] = "DT_QINT8_REF";
    DataType[DataType["DT_QUINT8_REF"] = 112] = "DT_QUINT8_REF";
    DataType[DataType["DT_QINT32_REF"] = 113] = "DT_QINT32_REF";
    DataType[DataType["DT_BFLOAT16_REF"] = 114] = "DT_BFLOAT16_REF";
    DataType[DataType["DT_QINT16_REF"] = 115] = "DT_QINT16_REF";
    DataType[DataType["DT_QUINT16_REF"] = 116] = "DT_QUINT16_REF";
    DataType[DataType["DT_UINT16_REF"] = 117] = "DT_UINT16_REF";
    DataType[DataType["DT_COMPLEX128_REF"] = 118] = "DT_COMPLEX128_REF";
    DataType[DataType["DT_HALF_REF"] = 119] = "DT_HALF_REF";
    DataType[DataType["DT_RESOURCE_REF"] = 120] = "DT_RESOURCE_REF";
    DataType[DataType["DT_VARIANT_REF"] = 121] = "DT_VARIANT_REF";
    DataType[DataType["DT_UINT32_REF"] = 122] = "DT_UINT32_REF";
    DataType[DataType["DT_UINT64_REF"] = 123] = "DT_UINT64_REF";
})($cc01e569cd40cbb4$export$45c69700ee30a78c || ($cc01e569cd40cbb4$export$45c69700ee30a78c = {}));
var $cc01e569cd40cbb4$export$c7aebf4a33f92df2;
(function(SaverDef) {
    /** CheckpointFormatVersion enum. */ let CheckpointFormatVersion;
    (function(CheckpointFormatVersion) {
        CheckpointFormatVersion[CheckpointFormatVersion["LEGACY"] = 0] = "LEGACY";
        CheckpointFormatVersion[CheckpointFormatVersion["V1"] = 1] = "V1";
        CheckpointFormatVersion[CheckpointFormatVersion["V2"] = 2] = "V2";
    })(CheckpointFormatVersion = SaverDef.CheckpointFormatVersion || (SaverDef.CheckpointFormatVersion = {}));
})($cc01e569cd40cbb4$export$c7aebf4a33f92df2 || ($cc01e569cd40cbb4$export$c7aebf4a33f92df2 = {}));

});

parcelRegister("2Z8vl", function(module, exports) {

$parcel$export(module.exports, "getRegisteredOp", function () { return $22c7e01bd4d67258$export$ad480e5d0b303fdc; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $22c7e01bd4d67258$var$CUSTOM_OPS = {};
function $22c7e01bd4d67258$export$670e5ae0b581ed28(name, opFunc) {
    const opMapper = {
        tfOpName: name,
        category: 'custom',
        inputs: [],
        attrs: [],
        customExecutor: opFunc
    };
    $22c7e01bd4d67258$var$CUSTOM_OPS[name] = opMapper;
}
function $22c7e01bd4d67258$export$ad480e5d0b303fdc(name) {
    return $22c7e01bd4d67258$var$CUSTOM_OPS[name];
}
function $22c7e01bd4d67258$export$26ff69eae92eb5cb(name) {
    delete $22c7e01bd4d67258$var$CUSTOM_OPS[name];
}

});

parcelRegister("j83KU", function(module, exports) {

$parcel$export(module.exports, "getParamValue", function () { return $ded1ad7a8e656746$export$390042a9afe1baa5; });
$parcel$export(module.exports, "getTensor", function () { return $ded1ad7a8e656746$export$c5e50df225428195; });
$parcel$export(module.exports, "parseNodeName", function () { return $ded1ad7a8e656746$export$67aec20b8c372baf; });
$parcel$export(module.exports, "getTensorsForCurrentContext", function () { return $ded1ad7a8e656746$export$d8cd584ff358961a; });
$parcel$export(module.exports, "getNodeNameAndIndex", function () { return $ded1ad7a8e656746$export$6cbb65bf9e07a72; });
$parcel$export(module.exports, "getPadding", function () { return $ded1ad7a8e656746$export$d7501e6bee71bfee; });
$parcel$export(module.exports, "cloneTensor", function () { return $ded1ad7a8e656746$export$c2185cfeaef7ba84; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $ek4FP = parcelRequire("ek4FP");
var $lBDHD = parcelRequire("lBDHD");
function $ded1ad7a8e656746$export$390042a9afe1baa5(paramName, node, tensorMap, context, resourceManager) {
    const inputParam = node.inputParams[paramName];
    if (inputParam && inputParam.inputIndexStart !== undefined) {
        const start = inputParam.inputIndexStart;
        const end = inputParam.inputIndexEnd === 0 ? undefined : inputParam.inputIndexEnd === undefined ? start + 1 : inputParam.inputIndexEnd;
        const shiftedStart = start < 0 ? node.inputNames.length + start : start;
        if (inputParam.type === 'tensor') return $ded1ad7a8e656746$export$c5e50df225428195(node.inputNames[shiftedStart], tensorMap, context, resourceManager);
        if (inputParam.type === 'tensors') {
            // TODO(mattSoulanille): This filters out NoOp nodes during execution, but
            // these should really never be in the execution graph in the first place.
            // They're necessary for ordering the graph, but should not be visible
            // during execution. Perhaps have different sets of children, one for
            // control dependencies and another for real dependencies.
            const inputs = node.inputs.slice(start, end);
            const inputNames = node.inputNames.slice(start, end).filter((_name, index)=>{
                var _a;
                return ((_a = inputs[index]) === null || _a === void 0 ? void 0 : _a.op) !== 'NoOp';
            });
            return inputNames.map((name)=>$ded1ad7a8e656746$export$c5e50df225428195(name, tensorMap, context, resourceManager));
        }
        const tensor = $ded1ad7a8e656746$export$c5e50df225428195(node.inputNames[shiftedStart], tensorMap, context, resourceManager);
        const data = tensor.dataSync();
        return inputParam.type === 'number' ? data[0] : (0, $lBDHD).toNestedArray(tensor.shape, data);
    }
    const attrParam = node.attrParams[paramName];
    return attrParam && attrParam.value;
}
function $ded1ad7a8e656746$export$c5e50df225428195(name, tensorsMap, context, resourceManager) {
    const [nodeName, index] = $ded1ad7a8e656746$export$67aec20b8c372baf(name, context);
    if (resourceManager != null) {
        const tensor = resourceManager.getHashTableHandleByName(nodeName);
        if (tensor != null) return tensor;
    }
    const contextId = context.currentContextIds.find((contextId)=>{
        return !!tensorsMap[$ded1ad7a8e656746$var$getNodeNameWithContextId(nodeName, contextId)];
    });
    return contextId !== undefined ? tensorsMap[$ded1ad7a8e656746$var$getNodeNameWithContextId(nodeName, contextId)][index] : undefined;
}
function $ded1ad7a8e656746$export$d8cd584ff358961a(name, tensorsMap, context) {
    return tensorsMap[$ded1ad7a8e656746$var$getNodeNameWithContextId(name, context.currentContextId)];
}
function $ded1ad7a8e656746$export$6cbb65bf9e07a72(inputName, context) {
    const [nodeName, index, outputName] = $ded1ad7a8e656746$export$67aec20b8c372baf(inputName, context);
    return [
        $ded1ad7a8e656746$var$getNodeNameWithContextId(nodeName, context && context.currentContextId),
        index,
        outputName
    ];
}
function $ded1ad7a8e656746$var$getNodeNameWithContextId(name, contextId) {
    return !!contextId ? `${name}-${contextId}` : name;
}
function $ded1ad7a8e656746$export$67aec20b8c372baf(name, context) {
    if (name === '') return [
        '',
        0,
        undefined
    ];
    const isCacheEnabled = context != null && context.parseNodeNameCache != null;
    if (isCacheEnabled) {
        const cachedResult = context.parseNodeNameCache.get(name);
        if (cachedResult != null) return cachedResult;
    }
    const parts = name.split(':');
    let result;
    if (parts.length === 1) result = [
        name,
        0,
        undefined
    ];
    else {
        const nodeName = parts[0];
        const outputName = parts.length === 3 ? parts[1] : undefined;
        const index = Number(parts[parts.length - 1]);
        result = [
            nodeName,
            index,
            outputName
        ];
    }
    if (isCacheEnabled) context.parseNodeNameCache.set(name, result);
    return result;
}
function $ded1ad7a8e656746$export$65980d18b75784e2(arr, size) {
    const res = [];
    for(let i = 0; i < arr.length; i += size)res.push(arr.slice(i, i + size));
    return res;
}
function $ded1ad7a8e656746$export$d7501e6bee71bfee(node, tensorMap, context) {
    let pad = $ded1ad7a8e656746$export$390042a9afe1baa5('pad', node, tensorMap, context);
    if (pad === 'explicit') {
        // This is 1d array, we need to convert it to 2d array
        pad = $ded1ad7a8e656746$export$390042a9afe1baa5('explicitPaddings', node, tensorMap, context);
        const explicitPadding = [
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ];
        for(let i = 0; i < 4; i++){
            explicitPadding[i][0] = pad[i * 2];
            explicitPadding[i][1] = pad[i * 2 + 1];
        }
        return explicitPadding;
    }
    return pad;
}
function $ded1ad7a8e656746$export$c2185cfeaef7ba84(tensor) {
    return tensor.kept ? tensor : (0, $ek4FP.clone)(tensor);
}

});

parcelRegister("8FvXY", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $64faf2ed05b5c1b7$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $64faf2ed05b5c1b7$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Add',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddV2',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AddN',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'BiasAdd',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sub',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RealDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Div',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DivNoNan',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorDiv',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mul',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Maximum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Minimum',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Pow',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SquaredDifference',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Mod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FloorMod',
        'category': 'arithmetic',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("bkEnB", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $8400e2829830fa83$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $8400e2829830fa83$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Abs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atan2',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Ceil',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ClipByValue',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'clipValueMin',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'clipValueMax',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Complex',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'real',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'imag',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ComplexAbs',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cos',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Elu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Exp',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Floor',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Imag',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Neg',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Real',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'outputType',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Prelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'alpha',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Relu6',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Selu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sigmoid',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sin',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Rsqrt',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Square',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Sign',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Round',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Expm1',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Log1p',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reciprocal',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Softplus',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Asinh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Acosh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Atanh',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Erf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LeakyRelu',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsNan',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsFinite',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IsInf',
        'category': 'basic_math',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("dvmAg", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $9d4fb05248278ba3$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $9d4fb05248278ba3$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EmptyTensorList',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'maxNumElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LoopCond',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Switch',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'pred',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Merge',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Enter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'frame_name',
                'name': 'frameName',
                'type': 'string'
            },
            {
                'tfName': 'is_constant',
                'name': 'isConstant',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Exit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NextIteration',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'size',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'dynamic_size',
                'name': 'dynamicSize',
                'type': 'bool'
            },
            {
                'tfName': 'clear_after_read',
                'name': 'clearAfterRead',
                'type': 'bool'
            },
            {
                'tfName': 'identical_element_shapes',
                'name': 'identicalElementShapes',
                'type': 'bool'
            },
            {
                'tfName': 'tensor_array_name',
                'name': 'name',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayWriteV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayReadV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayGatherV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayScatterV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayConcatV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'element_shape_except0',
                'name': 'elementShapeExcept0',
                'type': 'shape',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySplitV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'flowIn',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorArraySizeV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'flowIn',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'TensorArrayCloseV3',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorArrayId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'StatelessIf',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'If',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'cond',
                'type': 'tensor'
            },
            {
                'start': 1,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'then_branch',
                'name': 'thenBranch',
                'type': 'func'
            },
            {
                'tfName': 'else_branch',
                'name': 'elseBranch',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'StatelessWhile',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'While',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'cond',
                'name': 'cond',
                'type': 'func'
            },
            {
                'tfName': 'body',
                'name': 'body',
                'type': 'func'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatter',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListScatterV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 3,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGather',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListGetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSetItem',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'index',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListReserve',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 1,
                'name': 'numElements',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListFromTensor',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListStack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            },
            {
                'tfName': 'num_elements',
                'name': 'numElements',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListSplit',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'start': 2,
                'name': 'lengths',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcat',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListConcatV2',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_shape',
                'name': 'elementShape',
                'type': 'shape'
            },
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPopBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'elementShape',
                'type': 'shape'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListPushBack',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'element_dtype',
                'name': 'elementDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TensorListLength',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TensorListResize',
        'category': 'control',
        'inputs': [
            {
                'start': 0,
                'name': 'tensorListId',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("huUUj", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $cbd16198c8d881fe$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $cbd16198c8d881fe$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'AvgPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': [],
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPoolWithArgmax',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'include_batch_in_index',
                'name': 'includeBatchInIndex',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'AvgPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MaxPool3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'ksize',
                'name': 'kernelSize',
                'type': 'number[]'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Conv1D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'stride',
                'name': 'stride',
                'type': 'number'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NWC'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'dilation',
                'name': 'dilation',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'Conv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'useCudnnOnGpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': '_FusedConv2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'use_cudnn_on_gpu',
                'name': 'useCudnnOnGpu',
                'type': 'bool',
                'defaultValue': true
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            }
        ]
    },
    {
        'tfOpName': 'Conv2DBackpropInput',
        'category': 'convolution',
        'inputs': [
            {
                'start': 2,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 0,
                'name': 'outputShape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2d',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'FusedDepthwiseConv2dNative',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]',
                'defaultValue': [
                    1,
                    1,
                    1,
                    1
                ]
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'explicit_paddings',
                'name': 'explicitPaddings',
                'type': 'number[]',
                'defaultValue': []
            }
        ]
    },
    {
        'tfOpName': 'Conv3D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'defaultValue': 'NHWC'
            },
            {
                'tfName': 'dilations',
                'name': 'dilations',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Dilation2D',
        'category': 'convolution',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'filter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'strides',
                'name': 'strides',
                'type': 'number[]'
            },
            {
                'tfName': 'rates',
                'name': 'dilations',
                'type': 'number[]'
            },
            {
                'tfName': 'padding',
                'name': 'pad',
                'type': 'string'
            }
        ]
    }
];

});

parcelRegister("jfkFY", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $e02f74dcba7fc15e$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $e02f74dcba7fc15e$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Fill',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            },
            {
                'start': 1,
                'name': 'value',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LinSpace',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'num',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'OneHot',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'depth',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'onValue',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'start': 3,
                'name': 'offValue',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Ones',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'OnesLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'RandomStandardNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniform',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'RandomUniformInt',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'minval',
                'name': 'minval',
                'type': 'number'
            },
            {
                'tfName': 'maxval',
                'name': 'maxval',
                'type': 'number'
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Range',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'start',
                'type': 'number'
            },
            {
                'start': 1,
                'name': 'stop',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'step',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'Tidx',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'TruncatedNormal',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'means',
                'name': 'mean',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'stddev',
                'name': 'stdDev',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'T',
                'name': 'T',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Zeros',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ZerosLike',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Multinomial',
        'category': 'creation',
        'inputs': [
            {
                'start': 0,
                'name': 'logits',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numSamples',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'seed',
                'name': 'seed',
                'type': 'number'
            },
            {
                'tfName': 'seed2',
                'name': 'seed2',
                'type': 'number'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            },
            {
                'tfName': 'output_dtype',
                'name': 'output_dtype',
                'type': 'dtype'
            }
        ]
    }
];

});

parcelRegister("bT6eH", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $8a79ab222b361a97$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $8a79ab222b361a97$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'NonMaxSuppressionV2',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV3',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV4',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'T_threshold',
                'name': 'threshold',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'pad_to_max_output_size',
                'name': 'padToMaxOutputSize',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'NonMaxSuppressionV5',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scores',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'maxOutputSize',
                'type': 'number'
            },
            {
                'start': 3,
                'name': 'iouThreshold',
                'type': 'number'
            },
            {
                'start': 4,
                'name': 'scoreThreshold',
                'type': 'number'
            },
            {
                'start': 5,
                'name': 'softNmsSigma',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Where',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ListDiff',
        'category': 'dynamic',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("eIjjB", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $ab642854f12b3a7a$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $ab642854f12b3a7a$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'LowerBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'TopKV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'k',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'sorted',
                'name': 'sorted',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'UpperBound',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'sortedSequence',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Unique',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'UniqueV2',
        'category': 'evaluation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("c1KjH", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $8c1981968da23412$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $8c1981968da23412$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'PlaceholderWithDefault',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'default',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Placeholder',
        'category': 'graph',
        'attrs': [
            {
                'tfName': 'shape',
                'name': 'shape',
                'type': 'shape'
            },
            {
                'tfName': 'dtype',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'Const',
        'category': 'graph'
    },
    {
        'tfOpName': 'Identity',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IdentityN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Snapshot',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Rank',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Size',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'Shape',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'ShapeN',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'x',
                'type': 'tensors'
            }
        ]
    },
    {
        'tfOpName': 'Print',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'data',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'message',
                'name': 'message',
                'type': 'string'
            },
            {
                'tfName': 'first_n',
                'name': 'firstN',
                'type': 'number',
                'notSupported': true
            },
            {
                'tfName': 'summarize',
                'name': 'summarize',
                'type': 'number',
                'defaultValue': 3
            }
        ]
    },
    {
        'tfOpName': 'NoOp',
        'category': 'graph',
        'inputs': []
    },
    {
        'tfOpName': 'StopGradient',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'FakeQuantWithMinMaxVars',
        'category': 'graph',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'min',
                'name': 'min',
                'type': 'number'
            },
            {
                'tfName': 'max',
                'name': 'max',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("lv1H7", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $fa6dceb93a67c2b8$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $fa6dceb93a67c2b8$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'HashTable',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'HashTableV2',
        'category': 'hash_table',
        'inputs': [],
        'attrs': [
            {
                'tfName': 'shared_name',
                'name': 'sharedName',
                'type': 'string'
            },
            {
                'tfName': 'use_node_name_sharing',
                'name': 'useNodeNameSharing',
                'type': 'bool'
            },
            {
                'tfName': 'key_dtype',
                'name': 'keyDType',
                'type': 'dtype'
            },
            {
                'tfName': 'value_dtype',
                'name': 'valueDType',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImport',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableImportV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFind',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableFindV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'Tin',
                'name': 'tIn',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'Tout',
                'name': 'tOut',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSize',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LookupTableSizeV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'InitializeTable',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'InitializeTableV2',
        'category': 'hash_table',
        'inputs': [
            {
                'start': 0,
                'name': 'tableHandle',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'keys',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("jDJAG", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $e4c5063191798944$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $e4c5063191798944$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ResizeBilinear',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'ResizeNearestNeighbor',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'align_corners',
                'name': 'alignCorners',
                'type': 'bool'
            },
            {
                'tfName': 'half_pixel_centers',
                'name': 'halfPixelCenters',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'CropAndResize',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'image',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'boxes',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'boxInd',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'cropSize',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'method',
                'name': 'method',
                'type': 'string'
            },
            {
                'tfName': 'extrapolation_value',
                'name': 'extrapolationValue',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ImageProjectiveTransformV3',
        'category': 'image',
        'inputs': [
            {
                'start': 0,
                'name': 'images',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'transforms',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'fillValue',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'interpolation',
                'name': 'interpolation',
                'type': 'string'
            },
            {
                'tfName': 'fill_mode',
                'name': 'fillMode',
                'type': 'string'
            }
        ]
    }
];

});

parcelRegister("ibJ1s", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $d3dc2da1a1cb013a$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $d3dc2da1a1cb013a$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Equal',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'NotEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Greater',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'GreaterEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Less',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LessEqual',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalNot',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LogicalOr',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Select',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SelectV2',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'condition',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BitwiseAnd',
        'category': 'logical',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'y',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("clRwT", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $8fe0f80d8ae32644$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $8fe0f80d8ae32644$export$7b419323e6ed4f31 = [
    {
        'tfOpName': '_FusedMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            },
            {
                'start': 2,
                'end': 0,
                'name': 'args',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_args',
                'name': 'numArgs',
                'type': 'number'
            },
            {
                'tfName': 'fused_ops',
                'name': 'fusedOps',
                'type': 'string[]',
                'defaultValue': []
            },
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.0001
            },
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'leakyrelu_alpha',
                'name': 'leakyreluAlpha',
                'type': 'number',
                'defaultValue': 0.2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'MatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'transpose_a',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'transpose_b',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMul',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'BatchMatMulV2',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'b',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'adj_x',
                'name': 'transposeA',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'adj_y',
                'name': 'transposeB',
                'type': 'bool',
                'defaultValue': false
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Transpose',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'perm',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Einsum',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'equation',
                'name': 'equation',
                'type': 'string'
            },
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'MatrixBandPart',
        'category': 'matrices',
        'inputs': [
            {
                'start': 0,
                'name': 'a',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numLower',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numUpper',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("kDox3", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $f05a7abcd4792cdb$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $f05a7abcd4792cdb$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'EuclideanNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool',
                'defaultValue': false
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNorm',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV2',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'FusedBatchNormV3',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'scale',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'offset',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'mean',
                'type': 'tensor'
            },
            {
                'start': 4,
                'name': 'variance',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'epsilon',
                'name': 'epsilon',
                'type': 'number',
                'defaultValue': 0.001
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'LRN',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'depth_radius',
                'name': 'radius',
                'type': 'number',
                'defaultValue': 5
            },
            {
                'tfName': 'bias',
                'name': 'bias',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'alpha',
                'name': 'alpha',
                'type': 'number',
                'defaultValue': 1
            },
            {
                'tfName': 'beta',
                'name': 'beta',
                'type': 'number',
                'defaultValue': 0.5
            }
        ]
    },
    {
        'tfOpName': 'Softmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'LogSoftmax',
        'category': 'normalization',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("3nItX", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $2766064a85684fe8$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $2766064a85684fe8$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Bincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'DenseBincount',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'size',
                'type': 'number'
            },
            {
                'start': 2,
                'name': 'weights',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'binary_output',
                'name': 'binaryOutput',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Max',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Mean',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Min',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Sum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'All',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Any',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'ArgMax',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'ArgMin',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'Prod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'keep_dims',
                'name': 'keepDims',
                'type': 'bool'
            },
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Cumprod',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'Cumsum',
        'category': 'reduction',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'exclusive',
                'name': 'exclusive',
                'type': 'bool'
            },
            {
                'tfName': 'reverse',
                'name': 'reverse',
                'type': 'bool'
            }
        ]
    }
];

});

parcelRegister("a4KMD", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $755e914db7340ada$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $755e914db7340ada$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'ConcatV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': -1,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': -1,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'Concat',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 1,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            },
            {
                'start': 0,
                'name': 'axis',
                'type': 'number'
            }
        ],
        'attrs': [
            {
                'tfName': 'N',
                'name': 'n',
                'type': 'number',
                'defaultValue': 2
            }
        ]
    },
    {
        'tfOpName': 'GatherV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ],
        'attrs': [
            {
                'tfName': 'batch_dims',
                'name': 'batchDims',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Gather',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Reverse',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dims',
                'type': 'bool[]'
            }
        ]
    },
    {
        'tfOpName': 'ReverseV2',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Slice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'size',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'StridedSlice',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'begin',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'end',
                'type': 'number[]'
            },
            {
                'start': 3,
                'name': 'strides',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'begin_mask',
                'name': 'beginMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'end_mask',
                'name': 'endMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'new_axis_mask',
                'name': 'newAxisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'ellipsis_mask',
                'name': 'ellipsisMask',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'shrink_axis_mask',
                'name': 'shrinkAxisMask',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Pack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'end': 0,
                'name': 'tensors',
                'type': 'tensors'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Unpack',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'tfName': 'num',
                'name': 'num',
                'type': 'number',
                'defaultValue': 0,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'Tile',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'reps',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Split',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            },
            {
                'start': 1,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_split',
                'name': 'numOrSizeSplits',
                'type': 'number',
                'defaultValue': 1
            }
        ]
    },
    {
        'tfOpName': 'SplitV',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'numOrSizeSplits',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'axis',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'ScatterNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'GatherNd',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseToDense',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'sparseIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'outputShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'sparseValues',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'validate_indices',
                'name': 'validateIndices',
                'type': 'bool',
                'defaultValue': false,
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'TensorScatterUpdate',
        'category': 'slice_join',
        'inputs': [
            {
                'start': 0,
                'name': 'tensor',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'values',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("8qKju", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $6234ad537ccf3fad$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $6234ad537ccf3fad$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'SparseFillEmptyRows',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'values',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'denseShape',
                'type': 'tensor'
            },
            {
                'start': 3,
                'name': 'defaultValue',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseReshape',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'inputIndices',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'inputShape',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'newShape',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'T',
                'name': 'dtype',
                'type': 'dtype',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentMean',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'SparseSegmentSum',
        'category': 'sparse',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'indices',
                'type': 'tensor'
            },
            {
                'start': 2,
                'name': 'segmentIds',
                'type': 'tensor'
            }
        ]
    }
];

});

parcelRegister("8szR8", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $628cc086d08bcda2$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $628cc086d08bcda2$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'FFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'IFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ]
    },
    {
        'tfOpName': 'RFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    },
    {
        'tfOpName': 'IRFFT',
        'category': 'spectral',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'fft_length',
                'type': 'number',
                'notSupported': true
            }
        ]
    }
];

});

parcelRegister("4dgkM", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $31150bf3861cf77b$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $31150bf3861cf77b$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'StaticRegexReplace',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'pattern',
                'name': 'pattern',
                'type': 'string'
            },
            {
                'tfName': 'rewrite',
                'name': 'rewrite',
                'type': 'string'
            },
            {
                'tfName': 'replace_global',
                'name': 'replaceGlobal',
                'type': 'bool'
            }
        ]
    },
    {
        'tfOpName': 'StringNGrams',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'data',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'dataSplits',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'separator',
                'name': 'separator',
                'type': 'string'
            },
            {
                'tfName': 'ngram_widths',
                'name': 'nGramWidths',
                'type': 'number[]'
            },
            {
                'tfName': 'left_pad',
                'name': 'leftPad',
                'type': 'string'
            },
            {
                'tfName': 'right_pad',
                'name': 'rightPad',
                'type': 'string'
            },
            {
                'tfName': 'pad_width',
                'name': 'padWidth',
                'type': 'number'
            },
            {
                'tfName': 'preserve_short_sequences',
                'name': 'preserveShortSequences',
                'type': 'bool'
            }
        ],
        'outputs': [
            'ngrams',
            'ngrams_splits'
        ]
    },
    {
        'tfOpName': 'StringSplit',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'delimiter',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'skip_empty',
                'name': 'skipEmpty',
                'type': 'bool'
            }
        ],
        'outputs': [
            'indices',
            'values',
            'shape'
        ]
    },
    {
        'tfOpName': 'StringToHashBucketFast',
        'category': 'string',
        'inputs': [
            {
                'start': 0,
                'name': 'input',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'num_buckets',
                'name': 'numBuckets',
                'type': 'number'
            }
        ]
    }
];

});

parcelRegister("76upq", function(module, exports) {

$parcel$export(module.exports, "json", function () { return $52c0ae8728f092a3$export$7b419323e6ed4f31; });
/**
 * @license
 * Copyright 2023 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ const $52c0ae8728f092a3$export$7b419323e6ed4f31 = [
    {
        'tfOpName': 'Cast',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'SrcT',
                'name': 'sdtype',
                'type': 'dtype',
                'notSupported': true
            },
            {
                'tfName': 'DstT',
                'name': 'dtype',
                'type': 'dtype'
            }
        ]
    },
    {
        'tfOpName': 'ExpandDims',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'axis',
                'type': 'number'
            }
        ]
    },
    {
        'tfOpName': 'MirrorPad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'mode',
                'name': 'mode',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'Pad',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            }
        ],
        'attrs': [
            {
                'tfName': 'constant_value',
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'PadV2',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'padding',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'constantValue',
                'type': 'number',
                'defaultValue': 0
            }
        ]
    },
    {
        'tfOpName': 'Reshape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'EnsureShape',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'Squeeze',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'axis',
                'tfDeprecatedName': 'squeeze_dims',
                'name': 'axis',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'SpaceToBatchND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'paddings',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'BatchToSpaceND',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'blockShape',
                'type': 'number[]'
            },
            {
                'start': 2,
                'name': 'crops',
                'type': 'number[]'
            }
        ]
    },
    {
        'tfOpName': 'DepthToSpace',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            }
        ],
        'attrs': [
            {
                'tfName': 'block_size',
                'name': 'blockSize',
                'type': 'number'
            },
            {
                'tfName': 'data_format',
                'name': 'dataFormat',
                'type': 'string'
            }
        ]
    },
    {
        'tfOpName': 'BroadcastTo',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 'x',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 'shape',
                'type': 'number[]'
            }
        ],
        'attrs': []
    },
    {
        'tfOpName': 'BroadcastArgs',
        'category': 'transformation',
        'inputs': [
            {
                'start': 0,
                'name': 's0',
                'type': 'tensor'
            },
            {
                'start': 1,
                'name': 's1',
                'type': 'tensor'
            }
        ],
        'attrs': []
    }
];

});


parcelRegister("fXEIJ", function(module, exports) {

$parcel$export(module.exports, "GraphExecutor", function () { return $b9ebf3ee86c94e35$export$289b3892ec35f79a; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $j83KU = parcelRequire("j83KU");

var $3tofP = parcelRequire("3tofP");

var $jTX20 = parcelRequire("jTX20");

var $aPKfH = parcelRequire("aPKfH");
class $b9ebf3ee86c94e35$export$289b3892ec35f79a {
    get weightIds() {
        return this.parent ? this.parent.weightIds : this._weightIds;
    }
    get functionExecutorMap() {
        return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap;
    }
    get weightMap() {
        return this.parent ? this.parent.weightMap : this._weightMap;
    }
    set weightMap(weightMap) {
        const weightIds = Object.keys(weightMap).map((key)=>weightMap[key].map((tensor)=>tensor.id));
        this._weightIds = [].concat(...weightIds);
        this._weightMap = weightMap;
    }
    /**
     * Set `ResourceManager` shared by executors of a model.
     * @param resourceManager: `ResourceManager` of the `GraphModel`.
     */ set resourceManager(resourceManager) {
        this._resourceManager = resourceManager;
    }
    get inputs() {
        return this._inputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get outputs() {
        return this._outputs.map((node)=>{
            return {
                name: node.name,
                shape: node.attrParams['shape'] ? node.attrParams['shape'].value : undefined,
                dtype: node.attrParams['dtype'] ? node.attrParams['dtype'].value : undefined
            };
        });
    }
    get inputNodes() {
        return this._inputs.map((node)=>node.signatureKey || node.name);
    }
    get outputNodes() {
        return this._outputs.map((node)=>{
            const name = node.signatureKey || node.name;
            return node.defaultOutput ? `${name}:${node.defaultOutput}` : name;
        });
    }
    get functions() {
        return Object.keys(this._functions).reduce((map, key)=>{
            map[key] = this._functions[key].signature;
            return map;
        }, {});
    }
    /**
     *
     * @param graph Graph the model or function graph to be executed.
     * @param parent When building function exector you need to set the parent
     * executor. Since the weights and function executor maps are set at parant
     * level, that function executor can access the function maps and weight maps
     * through the parent.
     */ constructor(graph, parent){
        this.graph = graph;
        this.parent = parent;
        this.compiledMap = new Map();
        this.parseNodeNameCache = new Map();
        this._weightMap = {};
        this.SEPARATOR = ',';
        this._functions = {};
        this._functionExecutorMap = {};
        this.keepIntermediateTensors = false;
        this._outputs = graph.outputs;
        this._inputs = graph.inputs;
        this._initNodes = graph.initNodes;
        this._signature = graph.signature;
        this._functions = graph.functions;
        // create sub-graph executors
        if (graph.functions != null) Object.keys(graph.functions).forEach((name)=>{
            this._functionExecutorMap[name] = new $b9ebf3ee86c94e35$export$289b3892ec35f79a(graph.functions[name], this);
        });
    }
    getCompilationKey(inputs, outputs) {
        const sortedInputs = inputs.map((node)=>node.name).sort();
        const sortedOutputs = outputs.map((node)=>node.name).sort();
        return sortedInputs.join(this.SEPARATOR) + '--' + sortedOutputs.join(this.SEPARATOR);
    }
    /**
     * Compiles the inference graph and returns the minimal set of nodes that are
     * required for execution, in the correct execution order.
     * @returns {Object} compilation The compile result.
     * @returns {Node[]} compilation.orderedNodes Nodes in the correct execution
     *     order.
     * @returns {Map<string, Node[]>} compilation.nodeLiveUntilMap A map from node
     *     to disposable nodes after its execution. That is, for a node `x`,
     *     `nodeLiveUntilMap[x]` indicates all nodes whose intermediate
     *     tensors should be disposed after `x` is executed.
     */ compile(inputs, outputs) {
        const executionInfo = (0, $aPKfH.getExecutionSubgraph)(inputs, outputs, this.weightMap, this._initNodes);
        const { missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = executionInfo;
        if (dynamicNode != null) throw new Error(`This execution contains the node '${dynamicNode.name}', which has ` + `the dynamic op '${dynamicNode.op}'. Please use ` + `model.executeAsync() instead. Alternatively, to avoid the ` + `dynamic ops, specify the inputs [${syncInputs}]`);
        if (missingInputs.length > 0) {
            const outNames = outputs.map((n)=>n.name);
            const inNames = Object.keys(inputs);
            throw new Error(`Cannot compute the outputs [${outNames}] from the provided inputs ` + `[${inNames}]. Missing the following inputs: [${missingInputs}]`);
        }
        const orderedNodes = (0, $aPKfH.getNodesInTopologicalOrder)(this.graph, executionInfo);
        const nodeLiveUntilMap = (0, $aPKfH.getNodeLiveUntilMap)(orderedNodes);
        return {
            orderedNodes: orderedNodes,
            nodeLiveUntilMap: nodeLiveUntilMap
        };
    }
    cloneAndKeepTensor(tensor) {
        if (tensor == null) return null;
        const clone = tensor.clone();
        // Keep the clone because`model.execute()` may be called within
        // a `tidy()`, but the user may inspect these tensors after the
        // tidy.
        (0, $d7Nxs.keep)(clone);
        return clone;
    }
    cloneTensorList(tensors) {
        if (!tensors) return null;
        const clonedTensor = tensors.map((tensor)=>{
            return this.cloneAndKeepTensor(tensor);
        });
        return clonedTensor;
    }
    cloneTensorMap(tensorsMap) {
        return Object.fromEntries(Object.entries(tensorsMap).map(([name, tensorsList])=>{
            return [
                name,
                this.cloneTensorList(tensorsList)
            ];
        }));
    }
    /**
     * Executes the inference for given input tensors.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model, if
     * no outputs are specified, the default outputs of the model would be used.
     * You can inspect intermediate nodes of the model by adding them to the
     * outputs array.
     */ execute(inputs, outputs) {
        // Dispose any tensors from a prior run to avoid leaking them.
        this.disposeIntermediateTensors();
        inputs = this.mapInputs(inputs);
        const names = Object.keys(inputs).sort();
        this.checkInputs(inputs);
        this.checkInputShapeAndType(inputs);
        outputs = this.mapOutputs(outputs);
        this.checkOutputs(outputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $j83KU.parseNodeName)(name)[0]]);
        const outputNodeNames = outputs.map((name)=>(0, $j83KU.parseNodeName)(name)[0]);
        const outputNodeNameSet = new Set(outputNodeNames);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const compilationKey = this.getCompilationKey(inputNodes, outputNodes);
        // Do nothing if the compiled graph cache contains the input.
        let compilation = this.compiledMap.get(compilationKey);
        if (compilation == null) {
            compilation = this.compile(inputs, outputNodes);
            this.compiledMap.set(compilationKey, compilation);
        }
        // Keep tensors if KEEP_INTERMEDIATE_TENSORS is on.
        try {
            this.keepIntermediateTensors = (0, $tdutJ.env)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            this.keepIntermediateTensors = false;
            console.warn(e.message);
        }
        const tensorArrayMap = {};
        const tensorListMap = {};
        return (0, $d7Nxs.tidy)(()=>{
            const context = new (0, $jTX20.ExecutionContext)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap, this.parseNodeNameCache);
            const tensorsMap = Object.assign({}, this.weightMap);
            if (this.keepIntermediateTensors) this.clonedTensorsMap = this.cloneTensorMap(this.weightMap);
            Object.keys(inputs).forEach((name)=>{
                const [nodeName, index] = (0, $j83KU.parseNodeName)(name, context);
                const tensors = [];
                tensors[index] = inputs[name];
                tensorsMap[nodeName] = tensors;
                if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(tensors);
            });
            const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
            const { orderedNodes: orderedNodes, nodeLiveUntilMap: nodeLiveUntilMap } = compilation;
            for (const node of orderedNodes){
                if (tensorsMap[node.name]) continue;
                const tensors = (0, $3tofP.executeOp)(node, tensorsMap, context, this._resourceManager);
                if ((0, $lBDHD).isPromise(tensors)) throw new Error(`The execution of the op '${node.op}' returned a promise. ` + `Please use model.executeAsync() instead.`);
                tensorsMap[node.name] = tensors;
                if (this.keepIntermediateTensors) this.clonedTensorsMap[node.name] = this.cloneTensorList(tensors);
                this.checkTensorForDisposalWithNodeLiveUntilInfo(node, tensorsMap, context, tensorsToKeep, outputNodeNameSet, nodeLiveUntilMap.get(node.name));
            }
            // dispose the context for the root executor
            if (this.parent == null) context.dispose(tensorsToKeep);
            return outputs.map((name)=>(0, $j83KU.getTensor)(name, tensorsMap, context));
        });
    }
    getFrozenTensorIds(tensorMap) {
        const ids = [].concat.apply([], Object.keys(tensorMap).map((key)=>tensorMap[key]).map((tensors)=>tensors.map((tensor)=>tensor.id)));
        return new Set(ids);
    }
    checkTensorForDisposal(nodeName, node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount) {
        // Skip output nodes and any control flow nodes, since its dependency is
        // tricky to track correctly.
        if ((0, $aPKfH.isControlFlow)(node) || outputNodeNameSet.has(nodeName)) return;
        for (const tensor of tensorMap[nodeName]){
            if (tensor == null) continue;
            intermediateTensorConsumerCount[tensor.id] = (intermediateTensorConsumerCount[tensor.id] || 0) + node.children.length;
        }
        for (const input of node.inputs){
            // Skip any control flow nodes, since its dependency is tricky to track
            // correctly.
            if ((0, $aPKfH.isControlFlow)(input)) continue;
            const tensors = (0, $j83KU.getTensorsForCurrentContext)(input.name, tensorMap, context);
            if (tensors == null) continue;
            for (const tensor of tensors){
                if (!tensor || tensor.kept || tensorsToKeep.has(tensor.id)) continue;
                // Only intermediate nodes' tensors have counts set, not marked as
                // kept, and not in `tensorsToKeep`.
                // Input and weight nodes' tensors should exist in `tensorsToKeep`.
                // Output and control flow nodes' tensors should never have count set.
                const count = intermediateTensorConsumerCount[tensor.id];
                if (count === 1) {
                    tensor.dispose();
                    delete intermediateTensorConsumerCount[tensor.id];
                } else if (count != null) intermediateTensorConsumerCount[tensor.id]--;
            }
        }
    }
    checkTensorForDisposalWithNodeLiveUntilInfo(node, tensorMap, context, tensorsToKeep, outputNodeNameSet, liveUntilNodes) {
        function isNonDisposableNode(node) {
            // Skip output nodes and any control flow nodes, since its dependency is
            // tricky to track correctly.
            return (0, $aPKfH.isControlFlow)(node) || outputNodeNameSet.has(node.name);
        }
        if ((0, $aPKfH.isControlFlow)(node) || liveUntilNodes == null) return;
        for (const nodeToDispose of liveUntilNodes){
            if (isNonDisposableNode(nodeToDispose)) continue;
            const tensors = (0, $j83KU.getTensorsForCurrentContext)(nodeToDispose.name, tensorMap, context);
            for (const tensor of tensors){
                if (!tensor || tensor.kept || tensorsToKeep.has(tensor.id)) continue;
                tensor.dispose();
            }
        }
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs output node name from the Tensorflow model, if no outputs
     * are specified, the default outputs of the model would be used. You can
     * inspect intermediate nodes of the model by adding them to the outputs
     * array.
     */ async executeAsync(inputs, outputs) {
        return this._executeAsync(inputs, outputs);
    }
    disposeIntermediateTensors() {
        if (!this.clonedTensorsMap) return;
        Object.values(this.clonedTensorsMap).forEach((tensorsList)=>{
            for (const tensor of tensorsList)if (tensor && !tensor.isDisposed) tensor.dispose();
        });
        this.clonedTensorsMap = null;
    }
    getIntermediateTensors() {
        return this.clonedTensorsMap;
    }
    /**
     * Executes the inference for given input tensors in Async fashion.
     * @param inputs Tensor map for the model inputs, keyed by the input node
     * names.
     * @param outputs Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to
     * the outputs array.
     * @param isFunctionExecution Optional. Flag for executing a function.
     * @param tensorArrayMap Optional, global TensorArray map by id. Used for
     * function execution.
     * @param tensorArrayMap Optional global TensorList map by id. Used for
     * function execution.
     */ async _executeAsync(inputs, outputs, isFunctionExecution = false, tensorArrayMap = {}, tensorListMap = {}) {
        // Dispose any tensors from a prior run to avoid leaking them.
        this.disposeIntermediateTensors();
        if (!isFunctionExecution) {
            inputs = this.mapInputs(inputs);
            this.checkInputs(inputs);
            this.checkInputShapeAndType(inputs);
            outputs = this.mapOutputs(outputs);
            this.checkOutputs(outputs);
        }
        // Keep tensors if KEEP_INTERMEDIATE_TENSORS is on.
        try {
            this.keepIntermediateTensors = (0, $tdutJ.env)().getBool('KEEP_INTERMEDIATE_TENSORS');
        } catch (e) {
            this.keepIntermediateTensors = false;
            console.warn(e.message);
        }
        const context = new (0, $jTX20.ExecutionContext)(this.weightMap, tensorArrayMap, tensorListMap, this.functionExecutorMap, this.parseNodeNameCache);
        if (this.keepIntermediateTensors) this.clonedTensorsMap = this.cloneTensorMap(this.weightMap);
        // Graph with control flow op requires runtime evaluation of the execution
        // order, while without control flow the execution order is pre-determined
        // in the compile method.
        const tensorsMap = await this.executeWithControlFlow(inputs, context, outputs, isFunctionExecution);
        const results = outputs.map((name)=>(0, $j83KU.getTensor)(name, tensorsMap, context));
        // dispose all the intermediate tensors
        const outputIds = results.map((t)=>t.id);
        const inputIds = Object.keys(inputs).map((name)=>inputs[name].id);
        const keepIds = new Set([
            ...outputIds,
            ...inputIds,
            ...this.weightIds
        ]);
        Object.values(tensorsMap).forEach((tensorsList)=>{
            tensorsList.forEach((tensor)=>{
                if (tensor && !tensor.isDisposed && !keepIds.has(tensor.id)) tensor.dispose();
            });
        });
        // dispose the context for the root executor
        if (this.parent == null) context.dispose(keepIds);
        return results;
    }
    async executeFunctionAsync(inputs, tensorArrayMap, tensorListMap) {
        const mappedInputs = inputs.reduce((map, tensor, index)=>{
            map[this.inputs[index].name] = tensor;
            return map;
        }, {});
        return this._executeAsync(mappedInputs, this.outputNodes, true, tensorArrayMap, tensorListMap);
    }
    /**
     * When there are control flow nodes in the graph, the graph execution use
     * ExecutionContext to keep track of the frames and loop iterators.
     * @param inputs placeholder tensors for the graph.
     * @param context the execution context object for current execution.
     * @param outputNames Optional. output node name from the Tensorflow model,
     * if no outputs are specified, the default outputs of the model would be
     * used. You can inspect intermediate nodes of the model by adding them to
     * the outputs array.
     * @param isFunctionExecution Flag for executing a function.
     */ async executeWithControlFlow(inputs, context, outputNames, isFunctionExecution) {
        const names = Object.keys(inputs);
        const inputNodes = names.map((name)=>this.graph.nodes[(0, $j83KU.parseNodeName)(name)[0]]);
        const outputNodeNames = outputNames.map((name)=>(0, $j83KU.parseNodeName)(name)[0]);
        const outputNodeNameSet = new Set(outputNodeNames);
        let outputNodes = outputNodeNames.map((name)=>this.graph.nodes[name]);
        // If no outputs are specified, then use the default outputs of the model.
        if (outputNodes.length === 0) outputNodes = this._outputs;
        const { usedNodes: usedNodes, missingInputs: missingInputs, dynamicNode: dynamicNode, syncInputs: syncInputs } = (0, $aPKfH.getExecutionSubgraph)(inputs, outputNodes, this.weightMap, this._initNodes);
        // First nodes to execute include inputNodes, weights, and initNodes.
        const stack = [
            ...inputNodes,
            ...this.graph.weights,
            ...this._initNodes || []
        ].map((node)=>{
            return {
                node: node,
                contexts: context.currentContext
            };
        });
        const tensorsMap = Object.assign({}, this.weightMap);
        Object.keys(inputs).forEach((name)=>{
            const [nodeName, index] = (0, $j83KU.parseNodeName)(name);
            const tensors = [];
            tensors[index] = inputs[name];
            tensorsMap[nodeName] = tensors;
        });
        const intermediateTensorConsumerCount = {};
        const tensorsToKeep = this.getFrozenTensorIds(tensorsMap);
        const added = {};
        while(stack.length > 0){
            const promises = this.processStack(inputNodes, stack, context, tensorsMap, added, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount, usedNodes);
            await Promise.all(promises);
        }
        if (dynamicNode == null && !isFunctionExecution) console.warn(`This model execution did not contain any nodes with control flow ` + `or dynamic output shapes. You can use model.execute() instead.`);
        const missingOutputs = outputNodes.filter((node)=>!(0, $aPKfH.isControlFlow)(node) && !(0, $j83KU.getTensor)(node.name, tensorsMap, context)).map((node)=>node.name);
        if (missingOutputs.length > 0) {
            let alternativeMsg = '';
            if (dynamicNode != null) alternativeMsg = `Alternatively, to avoid the dynamic ops, use model.execute() ` + `and specify the inputs [${syncInputs}]`;
            throw new Error(`Cannot compute the outputs [${missingOutputs}] from the provided ` + `inputs [${names}]. Consider providing the following inputs: ` + `[${missingInputs}]. ${alternativeMsg}`);
        }
        return tensorsMap;
    }
    processStack(inputNodes, stack, context, tensorMap, added, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount, usedNodes) {
        const promises = [];
        while(stack.length > 0){
            const item = stack.pop();
            context.currentContext = item.contexts;
            let nodeName = '';
            // The tensor of the Enter op with isConstant set should be set
            // in the parent scope, so it will be available as constant for the
            // whole loop.
            if (item.node.op === 'Enter' && (0, $j83KU.getParamValue)('isConstant', item.node, tensorMap, context)) [nodeName] = (0, $j83KU.getNodeNameAndIndex)(item.node.name, context);
            // only process nodes that are not in the tensorMap yet, this include
            // inputNodes and internal initNodes.
            if (tensorMap[item.node.name] == null) {
                const tensors = (0, $3tofP.executeOp)(item.node, tensorMap, context, this._resourceManager);
                if (!nodeName) [nodeName] = (0, $j83KU.getNodeNameAndIndex)(item.node.name, context);
                const currentContext = context.currentContext;
                if ((0, $lBDHD).isPromise(tensors)) promises.push(tensors.then((t)=>{
                    tensorMap[nodeName] = t;
                    if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(t);
                    context.currentContext = currentContext;
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                    return t;
                }));
                else {
                    tensorMap[nodeName] = tensors;
                    if (this.keepIntermediateTensors) this.clonedTensorsMap[nodeName] = this.cloneTensorList(tensors);
                    this.checkTensorForDisposal(nodeName, item.node, tensorMap, context, tensorsToKeep, outputNodeNameSet, intermediateTensorConsumerCount);
                    this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
                }
            } else this.processChildNodes(item.node, stack, context, tensorMap, added, usedNodes);
        }
        return promises;
    }
    processChildNodes(node, stack, context, tensorMap, added, usedNodes) {
        node.children.forEach((childNode)=>{
            const [nodeName] = (0, $j83KU.getNodeNameAndIndex)(childNode.name, context);
            if (added[nodeName] || !usedNodes.has(childNode.name)) return;
            // Merge op can be pushed if any of its inputs has value.
            if (childNode.op === 'Merge') {
                if (childNode.inputNames.some((name)=>{
                    return !!(0, $j83KU.getTensor)(name, tensorMap, context);
                })) {
                    added[nodeName] = true;
                    stack.push({
                        contexts: context.currentContext,
                        node: childNode
                    });
                }
            } else if (childNode.inputNames.every((name)=>{
                return !!(0, $j83KU.getTensor)(name, tensorMap, context);
            })) {
                added[nodeName] = true;
                stack.push({
                    contexts: context.currentContext,
                    node: childNode
                });
            }
        });
    }
    /**
     * Releases the memory used by the weight tensors.
     */ dispose() {
        Object.keys(this.weightMap).forEach((key)=>this.weightMap[key].forEach((tensor)=>tensor.dispose()));
    }
    checkInputShapeAndType(inputs) {
        Object.keys(inputs).forEach((name)=>{
            const input = inputs[name];
            const [nodeName] = (0, $j83KU.parseNodeName)(name);
            const node = this.graph.nodes[nodeName];
            if (node.attrParams['shape'] && node.attrParams['shape'].value) {
                const shape = node.attrParams['shape'].value;
                const match = shape.length === input.shape.length && input.shape.every((dim, index)=>shape[index] === -1 || shape[index] === dim);
                (0, $lBDHD).assert(match, ()=>`The shape of dict['${node.name}'] provided in ` + `model.execute(dict) must be [${shape}], but was ` + `[${input.shape}]`);
            }
            if (node.attrParams['dtype'] && node.attrParams['dtype'].value) (0, $lBDHD).assert(input.dtype === node.attrParams['dtype'].value, ()=>`The dtype of dict['${node.name}'] provided in ` + `model.execute(dict) must be ` + `${node.attrParams['dtype'].value}, but was ${input.dtype}`);
        });
    }
    mapInputs(inputs) {
        var _a, _b;
        const result = {};
        for(const inputName in inputs){
            const tensor = (_b = (_a = this._signature) === null || _a === void 0 ? void 0 : _a.inputs) === null || _b === void 0 ? void 0 : _b[inputName];
            if (tensor != null) result[tensor.name] = inputs[inputName];
            else result[inputName] = inputs[inputName];
        }
        return result;
    }
    checkInputs(inputs) {
        const notInGraph = Object.keys(inputs).filter((name)=>{
            const [nodeName] = (0, $j83KU.parseNodeName)(name);
            return this.graph.nodes[nodeName] == null;
        });
        if (notInGraph.length > 0) throw new Error(`The dict provided in model.execute(dict) has ` + `keys: [${notInGraph}] that are not part of graph`);
    }
    mapOutputs(outputs) {
        return outputs.map((name)=>{
            var _a, _b;
            const tensor = (_b = (_a = this._signature) === null || _a === void 0 ? void 0 : _a.outputs) === null || _b === void 0 ? void 0 : _b[name];
            if (tensor != null) return tensor.name;
            return name;
        }, {});
    }
    checkOutputs(outputs) {
        outputs.forEach((name)=>{
            const [normalizedName] = (0, $j83KU.parseNodeName)(name);
            if (!this.graph.nodes[normalizedName]) throw new Error(`The output '${name}' is not found in the graph`);
        });
    }
}

});
parcelRegister("3tofP", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $2876e4eb77daec0c$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $idBkh = parcelRequire("idBkh");

var $2Z8vl = parcelRequire("2Z8vl");

var $k9TKJ = parcelRequire("k9TKJ");

var $bPKqf = parcelRequire("bPKqf");

var $fKau1 = parcelRequire("fKau1");

var $f688J = parcelRequire("f688J");

var $33tFY = parcelRequire("33tFY");

var $9W3wp = parcelRequire("9W3wp");

var $4YC1x = parcelRequire("4YC1x");

var $c8uSv = parcelRequire("c8uSv");

var $5JtV9 = parcelRequire("5JtV9");

var $cHVFh = parcelRequire("cHVFh");

var $3siIF = parcelRequire("3siIF");

var $1Rr3m = parcelRequire("1Rr3m");

var $87Rsn = parcelRequire("87Rsn");

var $fsRTE = parcelRequire("fsRTE");

var $fSsyC = parcelRequire("fSsyC");

var $hPj17 = parcelRequire("hPj17");

var $aCJr4 = parcelRequire("aCJr4");

var $vUjVP = parcelRequire("vUjVP");

var $1t2LQ = parcelRequire("1t2LQ");

var $fAvr0 = parcelRequire("fAvr0");
function $2876e4eb77daec0c$export$7be88578e558e499(node, tensorMap, context, resourceManager, tidy = $d7Nxs.tidy) {
    const value = ((node, tensorMap, context)=>{
        switch(node.category){
            case 'arithmetic':
                return tidy(()=>$k9TKJ.executeOp(node, tensorMap, context));
            case 'basic_math':
                return tidy(()=>$bPKqf.executeOp(node, tensorMap, context));
            case 'control':
                return $fKau1.executeOp(node, tensorMap, context);
            case 'convolution':
                return tidy(()=>$f688J.executeOp(node, tensorMap, context));
            case 'creation':
                return tidy(()=>$33tFY.executeOp(node, tensorMap, context));
            case 'dynamic':
                return $9W3wp.executeOp(node, tensorMap, context);
            case 'evaluation':
                return tidy(()=>$4YC1x.executeOp(node, tensorMap, context));
            case 'image':
                return tidy(()=>$cHVFh.executeOp(node, tensorMap, context));
            case 'graph':
                return tidy(()=>$c8uSv.executeOp(node, tensorMap, context));
            case 'logical':
                return tidy(()=>$3siIF.executeOp(node, tensorMap, context));
            case 'matrices':
                return tidy(()=>$1Rr3m.executeOp(node, tensorMap, context));
            case 'normalization':
                return tidy(()=>$87Rsn.executeOp(node, tensorMap, context));
            case 'ragged':
                return tidy(()=>$fsRTE.executeOp(node, tensorMap, context));
            case 'reduction':
                return tidy(()=>$fSsyC.executeOp(node, tensorMap, context));
            case 'slice_join':
                return tidy(()=>$hPj17.executeOp(node, tensorMap, context));
            case 'sparse':
                return tidy(()=>$aCJr4.executeOp(node, tensorMap, context));
            case 'spectral':
                return tidy(()=>$vUjVP.executeOp(node, tensorMap, context));
            case 'string':
                return tidy(()=>$1t2LQ.executeOp(node, tensorMap, context));
            case 'transformation':
                return tidy(()=>$fAvr0.executeOp(node, tensorMap, context));
            case 'hash_table':
                return $5JtV9.executeOp(node, tensorMap, context, resourceManager);
            case 'custom':
                const opMapper = (0, $2Z8vl.getRegisteredOp)(node.op);
                if (opMapper && opMapper.customExecutor) return opMapper.customExecutor(new (0, $idBkh.NodeValueImpl)(node, tensorMap, context));
                else throw TypeError(`Custom op ${node.op} is not registered.`);
            default:
                throw TypeError(`Unknown op '${node.op}'. File an issue at ` + `https://github.com/tensorflow/tfjs/issues so we can add it` + `, or register a custom execution with tf.registerOp()`);
        }
    })(node, tensorMap, context);
    if ($lBDHD.isPromise(value)) return value.then((data)=>[].concat(data));
    return [].concat(value);
}

});
parcelRegister("idBkh", function(module, exports) {

$parcel$export(module.exports, "NodeValueImpl", function () { return $d436651814b9c844$export$2964c493e854c8ad; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $j83KU = parcelRequire("j83KU");

var $5cY9q = parcelRequire("5cY9q");
class $d436651814b9c844$export$2964c493e854c8ad {
    constructor(node, tensorMap, context){
        this.node = node;
        this.tensorMap = tensorMap;
        this.context = context;
        this.inputs = [];
        this.attrs = {};
        this.inputs = node.inputNames.map((name)=>this.getInput(name));
        if (node.rawAttrs != null) this.attrs = Object.keys(node.rawAttrs).reduce((attrs, key)=>{
            attrs[key] = this.getAttr(key);
            return attrs;
        }, {});
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getInput(name) {
        return (0, $j83KU.getTensor)(name, this.tensorMap, this.context);
    }
    /**
     * Return the value of the attribute or input param.
     * @param name String: name of attribute or input param.
     */ getAttr(name, defaultValue) {
        const value = this.node.rawAttrs[name];
        if (value.tensor != null) return (0, $j83KU.getTensor)(name, this.tensorMap, this.context);
        if (value.i != null || value.f != null) return (0, $5cY9q.getNumberParam)(this.node.rawAttrs, name, defaultValue);
        if (value.s != null) return (0, $5cY9q.getStringParam)(this.node.rawAttrs, name, defaultValue);
        if (value.b != null) return (0, $5cY9q.getBoolParam)(this.node.rawAttrs, name, defaultValue);
        if (value.shape != null) return (0, $5cY9q.getTensorShapeParam)(this.node.rawAttrs, name, defaultValue);
        if (value.type != null) return (0, $5cY9q.getDtypeParam)(this.node.rawAttrs, name, defaultValue);
        if (value.list != null) {
            if (value.list.i != null || value.list.f != null) return (0, $5cY9q.getNumericArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.s != null) return (0, $5cY9q.getStringArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.shape != null) return (0, $5cY9q.getTensorShapeArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.b != null) return (0, $5cY9q.getBoolArrayParam)(this.node.rawAttrs, name, defaultValue);
            if (value.list.type != null) return (0, $5cY9q.getDtypeArrayParam)(this.node.rawAttrs, name, defaultValue);
        }
        return defaultValue;
    }
}

});

parcelRegister("k9TKJ", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $eacfe53abf898ec1$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $eacfe53abf898ec1$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'BiasAdd':
        case 'AddV2':
        case 'Add':
            return [
                ops.add((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'AddN':
            return [
                ops.addN((0, $j83KU.getParamValue)('tensors', node, tensorMap, context))
            ];
        case 'FloorMod':
        case 'Mod':
            return [
                ops.mod((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Mul':
            return [
                ops.mul((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'RealDiv':
        case 'Div':
            return [
                ops.div((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'DivNoNan':
            return [
                ops.divNoNan((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'FloorDiv':
            return [
                ops.floorDiv((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Sub':
            return [
                ops.sub((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Minimum':
            return [
                ops.minimum((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Maximum':
            return [
                ops.maximum((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Pow':
            return [
                ops.pow((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'SquaredDifference':
            return [
                ops.squaredDifference((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $eacfe53abf898ec1$export$2c04807512a22510 = 'arithmetic';

});
parcelRegister("5PA95", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This file exports ops used by the converters executors. By default it
 * re-exports all ops. In a custom build this is aliased to a file that will
 * only exports ops for a given model.json.
 */ 
var $4I5dI = parcelRequire("4I5dI");
$parcel$exportWildcard(module.exports, $4I5dI);

});


parcelRegister("bPKqf", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $89d877a3c570626a$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $89d877a3c570626a$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'Abs':
        case 'ComplexAbs':
            return [
                ops.abs((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Acos':
            return [
                ops.acos((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Acosh':
            return [
                ops.acosh((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Asin':
            return [
                ops.asin((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Asinh':
            return [
                ops.asinh((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Atan':
            return [
                ops.atan((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Atan2':
            return [
                ops.atan2((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('y', node, tensorMap, context))
            ];
        case 'Atanh':
            return [
                ops.atanh((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Ceil':
            return [
                ops.ceil((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Complex':
            return [
                ops.complex((0, $j83KU.getParamValue)('real', node, tensorMap, context), (0, $j83KU.getParamValue)('imag', node, tensorMap, context))
            ];
        case 'Cos':
            return [
                ops.cos((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Cosh':
            return [
                ops.cosh((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Elu':
            return [
                ops.elu((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Erf':
            return [
                ops.erf((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Exp':
            return [
                ops.exp((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Expm1':
            return [
                ops.expm1((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Floor':
            return [
                ops.floor((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Log':
            return [
                ops.log((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Log1p':
            return [
                ops.log1p((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Imag':
            return [
                ops.imag((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Neg':
            return [
                ops.neg((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Reciprocal':
            return [
                ops.reciprocal((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Real':
            return [
                ops.real((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Relu':
            return [
                ops.relu((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Round':
            return [
                ops.round((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Selu':
            return [
                ops.selu((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sigmoid':
            return [
                ops.sigmoid((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sin':
            return [
                ops.sin((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sign':
            return [
                ops.sign((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sinh':
            return [
                ops.sinh((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Softplus':
            return [
                ops.softplus((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Sqrt':
            return [
                ops.sqrt((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Square':
            return [
                ops.square((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Tanh':
            return [
                ops.tanh((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Tan':
            return [
                ops.tan((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'ClipByValue':
            return [
                ops.clipByValue((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('clipValueMin', node, tensorMap, context), (0, $j83KU.getParamValue)('clipValueMax', node, tensorMap, context))
            ];
        case 'Relu6':
            return [
                ops.relu6((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'Rsqrt':
            return [
                ops.rsqrt((0, $j83KU.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        case 'LeakyRelu':
            return [
                ops.leakyRelu((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('alpha', node, tensorMap, context))
            ];
        case 'Prelu':
            return [
                ops.prelu((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('alpha', node, tensorMap, context))
            ];
        case 'IsNan':
            return [
                ops.isNaN((0, $j83KU.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        case 'IsInf':
            return [
                ops.isInf((0, $j83KU.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        case 'IsFinite':
            return [
                ops.isFinite((0, $j83KU.getTensor)(node.inputNames[0], tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $89d877a3c570626a$export$2c04807512a22510 = 'basic_math';

});

parcelRegister("fKau1", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $b76348a428010b79$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $7hONX = parcelRequire("7hONX");

var $6fkeu = parcelRequire("6fkeu");

var $dcKEI = parcelRequire("dcKEI");

var $j83KU = parcelRequire("j83KU");
const $b76348a428010b79$export$7be88578e558e499 = async (node, tensorMap, context)=>{
    switch(node.op){
        case 'If':
        case 'StatelessIf':
            {
                const thenFunc = (0, $j83KU.getParamValue)('thenBranch', node, tensorMap, context);
                const elseFunc = (0, $j83KU.getParamValue)('elseBranch', node, tensorMap, context);
                const cond = (0, $j83KU.getParamValue)('cond', node, tensorMap, context);
                const args = (0, $j83KU.getParamValue)('args', node, tensorMap, context);
                const condValue = await cond.data();
                if (condValue[0]) return context.functionMap[thenFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                else return context.functionMap[elseFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
            }
        case 'While':
        case 'StatelessWhile':
            {
                const bodyFunc = (0, $j83KU.getParamValue)('body', node, tensorMap, context);
                const condFunc = (0, $j83KU.getParamValue)('cond', node, tensorMap, context);
                const args = (0, $j83KU.getParamValue)('args', node, tensorMap, context);
                // Calculate the condition of the loop
                const condResult = await context.functionMap[condFunc].executeFunctionAsync(args, context.tensorArrayMap, context.tensorListMap);
                const argIds = args.map((tensor)=>tensor.id);
                let condValue = await condResult[0].data();
                // Dispose the intermediate tensors for condition function
                condResult.forEach((tensor)=>{
                    if (!tensor.kept && argIds.indexOf(tensor.id) === -1) tensor.dispose();
                });
                let result = args;
                while(condValue[0]){
                    // Record the previous result for intermediate tensor tracking
                    const origResult = result;
                    // Execution the body of the loop
                    result = await context.functionMap[bodyFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    const resultIds = result.map((tensor)=>tensor.id);
                    // Dispose the intermediate tensor for body function that is not global
                    // kept, not input/output of the body function
                    origResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                    // Recalcuate the condition of the loop using the latest results.
                    const condResult = await context.functionMap[condFunc].executeFunctionAsync(result, context.tensorArrayMap, context.tensorListMap);
                    condValue = await condResult[0].data();
                    // Dispose the intermediate tensors for condition function
                    condResult.forEach((tensor)=>{
                        if (!tensor.kept && argIds.indexOf(tensor.id) === -1 && resultIds.indexOf(tensor.id) === -1) tensor.dispose();
                    });
                }
                return result;
            }
        case 'LoopCond':
            {
                const pred = (0, $j83KU.getParamValue)('pred', node, tensorMap, context);
                return [
                    (0, $j83KU.cloneTensor)(pred)
                ];
            }
        case 'Switch':
            {
                const pred = (0, $j83KU.getParamValue)('pred', node, tensorMap, context);
                let data = (0, $j83KU.getParamValue)('data', node, tensorMap, context);
                if (!data.kept) data = (0, $j83KU.cloneTensor)(data);
                // Outputs nodes :0 => false, :1 => true
                return (await pred.data())[0] ? [
                    undefined,
                    data
                ] : [
                    data,
                    undefined
                ];
            }
        case 'Merge':
            {
                const inputName = node.inputNames.find((name)=>(0, $j83KU.getTensor)(name, tensorMap, context) !== undefined);
                if (inputName) {
                    const data = (0, $j83KU.getTensor)(inputName, tensorMap, context);
                    return [
                        (0, $j83KU.cloneTensor)(data)
                    ];
                }
                return undefined;
            }
        case 'Enter':
            {
                const frameId = (0, $j83KU.getParamValue)('frameName', node, tensorMap, context);
                const data = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                context.enterFrame(frameId);
                return [
                    (0, $j83KU.cloneTensor)(data)
                ];
            }
        case 'Exit':
            {
                const data = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                context.exitFrame();
                return [
                    (0, $j83KU.cloneTensor)(data)
                ];
            }
        case 'NextIteration':
            {
                const data = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                context.nextIteration();
                return [
                    (0, $j83KU.cloneTensor)(data)
                ];
            }
        case 'TensorArrayV3':
            {
                const size = (0, $j83KU.getParamValue)('size', node, tensorMap, context);
                const dtype = (0, $j83KU.getParamValue)('dtype', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const dynamicSize = (0, $j83KU.getParamValue)('dynamicSize', node, tensorMap, context);
                const clearAfterRead = (0, $j83KU.getParamValue)('clearAfterRead', node, tensorMap, context);
                const identicalElementShapes = (0, $j83KU.getParamValue)('identicalElementShapes', node, tensorMap, context);
                const name = (0, $j83KU.getParamValue)('name', node, tensorMap, context);
                const tensorArray = new (0, $6fkeu.TensorArray)(name, dtype, size, elementShape, identicalElementShapes, dynamicSize, clearAfterRead);
                context.addTensorArray(tensorArray);
                return [
                    tensorArray.idTensor,
                    (0, $7hONX.scalar)(1.0)
                ];
            }
        case 'TensorArrayWriteV3':
            {
                const id = (0, $j83KU.getParamValue)('tensorArrayId', node, tensorMap, context);
                const index = (0, $j83KU.getParamValue)('index', node, tensorMap, context);
                const writeTensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                const writeTensorArray = context.getTensorArray(id.id);
                writeTensorArray.write(index, writeTensor);
                return [
                    writeTensorArray.idTensor
                ];
            }
        case 'TensorArrayReadV3':
            {
                const readId = (0, $j83KU.getParamValue)('tensorArrayId', node, tensorMap, context);
                const readIndex = (0, $j83KU.getParamValue)('index', node, tensorMap, context);
                const readTensorArray = context.getTensorArray(readId.id);
                return [
                    readTensorArray.read(readIndex)
                ];
            }
        case 'TensorArrayGatherV3':
            {
                const gatherId = (0, $j83KU.getParamValue)('tensorArrayId', node, tensorMap, context);
                const gatherIndices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                const gatherDtype = (0, $j83KU.getParamValue)('dtype', node, tensorMap, context);
                const gatherTensorArray = context.getTensorArray(gatherId.id);
                return [
                    gatherTensorArray.gather(gatherIndices, gatherDtype)
                ];
            }
        case 'TensorArrayScatterV3':
            {
                const scatterId = (0, $j83KU.getParamValue)('tensorArrayId', node, tensorMap, context);
                const scatterIndices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                const scatterTensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                const scatterTensorArray = context.getTensorArray(scatterId.id);
                scatterTensorArray.scatter(scatterIndices, scatterTensor);
                return [
                    scatterTensorArray.idTensor
                ];
            }
        case 'TensorArrayConcatV3':
            {
                const concatId = (0, $j83KU.getParamValue)('tensorArrayId', node, tensorMap, context);
                const concatTensorArray = context.getTensorArray(concatId.id);
                const concatDtype = (0, $j83KU.getParamValue)('dtype', node, tensorMap, context);
                return [
                    concatTensorArray.concat(concatDtype)
                ];
            }
        case 'TensorArraySplitV3':
            {
                const splitId = (0, $j83KU.getParamValue)('tensorArrayId', node, tensorMap, context);
                const splitTensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                const lengths = (0, $j83KU.getParamValue)('lengths', node, tensorMap, context);
                const splitTensorArray = context.getTensorArray(splitId.id);
                splitTensorArray.split(lengths, splitTensor);
                return [
                    splitTensorArray.idTensor
                ];
            }
        case 'TensorArraySizeV3':
            {
                const sizeId = (0, $j83KU.getParamValue)('tensorArrayId', node, tensorMap, context);
                const sizeTensorArray = context.getTensorArray(sizeId.id);
                return [
                    (0, $7hONX.scalar)(sizeTensorArray.size(), 'int32')
                ];
            }
        case 'TensorArrayCloseV3':
            {
                const closeId = (0, $j83KU.getParamValue)('tensorArrayId', node, tensorMap, context);
                const closeTensorArray = context.getTensorArray(closeId.id);
                closeTensorArray.clearAndClose();
                return [
                    closeTensorArray.idTensor
                ];
            }
        case 'TensorListSetItem':
            {
                const idTensor = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const index = (0, $j83KU.getParamValue)('index', node, tensorMap, context);
                const writeTensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.setItem(index, writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGetItem':
            {
                const idTensor = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const readIndex = (0, $j83KU.getParamValue)('index', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const elementDType = (0, $j83KU.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.getItem(readIndex, elementShape, elementDType)
                ];
            }
        case 'TensorListScatterV2':
        case 'TensorListScatter':
            {
                const scatterIndices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                const scatterTensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const numElements = (0, $j83KU.getParamValue)('numElements', node, tensorMap, context);
                const tensorList = (0, $dcKEI.scatter)(scatterTensor, scatterIndices, elementShape, numElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListReserve':
        case 'EmptyTensorList':
            {
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $j83KU.getParamValue)('elementDType', node, tensorMap, context);
                let numElementsParam;
                if (node.op === 'TensorListReserve') numElementsParam = 'numElements';
                else numElementsParam = 'maxNumElements';
                const numElements = (0, $j83KU.getParamValue)(numElementsParam, node, tensorMap, context);
                const maxNumElements = node.op === 'TensorListReserve' ? -1 : numElements;
                const tensorList = (0, $dcKEI.reserve)(elementShape, elementDtype, numElements, maxNumElements);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListGather':
            {
                const gatherId = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const gatherIndices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $j83KU.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(gatherId.id);
                return [
                    tensorList.gather(gatherIndices, elementDtype, elementShape)
                ];
            }
        case 'TensorListStack':
            {
                const idTensor = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $j83KU.getParamValue)('elementDType', node, tensorMap, context);
                const numElements = (0, $j83KU.getParamValue)('numElements', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.stack(elementShape, elementDtype, numElements)
                ];
            }
        case 'TensorListFromTensor':
            {
                const tensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const elementDtype = (0, $j83KU.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = (0, $dcKEI.fromTensor)(tensor, elementShape, elementDtype);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListConcat':
        case 'TensorListConcatV2':
            {
                const concatId = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(concatId.id);
                const concatDtype = (0, $j83KU.getParamValue)('dtype', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                return [
                    tensorList.concat(concatDtype, elementShape)
                ];
            }
        case 'TensorListPushBack':
            {
                const idTensor = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const writeTensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                tensorList.pushBack(writeTensor);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListPopBack':
            {
                const idTensor = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const elementDType = (0, $j83KU.getParamValue)('elementDType', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    tensorList.popBack(elementShape, elementDType)
                ];
            }
        case 'TensorListSplit':
            {
                const splitTensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                const elementShape = (0, $j83KU.getParamValue)('elementShape', node, tensorMap, context);
                const lengths = (0, $j83KU.getParamValue)('lengths', node, tensorMap, context);
                const tensorList = (0, $dcKEI.split)(splitTensor, lengths, elementShape);
                context.addTensorList(tensorList);
                return [
                    tensorList.idTensor
                ];
            }
        case 'TensorListLength':
            {
                const idTensor = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const tensorList = context.getTensorList(idTensor.id);
                return [
                    (0, $7hONX.scalar)(tensorList.size(), 'int32')
                ];
            }
        case 'TensorListResize':
            {
                const idTensor = (0, $j83KU.getParamValue)('tensorListId', node, tensorMap, context);
                const size = (0, $j83KU.getParamValue)('size', node, tensorMap, context);
                const srcTensorList = context.getTensorList(idTensor.id);
                const destTensorList = srcTensorList.resize(size);
                context.addTensorList(destTensorList);
                return [
                    destTensorList.idTensor
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $b76348a428010b79$export$2c04807512a22510 = 'control';

});
parcelRegister("6fkeu", function(module, exports) {

$parcel$export(module.exports, "TensorArray", function () { return $48c3d696364e8988$export$854ca114072d2abc; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $1goxr = parcelRequire("1goxr");
var $d7Nxs = parcelRequire("d7Nxs");
var $8nMOl = parcelRequire("8nMOl");
var $7hONX = parcelRequire("7hONX");
var $l7afw = parcelRequire("l7afw");
var $lq9U1 = parcelRequire("lq9U1");
var $eZfvk = parcelRequire("eZfvk");
var $3mzDh = parcelRequire("3mzDh");

var $bZsdk = parcelRequire("bZsdk");
class $48c3d696364e8988$export$854ca114072d2abc {
    constructor(name, dtype, maxSize, elementShape, identicalElementShapes, dynamicSize, clearAfterRead){
        this.name = name;
        this.dtype = dtype;
        this.maxSize = maxSize;
        this.elementShape = elementShape;
        this.identicalElementShapes = identicalElementShapes;
        this.dynamicSize = dynamicSize;
        this.clearAfterRead = clearAfterRead;
        this.tensors = [];
        this.closed_ = false;
        this.idTensor = (0, $7hONX.scalar)(0);
        (0, $d7Nxs.keep)(this.idTensor);
    }
    get id() {
        return this.idTensor.id;
    }
    get closed() {
        return this.closed_;
    }
    /**
     * Dispose the tensors and idTensor and mark the TensoryArray as closed.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.tensor.id)) tensor.tensor.dispose();
        });
        this.tensors = [];
        this.closed_ = true;
        this.idTensor.dispose();
    }
    size() {
        return this.tensors.length;
    }
    /**
     * Read the value at location index in the TensorArray.
     * @param index Number the index to read from.
     */ read(index) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || index >= this.size()) throw new Error(`Tried to read from index ${index}, but array size is: ${this.size()}`);
        const tensorWithState = this.tensors[index];
        if (tensorWithState.cleared) throw new Error(`TensorArray ${this.name}: Could not read index ${index} twice because it was cleared after a previous read ` + `(perhaps try setting clear_after_read = false?).`);
        if (this.clearAfterRead) tensorWithState.cleared = true;
        tensorWithState.read = true;
        return tensorWithState.tensor;
    }
    /**
     * Helper method to read multiple tensors from the specified indices.
     */ readMany(indices) {
        return indices.map((index)=>this.read(index));
    }
    /**
     * Write value into the index of the TensorArray.
     * @param index number the index to write to.
     * @param tensor
     */ write(index, tensor) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (index < 0 || !this.dynamicSize && index >= this.maxSize) throw new Error(`Tried to write to index ${index}, but array is not resizeable and size is: ${this.maxSize}`);
        const t = this.tensors[index] || {};
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index},
          because the value dtype is ${tensor.dtype}, but TensorArray dtype is ${this.dtype}.`);
        // Set the shape for the first time write to unknow shape tensor array
        if (this.size() === 0 && (this.elementShape == null || this.elementShape.length === 0)) this.elementShape = tensor.shape;
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensor.shape, `TensorArray ${this.name}: Could not write to TensorArray index ${index}.`);
        if (t.read) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been read.`);
        if (t.written) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${index}, because it has already been written.`);
        t.tensor = tensor;
        (0, $d7Nxs.keep)(tensor);
        t.written = true;
        this.tensors[index] = t;
    }
    /**
     * Helper method to write multiple tensors to the specified indices.
     */ writeMany(indices, tensors) {
        if (indices.length !== tensors.length) throw new Error(`TensorArray ${this.name}: could not write multiple tensors,` + `because the index size: ${indices.length} is not the same as tensors size: ${tensors.length}.`);
        indices.forEach((i, index)=>this.write(i, tensors[index]));
    }
    /**
     * Return selected values in the TensorArray as a packed Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param [indices] number[] Optional. Taking values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size(). If not specified returns
     *    all tensors in the original order.
     * @param [dtype]
     */ gather(indices, dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but gather requested dtype ${dtype}`);
        if (!indices) {
            indices = [];
            for(let i = 0; i < this.size(); i++)indices.push(i);
        } else indices = indices.slice(0, this.size());
        if (indices.length === 0) return (0, $eZfvk.tensor)([], [
            0
        ].concat(this.elementShape));
        // Read all the PersistentTensors into a vector to keep track of
        // their memory.
        const tensors = this.readMany(indices);
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensors[0].shape, 'TensorArray shape mismatch: ');
        return (0, $lq9U1.stack)(tensors, 0);
    }
    /**
     * Return the values in the TensorArray as a concatenated Tensor.
     */ concat(dtype) {
        if (!!dtype && dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but concat requested dtype ${dtype}`);
        if (this.size() === 0) return (0, $eZfvk.tensor)([], [
            0
        ].concat(this.elementShape));
        const indices = [];
        for(let i = 0; i < this.size(); i++)indices.push(i);
        // Collect all the tensors from the tensors array.
        const tensors = this.readMany(indices);
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensors[0].shape, `TensorArray shape mismatch: tensor array shape (${this.elementShape}) vs first tensor shape (${tensors[0].shape})`);
        return (0, $1goxr.concat)(tensors, 0);
    }
    /**
     * Scatter the values of a Tensor in specific indices of a TensorArray.
     * @param indices number[] values in [0, max_value). If the
     *    TensorArray is not dynamic, max_value=size().
     * @param tensor Tensor input tensor.
     */ scatter(indices, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
        const maxIndex = Math.max(...indices);
        if (!this.dynamicSize && maxIndex >= this.maxSize) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${this.maxSize})`);
        this.writeMany(indices, (0, $3mzDh.unstack)(tensor, 0));
    }
    /**
     * Split the values of a Tensor into the TensorArray.
     * @param length number[] with the lengths to use when splitting value along
     *    its first dimension.
     * @param tensor Tensor, the tensor to split.
     */ split(length, tensor) {
        if (tensor.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${tensor.dtype}`);
        let totalLength = 0;
        const cumulativeLengths = length.map((len)=>{
            totalLength += len;
            return totalLength;
        });
        if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
        if (!this.dynamicSize && length.length !== this.maxSize) throw new Error(`TensorArray's size is not equal to the size of lengths (${this.maxSize} vs. ${length.length}), ` + 'and the TensorArray is not marked as dynamically resizeable');
        const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
        const tensors = [];
        (0, $d7Nxs.tidy)(()=>{
            tensor = (0, $8nMOl.reshape)(tensor, [
                1,
                totalLength,
                elementPerRow
            ]);
            for(let i = 0; i < length.length; ++i){
                const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
                const indices = [
                    0,
                    previousLength,
                    0
                ];
                const sizes = [
                    1,
                    length[i],
                    elementPerRow
                ];
                tensors[i] = (0, $8nMOl.reshape)((0, $l7afw.slice)(tensor, indices, sizes), this.elementShape);
            }
            return tensors;
        });
        const indices = [];
        for(let i = 0; i < length.length; i++)indices[i] = i;
        this.writeMany(indices, tensors);
    }
}

});
parcelRegister("bZsdk", function(module, exports) {

$parcel$export(module.exports, "assertShapesMatchAllowUndefinedSize", function () { return $8bab46e922ad6a6e$export$c20af1b3c2621826; });
$parcel$export(module.exports, "inferElementShape", function () { return $8bab46e922ad6a6e$export$48aa6d00714ed79b; });
$parcel$export(module.exports, "mergeElementShape", function () { return $8bab46e922ad6a6e$export$455cf61aa434d74b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * This differs from util.assertShapesMatch in that it allows values of
 * negative one, an undefined size of a dimensinon, in a shape to match
 * anything.
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $8bab46e922ad6a6e$export$c20af1b3c2621826(shapeA, shapeB, errorMessagePrefix = '') {
    // constant shape means unknown rank
    if (typeof shapeA === 'number' || typeof shapeB === 'number') return;
    (0, $lBDHD).assert(shapeA.length === shapeB.length, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    for(let i = 0; i < shapeA.length; i++){
        const dim0 = shapeA[i];
        const dim1 = shapeB[i];
        (0, $lBDHD).assert(dim0 < 0 || dim1 < 0 || dim0 === dim1, ()=>errorMessagePrefix + ` Shapes ${shapeA} and ${shapeB} must match`);
    }
}
function $8bab46e922ad6a6e$export$caa10238f73d8dc2(elementShape) {
    if (typeof elementShape === 'number' || elementShape.some((dim)=>dim < 0)) return false;
    return true;
}
function $8bab46e922ad6a6e$export$48aa6d00714ed79b(listElementShape, tensors, elementShape) {
    let partialShape = $8bab46e922ad6a6e$export$455cf61aa434d74b(listElementShape, elementShape);
    const notfullDefinedShape = !$8bab46e922ad6a6e$export$caa10238f73d8dc2(partialShape);
    if (notfullDefinedShape && tensors.length === 0) throw new Error(`Tried to calculate elements of an empty list` + ` with non-fully-defined elementShape: ${partialShape}`);
    if (notfullDefinedShape) tensors.forEach((tensor)=>{
        partialShape = $8bab46e922ad6a6e$export$455cf61aa434d74b(tensor.shape, partialShape);
    });
    if (!$8bab46e922ad6a6e$export$caa10238f73d8dc2(partialShape)) throw new Error(`Non-fully-defined elementShape: ${partialShape}`);
    return partialShape;
}
function $8bab46e922ad6a6e$export$455cf61aa434d74b(elementShapeA, elementShapeB) {
    if (typeof elementShapeA === 'number') return elementShapeB;
    if (typeof elementShapeB === 'number') return elementShapeA;
    if (elementShapeA.length !== elementShapeB.length) throw new Error(`Incompatible ranks during merge: ${elementShapeA} vs. ${elementShapeB}`);
    const result = [];
    for(let i = 0; i < elementShapeA.length; ++i){
        const dim0 = elementShapeA[i];
        const dim1 = elementShapeB[i];
        if (dim0 >= 0 && dim1 >= 0 && dim0 !== dim1) throw new Error(`Incompatible shape during merge: ${elementShapeA} vs. ${elementShapeB}`);
        result[i] = dim0 >= 0 ? dim0 : dim1;
    }
    return result;
}

});


parcelRegister("dcKEI", function(module, exports) {

$parcel$export(module.exports, "fromTensor", function () { return $99d0962e0f679cc0$export$1bc9ee297bacb6e5; });
$parcel$export(module.exports, "reserve", function () { return $99d0962e0f679cc0$export$12d6b2bf497a6811; });
$parcel$export(module.exports, "scatter", function () { return $99d0962e0f679cc0$export$c97954fff4307550; });
$parcel$export(module.exports, "split", function () { return $99d0962e0f679cc0$export$65980d18b75784e2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $1goxr = parcelRequire("1goxr");
var $d7Nxs = parcelRequire("d7Nxs");
var $8nMOl = parcelRequire("8nMOl");
var $7hONX = parcelRequire("7hONX");
var $l7afw = parcelRequire("l7afw");
var $lq9U1 = parcelRequire("lq9U1");
var $eZfvk = parcelRequire("eZfvk");
var $3mzDh = parcelRequire("3mzDh");

var $bZsdk = parcelRequire("bZsdk");
class $99d0962e0f679cc0$export$97d48a41015c8fa8 {
    get id() {
        return this.idTensor.id;
    }
    /**
     *
     * @param tensors list of tensors
     * @param elementShape shape of each tensor, this can be a single number (any
     * shape is allowed) or partial shape (dim = -1).
     * @param elementDtype data type of each tensor
     * @param maxNumElements The maximum allowed size of `tensors`. Defaults to -1
     *   meaning that the size of `tensors` is unbounded.
     */ constructor(tensors, elementShape, elementDtype, maxNumElements = -1){
        this.tensors = tensors;
        this.elementShape = elementShape;
        this.elementDtype = elementDtype;
        if (tensors != null) tensors.forEach((tensor)=>{
            if (elementDtype !== tensor.dtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${tensor.dtype}`);
            (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(elementShape, tensor.shape, 'TensorList shape mismatch: ');
            (0, $d7Nxs.keep)(tensor);
        });
        this.idTensor = (0, $7hONX.scalar)(0);
        this.maxNumElements = maxNumElements;
        (0, $d7Nxs.keep)(this.idTensor);
    }
    /**
     * Get a new TensorList containing a copy of the underlying tensor container.
     */ copy() {
        return new $99d0962e0f679cc0$export$97d48a41015c8fa8([
            ...this.tensors
        ], this.elementShape, this.elementDtype);
    }
    /**
     * Dispose the tensors and idTensor and clear the tensor list.
     */ clearAndClose(keepIds) {
        this.tensors.forEach((tensor)=>{
            if (keepIds == null || !keepIds.has(tensor.id)) tensor.dispose();
        });
        this.tensors.length = 0;
        this.idTensor.dispose();
    }
    /**
     * The size of the tensors in the tensor list.
     */ size() {
        return this.tensors.length;
    }
    /**
     * Return a tensor that stacks a list of rank-R tf.Tensors into one rank-(R+1)
     * tf.Tensor.
     * @param elementShape shape of each tensor
     * @param elementDtype data type of each tensor
     * @param numElements the number of elements to stack
     */ stack(elementShape, elementDtype, numElements = -1) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (numElements !== -1 && this.tensors.length !== numElements) throw new Error(`Operation expected a list with ${numElements} elements but got a list with ${this.tensors.length} elements.`);
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(elementShape, this.elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $bZsdk.inferElementShape)(this.elementShape, this.tensors, elementShape);
        return (0, $d7Nxs.tidy)(()=>{
            const reshapedTensors = this.tensors.map((tensor)=>(0, $8nMOl.reshape)(tensor, outputElementShape));
            return (0, $lq9U1.stack)(reshapedTensors, 0);
        });
    }
    /**
     * Pop a tensor from the end of the list.
     * @param elementShape shape of the tensor
     * @param elementDtype data type of the tensor
     */ popBack(elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (this.size() === 0) throw new Error('Trying to pop from an empty list.');
        const outputElementShape = (0, $bZsdk.inferElementShape)(this.elementShape, this.tensors, elementShape);
        const tensor = this.tensors.pop();
        tensor.kept = false;
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(tensor.shape, elementShape, 'TensorList shape mismatch: ');
        return (0, $8nMOl.reshape)(tensor, outputElementShape);
    }
    /**
     * Push a tensor to the end of the list.
     * @param tensor Tensor to be pushed.
     */ pushBack(tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(tensor.shape, this.elementShape, 'TensorList shape mismatch: ');
        if (this.maxNumElements === this.size()) throw new Error(`Trying to push element into a full list.`);
        (0, $d7Nxs.keep)(tensor);
        this.tensors.push(tensor);
    }
    /**
     * Update the size of the list.
     * @param size the new size of the list.
     */ resize(size) {
        if (size < 0) throw new Error(`TensorListResize expects size to be non-negative. Got: ${size}`);
        if (this.maxNumElements !== -1 && size > this.maxNumElements) throw new Error(`TensorListResize input size ${size} is greater maxNumElement ${this.maxNumElements}.`);
        const destTensorList = new $99d0962e0f679cc0$export$97d48a41015c8fa8([], this.elementShape, this.elementDtype, this.maxNumElements);
        destTensorList.tensors.length = size;
        for(let i = 0; i < Math.min(this.tensors.length, size); ++i)destTensorList.tensors[i] = this.tensors[i];
        return destTensorList;
    }
    /**
     * Retrieve the element at the provided index
     * @param elementShape shape of the tensor
     * @param elementDtype dtype of the tensor
     * @param elementIndex index of the tensor
     */ getItem(elementIndex, elementShape, elementDtype) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || elementIndex > this.tensors.length) throw new Error(`Trying to access element ${elementIndex} in a list with ${this.tensors.length} elements.`);
        if (this.tensors[elementIndex] == null) throw new Error(`element at index ${elementIndex} is null.`);
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(this.tensors[elementIndex].shape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $bZsdk.inferElementShape)(this.elementShape, this.tensors, elementShape);
        return (0, $8nMOl.reshape)(this.tensors[elementIndex], outputElementShape);
    }
    /**
     * Set the tensor at the index
     * @param elementIndex index of the tensor
     * @param tensor the tensor to be inserted into the list
     */ setItem(elementIndex, tensor) {
        if (tensor.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${this.elementDtype}`);
        if (elementIndex < 0 || this.maxNumElements !== -1 && elementIndex >= this.maxNumElements) throw new Error(`Trying to set element ${elementIndex} in a list with max ${this.maxNumElements} elements.`);
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(this.elementShape, tensor.shape, 'TensorList shape mismatch: ');
        (0, $d7Nxs.keep)(tensor);
        // dispose the previous value if it is replacing.
        if (this.tensors[elementIndex] != null) this.tensors[elementIndex].kept = false;
        this.tensors[elementIndex] = tensor;
    }
    /**
     * Return selected values in the TensorList as a stacked Tensor. All of
     * selected values must have been written and their shapes must all match.
     * @param indices indices of tensors to gather
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ gather(indices, elementDtype, elementShape) {
        if (elementDtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${elementDtype}, but list elements ${this.elementDtype}`);
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        // When indices is greater than the size of the list, indices beyond the
        // size of the list are ignored.
        indices = indices.slice(0, this.size());
        const outputElementShape = (0, $bZsdk.inferElementShape)(this.elementShape, this.tensors, elementShape);
        if (indices.length === 0) return (0, $eZfvk.tensor)([], [
            0
        ].concat(outputElementShape));
        return (0, $d7Nxs.tidy)(()=>{
            const tensors = indices.map((i)=>(0, $8nMOl.reshape)(this.tensors[i], outputElementShape));
            return (0, $lq9U1.stack)(tensors, 0);
        });
    }
    /**
     * Return the values in the TensorList as a concatenated Tensor.
     * @param elementDtype output tensor dtype
     * @param elementShape output tensor element shape
     */ concat(elementDtype, elementShape) {
        if (!!elementDtype && elementDtype !== this.elementDtype) throw new Error(`TensorList dtype is ${this.elementDtype} but concat requested dtype ${elementDtype}`);
        (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(this.elementShape, elementShape, 'TensorList shape mismatch: ');
        const outputElementShape = (0, $bZsdk.inferElementShape)(this.elementShape, this.tensors, elementShape);
        if (this.size() === 0) return (0, $eZfvk.tensor)([], [
            0
        ].concat(outputElementShape));
        return (0, $d7Nxs.tidy)(()=>{
            const tensors = this.tensors.map((t)=>(0, $8nMOl.reshape)(t, outputElementShape));
            return (0, $1goxr.concat)(tensors, 0);
        });
    }
}
function $99d0962e0f679cc0$export$1bc9ee297bacb6e5(tensor, elementShape, elementDtype) {
    const dtype = tensor.dtype;
    if (tensor.shape.length < 1) throw new Error(`Tensor must be at least a vector, but saw shape: ${tensor.shape}`);
    if (tensor.dtype !== elementDtype) throw new Error(`Invalid data types; op elements ${tensor.dtype}, but list elements ${elementDtype}`);
    const tensorElementShape = tensor.shape.slice(1);
    (0, $bZsdk.assertShapesMatchAllowUndefinedSize)(tensorElementShape, elementShape, 'TensorList shape mismatch: ');
    const tensorList = (0, $3mzDh.unstack)(tensor);
    return new $99d0962e0f679cc0$export$97d48a41015c8fa8(tensorList, elementShape, dtype);
}
function $99d0962e0f679cc0$export$12d6b2bf497a6811(elementShape, elementDtype, numElements, maxNumElements) {
    return new $99d0962e0f679cc0$export$97d48a41015c8fa8([], elementShape, elementDtype, maxNumElements);
}
function $99d0962e0f679cc0$export$c97954fff4307550(tensor, indices, elementShape, numElements) {
    if (indices.length !== tensor.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${indices.length} vs. ${tensor.shape[0]}`);
    const maxIndex = Math.max(...indices);
    if (numElements != null && numElements !== -1 && maxIndex >= numElements) throw new Error(`Max index must be < array size (${maxIndex}  vs. ${numElements})`);
    const list = new $99d0962e0f679cc0$export$97d48a41015c8fa8([], elementShape, tensor.dtype, numElements);
    const tensors = (0, $3mzDh.unstack)(tensor, 0);
    indices.forEach((value, index)=>{
        list.setItem(value, tensors[index]);
    });
    return list;
}
function $99d0962e0f679cc0$export$65980d18b75784e2(tensor, length, elementShape) {
    let totalLength = 0;
    const cumulativeLengths = length.map((len)=>{
        totalLength += len;
        return totalLength;
    });
    if (totalLength !== tensor.shape[0]) throw new Error(`Expected sum of lengths to be equal to
          tensor.shape[0], but sum of lengths is
        ${totalLength}, and tensor's shape is: ${tensor.shape}`);
    const shapeWithoutFirstDim = tensor.shape.slice(1);
    const outputElementShape = (0, $bZsdk.mergeElementShape)(shapeWithoutFirstDim, elementShape);
    const elementPerRow = totalLength === 0 ? 0 : tensor.size / totalLength;
    const tensors = (0, $d7Nxs.tidy)(()=>{
        const tensors = [];
        tensor = (0, $8nMOl.reshape)(tensor, [
            1,
            totalLength,
            elementPerRow
        ]);
        for(let i = 0; i < length.length; ++i){
            const previousLength = i === 0 ? 0 : cumulativeLengths[i - 1];
            const indices = [
                0,
                previousLength,
                0
            ];
            const sizes = [
                1,
                length[i],
                elementPerRow
            ];
            tensors[i] = (0, $8nMOl.reshape)((0, $l7afw.slice)(tensor, indices, sizes), outputElementShape);
        }
        tensor.dispose();
        return tensors;
    });
    const list = new $99d0962e0f679cc0$export$97d48a41015c8fa8([], elementShape, tensor.dtype, length.length);
    for(let i = 0; i < tensors.length; i++)list.setItem(i, tensors[i]);
    return list;
}

});


parcelRegister("f688J", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $afddbaef884b3b33$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
function $afddbaef884b3b33$var$fusedConvAndDepthWiseParams(node, tensorMap, context) {
    const [extraOp, activationFunc] = (0, $j83KU.getParamValue)('fusedOps', node, tensorMap, context);
    const isBiasAdd = extraOp === 'biasadd';
    const noBiasAdd = !isBiasAdd;
    const isPrelu = activationFunc === 'prelu';
    const isBatchNorm = extraOp === 'fusedbatchnorm';
    const numArgs = (0, $j83KU.getParamValue)('numArgs', node, tensorMap, context);
    if (isBiasAdd) {
        if (isPrelu && numArgs !== 2) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
        if (!isPrelu && isBiasAdd && numArgs !== 1) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd must have one extra argument: bias.");
    }
    if (isBatchNorm) throw new Error('FusedConv2d and DepthwiseConv2d with FusedBatchNorm is not supported');
    const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
    const pad = (0, $j83KU.getPadding)(node, tensorMap, context);
    const dataFormat = (0, $j83KU.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
    const dilations = (0, $j83KU.getParamValue)('dilations', node, tensorMap, context);
    let [biasArg, preluArg] = (0, $j83KU.getParamValue)('args', node, tensorMap, context);
    if (noBiasAdd) {
        preluArg = biasArg;
        biasArg = undefined;
    }
    const leakyreluAlpha = (0, $j83KU.getParamValue)('leakyreluAlpha', node, tensorMap, context);
    return {
        stride: stride,
        pad: pad,
        dataFormat: dataFormat,
        dilations: dilations,
        biasArg: biasArg,
        preluArg: preluArg,
        activationFunc: activationFunc,
        leakyreluAlpha: leakyreluAlpha
    };
}
const $afddbaef884b3b33$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'Conv1D':
            {
                const stride = (0, $j83KU.getParamValue)('stride', node, tensorMap, context);
                const pad = (0, $j83KU.getParamValue)('pad', node, tensorMap, context);
                const dataFormat = (0, $j83KU.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilation = (0, $j83KU.getParamValue)('dilation', node, tensorMap, context);
                return [
                    ops.conv1d((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('filter', node, tensorMap, context), stride, pad, dataFormat, dilation)
                ];
            }
        case 'Conv2D':
            {
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getPadding)(node, tensorMap, context);
                const dataFormat = (0, $j83KU.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $j83KU.getParamValue)('dilations', node, tensorMap, context);
                return [
                    ops.conv2d((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case '_FusedConv2D':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $afddbaef884b3b33$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.conv2d({
                        x: (0, $j83KU.getParamValue)('x', node, tensorMap, context),
                        filter: (0, $j83KU.getParamValue)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'FusedDepthwiseConv2dNative':
            {
                const { stride: stride, pad: pad, dataFormat: dataFormat, dilations: dilations, biasArg: biasArg, preluArg: preluArg, activationFunc: activationFunc, leakyreluAlpha: leakyreluAlpha } = $afddbaef884b3b33$var$fusedConvAndDepthWiseParams(node, tensorMap, context);
                return [
                    ops.fused.depthwiseConv2d({
                        x: (0, $j83KU.getParamValue)('x', node, tensorMap, context),
                        filter: (0, $j83KU.getParamValue)('filter', node, tensorMap, context),
                        strides: [
                            stride[1],
                            stride[2]
                        ],
                        pad: pad,
                        dataFormat: dataFormat,
                        dilations: [
                            dilations[1],
                            dilations[2]
                        ],
                        bias: biasArg,
                        activation: activationFunc,
                        preluActivationWeights: preluArg,
                        leakyreluAlpha: leakyreluAlpha
                    })
                ];
            }
        case 'Conv2DBackpropInput':
        case 'Conv2dTranspose':
            {
                const shape = (0, $j83KU.getParamValue)('outputShape', node, tensorMap, context);
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getPadding)(node, tensorMap, context);
                return [
                    ops.conv2dTranspose((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('filter', node, tensorMap, context), shape, [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'DepthwiseConv2dNative':
        case 'DepthwiseConv2d':
            {
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getPadding)(node, tensorMap, context);
                const dilations = (0, $j83KU.getParamValue)('dilations', node, tensorMap, context);
                const dataFormat = (0, $j83KU.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthwiseConv2d((0, $j83KU.getParamValue)('input', node, tensorMap, context), (0, $j83KU.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2]
                    ])
                ];
            }
        case 'Conv3D':
            {
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getParamValue)('pad', node, tensorMap, context);
                const dataFormat = (0, $j83KU.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                const dilations = (0, $j83KU.getParamValue)('dilations', node, tensorMap, context);
                return [
                    ops.conv3d((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('filter', node, tensorMap, context), [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad, dataFormat, [
                        dilations[1],
                        dilations[2],
                        dilations[3]
                    ])
                ];
            }
        case 'AvgPool':
            {
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $j83KU.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool((0, $j83KU.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPool':
            {
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $j83KU.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool((0, $j83KU.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2]
                    ], [
                        stride[1],
                        stride[2]
                    ], pad)
                ];
            }
        case 'MaxPoolWithArgmax':
            {
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $j83KU.getParamValue)('kernelSize', node, tensorMap, context);
                const includeBatchInIndex = (0, $j83KU.getParamValue)('includeBatchInIndex', node, tensorMap, context);
                const { result: result, indexes: indexes } = ops.maxPoolWithArgmax((0, $j83KU.getParamValue)('x', node, tensorMap, context), [
                    kernelSize[1],
                    kernelSize[2]
                ], [
                    stride[1],
                    stride[2]
                ], pad, includeBatchInIndex);
                return [
                    result,
                    indexes
                ];
            }
        case 'AvgPool3D':
            {
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $j83KU.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.avgPool3d((0, $j83KU.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'MaxPool3D':
            {
                const stride = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getParamValue)('pad', node, tensorMap, context);
                const kernelSize = (0, $j83KU.getParamValue)('kernelSize', node, tensorMap, context);
                return [
                    ops.maxPool3d((0, $j83KU.getParamValue)('x', node, tensorMap, context), [
                        kernelSize[1],
                        kernelSize[2],
                        kernelSize[3]
                    ], [
                        stride[1],
                        stride[2],
                        stride[3]
                    ], pad)
                ];
            }
        case 'Dilation2D':
            {
                const strides = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const pad = (0, $j83KU.getParamValue)('pad', node, tensorMap, context);
                const dilations = (0, $j83KU.getParamValue)('dilations', node, tensorMap, context);
                // strides: [1, stride_height, stride_width, 1].
                const strideHeight = strides[1];
                const strideWidth = strides[2];
                // dilations: [1, dilation_height, dilation_width, 1].
                const dilationHeight = dilations[1];
                const dilationWidth = dilations[2];
                return [
                    ops.dilation2d((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('filter', node, tensorMap, context), [
                        strideHeight,
                        strideWidth
                    ], pad, [
                        dilationHeight,
                        dilationWidth
                    ], 'NHWC' /* dataFormat */ )
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $afddbaef884b3b33$export$2c04807512a22510 = 'convolution';

});

parcelRegister("33tFY", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $2398abf23a6716a3$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $2398abf23a6716a3$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'Fill':
            {
                const shape = (0, $j83KU.getParamValue)('shape', node, tensorMap, context);
                const dtype = (0, $j83KU.getParamValue)('dtype', node, tensorMap, context);
                const value = (0, $j83KU.getParamValue)('value', node, tensorMap, context);
                return [
                    ops.fill(shape, value, dtype)
                ];
            }
        case 'LinSpace':
            {
                const start = (0, $j83KU.getParamValue)('start', node, tensorMap, context);
                const stop = (0, $j83KU.getParamValue)('stop', node, tensorMap, context);
                const num = (0, $j83KU.getParamValue)('num', node, tensorMap, context);
                return [
                    ops.linspace(start, stop, num)
                ];
            }
        case 'Multinomial':
            {
                const logits = (0, $j83KU.getParamValue)('logits', node, tensorMap, context);
                const numSamples = (0, $j83KU.getParamValue)('numSamples', node, tensorMap, context);
                const seed = (0, $j83KU.getParamValue)('seed', node, tensorMap, context);
                return [
                    ops.multinomial(logits, numSamples, seed)
                ];
            }
        case 'OneHot':
            {
                const indices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                const depth = (0, $j83KU.getParamValue)('depth', node, tensorMap, context);
                const onValue = (0, $j83KU.getParamValue)('onValue', node, tensorMap, context);
                const offValue = (0, $j83KU.getParamValue)('offValue', node, tensorMap, context);
                const dtype = (0, $j83KU.getParamValue)('dtype', node, tensorMap, context);
                return [
                    ops.oneHot(indices, depth, onValue, offValue, dtype)
                ];
            }
        case 'Ones':
            return [
                ops.ones((0, $j83KU.getParamValue)('shape', node, tensorMap, context), (0, $j83KU.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'OnesLike':
            return [
                ops.onesLike((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'RandomStandardNormal':
            return [
                ops.randomStandardNormal((0, $j83KU.getParamValue)('shape', node, tensorMap, context), (0, $j83KU.getParamValue)('dtype', node, tensorMap, context), (0, $j83KU.getParamValue)('seed', node, tensorMap, context))
            ];
        case 'RandomUniform':
            return [
                ops.randomUniform(// tslint:disable-next-line:no-any
                (0, $j83KU.getParamValue)('shape', node, tensorMap, context), (0, $j83KU.getParamValue)('minval', node, tensorMap, context), (0, $j83KU.getParamValue)('maxval', node, tensorMap, context), (0, $j83KU.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'RandomUniformInt':
            return [
                ops.randomUniformInt((0, $j83KU.getParamValue)('shape', node, tensorMap, context), (0, $j83KU.getParamValue)('minval', node, tensorMap, context), (0, $j83KU.getParamValue)('maxval', node, tensorMap, context), (0, $j83KU.getParamValue)('seed', node, tensorMap, context))
            ];
        case 'Range':
            {
                const start = (0, $j83KU.getParamValue)('start', node, tensorMap, context);
                const stop = (0, $j83KU.getParamValue)('stop', node, tensorMap, context);
                const step = (0, $j83KU.getParamValue)('step', node, tensorMap, context);
                return [
                    ops.range(start, stop, step, (0, $j83KU.getParamValue)('dtype', node, tensorMap, context))
                ];
            }
        case 'TruncatedNormal':
            {
                const shape = (0, $j83KU.getParamValue)('shape', node, tensorMap, context);
                const mean = (0, $j83KU.getParamValue)('mean', node, tensorMap, context);
                const stdDev = (0, $j83KU.getParamValue)('stdDev', node, tensorMap, context);
                const seed = (0, $j83KU.getParamValue)('seed', node, tensorMap, context);
                return [
                    ops.truncatedNormal(shape, mean, stdDev, (0, $j83KU.getParamValue)('dtype', node, tensorMap, context), seed)
                ];
            }
        case 'Zeros':
            return [
                ops.zeros((0, $j83KU.getParamValue)('shape', node, tensorMap, context), (0, $j83KU.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'ZerosLike':
            return [
                ops.zerosLike((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $2398abf23a6716a3$export$2c04807512a22510 = 'creation';

});

parcelRegister("9W3wp", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $73bc43273fd72854$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
function $73bc43273fd72854$var$nmsParams(node, tensorMap, context) {
    const boxes = (0, $j83KU.getParamValue)('boxes', node, tensorMap, context);
    const scores = (0, $j83KU.getParamValue)('scores', node, tensorMap, context);
    const maxOutputSize = (0, $j83KU.getParamValue)('maxOutputSize', node, tensorMap, context);
    const iouThreshold = (0, $j83KU.getParamValue)('iouThreshold', node, tensorMap, context);
    const scoreThreshold = (0, $j83KU.getParamValue)('scoreThreshold', node, tensorMap, context);
    const softNmsSigma = (0, $j83KU.getParamValue)('softNmsSigma', node, tensorMap, context);
    return {
        boxes: boxes,
        scores: scores,
        maxOutputSize: maxOutputSize,
        iouThreshold: iouThreshold,
        scoreThreshold: scoreThreshold,
        softNmsSigma: softNmsSigma
    };
}
const $73bc43273fd72854$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager, ops = $5PA95)=>{
    switch(node.op){
        case 'NonMaxSuppressionV5':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = $73bc43273fd72854$var$nmsParams(node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionWithScoreAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, softNmsSigma);
                return [
                    result.selectedIndices,
                    result.selectedScores
                ];
            }
        case 'NonMaxSuppressionV4':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $73bc43273fd72854$var$nmsParams(node, tensorMap, context);
                const padToMaxOutputSize = (0, $j83KU.getParamValue)('padToMaxOutputSize', node, tensorMap, context);
                const result = await ops.image.nonMaxSuppressionPaddedAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
                return [
                    result.selectedIndices,
                    result.validOutputs
                ];
            }
        case 'NonMaxSuppressionV3':
        case 'NonMaxSuppressionV2':
            {
                const { boxes: boxes, scores: scores, maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = $73bc43273fd72854$var$nmsParams(node, tensorMap, context);
                return [
                    await ops.image.nonMaxSuppressionAsync(boxes, scores, maxOutputSize, iouThreshold, scoreThreshold)
                ];
            }
        case 'Where':
            {
                const condition = ops.cast((0, $j83KU.getParamValue)('condition', node, tensorMap, context), 'bool');
                const result = [
                    await ops.whereAsync(condition)
                ];
                condition.dispose();
                return result;
            }
        case 'ListDiff':
            return ops.setdiff1dAsync((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('y', node, tensorMap, context));
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $73bc43273fd72854$export$2c04807512a22510 = 'dynamic';

});

parcelRegister("4YC1x", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $39fa42c7ea75bb2c$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $39fa42c7ea75bb2c$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'LowerBound':
            {
                const sortedSequence = (0, $j83KU.getParamValue)('sortedSequence', node, tensorMap, context);
                const values = (0, $j83KU.getParamValue)('values', node, tensorMap, context);
                return [
                    ops.lowerBound(sortedSequence, values)
                ];
            }
        case 'TopKV2':
            {
                const x = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                const k = (0, $j83KU.getParamValue)('k', node, tensorMap, context);
                const sorted = (0, $j83KU.getParamValue)('sorted', node, tensorMap, context);
                const result = ops.topk(x, k, sorted);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UpperBound':
            {
                const sortedSequence = (0, $j83KU.getParamValue)('sortedSequence', node, tensorMap, context);
                const values = (0, $j83KU.getParamValue)('values', node, tensorMap, context);
                return [
                    ops.upperBound(sortedSequence, values)
                ];
            }
        case 'Unique':
            {
                const x = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                const result = ops.unique(x);
                return [
                    result.values,
                    result.indices
                ];
            }
        case 'UniqueV2':
            {
                const x = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const result = ops.unique(x, axis);
                return [
                    result.values,
                    result.indices
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $39fa42c7ea75bb2c$export$2c04807512a22510 = 'evaluation';

});

parcelRegister("c8uSv", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $8d5e2f2965b26028$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $8d5e2f2965b26028$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'Const':
            return tensorMap[node.name];
        case 'PlaceholderWithDefault':
            const def = (0, $j83KU.getParamValue)('default', node, tensorMap, context);
            return [
                (0, $j83KU.getTensor)(node.name, tensorMap, context) || def
            ];
        case 'Placeholder':
            return [
                (0, $j83KU.getTensor)(node.name, tensorMap, context)
            ];
        case 'Identity':
        case 'StopGradient':
        case 'FakeQuantWithMinMaxVars':
            {
                const data = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                return [
                    (0, $j83KU.cloneTensor)(data)
                ];
            }
        case 'IdentityN':
            return (0, $j83KU.getParamValue)('x', node, tensorMap, context).map((t)=>(0, $j83KU.cloneTensor)(t));
        case 'Snapshot':
            const snapshot = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
            return [
                (0, $j83KU.cloneTensor)(snapshot)
            ];
        case 'Shape':
            return [
                ops.tensor1d((0, $j83KU.getParamValue)('x', node, tensorMap, context).shape, 'int32')
            ];
        case 'ShapeN':
            return (0, $j83KU.getParamValue)('x', node, tensorMap, context).map((t)=>ops.tensor1d(t.shape));
        case 'Size':
            return [
                ops.scalar((0, $j83KU.getParamValue)('x', node, tensorMap, context).size, 'int32')
            ];
        case 'Rank':
            return [
                ops.scalar((0, $j83KU.getParamValue)('x', node, tensorMap, context).rank, 'int32')
            ];
        case 'NoOp':
            return [
                ops.scalar(1)
            ];
        case 'Print':
            const input = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
            const data = (0, $j83KU.getParamValue)('data', node, tensorMap, context);
            const message = (0, $j83KU.getParamValue)('message', node, tensorMap, context);
            const summarize = (0, $j83KU.getParamValue)('summarize', node, tensorMap, context);
            console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance.");
            console.log(message);
            for(let i = 0; i < data.length; i++)console.log(Array.prototype.slice.call(data[i].dataSync()).slice(0, summarize));
            return [
                input
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $8d5e2f2965b26028$export$2c04807512a22510 = 'graph';

});

parcelRegister("5JtV9", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $42c85d5d51d68ec1$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $jHd6W = parcelRequire("jHd6W");

var $j83KU = parcelRequire("j83KU");
const $42c85d5d51d68ec1$export$7be88578e558e499 = async (node, tensorMap, context, resourceManager)=>{
    switch(node.op){
        case 'HashTable':
        case 'HashTableV2':
            {
                const existingTableHandle = resourceManager.getHashTableHandleByName(node.name);
                // Table is shared with initializer.
                if (existingTableHandle != null) return [
                    existingTableHandle
                ];
                else {
                    const keyDType = (0, $j83KU.getParamValue)('keyDType', node, tensorMap, context);
                    const valueDType = (0, $j83KU.getParamValue)('valueDType', node, tensorMap, context);
                    const hashTable = new (0, $jHd6W.HashTable)(keyDType, valueDType);
                    resourceManager.addHashTable(node.name, hashTable);
                    return [
                        hashTable.handle
                    ];
                }
            }
        case 'InitializeTable':
        case 'InitializeTableV2':
        case 'LookupTableImport':
        case 'LookupTableImportV2':
            {
                const handle = (0, $j83KU.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $j83KU.getParamValue)('keys', node, tensorMap, context);
                const values = (0, $j83KU.getParamValue)('values', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.import(keys, values)
                ];
            }
        case 'LookupTableFind':
        case 'LookupTableFindV2':
            {
                const handle = (0, $j83KU.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const keys = (0, $j83KU.getParamValue)('keys', node, tensorMap, context);
                const defaultValue = (0, $j83KU.getParamValue)('defaultValue', node, tensorMap, context);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    await hashTable.find(keys, defaultValue)
                ];
            }
        case 'LookupTableSize':
        case 'LookupTableSizeV2':
            {
                const handle = (0, $j83KU.getParamValue)('tableHandle', node, tensorMap, context, resourceManager);
                const hashTable = resourceManager.getHashTableById(handle.id);
                return [
                    hashTable.tensorSize()
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $42c85d5d51d68ec1$export$2c04807512a22510 = 'hash_table';

});
parcelRegister("jHd6W", function(module, exports) {

$parcel$export(module.exports, "HashTable", function () { return $e56c3407eb061c56$export$b3bcf29b77543c46; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");
var $7hONX = parcelRequire("7hONX");
var $lq9U1 = parcelRequire("lq9U1");
var $3mzDh = parcelRequire("3mzDh");
var $lBDHD = parcelRequire("lBDHD");

var $7hONX = parcelRequire("7hONX");
class $e56c3407eb061c56$export$b3bcf29b77543c46 {
    get id() {
        return this.handle.id;
    }
    /**
     * Constructor of HashTable. Creates a hash table.
     *
     * @param keyDType `dtype` of the table keys.
     * @param valueDType `dtype` of the table values.
     */ constructor(keyDType, valueDType){
        this.keyDType = keyDType;
        this.valueDType = valueDType;
        this.handle = (0, $7hONX.scalar)(0);
        // tslint:disable-next-line: no-any
        this.tensorMap = new Map();
        (0, $d7Nxs.keep)(this.handle);
    }
    /**
     * Dispose the tensors and handle and clear the hashtable.
     */ clearAndClose() {
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        this.handle.dispose();
    }
    /**
     * The number of items in the hash table.
     */ size() {
        return this.tensorMap.size;
    }
    /**
     * The number of items in the hash table as a rank-0 tensor.
     */ tensorSize() {
        return $7hONX.scalar(this.size(), 'int32');
    }
    /**
     * Replaces the contents of the table with the specified keys and values.
     * @param keys Keys to store in the hashtable.
     * @param values Values to store in the hashtable.
     */ async import(keys, values) {
        this.checkKeyAndValueTensor(keys, values);
        // We only store the primitive values of the keys, this allows lookup
        // to be O(1).
        const $keys = await keys.data();
        // Clear the hashTable before inserting new values.
        this.tensorMap.forEach((value)=>value.dispose());
        this.tensorMap.clear();
        return (0, $d7Nxs.tidy)(()=>{
            const $values = (0, $3mzDh.unstack)(values);
            const keysLength = $keys.length;
            const valuesLength = $values.length;
            (0, $lBDHD).assert(keysLength === valuesLength, ()=>`The number of elements doesn't match, keys has ` + `${keysLength} elements, the values has ${valuesLength} ` + `elements.`);
            for(let i = 0; i < keysLength; i++){
                const key = $keys[i];
                const value = $values[i];
                (0, $d7Nxs.keep)(value);
                this.tensorMap.set(key, value);
            }
            return this.handle;
        });
    }
    /**
     * Looks up keys in a hash table, outputs the corresponding values.
     *
     * Performs batch lookups, for every element in the key tensor, `find`
     * stacks the corresponding value into the return tensor.
     *
     * If an element is not present in the table, the given `defaultValue` is
     * used.
     *
     * @param keys Keys to look up. Must have the same type as the keys of the
     *     table.
     * @param defaultValue The scalar `defaultValue` is the value output for keys
     *     not present in the table. It must also be of the same type as the
     *     table values.
     */ async find(keys, defaultValue) {
        this.checkKeyAndValueTensor(keys, defaultValue);
        const $keys = await keys.data();
        return (0, $d7Nxs.tidy)(()=>{
            const result = [];
            for(let i = 0; i < $keys.length; i++){
                const key = $keys[i];
                const value = this.findWithDefault(key, defaultValue);
                result.push(value);
            }
            return (0, $lq9U1.stack)(result);
        });
    }
    // tslint:disable-next-line: no-any
    findWithDefault(key, defaultValue) {
        const result = this.tensorMap.get(key);
        return result != null ? result : defaultValue;
    }
    checkKeyAndValueTensor(key, value) {
        if (key.dtype !== this.keyDType) throw new Error(`Expect key dtype ${this.keyDType}, but got ` + `${key.dtype}`);
        if (value.dtype !== this.valueDType) throw new Error(`Expect value dtype ${this.valueDType}, but got ` + `${value.dtype}`);
    }
}

});


parcelRegister("cHVFh", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $94063b344cc42247$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $94063b344cc42247$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'ResizeBilinear':
            {
                const images = (0, $j83KU.getParamValue)('images', node, tensorMap, context);
                const size = (0, $j83KU.getParamValue)('size', node, tensorMap, context);
                const alignCorners = (0, $j83KU.getParamValue)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $j83KU.getParamValue)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeBilinear(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'ResizeNearestNeighbor':
            {
                const images = (0, $j83KU.getParamValue)('images', node, tensorMap, context);
                const size = (0, $j83KU.getParamValue)('size', node, tensorMap, context);
                const alignCorners = (0, $j83KU.getParamValue)('alignCorners', node, tensorMap, context);
                const halfPixelCenters = (0, $j83KU.getParamValue)('halfPixelCenters', node, tensorMap, context);
                return [
                    ops.image.resizeNearestNeighbor(images, [
                        size[0],
                        size[1]
                    ], alignCorners, halfPixelCenters)
                ];
            }
        case 'CropAndResize':
            {
                const image = (0, $j83KU.getParamValue)('image', node, tensorMap, context);
                const boxes = (0, $j83KU.getParamValue)('boxes', node, tensorMap, context);
                const boxInd = (0, $j83KU.getParamValue)('boxInd', node, tensorMap, context);
                const cropSize = (0, $j83KU.getParamValue)('cropSize', node, tensorMap, context);
                const method = (0, $j83KU.getParamValue)('method', node, tensorMap, context);
                const extrapolationValue = (0, $j83KU.getParamValue)('extrapolationValue', node, tensorMap, context);
                return [
                    ops.image.cropAndResize(image, boxes, boxInd, cropSize, method, extrapolationValue)
                ];
            }
        case 'ImageProjectiveTransformV3':
            {
                const images = (0, $j83KU.getParamValue)('images', node, tensorMap, context);
                const transforms = (0, $j83KU.getParamValue)('transforms', node, tensorMap, context);
                const outputShape = (0, $j83KU.getParamValue)('outputShape', node, tensorMap, context);
                const fillValue = (0, $j83KU.getParamValue)('fillValue', node, tensorMap, context);
                const interpolation = (0, $j83KU.getParamValue)('interpolation', node, tensorMap, context);
                const fillMode = (0, $j83KU.getParamValue)('fillMode', node, tensorMap, context);
                return [
                    ops.image.transform(images, transforms, interpolation.toLowerCase(), fillMode.toLowerCase(), fillValue, outputShape)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $94063b344cc42247$export$2c04807512a22510 = 'image';

});

parcelRegister("3siIF", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $284281e3fe19a6ab$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $284281e3fe19a6ab$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'Equal':
            return [
                ops.equal((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'NotEqual':
            return [
                ops.notEqual((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Greater':
            return [
                ops.greater((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'GreaterEqual':
            return [
                ops.greaterEqual((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Less':
            return [
                ops.less((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LessEqual':
            return [
                ops.lessEqual((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LogicalAnd':
            return [
                ops.logicalAnd((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'LogicalNot':
            return [
                ops.logicalNot((0, $j83KU.getParamValue)('a', node, tensorMap, context))
            ];
        case 'LogicalOr':
            return [
                ops.logicalOr((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'Select':
        case 'SelectV2':
            return [
                ops.where((0, $j83KU.getParamValue)('condition', node, tensorMap, context), (0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        case 'BitwiseAnd':
            return [
                ops.bitwiseAnd((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $284281e3fe19a6ab$export$2c04807512a22510 = 'logical';

});

parcelRegister("1Rr3m", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $15afb9e5371e5ca3$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $15afb9e5371e5ca3$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'BatchMatMul':
        case 'BatchMatMulV2':
        case 'MatMul':
            return [
                ops.matMul((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('b', node, tensorMap, context), (0, $j83KU.getParamValue)('transposeA', node, tensorMap, context), (0, $j83KU.getParamValue)('transposeB', node, tensorMap, context))
            ];
        case 'Einsum':
            return [
                ops.einsum((0, $j83KU.getParamValue)('equation', node, tensorMap, context), ...(0, $j83KU.getParamValue)('tensors', node, tensorMap, context))
            ];
        case 'Transpose':
            return [
                ops.transpose((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('perm', node, tensorMap, context))
            ];
        case '_FusedMatMul':
            const [extraOp, activationFunc] = (0, $j83KU.getParamValue)('fusedOps', node, tensorMap, context);
            const isBiasAdd = extraOp === 'biasadd';
            const isPrelu = activationFunc === 'prelu';
            const numArgs = (0, $j83KU.getParamValue)('numArgs', node, tensorMap, context);
            const leakyreluAlpha = (0, $j83KU.getParamValue)('leakyreluAlpha', node, tensorMap, context);
            if (isBiasAdd) {
                if (isPrelu && numArgs !== 2) throw new Error("Fused MatMul with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
                if (!isPrelu && numArgs !== 1) throw new Error('Fused MatMul with BiasAdd must have one extra argument: bias.');
            }
            const [biasArg, preluArg] = (0, $j83KU.getParamValue)('args', node, tensorMap, context);
            return [
                ops.fused.matMul({
                    a: (0, $j83KU.getParamValue)('a', node, tensorMap, context),
                    b: (0, $j83KU.getParamValue)('b', node, tensorMap, context),
                    transposeA: (0, $j83KU.getParamValue)('transposeA', node, tensorMap, context),
                    transposeB: (0, $j83KU.getParamValue)('transposeB', node, tensorMap, context),
                    bias: biasArg,
                    activation: activationFunc,
                    preluActivationWeights: preluArg,
                    leakyreluAlpha: leakyreluAlpha
                })
            ];
        case 'MatrixBandPart':
            return [
                ops.linalg.bandPart((0, $j83KU.getParamValue)('a', node, tensorMap, context), (0, $j83KU.getParamValue)('numLower', node, tensorMap, context), (0, $j83KU.getParamValue)('numUpper', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $15afb9e5371e5ca3$export$2c04807512a22510 = 'matrices';

});

parcelRegister("87Rsn", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $5ea8718f85c1897d$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $5ea8718f85c1897d$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'EuclideanNorm':
            return [
                ops.euclideanNorm((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('axis', node, tensorMap, context), (0, $j83KU.getParamValue)('keepDims', node, tensorMap, context))
            ];
        case 'FusedBatchNorm':
        case 'FusedBatchNormV2':
            return [
                ops.batchNorm((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('mean', node, tensorMap, context), (0, $j83KU.getParamValue)('variance', node, tensorMap, context), (0, $j83KU.getParamValue)('offset', node, tensorMap, context), (0, $j83KU.getParamValue)('scale', node, tensorMap, context), (0, $j83KU.getParamValue)('epsilon', node, tensorMap, context))
            ];
        case 'FusedBatchNormV3':
            return [
                ops.batchNorm((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('mean', node, tensorMap, context), (0, $j83KU.getParamValue)('variance', node, tensorMap, context), (0, $j83KU.getParamValue)('offset', node, tensorMap, context), (0, $j83KU.getParamValue)('scale', node, tensorMap, context), (0, $j83KU.getParamValue)('epsilon', node, tensorMap, context))
            ];
        case 'LRN':
            return [
                ops.localResponseNormalization((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('radius', node, tensorMap, context), (0, $j83KU.getParamValue)('bias', node, tensorMap, context), (0, $j83KU.getParamValue)('alpha', node, tensorMap, context), (0, $j83KU.getParamValue)('beta', node, tensorMap, context))
            ];
        case 'Softmax':
            return [
                ops.softmax((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'LogSoftmax':
            return [
                ops.logSoftmax((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $5ea8718f85c1897d$export$2c04807512a22510 = 'normalization';

});

parcelRegister("fsRTE", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $b4234742f2518398$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $b4234742f2518398$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'RaggedGather':
            {
                const { outputNestedSplits: outputNestedSplits, outputDenseValues: outputDenseValues } = ops.raggedGather((0, $j83KU.getParamValue)('paramsNestedSplits', node, tensorMap, context), (0, $j83KU.getParamValue)('paramsDenseValues', node, tensorMap, context), (0, $j83KU.getParamValue)('indices', node, tensorMap, context), (0, $j83KU.getParamValue)('outputRaggedRank', node, tensorMap, context));
                return outputNestedSplits.concat(outputDenseValues);
            }
        case 'RaggedRange':
            {
                const { rtNestedSplits: rtNestedSplits, rtDenseValues: rtDenseValues } = ops.raggedRange((0, $j83KU.getParamValue)('starts', node, tensorMap, context), (0, $j83KU.getParamValue)('limits', node, tensorMap, context), (0, $j83KU.getParamValue)('splits', node, tensorMap, context));
                return [
                    rtNestedSplits,
                    rtDenseValues
                ];
            }
        case 'RaggedTensorToTensor':
            return [
                ops.raggedTensorToTensor((0, $j83KU.getParamValue)('shape', node, tensorMap, context), (0, $j83KU.getParamValue)('values', node, tensorMap, context), (0, $j83KU.getParamValue)('defaultValue', node, tensorMap, context), (0, $j83KU.getParamValue)('rowPartitionTensors', node, tensorMap, context), (0, $j83KU.getParamValue)('rowPartitionTypes', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $b4234742f2518398$export$2c04807512a22510 = 'ragged';

});

parcelRegister("fSsyC", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $b8f20d09a14c3b72$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $b8f20d09a14c3b72$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'Max':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $j83KU.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.max((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Mean':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $j83KU.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.mean((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Min':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $j83KU.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.min((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Sum':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $j83KU.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.sum((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'All':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $j83KU.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.all((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Any':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $j83KU.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.any((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'ArgMax':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.argMax((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'ArgMin':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.argMin((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Prod':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const keepDims = (0, $j83KU.getParamValue)('keepDims', node, tensorMap, context);
                return [
                    ops.prod((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, keepDims)
                ];
            }
        case 'Cumprod':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const exclusive = (0, $j83KU.getParamValue)('exclusive', node, tensorMap, context);
                const reverse = (0, $j83KU.getParamValue)('reverse', node, tensorMap, context);
                return [
                    ops.cumprod((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Cumsum':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const exclusive = (0, $j83KU.getParamValue)('exclusive', node, tensorMap, context);
                const reverse = (0, $j83KU.getParamValue)('reverse', node, tensorMap, context);
                return [
                    ops.cumsum((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis, exclusive, reverse)
                ];
            }
        case 'Bincount':
            const x = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
            const weights = (0, $j83KU.getParamValue)('weights', node, tensorMap, context);
            const size = (0, $j83KU.getParamValue)('size', node, tensorMap, context);
            return [
                ops.bincount(x, weights, size)
            ];
        case 'DenseBincount':
            {
                const x = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                const weights = (0, $j83KU.getParamValue)('weights', node, tensorMap, context);
                const size = (0, $j83KU.getParamValue)('size', node, tensorMap, context);
                const binaryOutput = (0, $j83KU.getParamValue)('binaryOutput', node, tensorMap, context);
                return [
                    ops.denseBincount(x, weights, size, binaryOutput)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $b8f20d09a14c3b72$export$2c04807512a22510 = 'reduction';

});

parcelRegister("hPj17", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $cfa5f3739e7fefe4$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $cfa5f3739e7fefe4$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'ConcatV2':
        case 'Concat':
            {
                const n = (0, $j83KU.getParamValue)('n', node, tensorMap, context);
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                let inputs = (0, $j83KU.getParamValue)('tensors', node, tensorMap, context);
                inputs = inputs.slice(0, n);
                return [
                    ops.concat(inputs, axis)
                ];
            }
        case 'Gather':
            {
                const input = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), 0)
                ];
            }
        case 'GatherV2':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const batchDims = (0, $j83KU.getParamValue)('batchDims', node, tensorMap, context);
                const input = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gather(input, ops.cast(indices, 'int32'), axis, batchDims)
                ];
            }
        case 'Reverse':
            {
                const dims = (0, $j83KU.getParamValue)('dims', node, tensorMap, context);
                const axis = [];
                for(let i = 0; i < dims.length; i++)if (dims[i]) axis.push(i);
                const input = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'ReverseV2':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const input = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.reverse(input, axis)
                ];
            }
        case 'Slice':
            {
                // tslint:disable-next-line:no-any
                const begin = (0, $j83KU.getParamValue)('begin', node, tensorMap, context);
                // tslint:disable-next-line:no-any
                const size = (0, $j83KU.getParamValue)('size', node, tensorMap, context);
                return [
                    ops.slice((0, $j83KU.getParamValue)('x', node, tensorMap, context), begin, size)
                ];
            }
        case 'StridedSlice':
            {
                const begin = (0, $j83KU.getParamValue)('begin', node, tensorMap, context);
                const end = (0, $j83KU.getParamValue)('end', node, tensorMap, context);
                const strides = (0, $j83KU.getParamValue)('strides', node, tensorMap, context);
                const beginMask = (0, $j83KU.getParamValue)('beginMask', node, tensorMap, context);
                const endMask = (0, $j83KU.getParamValue)('endMask', node, tensorMap, context);
                const ellipsisMask = (0, $j83KU.getParamValue)('ellipsisMask', node, tensorMap, context);
                const newAxisMask = (0, $j83KU.getParamValue)('newAxisMask', node, tensorMap, context);
                const shrinkAxisMask = (0, $j83KU.getParamValue)('shrinkAxisMask', node, tensorMap, context);
                const tensor = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                return [
                    ops.stridedSlice(tensor, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask)
                ];
            }
        case 'Pack':
            return (0, $d7Nxs.tidy)(()=>{
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const tensors = (0, $j83KU.getParamValue)('tensors', node, tensorMap, context);
                // Reshape the tensors to the first tensor's shape if they don't
                // match.
                const shape = tensors[0].shape;
                const squeezedShape = ops.squeeze(tensors[0]).shape;
                const mapped = tensors.map((tensor)=>{
                    const sameShape = (0, $lBDHD).arraysEqual(tensor.shape, shape);
                    if (!sameShape && !(0, $lBDHD).arraysEqual(ops.squeeze(tensor).shape, squeezedShape)) throw new Error('the input tensors shape does not match');
                    return sameShape ? tensor : ops.reshape(tensor, shape);
                });
                return [
                    ops.stack(mapped, axis)
                ];
            });
        case 'Unpack':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const tensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                return ops.unstack(tensor, axis);
            }
        case 'Tile':
            {
                const reps = (0, $j83KU.getParamValue)('reps', node, tensorMap, context);
                return [
                    ops.tile((0, $j83KU.getParamValue)('x', node, tensorMap, context), reps)
                ];
            }
        case 'Split':
        case 'SplitV':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                const numOrSizeSplits = (0, $j83KU.getParamValue)('numOrSizeSplits', node, tensorMap, context);
                const tensor = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                return ops.split(tensor, numOrSizeSplits, axis);
            }
        case 'ScatterNd':
            {
                const indices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                const values = (0, $j83KU.getParamValue)('values', node, tensorMap, context);
                const shape = (0, $j83KU.getParamValue)('shape', node, tensorMap, context);
                return [
                    ops.scatterND(indices, values, shape)
                ];
            }
        case 'GatherNd':
            {
                const x = (0, $j83KU.getParamValue)('x', node, tensorMap, context);
                const indices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                return [
                    ops.gatherND(x, indices)
                ];
            }
        case 'SparseToDense':
            {
                const indices = (0, $j83KU.getParamValue)('sparseIndices', node, tensorMap, context);
                const shape = (0, $j83KU.getParamValue)('outputShape', node, tensorMap, context);
                const sparseValues = (0, $j83KU.getParamValue)('sparseValues', node, tensorMap, context);
                const defaultValue = (0, $j83KU.getParamValue)('defaultValue', node, tensorMap, context);
                return [
                    ops.sparseToDense(indices, sparseValues, shape, sparseValues.dtype === defaultValue.dtype ? defaultValue : ops.cast(defaultValue, sparseValues.dtype))
                ];
            }
        case 'TensorScatterUpdate':
            {
                const indices = (0, $j83KU.getParamValue)('indices', node, tensorMap, context);
                const values = (0, $j83KU.getParamValue)('values', node, tensorMap, context);
                const tensor = (0, $j83KU.getParamValue)('tensor', node, tensorMap, context);
                return [
                    ops.tensorScatterUpdate(tensor, indices, values)
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $cfa5f3739e7fefe4$export$2c04807512a22510 = 'slice_join';

});

parcelRegister("aCJr4", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $7bc0b29249e53639$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $7bc0b29249e53639$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'SparseFillEmptyRows':
            {
                const { outputIndices: outputIndices, outputValues: outputValues, emptyRowIndicator: emptyRowIndicator, reverseIndexMap: reverseIndexMap } = ops.sparse.sparseFillEmptyRows((0, $j83KU.getParamValue)('indices', node, tensorMap, context), (0, $j83KU.getParamValue)('values', node, tensorMap, context), (0, $j83KU.getParamValue)('denseShape', node, tensorMap, context), (0, $j83KU.getParamValue)('defaultValue', node, tensorMap, context));
                return [
                    outputIndices,
                    outputValues,
                    emptyRowIndicator,
                    reverseIndexMap
                ];
            }
        case 'SparseReshape':
            {
                const { outputIndices: outputIndices, outputShape: outputShape } = ops.sparse.sparseReshape((0, $j83KU.getParamValue)('inputIndices', node, tensorMap, context), (0, $j83KU.getParamValue)('inputShape', node, tensorMap, context), (0, $j83KU.getParamValue)('newShape', node, tensorMap, context));
                return [
                    outputIndices,
                    outputShape
                ];
            }
        case 'SparseSegmentMean':
            {
                const outputData = ops.sparse.sparseSegmentMean((0, $j83KU.getParamValue)('data', node, tensorMap, context), (0, $j83KU.getParamValue)('indices', node, tensorMap, context), (0, $j83KU.getParamValue)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        case 'SparseSegmentSum':
            {
                const outputData = ops.sparse.sparseSegmentSum((0, $j83KU.getParamValue)('data', node, tensorMap, context), (0, $j83KU.getParamValue)('indices', node, tensorMap, context), (0, $j83KU.getParamValue)('segmentIds', node, tensorMap, context));
                return [
                    outputData
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $7bc0b29249e53639$export$2c04807512a22510 = 'sparse';

});

parcelRegister("vUjVP", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $05fe95707ee1597a$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $05fe95707ee1597a$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'FFT':
            return [
                ops.fft((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'IFFT':
            return [
                ops.ifft((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'RFFT':
            return [
                ops.rfft((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        case 'IRFFT':
            return [
                ops.irfft((0, $j83KU.getParamValue)('x', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $05fe95707ee1597a$export$2c04807512a22510 = 'spectral';

});

parcelRegister("1t2LQ", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $111aa6159dcd8636$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $111aa6159dcd8636$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'StaticRegexReplace':
            return [
                ops.string.staticRegexReplace((0, $j83KU.getParamValue)('input', node, tensorMap, context), (0, $j83KU.getParamValue)('pattern', node, tensorMap, context), (0, $j83KU.getParamValue)('rewrite', node, tensorMap, context), (0, $j83KU.getParamValue)('replaceGlobal', node, tensorMap, context))
            ];
        case 'StringNGrams':
            {
                const { nGrams: nGrams, nGramsSplits: nGramsSplits } = ops.string.stringNGrams((0, $j83KU.getParamValue)('data', node, tensorMap, context), (0, $j83KU.getParamValue)('dataSplits', node, tensorMap, context), (0, $j83KU.getParamValue)('separator', node, tensorMap, context), (0, $j83KU.getParamValue)('nGramWidths', node, tensorMap, context), (0, $j83KU.getParamValue)('leftPad', node, tensorMap, context), (0, $j83KU.getParamValue)('rightPad', node, tensorMap, context), (0, $j83KU.getParamValue)('padWidth', node, tensorMap, context), (0, $j83KU.getParamValue)('preserveShortSequences', node, tensorMap, context));
                return [
                    nGrams,
                    nGramsSplits
                ];
            }
        case 'StringSplit':
            {
                const { indices: indices, values: values, shape: shape } = ops.string.stringSplit((0, $j83KU.getParamValue)('input', node, tensorMap, context), (0, $j83KU.getParamValue)('delimiter', node, tensorMap, context), (0, $j83KU.getParamValue)('skipEmpty', node, tensorMap, context));
                return [
                    indices,
                    values,
                    shape
                ];
            }
        case 'StringToHashBucketFast':
            {
                const output = ops.string.stringToHashBucketFast((0, $j83KU.getParamValue)('input', node, tensorMap, context), (0, $j83KU.getParamValue)('numBuckets', node, tensorMap, context));
                return [
                    output
                ];
            }
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $111aa6159dcd8636$export$2c04807512a22510 = 'string';

});

parcelRegister("fAvr0", function(module, exports) {

$parcel$export(module.exports, "executeOp", function () { return $b5929a0a49eae1cd$export$7be88578e558e499; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // tslint:disable-next-line: no-imports-from-dist

var $5PA95 = parcelRequire("5PA95");

var $j83KU = parcelRequire("j83KU");
const $b5929a0a49eae1cd$export$7be88578e558e499 = (node, tensorMap, context, ops = $5PA95)=>{
    switch(node.op){
        case 'Cast':
            return [
                ops.cast((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('dtype', node, tensorMap, context))
            ];
        case 'ExpandDims':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.expandDims((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Squeeze':
            {
                const axis = (0, $j83KU.getParamValue)('axis', node, tensorMap, context);
                return [
                    ops.squeeze((0, $j83KU.getParamValue)('x', node, tensorMap, context), axis)
                ];
            }
        case 'Reshape':
            return [
                ops.reshape((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('shape', node, tensorMap, context))
            ];
        case 'EnsureShape':
            return [
                ops.ensureShape((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('shape', node, tensorMap, context))
            ];
        case 'MirrorPad':
            return [
                ops.mirrorPad((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('padding', node, tensorMap, context), (0, $j83KU.getParamValue)('mode', node, tensorMap, context))
            ];
        case 'PadV2':
        case 'Pad':
            return [
                ops.pad((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('padding', node, tensorMap, context), (0, $j83KU.getParamValue)('constantValue', node, tensorMap, context))
            ];
        case 'SpaceToBatchND':
            {
                const blockShape = (0, $j83KU.getParamValue)('blockShape', node, tensorMap, context);
                const paddings = (0, $j83KU.getParamValue)('paddings', node, tensorMap, context);
                return [
                    ops.spaceToBatchND((0, $j83KU.getParamValue)('x', node, tensorMap, context), blockShape, paddings)
                ];
            }
        case 'BatchToSpaceND':
            {
                const blockShape = (0, $j83KU.getParamValue)('blockShape', node, tensorMap, context);
                const crops = (0, $j83KU.getParamValue)('crops', node, tensorMap, context);
                return [
                    ops.batchToSpaceND((0, $j83KU.getParamValue)('x', node, tensorMap, context), blockShape, crops)
                ];
            }
        case 'DepthToSpace':
            {
                const blockSize = (0, $j83KU.getParamValue)('blockSize', node, tensorMap, context);
                const dataFormat = (0, $j83KU.getParamValue)('dataFormat', node, tensorMap, context).toUpperCase();
                return [
                    ops.depthToSpace((0, $j83KU.getParamValue)('x', node, tensorMap, context), blockSize, dataFormat)
                ];
            }
        case 'BroadcastTo':
            return [
                ops.broadcastTo((0, $j83KU.getParamValue)('x', node, tensorMap, context), (0, $j83KU.getParamValue)('shape', node, tensorMap, context))
            ];
        case 'BroadcastArgs':
            return [
                ops.broadcastArgs((0, $j83KU.getParamValue)('s0', node, tensorMap, context), (0, $j83KU.getParamValue)('s1', node, tensorMap, context))
            ];
        default:
            throw TypeError(`Node type ${node.op} is not implemented`);
    }
};
const $b5929a0a49eae1cd$export$2c04807512a22510 = 'transformation';

});


parcelRegister("jTX20", function(module, exports) {

$parcel$export(module.exports, "ExecutionContext", function () { return $e7d0f1bf8d391b84$export$f7c638676c8af91d; });
/**
 * ExecutionContext captures the runtime environment of the node. It keeps
 * track of the current frame and iteration for the control flow ops.
 *
 * For example, typical Dynamic RNN model may contain loops, for which
 * TensorFlow will generate graphs with Enter/Exit nodes to control the
 * current execution frame, and NextIteration Nodes for iteration id increment.
 * For model with branch logic, TensorFLow will generate Switch/Merge ops.
 */ class $e7d0f1bf8d391b84$export$f7c638676c8af91d {
    constructor(weightMap = {}, tensorArrayMap = {}, tensorListMap = {}, functionMap = {}, parseNodeNameCache){
        this.weightMap = weightMap;
        this.tensorArrayMap = tensorArrayMap;
        this.tensorListMap = tensorListMap;
        this.functionMap = functionMap;
        this.parseNodeNameCache = parseNodeNameCache;
        this.rootContext = {
            id: 0,
            frameName: '',
            iterationId: 0
        };
        this.contexts = [
            this.rootContext
        ];
        this.lastId = 0;
        this.generateCurrentContextIds();
    }
    newFrame(id, frameName) {
        return {
            id: id,
            frameName: frameName,
            iterationId: 0
        };
    }
    /**
     * Set the current context
     * @param contexts: ExecutionContextInfo[] the current path of execution
     * frames
     */ set currentContext(contexts) {
        if (this.contexts !== contexts) {
            this.contexts = contexts;
            this.generateCurrentContextIds();
        }
    }
    get currentContext() {
        return this.contexts;
    }
    /**
     * Returns the current context in string format.
     */ get currentContextId() {
        return this._currentContextIds[0];
    }
    /**
     * Returns the current context and all parent contexts in string format.
     * This allow access to the nodes in the current and parent frames.
     */ get currentContextIds() {
        return this._currentContextIds;
    }
    generateCurrentContextIds() {
        const names = [];
        for(let i = 0; i < this.contexts.length - 1; i++){
            const contexts = this.contexts.slice(0, this.contexts.length - i);
            names.push(this.contextIdforContexts(contexts));
        }
        names.push('');
        this._currentContextIds = names;
    }
    contextIdforContexts(contexts) {
        return contexts ? contexts.map((context)=>context.id === 0 && context.iterationId === 0 ? '' : `${context.frameName}-${context.iterationId}`).join('/') : '';
    }
    /**
     * Enter a new frame, a new context is pushed on the current context list.
     * @param frameId new frame id
     */ enterFrame(frameId) {
        if (this.contexts) {
            this.lastId++;
            this.contexts = this.contexts.slice();
            this.contexts.push(this.newFrame(this.lastId, frameId));
            this._currentContextIds.unshift(this.contextIdforContexts(this.contexts));
        }
    }
    /**
     * Exit the current frame, the last context is removed from the current
     * context list.
     */ exitFrame() {
        if (this.contexts && this.contexts.length > 1) {
            this.contexts = this.contexts.slice();
            this.contexts.splice(-1);
            this.currentContextIds.shift();
        } else throw new Error('Cannot exit frame, the context is empty');
    }
    /**
     * Enter the next iteration of a loop, the iteration id of last context is
     * increased.
     */ nextIteration() {
        if (this.contexts && this.contexts.length > 0) {
            this.contexts = this.contexts.slice();
            this.lastId++;
            const context = Object.assign({}, this.contexts[this.contexts.length - 1]);
            context.iterationId += 1;
            context.id = this.lastId;
            this.contexts.splice(-1, 1, context);
            this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts));
        } else throw new Error('Cannot increase frame iteration, the context is empty');
    }
    getWeight(name) {
        return this.weightMap[name];
    }
    addTensorArray(tensorArray) {
        this.tensorArrayMap[tensorArray.id] = tensorArray;
    }
    getTensorArray(id) {
        return this.tensorArrayMap[id];
    }
    addTensorList(tensorList) {
        this.tensorListMap[tensorList.id] = tensorList;
    }
    getTensorList(id) {
        return this.tensorListMap[id];
    }
    dispose(keepIds) {
        for(const key in this.tensorArrayMap)this.tensorArrayMap[key].clearAndClose(keepIds);
        for(const key in this.tensorListMap)this.tensorListMap[key].clearAndClose(keepIds);
    }
}

});

parcelRegister("aPKfH", function(module, exports) {

$parcel$export(module.exports, "getExecutionSubgraph", function () { return $7e328b819373a867$export$73c2416e6ab509c5; });
$parcel$export(module.exports, "isControlFlow", function () { return $7e328b819373a867$export$683ae22d42a16fd1; });
$parcel$export(module.exports, "getNodesInTopologicalOrder", function () { return $7e328b819373a867$export$66747854b63761e1; });
$parcel$export(module.exports, "getNodeLiveUntilMap", function () { return $7e328b819373a867$export$1b4890839d1091f5; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $j83KU = parcelRequire("j83KU");
function $7e328b819373a867$export$73c2416e6ab509c5(inputs, outputs, weightMap, initNodes) {
    const usedNodes = new Set();
    const missingInputs = [];
    let dynamicNode = null;
    let syncInputs = null;
    // Start with the outputs, going backwards and find all the nodes that are
    // needed to compute those outputs.
    const seen = new Set();
    const inputNodeNames = new Set(Object.keys(inputs).map((name)=>(0, $j83KU.parseNodeName)(name)[0]));
    initNodes = initNodes || [];
    const initNodeNames = new Set(initNodes.map((node)=>(0, $j83KU.parseNodeName)(node.name)[0]));
    const frontier = [
        ...outputs
    ];
    while(frontier.length > 0){
        const node = frontier.pop();
        if ($7e328b819373a867$export$683ae22d42a16fd1(node) || $7e328b819373a867$export$eee9c104bd05368d(node) || $7e328b819373a867$export$ad7e54a7e645a447(node)) {
            if (dynamicNode == null) {
                dynamicNode = node;
                syncInputs = dynamicNode.children.map((child)=>child.name).filter((name)=>usedNodes.has(name));
            }
        }
        usedNodes.add(node.name);
        // Weights are dead end since we already have their values.
        if (weightMap[node.name] != null) continue;
        // This node is a dead end since it's one of the user-provided inputs.
        if (inputNodeNames.has(node.name)) continue;
        // This node is a dead end since it doesn't have any inputs.
        if (initNodeNames.has(node.name)) continue;
        if (node.inputs.length === 0) {
            missingInputs.push(node.name);
            continue;
        }
        node.inputs.forEach((input)=>{
            // Don't add to the frontier if it is already there.
            if (seen.has(input.name)) return;
            seen.add(input.name);
            frontier.push(input);
        });
    }
    return {
        inputs: inputs,
        outputs: outputs,
        usedNodes: usedNodes,
        missingInputs: missingInputs,
        dynamicNode: dynamicNode,
        syncInputs: syncInputs
    };
}
function $7e328b819373a867$export$66747854b63761e1(graph, executionInfo) {
    const { usedNodes: usedNodes, inputs: inputs } = executionInfo;
    const inputNodes = Object.keys(inputs).map((name)=>(0, $j83KU.parseNodeName)(name)[0]).map((name)=>graph.nodes[name]);
    const initNodes = graph.initNodes || [];
    const isUsed = (node)=>usedNodes.has(typeof node === 'string' ? node : node.name);
    function unique(nodes) {
        return [
            ...new Map(nodes.map((node)=>[
                    node.name,
                    node
                ])).values()
        ];
    }
    const predefinedNodes = unique([
        ...inputNodes,
        ...graph.weights,
        ...initNodes
    ]).filter(isUsed);
    const allNodes = unique([
        ...predefinedNodes,
        ...Object.values(graph.nodes)
    ]).filter(isUsed);
    const nameToNode = new Map(allNodes.map((node)=>[
            node.name,
            node
        ]));
    const inCounts = {};
    for (const node of allNodes){
        inCounts[node.name] = inCounts[node.name] || 0;
        for (const child of node.children){
            // When the child is unused, set in counts to infinity so that it will
            // never be decreased to 0 and added to the execution list.
            if (!isUsed(child)) inCounts[child.name] = Number.POSITIVE_INFINITY;
            inCounts[child.name] = (inCounts[child.name] || 0) + 1;
        }
    }
    // Build execution order for all used nodes regardless whether they are
    // predefined or not.
    const frontier = Object.entries(inCounts).filter(([, inCount])=>inCount === 0).map(([name])=>name);
    const orderedNodeNames = [
        ...frontier
    ];
    while(frontier.length > 0){
        const nodeName = frontier.pop();
        const node = nameToNode.get(nodeName);
        for (const child of node.children.filter(isUsed))if (--inCounts[child.name] === 0) {
            orderedNodeNames.push(child.name);
            frontier.push(child.name);
        }
    }
    const orderedNodes = orderedNodeNames.map((name)=>nameToNode.get(name));
    const filteredOrderedNodes = $7e328b819373a867$var$filterPredefinedReachableNodes(orderedNodes, predefinedNodes);
    // TODO: Turn validation on/off with tf env flag.
    $7e328b819373a867$var$validateNodesExecutionOrder(filteredOrderedNodes, predefinedNodes);
    return filteredOrderedNodes;
}
/**
 * This is a helper function of `getNodesInTopologicalOrder`.
 * Returns ordered nodes reachable by at least one predefined node.
 * This can help us filter out redundant nodes from the returned node list.
 * For example:
 * If we have four nodes with dependencies like this:
 *   a --> b --> c --> d
 * when node `c` is predefined (e.g. given as an input tensor), we can
 * skip node `a` and `b` since their outputs will never be used.
 *
 * @param orderedNodes Graph nodes in execution order.
 * @param predefinedNodes Graph inputs, weights, and init nodes. Nodes in this
 *     list must have distinct names.
 */ function $7e328b819373a867$var$filterPredefinedReachableNodes(orderedNodes, predefinedNodes) {
    const nameToNode = new Map(orderedNodes.map((node)=>[
            node.name,
            node
        ]));
    // TODO: Filter out more nodes when >=2 nodes are predefined in a path.
    const stack = predefinedNodes.map((node)=>node.name);
    const predefinedReachableNodeNames = new Set(stack);
    // Perform a DFS starting from the set of all predefined nodes
    // to find the set of all nodes reachable from the predefined nodes.
    while(stack.length > 0){
        const nodeName = stack.pop();
        const node = nameToNode.get(nodeName);
        for (const child of node.children){
            if (!nameToNode.has(child.name) || predefinedReachableNodeNames.has(child.name)) continue;
            predefinedReachableNodeNames.add(child.name);
            stack.push(child.name);
        }
    }
    // Filter out unreachable nodes and build the ordered node list.
    const filteredOrderedNodes = orderedNodes.filter((node)=>predefinedReachableNodeNames.has(node.name));
    return filteredOrderedNodes;
}
class $7e328b819373a867$var$NodesExecutionOrderError extends Error {
    constructor(message){
        super(`NodesExecutionOrderError: ${message}`);
    }
}
/**
 * This is a helper function of `getNodesInTopologicalOrder`.
 * Validates property: given nodes `a` and `b`, Order(a) > Order(b) if `a`
 * is a child of `b`. This function throws an error if validation fails.
 *
 * @param orderedNodes Graph nodes in execution order.
 * @param predefinedNodes Graph inputs, weights, and init nodes. Nodes in this
 *     list must have distinct names.
 */ function $7e328b819373a867$var$validateNodesExecutionOrder(orderedNodes, predefinedNodes) {
    const nodeNameToOrder = new Map(orderedNodes.map((node, order)=>[
            node.name,
            order
        ]));
    const predefinedNodeNames = new Set(predefinedNodes.map((node)=>node.name));
    const isPredefined = (node)=>predefinedNodeNames.has(typeof node === 'string' ? node : node.name);
    const willBeExecutedNodeNames = new Set(orderedNodes.map((node)=>node.name));
    const willBeExecuted = (node)=>willBeExecutedNodeNames.has(typeof node === 'string' ? node : node.name);
    for (const node of orderedNodes){
        for (const child of node.children.filter(willBeExecuted)){
            if (!nodeNameToOrder.has(child.name)) throw new $7e328b819373a867$var$NodesExecutionOrderError(`Child ${child.name} of node ${node.name} is unreachable.`);
            if (nodeNameToOrder.get(node.name) > nodeNameToOrder.get(child.name)) throw new $7e328b819373a867$var$NodesExecutionOrderError(`Node ${node.name} is scheduled to run after its child ${child.name}.`);
        }
        if (!isPredefined(node)) for (const input of node.inputs){
            if (!nodeNameToOrder.has(input.name)) throw new $7e328b819373a867$var$NodesExecutionOrderError(`Input ${input.name} of node ${node.name} is unreachable.`);
            if (nodeNameToOrder.get(input.name) > nodeNameToOrder.get(node.name)) throw new $7e328b819373a867$var$NodesExecutionOrderError(`Node ${node.name} is scheduled to run before its input ${input.name}.`);
        }
    }
}
function $7e328b819373a867$export$1b4890839d1091f5(orderedNodes) {
    const nodeNameToOrder = new Map(orderedNodes.map((node, order)=>[
            node.name,
            order
        ]));
    const INF_LIFE = Number.MAX_SAFE_INTEGER;
    // Make control flow nodes (and consequently their direct parents)
    // live forever since they're tricky to track correctly.
    const selfLifespans = orderedNodes.map((node, nodeOrder)=>$7e328b819373a867$export$683ae22d42a16fd1(node) ? INF_LIFE : nodeOrder);
    const getSelfLifeSpan = (node)=>{
        const selfLife = selfLifespans[nodeNameToOrder.get(node.name)];
        if (selfLife == null) // If nodeToOrder does not contain the node, it is unused or
        // unreachable in graph.
        return -1;
        return selfLife;
    };
    // `liveUntil[i]` points to the last node in the `orderedNodes` array that
    // may depend on tensors from node `i`. It indicates that all the
    // intermediate tensors from `orderedNodes[i]` should be disposed after
    // `orderedNodes[liveUntil[i]]` is executed.
    // A node lives long enough to pass on its tensors to its children.
    // It lives until at least `max(node's position, children's positions)`.
    const liveUntilOrders = orderedNodes.map((node, nodeOrder)=>{
        return node.children.map(getSelfLifeSpan).reduce((a, b)=>Math.max(a, b), selfLifespans[nodeOrder]);
    });
    // liveUntilMap:
    // - Key: Name of a node `x`
    // - Values: All nodes whose intermediate tensors should be disposed
    //           after `x` is executed.
    const liveUntilMap = new Map();
    for(let nodeOrder = 0; nodeOrder < orderedNodes.length; ++nodeOrder){
        const liveUntilOrder = liveUntilOrders[nodeOrder];
        if (liveUntilOrder === INF_LIFE) continue;
        const node = orderedNodes[nodeOrder];
        const liveUntilNode = orderedNodes[liveUntilOrder];
        if (!liveUntilMap.has(liveUntilNode.name)) liveUntilMap.set(liveUntilNode.name, []);
        liveUntilMap.get(liveUntilNode.name).push(node);
    }
    return liveUntilMap;
}
const $7e328b819373a867$var$CONTROL_FLOW_OPS = new Set([
    'Switch',
    'Merge',
    'Enter',
    'Exit',
    'NextIteration',
    'StatelessIf',
    'StatelessWhile',
    'if',
    'While'
]);
const $7e328b819373a867$var$DYNAMIC_SHAPE_OPS = new Set([
    'NonMaxSuppressionV2',
    'NonMaxSuppressionV3',
    'NonMaxSuppressionV5',
    'Where'
]);
const $7e328b819373a867$var$HASH_TABLE_OPS = new Set([
    'HashTable',
    'HashTableV2',
    'LookupTableImport',
    'LookupTableImportV2',
    'LookupTableFind',
    'LookupTableFindV2',
    'LookupTableSize',
    'LookupTableSizeV2'
]);
function $7e328b819373a867$export$683ae22d42a16fd1(node) {
    return $7e328b819373a867$var$CONTROL_FLOW_OPS.has(node.op);
}
function $7e328b819373a867$export$eee9c104bd05368d(node) {
    return $7e328b819373a867$var$DYNAMIC_SHAPE_OPS.has(node.op);
}
function $7e328b819373a867$export$ad7e54a7e645a447(node) {
    return $7e328b819373a867$var$HASH_TABLE_OPS.has(node.op);
}

});


parcelRegister("ivFPv", function(module, exports) {

$parcel$export(module.exports, "ResourceManager", function () { return $d79b91be733e68bb$export$60667f9de734e56; });
/**
 * Contains global resources of a model.
 */ class $d79b91be733e68bb$export$60667f9de734e56 {
    constructor(hashTableNameToHandle = {}, hashTableMap = {}){
        this.hashTableNameToHandle = hashTableNameToHandle;
        this.hashTableMap = hashTableMap;
    }
    /**
     * Register a `HashTable` in the resource manager.
     *
     * The `HashTable` can be retrieved by `resourceManager.getHashTableById`,
     * where id is the table handle tensor's id.
     *
     * @param name Op node name that creates the `HashTable`.
     * @param hashTable The `HashTable` to be added to resource manager.
     */ addHashTable(name, hashTable) {
        this.hashTableNameToHandle[name] = hashTable.handle;
        this.hashTableMap[hashTable.id] = hashTable;
    }
    /**
     * Get the table handle by node name.
     * @param name Op node name that creates the `HashTable`. This name is also
     *     used in the inputs list of lookup and import `HashTable` ops.
     */ getHashTableHandleByName(name) {
        return this.hashTableNameToHandle[name];
    }
    /**
     * Get the actual `HashTable` by its handle tensor's id.
     * @param id The id of the handle tensor.
     */ getHashTableById(id) {
        return this.hashTableMap[id];
    }
    /**
     * Dispose `ResourceManager`, including its hashTables and tensors in them.
     */ dispose() {
        for(const key in this.hashTableMap){
            this.hashTableMap[key].clearAndClose();
            delete this.hashTableMap[key];
        }
        for(const name in this.hashTableNameToHandle){
            this.hashTableNameToHandle[name].dispose();
            delete this.hashTableNameToHandle[name];
        }
    }
}

});


parcelRegister("hNaaE", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $cf3ee6f7c463d44d$export$83d89fbfd8236492; });
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $cf3ee6f7c463d44d$export$83d89fbfd8236492 = '4.22.0';

});


parcelRegister("bOU3T", function(module, exports) {

$parcel$export(module.exports, "version_data", function () { return (parcelRequire("4amQM")).version; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $5kCnl = parcelRequire("5kCnl");

var $607KO = parcelRequire("607KO");

var $4vPKd = parcelRequire("4vPKd");

var $iSIxo = parcelRequire("iSIxo");

var $itOHT = parcelRequire("itOHT");

var $l0gjN = parcelRequire("l0gjN");

var $4amQM = parcelRequire("4amQM");

});
parcelRegister("5kCnl", function(module, exports) {

$parcel$export(module.exports, "Dataset", function () { return $3e1c96987982c27e$export$827063163a0a89f5; });
$parcel$export(module.exports, "datasetFromIteratorFn", function () { return $3e1c96987982c27e$export$3a70158aa38bbd76; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lq9U1 = parcelRequire("lq9U1");
var $eZfvk = parcelRequire("eZfvk");
var $3pVUH = parcelRequire("3pVUH");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $23NWZ = parcelRequire("23NWZ");

var $4rCj9 = parcelRequire("4rCj9");

var $jjiEr = parcelRequire("jjiEr");
// TODO(soergel): consider vectorized operations within the pipeline.
/**
 * Represents a potentially large list of independent data elements (typically
 * 'samples' or 'examples').
 *
 * A 'data example' may be a primitive, an array, a map from string keys to
 * values, or any nested structure of these.
 *
 * A `Dataset` represents an ordered collection of elements, together with a
 * chain of transformations to be performed on those elements. Each
 * transformation is a method of `Dataset` that returns another `Dataset`, so
 * these may be chained, e.g.
 * `const processedDataset = rawDataset.filter(...).map(...).batch(...)`.
 *
 * Data loading and transformation is done in a lazy, streaming fashion.  The
 * dataset may be iterated over multiple times; each iteration starts the data
 * loading anew and recapitulates the transformations.
 *
 * A `Dataset` is typically processed as a stream of unbatched examples -- i.e.,
 * its transformations are applied one example at a time. Batching produces a
 * new `Dataset` where each element is a batch. Batching should usually come
 * last in a pipeline, because data transformations are easier to express on a
 * per-example basis than on a per-batch basis.
 *
 * The following code examples are calling `await dataset.forEachAsync(...)` to
 * iterate once over the entire dataset in order to print out the data.
 *
 * @doc {heading: 'Data', subheading: 'Classes', namespace: 'data'}
 */ class $3e1c96987982c27e$export$827063163a0a89f5 {
    constructor(){
        this.size = null;
    }
    // TODO(soergel): Make Datasets report whether repeated iterator() calls
    // produce the same result (e.g., reading from a file) or different results
    // (e.g., from the webcam).  Currently we don't make this distinction but it
    // could be important for the user to know.
    // abstract isDeterministic(): boolean;
    /**
     * Groups elements into batches.
     *
     * It is assumed that each of the incoming dataset elements has the same
     * structure -- i.e. the same set of keys at each location in an object
     * hierarchy.  For each key, the resulting `Dataset` provides a batched
     * element collecting all of the incoming values for that key.
     *
     *  * Incoming primitives are grouped into a 1-D Tensor.
     *  * Incoming Tensors are grouped into a new Tensor where the 0th axis is
     *    the batch dimension.
     *  * Incoming arrays are converted to Tensor and then batched.
     *  * A nested array is interpreted as an n-D Tensor, so the batched result
     *    has n+1 dimensions.
     *  * An array that cannot be converted to Tensor produces an error.
     *
     * If an array should not be batched as a unit, it should first be converted
     * to an object with integer keys.
     *
     * Here are a few examples:
     *
     * Batch a dataset of numbers:
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6, 7, 8]).batch(4);
     * await a.forEachAsync(e => e.print());
     * ```
     *
     * Batch a dataset of arrays:
     * ```js
     * const b = tf.data.array([[1], [2], [3], [4], [5], [6], [7], [8]]).batch(4);
     * await b.forEachAsync(e => e.print());
     * ```
     *
     * Batch a dataset of objects:
     * ```js
     * const c = tf.data.array([{a: 1, b: 11}, {a: 2, b: 12}, {a: 3, b: 13},
     *   {a: 4, b: 14}, {a: 5, b: 15}, {a: 6, b: 16}, {a: 7, b: 17},
     *   {a: 8, b: 18}]).batch(4);
     * await c.forEachAsync(e => {
     *   console.log('{');
     *   for(var key in e) {
     *     console.log(key+':');
     *     e[key].print();
     *   }
     *   console.log('}');
     * })
     * ```
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @returns A `Dataset`, from which a stream of batches can be obtained.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ batch(batchSize, smallLastBatch = true) {
        const base = this;
        $lBDHD.assert(batchSize > 0, ()=>`batchSize needs to be positive, but it is
      ${batchSize}`);
        let size;
        if (this.size === Infinity || this.size == null) // If the size of this dataset is infinity or null, the new size keeps the
        // same.
        size = this.size;
        else if (smallLastBatch) // If the size of this dataset is known and include small last batch, the
        // new size is full batch count plus last batch.
        size = Math.ceil(this.size / batchSize);
        else // If the size of this dataset is known and not include small last batch,
        // the new size is full batch count.
        size = Math.floor(this.size / batchSize);
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).columnMajorBatch(batchSize, smallLastBatch, $3e1c96987982c27e$var$deepBatchConcat);
        }, size);
    }
    /**
     * Concatenates this `Dataset` with another.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]);
     * const b = tf.data.array([4, 5, 6]);
     * const c = a.concatenate(b);
     * await c.forEachAsync(e => console.log(e));
     * ```
     *
     * @param dataset A `Dataset` to be concatenated onto this one.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ concatenate(dataset) {
        const base = this;
        let size;
        if (this.size === Infinity || dataset.size === Infinity) // If the size of any of these two dataset is infinity, new size is
        // infinity.
        size = Infinity;
        else if (this.size != null && dataset.size != null) // If the size of both datasets are known and not infinity, new size is
        // sum the size of these two datasets.
        size = this.size + dataset.size;
        else // If neither of these two datasets has infinite size and any of these two
        // datasets' size is null, the new size is null.
        size = null;
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>(await base.iterator()).concatenate(await dataset.iterator()), size);
    }
    /**
     * Filters this dataset according to `predicate`.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
     *   .filter(x => x%2 === 0);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param predicate A function mapping a dataset element to a boolean or a
     * `Promise` for one.
     *
     * @returns A `Dataset` of elements for which the predicate was true.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ filter(predicate) {
        const base = this;
        let size;
        if (this.size === Infinity) // If the size of this dataset is infinity, new size is infinity
        size = Infinity;
        else // If this dataset has limited elements, new size is null because it might
        // exhausted randomly.
        size = null;
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).filter((x)=>$d7Nxs.tidy(()=>predicate(x)));
        }, size);
    }
    /**
     * Apply a function to every element of the dataset.
     *
     * After the function is applied to a dataset element, any Tensors contained
     * within that element are disposed.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param f A function to apply to each dataset element.
     * @returns A `Promise` that resolves after all elements have been processed.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async forEachAsync(f) {
        return (await this.iterator()).forEachAsync(f);
    }
    /**
     * Maps this dataset through a 1-to-1 transform.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]).map(x => x*x);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param transform A function mapping a dataset element to a transformed
     *   dataset element.
     *
     * @returns A `Dataset` of transformed elements.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ map(transform) {
        const base = this;
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).map((x)=>$d7Nxs.tidy(()=>transform(x)));
        }, this.size);
    }
    /**
     * Maps this dataset through an async 1-to-1 transform.
     *
     * ```js
     * const a =
     *  tf.data.array([1, 2, 3]).mapAsync(x => new Promise(function(resolve){
     *    setTimeout(() => {
     *      resolve(x * x);
     *    }, Math.random()*1000 + 500);
     *  }));
     * console.log(await a.toArray());
     * ```
     *
     * @param transform A function mapping a dataset element to a `Promise` for a
     *   transformed dataset element.  This transform is responsible for disposing
     *   any intermediate `Tensor`s, i.e. by wrapping its computation in
     *   `tf.tidy()`; that cannot be automated here (as it is in the synchronous
     *   `map()` case).
     *
     * @returns A `Dataset` of transformed elements.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ mapAsync(transform) {
        const base = this;
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>{
            return (await base.iterator()).mapAsync(transform);
        }, this.size);
    }
    /**
     *  Creates a `Dataset` that prefetches elements from this dataset.
     *
     * @param bufferSize: An integer specifying the number of elements to be
     *   prefetched.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ prefetch(bufferSize) {
        if (bufferSize == null) throw new RangeError('`Dataset.prefetch()` requires bufferSize to be specified.');
        const base = this;
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>(await base.iterator()).prefetch(bufferSize), this.size);
    }
    /**
     * Repeats this dataset `count` times.
     *
     * NOTE: If this dataset is a function of global state (e.g. a random number
     * generator), then different repetitions may produce different elements.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3]).repeat(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: (Optional) An integer, representing the number of times
     *   the dataset should be repeated. The default behavior (if `count` is
     *   `undefined` or negative) is for the dataset be repeated indefinitely.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ repeat(count) {
        const base = this;
        let size;
        if (this.size != null && count > 0) // If this dataset has size and count is positive, new size is current
        // size multiply count. This also covers the case that current size is
        // infinity.
        size = this.size * count;
        else if (count === 0) // If count is 0, new size is 0.
        size = 0;
        else if (this.size != null && (count === undefined || count < 0)) // If this dataset has size and count is undefined or negative, the
        // dataset will be repeated indefinitely and new size is infinity.
        size = Infinity;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>{
            const iteratorIterator = (0, $4rCj9.iteratorFromFunction)(async ()=>({
                    value: await base.iterator(),
                    done: false
                }));
            return (0, $4rCj9.iteratorFromConcatenated)(iteratorIterator.take(count));
        }, size);
    }
    /**
     * Creates a `Dataset` that skips `count` initial elements from this dataset.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).skip(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: The number of elements of this dataset that should be skipped
     *   to form the new dataset.  If `count` is greater than the size of this
     *   dataset, the new dataset will contain no elements.  If `count`
     *   is `undefined` or negative, skips the entire dataset.
     *
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ skip(count) {
        const base = this;
        let size;
        if (this.size != null && count >= 0 && this.size >= count) // If the size of this dataset is greater than count, the new dataset's
        // size is current size minus skipped size.This also covers the case that
        // current size is infinity.
        size = this.size - count;
        else if (this.size != null && (this.size < count || count === undefined || count < 0)) // If the size of this dataset is smaller than count, or count is
        // undefined or negative, skips the entire dataset and the new size is 0.
        size = 0;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>(await base.iterator()).skip(count), size);
    }
    /**
     * Pseudorandomly shuffles the elements of this dataset. This is done in a
     * streaming manner, by sampling from a given number of prefetched elements.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).shuffle(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param bufferSize: An integer specifying the number of elements from this
     *   dataset from which the new dataset will sample.
     * @param seed: (Optional) An integer specifying the random seed that will
     *   be used to create the distribution.
     * @param reshuffleEachIteration: (Optional) A boolean, which if true
     *   indicates that the dataset should be pseudorandomly reshuffled each time
     *   it is iterated over. If false, elements will be returned in the same
     *   shuffled order on each iteration. (Defaults to `true`.)
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ shuffle(bufferSize, seed, reshuffleEachIteration = true) {
        if (bufferSize == null || bufferSize < 0) {
            if (this.size == null) throw new RangeError('`Dataset.shuffle()` requires bufferSize to be specified.');
            else throw new RangeError("`Dataset.shuffle()` requires bufferSize to be specified.  If your data fits in main memory (for regular JS objects), and/or GPU memory (for `tf.Tensor`s), consider setting " + `bufferSize to the dataset size (${this.size} elements)`);
        }
        const base = this;
        const random = $23NWZ.alea(seed || $lBDHD.now().toString());
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>{
            let seed2 = random.int32();
            if (reshuffleEachIteration) seed2 += random.int32();
            return (await base.iterator()).shuffle(bufferSize, seed2.toString());
        }, this.size);
    }
    /**
     * Creates a `Dataset` with at most `count` initial elements from this
     * dataset.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]).take(3);
     * await a.forEachAsync(e => console.log(e));
     * ```
     *
     * @param count: The number of elements of this dataset that should be taken
     *   to form the new dataset.  If `count` is `undefined` or negative, or if
     *   `count` is greater than the size of this dataset, the new dataset will
     *   contain all elements of this dataset.
     * @returns A `Dataset`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ take(count) {
        const base = this;
        let size;
        if (this.size != null && this.size > count) // If the size of this dataset is greater than count, the new dataset's
        // size is count.
        size = count;
        else if (this.size != null && this.size <= count) // If the size of this dataset is equal or smaller than count, the new
        // dataset's size is the size of this dataset.
        size = this.size;
        else // If the size of this dataset is null, the new dataset's size is null.
        size = null;
        return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>(await base.iterator()).take(count), size);
    }
    /**
     * Collect all elements of this dataset into an array.
     *
     * Obviously this will succeed only for small datasets that fit in memory.
     * Useful for testing and generally should be avoided if possible.
     *
     * ```js
     * const a = tf.data.array([1, 2, 3, 4, 5, 6]);
     * console.log(await a.toArray());
     * ```
     *
     * @returns A Promise for an array of elements, which will resolve
     *   when a new stream has been obtained and fully consumed.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async toArray() {
        if (this.size === Infinity) throw new Error('Can not convert infinite data stream to array.');
        return (await this.iterator()).toArray();
    }
    /**
     * Collect all elements of this dataset into an array with prefetching 100
     * elements. This is useful for testing, because the prefetch changes the
     * order in which the Promises are resolved along the processing pipeline.
     * This may help expose bugs where results are dependent on the order of
     * Promise resolution rather than on the logical order of the stream (i.e.,
     * due to hidden mutable state).
     *
     * @returns A Promise for an array of elements, which will resolve
     *   when a new stream has been obtained and fully consumed.
     */ async toArrayForTest() {
        if (this.size === Infinity) throw new Error('Can not convert infinite data stream to array.');
        return (await this.iterator()).toArrayForTest();
    }
}
// TODO(soergel): deep sharded shuffle, where supported
$3e1c96987982c27e$export$827063163a0a89f5.MAX_BUFFER_SIZE = 10000;
function $3e1c96987982c27e$export$3a70158aa38bbd76(iteratorFn, size = null) {
    return new class extends $3e1c96987982c27e$export$827063163a0a89f5 {
        constructor(){
            super(...arguments);
            this.size = size;
        }
        /*
         * Provide a new stream of elements.  Note this will also start new streams
         * from any underlying `Dataset`s.
         */ async iterator() {
            return iteratorFn();
        }
    }();
}
function $3e1c96987982c27e$export$2f23118c22fb2630(items) {
    return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>(0, $4rCj9.iteratorFromItems)(items), items.length);
}
function $3e1c96987982c27e$export$8901015135f2fb22(datasets) {
    // manually type-check the argument for JS users
    if (!(0, $jjiEr.isIterable)(datasets)) throw new Error('The argument to zip() must be an object or array.');
    let size;
    if (Array.isArray(datasets)) for(let i = 0; i < datasets.length; i++)size = size == null ? datasets[i].size : Math.min(size, datasets[i].size);
    else if (datasets instanceof Object) for(const ds in datasets)size = size == null ? datasets[ds].size : Math.min(size, datasets[ds].size);
    return $3e1c96987982c27e$export$3a70158aa38bbd76(async ()=>{
        const streams = await (0, $jjiEr.deepMapAndAwaitAll)(datasets, (d)=>{
            if (d instanceof $3e1c96987982c27e$export$827063163a0a89f5) return {
                value: d.iterator(),
                recurse: false
            };
            else if ((0, $jjiEr.isIterable)(d)) return {
                value: null,
                recurse: true
            };
            else throw new Error("Leaves of the structure passed to zip() must be Datasets, not primitives.");
        });
        return (0, $4rCj9.iteratorFromZipped)(streams, (0, $4rCj9.ZipMismatchMode).SHORTEST);
    }, size);
}
/**
 * A zip function for use with deepZip, passed via the columnMajorBatch call.
 *
 * Accepts an array of identically-structured nested elements and either batches
 * them (if they are primitives, numeric arrays, or Tensors) or requests
 * recursion (if not).
 */ // tslint:disable-next-line:no-any
function $3e1c96987982c27e$var$deepBatchConcat(rows) {
    if (rows === null) return null;
    // use the first item to decide whether to recurse or batch here.
    const exampleRow = rows[0];
    if ((0, $jjiEr.canTensorify)(exampleRow)) {
        // rows is an array of primitives, Tensors, or arrays.  Batch them.
        const value = $3e1c96987982c27e$var$batchConcat(rows);
        return {
            value: value,
            recurse: false
        };
    }
    // the example row is an object, so recurse into it.
    return {
        value: null,
        recurse: true
    };
}
/**
 * Assembles a list of same-shaped numbers, number arrays, or Tensors
 * into a single new Tensor where axis 0 is the batch dimension.
 */ function $3e1c96987982c27e$var$batchConcat(arrays) {
    if (arrays.length === 0) // We can't return an empty Tensor because we don't know the element shape.
    throw new Error('Can\'t make a batch of zero elements.');
    if (arrays[0] instanceof $3pVUH.Tensor) // Input is an array of Tensors
    return $lq9U1.stack(arrays);
    else // Input is a possibly-nested array of numbers.
    return $eZfvk.tensor(arrays);
}

});
parcelRegister("4rCj9", function(module, exports) {

$parcel$export(module.exports, "iteratorFromItems", function () { return $33c7662a8c41dee3$export$313b11d04150405f; });
$parcel$export(module.exports, "iteratorFromFunction", function () { return $33c7662a8c41dee3$export$392feaf09f7ef035; });
$parcel$export(module.exports, "iteratorFromConcatenated", function () { return $33c7662a8c41dee3$export$a9a63cf863a3bed5; });
$parcel$export(module.exports, "iteratorFromZipped", function () { return $33c7662a8c41dee3$export$5ecdf828f976b66e; });
$parcel$export(module.exports, "ZipMismatchMode", function () { return $33c7662a8c41dee3$export$4b13032c4dd08391; });
$parcel$export(module.exports, "LazyIterator", function () { return $33c7662a8c41dee3$export$b7f78d762925efef; });
$parcel$export(module.exports, "OneToManyIterator", function () { return $33c7662a8c41dee3$export$3c2cec00242a8bd8; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");
var $gpWQN = parcelRequire("gpWQN");
var $lBDHD = parcelRequire("lBDHD");

var $23NWZ = parcelRequire("23NWZ");

var $4WG96 = parcelRequire("4WG96");

var $jjiEr = parcelRequire("jjiEr");

var $23k4j = parcelRequire("23k4j");

var $8Pn2i = parcelRequire("8Pn2i");
function $33c7662a8c41dee3$export$313b11d04150405f(items) {
    return new $33c7662a8c41dee3$var$ArrayIterator(items);
}
function $33c7662a8c41dee3$export$8dc48c1840268a(start) {
    let i = start;
    return $33c7662a8c41dee3$export$392feaf09f7ef035(()=>({
            value: i++,
            done: false
        }));
}
function $33c7662a8c41dee3$export$392feaf09f7ef035(func) {
    return new $33c7662a8c41dee3$var$FunctionCallIterator(func);
}
function $33c7662a8c41dee3$export$a9a63cf863a3bed5(baseIterators, baseErrorHandler) {
    return new $33c7662a8c41dee3$export$22a7cbb11e3b9068(baseIterators, baseErrorHandler);
}
function $33c7662a8c41dee3$export$89912d30bab1596b(iteratorFunc, count, baseErrorHandler) {
    return $33c7662a8c41dee3$export$a9a63cf863a3bed5($33c7662a8c41dee3$export$392feaf09f7ef035(iteratorFunc).take(count), baseErrorHandler);
}
function $33c7662a8c41dee3$export$5ecdf828f976b66e(iterators, mismatchMode = $33c7662a8c41dee3$export$4b13032c4dd08391.FAIL) {
    return new $33c7662a8c41dee3$var$ZipIterator(iterators, mismatchMode);
}
class $33c7662a8c41dee3$export$b7f78d762925efef {
    /**
     * Collect all remaining elements of a bounded stream into an array.
     * Obviously this will succeed only for small streams that fit in memory.
     * Useful for testing.
     *
     * @returns A Promise for an array of stream elements, which will resolve
     *   when the stream is exhausted.
     */ async toArray() {
        const result = [];
        let x = await this.next();
        while(!x.done){
            result.push(x.value);
            x = await this.next();
        }
        return result;
    }
    /**
     * Collect all elements of this dataset into an array with prefetching 100
     * elements. This is useful for testing, because the prefetch changes the
     * order in which the Promises are resolved along the processing pipeline.
     * This may help expose bugs where results are dependent on the order of
     * Promise resolution rather than on the logical order of the stream (i.e.,
     * due to hidden mutable state).
     *
     * @returns A Promise for an array of stream elements, which will resolve
     *   when the stream is exhausted.
     */ async toArrayForTest() {
        const stream = this.prefetch(100);
        const result = [];
        let x = await stream.next();
        while(!x.done){
            result.push(x.value);
            x = await stream.next();
        }
        return result;
    }
    /**
     * Draw items from the stream until it is exhausted.
     *
     * This can be useful when the stream has side effects but no output.  In
     * that case, calling this function guarantees that the stream will be
     * fully processed.
     */ async resolveFully() {
        let x = await this.next();
        while(!x.done)x = await this.next();
    }
    /**
     * Draw items from the stream until it is exhausted, or a predicate fails.
     *
     * This can be useful when the stream has side effects but no output.  In
     * that case, calling this function guarantees that the stream will be
     * fully processed.
     */ async resolveWhile(predicate) {
        let x = await this.next();
        let shouldContinue = predicate(x.value);
        while(!x.done && shouldContinue){
            x = await this.next();
            shouldContinue = predicate(x.value);
        }
    }
    /**
     * Handles errors thrown on this stream using a provided handler function.
     *
     * @param handler A function that handles any `Error` thrown during a `next()`
     *   call and returns true if the stream should continue (dropping the failed
     *   call) or false if the stream should quietly terminate.  If the handler
     *   itself throws (or rethrows) an `Error`, that will be propagated.
     *
     * @returns A `LazyIterator` of elements passed through from upstream,
     *   possibly filtering or terminating on upstream `next()` calls that
     *   throw an `Error`.
     */ handleErrors(handler) {
        return new $33c7662a8c41dee3$var$ErrorHandlingLazyIterator(this, handler);
    }
    // TODO(soergel): Implement reduce() etc.
    /**
     * Filters this stream according to `predicate`.
     *
     * @param predicate A function mapping a stream element to a boolean or a
     * `Promise` for one.
     *
     * @returns A `LazyIterator` of elements for which the predicate was true.
     */ filter(predicate) {
        return new $33c7662a8c41dee3$var$FilterIterator(this, predicate);
    }
    /**
     * Maps this stream through a 1-to-1 transform.
     *
     * @param transform A function mapping a stream element to a transformed
     *   element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ map(transform) {
        return new $33c7662a8c41dee3$var$MapIterator(this, transform);
    }
    /**
     * Maps this stream through an async 1-to-1 transform.
     *
     * @param transform A function mapping a stream element to a `Promise` for a
     *   transformed stream element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ mapAsync(transform) {
        return new $33c7662a8c41dee3$var$AsyncMapIterator(this, transform);
    }
    /**
     * Maps this stream through a 1-to-1 transform, forcing serial execution.
     *
     * @param transform A function mapping a stream element to a transformed
     *   element.
     *
     * @returns A `LazyIterator` of transformed elements.
     */ serialMapAsync(transform) {
        return new $33c7662a8c41dee3$var$AsyncMapIterator(this, transform).serial();
    }
    /**
     * Maps this stream through a 1-to-many transform.
     *
     * @param transform A function mapping a stream element to an array of
     *   transformed elements.
     *
     * @returns A `DataStream` of transformed elements.
     */ flatmap(transform) {
        return new $33c7662a8c41dee3$var$FlatmapIterator(this, transform);
    }
    /**
     * Apply a function to every element of the stream.
     *
     * @param f A function to apply to each stream element.
     */ async forEachAsync(f) {
        return this.map(f).resolveFully();
    }
    /**
     * Apply a function to every element of the stream, forcing serial execution.
     *
     * @param f A function to apply to each stream element.  Should return 'true'
     *   to indicate that the stream should continue, or 'false' to cause it to
     *   terminate.
     */ async serialForEach(f) {
        return this.serialMapAsync(f).resolveWhile((x)=>x === true);
    }
    /**
     * Groups elements into batches, represented as arrays of elements.
     *
     * We can think of the elements of this iterator as 'rows' (even if they are
     * nested structures).  By the same token, consecutive values for a given
     * key within the elements form a 'column'.  This matches the usual sense of
     * 'row' and 'column' when processing tabular data (e.g., parsing a CSV).
     *
     * Thus, "Row-major" means that the resulting batch is simply a collection of
     * rows: `[row1, row2, row3, ...]`.  This is contrast to the column-major
     * form, which is needed for vectorized computation.
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @returns A `LazyIterator` of batches of elements, represented as arrays
     *   of the original element type.
     */ rowMajorBatch(batchSize, smallLastBatch = true) {
        return new $33c7662a8c41dee3$var$RowMajorBatchIterator(this, batchSize, smallLastBatch);
    }
    /**
     * Groups elements into batches, represented in column-major form.
     *
     * We can think of the elements of this iterator as 'rows' (even if they are
     * nested structures).  By the same token, consecutive values for a given
     * key within the elements form a 'column'.  This matches the usual sense of
     * 'row' and 'column' when processing tabular data (e.g., parsing a CSV).
     *
     * Thus, "column-major" means that the resulting batch is a (potentially
     * nested) structure representing the columns.  Each column entry, then,
     * contains a collection of the values found in that column for a range of
     * input elements.  This representation allows for vectorized computation, in
     * contrast to the row-major form.
     *
     * The inputs should all have the same nested structure (i.e., of arrays and
     * dicts).  The result is a single object with the same nested structure,
     * where the leaves are arrays collecting the values of the inputs at that
     * location (or, optionally, the result of a custom function applied to those
     * arrays).
     *
     * @param batchSize The number of elements desired per batch.
     * @param smallLastBatch Whether to emit the final batch when it has fewer
     *   than batchSize elements. Default true.
     * @param zipFn: (optional) A function that expects an array of elements at a
     *   single node of the object tree, and returns a `DeepMapResult`.  The
     *   `DeepMapResult` either provides a result value for that node (i.e.,
     *   representing the subtree), or indicates that the node should be processed
     *   recursively.  The default zipFn recurses as far as possible and places
     *   arrays at the leaves.
     * @returns A `LazyIterator` of batches of elements, represented as an object
     *   with collections at the leaves.
     */ columnMajorBatch(batchSize, smallLastBatch = true, // tslint:disable-next-line:no-any
    zipFn = (0, $jjiEr.zipToList)) {
        // First collect the desired number of input elements as a row-major batch.
        const rowBatches = this.rowMajorBatch(batchSize, smallLastBatch);
        // Now 'rotate' or 'pivot' the data, collecting all values from each column
        // in the batch (i.e., for each key within the elements) into an array.
        return rowBatches.map((x)=>(0, $jjiEr.deepZip)(x, zipFn));
    }
    /**
     * Concatenate this `LazyIterator` with another.
     *
     * @param iterator A `LazyIterator` to be concatenated onto this one.
     * @param baseErrorHandler An optional function that can intercept `Error`s
     *   raised during a `next()` call on the base stream.  This function can
     *   decide whether the error should be propagated, whether the error should
     *   be ignored, or whether the base stream should be terminated.
     * @returns A `LazyIterator`.
     */ concatenate(iterator, baseErrorHandler) {
        return new $33c7662a8c41dee3$export$22a7cbb11e3b9068($33c7662a8c41dee3$export$313b11d04150405f([
            this,
            iterator
        ]), baseErrorHandler);
    }
    /**
     * Limits this stream to return at most `count` items.
     *
     * @param count The maximum number of items to provide from the stream. If
     * a negative or undefined value is given, the entire stream is returned
     *   unaltered.
     */ take(count) {
        if (count < 0 || count == null) return this;
        return new $33c7662a8c41dee3$var$TakeIterator(this, count);
    }
    /**
     * Skips the first `count` items in this stream.
     *
     * @param count The number of items to skip.  If a negative or undefined
     * value is given, the entire stream is returned unaltered.
     */ skip(count) {
        if (count < 0 || count == null) return this;
        return new $33c7662a8c41dee3$var$SkipIterator(this, count);
    }
    /**
     * Prefetch the first `bufferSize` items in this stream.
     *
     * Note this prefetches Promises, but makes no guarantees about when those
     * Promises resolve.
     *
     * @param bufferSize: An integer specifying the number of elements to be
     *   prefetched.
     */ prefetch(bufferSize) {
        return new $33c7662a8c41dee3$export$7126304418df8697(this, bufferSize);
    }
    // TODO(soergel): deep sharded shuffle, where supported
    /**
     * Randomly shuffles the elements of this stream.
     *
     * @param bufferSize: An integer specifying the number of elements from
     * this stream from which the new stream will sample.
     * @param seed: (Optional.) An integer specifying the random seed that
     * will be used to create the distribution.
     */ shuffle(windowSize, seed) {
        return new $33c7662a8c41dee3$export$50d642f401310a09(this, windowSize, seed);
    }
    /**
     * Force an iterator to execute serially: each next() call will await the
     * prior one, so that they cannot execute concurrently.
     */ serial() {
        return new $33c7662a8c41dee3$var$SerialIterator(this);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on LazyIterator.  Unfortunately they can't be placed in separate files,
// due to resulting trouble with circular imports.
// ============================================================================
// Iterators that just extend LazyIterator directly
// ============================================================================
class $33c7662a8c41dee3$var$ArrayIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(items){
        super();
        this.items = items;
        this.trav = 0;
    }
    summary() {
        return `Array of ${this.items.length} items`;
    }
    async next() {
        if (this.trav >= this.items.length) return {
            value: null,
            done: true
        };
        const item = this.items[this.trav];
        this.trav++;
        return {
            value: (0, $4WG96.deepClone)(item),
            done: false
        };
    }
}
class $33c7662a8c41dee3$var$FunctionCallIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(nextFn){
        super();
        this.nextFn = nextFn;
    }
    summary() {
        return `Function call`;
    }
    async next() {
        try {
            return this.nextFn();
        } catch (e) {
            // Modify the error message but leave the stack trace intact
            e.message = `Error thrown while iterating through a dataset: ${e.message}`;
            throw e;
        }
    }
}
class $33c7662a8c41dee3$var$SerialIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream){
        super();
        this.upstream = upstream;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Serial`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        return this.upstream.next();
    }
}
class $33c7662a8c41dee3$var$SkipIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream, maxCount){
        super();
        this.upstream = upstream;
        this.maxCount = maxCount;
        // Local state that should not be clobbered by out-of-order execution.
        this.count = 0;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Skip`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        // TODO(soergel): consider tradeoffs of reading in parallel, eg.
        // collecting next() promises in an Array and then waiting for
        // Promise.all() of those. Benefit: pseudo-parallel execution.  Drawback:
        // maybe delayed GC.
        while(this.count++ < this.maxCount){
            const skipped = await this.upstream.next();
            // short-circuit if upstream is already empty
            if (skipped.done) return skipped;
            $d7Nxs.dispose(skipped.value);
        }
        return this.upstream.next();
    }
}
class $33c7662a8c41dee3$var$TakeIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream, maxCount){
        super();
        this.upstream = upstream;
        this.maxCount = maxCount;
        this.count = 0;
    }
    summary() {
        return `${this.upstream.summary()} -> Take`;
    }
    async next() {
        if (this.count++ >= this.maxCount) return {
            value: null,
            done: true
        };
        return this.upstream.next();
    }
}
// Note this batch just groups items into row-wise element arrays.
// Rotating these to a column-wise representation happens only at the dataset
// level.
class $33c7662a8c41dee3$var$RowMajorBatchIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream, batchSize, enableSmallLastBatch = true){
        super();
        this.upstream = upstream;
        this.batchSize = batchSize;
        this.enableSmallLastBatch = enableSmallLastBatch;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> RowMajorBatch`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        const batch = [];
        while(batch.length < this.batchSize){
            const item = await this.upstream.next();
            if (item.done) {
                if (this.enableSmallLastBatch && batch.length > 0) return {
                    value: batch,
                    done: false
                };
                return {
                    value: null,
                    done: true
                };
            }
            batch.push(item.value);
        }
        return {
            value: batch,
            done: false
        };
    }
}
class $33c7662a8c41dee3$var$FilterIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream, predicate){
        super();
        this.upstream = upstream;
        this.predicate = predicate;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> Filter`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        while(true){
            const item = await this.upstream.next();
            if (item.done || this.predicate(item.value)) return item;
            $d7Nxs.dispose(item.value);
        }
    }
}
class $33c7662a8c41dee3$var$MapIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> Map`;
    }
    async next() {
        const item = await this.upstream.next();
        if (item.done) return {
            value: null,
            done: true
        };
        const inputTensors = $gpWQN.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // That's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying
        // any intermediate Tensors.  Here we are concerned only about the
        // inputs.
        const mapped = this.transform(item.value);
        const outputTensors = $gpWQN.getTensorsInContainer(mapped);
        // TODO(soergel) faster intersection
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$gpWQN.isTensorInList(t, outputTensors)) t.dispose();
        return {
            value: mapped,
            done: false
        };
    }
}
class $33c7662a8c41dee3$var$ErrorHandlingLazyIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream, handler){
        super();
        this.upstream = upstream;
        this.handler = handler;
        this.count = 0;
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    summary() {
        return `${this.upstream.summary()} -> handleErrors`;
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        while(true)try {
            return await this.upstream.next();
        } catch (e) {
            if (!this.handler(e)) return {
                value: null,
                done: true
            };
        // If the handler returns true, loop and fetch the next upstream item.
        // If the upstream iterator throws an endless stream of errors, and if
        // the handler says to ignore them, then we loop forever here.  That is
        // the correct behavior-- it's up to the handler to decide when to stop.
        }
    }
}
class $33c7662a8c41dee3$var$AsyncMapIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> AsyncMap`;
    }
    async next() {
        const item = await this.upstream.next();
        if (item.done) return {
            value: null,
            done: true
        };
        const inputTensors = $gpWQN.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // That's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying
        // any intermediate Tensors.  Here we are concerned only about the
        // inputs.
        const mapped = await this.transform(item.value);
        const outputTensors = $gpWQN.getTensorsInContainer(mapped);
        // TODO(soergel) faster intersection
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$gpWQN.isTensorInList(t, outputTensors)) t.dispose();
        return {
            value: mapped,
            done: false
        };
    }
}
class $33c7662a8c41dee3$export$3c2cec00242a8bd8 extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(){
        super();
        this.outputQueue = new (0, $23k4j.GrowingRingBuffer)();
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    async serialNext() {
        // Fetch so that the queue contains at least one item if possible.
        // If the upstream source is exhausted, AND there are no items left in
        // the output queue, then this stream is also exhausted.
        while(this.outputQueue.length() === 0){
            // TODO(soergel): consider parallel reads.
            if (!await this.pump()) return {
                value: null,
                done: true
            };
        }
        return {
            value: this.outputQueue.shift(),
            done: false
        };
    }
}
class $33c7662a8c41dee3$var$FlatmapIterator extends $33c7662a8c41dee3$export$3c2cec00242a8bd8 {
    constructor(upstream, transform){
        super();
        this.upstream = upstream;
        this.transform = transform;
    }
    summary() {
        return `${this.upstream.summary()} -> Flatmap`;
    }
    async pump() {
        const item = await this.upstream.next();
        if (item.done) return false;
        const inputTensors = $gpWQN.getTensorsInContainer(item.value);
        // Careful: the transform may mutate the item in place.
        // that's why we have to remember the input Tensors above, and then
        // below dispose only those that were not passed through to the output.
        // Note too that the transform function is responsible for tidying any
        // intermediate Tensors.  Here we are concerned only about the inputs.
        const mappedArray = this.transform(item.value);
        const outputTensors = $gpWQN.getTensorsInContainer(mappedArray);
        this.outputQueue.pushAll(mappedArray);
        // TODO(soergel) faster intersection, and deduplicate outputTensors
        // TODO(soergel) move to tf.disposeExcept(in, out)?
        for (const t of inputTensors)if (!$gpWQN.isTensorInList(t, outputTensors)) t.dispose();
        return true;
    }
}
class $33c7662a8c41dee3$export$22a7cbb11e3b9068 extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(iterators, baseErrorHandler){
        super();
        this.baseErrorHandler = baseErrorHandler;
        // Strict Promise execution order:
        // a next() call may not even begin until the previous one completes.
        this.lastRead = null;
        // Local state that should not be clobbered by out-of-order execution.
        this.iterator = null;
        this.moreIterators = iterators;
    }
    summary() {
        const upstreamSummaries = 'TODO: fill in upstream of chained summaries';
        return `${upstreamSummaries} -> Chained`;
    }
    async next() {
        this.lastRead = this.readFromChain(this.lastRead);
        return this.lastRead;
    }
    async readFromChain(lastRead) {
        // Must await on the previous read since the previous read may have advanced
        // the stream of streams, from which we need to read.
        // This is unfortunate since we can't parallelize reads. Which means
        // prefetching of chained streams is a no-op.
        // One solution is to prefetch immediately upstream of this.
        await lastRead;
        if (this.iterator == null) {
            const iteratorResult = await this.moreIterators.next();
            if (iteratorResult.done) // No more streams to stream from.
            return {
                value: null,
                done: true
            };
            this.iterator = iteratorResult.value;
            if (this.baseErrorHandler != null) this.iterator = this.iterator.handleErrors(this.baseErrorHandler);
        }
        const itemResult = await this.iterator.next();
        if (itemResult.done) {
            this.iterator = null;
            return this.readFromChain(lastRead);
        }
        return itemResult;
    }
}
var $33c7662a8c41dee3$export$4b13032c4dd08391;
(function(ZipMismatchMode) {
    ZipMismatchMode[ZipMismatchMode["FAIL"] = 0] = "FAIL";
    ZipMismatchMode[ZipMismatchMode["SHORTEST"] = 1] = "SHORTEST";
    ZipMismatchMode[ZipMismatchMode["LONGEST"] = 2] = "LONGEST"; // use nulls for exhausted streams; use up the longest stream.
})($33c7662a8c41dee3$export$4b13032c4dd08391 || ($33c7662a8c41dee3$export$4b13032c4dd08391 = {}));
/**
 * Provides a `LazyIterator` that zips together an array, dict, or nested
 * structure of `LazyIterator`s (and perhaps additional constants).
 *
 * The underlying streams must provide elements in a consistent order such
 * that they correspond.
 *
 * Typically, the underlying streams should have the same number of
 * elements. If they do not, the behavior is determined by the
 * `mismatchMode` argument.
 *
 * The nested structure of the `iterators` argument determines the
 * structure of elements in the resulting iterator.
 *
 * Doing this in a concurrency-safe way requires some trickery.  In
 * particular, we want this stream to return the elements from the
 * underlying streams in the correct order according to when next() was
 * called, even if the resulting Promises resolve in a different order.
 *
 * @param iterators: An array or object containing LazyIterators at the
 * leaves.
 * @param mismatchMode: Determines what to do when one underlying iterator
 * is exhausted before the others.  `ZipMismatchMode.FAIL` (the default)
 * causes an error to be thrown in this case.  `ZipMismatchMode.SHORTEST`
 * causes the zipped iterator to terminate with the furst underlying
 * streams, so elements remaining on the longer streams are ignored.
 * `ZipMismatchMode.LONGEST` causes the zipped stream to continue, filling
 * in nulls for the exhausted streams, until all streams are exhausted.
 */ class $33c7662a8c41dee3$var$ZipIterator extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(iterators, mismatchMode = $33c7662a8c41dee3$export$4b13032c4dd08391.FAIL){
        super();
        this.iterators = iterators;
        this.mismatchMode = mismatchMode;
        this.count = 0;
        this.currentPromise = null;
    }
    summary() {
        const upstreamSummaries = 'TODO: fill in upstream of zip summaries';
        return `{${upstreamSummaries}} -> Zip`;
    }
    async nextState(afterState) {
        // This chaining ensures that the underlying next() are not even called
        // before the previous ones have resolved.
        await afterState;
        // Collect underlying iterator "done" signals as a side effect in
        // getNext()
        let numIterators = 0;
        let iteratorsDone = 0;
        function getNext(container) {
            if (container instanceof $33c7662a8c41dee3$export$b7f78d762925efef) {
                const result = container.next();
                return {
                    value: result.then((x)=>{
                        numIterators++;
                        if (x.done) iteratorsDone++;
                        return x.value;
                    }),
                    recurse: false
                };
            } else return {
                value: null,
                recurse: true
            };
        }
        const mapped = await (0, $jjiEr.deepMapAndAwaitAll)(this.iterators, getNext);
        if (numIterators === iteratorsDone) // The streams have all ended.
        return {
            value: null,
            done: true
        };
        if (iteratorsDone > 0) switch(this.mismatchMode){
            case $33c7662a8c41dee3$export$4b13032c4dd08391.FAIL:
                throw new Error('Zipped streams should have the same length. ' + `Mismatched at element ${this.count}.`);
            case $33c7662a8c41dee3$export$4b13032c4dd08391.SHORTEST:
                return {
                    value: null,
                    done: true
                };
            case $33c7662a8c41dee3$export$4b13032c4dd08391.LONGEST:
            default:
        }
        this.count++;
        return {
            value: mapped,
            done: false
        };
    }
    async next() {
        this.currentPromise = this.nextState(this.currentPromise);
        return this.currentPromise;
    }
}
class $33c7662a8c41dee3$export$7126304418df8697 extends $33c7662a8c41dee3$export$b7f78d762925efef {
    constructor(upstream, bufferSize){
        super();
        this.upstream = upstream;
        this.bufferSize = bufferSize;
        this.buffer = new (0, $8Pn2i.RingBuffer)(bufferSize);
    }
    summary() {
        return `${this.upstream.summary()} -> Prefetch`;
    }
    /**
     * Refill the prefetch buffer.  Returns only after the buffer is full, or
     * the upstream source is exhausted.
     */ refill() {
        while(!this.buffer.isFull()){
            const v = this.upstream.next();
            this.buffer.push(v);
        }
    }
    next() {
        this.refill();
        // This shift will never throw an error because the buffer is always
        // full after a refill. If the stream is exhausted, the buffer will be
        // full of Promises that will resolve to the end-of-stream signal.
        return this.buffer.shift();
    }
}
class $33c7662a8c41dee3$export$50d642f401310a09 extends $33c7662a8c41dee3$export$7126304418df8697 {
    constructor(upstream, windowSize, seed){
        super(upstream, windowSize);
        this.upstream = upstream;
        this.windowSize = windowSize;
        // Local state that should not be clobbered by out-of-order execution.
        this.upstreamExhausted = false;
        this.random = $23NWZ.alea(seed || $lBDHD.now().toString());
        this.lastRead = Promise.resolve({
            value: null,
            done: false
        });
    }
    async next() {
        // This sets this.lastRead to a new Promise right away, as opposed to
        // saying `await this.lastRead; this.lastRead = this.serialNext();` which
        // would not work because this.nextRead would be updated only after the
        // promise resolves.
        this.lastRead = this.lastRead.then(()=>this.serialNext());
        return this.lastRead;
    }
    randomInt(max) {
        return Math.floor(this.random() * max);
    }
    chooseIndex() {
        return this.randomInt(this.buffer.length());
    }
    async serialNext() {
        // TODO(soergel): consider performance
        if (!this.upstreamExhausted) this.refill();
        while(!this.buffer.isEmpty()){
            const chosenIndex = this.chooseIndex();
            const result = await this.buffer.shuffleExcise(chosenIndex);
            if (result.done) this.upstreamExhausted = true;
            else {
                this.refill();
                return result;
            }
        }
        return {
            value: null,
            done: true
        };
    }
}

});
parcelRegister("4WG96", function(module, exports) {

$parcel$export(module.exports, "deepClone", function () { return $399d457e2019f81a$export$b7d58db314e0ac27; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $3pVUH = parcelRequire("3pVUH");

var $jjiEr = parcelRequire("jjiEr");
function $399d457e2019f81a$export$b7d58db314e0ac27(container) {
    return (0, $jjiEr.deepMap)(container, $399d457e2019f81a$var$cloneIfTensor);
}
// tslint:disable-next-line: no-any
function $399d457e2019f81a$var$cloneIfTensor(item) {
    if (item instanceof $3pVUH.Tensor) return {
        value: item.clone(),
        recurse: false
    };
    else if ((0, $jjiEr.isIterable)(item)) return {
        value: null,
        recurse: true
    };
    else return {
        value: item,
        recurse: false
    };
}

});
parcelRegister("jjiEr", function(module, exports) {

$parcel$export(module.exports, "deepMap", function () { return $e0ee4272a046e279$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "isIterable", function () { return $e0ee4272a046e279$export$9652023d9040757; });
$parcel$export(module.exports, "deepZip", function () { return $e0ee4272a046e279$export$de254daced10325b; });
$parcel$export(module.exports, "zipToList", function () { return $e0ee4272a046e279$export$5af6628663604bcb; });
$parcel$export(module.exports, "deepMapAndAwaitAll", function () { return $e0ee4272a046e279$export$20eea0c38ad5b6db; });
$parcel$export(module.exports, "canTensorify", function () { return $e0ee4272a046e279$export$2714d9e1645b25ab; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");
function $e0ee4272a046e279$export$ce7eaaed37329a1b(input, mapFn) {
    return $e0ee4272a046e279$var$deepMapInternal(input, mapFn);
}
/**
 * @param seen: A Map of known object mappings (i.e., memoized results of
 *   `mapFn()`)
 * @param containedIn: An set containing objects on the reference path currently
 *   being processed (used to detect cycles).
 */ function $e0ee4272a046e279$var$deepMapInternal(input, mapFn, seen = new Map(), containedIn = new Set()) {
    if (input == null) return null;
    if (typeof Blob === 'function' && input instanceof Blob) return input.slice();
    if (containedIn.has(input)) throw new Error('Circular references are not supported.');
    if (seen.has(input)) return seen.get(input);
    const result = mapFn(input);
    if (result.recurse && result.value !== null) throw new Error('A deep map function may not return both a value and recurse=true.');
    if (!result.recurse) {
        seen.set(input, result.value);
        return result.value;
    } else if ($e0ee4272a046e279$export$9652023d9040757(input)) {
        // tslint:disable-next-line:no-any
        const mappedIterable = Array.isArray(input) ? [] : {};
        containedIn.add(input);
        for(const k in input){
            const child = input[k];
            const childResult = $e0ee4272a046e279$var$deepMapInternal(child, mapFn, seen, containedIn);
            mappedIterable[k] = childResult;
        }
        containedIn.delete(input);
        if (input.__proto__) mappedIterable.__proto__ = input.__proto__;
        return mappedIterable;
    } else throw new Error(`Can't recurse into non-iterable type: ${input}`);
}
function $e0ee4272a046e279$export$de254daced10325b(inputs, zipFn = $e0ee4272a046e279$export$5af6628663604bcb) {
    return $e0ee4272a046e279$var$deepZipInternal(inputs, zipFn);
}
/**
 * @param containedIn: An set containing objects on the reference path currently
 *   being processed (used to detect cycles).
 */ function $e0ee4272a046e279$var$deepZipInternal(inputs, zipFn, containedIn = new Set()) {
    // The recursion follows the structure of input 0; it's assumed that all the
    // other inputs have the same structure.
    const input = inputs[0];
    if (containedIn.has(input)) throw new Error('Circular references are not supported.');
    const result = zipFn(inputs);
    if (result.recurse && result.value !== null) throw new Error('A deep zip function may not return both a value and recurse=true.');
    if (!result.recurse) return result.value;
    else if ($e0ee4272a046e279$export$9652023d9040757(input)) {
        // tslint:disable-next-line:no-any
        const mappedIterable = Array.isArray(input) ? [] : {};
        containedIn.add(input);
        for(const k in input){
            const children = inputs.map((x)=>x[k]);
            const childResult = $e0ee4272a046e279$var$deepZipInternal(children, zipFn, containedIn);
            mappedIterable[k] = childResult;
        }
        containedIn.delete(input);
        return mappedIterable;
    } else throw new Error(`Can't recurse into non-iterable type: ${input}`);
}
function $e0ee4272a046e279$export$5af6628663604bcb(x) {
    if (x === null) return null;
    // TODO(soergel): validate array type?
    if ($e0ee4272a046e279$export$9652023d9040757(x[0])) return {
        value: null,
        recurse: true
    };
    else return {
        value: x,
        recurse: false
    };
}
async function $e0ee4272a046e279$export$20eea0c38ad5b6db(input, mapFn) {
    const seen = new Map();
    // First do a normal deepMap, collecting Promises in 'seen' as a side effect.
    $e0ee4272a046e279$var$deepMapInternal(input, mapFn, seen);
    // Replace the Promises in 'seen' in place.
    // Note TypeScript provides no async map iteration, and regular map iteration
    // is broken too, so sadly we have to do Array.from() to make it work.
    // (There's no advantage to Promise.all(), and that would be tricky anyway.)
    for (const key of Array.from(seen.keys())){
        const value = seen.get(key);
        if ($lBDHD.isPromise(value)) {
            const mappedValue = await value;
            seen.set(key, mappedValue);
        }
    }
    // Normal deepMap again, this time filling in the resolved values.
    // It's unfortunate that we have to do two passes.
    // TODO(soergel): test performance and think harder about a fast solution.
    const result = $e0ee4272a046e279$var$deepMapInternal(input, mapFn, seen);
    return result;
}

function $e0ee4272a046e279$export$9652023d9040757(obj) {
    let isTextDecoder = false;
    if ($tdutJ.env().get('IS_BROWSER')) isTextDecoder = obj instanceof TextDecoder;
    else {
        // tslint:disable-next-line:no-require-imports
        const { StringDecoder: StringDecoder } = (parcelRequire("9XjBr"));
        isTextDecoder = obj instanceof StringDecoder;
    }
    return obj != null && !ArrayBuffer.isView(obj) && (Array.isArray(obj) || typeof obj === 'object' && !(obj instanceof $3pVUH.Tensor) && !(obj instanceof Promise) && !isTextDecoder);
}
function $e0ee4272a046e279$export$2714d9e1645b25ab(obj) {
    return obj == null || $e0ee4272a046e279$var$isPrimitive(obj) || Array.isArray(obj) || typeof obj === 'object' && obj instanceof $3pVUH.Tensor || $lBDHD.isTypedArray(obj);
}
/**
 * Returns true if the given `value` is a primitive type. Otherwise returns
 * false. This is equivalant to node util.isPrimitive
 */ function $e0ee4272a046e279$var$isPrimitive(value) {
    return value === null || typeof value !== 'object' && typeof value !== 'function';
}

});


parcelRegister("23k4j", function(module, exports) {

$parcel$export(module.exports, "GrowingRingBuffer", function () { return $17eb6dcd843c4a8a$export$bd4eb95ce427db4d; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $8Pn2i = parcelRequire("8Pn2i");
class $17eb6dcd843c4a8a$export$bd4eb95ce427db4d extends (0, $8Pn2i.RingBuffer) {
    /**
     * Constructs a `GrowingRingBuffer`.
     */ constructor(){
        super($17eb6dcd843c4a8a$export$bd4eb95ce427db4d.INITIAL_CAPACITY);
    }
    isFull() {
        return false;
    }
    push(value) {
        if (super.isFull()) this.expand();
        super.push(value);
    }
    unshift(value) {
        if (super.isFull()) this.expand();
        super.unshift(value);
    }
    /**
     * Doubles the capacity of the buffer.
     */ expand() {
        const newCapacity = this.capacity * 2;
        const newData = new Array(newCapacity);
        const len = this.length();
        // Rotate the buffer to start at index 0 again, since we can't just
        // allocate more space at the end.
        for(let i = 0; i < len; i++)newData[i] = this.get(this.wrap(this.begin + i));
        this.data = newData;
        this.capacity = newCapacity;
        this.doubledCapacity = 2 * this.capacity;
        this.begin = 0;
        this.end = len;
    }
}
$17eb6dcd843c4a8a$export$bd4eb95ce427db4d.INITIAL_CAPACITY = 32;

});
parcelRegister("8Pn2i", function(module, exports) {

$parcel$export(module.exports, "RingBuffer", function () { return $66d4f49ab620f6dc$export$575ef0eeec6e42f5; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /**
 * A ring buffer, providing O(1) FIFO, LIFO, and related operations.
 */ class $66d4f49ab620f6dc$export$575ef0eeec6e42f5 {
    /**
     * Constructs a `RingBuffer`.
     * @param capacity The number of items that the buffer can accomodate.
     */ constructor(capacity){
        this.capacity = capacity;
        // Note we store the indices in the range 0 <= index < 2*capacity.
        // This allows us to distinguish the full from the empty case.
        // See https://www.snellman.net/blog/archive/2016-12-13-ring-buffers/
        this.begin = 0; // inclusive
        this.end = 0; // exclusive
        if (capacity == null) throw new RangeError('Can\'t create a ring buffer of unknown capacity.');
        if (capacity < 1) throw new RangeError('Can\'t create ring buffer of capacity < 1.');
        this.data = new Array(capacity);
        this.doubledCapacity = 2 * capacity;
    }
    /**
     * Map any index into the range 0 <= index < 2*capacity.
     */ wrap(index) {
        // don't trust % on negative numbers
        while(index < 0)index += this.doubledCapacity;
        return index % this.doubledCapacity;
    }
    get(index) {
        if (index < 0) throw new RangeError('Can\'t get item at a negative index.');
        return this.data[index % this.capacity];
    }
    set(index, value) {
        if (index < 0) throw new RangeError('Can\'t set item at a negative index.');
        this.data[index % this.capacity] = value;
    }
    /**
     * Returns the current number of items in the buffer.
     */ length() {
        let length = this.end - this.begin;
        if (length < 0) length = this.doubledCapacity + length;
        return length;
    }
    /**
     * Reports whether the buffer is full.
     * @returns true if the number of items in the buffer equals its capacity, and
     *   false otherwise.
     */ isFull() {
        return this.length() === this.capacity;
    }
    /**
     * Reports whether the buffer is empty.
     * @returns true if the number of items in the buffer equals zero, and
     *   false otherwise.
     */ isEmpty() {
        return this.length() === 0;
    }
    /**
     * Adds an item to the end of the buffer.
     */ push(value) {
        if (this.isFull()) throw new RangeError('Ring buffer is full.');
        this.set(this.end, value);
        this.end = this.wrap(this.end + 1);
    }
    /**
     * Adds many items to the end of the buffer, in order.
     */ pushAll(values) {
        for (const value of values)this.push(value);
    }
    /**
     * Removes and returns the last item in the buffer.
     */ pop() {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        this.end = this.wrap(this.end - 1);
        const result = this.get(this.end);
        this.set(this.end, undefined);
        return result;
    }
    /**
     * Adds an item to the beginning of the buffer.
     */ unshift(value) {
        if (this.isFull()) throw new RangeError('Ring buffer is full.');
        this.begin = this.wrap(this.begin - 1);
        this.set(this.begin, value);
    }
    /**
     * Removes and returns the first item in the buffer.
     */ shift() {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        const result = this.get(this.begin);
        this.set(this.begin, undefined);
        this.begin = this.wrap(this.begin + 1);
        return result;
    }
    /**
     * Removes and returns a specific item in the buffer, and moves the last item
     * to the vacated slot.  This is useful for implementing a shuffling stream.
     * Note that this operation necessarily scrambles the original order.
     *
     * @param relativeIndex: the index of the item to remove, relative to the
     *   first item in the buffer (e.g., hiding the ring nature of the underlying
     *   storage).
     */ shuffleExcise(relativeIndex) {
        if (this.isEmpty()) throw new RangeError('Ring buffer is empty.');
        const index = this.wrap(this.begin + relativeIndex);
        const result = this.get(index);
        this.set(index, this.pop());
        return result;
    }
}

});




parcelRegister("607KO", function(module, exports) {

$parcel$export(module.exports, "CSVDataset", function () { return $45e8c1f855165a28$export$1e441948ffa5f20a; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $5kCnl = parcelRequire("5kCnl");

var $4vPKd = parcelRequire("4vPKd");
const $45e8c1f855165a28$var$CODE_QUOTE = '"';
const $45e8c1f855165a28$var$STATE_OUT = Symbol('out');
const $45e8c1f855165a28$var$STATE_FIELD = Symbol('field');
const $45e8c1f855165a28$var$STATE_QUOTE = Symbol('quote');
const $45e8c1f855165a28$var$STATE_QUOTE_AFTER_QUOTE = Symbol('quoteafterquote');
const $45e8c1f855165a28$var$STATE_WITHIN_QUOTE_IN_QUOTE = Symbol('quoteinquote');
class $45e8c1f855165a28$export$1e441948ffa5f20a extends (0, $5kCnl.Dataset) {
    /**
     * Returns column names of the csv dataset. If `configuredColumnsOnly` is
     * true, return column names in `columnConfigs`. If `configuredColumnsOnly` is
     * false and `columnNames` is provided, `columnNames`. If
     * `configuredColumnsOnly` is false and `columnNames` is not provided, return
     * all column names parsed from the csv file. For example usage please go to
     * `tf.data.csv`.
     *
     * @doc {heading: 'Data', subheading: 'Classes'}
     */ async columnNames() {
        if (!this.columnNamesValidated) await this.setColumnNames();
        return this.configuredColumnsOnly ? Object.keys(this.columnConfigs) : this.fullColumnNames;
    }
    /* 1) If `columnNames` is provided as string[], use this string[] as output
     * keys in corresponding order. The length must match the number of inferred
     * columns if `hasHeader` is true .
     * 2) If `columnNames` is not provided, parse header line as `columnNames` if
     * hasHeader is true. If `hasHeader` is false, throw an error.
     * 3) If `columnConfigs` is provided, all the keys in `columnConfigs` must
     * exist in parsed `columnNames`.
     */ async setColumnNames() {
        const columnNamesFromFile = await this.maybeReadHeaderLine();
        if (!this.fullColumnNames && !columnNamesFromFile) // Throw an error if columnNames is not provided and no header line.
        throw new Error('Column names must be provided if there is no header line.');
        else if (this.fullColumnNames && columnNamesFromFile) // Check provided columnNames match header line.
        (0, $lBDHD).assert(columnNamesFromFile.length === this.fullColumnNames.length, ()=>'The length of provided columnNames (' + this.fullColumnNames.length.toString() + ') does not match the length of the header line read from ' + 'file (' + columnNamesFromFile.length.toString() + ').');
        if (!this.fullColumnNames) this.fullColumnNames = columnNamesFromFile;
        // Check if there are duplicate column names.
        const counts = this.fullColumnNames.reduce((countAcc, name)=>{
            countAcc[name] = countAcc[name] + 1 || 1;
            return countAcc;
        }, {});
        const duplicateNames = Object.keys(counts).filter((name)=>counts[name] > 1);
        (0, $lBDHD).assert(duplicateNames.length === 0, ()=>'Duplicate column names found: ' + duplicateNames.toString());
        // Check if keys in columnConfigs match columnNames.
        if (this.columnConfigs) for (const key of Object.keys(this.columnConfigs)){
            const index = this.fullColumnNames.indexOf(key);
            if (index === -1) throw new Error('The key "' + key + '" provided in columnConfigs does not match any of the column ' + 'names (' + this.fullColumnNames.toString() + ').');
        }
        this.columnNamesValidated = true;
    }
    async maybeReadHeaderLine() {
        if (this.hasHeader) {
            const iter = await this.base.iterator();
            const firstElement = await iter.next();
            if (firstElement.done) throw new Error('No data was found for CSV parsing.');
            const firstLine = firstElement.value;
            const headers = this.parseRow(firstLine, false);
            return headers;
        } else return null;
    }
    /**
     * Create a `CSVDataset`.
     *
     * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
     * @param csvConfig (Optional) A CSVConfig object that contains configurations
     *     of reading and decoding from CSV file(s).
     *
     *     hasHeader: (Optional) A boolean value that indicates whether the first
     *     row of provided CSV file is a header line with column names, and should
     *     not be included in the data. Defaults to `true`.
     *
     *     columnNames: (Optional) A list of strings that corresponds to
     *     the CSV column names, in order. If provided, it ignores the column
     *     names inferred from the header row. If not provided, infers the column
     *     names from the first row of the records. If hasHeader is false and
     *     columnNames is not provided, this method throws an error.
     *
     *     columnConfigs: (Optional) A dictionary whose key is column names, value
     *     is an object stating if this column is required, column's data type,
     *     default value, and if this column is label. If provided, keys must
     *     correspond to names provided in columnNames or inferred from the file
     *     header lines. If isLabel is true any column, returns an array of two
     *     items: the first item is a dict of features key/value pairs, the second
     *     item is a dict of labels key/value pairs. If no feature is marked as
     *     label, returns a dict of features only.
     *
     *     configuredColumnsOnly (Optional) If true, only columns provided in
     *     columnConfigs will be parsed and provided during iteration.
     *
     *     delimiter (Optional) The string used to parse each line of the input
     *     file. Defaults to `,`.
     */ constructor(input, csvConfig){
        super();
        this.input = input;
        this.hasHeader = true;
        this.fullColumnNames = null;
        this.columnNamesValidated = false;
        this.columnConfigs = null;
        this.configuredColumnsOnly = false;
        this.delimiter = ',';
        this.delimWhitespace = false;
        this.base = new (0, $4vPKd.TextLineDataset)(input);
        if (!csvConfig) csvConfig = {};
        this.hasHeader = csvConfig.hasHeader === false ? false : true;
        this.fullColumnNames = csvConfig.columnNames;
        this.columnConfigs = csvConfig.columnConfigs;
        this.configuredColumnsOnly = csvConfig.configuredColumnsOnly;
        if (csvConfig.delimWhitespace) {
            (0, $lBDHD).assert(csvConfig.delimiter == null, ()=>'Delimiter should not be provided when delimWhitespace is true.');
            this.delimWhitespace = true;
            this.delimiter = ' ';
        } else this.delimiter = csvConfig.delimiter ? csvConfig.delimiter : ',';
    }
    async iterator() {
        if (!this.columnNamesValidated) await this.setColumnNames();
        let lines = await this.base.iterator();
        if (this.hasHeader) // We previously read the first line to get the columnNames.
        // Now that we're providing data, skip it.
        lines = lines.skip(1);
        return lines.map((x)=>this.makeDataElement(x));
    }
    makeDataElement(line) {
        const values = this.parseRow(line);
        const features = {};
        const labels = {};
        for(let i = 0; i < this.fullColumnNames.length; i++){
            const key = this.fullColumnNames[i];
            const config = this.columnConfigs ? this.columnConfigs[key] : null;
            if (this.configuredColumnsOnly && !config) continue;
            else {
                const value = values[i];
                let parsedValue = null;
                if (value === '') {
                    // If default value is provided, use it. If default value is not
                    // provided, set as undefined.
                    if (config && config.default !== undefined) parsedValue = config.default;
                    else if (config && (config.required || config.isLabel)) throw new Error(`Required column ${key} is empty in this line: ${line}`);
                    else parsedValue = undefined;
                } else {
                    // A value is present, so parse it based on type
                    const valueAsNum = Number(value);
                    if (isNaN(valueAsNum)) {
                        // The value is a string and this column is declared as boolean
                        // in config, parse it as boolean.
                        if (config && config.dtype === 'bool') parsedValue = this.getBoolean(value);
                        else // Set value as string
                        parsedValue = value;
                    } else if (!config || !config.dtype) // If this value is a number and no type config is provided, return
                    // it as number.
                    parsedValue = valueAsNum;
                    else // If this value is a number and data type is provided, parse it
                    // according to provided data type.
                    switch(config.dtype){
                        case 'float32':
                            parsedValue = valueAsNum;
                            break;
                        case 'int32':
                            parsedValue = Math.floor(valueAsNum);
                            break;
                        case 'bool':
                            parsedValue = this.getBoolean(value);
                            break;
                        default:
                            parsedValue = valueAsNum;
                    }
                }
                // Check if this column is label.
                config && config.isLabel ? labels[key] = parsedValue : features[key] = parsedValue;
            }
        }
        // If label exists, return an object of features and labels as {xs:features,
        // ys:labels}, otherwise return features only.
        if (Object.keys(labels).length === 0) return features;
        else return {
            xs: features,
            ys: labels
        };
    }
    getBoolean(value) {
        if (value === '1' || value.toLowerCase() === 'true') return 1;
        else return 0;
    }
    // adapted from https://beta.observablehq.com/@mbostock/streaming-csv
    parseRow(line, validateElementCount = true) {
        const result = [];
        let readOffset = 0;
        const readLength = line.length;
        let currentState = $45e8c1f855165a28$var$STATE_OUT;
        // Goes through the line to parse quote.
        for(let i = 0; i < readLength; i++)switch(currentState){
            // Before enter a new field
            case $45e8c1f855165a28$var$STATE_OUT:
                switch(line.charAt(i)){
                    // Enter a quoted field
                    case $45e8c1f855165a28$var$CODE_QUOTE:
                        readOffset = i + 1;
                        currentState = $45e8c1f855165a28$var$STATE_QUOTE;
                        break;
                    // Read an empty field
                    case this.delimiter:
                        readOffset = i + 1;
                        // If delimiter is white space and configured to collapse
                        // multiple white spaces, ignore this white space.
                        if (this.delimiter === ' ' && this.delimWhitespace) break;
                        result.push('');
                        currentState = $45e8c1f855165a28$var$STATE_OUT;
                        break;
                    // Enter an unquoted field
                    default:
                        currentState = $45e8c1f855165a28$var$STATE_FIELD;
                        readOffset = i;
                        break;
                }
                break;
            // In an unquoted field
            case $45e8c1f855165a28$var$STATE_FIELD:
                switch(line.charAt(i)){
                    // Exit an unquoted field, add it to result
                    case this.delimiter:
                        result.push(line.substring(readOffset, i));
                        currentState = $45e8c1f855165a28$var$STATE_OUT;
                        readOffset = i + 1;
                        break;
                    default:
                }
                break;
            // In a quoted field
            case $45e8c1f855165a28$var$STATE_QUOTE:
                switch(line.charAt(i)){
                    // Read a quote after a quote
                    case $45e8c1f855165a28$var$CODE_QUOTE:
                        currentState = $45e8c1f855165a28$var$STATE_QUOTE_AFTER_QUOTE;
                        break;
                    default:
                }
                break;
            // This state means it's right after a second quote in a field
            case $45e8c1f855165a28$var$STATE_QUOTE_AFTER_QUOTE:
                switch(line.charAt(i)){
                    // Finished a quoted field
                    case this.delimiter:
                        result.push(line.substring(readOffset, i - 1));
                        currentState = $45e8c1f855165a28$var$STATE_OUT;
                        readOffset = i + 1;
                        break;
                    // Finished a quoted part in a quoted field
                    case $45e8c1f855165a28$var$CODE_QUOTE:
                        currentState = $45e8c1f855165a28$var$STATE_QUOTE;
                        break;
                    // In a quoted part in a quoted field
                    default:
                        currentState = $45e8c1f855165a28$var$STATE_WITHIN_QUOTE_IN_QUOTE;
                        break;
                }
                break;
            case $45e8c1f855165a28$var$STATE_WITHIN_QUOTE_IN_QUOTE:
                switch(line.charAt(i)){
                    // Exit a quoted part in a quoted field
                    case $45e8c1f855165a28$var$CODE_QUOTE:
                        currentState = $45e8c1f855165a28$var$STATE_QUOTE;
                        break;
                    default:
                }
                break;
            default:
        }
        // Adds last item based on if it is quoted.
        if (currentState === $45e8c1f855165a28$var$STATE_QUOTE_AFTER_QUOTE) result.push(line.substring(readOffset, readLength - 1));
        else result.push(line.substring(readOffset));
        // Check if each row has the same number of elements as column names.
        if (validateElementCount && result.length !== this.fullColumnNames.length) throw new Error(`Invalid row in csv file. Should have ${this.fullColumnNames.length} elements in a row, but got ${result}`);
        return result;
    }
} // TODO(soergel): add more basic datasets for parity with tf.data
 // tf.data.FixedLengthRecordDataset()
 // tf.data.TFRecordDataset()

});
parcelRegister("4vPKd", function(module, exports) {

$parcel$export(module.exports, "TextLineDataset", function () { return $3492320c8faf974a$export$e3ec11e2ed15d2cb; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $5kCnl = parcelRequire("5kCnl");
class $3492320c8faf974a$export$e3ec11e2ed15d2cb extends (0, $5kCnl.Dataset) {
    /**
     * Create a `TextLineDataset`.
     *
     * @param input A `DataSource` providing a chunked, UTF8-encoded byte stream.
     */ constructor(input){
        super();
        this.input = input;
    }
    async iterator() {
        const inputIterator = await this.input.iterator();
        const utf8Iterator = inputIterator.decodeUTF8();
        const lineIterator = utf8Iterator.split('\n').map((line)=>{
            // Windows/DOS format text file has extra line breaker at the end of line.
            if (line.endsWith('\r')) line = line.slice(0, -1);
            return line;
        });
        return lineIterator;
    }
}

});


parcelRegister("iSIxo", function(module, exports) {
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $5kCnl = parcelRequire("5kCnl");

var $607KO = parcelRequire("607KO");

var $4rCj9 = parcelRequire("4rCj9");

var $lmhvM = parcelRequire("lmhvM");

var $7xEUa = parcelRequire("7xEUa");

var $l0gjN = parcelRequire("l0gjN");
function $dbefd16248c4ecd1$export$901ba78aa04f49da(source, csvConfig = {}) {
    return new (0, $607KO.CSVDataset)(new (0, $l0gjN.URLDataSource)(source), csvConfig);
}
function $dbefd16248c4ecd1$export$86951950244e2001(f) {
    const iter = (0, $4rCj9.iteratorFromFunction)(f);
    return (0, $5kCnl.datasetFromIteratorFn)(async ()=>iter);
}
function $dbefd16248c4ecd1$export$2b513308e642d699(generator) {
    return (0, $5kCnl.datasetFromIteratorFn)(async ()=>{
        const gen = await generator();
        return (0, $4rCj9.iteratorFromFunction)(()=>gen.next());
    });
}
async function $dbefd16248c4ecd1$export$62c2c555d8a25fb5(webcamVideoElement, webcamConfig) {
    return (0, $7xEUa.WebcamIterator).create(webcamVideoElement, webcamConfig);
}
async function $dbefd16248c4ecd1$export$e852da8bac022cf9(microphoneConfig) {
    return (0, $lmhvM.MicrophoneIterator).create(microphoneConfig);
}

});
parcelRegister("lmhvM", function(module, exports) {

$parcel$export(module.exports, "MicrophoneIterator", function () { return $f8c93c76e0e41d73$export$e44e755604080137; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $eZfvk = parcelRequire("eZfvk");
var $lBDHD = parcelRequire("lBDHD");

var $4rCj9 = parcelRequire("4rCj9");
class $f8c93c76e0e41d73$export$e44e755604080137 extends (0, $4rCj9.LazyIterator) {
    constructor(microphoneConfig){
        super();
        this.microphoneConfig = microphoneConfig;
        this.isClosed = false;
        this.fftSize = microphoneConfig.fftSize || 1024;
        const fftSizeLog2 = Math.log2(this.fftSize);
        if (this.fftSize < 0 || fftSizeLog2 < 4 || fftSizeLog2 > 14 || !Number.isInteger(fftSizeLog2)) throw new Error(`Invalid fftSize: it must be a power of 2 between ` + `2 to 4 and 2 to 14, but got ${this.fftSize}`);
        this.numFrames = microphoneConfig.numFramesPerSpectrogram || 43;
        this.sampleRateHz = microphoneConfig.sampleRateHz;
        this.columnTruncateLength = microphoneConfig.columnTruncateLength || this.fftSize;
        this.audioTrackConstraints = microphoneConfig.audioTrackConstraints;
        this.smoothingTimeConstant = microphoneConfig.smoothingTimeConstant || 0;
        this.includeSpectrogram = microphoneConfig.includeSpectrogram === false ? false : true;
        this.includeWaveform = microphoneConfig.includeWaveform === true ? true : false;
        if (!this.includeSpectrogram && !this.includeWaveform) throw new Error("Both includeSpectrogram and includeWaveform are false. At least one type of data should be returned.");
    }
    summary() {
        return `microphone`;
    }
    // Construct a MicrophoneIterator and start the audio stream.
    static async create(microphoneConfig = {}) {
        if (!(0, $tdutJ.env)().get('IS_BROWSER')) throw new Error('microphone API is only supported in browser environment.');
        const microphoneIterator = new $f8c93c76e0e41d73$export$e44e755604080137(microphoneConfig);
        // Call async function start() to initialize the audio stream.
        await microphoneIterator.start();
        return microphoneIterator;
    }
    // Start the audio stream and FFT.
    async start() {
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                audio: this.audioTrackConstraints == null ? true : this.audioTrackConstraints,
                video: false
            });
        } catch (e) {
            throw new Error(`Error thrown while initializing video stream: ${e.message}`);
        }
        if (!this.stream) throw new Error('Could not obtain audio from microphone.');
        const ctxConstructor = // tslint:disable-next-line:no-any
        window.AudioContext || window.webkitAudioContext;
        this.audioContext = new ctxConstructor();
        if (!this.sampleRateHz) // If sample rate is not provided, use the available sample rate on
        // device.
        this.sampleRateHz = this.audioContext.sampleRate;
        else if (this.audioContext.sampleRate !== this.sampleRateHz) throw new Error(`Mismatch in sampling rate: ` + `Expected: ${this.sampleRateHz}; ` + `Actual: ${this.audioContext.sampleRate}`);
        const streamSource = this.audioContext.createMediaStreamSource(this.stream);
        this.analyser = this.audioContext.createAnalyser();
        this.analyser.fftSize = this.fftSize * 2;
        this.analyser.smoothingTimeConstant = this.smoothingTimeConstant;
        streamSource.connect(this.analyser);
        this.freqData = new Float32Array(this.fftSize);
        this.timeData = new Float32Array(this.fftSize);
        return;
    }
    async next() {
        if (this.isClosed) return {
            value: null,
            done: true
        };
        let spectrogramTensor;
        let waveformTensor;
        const audioDataQueue = await this.getAudioData();
        if (this.includeSpectrogram) {
            const freqData = this.flattenQueue(audioDataQueue.freqDataQueue);
            spectrogramTensor = this.getTensorFromAudioDataArray(freqData, [
                this.numFrames,
                this.columnTruncateLength,
                1
            ]);
        }
        if (this.includeWaveform) {
            const timeData = this.flattenQueue(audioDataQueue.timeDataQueue);
            waveformTensor = this.getTensorFromAudioDataArray(timeData, [
                this.numFrames * this.fftSize,
                1
            ]);
        }
        return {
            value: {
                'spectrogram': spectrogramTensor,
                'waveform': waveformTensor
            },
            done: false
        };
    }
    // Capture one result from the audio stream, and extract the value from
    // iterator.next() result.
    async capture() {
        return (await this.next()).value;
    }
    async getAudioData() {
        const freqDataQueue = [];
        const timeDataQueue = [];
        let currentFrames = 0;
        return new Promise((resolve)=>{
            const intervalID = setInterval(()=>{
                if (this.includeSpectrogram) {
                    this.analyser.getFloatFrequencyData(this.freqData);
                    // If the audio stream is initializing, return empty queue.
                    if (this.freqData[0] === -Infinity) resolve({
                        freqDataQueue: freqDataQueue,
                        timeDataQueue: timeDataQueue
                    });
                    freqDataQueue.push(this.freqData.slice(0, this.columnTruncateLength));
                }
                if (this.includeWaveform) {
                    this.analyser.getFloatTimeDomainData(this.timeData);
                    timeDataQueue.push(this.timeData.slice());
                }
                // Clean interval and return when all frames have been collected
                if (++currentFrames === this.numFrames) {
                    clearInterval(intervalID);
                    resolve({
                        freqDataQueue: freqDataQueue,
                        timeDataQueue: timeDataQueue
                    });
                }
            }, this.fftSize / this.sampleRateHz * 1e3);
        });
    }
    // Stop the audio stream and pause the iterator.
    stop() {
        if (!this.isClosed) {
            this.isClosed = true;
            this.analyser.disconnect();
            this.audioContext.close();
            if (this.stream != null && this.stream.getTracks().length > 0) this.stream.getTracks()[0].stop();
        }
    }
    // Override toArray() function to prevent collecting.
    toArray() {
        throw new Error('Can not convert infinite audio stream to array.');
    }
    // Return audio sampling rate in Hz
    getSampleRate() {
        return this.sampleRateHz;
    }
    flattenQueue(queue) {
        const frameSize = queue[0].length;
        const freqData = new Float32Array(queue.length * frameSize);
        queue.forEach((data, i)=>freqData.set(data, i * frameSize));
        return freqData;
    }
    getTensorFromAudioDataArray(freqData, shape) {
        const vals = new Float32Array((0, $lBDHD).sizeFromShape(shape));
        // If the data is less than the output shape, the rest is padded with zeros.
        vals.set(freqData, vals.length - freqData.length);
        return (0, $eZfvk.tensor)(vals, shape);
    }
}

});

parcelRegister("7xEUa", function(module, exports) {

$parcel$export(module.exports, "WebcamIterator", function () { return $57db585962ceed82$export$da055602df533e23; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $iVJWR = parcelRequire("iVJWR");
var $fxiHg = parcelRequire("fxiHg");
var $tdutJ = parcelRequire("tdutJ");
var $fO4kJ = parcelRequire("fO4kJ");
var $4I5dI = parcelRequire("4I5dI");
var $8nMOl = parcelRequire("8nMOl");
var $8tOOR = parcelRequire("8tOOR");
var $9NdGd = parcelRequire("9NdGd");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");

var $4rCj9 = parcelRequire("4rCj9");
class $57db585962ceed82$export$da055602df533e23 extends (0, $4rCj9.LazyIterator) {
    constructor(webcamVideoElement, webcamConfig){
        super();
        this.webcamVideoElement = webcamVideoElement;
        this.webcamConfig = webcamConfig;
        this.isClosed = true;
        this.resize = false;
        if (this.needToResize()) {
            this.resize = true;
            this.cropSize = [
                this.webcamConfig.resizeHeight,
                this.webcamConfig.resizeWidth
            ];
            this.cropBoxInd = (0, $8tOOR.tensor1d)([
                0
            ], 'int32');
            if (this.webcamConfig.centerCrop) {
                // Calculate the box based on resizing shape.
                const widthCroppingRatio = this.webcamConfig.resizeWidth * 1.0 / this.webcamVideoElement.width;
                const heightCroppingRatio = this.webcamConfig.resizeHeight * 1.0 / this.webcamVideoElement.height;
                const widthCropStart = (1 - widthCroppingRatio) / 2;
                const heightCropStart = (1 - heightCroppingRatio) / 2;
                const widthCropEnd = widthCropStart + widthCroppingRatio;
                const heightCropEnd = heightCroppingRatio + heightCropStart;
                this.cropBox = (0, $9NdGd.tensor2d)([
                    heightCropStart,
                    widthCropStart,
                    heightCropEnd,
                    widthCropEnd
                ], [
                    1,
                    4
                ]);
            } else this.cropBox = (0, $9NdGd.tensor2d)([
                0,
                0,
                1,
                1
            ], [
                1,
                4
            ]);
        }
    }
    summary() {
        return `webcam`;
    }
    // Construct a WebcamIterator and start it's video stream.
    static async create(webcamVideoElement, webcamConfig = {}) {
        if (!(0, $tdutJ.env)().get('IS_BROWSER')) throw new Error('tf.data.webcam is only supported in browser environment.');
        if (!webcamVideoElement) {
            // If webcam video element is not provided, create a hidden video element
            // with provided width and height.
            webcamVideoElement = document.createElement('video');
            if (!webcamConfig.resizeWidth || !webcamConfig.resizeHeight) throw new Error("Please provide webcam video element, or resizeWidth and resizeHeight to create a hidden video element.");
            webcamVideoElement.width = webcamConfig.resizeWidth;
            webcamVideoElement.height = webcamConfig.resizeHeight;
        }
        const webcamIterator = new $57db585962ceed82$export$da055602df533e23(webcamVideoElement, webcamConfig);
        // Call async function to initialize the video stream.
        await webcamIterator.start();
        return webcamIterator;
    }
    // Async function to start video stream.
    async start() {
        if (this.webcamConfig.facingMode) (0, $lBDHD).assert(this.webcamConfig.facingMode === 'user' || this.webcamConfig.facingMode === 'environment', ()=>`Invalid webcam facing mode: ${this.webcamConfig.facingMode}. ` + `Please provide 'user' or 'environment'`);
        try {
            this.stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: this.webcamConfig.deviceId,
                    facingMode: this.webcamConfig.facingMode ? this.webcamConfig.facingMode : 'user',
                    width: this.webcamVideoElement.width,
                    height: this.webcamVideoElement.height
                }
            });
        } catch (e) {
            // Modify the error message but leave the stack trace intact
            e.message = `Error thrown while initializing video stream: ${e.message}`;
            throw e;
        }
        if (!this.stream) throw new Error('Could not obtain video from webcam.');
        // Older browsers may not have srcObject
        try {
            this.webcamVideoElement.srcObject = this.stream;
        } catch (error) {
            console.log(error);
            this.webcamVideoElement.src = window.URL.createObjectURL(this.stream);
        }
        // Start the webcam video stream
        this.webcamVideoElement.play();
        this.isClosed = false;
        return new Promise((resolve)=>{
            // Add event listener to make sure the webcam has been fully initialized.
            this.webcamVideoElement.onloadedmetadata = ()=>{
                resolve();
            };
        });
    }
    async next() {
        if (this.isClosed) return {
            value: null,
            done: true
        };
        let img;
        try {
            img = (0, $iVJWR).fromPixels(this.webcamVideoElement);
        } catch (e) {
            throw new Error(`Error thrown converting video to pixels: ${JSON.stringify(e)}`);
        }
        if (this.resize) try {
            return {
                value: this.cropAndResizeFrame(img),
                done: false
            };
        } catch (e) {
            throw new Error(`Error thrown cropping the video: ${e.message}`);
        } finally{
            img.dispose();
        }
        else return {
            value: img,
            done: false
        };
    }
    needToResize() {
        // If resizeWidth and resizeHeight are provided, and different from the
        // width and height of original HTMLVideoElement, then resizing and cropping
        // is required.
        if (this.webcamConfig.resizeWidth && this.webcamConfig.resizeHeight && (this.webcamVideoElement.width !== this.webcamConfig.resizeWidth || this.webcamVideoElement.height !== this.webcamConfig.resizeHeight)) return true;
        return false;
    }
    // Cropping and resizing each frame based on config
    cropAndResizeFrame(img) {
        return (0, $d7Nxs.tidy)(()=>{
            const expandedImage = (0, $fO4kJ.expandDims)((0, $fxiHg.cast)(img, 'float32'), 0);
            let resizedImage;
            resizedImage = (0, $4I5dI.image).cropAndResize(expandedImage, this.cropBox, this.cropBoxInd, this.cropSize, 'bilinear');
            // Extract image from batch cropping.
            const shape = resizedImage.shape;
            return (0, $8nMOl.reshape)(resizedImage, shape.slice(1));
        });
    }
    // Capture one frame from the video stream, and extract the value from
    // iterator.next() result.
    async capture() {
        return (await this.next()).value;
    }
    // Stop the video stream and pause webcam iterator.
    stop() {
        const tracks = this.stream.getTracks();
        tracks.forEach((track)=>track.stop());
        try {
            this.webcamVideoElement.srcObject = null;
        } catch (error) {
            console.log(error);
            this.webcamVideoElement.src = null;
        }
        this.isClosed = true;
    }
    // Override toArray() function to prevent collecting.
    toArray() {
        throw new Error('Can not convert infinite video stream to array.');
    }
}

});

parcelRegister("l0gjN", function(module, exports) {

$parcel$export(module.exports, "URLDataSource", function () { return $f4a64183a89afa13$export$d8d4d86de1937e34; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $1BEmD = parcelRequire("1BEmD");

var $eayf1 = parcelRequire("eayf1");

var $43gPm = parcelRequire("43gPm");

var $itOHT = parcelRequire("itOHT");
class $f4a64183a89afa13$export$d8d4d86de1937e34 extends (0, $1BEmD.DataSource) {
    /**
     * Create a `URLDataSource`.
     *
     * @param url A source URL string, or a `Request` object.
     * @param options Options passed to the underlying `FileChunkIterator`s,
     *   such as {chunksize: 1024}.
     */ constructor(url, fileOptions = {}){
        super();
        this.url = url;
        this.fileOptions = fileOptions;
    }
    // TODO(soergel): provide appropriate caching options.  Currently this
    // will download the URL anew for each call to iterator().  Since we have
    // to treat the downloaded file as a blob/buffer anyway, we may as well retain
    // it-- but that raises GC issues.  Also we may want a persistent disk cache.
    async iterator() {
        if ((0, $43gPm.isLocalPath)(this.url)) return new (0, $itOHT.FileDataSource)(this.url, this.fileOptions).iterator();
        else return (0, $eayf1.urlChunkIterator)(this.url, this.fileOptions);
    }
}

});
parcelRegister("1BEmD", function(module, exports) {

$parcel$export(module.exports, "DataSource", function () { return $12b88e9a1f4ac4b7$export$accd73d198d77d2f; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ /**
 * Represents a data source readable as a stream of binary data chunks.
 *
 * Because `Dataset`s can be read repeatedly (via `Dataset.iterator()`), this
 * provides a means to repeatedly create streams from the underlying data
 * sources.
 */ class $12b88e9a1f4ac4b7$export$accd73d198d77d2f {
} // TODO(soergel): consider convenience factory functions here
 // in combination with chainable source->dataset above, e.g.:
 // tf.data.url(...).asCsvDataset().shuffle().batch()

});

parcelRegister("eayf1", function(module, exports) {

$parcel$export(module.exports, "urlChunkIterator", function () { return $a50c8f7caeadbeb9$export$158ba3195ecace84; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $aWPUE = parcelRequire("aWPUE");
async function $a50c8f7caeadbeb9$export$158ba3195ecace84(url, options = {}, fetchFunc) {
    let urlString;
    let requestInit;
    if (typeof url === 'string') urlString = url;
    else {
        urlString = url.url;
        requestInit = $a50c8f7caeadbeb9$var$getRequestInitFromRequest(url);
    }
    const response = await (fetchFunc || (0, $lBDHD).fetch)(urlString, requestInit);
    if (response.ok) {
        const uint8Array = new Uint8Array(await response.arrayBuffer());
        return new (0, $aWPUE.FileChunkIterator)(uint8Array, options);
    } else throw new Error(response.statusText);
}
// Generate RequestInit from Request to match tf.util.fetch signature.
const $a50c8f7caeadbeb9$var$getRequestInitFromRequest = (request)=>{
    const init = {
        method: request.method,
        headers: request.headers,
        body: request.body,
        mode: request.mode,
        credentials: request.credentials,
        cache: request.cache,
        redirect: request.redirect,
        referrer: request.referrer,
        integrity: request.integrity
    };
    return init;
};

});
parcelRegister("aWPUE", function(module, exports) {

$parcel$export(module.exports, "FileChunkIterator", function () { return $7f8796f6d14d79fa$export$2624998eee2e5c56; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ // inspired by https://github.com/maxogden/filereader-stream
parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $lBDHD = parcelRequire("lBDHD");

var $5Xjuz = parcelRequire("5Xjuz");
class $7f8796f6d14d79fa$export$2624998eee2e5c56 extends (0, $5Xjuz.ByteChunkIterator) {
    constructor(file, options = {}){
        super();
        this.file = file;
        this.options = options;
        (0, $lBDHD).assert(file instanceof Uint8Array || ((0, $tdutJ.env)().get('IS_BROWSER') ? file instanceof File || file instanceof Blob : false), ()=>"FileChunkIterator only supports File, Blob and Uint8Array right now.");
        this.offset = options.offset || 0;
        // default 1MB chunk has tolerable perf on large files
        this.chunkSize = options.chunkSize || 1048576;
    }
    summary() {
        return `FileChunks ${this.file}`;
    }
    async next() {
        if (this.offset >= (this.file instanceof Uint8Array ? this.file.byteLength : this.file.size)) return {
            value: null,
            done: true
        };
        const chunk = new Promise((resolve, reject)=>{
            const end = this.offset + this.chunkSize;
            if (this.file instanceof Uint8Array) // Note if end > this.uint8Array.byteLength, we just get a small last
            // chunk.
            resolve(new Uint8Array(this.file.slice(this.offset, end)));
            else {
                // This branch assumes that this.file type is File or Blob, which
                // means it is in the browser environment.
                // TODO(soergel): is this a performance issue?
                const fileReader = new FileReader();
                fileReader.onload = (event)=>{
                    let data = fileReader.result;
                    // Not sure we can trust the return type of
                    // FileReader.readAsArrayBuffer See e.g.
                    // https://github.com/node-file-api/FileReader/issues/2
                    if (data instanceof ArrayBuffer) data = new Uint8Array(data);
                    if (!(data instanceof Uint8Array)) return reject(new TypeError('FileReader returned unknown type.'));
                    resolve(data);
                };
                fileReader.onabort = (event)=>{
                    return reject(new Error('Aborted'));
                };
                fileReader.onerror = (event)=>{
                    return reject(new Error(event.type));
                };
                // TODO(soergel): better handle onabort, onerror
                // Note if end > this.file.size, we just get a small last chunk.
                const slice = this.file.slice(this.offset, end);
                // We can't use readAsText here (even if we know the file is text)
                // because the slice boundary may fall within a multi-byte character.
                fileReader.readAsArrayBuffer(slice);
            }
            this.offset = end;
        });
        return {
            value: await chunk,
            done: false
        };
    }
}

});
parcelRegister("5Xjuz", function(module, exports) {

$parcel$export(module.exports, "ByteChunkIterator", function () { return $4561952d36aef72a$export$6a47bd14492beb24; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");

var $4rCj9 = parcelRequire("4rCj9");

var $lBPmW = parcelRequire("lBPmW");

var $2bytI = parcelRequire("2bytI");
var $4561952d36aef72a$require$Buffer = $2bytI.Buffer;
class $4561952d36aef72a$export$6a47bd14492beb24 extends (0, $4rCj9.LazyIterator) {
    /**
     * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
     *
     * The byte arrays producetd from the ByteChunkIterator on which this is
     * called will be interpreted as concatenated.  No assumptions are made about
     * the boundaries of the incoming chunks, so a multi-byte UTF8 encoding of a
     * character may span the boundary between chunks.  This naturally happens,
     * for instance, when reading fixed-size byte arrays from a file.
     */ decodeUTF8() {
        return new $4561952d36aef72a$var$Utf8Iterator(this);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on ByteChunkIterator.  Unfortunately they can't be placed in separate files,
// due to resulting trouble with circular imports.
// ============================================================================
// We wanted multiple inheritance, e.g.
//   class Utf8Iterator extends QueueIterator<string>, StringIterator
// but the TypeScript mixin approach is a bit hacky, so we take this adapter
// approach instead.
class $4561952d36aef72a$var$Utf8Iterator extends (0, $lBPmW.StringIterator) {
    constructor(upstream){
        super();
        this.upstream = upstream;
        this.impl = new $4561952d36aef72a$var$Utf8IteratorImpl(upstream);
    }
    summary() {
        return this.impl.summary();
    }
    async next() {
        return this.impl.next();
    }
}

/**
 * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
 *
 * This is tricky because the incoming byte array boundaries may disrupt a
 * multi-byte UTF8 character. Thus any incomplete character data at the end of
 * a chunk must be carried over and prepended to the next chunk before
 * decoding. Luckily with native decoder, TextDecoder in browser and
 * string_decoder in node, byte array boundaries are handled automatically.
 *
 * In the context of an input pipeline for machine learning, UTF8 decoding is
 * needed to parse text files containing training examples or prediction
 * requests (e.g., formatted as CSV or JSON). We cannot use the built-in
 * decoding provided by FileReader.readAsText() because here we are in a
 * streaming context, which FileReader does not support.
 *
 * @param upstream A `LazyIterator` of `Uint8Arrays` containing UTF8-encoded
 *   text, which should be interpreted as concatenated.  No assumptions are
 *   made about the boundaries of the incoming chunks, so a multi-byte UTF8
 *   encoding of a character may span the boundary between chunks.  This
 *   naturally happens, for instance, when reading fixed-size byte arrays from a
 *   file.
 */ class $4561952d36aef72a$var$Utf8IteratorImpl extends (0, $4rCj9.OneToManyIterator) {
    constructor(upstream){
        super();
        this.upstream = upstream;
        if ((0, $tdutJ.env)().get('IS_BROWSER')) this.decoder = new TextDecoder('utf-8');
        else {
            // tslint:disable-next-line:no-require-imports
            const { StringDecoder: StringDecoder } = (parcelRequire("9XjBr"));
            this.decoder = new StringDecoder('utf8');
        }
    }
    summary() {
        return `${this.upstream.summary()} -> Utf8`;
    }
    async pump() {
        const chunkResult = await this.upstream.next();
        let chunk;
        if (chunkResult.done) return false;
        else chunk = chunkResult.value;
        let text;
        if ((0, $tdutJ.env)().get('IS_BROWSER')) text = this.decoder.decode(chunk, {
            stream: true
        });
        else text = this.decoder.write($4561952d36aef72a$require$Buffer.from(chunk.buffer));
        this.outputQueue.push(text);
        return true;
    }
}

});
parcelRegister("lBPmW", function(module, exports) {

$parcel$export(module.exports, "StringIterator", function () { return $fbb4e6787ae1644b$export$fa893445807b0b3b; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ 
var $4rCj9 = parcelRequire("4rCj9");
class $fbb4e6787ae1644b$export$fa893445807b0b3b extends (0, $4rCj9.LazyIterator) {
    /**
     * Splits a string stream on a given separator.
     *
     * It is assumed that the incoming chunk boundaries have no semantic meaning,
     * so conceptually the incoming stream is treated simply as the concatenation
     * of its elements.
     *
     * The outgoing stream provides chunks corresponding to the results of the
     * standard string split() operation (even if such a chunk spanned incoming
     * chunks).  The separators are not included.
     *
     * A typical usage is to split a text file (represented as a stream with
     * arbitrary chunk boundaries) into lines.
     *
     * @param upstream A readable stream of strings that can be treated as
     *   concatenated.
     * @param separator A character to split on.
     */ split(separator) {
        return new $fbb4e6787ae1644b$var$SplitIterator(this, separator);
    }
}
// ============================================================================
// The following private classes serve to implement the chainable methods
// on StringIterator.  Unfortunately they can't be placed in separate files, due
// to resulting trouble with circular imports.
// ============================================================================
// We wanted multiple inheritance, e.g.
//   class SplitIterator extends QueueIterator<string>, StringIterator
// but the TypeScript mixin approach is a bit hacky, so we take this adapter
// approach instead.
class $fbb4e6787ae1644b$var$SplitIterator extends $fbb4e6787ae1644b$export$fa893445807b0b3b {
    constructor(upstream, separator){
        super();
        this.upstream = upstream;
        this.impl = new $fbb4e6787ae1644b$var$SplitIteratorImpl(upstream, separator);
    }
    summary() {
        return this.impl.summary();
    }
    async next() {
        return this.impl.next();
    }
}
class $fbb4e6787ae1644b$var$SplitIteratorImpl extends (0, $4rCj9.OneToManyIterator) {
    constructor(upstream, separator){
        super();
        this.upstream = upstream;
        this.separator = separator;
        // A partial string at the end of an upstream chunk
        this.carryover = '';
    }
    summary() {
        return `${this.upstream.summary()} -> Split('${this.separator}')`;
    }
    async pump() {
        const chunkResult = await this.upstream.next();
        if (chunkResult.done) {
            if (this.carryover === '') return false;
            // Pretend that the pump succeeded in order to emit the small last batch.
            // The next pump() call will actually fail.
            this.outputQueue.push(this.carryover);
            this.carryover = '';
            return true;
        }
        const lines = chunkResult.value.split(this.separator);
        // Note the behavior: " ab ".split(' ') === ['', 'ab', '']
        // Thus the carryover may be '' if the separator falls on a chunk
        // boundary; this produces the correct result.
        lines[0] = this.carryover + lines[0];
        for (const line of lines.slice(0, -1))this.outputQueue.push(line);
        this.carryover = lines[lines.length - 1];
        return true;
    }
}

});




parcelRegister("43gPm", function(module, exports) {

$parcel$export(module.exports, "isLocalPath", function () { return $2f347ed1be868e5a$export$9fce4fde36401560; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ // Skip tslint any type check cause this method is aiming to check type of
// input.
// tslint:disable-next-line:no-any
function $2f347ed1be868e5a$export$9fce4fde36401560(source) {
    return typeof source === 'string' && source.slice(0, 7) === 'file://';
}

});

parcelRegister("itOHT", function(module, exports) {

$parcel$export(module.exports, "FileDataSource", function () { return $d74244c7f26b88b1$export$e7de913bc6153b84; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");

var $1BEmD = parcelRequire("1BEmD");

var $aWPUE = parcelRequire("aWPUE");

var $43gPm = parcelRequire("43gPm");

class $d74244c7f26b88b1$export$e7de913bc6153b84 extends (0, $1BEmD.DataSource) {
    /**
     * Create a `FileDataSource`.
     *
     * @param input Local file path, or `File`/`Blob`/`Uint8Array` object to
     *     read. Local file only works in node environment.
     * @param options Options passed to the underlying `FileChunkIterator`s,
     *   such as {chunksize: 1024}.
     */ constructor(input, options = {}){
        super();
        this.input = input;
        this.options = options;
    }
    async iterator() {
        if ((0, $43gPm.isLocalPath)(this.input) && (0, $tdutJ.env)().get('IS_NODE')) {
            // tslint:disable-next-line:no-require-imports
            const fs = (parcelRequire("9XjBr"));
            this.input = fs.readFileSync(this.input.slice(7));
        }
        // TODO(kangyizhang): Add LocalFileChunkIterator to split local streaming
        // with file in browser.
        return new (0, $aWPUE.FileChunkIterator)(this.input, this.options);
    }
}

});



parcelRegister("4amQM", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3089d22a594b03bf$export$83d89fbfd8236492; });
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $3089d22a594b03bf$export$83d89fbfd8236492 = '4.22.0';

});


parcelRegister("i0b4d", function(module, exports) {
$parcel$export(module.exports, "version_cpu", function () { return (parcelRequire("dqT0h")).version; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // All exports from this package should be in base.
parcelRequire("2nWIY");
parcelRequire("lXykE");

});
parcelRegister("2nWIY", function(module, exports) {

$parcel$export(module.exports, "version_cpu", function () { return (parcelRequire("dqT0h")).version; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /*
 * base.ts contains all the exports from tfjs-backend-cpu
 * without auto-kernel registration
 */ parcelRequire("8AHkS");
var $d7Nxs = parcelRequire("d7Nxs");

var $4JgXC = parcelRequire("4JgXC");


var $dqT0h = parcelRequire("dqT0h");
// Side effects for default initialization of MathBackendCPU
(0, $d7Nxs.registerBackend)('cpu', ()=>new (0, $4JgXC.MathBackendCPU)(), 1 /* priority */ );

});
parcelRegister("4JgXC", function(module, exports) {

$parcel$export(module.exports, "MathBackendCPU", function () { return $3718856e243ef2fa$export$65286aecbd5a8de9; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $5siju = parcelRequire("5siju");
var $2vCd3 = parcelRequire("2vCd3");
var $d7Nxs = parcelRequire("d7Nxs");
var $tdutJ = parcelRequire("tdutJ");
var $iEnT2 = parcelRequire("iEnT2");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
const $3718856e243ef2fa$var$whereImpl = (0, $iEnT2).whereImpl;
class $3718856e243ef2fa$export$65286aecbd5a8de9 extends (0, $2vCd3.KernelBackend) {
    nextDataId() {
        return $3718856e243ef2fa$export$65286aecbd5a8de9.nextDataId++;
    }
    constructor(){
        super();
        this.blockSize = 48;
        this.firstUse = true;
        this.data = new (0, $2vCd3.DataStorage)(this, (0, $d7Nxs.engine)());
    }
    write(values, shape, dtype) {
        if (this.firstUse) {
            this.firstUse = false;
            if ((0, $tdutJ.env)().get('IS_NODE')) (0, $dEVRx).warn("\n============================\nHi, looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, visit https://github.com/tensorflow/tfjs-node for more details. \n============================");
        }
        const dataId = {
            id: this.nextDataId()
        };
        this.data.set(dataId, {
            values: values,
            dtype: dtype,
            refCount: 1
        });
        return dataId;
    }
    /**
     * Create a data bucket in cpu backend.
     * @param shape Shape of the `TensorInfo`.
     * @param dtype DType of the `TensorInfo`.
     * @param values The value of the `TensorInfo` stored as a flattened array.
     */ makeTensorInfo(shape, dtype, values) {
        let outId;
        if (dtype === 'string' && values != null && values.length > 0 && (0, $lBDHD).isString(values[0])) {
            const encodedValues = values.map((d)=>(0, $lBDHD).encodeString(d));
            outId = this.write(encodedValues, shape, dtype);
        } else outId = this.write(values, shape, dtype);
        return {
            dataId: outId,
            shape: shape,
            dtype: dtype
        };
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.data.has(dataId)) {
            const tensorData = this.data.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TensorData`. */ incRef(dataId) {
        const tensorData = this.data.get(dataId);
        tensorData.refCount++;
    }
    /** Decrease refCount of a `TensorData`. */ decRef(dataId) {
        if (this.data.has(dataId)) {
            const tensorData = this.data.get(dataId);
            tensorData.refCount--;
        }
    }
    move(dataId, values, shape, dtype, refCount) {
        this.data.set(dataId, {
            values: values,
            dtype: dtype,
            refCount: refCount
        });
    }
    numDataIds() {
        return this.data.numDataIds();
    }
    async read(dataId) {
        return this.readSync(dataId);
    }
    readSync(dataId) {
        const { dtype: dtype, complexTensorInfos: complexTensorInfos } = this.data.get(dataId);
        if (dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            return (0, $dEVRx).mergeRealAndImagArrays(realValues, imagValues);
        }
        return (0, $lBDHD).convertBackendValuesAndArrayBuffer(this.data.get(dataId).values, dtype);
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $lBDHD).decodeString(d));
            return (0, $5siju.buffer)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $5siju.buffer)(t.shape, t.dtype, data);
    }
    makeOutput(values, shape, dtype) {
        return (0, $d7Nxs.engine)().makeTensorFromTensorInfo(this.makeTensorInfo(shape, dtype, values), this);
    }
    /**
     * Dispose the memory if the dataId has 0 refCount. Return true if the memory
     * is released or memory is not managed in this backend, false if memory is
     * not cleared.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        if (this.data.has(dataId)) {
            this.data.get(dataId).refCount--;
            if (!force && this.data.get(dataId).refCount > 0) return false;
            const { complexTensorInfos: complexTensorInfos } = this.data.get(dataId);
            if (complexTensorInfos != null) {
                this.disposeData(complexTensorInfos.real.dataId, true);
                this.disposeData(complexTensorInfos.imag.dataId, true);
            }
            this.data.delete(dataId);
        }
        return true;
    }
    disposeIntermediateTensorInfo(tensorInfo) {
        this.disposeData(tensorInfo.dataId);
    }
    async time(f) {
        const start = (0, $lBDHD).now();
        f();
        const kernelMs = (0, $lBDHD).now() - start;
        return {
            kernelMs: kernelMs
        };
    }
    memory() {
        return {
            // Unreliable due to automatic gc. The numbers above are cumulative.
            unreliable: true,
            reasons: [
                "The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."
            ]
        };
    }
    where(condition) {
        (0, $wi69v.assertNotComplex)([
            condition
        ], 'where');
        const condVals = this.readSync(condition.dataId);
        return $3718856e243ef2fa$var$whereImpl(condition.shape, condVals);
    }
    dispose() {}
    floatPrecision() {
        return 32;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return super.epsilon();
    }
}
$3718856e243ef2fa$export$65286aecbd5a8de9.nextDataId = 0;

});
parcelRegister("wi69v", function(module, exports) {

$parcel$export(module.exports, "assertNotComplex", function () { return $06110734927eece3$export$1412c17b2531581a; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $06110734927eece3$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $lBDHD).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors in the CPU backend.`);
    });
}

});


parcelRegister("dqT0h", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $9c785e9b4f5a48ac$export$83d89fbfd8236492; });
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $9c785e9b4f5a48ac$export$83d89fbfd8236492 = '4.22.0';

});


parcelRegister("lXykE", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // We explicitly import the modular kernels so they get registered in the
// global registry when we compile the library. A modular build would replace
// the contents of this file and import only the kernels that are needed.
parcelRequire("8AHkS");
var $fPoI0 = parcelRequire("fPoI0");

var $3WsdE = parcelRequire("3WsdE");

var $cSRnW = parcelRequire("cSRnW");

var $2KxaV = parcelRequire("2KxaV");

var $Qxmxv = parcelRequire("Qxmxv");

var $kuzxZ = parcelRequire("kuzxZ");

var $4eK92 = parcelRequire("4eK92");

var $8FaUp = parcelRequire("8FaUp");

var $edrPc = parcelRequire("edrPc");

var $V7Vzy = parcelRequire("V7Vzy");

var $amH7s = parcelRequire("amH7s");

var $5TudD = parcelRequire("5TudD");

var $bIxq4 = parcelRequire("bIxq4");

var $7FHsX = parcelRequire("7FHsX");

var $1pJRK = parcelRequire("1pJRK");

var $cR01M = parcelRequire("cR01M");

var $km6k9 = parcelRequire("km6k9");

var $1A72c = parcelRequire("1A72c");

var $kvA6F = parcelRequire("kvA6F");

var $ebGUr = parcelRequire("ebGUr");

var $7q7qv = parcelRequire("7q7qv");

var $hIsle = parcelRequire("hIsle");

var $cRzSP = parcelRequire("cRzSP");

var $hpM0s = parcelRequire("hpM0s");

var $3pAeM = parcelRequire("3pAeM");

var $6vYuN = parcelRequire("6vYuN");

var $9IBUg = parcelRequire("9IBUg");

var $kHDCc = parcelRequire("kHDCc");

var $8jprz = parcelRequire("8jprz");

var $hmrWF = parcelRequire("hmrWF");

var $kdvfR = parcelRequire("kdvfR");

var $aEIJt = parcelRequire("aEIJt");

var $jpv7x = parcelRequire("jpv7x");

var $lhINj = parcelRequire("lhINj");

var $eptaX = parcelRequire("eptaX");

var $hZMDE = parcelRequire("hZMDE");

var $haqJT = parcelRequire("haqJT");

var $4Cvwq = parcelRequire("4Cvwq");

var $ZwOc8 = parcelRequire("ZwOc8");

var $7J2Cn = parcelRequire("7J2Cn");

var $foorQ = parcelRequire("foorQ");

var $lyOLj = parcelRequire("lyOLj");

var $3hZDr = parcelRequire("3hZDr");

var $95dcs = parcelRequire("95dcs");

var $dZ9gT = parcelRequire("dZ9gT");

var $hsCDu = parcelRequire("hsCDu");

var $7pKW4 = parcelRequire("7pKW4");

var $1No46 = parcelRequire("1No46");

var $28jjJ = parcelRequire("28jjJ");

var $K0cia = parcelRequire("K0cia");

var $9wlyQ = parcelRequire("9wlyQ");

var $jqFJl = parcelRequire("jqFJl");

var $5CzjV = parcelRequire("5CzjV");

var $5wuKe = parcelRequire("5wuKe");

var $bk7Yz = parcelRequire("bk7Yz");

var $630uU = parcelRequire("630uU");

var $9Gjjv = parcelRequire("9Gjjv");

var $1N6wu = parcelRequire("1N6wu");

var $a6Y9A = parcelRequire("a6Y9A");

var $j72XB = parcelRequire("j72XB");

var $9G2FR = parcelRequire("9G2FR");

var $7eR69 = parcelRequire("7eR69");

var $2EKqh = parcelRequire("2EKqh");

var $3Ao6Y = parcelRequire("3Ao6Y");

var $lJgzZ = parcelRequire("lJgzZ");

var $kjdJQ = parcelRequire("kjdJQ");

var $bYokO = parcelRequire("bYokO");

var $fKu9a = parcelRequire("fKu9a");

var $dhJEK = parcelRequire("dhJEK");

var $fR08n = parcelRequire("fR08n");

var $hfAls = parcelRequire("hfAls");

var $6LIWt = parcelRequire("6LIWt");

var $l9MqT = parcelRequire("l9MqT");

var $eKB3h = parcelRequire("eKB3h");

var $acwXZ = parcelRequire("acwXZ");

var $gfQFw = parcelRequire("gfQFw");

var $3VapQ = parcelRequire("3VapQ");

var $izkXE = parcelRequire("izkXE");

var $8B2Nq = parcelRequire("8B2Nq");

var $1y3pA = parcelRequire("1y3pA");

var $gkuUa = parcelRequire("gkuUa");

var $hAQg3 = parcelRequire("hAQg3");

var $9J2ld = parcelRequire("9J2ld");

var $48qZT = parcelRequire("48qZT");

var $7CO38 = parcelRequire("7CO38");

var $52sI9 = parcelRequire("52sI9");

var $Vr6iN = parcelRequire("Vr6iN");

var $8o8Pp = parcelRequire("8o8Pp");

var $gZGW3 = parcelRequire("gZGW3");

var $c8z6c = parcelRequire("c8z6c");

var $cOTDj = parcelRequire("cOTDj");

var $WsKeW = parcelRequire("WsKeW");

var $CIxXQ = parcelRequire("CIxXQ");

var $j04Jl = parcelRequire("j04Jl");

var $klRsm = parcelRequire("klRsm");

var $NOBt0 = parcelRequire("NOBt0");

var $2KTmU = parcelRequire("2KTmU");

var $e8YXS = parcelRequire("e8YXS");

var $gbhaU = parcelRequire("gbhaU");

var $lM61A = parcelRequire("lM61A");

var $91k7s = parcelRequire("91k7s");

var $bSeCN = parcelRequire("bSeCN");

var $bMajv = parcelRequire("bMajv");

var $3iNqQ = parcelRequire("3iNqQ");

var $arrrA = parcelRequire("arrrA");

var $k3PkG = parcelRequire("k3PkG");

var $hWyXZ = parcelRequire("hWyXZ");

var $dSDQI = parcelRequire("dSDQI");

var $dsgJ3 = parcelRequire("dsgJ3");

var $cXYW9 = parcelRequire("cXYW9");

var $83uCx = parcelRequire("83uCx");

var $4gZLs = parcelRequire("4gZLs");

var $dof0H = parcelRequire("dof0H");

var $6es5J = parcelRequire("6es5J");

var $knCR9 = parcelRequire("knCR9");

var $5T1ar = parcelRequire("5T1ar");

var $gGhXU = parcelRequire("gGhXU");

var $gsyO3 = parcelRequire("gsyO3");

var $3iaps = parcelRequire("3iaps");

var $fWJq3 = parcelRequire("fWJq3");

var $avBJE = parcelRequire("avBJE");

var $gCFYp = parcelRequire("gCFYp");

var $3mxSY = parcelRequire("3mxSY");

var $gDXns = parcelRequire("gDXns");

var $dOeSU = parcelRequire("dOeSU");

var $8UdNU = parcelRequire("8UdNU");

var $jWJrL = parcelRequire("jWJrL");

var $cAOM1 = parcelRequire("cAOM1");

var $8cAqa = parcelRequire("8cAqa");

var $DLIeE = parcelRequire("DLIeE");

var $kSwap = parcelRequire("kSwap");

var $jfy0V = parcelRequire("jfy0V");

var $bUDnX = parcelRequire("bUDnX");

var $8a0Og = parcelRequire("8a0Og");

var $3tLqv = parcelRequire("3tLqv");

var $jRAN6 = parcelRequire("jRAN6");

var $bKRee = parcelRequire("bKRee");

var $eLSm4 = parcelRequire("eLSm4");

var $j6cju = parcelRequire("j6cju");

var $5jZs7 = parcelRequire("5jZs7");

var $bBqE7 = parcelRequire("bBqE7");

var $59DpV = parcelRequire("59DpV");

var $bNWZZ = parcelRequire("bNWZZ");

var $jUwcI = parcelRequire("jUwcI");

var $jCkjt = parcelRequire("jCkjt");

var $40gFl = parcelRequire("40gFl");

var $1XdE4 = parcelRequire("1XdE4");

var $73WGk = parcelRequire("73WGk");

var $hTBT7 = parcelRequire("hTBT7");

var $jYTdj = parcelRequire("jYTdj");

var $3yZvF = parcelRequire("3yZvF");

var $e5xGp = parcelRequire("e5xGp");

var $5HMOv = parcelRequire("5HMOv");

var $aIdWo = parcelRequire("aIdWo");

var $h11VZ = parcelRequire("h11VZ");

var $1SMNA = parcelRequire("1SMNA");

var $bJaiT = parcelRequire("bJaiT");

var $iD02Q = parcelRequire("iD02Q");

var $hpxIk = parcelRequire("hpxIk");

var $76mFA = parcelRequire("76mFA");

var $2rbI5 = parcelRequire("2rbI5");

var $5Mi8L = parcelRequire("5Mi8L");

var $hp7rt = parcelRequire("hp7rt");

var $k73c2 = parcelRequire("k73c2");

var $aT6X8 = parcelRequire("aT6X8");

var $fh5Jo = parcelRequire("fh5Jo");

var $8BP3N = parcelRequire("8BP3N");

var $9CeFb = parcelRequire("9CeFb");

var $joI4E = parcelRequire("joI4E");

var $3Z9gg = parcelRequire("3Z9gg");

var $imZ6w = parcelRequire("imZ6w");

var $liGsA = parcelRequire("liGsA");

var $jvRne = parcelRequire("jvRne");
// List all kernel configs here
const $ffc9bd50f6d9430d$var$kernelConfigs = [
    (0, $3WsdE._fusedMatMulConfig),
    (0, $cSRnW.absConfig),
    (0, $2KxaV.acosConfig),
    (0, $Qxmxv.acoshConfig),
    (0, $kuzxZ.addConfig),
    (0, $4eK92.addNConfig),
    (0, $8FaUp.allConfig),
    (0, $edrPc.anyConfig),
    (0, $V7Vzy.argMaxConfig),
    (0, $amH7s.argMinConfig),
    (0, $5TudD.asinConfig),
    (0, $bIxq4.asinhConfig),
    (0, $7FHsX.atanConfig),
    (0, $1pJRK.atan2Config),
    (0, $cR01M.atanhConfig),
    (0, $km6k9.avgPoolConfig),
    (0, $1A72c.avgPool3DConfig),
    (0, $kvA6F.avgPool3DGradConfig),
    (0, $ebGUr.avgPoolGradConfig),
    (0, $7q7qv.batchMatMulConfig),
    (0, $hIsle.batchNormConfig),
    (0, $cRzSP.batchToSpaceNDConfig),
    (0, $hpM0s.bincountConfig),
    (0, $3pAeM.bitwiseAndConfig),
    (0, $6vYuN.broadcastArgsConfig),
    (0, $9IBUg.castConfig),
    (0, $kHDCc.ceilConfig),
    (0, $8jprz.clipByValueConfig),
    (0, $hmrWF.complexConfig),
    (0, $kdvfR.complexAbsConfig),
    (0, $aEIJt.concatConfig),
    (0, $jpv7x.conv2DConfig),
    (0, $lhINj.conv2DBackpropFilterConfig),
    (0, $eptaX.conv2DBackpropInputConfig),
    (0, $hZMDE.conv3DConfig),
    (0, $haqJT.conv3DBackpropFilterV2Config),
    (0, $4Cvwq.conv3DBackpropInputV2Config),
    (0, $ZwOc8.cosConfig),
    (0, $7J2Cn.coshConfig),
    (0, $foorQ.cropAndResizeConfig),
    (0, $lyOLj.cumprodConfig),
    (0, $3hZDr.cumsumConfig),
    (0, $95dcs.denseBincountConfig),
    (0, $dZ9gT.depthToSpaceConfig),
    (0, $hsCDu.depthwiseConv2dNativeConfig),
    (0, $7pKW4.depthwiseConv2dNativeBackpropFilterConfig),
    (0, $1No46.depthwiseConv2dNativeBackpropInputConfig),
    (0, $28jjJ.diagConfig),
    (0, $K0cia.dilation2DConfig),
    (0, $9wlyQ.dilation2DBackpropFilterConfig),
    (0, $jqFJl.dilation2DBackpropInputConfig),
    (0, $5CzjV.drawConfig),
    (0, $5wuKe.einsumConfig),
    (0, $bk7Yz.eluConfig),
    (0, $630uU.eluGradConfig),
    (0, $9Gjjv.equalConfig),
    (0, $1N6wu.erfConfig),
    (0, $a6Y9A.expConfig),
    (0, $j72XB.expandDimsConfig),
    (0, $9G2FR.expm1Config),
    (0, $7eR69.fftConfig),
    (0, $2EKqh.fillConfig),
    (0, $3Ao6Y.flipLeftRightConfig),
    (0, $lJgzZ.floorConfig),
    (0, $kjdJQ.floorDivConfig),
    (0, $bYokO.fusedConv2DConfig),
    (0, $fKu9a.fusedDepthwiseConv2DConfig),
    (0, $dhJEK.gatherNdConfig),
    (0, $fR08n.gatherV2Config),
    (0, $hfAls.greaterConfig),
    (0, $6LIWt.greaterEqualConfig),
    (0, $l9MqT.identityConfig),
    (0, $eKB3h.ifftConfig),
    (0, $acwXZ.imagConfig),
    (0, $gfQFw.isFiniteConfig),
    (0, $3VapQ.isInfConfig),
    (0, $izkXE.isNaNConfig),
    (0, $8B2Nq.leakyReluConfig),
    (0, $1y3pA.lessConfig),
    (0, $gkuUa.lessEqualConfig),
    (0, $hAQg3.linSpaceConfig),
    (0, $9J2ld.logConfig),
    (0, $48qZT.log1pConfig),
    (0, $7CO38.logicalAndConfig),
    (0, $52sI9.logicalNotConfig),
    (0, $Vr6iN.logicalOrConfig),
    (0, $8o8Pp.LRNConfig),
    (0, $gZGW3.LRNGradConfig),
    (0, $c8z6c.maxConfig),
    (0, $cOTDj.maximumConfig),
    (0, $WsKeW.maxPoolConfig),
    (0, $CIxXQ.maxPool3DConfig),
    (0, $j04Jl.maxPool3DGradConfig),
    (0, $klRsm.maxPoolGradConfig),
    (0, $NOBt0.maxPoolWithArgmaxConfig),
    (0, $2KTmU.meanConfig),
    (0, $e8YXS.minConfig),
    (0, $gbhaU.minimumConfig),
    (0, $lM61A.mirrorPadConfig),
    (0, $91k7s.modConfig),
    (0, $bSeCN.multinomialConfig),
    (0, $bMajv.multiplyConfig),
    (0, $3iNqQ.negConfig),
    (0, $arrrA.nonMaxSuppressionV3Config),
    (0, $k3PkG.nonMaxSuppressionV4Config),
    (0, $hWyXZ.nonMaxSuppressionV5Config),
    (0, $dSDQI.notEqualConfig),
    (0, $dsgJ3.oneHotConfig),
    (0, $cXYW9.onesLikeConfig),
    (0, $83uCx.packConfig),
    (0, $4gZLs.padV2Config),
    (0, $dof0H.powConfig),
    (0, $6es5J.preluConfig),
    (0, $knCR9.prodConfig),
    (0, $5T1ar.raggedGatherConfig),
    (0, $gGhXU.raggedRangeConfig),
    (0, $gsyO3.raggedTensorToTensorConfig),
    (0, $3iaps.rangeConfig),
    (0, $fWJq3.realConfig),
    (0, $avBJE.realDivConfig),
    (0, $gCFYp.reciprocalConfig),
    (0, $3mxSY.reluConfig),
    (0, $gDXns.relu6Config),
    (0, $dOeSU.reshapeConfig),
    (0, $8UdNU.resizeBilinearConfig),
    (0, $jWJrL.resizeBilinearGradConfig),
    (0, $cAOM1.resizeNearestNeighborConfig),
    (0, $8cAqa.resizeNearestNeighborGradConfig),
    (0, $DLIeE.reverseConfig),
    (0, $kSwap.rotateWithOffsetConfig),
    (0, $jfy0V.roundConfig),
    (0, $bUDnX.rsqrtConfig),
    (0, $8a0Og.scatterNdConfig),
    (0, $3tLqv.searchSortedConfig),
    (0, $jRAN6.selectConfig),
    (0, $bKRee.seluConfig),
    (0, $eLSm4.sigmoidConfig),
    (0, $j6cju.signConfig),
    (0, $5jZs7.sinConfig),
    (0, $bBqE7.sinhConfig),
    (0, $59DpV.sliceConfig),
    (0, $bNWZZ.softmaxConfig),
    (0, $jUwcI.softplusConfig),
    (0, $jCkjt.spaceToBatchNDConfig),
    (0, $40gFl.sparseFillEmptyRowsConfig),
    (0, $1XdE4.sparseReshapeConfig),
    (0, $73WGk.sparseSegmentMeanConfig),
    (0, $hTBT7.sparseSegmentSumConfig),
    (0, $jYTdj.sparseToDenseConfig),
    (0, $3yZvF.splitVConfig),
    (0, $e5xGp.sqrtConfig),
    (0, $5HMOv.squareConfig),
    (0, $aIdWo.squaredDifferenceConfig),
    (0, $h11VZ.staticRegexReplaceConfig),
    (0, $1SMNA.stepConfig),
    (0, $bJaiT.stridedSliceConfig),
    (0, $iD02Q.stringNGramsConfig),
    (0, $hpxIk.stringSplitConfig),
    (0, $76mFA.stringToHashBucketFastConfig),
    (0, $2rbI5.subConfig),
    (0, $5Mi8L.sumConfig),
    (0, $hp7rt.tanConfig),
    (0, $k73c2.tanhConfig),
    (0, $aT6X8.tensorScatterUpdateConfig),
    (0, $fh5Jo.tileConfig),
    (0, $8BP3N.topKConfig),
    (0, $9CeFb.transformConfig),
    (0, $joI4E.transposeConfig),
    (0, $3Z9gg.uniqueConfig),
    (0, $imZ6w.unpackConfig),
    (0, $liGsA.unsortedSegmentSumConfig),
    (0, $jvRne.zerosLikeConfig)
];
for (const kernelConfig of $ffc9bd50f6d9430d$var$kernelConfigs)(0, $fPoI0.registerKernel)(kernelConfig);

});
parcelRegister("3WsdE", function(module, exports) {

$parcel$export(module.exports, "_fusedMatMulConfig", function () { return $2decada26b138814$export$f70d36da1c218f84; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $5AgIM = parcelRequire("5AgIM");

var $kuzxZ = parcelRequire("kuzxZ");

var $7q7qv = parcelRequire("7q7qv");
function $2decada26b138814$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let current;
    let addRes;
    let activationRes;
    const intermediates = [];
    const matMulRes = (0, $7q7qv.batchMatMul)({
        inputs: {
            a: a,
            b: b
        },
        attrs: {
            transposeA: transposeA,
            transposeB: transposeB
        },
        backend: backend
    });
    current = matMulRes;
    if (bias) {
        addRes = (0, $kuzxZ.add)({
            inputs: {
                a: current,
                b: bias
            },
            backend: backend
        });
        intermediates.push(current);
        current = addRes;
    }
    if (activation) {
        activationRes = (0, $5AgIM.applyActivation)(backend, current, activation, preluActivationWeights, leakyreluAlpha);
        intermediates.push(current);
        current = activationRes;
    }
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return current;
}
const $2decada26b138814$export$f70d36da1c218f84 = {
    kernelName: (0, $9BGT9._FusedMatMul),
    backendName: 'cpu',
    kernelFunc: $2decada26b138814$export$d86ca0bbe0236889
};

});
parcelRegister("5AgIM", function(module, exports) {

$parcel$export(module.exports, "applyActivation", function () { return $410d4907d0c8c315$export$a0f250a2ba84196; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $bk7Yz = parcelRequire("bk7Yz");

var $l9MqT = parcelRequire("l9MqT");

var $8B2Nq = parcelRequire("8B2Nq");

var $6es5J = parcelRequire("6es5J");

var $3mxSY = parcelRequire("3mxSY");

var $gDXns = parcelRequire("gDXns");

var $eLSm4 = parcelRequire("eLSm4");
function $410d4907d0c8c315$export$a0f250a2ba84196(backend, x, activation, preluActivationWeights, leakyreluAlpha) {
    if (activation === 'linear') return (0, $l9MqT.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'relu') return (0, $3mxSY.relu)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'elu') return (0, $bk7Yz.elu)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'relu6') return (0, $gDXns.relu6)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else if (activation === 'prelu') return (0, $6es5J.prelu)({
        inputs: {
            x: x,
            alpha: preluActivationWeights
        },
        backend: backend
    });
    else if (activation === 'leakyrelu') return (0, $8B2Nq.leakyRelu)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            alpha: leakyreluAlpha
        }
    });
    else if (activation === 'sigmoid') return (0, $eLSm4.sigmoid)({
        inputs: {
            x: x
        },
        backend: backend
    });
    throw new Error(`Activation ${activation} has not been implemented for the CPU backend.`);
}

});
parcelRegister("bk7Yz", function(module, exports) {

$parcel$export(module.exports, "elu", function () { return $83e7bfd480e0984e$export$796b583dd79d8524; });
$parcel$export(module.exports, "eluConfig", function () { return $83e7bfd480e0984e$export$b990686634ee3cce; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $83e7bfd480e0984e$export$796b583dd79d8524 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Elu), (xi)=>xi >= 0 ? xi : Math.exp(xi) - 1);
const $83e7bfd480e0984e$export$b990686634ee3cce = {
    kernelName: (0, $9BGT9.Elu),
    backendName: 'cpu',
    kernelFunc: $83e7bfd480e0984e$export$796b583dd79d8524
};

});
parcelRegister("6wQye", function(module, exports) {

$parcel$export(module.exports, "unaryKernelFunc", function () { return $4c0e7ed17b03619a$export$ba4daf5748026fba; });
$parcel$export(module.exports, "unaryKernelFuncFromImpl", function () { return $4c0e7ed17b03619a$export$34f6865a07ad09b6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");

var $wi69v = parcelRequire("wi69v");

var $cfLEm = parcelRequire("cfLEm");
function $4c0e7ed17b03619a$export$ba4daf5748026fba(name, op, dtype) {
    const impl = (0, $cfLEm.createSimpleUnaryImpl)(op);
    return $4c0e7ed17b03619a$export$34f6865a07ad09b6(name, impl, dtype);
}
function $4c0e7ed17b03619a$export$34f6865a07ad09b6(name, unaryImpl, dtype) {
    return ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        (0, $wi69v.assertNotComplex)(x, name);
        const cpuBackend = backend;
        const values = cpuBackend.data.get(x.dataId).values;
        let decoded;
        if (x.dtype === 'string') {
            if (!Array.isArray(values)) throw new Error('String tensor\'s value was not an instance of Array');
            decoded = (0, $dEVRx).fromUint8ToStringArray(values);
        } else decoded = values;
        const $dtype = dtype || x.dtype;
        const newValues = unaryImpl(decoded, $dtype, attrs);
        return cpuBackend.makeTensorInfo(x.shape, $dtype, newValues);
    };
}

});
parcelRegister("cfLEm", function(module, exports) {

$parcel$export(module.exports, "createSimpleUnaryImpl", function () { return $8ebbd906c779d885$export$ef8b4452872ef3fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $8ebbd906c779d885$export$ef8b4452872ef3fc(op) {
    return (values, dtype, attrs)=>{
        const newValues = (0, $lBDHD).getArrayFromDType(dtype, values.length);
        for(let i = 0; i < values.length; ++i)newValues[i] = op(values[i], attrs);
        return newValues;
    };
}

});



parcelRegister("l9MqT", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $f67001fc9f267855$export$f0954fd7d5368655; });
$parcel$export(module.exports, "identityConfig", function () { return $f67001fc9f267855$export$c426d3942537ad84; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
function $f67001fc9f267855$export$f0954fd7d5368655(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $f67001fc9f267855$export$c426d3942537ad84 = {
    kernelName: (0, $9BGT9.Identity),
    backendName: 'cpu',
    kernelFunc: $f67001fc9f267855$export$f0954fd7d5368655
};

});

parcelRegister("8B2Nq", function(module, exports) {

$parcel$export(module.exports, "leakyRelu", function () { return $019d7ba7f42f9753$export$23a860e40a2c6b61; });
$parcel$export(module.exports, "leakyReluConfig", function () { return $019d7ba7f42f9753$export$aa04ab963fdf437f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $019d7ba7f42f9753$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    (0, $wi69v.assertNotComplex)([
        x
    ], 'leakyRelu');
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const xVals = backend.data.get(x.dataId).values;
    const outVals = (0, $lBDHD).getTypedArrayFromDType('float32', xSize);
    for(let i = 0; i < xVals.length; i++)outVals[i] = xVals[i] < 0 ? alpha * xVals[i] : xVals[i];
    return backend.makeTensorInfo(x.shape, 'float32', outVals);
}
const $019d7ba7f42f9753$export$aa04ab963fdf437f = {
    kernelName: (0, $9BGT9.LeakyRelu),
    backendName: 'cpu',
    kernelFunc: $019d7ba7f42f9753$export$23a860e40a2c6b61
};

});

parcelRegister("6es5J", function(module, exports) {

$parcel$export(module.exports, "prelu", function () { return $4899d74277f267d6$export$5882f235222e6729; });
$parcel$export(module.exports, "preluConfig", function () { return $4899d74277f267d6$export$a5c4a9b694579636; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $bhNFZ = parcelRequire("bhNFZ");
const $4899d74277f267d6$var$preluImpl = (0, $bhNFZ.createSimpleBinaryKernelImpl)((xValue, aValue)=>xValue < 0 ? aValue * xValue : xValue);
function $4899d74277f267d6$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    (0, $wi69v.assertNotComplex)([
        x,
        alpha
    ], 'prelu');
    const aVals = backend.data.get(x.dataId).values;
    const bVals = backend.data.get(alpha.dataId).values;
    const [resultData, resultShape] = $4899d74277f267d6$var$preluImpl(x.shape, alpha.shape, aVals, bVals, 'float32');
    return backend.makeTensorInfo(resultShape, 'float32', resultData);
}
const $4899d74277f267d6$export$a5c4a9b694579636 = {
    kernelName: (0, $9BGT9.Prelu),
    backendName: 'cpu',
    kernelFunc: $4899d74277f267d6$export$5882f235222e6729
};

});
parcelRegister("bhNFZ", function(module, exports) {

$parcel$export(module.exports, "createSimpleBinaryKernelImpl", function () { return $8377d0e3dbab299f$export$28de919591fae5d9; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");
function $8377d0e3dbab299f$export$28de919591fae5d9(op) {
    return (aShape, bShape, aVals, bVals, dtype)=>{
        const newShape = (0, $dEVRx).assertAndGetBroadcastShape(aShape, bShape);
        const resultRank = newShape.length;
        const resultStrides = (0, $lBDHD).computeStrides(newShape);
        const resultSize = (0, $lBDHD).sizeFromShape(newShape);
        const result = (0, $lBDHD).getTypedArrayFromDType(dtype, resultSize);
        const aRank = aShape.length;
        const bRank = bShape.length;
        const aStrides = (0, $lBDHD).computeStrides(aShape);
        const bStrides = (0, $lBDHD).computeStrides(bShape);
        const aBroadcastDims = (0, $dEVRx).getBroadcastDims(aShape, newShape);
        const bBroadcastDims = (0, $dEVRx).getBroadcastDims(bShape, newShape);
        if (aBroadcastDims.length + bBroadcastDims.length === 0) for(let i = 0; i < result.length; ++i)result[i] = op(aVals[i % aVals.length], bVals[i % bVals.length]);
        else for(let i = 0; i < result.length; ++i){
            const loc = (0, $lBDHD).indexToLoc(i, resultRank, resultStrides);
            const aLoc = loc.slice(-aRank);
            aBroadcastDims.forEach((d)=>aLoc[d] = 0);
            const aIndex = (0, $lBDHD).locToIndex(aLoc, aRank, aStrides);
            const bLoc = loc.slice(-bRank);
            bBroadcastDims.forEach((d)=>bLoc[d] = 0);
            const bIndex = (0, $lBDHD).locToIndex(bLoc, bRank, bStrides);
            result[i] = op(aVals[aIndex], bVals[bIndex]);
        }
        return [
            result,
            newShape
        ];
    };
}

});


parcelRegister("3mxSY", function(module, exports) {

$parcel$export(module.exports, "relu", function () { return $272db622c212aadd$export$16d1e4612cc0139f; });
$parcel$export(module.exports, "reluConfig", function () { return $272db622c212aadd$export$731f9199bde068eb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $272db622c212aadd$export$16d1e4612cc0139f = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Relu), (xi)=>Math.max(0, xi));
const $272db622c212aadd$export$731f9199bde068eb = {
    kernelName: (0, $9BGT9.Relu),
    backendName: 'cpu',
    kernelFunc: $272db622c212aadd$export$16d1e4612cc0139f
};

});

parcelRegister("gDXns", function(module, exports) {

$parcel$export(module.exports, "relu6", function () { return $c1de58fd6f9830ed$export$4a62bcb95e9c44c4; });
$parcel$export(module.exports, "relu6Config", function () { return $c1de58fd6f9830ed$export$92c30890ad649d53; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $c1de58fd6f9830ed$export$4a62bcb95e9c44c4 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Relu6), (xi)=>Math.min(Math.max(0, xi), 6));
const $c1de58fd6f9830ed$export$92c30890ad649d53 = {
    kernelName: (0, $9BGT9.Relu6),
    backendName: 'cpu',
    kernelFunc: $c1de58fd6f9830ed$export$4a62bcb95e9c44c4
};

});

parcelRegister("eLSm4", function(module, exports) {

$parcel$export(module.exports, "sigmoidImpl", function () { return $ac0f9e42c597c9dc$export$e31bae35ce8238b3; });
$parcel$export(module.exports, "sigmoid", function () { return $ac0f9e42c597c9dc$export$3b295495ca3cad7c; });
$parcel$export(module.exports, "sigmoidConfig", function () { return $ac0f9e42c597c9dc$export$195d1cf7c59f3ef; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $ac0f9e42c597c9dc$export$e31bae35ce8238b3 = (0, $cfLEm.createSimpleUnaryImpl)((xi)=>1 / (1 + Math.exp(-xi)));
const $ac0f9e42c597c9dc$export$3b295495ca3cad7c = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Sigmoid), (xi)=>1 / (1 + Math.exp(-xi)));
const $ac0f9e42c597c9dc$export$195d1cf7c59f3ef = {
    kernelName: (0, $9BGT9.Sigmoid),
    backendName: 'cpu',
    kernelFunc: $ac0f9e42c597c9dc$export$3b295495ca3cad7c
};

});


parcelRegister("kuzxZ", function(module, exports) {

$parcel$export(module.exports, "addImpl", function () { return $eeb22ee76de9c1c4$export$da57353b24bb5e2; });
$parcel$export(module.exports, "add", function () { return $eeb22ee76de9c1c4$export$e16d8520af44a096; });
$parcel$export(module.exports, "addConfig", function () { return $eeb22ee76de9c1c4$export$b1f3a580afb68e4c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $eeb22ee76de9c1c4$export$da57353b24bb5e2 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a + b);
const $eeb22ee76de9c1c4$export$ace1d0de36b43ba2 = (0, $bvj2l.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal + bReal,
        imag: aImag + bImag
    };
});
const $eeb22ee76de9c1c4$export$e16d8520af44a096 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Add), $eeb22ee76de9c1c4$export$da57353b24bb5e2, $eeb22ee76de9c1c4$export$ace1d0de36b43ba2);
const $eeb22ee76de9c1c4$export$b1f3a580afb68e4c = {
    kernelName: (0, $9BGT9.Add),
    backendName: 'cpu',
    kernelFunc: $eeb22ee76de9c1c4$export$e16d8520af44a096
};

});
parcelRegister("bvj2l", function(module, exports) {

$parcel$export(module.exports, "binaryKernelFunc", function () { return $86015b4745710d16$export$29353c66e70e3e16; });
$parcel$export(module.exports, "createComplexBinaryKernelImpl", function () { return $86015b4745710d16$export$79261d982c3c14a7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $9IBUg = parcelRequire("9IBUg");

var $hmrWF = parcelRequire("hmrWF");
function $86015b4745710d16$export$29353c66e70e3e16(name, simpleImpl, complexImpl, dtype) {
    if (complexImpl == null) return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const cpuBackend = backend;
        (0, $wi69v.assertNotComplex)([
            a,
            b
        ], name);
        const aVals = cpuBackend.data.get(a.dataId).values;
        const bVals = cpuBackend.data.get(b.dataId).values;
        const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
        (0, $dEVRx).fromUint8ToStringArray(aVals) : aVals;
        const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
        (0, $dEVRx).fromUint8ToStringArray(bVals) : bVals;
        const $dtype = dtype || a.dtype;
        const [resultData, resultShape] = simpleImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
        return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
    };
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const cpuBackend = backend;
        if (a.dtype === 'complex64' || b.dtype === 'complex64') {
            const $aComplex = (0, $9IBUg.cast)({
                inputs: {
                    x: a
                },
                backend: cpuBackend,
                attrs: {
                    dtype: 'complex64'
                }
            });
            const $aComplexVals = cpuBackend.data.get($aComplex.dataId);
            const aReal = $aComplexVals.complexTensorInfos.real;
            const aImag = $aComplexVals.complexTensorInfos.imag;
            const aRealVals = cpuBackend.data.get(aReal.dataId).values;
            const aImagVals = cpuBackend.data.get(aImag.dataId).values;
            const $bComplex = (0, $9IBUg.cast)({
                inputs: {
                    x: b
                },
                backend: cpuBackend,
                attrs: {
                    dtype: 'complex64'
                }
            });
            const $bComplexVals = cpuBackend.data.get($bComplex.dataId);
            const bReal = $bComplexVals.complexTensorInfos.real;
            const bImag = $bComplexVals.complexTensorInfos.imag;
            const bRealVals = cpuBackend.data.get(bReal.dataId).values;
            const bImagVals = cpuBackend.data.get(bImag.dataId).values;
            const [resultRealData, resultImagData, resultShape] = complexImpl(a.shape, b.shape, aRealVals, aImagVals, bRealVals, bImagVals);
            const resultReal = cpuBackend.makeTensorInfo(resultShape, 'float32', resultRealData);
            const resultImag = cpuBackend.makeTensorInfo(resultShape, 'float32', resultImagData);
            const result = (0, $hmrWF.complex)({
                inputs: {
                    real: resultReal,
                    imag: resultImag
                },
                backend: cpuBackend
            });
            cpuBackend.disposeIntermediateTensorInfo($aComplex);
            cpuBackend.disposeIntermediateTensorInfo($bComplex);
            cpuBackend.disposeIntermediateTensorInfo(resultReal);
            cpuBackend.disposeIntermediateTensorInfo(resultImag);
            return result;
        } else {
            const aVals = cpuBackend.data.get(a.dataId).values;
            const bVals = cpuBackend.data.get(b.dataId).values;
            const $dtype = dtype || a.dtype;
            const [resultData, resultShape] = simpleImpl(a.shape, b.shape, aVals, bVals, $dtype);
            return cpuBackend.makeTensorInfo(resultShape, $dtype, resultData);
        }
    };
}
function $86015b4745710d16$export$79261d982c3c14a7(op) {
    return (aShape, bShape, aRealVals, aImagVals, bRealVals, bImagVals)=>{
        const resultShape = (0, $dEVRx).assertAndGetBroadcastShape(aShape, bShape);
        const resultSize = (0, $lBDHD).sizeFromShape(resultShape);
        const resultRank = resultShape.length;
        const resultStrides = (0, $lBDHD).computeStrides(resultShape);
        const resultRealVals = (0, $lBDHD).getTypedArrayFromDType('float32', resultSize);
        const resultImagVals = (0, $lBDHD).getTypedArrayFromDType('float32', resultSize);
        const aBroadcastDims = (0, $dEVRx).getBroadcastDims(aShape, resultShape);
        const bBroadcastDims = (0, $dEVRx).getBroadcastDims(bShape, resultShape);
        const aVals = (0, $dEVRx).mergeRealAndImagArrays(aRealVals, aImagVals);
        const bVals = (0, $dEVRx).mergeRealAndImagArrays(bRealVals, bImagVals);
        const aRank = aShape.length;
        const aStrides = (0, $lBDHD).computeStrides(aShape);
        const bRank = bShape.length;
        const bStrides = (0, $lBDHD).computeStrides(bShape);
        if (aBroadcastDims.length + bBroadcastDims.length === 0) for(let i = 0; i < resultRealVals.length; i++){
            const aIdx = i % aVals.length;
            const bIdx = i % bVals.length;
            const result = op(aVals[aIdx * 2], aVals[aIdx * 2 + 1], bVals[bIdx * 2], bVals[bIdx * 2 + 1]);
            resultRealVals[i] = result.real;
            resultImagVals[i] = result.imag;
        }
        else for(let i = 0; i < resultRealVals.length; i++){
            const loc = (0, $lBDHD).indexToLoc(i, resultRank, resultStrides);
            const aLoc = loc.slice(-aRank);
            aBroadcastDims.forEach((d)=>aLoc[d] = 0);
            const aIndex = (0, $lBDHD).locToIndex(aLoc, aRank, aStrides);
            const bLoc = loc.slice(-bRank);
            bBroadcastDims.forEach((d)=>bLoc[d] = 0);
            const bIndex = (0, $lBDHD).locToIndex(bLoc, bRank, bStrides);
            const opResult = op(aVals[aIndex * 2], aVals[aIndex * 2 + 1], bVals[bIndex * 2], bVals[bIndex * 2 + 1]);
            resultRealVals[i] = opResult.real;
            resultImagVals[i] = opResult.imag;
        }
        return [
            resultRealVals,
            resultImagVals,
            resultShape
        ];
    };
}

});
parcelRegister("9IBUg", function(module, exports) {

$parcel$export(module.exports, "castImpl", function () { return $7135a08f8310a9ae$export$aeeb3b33e2cee0c5; });
$parcel$export(module.exports, "cast", function () { return $7135a08f8310a9ae$export$f2db7d5238e1d23f; });
$parcel$export(module.exports, "castConfig", function () { return $7135a08f8310a9ae$export$ac4d0f0f3927a8f3; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $bhNFZ = parcelRequire("bhNFZ");

var $d9WU5 = parcelRequire("d9WU5");

var $hmrWF = parcelRequire("hmrWF");

var $l9MqT = parcelRequire("l9MqT");

var $fWJq3 = parcelRequire("fWJq3");
function $7135a08f8310a9ae$export$aeeb3b33e2cee0c5(values, shape, inputType, dtype) {
    if (dtype === 'int32') {
        const resultValues = Int32Array.from(values);
        return [
            shape,
            'int32',
            resultValues
        ];
    }
    if (dtype === 'bool') {
        // This is essentially the result of notEqual(x, 0). We avoid using
        // kernel notEqual to avoid circular dependency, i.e. binary_utils ->
        // cast -> notEqual -> binary_utils.
        const zero = (0, $lBDHD).toTypedArray([
            0
        ], inputType);
        const [resultData, resultShape] = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a !== b ? 1 : 0)(shape, [], values, zero, 'bool');
        return [
            resultShape,
            'bool',
            resultData
        ];
    }
    throw new Error(`Error in Cast: failed to cast ${inputType} to ${dtype}`);
}
function $7135a08f8310a9ae$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $l9MqT.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        const zerosTensorInfo = (0, $d9WU5.zeros)(backend, x.shape, x.dtype);
        const floatX = $7135a08f8310a9ae$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $hmrWF.complex)({
            inputs: {
                real: floatX,
                imag: zerosTensorInfo
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(zerosTensorInfo);
        backend.disposeIntermediateTensorInfo(floatX);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $fWJq3.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $7135a08f8310a9ae$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeIntermediateTensorInfo(realPart);
        return result;
    }
    if (!(0, $lBDHD).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $l9MqT.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    const values = backend.data.get(x.dataId).values;
    const [resultShape, resultType, resultData] = $7135a08f8310a9ae$export$aeeb3b33e2cee0c5(values, x.shape, x.dtype, dtype);
    return backend.makeTensorInfo(resultShape, resultType, resultData);
}
const $7135a08f8310a9ae$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $9BGT9.Cast),
    backendName: 'cpu',
    kernelFunc: $7135a08f8310a9ae$export$f2db7d5238e1d23f
};

});
parcelRegister("d9WU5", function(module, exports) {

$parcel$export(module.exports, "zeros", function () { return $9949ceaa20110c0e$export$4445a00dafa2633b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $hmrWF = parcelRequire("hmrWF");
function $9949ceaa20110c0e$export$4445a00dafa2633b(backend, shape, dtype = 'float32') {
    if (dtype === 'complex64') {
        const real = $9949ceaa20110c0e$export$4445a00dafa2633b(backend, shape, 'float32');
        const imag = $9949ceaa20110c0e$export$4445a00dafa2633b(backend, shape, 'float32');
        return (0, $hmrWF.complex)({
            inputs: {
                real: real,
                imag: imag
            },
            backend: backend
        });
    }
    const values = (0, $lBDHD).makeZerosTypedArray((0, $lBDHD).sizeFromShape(shape), dtype);
    return backend.makeTensorInfo(shape, dtype, values);
}

});
parcelRegister("hmrWF", function(module, exports) {

$parcel$export(module.exports, "complex", function () { return $ca3a2b148d03d96a$export$83a0e34f1302825b; });
$parcel$export(module.exports, "complexConfig", function () { return $ca3a2b148d03d96a$export$67917f7910d27fd8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
function $ca3a2b148d03d96a$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const realVals = backend.data.get(real.dataId).values;
    const imagVals = backend.data.get(imag.dataId).values;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.data.get(complexInfo.dataId);
    // The complex tensor owns the underlying real and imag tensorInfos, only the
    // complex tensor tracks refCount, when complexData is disposed the
    // underlying tensorData will be disposed.
    complex.complexTensorInfos = {
        real: backend.makeTensorInfo(real.shape, 'float32', realVals),
        imag: backend.makeTensorInfo(imag.shape, 'float32', imagVals)
    };
    return complexInfo;
}
const $ca3a2b148d03d96a$export$67917f7910d27fd8 = {
    kernelName: (0, $9BGT9.Complex),
    backendName: 'cpu',
    kernelFunc: $ca3a2b148d03d96a$export$83a0e34f1302825b
};

});


parcelRegister("fWJq3", function(module, exports) {

$parcel$export(module.exports, "real", function () { return $b9bf8117da8d11e9$export$9fc57fb453bdbd67; });
$parcel$export(module.exports, "realConfig", function () { return $b9bf8117da8d11e9$export$4b7bce57557ae68b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
function $b9bf8117da8d11e9$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const real = backend.data.get(input.dataId).complexTensorInfos.real;
    const realVal = backend.data.get(real.dataId).values;
    // When complex tensor is disposed, its underlying parts will be disposed too.
    // Make new tensor out of the real value of the complex. This makes sure the
    // value is still accessible even if complex tensor is disposed.
    return backend.makeTensorInfo(real.shape, real.dtype, realVal);
}
const $b9bf8117da8d11e9$export$4b7bce57557ae68b = {
    kernelName: (0, $9BGT9.Real),
    backendName: 'cpu',
    kernelFunc: $b9bf8117da8d11e9$export$9fc57fb453bdbd67
};

});




parcelRegister("7q7qv", function(module, exports) {

$parcel$export(module.exports, "batchMatMul", function () { return $5670b8deacd8ded6$export$8f97894b482227f0; });
$parcel$export(module.exports, "batchMatMulConfig", function () { return $5670b8deacd8ded6$export$d0dd993198185538; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $5mf1d = parcelRequire("5mf1d");
var $5siju = parcelRequire("5siju");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $dOeSU = parcelRequire("dOeSU");
function $5670b8deacd8ded6$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    (0, $wi69v.assertNotComplex)([
        a,
        b
    ], 'matMul');
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $lBDHD).sizeFromShape(outerDimsA);
    const batchDimB = (0, $lBDHD).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $5mf1d).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $lBDHD).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $dOeSU.reshape)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $dOeSU.reshape)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
    const leftDim = transposeA ? a3d.shape[2] : a3d.shape[1];
    const rightDim = transposeB ? b3d.shape[1] : b3d.shape[2];
    const batchDim = Math.max(batchDimA, batchDimB);
    const a3dValues = backend.data.get(a3d.dataId).values;
    const b3dValues = backend.data.get(b3d.dataId).values;
    const a3dStrides = (0, $lBDHD).computeStrides(a3d.shape);
    const b3dStrides = (0, $lBDHD).computeStrides(b3d.shape);
    const [aBatch, aOuterStep, aInnerStep] = transposeA ? [
        a3dStrides[0],
        1,
        a3dStrides[1]
    ] : [
        a3dStrides[0],
        a3dStrides[1],
        1
    ];
    const [bInnerStep, bOuterStep, bBatch] = transposeB ? [
        1,
        b3dStrides[1],
        b3dStrides[0]
    ] : [
        b3dStrides[1],
        1,
        b3dStrides[0]
    ];
    const size = leftDim * rightDim;
    const result = (0, $5siju.buffer)([
        batchDim,
        leftDim,
        rightDim
    ], a3d.dtype);
    const resVals = result.values;
    const blockSize = backend.blockSize;
    for(let bi = 0; bi < batchDim; bi++){
        const batchIndexA = bi % batchDimA;
        const batchIndexB = bi % batchDimB;
        for(let i0 = 0; i0 < leftDim; i0 += blockSize){
            // for when blockSize doesn't evenly divide the input
            const iBlock = Math.min(i0 + blockSize, leftDim);
            for(let j0 = 0; j0 < rightDim; j0 += blockSize){
                const jBlock = Math.min(j0 + blockSize, rightDim);
                for(let k0 = 0; k0 < sharedDim; k0 += blockSize){
                    const kBlock = Math.min(k0 + blockSize, sharedDim);
                    for(let i = i0; i < iBlock; i++)for(let j = j0; j < jBlock; j++){
                        let sum = 0.0;
                        for(let k = k0; k < kBlock; k++){
                            const aVal = // tslint:disable-next-line: max-line-length
                            a3dValues[batchIndexA * aBatch + i * aOuterStep + k * aInnerStep];
                            const bVal = // tslint:disable-next-line: max-line-length
                            b3dValues[k * bInnerStep + j * bOuterStep + batchIndexB * bBatch];
                            sum += aVal * bVal;
                        }
                        resVals[bi * size + (i * rightDim + j)] += sum;
                    }
                }
            }
        }
    }
    backend.disposeIntermediateTensorInfo(a3d);
    backend.disposeIntermediateTensorInfo(b3d);
    // set correct shape on output.
    return backend.makeTensorInfo(outShape, result.dtype, result.values);
}
const $5670b8deacd8ded6$export$d0dd993198185538 = {
    kernelName: (0, $9BGT9.BatchMatMul),
    backendName: 'cpu',
    kernelFunc: $5670b8deacd8ded6$export$8f97894b482227f0
};

});
parcelRegister("dOeSU", function(module, exports) {

$parcel$export(module.exports, "reshape", function () { return $a0db7da65ffbe67c$export$9eaad88cf88cee2b; });
$parcel$export(module.exports, "reshapeConfig", function () { return $a0db7da65ffbe67c$export$cfa02e698602aca2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
function $a0db7da65ffbe67c$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const $shape = (0, $lBDHD).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $lBDHD).sizeFromShape($shape);
    (0, $lBDHD).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    backend.incRef(x.dataId);
    const xData = backend.data.get(x.dataId);
    if (xData.complexTensorInfos != null) {
        const real = xData.complexTensorInfos.real;
        const imag = xData.complexTensorInfos.imag;
        real.shape = $shape;
        imag.shape = $shape;
    }
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $a0db7da65ffbe67c$export$cfa02e698602aca2 = {
    kernelName: (0, $9BGT9.Reshape),
    backendName: 'cpu',
    kernelFunc: $a0db7da65ffbe67c$export$9eaad88cf88cee2b
};

});



parcelRegister("cSRnW", function(module, exports) {

$parcel$export(module.exports, "simpleAbsImpl", function () { return $9613f0568dd3bfd6$export$9e7ee8a1798ec2d5; });
$parcel$export(module.exports, "absConfig", function () { return $9613f0568dd3bfd6$export$d66f48648b9d5ec7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $9613f0568dd3bfd6$export$9e7ee8a1798ec2d5(vals) {
    const resultValues = new Float32Array(vals.length);
    for(let i = 0; i < vals.length; ++i)resultValues[i] = Math.abs(vals[i]);
    return resultValues;
}
const $9613f0568dd3bfd6$export$2335f513bbd82c6d = (args)=>{
    const { x: x } = args.inputs;
    const cpuBackend = args.backend;
    (0, $wi69v.assertNotComplex)(x, 'abs');
    let resultValues = new Float32Array((0, $lBDHD).sizeFromShape(x.shape));
    const values = cpuBackend.data.get(x.dataId).values;
    resultValues = $9613f0568dd3bfd6$export$9e7ee8a1798ec2d5(values);
    return cpuBackend.makeOutput(resultValues, x.shape, x.dtype);
};
const $9613f0568dd3bfd6$export$d66f48648b9d5ec7 = {
    kernelName: (0, $9BGT9.Abs),
    backendName: 'cpu',
    kernelFunc: $9613f0568dd3bfd6$export$2335f513bbd82c6d
};

});

parcelRegister("2KxaV", function(module, exports) {

$parcel$export(module.exports, "acosConfig", function () { return $20099c8ec01889c5$export$255826ca70737275; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $20099c8ec01889c5$export$fd6306be3fde5b04 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Acos), (xi)=>Math.acos(xi));
const $20099c8ec01889c5$export$255826ca70737275 = {
    kernelName: (0, $9BGT9.Acos),
    backendName: 'cpu',
    kernelFunc: $20099c8ec01889c5$export$fd6306be3fde5b04
};

});

parcelRegister("Qxmxv", function(module, exports) {

$parcel$export(module.exports, "acoshConfig", function () { return $09debc8c6f8a0d80$export$3f520b71a56c9e70; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $09debc8c6f8a0d80$export$b26caf0f29211d08 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Acosh), (xi)=>Math.acosh(xi));
const $09debc8c6f8a0d80$export$3f520b71a56c9e70 = {
    kernelName: (0, $9BGT9.Acosh),
    backendName: 'cpu',
    kernelFunc: $09debc8c6f8a0d80$export$b26caf0f29211d08
};

});

parcelRegister("4eK92", function(module, exports) {

$parcel$export(module.exports, "addNConfig", function () { return $315c43a36b0449db$export$ff8000bc6f0313e1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $5siju = parcelRequire("5siju");

var $wi69v = parcelRequire("wi69v");
function $315c43a36b0449db$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    (0, $wi69v.assertNotComplex)(inputs, 'addN');
    const vals = tensors.map((t)=>backend.data.get(t.dataId).values);
    const outBuf = (0, $5siju.buffer)(tensors[0].shape, tensors[0].dtype);
    const outVals = outBuf.values;
    for(let i = 0; i < tensors.length; i++){
        const currVals = vals[i];
        for(let j = 0; j < outVals.length; j++)outVals[j] += currVals[j];
    }
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $315c43a36b0449db$export$ff8000bc6f0313e1 = {
    kernelName: (0, $9BGT9.AddN),
    backendName: 'cpu',
    kernelFunc: $315c43a36b0449db$export$37b75d0026f96b8d
};

});

parcelRegister("8FaUp", function(module, exports) {

$parcel$export(module.exports, "allConfig", function () { return $64ea9d51f49cbded$export$4e3f081eb1a330fa; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $dOeSU = parcelRequire("dOeSU");

var $joI4E = parcelRequire("joI4E");
function $64ea9d51f49cbded$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'all');
    const origAxes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $joI4E.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('all', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const vals = (0, $lBDHD).makeZerosTypedArray((0, $lBDHD).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let all = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            all = all && value;
        }
        vals[i] = all;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $dEVRx).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $dOeSU.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $64ea9d51f49cbded$export$4e3f081eb1a330fa = {
    kernelName: (0, $9BGT9.All),
    backendName: 'cpu',
    kernelFunc: $64ea9d51f49cbded$export$84bf76cd7afc7469
};

});
parcelRegister("joI4E", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $e1f2726aa0d7225f$export$9cb09a71b7d66923; });
$parcel$export(module.exports, "transposeConfig", function () { return $e1f2726aa0d7225f$export$895a002a39b774be; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $4gkPf = parcelRequire("4gkPf");
function $e1f2726aa0d7225f$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'transpose');
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    const values = backend.data.get(x.dataId).values;
    const result = (0, $4gkPf.transposeImpl)(values, x.shape, x.dtype, perm, newShape);
    const dataId = backend.write(result, newShape, x.dtype);
    return {
        dataId: dataId,
        shape: newShape,
        dtype: x.dtype
    };
}
const $e1f2726aa0d7225f$export$895a002a39b774be = {
    kernelName: (0, $9BGT9.Transpose),
    backendName: 'cpu',
    kernelFunc: $e1f2726aa0d7225f$export$9cb09a71b7d66923
};

});
parcelRegister("4gkPf", function(module, exports) {

$parcel$export(module.exports, "transposeImpl", function () { return $31a8cf8cb9536319$export$986b9e65182e08d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $31a8cf8cb9536319$export$986b9e65182e08d(xVals, xShape, dtype, perm, newShape) {
    const xRank = xShape.length;
    const xSize = (0, $lBDHD).sizeFromShape(xShape);
    const xStrides = (0, $lBDHD).computeStrides(xShape);
    const newStrides = (0, $lBDHD).computeStrides(newShape);
    const result = (0, $lBDHD).getTypedArrayFromDType(dtype, (0, $lBDHD).sizeFromShape(newShape));
    for(let i = 0; i < xSize; ++i){
        const loc = (0, $lBDHD).indexToLoc(i, xRank, xStrides);
        // Permute location.
        const newLoc = new Array(loc.length);
        for(let i = 0; i < newLoc.length; i++)newLoc[i] = loc[perm[i]];
        const newIndex = (0, $lBDHD).locToIndex(newLoc, xRank, newStrides);
        result[newIndex] = xVals[i];
    }
    return result;
}

});



parcelRegister("edrPc", function(module, exports) {

$parcel$export(module.exports, "anyConfig", function () { return $a597dd05251626b7$export$1a8ff634f2df3da6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $dOeSU = parcelRequire("dOeSU");

var $joI4E = parcelRequire("joI4E");
function $a597dd05251626b7$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'any');
    const origAxes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $joI4E.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('any', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const vals = (0, $lBDHD).makeZerosTypedArray((0, $lBDHD).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let anyVal = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            anyVal = anyVal || value;
        }
        vals[i] = anyVal;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $dEVRx).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $dOeSU.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $a597dd05251626b7$export$1a8ff634f2df3da6 = {
    kernelName: (0, $9BGT9.Any),
    backendName: 'cpu',
    kernelFunc: $a597dd05251626b7$export$4154a199d7d90455
};

});

parcelRegister("V7Vzy", function(module, exports) {

$parcel$export(module.exports, "argMaxConfig", function () { return $0abb793d6eb87b67$export$ec7419fc9ad0069e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $joI4E = parcelRequire("joI4E");
function $0abb793d6eb87b67$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'argMax');
    let axes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $joI4E.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, $x.shape.length);
    }
    axes = [
        axes[0]
    ];
    (0, $dEVRx).assertAxesAreInnerMostDims('argMax', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes($x.shape, axes);
    const outSize = (0, $lBDHD).sizeFromShape(outShape);
    const vals = (0, $lBDHD).makeZerosTypedArray(outSize, 'int32');
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let max = aVals[offset];
        let maxIndex = 0;
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (value > max) {
                max = value;
                maxIndex = j;
            }
        }
        vals[i] = maxIndex;
    }
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(outShape, 'int32', vals);
}
const $0abb793d6eb87b67$export$ec7419fc9ad0069e = {
    kernelName: (0, $9BGT9.ArgMax),
    backendName: 'cpu',
    kernelFunc: $0abb793d6eb87b67$export$7980a683c1b852b4
};

});

parcelRegister("amH7s", function(module, exports) {

$parcel$export(module.exports, "argMinConfig", function () { return $78bd680c0dfb91e3$export$21836a5e5fa09eb4; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $joI4E = parcelRequire("joI4E");
function $78bd680c0dfb91e3$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'argMin');
    let axes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $joI4E.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, $x.shape.length);
    }
    axes = [
        axes[0]
    ];
    (0, $dEVRx).assertAxesAreInnerMostDims('argMin', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes($x.shape, axes);
    const outSize = (0, $lBDHD).sizeFromShape(outShape);
    const vals = (0, $lBDHD).makeZerosTypedArray(outSize, 'int32');
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let min = aVals[offset];
        let minIndex = 0;
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (value < min) {
                min = value;
                minIndex = j;
            }
        }
        vals[i] = minIndex;
    }
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(outShape, 'int32', vals);
}
const $78bd680c0dfb91e3$export$21836a5e5fa09eb4 = {
    kernelName: (0, $9BGT9.ArgMin),
    backendName: 'cpu',
    kernelFunc: $78bd680c0dfb91e3$export$ec99a91cddfb29a2
};

});

parcelRegister("5TudD", function(module, exports) {

$parcel$export(module.exports, "asinConfig", function () { return $44a987aa7c28df23$export$de5cb0ef95dd6700; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $44a987aa7c28df23$export$41726bdb1fc63f = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Asin), (xi)=>Math.asin(xi));
const $44a987aa7c28df23$export$de5cb0ef95dd6700 = {
    kernelName: (0, $9BGT9.Asin),
    backendName: 'cpu',
    kernelFunc: $44a987aa7c28df23$export$41726bdb1fc63f
};

});

parcelRegister("bIxq4", function(module, exports) {

$parcel$export(module.exports, "asinhConfig", function () { return $887dba32c082d16f$export$20d424616c76166; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $887dba32c082d16f$export$839d8a01b6af4fc0 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Asinh), (xi)=>Math.asinh(xi));
const $887dba32c082d16f$export$20d424616c76166 = {
    kernelName: (0, $9BGT9.Asinh),
    backendName: 'cpu',
    kernelFunc: $887dba32c082d16f$export$839d8a01b6af4fc0
};

});

parcelRegister("7FHsX", function(module, exports) {

$parcel$export(module.exports, "atanConfig", function () { return $595e1433bbc85bcb$export$159d632e3ff13624; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $595e1433bbc85bcb$export$628dc4eed22b0fbd = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Atan), (xi)=>Math.atan(xi));
const $595e1433bbc85bcb$export$159d632e3ff13624 = {
    kernelName: (0, $9BGT9.Atan),
    backendName: 'cpu',
    kernelFunc: $595e1433bbc85bcb$export$628dc4eed22b0fbd
};

});

parcelRegister("1pJRK", function(module, exports) {

$parcel$export(module.exports, "atan2Config", function () { return $107bb43f2e1262d6$export$c53c7ab019edb8a0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $107bb43f2e1262d6$export$2420f4f902e099a2 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.atan2(aValue, bValue));
const $107bb43f2e1262d6$export$b8b770ee6a0d9760 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Atan2), $107bb43f2e1262d6$export$2420f4f902e099a2);
const $107bb43f2e1262d6$export$c53c7ab019edb8a0 = {
    kernelName: (0, $9BGT9.Atan2),
    backendName: 'cpu',
    kernelFunc: $107bb43f2e1262d6$export$b8b770ee6a0d9760
};

});

parcelRegister("cR01M", function(module, exports) {

$parcel$export(module.exports, "atanhConfig", function () { return $95ba74cbde3f6b80$export$e9ce1ba75fc9b746; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $95ba74cbde3f6b80$export$21ea955025ceb08b = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Atanh), (xi)=>Math.atanh(xi));
const $95ba74cbde3f6b80$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $9BGT9.Atanh),
    backendName: 'cpu',
    kernelFunc: $95ba74cbde3f6b80$export$21ea955025ceb08b
};

});

parcelRegister("km6k9", function(module, exports) {

$parcel$export(module.exports, "avgPoolConfig", function () { return $03d3032b8d95657b$export$6c901824a23e6150; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $2YRGy = parcelRequire("2YRGy");

var $l9MqT = parcelRequire("l9MqT");
function $03d3032b8d95657b$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $wi69v.assertNotComplex)(x, 'avgPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $lBDHD).assert((0, $dEVRx).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    let res;
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $lBDHD).arraysEqual(convInfo.inShape, convInfo.outShape)) res = (0, $l9MqT.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else {
        const xValues = backend.data.get(x.dataId).values;
        const strides = (0, $lBDHD).computeStrides(x.shape);
        const buffer = (0, $2YRGy.pool)(xValues, x.shape, x.dtype, strides, convInfo, 'avg');
        res = backend.makeTensorInfo(convInfo.outShape, x.dtype, buffer.values);
    }
    return res;
}
const $03d3032b8d95657b$export$6c901824a23e6150 = {
    kernelName: (0, $9BGT9.AvgPool),
    backendName: 'cpu',
    kernelFunc: $03d3032b8d95657b$export$d5c65a2abd3d97dc
};

});
parcelRegister("2YRGy", function(module, exports) {

$parcel$export(module.exports, "pool", function () { return $22bad42a00b2ab7f$export$7a0e2789ec54f0db; });
$parcel$export(module.exports, "maxPoolPositions", function () { return $22bad42a00b2ab7f$export$60b78444d0fe518d; });
$parcel$export(module.exports, "pool3d", function () { return $22bad42a00b2ab7f$export$3712ebf21d29ff82; });
$parcel$export(module.exports, "maxPool3dPositions", function () { return $22bad42a00b2ab7f$export$e389a84eda2bb69e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
function $22bad42a00b2ab7f$export$7a0e2789ec54f0db(xValues, xShape, dtype, strides, convInfo, poolType) {
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const initialValue = poolType === 'max' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    const output = (0, $5siju.buffer)(convInfo.outShape, dtype);
    const outputVals = output.values;
    const outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3];
    const outputRowStrides = convInfo.outShape[2] * convInfo.outShape[3];
    const outputColStrides = convInfo.outShape[3];
    for(let b = 0; b < convInfo.batchSize; ++b){
        const outputBatchOffset = b * outputBatchStrides;
        const inputBatchOffset = b * strides[0];
        for(let d = 0; d < convInfo.inChannels; ++d)for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const xRCorner = yR * strideHeight - padTop;
            const xRMin = Math.max(0, xRCorner);
            const xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
            const outputRowOffset = outputBatchOffset + yR * outputRowStrides;
            for(let yC = 0; yC < convInfo.outWidth; ++yC){
                const xCCorner = yC * strideWidth - padLeft;
                const xCMin = Math.max(0, xCCorner);
                const xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
                let minMaxValue = initialValue;
                let avgValue = 0;
                let count = 0;
                for(let xR = xRMin; xR < xRMax; xR += dilationHeight){
                    const xROffset = inputBatchOffset + xR * strides[1];
                    for(let xC = xCMin; xC < xCMax; xC += dilationWidth){
                        const xCOffset = xROffset + xC * strides[2];
                        const pixel = xValues[xCOffset + d];
                        if (poolType === 'max' && pixel > minMaxValue) minMaxValue = pixel;
                        else if (poolType === 'avg') {
                            avgValue += pixel;
                            count++;
                        }
                    }
                    if (isNaN(minMaxValue)) break;
                }
                const outputOffset = outputRowOffset + yC * outputColStrides + d;
                outputVals[outputOffset] = poolType === 'avg' ? avgValue / count : minMaxValue;
            }
        }
    }
    return output;
}
function $22bad42a00b2ab7f$export$60b78444d0fe518d(xValues, xShape, dtype, convInfo, flattenPositions = false, includeBatchInIndex = false) {
    const maxPositions = (0, $5siju.buffer)(convInfo.outShape, 'int32');
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const xBuf = (0, $5siju.buffer)(xShape, dtype, xValues);
    for(let b = 0; b < convInfo.batchSize; ++b){
        for(let d = 0; d < convInfo.inChannels; ++d)for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const xRCorner = yR * strideHeight - padTop;
            let xRMin = xRCorner;
            while(xRMin < 0)xRMin += dilationHeight;
            // const xRMin = Math.max(0, xRCorner);
            const xRMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRCorner);
            for(let yC = 0; yC < convInfo.outWidth; ++yC){
                const xCCorner = yC * strideWidth - padLeft;
                let xCMin = xCCorner;
                while(xCMin < 0)xCMin += dilationWidth;
                const xCMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xCCorner);
                let maxValue = Number.NEGATIVE_INFINITY;
                let maxPosition = -1;
                for(let xR = xRMin; xR < xRMax; xR += dilationHeight){
                    const wR = xR - xRCorner;
                    for(let xC = xCMin; xC < xCMax; xC += dilationWidth){
                        const wC = xC - xCCorner;
                        // For some reason, disable-next-line is not working
                        // TODO(mattsoulanille): Remove this when switching to TS5.
                        /* tslint:disable: no-unnecessary-type-assertion */ const pixel = xBuf.get(b, xR, xC, d);
                        if (pixel > maxValue) {
                            maxValue = pixel;
                            if (flattenPositions) maxPosition = includeBatchInIndex ? ((b * convInfo.inHeight + xR) * convInfo.inWidth + xC) * convInfo.inChannels + d : (xR * convInfo.inWidth + xC) * convInfo.inChannels + d;
                            else maxPosition = wR * effectiveFilterWidth + wC;
                        }
                    }
                }
                maxPositions.set(maxPosition, b, yR, yC, d);
            }
        }
    }
    return maxPositions;
}
function $22bad42a00b2ab7f$export$3712ebf21d29ff82(xValues, xShape, dtype, strides, convInfo, poolType) {
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    const initialValue = poolType === 'max' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    const output = (0, $5siju.buffer)(convInfo.outShape, dtype);
    const outputVals = output.values;
    const outputBatchStrides = convInfo.outShape[1] * convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
    const outputDepthStrides = convInfo.outShape[2] * convInfo.outShape[3] * convInfo.outShape[4];
    const outputRowStrides = convInfo.outShape[3] * convInfo.outShape[4];
    const outputColStrides = convInfo.outShape[4];
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        const outputBatchOffset = batch * outputBatchStrides;
        const inputBatchOffset = batch * strides[0];
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let yDepth = 0; yDepth < convInfo.outDepth; ++yDepth){
            const xDepthCorner = yDepth * strideDepth - padFront;
            let xDepthMin = xDepthCorner;
            while(xDepthMin < 0)xDepthMin += dilationDepth;
            const xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
            const outputDepthOffset = outputBatchOffset + yDepth * outputDepthStrides;
            for(let yRow = 0; yRow < convInfo.outHeight; ++yRow){
                const xRowCorner = yRow * strideHeight - padTop;
                let xRowMin = xRowCorner;
                while(xRowMin < 0)xRowMin += dilationHeight;
                const xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
                const outputRowOffset = outputDepthOffset + yRow * outputRowStrides;
                for(let yCol = 0; yCol < convInfo.outWidth; ++yCol){
                    const xColCorner = yCol * strideWidth - padLeft;
                    let xColMin = xColCorner;
                    while(xColMin < 0)xColMin += dilationWidth;
                    const xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
                    // Shader code begins
                    const outputColOffset = outputRowOffset + yCol * outputColStrides;
                    let minMaxValue = initialValue;
                    let avgValue = 0;
                    let count = 0;
                    for(let xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth){
                        const xDepthOffset = inputBatchOffset + xDepth * strides[1];
                        for(let xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight){
                            const xRowOffset = xDepthOffset + xRow * strides[2];
                            for(let xCol = xColMin; xCol < xColMax; xCol += dilationWidth){
                                const xColOffset = xRowOffset + xCol * strides[3];
                                const pixel = xValues[xColOffset + channel];
                                if (poolType === 'max' && pixel > minMaxValue) minMaxValue = pixel;
                                else if (poolType === 'avg') {
                                    avgValue += pixel;
                                    count++;
                                }
                                if (isNaN(minMaxValue)) break;
                            }
                            if (isNaN(minMaxValue)) break;
                        }
                        if (isNaN(minMaxValue)) break;
                    }
                    const outputOffset = outputColOffset + channel;
                    outputVals[outputOffset] = poolType === 'avg' ? avgValue / Math.max(count, 1) : minMaxValue;
                }
            }
        }
    }
    return output;
}
function $22bad42a00b2ab7f$export$e389a84eda2bb69e(xBuf, convInfo) {
    const maxPositions = (0, $5siju.buffer)(convInfo.outShape, 'int32');
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = convInfo.padInfo.front;
    const padTop = convInfo.padInfo.top;
    const padLeft = convInfo.padInfo.left;
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let yDepth = 0; yDepth < convInfo.outDepth; ++yDepth){
            const xDepthCorner = yDepth * strideDepth - padFront;
            let xDepthMin = xDepthCorner;
            while(xDepthMin < 0)xDepthMin += dilationDepth;
            const xDepthMax = Math.min(convInfo.inDepth, effectiveFilterDepth + xDepthCorner);
            for(let yRow = 0; yRow < convInfo.outHeight; ++yRow){
                const xRowCorner = yRow * strideHeight - padTop;
                let xRowMin = xRowCorner;
                while(xRowMin < 0)xRowMin += dilationHeight;
                const xRowMax = Math.min(convInfo.inHeight, effectiveFilterHeight + xRowCorner);
                for(let yCol = 0; yCol < convInfo.outWidth; ++yCol){
                    const xColCorner = yCol * strideWidth - padLeft;
                    let xColMin = xColCorner;
                    while(xColMin < 0)xColMin += dilationWidth;
                    const xColMax = Math.min(convInfo.inWidth, effectiveFilterWidth + xColCorner);
                    // Shader code begins
                    let maxValue = Number.NEGATIVE_INFINITY;
                    let maxPosition = -1;
                    for(let xDepth = xDepthMin; xDepth < xDepthMax; xDepth += dilationDepth){
                        const wDepth = xDepth - xDepthCorner;
                        for(let xRow = xRowMin; xRow < xRowMax; xRow += dilationHeight){
                            const wRow = xRow - xRowCorner;
                            for(let xCol = xColMin; xCol < xColMax; xCol += dilationWidth){
                                const wCol = xCol - xColCorner;
                                const pixel = xBuf.get(batch, xDepth, xRow, xCol, channel);
                                if (pixel >= maxValue) {
                                    maxValue = pixel;
                                    maxPosition = wDepth * effectiveFilterHeight * effectiveFilterWidth + wRow * effectiveFilterHeight + wCol;
                                }
                            }
                        }
                    }
                    maxPositions.set(maxPosition, batch, yDepth, yRow, yCol, channel);
                }
            }
        }
    }
    return maxPositions;
}

});


parcelRegister("1A72c", function(module, exports) {

$parcel$export(module.exports, "avgPool3DConfig", function () { return $126e9c2823c4d3b8$export$5a9c81d240244392; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $2YRGy = parcelRequire("2YRGy");
function $126e9c2823c4d3b8$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'avgPool3d');
    const convInfo = (0, $dEVRx).computePool3DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode, dataFormat);
    const xValues = backend.data.get(x.dataId).values;
    const outBuf = (0, $2YRGy.pool3d)(xValues, x.shape, x.dtype, (0, $lBDHD).computeStrides(x.shape), convInfo, 'avg');
    return backend.makeTensorInfo(outBuf.shape, 'float32', outBuf.values);
}
const $126e9c2823c4d3b8$export$5a9c81d240244392 = {
    kernelName: (0, $9BGT9.AvgPool3D),
    backendName: 'cpu',
    kernelFunc: $126e9c2823c4d3b8$export$8e92f7d23b27f144
};

});

parcelRegister("kvA6F", function(module, exports) {

$parcel$export(module.exports, "avgPool3DGradConfig", function () { return $eee2b5e48bfa84d6$export$1eeb8780807d0508; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $5siju = parcelRequire("5siju");

var $wi69v = parcelRequire("wi69v");
function $eee2b5e48bfa84d6$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $wi69v.assertNotComplex)([
        dy,
        input
    ], 'avgPool3DGrad');
    const convInfo = (0, $dEVRx).computePool3DInfo(input.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $5siju.buffer)(input.shape, 'float32');
    const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
    const dyBuf = backend.bufferSync(dy);
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth){
            for(let dxRow = 0; dxRow < convInfo.inHeight; ++dxRow)for(let dxCol = 0; dxCol < convInfo.inWidth; ++dxCol){
                // Shader code begins.
                const dyDepthCorner = dxDepth - padFront;
                const dyRowCorner = dxRow - padTop;
                const dyColCorner = dxCol - padLeft;
                let dotProd = 0;
                for(let wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth){
                    const dyDepth = (dyDepthCorner + wDepth) / strideDepth;
                    if (dyDepth < 0 || dyDepth >= convInfo.outDepth || Math.floor(dyDepth) !== dyDepth) continue;
                    for(let wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight){
                        const dyRow = (dyRowCorner + wRow) / strideHeight;
                        if (dyRow < 0 || dyRow >= convInfo.outHeight || Math.floor(dyRow) !== dyRow) continue;
                        for(let wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth){
                            const dyCol = (dyColCorner + wCol) / strideWidth;
                            if (dyCol < 0 || dyCol >= convInfo.outWidth || Math.floor(dyCol) !== dyCol) continue;
                            const pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            dotProd += pixel;
                        }
                    }
                }
                dx.set(dotProd * avgMultiplier, batch, dxDepth, dxRow, dxCol, channel);
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $eee2b5e48bfa84d6$export$1eeb8780807d0508 = {
    kernelName: (0, $9BGT9.AvgPool3DGrad),
    backendName: 'cpu',
    kernelFunc: $eee2b5e48bfa84d6$export$798cb4034e996ff4
};

});

parcelRegister("ebGUr", function(module, exports) {

$parcel$export(module.exports, "avgPoolGradConfig", function () { return $a54360a995b7dfba$export$ac3f8709351ab225; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $5siju = parcelRequire("5siju");

var $wi69v = parcelRequire("wi69v");
function $a54360a995b7dfba$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $wi69v.assertNotComplex)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $5siju.buffer)(x.shape, 'float32');
    const avgMultiplier = 1 / (filterHeight * filterWidth);
    const dyData = backend.data.get(dy.dataId).values;
    const dyBuf = (0, $5siju.buffer)(dy.shape, 'float32', dyData);
    for(let b = 0; b < convInfo.batchSize; ++b)for(let d = 0; d < convInfo.inChannels; ++d){
        for(let dxR = 0; dxR < convInfo.inHeight; ++dxR)for(let dxC = 0; dxC < convInfo.inWidth; ++dxC){
            // Shader code begins.
            const dyRCorner = dxR - padTop;
            const dyCCorner = dxC - padLeft;
            let dotProd = 0;
            for(let wR = 0; wR < effectiveFilterHeight; wR += dilationHeight){
                const dyR = (dyRCorner + wR) / strideHeight;
                if (dyR < 0 || dyR >= convInfo.outHeight || Math.floor(dyR) !== dyR) continue;
                for(let wC = 0; wC < effectiveFilterWidth; wC += dilationWidth){
                    const dyC = (dyCCorner + wC) / strideWidth;
                    if (dyC < 0 || dyC >= convInfo.outWidth || Math.floor(dyC) !== dyC) continue;
                    const pixel = dyBuf.get(b, dyR, dyC, d);
                    dotProd += pixel;
                }
            }
            dx.set(dotProd * avgMultiplier, b, dxR, dxC, d);
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $a54360a995b7dfba$export$ac3f8709351ab225 = {
    kernelName: (0, $9BGT9.AvgPoolGrad),
    backendName: 'cpu',
    kernelFunc: $a54360a995b7dfba$export$2f098171d1c79aea
};

});

parcelRegister("hIsle", function(module, exports) {

$parcel$export(module.exports, "batchNormConfig", function () { return $ce5c87bb0a838966$export$df2dc5c7a755e418; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $ce5c87bb0a838966$export$8ea8088e6d0cdd02(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, scale: scale, offset: offset, mean: mean, variance: variance } = inputs;
    (0, $lBDHD).assert(mean.shape.length === variance.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    (0, $lBDHD).assert(offset == null || mean.shape.length === offset.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    (0, $lBDHD).assert(scale == null || mean.shape.length === scale.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    (0, $wi69v.assertNotComplex)([
        x,
        mean,
        variance,
        scale,
        offset
    ], 'batchNorm');
    let { varianceEpsilon: varianceEpsilon } = attrs;
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const xVals = backend.data.get(x.dataId).values;
    const mVals = backend.data.get(mean.dataId).values;
    const varVals = backend.data.get(variance.dataId).values;
    const sVals = scale ? backend.data.get(scale.dataId).values : new Float32Array([
        1
    ]);
    const offVals = offset ? backend.data.get(offset.dataId).values : new Float32Array([
        0
    ]);
    const outVals = new Float32Array(xVals.length);
    const offValsLength = offVals.length;
    const sValsLength = sVals.length;
    const varValsLength = varVals.length;
    const mValsLength = mVals.length;
    let offi = 0;
    let mi = 0;
    let si = 0;
    let vi = 0;
    for(let i = 0; i < xVals.length; ++i){
        outVals[i] = offVals[offi++] + (xVals[i] - mVals[mi++]) * sVals[si++] / Math.sqrt(varVals[vi++] + varianceEpsilon);
        if (offi >= offValsLength) offi = 0;
        if (mi >= mValsLength) mi = 0;
        if (si >= sValsLength) si = 0;
        if (vi >= varValsLength) vi = 0;
    }
    return backend.makeTensorInfo(x.shape, x.dtype, outVals);
}
const $ce5c87bb0a838966$export$df2dc5c7a755e418 = {
    kernelName: (0, $9BGT9.FusedBatchNorm),
    backendName: 'cpu',
    kernelFunc: $ce5c87bb0a838966$export$8ea8088e6d0cdd02
};

});

parcelRegister("cRzSP", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceNDConfig", function () { return $95d644ee7e57985d$export$44e08e19f97e5513; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $dOeSU = parcelRequire("dOeSU");

var $59DpV = parcelRequire("59DpV");

var $joI4E = parcelRequire("joI4E");
function $95d644ee7e57985d$export$ea37d960c1808536(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $wi69v.assertNotComplex)([
        x
    ], 'batchToSpaceND');
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $dEVRx).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $dEVRx).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $dEVRx).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $dEVRx).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $dEVRx).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const xReshaped = (0, $dOeSU.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const xTransposed = (0, $joI4E.transpose)({
        inputs: {
            x: xReshaped
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const xTransposedReshaped = (0, $dOeSU.reshape)({
        inputs: {
            x: xTransposed
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const result = (0, $59DpV.slice)({
        inputs: {
            x: xTransposedReshaped
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    backend.disposeIntermediateTensorInfo(xReshaped);
    backend.disposeIntermediateTensorInfo(xTransposed);
    backend.disposeIntermediateTensorInfo(xTransposedReshaped);
    return result;
}
const $95d644ee7e57985d$export$44e08e19f97e5513 = {
    kernelName: (0, $9BGT9.BatchToSpaceND),
    backendName: 'cpu',
    kernelFunc: $95d644ee7e57985d$export$ea37d960c1808536
};

});
parcelRegister("59DpV", function(module, exports) {

$parcel$export(module.exports, "sliceImpl", function () { return $3c0c5e70a1e3e0f4$export$4bdf1ac3fa5d3d6a; });
$parcel$export(module.exports, "slice", function () { return $3c0c5e70a1e3e0f4$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "sliceConfig", function () { return $3c0c5e70a1e3e0f4$export$8d8a1e11dd2cc6c4; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $5siju = parcelRequire("5siju");
var $9BGT9 = parcelRequire("9BGT9");
var $iEcDD = parcelRequire("iEcDD");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $3c0c5e70a1e3e0f4$export$4bdf1ac3fa5d3d6a(vals, begin, size, shape, dtype) {
    const isContinous = (0, $iEcDD).isSliceContinous(shape, begin, size);
    const length = (0, $lBDHD).sizeFromShape(size);
    const xStrides = (0, $lBDHD).computeStrides(shape);
    if (isContinous) {
        const flatOffset = (0, $iEcDD).computeFlatOffset(begin, xStrides);
        if (dtype === 'string') return vals.slice(flatOffset, flatOffset + length);
        return vals.subarray(flatOffset, flatOffset + length);
    }
    const decodedData = dtype === 'string' ? (0, $dEVRx).fromUint8ToStringArray(vals) : vals;
    const inBuf = (0, $5siju.buffer)(shape, dtype, decodedData);
    const outBuf = (0, $5siju.buffer)(size, dtype);
    for(let i = 0; i < outBuf.size; ++i){
        const outLoc = outBuf.indexToLoc(i);
        const inLoc = outLoc.map((idx, j)=>idx + begin[j]);
        outBuf.set(inBuf.get(...inLoc), ...outLoc);
    }
    if (dtype === 'string') return (0, $dEVRx).fromStringArrayToUint8(outBuf.values);
    return outBuf.values;
}
function $3c0c5e70a1e3e0f4$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'slice');
    const [$begin, $size] = (0, $iEcDD).parseSliceParams(x, begin, size);
    (0, $iEcDD).assertParamsValid(x, $begin, $size);
    const vals = backend.data.get(x.dataId).values;
    const outVals = $3c0c5e70a1e3e0f4$export$4bdf1ac3fa5d3d6a(vals, $begin, $size, x.shape, x.dtype);
    return backend.makeTensorInfo($size, x.dtype, outVals);
}
const $3c0c5e70a1e3e0f4$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $9BGT9.Slice),
    backendName: 'cpu',
    kernelFunc: $3c0c5e70a1e3e0f4$export$58adb3bec8346d0f
};

});


parcelRegister("hpM0s", function(module, exports) {

$parcel$export(module.exports, "bincountConfig", function () { return $cada0282c080fee7$export$af9f0093738840fb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $lL92y = parcelRequire("lL92y");
function $cada0282c080fee7$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xVals = backend.data.get(x.dataId).values;
    const weightsVals = backend.data.get(weights.dataId).values;
    const outVals = (0, $lL92y.bincountImpl)(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend.makeTensorInfo([
        size
    ], weights.dtype, outVals);
}
const $cada0282c080fee7$export$af9f0093738840fb = {
    kernelName: (0, $9BGT9.Bincount),
    backendName: 'cpu',
    kernelFunc: $cada0282c080fee7$export$7e474bab088ed182
};

});
parcelRegister("lL92y", function(module, exports) {

$parcel$export(module.exports, "bincountImpl", function () { return $fd74fff6119e6973$export$8e4da6ec633bf0a6; });
$parcel$export(module.exports, "bincountReduceImpl", function () { return $fd74fff6119e6973$export$486b8d48edd28ba5; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
var $lBDHD = parcelRequire("lBDHD");
function $fd74fff6119e6973$export$8e4da6ec633bf0a6(xVals, weightsVals, weightsDtype, weightsShape, size) {
    const weightsSize = (0, $lBDHD).sizeFromShape(weightsShape);
    const outVals = (0, $lBDHD).makeZerosTypedArray(size, weightsDtype);
    for(let i = 0; i < xVals.length; i++){
        const value = xVals[i];
        if (value < 0) throw new Error('Input x must be non-negative!');
        if (value >= size) continue;
        if (weightsSize > 0) outVals[value] += weightsVals[i];
        else outVals[value] += 1;
    }
    return outVals;
}
function $fd74fff6119e6973$export$486b8d48edd28ba5(xBuf, weightsBuf, size, binaryOutput = false) {
    const numRows = xBuf.shape[0];
    const numCols = xBuf.shape[1];
    const outBuf = (0, $5siju.buffer)([
        numRows,
        size
    ], weightsBuf.dtype);
    for(let i = 0; i < numRows; i++)for(let j = 0; j < numCols; j++){
        const value = xBuf.get(i, j);
        if (value < 0) throw new Error('Input x must be non-negative!');
        if (value >= size) continue;
        if (binaryOutput) outBuf.set(1, i, value);
        else if (weightsBuf.size > 0) outBuf.set(outBuf.get(i, value) + weightsBuf.get(i, j), i, value);
        else outBuf.set(outBuf.get(i, value) + 1, i, value);
    }
    return outBuf;
}

});


parcelRegister("3pAeM", function(module, exports) {

$parcel$export(module.exports, "bitwiseAndImpl", function () { return $27bfd0dd50481517$export$54cf4ba005fa5753; });
$parcel$export(module.exports, "bitwiseAndConfig", function () { return $27bfd0dd50481517$export$6d53927dafa38bf9; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $27bfd0dd50481517$export$54cf4ba005fa5753 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a & b);
const $27bfd0dd50481517$export$84529b0ad3b42cd1 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.BitwiseAnd), $27bfd0dd50481517$export$54cf4ba005fa5753);
const $27bfd0dd50481517$export$6d53927dafa38bf9 = {
    kernelName: (0, $9BGT9.BitwiseAnd),
    backendName: 'cpu',
    kernelFunc: $27bfd0dd50481517$export$84529b0ad3b42cd1
};

});

parcelRegister("6vYuN", function(module, exports) {

$parcel$export(module.exports, "broadcastArgsConfig", function () { return $4be49086020872e8$export$8f7b2ec0c6f08fb2; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
function $4be49086020872e8$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    const s0Vals = backend.data.get(s0.dataId).values;
    const s1Vals = backend.data.get(s1.dataId).values;
    const broadcastShape = (0, $dEVRx).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
    return backend.makeTensorInfo([
        broadcastShape.length
    ], 'int32', Int32Array.from(broadcastShape));
}
const $4be49086020872e8$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $9BGT9.BroadcastArgs),
    backendName: 'cpu',
    kernelFunc: $4be49086020872e8$export$d226d344aedce941
};

});

parcelRegister("kHDCc", function(module, exports) {

$parcel$export(module.exports, "ceilImpl", function () { return $f1268d83aafab336$export$72486f20c97f6da8; });
$parcel$export(module.exports, "ceilConfig", function () { return $f1268d83aafab336$export$df387212b1898306; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $f1268d83aafab336$export$72486f20c97f6da8 = (0, $cfLEm.createSimpleUnaryImpl)((xi)=>Math.ceil(xi));
const $f1268d83aafab336$export$803ce6b71a0a94b2 = (0, $6wQye.unaryKernelFuncFromImpl)((0, $9BGT9.Ceil), $f1268d83aafab336$export$72486f20c97f6da8);
const $f1268d83aafab336$export$df387212b1898306 = {
    kernelName: (0, $9BGT9.Ceil),
    backendName: 'cpu',
    kernelFunc: $f1268d83aafab336$export$803ce6b71a0a94b2
};

});

parcelRegister("8jprz", function(module, exports) {

$parcel$export(module.exports, "clipByValueConfig", function () { return $60d3d5a3c5d17990$export$f7ee8f07ce0ff4e1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $60d3d5a3c5d17990$export$fa97baf70ad024c0 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.ClipByValue), (xi, attrs)=>{
    const clipAttrs = attrs;
    if (xi > clipAttrs.clipValueMax) return clipAttrs.clipValueMax;
    return xi < clipAttrs.clipValueMin ? clipAttrs.clipValueMin : xi;
});
const $60d3d5a3c5d17990$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $9BGT9.ClipByValue),
    backendName: 'cpu',
    kernelFunc: $60d3d5a3c5d17990$export$fa97baf70ad024c0
};

});

parcelRegister("kdvfR", function(module, exports) {

$parcel$export(module.exports, "complexAbsConfig", function () { return $eb7d441816d4e8c4$export$a4817d2978acc054; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
const $eb7d441816d4e8c4$export$2837bc62566f8808 = (args)=>{
    const { x: x } = args.inputs;
    const cpuBackend = args.backend;
    const resultValues = new Float32Array((0, $lBDHD).sizeFromShape(x.shape));
    const complexVals = cpuBackend.data.get(x.dataId);
    const real = complexVals.complexTensorInfos.real;
    const imag = complexVals.complexTensorInfos.imag;
    const realVals = cpuBackend.data.get(real.dataId).values;
    const imagVals = cpuBackend.data.get(imag.dataId).values;
    for(let i = 0; i < realVals.length; i++){
        const real = realVals[i];
        const imag = imagVals[i];
        resultValues[i] = Math.hypot(real, imag);
    }
    return cpuBackend.makeOutput(resultValues, x.shape, 'float32');
};
const $eb7d441816d4e8c4$export$a4817d2978acc054 = {
    kernelName: (0, $9BGT9.ComplexAbs),
    backendName: 'cpu',
    kernelFunc: $eb7d441816d4e8c4$export$2837bc62566f8808
};

});

parcelRegister("aEIJt", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $7c2056bc6b4e9620$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatConfig", function () { return $7c2056bc6b4e9620$export$c8cf96dae25282e5; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $hmrWF = parcelRequire("hmrWF");

var $kwcGR = parcelRequire("kwcGR");

var $l9MqT = parcelRequire("l9MqT");

var $acwXZ = parcelRequire("acwXZ");

var $fWJq3 = parcelRequire("fWJq3");

var $dOeSU = parcelRequire("dOeSU");
function $7c2056bc6b4e9620$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $lBDHD).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $dEVRx).assertParamsConsistent(shapes, $axis);
    let outShape = (0, $dEVRx).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $lBDHD).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $lBDHD).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $l9MqT.identity)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    if ($inputs[0].dtype === 'complex64') {
        const reals = $inputs.map((t)=>(0, $fWJq3.real)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = $inputs.map((t)=>(0, $acwXZ.imag)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $7c2056bc6b4e9620$export$ee1b3e54f0441b22({
            inputs: reals,
            backend: backend,
            attrs: {
                axis: $axis
            }
        });
        const imagConcated = $7c2056bc6b4e9620$export$ee1b3e54f0441b22({
            inputs: imags,
            backend: backend,
            attrs: {
                axis: $axis
            }
        });
        const result = (0, $hmrWF.complex)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
        imags.forEach((i)=>backend.disposeIntermediateTensorInfo(i));
        backend.disposeIntermediateTensorInfo(realConcated);
        backend.disposeIntermediateTensorInfo(imagConcated);
        return result;
    }
    // Any concat of n-dimensional tensors across any axis can be reduced to
    // a concatenation of two-dimensional tensors across the axis 1 by first
    // partitioning the axes of the original tensors into those less than the
    // axis to be concatenated and the rest. Then reshape the tensors
    // into a two-dimensional tensor by collapsing these two sets of axes and
    // concatenate the resulting matrices across the axis 1, finally reshaping
    // the result to have the proper shape.
    const inputs2D = $inputs.map((t)=>{
        const innerSize = (0, $lBDHD).sizeFromShape(t.shape.slice($axis));
        const shape = [
            -1,
            innerSize
        ];
        return (0, $dOeSU.reshape)({
            inputs: {
                x: t
            },
            backend: backend,
            attrs: {
                shape: shape
            }
        });
    });
    const inputsValShapes = inputs2D.map((t)=>{
        return {
            vals: backend.data.get(t.dataId).values,
            shape: t.shape
        };
    });
    // Concats 2d tensors along axis=1.
    outShape = (0, $dEVRx).computeOutShape(inputs2D.map((t)=>t.shape), 1 /* axis */ );
    const simplyConcat = inputs2D[0].shape[0] === 1;
    const outVals = (0, $kwcGR.concatImpl)(inputsValShapes, outShape, inputs[0].dtype, simplyConcat);
    const finalOutShape = (0, $dEVRx).computeOutShape($inputs.map((t)=>t.shape), $axis);
    const outInfo = backend.makeTensorInfo(finalOutShape, inputs[0].dtype, outVals);
    inputs2D.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return outInfo;
}
const $7c2056bc6b4e9620$export$c8cf96dae25282e5 = {
    kernelName: (0, $9BGT9.Concat),
    backendName: 'cpu',
    kernelFunc: $7c2056bc6b4e9620$export$ee1b3e54f0441b22
};

});
parcelRegister("kwcGR", function(module, exports) {

$parcel$export(module.exports, "concatImpl", function () { return $ef00a3d1cd8f4b4d$export$777da59f594f497d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");
function $ef00a3d1cd8f4b4d$export$777da59f594f497d(inputs, outShape, dtype, simplyConcat) {
    const outVals = (0, $lBDHD).getArrayFromDType(dtype, (0, $lBDHD).sizeFromShape(outShape));
    if (simplyConcat && dtype !== 'string') {
        // Use built-in TypedArray.set() method for speed.
        let offset = 0;
        inputs.forEach((input)=>{
            const size = (0, $lBDHD).sizeFromShape(input.shape);
            outVals.set(input.vals, offset);
            offset += size;
        });
    } else {
        let colOffset = 0;
        inputs.forEach((input)=>{
            const decodedData = dtype === 'string' ? (0, $dEVRx).fromUint8ToStringArray(input.vals) : input.vals;
            let tIdx = 0;
            for(let row = 0; row < input.shape[0]; ++row){
                const resIdx = row * outShape[1] + colOffset;
                for(let col = 0; col < input.shape[1]; ++col)outVals[resIdx + col] = decodedData[tIdx++];
            }
            colOffset += input.shape[1];
        });
    }
    return outVals;
}

});

parcelRegister("acwXZ", function(module, exports) {

$parcel$export(module.exports, "imag", function () { return $76d498d35207b665$export$d78fab5778ab392b; });
$parcel$export(module.exports, "imagConfig", function () { return $76d498d35207b665$export$ddfc128c2801add7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
function $76d498d35207b665$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const imag = backend.data.get(input.dataId).complexTensorInfos.imag;
    const imagVal = backend.data.get(imag.dataId).values;
    // When complex tensor is disposed, its underlying parts will be disposed too.
    // Make new tensor out of the imag value of the complex. This makes sure the
    // value is still accessible even if complex tensor is disposed.
    return backend.makeTensorInfo(imag.shape, imag.dtype, imagVal);
}
const $76d498d35207b665$export$ddfc128c2801add7 = {
    kernelName: (0, $9BGT9.Imag),
    backendName: 'cpu',
    kernelFunc: $76d498d35207b665$export$d78fab5778ab392b
};

});


parcelRegister("jpv7x", function(module, exports) {

$parcel$export(module.exports, "conv2D", function () { return $e2187e07bbab60be$export$5a2ce5b05041d9e4; });
$parcel$export(module.exports, "conv2DConfig", function () { return $e2187e07bbab60be$export$4a39bf13b4378042; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $e2187e07bbab60be$export$5a2ce5b05041d9e4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $wi69v.assertNotComplex)([
        x,
        filter
    ], 'conv2d');
    const $dataFormat = (0, $dEVRx).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const padLeft = convInfo.padInfo.left;
    const padTop = convInfo.padInfo.top;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const y = new (0, $3pVUH.TensorBuffer)(convInfo.outShape, x.dtype);
    const xStrides = (0, $lBDHD).computeStrides(x.shape);
    const filterStrides = (0, $lBDHD).computeStrides(filter.shape);
    const xBatchStride = xStrides[0];
    const xRowStride = isChannelsLast ? xStrides[1] : xStrides[2];
    const xColStride = isChannelsLast ? xStrides[2] : 1;
    const xChannelStride = isChannelsLast ? 1 : xStrides[1];
    const yBatchStride = y.strides[0];
    const yRowStride = isChannelsLast ? y.strides[1] : y.strides[2];
    const yColStride = isChannelsLast ? y.strides[2] : 1;
    const yChannelStride = isChannelsLast ? 1 : y.strides[1];
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xBatchStride;
        const yOffset1 = b * yBatchStride;
        for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const yOffset2 = yOffset1 + yR * yRowStride;
            const xRCorner = yR * convInfo.strideHeight - padTop;
            for(let wR = 0; wR < filterHeight; ++wR){
                const xR = xRCorner + wR * dilationHeight;
                if (xR < 0 || xR >= convInfo.inHeight) continue;
                const wOffset1 = wR * filterStrides[0];
                const xOffset2 = xOffset1 + xR * xRowStride;
                for(let yC = 0; yC < convInfo.outWidth; ++yC){
                    const yOffset3 = yOffset2 + yC * yColStride;
                    const xCCorner = yC * convInfo.strideWidth - padLeft;
                    for(let wC = 0; wC < filterWidth; ++wC){
                        const xC = xCCorner + wC * dilationWidth;
                        if (xC < 0 || xC >= convInfo.inWidth) continue;
                        const wOffset2 = wOffset1 + wC * filterStrides[1];
                        const xOffset3 = xOffset2 + xC * xColStride;
                        let wOffset3 = wOffset2;
                        for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                            const xVal = xVals[xOffset3 + d1 * xChannelStride];
                            for(let d2 = 0; d2 < convInfo.outChannels; ++d2)yVals[yOffset3 + d2 * yChannelStride] += xVal * wVals[wOffset3 + d2];
                            wOffset3 += convInfo.outChannels;
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, yVals);
}
const $e2187e07bbab60be$export$4a39bf13b4378042 = {
    kernelName: (0, $9BGT9.Conv2D),
    backendName: 'cpu',
    kernelFunc: $e2187e07bbab60be$export$5a2ce5b05041d9e4
};

});

parcelRegister("lhINj", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropFilterConfig", function () { return $f7edeebaf9357c4f$export$7a95f55d2d2e7d24; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");

var $wi69v = parcelRequire("wi69v");
function $f7edeebaf9357c4f$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    (0, $wi69v.assertNotComplex)([
        x,
        dy
    ], 'conv2dBackpropFilter');
    const $dataFormat = (0, $dEVRx).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const { strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth } = convInfo;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const dW = new (0, $3pVUH.TensorBuffer)(convInfo.filterShape, 'float32');
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    const xVals = backend.data.get(x.dataId).values;
    const dyVals = backend.data.get(dy.dataId).values;
    const xBuf = new (0, $3pVUH.TensorBuffer)(x.shape, x.dtype, xVals);
    const dyBuf = new (0, $3pVUH.TensorBuffer)(dy.shape, dy.dtype, dyVals);
    for(let wR = 0; wR < filterHeight; ++wR){
        const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
        const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
        for(let wC = 0; wC < filterWidth; ++wC){
            const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
            const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
            for(let d1 = 0; d1 < convInfo.inChannels; ++d1)for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                let dotProd = 0;
                for(let b = 0; b < convInfo.batchSize; ++b)for(let yR = yRMin; yR < yRMax; ++yR){
                    const xR = wR + yR * strideHeight - topPad;
                    for(let yC = yCMin; yC < yCMax; ++yC){
                        const xC = wC + yC * strideWidth - leftPad;
                        if (isChannelsLast) dotProd += xBuf.get(b, xR, xC, d1) * dyBuf.get(b, yR, yC, d2);
                        else dotProd += xBuf.get(b, d1, xR, xC) * dyBuf.get(b, d2, yR, yC);
                    }
                }
                dW.set(dotProd, wR, wC, d1, d2);
            }
        }
    }
    return backend.makeTensorInfo(dW.shape, dW.dtype, dW.values);
}
const $f7edeebaf9357c4f$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $9BGT9.Conv2DBackpropFilter),
    backendName: 'cpu',
    kernelFunc: $f7edeebaf9357c4f$export$652a30c9379f3de7
};

});

parcelRegister("eptaX", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInputConfig", function () { return $a7da0831c9e49a2c$export$19bbc19fff1ed26f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $a7da0831c9e49a2c$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $wi69v.assertNotComplex)([
        dy,
        filter
    ], 'conv2dBackpropInput');
    const filterStrides = (0, $lBDHD).computeStrides(filter.shape);
    const dyStrides = (0, $lBDHD).computeStrides(dy.shape);
    let $dataFormat = (0, $dEVRx).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $dEVRx).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const dx = new (0, $3pVUH.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const dyValues = backend.data.get(dy.dataId).values;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2] = filterStrides;
    const { batchSize: batchSize, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outHeight: outHeight, outWidth: outWidth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    $dataFormat = convInfo.dataFormat;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    const isChannelsLast = $dataFormat === 'channelsLast';
    const xBatchStride = dx.strides[0];
    const xRowStride = isChannelsLast ? dx.strides[1] : dx.strides[2];
    const xColStride = isChannelsLast ? dx.strides[2] : 1;
    const xChannelStride = isChannelsLast ? 1 : dx.strides[1];
    const yBatchStride = dyStrides[0];
    const yRowStride = isChannelsLast ? dyStrides[1] : dyStrides[2];
    const yColStride = isChannelsLast ? dyStrides[2] : 1;
    const yChannelStride = isChannelsLast ? 1 : dyStrides[1];
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)for(let xR = 0; xR < inHeight; ++xR){
            const xRCorner = xR - topPad;
            const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
            const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
            for(let xC = 0; xC < inWidth; ++xC){
                const xCCorner = xC - leftPad;
                const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                let dotProd = 0;
                for(let yR = xRMin; yR < yRMax; ++yR){
                    const wR = yR * strideHeight - xRCorner;
                    for(let yC = xCMin; yC < yCMax; ++yC){
                        const wC = yC * strideWidth - xCCorner;
                        const dyOffset = yBatchStride * b + yRowStride * yR + yColStride * yC;
                        const fltOffset = fltS0 * (filterHeight - 1 - wR) + fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
                        for(let d2 = 0; d2 < outChannels; ++d2){
                            const pixel = dyValues[dyOffset + yChannelStride * d2];
                            const weight = fltValues[fltOffset + d2];
                            dotProd += pixel * weight;
                        }
                    }
                }
                const dxOffset = xBatchStride * b + xRowStride * xR + xColStride * xC + xChannelStride * d1;
                dxValues[dxOffset] = dotProd;
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $a7da0831c9e49a2c$export$19bbc19fff1ed26f = {
    kernelName: (0, $9BGT9.Conv2DBackpropInput),
    backendName: 'cpu',
    kernelFunc: $a7da0831c9e49a2c$export$633310eed0c26e72
};

});

parcelRegister("hZMDE", function(module, exports) {

$parcel$export(module.exports, "conv3DConfig", function () { return $d19ddcc39a36a2da$export$1fe590fda0829040; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $d19ddcc39a36a2da$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    (0, $wi69v.assertNotComplex)([
        x,
        filter
    ], 'conv3d');
    const convInfo = (0, $dEVRx).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const { filterDepth: filterDepth, filterHeight: filterHeight, filterWidth: filterWidth, dilationDepth: dilationDepth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, padInfo: padInfo } = convInfo;
    const padFront = padInfo.front;
    const padLeft = padInfo.left;
    const padTop = padInfo.top;
    const y = new (0, $3pVUH.TensorBuffer)(convInfo.outShape, x.dtype);
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    const xStrides = (0, $lBDHD).computeStrides(x.shape);
    const filterStrides = (0, $lBDHD).computeStrides(filter.shape);
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xStrides[0];
        const yOffset1 = b * y.strides[0];
        for(let yF = 0; yF < convInfo.outDepth; ++yF){
            const yOffset2 = yOffset1 + yF * y.strides[1];
            const xFCorner = yF * convInfo.strideDepth - padFront;
            for(let wF = 0; wF < filterDepth; ++wF){
                const xF = xFCorner + wF * dilationDepth;
                if (xF < 0 || xF >= convInfo.inDepth) continue;
                const wOffset1 = wF * filterStrides[0];
                const xOffset2 = xOffset1 + xF * xStrides[1];
                for(let yR = 0; yR < convInfo.outHeight; ++yR){
                    const yOffset3 = yOffset2 + yR * y.strides[2];
                    const xRCorner = yR * convInfo.strideHeight - padTop;
                    for(let wR = 0; wR < filterHeight; ++wR){
                        const xR = xRCorner + wR * dilationHeight;
                        if (xR < 0 || xR >= convInfo.inHeight) continue;
                        const wOffset2 = wOffset1 + wR * filterStrides[1];
                        const xOffset3 = xOffset2 + xR * xStrides[2];
                        for(let yC = 0; yC < convInfo.outWidth; ++yC){
                            const yOffset4 = yOffset3 + yC * convInfo.outChannels;
                            const xCCorner = yC * convInfo.strideWidth - padLeft;
                            for(let wC = 0; wC < filterWidth; ++wC){
                                const xC = xCCorner + wC * dilationWidth;
                                if (xC < 0 || xC >= convInfo.inWidth) continue;
                                const wOffset3 = wOffset2 + wC * filterStrides[2];
                                const xOffset4 = xOffset3 + xC * convInfo.inChannels;
                                let wOffset4 = wOffset3;
                                for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                                    const xVal = xVals[xOffset4 + d1];
                                    for(let d2 = 0; d2 < convInfo.outChannels; ++d2)yVals[yOffset4 + d2] += xVal * wVals[wOffset4 + d2];
                                    wOffset4 += convInfo.outChannels;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, y.values);
}
const $d19ddcc39a36a2da$export$1fe590fda0829040 = {
    kernelName: (0, $9BGT9.Conv3D),
    backendName: 'cpu',
    kernelFunc: $d19ddcc39a36a2da$export$1929932f31d07956
};

});

parcelRegister("haqJT", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropFilterV2Config", function () { return $c7f81cb58c61effe$export$6dce9169640850fa; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $c7f81cb58c61effe$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    (0, $wi69v.assertNotComplex)([
        x,
        dy
    ], 'conv3dBackpropFilterV2');
    const xStrides = (0, $lBDHD).computeStrides(x.shape);
    const dyStrides = (0, $lBDHD).computeStrides(dy.shape);
    const convInfo = (0, $dEVRx).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const filterDepth = convInfo.filterDepth;
    const filterHeight = convInfo.filterHeight;
    const filterWidth = convInfo.filterWidth;
    const dw = new (0, $3pVUH.TensorBuffer)(convInfo.filterShape, 'float32');
    const dwValues = dw.values;
    const [dwS0, dwS1, dwS2, dwS3] = dw.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2, dyS3] = dyStrides;
    const xValues = backend.data.get(x.dataId).values;
    const [xS0, xS1, xS2, xS3] = xStrides;
    const frontPad = convInfo.padInfo.front;
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    for(let wF = 0; wF < filterDepth; ++wF){
        const yFMin = Math.max(0, Math.ceil((frontPad - wF) / strideDepth));
        const yFMax = Math.min(convInfo.outDepth, (convInfo.inDepth + frontPad - wF) / strideDepth);
        const wOffset1 = wF * dwS0;
        for(let wR = 0; wR < filterHeight; ++wR){
            const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
            const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
            const wOffset2 = wR * dwS1 + wOffset1;
            for(let wC = 0; wC < filterWidth; ++wC){
                const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
                const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
                const wOffset3 = wC * dwS2 + wOffset2;
                for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                    const wOffset4 = d1 * dwS3 + wOffset3;
                    for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                        let dotProd = 0;
                        for(let b = 0; b < convInfo.batchSize; ++b){
                            const xOffset1 = b * xS0;
                            const yOffset1 = b * dyS0;
                            for(let yF = yFMin; yF < yFMax; ++yF){
                                const xF = wF + yF * strideDepth - frontPad;
                                const xOffset2 = xF * xS1 + xOffset1;
                                const yOffset2 = yF * dyS1 + yOffset1;
                                for(let yR = yRMin; yR < yRMax; ++yR){
                                    const xR = wR + yR * strideHeight - topPad;
                                    const xOffset3 = xR * xS2 + xOffset2;
                                    const yOffset3 = yR * dyS2 + yOffset2;
                                    for(let yC = yCMin; yC < yCMax; ++yC){
                                        const xC = wC + yC * strideWidth - leftPad;
                                        const xOffset4 = xC * xS3 + xOffset3;
                                        const yOffset4 = yC * dyS3 + yOffset3;
                                        dotProd += xValues[xOffset4 + d1] * dyValues[yOffset4 + d2];
                                    }
                                }
                            }
                        }
                        dwValues[wOffset4 + d2] = dotProd;
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(dw.shape, dw.dtype, dw.values);
}
const $c7f81cb58c61effe$export$6dce9169640850fa = {
    kernelName: (0, $9BGT9.Conv3DBackpropFilterV2),
    backendName: 'cpu',
    kernelFunc: $c7f81cb58c61effe$export$b57760dc3101cea7
};

});

parcelRegister("4Cvwq", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropInputV2Config", function () { return $35d329a76f3b8dcb$export$40ece1caaaf084b2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $35d329a76f3b8dcb$export$ab31b884dc9f0971(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { pad: pad, strides: strides, inputShape: inputShape } = attrs;
    (0, $wi69v.assertNotComplex)([
        dy
    ], 'conv3dBackpropInputV2');
    const dyStrides = (0, $lBDHD).computeStrides(dy.shape);
    const filterStrides = (0, $lBDHD).computeStrides(filter.shape);
    const convInfo = (0, $dEVRx).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const dx = new (0, $3pVUH.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const [dxS0, dxS1, dxS2, dxS3] = dx.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2, dyS3] = dyStrides;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2, fltS3] = filterStrides;
    const { batchSize: batchSize, filterDepth: filterDepth, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inDepth: inDepth, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outDepth: outDepth, outHeight: outHeight, outWidth: outWidth, strideDepth: strideDepth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    const frontPad = filterDepth - 1 - convInfo.padInfo.front;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)// Frames of depth
        for(let xF = 0; xF < inDepth; ++xF){
            const xFCorner = xF - frontPad;
            const xFMin = Math.max(0, Math.ceil(xFCorner / strideDepth));
            const yFMax = Math.min(outDepth, (filterDepth + xFCorner) / strideDepth);
            // Rows as per standard 2d matrix notation
            for(let xR = 0; xR < inHeight; ++xR){
                const xRCorner = xR - topPad;
                const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
                const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
                // Columns as per standard 2d matrix notation
                for(let xC = 0; xC < inWidth; ++xC){
                    const xCCorner = xC - leftPad;
                    const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                    const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                    let dotProd = 0;
                    for(let yF = xFMin; yF < yFMax; ++yF){
                        const wF = yF * strideDepth - xFCorner;
                        for(let yR = xRMin; yR < yRMax; ++yR){
                            const wR = yR * strideHeight - xRCorner;
                            for(let yC = xCMin; yC < yCMax; ++yC){
                                const wC = yC * strideWidth - xCCorner;
                                const dyOffset = dyS0 * b + dyS1 * yF + dyS2 * yR + dyS3 * yC;
                                const fltOffset = fltS0 * (filterDepth - 1 - wF) + fltS1 * (filterHeight - 1 - wR) + fltS2 * (filterWidth - 1 - wC) + fltS3 * d1;
                                for(let d2 = 0; d2 < outChannels; ++d2){
                                    const pixel = dyValues[dyOffset + d2];
                                    const weight = fltValues[fltOffset + d2];
                                    dotProd += pixel * weight;
                                }
                            }
                        }
                    }
                    dxValues[dxS0 * b + dxS1 * xF + dxS2 * xR + dxS3 * xC + d1] = dotProd;
                }
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $35d329a76f3b8dcb$export$40ece1caaaf084b2 = {
    kernelName: (0, $9BGT9.Conv3DBackpropInputV2),
    backendName: 'cpu',
    kernelFunc: $35d329a76f3b8dcb$export$ab31b884dc9f0971
};

});

parcelRegister("ZwOc8", function(module, exports) {

$parcel$export(module.exports, "cosConfig", function () { return $0b8f25b905b5d88a$export$ff099a1da5235a7e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $0b8f25b905b5d88a$export$50d414a77b60d802 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Cos), (xi)=>Math.cos(xi));
const $0b8f25b905b5d88a$export$ff099a1da5235a7e = {
    kernelName: (0, $9BGT9.Cos),
    backendName: 'cpu',
    kernelFunc: $0b8f25b905b5d88a$export$50d414a77b60d802
};

});

parcelRegister("7J2Cn", function(module, exports) {

$parcel$export(module.exports, "coshConfig", function () { return $59fec43dc678ec83$export$c5824052b09ba0ed; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $59fec43dc678ec83$export$2e2fd1ad24e4d350 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Cosh), (xi)=>Math.cosh(xi));
const $59fec43dc678ec83$export$c5824052b09ba0ed = {
    kernelName: (0, $9BGT9.Cosh),
    backendName: 'cpu',
    kernelFunc: $59fec43dc678ec83$export$2e2fd1ad24e4d350
};

});

parcelRegister("foorQ", function(module, exports) {

$parcel$export(module.exports, "cropAndResizeConfig", function () { return $b34c0fc7b647e657$export$f7086edcf0050c7f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
function $b34c0fc7b647e657$export$6f0f0090e1f6cd3c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const numBoxes = boxes.shape[0];
    const [cropHeight, cropWidth] = cropSize;
    const output = (0, $5siju.buffer)([
        numBoxes,
        cropHeight,
        cropWidth,
        numChannels
    ], 'float32');
    const boxVals = backend.data.get(boxes.dataId).values;
    const boxIndVals = backend.data.get(boxInd.dataId).values;
    const imageVals = backend.data.get(image.dataId).values;
    const inStride = (0, $lBDHD).computeStrides(image.shape); // to calculate flat indexes into image
    const outStride = (0, $lBDHD).computeStrides(output.shape); // to calculate flat indexes into output
    // Reference implementation
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op.cc
    for(let b = 0; b < numBoxes; b++){
        const startInd = b * 4;
        const y1 = boxVals[startInd];
        const x1 = boxVals[startInd + 1];
        const y2 = boxVals[startInd + 2];
        const x2 = boxVals[startInd + 3];
        const bInd = boxIndVals[b];
        if (bInd >= batch) continue;
        const heightScale = cropHeight > 1 ? (y2 - y1) * (imageHeight - 1) / (cropHeight - 1) : 0;
        const widthScale = cropWidth > 1 ? (x2 - x1) * (imageWidth - 1) / (cropWidth - 1) : 0;
        for(let y = 0; y < cropHeight; y++){
            const yInd = cropHeight > 1 ? y1 * (imageHeight - 1) + y * heightScale : 0.5 * (y1 + y2) * (imageHeight - 1);
            if (yInd < 0 || yInd > imageHeight - 1) {
                for(let x = 0; x < cropWidth; x++)for(let c = 0; c < numChannels; c++){
                    const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                    output.values[ind] = extrapolationValue;
                }
                continue;
            }
            if (method === 'bilinear') {
                const topInd = Math.floor(yInd);
                const bottomInd = Math.ceil(yInd);
                const yLerp = yInd - topInd;
                for(let x = 0; x < cropWidth; x++){
                    const xInd = cropWidth > 1 ? x1 * (imageWidth - 1) + x * widthScale : 0.5 * (x1 + x2) * (imageWidth - 1);
                    if (xInd < 0 || xInd > imageWidth - 1) {
                        for(let c = 0; c < numChannels; c++){
                            const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                            output.values[ind] = extrapolationValue;
                        }
                        continue;
                    }
                    const leftInd = Math.floor(xInd);
                    const rightInd = Math.ceil(xInd);
                    const xLerp = xInd - leftInd;
                    for(let c = 0; c < numChannels; c++){
                        let ind = c + leftInd * inStride[2] + topInd * inStride[1] + bInd * inStride[0];
                        const topLeft = imageVals[ind];
                        ind = c + rightInd * inStride[2] + topInd * inStride[1] + bInd * inStride[0];
                        const topRight = imageVals[ind];
                        ind = c + leftInd * inStride[2] + bottomInd * inStride[1] + bInd * inStride[0];
                        const bottomLeft = imageVals[ind];
                        ind = c + rightInd * inStride[2] + bottomInd * inStride[1] + bInd * inStride[0];
                        const bottomRight = imageVals[ind];
                        const top = topLeft + (topRight - topLeft) * xLerp;
                        const bottom = bottomLeft + (bottomRight - bottomLeft) * xLerp;
                        ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                        output.values[ind] = top + (bottom - top) * yLerp;
                    }
                }
            } else for(let x = 0; x < cropWidth; ++x){
                const xInd = cropWidth > 1 ? x1 * (imageWidth - 1) + x * widthScale : 0.5 * (x1 + x2) * (imageWidth - 1);
                if (xInd < 0 || xInd > imageWidth - 1) {
                    for(let c = 0; c < numChannels; c++){
                        const ind = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                        output.values[ind] = extrapolationValue;
                    }
                    continue;
                }
                const closestX = Math.round(xInd);
                const closestY = Math.round(yInd);
                for(let c = 0; c < numChannels; c++){
                    const inInd = c + closestX * inStride[2] + closestY * inStride[1] + bInd * inStride[0];
                    const outInd = c + x * outStride[2] + y * outStride[1] + b * outStride[0];
                    output.values[outInd] = imageVals[inInd];
                }
            }
        }
    }
    return backend.makeTensorInfo(output.shape, output.dtype, output.values);
}
const $b34c0fc7b647e657$export$f7086edcf0050c7f = {
    kernelName: (0, $9BGT9.CropAndResize),
    backendName: 'cpu',
    kernelFunc: $b34c0fc7b647e657$export$6f0f0090e1f6cd3c
};

});

parcelRegister("lyOLj", function(module, exports) {

$parcel$export(module.exports, "cumprodConfig", function () { return $fb24263f4b22785b$export$db50d81ed60c5a35; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $kKv2E = parcelRequire("kKv2E");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $joI4E = parcelRequire("joI4E");
function $fb24263f4b22785b$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'cumprod');
    const permutation = (0, $dEVRx).getAxesPermutation([
        axis
    ], x.shape.length);
    let $x = x;
    if (permutation != null) $x = (0, $joI4E.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $dEVRx).getInnerMostAxes(1, x.shape.length)[0];
    if (permutedAxis !== $x.shape.length - 1) throw new Error(`backend.cumprod in CPU expects an inner-most ` + `axis=${$x.shape.length - 1} but got axis=${permutedAxis}`);
    const resultDtype = (0, $kKv2E.upcastType)($x.dtype, 'int32');
    const vals = (0, $lBDHD).makeOnesTypedArray((0, $lBDHD).sizeFromShape($x.shape), resultDtype);
    const aVals = backend.data.get($x.dataId).values;
    const finalDim = $x.shape[$x.shape.length - 1];
    const indexAdjuster = reverse ? (i, j)=>i + finalDim - j - 1 : (i, j)=>i + j;
    for(let i = 0; i < aVals.length; i += finalDim)for(let j = 0; j < finalDim; j++){
        const idx = indexAdjuster(i, j);
        if (j === 0) vals[idx] = exclusive ? 1 : aVals[idx];
        else {
            const prevIdx = indexAdjuster(i, j - 1);
            vals[idx] = exclusive ? aVals[prevIdx] * vals[prevIdx] : aVals[idx] * vals[prevIdx];
        }
    }
    const result = backend.makeTensorInfo($x.shape, resultDtype, vals);
    if (permutation != null) {
        const reversePermutation = (0, $dEVRx).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $joI4E.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo($x);
        return reverseTransposedResult;
    }
    return result;
}
const $fb24263f4b22785b$export$db50d81ed60c5a35 = {
    kernelName: (0, $9BGT9.Cumprod),
    backendName: 'cpu',
    kernelFunc: $fb24263f4b22785b$export$dc7513e907e94b8d
};

});

parcelRegister("3hZDr", function(module, exports) {

$parcel$export(module.exports, "cumsumConfig", function () { return $2652c51441aad351$export$2f6196f3316e7ed2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $kKv2E = parcelRequire("kKv2E");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $joI4E = parcelRequire("joI4E");
function $2652c51441aad351$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'cumsum');
    const permutation = (0, $dEVRx).getAxesPermutation([
        axis
    ], x.shape.length);
    let $x = x;
    if (permutation != null) $x = (0, $joI4E.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $dEVRx).getInnerMostAxes(1, x.shape.length)[0];
    if (permutedAxis !== $x.shape.length - 1) throw new Error(`backend.cumsum in CPU expects an inner-most ` + `axis=${$x.shape.length - 1} but got axis=${permutedAxis}`);
    const resultDtype = (0, $kKv2E.upcastType)($x.dtype, 'int32');
    const vals = (0, $lBDHD).makeZerosTypedArray((0, $lBDHD).sizeFromShape($x.shape), resultDtype);
    const aVals = backend.data.get($x.dataId).values;
    const finalDim = $x.shape[$x.shape.length - 1];
    const indexAdjuster = reverse ? (i, j)=>i + finalDim - j - 1 : (i, j)=>i + j;
    for(let i = 0; i < aVals.length; i += finalDim)for(let j = 0; j < finalDim; j++){
        const idx = indexAdjuster(i, j);
        if (j === 0) vals[idx] = exclusive ? 0 : aVals[idx];
        else {
            const prevIdx = indexAdjuster(i, j - 1);
            vals[idx] = exclusive ? aVals[prevIdx] + vals[prevIdx] : aVals[idx] + vals[prevIdx];
        }
    }
    const result = backend.makeTensorInfo($x.shape, resultDtype, vals);
    if (permutation != null) {
        const reversePermutation = (0, $dEVRx).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $joI4E.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo($x);
        return reverseTransposedResult;
    }
    return result;
}
const $2652c51441aad351$export$2f6196f3316e7ed2 = {
    kernelName: (0, $9BGT9.Cumsum),
    backendName: 'cpu',
    kernelFunc: $2652c51441aad351$export$71990b1e1c4912fe
};

});

parcelRegister("95dcs", function(module, exports) {

$parcel$export(module.exports, "denseBincountConfig", function () { return $69ced1e47f11fd79$export$88ba267b84334692; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $lL92y = parcelRequire("lL92y");
function $69ced1e47f11fd79$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    if (x.shape.length === 1) {
        const xVals = backend.data.get(x.dataId).values;
        const weightsVals = backend.data.get(weights.dataId).values;
        const outVals = (0, $lL92y.bincountImpl)(xVals, weightsVals, weights.dtype, weights.shape, size);
        return backend.makeTensorInfo([
            size
        ], weights.dtype, outVals);
    } else if (x.shape.length === 2) {
        const xBuf = backend.bufferSync(x);
        const weightsBuf = backend.bufferSync(weights);
        const outBuf = (0, $lL92y.bincountReduceImpl)(xBuf, weightsBuf, size, binaryOutput);
        return backend.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank` + `${x.shape.length}.`);
}
const $69ced1e47f11fd79$export$88ba267b84334692 = {
    kernelName: (0, $9BGT9.DenseBincount),
    backendName: 'cpu',
    kernelFunc: $69ced1e47f11fd79$export$436934e6cf1946f1
};

});

parcelRegister("dZ9gT", function(module, exports) {

$parcel$export(module.exports, "depthToSpaceConfig", function () { return $a2e829f72297ee19$export$9c5b88dcb1d2008b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
function $a2e829f72297ee19$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    (0, $lBDHD).assert(dataFormat === 'NHWC', ()=>`Only NHWC dataFormat supported on CPU for depthToSpace. Got ${dataFormat}`);
    const batchSize = x.shape[0];
    const inputHeight = x.shape[1];
    const inputWidth = x.shape[2];
    const inputDepth = x.shape[3];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const xValues = backend.data.get(x.dataId).values;
    const result = new Float32Array(batchSize * outputHeight * outputWidth * outputDepth);
    let outputIdx = 0;
    for(let b = 0; b < batchSize; ++b)for(let h = 0; h < outputHeight; ++h){
        const inH = Math.floor(h / blockSize);
        const offsetH = h % blockSize;
        for(let w = 0; w < outputWidth; ++w){
            const inW = Math.floor(w / blockSize);
            const offsetW = w % blockSize;
            const offsetD = (offsetH * blockSize + offsetW) * outputDepth;
            for(let d = 0; d < outputDepth; ++d){
                const inD = d + offsetD;
                const inputIdx = inD + inputDepth * (inW + inputWidth * (inH + inputHeight * b));
                result[outputIdx++] = xValues[inputIdx];
            }
        }
    }
    return backend.makeTensorInfo([
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ], x.dtype, result);
}
const $a2e829f72297ee19$export$9c5b88dcb1d2008b = {
    kernelName: (0, $9BGT9.DepthToSpace),
    backendName: 'cpu',
    kernelFunc: $a2e829f72297ee19$export$3b50daec0f185f12
};

});

parcelRegister("hsCDu", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNative", function () { return $cb63057eb4fcfd82$export$14e793fe8822afd1; });
$parcel$export(module.exports, "depthwiseConv2dNativeConfig", function () { return $cb63057eb4fcfd82$export$240667804b7c390e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $cb63057eb4fcfd82$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $wi69v.assertNotComplex)([
        x,
        filter
    ], 'depthwiseConv2DNative');
    const xStrides = (0, $lBDHD).computeStrides(x.shape);
    const filterStrides = (0, $lBDHD).computeStrides(filter.shape);
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $lBDHD).assert((0, $dEVRx).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const { filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, padInfo: padInfo } = convInfo;
    const padLeft = padInfo.left;
    const padTop = padInfo.top;
    const chMul = convInfo.outChannels / convInfo.inChannels;
    const y = new (0, $3pVUH.TensorBuffer)(convInfo.outShape, x.dtype);
    const xVals = backend.data.get(x.dataId).values;
    const wVals = backend.data.get(filter.dataId).values;
    const yVals = y.values;
    for(let b = 0; b < convInfo.batchSize; ++b){
        const xOffset1 = b * xStrides[0];
        const yOffset1 = b * y.strides[0];
        for(let yR = 0; yR < convInfo.outHeight; ++yR){
            const yOffset2 = yOffset1 + yR * y.strides[1];
            const xRCorner = yR * convInfo.strideHeight - padTop;
            for(let wR = 0; wR < filterHeight; ++wR){
                const xR = xRCorner + wR * dilationHeight;
                if (xR < 0 || xR >= convInfo.inHeight) continue;
                const wOffset1 = wR * filterStrides[0];
                const xOffset2 = xOffset1 + xR * xStrides[1];
                for(let yC = 0; yC < convInfo.outWidth; ++yC){
                    const yOffset3 = yOffset2 + yC * y.strides[2];
                    const xCCorner = yC * convInfo.strideWidth - padLeft;
                    for(let wC = 0; wC < filterWidth; ++wC){
                        const xC = xCCorner + wC * dilationWidth;
                        if (xC < 0 || xC >= convInfo.inWidth) continue;
                        const wOffset2 = wOffset1 + wC * filterStrides[1];
                        const xOffset3 = xOffset2 + xC * convInfo.inChannels;
                        let yOffset4 = yOffset3;
                        let wOffset3 = wOffset2;
                        for(let d1 = 0; d1 < convInfo.inChannels; ++d1){
                            const xVal = xVals[xOffset3 + d1];
                            for(let q = 0; q < chMul; ++q)yVals[yOffset4 + q] += xVal * wVals[wOffset3 + q];
                            yOffset4 += chMul;
                            wOffset3 += chMul;
                        }
                    }
                }
            }
        }
    }
    return backend.makeTensorInfo(y.shape, y.dtype, y.values);
}
const $cb63057eb4fcfd82$export$240667804b7c390e = {
    kernelName: (0, $9BGT9.DepthwiseConv2dNative),
    backendName: 'cpu',
    kernelFunc: $cb63057eb4fcfd82$export$14e793fe8822afd1
};

});

parcelRegister("7pKW4", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropFilterConfig", function () { return $565f46a6e616d510$export$30bc0ac3775583fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");

var $wi69v = parcelRequire("wi69v");
function $565f46a6e616d510$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    (0, $wi69v.assertNotComplex)([
        x,
        dy
    ], 'depthwiseConv2dNativeBackpropFilter');
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const { strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth } = convInfo;
    const dW = new (0, $3pVUH.TensorBuffer)(convInfo.filterShape, 'float32');
    const leftPad = convInfo.padInfo.left;
    const topPad = convInfo.padInfo.top;
    const chMul = convInfo.outChannels / convInfo.inChannels;
    const xVals = backend.data.get(x.dataId).values;
    const xBuf = new (0, $3pVUH.TensorBuffer)(x.shape, x.dtype, xVals);
    const dyVals = backend.data.get(dy.dataId).values;
    const dyBuf = new (0, $3pVUH.TensorBuffer)(dy.shape, dy.dtype, dyVals);
    for(let wR = 0; wR < filterHeight; ++wR){
        const yRMin = Math.max(0, Math.ceil((topPad - wR) / strideHeight));
        const yRMax = Math.min(convInfo.outHeight, (convInfo.inHeight + topPad - wR) / strideHeight);
        for(let wC = 0; wC < filterWidth; ++wC){
            const yCMin = Math.max(0, Math.ceil((leftPad - wC) / strideWidth));
            const yCMax = Math.min(convInfo.outWidth, (convInfo.inWidth + leftPad - wC) / strideWidth);
            for(let d2 = 0; d2 < convInfo.outChannels; ++d2){
                const d1 = Math.trunc(d2 / chMul);
                const dm = d2 % chMul;
                let dotProd = 0;
                for(let b = 0; b < convInfo.batchSize; ++b)for(let yR = yRMin; yR < yRMax; ++yR){
                    const xR = wR + yR * strideHeight - topPad;
                    for(let yC = yCMin; yC < yCMax; ++yC){
                        const xC = wC + yC * strideWidth - leftPad;
                        dotProd += xBuf.get(b, xR, xC, d1) * dyBuf.get(b, yR, yC, d2);
                    }
                }
                dW.set(dotProd, wR, wC, d1, dm);
            }
        }
    }
    return backend.makeTensorInfo(dW.shape, dW.dtype, dW.values);
}
const $565f46a6e616d510$export$30bc0ac3775583fc = {
    kernelName: (0, $9BGT9.DepthwiseConv2dNativeBackpropFilter),
    backendName: 'cpu',
    kernelFunc: $565f46a6e616d510$export$cc0ae65e9edc7e1a
};

});

parcelRegister("1No46", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropInputConfig", function () { return $14ed08e8559831d4$export$55d12409e744bebe; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $14ed08e8559831d4$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    (0, $wi69v.assertNotComplex)([
        dy,
        filter
    ], 'depthwiseConv2DNativeBackpropInput');
    const dyStrides = (0, $lBDHD).computeStrides(dy.shape);
    const filterStrides = (0, $lBDHD).computeStrides(filter.shape);
    const convInfo = (0, $dEVRx).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const dx = new (0, $3pVUH.TensorBuffer)(convInfo.inShape, 'float32');
    const dxValues = dx.values;
    const [dxS0, dxS1, dxS2] = dx.strides;
    const dyValues = backend.data.get(dy.dataId).values;
    const [dyS0, dyS1, dyS2] = dyStrides;
    const fltValues = backend.data.get(filter.dataId).values;
    const [fltS0, fltS1, fltS2] = filterStrides;
    const { batchSize: batchSize, filterHeight: filterHeight, filterWidth: filterWidth, inChannels: inChannels, inHeight: inHeight, inWidth: inWidth, outChannels: outChannels, outHeight: outHeight, outWidth: outWidth, strideHeight: strideHeight, strideWidth: strideWidth } = convInfo;
    const topPad = filterHeight - 1 - convInfo.padInfo.top;
    const leftPad = filterWidth - 1 - convInfo.padInfo.left;
    const chMul = outChannels / inChannels;
    for(let b = 0; b < batchSize; ++b){
        for(let d1 = 0; d1 < inChannels; ++d1)for(let xR = 0; xR < inHeight; ++xR){
            const xRCorner = xR - topPad;
            const xRMin = Math.max(0, Math.ceil(xRCorner / strideHeight));
            const yRMax = Math.min(outHeight, (filterHeight + xRCorner) / strideHeight);
            for(let xC = 0; xC < inWidth; ++xC){
                const xCCorner = xC - leftPad;
                const xCMin = Math.max(0, Math.ceil(xCCorner / strideWidth));
                const yCMax = Math.min(outWidth, (filterWidth + xCCorner) / strideWidth);
                let dotProd = 0;
                for(let yR = xRMin; yR < yRMax; ++yR){
                    const wR = yR * strideHeight - xRCorner;
                    for(let yC = xCMin; yC < yCMax; ++yC){
                        const wC = yC * strideWidth - xCCorner;
                        const dyOffset = dyS0 * b + dyS1 * yR + dyS2 * yC;
                        const fltOffset = fltS0 * (filterHeight - 1 - wR) + fltS1 * (filterWidth - 1 - wC) + fltS2 * d1;
                        for(let dm = 0; dm < chMul; ++dm){
                            const d2 = d1 * chMul + dm;
                            const pixel = dyValues[dyOffset + d2];
                            const weight = fltValues[fltOffset + dm];
                            dotProd += pixel * weight;
                        }
                    }
                }
                dxValues[dxS0 * b + dxS1 * xR + dxS2 * xC + d1] = dotProd;
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $14ed08e8559831d4$export$55d12409e744bebe = {
    kernelName: (0, $9BGT9.DepthwiseConv2dNativeBackpropInput),
    backendName: 'cpu',
    kernelFunc: $14ed08e8559831d4$export$37e2ab95a4a4c24b
};

});

parcelRegister("28jjJ", function(module, exports) {

$parcel$export(module.exports, "diagConfig", function () { return $18db5021b418c527$export$56dc5d812a22748f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
function $18db5021b418c527$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const xVals = backend.data.get(x.dataId).values;
    const outBuf = (0, $5siju.buffer)([
        xSize,
        xSize
    ], x.dtype);
    const vals = outBuf.values;
    for(let i = 0; i < xVals.length; i++)vals[i * xSize + i] = xVals[i];
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    return backend.makeTensorInfo(outShape, outBuf.dtype, outBuf.values);
}
const $18db5021b418c527$export$56dc5d812a22748f = {
    kernelName: (0, $9BGT9.Diag),
    backendName: 'cpu',
    kernelFunc: $18db5021b418c527$export$c042e7c2f59bc046
};

});

parcelRegister("K0cia", function(module, exports) {

$parcel$export(module.exports, "dilation2DConfig", function () { return $08a47329e2f2e611$export$36d3c11f61a8891a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
const $08a47329e2f2e611$export$36d3c11f61a8891a = {
    kernelName: (0, $9BGT9.Dilation2D),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const xVals = cpuBackend.data.get(x.dataId).values;
        const xRank = x.shape.length;
        const filterVals = cpuBackend.data.get(filter.dataId).values;
        const filterRank = filter.shape.length;
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $dEVRx).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        const outSize = (0, $lBDHD).sizeFromShape(outShape);
        const outRank = outShape.length;
        const outputVals = (0, $lBDHD).getArrayFromDType(x.dtype, outSize);
        // Upsampling the input by fill in `dilation size - 1` values between each
        // input value.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const xIndex = (0, $lBDHD).locToIndex([
                                    b,
                                    hIn,
                                    wIn,
                                    d
                                ], xRank, (0, $lBDHD).computeStrides(x.shape));
                                const filterIndex = (0, $lBDHD).locToIndex([
                                    h,
                                    w,
                                    d
                                ], filterRank, (0, $lBDHD).computeStrides(filter.shape));
                                const val = xVals[xIndex] + filterVals[filterIndex];
                                if (val > curVal) curVal = val;
                            }
                        }
                    }
                    const outputIndex = (0, $lBDHD).locToIndex([
                        b,
                        hOut,
                        wOut,
                        d
                    ], outRank, (0, $lBDHD).computeStrides(outShape));
                    outputVals[outputIndex] = curVal;
                }
            }
        }
        const dataId = cpuBackend.write((0, $lBDHD).toTypedArray(outputVals, x.dtype), outShape, x.dtype);
        return {
            dataId: dataId,
            shape: outShape,
            dtype: x.dtype
        };
    }
};

});

parcelRegister("9wlyQ", function(module, exports) {

$parcel$export(module.exports, "dilation2DBackpropFilterConfig", function () { return $6ee7d3c9c31cc4ca$export$cf83abe0e8c87ce8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
const $6ee7d3c9c31cc4ca$export$cf83abe0e8c87ce8 = {
    kernelName: (0, $9BGT9.Dilation2DBackpropFilter),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter, dy: dy } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const $x = (0, $lBDHD).toNestedArray(x.shape, cpuBackend.data.get(x.dataId).values);
        const $filter = (0, $lBDHD).toNestedArray(filter.shape, cpuBackend.data.get(filter.dataId).values);
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $dEVRx).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        (0, $lBDHD).assert(dy.rank === outShape.length, ()=>`Error in ${0, $9BGT9.Dilation2DBackpropFilter}, dy ` + `must have the same rank as output ${outShape.length}, but got ` + `${dy.rank}`);
        const $dy = (0, $lBDHD).toNestedArray(outShape, cpuBackend.data.get(dy.dataId).values);
        // The computed filter gradients has the same dimensions as the filter:
        // [filterHeight, filterWidth, depth]
        const gradients = (0, $lBDHD).makeZerosNestedTypedArray(filter.shape, filter.dtype);
        // In the case of multiple argmax branches, we only back-propagate along the
        // last branch, i.e., the one with largest value of `h * filter_cols + w`,
        // similarly to the max-pooling backward routines.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    let hMax = 0;
                    let wMax = 0;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const val = $x[b][hIn][wIn][d] + $filter[h][w][d];
                                if (val > curVal) {
                                    curVal = val;
                                    hMax = h;
                                    wMax = w;
                                }
                            }
                        }
                    }
                    gradients[hMax][wMax][d] += $dy[b][hOut][wOut][d];
                }
            }
        }
        const dataId = cpuBackend.write((0, $lBDHD).toTypedArray(gradients, x.dtype), filter.shape, filter.dtype);
        return {
            dataId: dataId,
            shape: filter.shape,
            dtype: filter.dtype
        };
    }
};

});

parcelRegister("jqFJl", function(module, exports) {

$parcel$export(module.exports, "dilation2DBackpropInputConfig", function () { return $e250d0cf40641941$export$42e4451417dc5ea0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
const $e250d0cf40641941$export$42e4451417dc5ea0 = {
    kernelName: (0, $9BGT9.Dilation2DBackpropInput),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend, attrs: attrs })=>{
        const { x: x, filter: filter, dy: dy } = inputs;
        const { strides: strides, pad: pad, dilations: dilations } = attrs;
        const cpuBackend = backend;
        const $x = (0, $lBDHD).toNestedArray(x.shape, cpuBackend.data.get(x.dataId).values);
        const $filter = (0, $lBDHD).toNestedArray(filter.shape, cpuBackend.data.get(filter.dataId).values);
        const { batchSize: batchSize, inHeight: inHeight, inWidth: inWidth, inChannels: inChannels, outHeight: outHeight, outWidth: outWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth, outShape: outShape } = (0, $dEVRx).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
        (0, $lBDHD).assert(dy.rank === outShape.length, ()=>`Error in ${0, $9BGT9.Dilation2DBackpropInput}, dy ` + `must have the same rank as output ${outShape.length}, but got ` + `${dy.rank}`);
        const $dy = (0, $lBDHD).toNestedArray(outShape, cpuBackend.data.get(dy.dataId).values);
        // The computed gradients has the same dimensions as the input:
        // [batch, inputHeight, inputCols, inChannel]
        const gradients = (0, $lBDHD).makeZerosNestedTypedArray(x.shape, x.dtype);
        // In the case of multiple argmax branches, we only back-propagate along the
        // last branch, i.e., the one with largest value of `h * filter_cols + w`,
        // similarly to the max-pooling backward routines.
        // This implementation follows the TF c++ implementation:
        // https://github.com/tensorflow/tensorflow/blob/d9a3a849edc198e90172bc58eb293de457f9d986/tensorflow/core/kernels/dilation_ops.cc
        for(let b = 0; b < batchSize; ++b)for(let hOut = 0; hOut < outHeight; ++hOut){
            const hBeg = hOut * strideHeight - padInfo.top;
            for(let wOut = 0; wOut < outWidth; ++wOut){
                const wBeg = wOut * strideWidth - padInfo.left;
                for(let d = 0; d < inChannels; ++d){
                    let curVal = Number.MIN_SAFE_INTEGER;
                    let hInMax = hBeg < 0 ? 0 : hBeg;
                    let wInMax = wBeg < 0 ? 0 : wBeg;
                    for(let h = 0; h < filterHeight; ++h){
                        const hIn = hBeg + h * dilationHeight;
                        if (hIn >= 0 && hIn < inHeight) for(let w = 0; w < filterWidth; ++w){
                            const wIn = wBeg + w * dilationWidth;
                            if (wIn >= 0 && wIn < inWidth) {
                                const val = $x[b][hIn][wIn][d] + $filter[h][w][d];
                                if (val > curVal) {
                                    curVal = val;
                                    hInMax = hIn;
                                    wInMax = wIn;
                                }
                            }
                        }
                    }
                    gradients[b][hInMax][wInMax][d] += $dy[b][hOut][wOut][d];
                }
            }
        }
        const dataId = cpuBackend.write((0, $lBDHD).toTypedArray(gradients, x.dtype), x.shape, x.dtype);
        return {
            dataId: dataId,
            shape: x.shape,
            dtype: x.dtype
        };
    }
};

});

parcelRegister("5CzjV", function(module, exports) {

$parcel$export(module.exports, "drawConfig", function () { return $417be64140bd2428$export$917213cafa72964b; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
function $417be64140bd2428$export$e529deb2bfd496dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image } = inputs;
    const { canvas: canvas, options: options } = attrs;
    const { contextOptions: contextOptions, imageOptions: imageOptions } = options || {};
    const alpha = (imageOptions === null || imageOptions === void 0 ? void 0 : imageOptions.alpha) || 1;
    const contextType = (contextOptions === null || contextOptions === void 0 ? void 0 : contextOptions.contextType) || '2d';
    if (contextType !== '2d') throw new Error(`Context type ${contextOptions.contextType} is not supported by the CPU backend.`);
    const ctx = canvas.getContext(contextType, (contextOptions === null || contextOptions === void 0 ? void 0 : contextOptions.contextAttributes) || {});
    if (ctx == null) throw new Error(`Could not get the context with ${contextType} type.`);
    const [height, width] = image.shape.slice(0, 2);
    const depth = image.shape.length === 2 ? 1 : image.shape[2];
    const data = backend.data.get(image.dataId).values;
    const multiplier = image.dtype === 'float32' ? 255 : 1;
    const bytes = new Uint8ClampedArray(width * height * 4);
    for(let i = 0; i < height * width; ++i){
        const rgba = [
            0,
            0,
            0,
            255 * alpha
        ];
        for(let d = 0; d < depth; d++){
            const value = data[i * depth + d];
            if (image.dtype === 'float32') {
                if (value < 0 || value > 1) throw new Error(`Tensor values for a float32 Tensor must be in the ` + `range [0 - 1] but encountered ${value}.`);
            } else if (image.dtype === 'int32') {
                if (value < 0 || value > 255) throw new Error(`Tensor values for a int32 Tensor must be in the ` + `range [0 - 255] but encountered ${value}.`);
            }
            if (depth === 1) {
                rgba[0] = value * multiplier;
                rgba[1] = value * multiplier;
                rgba[2] = value * multiplier;
            } else rgba[d] = value * multiplier;
        }
        const j = i * 4;
        bytes[j + 0] = Math.round(rgba[0]);
        bytes[j + 1] = Math.round(rgba[1]);
        bytes[j + 2] = Math.round(rgba[2]);
        bytes[j + 3] = Math.round(rgba[3]);
    }
    canvas.width = width;
    canvas.height = height;
    const imageData = new ImageData(bytes, width, height);
    ctx.putImageData(imageData, 0, 0);
    return image;
}
const $417be64140bd2428$export$917213cafa72964b = {
    kernelName: (0, $9BGT9.Draw),
    backendName: 'cpu',
    kernelFunc: $417be64140bd2428$export$e529deb2bfd496dc
};

});

parcelRegister("5wuKe", function(module, exports) {

$parcel$export(module.exports, "einsumConfig", function () { return $4057ca243c473602$export$40bbf341885a23b7; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $bMajv = parcelRequire("bMajv");

var $dOeSU = parcelRequire("dOeSU");

var $5Mi8L = parcelRequire("5Mi8L");

var $joI4E = parcelRequire("joI4E");
function $4057ca243c473602$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $dEVRx).decodeEinsumEquation(equation, tensors.length);
    (0, $dEVRx).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $dEVRx).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $dEVRx).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $dEVRx).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $joI4E.transpose)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $lBDHD).arraysEqual(x.shape, targetShape)) {
                x = (0, $dOeSU.reshape)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $bMajv.multiply)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $5Mi8L.sum)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeIntermediateTensorInfo(tensorInfo);
    }
    return out;
}
const $4057ca243c473602$export$40bbf341885a23b7 = {
    kernelName: (0, $9BGT9.Einsum),
    backendName: 'cpu',
    kernelFunc: $4057ca243c473602$export$27265e7daac5c403
};

});
parcelRegister("bMajv", function(module, exports) {

$parcel$export(module.exports, "multiplyImpl", function () { return $023663d485b560af$export$ac59ae2be94ddda3; });
$parcel$export(module.exports, "multiply", function () { return $023663d485b560af$export$2060d2db72cce88f; });
$parcel$export(module.exports, "multiplyConfig", function () { return $023663d485b560af$export$745576778aafee88; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $023663d485b560af$export$ac59ae2be94ddda3 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((aValue, bValue)=>aValue * bValue);
const $023663d485b560af$export$93ff634b9c7cb5b9 = (0, $bvj2l.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal * bReal - aImag * bImag,
        imag: aReal * bImag + aImag * bReal
    };
});
const $023663d485b560af$export$2060d2db72cce88f = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Multiply), $023663d485b560af$export$ac59ae2be94ddda3, $023663d485b560af$export$93ff634b9c7cb5b9);
const $023663d485b560af$export$745576778aafee88 = {
    kernelName: (0, $9BGT9.Multiply),
    backendName: 'cpu',
    kernelFunc: $023663d485b560af$export$2060d2db72cce88f
};

});

parcelRegister("5Mi8L", function(module, exports) {

$parcel$export(module.exports, "sum", function () { return $434f81bbb33bd05f$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "sumConfig", function () { return $434f81bbb33bd05f$export$47edea402251c258; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $d9WU5 = parcelRequire("d9WU5");

var $9IBUg = parcelRequire("9IBUg");

var $l9MqT = parcelRequire("l9MqT");

var $dOeSU = parcelRequire("dOeSU");

var $joI4E = parcelRequire("joI4E");
function $434f81bbb33bd05f$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'sum');
    let $x;
    if (x.dtype === 'bool') $x = (0, $9IBUg.cast)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            dtype: 'int32'
        }
    });
    else $x = (0, $l9MqT.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const xRank = $x.shape.length;
    const axes = (0, $lBDHD).parseAxisParam(axis, $x.shape);
    const permutation = (0, $dEVRx).getAxesPermutation(axes, xRank);
    let reductionAxes = axes;
    let permutedX = $x;
    if (permutation != null) {
        permutedX = (0, $joI4E.transpose)({
            inputs: {
                x: $x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        reductionAxes = (0, $dEVRx).getInnerMostAxes(reductionAxes.length, xRank);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('sum', reductionAxes, permutedX.shape.length);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(permutedX.shape, reductionAxes);
    const resultDtype = (0, $dEVRx).upcastType(permutedX.dtype, 'int32');
    let result = (0, $d9WU5.zeros)(backend, outShape, resultDtype);
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const vals = backend.data.get(result.dataId).values;
    const aVals = backend.data.get(permutedX.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let sum = 0;
        for(let j = 0; j < reduceSize; ++j)sum += aVals[offset + j];
        vals[i] = sum;
    }
    if (keepDims) {
        const newShape = (0, $dEVRx).expandShapeToKeepDim(result.shape, axes);
        const oldResult = result;
        result = (0, $dOeSU.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    backend.disposeIntermediateTensorInfo($x);
    if (permutation != null) backend.disposeIntermediateTensorInfo(permutedX);
    return result;
}
const $434f81bbb33bd05f$export$47edea402251c258 = {
    kernelName: (0, $9BGT9.Sum),
    backendName: 'cpu',
    kernelFunc: $434f81bbb33bd05f$export$8a63f25cc62965f1
};

});


parcelRegister("630uU", function(module, exports) {

$parcel$export(module.exports, "eluGradConfig", function () { return $467368b4fa76685e$export$59bb07dd04647a1d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $467368b4fa76685e$export$a346244024505ff9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    (0, $wi69v.assertNotComplex)([
        dy,
        y
    ], 'eluGrad');
    const resultValues = new Float32Array((0, $lBDHD).sizeFromShape(y.shape));
    const values = backend.data.get(y.dataId).values;
    const dyValues = backend.data.get(dy.dataId).values;
    for(let i = 0; i < values.length; ++i){
        const v = values[i];
        if (v >= 0) resultValues[i] = dyValues[i];
        else resultValues[i] = dyValues[i] * (v + 1);
    }
    return backend.makeTensorInfo(y.shape, 'float32', resultValues);
}
const $467368b4fa76685e$export$59bb07dd04647a1d = {
    kernelName: (0, $9BGT9.EluGrad),
    backendName: 'cpu',
    kernelFunc: $467368b4fa76685e$export$a346244024505ff9
};

});

parcelRegister("9Gjjv", function(module, exports) {

$parcel$export(module.exports, "equalImpl", function () { return $70c70493566a4119$export$437b1c87795f120c; });
$parcel$export(module.exports, "equal", function () { return $70c70493566a4119$export$411ce8e5a71e3069; });
$parcel$export(module.exports, "equalConfig", function () { return $70c70493566a4119$export$3c8bc3d8ee318217; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $70c70493566a4119$export$437b1c87795f120c = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a === b ? 1 : 0);
const $70c70493566a4119$export$411ce8e5a71e3069 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Equal), $70c70493566a4119$export$437b1c87795f120c, null, 'bool');
const $70c70493566a4119$export$3c8bc3d8ee318217 = {
    kernelName: (0, $9BGT9.Equal),
    backendName: 'cpu',
    kernelFunc: $70c70493566a4119$export$411ce8e5a71e3069
};

});

parcelRegister("1N6wu", function(module, exports) {

$parcel$export(module.exports, "erfConfig", function () { return $14df6d6944ebb36a$export$d044ffef16079bd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $14df6d6944ebb36a$var$p = (0, $dEVRx).ERF_P;
const $14df6d6944ebb36a$var$a1 = (0, $dEVRx).ERF_A1;
const $14df6d6944ebb36a$var$a2 = (0, $dEVRx).ERF_A2;
const $14df6d6944ebb36a$var$a3 = (0, $dEVRx).ERF_A3;
const $14df6d6944ebb36a$var$a4 = (0, $dEVRx).ERF_A4;
const $14df6d6944ebb36a$var$a5 = (0, $dEVRx).ERF_A5;
const $14df6d6944ebb36a$export$d3896f355fc09423 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Erf), (xi)=>{
    const sign = Math.sign(xi);
    const v = Math.abs(xi);
    const t = 1.0 / (1.0 + $14df6d6944ebb36a$var$p * v);
    return sign * (1.0 - (((($14df6d6944ebb36a$var$a5 * t + $14df6d6944ebb36a$var$a4) * t + $14df6d6944ebb36a$var$a3) * t + $14df6d6944ebb36a$var$a2) * t + $14df6d6944ebb36a$var$a1) * t * Math.exp(-v * v));
});
const $14df6d6944ebb36a$export$d044ffef16079bd = {
    kernelName: (0, $9BGT9.Erf),
    backendName: 'cpu',
    kernelFunc: $14df6d6944ebb36a$export$d3896f355fc09423
};

});

parcelRegister("a6Y9A", function(module, exports) {

$parcel$export(module.exports, "expImpl", function () { return $75c920281a18a5d9$export$823000b70594f385; });
$parcel$export(module.exports, "exp", function () { return $75c920281a18a5d9$export$b310ec824aaee37f; });
$parcel$export(module.exports, "expConfig", function () { return $75c920281a18a5d9$export$2fd7ea0fcf021f34; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $75c920281a18a5d9$export$823000b70594f385 = (0, $cfLEm.createSimpleUnaryImpl)((xi)=>Math.exp(xi));
const $75c920281a18a5d9$export$b310ec824aaee37f = (0, $6wQye.unaryKernelFuncFromImpl)((0, $9BGT9.Exp), $75c920281a18a5d9$export$823000b70594f385, 'float32');
const $75c920281a18a5d9$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $9BGT9.Exp),
    backendName: 'cpu',
    kernelFunc: $75c920281a18a5d9$export$b310ec824aaee37f
};

});

parcelRegister("j72XB", function(module, exports) {

$parcel$export(module.exports, "expandDims", function () { return $dea0f79d7af4182a$export$d660d8ed21f46635; });
$parcel$export(module.exports, "expandDimsConfig", function () { return $dea0f79d7af4182a$export$86341ba0ce5d8e60; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $dOeSU = parcelRequire("dOeSU");
function $dea0f79d7af4182a$export$d660d8ed21f46635(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { input: input } = inputs;
    const { dim: dim } = attrs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $lBDHD).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $dOeSU.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $dea0f79d7af4182a$export$86341ba0ce5d8e60 = {
    kernelName: (0, $9BGT9.ExpandDims),
    backendName: 'cpu',
    kernelFunc: $dea0f79d7af4182a$export$d660d8ed21f46635
};

});

parcelRegister("9G2FR", function(module, exports) {

$parcel$export(module.exports, "expm1Impl", function () { return $70ba1c5780d744cd$export$44f6c1b1ff8db911; });
$parcel$export(module.exports, "expm1Config", function () { return $70ba1c5780d744cd$export$16db8a08b36f938; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $70ba1c5780d744cd$export$44f6c1b1ff8db911 = (0, $cfLEm.createSimpleUnaryImpl)((xi)=>Math.expm1(xi));
const $70ba1c5780d744cd$export$b6c0a80d46d3391d = (0, $6wQye.unaryKernelFuncFromImpl)((0, $9BGT9.Expm1), $70ba1c5780d744cd$export$44f6c1b1ff8db911);
const $70ba1c5780d744cd$export$16db8a08b36f938 = {
    kernelName: (0, $9BGT9.Expm1),
    backendName: 'cpu',
    kernelFunc: $70ba1c5780d744cd$export$b6c0a80d46d3391d
};

});

parcelRegister("7eR69", function(module, exports) {

$parcel$export(module.exports, "fftConfig", function () { return $54530766fa5d04d2$export$a4d564e380763c78; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $cx86A = parcelRequire("cx86A");

var $dOeSU = parcelRequire("dOeSU");
function $54530766fa5d04d2$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputSize = (0, $lBDHD).sizeFromShape(input.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $dOeSU.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const result = (0, $cx86A.fftBatch)(input2D, false, backend);
    const resultReshaped = (0, $dOeSU.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: input.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $54530766fa5d04d2$export$a4d564e380763c78 = {
    kernelName: (0, $9BGT9.FFT),
    backendName: 'cpu',
    kernelFunc: $54530766fa5d04d2$export$a535ef183b6128fa
};

});
parcelRegister("cx86A", function(module, exports) {

$parcel$export(module.exports, "fftBatch", function () { return $91feda9cfc601753$export$3f1645f616cf26f8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $kuzxZ = parcelRequire("kuzxZ");

var $hmrWF = parcelRequire("hmrWF");

var $aEIJt = parcelRequire("aEIJt");

var $l9MqT = parcelRequire("l9MqT");

var $acwXZ = parcelRequire("acwXZ");

var $bMajv = parcelRequire("bMajv");

var $fWJq3 = parcelRequire("fWJq3");

var $avBJE = parcelRequire("avBJE");

var $59DpV = parcelRequire("59DpV");

var $2rbI5 = parcelRequire("2rbI5");
function $91feda9cfc601753$export$3f1645f616cf26f8(input, inverse, cpuBackend) {
    const inputShape = input.shape;
    const batch = inputShape[0];
    const innerDim = inputShape[1];
    const inputVals = cpuBackend.data.get(input.dataId);
    const real2D = inputVals.complexTensorInfos.real;
    const imag2D = inputVals.complexTensorInfos.imag;
    // Collects real and imaginary values separately.
    const resultShape = [
        batch,
        innerDim
    ];
    const resultSize = (0, $lBDHD).sizeFromShape(resultShape);
    const resultReal = (0, $lBDHD).getTypedArrayFromDType('float32', resultSize);
    const resultImag = (0, $lBDHD).getTypedArrayFromDType('float32', resultSize);
    for(let b = 0; b < batch; b++){
        // TODO: Support slice ops for complex type.
        const r = (0, $59DpV.slice)({
            inputs: {
                x: real2D
            },
            backend: cpuBackend,
            attrs: {
                begin: [
                    b,
                    0
                ],
                size: [
                    1,
                    innerDim
                ]
            }
        });
        const i = (0, $59DpV.slice)({
            inputs: {
                x: imag2D
            },
            backend: cpuBackend,
            attrs: {
                begin: [
                    b,
                    0
                ],
                size: [
                    1,
                    innerDim
                ]
            }
        });
        const input = (0, $hmrWF.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: cpuBackend
        });
        // Run FFT by batch element.
        const { real: real, imag: imag } = $91feda9cfc601753$export$75d3742a7578721e(input, inverse, cpuBackend);
        const res = (0, $dEVRx).mergeRealAndImagArrays(real, imag);
        for(let d = 0; d < innerDim; d++){
            const c = (0, $dEVRx).getComplexWithIndex(res, d);
            resultReal[b * innerDim + d] = c.real;
            resultImag[b * innerDim + d] = c.imag;
        }
        cpuBackend.disposeIntermediateTensorInfo(r);
        cpuBackend.disposeIntermediateTensorInfo(i);
        cpuBackend.disposeIntermediateTensorInfo(input);
    }
    const $realInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', resultReal);
    const $imagInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', resultImag);
    const result = (0, $hmrWF.complex)({
        inputs: {
            real: $realInfo,
            imag: $imagInfo
        },
        backend: cpuBackend
    });
    cpuBackend.disposeIntermediateTensorInfo($realInfo);
    cpuBackend.disposeIntermediateTensorInfo($imagInfo);
    return result;
}
function $91feda9cfc601753$export$75d3742a7578721e(input, inverse, cpuBackend) {
    const inputSize = (0, $lBDHD).sizeFromShape(input.shape);
    const inputVals = cpuBackend.data.get(input.dataId);
    const realVals = cpuBackend.data.get(inputVals.complexTensorInfos.real.dataId).values;
    const imagVals = cpuBackend.data.get(inputVals.complexTensorInfos.imag.dataId).values;
    if ($91feda9cfc601753$var$isExponentOf2(inputSize)) {
        const result = $91feda9cfc601753$var$fftRadix2(realVals, imagVals, inputSize, inverse, cpuBackend);
        const resultShape = [
            input.shape[0],
            input.shape[1]
        ];
        if (inverse) {
            const realInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', result.real);
            const imagInfo = cpuBackend.makeTensorInfo(resultShape, 'float32', result.imag);
            const sizeInfo = cpuBackend.makeTensorInfo([], 'float32', (0, $lBDHD).createScalarValue(inputSize, 'float32'));
            const sizeInfoCopy = (0, $l9MqT.identity)({
                inputs: {
                    x: sizeInfo
                },
                backend: cpuBackend
            });
            const divRealInfo = (0, $avBJE.realDivConfig).kernelFunc({
                inputs: {
                    a: realInfo,
                    b: sizeInfo
                },
                backend: cpuBackend
            });
            const divImagInfo = (0, $avBJE.realDivConfig).kernelFunc({
                inputs: {
                    a: imagInfo,
                    b: sizeInfoCopy
                },
                backend: cpuBackend
            });
            const divRealVals = cpuBackend.data.get(divRealInfo.dataId).values;
            const divImagVals = cpuBackend.data.get(divImagInfo.dataId).values;
            cpuBackend.disposeIntermediateTensorInfo(realInfo);
            cpuBackend.disposeIntermediateTensorInfo(imagInfo);
            cpuBackend.disposeIntermediateTensorInfo(sizeInfo);
            cpuBackend.disposeIntermediateTensorInfo(sizeInfoCopy);
            cpuBackend.disposeIntermediateTensorInfo(divRealInfo);
            cpuBackend.disposeIntermediateTensorInfo(divImagInfo);
            return {
                real: divRealVals,
                imag: divImagVals
            };
        }
        return result;
    } else {
        const data = (0, $dEVRx).mergeRealAndImagArrays(realVals, imagVals);
        const rawOutput = $91feda9cfc601753$var$fourierTransformByMatmul(data, inputSize, inverse);
        return (0, $dEVRx).splitRealAndImagArrays(rawOutput);
    }
}
function $91feda9cfc601753$var$isExponentOf2(size) {
    return (size & size - 1) === 0;
}
// FFT using Cooley-Tukey algorithm on radix 2 dimensional input.
function $91feda9cfc601753$var$fftRadix2(realVals, imagVals, size, inverse, cpuBackend) {
    if (size === 1) return {
        real: realVals,
        imag: imagVals
    };
    const data = (0, $dEVRx).mergeRealAndImagArrays(realVals, imagVals);
    const half = size / 2;
    const evenComplex = (0, $dEVRx).complexWithEvenIndex(data);
    const evenRealVals = evenComplex.real;
    const evenImagVals = evenComplex.imag;
    const evenShape = [
        evenRealVals.length
    ];
    const evenRealInfo = cpuBackend.makeTensorInfo(evenShape, 'float32', evenRealVals);
    const evenImagInfo = cpuBackend.makeTensorInfo(evenShape, 'float32', evenImagVals);
    const evenTensorInfo = (0, $hmrWF.complex)({
        inputs: {
            real: evenRealInfo,
            imag: evenImagInfo
        },
        backend: cpuBackend
    });
    const oddComplex = (0, $dEVRx).complexWithOddIndex(data);
    const oddRealVals = oddComplex.real;
    const oddImagVals = oddComplex.imag;
    const oddShape = [
        oddRealVals.length
    ];
    const oddRealInfo = cpuBackend.makeTensorInfo(oddShape, 'float32', oddRealVals);
    const oddImagInfo = cpuBackend.makeTensorInfo(oddShape, 'float32', oddImagVals);
    const oddTensorInfo = (0, $hmrWF.complex)({
        inputs: {
            real: oddRealInfo,
            imag: oddImagInfo
        },
        backend: cpuBackend
    });
    // Recursive call for half part of original input.
    const $evenComplex = $91feda9cfc601753$var$fftRadix2(evenRealVals, evenImagVals, half, inverse, cpuBackend);
    const $evenRealVals = $evenComplex.real;
    const $evenImagVals = $evenComplex.imag;
    const $evenShape = [
        $evenRealVals.length
    ];
    const $evenRealInfo = cpuBackend.makeTensorInfo($evenShape, 'float32', $evenRealVals);
    const $evenImagInfo = cpuBackend.makeTensorInfo($evenShape, 'float32', $evenImagVals);
    const $evenTensorInfo = (0, $hmrWF.complex)({
        inputs: {
            real: $evenRealInfo,
            imag: $evenImagInfo
        },
        backend: cpuBackend
    });
    const $oddComplex = $91feda9cfc601753$var$fftRadix2(oddRealVals, oddImagVals, half, inverse, cpuBackend);
    const $oddRealVals = $oddComplex.real;
    const $oddImagVals = $oddComplex.imag;
    const $oddShape = [
        $oddRealVals.length
    ];
    const $oddRealInfo = cpuBackend.makeTensorInfo($oddShape, 'float32', $oddRealVals);
    const $oddImagInfo = cpuBackend.makeTensorInfo($oddShape, 'float32', $oddImagVals);
    const $oddTensorInfo = (0, $hmrWF.complex)({
        inputs: {
            real: $oddRealInfo,
            imag: $oddImagInfo
        },
        backend: cpuBackend
    });
    const e = (0, $dEVRx).exponents(size, inverse);
    const eShape = [
        e.real.length
    ];
    const eRealInfo = cpuBackend.makeTensorInfo(eShape, 'float32', e.real);
    const eImagInfo = cpuBackend.makeTensorInfo(eShape, 'float32', e.imag);
    const complexInfo = (0, $hmrWF.complex)({
        inputs: {
            real: eRealInfo,
            imag: eImagInfo
        },
        backend: cpuBackend
    });
    const exponentInfo = (0, $bMajv.multiply)({
        inputs: {
            a: complexInfo,
            b: $oddTensorInfo
        },
        backend: cpuBackend
    });
    const addPart = (0, $kuzxZ.add)({
        inputs: {
            a: $evenTensorInfo,
            b: exponentInfo
        },
        backend: cpuBackend
    });
    const subPart = (0, $2rbI5.sub)({
        inputs: {
            a: $evenTensorInfo,
            b: exponentInfo
        },
        backend: cpuBackend
    });
    const addPartReal = (0, $fWJq3.real)({
        inputs: {
            input: addPart
        },
        backend: cpuBackend
    });
    const subPartReal = (0, $fWJq3.real)({
        inputs: {
            input: subPart
        },
        backend: cpuBackend
    });
    const addPartImag = (0, $acwXZ.imag)({
        inputs: {
            input: addPart
        },
        backend: cpuBackend
    });
    const subPartImag = (0, $acwXZ.imag)({
        inputs: {
            input: subPart
        },
        backend: cpuBackend
    });
    const $real = (0, $aEIJt.concat)({
        inputs: [
            addPartReal,
            subPartReal
        ],
        backend: cpuBackend,
        attrs: {
            axis: 0
        }
    });
    const $imag = (0, $aEIJt.concat)({
        inputs: [
            addPartImag,
            subPartImag
        ],
        backend: cpuBackend,
        attrs: {
            axis: 0
        }
    });
    const $realVals = cpuBackend.data.get($real.dataId).values;
    const $imagVals = cpuBackend.data.get($imag.dataId).values;
    cpuBackend.disposeIntermediateTensorInfo(evenRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(evenImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(evenTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(oddTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenRealInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenImagInfo);
    cpuBackend.disposeIntermediateTensorInfo($evenTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddRealInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddImagInfo);
    cpuBackend.disposeIntermediateTensorInfo($oddTensorInfo);
    cpuBackend.disposeIntermediateTensorInfo(eRealInfo);
    cpuBackend.disposeIntermediateTensorInfo(eImagInfo);
    cpuBackend.disposeIntermediateTensorInfo(complexInfo);
    cpuBackend.disposeIntermediateTensorInfo(exponentInfo);
    cpuBackend.disposeIntermediateTensorInfo(addPart);
    cpuBackend.disposeIntermediateTensorInfo(subPart);
    cpuBackend.disposeIntermediateTensorInfo(addPartReal);
    cpuBackend.disposeIntermediateTensorInfo(addPartImag);
    cpuBackend.disposeIntermediateTensorInfo(subPartReal);
    cpuBackend.disposeIntermediateTensorInfo(subPartImag);
    cpuBackend.disposeIntermediateTensorInfo($real);
    cpuBackend.disposeIntermediateTensorInfo($imag);
    return {
        real: $realVals,
        imag: $imagVals
    };
}
// Calculate fourier transform by multplying sinusoid matrix.
function $91feda9cfc601753$var$fourierTransformByMatmul(data, size, inverse) {
    const ret = new Float32Array(size * 2);
    // TODO: Use matmul instead once it supports complex64 type.
    for(let r = 0; r < size; r++){
        let real = 0.0;
        let imag = 0.0;
        for(let c = 0; c < size; c++){
            const e = (0, $dEVRx).exponent(r * c, size, inverse);
            const term = (0, $dEVRx).getComplexWithIndex(data, c);
            real += term.real * e.real - term.imag * e.imag;
            imag += term.real * e.imag + term.imag * e.real;
        }
        if (inverse) {
            real /= size;
            imag /= size;
        }
        (0, $dEVRx).assignToTypedArray(ret, real, imag, r);
    }
    return ret;
}

});
parcelRegister("avBJE", function(module, exports) {

$parcel$export(module.exports, "div", function () { return $7a6a12149edc24b7$export$159d9494db57879b; });
$parcel$export(module.exports, "realDivConfig", function () { return $7a6a12149edc24b7$export$15c5d6176b30b9a6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $7a6a12149edc24b7$export$967709f6160bacde = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a / b);
const $7a6a12149edc24b7$export$159d9494db57879b = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.RealDiv), $7a6a12149edc24b7$export$967709f6160bacde);
const $7a6a12149edc24b7$export$15c5d6176b30b9a6 = {
    kernelName: (0, $9BGT9.RealDiv),
    backendName: 'cpu',
    kernelFunc: $7a6a12149edc24b7$export$159d9494db57879b
};

});

parcelRegister("2rbI5", function(module, exports) {

$parcel$export(module.exports, "subImpl", function () { return $1c672fbfba1e9908$export$ad8defe68e22c8c1; });
$parcel$export(module.exports, "sub", function () { return $1c672fbfba1e9908$export$f93b5905241a7cca; });
$parcel$export(module.exports, "subConfig", function () { return $1c672fbfba1e9908$export$5d068476dad60c4d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $1c672fbfba1e9908$export$ad8defe68e22c8c1 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((aValue, bValue)=>aValue - bValue);
const $1c672fbfba1e9908$export$e56bd24b892e7ec5 = (0, $bvj2l.createComplexBinaryKernelImpl)((aReal, aImag, bReal, bImag)=>{
    return {
        real: aReal - bReal,
        imag: aImag - bImag
    };
});
const $1c672fbfba1e9908$export$f93b5905241a7cca = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Sub), $1c672fbfba1e9908$export$ad8defe68e22c8c1, $1c672fbfba1e9908$export$e56bd24b892e7ec5);
const $1c672fbfba1e9908$export$5d068476dad60c4d = {
    kernelName: (0, $9BGT9.Sub),
    backendName: 'cpu',
    kernelFunc: $1c672fbfba1e9908$export$f93b5905241a7cca
};

});



parcelRegister("2EKqh", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $1ef353d139b98525$export$9563e054e6f787fb; });
$parcel$export(module.exports, "fillConfig", function () { return $1ef353d139b98525$export$c953bf474b2bde62; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
function $1ef353d139b98525$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value, dtype: dtype } = attrs;
    const $dtype = dtype || (0, $lBDHD).inferDtype(value);
    const values = (0, $lBDHD).getArrayFromDType($dtype, (0, $lBDHD).sizeFromShape(shape));
    $1ef353d139b98525$var$fillValues(values, value, $dtype);
    return backend.makeTensorInfo(shape, $dtype, values);
}
const $1ef353d139b98525$export$c953bf474b2bde62 = {
    kernelName: (0, $9BGT9.Fill),
    backendName: 'cpu',
    kernelFunc: $1ef353d139b98525$export$9563e054e6f787fb
};
function $1ef353d139b98525$var$fillValues(values, value, dtype) {
    if (dtype === 'string') values.fill(value);
    else values.fill(value);
}

});

parcelRegister("3Ao6Y", function(module, exports) {

$parcel$export(module.exports, "flipLeftRightConfig", function () { return $29c76fe969f9f761$export$c9ec83cb23304466; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
const $29c76fe969f9f761$export$c9ec83cb23304466 = {
    kernelName: (0, $9BGT9.FlipLeftRight),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const cpuBackend = backend;
        const output = (0, $lBDHD).getTypedArrayFromDType(image.dtype, (0, $lBDHD).sizeFromShape(image.shape));
        const [batch, imageHeight, imageWidth, numChannels] = image.shape;
        const imageVals = cpuBackend.data.get(image.dataId).values;
        for(let batchIdx = 0; batchIdx < batch; batchIdx++){
            const batchOffset = batchIdx * imageWidth * imageHeight * numChannels;
            for(let row = 0; row < imageHeight; row++){
                const rowOffset = row * (imageWidth * numChannels);
                for(let col = 0; col < imageWidth; col++){
                    const colOffset = col * numChannels;
                    for(let channel = 0; channel < numChannels; channel++){
                        const coordX = Math.round(imageWidth - col - 1);
                        const outIdx = batchOffset + rowOffset + colOffset + channel;
                        let outputValue = imageVals[outIdx];
                        // If the coordinate position falls within the image boundaries...
                        if (coordX >= 0 && coordX < imageWidth) {
                            // set the output to the image value at the coordinate position.
                            const rotatedColOffset = coordX * numChannels;
                            const imageIdx = batchOffset + rowOffset + rotatedColOffset + channel;
                            outputValue = imageVals[imageIdx];
                        }
                        output[outIdx] = outputValue;
                    }
                }
            }
        }
        const dataId = cpuBackend.write(output, image.shape, image.dtype);
        return {
            dataId: dataId,
            shape: image.shape,
            dtype: image.dtype
        };
    }
};

});

parcelRegister("lJgzZ", function(module, exports) {

$parcel$export(module.exports, "floorImpl", function () { return $fd1aa948f37ef098$export$c365361068e97c87; });
$parcel$export(module.exports, "floorConfig", function () { return $fd1aa948f37ef098$export$7e9a0f96fa6bd01c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $fd1aa948f37ef098$export$c365361068e97c87 = (0, $cfLEm.createSimpleUnaryImpl)((xi)=>Math.floor(xi));
const $fd1aa948f37ef098$export$a3fe094919f356fd = (0, $6wQye.unaryKernelFuncFromImpl)((0, $9BGT9.Floor), $fd1aa948f37ef098$export$c365361068e97c87);
const $fd1aa948f37ef098$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $9BGT9.Floor),
    backendName: 'cpu',
    kernelFunc: $fd1aa948f37ef098$export$a3fe094919f356fd
};

});

parcelRegister("kjdJQ", function(module, exports) {

$parcel$export(module.exports, "floorDivImpl", function () { return $ec903d2928cf0f79$export$9b7f64e28e98c78e; });
$parcel$export(module.exports, "floorDivConfig", function () { return $ec903d2928cf0f79$export$7eac933a0c7fd37f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $ec903d2928cf0f79$export$9b7f64e28e98c78e = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>Math.floor(a / b));
const $ec903d2928cf0f79$export$112397bc52715a8 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.FloorDiv), $ec903d2928cf0f79$export$9b7f64e28e98c78e, null, 'int32');
const $ec903d2928cf0f79$export$7eac933a0c7fd37f = {
    kernelName: (0, $9BGT9.FloorDiv),
    backendName: 'cpu',
    kernelFunc: $ec903d2928cf0f79$export$112397bc52715a8
};

});

parcelRegister("bYokO", function(module, exports) {

$parcel$export(module.exports, "fusedConv2DConfig", function () { return $8b782cad41d2e581$export$5b64efa829ddf94e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $5AgIM = parcelRequire("5AgIM");

var $kuzxZ = parcelRequire("kuzxZ");

var $jpv7x = parcelRequire("jpv7x");

var $dOeSU = parcelRequire("dOeSU");
function $8b782cad41d2e581$export$8db45c19fd28b6b8(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let result = (0, $jpv7x.conv2D)({
        inputs: {
            x: x,
            filter: filter
        },
        backend: backend,
        attrs: {
            strides: strides,
            pad: pad,
            dataFormat: dataFormat,
            dilations: dilations,
            dimRoundingMode: dimRoundingMode
        }
    });
    if (bias) {
        const resultOld = result;
        // For NCHW format, if bias is a 1-D tensor, it is supposed to be aligned
        // to the channel of the conv2d's result; if the bias is a scalar, the
        // bias_add is computed as if the bias was broadcasted to the shape of the
        // conv2d's result.
        if (dataFormat === 'NCHW' && bias.shape.length === 1 && bias.shape[0] !== 1) {
            const reshapedBias = (0, $dOeSU.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: [
                        bias.shape[0],
                        1,
                        1
                    ]
                }
            });
            result = (0, $kuzxZ.add)({
                inputs: {
                    a: result,
                    b: reshapedBias
                },
                backend: backend
            });
            backend.disposeIntermediateTensorInfo(reshapedBias);
        } else // This condition handles NHWC and NCHW (scalar case). The only other case
        // for NCHW (1D case) is handled above.
        result = (0, $kuzxZ.add)({
            inputs: {
                a: result,
                b: bias
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(resultOld);
    }
    if (activation) {
        const resultOld = result;
        // For NCHW format, if PReLu activation weights is a 1-D tensor, it is
        // supposed to be aligned with the channel of the conv2d's result. For other
        // cases, whether NCHW or NHWC data format, the conv2d result is
        // already aligned with the activation weights.
        if (dataFormat === 'NCHW' && activation === 'prelu' && preluActivationWeights.shape.length === 1 && preluActivationWeights.shape[0] !== 1) {
            const reshapedAlpha = (0, $dOeSU.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: [
                        preluActivationWeights.shape[0],
                        1,
                        1
                    ]
                }
            });
            result = (0, $5AgIM.applyActivation)(backend, result, activation, reshapedAlpha, leakyreluAlpha);
            backend.disposeIntermediateTensorInfo(reshapedAlpha);
        } else result = (0, $5AgIM.applyActivation)(backend, result, activation, preluActivationWeights, leakyreluAlpha);
        backend.disposeIntermediateTensorInfo(resultOld);
    }
    return result;
}
const $8b782cad41d2e581$export$5b64efa829ddf94e = {
    kernelName: (0, $9BGT9.FusedConv2D),
    backendName: 'cpu',
    kernelFunc: $8b782cad41d2e581$export$8db45c19fd28b6b8
};

});

parcelRegister("fKu9a", function(module, exports) {

$parcel$export(module.exports, "fusedDepthwiseConv2DConfig", function () { return $b7728970364aa521$export$58481cc3409b412c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $5AgIM = parcelRequire("5AgIM");

var $kuzxZ = parcelRequire("kuzxZ");

var $hsCDu = parcelRequire("hsCDu");
function $b7728970364aa521$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    let result = (0, $hsCDu.depthwiseConv2dNative)({
        inputs: {
            x: x,
            filter: filter
        },
        backend: backend,
        attrs: {
            strides: strides,
            pad: pad,
            dataFormat: dataFormat,
            dilations: dilations,
            dimRoundingMode: dimRoundingMode
        }
    });
    if (bias) {
        const oldResult = result;
        result = (0, $kuzxZ.add)({
            inputs: {
                a: result,
                b: bias
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    if (activation) {
        const oldResult = result;
        result = (0, $5AgIM.applyActivation)(backend, result, activation, preluActivationWeights, leakyreluAlpha);
        backend.disposeIntermediateTensorInfo(oldResult);
    }
    return result;
}
const $b7728970364aa521$export$58481cc3409b412c = {
    kernelName: (0, $9BGT9.FusedDepthwiseConv2D),
    backendName: 'cpu',
    kernelFunc: $b7728970364aa521$export$d61de7729228094b
};

});

parcelRegister("dhJEK", function(module, exports) {

$parcel$export(module.exports, "gatherNdConfig", function () { return $9ac0474268d4ab21$export$d9700eb1c7f5c969; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $gZ4JZ = parcelRequire("gZ4JZ");
function $9ac0474268d4ab21$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const paramsSize = (0, $lBDHD).sizeFromShape(params.shape);
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const [resultShape, numSlices, sliceSize, strides] = (0, $dEVRx).prepareAndValidate(params, indices);
    if (numSlices === 0) return backend.makeTensorInfo(resultShape, params.dtype, []);
    const indicesData = backend.data.get(indices.dataId).values;
    const paramsBuf = backend.bufferSync(params);
    const outBuf = (0, $gZ4JZ.gatherNdImpl)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
    return backend.makeTensorInfo(resultShape, params.dtype, outBuf.values);
}
const $9ac0474268d4ab21$export$d9700eb1c7f5c969 = {
    kernelName: (0, $9BGT9.GatherNd),
    backendName: 'cpu',
    kernelFunc: $9ac0474268d4ab21$export$3c586830e482d2b9
};

});
parcelRegister("gZ4JZ", function(module, exports) {

$parcel$export(module.exports, "gatherNdImpl", function () { return $c5d60547bc608853$export$eed1912b07a3c4d5; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
function $c5d60547bc608853$export$eed1912b07a3c4d5(indicesData, paramsBuf, dtype, numSlices, sliceRank, sliceSize, strides, paramsShape, paramsSize) {
    const outBuf = (0, $5siju.buffer)([
        numSlices,
        sliceSize
    ], dtype);
    for(let i = 0; i < numSlices; i++){
        const index = [];
        let flattenIndex = 0;
        for(let j = 0; j < sliceRank; j++){
            const dim = indicesData[i * sliceRank + j];
            flattenIndex += dim * strides[j];
            index.push(dim);
        }
        if (flattenIndex < 0 || flattenIndex >= paramsSize / sliceSize) throw new Error(`Invalid indices: ${index} does not index into ${paramsShape}`);
        for(let k = 0; k < sliceSize; k++)outBuf.values[i * sliceSize + k] = paramsBuf.get(...paramsBuf.indexToLoc(flattenIndex * sliceSize + k));
    }
    return outBuf;
}

});


parcelRegister("fR08n", function(module, exports) {

$parcel$export(module.exports, "gatherV2Config", function () { return $b8abe8dfa94f4d6f$export$b1bd3139c91d8765; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $9E7lO = parcelRequire("9E7lO");

var $dOeSU = parcelRequire("dOeSU");
function $b8abe8dfa94f4d6f$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    (0, $wi69v.assertNotComplex)([
        x,
        indices
    ], 'gatherV2');
    // Throw error when any index is out of bound.
    const parsedAxis = (0, $lBDHD).parseAxisParam(axis, x.shape)[0];
    const indicesVals = backend.data.get(indices.dataId).values;
    const axisDim = x.shape[parsedAxis];
    for(let i = 0; i < indicesVals.length; ++i){
        const index = indicesVals[i];
        (0, $lBDHD).assert(index <= axisDim - 1 && index >= 0, ()=>`GatherV2: the index value ${index} is not in [0, ${axisDim - 1}]`);
    }
    let $batchDims = batchDims;
    if (batchDims == null) $batchDims = 0;
    const indicesSize = (0, $lBDHD).sizeFromShape(indices.shape);
    const shapeInfo = (0, $dEVRx).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, $batchDims);
    const flattenX = (0, $dOeSU.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $dOeSU.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    const indicesBuf = backend.bufferSync(flattenIndex);
    const xBuf = backend.bufferSync(flattenX);
    const outBuf = (0, $9E7lO.gatherV2Impl)(xBuf, indicesBuf, flattenOutputShape);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(flattenIndex);
    return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
}
const $b8abe8dfa94f4d6f$export$b1bd3139c91d8765 = {
    kernelName: (0, $9BGT9.GatherV2),
    backendName: 'cpu',
    kernelFunc: $b8abe8dfa94f4d6f$export$3d75b4295ded9925
};

});
parcelRegister("9E7lO", function(module, exports) {

$parcel$export(module.exports, "gatherV2Impl", function () { return $705d8d2d58a3822d$export$d7b732f2e62ccc09; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
function $705d8d2d58a3822d$export$d7b732f2e62ccc09(xBuf, indicesBuf, flattenOutputShape) {
    const outBuf = (0, $5siju.buffer)(flattenOutputShape, xBuf.dtype);
    for(let i = 0; i < outBuf.size; ++i){
        const newLoc = outBuf.indexToLoc(i);
        const originalLoc = newLoc.slice();
        const batchIdx = originalLoc[0];
        const indicesIdx = originalLoc[2];
        const indicesIndex = indicesBuf.locToIndex([
            batchIdx,
            indicesIdx
        ]);
        originalLoc[2] = indicesBuf.values[indicesIndex];
        const originalIndex = xBuf.locToIndex(originalLoc);
        if (0 <= originalIndex && originalIndex < xBuf.values.length) outBuf.values[i] = xBuf.values[originalIndex];
         // Else, index is out of bounds, so leave the default zero val in outBuf.
    }
    return outBuf;
}

});


parcelRegister("hfAls", function(module, exports) {

$parcel$export(module.exports, "greaterImpl", function () { return $c8f007bfc46b72ef$export$bec57aa1d63b78bc; });
$parcel$export(module.exports, "greaterConfig", function () { return $c8f007bfc46b72ef$export$8c4f7e92d92310f8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $c8f007bfc46b72ef$export$bec57aa1d63b78bc = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a > b ? 1 : 0);
const $c8f007bfc46b72ef$export$9dca161faaf6308b = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Greater), $c8f007bfc46b72ef$export$bec57aa1d63b78bc, null, 'bool');
const $c8f007bfc46b72ef$export$8c4f7e92d92310f8 = {
    kernelName: (0, $9BGT9.Greater),
    backendName: 'cpu',
    kernelFunc: $c8f007bfc46b72ef$export$9dca161faaf6308b
};

});

parcelRegister("6LIWt", function(module, exports) {

$parcel$export(module.exports, "greaterEqualImpl", function () { return $4ed9fe6b0eebb2d8$export$3cea60aeb61ae586; });
$parcel$export(module.exports, "greaterEqualConfig", function () { return $4ed9fe6b0eebb2d8$export$7a6926f9fcac24ca; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $4ed9fe6b0eebb2d8$export$3cea60aeb61ae586 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a >= b ? 1 : 0);
const $4ed9fe6b0eebb2d8$export$c2fd4164cadc1fa2 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.GreaterEqual), $4ed9fe6b0eebb2d8$export$3cea60aeb61ae586, null, 'bool');
const $4ed9fe6b0eebb2d8$export$7a6926f9fcac24ca = {
    kernelName: (0, $9BGT9.GreaterEqual),
    backendName: 'cpu',
    kernelFunc: $4ed9fe6b0eebb2d8$export$c2fd4164cadc1fa2
};

});

parcelRegister("eKB3h", function(module, exports) {

$parcel$export(module.exports, "ifftConfig", function () { return $abd21a4bbc00c414$export$dc267425bf21b465; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $cx86A = parcelRequire("cx86A");

var $dOeSU = parcelRequire("dOeSU");
function $abd21a4bbc00c414$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputSize = (0, $lBDHD).sizeFromShape(input.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = input.shape[input.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $dOeSU.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const result = (0, $cx86A.fftBatch)(input2D, true, backend);
    const resultReshaped = (0, $dOeSU.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: input.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $abd21a4bbc00c414$export$dc267425bf21b465 = {
    kernelName: (0, $9BGT9.IFFT),
    backendName: 'cpu',
    kernelFunc: $abd21a4bbc00c414$export$776649b0bf8ce1fd
};

});

parcelRegister("gfQFw", function(module, exports) {

$parcel$export(module.exports, "isFiniteConfig", function () { return $bd56e6f21625fc08$export$4d45c8f7b9ffdaf1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $bd56e6f21625fc08$export$65f0b13f2f82375a = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.IsFinite), (xi)=>Number.isFinite(xi) ? 1 : 0, 'bool');
const $bd56e6f21625fc08$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $9BGT9.IsFinite),
    backendName: 'cpu',
    kernelFunc: $bd56e6f21625fc08$export$65f0b13f2f82375a
};

});

parcelRegister("3VapQ", function(module, exports) {

$parcel$export(module.exports, "isInfConfig", function () { return $2daec6554f7b1e9b$export$bc383b82282e9b5a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $2daec6554f7b1e9b$export$e5d3415c656f7096 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.IsInf), (xi)=>Math.abs(xi) === Infinity ? 1 : 0, 'bool');
const $2daec6554f7b1e9b$export$bc383b82282e9b5a = {
    kernelName: (0, $9BGT9.IsInf),
    backendName: 'cpu',
    kernelFunc: $2daec6554f7b1e9b$export$e5d3415c656f7096
};

});

parcelRegister("izkXE", function(module, exports) {

$parcel$export(module.exports, "isNaNConfig", function () { return $d84bc15049a33398$export$d58ff790c765c1f0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $d84bc15049a33398$export$c9f5652083b8129d = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.IsNan), (xi)=>Number.isNaN(xi) ? 1 : 0, 'bool');
const $d84bc15049a33398$export$d58ff790c765c1f0 = {
    kernelName: (0, $9BGT9.IsNan),
    backendName: 'cpu',
    kernelFunc: $d84bc15049a33398$export$c9f5652083b8129d
};

});

parcelRegister("1y3pA", function(module, exports) {

$parcel$export(module.exports, "lessImpl", function () { return $120b9ce6ef3ea41e$export$d4d22ddbe6cd91a5; });
$parcel$export(module.exports, "lessConfig", function () { return $120b9ce6ef3ea41e$export$8d4530ce8b6ffc3c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $120b9ce6ef3ea41e$export$d4d22ddbe6cd91a5 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a < b ? 1 : 0);
const $120b9ce6ef3ea41e$export$bb1a638da8ad190f = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Less), $120b9ce6ef3ea41e$export$d4d22ddbe6cd91a5, null, 'bool');
const $120b9ce6ef3ea41e$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $9BGT9.Less),
    backendName: 'cpu',
    kernelFunc: $120b9ce6ef3ea41e$export$bb1a638da8ad190f
};

});

parcelRegister("gkuUa", function(module, exports) {

$parcel$export(module.exports, "lessEqualImpl", function () { return $be367cafebde24d8$export$27397851733876fa; });
$parcel$export(module.exports, "lessEqualConfig", function () { return $be367cafebde24d8$export$9f26bd257393dd8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $be367cafebde24d8$export$27397851733876fa = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a <= b ? 1 : 0);
const $be367cafebde24d8$export$c24ad19a692bb92 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.LessEqual), $be367cafebde24d8$export$27397851733876fa, null, 'bool');
const $be367cafebde24d8$export$9f26bd257393dd8 = {
    kernelName: (0, $9BGT9.LessEqual),
    backendName: 'cpu',
    kernelFunc: $be367cafebde24d8$export$c24ad19a692bb92
};

});

parcelRegister("hAQg3", function(module, exports) {

$parcel$export(module.exports, "linSpaceConfig", function () { return $ccee55cfa9e3112b$export$46b96f742c70959b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $kwLEl = parcelRequire("kwLEl");
function $ccee55cfa9e3112b$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    const outVals = (0, $kwLEl.linSpaceImpl)(start, stop, num);
    return backend.makeTensorInfo([
        outVals.length
    ], 'float32', outVals);
}
const $ccee55cfa9e3112b$export$46b96f742c70959b = {
    kernelName: (0, $9BGT9.LinSpace),
    backendName: 'cpu',
    kernelFunc: $ccee55cfa9e3112b$export$865a19adce4d7a46
};

});
parcelRegister("kwLEl", function(module, exports) {

$parcel$export(module.exports, "linSpaceImpl", function () { return $ef1bc2071db44683$export$31412d657cd1cc08; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $ef1bc2071db44683$export$31412d657cd1cc08(start, stop, num) {
    const step = (stop - start) / (num - 1);
    const values = (0, $lBDHD).makeZerosTypedArray(num, 'float32');
    values[0] = start;
    for(let i = 1; i < values.length; i++)values[i] = values[i - 1] + step;
    return values;
}

});


parcelRegister("9J2ld", function(module, exports) {

$parcel$export(module.exports, "logImpl", function () { return $714a21f55b8220c6$export$8a107ec4d5b0e907; });
$parcel$export(module.exports, "logConfig", function () { return $714a21f55b8220c6$export$a4ae1f00643ddd14; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $714a21f55b8220c6$export$8a107ec4d5b0e907 = (0, $cfLEm.createSimpleUnaryImpl)((xi)=>Math.log(xi));
const $714a21f55b8220c6$export$bef1f36f5486a6a3 = (0, $6wQye.unaryKernelFuncFromImpl)((0, $9BGT9.Log), $714a21f55b8220c6$export$8a107ec4d5b0e907);
const $714a21f55b8220c6$export$a4ae1f00643ddd14 = {
    kernelName: (0, $9BGT9.Log),
    backendName: 'cpu',
    kernelFunc: $714a21f55b8220c6$export$bef1f36f5486a6a3
};

});

parcelRegister("48qZT", function(module, exports) {

$parcel$export(module.exports, "log1pConfig", function () { return $302cd9de2e1d44f8$export$c458b9e5ba980198; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $302cd9de2e1d44f8$export$144dcf16adfb9698 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Log1p), (xi)=>Math.log1p(xi));
const $302cd9de2e1d44f8$export$c458b9e5ba980198 = {
    kernelName: (0, $9BGT9.Log1p),
    backendName: 'cpu',
    kernelFunc: $302cd9de2e1d44f8$export$144dcf16adfb9698
};

});

parcelRegister("7CO38", function(module, exports) {

$parcel$export(module.exports, "logicalAndConfig", function () { return $58d2e7cc849e9724$export$257f1e82e69113fb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $58d2e7cc849e9724$export$e75adbe8a6aa8c40 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a && b);
const $58d2e7cc849e9724$export$db5dd0ef9d505f = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.LogicalAnd), $58d2e7cc849e9724$export$e75adbe8a6aa8c40, null, 'bool');
const $58d2e7cc849e9724$export$257f1e82e69113fb = {
    kernelName: (0, $9BGT9.LogicalAnd),
    backendName: 'cpu',
    kernelFunc: $58d2e7cc849e9724$export$db5dd0ef9d505f
};

});

parcelRegister("52sI9", function(module, exports) {

$parcel$export(module.exports, "logicalNotConfig", function () { return $3ab369104c623973$export$68e2dd0840056271; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $3ab369104c623973$export$c836ff7b605b1617 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.LogicalNot), (xi)=>xi ? 0 : 1, 'bool');
const $3ab369104c623973$export$68e2dd0840056271 = {
    kernelName: (0, $9BGT9.LogicalNot),
    backendName: 'cpu',
    kernelFunc: $3ab369104c623973$export$c836ff7b605b1617
};

});

parcelRegister("Vr6iN", function(module, exports) {

$parcel$export(module.exports, "logicalOrConfig", function () { return $0aca589c146255aa$export$ce04b6546987ef43; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $0aca589c146255aa$export$9b10f32fda33cd6f = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a || b);
const $0aca589c146255aa$export$e2a73975983cadd8 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.LogicalOr), $0aca589c146255aa$export$9b10f32fda33cd6f, null, 'bool');
const $0aca589c146255aa$export$ce04b6546987ef43 = {
    kernelName: (0, $9BGT9.LogicalOr),
    backendName: 'cpu',
    kernelFunc: $0aca589c146255aa$export$e2a73975983cadd8
};

});

parcelRegister("8o8Pp", function(module, exports) {

$parcel$export(module.exports, "LRNConfig", function () { return $61b769b7eec6f8d5$export$6fb124d5a6994734; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $61b769b7eec6f8d5$export$ac78e832c121c629(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'LRN');
    const channels = x.shape[3];
    const maxD = channels - 1;
    const xValues = backend.data.get(x.dataId).values;
    const size = (0, $lBDHD).sizeFromShape(x.shape);
    const result = new Float32Array(size);
    function sumAcrossChannels(offset) {
        const currentChannel = offset % channels;
        let beginSumOffset = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
        const endSumOffset = offset - currentChannel + Math.min(currentChannel + depthRadius, maxD);
        let sum = 0.0;
        for(; beginSumOffset <= endSumOffset; beginSumOffset++){
            const z = xValues[beginSumOffset];
            sum += z * z;
        }
        return sum;
    }
    for(let offset = 0; offset < size; offset++){
        const sum = sumAcrossChannels(offset);
        const val = xValues[offset] * Math.pow(bias + alpha * sum, -beta);
        result[offset] = val;
    }
    return backend.makeTensorInfo(x.shape, x.dtype, result);
}
const $61b769b7eec6f8d5$export$6fb124d5a6994734 = {
    kernelName: (0, $9BGT9.LRN),
    backendName: 'cpu',
    kernelFunc: $61b769b7eec6f8d5$export$ac78e832c121c629
};

});

parcelRegister("gZGW3", function(module, exports) {

$parcel$export(module.exports, "LRNGradConfig", function () { return $c5f3a5ea22e253cf$export$99a62fc039d7aca0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $c5f3a5ea22e253cf$export$c4c981cfebdcf90(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    (0, $wi69v.assertNotComplex)(dy, 'LRNGrad');
    const dySize = (0, $lBDHD).sizeFromShape(dy.shape);
    const channels = dy.shape[3];
    const dyValues = backend.data.get(dy.dataId).values;
    const xValues = backend.data.get(x.dataId).values;
    const yValues = backend.data.get(y.dataId).values;
    const result = new Float32Array(dySize);
    const size = dySize;
    for(let offset = 0; offset < size; offset++){
        const currentChannel = offset % channels;
        const depthBegin = offset - currentChannel + Math.max(0, currentChannel - depthRadius);
        const depthEnd = offset - currentChannel + Math.min(channels, currentChannel + depthRadius + 1);
        let norm = 0;
        for(let k = depthBegin; k < depthEnd; k++)norm += Math.pow(xValues[k], 2);
        norm = alpha * norm + bias;
        for(let k = depthBegin; k < depthEnd; k++){
            let dyi = -2 * alpha * beta * xValues[k] * yValues[offset] / norm;
            if (offset === k) dyi += Math.pow(norm, -beta);
            dyi *= dyValues[offset];
            result[k] += dyi;
        }
    }
    return backend.makeTensorInfo(dy.shape, x.dtype, result);
}
const $c5f3a5ea22e253cf$export$99a62fc039d7aca0 = {
    kernelName: (0, $9BGT9.LRNGrad),
    backendName: 'cpu',
    kernelFunc: $c5f3a5ea22e253cf$export$c4c981cfebdcf90
};

});

parcelRegister("c8z6c", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $8d6175534040dcf1$export$8960430cfd85939f; });
$parcel$export(module.exports, "maxConfig", function () { return $8d6175534040dcf1$export$7d79147246e312bb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $2uwJU = parcelRequire("2uwJU");

var $4gkPf = parcelRequire("4gkPf");
function $8d6175534040dcf1$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    const cpuBackend = backend;
    let xShape = x.shape;
    const xRank = xShape.length;
    const origAxes = (0, $lBDHD).parseAxisParam(reductionIndices, xShape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, xRank);
    let xVals = cpuBackend.data.get(x.dataId).values;
    if (permutedAxes != null) {
        const newShape = new Array(xRank);
        for(let i = 0; i < newShape.length; i++)newShape[i] = xShape[permutedAxes[i]];
        xVals = (0, $4gkPf.transposeImpl)(xVals, xShape, x.dtype, permutedAxes, newShape);
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, xRank);
        xShape = newShape;
    }
    (0, $wi69v.assertNotComplex)(x, 'max');
    (0, $dEVRx).assertAxesAreInnerMostDims('max', axes, xRank);
    const [maxOutShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(xShape, axes);
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const result = (0, $2uwJU.maxImpl)(xVals, reduceSize, maxOutShape, x.dtype);
    const dataId = cpuBackend.write(result, maxOutShape, x.dtype);
    let outShape = maxOutShape;
    if (keepDims) {
        // reshape
        const newShape = (0, $dEVRx).expandShapeToKeepDim(maxOutShape, origAxes);
        outShape = newShape;
    }
    return {
        dataId: dataId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $8d6175534040dcf1$export$7d79147246e312bb = {
    kernelName: (0, $9BGT9.Max),
    backendName: 'cpu',
    kernelFunc: $8d6175534040dcf1$export$8960430cfd85939f
};

});
parcelRegister("2uwJU", function(module, exports) {

$parcel$export(module.exports, "maxImpl", function () { return $1d07c781f88a32c7$export$23c9b99bdac85be0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $1d07c781f88a32c7$export$23c9b99bdac85be0(aVals, reduceSize, outShape, dtype) {
    const vals = (0, $lBDHD).getTypedArrayFromDType(dtype, (0, $lBDHD).sizeFromShape(outShape));
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let max = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (Number.isNaN(value) || value > max) max = value;
        }
        vals[i] = max;
    }
    return vals;
}

});


parcelRegister("cOTDj", function(module, exports) {

$parcel$export(module.exports, "maximumImpl", function () { return $95554f20899155c9$export$4e233ba825c9b60e; });
$parcel$export(module.exports, "maximumConfig", function () { return $95554f20899155c9$export$45b97bdc342e72a2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $95554f20899155c9$export$4e233ba825c9b60e = (0, $bhNFZ.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.max(aValue, bValue));
const $95554f20899155c9$export$b25e0be55f42c9a = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Maximum), $95554f20899155c9$export$4e233ba825c9b60e);
const $95554f20899155c9$export$45b97bdc342e72a2 = {
    kernelName: (0, $9BGT9.Maximum),
    backendName: 'cpu',
    kernelFunc: $95554f20899155c9$export$b25e0be55f42c9a
};

});

parcelRegister("WsKeW", function(module, exports) {

$parcel$export(module.exports, "maxPoolConfig", function () { return $0afbb703a82e82d1$export$45c8263b38f19e33; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $2YRGy = parcelRequire("2YRGy");

var $l9MqT = parcelRequire("l9MqT");
function $0afbb703a82e82d1$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $wi69v.assertNotComplex)(x, 'maxPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $lBDHD).assert((0, $dEVRx).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    let res;
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $lBDHD).arraysEqual(convInfo.inShape, convInfo.outShape)) res = (0, $l9MqT.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    else {
        const xValues = backend.data.get(x.dataId).values;
        const strides = (0, $lBDHD).computeStrides(x.shape);
        const buffer = (0, $2YRGy.pool)(xValues, x.shape, x.dtype, strides, convInfo, 'max');
        res = backend.makeTensorInfo(convInfo.outShape, x.dtype, buffer.values);
    }
    return res;
}
const $0afbb703a82e82d1$export$45c8263b38f19e33 = {
    kernelName: (0, $9BGT9.MaxPool),
    backendName: 'cpu',
    kernelFunc: $0afbb703a82e82d1$export$e4aadcf115842782
};

});

parcelRegister("CIxXQ", function(module, exports) {

$parcel$export(module.exports, "maxPool3DConfig", function () { return $07461acaf052a1d4$export$91a8fc5da39ec855; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $2YRGy = parcelRequire("2YRGy");
function $07461acaf052a1d4$export$bf5a4705068838e7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'maxPool3d');
    const convInfo = (0, $dEVRx).computePool3DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode, dataFormat);
    const xValues = backend.data.get(x.dataId).values;
    const outBuf = (0, $2YRGy.pool3d)(xValues, x.shape, x.dtype, (0, $lBDHD).computeStrides(x.shape), convInfo, 'max');
    return backend.makeTensorInfo(outBuf.shape, 'float32', outBuf.values);
}
const $07461acaf052a1d4$export$91a8fc5da39ec855 = {
    kernelName: (0, $9BGT9.MaxPool3D),
    backendName: 'cpu',
    kernelFunc: $07461acaf052a1d4$export$bf5a4705068838e7
};

});

parcelRegister("j04Jl", function(module, exports) {

$parcel$export(module.exports, "maxPool3DGradConfig", function () { return $dd51afc1dac13f31$export$5201426bb10bd5eb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $5siju = parcelRequire("5siju");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $2YRGy = parcelRequire("2YRGy");
function $dd51afc1dac13f31$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    (0, $wi69v.assertNotComplex)([
        dy,
        input
    ], 'maxPool3DGrad');
    const convInfo = (0, $dEVRx).computePool3DInfo(input.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const inputBuf = backend.bufferSync(input);
    const maxPosBuf = (0, $2YRGy.maxPool3dPositions)(inputBuf, convInfo);
    const strideDepth = convInfo.strideDepth;
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationDepth = convInfo.dilationDepth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterDepth = convInfo.effectiveFilterDepth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $5siju.buffer)(input.shape, 'float32');
    const dyBuf = backend.bufferSync(dy);
    for(let batch = 0; batch < convInfo.batchSize; ++batch){
        for(let channel = 0; channel < convInfo.inChannels; ++channel)for(let dxDepth = 0; dxDepth < convInfo.inDepth; ++dxDepth){
            for(let dxRow = 0; dxRow < convInfo.inHeight; ++dxRow)for(let dxCol = 0; dxCol < convInfo.inWidth; ++dxCol){
                // Shader code begins
                const dyDepthCorner = dxDepth - padFront;
                const dyRowCorner = dxRow - padTop;
                const dyColCorner = dxCol - padLeft;
                let dotProd = 0;
                for(let wDepth = 0; wDepth < effectiveFilterDepth; wDepth += dilationDepth){
                    const dyDepth = (dyDepthCorner + wDepth) / strideDepth;
                    if (dyDepth < 0 || dyDepth >= convInfo.outDepth || Math.floor(dyDepth) !== dyDepth) continue;
                    for(let wRow = 0; wRow < effectiveFilterHeight; wRow += dilationHeight){
                        const dyRow = (dyRowCorner + wRow) / strideHeight;
                        if (dyRow < 0 || dyRow >= convInfo.outHeight || Math.floor(dyRow) !== dyRow) continue;
                        for(let wCol = 0; wCol < effectiveFilterWidth; wCol += dilationWidth){
                            const dyCol = (dyColCorner + wCol) / strideWidth;
                            if (dyCol < 0 || dyCol >= convInfo.outWidth || Math.floor(dyCol) !== dyCol) continue;
                            const maxPos = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1 - maxPosBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            const curPos = wDepth * effectiveFilterHeight * effectiveFilterWidth + wRow * effectiveFilterWidth + wCol;
                            const mask = maxPos === curPos ? 1 : 0;
                            if (mask === 0) continue;
                            const pixel = dyBuf.get(batch, dyDepth, dyRow, dyCol, channel);
                            dotProd += pixel * mask;
                        }
                    }
                }
                dx.set(dotProd, batch, dxDepth, dxRow, dxCol, channel);
            }
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $dd51afc1dac13f31$export$5201426bb10bd5eb = {
    kernelName: (0, $9BGT9.MaxPool3DGrad),
    backendName: 'cpu',
    kernelFunc: $dd51afc1dac13f31$export$e68b9bef571dd4ea
};

});

parcelRegister("klRsm", function(module, exports) {

$parcel$export(module.exports, "maxPoolGradConfig", function () { return $ed0f3c2086c7095f$export$e01a7f8dbee29127; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $5siju = parcelRequire("5siju");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $2YRGy = parcelRequire("2YRGy");
function $ed0f3c2086c7095f$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $wi69v.assertNotComplex)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const xValues = backend.data.get(x.dataId).values;
    const maxPosBuf = (0, $5siju.buffer)(convInfo.outShape, x.dtype, (0, $2YRGy.maxPoolPositions)(xValues, x.shape, x.dtype, convInfo).values);
    const strideHeight = convInfo.strideHeight;
    const strideWidth = convInfo.strideWidth;
    const dilationHeight = convInfo.dilationHeight;
    const dilationWidth = convInfo.dilationWidth;
    const effectiveFilterHeight = convInfo.effectiveFilterHeight;
    const effectiveFilterWidth = convInfo.effectiveFilterWidth;
    const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
    const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
    const dx = (0, $5siju.buffer)(x.shape, 'float32');
    const dyData = backend.data.get(dy.dataId).values;
    const dyBuf = (0, $5siju.buffer)(dy.shape, 'float32', dyData);
    for(let b = 0; b < convInfo.batchSize; ++b)for(let d = 0; d < convInfo.inChannels; ++d){
        for(let dxR = 0; dxR < convInfo.inHeight; ++dxR)for(let dxC = 0; dxC < convInfo.inWidth; ++dxC){
            // Shader code begins.
            const dyRCorner = dxR - padTop;
            const dyCCorner = dxC - padLeft;
            let dotProd = 0;
            for(let wR = 0; wR < effectiveFilterHeight; wR += dilationHeight){
                const dyR = (dyRCorner + wR) / strideHeight;
                if (dyR < 0 || dyR >= convInfo.outHeight || Math.floor(dyR) !== dyR) continue;
                for(let wC = 0; wC < effectiveFilterWidth; wC += dilationWidth){
                    const dyC = (dyCCorner + wC) / strideWidth;
                    if (dyC < 0 || dyC >= convInfo.outWidth || Math.floor(dyC) !== dyC) continue;
                    const maxPos = effectiveFilterHeight * effectiveFilterWidth - 1 - maxPosBuf.get(b, dyR, dyC, d);
                    const curPos = wR * effectiveFilterWidth + wC;
                    const mask = maxPos === curPos ? 1 : 0;
                    if (mask === 0) continue;
                    const pixel = dyBuf.get(b, dyR, dyC, d);
                    dotProd += pixel * mask;
                }
            }
            dx.set(dotProd, b, dxR, dxC, d);
        }
    }
    return backend.makeTensorInfo(dx.shape, dx.dtype, dx.values);
}
const $ed0f3c2086c7095f$export$e01a7f8dbee29127 = {
    kernelName: (0, $9BGT9.MaxPoolGrad),
    backendName: 'cpu',
    kernelFunc: $ed0f3c2086c7095f$export$85dfd1121f049514
};

});

parcelRegister("NOBt0", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxConfig", function () { return $095bd47ad68efe69$export$a069ee2247a7d1ce; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $gcm1G = parcelRequire("gcm1G");
const $095bd47ad68efe69$export$a069ee2247a7d1ce = {
    kernelName: (0, $9BGT9.MaxPoolWithArgmax),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
        const cpuBackend = backend;
        (0, $wi69v.assertNotComplex)(x, 'MaxPoolWithArgmax');
        const values = cpuBackend.data.get(x.dataId).values;
        const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, [
            1,
            1
        ], pad);
        const [pooled, indexes] = (0, $gcm1G.maxPoolWithArgmaxImpl)(values, x.shape, x.dtype, includeBatchInIndex, convInfo);
        const pooledDataId = cpuBackend.write(pooled, convInfo.outShape, x.dtype);
        const indexesDataId = cpuBackend.write(indexes, convInfo.outShape, x.dtype);
        return [
            {
                dataId: pooledDataId,
                shape: convInfo.outShape,
                dtype: x.dtype
            },
            {
                dataId: indexesDataId,
                shape: convInfo.outShape,
                dtype: 'int32'
            }
        ];
    }
};

});
parcelRegister("gcm1G", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxImpl", function () { return $bcaeda48bd05f16d$export$3cc34964a47e7a3f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $2YRGy = parcelRequire("2YRGy");
function $bcaeda48bd05f16d$export$3cc34964a47e7a3f(xValues, xShape, dtype, includeBatchInIndex, convInfo) {
    const strides = (0, $lBDHD).computeStrides(xShape);
    const maxPools = (0, $2YRGy.pool)(xValues, xShape, dtype, strides, convInfo, 'max');
    const maxPositions = (0, $2YRGy.maxPoolPositions)(xValues, xShape, dtype, convInfo, true, includeBatchInIndex);
    return [
        maxPools.values,
        maxPositions.values
    ];
}

});


parcelRegister("2KTmU", function(module, exports) {

$parcel$export(module.exports, "meanConfig", function () { return $201ad3a79572f061$export$b934af0ccd0cdbe1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $9IBUg = parcelRequire("9IBUg");

var $avBJE = parcelRequire("avBJE");

var $5Mi8L = parcelRequire("5Mi8L");
function $201ad3a79572f061$export$1ce691f85baaa52(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const axes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    const shapes = (0, $dEVRx).computeOutAndReduceShapes(x.shape, axes);
    const reduceShape = shapes[1];
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const toDispose = [];
    const reduceSizeScalar = backend.makeTensorInfo([], 'float32', new Float32Array([
        reduceSize
    ]));
    toDispose.push(reduceSizeScalar);
    const $x = (0, $9IBUg.cast)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            dtype: 'float32'
        }
    });
    toDispose.push($x);
    const res = (0, $avBJE.div)({
        inputs: {
            a: $x,
            b: reduceSizeScalar
        },
        backend: backend
    });
    toDispose.push(res);
    const result = (0, $5Mi8L.sum)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            axis: axis,
            keepDims: keepDims
        }
    });
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $201ad3a79572f061$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $9BGT9.Mean),
    backendName: 'cpu',
    kernelFunc: $201ad3a79572f061$export$1ce691f85baaa52
};

});

parcelRegister("e8YXS", function(module, exports) {

$parcel$export(module.exports, "minConfig", function () { return $a4c11a6311e1dee0$export$3cd9f9a31b38cf18; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $dOeSU = parcelRequire("dOeSU");

var $joI4E = parcelRequire("joI4E");
function $a4c11a6311e1dee0$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'min');
    const origAxes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    if (permutedAxes != null) {
        $x = (0, $joI4E.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('min', axes, $x.shape.length);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes($x.shape, axes);
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const vals = (0, $lBDHD).makeZerosTypedArray((0, $lBDHD).sizeFromShape(outShape), $x.dtype);
    const aVals = backend.data.get($x.dataId).values;
    for(let i = 0; i < vals.length; ++i){
        const offset = i * reduceSize;
        let min = aVals[offset];
        for(let j = 0; j < reduceSize; ++j){
            const value = aVals[offset + j];
            if (Number.isNaN(value) || value < min) min = value;
        }
        vals[i] = min;
    }
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo($x);
    const result = backend.makeTensorInfo(outShape, $x.dtype, vals);
    if (keepDims) {
        const expandedShape = (0, $dEVRx).expandShapeToKeepDim(outShape, origAxes);
        const reshapedResult = (0, $dOeSU.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: expandedShape
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        return reshapedResult;
    }
    return result;
}
const $a4c11a6311e1dee0$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $9BGT9.Min),
    backendName: 'cpu',
    kernelFunc: $a4c11a6311e1dee0$export$96ec731ed4dcb222
};

});

parcelRegister("gbhaU", function(module, exports) {

$parcel$export(module.exports, "minimumImpl", function () { return $bc7aff06ea4c9527$export$756c08a3fa64d43; });
$parcel$export(module.exports, "minimumConfig", function () { return $bc7aff06ea4c9527$export$ea24ffbbbce8d546; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $bc7aff06ea4c9527$export$756c08a3fa64d43 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((aValue, bValue)=>Math.min(aValue, bValue));
const $bc7aff06ea4c9527$export$916782c1f0ddb132 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Minimum), $bc7aff06ea4c9527$export$756c08a3fa64d43);
const $bc7aff06ea4c9527$export$ea24ffbbbce8d546 = {
    kernelName: (0, $9BGT9.Minimum),
    backendName: 'cpu',
    kernelFunc: $bc7aff06ea4c9527$export$916782c1f0ddb132
};

});

parcelRegister("lM61A", function(module, exports) {

$parcel$export(module.exports, "mirrorPadConfig", function () { return $fda2c10bab3c5f02$export$2cfd6c6c7daeb5fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $fda2c10bab3c5f02$export$c0b11600e90b86ae(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, mode: mode } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'mirrorPad');
    const outShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
    const start = paddings.map((p)=>p[0]);
    const end = paddings.map((p, i)=>p[0] + x.shape[i]);
    const offset = mode === 'reflect' ? 0 : 1;
    const xVals = backend.data.get(x.dataId).values;
    const xRank = x.shape.length;
    const xStrides = (0, $lBDHD).computeStrides(x.shape);
    const resultSize = (0, $lBDHD).sizeFromShape(outShape);
    const resultRank = outShape.length;
    const resultStrides = (0, $lBDHD).computeStrides(outShape);
    const resVals = (0, $lBDHD).getTypedArrayFromDType(x.dtype, resultSize);
    for(let i = 0; i < resultSize; i++){
        let coords = (0, $lBDHD).indexToLoc(i, resultRank, resultStrides);
        for(let i = 0; i < resultRank; i++){
            if (coords[i] < start[i]) coords[i] = start[i] * 2 - coords[i] - offset;
            else if (coords[i] >= end[i]) coords[i] = (end[i] - 1) * 2 - coords[i] + offset;
        }
        coords = coords.map((c, i)=>c - start[i]);
        const inIndex = (0, $lBDHD).locToIndex(coords, xRank, xStrides);
        resVals[i] = xVals[inIndex];
    }
    const outId = backend.write(resVals, outShape, x.dtype);
    return {
        dataId: outId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $fda2c10bab3c5f02$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $9BGT9.MirrorPad),
    backendName: 'cpu',
    kernelFunc: $fda2c10bab3c5f02$export$c0b11600e90b86ae
};

});

parcelRegister("91k7s", function(module, exports) {

$parcel$export(module.exports, "modConfig", function () { return $6913d04d1ee55414$export$9037685a81180a9c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $6913d04d1ee55414$export$fc31b6ef8ca4db11 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((aValue, bValue)=>{
    const rem = aValue % bValue;
    if (aValue < 0 && bValue < 0 || aValue >= 0 && bValue >= 0) return rem;
    else return (rem + bValue) % bValue;
});
const $6913d04d1ee55414$export$842a2cf37af977e1 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Mod), $6913d04d1ee55414$export$fc31b6ef8ca4db11);
const $6913d04d1ee55414$export$9037685a81180a9c = {
    kernelName: (0, $9BGT9.Mod),
    backendName: 'cpu',
    kernelFunc: $6913d04d1ee55414$export$842a2cf37af977e1
};

});

parcelRegister("bSeCN", function(module, exports) {

$parcel$export(module.exports, "multinomialConfig", function () { return $8a50150bc6bf1fc4$export$ad960e364767f0e2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $23NWZ = parcelRequire("23NWZ");

var $wi69v = parcelRequire("wi69v");

var $bNWZZ = parcelRequire("bNWZZ");
function $8a50150bc6bf1fc4$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    (0, $wi69v.assertNotComplex)(logits, 'multinomial');
    const probabilities = normalized ? logits : (0, $bNWZZ.softmax)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: -1
        }
    });
    const batchSize = probabilities.shape[0];
    const numEvents = probabilities.shape[1];
    const probVals = backend.data.get(probabilities.dataId).values;
    const resShape = [
        batchSize,
        numSamples
    ];
    const resVals = (0, $lBDHD).makeZerosTypedArray((0, $lBDHD).sizeFromShape(resShape), 'int32');
    for(let b = 0; b < batchSize; ++b){
        const offset = b * numEvents;
        // The cdf won't include the last event. It will be implicit if no other
        // event happened.
        const cdf = new Float32Array(numEvents - 1);
        cdf[0] = probVals[offset];
        for(let event = 1; event < cdf.length; ++event)cdf[event] = cdf[event - 1] + probVals[offset + event];
        const random = $23NWZ.alea(seed.toString());
        const outOffset = b * numSamples;
        for(let sampleId = 0; sampleId < numSamples; ++sampleId){
            const r = random();
            // Assume last event happened by default.
            resVals[outOffset + sampleId] = cdf.length;
            for(let event = 0; event < cdf.length; event++)if (r < cdf[event]) {
                resVals[outOffset + sampleId] = event;
                break;
            }
        }
    }
    if (!normalized) backend.disposeIntermediateTensorInfo(probabilities);
    return backend.makeTensorInfo(resShape, 'int32', resVals);
}
const $8a50150bc6bf1fc4$export$ad960e364767f0e2 = {
    kernelName: (0, $9BGT9.Multinomial),
    backendName: 'cpu',
    kernelFunc: $8a50150bc6bf1fc4$export$f4d580f3101a1c7e
};

});
parcelRegister("bNWZZ", function(module, exports) {

$parcel$export(module.exports, "softmax", function () { return $8982093cbaa85bef$export$e008137e76238601; });
$parcel$export(module.exports, "softmaxConfig", function () { return $8982093cbaa85bef$export$c022691f23e2ee69; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $a6Y9A = parcelRequire("a6Y9A");

var $c8z6c = parcelRequire("c8z6c");

var $avBJE = parcelRequire("avBJE");

var $dOeSU = parcelRequire("dOeSU");

var $2rbI5 = parcelRequire("2rbI5");

var $5Mi8L = parcelRequire("5Mi8L");
function $8982093cbaa85bef$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const logitsRank = logits.shape.length;
    let $dim = dim;
    if ($dim === -1) $dim = logitsRank - 1;
    if ($dim !== logitsRank - 1) throw Error('Softmax along a non-last dimension is not yet supported. ' + `Logits was rank ${logitsRank} and dim was ${$dim}`);
    const axes = (0, $lBDHD).parseAxisParam([
        $dim
    ], logits.shape);
    const maxLogit = (0, $c8z6c.max)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            reductionIndices: axes,
            keepDims: false
        }
    });
    const expandedShape = (0, $dEVRx).expandShapeToKeepDim(maxLogit.shape, axes);
    const maxLogitReshaped = (0, $dOeSU.reshape)({
        inputs: {
            x: maxLogit
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const a = (0, $2rbI5.sub)({
        inputs: {
            a: logits,
            b: maxLogitReshaped
        },
        backend: backend
    });
    const b = (0, $a6Y9A.exp)({
        inputs: {
            x: a
        },
        backend: backend
    });
    const sumExp = (0, $5Mi8L.sum)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            axis: axes,
            keepDims: false
        }
    });
    const sumReshaped = (0, $dOeSU.reshape)({
        inputs: {
            x: sumExp
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const result = (0, $avBJE.div)({
        inputs: {
            a: b,
            b: sumReshaped
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(maxLogit);
    backend.disposeIntermediateTensorInfo(maxLogitReshaped);
    backend.disposeIntermediateTensorInfo(a);
    backend.disposeIntermediateTensorInfo(b);
    backend.disposeIntermediateTensorInfo(sumExp);
    backend.disposeIntermediateTensorInfo(sumReshaped);
    return result;
}
const $8982093cbaa85bef$export$c022691f23e2ee69 = {
    kernelName: (0, $9BGT9.Softmax),
    backendName: 'cpu',
    kernelFunc: $8982093cbaa85bef$export$e008137e76238601
};

});


parcelRegister("3iNqQ", function(module, exports) {

$parcel$export(module.exports, "negImpl", function () { return $267965ae9e626e76$export$e9053236ce0e659b; });
$parcel$export(module.exports, "negConfig", function () { return $267965ae9e626e76$export$cc7b18b8229c3db; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $bMajv = parcelRequire("bMajv");
function $267965ae9e626e76$export$e9053236ce0e659b(xVals, xShape, xDtype) {
    const minusOne = (0, $lBDHD).createScalarValue(-1, xDtype);
    return (0, $bMajv.multiplyImpl)([], xShape, minusOne, xVals, xDtype);
}
function $267965ae9e626e76$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    (0, $wi69v.assertNotComplex)(x, 'neg');
    const xVals = backend.data.get(x.dataId).values;
    const [res, newShape] = $267965ae9e626e76$export$e9053236ce0e659b(xVals, x.shape, x.dtype);
    return backend.makeTensorInfo(newShape, x.dtype, res);
}
const $267965ae9e626e76$export$cc7b18b8229c3db = {
    kernelName: (0, $9BGT9.Neg),
    backendName: 'cpu',
    kernelFunc: $267965ae9e626e76$export$d9493ff0dfa0fdd5
};

});

parcelRegister("arrrA", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Config", function () { return $79a1b6d158c0ee7d$export$549561cd158f260a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $iEnT2 = parcelRequire("iEnT2");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");
const $79a1b6d158c0ee7d$var$nonMaxSuppressionV3Impl = (0, $iEnT2).nonMaxSuppressionV3Impl;
function $79a1b6d158c0ee7d$export$8917e4bf7f7f5d42(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    (0, $wi69v.assertNotComplex)(boxes, 'NonMaxSuppression');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const { selectedIndices: selectedIndices } = $79a1b6d158c0ee7d$var$nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $79a1b6d158c0ee7d$export$549561cd158f260a = {
    kernelName: (0, $9BGT9.NonMaxSuppressionV3),
    backendName: 'cpu',
    kernelFunc: $79a1b6d158c0ee7d$export$8917e4bf7f7f5d42
};

});

parcelRegister("k3PkG", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV4Config", function () { return $e9abe808090e6b78$export$906b8fb32c570e9d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $iEnT2 = parcelRequire("iEnT2");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");
const $e9abe808090e6b78$var$nonMaxSuppressionV4Impl = (0, $iEnT2).nonMaxSuppressionV4Impl;
function $e9abe808090e6b78$export$ad519bdebe8f4dcf(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, padToMaxOutputSize: padToMaxOutputSize } = attrs;
    (0, $wi69v.assertNotComplex)(boxes, 'NonMaxSuppressionPadded');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = $e9abe808090e6b78$var$nonMaxSuppressionV4Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([], 'int32', new Int32Array([
            validOutputs
        ]))
    ];
}
const $e9abe808090e6b78$export$906b8fb32c570e9d = {
    kernelName: (0, $9BGT9.NonMaxSuppressionV4),
    backendName: 'cpu',
    kernelFunc: $e9abe808090e6b78$export$ad519bdebe8f4dcf
};

});

parcelRegister("hWyXZ", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV5Config", function () { return $d102fa0eb53f5377$export$4c00b682f309701d; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $iEnT2 = parcelRequire("iEnT2");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");
const $d102fa0eb53f5377$var$nonMaxSuppressionV5Impl = (0, $iEnT2).nonMaxSuppressionV5Impl;
function $d102fa0eb53f5377$export$49e389fdbe01a534(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    (0, $wi69v.assertNotComplex)(boxes, 'NonMaxSuppressionWithScore');
    const boxesVals = backend.data.get(boxes.dataId).values;
    const scoresVals = backend.data.get(scores.dataId).values;
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = $d102fa0eb53f5377$var$nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $d102fa0eb53f5377$export$4c00b682f309701d = {
    kernelName: (0, $9BGT9.NonMaxSuppressionV5),
    backendName: 'cpu',
    kernelFunc: $d102fa0eb53f5377$export$49e389fdbe01a534
};

});

parcelRegister("dSDQI", function(module, exports) {

$parcel$export(module.exports, "notEqualImpl", function () { return $a1af3ac2afa287b1$export$eaea354630818ed4; });
$parcel$export(module.exports, "notEqualConfig", function () { return $a1af3ac2afa287b1$export$d003d4d7e1500775; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $a1af3ac2afa287b1$export$eaea354630818ed4 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>a !== b ? 1 : 0);
const $a1af3ac2afa287b1$export$53a6892c50694894 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.NotEqual), $a1af3ac2afa287b1$export$eaea354630818ed4, null, 'bool');
const $a1af3ac2afa287b1$export$d003d4d7e1500775 = {
    kernelName: (0, $9BGT9.NotEqual),
    backendName: 'cpu',
    kernelFunc: $a1af3ac2afa287b1$export$53a6892c50694894
};

});

parcelRegister("dsgJ3", function(module, exports) {

$parcel$export(module.exports, "oneHotConfig", function () { return $9cbadd40415714b9$export$dde5645b472b80b2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $9cbadd40415714b9$export$341b5490a776d041(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    (0, $wi69v.assertNotComplex)(indices, 'oneHot');
    const indicesSize = (0, $lBDHD).sizeFromShape(indices.shape);
    const res = new Float32Array(indicesSize * depth);
    res.fill(offValue);
    const indicesVal = backend.data.get(indices.dataId).values;
    for(let event = 0; event < indicesSize; ++event)if (indicesVal[event] >= 0 && indicesVal[event] < depth) res[event * depth + indicesVal[event]] = onValue;
    return backend.makeTensorInfo([
        ...indices.shape,
        depth
    ], dtype, res);
}
const $9cbadd40415714b9$export$dde5645b472b80b2 = {
    kernelName: (0, $9BGT9.OneHot),
    backendName: 'cpu',
    kernelFunc: $9cbadd40415714b9$export$341b5490a776d041
};

});

parcelRegister("cXYW9", function(module, exports) {

$parcel$export(module.exports, "onesLikeConfig", function () { return $970a438b17d14c65$export$d8d7015eb6ab37d0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $hmrWF = parcelRequire("hmrWF");

var $2EKqh = parcelRequire("2EKqh");

var $acwXZ = parcelRequire("acwXZ");

var $fWJq3 = parcelRequire("fWJq3");

var $jvRne = parcelRequire("jvRne");
function $970a438b17d14c65$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported for string tensors');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $fWJq3.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $970a438b17d14c65$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $acwXZ.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $jvRne.zerosLike)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $hmrWF.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $2EKqh.fill)({
        backend: backend,
        attrs: {
            shape: x.shape,
            value: 1,
            dtype: x.dtype
        }
    });
}
const $970a438b17d14c65$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $9BGT9.OnesLike),
    backendName: 'cpu',
    kernelFunc: $970a438b17d14c65$export$fb6afd6214fee9e9
};

});
parcelRegister("jvRne", function(module, exports) {

$parcel$export(module.exports, "zerosLike", function () { return $e34a507a10e921b4$export$cb1f824e7733584d; });
$parcel$export(module.exports, "zerosLikeConfig", function () { return $e34a507a10e921b4$export$15368df05c479e41; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $hmrWF = parcelRequire("hmrWF");

var $2EKqh = parcelRequire("2EKqh");

var $acwXZ = parcelRequire("acwXZ");

var $fWJq3 = parcelRequire("fWJq3");
function $e34a507a10e921b4$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('zerosLike is not supported for string tensors');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $fWJq3.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $e34a507a10e921b4$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $acwXZ.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $e34a507a10e921b4$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $hmrWF.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $2EKqh.fill)({
        backend: backend,
        attrs: {
            shape: x.shape,
            value: 0,
            dtype: x.dtype
        }
    });
}
const $e34a507a10e921b4$export$15368df05c479e41 = {
    kernelName: (0, $9BGT9.ZerosLike),
    backendName: 'cpu',
    kernelFunc: $e34a507a10e921b4$export$cb1f824e7733584d
};

});


parcelRegister("83uCx", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $5dd65b2b25222131$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "packConfig", function () { return $5dd65b2b25222131$export$1645fa8803aa1f86; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $aEIJt = parcelRequire("aEIJt");

var $j72XB = parcelRequire("j72XB");
function $5dd65b2b25222131$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $j72XB.expandDims)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $lBDHD).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $lBDHD).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $j72XB.expandDims)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $aEIJt.concat)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $5dd65b2b25222131$export$1645fa8803aa1f86 = {
    kernelName: (0, $9BGT9.Pack),
    backendName: 'cpu',
    kernelFunc: $5dd65b2b25222131$export$2a703dbb0cb35339
};

});

parcelRegister("4gZLs", function(module, exports) {

$parcel$export(module.exports, "padV2Config", function () { return $31c89132a77f6a2b$export$b0317e720bfd61fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $31c89132a77f6a2b$export$f676d6ad4f38bb89(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'pad');
    const outShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
    const start = paddings.map((p)=>p[0]);
    const xVals = backend.data.get(x.dataId).values;
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const xRank = x.shape.length;
    const xStrides = (0, $lBDHD).computeStrides(x.shape);
    const resultSize = (0, $lBDHD).sizeFromShape(outShape);
    const resultRank = outShape.length;
    const resultStrides = (0, $lBDHD).computeStrides(outShape);
    const resVals = (0, $lBDHD).getTypedArrayFromDType(x.dtype, resultSize);
    if (constantValue !== 0) resVals.fill(constantValue);
    for(let i = 0; i < xSize; i++){
        const coords = (0, $lBDHD).indexToLoc(i, xRank, xStrides);
        const outCoords = coords.map((c, i)=>c + start[i]);
        const outIndex = (0, $lBDHD).locToIndex(outCoords, resultRank, resultStrides);
        resVals[outIndex] = xVals[i];
    }
    const outId = backend.write(resVals, outShape, x.dtype);
    return {
        dataId: outId,
        shape: outShape,
        dtype: x.dtype
    };
}
const $31c89132a77f6a2b$export$b0317e720bfd61fc = {
    kernelName: (0, $9BGT9.PadV2),
    backendName: 'cpu',
    kernelFunc: $31c89132a77f6a2b$export$f676d6ad4f38bb89
};

});

parcelRegister("dof0H", function(module, exports) {

$parcel$export(module.exports, "powConfig", function () { return $9bf928f963349cea$export$b823d49786719761; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $9bf928f963349cea$export$92051c71bb41bd8a = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>Math.pow(a, b));
const $9bf928f963349cea$export$9c297f60e22e3389 = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.Pow), $9bf928f963349cea$export$92051c71bb41bd8a);
const $9bf928f963349cea$export$b823d49786719761 = {
    kernelName: (0, $9BGT9.Pow),
    backendName: 'cpu',
    kernelFunc: $9bf928f963349cea$export$9c297f60e22e3389
};

});

parcelRegister("knCR9", function(module, exports) {

$parcel$export(module.exports, "prodImpl", function () { return $ed6418a8a1af66cf$export$a3c8a5271f6bb700; });
$parcel$export(module.exports, "prodConfig", function () { return $ed6418a8a1af66cf$export$d556aa935cef5c0c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $kKv2E = parcelRequire("kKv2E");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $joI4E = parcelRequire("joI4E");
function $ed6418a8a1af66cf$export$a3c8a5271f6bb700(xShape, xDtype, xVals, reductionAxes) {
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(xShape, reductionAxes);
    const outDtype = (0, $kKv2E.upcastType)(xDtype, 'int32');
    const outVals = (0, $lBDHD).makeZerosTypedArray((0, $lBDHD).sizeFromShape(outShape), outDtype);
    const reduceSize = (0, $lBDHD).sizeFromShape(reduceShape);
    for(let i = 0; i < outVals.length; ++i){
        const offset = i * reduceSize;
        let prod = 1;
        for(let j = 0; j < reduceSize; ++j)prod *= xVals[offset + j];
        outVals[i] = prod;
    }
    return {
        outVals: outVals,
        outShape: outShape,
        outDtype: outDtype
    };
}
function $ed6418a8a1af66cf$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'prod');
    const xRank = x.shape.length;
    const axes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    const permutation = (0, $dEVRx).getAxesPermutation(axes, xRank);
    let reductionAxes = axes;
    let permutedX = x;
    const intermediateTensorInfos = [];
    if (permutation != null) {
        permutedX = (0, $joI4E.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        intermediateTensorInfos.push(permutedX);
        reductionAxes = (0, $dEVRx).getInnerMostAxes(reductionAxes.length, xRank);
    }
    const xVals = backend.data.get(permutedX.dataId).values;
    const { outVals: outVals, outShape: outShape, outDtype: outDtype } = $ed6418a8a1af66cf$export$a3c8a5271f6bb700(permutedX.shape, permutedX.dtype, xVals, reductionAxes);
    let resultShape = outShape;
    if (keepDims) resultShape = (0, $dEVRx).expandShapeToKeepDim(outShape, axes);
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return backend.makeTensorInfo(resultShape, outDtype, outVals);
}
const $ed6418a8a1af66cf$export$d556aa935cef5c0c = {
    kernelName: (0, $9BGT9.Prod),
    backendName: 'cpu',
    kernelFunc: $ed6418a8a1af66cf$export$5e143010dea16c85
};

});

parcelRegister("5T1ar", function(module, exports) {

$parcel$export(module.exports, "raggedGatherConfig", function () { return $4492fea0082c8036$export$cebb8a7d5932c7e8; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $4cNdG = parcelRequire("4cNdG");
function $4492fea0082c8036$export$e7118f605df251dd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { paramsNestedSplits: paramsNestedSplits, paramsDenseValues: paramsDenseValues, indices: indices } = inputs;
    const { outputRaggedRank: outputRaggedRank } = attrs;
    const $paramsNestedSplits = paramsNestedSplits.map((t)=>backend.data.get(t.dataId).values);
    const $paramsNestedSplitsShapes = paramsNestedSplits.map((t)=>t.shape);
    const $paramsDenseValues = backend.data.get(paramsDenseValues.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const [outputNestedSplits, outputDenseValues, outputDenseValuesShape] = (0, $4cNdG.raggedGatherImpl)($paramsNestedSplits, $paramsNestedSplitsShapes, $paramsDenseValues, paramsDenseValues.shape, paramsDenseValues.dtype, $indices, indices.shape, outputRaggedRank);
    const outputNestedSplitsTensors = outputNestedSplits.map((splits)=>backend.makeTensorInfo([
            splits.length
        ], 'int32', splits));
    const outputDenseValuesTensor = backend.makeTensorInfo(outputDenseValuesShape, paramsDenseValues.dtype, outputDenseValues);
    return outputNestedSplitsTensors.concat([
        outputDenseValuesTensor
    ]);
}
const $4492fea0082c8036$export$cebb8a7d5932c7e8 = {
    kernelName: (0, $9BGT9.RaggedGather),
    backendName: 'cpu',
    kernelFunc: $4492fea0082c8036$export$e7118f605df251dd
};

});
parcelRegister("4cNdG", function(module, exports) {

$parcel$export(module.exports, "raggedGatherImpl", function () { return $30fe766c57ed2e65$export$4104e3de41455909; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $30fe766c57ed2e65$var$validateIndices(indices, indicesShape, numParams) {
    indices.forEach((index, i)=>{
        if (index < 0 || index >= numParams) {
            const locString = (0, $lBDHD).indexToLoc(i, indicesShape.length, (0, $lBDHD).computeStrides(indicesShape)).join(',');
            throw new Error(`indices[${locString}] = ${index} is not in [0, ${numParams})`);
        }
    });
}
function $30fe766c57ed2e65$var$validateSplits(paramsNestedSplits, numParamsDenseValues) {
    // Validate
    for(let dim = 0; dim < paramsNestedSplits.length; ++dim){
        const splits = paramsNestedSplits[dim];
        const lastSplit = dim === paramsNestedSplits.length - 1 ? numParamsDenseValues : paramsNestedSplits[dim + 1].length;
        if (splits.length === 0) throw new Error('Ragged splits may not be empty');
        if (splits[0] < 0) throw new Error('Ragged splits must be non-negative');
        if (splits[splits.length - 1] > lastSplit) throw new Error('Ragged splits must not point past values');
        for(let i = 1; i < splits.length; ++i){
            if (splits[i - 1] > splits[i]) throw new Error('Ragged splits must be sorted in ascending order');
        }
    }
}
// Construct the `splits` output tensors, encoded using a nested vector.
// Also find the slices of values that need to be copied, and store them
// in `valueSlices`.  The total number of values that will be copied (which
// we need for allocating the output values tensor) is stored in `numValues`.
function $30fe766c57ed2e65$var$makeSplits(indices, indicesShape, paramsNestedSplits, numParamsDenseValues) {
    const valueSlices = [];
    let numValues = 0;
    const numSplits = indicesShape.length - 1 + paramsNestedSplits.length;
    const outSplits = new Array(numSplits).fill(null).map(()=>[
            0
        ]);
    $30fe766c57ed2e65$var$validateSplits(paramsNestedSplits, numParamsDenseValues);
    // Add `splits` that come from all but the last dimension of the dense
    // Tensor `indices`.  In particular, for each dimension D, we add a
    // splits tensor whose values are:
    //   range(reduceProd(splits.shape[:D]) + 1) * splits.shape[D+1]
    // E.g., if indices.shape=[2, 3, 4] then we will add splits tensors:
    //   [0, 3, 6]                    # length=2+1, stride=3
    //   [0, 4, 8, 12, 16, 20, 24]    # length=2*3+1, stride=4
    let nrows = 1;
    for(let dim = 0; dim < indicesShape.length - 1; ++dim){
        nrows *= indicesShape[dim];
        const rowLength = indicesShape[dim + 1];
        for(let i = 1; i < nrows + 1; ++i)outSplits[dim].push(i * rowLength);
    }
    // Add `splits` that come from `paramsNestedSplits`.  Starting with the
    // outermost ragged dimension (i.e., the first `splits` tensor), we work
    // our way in, finding the range of values that should be copied.  As we
    // go, we update the output `splits` for each dimension with the appropriate
    // values.  In particular, the *lengths* of the slices from `param_splits`
    // should be copied to generate corresponding slice lengths in the output
    // splits.  E.g., if we are copying a ragged row with length 4, then we
    // should add a new split point to outSplits that is 4 greater than the
    // previous split point in outSplits.
    for(let i = 0; i < indices.length; ++i){
        let start = indices[i];
        let limit = indices[i] + 1;
        // Copy splits.
        for(let dim = 0; dim < paramsNestedSplits.length; ++dim){
            const splits = paramsNestedSplits[dim];
            const outDim = dim + indicesShape.length - 1;
            if (outDim >= 0) {
                const outSplitsOutDim = outSplits[outDim];
                const delta = outSplitsOutDim[outSplitsOutDim.length - 1] - splits[start];
                for(let j = start; j < limit; ++j)outSplits[outDim].push(splits[j + 1] + delta);
            }
            start = splits[start];
            limit = splits[limit];
        }
        if (limit !== start) {
            valueSlices.push([
                start,
                limit
            ]);
            numValues += limit - start;
        }
    }
    return {
        outSplits: outSplits,
        valueSlices: valueSlices,
        numValues: numValues
    };
}
function $30fe766c57ed2e65$var$getSplits(outSplits) {
    const splitsOut = [];
    for(let i = 0; i < outSplits.length; ++i){
        const numSplits = outSplits[i].length;
        const splits = (0, $lBDHD).getArrayFromDType('int32', numSplits);
        splitsOut.push(splits);
        outSplits[i].forEach((value, j)=>splits[j] = value);
    }
    return splitsOut;
}
function $30fe766c57ed2e65$var$computeFlatOuterDims(orig, numOutDims) {
    const outDims = orig.slice(0, numOutDims);
    while(outDims.length < numOutDims)outDims.push(1);
    for(let inDim = numOutDims; inDim < orig.length; inDim++)outDims[numOutDims - 1] *= orig[inDim];
    return outDims;
}
// For each slice in `(start, limit)` in `valueSlices`, append
// `paramsDenseValues[start,...,limit] to `values`.  `valueSize` indicates
// the number of scalars contained in each value paramsDenseValues[i].
function $30fe766c57ed2e65$var$writeValueSlices(paramsDenseValues, paramsDenseValuesShape, valueSlices, valueSize, values, valuesShape) {
    const denseM = $30fe766c57ed2e65$var$computeFlatOuterDims(paramsDenseValuesShape, 2)[1];
    const valuesM = $30fe766c57ed2e65$var$computeFlatOuterDims(valuesShape, 2)[1];
    let outPos = 0;
    for (const slice of valueSlices)for(let i = slice[0]; i < slice[1]; ++i){
        for(let j = 0; j < valueSize; ++j)values[outPos * valuesM + j] = paramsDenseValues[i * denseM + j];
        ++outPos;
    }
}
function $30fe766c57ed2e65$var$getValues(paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, valueSlices, numValues) {
    const valuesShape = paramsDenseValuesShape.slice();
    valuesShape[0] = numValues;
    const valuesOut = (0, $lBDHD).getArrayFromDType(paramsDenseValuesDType, (0, $lBDHD).sizeFromShape(valuesShape));
    const numElements = paramsDenseValues.length;
    const valueSize = numElements === 0 ? 0 : numElements / paramsDenseValuesShape[0];
    $30fe766c57ed2e65$var$writeValueSlices(paramsDenseValues, paramsDenseValuesShape, valueSlices, valueSize, valuesOut, valuesShape);
    return [
        valuesOut,
        valuesShape
    ];
}
function $30fe766c57ed2e65$export$4104e3de41455909(paramsNestedSplits, paramsNestedSplitsShapes, paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, indices, indicesShape, outputRaggedRank) {
    if (paramsNestedSplits.length === 0) throw new Error('paramsNestedSplits must be non empty');
    if (paramsNestedSplitsShapes[0].length === 0) throw new Error('Split tensors must not be scalars');
    const numParams = paramsNestedSplitsShapes[0][0] - 1;
    $30fe766c57ed2e65$var$validateIndices(indices, indicesShape, numParams);
    if (paramsDenseValuesShape.length === 0) throw new Error('params.rank must be nonzero');
    const numParamsDenseValues = paramsDenseValuesShape[0];
    // Calculate the `splits`, and store the value slices that we need to
    // copy in `valueSlices`.
    const { outSplits: outSplits, valueSlices: valueSlices, numValues: numValues } = $30fe766c57ed2e65$var$makeSplits(indices, indicesShape, paramsNestedSplits, numParamsDenseValues);
    // Write the output tensors.
    const outputNestedSplits = $30fe766c57ed2e65$var$getSplits(outSplits);
    const outputDenseValues = $30fe766c57ed2e65$var$getValues(paramsDenseValues, paramsDenseValuesShape, paramsDenseValuesDType, valueSlices, numValues);
    return [
        outputNestedSplits,
        outputDenseValues[0],
        outputDenseValues[1]
    ];
}

});


parcelRegister("gGhXU", function(module, exports) {

$parcel$export(module.exports, "raggedRangeConfig", function () { return $c24e811b19e739cc$export$91ddd62a193b9401; });
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $9WmKq = parcelRequire("9WmKq");
function $c24e811b19e739cc$export$a173be400c6762b5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { starts: starts, limits: limits, deltas: deltas } = inputs;
    const $starts = backend.data.get(starts.dataId).values;
    const $limits = backend.data.get(limits.dataId).values;
    const $deltas = backend.data.get(deltas.dataId).values;
    const [rtNestedSplitsData, rtDenseValuesData] = (0, $9WmKq.raggedRangeImpl)($starts, starts.shape, starts.dtype, $limits, limits.shape, $deltas, deltas.shape);
    const rtNestedSplits = backend.makeTensorInfo([
        rtNestedSplitsData.length
    ], 'int32', rtNestedSplitsData);
    const rtDenseValues = backend.makeTensorInfo([
        rtDenseValuesData.length
    ], starts.dtype, rtDenseValuesData);
    return [
        rtNestedSplits,
        rtDenseValues
    ];
}
const $c24e811b19e739cc$export$91ddd62a193b9401 = {
    kernelName: (0, $9BGT9.RaggedRange),
    backendName: 'cpu',
    kernelFunc: $c24e811b19e739cc$export$a173be400c6762b5
};

});
parcelRegister("9WmKq", function(module, exports) {

$parcel$export(module.exports, "raggedRangeImpl", function () { return $73cb2d1622353935$export$af0dda5a37ea8d94; });
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
const $73cb2d1622353935$var$INT32_MAX = 2147483647;
function $73cb2d1622353935$export$af0dda5a37ea8d94(starts, startsShape, startsDType, limits, limitsShape, deltas, deltasShape) {
    // Check input tensor shapes.
    if (startsShape.length > 1) throw new Error('starts must be a scalar or vector');
    if (limitsShape.length > 1) throw new Error('limits must be a scalar or vector');
    if (deltasShape.length > 1) throw new Error('deltas must be a scalar or vector');
    // Determine which tensors we need to broadcast.
    const broadcastStarts = startsShape.length === 0;
    const broadcastLimits = limitsShape.length === 0;
    const broadcastDeltas = deltasShape.length === 0;
    // nRows (number of output rows) is the size of the non-broadcast inputs,
    // or 1 if all inputs are scalars.
    const inSizes = [];
    if (!broadcastStarts) inSizes.push(startsShape[0]);
    if (!broadcastLimits) inSizes.push(limitsShape[0]);
    if (!broadcastDeltas) inSizes.push(deltasShape[0]);
    for(let i = 1; i < inSizes.length; ++i){
        if (inSizes[i] !== inSizes[i - 1]) throw new Error('starts, limits, and deltas must have the same shape');
    }
    const nRows = inSizes.length === 0 ? 1 : inSizes[0];
    // Construct the rtNestedSplits tensor.
    const rtNestedSplits = (0, $lBDHD).getArrayFromDType('int32', nRows + 1);
    rtNestedSplits[0] = 0;
    for(let row = 0; row < nRows; ++row){
        const start = broadcastStarts ? starts[0] : starts[row];
        const limit = broadcastLimits ? limits[0] : limits[row];
        const delta = broadcastDeltas ? deltas[0] : deltas[row];
        if (delta === 0) throw new Error('Requires delta != 0');
        let size; // The number of elements in the specified range.
        if (delta > 0 && limit < start || delta < 0 && limit > start) size = 0;
        else {
            size = Math.ceil(Math.abs((limit - start) / delta));
            if (size > $73cb2d1622353935$var$INT32_MAX) throw new Error(`Requires ((limit - start) / delta) <= ${$73cb2d1622353935$var$INT32_MAX}`);
        }
        rtNestedSplits[row + 1] = rtNestedSplits[row] + size;
    }
    const nVals = rtNestedSplits[nRows];
    // Construct the rtDenseValues tensor.
    const rtDenseValues = (0, $lBDHD).getArrayFromDType(startsDType, nVals);
    let valueIndex = 0;
    for(let row = 0; row < nRows; ++row){
        const rowSize = rtNestedSplits[row + 1] - rtNestedSplits[row];
        let value = broadcastStarts ? starts[0] : starts[row];
        const delta = broadcastDeltas ? deltas[0] : deltas[row];
        for(let i = 0; i < rowSize; ++i){
            rtDenseValues[valueIndex++] = value;
            value += delta;
        }
    }
    return [
        rtNestedSplits,
        rtDenseValues
    ];
}

});


parcelRegister("gsyO3", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensorConfig", function () { return $bfba42ac7de58fb2$export$792f441e33dcdf26; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6kS8g = parcelRequire("6kS8g");
function $bfba42ac7de58fb2$export$621e390307cbbaa1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { shape: shape, values: values, defaultValue: defaultValue, rowPartitionTensors: rowPartitionTensors } = inputs;
    const { rowPartitionTypes: rowPartitionTypes } = attrs;
    const $shape = backend.data.get(shape.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const $defaultValue = backend.data.get(defaultValue.dataId).values;
    const $rowPartitionValues = rowPartitionTensors.map((t)=>backend.data.get(t.dataId).values);
    const rowPartitionValuesShapes = rowPartitionTensors.map((t)=>t.shape);
    const [outputShape, output] = (0, $6kS8g.raggedTensorToTensorImpl)($shape, shape.shape, $values, values.shape, values.dtype, $defaultValue, defaultValue.shape, $rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes);
    return backend.makeTensorInfo(outputShape, values.dtype, output);
}
const $bfba42ac7de58fb2$export$792f441e33dcdf26 = {
    kernelName: (0, $9BGT9.RaggedTensorToTensor),
    backendName: 'cpu',
    kernelFunc: $bfba42ac7de58fb2$export$621e390307cbbaa1
};

});
parcelRegister("6kS8g", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensorImpl", function () { return $49ce99dd19f52ca8$export$8194a77b1066327a; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $bMTXt = parcelRequire("bMTXt");
var $8nMOl = parcelRequire("8nMOl");
var $d7Nxs = parcelRequire("d7Nxs");
var $lBDHD = parcelRequire("lBDHD");
var $49ce99dd19f52ca8$var$RowPartitionType = (0, $dEVRx).RowPartitionType;
// Based on
// https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/ragged_tensor_to_tensor_op.cc
class $49ce99dd19f52ca8$var$RaggedTensorToTensorOp {
    constructor(shape, shapeShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypeStrings){
        this.shape = shape;
        this.shapeShape = shapeShape;
        this.values = values;
        this.valuesShape = valuesShape;
        this.valuesDType = valuesDType;
        this.defaultValue = defaultValue;
        this.defaultValueShape = defaultValueShape;
        this.rowPartitionValues = rowPartitionValues;
        this.rowPartitionValuesShapes = rowPartitionValuesShapes;
        this.rowPartitionTypes = (0, $dEVRx).getRowPartitionTypesHelper(rowPartitionTypeStrings);
        this.raggedRank = (0, $dEVRx).getRaggedRank(this.rowPartitionTypes);
    }
    getRowPartitionTypeByDimension(dimension) {
        if (this.rowPartitionTypes[0] === $49ce99dd19f52ca8$var$RowPartitionType.FIRST_DIM_SIZE) return this.rowPartitionTypes[dimension + 1];
        else return this.rowPartitionTypes[dimension];
    }
    // Returns the relationship between dimension and dimension + 1.
    getRowPartitionTensor(dimension) {
        if (this.rowPartitionTypes[0] === $49ce99dd19f52ca8$var$RowPartitionType.FIRST_DIM_SIZE) return this.rowPartitionValues[dimension + 1];
        else return this.rowPartitionValues[dimension];
    }
    getMaxWidth(dimension) {
        const rowPartitionTensor = this.getRowPartitionTensor(dimension - 1);
        switch(this.getRowPartitionTypeByDimension(dimension - 1)){
            case $49ce99dd19f52ca8$var$RowPartitionType.VALUE_ROWIDS:
                return $49ce99dd19f52ca8$var$RaggedTensorToTensorOp.getMaxWidthValueRowID(rowPartitionTensor);
            case $49ce99dd19f52ca8$var$RowPartitionType.ROW_SPLITS:
                return $49ce99dd19f52ca8$var$RaggedTensorToTensorOp.getMaxWidthRowSplit(rowPartitionTensor);
            default:
                throw new Error(`Cannot handle partition type ${$49ce99dd19f52ca8$var$RowPartitionType[this.getRowPartitionTypeByDimension(dimension - 1)]}`);
        }
    }
    static getMaxWidthRowSplit(rowSplit) {
        const tensorLength = rowSplit.length;
        if (tensorLength === 0 || tensorLength === 1) return 0;
        let maxWidth = 0;
        for(let i = 0; i < tensorLength - 1; ++i){
            const currentWidth = rowSplit[i + 1] - rowSplit[i];
            if (currentWidth > maxWidth) maxWidth = currentWidth;
        }
        return maxWidth;
    }
    static getMaxWidthValueRowID(valueRowIds) {
        const indexLength = valueRowIds.length;
        if (indexLength === 0) return 0;
        let firstEqualIndex = 0;
        let firstEqualIndexValue = valueRowIds[0];
        let maxWidth = 0;
        for(let i = 1; i < indexLength; ++i){
            const value = valueRowIds[i];
            if (value !== firstEqualIndexValue) {
                firstEqualIndexValue = value;
                maxWidth = Math.max(i - firstEqualIndex, maxWidth);
                firstEqualIndex = i;
            }
        }
        return Math.max(indexLength - firstEqualIndex, maxWidth);
    }
    tensorShapeFromTensor(t, tShape, isPartial = true) {
        if (tShape.length === 0) {
            if (t[0] === -1) return [];
            throw new Error(`The only valid scalar shape tensor is the fully unknown shape specified as -1.`);
        }
        // MakePartialShape/MakeShapeHelper.
        return $49ce99dd19f52ca8$var$makeShape(t, isPartial);
    }
    calculateOutputSize(firstDim) {
        const valueShape = this.valuesShape;
        const defaultValueShape = this.defaultValueShape;
        (0, $dEVRx).validateDefaultValueShape(defaultValueShape, valueShape);
        const shape = this.tensorShapeFromTensor(this.shape, this.shapeShape);
        const outputShape = (0, $dEVRx).combineRaggedTensorToTensorShapes(this.raggedRank, shape, valueShape);
        const result = outputShape;
        if (result[0] < 0) result[0] = firstDim;
        for(let i = 1; i <= this.raggedRank; ++i)if (result[i] < 0) result[i] = this.getMaxWidth(i);
        return result;
    }
    /**
     * The outputIndex represents the index in the output tensor
     * where the first element of a particular dimension would be written.
     * If it is -1, it indicates that the index is out of scope.
     * Example, given firstDimension = 10, firstDimensionOutput = 6,
     * and outputIndexMultiplier = 100:
     * result = [0 100 200 300 400 500 -1 -1 -1 -1]
     * If firstDimensionOutput = 11 instead, then:
     * result = [0 100 200 300 400 500 600 700 800 900]
     */ calculateFirstParentOutputIndex(firstDimension, outputIndexMultiplier, firstDimensionOutput) {
        const minDimension = Math.min(firstDimension, firstDimensionOutput);
        const result = [];
        let currentOutputIndex = 0;
        for(let i = 0; i < minDimension; ++i, currentOutputIndex += outputIndexMultiplier)result.push(currentOutputIndex);
        for(let i = minDimension; i < firstDimension; ++i)result.push(-1);
        (0, $lBDHD).assert(result.length === firstDimension, ()=>'Final length of result must be equal to firstDimension.');
        return result;
    }
    calculateOutputIndexRowSplit(rowSplit, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const rowSplitSize = rowSplit.length;
        const result = [];
        for(let i = 0; i < rowSplitSize - 1; ++i){
            const rowLength = rowSplit[i + 1] - rowSplit[i];
            let realLength = Math.min(outputSize, rowLength);
            let parentOutputIndexCurrent = parentOutputIndex[i];
            if (parentOutputIndexCurrent === -1) realLength = 0;
            for(let j = 0; j < realLength; ++j){
                result.push(parentOutputIndexCurrent);
                parentOutputIndexCurrent += outputIndexMultiplier;
            }
            for(let j = 0; j < rowLength - realLength; ++j)result.push(-1);
        }
        if (rowSplitSize > 0 && result.length !== rowSplit[rowSplitSize - 1]) throw new Error('Invalid row split size.');
        return result;
    }
    // Calculate the output index of the first element of a list.
    // The parentOutputIndex is the same computation for the previous list.
    // -1 indicates an element or list that is out of range.
    // The outputIndexMultiplier is the number of output indices one moves
    // forward for each column.
    // E.g., given:
    // valueRowIds:[0 1 2 2 2 3 5 5 6]
    // parentOutputIndex:[1000 1100 2000 2100 -1 3000 4000]
    // outputIndexMultiplier: 10
    // outputSize: 2
    // You get:
    // result = [1000 1100 2000 2010 -1 2100 -1 -1 3000]
    // result[0] = parentOutputIndex[valueRowIds[0]]
    // result[1] = parentOutputIndex[valueRowIds[1]]
    // result[2] = parentOutputIndex[valueRowIds[2]]
    // result[3] = parentOutputIndex[valueRowIds[2] + 10]
    // result[4] = -1 because it is the third element the size is 2.
    // result[5] = parentOutputIndex[valueRowIds[3]]
    // result[6] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[7] = -1 because parentOutputIndex[valueRowIds[6]] == -1
    // result[8] = parentOutputIndex[valueRowIds[7]]
    calculateOutputIndexValueRowID(valueRowIds, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const indexSize = valueRowIds.length;
        const result = [];
        if (indexSize === 0) return [];
        let currentOutputColumn = 0;
        let currentValueRowId = valueRowIds[0];
        if (currentValueRowId >= parentOutputIndex.length) throw new Error(`Got currentValueRowId=${currentValueRowId}, which is not less than ${parentOutputIndex.length}`);
        let currentOutputIndex = parentOutputIndex[currentValueRowId];
        result.push(currentOutputIndex);
        for(let i = 1; i < indexSize; ++i){
            const nextValueRowId = valueRowIds[i];
            if (nextValueRowId === currentValueRowId) {
                if (currentOutputIndex >= 0) {
                    ++currentOutputColumn;
                    if (currentOutputColumn < outputSize) currentOutputIndex += outputIndexMultiplier;
                    else currentOutputIndex = -1;
                }
            } else {
                currentOutputColumn = 0;
                currentValueRowId = nextValueRowId;
                if (nextValueRowId >= parentOutputIndex.length) throw new Error(`Got nextValueRowId=${nextValueRowId} which is not less than ${parentOutputIndex.length}`);
                currentOutputIndex = parentOutputIndex[nextValueRowId];
            }
            result.push(currentOutputIndex);
        }
        if (result.length !== valueRowIds.length) throw new Error('Invalid row ids.');
        return result;
    }
    calculateOutputIndex(dimension, parentOutputIndex, outputIndexMultiplier, outputSize) {
        const rowPartitionTensor = this.getRowPartitionTensor(dimension);
        const partitionType = this.getRowPartitionTypeByDimension(dimension);
        switch(partitionType){
            case $49ce99dd19f52ca8$var$RowPartitionType.VALUE_ROWIDS:
                return this.calculateOutputIndexValueRowID(rowPartitionTensor, parentOutputIndex, outputIndexMultiplier, outputSize);
            case $49ce99dd19f52ca8$var$RowPartitionType.ROW_SPLITS:
                if (rowPartitionTensor.length - 1 > parentOutputIndex.length) throw new Error(`Row partition size is greater than output size: ${rowPartitionTensor.length - 1} > ${parentOutputIndex.length}`);
                return this.calculateOutputIndexRowSplit(rowPartitionTensor, parentOutputIndex, outputIndexMultiplier, outputSize);
            default:
                throw new Error(`Unsupported partition type: ${$49ce99dd19f52ca8$var$RowPartitionType[partitionType]}`);
        }
    }
    getFirstDimensionSize() {
        const firstPartitionTensor = this.rowPartitionValues[0];
        if (this.rowPartitionTypes.length === 0) throw new Error('No row_partition_types given.');
        const firstPartitionType = this.rowPartitionTypes[0];
        switch(firstPartitionType){
            case $49ce99dd19f52ca8$var$RowPartitionType.FIRST_DIM_SIZE:
                return firstPartitionTensor[0];
            case $49ce99dd19f52ca8$var$RowPartitionType.VALUE_ROWIDS:
                throw new Error('Cannot handle VALUE_ROWIDS in first dimension.');
            case $49ce99dd19f52ca8$var$RowPartitionType.ROW_SPLITS:
                return this.rowPartitionValuesShapes[0][0] - 1;
            default:
                throw new Error(`Cannot handle type ${$49ce99dd19f52ca8$var$RowPartitionType[firstPartitionType]}`);
        }
    }
    compute() {
        const firstPartitionTensor = this.rowPartitionValues[0];
        if (firstPartitionTensor.length <= 0) throw new Error("Invalid first partition input. Tensor requires at least one element.");
        const firstDimension = this.getFirstDimensionSize();
        const outputSize = this.calculateOutputSize(firstDimension);
        const multiplier = new Array(this.raggedRank + 1);
        multiplier[multiplier.length - 1] = 1;
        for(let i = multiplier.length - 2; i >= 0; --i)multiplier[i] = multiplier[i + 1] * outputSize[i + 1];
        // Full size of the tensor.
        const outputShape = $49ce99dd19f52ca8$var$makeShape(outputSize, false);
        const outputTensor = (0, $lBDHD).getArrayFromDType(this.valuesDType, (0, $lBDHD).sizeFromShape(outputShape));
        const fullSize = multiplier[0] * outputSize[0];
        if (fullSize > 0) {
            let outputIndex = this.calculateFirstParentOutputIndex(firstDimension, multiplier[0], outputSize[0]);
            for(let i = 1; i <= this.raggedRank; ++i){
                const newOutputIndex = this.calculateOutputIndex(i - 1, outputIndex, multiplier[i], outputSize[i]);
                outputIndex = newOutputIndex;
            }
            this.setOutput(this.raggedRank, outputIndex, outputTensor, outputShape);
        }
        return [
            outputShape,
            outputTensor
        ];
    }
    setOutput(raggedRank, outputIndex, outputTensor, outputShape) {
        if (outputTensor.length === 0) return;
        const valuesBase = this.values;
        const outputBase = outputTensor;
        let elementShape = outputShape.slice();
        elementShape = elementShape.slice(raggedRank + 1);
        const valueElementSize = (0, $lBDHD).sizeFromShape(elementShape);
        const outputIndexSize = outputIndex.length;
        // Broadcast the default value to value_element_size.  (We can skip this
        // if defaultValueTensor.size == 1, since we use fill when that's true.)
        let defaultValue = this.defaultValue;
        if (defaultValue.length !== valueElementSize && defaultValue.length !== 1) {
            const srcShape = this.defaultValueShape;
            (0, $d7Nxs.tidy)(()=>{
                const defaultValueTensor = (0, $8nMOl.reshape)(defaultValue, srcShape);
                const bCastDefault = (0, $bMTXt.broadcastTo)(defaultValueTensor, elementShape);
                defaultValue = bCastDefault.dataSync();
            });
        }
        // Loop through the outputIndex array, finding contiguous regions that
        // should be copied.  Once we find the end of a contiguous region, copy it
        // and add any necessary padding (with defaultValue).
        let srcStart = 0; // Start of contiguous region (in values)
        let dstStart = 0; // Destination for contiguous region (in output)
        let dstEnd = 0; // Destination for contiguous region (in output)
        for(let srcI = 0; srcI <= outputIndexSize; ++srcI){
            // dstI is the destination where the value at srcI should be copied.
            let dstI = srcI < outputIndexSize ? outputIndex[srcI] : -1;
            // If we're still in a contiguous region, then update dstEnd go to the
            // next srcI.
            if (dstI === dstEnd) {
                ++dstEnd;
                continue;
            }
            // We found the end of contiguous region.  This can be because we found
            // a gap (dstI > dstEnd), or a source value that shouldn't be copied
            // because it's out-of-bounds (dstI == -1), or the end of the tensor
            // (dstI === -1).
            if (dstStart < dstEnd) {
                // Copy the contiguous region.
                const src = valuesBase.subarray(srcStart * valueElementSize);
                const dst = outputBase.subarray(dstStart * valueElementSize);
                const nVals = (dstEnd - dstStart) * valueElementSize;
                $49ce99dd19f52ca8$var$copyArray(dst, src, nVals);
            }
            // Add any necessary padding (w/ defaultValue).
            if (srcI >= outputIndexSize) {
                // We reached the end of values: pad to the end of output.
                const outputSize = outputTensor.length;
                dstI = Math.floor(outputSize / valueElementSize);
            }
            if (dstI > dstEnd) {
                if (this.defaultValue.length === 1) {
                    outputBase.subarray(dstEnd * valueElementSize, dstI * valueElementSize).fill(this.defaultValue[0]);
                    dstEnd = dstI;
                } else while(dstI > dstEnd){
                    const dst = outputBase.slice(dstEnd * valueElementSize);
                    $49ce99dd19f52ca8$var$copyArray(dst, defaultValue, valueElementSize);
                    ++dstEnd;
                }
            }
            // Update indices.
            if (dstI < 0) {
                // srcI should be skipped -- leave it out of the contiguous region.
                srcStart = srcI + 1;
                dstStart = dstEnd;
            } else {
                // srcI should be copied -- include it in the contiguous region.
                srcStart = srcI;
                dstStart = dstEnd;
                dstEnd = dstStart + 1;
            }
        }
    }
}
function $49ce99dd19f52ca8$var$copyArray(dst, src, size) {
    for(let i = 0; i < size; i++)dst[i] = src[i];
}
function $49ce99dd19f52ca8$var$makeShape(shape, isPartial) {
    const out = [];
    for (let dim of shape){
        if (dim < 0) {
            if (!isPartial) throw new Error(`Dimension ${dim} must be >= 0`);
            if (dim < -1) throw new Error(`Dimension ${dim} must be >= -1`);
            dim = -1;
        }
        out.push(dim);
    }
    return out;
}
function $49ce99dd19f52ca8$export$8194a77b1066327a(shape, shapesShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes) {
    return new $49ce99dd19f52ca8$var$RaggedTensorToTensorOp(shape, shapesShape, values, valuesShape, valuesDType, defaultValue, defaultValueShape, rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes).compute();
}

});


parcelRegister("3iaps", function(module, exports) {

$parcel$export(module.exports, "rangeConfig", function () { return $265b20a52321d1c5$export$361c4075706e31c2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $fWx5R = parcelRequire("fWx5R");
function $265b20a52321d1c5$export$d02631cccf789723(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, dtype: dtype, step: step } = attrs;
    const values = (0, $fWx5R.rangeImpl)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
}
const $265b20a52321d1c5$export$361c4075706e31c2 = {
    kernelName: (0, $9BGT9.Range),
    backendName: 'cpu',
    kernelFunc: $265b20a52321d1c5$export$d02631cccf789723
};

});
parcelRegister("fWx5R", function(module, exports) {

$parcel$export(module.exports, "rangeImpl", function () { return $b9b5f176f5201ab2$export$3561205b7dff20bf; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $b9b5f176f5201ab2$export$3561205b7dff20bf(start, stop, step, dtype) {
    const sameStartStop = start === stop;
    const increasingRangeNegativeStep = start < stop && step < 0;
    const decreasingRangePositiveStep = stop < start && step > 1;
    if (sameStartStop || increasingRangeNegativeStep || decreasingRangePositiveStep) return (0, $lBDHD).makeZerosTypedArray(0, dtype);
    const numElements = Math.abs(Math.ceil((stop - start) / step));
    const values = (0, $lBDHD).makeZerosTypedArray(numElements, dtype);
    if (stop < start && step === 1) // Auto adjust the step's sign if it hasn't been set
    // (or was set to 1)
    step = -1;
    values[0] = start;
    for(let i = 1; i < values.length; i++)values[i] = values[i - 1] + step;
    return values;
}

});


parcelRegister("gCFYp", function(module, exports) {

$parcel$export(module.exports, "reciprocalConfig", function () { return $c1a0c0fc3bb378a5$export$412a6b66203fdf72; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $c1a0c0fc3bb378a5$export$163bc8c839a1ac04 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Reciprocal), (xi)=>1 / xi);
const $c1a0c0fc3bb378a5$export$412a6b66203fdf72 = {
    kernelName: (0, $9BGT9.Reciprocal),
    backendName: 'cpu',
    kernelFunc: $c1a0c0fc3bb378a5$export$163bc8c839a1ac04
};

});

parcelRegister("8UdNU", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearConfig", function () { return $67be42e6183c0a51$export$a37a56137abc1357; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $67be42e6183c0a51$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    (0, $wi69v.assertNotComplex)(images, 'resizeBilinear');
    const imagesStrides = (0, $lBDHD).computeStrides(images.shape);
    const [newHeight, newWidth] = size;
    const [batch, oldHeight, oldWidth, numChannels] = images.shape;
    const xValues = backend.data.get(images.dataId).values;
    const result = new Float32Array((0, $lBDHD).sizeFromShape([
        batch,
        newHeight,
        newWidth,
        numChannels
    ]));
    const effectiveInputSize = [
        alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
        alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutputSize = [
        alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
        alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    let outputIdx = 0;
    const effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
    const effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
    for(let b = 0; b < batch; b++)for(let r = 0; r < newHeight; r++){
        let sourceFracRow;
        if (halfPixelCenters) sourceFracRow = effectiveRowSizeRatio * (r + 0.5) - 0.5;
        else sourceFracRow = effectiveRowSizeRatio * r;
        const sourceRowFloor = Math.max(0, Math.floor(sourceFracRow));
        const rowFrac = sourceFracRow - sourceRowFloor;
        const sourceRowCeil = Math.min(oldHeight - 1, Math.ceil(sourceFracRow));
        const topRowOffset = b * imagesStrides[0] + sourceRowFloor * imagesStrides[1];
        const botRowOffset = b * imagesStrides[0] + sourceRowCeil * imagesStrides[1];
        for(let c = 0; c < newWidth; c++){
            let sourceFracCol;
            if (halfPixelCenters) sourceFracCol = effectiveColSizeRatio * (c + 0.5) - 0.5;
            else sourceFracCol = effectiveColSizeRatio * c;
            const sourceColFloor = Math.max(0, Math.floor(sourceFracCol));
            const colFrac = sourceFracCol - sourceColFloor;
            const sourceColCeil = Math.min(oldWidth - 1, Math.ceil(sourceFracCol));
            const topLeftOffest = topRowOffset + sourceColFloor * imagesStrides[2];
            const botLeftOffset = botRowOffset + sourceColFloor * imagesStrides[2];
            const topRightOffset = topRowOffset + sourceColCeil * imagesStrides[2];
            const botRightOffest = botRowOffset + sourceColCeil * imagesStrides[2];
            for(let d = 0; d < numChannels; d++){
                // Begin shader.
                // Compute the fractional index of the source.
                const topLeft = xValues[topLeftOffest + d];
                const bottomLeft = xValues[botLeftOffset + d];
                const topRight = xValues[topRightOffset + d];
                const bottomRight = xValues[botRightOffest + d];
                const top = topLeft + (topRight - topLeft) * colFrac;
                const bottom = bottomLeft + (bottomRight - bottomLeft) * colFrac;
                const newValue = top + (bottom - top) * rowFrac;
                result[outputIdx++] = newValue;
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        newHeight,
        newWidth,
        numChannels
    ], 'float32', result);
}
const $67be42e6183c0a51$export$a37a56137abc1357 = {
    kernelName: (0, $9BGT9.ResizeBilinear),
    backendName: 'cpu',
    kernelFunc: $67be42e6183c0a51$export$1f1cbc7da93d06a0
};

});

parcelRegister("jWJrL", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearGradConfig", function () { return $e856afe29dbf8649$export$51f84ca614e84763; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $e856afe29dbf8649$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    (0, $wi69v.assertNotComplex)([
        dy,
        images
    ], 'resizeBilinearGrad');
    const imagesStrides = (0, $lBDHD).computeStrides(images.shape);
    const [batch, xHeight, xWidth, depth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const output = new Float32Array(batch * xHeight * xWidth * depth);
    // In the backwards pass, we want to find the pixels that were generated
    // for each pixel in the input image the forward pass and add the
    // corresponding coefficient from dy to the gradient (with some
    // interpolation).
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    // Reference implementation
    // tslint:disable-next-line:max-line-length
    // https://github.com/tensorflow/tensorflow/blob/3039375c86a5bbc9610c7725dcaa95d635f87ba2/tensorflow/core/kernels/resize_bilinear_op.cc#L275
    const dyValues = backend.data.get(dy.dataId).values;
    let offset = 0;
    for(let b = 0; b < batch; b++){
        const bOffset = b * imagesStrides[0];
        for(let r = 0; r < yHeight; r++){
            const dxR = r * heightScale;
            const topDxRIndex = Math.floor(dxR);
            const bottomDxRIndex = Math.min(Math.ceil(dxR), xHeight - 1);
            const topDxROffset = bOffset + topDxRIndex * imagesStrides[1];
            const bottomDxROffset = bOffset + bottomDxRIndex * imagesStrides[1];
            const dxRLerp = dxR - topDxRIndex;
            const inverseDxRLerp = 1.0 - dxRLerp;
            for(let c = 0; c < yWidth; c++){
                const dxC = c * widthScale;
                const leftDxCIndex = Math.floor(dxC);
                const rightDxCIndex = Math.min(Math.ceil(dxC), xWidth - 1);
                const dxCLerp = dxC - leftDxCIndex;
                const inverseDxCLerp = 1.0 - dxCLerp;
                const topLeftRCOffset = topDxROffset + leftDxCIndex * imagesStrides[2];
                const topRightRCOffset = topDxROffset + rightDxCIndex * imagesStrides[2];
                const bottomLeftRCOffset = bottomDxROffset + leftDxCIndex * imagesStrides[2];
                const bottomRightRCOffset = bottomDxROffset + rightDxCIndex * imagesStrides[2];
                const inverseDxRLerpTimesInverseDxCLerp = inverseDxRLerp * inverseDxCLerp;
                const inverseDxRLerpTimesDxCLerp = inverseDxRLerp * dxCLerp;
                const dxRLerpTimesInverseDxCLerp = dxRLerp * inverseDxCLerp;
                const dxRLerpTimesDxCLerp = dxRLerp * dxCLerp;
                for(let d = 0; d < depth; d++){
                    const dyVal = dyValues[offset++];
                    output[topLeftRCOffset + d] += dyVal * inverseDxRLerpTimesInverseDxCLerp;
                    output[topRightRCOffset + d] += dyVal * inverseDxRLerpTimesDxCLerp;
                    output[bottomLeftRCOffset + d] += dyVal * dxRLerpTimesInverseDxCLerp;
                    output[bottomRightRCOffset + d] += dyVal * dxRLerpTimesDxCLerp;
                }
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        xWidth,
        xHeight,
        depth
    ], 'float32', output);
}
const $e856afe29dbf8649$export$51f84ca614e84763 = {
    kernelName: (0, $9BGT9.ResizeBilinearGrad),
    backendName: 'cpu',
    kernelFunc: $e856afe29dbf8649$export$8899506794ec394
};

});

parcelRegister("cAOM1", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborConfig", function () { return $92b03b6419439948$export$2b6a92caba113b89; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $92b03b6419439948$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    (0, $wi69v.assertNotComplex)(images, 'resizeNearestNeighbor');
    const imagesStrides = (0, $lBDHD).computeStrides(images.shape);
    const [newHeight, newWidth] = size;
    const [batch, oldHeight, oldWidth, numChannels] = images.shape;
    const xValues = backend.data.get(images.dataId).values;
    const output = new Float32Array(batch * newHeight * newWidth * numChannels);
    const effectiveInputSize = [
        alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
        alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
    ];
    const effectiveOutputSize = [
        alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
        alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
    ];
    const effectiveRowSizeRatio = effectiveInputSize[0] / effectiveOutputSize[0];
    const effectiveColSizeRatio = effectiveInputSize[1] / effectiveOutputSize[1];
    let outputOffset = 0;
    for(let b = 0; b < batch; b++){
        const batchOffset = b * imagesStrides[0];
        for(let r = 0; r < newHeight; r++){
            const sourceFracRow = halfPixelCenters ? effectiveRowSizeRatio * (r + 0.5) : effectiveRowSizeRatio * r;
            let sourceNearestRow = Math.min(oldHeight - 1, alignCorners ? Math.round(sourceFracRow) : Math.floor(sourceFracRow));
            if (halfPixelCenters) sourceNearestRow = Math.max(0, sourceNearestRow);
            const rowOffset = batchOffset + sourceNearestRow * imagesStrides[1];
            for(let c = 0; c < newWidth; c++){
                const sourceFracCol = halfPixelCenters ? effectiveColSizeRatio * (c + 0.5) : effectiveColSizeRatio * c;
                let sourceNearestCol = Math.min(oldWidth - 1, alignCorners ? Math.round(sourceFracCol) : Math.floor(sourceFracCol));
                if (halfPixelCenters) sourceNearestCol = Math.max(0, sourceNearestCol);
                const colOffset = rowOffset + sourceNearestCol * imagesStrides[2];
                for(let d = 0; d < numChannels; d++){
                    // Begin shader.
                    // Compute the fractional index of the source.
                    const newVal = xValues[colOffset + d];
                    output[outputOffset++] = newVal;
                }
            }
        }
    }
    return backend.makeTensorInfo([
        batch,
        newHeight,
        newWidth,
        numChannels
    ], images.dtype, output);
}
const $92b03b6419439948$export$2b6a92caba113b89 = {
    kernelName: (0, $9BGT9.ResizeNearestNeighbor),
    backendName: 'cpu',
    kernelFunc: $92b03b6419439948$export$74a902ae74ac2560
};

});

parcelRegister("8cAqa", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborGradConfig", function () { return $5f8bb22a88a5684a$export$2b08d810b5090fe1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $5f8bb22a88a5684a$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    (0, $wi69v.assertNotComplex)([
        dy,
        images
    ], 'resizeNearestNeighborGrad');
    const imagesStrides = (0, $lBDHD).computeStrides(images.shape);
    const dyStrides = (0, $lBDHD).computeStrides(dy.shape);
    const [batch, xHeight, xWidth, depth] = images.shape;
    const [, yHeight, yWidth] = dy.shape;
    const output = new Float32Array(batch * xHeight * xWidth * depth);
    const dyValues = backend.data.get(dy.dataId).values;
    // In the backwards pass, we want to find the pixels that were generated
    // for each pixel in the input image the forward pass
    const effectiveXSize = [
        alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
        alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
    ];
    const effectiveYSize = [
        alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
        alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
    ];
    const heightScale = effectiveXSize[0] / effectiveYSize[0];
    const widthScale = effectiveXSize[1] / effectiveYSize[1];
    const invHeightScale = 1 / heightScale;
    const invWidthScale = 1 / widthScale;
    // This defines the size of the window of values around a particular
    // index in dy that we want to search for contributions to dx.
    const winHeight = Math.ceil(invHeightScale) * 2 + 2;
    const winWidth = Math.ceil(invWidthScale) * 2 + 2;
    // Loop over the output space.
    for(let b = 0; b < batch; b++){
        const batchOffset = b * imagesStrides[0];
        for(let r = 0; r < xHeight; r++){
            const rowOffset = batchOffset + r * imagesStrides[1];
            // Compute bounds for where in dy we will look
            const startRLerp = Math.floor(r * invHeightScale);
            const startDyR = Math.floor(startRLerp - winHeight / 2);
            for(let c = 0; c < xWidth; c++){
                const colOffset = rowOffset + c * imagesStrides[2];
                // Compute bounds for where in dy we will look
                const startCLerp = Math.floor(c * invWidthScale);
                const startDyC = Math.floor(startCLerp - winWidth / 2);
                for(let d = 0; d < depth; d++){
                    let accum = 0;
                    // loop over dy
                    for(let dyRIndex = 0; dyRIndex < winHeight; dyRIndex++){
                        const dyR = dyRIndex + startDyR;
                        // Guard against the window exceeding the bounds of dy
                        if (dyR < 0 || dyR >= yHeight) continue;
                        const dyROffset = batchOffset + dyR * dyStrides[1];
                        const sourceFracRow = dyR * heightScale;
                        const sourceNearestRow = Math.min(xHeight - 1, alignCorners ? Math.round(sourceFracRow) : Math.floor(sourceFracRow));
                        if (r !== sourceNearestRow) continue;
                        for(let dyCIndex = 0; dyCIndex < winWidth; dyCIndex++){
                            const dyC = dyCIndex + startDyC;
                            // Guard against the window exceeding the bounds of dy
                            if (dyC < 0 || dyC >= yWidth) continue;
                            const dyCOffset = dyROffset + dyC * dyStrides[2];
                            const sourceFracCol = dyC * widthScale;
                            const sourceNearestCol = Math.min(xWidth - 1, alignCorners ? Math.round(sourceFracCol) : Math.floor(sourceFracCol));
                            if (c === sourceNearestCol) accum += dyValues[dyCOffset + d];
                        }
                    }
                    output[colOffset + d] = accum;
                }
            }
        }
    }
    return backend.makeTensorInfo(images.shape, images.dtype, output);
}
const $5f8bb22a88a5684a$export$2b08d810b5090fe1 = {
    kernelName: (0, $9BGT9.ResizeNearestNeighborGrad),
    backendName: 'cpu',
    kernelFunc: $5f8bb22a88a5684a$export$2b75795f158f1b18
};

});

parcelRegister("DLIeE", function(module, exports) {

$parcel$export(module.exports, "reverseConfig", function () { return $0778a7560309bb9c$export$cab6a4e8d2ed8e8d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $l9MqT = parcelRequire("l9MqT");
function $0778a7560309bb9c$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'reverse');
    const xRank = x.shape.length;
    const $dims = (0, $lBDHD).parseAxisParam(dims, x.shape);
    if (xRank === 0) return (0, $l9MqT.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const outBuf = new (0, $3pVUH.TensorBuffer)(x.shape, x.dtype);
    const xBuf = backend.bufferSync(x);
    for(let i = 0; i < outBuf.size; i++){
        const outLoc = outBuf.indexToLoc(i);
        const inLoc = outLoc.slice();
        $dims.forEach((d)=>inLoc[d] = x.shape[d] - 1 - inLoc[d]);
        outBuf.set(xBuf.get(...inLoc), ...outLoc);
    }
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $0778a7560309bb9c$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $9BGT9.Reverse),
    backendName: 'cpu',
    kernelFunc: $0778a7560309bb9c$export$66c1ae025e96b4bc
};

});

parcelRegister("kSwap", function(module, exports) {

$parcel$export(module.exports, "rotateWithOffsetConfig", function () { return $f331cd71a3726e05$export$44ba8c83417ab668; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
const $f331cd71a3726e05$export$44ba8c83417ab668 = {
    kernelName: (0, $9BGT9.RotateWithOffset),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const cpuBackend = backend;
        const output = (0, $lBDHD).getTypedArrayFromDType(image.dtype, (0, $lBDHD).sizeFromShape(image.shape));
        const [batch, imageHeight, imageWidth, numChannels] = image.shape;
        const [centerX, centerY] = (0, $dEVRx).getImageCenter(center, imageHeight, imageWidth);
        const fullOpacityValue = 255;
        const sinFactor = Math.sin(radians);
        const cosFactor = Math.cos(radians);
        const imageVals = cpuBackend.data.get(image.dataId).values;
        for(let batchIdx = 0; batchIdx < batch; batchIdx++){
            const batchOffset = batchIdx * imageWidth * imageHeight * numChannels;
            for(let row = 0; row < imageHeight; row++){
                const rowOffset = row * (imageWidth * numChannels);
                for(let col = 0; col < imageWidth; col++){
                    const colOffset = col * numChannels;
                    for(let channel = 0; channel < numChannels; channel++){
                        const coords = [
                            batch,
                            row,
                            col,
                            channel
                        ];
                        const x = coords[2];
                        const y = coords[1];
                        // coordX/coordY are the result of rotating and translating x/y.
                        let coordX = (x - centerX) * cosFactor - (y - centerY) * sinFactor;
                        let coordY = (x - centerX) * sinFactor + (y - centerY) * cosFactor;
                        coordX = Math.round(coordX + centerX);
                        coordY = Math.round(coordY + centerY);
                        let outputValue = fillValue;
                        if (typeof fillValue !== 'number') {
                            if (channel === 3) outputValue = fullOpacityValue;
                            else outputValue = fillValue[channel];
                        }
                        // If the coordinate position falls within the image boundaries...
                        if (coordX >= 0 && coordX < imageWidth && coordY >= 0 && coordY < imageHeight) {
                            // set the output to the image value at the coordinate position.
                            const rotatedRowOffset = coordY * (imageWidth * numChannels);
                            const rotatedColOffset = coordX * numChannels;
                            const imageIdx = batchOffset + rotatedRowOffset + rotatedColOffset + channel;
                            outputValue = imageVals[imageIdx];
                        }
                        const outIdx = batchOffset + rowOffset + colOffset + channel;
                        output[outIdx] = outputValue;
                    }
                }
            }
        }
        const dataId = cpuBackend.write(output, image.shape, image.dtype);
        return {
            dataId: dataId,
            shape: image.shape,
            dtype: image.dtype
        };
    }
};

});

parcelRegister("jfy0V", function(module, exports) {

$parcel$export(module.exports, "roundConfig", function () { return $e039cd83fdfa3493$export$6c09e3291f636503; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $e039cd83fdfa3493$export$2077e0241d6afd3c = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Round), (xi)=>{
    // The algorithm is based on banker's rounding.
    const base = Math.floor(xi);
    if (xi - base < 0.5) return Math.floor(xi);
    else if (xi - base > 0.5) return Math.ceil(xi);
    else {
        if (base % 2.0 === 0.0) return base;
        else return base + 1.0;
    }
});
const $e039cd83fdfa3493$export$6c09e3291f636503 = {
    kernelName: (0, $9BGT9.Round),
    backendName: 'cpu',
    kernelFunc: $e039cd83fdfa3493$export$2077e0241d6afd3c
};

});

parcelRegister("bUDnX", function(module, exports) {

$parcel$export(module.exports, "rsqrtImpl", function () { return $8ac379caa085089d$export$7ec24de9bffc6b90; });
$parcel$export(module.exports, "rsqrtConfig", function () { return $8ac379caa085089d$export$941104b789956ef6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $8ac379caa085089d$export$7ec24de9bffc6b90 = (0, $cfLEm.createSimpleUnaryImpl)((xi)=>1 / Math.sqrt(xi));
const $8ac379caa085089d$export$1cc01d192953037e = (0, $6wQye.unaryKernelFuncFromImpl)((0, $9BGT9.Rsqrt), $8ac379caa085089d$export$7ec24de9bffc6b90);
const $8ac379caa085089d$export$941104b789956ef6 = {
    kernelName: (0, $9BGT9.Rsqrt),
    backendName: 'cpu',
    kernelFunc: $8ac379caa085089d$export$1cc01d192953037e
};

});

parcelRegister("8a0Og", function(module, exports) {

$parcel$export(module.exports, "scatterNdConfig", function () { return $5f0fe2b0814ea4ad$export$573371744f044f5; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $eI5eD = parcelRequire("eI5eD");
function $5f0fe2b0814ea4ad$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $dEVRx).calculateShapes(updates, indices, shape);
    const sumDupeIndices = true;
    const indicesBuf = backend.bufferSync(indices);
    const updatesBuf = backend.bufferSync(updates);
    const outBuf = (0, $eI5eD.scatterImpl)(indicesBuf, updatesBuf, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, 0 /* defaultValue */ , sumDupeIndices);
    return backend.makeTensorInfo(shape, outBuf.dtype, outBuf.values);
}
const $5f0fe2b0814ea4ad$export$573371744f044f5 = {
    kernelName: (0, $9BGT9.ScatterNd),
    backendName: 'cpu',
    kernelFunc: $5f0fe2b0814ea4ad$export$b6f42038a536d877
};

});
parcelRegister("eI5eD", function(module, exports) {

$parcel$export(module.exports, "scatterImpl", function () { return $ab593c54e43fc1ef$export$5fc9b0358a19bd54; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
var $3pVUH = parcelRequire("3pVUH");
function $ab593c54e43fc1ef$export$5fc9b0358a19bd54(indices, updates, shape, outputSize, sliceSize, numUpdates, sliceRank, strides, defaultValue, sumDupeIndices) {
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    const indicesData = indices.values;
    const updatesData = updates.values;
    if (outputSize === 0) return (0, $5siju.buffer)(shape, updates.dtype);
    const outBuf = defaultValue instanceof (0, $3pVUH.TensorBuffer) ? defaultValue : (0, $5siju.buffer)(flattenShape, updates.dtype);
    if (typeof defaultValue === 'string') outBuf.values.fill(defaultValue);
    else if (typeof defaultValue === 'number') outBuf.values.fill(defaultValue);
    else if (typeof defaultValue === 'boolean') outBuf.values.fill(+defaultValue);
    for(let i = 0; i < numUpdates; i++){
        const index = [];
        let flattenIndex = 0;
        for(let j = 0; j < sliceRank; j++){
            const dim = indicesData[i * sliceRank + j];
            index.push(dim);
            flattenIndex += dim * strides[j];
        }
        if (flattenIndex < 0 || flattenIndex >= outputSize / sliceSize) throw new Error(`Invalid indices: ${index} does not index into ${shape}`);
        for(let k = 0; k < sliceSize; k++)if (sumDupeIndices) outBuf.values[flattenIndex * sliceSize + k] += updatesData[i * sliceSize + k];
        else outBuf.values[flattenIndex * sliceSize + k] = updates.rank === 0 ? updatesData[0] : updatesData[i * sliceSize + k];
    }
    return outBuf;
}

});


parcelRegister("3tLqv", function(module, exports) {

$parcel$export(module.exports, "searchSortedConfig", function () { return $2888de70eeb34e7b$export$4b437b1a1aa6472f; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bX76s = parcelRequire("bX76s");
function $2888de70eeb34e7b$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const $sortedSequence = backend.data.get(sortedSequence.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const output = (0, $bX76s.searchSortedImpl)($sortedSequence, $values, sortedSequence.shape[0], sortedSequence.shape[1], values.shape[1], side);
    return backend.makeTensorInfo(values.shape, 'int32', output);
}
const $2888de70eeb34e7b$export$4b437b1a1aa6472f = {
    kernelName: (0, $9BGT9.SearchSorted),
    backendName: 'cpu',
    kernelFunc: $2888de70eeb34e7b$export$56fad8d65b0adbdd
};

});
parcelRegister("bX76s", function(module, exports) {

$parcel$export(module.exports, "searchSortedImpl", function () { return $8b3ab6e98be9ac3d$export$dbd5299c7ff33b30; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $8b3ab6e98be9ac3d$var$lowerBound(array, value) {
    let left = 0;
    let right = array.length;
    let mid = 0;
    while(left < right){
        mid = Math.floor((left + right) / 2);
        if (array[mid] < value) left = mid + 1;
        else right = mid;
    }
    return right;
}
function $8b3ab6e98be9ac3d$var$upperBound(array, value) {
    let left = 0;
    let right = array.length;
    let mid = 0;
    while(left < right){
        mid = Math.floor((left + right) / 2);
        if (array[mid] <= value) left = mid + 1;
        else right = mid;
    }
    return right;
}
function $8b3ab6e98be9ac3d$export$dbd5299c7ff33b30(sortedInputs, values, batchSize, numInputs, numValues, side) {
    const output = (0, $lBDHD).getArrayFromDType('int32', batchSize * numValues);
    for(let b = 0; b < batchSize; ++b){
        const sortedInputsSlice = sortedInputs.slice(b * numInputs, (b + 1) * numInputs);
        const outputOffset = b * numValues;
        for(let i = 0; i < numValues; ++i)output[outputOffset + i] = side === 'left' ? $8b3ab6e98be9ac3d$var$lowerBound(sortedInputsSlice, values[i + outputOffset]) : $8b3ab6e98be9ac3d$var$upperBound(sortedInputsSlice, values[i + outputOffset]);
    }
    return output;
}

});


parcelRegister("jRAN6", function(module, exports) {

$parcel$export(module.exports, "selectConfig", function () { return $e75f8176afd9e7c5$export$7ff911e710ee72fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $kKv2E = parcelRequire("kKv2E");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");
function $e75f8176afd9e7c5$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    (0, $wi69v.assertNotComplex)([
        condition,
        t,
        e
    ], 'select');
    const conditionRank = condition.shape.length;
    const values = backend.data.get(condition.dataId).values;
    const tValues = backend.data.get(t.dataId).values;
    const eValues = backend.data.get(e.dataId).values;
    const resultDtype = (0, $kKv2E.upcastType)(t.dtype, e.dtype);
    const newValues = (0, $lBDHD).makeZerosTypedArray((0, $lBDHD).sizeFromShape(t.shape), resultDtype);
    let index = 0;
    const offset = conditionRank === 0 || conditionRank > 1 || t.shape.length === 1 ? 1 : (0, $lBDHD).sizeFromShape(t.shape.slice(1));
    for(let i = 0; i < values.length; i++){
        for(let j = 0; j < offset; j++)if (values[i] === 1) newValues[index++] = tValues[i];
        else newValues[index++] = eValues[i];
    }
    return backend.makeTensorInfo(t.shape, resultDtype, newValues);
}
const $e75f8176afd9e7c5$export$7ff911e710ee72fc = {
    kernelName: (0, $9BGT9.Select),
    backendName: 'cpu',
    kernelFunc: $e75f8176afd9e7c5$export$2e6c959c16ff56b8
};

});

parcelRegister("bKRee", function(module, exports) {

$parcel$export(module.exports, "seluConfig", function () { return $88ed47ac273b32df$export$8afc8558705c1a39; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $88ed47ac273b32df$var$scaleAlpha = (0, $dEVRx).SELU_SCALEALPHA;
const $88ed47ac273b32df$var$scale = (0, $dEVRx).SELU_SCALE;
const $88ed47ac273b32df$export$a5f8240d9e99b438 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Selu), (xi)=>{
    if (xi >= 0) return $88ed47ac273b32df$var$scale * xi;
    else return $88ed47ac273b32df$var$scaleAlpha * (Math.exp(xi) - 1);
});
const $88ed47ac273b32df$export$8afc8558705c1a39 = {
    kernelName: (0, $9BGT9.Selu),
    backendName: 'cpu',
    kernelFunc: $88ed47ac273b32df$export$a5f8240d9e99b438
};

});

parcelRegister("j6cju", function(module, exports) {

$parcel$export(module.exports, "signConfig", function () { return $de78210b63c5e595$export$9c0fb3eb2124ceb7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $de78210b63c5e595$export$c5552dfdbc7cec71 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Sign), (xi)=>{
    if (xi < 0) return -1;
    else if (xi > 0) return 1;
    else return 0;
});
const $de78210b63c5e595$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $9BGT9.Sign),
    backendName: 'cpu',
    kernelFunc: $de78210b63c5e595$export$c5552dfdbc7cec71
};

});

parcelRegister("5jZs7", function(module, exports) {

$parcel$export(module.exports, "sinConfig", function () { return $3dfe654cdfc0696c$export$d993ec4e5c253b66; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $3dfe654cdfc0696c$export$5de3937cb4b592ed = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Sin), (xi)=>Math.sin(xi));
const $3dfe654cdfc0696c$export$d993ec4e5c253b66 = {
    kernelName: (0, $9BGT9.Sin),
    backendName: 'cpu',
    kernelFunc: $3dfe654cdfc0696c$export$5de3937cb4b592ed
};

});

parcelRegister("bBqE7", function(module, exports) {

$parcel$export(module.exports, "sinhConfig", function () { return $8727d1c1ce058c4d$export$b92766b47f18ac85; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $8727d1c1ce058c4d$export$545004b505d7c555 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Sinh), (xi)=>Math.sinh(xi));
const $8727d1c1ce058c4d$export$b92766b47f18ac85 = {
    kernelName: (0, $9BGT9.Sinh),
    backendName: 'cpu',
    kernelFunc: $8727d1c1ce058c4d$export$545004b505d7c555
};

});

parcelRegister("jUwcI", function(module, exports) {

$parcel$export(module.exports, "softplusConfig", function () { return $e7ec3a56375294a6$export$d9bcfe553d12d9e3; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
// mirrors the implementation of tf.nn.softplus: https://goo.gl/vkcvwX
// epsilon is the difference between 1.0 and the next representable float.
// For a single precision 32 bit float this should be 2^-23, see:
// https://math.byu.edu/~schow/work/IEEEFloatingPoint.htm
const $e7ec3a56375294a6$var$epsilon = 1.1920928955078125e-7;
const $e7ec3a56375294a6$var$threshold = Math.log($e7ec3a56375294a6$var$epsilon) + 2.0;
const $e7ec3a56375294a6$export$76aa560a8c2b0055 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Softplus), (xi)=>{
    // Value above which exp(x) may overflow, but softplus(x) == x
    // is within machine epsilon.
    const tooLarge = xi > -$e7ec3a56375294a6$var$threshold;
    // Value below which exp(x) may underflow, but softplus(x) == exp(x)
    // is within machine epsilon.
    const tooSmall = xi < $e7ec3a56375294a6$var$threshold;
    const expX = Math.exp(xi);
    let result;
    if (tooSmall) result = expX;
    else if (tooLarge) result = xi;
    else result = Math.log(1.0 + expX);
    return result;
});
const $e7ec3a56375294a6$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $9BGT9.Softplus),
    backendName: 'cpu',
    kernelFunc: $e7ec3a56375294a6$export$76aa560a8c2b0055
};

});

parcelRegister("jCkjt", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchNDConfig", function () { return $03af81557086170b$export$2f85417863d2050b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $4gZLs = parcelRequire("4gZLs");

var $dOeSU = parcelRequire("dOeSU");

var $joI4E = parcelRequire("joI4E");
function $03af81557086170b$export$effb9d7cae92012f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $wi69v.assertNotComplex)([
        x
    ], 'spaceToBatchND');
    const prod = (0, $lBDHD).sizeFromShape(blockShape);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const paddedX = (0, $4gZLs.padV2Config).kernelFunc({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            paddings: completePaddings,
            constantValue: 0
        }
    });
    const reshapedPaddedShape = (0, $dEVRx).getReshaped(paddedX.shape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $dEVRx).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $dEVRx).getReshapedPermuted(paddedX.shape, blockShape, prod, false);
    const reshapeInputs = {
        x: paddedX
    };
    const reshapeAttrs = {
        shape: reshapedPaddedShape
    };
    const paddedXReshaped = (0, $dOeSU.reshape)({
        inputs: reshapeInputs,
        backend: backend,
        attrs: reshapeAttrs
    });
    const transposeInputs = {
        x: paddedXReshaped
    };
    const transposeAttrs = {
        perm: permutedReshapedPaddedPermutation
    };
    const paddedXT = (0, $joI4E.transpose)({
        inputs: transposeInputs,
        backend: backend,
        attrs: transposeAttrs
    });
    const resultReshapeInputs = {
        x: paddedXT
    };
    const resultReshapeAttrs = {
        shape: flattenShape
    };
    const result = (0, $dOeSU.reshape)({
        inputs: resultReshapeInputs,
        backend: backend,
        attrs: resultReshapeAttrs
    });
    backend.disposeIntermediateTensorInfo(paddedX);
    backend.disposeIntermediateTensorInfo(paddedXReshaped);
    backend.disposeIntermediateTensorInfo(paddedXT);
    return result;
}
const $03af81557086170b$export$2f85417863d2050b = {
    kernelName: (0, $9BGT9.SpaceToBatchND),
    backendName: 'cpu',
    kernelFunc: $03af81557086170b$export$effb9d7cae92012f
};

});

parcelRegister("40gFl", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRowsConfig", function () { return $2ea417022bca3ef8$export$818286c593224d1a; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $5GI8X = parcelRequire("5GI8X");
function $2ea417022bca3ef8$export$c82a1904a15b5028(args) {
    const { inputs: inputs, backend: backend } = args;
    const { indices: indices, values: values, denseShape: denseShape, defaultValue: defaultValue } = inputs;
    if (denseShape.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
        ${denseShape.shape}`);
    if (indices.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
        ${indices.shape}`);
    if (values.shape.length !== 1) throw new Error(`Values must be a vector, saw:
        ${values.shape}`);
    if (defaultValue.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
    const $indices = backend.data.get(indices.dataId).values;
    const $values = backend.data.get(values.dataId).values;
    const $denseShape = backend.data.get(denseShape.dataId).values;
    const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
    const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = (0, $5GI8X.sparseFillEmptyRowsImpl)($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
    return [
        backend.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
        backend.makeTensorInfo([
            outputIndicesShape[0]
        ], values.dtype, outputValues),
        backend.makeTensorInfo([
            emptyRowIndicator.length
        ], 'bool', new Uint8Array(emptyRowIndicator.map((value)=>Number(value)))),
        backend.makeTensorInfo([
            reverseIndexMap.length
        ], indices.dtype, new Int32Array(reverseIndexMap))
    ];
}
const $2ea417022bca3ef8$export$818286c593224d1a = {
    kernelName: (0, $9BGT9.SparseFillEmptyRows),
    backendName: 'cpu',
    kernelFunc: $2ea417022bca3ef8$export$c82a1904a15b5028
};

});
parcelRegister("5GI8X", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRowsImpl", function () { return $42431dfeaa0a530d$export$9db01208a1bec190; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");
function $42431dfeaa0a530d$export$9db01208a1bec190(indices, indicesShape, indicesDType, values, valuesDType, denseShape, defaultValue) {
    const indicesCount = indicesShape[0];
    const denseRows = denseShape[0];
    const emptyRowIndicator = new Array(denseRows);
    const reverseIndexMap = new Array(indicesCount);
    const rank = indicesShape[1];
    if (denseRows === 0) {
        if (indicesCount !== 0) throw new Error((0, $dEVRx).getSparseFillEmptyRowsIndicesDenseShapeMismatch(indicesCount));
        const outputIndices = (0, $lBDHD).getArrayFromDType(indicesDType, 0);
        const outputValues = (0, $lBDHD).getArrayFromDType(valuesDType, 0);
        return [
            outputIndices,
            [
                0,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    }
    let rowsAreOrdered = true;
    let lastIndicesRow = 0;
    const csrOffset = new Array(denseRows).fill(0);
    for(let i = 0; i < indicesCount; ++i){
        // indices is a 2d tensor with shape of [N, rank]
        const row = indices[i * rank];
        if (row < 0) throw new Error((0, $dEVRx).getSparseFillEmptyRowsNegativeIndexErrorMessage(i, row));
        if (row >= denseRows) throw new Error((0, $dEVRx).getSparseFillEmptyRowsOutOfRangeIndexErrorMessage(i, row, denseRows));
        ++csrOffset[row];
        rowsAreOrdered = rowsAreOrdered && row >= lastIndicesRow;
        lastIndicesRow = row;
    }
    let allRowsFull = true;
    for(let row = 0; row < denseRows; ++row){
        // csrOffset here describes the number of elements in this dense row
        const rowEmpty = csrOffset[row] === 0;
        emptyRowIndicator[row] = rowEmpty;
        allRowsFull = allRowsFull && !rowEmpty;
        // In filled version, each row has at least one element.
        csrOffset[row] = Math.max(csrOffset[row], 1);
        // Update csrOffset to represent the number of elements up to and
        // including denseRows + 1:
        //  csrOffset[0] == #{elements of row 0}
        //  csrOffset[1] == #{elements of row 1} + #{elements of row 0}
        //  ..
        //  csrOffset[i] == starting index for elements in row i + 1.
        if (row > 0) csrOffset[row] += csrOffset[row - 1];
    }
    if (allRowsFull && rowsAreOrdered) {
        const outputIndices = indices;
        const outputValues = values;
        for(let i = 0; i < indicesCount; ++i)reverseIndexMap[i] = i;
        return [
            outputIndices,
            [
                indicesCount,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    } else {
        const fullIndicesCount = csrOffset[denseRows - 1];
        const outputIndices = (0, $lBDHD).getArrayFromDType(indicesDType, fullIndicesCount * rank);
        const outputValues = (0, $lBDHD).getArrayFromDType(valuesDType, fullIndicesCount);
        const filledCount = new Array(denseRows).fill(0);
        // Fill in values for rows that are not missing
        for(let i = 0; i < indicesCount; ++i){
            // indices is a 2d tensor with shape of [N, rank]
            const row = indices[i * rank];
            const offset = filledCount[row];
            const outputI = (row === 0 ? 0 : csrOffset[row - 1]) + offset;
            filledCount[row]++; // Increment the filled count for this row.
            for(let j = 0; j < rank; ++j)// indices and outputIndices are 2d tensors with shape of [N, rank]
            outputIndices[outputI * rank + j] = indices[i * rank + j];
            outputValues[outputI] = values[i];
            // We'll need this reverse index map to backprop correctly.
            reverseIndexMap[i] = outputI;
        }
        // Fill in values for rows that are missing
        for(let row = 0; row < denseRows; ++row){
            const rowCount = filledCount[row];
            if (rowCount === 0) {
                const startingIndex = row === 0 ? 0 : csrOffset[row - 1];
                // Remaining index values were set to zero already.
                // Just need to set the row index in the right location.
                // outputIndices is a 2d tensor with shape of [N, rank]
                outputIndices[startingIndex * rank + 0] = row;
                for(let col = 1; col < rank; ++col)outputIndices[startingIndex * rank + col] = 0;
                outputValues[startingIndex] = defaultValue;
            }
        }
        return [
            outputIndices,
            [
                fullIndicesCount,
                rank
            ],
            outputValues,
            emptyRowIndicator,
            reverseIndexMap
        ];
    }
}

});


parcelRegister("1XdE4", function(module, exports) {

$parcel$export(module.exports, "sparseReshapeConfig", function () { return $16c5e2cc19cb094b$export$eb106efc10374803; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $h0C13 = parcelRequire("h0C13");
function $16c5e2cc19cb094b$export$1408c45865e11fc6(args) {
    const { inputs: inputs, backend: backend } = args;
    const { inputIndices: inputIndices, inputShape: inputShape, newShape: newShape } = inputs;
    if (inputIndices.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape
        ${inputIndices.shape}`);
    if (inputShape.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape
        ${inputShape.shape}`);
    if (newShape.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
    const $inputShape = Array.from(backend.data.get(inputShape.dataId).values);
    const $inputIndices = backend.data.get(inputIndices.dataId).values;
    const targetShape = Array.from(backend.data.get(newShape.dataId).values);
    const [newIndices, indicesShape, outputShape] = (0, $h0C13.sparseReshapeImpl)($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
    return [
        backend.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
        backend.makeTensorInfo([
            outputShape.length
        ], newShape.dtype, new Int32Array(outputShape))
    ];
}
const $16c5e2cc19cb094b$export$eb106efc10374803 = {
    kernelName: (0, $9BGT9.SparseReshape),
    backendName: 'cpu',
    kernelFunc: $16c5e2cc19cb094b$export$1408c45865e11fc6
};

});
parcelRegister("h0C13", function(module, exports) {

$parcel$export(module.exports, "sparseReshapeImpl", function () { return $c61fecf62ae41317$export$a65a15ebab81f5cd; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");
function $c61fecf62ae41317$export$a65a15ebab81f5cd(inputIndices, inputIndicesShape, inputDType, inputShape, targetShape) {
    const denseSize = (0, $lBDHD).sizeFromShape(inputShape);
    const nnz = inputIndicesShape[0];
    const outputRank = targetShape.length;
    // Compute the output shape. Determine product of specified dimensions, and
    // find the index of the unspecified one.
    const outputShape = [];
    let product = 1;
    let unknownIndex = -1;
    for(let d = 0; d < outputRank; ++d){
        const size = targetShape[d];
        if (size === -1) {
            if (unknownIndex !== -1) throw new Error((0, $dEVRx).getSparseReshapeMultipleNegativeOneOutputDimErrorMessage(unknownIndex, d));
            unknownIndex = d;
            outputShape.push(1);
        } else {
            if (size < 0) throw new Error((0, $dEVRx).getSparseReshapeNegativeOutputDimErrorMessage(d, size));
            product *= size;
            outputShape.push(size);
        }
    }
    if (unknownIndex !== -1) {
        if (product <= 0) throw new Error((0, $dEVRx).getSparseReshapeEmptyTensorZeroOutputDimErrorMessage());
        const missing = Math.trunc(denseSize / product);
        if (product * missing !== denseSize) throw new Error((0, $dEVRx).getSparseReshapeInputOutputMultipleErrorMessage(inputShape, outputShape));
        outputShape[unknownIndex] = missing;
    }
    const outputSize = (0, $lBDHD).sizeFromShape(outputShape);
    if (outputSize !== denseSize) throw new Error((0, $dEVRx).getSparseReshapeInputOutputMismatchErrorMessage(inputShape, outputShape));
    const inputRank = inputShape.length;
    const inputStrides = [];
    if (inputRank > 0) {
        inputStrides[inputRank - 1] = 1;
        for(let d = inputRank - 2; d >= 0; --d)inputStrides[d] = inputStrides[d + 1] * inputShape[d + 1];
    }
    const outputStrides = [];
    if (outputRank > 0) {
        outputStrides[outputRank - 1] = 1;
        for(let d = outputRank - 2; d >= 0; --d)outputStrides[d] = outputStrides[d + 1] * outputShape[d + 1];
    }
    const newIndices = (0, $lBDHD).getArrayFromDType(inputDType, nnz * outputRank);
    for(let i = 0; i < nnz; ++i){
        let id = 0;
        for(let j = 0; j < inputRank; ++j)// inputIndices is a 2d tensor with shape of [nnz, inputRank]
        id += inputIndices[i * inputRank + j] * inputStrides[j];
        for(let j = 0; j < outputRank; ++j){
            // newIndices is a 2d tensor with shape of [nnz, outputRank]
            newIndices[i * outputRank + j] = Math.trunc(id / outputStrides[j]);
            id %= outputStrides[j];
        }
    }
    return [
        newIndices,
        [
            nnz,
            outputRank
        ],
        outputShape
    ];
}

});


parcelRegister("73WGk", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentMeanConfig", function () { return $5246552a1bf6dd4f$export$51e7224ae14d7f78; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bVemu = parcelRequire("bVemu");
function $5246552a1bf6dd4f$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
          ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
          ${segmentIds.shape}`);
    if (indices.shape[0] !== segmentIds.shape[0]) throw new Error(`segmentIds and indices should have same size.`);
    const $data = backend.data.get(data.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const $segmentIds = backend.data.get(segmentIds.dataId).values;
    const [outputData, outputDataShape] = (0, $bVemu.sparseSegmentReductionImpl)($data, data.shape, data.dtype, $indices, $segmentIds, true);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $5246552a1bf6dd4f$export$51e7224ae14d7f78 = {
    kernelName: (0, $9BGT9.SparseSegmentMean),
    backendName: 'cpu',
    kernelFunc: $5246552a1bf6dd4f$export$dbc0c9096869d04e
};

});
parcelRegister("bVemu", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentReductionImpl", function () { return $8ae028872e9a2c92$export$7d3f7130c4245e65; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");
function $8ae028872e9a2c92$export$7d3f7130c4245e65(input, inputShape, inputDType, indices, segmentIds, isMean = false, defaultValue = 0) {
    const numIndices = indices.length;
    // Flatten the array to two dimensions
    const inputFlat = [
        inputShape[0],
        input.length / inputShape[0]
    ];
    const numCol = inputFlat[1];
    // Note that the current implementation assumes that segmentIds values are
    // sorted.
    const lastSegmentIdPlusOne = numIndices > 0 ? segmentIds[numIndices - 1] + 1 : 0;
    const outputRows = lastSegmentIdPlusOne;
    if (outputRows < 0) throw new Error((0, $dEVRx).getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
    const outputShape = inputShape.slice();
    outputShape[0] = outputRows;
    const outputLength = outputShape.reduce((product, value)=>product * value, 1);
    // Output array is initialized with the value 0 by default.
    const output = (0, $lBDHD).getArrayFromDType(inputDType, outputLength);
    // Note that we do not initialize the output buffer with a default value, so
    // we need to explicitly set missing indices to the default value.
    if (numIndices === 0) {
        if (outputRows > 0) output.fill(defaultValue);
        return [
            output,
            outputShape
        ];
    }
    if (outputRows <= 0) throw new Error((0, $dEVRx).getSparseSegmentReductionNegativeSegmentIdsErrorMessage());
    let start = 0, end = 1;
    // Index from which the output is not initialized.
    let uninitializedIndex = 0;
    let outIndex = segmentIds[start];
    while(true){
        // We initialize nextIndex to 0 to avoid may be uninitialized warning
        let nextIndex = 0;
        if (end < numIndices) {
            nextIndex = segmentIds[end];
            if (outIndex === nextIndex) {
                ++end;
                continue;
            }
            // We have a new segment here.  Verify that the segment ids are growing.
            if (outIndex >= nextIndex) throw new Error((0, $dEVRx).getSparseSegmentReductionNonIncreasingSegmentIdsErrorMessage());
        }
        if (outIndex < 0 || outIndex >= outputRows) throw new Error((0, $dEVRx).getSparseSegmentReductionSegmentIdOutOfRangeErrorMessage(outIndex, outputRows));
        // If there is a gap between two indices, we need to set that gap to the
        // default value.
        if (outIndex > uninitializedIndex) output.fill(defaultValue, uninitializedIndex * numCol, outIndex * numCol);
        for(let i = start; i < end; ++i){
            const index = indices[i];
            if (index < 0 || index >= inputFlat[0]) throw new Error((0, $dEVRx).getSparseSegmentReductionIndicesOutOfRangeErrorMessage(i, indices[i], inputFlat[0]));
            for(let j = 0; j < numCol; j++)output[outIndex * numCol + j] += input[index * numCol + j];
        }
        if (isMean) for(let j = 0; j < numCol; j++)output[outIndex * numCol + j] /= end - start;
        start = end;
        ++end;
        uninitializedIndex = outIndex + 1;
        outIndex = nextIndex;
        if (end > numIndices) break;
    }
    // Fill the gap at the end with the default value.
    if (uninitializedIndex < outputRows) output.fill(defaultValue, uninitializedIndex * numCol, outputRows * numCol);
    return [
        output,
        outputShape
    ];
}

});


parcelRegister("hTBT7", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentSumConfig", function () { return $d074f6777e58a755$export$73fa0270f28b9555; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bVemu = parcelRequire("bVemu");
function $d074f6777e58a755$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
         ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
         ${segmentIds.shape}`);
    if (indices.shape[0] !== segmentIds.shape[0]) throw new Error(`segmentIds and indices should have same size.`);
    const $data = backend.data.get(data.dataId).values;
    const $indices = backend.data.get(indices.dataId).values;
    const $segmentIds = backend.data.get(segmentIds.dataId).values;
    const [outputData, outputDataShape] = (0, $bVemu.sparseSegmentReductionImpl)($data, data.shape, data.dtype, $indices, $segmentIds);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $d074f6777e58a755$export$73fa0270f28b9555 = {
    kernelName: (0, $9BGT9.SparseSegmentSum),
    backendName: 'cpu',
    kernelFunc: $d074f6777e58a755$export$2255ce53fc777865
};

});

parcelRegister("jYTdj", function(module, exports) {

$parcel$export(module.exports, "sparseToDenseConfig", function () { return $e8be7336de4e95b9$export$7bc088f8ad44ef99; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $eI5eD = parcelRequire("eI5eD");
function $e8be7336de4e95b9$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $dEVRx).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    const indicesBuf = backend.bufferSync(sparseIndices);
    let outBuf;
    switch(sparseValues.dtype){
        case 'bool':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = Boolean(backend.data.get(defaultValue.dataId).values[0]);
                outBuf = (0, $eI5eD.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'float32':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
                outBuf = (0, $eI5eD.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'int32':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = backend.data.get(defaultValue.dataId).values[0];
                outBuf = (0, $eI5eD.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        case 'string':
            {
                const updatesBuf = backend.bufferSync(sparseValues);
                const $defaultValue = (0, $lBDHD).decodeString(backend.data.get(defaultValue.dataId).values[0]);
                outBuf = (0, $eI5eD.scatterImpl)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
                break;
            }
        default:
            throw new Error(`Unsupported type ${sparseValues.dtype}`);
    }
    return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
}
const $e8be7336de4e95b9$export$7bc088f8ad44ef99 = {
    kernelName: (0, $9BGT9.SparseToDense),
    backendName: 'cpu',
    kernelFunc: $e8be7336de4e95b9$export$1be4b823dd1a3080
};

});

parcelRegister("3yZvF", function(module, exports) {

$parcel$export(module.exports, "splitVConfig", function () { return $2984429d18cc1563$export$317be24be3af9ea0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $59DpV = parcelRequire("59DpV");
function $2984429d18cc1563$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $lBDHD).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $dEVRx).prepareSplitSize(x, numOrSizeSplits, $axis);
    const begin = new Array(x.shape.length).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $59DpV.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $2984429d18cc1563$export$317be24be3af9ea0 = {
    kernelName: (0, $9BGT9.SplitV),
    backendName: 'cpu',
    kernelFunc: $2984429d18cc1563$export$c0085d48b0a75d8f
};

});

parcelRegister("e5xGp", function(module, exports) {

$parcel$export(module.exports, "sqrtImpl", function () { return $a41ba911c04f383d$export$c6f4fdf945028fb; });
$parcel$export(module.exports, "sqrtConfig", function () { return $a41ba911c04f383d$export$a592ba9268f10eeb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $a41ba911c04f383d$export$c6f4fdf945028fb = (0, $cfLEm.createSimpleUnaryImpl)((xi)=>Math.sqrt(xi));
const $a41ba911c04f383d$export$eba8049fb5020b81 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Sqrt), (xi)=>Math.sqrt(xi));
const $a41ba911c04f383d$export$a592ba9268f10eeb = {
    kernelName: (0, $9BGT9.Sqrt),
    backendName: 'cpu',
    kernelFunc: $a41ba911c04f383d$export$eba8049fb5020b81
};

});

parcelRegister("5HMOv", function(module, exports) {

$parcel$export(module.exports, "squareConfig", function () { return $4276d543b5eb83c3$export$7c77bece4d51efc4; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");
const $4276d543b5eb83c3$export$7c77bece4d51efc4 = {
    kernelName: (0, $9BGT9.Square),
    backendName: 'cpu',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const cpuBackend = backend;
        (0, $wi69v.assertNotComplex)(x, 'square');
        const values = cpuBackend.data.get(x.dataId).values;
        const newValues = new Float32Array(values.length);
        for(let i = 0; i < values.length; ++i){
            const value = values[i];
            newValues[i] = value * value;
        }
        const dataId = cpuBackend.write(newValues, x.shape, x.dtype);
        return {
            dataId: dataId,
            shape: x.shape,
            dtype: x.dtype
        };
    }
};

});

parcelRegister("aIdWo", function(module, exports) {

$parcel$export(module.exports, "squaredDifferenceImpl", function () { return $7cc8d3cfb99262a7$export$11806d7b3158c032; });
$parcel$export(module.exports, "squaredDifferenceConfig", function () { return $7cc8d3cfb99262a7$export$9ed4691d69db8a43; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bhNFZ = parcelRequire("bhNFZ");

var $bvj2l = parcelRequire("bvj2l");
const $7cc8d3cfb99262a7$export$11806d7b3158c032 = (0, $bhNFZ.createSimpleBinaryKernelImpl)((a, b)=>{
    const diff = a - b;
    return diff * diff;
});
const $7cc8d3cfb99262a7$export$b178697fb6d0b37f = (0, $bvj2l.binaryKernelFunc)((0, $9BGT9.SquaredDifference), $7cc8d3cfb99262a7$export$11806d7b3158c032);
const $7cc8d3cfb99262a7$export$9ed4691d69db8a43 = {
    kernelName: (0, $9BGT9.SquaredDifference),
    backendName: 'cpu',
    kernelFunc: $7cc8d3cfb99262a7$export$b178697fb6d0b37f
};

});

parcelRegister("h11VZ", function(module, exports) {

$parcel$export(module.exports, "staticRegexReplaceImpl", function () { return $c63407c26aa7ca69$export$d0ac9d977b12e2a1; });
$parcel$export(module.exports, "staticRegexReplaceConfig", function () { return $c63407c26aa7ca69$export$1069b2f6977254f4; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $cfLEm = parcelRequire("cfLEm");

var $6wQye = parcelRequire("6wQye");
const $c63407c26aa7ca69$export$d0ac9d977b12e2a1 = (0, $cfLEm.createSimpleUnaryImpl)((x, attrs)=>{
    const { pattern: pattern, replaceGlobal: replaceGlobal, rewrite: rewrite } = attrs;
    // TODO(mattSoulanille): Don't create a regex each time.
    return x.replace(new RegExp(pattern, replaceGlobal ? 'g' : ''), rewrite);
});
const $c63407c26aa7ca69$var$staticRegexReplace = (0, $6wQye.unaryKernelFuncFromImpl)((0, $9BGT9.StaticRegexReplace), $c63407c26aa7ca69$export$d0ac9d977b12e2a1);
const $c63407c26aa7ca69$export$1069b2f6977254f4 = {
    kernelName: (0, $9BGT9.StaticRegexReplace),
    backendName: 'cpu',
    kernelFunc: $c63407c26aa7ca69$var$staticRegexReplace
};

});

parcelRegister("1SMNA", function(module, exports) {

$parcel$export(module.exports, "stepConfig", function () { return $15f0b007754aa5d0$export$c42ffaf52eb2647; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $15f0b007754aa5d0$export$35d34bc0ed591a92 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Step), (xi, attrs)=>{
    const stepAttrs = attrs;
    if (isNaN(xi)) return NaN;
    else return xi > 0 ? 1 : stepAttrs.alpha;
});
const $15f0b007754aa5d0$export$c42ffaf52eb2647 = {
    kernelName: (0, $9BGT9.Step),
    backendName: 'cpu',
    kernelFunc: $15f0b007754aa5d0$export$35d34bc0ed591a92
};

});

parcelRegister("bJaiT", function(module, exports) {

$parcel$export(module.exports, "stridedSliceConfig", function () { return $889be3cb1e929f4a$export$81773633114187bd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $iEcDD = parcelRequire("iEcDD");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $dOeSU = parcelRequire("dOeSU");

var $59DpV = parcelRequire("59DpV");

var $lxY5y = parcelRequire("lxY5y");
function $889be3cb1e929f4a$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'stridedSlice');
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $iEcDD).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    // ref:
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/strided_slice_op.cc
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $dOeSU.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $lBDHD).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $iEcDD).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $59DpV.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $dOeSU.reshape)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeIntermediateTensorInfo(sliced);
    } else {
        const xBuf = backend.bufferSync(x);
        const outBuf = (0, $lxY5y.stridedSliceImpl)(finalShapeSparse, xBuf, $strides, $begin);
        result = backend.makeTensorInfo(finalShape, outBuf.dtype, outBuf.values);
    }
    return result;
}
const $889be3cb1e929f4a$export$81773633114187bd = {
    kernelName: (0, $9BGT9.StridedSlice),
    backendName: 'cpu',
    kernelFunc: $889be3cb1e929f4a$export$4ae57224f3b0605c
};

});
parcelRegister("lxY5y", function(module, exports) {

$parcel$export(module.exports, "stridedSliceImpl", function () { return $fafb4a67fcb89e28$export$b7c450ffe7e10d88; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
function $fafb4a67fcb89e28$export$b7c450ffe7e10d88(outShape, xBuf, strides, begin) {
    const outBuf = (0, $5siju.buffer)(outShape, xBuf.dtype);
    for(let i = 0; i < outBuf.size; i++){
        const loc = outBuf.indexToLoc(i);
        const newLoc = new Array(loc.length);
        for(let j = 0; j < newLoc.length; j++)newLoc[j] = loc[j] * strides[j] + begin[j];
        outBuf.set(xBuf.get(...newLoc), ...loc);
    }
    return outBuf;
}

});


parcelRegister("iD02Q", function(module, exports) {

$parcel$export(module.exports, "stringNGramsConfig", function () { return $d8fbe76653dec7d2$export$35e13284eed34c22; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $HdgEZ = parcelRequire("HdgEZ");
function $d8fbe76653dec7d2$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.data.get(data.dataId).values;
    const $dataSplits = backend.data.get(dataSplits.dataId).values;
    const [nGrams, nGramsSplits] = (0, $HdgEZ.stringNGramsImpl)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $d8fbe76653dec7d2$export$35e13284eed34c22 = {
    kernelName: (0, $9BGT9.StringNGrams),
    backendName: 'cpu',
    kernelFunc: $d8fbe76653dec7d2$export$3490514dcc63b044
};

});
parcelRegister("HdgEZ", function(module, exports) {

$parcel$export(module.exports, "stringNGramsImpl", function () { return $081e4ef563fe5c14$export$67c0958e8184138b; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
/**
 * The StringNGramsOp class creates ngrams from ragged string data.
 * The constructor contains all attributes related to the operation such as
 * padding widths and strings, and the compute function can be used to
 * compute the ngrams for different ragged tensor inputs.
 */ class $081e4ef563fe5c14$var$StringNGramsOp {
    constructor(separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences){
        this.separator = (0, $lBDHD).encodeString(separator);
        this.nGramWidths = nGramWidths;
        this.leftPad = (0, $lBDHD).encodeString(leftPad);
        this.rightPad = (0, $lBDHD).encodeString(rightPad);
        this.padWidth = padWidth;
        this.preserveShort = preserveShortSequences;
    }
    getPadWidth(nGramWidth) {
        // Ngrams can be padded with either a fixed pad width or a dynamic pad
        // width depending on the 'padWidth' arg, but in no case should the padding
        // ever be wider than 'nGramWidth' - 1.
        return Math.min(this.padWidth < 0 ? nGramWidth - 1 : this.padWidth, nGramWidth - 1);
    }
    getNumNGrams(length, nGramWidth) {
        const padWidth = this.getPadWidth(nGramWidth);
        return Math.max(0, length + 2 * padWidth - nGramWidth + 1);
    }
    createNGrams(data, splitIndex, output, outputStartIndex, numNGrams, nGramWidth) {
        for(let nGramIndex = 0; nGramIndex < numNGrams; ++nGramIndex){
            const padWidth = this.getPadWidth(nGramWidth);
            const leftPadding = Math.max(0, padWidth - nGramIndex);
            const rightPadding = Math.max(0, padWidth - (numNGrams - (nGramIndex + 1)));
            const numTokens = nGramWidth - (leftPadding + rightPadding);
            const dataStartIndex = splitIndex + (leftPadding > 0 ? 0 : nGramIndex - padWidth);
            // Calculate the total expected size of the nGram so we can reserve the
            // correct amount of space in the string.
            let nGramSize = 0;
            // Size of the left padding.
            nGramSize += leftPadding * this.leftPad.length;
            // Size of the tokens.
            for(let n = 0; n < numTokens; ++n)nGramSize += data[dataStartIndex + n].length;
            // Size of the right padding.
            nGramSize += rightPadding * this.rightPad.length;
            // Size of the separators.
            const numSeparators = leftPadding + rightPadding + numTokens - 1;
            nGramSize += numSeparators * this.separator.length;
            // Build the nGram.
            output[outputStartIndex + nGramIndex] = new Uint8Array(nGramSize);
            const nGram = output[outputStartIndex + nGramIndex];
            let nextNGramIndex = 0;
            const appendToNGram = (str)=>str.forEach((value)=>nGram[nextNGramIndex++] = value);
            for(let n = 0; n < leftPadding; ++n){
                appendToNGram(this.leftPad);
                appendToNGram(this.separator);
            }
            // Only output first numTokens - 1 pairs of data and separator
            for(let n = 0; n < numTokens - 1; ++n){
                appendToNGram(data[dataStartIndex + n]);
                appendToNGram(this.separator);
            }
            // Handle case when there are no tokens or no right padding as these
            // can result in consecutive separators.
            if (numTokens > 0) {
                // If we have tokens, then output last and then pair each separator
                // with the right padding that follows, to ensure nGram ends either with
                // the token or with the right pad.
                appendToNGram(data[dataStartIndex + numTokens - 1]);
                for(let n = 0; n < rightPadding; ++n){
                    appendToNGram(this.separator);
                    appendToNGram(this.rightPad);
                }
            } else {
                // If we don't have tokens, then the last item inserted into the nGram
                // has been the separator from the left padding loop above. Hence,
                // output right pad and separator and make sure to finish with a
                // padding, not a separator.
                for(let n = 0; n < rightPadding - 1; ++n){
                    appendToNGram(this.rightPad);
                    appendToNGram(this.separator);
                }
                appendToNGram(this.rightPad);
            }
        }
    }
    // Data and splits together form the definition of the ragged tensor,
    // where data is 1 dimensional and contains the values of the tensor
    // and splits denotes the indices at which each row starts.
    compute(data, splits) {
        // Validate that the splits are valid indices into data, only if there are
        // splits specified.
        const inputDataSize = data.length;
        const splitsSize = splits.length;
        if (splitsSize > 0) {
            let prevSplit = splits[0];
            if (prevSplit !== 0) throw new Error(`First split value must be 0, got ${prevSplit}`);
            for(let i = 1; i < splitsSize; ++i){
                let validSplits = splits[i] >= prevSplit;
                validSplits = validSplits && splits[i] <= inputDataSize;
                if (!validSplits) throw new Error(`Invalid split value ${splits[i]}, must be in [${prevSplit}, ${inputDataSize}]`);
                prevSplit = splits[i];
            }
            if (prevSplit !== inputDataSize) throw new Error(`Last split value must be data size. Expected ${inputDataSize}, got ${prevSplit}`);
        }
        const numBatchItems = splitsSize - 1;
        const nGramsSplits = (0, $lBDHD).getArrayFromDType('int32', splitsSize);
        // If there is no data or size, return an empty ragged tensor.
        if (inputDataSize === 0 || splitsSize === 0) {
            const empty = new Array(inputDataSize);
            for(let i = 0; i <= numBatchItems; ++i)nGramsSplits[i] = 0;
            return [
                empty,
                nGramsSplits
            ];
        }
        nGramsSplits[0] = 0;
        for(let i = 1; i <= numBatchItems; ++i){
            const length = splits[i] - splits[i - 1];
            let numNGrams = 0;
            this.nGramWidths.forEach((nGramWidth)=>{
                numNGrams += this.getNumNGrams(length, nGramWidth);
            });
            if (this.preserveShort && length > 0 && numNGrams === 0) numNGrams = 1;
            nGramsSplits[i] = nGramsSplits[i - 1] + numNGrams;
        }
        const nGrams = new Array(nGramsSplits[numBatchItems]);
        for(let i = 0; i < numBatchItems; ++i){
            const splitIndex = splits[i];
            let outputStartIdx = nGramsSplits[i];
            this.nGramWidths.forEach((nGramWidth)=>{
                const length = splits[i + 1] - splits[i];
                const numNGrams = this.getNumNGrams(length, nGramWidth);
                this.createNGrams(data, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
                outputStartIdx += numNGrams;
            });
            // If we're preserving short sequences, check to see if no sequence was
            // generated by comparing the current output start idx to the original
            // one (nGramSplitsdata). If no ngrams were generated, then they will
            // be equal (since we increment outputStartIdx by numNGrams every
            // time we create a set of ngrams.)
            if (this.preserveShort && outputStartIdx === nGramsSplits[i]) {
                const dataLength = splits[i + 1] - splits[i];
                // One legitimate reason to not have any ngrams when this.preserveShort
                // is true is if the sequence itself is empty. In that case, move on.
                if (dataLength === 0) continue;
                // We don't have to worry about dynamic padding sizes here: if padding
                // was dynamic, every sequence would have had sufficient padding to
                // generate at least one nGram.
                const nGramWidth = dataLength + 2 * this.padWidth;
                const numNGrams = 1;
                this.createNGrams(data, splitIndex, nGrams, outputStartIdx, numNGrams, nGramWidth);
            }
        }
        return [
            nGrams,
            nGramsSplits
        ];
    }
}
function $081e4ef563fe5c14$export$67c0958e8184138b(data, dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences) {
    return new $081e4ef563fe5c14$var$StringNGramsOp(separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences).compute(data, dataSplits);
}

});


parcelRegister("hpxIk", function(module, exports) {

$parcel$export(module.exports, "stringSplitConfig", function () { return $caceec612c0c37d1$export$c51cbbd627a96532; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $kir6G = parcelRequire("kir6G");
function $caceec612c0c37d1$export$aa7f8babb17e7672(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { skipEmpty: skipEmpty } = attrs;
    const { input: input, delimiter: delimiter } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (input.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${input.shape}`);
    if (delimiter.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
    const $input = backend.data.get(input.dataId).values;
    const $delimiter = backend.data.get(delimiter.dataId).values[0];
    const [indices, values, shape] = (0, $kir6G.stringSplitImpl)($input, $delimiter, skipEmpty);
    const outputSize = values.length;
    return [
        backend.makeTensorInfo([
            outputSize,
            2
        ], 'int32', indices),
        backend.makeTensorInfo([
            outputSize
        ], 'string', values),
        backend.makeTensorInfo([
            2
        ], 'int32', new Int32Array(shape))
    ];
}
const $caceec612c0c37d1$export$c51cbbd627a96532 = {
    kernelName: (0, $9BGT9.StringSplit),
    backendName: 'cpu',
    kernelFunc: $caceec612c0c37d1$export$aa7f8babb17e7672
};

});
parcelRegister("kir6G", function(module, exports) {

$parcel$export(module.exports, "stringSplitImpl", function () { return $ec6a83eef0197a93$export$c3b08e43aa36d65d; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $ec6a83eef0197a93$var$split(str, delimiters, skipEmpty, result) {
    if (!str.length) return;
    // When the delimiter is empty, the input is split into individual characters.
    if (delimiters.length === 0) {
        for(let i = 0; i < str.length; ++i)result.push(str.subarray(i, i + 1));
        return;
    }
    // When there is one delimiter, the input is split only at that delimiter.
    if (delimiters.length === 1) {
        const delimiter = delimiters[0];
        let f = str.indexOf(delimiter);
        while(f !== -1){
            const token = str.subarray(0, f);
            if (!skipEmpty || token.length !== 0) result.push(token);
            str = str.subarray(f + 1);
            f = str.indexOf(delimiter);
        }
        if (!skipEmpty || str.length !== 0) result.push(str);
        return;
    }
    // When there are multiple delimiters, the input is split at every instance
    // one of the delimiters appears.
    let tokenStart = 0;
    for(let i = 0; i < str.length + 1; i++)if (i === str.length || delimiters.indexOf(str[i]) !== -1) {
        const token = str.subarray(tokenStart, i);
        if (!skipEmpty || token.length !== 0) result.push(token);
        tokenStart = i + 1;
    }
}
function $ec6a83eef0197a93$export$c3b08e43aa36d65d(input, delimiter, skipEmpty) {
    const batchSize = input.length;
    // Empty delimiter means split the input character by character.
    const tokens = [];
    let outputSize = 0;
    let maxNumEntries = 0;
    const numIndices = new Array(batchSize);
    for(let i = 0; i < batchSize; ++i){
        const prevTokensLength = tokens.length;
        $ec6a83eef0197a93$var$split(input[i], delimiter, skipEmpty, tokens);
        const nEntries = tokens.length - prevTokensLength;
        numIndices[i] = nEntries;
        outputSize += nEntries;
        maxNumEntries = Math.max(maxNumEntries, nEntries);
    }
    const indices = (0, $lBDHD).getArrayFromDType('int32', outputSize * 2);
    const values = new Array(outputSize);
    const shape = [
        batchSize,
        maxNumEntries
    ];
    let c = 0;
    for(let i = 0; i < batchSize; ++i)for(let j = 0; j < numIndices[i]; ++j){
        // indices is a 2d tensor with shape of [outputSize, 2]
        indices[c * 2] = i;
        indices[c * 2 + 1] = j;
        values[c] = tokens[c];
        ++c;
    }
    return [
        indices,
        values,
        shape
    ];
}

});


parcelRegister("76mFA", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFastConfig", function () { return $52baadae13197eac$export$a88a78b2b233f507; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $5vxaZ = parcelRequire("5vxaZ");
function $52baadae13197eac$export$6195616d6fd0c848(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { numBuckets: numBuckets } = attrs;
    const { input: input } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const $input = backend.data.get(input.dataId).values;
    const output = (0, $5vxaZ.stringToHashBucketFastImpl)($input, numBuckets);
    return backend.makeTensorInfo(input.shape, 'int32', output);
}
const $52baadae13197eac$export$a88a78b2b233f507 = {
    kernelName: (0, $9BGT9.StringToHashBucketFast),
    backendName: 'cpu',
    kernelFunc: $52baadae13197eac$export$6195616d6fd0c848
};

});
parcelRegister("5vxaZ", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFastImpl", function () { return $40299521f01d6282$export$37cbed4d0b2fe56a; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $40299521f01d6282$export$37cbed4d0b2fe56a(input, numBuckets) {
    const output = (0, $lBDHD).getArrayFromDType('int32', input.length);
    for(let i = 0; i < input.length; ++i)output[i] = (0, $lBDHD).fingerPrint64(input[i]).modulo(numBuckets).getLowBitsUnsigned();
    return output;
}

});


parcelRegister("hp7rt", function(module, exports) {

$parcel$export(module.exports, "tanConfig", function () { return $caba8b4e383be23c$export$97648844df7611f3; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $caba8b4e383be23c$export$fcdd3b0b3246a325 = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Tan), (xi)=>Math.tan(xi));
const $caba8b4e383be23c$export$97648844df7611f3 = {
    kernelName: (0, $9BGT9.Tan),
    backendName: 'cpu',
    kernelFunc: $caba8b4e383be23c$export$fcdd3b0b3246a325
};

});

parcelRegister("k73c2", function(module, exports) {

$parcel$export(module.exports, "tanhConfig", function () { return $ea46f02a909bfc91$export$a2fc7de1a1e4eee0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6wQye = parcelRequire("6wQye");
const $ea46f02a909bfc91$export$7128670e45beef9a = (0, $6wQye.unaryKernelFunc)((0, $9BGT9.Tanh), (xi)=>Math.tanh(xi));
const $ea46f02a909bfc91$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $9BGT9.Tanh),
    backendName: 'cpu',
    kernelFunc: $ea46f02a909bfc91$export$7128670e45beef9a
};

});

parcelRegister("aT6X8", function(module, exports) {

$parcel$export(module.exports, "tensorScatterUpdateConfig", function () { return $7ed46f21cb3ea117$export$2819813ce8339b64; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $eI5eD = parcelRequire("eI5eD");
function $7ed46f21cb3ea117$export$d3ac02769385eb36(args) {
    const { inputs: inputs, backend: backend } = args;
    const { tensor: tensor, indices: indices, updates: updates } = inputs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $dEVRx).calculateShapes(updates, indices, tensor.shape);
    const sumDupeIndices = false;
    const indicesBuf = backend.bufferSync(indices);
    const updatesBuf = backend.bufferSync(updates);
    const tensorBuf = backend.bufferSync(tensor);
    const outBuf = (0, $eI5eD.scatterImpl)(indicesBuf, updatesBuf, tensor.shape, outputSize, sliceSize, numUpdates, sliceRank, strides, tensorBuf, sumDupeIndices);
    return backend.makeTensorInfo(tensor.shape, outBuf.dtype, outBuf.values);
}
const $7ed46f21cb3ea117$export$2819813ce8339b64 = {
    kernelName: (0, $9BGT9.TensorScatterUpdate),
    backendName: 'cpu',
    kernelFunc: $7ed46f21cb3ea117$export$d3ac02769385eb36
};

});

parcelRegister("fh5Jo", function(module, exports) {

$parcel$export(module.exports, "tileConfig", function () { return $b1ece3a1099a0c07$export$a5a9f8050ba7f41e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $9240Q = parcelRequire("9240Q");
function $b1ece3a1099a0c07$export$3c17558da18e4d75(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'tile');
    const outBuf = (0, $9240Q.tileImpl)(backend.bufferSync(x), reps);
    return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
}
const $b1ece3a1099a0c07$export$a5a9f8050ba7f41e = {
    kernelName: (0, $9BGT9.Tile),
    backendName: 'cpu',
    kernelFunc: $b1ece3a1099a0c07$export$3c17558da18e4d75
};

});
parcelRegister("9240Q", function(module, exports) {

$parcel$export(module.exports, "tileImpl", function () { return $693769cba8881461$export$f3e554b937559516; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
function $693769cba8881461$export$f3e554b937559516(xBuf, reps) {
    const newShape = new Array(xBuf.rank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = xBuf.shape[i] * reps[i];
    const result = (0, $5siju.buffer)(newShape, xBuf.dtype);
    for(let i = 0; i < result.values.length; ++i){
        const newLoc = result.indexToLoc(i);
        const originalLoc = new Array(xBuf.rank);
        for(let j = 0; j < originalLoc.length; j++)originalLoc[j] = newLoc[j] % xBuf.shape[j];
        const originalIndex = xBuf.locToIndex(originalLoc);
        result.values[i] = xBuf.values[originalIndex];
    }
    return result;
}

});


parcelRegister("8BP3N", function(module, exports) {

$parcel$export(module.exports, "topKConfig", function () { return $644962ec5e568947$export$cffaee31213314ce; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $ksnUK = parcelRequire("ksnUK");
function $644962ec5e568947$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'topk');
    const xVals = backend.data.get(x.dataId).values;
    const [allTopKVals, allTopKIndices] = (0, $ksnUK.topKImpl)(xVals, x.shape, x.dtype, k, sorted);
    return [
        backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
        backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
    ];
}
const $644962ec5e568947$export$cffaee31213314ce = {
    kernelName: (0, $9BGT9.TopK),
    backendName: 'cpu',
    kernelFunc: $644962ec5e568947$export$7e641efc73a2d81
};

});
parcelRegister("ksnUK", function(module, exports) {

$parcel$export(module.exports, "topKImpl", function () { return $ee48f908870eeb5f$export$b083239978762299; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /** An implementation of the TopK kernel shared between webgl and cpu. */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
var $lBDHD = parcelRequire("lBDHD");
const $ee48f908870eeb5f$var$comparePair = (a, b)=>{
    const valueDiff = b.value - a.value;
    return valueDiff === 0 ? a.index - b.index : valueDiff;
};
/**
 * Partitions array where all elements smaller than the (k+1) smallest element
 * are found to the left of it, and all larger to the right of it.
 * Based on the Floyd-Rivest Algorithm, ref:
 * https://en.wikipedia.org/wiki/Floyd%E2%80%93Rivest_algorithm
 * @param array: Array to partition
 * @param left: Left index for the interval
 * @param right: Right index for the interval
 * @param k: Desired index value, where array[k] is the (k+1)th smallest element
 *           when left = 0
 */ function $ee48f908870eeb5f$var$select(array, k, left = 0, right = array.length - 1) {
    while(right > left){
        // Use select recursively to sample a smaller set of size s
        // the arbitrary constants 600 and 0.5 are used in the original
        // version to minimize execution time.
        if (right - left > 600) {
            const n = right - left + 1;
            const i = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * Math.sign(i - n / 2);
            const newLeft = Math.max(left, Math.floor(k - i * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - i) * s / n + sd));
            $ee48f908870eeb5f$var$select(array, k, newLeft, newRight);
        }
        // partition the elements between left and right around t
        const t = array[k];
        let i = left;
        let j = right;
        (0, $lBDHD).swap(array, left, k);
        if ($ee48f908870eeb5f$var$comparePair(array[right], t) > 0) (0, $lBDHD).swap(array, left, right);
        while(i < j){
            (0, $lBDHD).swap(array, i, j);
            i++;
            j--;
            while($ee48f908870eeb5f$var$comparePair(array[i], t) < 0)i = i + 1;
            while($ee48f908870eeb5f$var$comparePair(array[j], t) > 0)j = j - 1;
        }
        if ($ee48f908870eeb5f$var$comparePair(array[left], t) === 0) (0, $lBDHD).swap(array, left, j);
        else {
            j = j + 1;
            (0, $lBDHD).swap(array, j, right);
        }
        // Adjust left and right towards the boundaries of the subset
        // containing the (k - left + 1)th smallest element.
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
function $ee48f908870eeb5f$export$b083239978762299(x, xShape, xDtype, k, sorted) {
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const lastDim = xShape[xShape.length - 1];
    const [batch, size] = [
        x.length / lastDim,
        lastDim
    ];
    const allTopKVals = (0, $lBDHD).getTypedArrayFromDType(xDtype, batch * k);
    const allTopKIndices = (0, $lBDHD).getTypedArrayFromDType('int32', batch * k);
    for(let b = 0; b < batch; b++){
        const offset = b * size;
        const vals = x.subarray(offset, offset + size);
        let valAndInd = new Array(vals.length);
        vals.forEach((value, index)=>valAndInd[index] = {
                value: value,
                index: index
            });
        if (k < valAndInd.length) {
            $ee48f908870eeb5f$var$select(valAndInd, k);
            valAndInd = valAndInd.slice(0, k);
        }
        if (sorted) valAndInd.sort($ee48f908870eeb5f$var$comparePair);
        const outOffset = b * k;
        const topKVals = allTopKVals.subarray(outOffset, outOffset + k);
        const topKIndices = allTopKIndices.subarray(outOffset, outOffset + k);
        for(let i = 0; i < k; i++){
            topKVals[i] = valAndInd[i].value;
            topKIndices[i] = valAndInd[i].index;
        }
    }
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const outputShape = xShape.slice();
    outputShape[outputShape.length - 1] = k;
    return [
        (0, $5siju.buffer)(outputShape, xDtype, allTopKVals),
        (0, $5siju.buffer)(outputShape, 'int32', allTopKIndices)
    ];
}

});


parcelRegister("9CeFb", function(module, exports) {

$parcel$export(module.exports, "transformConfig", function () { return $700309781933d52d$export$1c7a3de6335954ed; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
function $700309781933d52d$export$51186ad6e864892a(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const inStrides = (0, $lBDHD).computeStrides(image.shape);
    const batchInStride = inStrides[0];
    const rowInStride = inStrides[1];
    const colInStride = inStrides[2];
    const outStrides = (0, $lBDHD).computeStrides(outShape);
    const batchOutStride = outStrides[0];
    const rowOutStride = outStrides[1];
    const colOutStride = outStrides[2];
    const outVals = (0, $lBDHD).getTypedArrayFromDType(image.dtype, (0, $lBDHD).sizeFromShape(outShape));
    outVals.fill(fillValue);
    const imageVals = backend.data.get(image.dataId).values;
    const transformVals = backend.data.get(transforms.dataId).values;
    // Ref TF implementation:
    // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/image/image_ops.h
    for(let b = 0; b < batch; ++b){
        const transform = transforms.shape[0] === 1 ? transformVals : transformVals.subarray(b * 8, b * 8 + 8);
        for(let outY = 0; outY < outHeight; ++outY){
            for(let outX = 0; outX < outWidth; ++outX)for(let channel = 0; channel < numChannels; ++channel){
                let val;
                const projection = transform[6] * outX + transform[7] * outY + 1;
                if (projection === 0) continue;
                const inX = (transform[0] * outX + transform[1] * outY + transform[2]) / projection;
                const inY = (transform[3] * outX + transform[4] * outY + transform[5]) / projection;
                const x = $700309781933d52d$var$mapCoord(inX, imageWidth, fillMode);
                const y = $700309781933d52d$var$mapCoord(inY, imageHeight, fillMode);
                switch(interpolation){
                    case 'nearest':
                        val = $700309781933d52d$var$nearestInterpolation(imageVals, imageHeight, imageWidth, batchInStride, rowInStride, colInStride, b, y, x, channel, fillValue);
                        break;
                    case 'bilinear':
                        val = $700309781933d52d$var$bilinearInterpolation(imageVals, imageHeight, imageWidth, batchInStride, rowInStride, colInStride, b, y, x, channel, fillValue);
                        break;
                    default:
                        throw new Error(`Error in Transform: Expect 'nearest' or ` + `'bilinear', but got ${interpolation}`);
                }
                const ind = b * batchOutStride + outY * rowOutStride + outX * colOutStride + channel;
                outVals[ind] = val;
            }
        }
        return backend.makeTensorInfo(outShape, image.dtype, outVals);
    }
    const dataId = backend.write(outVals, outShape, image.dtype);
    return {
        dataId: dataId,
        shape: image.shape,
        dtype: image.dtype
    };
}
const $700309781933d52d$export$1c7a3de6335954ed = {
    kernelName: (0, $9BGT9.Transform),
    backendName: 'cpu',
    kernelFunc: $700309781933d52d$export$51186ad6e864892a
};
function $700309781933d52d$var$mapCoord(outCoord, len, mode) {
    switch(mode){
        case 'reflect':
            return $700309781933d52d$var$mapCoordReflect(outCoord, len);
        case 'wrap':
            return $700309781933d52d$var$mapCoordWrap(outCoord, len);
        case 'nearest':
            return $700309781933d52d$var$mapCoordNearest(outCoord, len);
        case 'constant':
        default:
            return $700309781933d52d$var$mapCoordConstant(outCoord, len);
    }
}
function $700309781933d52d$var$mapCoordReflect(outCoord, len) {
    // Reflect [abcd] to [dcba|abcd|dcba].
    let inCoord = outCoord;
    if (inCoord < 0) {
        if (len <= 1) inCoord = 0;
        else {
            const sz2 = 2 * len;
            if (inCoord < sz2) inCoord = sz2 * Math.trunc(-inCoord / sz2) + inCoord;
            inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1;
        }
    } else if (inCoord > len - 1) {
        if (len <= 1) inCoord = 0;
        else {
            const sz2 = 2 * len;
            inCoord -= sz2 * Math.trunc(inCoord / sz2);
            if (inCoord >= len) inCoord = sz2 - inCoord - 1;
        }
    }
    // clamp is necessary because when outCoord = 3.5 and len = 4,
    // inCoord = 3.5 and will be rounded to 4 in nearest interpolation.
    return (0, $lBDHD).clamp(0, inCoord, len - 1);
}
function $700309781933d52d$var$mapCoordWrap(outCoord, len) {
    // Wrap [abcd] to [abcd|abcd|abcd].
    let inCoord = outCoord;
    if (inCoord < 0) {
        if (len <= 1) inCoord = 0;
        else {
            const sz = len - 1;
            inCoord += len * (Math.trunc(-inCoord / sz) + 1);
        }
    } else if (inCoord > len - 1) {
        if (len <= 1) inCoord = 0;
        else {
            const sz = len - 1;
            inCoord -= len * Math.trunc(inCoord / sz);
        }
    }
    // clamp is necessary because when outCoord = -0.5 and len = 4,
    // inCoord = 3.5 and will be rounded to 4 in nearest interpolation.
    return (0, $lBDHD).clamp(0, inCoord, len - 1);
}
function $700309781933d52d$var$mapCoordConstant(outCoord, len) {
    return outCoord;
}
function $700309781933d52d$var$mapCoordNearest(outCoord, len) {
    return (0, $lBDHD).clamp(0, outCoord, len - 1);
}
function $700309781933d52d$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const ind = batch * batchStride + y * rowStride + x * colStride + channel;
    if (0 <= y && y < imageHeight && 0 <= x && x < imageWidth) return imageVals[ind];
    else return fillValue;
}
function $700309781933d52d$var$nearestInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const $y = Math.round(y);
    const $x = Math.round(x);
    return $700309781933d52d$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, $y, $x, channel, fillValue);
}
function $700309781933d52d$var$bilinearInterpolation(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, y, x, channel, fillValue) {
    const yFloor = Math.floor(y);
    const xFloor = Math.floor(x);
    const yCeil = yFloor + 1;
    const xCeil = xFloor + 1;
    // f(x, yFloor) = (xCeil - x) / (xCeil - xFloor) * f(xFloor, yFloor)
    //               + (x - xFloor) / (xCeil - xFloor) * f(xCeil, yFloor)
    const valueYFloor = (xCeil - x) * $700309781933d52d$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yFloor, xFloor, channel, fillValue) + (x - xFloor) * $700309781933d52d$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yFloor, xCeil, channel, fillValue);
    // f(x, yCeil) = (xCeil - x) / (xCeil - xFloor) * f(xFloor, yCeil)
    //             + (x - xFloor) / (xCeil - xFloor) * f(xCeil, yCeil)
    const valueYCeil = (xCeil - x) * $700309781933d52d$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yCeil, xFloor, channel, fillValue) + (x - xFloor) * $700309781933d52d$var$readWithFillValue(imageVals, imageHeight, imageWidth, batchStride, rowStride, colStride, batch, yCeil, xCeil, channel, fillValue);
    // f(x, y) = (yCeil - y) / (yCeil - yFloor) * f(x, yFloor)
    //         + (y - yFloor) / (yCeil - yFloor) * f(x, yCeil)
    return (yCeil - y) * valueYFloor + (y - yFloor) * valueYCeil;
}

});

parcelRegister("3Z9gg", function(module, exports) {

$parcel$export(module.exports, "uniqueConfig", function () { return $2e6e40b8c8397284$export$78cd70dcd092910e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $wi69v = parcelRequire("wi69v");

var $8pjeL = parcelRequire("8pjeL");
function $2e6e40b8c8397284$export$7a5d5c156e7dc406(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { axis: axis } = attrs;
    const { x: x } = inputs;
    (0, $wi69v.assertNotComplex)(x, 'unique');
    const values = backend.data.get(x.dataId).values;
    const { outputValues: outputValues, outputShape: outputShape, indices: indices } = (0, $8pjeL.uniqueImpl)(values, axis, x.shape, x.dtype);
    return [
        backend.makeTensorInfo(outputShape, x.dtype, outputValues),
        backend.makeTensorInfo([
            indices.length
        ], 'int32', indices)
    ];
}
const $2e6e40b8c8397284$export$78cd70dcd092910e = {
    kernelName: (0, $9BGT9.Unique),
    backendName: 'cpu',
    kernelFunc: $2e6e40b8c8397284$export$7a5d5c156e7dc406
};

});
parcelRegister("8pjeL", function(module, exports) {

$parcel$export(module.exports, "uniqueImpl", function () { return $0194615d7ca50e5b$export$58be9cc013c994e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $3pVUH = parcelRequire("3pVUH");
var $lBDHD = parcelRequire("lBDHD");
function $0194615d7ca50e5b$export$58be9cc013c994e(values, axis, shape, dtype) {
    // Normalize and validate axis.
    const $axis = (0, $lBDHD).parseAxisParam(axis, shape)[0];
    // Calculate the new shape that is suitable for extracting data along the
    // given axis.
    //
    // The rank is 3.
    // The size of the 1st dimension is the size of all the axes < the given axis.
    // The size of the 2nd dimension is the same as the size of the given axis.
    // The size of the 3rd dimension is the size of all the axes > the given axis.
    //
    // For example, for a 4D tensor with shape=[2, 3, 5, 4] and axis=2, the
    // newShape would be: [2*3, 5, 4].
    //
    // Note that this is not the final output shape. This will be the shape for an
    // intermediate TensorBuffer (see inputBuffer below) to allow us to extract
    // values along the given axis. To demonstrate how it works, consider the
    // following example:
    //
    // Input: a 3D tensor, with shape [1, 2, 3]
    // [
    //   [
    //      [1,2,3],
    //      [4,5,6]
    //   ]
    // ]
    // Axis: 2 (the last axis).
    // Along axis 2, we expect to extract 3 tensors: [1,4], [2,5], [3,6].
    //
    // For this example, newShape would be: [2, 3, 1], where 2 is calculated from
    // 1*2. The re-shaped data would look like:
    //
    // [
    //   [
    //     [1], [2], [3]
    //   ],
    //   [
    //     [4], [5], [6]
    //   ]
    // ]
    //
    // Then, we can construct a 3-level nested loop by the following dimension
    // order to extract the values along the axis (dimension1):
    // i: dimension1       // 0,1,2 (newShape[1])
    //   m: dimension0     // 0,1   (newShape[0])
    //     n: dimension2   // 0     (newShape[2])
    //
    //                       m, i, n
    //                      ---------
    // Iteration 0: data at [0, 0, 0] => "1"
    // Iteration 1: data at [1, 0, 0] => "4"
    // We got [1,4].
    // Iteration 2: data at [0, 1, 0] => "2"
    // Iteration 3: data at [1, 1, 0] => "5"
    // We got [2,5].
    // Iteration 4: data at [0, 2, 0] => "3"
    // Iteration 5: data at [1, 2, 0] => "6"
    // We got [3,6].
    const newShape = [
        1,
        shape[0],
        1
    ];
    for(let i = 0; i < $axis; i++)newShape[0] *= shape[i];
    newShape[1] = shape[$axis];
    for(let i = $axis + 1; i < shape.length; i++)newShape[2] *= shape[i];
    // A map from unique elements (their string representations) to their values
    // in "indices" (below).
    const uniqueElements = new Map();
    // The indices of each unique element in the original tensor along the given
    // axis. It is 1D and has the same size as the given axis.
    const indices = new Int32Array(shape[$axis]);
    // Create a buffer so we can easily extract value at a given location.
    const inputBuffer = new (0, $3pVUH.TensorBuffer)(newShape, dtype, values);
    // The indices along the given axis that have unique elements. This is a
    // de-duped version of "indices" above.
    const uniqueIndices = [];
    const is1DTensor = newShape[0] === 1 && newShape[2] === 1;
    for(let i = 0; i < shape[$axis]; i++){
        // Extract values along the axis.
        let element;
        if (is1DTensor) // Fast path for 1D tensor input.
        element = values[i].toString();
        else {
            const axisValues = [];
            for(let m = 0; m < newShape[0]; m++)for(let n = 0; n < newShape[2]; n++)axisValues.push(inputBuffer.get(m, i, n));
            element = axisValues.join(',');
        }
        // Dedup and update various indices.
        const existingIndex = uniqueElements.get(element);
        if (existingIndex != null) indices[i] = existingIndex;
        else {
            const uniqueIndex = uniqueElements.size;
            uniqueElements.set(element, uniqueIndex);
            indices[i] = uniqueIndex;
            uniqueIndices.push(i);
        }
    }
    // Now we know where each of the unique elements are located along the axis
    // (uniqueIndices). Extract them from input buffer and store them in the
    // output buffer.
    const outputTmpShape = newShape.slice();
    outputTmpShape[1] = uniqueElements.size;
    const outputBuffer = new (0, $3pVUH.TensorBuffer)(outputTmpShape, dtype);
    uniqueIndices.forEach((uniqueElementIndex, i)=>{
        for(let m = 0; m < newShape[0]; m++)for(let n = 0; n < newShape[2]; n++)outputBuffer.set(inputBuffer.get(m, uniqueElementIndex, n), m, i, n);
    });
    // The output shape can be calculated from the input shape with the size of
    // the given axis replaced by the number of unique elements along that axis.
    const outputShape = shape.slice();
    outputShape[$axis] = outputTmpShape[1];
    return {
        outputValues: outputBuffer.values,
        outputShape: outputShape,
        indices: indices
    };
}

});


parcelRegister("imZ6w", function(module, exports) {

$parcel$export(module.exports, "unpackConfig", function () { return $d5f9ae1c2dd173ed$export$d06292128cae50d6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $dOeSU = parcelRequire("dOeSU");

var $59DpV = parcelRequire("59DpV");
function $d5f9ae1c2dd173ed$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const valueRank = value.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(valueRank - 1);
    let outIndex = 0;
    for(let i = 0; i < valueRank; i++)if (i !== axis) outShape[outIndex++] = value.shape[i];
    const begin = new Array(valueRank).fill(0);
    const size = value.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const tempRes = (0, $59DpV.slice)({
            inputs: {
                x: value
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        res[i] = (0, $dOeSU.reshape)({
            inputs: {
                x: tempRes
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        backend.disposeIntermediateTensorInfo(tempRes);
    }
    return res;
}
const $d5f9ae1c2dd173ed$export$d06292128cae50d6 = {
    kernelName: (0, $9BGT9.Unpack),
    backendName: 'cpu',
    kernelFunc: $d5f9ae1c2dd173ed$export$417857010dc9287f
};

});

parcelRegister("liGsA", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSumConfig", function () { return $f81c37173d780337$export$71e3626a4ca29968; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $wi69v = parcelRequire("wi69v");

var $9IBUg = parcelRequire("9IBUg");

var $9Gjjv = parcelRequire("9Gjjv");

var $j72XB = parcelRequire("j72XB");

var $bMajv = parcelRequire("bMajv");

var $83uCx = parcelRequire("83uCx");

var $5Mi8L = parcelRequire("5Mi8L");
function $f81c37173d780337$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    (0, $wi69v.assertNotComplex)(x, 'unsortedSegmentSum');
    const xRank = x.shape.length;
    const segmentIdsRank = segmentIds.shape.length;
    const res = [];
    const intermediates = [];
    // Reshape the segment id's so that they can be broadcast with
    // x. The new shape should be [segmentIds.shape, 1, ..., 1]
    const numIters = xRank - segmentIdsRank;
    let $segmentIds = segmentIds;
    for(let i = 0; i < numIters; ++i){
        const expanded = (0, $j72XB.expandDims)({
            inputs: {
                input: $segmentIds
            },
            backend: backend,
            attrs: {
                dim: i + 1
            }
        });
        $segmentIds = expanded;
        intermediates.push(expanded);
    }
    for(let i = 0; i < numSegments; ++i){
        const scalarValue = (0, $lBDHD).createScalarValue(i, 'int32');
        const segmentId = backend.makeTensorInfo([], 'int32', scalarValue);
        const mask = (0, $9Gjjv.equal)({
            inputs: {
                a: segmentId,
                b: $segmentIds
            },
            backend: backend
        });
        const maskCasted = (0, $9IBUg.cast)({
            inputs: {
                x: mask
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const mul = (0, $bMajv.multiply)({
            inputs: {
                a: maskCasted,
                b: x
            },
            backend: backend
        });
        const sumTensorInfo = (0, $5Mi8L.sum)({
            inputs: {
                x: mul
            },
            backend: backend,
            attrs: {
                axis: 0,
                keepDims: false
            }
        });
        res.push(sumTensorInfo);
        intermediates.push(segmentId);
        intermediates.push(mask);
        intermediates.push(maskCasted);
        intermediates.push(mul);
        intermediates.push(sumTensorInfo);
    }
    const result = (0, $83uCx.pack)({
        inputs: res,
        backend: backend,
        attrs: {
            axis: 0
        }
    });
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $f81c37173d780337$export$71e3626a4ca29968 = {
    kernelName: (0, $9BGT9.UnsortedSegmentSum),
    backendName: 'cpu',
    kernelFunc: $f81c37173d780337$export$ba7c4d144d85a309
};

});



parcelRegister("6SCsp", function(module, exports) {
$parcel$export(module.exports, "version_webgl", function () { return (parcelRequire("5QpdQ")).version; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // All exports from this package should be in base.
parcelRequire("eqgfy");
parcelRequire("jDCaT");

});
parcelRegister("eqgfy", function(module, exports) {

$parcel$export(module.exports, "version_webgl", function () { return (parcelRequire("5QpdQ")).version; });
/**
 * @license
 * Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // base.ts is the webgl backend without auto kernel registration.
parcelRequire("8AHkS");
var $egPzb = parcelRequire("egPzb");
var $d7Nxs = parcelRequire("d7Nxs");

var $11OZW = parcelRequire("11OZW");

var $5QpdQ = parcelRequire("5QpdQ");

var $jsSx3 = parcelRequire("jsSx3");
if ((0, $egPzb).isBrowser()) (0, $d7Nxs.registerBackend)('webgl', ()=>new (0, $11OZW.MathBackendWebGL)(), 2 /* priority */ );
const $a800194bb06e18ed$export$d55298c9efc5ed14 = {
    forceHalfFloat: $jsSx3.forceHalfFloat
};

});
parcelRegister("11OZW", function(module, exports) {

$parcel$export(module.exports, "MathBackendWebGL", function () { return $0bfd71980e88f39a$export$33567d88bc7c6249; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import webgl flags.
parcelRequire("7NwnT");
parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $5siju = parcelRequire("5siju");
var $2vCd3 = parcelRequire("2vCd3");
var $d7Nxs = parcelRequire("d7Nxs");
var $tdutJ = parcelRequire("tdutJ");
var $iEnT2 = parcelRequire("iEnT2");
var $k22sw = parcelRequire("k22sw");
var $7hONX = parcelRequire("7hONX");
var $lBDHD = parcelRequire("lBDHD");

var $8BJsC = parcelRequire("8BJsC");

var $k1edx = parcelRequire("k1edx");

var $euZt6 = parcelRequire("euZt6");

var $5pqKu = parcelRequire("5pqKu");

var $5gsGP = parcelRequire("5gsGP");

var $ajlEV = parcelRequire("ajlEV");

var $kCGTi = parcelRequire("kCGTi");

var $1as8e = parcelRequire("1as8e");

var $SwRKX = parcelRequire("SwRKX");

var $glyiU = parcelRequire("glyiU");

var $jC64O = parcelRequire("jC64O");

var $h6lzw = parcelRequire("h6lzw");

var $2zyhV = parcelRequire("2zyhV");

var $2re5Z = parcelRequire("2re5Z");

var $1V6Qm = parcelRequire("1V6Qm");

var $2s8wb = parcelRequire("2s8wb");

var $4uRal = parcelRequire("4uRal");

var $k42ZR = parcelRequire("k42ZR");
const $0bfd71980e88f39a$var$whereImpl = (0, $iEnT2).whereImpl;
const $0bfd71980e88f39a$export$76e53a66c52b6d4d = 1e-7;
const $0bfd71980e88f39a$export$49716d145771e6a2 = 1e-4;
const $0bfd71980e88f39a$var$binaryCaches = {};
function $0bfd71980e88f39a$export$5863a14c5c829662(webGLVersion) {
    if (webGLVersion in $0bfd71980e88f39a$var$binaryCaches) return $0bfd71980e88f39a$var$binaryCaches[webGLVersion];
    $0bfd71980e88f39a$var$binaryCaches[webGLVersion] = {};
    return $0bfd71980e88f39a$var$binaryCaches[webGLVersion];
}
// Empirically determined constant used to determine size threshold for handing
// off execution to the CPU.
const $0bfd71980e88f39a$var$CPU_HANDOFF_SIZE_THRESHOLD = (0, $tdutJ.env)().getNumber('CPU_HANDOFF_SIZE_THRESHOLD');
// Empirically determined constant used to decide the number of MB on GPU
// before we warn about high memory use. The MB are this constant * screen area
// * dpi / 1024 / 1024.
const $0bfd71980e88f39a$var$BEFORE_PAGING_CONSTANT = 600;
function $0bfd71980e88f39a$var$numMBBeforeWarning() {
    if ((0, $tdutJ.env)().global.screen == null) return 1024; // 1 GB.
    return (0, $tdutJ.env)().global.screen.height * (0, $tdutJ.env)().global.screen.width * window.devicePixelRatio * $0bfd71980e88f39a$var$BEFORE_PAGING_CONSTANT / 1024 / 1024;
}
class $0bfd71980e88f39a$export$33567d88bc7c6249 extends (0, $2vCd3.KernelBackend) {
    nextDataId() {
        return $0bfd71980e88f39a$export$33567d88bc7c6249.nextDataId++;
    }
    constructor(gpuResource){
        super();
        // Maps data ids that have a pending read operation, to list of subscribers.
        this.pendingRead = new WeakMap();
        // List of data ids that are scheduled for disposal, but are waiting on a
        // pending read operation.
        this.pendingDisposal = new WeakSet();
        // Used to count the number of 'shallow' sliced tensors that point to the
        // same data id.
        this.dataRefCount = new WeakMap();
        this.numBytesInGPU = 0;
        // Accumulated time spent (including blocking) in uploading data to webgl.
        this.uploadWaitMs = 0;
        // Accumulated time spent (including blocking in downloading data from webgl.
        this.downloadWaitMs = 0;
        // record the last manual GL Flush time.
        this.lastGlFlushTime = 0;
        this.warnedAboutMemory = false;
        this.pendingDeletes = 0;
        this.disposed = false;
        if (!(0, $tdutJ.env)().getBool('HAS_WEBGL')) throw new Error('WebGL is not supported on this device');
        let newGPGPU;
        if (gpuResource != null) {
            if (gpuResource instanceof (0, $1as8e.GPGPUContext)) newGPGPU = gpuResource;
            else {
                const gl = (0, $8BJsC.getWebGLContext)((0, $tdutJ.env)().getNumber('WEBGL_VERSION'), gpuResource);
                newGPGPU = new (0, $1as8e.GPGPUContext)(gl);
            }
            this.binaryCache = {};
            this.gpgpuCreatedLocally = false;
        } else {
            const gl = (0, $8BJsC.getWebGLContext)((0, $tdutJ.env)().getNumber('WEBGL_VERSION'));
            newGPGPU = new (0, $1as8e.GPGPUContext)(gl);
            this.binaryCache = $0bfd71980e88f39a$export$5863a14c5c829662((0, $tdutJ.env)().getNumber('WEBGL_VERSION'));
            this.gpgpuCreatedLocally = true;
        }
        this.gpgpu = newGPGPU;
        this.canvas = this.gpgpu.gl.canvas;
        this.textureManager = new (0, $2re5Z.TextureManager)(this.gpgpu);
        this.numMBBeforeWarning = $0bfd71980e88f39a$var$numMBBeforeWarning();
        this.texData = new (0, $2vCd3.DataStorage)(this, (0, $d7Nxs.engine)());
    }
    numDataIds() {
        return this.texData.numDataIds() - this.pendingDeletes;
    }
    // Writes a new entry to the data store with a WebGL texture, and registers it
    // to the texture manager.
    writeTexture(texture, shape, dtype, texHeight, texWidth, channels) {
        // Temporarily create an tensor info to make the texture compatible with
        // the runWebGLProgram's input.
        const input = this.makeTensorInfo(shape, dtype);
        const inData = this.texData.get(input.dataId);
        // Even though the input texture could be unpacked or dense packed, it is
        // always considered as unpacked for EncodeMatrixProgram.
        inData.isPacked = false;
        // Bind texture to the input tensor.
        inData.texture = {
            texture: texture,
            texShape: [
                texHeight,
                texWidth
            ]
        };
        inData.texShape = [
            texHeight,
            texWidth
        ];
        const shapeAs3D = $k42ZR.getShapeAs3D(shape);
        const program = new (0, $ajlEV.EncodeMatrixProgram)(shapeAs3D, false, channels);
        const output = this.runWebGLProgram(program, [
            input
        ], dtype, [
            [
                texHeight,
                texWidth
            ]
        ]);
        output.shape = shape;
        // Unbind the texture from the input tensor to avoid the texture being
        // released.
        inData.texture = null;
        this.disposeIntermediateTensorInfo(input);
        return output.dataId;
    }
    write(values, shape, dtype) {
        if ((0, $tdutJ.env)().getBool('WEBGL_CHECK_NUMERICAL_PROBLEMS') || (0, $tdutJ.env)().getBool('DEBUG')) this.checkNumericalProblems(values);
        if (dtype === 'complex64' && values != null) throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        const dataId = {
            id: this.nextDataId()
        };
        this.texData.set(dataId, {
            shape: shape,
            dtype: dtype,
            values: values,
            usage: (0, $2zyhV.TextureUsage).UPLOAD,
            refCount: 1
        });
        return dataId;
    }
    /** Return refCount of a `TensorData`. */ refCount(dataId) {
        if (this.texData.has(dataId)) {
            const tensorData = this.texData.get(dataId);
            return tensorData.refCount;
        }
        return 0;
    }
    /** Increase refCount of a `TextureData`. */ incRef(dataId) {
        const texData = this.texData.get(dataId);
        texData.refCount++;
    }
    /** Decrease refCount of a `TextureData`. */ decRef(dataId) {
        if (this.texData.has(dataId)) {
            const texData = this.texData.get(dataId);
            texData.refCount--;
        }
    }
    move(dataId, values, shape, dtype, refCount) {
        if ((0, $tdutJ.env)().getBool('DEBUG')) this.checkNumericalProblems(values);
        if (dtype === 'complex64') throw new Error(`Cannot write to a complex64 dtype. ` + `Please use tf.complex(real, imag).`);
        this.texData.set(dataId, {
            shape: shape,
            dtype: dtype,
            values: values,
            usage: (0, $2zyhV.TextureUsage).UPLOAD,
            refCount: refCount
        });
    }
    disposeIntermediateTensorInfo(tensorInfo) {
        this.disposeData(tensorInfo.dataId);
    }
    readSync(dataId) {
        const texData = this.texData.get(dataId);
        const { values: values, dtype: dtype, complexTensorInfos: complexTensorInfos, slice: slice, shape: shape, isPacked: isPacked } = texData;
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $2s8wb.UnaryOpPackedProgram)(shape, $1V6Qm.CLONE);
            else program = new (0, $1V6Qm.UnaryOpProgram)(shape, $1V6Qm.CLONE);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const data = this.readSync(res.dataId);
            this.disposeIntermediateTensorInfo(res);
            return data;
        }
        if (values != null) return this.convertAndCacheOnCPU(dataId);
        if (dtype === 'string') return values;
        const shouldTimeProgram = this.activeTimers != null;
        let start;
        if (shouldTimeProgram) start = (0, $lBDHD).now();
        let result;
        if (dtype === 'complex64') {
            const realValues = this.readSync(complexTensorInfos.real.dataId);
            const imagValues = this.readSync(complexTensorInfos.imag.dataId);
            result = (0, $dEVRx).mergeRealAndImagArrays(realValues, imagValues);
        } else result = this.getValuesFromTexture(dataId);
        if (shouldTimeProgram) this.downloadWaitMs += (0, $lBDHD).now() - start;
        return this.convertAndCacheOnCPU(dataId, result);
    }
    async read(dataId) {
        if (this.pendingRead.has(dataId)) {
            const subscribers = this.pendingRead.get(dataId);
            return new Promise((resolve)=>subscribers.push(resolve));
        }
        const texData = this.texData.get(dataId);
        const { values: values, shape: shape, slice: slice, dtype: dtype, complexTensorInfos: complexTensorInfos, isPacked: isPacked } = texData;
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $2s8wb.UnaryOpPackedProgram)(shape, $1V6Qm.CLONE);
            else program = new (0, $1V6Qm.UnaryOpProgram)(shape, $1V6Qm.CLONE);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const data = this.read(res.dataId);
            this.disposeIntermediateTensorInfo(res);
            return data;
        }
        if (values != null) return this.convertAndCacheOnCPU(dataId);
        if ((0, $tdutJ.env)().getBool('DEBUG')) {
            // getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') caused a blocking GPU call.
            // For performance reason, only check it for debugging. In production,
            // it doesn't handle this use case anyway, so behavior is not changed.
            if (!(0, $tdutJ.env)().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED') && (0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2) throw new Error(`tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and ` + `WEBGL_VERSION=2 not yet supported.`);
        }
        let buffer = null;
        let tmpDownloadTarget;
        if (dtype !== 'complex64' && (0, $tdutJ.env)().get('WEBGL_BUFFER_SUPPORTED')) {
            // Possibly copy the texture into a buffer before inserting a fence.
            tmpDownloadTarget = this.decode(dataId);
            const tmpData = this.texData.get(tmpDownloadTarget.dataId);
            buffer = this.gpgpu.createBufferFromTexture(tmpData.texture.texture, ...$2zyhV.getDenseTexShape(shape));
        }
        this.pendingRead.set(dataId, []);
        if (dtype !== 'complex64') // Create a fence and wait for it to resolve.
        await this.gpgpu.createAndWaitForFence();
        // Download the values from the GPU.
        let vals;
        if (dtype === 'complex64') {
            const ps = await Promise.all([
                this.read(complexTensorInfos.real.dataId),
                this.read(complexTensorInfos.imag.dataId)
            ]);
            const realValues = ps[0];
            const imagValues = ps[1];
            vals = (0, $dEVRx).mergeRealAndImagArrays(realValues, imagValues);
        } else if (buffer == null) vals = this.getValuesFromTexture(dataId);
        else {
            const size = (0, $lBDHD).sizeFromShape(shape);
            vals = this.gpgpu.downloadFloat32MatrixFromBuffer(buffer, size);
        }
        if (tmpDownloadTarget != null) this.disposeIntermediateTensorInfo(tmpDownloadTarget);
        if (buffer != null) {
            const gl = this.gpgpu.gl;
            $k42ZR.callAndCheck(gl, ()=>gl.deleteBuffer(buffer));
        }
        const dTypeVals = this.convertAndCacheOnCPU(dataId, vals);
        const subscribers = this.pendingRead.get(dataId);
        this.pendingRead.delete(dataId);
        // Notify all pending reads.
        subscribers.forEach((resolve)=>resolve(dTypeVals));
        if (this.pendingDisposal.has(dataId)) {
            this.pendingDisposal.delete(dataId);
            if (this.disposeData(dataId)) (0, $d7Nxs.engine)().removeDataId(dataId, this);
            this.pendingDeletes--;
        }
        return dTypeVals;
    }
    /**
     * Read tensor to a new texture that is densely packed for ease of use.
     * @param dataId The source tensor.
     * @param options
     *     customTexShape: Optional. If set, will use the user defined texture
     *     shape to create the texture.
     */ readToGPU(dataId, options = {}) {
        const texData = this.texData.get(dataId);
        const { values: values, shape: shape, slice: slice, dtype: dtype, isPacked: isPacked, texture: texture } = texData;
        if (dtype === 'complex64') throw new Error('Does not support reading texture for complex64 dtype.');
        // The presence of `slice` indicates this tensor is a shallow slice of a
        // different tensor, and is using that original tensor's texture. Run
        // `clone` in order to copy that texture and read from it.
        if (slice != null) {
            let program;
            if (isPacked) program = new (0, $2s8wb.UnaryOpPackedProgram)(shape, $1V6Qm.CLONE);
            else program = new (0, $1V6Qm.UnaryOpProgram)(shape, $1V6Qm.CLONE);
            const res = this.runWebGLProgram(program, [
                {
                    dataId: dataId,
                    shape: shape,
                    dtype: dtype
                }
            ], dtype);
            const gpuResouorce = this.readToGPU(res, options);
            this.disposeIntermediateTensorInfo(res);
            return gpuResouorce;
        }
        if (texture == null) {
            if (values != null) throw new Error('Data is not on GPU but on CPU.');
            else throw new Error('There is no data on GPU or CPU.');
        }
        // Decode the texture so that it is stored densely (using four channels).
        const tmpTarget = this.decode(dataId, options.customTexShape);
        // Make engine track this tensor, so that we can dispose it later.
        const tensorRef = (0, $d7Nxs.engine)().makeTensorFromTensorInfo(tmpTarget);
        const tmpData = this.texData.get(tmpTarget.dataId);
        return Object.assign({
            tensorRef: tensorRef
        }, tmpData.texture);
    }
    bufferSync(t) {
        const data = this.readSync(t.dataId);
        if (t.dtype === 'string') try {
            // Decode the bytes into string.
            const strings = data.map((d)=>(0, $lBDHD).decodeString(d));
            return (0, $5siju.buffer)(t.shape, t.dtype, strings);
        } catch (_a) {
            throw new Error('Failed to decode encoded string bytes into utf-8');
        }
        return (0, $5siju.buffer)(t.shape, t.dtype, data);
    }
    checkNumericalProblems(values) {
        if (values == null) return;
        for(let i = 0; i < values.length; i++){
            const num = values[i];
            if (!$k42ZR.canBeRepresented(num)) {
                if ((0, $tdutJ.env)().getBool('WEBGL_RENDER_FLOAT32_CAPABLE')) throw Error(`The value ${num} cannot be represented with your ` + `current settings. Consider enabling float32 rendering: ` + `'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'`);
                throw Error(`The value ${num} cannot be represented on this device.`);
            }
        }
    }
    getValuesFromTexture(dataId) {
        const { shape: shape, dtype: dtype, isPacked: isPacked } = this.texData.get(dataId);
        const size = (0, $lBDHD).sizeFromShape(shape);
        if ((0, $tdutJ.env)().getBool('WEBGL_DOWNLOAD_FLOAT_ENABLED')) {
            const tmpTarget = this.decode(dataId);
            const tmpData = this.texData.get(tmpTarget.dataId);
            const vals = this.gpgpu.downloadMatrixFromPackedTexture(tmpData.texture.texture, ...$2zyhV.getDenseTexShape(shape)).subarray(0, size);
            this.disposeIntermediateTensorInfo(tmpTarget);
            return vals;
        }
        const shouldUsePackedProgram = (0, $tdutJ.env)().getBool('WEBGL_PACK') && isPacked === true;
        const outputShape = shouldUsePackedProgram ? $k42ZR.getShapeAs3D(shape) : shape;
        const program = shouldUsePackedProgram ? new (0, $5gsGP.EncodeFloatPackedProgram)(outputShape) : new (0, $5pqKu.EncodeFloatProgram)(outputShape);
        const output = this.runWebGLProgram(program, [
            {
                shape: outputShape,
                dtype: dtype,
                dataId: dataId
            }
        ], 'float32');
        const tmpData = this.texData.get(output.dataId);
        const vals = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(tmpData.texture.texture, tmpData.texShape[0], tmpData.texShape[1]).subarray(0, size);
        this.disposeIntermediateTensorInfo(output);
        return vals;
    }
    timerAvailable() {
        return (0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0;
    }
    time(f) {
        const oldActiveTimers = this.activeTimers;
        const newActiveTimers = [];
        let outerMostTime = false;
        if (this.programTimersStack == null) {
            this.programTimersStack = newActiveTimers;
            outerMostTime = true;
        } else this.activeTimers.push(newActiveTimers);
        this.activeTimers = newActiveTimers;
        f();
        // needing to split these up because util.flatten only accepts certain types
        const flattenedActiveTimerQueries = (0, $lBDHD).flatten(this.activeTimers.map((d)=>d.query)).filter((d)=>d != null);
        const flattenedActiveTimerNames = (0, $lBDHD).flatten(this.activeTimers.map((d)=>d.name)).filter((d)=>d != null);
        this.activeTimers = oldActiveTimers;
        if (outerMostTime) this.programTimersStack = null;
        const res = {
            uploadWaitMs: this.uploadWaitMs,
            downloadWaitMs: this.downloadWaitMs,
            kernelMs: null,
            wallMs: null // will be filled by the engine
        };
        return (async ()=>{
            if ((0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
                const kernelMs = await Promise.all(flattenedActiveTimerQueries);
                res['kernelMs'] = (0, $lBDHD).sum(kernelMs);
                res['getExtraProfileInfo'] = ()=>kernelMs.map((d, i)=>({
                            name: flattenedActiveTimerNames[i],
                            ms: d
                        })).map((d)=>`${d.name}: ${d.ms}`).join(', ');
            } else res['kernelMs'] = {
                error: 'WebGL query timers are not supported in this environment.'
            };
            this.uploadWaitMs = 0;
            this.downloadWaitMs = 0;
            return res;
        })();
    }
    memory() {
        return {
            unreliable: false,
            numBytesInGPU: this.numBytesInGPU,
            numBytesInGPUAllocated: this.textureManager.numBytesAllocated,
            numBytesInGPUFree: this.textureManager.numBytesFree
        };
    }
    startTimer() {
        if ((0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) return this.gpgpu.beginQuery();
        return {
            startMs: (0, $lBDHD).now(),
            endMs: null
        };
    }
    endTimer(query) {
        if ((0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) {
            this.gpgpu.endQuery();
            return query;
        }
        query.endMs = (0, $lBDHD).now();
        return query;
    }
    async getQueryTime(query) {
        if ((0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE') > 0) return this.gpgpu.waitForQueryAndGetTime(query);
        const timerQuery = query;
        return timerQuery.endMs - timerQuery.startMs;
    }
    /**
     * Decrease the RefCount on the dataId and dispose the memory if the dataId
     * has 0 refCount. If there are pending read on the data, the disposal would
     * added to the pending delete queue. Return true if the dataId is removed
     * from backend or the backend does not contain the dataId, false if the
     * dataId is not removed. Memory may or may not be released even when dataId
     * is removed, which also depends on dataRefCount, see `releaseGPU`.
     * @param dataId
     * @oaram force Optional, remove the data regardless of refCount
     */ disposeData(dataId, force = false) {
        if (this.pendingDisposal.has(dataId)) return false;
        // No-op if already disposed.
        if (!this.texData.has(dataId)) return true;
        // if force flag is set, change refCount to 0, this would ensure disposal
        // when added to the pendingDisposal queue. Memory may or may not be
        // released, which also depends on dataRefCount, see `releaseGPU`.
        if (force) this.texData.get(dataId).refCount = 0;
        else this.texData.get(dataId).refCount--;
        if (!force && this.texData.get(dataId).refCount > 0) return false;
        if (this.pendingRead.has(dataId)) {
            this.pendingDisposal.add(dataId);
            this.pendingDeletes++;
            return false;
        }
        this.releaseGPUData(dataId);
        const { complexTensorInfos: complexTensorInfos } = this.texData.get(dataId);
        if (complexTensorInfos != null) {
            this.disposeData(complexTensorInfos.real.dataId, force);
            this.disposeData(complexTensorInfos.imag.dataId, force);
        }
        this.texData.delete(dataId);
        return true;
    }
    releaseGPUData(dataId) {
        const { texture: texture, dtype: dtype, texShape: texShape, usage: usage, isPacked: isPacked, slice: slice } = this.texData.get(dataId);
        const key = slice && slice.origDataId || dataId;
        const refCount = this.dataRefCount.get(key);
        if (refCount > 1) this.dataRefCount.set(key, refCount - 1);
        else {
            this.dataRefCount.delete(key);
            if (texture != null) {
                this.numBytesInGPU -= this.computeBytes(texShape, dtype);
                this.textureManager.releaseTexture(texture, texShape, usage, isPacked);
            }
        }
        const texData = this.texData.get(dataId);
        texData.texture = null;
        texData.texShape = null;
        texData.isPacked = false;
        texData.slice = null;
    }
    getTexture(dataId) {
        this.uploadToGPU(dataId);
        return this.texData.get(dataId).texture.texture;
    }
    /**
     * Returns internal information for the specific data bucket. Used in unit
     * tests.
     */ getDataInfo(dataId) {
        return this.texData.get(dataId);
    }
    /*
    Tests whether all the inputs to an op are small and on the CPU. This heuristic
    determines when it would be faster to execute a kernel on the CPU. WebGL
    kernels opt into running this check and forwarding when appropriate.
    TODO(https://github.com/tensorflow/tfjs/issues/872): Develop a more
    sustainable strategy for optimizing backend execution of ops.
     */ shouldExecuteOnCPU(inputs, sizeThreshold = $0bfd71980e88f39a$var$CPU_HANDOFF_SIZE_THRESHOLD) {
        return (0, $tdutJ.env)().getBool('WEBGL_CPU_FORWARD') && inputs.every((input)=>this.texData.get(input.dataId).texture == null && (0, $lBDHD).sizeFromShape(input.shape) < sizeThreshold);
    }
    getGPGPUContext() {
        return this.gpgpu;
    }
    where(condition) {
        (0, $dEVRx).warn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
        const condVals = condition.dataSync();
        return $0bfd71980e88f39a$var$whereImpl(condition.shape, condVals);
    }
    packedUnaryOp(x, op, dtype) {
        const program = new (0, $2s8wb.UnaryOpPackedProgram)(x.shape, op);
        const outInfo = this.compileAndRun(program, [
            x
        ], dtype);
        return (0, $d7Nxs.engine)().makeTensorFromTensorInfo(outInfo);
    }
    // TODO(msoulanille) remove this once the backend has been modularized
    // a copy is needed here to break a circular dependency.
    // Also remove the op from unary_op.
    abs(x) {
        // TODO: handle cases when x is complex.
        if (this.shouldExecuteOnCPU([
            x
        ]) && x.dtype !== 'complex64') {
            const outValues = (0, $glyiU.simpleAbsImplCPU)(this.texData.get(x.dataId).values);
            return this.makeOutput(x.shape, x.dtype, outValues);
        }
        if ((0, $tdutJ.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) return this.packedUnaryOp(x, $1V6Qm.ABS, x.dtype);
        const program = new (0, $1V6Qm.UnaryOpProgram)(x.shape, $1V6Qm.ABS);
        const outInfo = this.compileAndRun(program, [
            x
        ]);
        return (0, $d7Nxs.engine)().makeTensorFromTensorInfo(outInfo);
    }
    makeTensorInfo(shape, dtype, values) {
        let dataId;
        if (dtype === 'string' && values != null && values.length > 0 && (0, $lBDHD).isString(values[0])) {
            const encodedValues = values.map((d)=>(0, $lBDHD).encodeString(d));
            dataId = this.write(encodedValues, shape, dtype);
        } else dataId = this.write(values, shape, dtype);
        this.texData.get(dataId).usage = null;
        return {
            dataId: dataId,
            shape: shape,
            dtype: dtype
        };
    }
    makeOutput(shape, dtype, values) {
        return (0, $d7Nxs.engine)().makeTensorFromTensorInfo(this.makeTensorInfo(shape, dtype, values), this);
    }
    unpackTensor(input) {
        const program = new (0, $4uRal.UnpackProgram)(input.shape);
        return this.runWebGLProgram(program, [
            input
        ], input.dtype);
    }
    packTensor(input) {
        const program = new (0, $jC64O.PackProgram)(input.shape);
        const preventEagerUnpackingOutput = true;
        return this.runWebGLProgram(program, [
            input
        ], input.dtype, null, preventEagerUnpackingOutput);
    }
    packedReshape(input, afterShape) {
        const input3DShape = [
            $k42ZR.getBatchDim(input.shape),
            ...$k42ZR.getRowsCols(input.shape)
        ];
        const input3D = {
            dtype: input.dtype,
            shape: input3DShape,
            dataId: input.dataId
        };
        const afterShapeAs3D = [
            $k42ZR.getBatchDim(afterShape),
            ...$k42ZR.getRowsCols(afterShape)
        ];
        const program = new (0, $h6lzw.ReshapePackedProgram)(afterShapeAs3D, input3DShape);
        const preventEagerUnpackingOfOutput = true;
        const customValues = [
            input3DShape
        ];
        const output = this.runWebGLProgram(program, [
            input3D
        ], input.dtype, customValues, preventEagerUnpackingOfOutput);
        return {
            dataId: output.dataId,
            shape: afterShape,
            dtype: output.dtype
        };
    }
    decode(dataId, customTexShape) {
        const texData = this.texData.get(dataId);
        const { isPacked: isPacked, shape: shape, dtype: dtype } = texData;
        if (customTexShape != null) {
            const size = (0, $lBDHD).sizeFromShape(shape);
            const texSize = customTexShape[0] * customTexShape[1] * 4;
            (0, $lBDHD).assert(size <= texSize, ()=>"customTexShape is too small. Row * Column * 4 should be equal or larger than the size of the tensor data.");
        }
        const shapeAs3D = $k42ZR.getShapeAs3D(shape);
        let program;
        if (isPacked) program = new (0, $euZt6.DecodeMatrixPackedProgram)(shapeAs3D);
        else program = new (0, $k1edx.DecodeMatrixProgram)(shapeAs3D);
        const preventEagerUnpackingOfOutput = true;
        const customValues = [
            customTexShape != null ? customTexShape : $2zyhV.getDenseTexShape(shapeAs3D)
        ];
        const out = this.runWebGLProgram(program, [
            {
                shape: shapeAs3D,
                dtype: dtype,
                dataId: dataId
            }
        ], dtype, customValues, preventEagerUnpackingOfOutput, customTexShape);
        return {
            dtype: dtype,
            shape: shape,
            dataId: out.dataId
        };
    }
    runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false, customTexShape) {
        const output = this.makeTensorInfo(program.outputShape, outputDtype);
        const outData = this.texData.get(output.dataId);
        if (program.packedOutput) outData.isPacked = true;
        if (program.outPackingScheme === $2zyhV.PackingScheme.DENSE) {
            const texelShape = customTexShape != null ? customTexShape : $2zyhV.getDenseTexShape(program.outputShape);
            // For a densely packed output, we explicitly set texShape
            // so it doesn't get assigned later according to our typical packing
            // scheme wherein a single texel can only contain values from adjacent
            // rows/cols.
            outData.texShape = texelShape.map((d)=>d * 2);
        }
        if (program.outTexUsage != null) outData.usage = program.outTexUsage;
        if ((0, $lBDHD).sizeFromShape(output.shape) === 0) {
            // Short-circuit the computation since the result is empty (has 0 in its
            // shape).
            outData.values = (0, $lBDHD).getTypedArrayFromDType(output.dtype, 0);
            return output;
        }
        const dataToDispose = [];
        const inputsData = inputs.map((input)=>{
            if (input.dtype === 'complex64') throw new Error(`GPGPUProgram does not support complex64 input. For complex64 ` + `dtypes, please separate the program into real and imaginary ` + `parts.`);
            let texData = this.texData.get(input.dataId);
            if (texData.texture == null) {
                if (!program.packedInputs && (0, $lBDHD).sizeFromShape(input.shape) <= (0, $tdutJ.env)().getNumber('WEBGL_SIZE_UPLOAD_UNIFORM')) // Upload small tensors that live on the CPU as uniforms, not as
                // textures. Do this only when the environment supports 32bit floats
                // due to problems when comparing 16bit floats with 32bit floats.
                // TODO(https://github.com/tensorflow/tfjs/issues/821): Make it
                // possible for packed shaders to sample from uniforms.
                return {
                    shape: input.shape,
                    texData: null,
                    isUniform: true,
                    uniformValues: texData.values
                };
                // This ensures that if a packed program's inputs have not yet been
                // uploaded to the GPU, they get uploaded as packed right off the bat.
                if (program.packedInputs) {
                    texData.isPacked = true;
                    texData.shape = input.shape;
                }
            }
            this.uploadToGPU(input.dataId);
            if (!!texData.isPacked !== !!program.packedInputs) {
                input = texData.isPacked ? this.unpackTensor(input) : this.packTensor(input);
                dataToDispose.push(input);
                texData = this.texData.get(input.dataId);
            } else if (texData.isPacked && !$k42ZR.isReshapeFree(texData.shape, input.shape)) {
                // This is a special case where a texture exists for a tensor
                // but the shapes are incompatible (due to packing constraints) because
                // the tensor did not have a chance to go through the packed reshape
                // shader. This only happens when we reshape the *same* tensor to form
                // *distinct* inputs to an op, e.g. dotting a vector with itself. This
                // case will disappear once packed uploading is the default.
                const savedInput = input;
                const targetShape = input.shape;
                input.shape = texData.shape;
                input = this.packedReshape(input, targetShape);
                dataToDispose.push(input);
                texData = this.texData.get(input.dataId);
                savedInput.shape = targetShape;
            }
            return {
                shape: input.shape,
                texData: texData,
                isUniform: false
            };
        });
        this.uploadToGPU(output.dataId);
        const outputData = {
            shape: output.shape,
            texData: outData,
            isUniform: false
        };
        const key = $SwRKX.makeShaderKey(program, inputsData, outputData);
        const binary = this.getAndSaveBinary(key, ()=>{
            return $SwRKX.compileProgram(this.gpgpu, program, inputsData, outputData);
        });
        const shouldTimeProgram = this.activeTimers != null;
        let query;
        if (shouldTimeProgram) query = this.startTimer();
        if (!(0, $tdutJ.env)().get('ENGINE_COMPILE_ONLY')) $SwRKX.runProgram(this.gpgpu, binary, inputsData, outputData, customUniformValues);
        dataToDispose.forEach((info)=>this.disposeIntermediateTensorInfo(info));
        if (shouldTimeProgram) {
            query = this.endTimer(query);
            this.activeTimers.push({
                name: program.constructor.name,
                query: this.getQueryTime(query)
            });
        }
        const glFlushThreshold = (0, $tdutJ.env)().getNumber('WEBGL_FLUSH_THRESHOLD');
        // Manually GL flush requested
        if (glFlushThreshold > 0) {
            const time = (0, $lBDHD).now();
            if (time - this.lastGlFlushTime > glFlushThreshold) {
                this.gpgpu.gl.flush();
                this.lastGlFlushTime = time;
            }
        }
        if (!(0, $tdutJ.env)().getBool('WEBGL_LAZILY_UNPACK') && outData.isPacked && preventEagerUnpackingOfOutput === false) {
            const unpacked = this.unpackTensor(output);
            this.disposeIntermediateTensorInfo(output);
            return unpacked;
        }
        return output;
    }
    compileAndRun(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput = false) {
        outputDtype = outputDtype || inputs[0].dtype;
        const outInfo = this.runWebGLProgram(program, inputs, outputDtype, customUniformValues, preventEagerUnpackingOfOutput);
        return outInfo;
    }
    getAndSaveBinary(key, getBinary) {
        if (!(key in this.binaryCache)) this.binaryCache[key] = getBinary();
        return this.binaryCache[key];
    }
    getTextureManager() {
        return this.textureManager;
    }
    dispose() {
        if (this.disposed) return;
        // Avoid disposing the compiled webgl programs during unit testing because
        // it slows down test execution.
        if (!(0, $tdutJ.env)().getBool('IS_TEST')) {
            const allKeys = Object.keys(this.binaryCache);
            allKeys.forEach((key)=>{
                this.gpgpu.deleteProgram(this.binaryCache[key].webGLProgram);
                delete this.binaryCache[key];
            });
        }
        this.textureManager.dispose();
        if (this.canvas != null && typeof HTMLCanvasElement !== 'undefined' && this.canvas instanceof HTMLCanvasElement) this.canvas.remove();
        else this.canvas = null;
        if (this.gpgpuCreatedLocally) {
            this.gpgpu.program = null;
            this.gpgpu.dispose();
        }
        this.disposed = true;
    }
    floatPrecision() {
        if (this.floatPrecisionValue == null) this.floatPrecisionValue = (0, $d7Nxs.tidy)(()=>{
            if (!(0, $tdutJ.env)().get('WEBGL_RENDER_FLOAT32_ENABLED')) {
                // Momentarily switching DEBUG flag to false so we don't throw an
                // error trying to upload a small value.
                const debugFlag = (0, $tdutJ.env)().getBool('DEBUG');
                (0, $tdutJ.env)().set('DEBUG', false);
                const underflowCheckValue = this.abs((0, $7hONX.scalar)(1e-8)).dataSync()[0];
                (0, $tdutJ.env)().set('DEBUG', debugFlag);
                if (underflowCheckValue > 0) return 32;
            }
            return 16;
        });
        return this.floatPrecisionValue;
    }
    /** Returns the smallest representable number.  */ epsilon() {
        return this.floatPrecision() === 32 ? $0bfd71980e88f39a$export$76e53a66c52b6d4d : $0bfd71980e88f39a$export$49716d145771e6a2;
    }
    uploadToGPU(dataId) {
        const texData = this.texData.get(dataId);
        const { shape: shape, dtype: dtype, values: values, texture: texture, usage: usage, isPacked: isPacked } = texData;
        if (texture != null) // Array is already on GPU. No-op.
        return;
        const shouldTimeProgram = this.activeTimers != null;
        let start;
        if (shouldTimeProgram) start = (0, $lBDHD).now();
        let texShape = texData.texShape;
        if (texShape == null) {
            // This texShape may not be the final texture shape. For packed or dense
            // textures, the texShape will be changed when textures are created.
            texShape = $k42ZR.getTextureShapeFromLogicalShape(shape, isPacked);
            texData.texShape = texShape;
        }
        if (values != null) {
            const shapeAs3D = $k42ZR.getShapeAs3D(shape);
            let program;
            let width = texShape[1], height = texShape[0];
            const isByteArray = values instanceof Uint8Array || values instanceof Uint8ClampedArray;
            // texture for float array is PhysicalTextureType.PACKED_2X2_FLOAT32, we
            // need to make sure the upload uses the same packed size
            if (isPacked || !isByteArray) [width, height] = $2zyhV.getPackedMatrixTextureShapeWidthHeight(texShape[0], texShape[1]);
            if (isPacked) program = new (0, $kCGTi.EncodeMatrixPackedProgram)(shapeAs3D, isByteArray);
            else program = new (0, $ajlEV.EncodeMatrixProgram)(shapeAs3D, isByteArray);
            // TexShape for float array needs to be the original shape, which byte
            // array needs to be packed size. This allow the data upload shape to be
            // matched with texture creation logic.
            const tempDenseInputTexShape = isByteArray ? [
                height,
                width
            ] : texShape;
            const tempDenseInputHandle = this.makeTensorInfo(tempDenseInputTexShape, dtype);
            const tempDenseInputTexData = this.texData.get(tempDenseInputHandle.dataId);
            if (isByteArray) tempDenseInputTexData.usage = (0, $2zyhV.TextureUsage).PIXELS;
            else tempDenseInputTexData.usage = (0, $2zyhV.TextureUsage).UPLOAD;
            tempDenseInputTexData.texShape = tempDenseInputTexShape;
            this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(tempDenseInputHandle.dataId), width, height, values);
            const customValues = [
                [
                    height,
                    width
                ]
            ];
            // We want the output to remain packed regardless of the value of
            // WEBGL_PACK.
            const preventEagerUnpacking = true;
            const encodedOutputTarget = this.runWebGLProgram(program, [
                tempDenseInputHandle
            ], dtype, customValues, preventEagerUnpacking);
            // Have the original texture assume the identity of the encoded output.
            const outputTexData = this.texData.get(encodedOutputTarget.dataId);
            texData.texShape = outputTexData.texShape;
            texData.isPacked = outputTexData.isPacked;
            texData.usage = outputTexData.usage;
            if (!(0, $tdutJ.env)().get('ENGINE_COMPILE_ONLY')) {
                texData.texture = outputTexData.texture;
                // Once uploaded, don't store the values on cpu.
                texData.values = null;
                this.texData.delete(encodedOutputTarget.dataId);
            } else this.disposeData(encodedOutputTarget.dataId);
            this.disposeIntermediateTensorInfo(tempDenseInputHandle);
            if (shouldTimeProgram) this.uploadWaitMs += (0, $lBDHD).now() - start;
        } else {
            const newTexture = this.acquireTexture(texShape, usage, dtype, isPacked);
            texData.texture = newTexture;
        }
    }
    convertAndCacheOnCPU(dataId, float32Values) {
        const texData = this.texData.get(dataId);
        const { dtype: dtype } = texData;
        if (float32Values != null) texData.values = $0bfd71980e88f39a$var$float32ToTypedArray(float32Values, dtype);
        return texData.values;
    }
    acquireTexture(texShape, texType, dtype, isPacked) {
        this.numBytesInGPU += this.computeBytes(texShape, dtype);
        if (!this.warnedAboutMemory && this.numBytesInGPU > this.numMBBeforeWarning * 1048576) {
            const mb = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
            this.warnedAboutMemory = true;
            console.warn(`High memory usage in GPU: ${mb} MB, ` + `most likely due to a memory leak`);
        }
        return this.textureManager.acquireTexture(texShape, texType, isPacked);
    }
    computeBytes(shape, dtype) {
        return shape[0] * shape[1] * (0, $lBDHD).bytesPerElement(dtype);
    }
    checkCompileCompletion() {
        for (const [, binary] of Object.entries(this.binaryCache))this.checkCompletion_(binary);
    }
    async checkCompileCompletionAsync() {
        const ps = [];
        if (this.gpgpu.parallelCompilationExtension) {
            for (const [, binary] of Object.entries(this.binaryCache))ps.push(this.checkCompletionAsync_(binary));
            return Promise.all(ps);
        } else {
            for (const [, binary] of Object.entries(this.binaryCache)){
                const p = new Promise((resolve)=>{
                    try {
                        this.checkCompletion_(binary);
                        resolve(true);
                    } catch (error) {
                        throw error;
                    }
                });
                ps.push(p);
            }
            return Promise.all(ps);
        }
    }
    async checkCompletionAsync_(binary) {
        if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.parallelCompilationExtension.COMPLETION_STATUS_KHR)) return this.checkCompletion_(binary);
        else {
            await (0, $k22sw.nextFrame)();
            return this.checkCompletionAsync_(binary);
        }
    }
    checkCompletion_(binary) {
        if (this.gpgpu.gl.getProgramParameter(binary.webGLProgram, this.gpgpu.gl.LINK_STATUS) === false) {
            console.log(this.gpgpu.gl.getProgramInfoLog(binary.webGLProgram));
            if (this.gpgpu.gl.getShaderParameter(binary.fragmentShader, this.gpgpu.gl.COMPILE_STATUS) === false) {
                $k42ZR.logShaderSourceAndInfoLog(binary.source, this.gpgpu.gl.getShaderInfoLog(binary.fragmentShader));
                throw new Error('Failed to compile fragment shader.');
            }
            throw new Error('Failed to link vertex and fragment shaders.');
        }
        return true;
    }
    getUniformLocations() {
        for (const binary of Object.values(this.binaryCache)){
            // TODO: Iterating through all binaries to build VAOs is supposed to be in
            // a seperate function, like 'setVaos'. However, to avoid breaking changes
            // for the users using parallel compile feature now, buildVao is silently
            // added here.
            this.gpgpu.buildVao(binary.webGLProgram);
            const { variablesLocations: variablesLocations, customUniformLocations: customUniformLocations, infLoc: infLoc, nanLoc: nanLoc, outShapeLocation: outShapeLocation, outShapeStridesLocation: outShapeStridesLocation, outTexShapeLocation: outTexShapeLocation } = (0, $SwRKX.getUniformLocations)(this.gpgpu, binary.program, binary.webGLProgram);
            binary.variablesLocations = variablesLocations;
            binary.customUniformLocations = customUniformLocations;
            binary.infLoc = infLoc;
            binary.nanLoc = nanLoc;
            binary.outShapeLocation = outShapeLocation;
            binary.outShapeStridesLocation = outShapeStridesLocation;
            binary.outTexShapeLocation = outTexShapeLocation;
        }
    }
    /**
     * Create a TF.js tensor out of an existing WebGL texture. A new texture will
     * be created.
     */ createTensorFromGPUData(values, shape, dtype) {
        values.channels = values.channels || 'RGBA';
        const { texture: texture, height: height, width: width, channels: channels } = values;
        const backend = (0, $d7Nxs.engine)().backend;
        // Have to throw an error, otherwise WebGL just warns and returns wrong
        // values.
        if (!backend.gpgpu.gl.isTexture(texture)) throw new Error(`The texture is invalid. Also, please make sure the texture and ` + `the TFJS WebGL backend are using the same canvas. If you want to ` + `use your own custom canvas, you have to create and use the custom ` + `TFJS WebGL backend created from the canvas through ` + `'new tf.MathBackendWebGL(customCanvas)'.`);
        const dataId = backend.writeTexture(texture, shape, dtype, height, width, channels);
        return (0, $d7Nxs.engine)().makeTensorFromDataId(dataId, shape, dtype, backend);
    }
}
$0bfd71980e88f39a$export$33567d88bc7c6249.nextDataId = 0;
function $0bfd71980e88f39a$var$float32ToTypedArray(a, dtype) {
    if (dtype === 'float32' || dtype === 'complex64') return a;
    else if (dtype === 'int32' || dtype === 'bool') {
        const result = dtype === 'int32' ? new Int32Array(a.length) : new Uint8Array(a.length);
        for(let i = 0; i < result.length; ++i)result[i] = Math.round(a[i]);
        return result;
    } else throw new Error(`Unknown dtype ${dtype}`);
}

});
parcelRegister("7NwnT", function(module, exports) {
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $egPzb = parcelRequire("egPzb");
var $tdutJ = parcelRequire("tdutJ");

var $k42ZR = parcelRequire("k42ZR");
const $5ad63ae29e1c4afe$var$ENV = (0, $tdutJ.env)();
/**
 * This file contains WebGL-specific flag registrations.
 */ /**
 * True if WebGL is supported.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('HAS_WEBGL', ()=>$5ad63ae29e1c4afe$var$ENV.getNumber('WEBGL_VERSION') > 0);
/** 0: No WebGL, 1: WebGL 1.0, 2: WebGL 2.0. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_VERSION', ()=>{
    if ((0, $k42ZR.isWebGLVersionEnabled)(2)) return 2;
    else if ((0, $k42ZR.isWebGLVersionEnabled)(1)) return 1;
    return 0;
});
/** Whether to check for numerical representation problems. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_CHECK_NUMERICAL_PROBLEMS', ()=>false);
$5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_BUFFER_SUPPORTED', ()=>$5ad63ae29e1c4afe$var$ENV.get('WEBGL_VERSION') === 2);
/** Whether the WebGL backend will sometimes forward ops to the CPU. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_CPU_FORWARD', ()=>true);
/** Whether the WebGL backend will always use f16 textures for rendering. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_FORCE_F16_TEXTURES', ()=>false);
/** Whether to turn all packing related flags on. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('HAS_WEBGL'));
/** Whether we will pack the batchnormalization op. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_NORMALIZATION', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack the clip op. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_CLIP', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack the depthwise conv op. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_DEPTHWISECONV', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack binary ops. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_BINARY_OPERATIONS', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack unary ops. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_UNARY_OPERATIONS', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack array ops. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_ARRAY_OPERATIONS', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack image ops. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_IMAGE_OPERATIONS', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack reduce ops. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_REDUCE', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether packed WebGL kernels lazily unpack their outputs. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_LAZILY_UNPACK', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will use the im2col algorithm to speed up convolutions. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_CONV_IM2COL', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** Whether we will pack conv2dTranspose op. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_PACK_CONV2DTRANSPOSE', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_PACK'));
/** The maximum texture dimension. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_MAX_TEXTURE_SIZE', ()=>(0, $k42ZR.getWebGLMaxTextureSize)($5ad63ae29e1c4afe$var$ENV.getNumber('WEBGL_VERSION')));
/** The maximum texture dimension. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_MAX_TEXTURES_IN_SHADER', ()=>(0, $k42ZR.getMaxTexturesInShader)($5ad63ae29e1c4afe$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * The disjoint_query_timer extension version.
 * 0: disabled, 1: EXT_disjoint_timer_query, 2:
 * EXT_disjoint_timer_query_webgl2.
 * In Firefox with WebGL 2.0,
 * EXT_disjoint_timer_query_webgl2 is not available, so we must use the
 * WebGL 1.0 extension.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION', ()=>{
    const webGLVersion = $5ad63ae29e1c4afe$var$ENV.getNumber('WEBGL_VERSION');
    if (webGLVersion === 0) return 0;
    return (0, $k42ZR.getWebGLDisjointQueryTimerVersion)(webGLVersion);
});
/**
 * Whether the timer object from the disjoint_query_timer extension gives
 * timing information that is reliable.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE', ()=>$5ad63ae29e1c4afe$var$ENV.getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0 && !(0, $egPzb).isMobile());
/**
 * Whether the device is physically capable of rendering to float32 textures.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_RENDER_FLOAT32_CAPABLE', ()=>(0, $k42ZR.isCapableOfRenderingToFloatTexture)($5ad63ae29e1c4afe$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * Whether rendering to float32 textures is enabled. If disabled, renders to
 * float16 textures.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_RENDER_FLOAT32_ENABLED', ()=>{
    return $5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_FORCE_F16_TEXTURES') ? false : $5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_RENDER_FLOAT32_CAPABLE');
});
/**
 * Whether downloading float textures is enabled (16 or 32 bit). If disabled,
 * uses IEEE 754 encoding of the float32 values to 4 uint8 when downloading.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_DOWNLOAD_FLOAT_ENABLED', ()=>(0, $k42ZR.isDownloadFloatTextureEnabled)($5ad63ae29e1c4afe$var$ENV.getNumber('WEBGL_VERSION')));
/** Whether the fence API is available. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_FENCE_API_ENABLED', ()=>(0, $k42ZR.isWebGLFenceEnabled)($5ad63ae29e1c4afe$var$ENV.getNumber('WEBGL_VERSION')));
/**
 * Tensors with size <= than this will be uploaded as uniforms, not textures.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_SIZE_UPLOAD_UNIFORM', ()=>{
    // Use uniform uploads only when 32bit floats are supported. In
    // 16bit
    // environments there are problems with comparing a 16bit texture value
    // with a 32bit uniform value.
    const useUniforms = $5ad63ae29e1c4afe$var$ENV.getBool('WEBGL_RENDER_FLOAT32_ENABLED');
    return useUniforms ? 4 : 0;
});
/**
 * If the total number of bytes allocated on the GPU is greater than this
 * number, we will aggressively delete textures upon disposal with
 * gl.deleteMatrixTexture, rather than making them available for reuse.
 *
 * Default value -1 indicates that we will never aggressively delete textures.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_DELETE_TEXTURE_THRESHOLD', ()=>{
    return -1;
}, (threshold)=>{
    if (!(typeof threshold === 'number')) throw new Error('WEBGL_DELETE_TEXTURE_THRESHOLD must be a number but ' + `got ${threshold}.`);
    if (threshold < 0 && threshold !== -1) throw new Error(`WEBGL_DELETE_TEXTURE_THRESHOLD must be -1 (indicating never ` + `delete) or at least 0, but got ${threshold}.`);
});
/**
 * Trigger a manual GL command flush if the threshold of time has passed since
 * previous Kernel execution. This can be useful for Andorid device where GL
 * command flush are delayed un til the end of javascript task. This value is
 * measured in millisecond. Typically you want to set this value to close to 1.
 *
 * Default value 1 for mobile chrome, and -1 for rest cases. -1 indicates that
 * we will not enforce manual flush and depend on system default flush schedule.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_FLUSH_THRESHOLD', ()=>{
    return (0, $egPzb).isMobile() ? 1 : -1;
}, (threshold)=>{
    if (!(typeof threshold === 'number')) throw new Error('WEBGL_FLUSH_THRESHOLD must be a number but got ' + `${threshold}.`);
    if (threshold < 0 && threshold !== -1) throw new Error(`WEBGL_FLUSH_THRESHOLD must be -1 (indicating never ` + `manual flush) or at least 0, but got ${threshold}.`);
});
/**
 * Threshold for input tensor size that determines whether WebGL backend will
 * delegate computation to CPU.
 *
 * Default value is 128.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('CPU_HANDOFF_SIZE_THRESHOLD', ()=>128);
/** Whether we will use shapes uniforms. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_USE_SHAPES_UNIFORMS', ()=>false);
/**
 * Threshold for last dimension of input tensor that determines whether
 * WebGL backend for the Top K op will delegate computation to CPU. If input
 * is smaller than threshold then CPU will be used
 *
 * Default value is 100000.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD', ()=>100000);
/**
 * Threshold for K that determines whether
 * WebGL backend for the Top K op will delegate computation to CPU. If k
 * is larger than threshold then CPU will be used
 *
 * Default value is 128.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('TOPK_K_CPU_HANDOFF_THRESHOLD', ()=>128);
/** Whether we will use the experimental conv op. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_EXP_CONV', ()=>false);
/**
 * If the device performance is low or if no hardware GPU is available, whether
 * software WebGL will be used.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('SOFTWARE_WEBGL_ENABLED', ()=>$5ad63ae29e1c4afe$var$ENV.getBool('IS_TEST'));
/**
 * For narrow texture (physical height or physical width is 1), if the length of
 * any texture edges exceed the threshold, the texture will be reshaped to be
 * more squarish.
 *
 * This flag is used to help some GPUs that could not provide correct
 * interpolations for long skinny triangles. We found Mali GPU probably has this
 * problem: https://github.com/tensorflow/tfjs/issues/6775.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE', ()=>Infinity);
/**
 * If the flag is set to true, the max size of the narrow texture will be auto
 * computed and it will be considerred as a threshold to reshape the narrow
 * texture to be more squarish.
 *
 * This flag is used to help some GPUs that could not provide correct
 * interpolations for long skinny triangles. We found Mali GPU probably has this
 * problem: https://github.com/tensorflow/tfjs/issues/6775.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE', ()=>false);
/**
 * Whether to use the customized isnan. It's only useful for webgl2 since webgl1
 * doesn't have the builtin isnan.
 */ $5ad63ae29e1c4afe$var$ENV.registerFlag('WEBGL2_ISNAN_CUSTOM', ()=>false);
/** Experimental flag, whether enter compile only phase. */ $5ad63ae29e1c4afe$var$ENV.registerFlag('ENGINE_COMPILE_ONLY', ()=>false);

});
parcelRegister("k42ZR", function(module, exports) {

$parcel$export(module.exports, "callAndCheck", function () { return $e9b6817640cf8532$export$7642ac97981532b8; });
$parcel$export(module.exports, "canBeRepresented", function () { return $e9b6817640cf8532$export$829768a5b7625879; });
$parcel$export(module.exports, "getExtensionOrThrow", function () { return $e9b6817640cf8532$export$3a5e7a891790a26c; });
$parcel$export(module.exports, "createVertexShader", function () { return $e9b6817640cf8532$export$4ca6704ce1875929; });
$parcel$export(module.exports, "createFragmentShader", function () { return $e9b6817640cf8532$export$a8ab0e04b20572c0; });
$parcel$export(module.exports, "logShaderSourceAndInfoLog", function () { return $e9b6817640cf8532$export$f7b23987b58d218; });
$parcel$export(module.exports, "createProgram", function () { return $e9b6817640cf8532$export$327d24a04cd0dc17; });
$parcel$export(module.exports, "linkProgram", function () { return $e9b6817640cf8532$export$d879afae78b531a5; });
$parcel$export(module.exports, "validateProgram", function () { return $e9b6817640cf8532$export$e2dfaf93681cde16; });
$parcel$export(module.exports, "createStaticVertexBuffer", function () { return $e9b6817640cf8532$export$3871e1d1e28ac6cb; });
$parcel$export(module.exports, "createStaticIndexBuffer", function () { return $e9b6817640cf8532$export$f9b26b97ca2b25e9; });
$parcel$export(module.exports, "createTexture", function () { return $e9b6817640cf8532$export$37b981a8c575f415; });
$parcel$export(module.exports, "validateTextureSize", function () { return $e9b6817640cf8532$export$3543950a45505554; });
$parcel$export(module.exports, "createFramebuffer", function () { return $e9b6817640cf8532$export$366d1e3e32f5a700; });
$parcel$export(module.exports, "bindVertexBufferToProgramAttribute", function () { return $e9b6817640cf8532$export$4c858b3c953a013f; });
$parcel$export(module.exports, "getProgramUniformLocationOrThrow", function () { return $e9b6817640cf8532$export$748cafa2cdf50d8; });
$parcel$export(module.exports, "getProgramUniformLocation", function () { return $e9b6817640cf8532$export$d27256445dd7e8dd; });
$parcel$export(module.exports, "bindTextureToProgramUniformSampler", function () { return $e9b6817640cf8532$export$f9ffd997f3c8b98f; });
$parcel$export(module.exports, "bindColorTextureToFramebuffer", function () { return $e9b6817640cf8532$export$4e154f0d71f19013; });
$parcel$export(module.exports, "unbindColorTextureFromFramebuffer", function () { return $e9b6817640cf8532$export$d3c809959a3c24fa; });
$parcel$export(module.exports, "validateFramebuffer", function () { return $e9b6817640cf8532$export$ca09b577525e6519; });
$parcel$export(module.exports, "getBatchDim", function () { return $e9b6817640cf8532$export$4dfd7bc0667970e0; });
$parcel$export(module.exports, "getRowsCols", function () { return $e9b6817640cf8532$export$e8f6c350b57b8270; });
$parcel$export(module.exports, "getShapeAs3D", function () { return $e9b6817640cf8532$export$f944c0101b593a79; });
$parcel$export(module.exports, "getTextureShapeFromLogicalShape", function () { return $e9b6817640cf8532$export$80bf57c6927be1d9; });
$parcel$export(module.exports, "isReshapeFree", function () { return $e9b6817640cf8532$export$951b388203a0422d; });
$parcel$export(module.exports, "getWebGLMaxTextureSize", function () { return $e9b6817640cf8532$export$9dbf32263e41ec5; });
$parcel$export(module.exports, "getMaxTexturesInShader", function () { return $e9b6817640cf8532$export$ce91baf6aebded89; });
$parcel$export(module.exports, "getWebGLDisjointQueryTimerVersion", function () { return $e9b6817640cf8532$export$8a49d28f4bb7b8a0; });
$parcel$export(module.exports, "hasExtension", function () { return $e9b6817640cf8532$export$4f402f57c05c9ec3; });
$parcel$export(module.exports, "isWebGLVersionEnabled", function () { return $e9b6817640cf8532$export$9232c111e2230c00; });
$parcel$export(module.exports, "isCapableOfRenderingToFloatTexture", function () { return $e9b6817640cf8532$export$d571cb60e9b5ec74; });
$parcel$export(module.exports, "isDownloadFloatTextureEnabled", function () { return $e9b6817640cf8532$export$9cd61c8662dbbc66; });
$parcel$export(module.exports, "isWebGLFenceEnabled", function () { return $e9b6817640cf8532$export$77efcdc20b17e5f2; });
$parcel$export(module.exports, "assertNotComplex", function () { return $e9b6817640cf8532$export$1412c17b2531581a; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $lBDHD = parcelRequire("lBDHD");

var $8BJsC = parcelRequire("8BJsC");

var $2zyhV = parcelRequire("2zyhV");
function $e9b6817640cf8532$export$7642ac97981532b8(gl, func) {
    const returnValue = func();
    if ((0, $tdutJ.env)().getBool('DEBUG')) $e9b6817640cf8532$var$checkWebGLError(gl);
    return returnValue;
}
function $e9b6817640cf8532$var$checkWebGLError(gl) {
    const error = gl.getError();
    if (error !== gl.NO_ERROR) throw new Error('WebGL Error: ' + $e9b6817640cf8532$export$ee3c7ff80964e13e(gl, error));
}
// https://en.wikipedia.org/wiki/Half-precision_floating-point_format
const $e9b6817640cf8532$var$MIN_FLOAT16 = 5.96e-8;
const $e9b6817640cf8532$var$MAX_FLOAT16 = 65504;
function $e9b6817640cf8532$export$829768a5b7625879(num) {
    if ((0, $tdutJ.env)().getBool('WEBGL_RENDER_FLOAT32_ENABLED') || num === 0 || $e9b6817640cf8532$var$MIN_FLOAT16 < Math.abs(num) && Math.abs(num) < $e9b6817640cf8532$var$MAX_FLOAT16) return true;
    return false;
}
function $e9b6817640cf8532$export$ee3c7ff80964e13e(gl, status) {
    switch(status){
        case gl.NO_ERROR:
            return 'NO_ERROR';
        case gl.INVALID_ENUM:
            return 'INVALID_ENUM';
        case gl.INVALID_VALUE:
            return 'INVALID_VALUE';
        case gl.INVALID_OPERATION:
            return 'INVALID_OPERATION';
        case gl.INVALID_FRAMEBUFFER_OPERATION:
            return 'INVALID_FRAMEBUFFER_OPERATION';
        case gl.OUT_OF_MEMORY:
            return 'OUT_OF_MEMORY';
        case gl.CONTEXT_LOST_WEBGL:
            return 'CONTEXT_LOST_WEBGL';
        default:
            return `Unknown error code ${status}`;
    }
}
function $e9b6817640cf8532$export$3a5e7a891790a26c(gl, extensionName) {
    return $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.getExtension(extensionName), 'Extension "' + extensionName + '" not supported on this browser.');
}
function $e9b6817640cf8532$export$4ca6704ce1875929(gl, vertexShaderSource) {
    const vertexShader = $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.createShader(gl.VERTEX_SHADER), 'Unable to create vertex WebGLShader.');
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.shaderSource(vertexShader, vertexShaderSource));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.compileShader(vertexShader));
    if (gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS) === false) {
        console.log(gl.getShaderInfoLog(vertexShader));
        throw new Error('Failed to compile vertex shader.');
    }
    return vertexShader;
}
function $e9b6817640cf8532$export$a8ab0e04b20572c0(gl, fragmentShaderSource) {
    const fragmentShader = $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.createShader(gl.FRAGMENT_SHADER), 'Unable to create fragment WebGLShader.');
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.shaderSource(fragmentShader, fragmentShaderSource));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.compileShader(fragmentShader));
    if ((0, $tdutJ.env)().get('ENGINE_COMPILE_ONLY')) return fragmentShader;
    if (gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS) === false) {
        $e9b6817640cf8532$export$f7b23987b58d218(fragmentShaderSource, gl.getShaderInfoLog(fragmentShader));
        throw new Error('Failed to compile fragment shader.');
    }
    return fragmentShader;
}
const $e9b6817640cf8532$var$lineNumberRegex = /ERROR: [0-9]+:([0-9]+):/g;
function $e9b6817640cf8532$export$f7b23987b58d218(shaderSource, shaderInfoLog) {
    const lineNumberRegexResult = $e9b6817640cf8532$var$lineNumberRegex.exec(shaderInfoLog);
    if (lineNumberRegexResult == null) {
        console.log(`Couldn't parse line number in error: ${shaderInfoLog}`);
        console.log(shaderSource);
        return;
    }
    const lineNumber = +lineNumberRegexResult[1];
    const shaderLines = shaderSource.split('\n');
    const pad = shaderLines.length.toString().length + 2;
    const linesWithLineNumbers = shaderLines.map((line, lineNumber)=>(0, $lBDHD).rightPad((lineNumber + 1).toString(), pad) + line);
    let maxLineLength = 0;
    for(let i = 0; i < linesWithLineNumbers.length; i++)maxLineLength = Math.max(linesWithLineNumbers[i].length, maxLineLength);
    const beforeErrorLines = linesWithLineNumbers.slice(0, lineNumber - 1);
    const errorLine = linesWithLineNumbers.slice(lineNumber - 1, lineNumber);
    const afterErrorLines = linesWithLineNumbers.slice(lineNumber);
    console.log(beforeErrorLines.join('\n'));
    console.log(shaderInfoLog.split('\n')[0]);
    console.log(`%c ${(0, $lBDHD).rightPad(errorLine[0], maxLineLength)}`, 'border:1px solid red; background-color:#e3d2d2; color:#a61717');
    console.log(afterErrorLines.join('\n'));
}
function $e9b6817640cf8532$export$327d24a04cd0dc17(gl) {
    return $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.createProgram(), 'Unable to create WebGLProgram.');
}
function $e9b6817640cf8532$export$d879afae78b531a5(gl, program) {
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.linkProgram(program));
    if ((0, $tdutJ.env)().get('ENGINE_COMPILE_ONLY')) return;
    if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
        console.log(gl.getProgramInfoLog(program));
        throw new Error('Failed to link vertex and fragment shaders.');
    }
}
function $e9b6817640cf8532$export$e2dfaf93681cde16(gl, program) {
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.validateProgram(program));
    if (gl.getProgramParameter(program, gl.VALIDATE_STATUS) === false) {
        console.log(gl.getProgramInfoLog(program));
        throw new Error('Shader program validation failed.');
    }
}
function $e9b6817640cf8532$export$3871e1d1e28ac6cb(gl, data) {
    const buffer = $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.createBuffer(), 'Unable to create WebGLBuffer');
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, buffer));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW));
    return buffer;
}
function $e9b6817640cf8532$export$f9b26b97ca2b25e9(gl, data) {
    const buffer = $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.createBuffer(), 'Unable to create WebGLBuffer');
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, buffer));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, data, gl.STATIC_DRAW));
    return buffer;
}
function $e9b6817640cf8532$export$45c2ce5fe87dcf0f() {
    if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2) return 1;
    return 4;
}
function $e9b6817640cf8532$export$37b981a8c575f415(gl) {
    return $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.createTexture(), 'Unable to create WebGLTexture.');
}
function $e9b6817640cf8532$export$3543950a45505554(width, height) {
    const maxTextureSize = (0, $tdutJ.env)().getNumber('WEBGL_MAX_TEXTURE_SIZE');
    if (width <= 0 || height <= 0) {
        const requested = `[${width}x${height}]`;
        throw new Error('Requested texture size ' + requested + ' is invalid.');
    }
    if (width > maxTextureSize || height > maxTextureSize) {
        const requested = `[${width}x${height}]`;
        const max = `[${maxTextureSize}x${maxTextureSize}]`;
        throw new Error('Requested texture size ' + requested + ' greater than WebGL maximum on this browser / GPU ' + max + '.');
    }
}
function $e9b6817640cf8532$export$366d1e3e32f5a700(gl) {
    return $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.createFramebuffer(), 'Unable to create WebGLFramebuffer.');
}
function $e9b6817640cf8532$export$4c858b3c953a013f(gl, program, attribute, buffer, arrayEntriesPerItem, itemStrideInBytes, itemOffsetInBytes) {
    const loc = gl.getAttribLocation(program, attribute);
    if (loc === -1) // The GPU compiler decided to strip out this attribute because it's unused,
    // thus no need to bind.
    return false;
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, buffer));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.vertexAttribPointer(loc, arrayEntriesPerItem, gl.FLOAT, false, itemStrideInBytes, itemOffsetInBytes));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.enableVertexAttribArray(loc));
    return true;
}
function $e9b6817640cf8532$export$520907fe7b2c7a2d(gl, texture, textureUnit) {
    $e9b6817640cf8532$var$validateTextureUnit(gl, textureUnit);
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.activeTexture(gl.TEXTURE0 + textureUnit));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
}
function $e9b6817640cf8532$export$9bed01c46f4769b6(gl, textureUnit) {
    $e9b6817640cf8532$var$validateTextureUnit(gl, textureUnit);
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.activeTexture(gl.TEXTURE0 + textureUnit));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $e9b6817640cf8532$export$748cafa2cdf50d8(gl, program, uniformName) {
    return $e9b6817640cf8532$var$throwIfNull(gl, ()=>gl.getUniformLocation(program, uniformName), 'uniform "' + uniformName + '" not present in program.');
}
function $e9b6817640cf8532$export$d27256445dd7e8dd(gl, program, uniformName) {
    return gl.getUniformLocation(program, uniformName);
}
function $e9b6817640cf8532$export$f9ffd997f3c8b98f(gl, texture, uniformSamplerLocation, textureUnit) {
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>$e9b6817640cf8532$export$520907fe7b2c7a2d(gl, texture, textureUnit));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.uniform1i(uniformSamplerLocation, textureUnit));
}
function $e9b6817640cf8532$export$2e43f6b5d575e241(gl) {
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, null));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.viewport(0, 0, gl.canvas.width, gl.canvas.height));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.scissor(0, 0, gl.canvas.width, gl.canvas.height));
}
function $e9b6817640cf8532$export$4e154f0d71f19013(gl, texture, framebuffer) {
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0));
}
function $e9b6817640cf8532$export$d3c809959a3c24fa(gl, framebuffer) {
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer));
    $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, null, 0));
}
function $e9b6817640cf8532$export$ca09b577525e6519(gl) {
    const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    if (status !== gl.FRAMEBUFFER_COMPLETE) throw new Error('Error binding framebuffer: ' + $e9b6817640cf8532$export$851c7fde035f5bf6(gl, status));
}
function $e9b6817640cf8532$export$851c7fde035f5bf6(gl, status) {
    switch(status){
        case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
            return 'FRAMEBUFFER_INCOMPLETE_ATTACHMENT';
        case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
            return 'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT';
        case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
            return 'FRAMEBUFFER_INCOMPLETE_DIMENSIONS';
        case gl.FRAMEBUFFER_UNSUPPORTED:
            return 'FRAMEBUFFER_UNSUPPORTED';
        default:
            return `unknown error ${status}`;
    }
}
function $e9b6817640cf8532$var$throwIfNull(gl, returnTOrNull, failureMessage) {
    const tOrNull = $e9b6817640cf8532$export$7642ac97981532b8(gl, ()=>returnTOrNull());
    if (tOrNull == null) throw new Error(failureMessage);
    return tOrNull;
}
function $e9b6817640cf8532$var$validateTextureUnit(gl, textureUnit) {
    const maxTextureUnit = gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1;
    const glTextureUnit = textureUnit + gl.TEXTURE0;
    if (glTextureUnit < gl.TEXTURE0 || glTextureUnit > maxTextureUnit) {
        const textureUnitRange = `[gl.TEXTURE0, gl.TEXTURE${maxTextureUnit}]`;
        throw new Error(`textureUnit must be in ${textureUnitRange}.`);
    }
}
function $e9b6817640cf8532$export$4dfd7bc0667970e0(shape, dimsToSkip = 2) {
    return (0, $lBDHD).sizeFromShape(shape.slice(0, shape.length - dimsToSkip));
}
function $e9b6817640cf8532$export$e8f6c350b57b8270(shape) {
    if (shape.length === 0) throw Error('Cannot get rows and columns of an empty shape array.');
    return [
        shape.length > 1 ? shape[shape.length - 2] : 1,
        shape[shape.length - 1]
    ];
}
function $e9b6817640cf8532$export$f944c0101b593a79(shape) {
    let shapeAs3D = [
        1,
        1,
        1
    ];
    const isScalar = shape.length === 0 || shape.length === 1 && shape[0] === 1;
    if (!isScalar) shapeAs3D = [
        $e9b6817640cf8532$export$4dfd7bc0667970e0(shape),
        ...$e9b6817640cf8532$export$e8f6c350b57b8270(shape)
    ];
    return shapeAs3D;
}
function $e9b6817640cf8532$export$80bf57c6927be1d9(logShape, isPacked = false) {
    let maxTexSize = (0, $tdutJ.env)().getNumber('WEBGL_MAX_TEXTURE_SIZE');
    let maxSizeForNarrowTex = (0, $tdutJ.env)().getNumber('WEBGL_MAX_SIZE_FOR_NARROW_TEXTURE');
    if (maxSizeForNarrowTex === Infinity && (0, $tdutJ.env)().getBool('WEBGL_AUTO_SQUARIFY_NARROW_TEXTURE_SHAPE')) maxSizeForNarrowTex = maxTexSize / 2;
    if (isPacked) {
        maxTexSize = maxTexSize * 2;
        maxSizeForNarrowTex = maxSizeForNarrowTex * 2;
        // This logic ensures we accurately count the number of packed texels needed
        // to accommodate the tensor. We can only pack values in the same texel if
        // they are from adjacent pairs of rows/cols within the same batch. So if a
        // tensor has 3 rows, we pretend it has 4 rows in order to account for the
        // fact that the texels containing the third row are half empty.
        logShape = logShape.map((d, i)=>i >= logShape.length - 2 ? (0, $lBDHD).nearestLargerEven(logShape[i]) : logShape[i]);
        // Packed texture height is at least 2 (the channel height of a single
        // texel).
        if (logShape.length === 1) logShape = [
            2,
            logShape[0]
        ];
    }
    // If logical shape is 2, we don't squeeze, since we want to match physical.
    if (logShape.length !== 2) {
        const squeezeResult = (0, $lBDHD).squeezeShape(logShape);
        logShape = squeezeResult.newShape;
    }
    let size = (0, $lBDHD).sizeFromShape(logShape);
    let textureShape = null;
    if (logShape.length <= 1 && size <= maxTexSize) textureShape = [
        1,
        size
    ];
    else if (logShape.length === 2 && logShape[0] <= maxTexSize && logShape[1] <= maxTexSize) textureShape = logShape;
    else if (logShape.length === 3 && logShape[0] * logShape[1] <= maxTexSize && logShape[2] <= maxTexSize) textureShape = [
        logShape[0] * logShape[1],
        logShape[2]
    ];
    else if (logShape.length === 3 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] <= maxTexSize) textureShape = [
        logShape[0],
        logShape[1] * logShape[2]
    ];
    else if (logShape.length === 4 && logShape[0] * logShape[1] * logShape[2] <= maxTexSize && logShape[3] <= maxTexSize) textureShape = [
        logShape[0] * logShape[1] * logShape[2],
        logShape[3]
    ];
    else if (logShape.length === 4 && logShape[0] <= maxTexSize && logShape[1] * logShape[2] * logShape[3] <= maxTexSize) textureShape = [
        logShape[0],
        logShape[1] * logShape[2] * logShape[3]
    ];
    // true if one edge length is 1 (1 or 2, if packed), while another edge
    // length exceeds maxSizeForNarrowTex.
    const isLongNarrowTex = textureShape != null && Math.max(...textureShape) > maxSizeForNarrowTex && Math.min(...textureShape) <= (isPacked ? 2 : 1) && Math.min(...textureShape) > 0;
    if (textureShape == null || isLongNarrowTex) {
        if (isPacked) {
            // For packed textures size equals the number of channels required to
            // accommodate the texture data. However in order to squarify such that
            // inner dimensions stay even, we rewrite size to equal the number of
            // texels. Then in the return statement we rehydrate the squarified
            // dimensions to channel units.
            const batchDim = $e9b6817640cf8532$export$4dfd7bc0667970e0(logShape);
            let rows = 2, cols = 2;
            if (logShape.length) [rows, cols] = $e9b6817640cf8532$export$e8f6c350b57b8270(logShape);
            size = batchDim * (rows / 2) * (cols / 2);
            textureShape = (0, $lBDHD).sizeToSquarishShape(size).map((d)=>d * 2);
        } else textureShape = (0, $lBDHD).sizeToSquarishShape(size);
    }
    return textureShape;
}
function $e9b6817640cf8532$var$isEven(n) {
    return n % 2 === 0;
}
function $e9b6817640cf8532$export$951b388203a0422d(shape1, shape2) {
    shape1 = shape1.slice(-2);
    shape2 = shape2.slice(-2);
    if ((0, $lBDHD).arraysEqual(shape1, shape2)) return true;
    if (!shape1.length || !shape2.length) return true;
    if (shape1[0] === 0 || shape1[1] === 0 || shape2[0] === 0 || shape2[1] === 0) return true;
    if (shape1.length !== shape2.length) {
        const shape1Cols = shape1[shape1.length - 1];
        const shape2Cols = shape2[shape2.length - 1];
        if (shape1Cols === shape2Cols) return true;
        if ($e9b6817640cf8532$var$isEven(shape1Cols) && $e9b6817640cf8532$var$isEven(shape2Cols) && (shape1[0] === 1 || shape2[0] === 1)) return true;
    }
    return shape1[1] === shape2[1] && $e9b6817640cf8532$var$isEven(shape1[0]) && $e9b6817640cf8532$var$isEven(shape2[0]);
}
// We cache webgl params because the environment gets reset between
// unit tests and we don't want to constantly query the WebGLContext for
// MAX_TEXTURE_SIZE.
let $e9b6817640cf8532$var$MAX_TEXTURE_SIZE;
let $e9b6817640cf8532$var$MAX_TEXTURES_IN_SHADER;
function $e9b6817640cf8532$export$9dbf32263e41ec5(webGLVersion) {
    if ($e9b6817640cf8532$var$MAX_TEXTURE_SIZE == null) {
        const gl = (0, $8BJsC.getWebGLContext)(webGLVersion);
        $e9b6817640cf8532$var$MAX_TEXTURE_SIZE = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    }
    return $e9b6817640cf8532$var$MAX_TEXTURE_SIZE;
}
function $e9b6817640cf8532$export$3bb3363a1d77ce11() {
    $e9b6817640cf8532$var$MAX_TEXTURE_SIZE = null;
}
function $e9b6817640cf8532$export$295b7d11bb89e671() {
    $e9b6817640cf8532$var$MAX_TEXTURES_IN_SHADER = null;
}
function $e9b6817640cf8532$export$ce91baf6aebded89(webGLVersion) {
    if ($e9b6817640cf8532$var$MAX_TEXTURES_IN_SHADER == null) {
        const gl = (0, $8BJsC.getWebGLContext)(webGLVersion);
        $e9b6817640cf8532$var$MAX_TEXTURES_IN_SHADER = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    }
    // We cap at 16 to avoid spurious runtime "memory exhausted" error.
    return Math.min(16, $e9b6817640cf8532$var$MAX_TEXTURES_IN_SHADER);
}
function $e9b6817640cf8532$export$8a49d28f4bb7b8a0(webGLVersion) {
    if (webGLVersion === 0) return 0;
    let queryTimerVersion;
    const gl = (0, $8BJsC.getWebGLContext)(webGLVersion);
    if ($e9b6817640cf8532$export$4f402f57c05c9ec3(gl, 'EXT_disjoint_timer_query_webgl2') && webGLVersion === 2) queryTimerVersion = 2;
    else if ($e9b6817640cf8532$export$4f402f57c05c9ec3(gl, 'EXT_disjoint_timer_query')) queryTimerVersion = 1;
    else queryTimerVersion = 0;
    return queryTimerVersion;
}
function $e9b6817640cf8532$export$4f402f57c05c9ec3(gl, extensionName) {
    const ext = gl.getExtension(extensionName);
    return ext != null;
}
function $e9b6817640cf8532$export$9232c111e2230c00(webGLVersion) {
    try {
        const gl = (0, $8BJsC.getWebGLContext)(webGLVersion);
        if (gl != null) return true;
    } catch (e) {
        console.log('Error when getting WebGL context: ', e);
        return false;
    }
    return false;
}
function $e9b6817640cf8532$export$d571cb60e9b5ec74(webGLVersion) {
    if (webGLVersion === 0) return false;
    const gl = (0, $8BJsC.getWebGLContext)(webGLVersion);
    if (webGLVersion === 1) {
        if (!$e9b6817640cf8532$export$4f402f57c05c9ec3(gl, 'OES_texture_float')) return false;
    } else {
        if (!$e9b6817640cf8532$export$4f402f57c05c9ec3(gl, 'EXT_color_buffer_float')) return false;
    }
    const isFrameBufferComplete = $e9b6817640cf8532$var$createFloatTextureAndBindToFramebuffer(gl);
    return isFrameBufferComplete;
}
function $e9b6817640cf8532$export$9cd61c8662dbbc66(webGLVersion) {
    if (webGLVersion === 0) return false;
    const gl = (0, $8BJsC.getWebGLContext)(webGLVersion);
    if (webGLVersion === 1) {
        if (!$e9b6817640cf8532$export$4f402f57c05c9ec3(gl, 'OES_texture_float')) return false;
        if (!$e9b6817640cf8532$export$4f402f57c05c9ec3(gl, 'WEBGL_color_buffer_float')) return false;
    } else {
        if ($e9b6817640cf8532$export$4f402f57c05c9ec3(gl, 'EXT_color_buffer_float')) return $e9b6817640cf8532$var$createFloatTextureAndBindToFramebuffer(gl);
        const COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
        if ($e9b6817640cf8532$export$4f402f57c05c9ec3(gl, COLOR_BUFFER_HALF_FLOAT)) {
            const textureHalfFloatExtension = gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
            return $e9b6817640cf8532$var$createHalfFloatTextureAndBindToFramebuffer(gl, textureHalfFloatExtension);
        }
        return false;
    }
    const isFrameBufferComplete = $e9b6817640cf8532$var$createFloatTextureAndBindToFramebuffer(gl);
    return isFrameBufferComplete;
}
function $e9b6817640cf8532$var$createFloatTextureAndBindToFramebuffer(gl) {
    const texConfig = (0, $2zyhV.getTextureConfig)(gl);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const width = 1;
    const height = 1;
    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeFloat, null);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(frameBuffer);
    return isFrameBufferComplete;
}
function $e9b6817640cf8532$var$createHalfFloatTextureAndBindToFramebuffer(// tslint:disable-next-line:no-any
gl, textureHalfFloatExtension) {
    const texConfig = (0, $2zyhV.getTextureConfig)(gl, textureHalfFloatExtension);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    const width = 1;
    const height = 1;
    gl.texImage2D(gl.TEXTURE_2D, 0, texConfig.internalFormatHalfFloat, width, height, 0, texConfig.textureFormatFloat, texConfig.textureTypeHalfFloat, null);
    const frameBuffer = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, frameBuffer);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const isFrameBufferComplete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
    gl.bindTexture(gl.TEXTURE_2D, null);
    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    gl.deleteTexture(texture);
    gl.deleteFramebuffer(frameBuffer);
    return isFrameBufferComplete;
}
function $e9b6817640cf8532$export$77efcdc20b17e5f2(webGLVersion) {
    if (webGLVersion !== 2) return false;
    const gl = (0, $8BJsC.getWebGLContext)(webGLVersion);
    // tslint:disable-next-line:no-any
    const isEnabled = gl.fenceSync != null;
    return isEnabled;
}
function $e9b6817640cf8532$export$1412c17b2531581a(tensor, opName) {
    if (!Array.isArray(tensor)) tensor = [
        tensor
    ];
    tensor.forEach((t)=>{
        if (t != null) (0, $lBDHD).assert(t.dtype !== 'complex64', ()=>`${opName} does not support complex64 tensors ` + 'in the WebGL backend.');
    });
}

});
parcelRegister("8BJsC", function(module, exports) {

$parcel$export(module.exports, "setWebGLContext", function () { return $64450af18d844cd7$export$4b8d5e1525955c68; });
$parcel$export(module.exports, "getWebGLContext", function () { return $64450af18d844cd7$export$c7a808a518b9a146; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
const $64450af18d844cd7$var$contexts = {};
const $64450af18d844cd7$var$WEBGL_ATTRIBUTES = {
    alpha: false,
    antialias: false,
    premultipliedAlpha: false,
    preserveDrawingBuffer: false,
    depth: false,
    stencil: false,
    failIfMajorPerformanceCaveat: true
};
function $64450af18d844cd7$export$c5302deff3a07920(webGLVersion) {
    delete $64450af18d844cd7$var$contexts[webGLVersion];
}
function $64450af18d844cd7$export$4b8d5e1525955c68(webGLVersion, gl) {
    $64450af18d844cd7$var$contexts[webGLVersion] = gl;
}
function $64450af18d844cd7$export$c7a808a518b9a146(webGLVersion, customCanvas) {
    if (!(webGLVersion in $64450af18d844cd7$var$contexts) || customCanvas != null) {
        const newCtx = $64450af18d844cd7$var$getWebGLRenderingContext(webGLVersion, customCanvas);
        if (newCtx !== null) $64450af18d844cd7$var$contexts[webGLVersion] = newCtx;
        else {
            console.log('Could not get context for WebGL version', webGLVersion);
            return null;
        }
    }
    const gl = $64450af18d844cd7$var$contexts[webGLVersion];
    if (gl == null || gl.isContextLost()) {
        delete $64450af18d844cd7$var$contexts[webGLVersion];
        return $64450af18d844cd7$export$c7a808a518b9a146(webGLVersion);
    }
    gl.disable(gl.DEPTH_TEST);
    gl.disable(gl.STENCIL_TEST);
    gl.disable(gl.BLEND);
    gl.disable(gl.DITHER);
    gl.disable(gl.POLYGON_OFFSET_FILL);
    gl.disable(gl.SAMPLE_COVERAGE);
    gl.enable(gl.SCISSOR_TEST);
    gl.enable(gl.CULL_FACE);
    gl.cullFace(gl.BACK);
    return $64450af18d844cd7$var$contexts[webGLVersion];
}
function $64450af18d844cd7$var$createCanvas(webGLVersion) {
    // Use canvas element for Safari, since its offscreen canvas does not support
    // fencing.
    if (!(0, $tdutJ.env)().getBool('IS_SAFARI') && typeof OffscreenCanvas !== 'undefined' && webGLVersion === 2) return new OffscreenCanvas(300, 150);
    else if (typeof document !== 'undefined') return document.createElement('canvas');
    else throw new Error('Cannot create a canvas in this context');
}
function $64450af18d844cd7$var$getWebGLRenderingContext(webGLVersion, customCanvas) {
    if (webGLVersion !== 1 && webGLVersion !== 2) throw new Error('Cannot get WebGL rendering context, WebGL is disabled.');
    const canvas = customCanvas == null ? $64450af18d844cd7$var$createCanvas(webGLVersion) : customCanvas;
    canvas.addEventListener('webglcontextlost', (ev)=>{
        ev.preventDefault();
        delete $64450af18d844cd7$var$contexts[webGLVersion];
    }, false);
    if ((0, $tdutJ.env)().getBool('SOFTWARE_WEBGL_ENABLED')) $64450af18d844cd7$var$WEBGL_ATTRIBUTES.failIfMajorPerformanceCaveat = false;
    if (webGLVersion === 1) return(// tslint:disable-next-line
    canvas.getContext('webgl', $64450af18d844cd7$var$WEBGL_ATTRIBUTES) || canvas.getContext('experimental-webgl', $64450af18d844cd7$var$WEBGL_ATTRIBUTES));
    return canvas.getContext('webgl2', $64450af18d844cd7$var$WEBGL_ATTRIBUTES);
}

});

parcelRegister("2zyhV", function(module, exports) {

$parcel$export(module.exports, "PackingScheme", function () { return $1df9729505c473fa$export$81d5c79efa1086f2; });
$parcel$export(module.exports, "TextureUsage", function () { return $1df9729505c473fa$export$6bf4bd1b6beb0bfd; });
$parcel$export(module.exports, "PhysicalTextureType", function () { return $1df9729505c473fa$export$bde70ab3692e385c; });
$parcel$export(module.exports, "getUnpackedMatrixTextureShapeWidthHeight", function () { return $1df9729505c473fa$export$95fb8493b25f77a4; });
$parcel$export(module.exports, "getUnpackedArraySizeFromMatrixSize", function () { return $1df9729505c473fa$export$9427543edb6e188a; });
$parcel$export(module.exports, "getDenseTexShape", function () { return $1df9729505c473fa$export$2cc7cc972aa2533d; });
$parcel$export(module.exports, "getPackedMatrixTextureShapeWidthHeight", function () { return $1df9729505c473fa$export$2754e02fa98f5582; });
$parcel$export(module.exports, "getPackedRGBAArraySizeFromMatrixShape", function () { return $1df9729505c473fa$export$12d4e412f879b1d4; });
$parcel$export(module.exports, "getTextureConfig", function () { return $1df9729505c473fa$export$129d92ae6e74c416; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $lBDHD = parcelRequire("lBDHD");
var $1df9729505c473fa$export$81d5c79efa1086f2;
(function(PackingScheme) {
    /**
     * All values in a single texel are densely packed without any constraints.
     *
     * This is how the shader encodes a tensor with shape = [2, 3, 4]
     * (indices are [batch, row, col]).
     *
     * 000|001   010|011   020|021
     * -------   -------   -------
     * 002|003   012|013   022|023
     *
     * 100|101   110|111   120|121
     * -------   -------   -------
     * 102|103   112|113   122|123
     *
     */ PackingScheme[PackingScheme["DENSE"] = 0] = "DENSE";
    /**
     * Single texels contain only values from the same batch, and from adjacent
     * rows and columns.
     *
     * This is how the shader encodes a tensor with shape = [2, 3, 5]
     * (indices are [batch, row, col]).
     *
     * 000|001   002|003   004|xxx   020|021   022|023   024|xxx
     * -------   -------   -------   -------   -------   -------
     * 010|011   012|013   014|xxx   xxx|xxx   xxx|xxx   xxx|xxx
     *
     * 100|101   102|103   104|xxx   120|121   122|123   124|xxx
     * -------   -------   -------   -------   -------   -------
     * 110|111   112|113   114|xxx   xxx|xxx   xxx|xxx   xxx|xxx
     *
     */ PackingScheme[PackingScheme["SHARED_BATCH"] = 1] = "SHARED_BATCH";
})($1df9729505c473fa$export$81d5c79efa1086f2 || ($1df9729505c473fa$export$81d5c79efa1086f2 = {}));
var $1df9729505c473fa$export$6bf4bd1b6beb0bfd;
(function(TextureUsage) {
    TextureUsage[TextureUsage["RENDER"] = 0] = "RENDER";
    TextureUsage[TextureUsage["UPLOAD"] = 1] = "UPLOAD";
    TextureUsage[TextureUsage["PIXELS"] = 2] = "PIXELS";
    TextureUsage[TextureUsage["DOWNLOAD"] = 3] = "DOWNLOAD";
})($1df9729505c473fa$export$6bf4bd1b6beb0bfd || ($1df9729505c473fa$export$6bf4bd1b6beb0bfd = {}));
var $1df9729505c473fa$export$bde70ab3692e385c;
(function(PhysicalTextureType) {
    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT16"] = 0] = "UNPACKED_FLOAT16";
    PhysicalTextureType[PhysicalTextureType["UNPACKED_FLOAT32"] = 1] = "UNPACKED_FLOAT32";
    PhysicalTextureType[PhysicalTextureType["PACKED_4X1_UNSIGNED_BYTE"] = 2] = "PACKED_4X1_UNSIGNED_BYTE";
    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT32"] = 3] = "PACKED_2X2_FLOAT32";
    PhysicalTextureType[PhysicalTextureType["PACKED_2X2_FLOAT16"] = 4] = "PACKED_2X2_FLOAT16";
})($1df9729505c473fa$export$bde70ab3692e385c || ($1df9729505c473fa$export$bde70ab3692e385c = {}));
function $1df9729505c473fa$export$95fb8493b25f77a4(rows, columns) {
    return [
        columns,
        rows
    ];
}
function $1df9729505c473fa$export$9427543edb6e188a(matrixSize, channelsPerTexture) {
    return matrixSize * channelsPerTexture;
}
function $1df9729505c473fa$export$bb1043669f490840(rows, columns) {
    return [
        columns * 4,
        rows
    ];
}
function $1df9729505c473fa$export$2cc7cc972aa2533d(shape) {
    const size = (0, $lBDHD).sizeFromShape(shape);
    const texelsNeeded = Math.ceil(size / 4);
    return (0, $lBDHD).sizeToSquarishShape(texelsNeeded);
}
function $1df9729505c473fa$export$4c2d3be5c837367c(unpackedSize, channelsPerTexture) {
    if (unpackedSize % channelsPerTexture !== 0) throw new Error(`unpackedSize (${unpackedSize}) must be a multiple of ` + `${channelsPerTexture}`);
    return unpackedSize / channelsPerTexture;
}
function $1df9729505c473fa$export$ccf59730cad262bd(unpackedArray, matrix, channels) {
    const requiredSize = unpackedArray.length * channels / 4;
    if (matrix.length < requiredSize) throw new Error(`matrix length (${matrix.length}) must be >= ${requiredSize}`);
    let dst = 0;
    for(let src = 0; src < unpackedArray.length; src += 4)for(let c = 0; c < channels; c++)matrix[dst++] = unpackedArray[src + c];
}
function $1df9729505c473fa$export$2754e02fa98f5582(rows, columns) {
    return [
        Math.max(1, Math.ceil(columns / 2)),
        Math.max(1, Math.ceil(rows / 2))
    ];
}
function $1df9729505c473fa$export$12d4e412f879b1d4(rows, columns) {
    const [w, h] = $1df9729505c473fa$export$2754e02fa98f5582(rows, columns);
    return w * h * 4;
}
function $1df9729505c473fa$export$129d92ae6e74c416(// tslint:disable-next-line:no-any
gl, textureHalfFloatExtension) {
    // tslint:disable-next-line:no-any
    const glany = gl;
    let internalFormatFloat;
    let internalFormatHalfFloat;
    let internalFormatPackedHalfFloat;
    let internalFormatPackedFloat;
    let textureFormatFloat;
    let downloadTextureFormat;
    let downloadUnpackNumChannels;
    let defaultNumChannels;
    let textureTypeHalfFloat;
    let textureTypeFloat;
    if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2) {
        internalFormatFloat = glany.R32F;
        internalFormatHalfFloat = glany.R16F;
        internalFormatPackedHalfFloat = glany.RGBA16F;
        internalFormatPackedFloat = glany.RGBA32F;
        textureFormatFloat = glany.RED;
        downloadUnpackNumChannels = 4;
        defaultNumChannels = 1;
        textureTypeHalfFloat = glany.HALF_FLOAT;
        textureTypeFloat = glany.FLOAT;
        downloadTextureFormat = glany.RGBA8;
    } else {
        internalFormatFloat = gl.RGBA;
        internalFormatHalfFloat = gl.RGBA;
        internalFormatPackedHalfFloat = gl.RGBA;
        internalFormatPackedFloat = glany.RGBA;
        textureFormatFloat = gl.RGBA;
        downloadUnpackNumChannels = 4;
        defaultNumChannels = 4;
        textureTypeHalfFloat = textureHalfFloatExtension != null ? textureHalfFloatExtension.HALF_FLOAT_OES : null;
        textureTypeFloat = gl.FLOAT;
        downloadTextureFormat = gl.RGBA;
    }
    return {
        internalFormatFloat: internalFormatFloat,
        internalFormatHalfFloat: internalFormatHalfFloat,
        internalFormatPackedHalfFloat: internalFormatPackedHalfFloat,
        internalFormatPackedFloat: internalFormatPackedFloat,
        textureFormatFloat: textureFormatFloat,
        downloadTextureFormat: downloadTextureFormat,
        downloadUnpackNumChannels: downloadUnpackNumChannels,
        defaultNumChannels: defaultNumChannels,
        textureTypeHalfFloat: textureTypeHalfFloat,
        textureTypeFloat: textureTypeFloat
    };
}

});



parcelRegister("k1edx", function(module, exports) {

$parcel$export(module.exports, "DecodeMatrixProgram", function () { return $e92eedef61f5c8ba$export$f6ee51c6efbee026; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");

var $SwRKX = parcelRequire("SwRKX");

var $iR3z2 = parcelRequire("iR3z2");

var $2zyhV = parcelRequire("2zyhV");
class $e92eedef61f5c8ba$export$f6ee51c6efbee026 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        this.outPackingScheme = (0, $2zyhV.PackingScheme).DENSE;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $8qxEr.getGlslDifferences)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? $iR3z2.getOutputLogicalCoordinatesFromFlatIndexByUniform([
            'r',
            'c',
            'd'
        ], outputShape) : $iR3z2.getLogicalCoordinatesFromFlatIndex([
            'r',
            'c',
            'd'
        ], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getA(rc.x, rc.y, rc.z);
        }

        ${glsl.output} = result;
      }
    `;
    }
}

});
parcelRegister("8qxEr", function(module, exports) {

$parcel$export(module.exports, "getGlslDifferences", function () { return $622adae6f9a0f026$export$3ebf4a18d6319f7a; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
function $622adae6f9a0f026$export$3ebf4a18d6319f7a() {
    let version;
    let attribute;
    let varyingVs;
    let varyingFs;
    let texture2D;
    let output;
    let defineOutput;
    let defineSpecialNaN;
    let defineSpecialInf;
    let defineRound;
    if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2) {
        version = '#version 300 es';
        attribute = 'in';
        varyingVs = 'out';
        varyingFs = 'in';
        texture2D = 'texture';
        output = 'outputColor';
        defineOutput = 'out vec4 outputColor;';
        // Use custom isnan definition to work across differences between
        // implementations on various platforms. While this should happen in ANGLE
        // we still see differences between android and windows (on chrome) when
        // using isnan directly. Since WebGL2 supports uint type and
        // floatBitsToUinT built-in function, we could implment isnan following
        // IEEE 754 rules.
        // NaN defination in IEEE 754-1985 is :
        //   - sign = either 0 or 1.
        //   - biased exponent = all 1 bits.
        //   - fraction = anything except all 0 bits (since all 0 bits represents
        //   infinity).
        // https://en.wikipedia.org/wiki/IEEE_754-1985#Representation_of_non-numbers
        defineSpecialNaN = (0, $tdutJ.env)().getBool('WEBGL2_ISNAN_CUSTOM') ? `
      bool isnan_custom(float val) {
        uint floatToUint = floatBitsToUint(val);
        return (floatToUint & 0x7fffffffu) > 0x7f800000u;
      }

      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan_custom(val.x),
          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));
      }

      #define isnan(value) isnan_custom(value)
    ` : '';
        // In webgl 2 we do not need to specify a custom isinf so there is no
        // need for a special INFINITY constant.
        defineSpecialInf = ``;
        defineRound = `
      #define round(value) newRound(value)
      int newRound(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 newRound(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
    } else {
        version = '';
        attribute = 'attribute';
        varyingVs = 'varying';
        varyingFs = 'varying';
        texture2D = 'texture2D';
        output = 'gl_FragColor';
        defineOutput = '';
        // WebGL1 has no built in isnan so we define one here.
        defineSpecialNaN = `
      #define isnan(value) isnan_custom(value)
      bool isnan_custom(float val) {
        return (val > 0. || val < 1. || val == 0.) ? false : true;
      }
      bvec4 isnan_custom(vec4 val) {
        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));
      }
    `;
        defineSpecialInf = `
      uniform float INFINITY;

      bool isinf(float val) {
        return abs(val) == INFINITY;
      }
      bvec4 isinf(vec4 val) {
        return equal(abs(val), vec4(INFINITY));
      }
    `;
        defineRound = `
      int round(float value) {
        return int(floor(value + 0.5));
      }

      ivec4 round(vec4 value) {
        return ivec4(floor(value + vec4(0.5)));
      }
    `;
    }
    return {
        version: version,
        attribute: attribute,
        varyingVs: varyingVs,
        varyingFs: varyingFs,
        texture2D: texture2D,
        output: output,
        defineOutput: defineOutput,
        defineSpecialNaN: defineSpecialNaN,
        defineSpecialInf: defineSpecialInf,
        defineRound: defineRound
    };
}

});

parcelRegister("SwRKX", function(module, exports) {

$parcel$export(module.exports, "compileProgram", function () { return $0a3e89c573a4fa22$export$5ca2cb6073dd12df; });
$parcel$export(module.exports, "getUniformLocations", function () { return $0a3e89c573a4fa22$export$d421ceceafba9cc0; });
$parcel$export(module.exports, "runProgram", function () { return $0a3e89c573a4fa22$export$4e01d2c5eea12ae3; });
$parcel$export(module.exports, "makeShaderKey", function () { return $0a3e89c573a4fa22$export$2a17a6d53fe6f5d9; });
$parcel$export(module.exports, "useShapeUniforms", function () { return $0a3e89c573a4fa22$export$5acc770fc06a0138; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $lBDHD = parcelRequire("lBDHD");

var $1eI1C = parcelRequire("1eI1C");

var $k42ZR = parcelRequire("k42ZR");
function $0a3e89c573a4fa22$export$5ca2cb6073dd12df(gpgpu, program, inputs, output) {
    const inputInfos = inputs.map((input, i)=>{
        const shapeInfo = {
            logicalShape: input.shape,
            texShape: input.isUniform ? null : input.texData.texShape,
            isUniform: input.isUniform,
            isPacked: input.isUniform ? false : input.texData.isPacked,
            flatOffset: null
        };
        if (input.texData != null && input.texData.slice != null && input.texData.slice.flatOffset > 0) shapeInfo.flatOffset = input.texData.slice.flatOffset;
        return {
            name: program.variableNames[i],
            shapeInfo: shapeInfo
        };
    });
    const inShapeInfos = inputInfos.map((x)=>x.shapeInfo);
    const outShapeInfo = {
        logicalShape: output.shape,
        texShape: output.texData.texShape,
        isUniform: false,
        isPacked: output.texData.isPacked,
        flatOffset: null
    };
    const source = $1eI1C.makeShader(inputInfos, outShapeInfo, program);
    const fragmentShader = (0, $k42ZR.createFragmentShader)(gpgpu.gl, source);
    const webGLProgram = gpgpu.createProgram(fragmentShader);
    if (!(0, $tdutJ.env)().get('ENGINE_COMPILE_ONLY')) {
        gpgpu.buildVao(webGLProgram);
        return Object.assign({
            program: program,
            fragmentShader: fragmentShader,
            source: source,
            webGLProgram: webGLProgram,
            inShapeInfos: inShapeInfos,
            outShapeInfo: outShapeInfo
        }, $0a3e89c573a4fa22$export$d421ceceafba9cc0(gpgpu, program, webGLProgram));
    } else return {
        program: program,
        fragmentShader: fragmentShader,
        source: source,
        webGLProgram: webGLProgram,
        inShapeInfos: inShapeInfos,
        outShapeInfo: outShapeInfo,
        variablesLocations: null,
        customUniformLocations: null,
        infLoc: null,
        nanLoc: null,
        outShapeLocation: null,
        outShapeStridesLocation: null,
        outTexShapeLocation: null
    };
}
function $0a3e89c573a4fa22$export$d421ceceafba9cc0(gpgpu, program, webGLProgram) {
    const variablesLocations = [];
    const customUniformLocations = [];
    let outShapeLocation;
    let outTexShapeLocation;
    let outShapeStridesLocation;
    let infLoc = null;
    let nanLoc = null;
    // Add special uniforms (NAN, INFINITY)
    nanLoc = gpgpu.getUniformLocation(webGLProgram, 'NAN', false);
    if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 1) infLoc = gpgpu.getUniformLocation(webGLProgram, 'INFINITY', false);
    // Add user-defined uniforms
    const shouldThrow = false;
    for (const varName of program.variableNames){
        const varLocs = {
            name: varName,
            uniform: gpgpu.getUniformLocation(webGLProgram, varName, shouldThrow),
            offset: gpgpu.getUniformLocation(webGLProgram, `offset${varName}`, shouldThrow)
        };
        if (program.enableShapeUniforms) {
            varLocs.shape = gpgpu.getUniformLocation(webGLProgram, `${varName}Shape`, shouldThrow);
            varLocs.texShape = gpgpu.getUniformLocation(webGLProgram, `${varName}TexShape`, shouldThrow);
        }
        variablesLocations.push(varLocs);
    }
    if (program.enableShapeUniforms) {
        outShapeLocation = gpgpu.getUniformLocation(webGLProgram, 'outShape', shouldThrow);
        outShapeStridesLocation = gpgpu.getUniformLocation(webGLProgram, 'outShapeStrides', shouldThrow);
        outTexShapeLocation = gpgpu.getUniformLocation(webGLProgram, 'outTexShape', shouldThrow);
    }
    if (program.customUniforms) for (const d of program.customUniforms)customUniformLocations.push(gpgpu.getUniformLocation(webGLProgram, d.name, shouldThrow));
    return {
        variablesLocations: variablesLocations,
        customUniformLocations: customUniformLocations,
        infLoc: infLoc,
        nanLoc: nanLoc,
        outShapeLocation: outShapeLocation,
        outShapeStridesLocation: outShapeStridesLocation,
        outTexShapeLocation: outTexShapeLocation
    };
}
function $0a3e89c573a4fa22$var$validateBinaryAndProgram(shapeInfos, inputs) {
    if (shapeInfos.length !== inputs.length) throw Error(`Binary was compiled with ${shapeInfos.length} inputs, but ` + `was executed with ${inputs.length} inputs`);
    shapeInfos.forEach((s, i)=>{
        const shapeA = s.logicalShape;
        const input = inputs[i];
        const shapeB = input.shape;
        if (!(0, $lBDHD).arraysEqual(shapeA, shapeB)) throw Error(`Binary was compiled with different shapes than ` + `the current args. Shapes ${shapeA} and ${shapeB} must match`);
        // The input is uploaded as uniform.
        if (s.isUniform && input.isUniform) return;
        const texShapeA = s.texShape;
        const texShapeB = input.isUniform ? null : input.texData.texShape;
        if (!(0, $lBDHD).arraysEqual(texShapeA, texShapeB)) throw Error(`Binary was compiled with different texture shapes than the` + ` current args. Shape ${texShapeA} and ${texShapeB} must match`);
    });
}
function $0a3e89c573a4fa22$export$4e01d2c5eea12ae3(gpgpu, binary, inputs, output, customUniformValues) {
    if (!binary.program.enableShapeUniforms) {
        $0a3e89c573a4fa22$var$validateBinaryAndProgram(binary.inShapeInfos, inputs);
        $0a3e89c573a4fa22$var$validateBinaryAndProgram([
            binary.outShapeInfo
        ], [
            output
        ]);
    }
    const outTex = output.texData.texture;
    const outTexShape = output.texData.texShape;
    if (output.texData.isPacked) gpgpu.setOutputPackedMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
    else gpgpu.setOutputMatrixTexture(outTex.texture, outTexShape[0], outTexShape[1]);
    gpgpu.setProgram(binary.webGLProgram);
    gpgpu.bindVertexArray(binary.webGLProgram.vao);
    // Set special uniforms (NAN, INFINITY)
    if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 1) {
        if (binary.infLoc !== null) gpgpu.gl.uniform1f(binary.infLoc, Infinity);
    }
    if (binary.nanLoc !== null) gpgpu.gl.uniform1f(binary.nanLoc, NaN);
    // Set user-defined inputs
    for(let i = 0; i < inputs.length; ++i){
        const input = inputs[i];
        const { uniform: varLoc, offset: varOffsetLoc, shape: varShapeLoc, texShape: varTexShapeLoc } = binary.variablesLocations[i];
        if (varShapeLoc) {
            const { uniformShape: uniformShape } = $1eI1C.getUniformInfoFromShape(binary.program.packedInputs, input.shape, input.texData.texShape);
            switch(uniformShape.length){
                case 1:
                    gpgpu.gl.uniform1iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 2:
                    gpgpu.gl.uniform2iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 3:
                    gpgpu.gl.uniform3iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                case 4:
                    gpgpu.gl.uniform4iv(varShapeLoc, new Int32Array(uniformShape));
                    break;
                default:
                    break;
            }
        }
        if (varTexShapeLoc) gpgpu.gl.uniform2i(varTexShapeLoc, input.texData.texShape[0], input.texData.texShape[1]);
        if (varLoc == null) continue;
        if (input.isUniform) {
            // Upload the values of the tensor as uniform.
            if ((0, $lBDHD).sizeFromShape(input.shape) < 2) gpgpu.gl.uniform1f(varLoc, input.uniformValues[0]);
            else {
                let vals = input.uniformValues;
                if (!(vals instanceof Float32Array)) vals = new Float32Array(vals);
                gpgpu.gl.uniform1fv(varLoc, vals);
            }
            continue;
        }
        // If the input was sliced, upload the flat offset index.
        if (input.texData.slice != null && varOffsetLoc != null) gpgpu.gl.uniform1i(varOffsetLoc, input.texData.slice.flatOffset);
        gpgpu.setInputMatrixTexture(input.texData.texture.texture, varLoc, i);
    }
    const outShapeLoc = binary.outShapeLocation;
    if (outShapeLoc) switch(output.shape.length){
        case 1:
            gpgpu.gl.uniform1iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 2:
            gpgpu.gl.uniform2iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 3:
            gpgpu.gl.uniform3iv(outShapeLoc, new Int32Array(output.shape));
            break;
        case 4:
            gpgpu.gl.uniform4iv(outShapeLoc, new Int32Array(output.shape));
            break;
        default:
            break;
    }
    if (binary.outShapeStridesLocation) {
        const strides = (0, $lBDHD).computeStrides(output.shape);
        switch(output.shape.length){
            case 2:
                gpgpu.gl.uniform1iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            case 3:
                gpgpu.gl.uniform2iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            case 4:
                gpgpu.gl.uniform3iv(binary.outShapeStridesLocation, new Int32Array(strides));
                break;
            default:
                break;
        }
    }
    if (binary.outTexShapeLocation) gpgpu.gl.uniform2i(binary.outTexShapeLocation, output.texData.texShape[0], output.texData.texShape[1]);
    if (binary.program.customUniforms && customUniformValues) for(let i = 0; i < binary.program.customUniforms.length; ++i){
        const d = binary.program.customUniforms[i];
        const customLoc = binary.customUniformLocations[i];
        const customValue = customUniformValues[i];
        if (d.type === 'float') gpgpu.gl.uniform1fv(customLoc, customValue);
        else if (d.type === 'vec2') gpgpu.gl.uniform2fv(customLoc, customValue);
        else if (d.type === 'vec3') gpgpu.gl.uniform3fv(customLoc, customValue);
        else if (d.type === 'vec4') gpgpu.gl.uniform4fv(customLoc, customValue);
        else if (d.type === 'int') gpgpu.gl.uniform1iv(customLoc, customValue);
        else if (d.type === 'ivec2') gpgpu.gl.uniform2iv(customLoc, customValue);
        else if (d.type === 'ivec3') gpgpu.gl.uniform3iv(customLoc, customValue);
        else if (d.type === 'ivec4') gpgpu.gl.uniform4iv(customLoc, customValue);
        else throw Error(`uniform type ${d.type} is not supported yet.`);
    }
    gpgpu.executeProgram();
}
function $0a3e89c573a4fa22$export$2a17a6d53fe6f5d9(program, inputs, output) {
    let keyInputs = '';
    inputs.concat(output).forEach((x)=>{
        const hasOffset = x.texData != null && x.texData.slice != null && x.texData.slice.flatOffset > 0;
        // TODO: Remove the condition of !x.isUniform.
        if (program.enableShapeUniforms && !x.isUniform) {
            const xTexShape = x.texData.texShape;
            const { useSqueezeShape: useSqueezeShape, uniformShape: uniformShape, keptDims: keptDims } = $1eI1C.getUniformInfoFromShape(program.packedInputs, x.shape, xTexShape);
            let rank1 = '', rank2 = '', rank34 = '';
            if (uniformShape.length === 1 && program.packedInputs) {
                const packedTexShape = [
                    Math.ceil(xTexShape[0] / 2),
                    Math.ceil(xTexShape[1] / 2)
                ];
                rank1 = `${packedTexShape[0] > 1}_${packedTexShape[1] > 1}`;
            } else if (uniformShape.length === 2 && !program.packedInputs) rank2 = `${uniformShape[0] > 1}_${uniformShape[1] > 1}`;
            else if (uniformShape.length > 2 && !program.packedInputs) {
                const strides = (0, $lBDHD).computeStrides(uniformShape);
                rank34 = `${strides[0] === xTexShape[1]}_${strides[strides.length - 1] === xTexShape[1]}`;
            }
            const xRank = x.shape.length;
            const isLogicalShapTexShapeEqual = uniformShape.length === 2 && (0, $lBDHD).arraysEqual(x.shape, xTexShape);
            const isScalar = (0, $lBDHD).sizeFromShape(x.shape) === 1;
            const broadcastDims = (0, $dEVRx).getBroadcastDims(x.shape, output.shape);
            const isInOutTexShapeEqual = !program.packedInputs && xRank === output.shape.length && (0, $lBDHD).arraysEqual(xTexShape, output.texData.texShape);
            const isTexShapeGreaterThanOne = program.packedInputs || uniformShape.length > 2 ? '' : `${xTexShape[0] > 1}_${xTexShape[1] > 1}`;
            // These key components are needed due to shader_compiler is embedding
            // them in the shader.
            // |xRank| is used to determine the coords length. See
            // get[Packed]SamplerAtOutputCoords.
            // |isInOutTexShapeEqual| is used to determine whether going to an
            // optimization path in getSamplerAtOutputCoords.
            // |useSqueezeShape| is extracted from squeezeInputInfo of
            // getSampler[2|3|4]D/getPackedSampler3D.
            // |isScalar| is extracted from isInputScalar/isOutputScalar in
            // getPackedSamplerAtOutputCoords.
            // |broadcastDims| is extracted from get[Packed]SamplerAtOutputCoords.
            // |isLogicalShapTexShapeEqual| is used in
            // getOutput[Packed]2DCoords/get[Packed]Sampler2D.
            // |rank1| is used in getOutputPacked1DCoords.
            // |rank2| is used in getOutput2DCoords.
            // |rank34| is used in getSampler3D/getSampler4D.
            // |isTexShapeGreaterThanOne| are used in
            // getSampler[Scalar|1D|2D]/getOutput1DCoords.
            keyInputs += `${xRank}_${isInOutTexShapeEqual}_${useSqueezeShape ? keptDims : ''}_${uniformShape.length}_${isScalar}_${broadcastDims}_${isLogicalShapTexShapeEqual}_${rank1}_${rank2}_${rank34}_${isTexShapeGreaterThanOne}_${hasOffset}`;
        } else {
            const texShape = x.isUniform ? 'uniform' : x.texData.texShape;
            keyInputs += `${x.shape}_${texShape}_${hasOffset}`;
        }
    });
    const keyUserCode = program.userCode;
    let key = program.constructor.name;
    // Fast string concat. See https://jsperf.com/string-concatenation/14.
    key += '_' + keyInputs + '_' + keyUserCode + `${(0, $tdutJ.env)().getNumber('WEBGL_VERSION')}`;
    return key;
}
function $0a3e89c573a4fa22$export$5acc770fc06a0138(rank) {
    // TODO: Remove the limitaion of rank <= 4.
    return (0, $tdutJ.env)().getBool('WEBGL_USE_SHAPES_UNIFORMS') && rank <= 4;
}

});
parcelRegister("1eI1C", function(module, exports) {

$parcel$export(module.exports, "makeShader", function () { return $0e693fb2f91ad76c$export$37f33ba844563dd2; });
$parcel$export(module.exports, "getUniformInfoFromShape", function () { return $0e693fb2f91ad76c$export$19e35a0844e29cf9; });
$parcel$export(module.exports, "getCoordsDataType", function () { return $0e693fb2f91ad76c$export$859efd105c10c755; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Please make sure the shaker key in makeShaderKey in gpgpu_math.ts is well
// mapped if any shader source code is changed in this file.
parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $8qxEr = parcelRequire("8qxEr");

var $iR3z2 = parcelRequire("iR3z2");
const { getBroadcastDims: $0e693fb2f91ad76c$var$getBroadcastDims } = (0, $dEVRx);
function $0e693fb2f91ad76c$export$37f33ba844563dd2(inputsInfo, outputShape, program) {
    const prefixSnippets = [];
    inputsInfo.forEach((x)=>{
        const size = (0, $lBDHD).sizeFromShape(x.shapeInfo.logicalShape);
        // Snippet when we decided to upload the values as uniform.
        if (x.shapeInfo.isUniform) prefixSnippets.push(`uniform float ${x.name}${size > 1 ? `[${size}]` : ''};`);
        else {
            prefixSnippets.push(`uniform sampler2D ${x.name};`);
            prefixSnippets.push(`uniform int offset${x.name};`);
        }
        if (program.enableShapeUniforms) {
            const { uniformShape: uniformShape } = $0e693fb2f91ad76c$export$19e35a0844e29cf9(program.packedInputs, x.shapeInfo.logicalShape, x.shapeInfo.texShape);
            switch(uniformShape.length){
                case 1:
                    prefixSnippets.push(`uniform int ${x.name}Shape;`);
                    break;
                case 2:
                    prefixSnippets.push(`uniform ivec2 ${x.name}Shape;`);
                    break;
                case 3:
                    prefixSnippets.push(`uniform ivec3 ${x.name}Shape;`);
                    break;
                case 4:
                    prefixSnippets.push(`uniform ivec4 ${x.name}Shape;`);
                    break;
                default:
                    break;
            }
            prefixSnippets.push(`uniform ivec2 ${x.name}TexShape;`);
        }
    });
    if (program.enableShapeUniforms) {
        switch(outputShape.logicalShape.length){
            case 1:
                prefixSnippets.push(`uniform int outShape;`);
                break;
            case 2:
                prefixSnippets.push(`uniform ivec2 outShape;`);
                prefixSnippets.push(`uniform int outShapeStrides;`);
                break;
            case 3:
                prefixSnippets.push(`uniform ivec3 outShape;`);
                prefixSnippets.push(`uniform ivec2 outShapeStrides;`);
                break;
            case 4:
                prefixSnippets.push(`uniform ivec4 outShape;`);
                prefixSnippets.push(`uniform ivec3 outShapeStrides;`);
                break;
            default:
                break;
        }
        prefixSnippets.push(`uniform ivec2 outTexShape;`);
    }
    if (program.customUniforms) program.customUniforms.forEach((d)=>{
        prefixSnippets.push(`uniform ${d.type} ${d.name}${d.arrayIndex ? `[${d.arrayIndex}]` : ''};`);
    });
    const inputPrefixSnippet = prefixSnippets.join('\n');
    const inputSamplingSnippet = inputsInfo.map((x)=>$0e693fb2f91ad76c$var$getInputSamplingSnippet(x, outputShape, program.packedInputs, program.enableShapeUniforms)).join('\n');
    const outTexShape = outputShape.texShape;
    const glsl = (0, $8qxEr.getGlslDifferences)();
    const floatTextureSampleSnippet = $0e693fb2f91ad76c$var$getFloatTextureSampleSnippet(glsl);
    let outputSamplingSnippet;
    let floatTextureSetOutputSnippet;
    let shaderPrefix = $0e693fb2f91ad76c$var$getShaderPrefix(glsl);
    if (outputShape.isPacked) {
        outputSamplingSnippet = $0e693fb2f91ad76c$var$getPackedOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
        floatTextureSetOutputSnippet = $0e693fb2f91ad76c$var$getFloatTextureSetRGBASnippet(glsl);
    } else {
        outputSamplingSnippet = $0e693fb2f91ad76c$var$getOutputSamplingSnippet(outputShape.logicalShape, outTexShape, program.enableShapeUniforms);
        floatTextureSetOutputSnippet = $0e693fb2f91ad76c$var$getFloatTextureSetRSnippet(glsl);
    }
    if (program.packedInputs) shaderPrefix += $0e693fb2f91ad76c$var$SHADER_PACKED_PREFIX;
    const source = [
        shaderPrefix,
        floatTextureSampleSnippet,
        floatTextureSetOutputSnippet,
        inputPrefixSnippet,
        outputSamplingSnippet,
        inputSamplingSnippet,
        program.userCode
    ].join('\n');
    return source;
}
function $0e693fb2f91ad76c$var$getSamplerFromInInfo(inInfo, enableShapeUniforms = false) {
    const shape = inInfo.shapeInfo.logicalShape;
    switch(shape.length){
        case 0:
            return $0e693fb2f91ad76c$var$getSamplerScalar(inInfo, enableShapeUniforms);
        case 1:
            return $0e693fb2f91ad76c$var$getSampler1D(inInfo, enableShapeUniforms);
        case 2:
            return $0e693fb2f91ad76c$var$getSampler2D(inInfo, enableShapeUniforms);
        case 3:
            return $0e693fb2f91ad76c$var$getSampler3D(inInfo, enableShapeUniforms);
        case 4:
            return $0e693fb2f91ad76c$var$getSampler4D(inInfo, enableShapeUniforms);
        case 5:
            return $0e693fb2f91ad76c$var$getSampler5D(inInfo);
        case 6:
            return $0e693fb2f91ad76c$var$getSampler6D(inInfo);
        default:
            throw new Error(`${shape.length}-D input sampling` + ` is not yet supported`);
    }
}
function $0e693fb2f91ad76c$var$getPackedSamplerFromInInfo(inInfo, enableShapeUniforms) {
    const shape = inInfo.shapeInfo.logicalShape;
    switch(shape.length){
        case 0:
            return $0e693fb2f91ad76c$var$getPackedSamplerScalar(inInfo);
        case 1:
            return $0e693fb2f91ad76c$var$getPackedSampler1D(inInfo, enableShapeUniforms);
        case 2:
            return $0e693fb2f91ad76c$var$getPackedSampler2D(inInfo, enableShapeUniforms);
        case 3:
            return $0e693fb2f91ad76c$var$getPackedSampler3D(inInfo, enableShapeUniforms);
        default:
            return $0e693fb2f91ad76c$var$getPackedSamplerND(inInfo, enableShapeUniforms);
    }
}
function $0e693fb2f91ad76c$var$getInputSamplingSnippet(inInfo, outShapeInfo, usesPackedTextures = false, enableShapeUniforms) {
    let res = '';
    if (usesPackedTextures) res += $0e693fb2f91ad76c$var$getPackedSamplerFromInInfo(inInfo, enableShapeUniforms);
    else res += $0e693fb2f91ad76c$var$getSamplerFromInInfo(inInfo, enableShapeUniforms);
    const inShape = inInfo.shapeInfo.logicalShape;
    const outShape = outShapeInfo.logicalShape;
    if (inShape.length <= outShape.length) {
        if (usesPackedTextures) res += $0e693fb2f91ad76c$var$getPackedSamplerAtOutputCoords(inInfo, outShapeInfo);
        else res += $0e693fb2f91ad76c$var$getSamplerAtOutputCoords(inInfo, outShapeInfo);
    }
    return res;
}
function $0e693fb2f91ad76c$var$getPackedOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
    switch(outShape.length){
        case 0:
            return $0e693fb2f91ad76c$var$getOutputScalarCoords();
        case 1:
            return $0e693fb2f91ad76c$var$getOutputPacked1DCoords(outShape, outTexShape, enableShapeUniforms);
        case 2:
            return $0e693fb2f91ad76c$var$getOutputPacked2DCoords(outShape, outTexShape, enableShapeUniforms);
        case 3:
            return $0e693fb2f91ad76c$var$getOutputPacked3DCoords(outShape, outTexShape, enableShapeUniforms);
        default:
            return $0e693fb2f91ad76c$var$getOutputPackedNDCoords(outShape, outTexShape, enableShapeUniforms);
    }
}
function $0e693fb2f91ad76c$var$getOutputSamplingSnippet(outShape, outTexShape, enableShapeUniforms) {
    switch(outShape.length){
        case 0:
            return $0e693fb2f91ad76c$var$getOutputScalarCoords();
        case 1:
            return $0e693fb2f91ad76c$var$getOutput1DCoords(outShape, outTexShape, enableShapeUniforms);
        case 2:
            return $0e693fb2f91ad76c$var$getOutput2DCoords(outShape, outTexShape, enableShapeUniforms);
        case 3:
            return $0e693fb2f91ad76c$var$getOutput3DCoords(outShape, outTexShape, enableShapeUniforms);
        case 4:
            return $0e693fb2f91ad76c$var$getOutput4DCoords(outShape, outTexShape, enableShapeUniforms);
        case 5:
            return $0e693fb2f91ad76c$var$getOutput5DCoords(outShape, outTexShape);
        case 6:
            return $0e693fb2f91ad76c$var$getOutput6DCoords(outShape, outTexShape);
        default:
            throw new Error(`${outShape.length}-D output sampling is not yet supported`);
    }
}
function $0e693fb2f91ad76c$var$getFloatTextureSampleSnippet(glsl) {
    return `
    float sampleTexture(sampler2D textureSampler, vec2 uv) {
      return ${glsl.texture2D}(textureSampler, uv).r;
    }
  `;
}
function $0e693fb2f91ad76c$var$getFloatTextureSetRSnippet(glsl) {
    return `
    void setOutput(float val) {
      ${glsl.output} = vec4(val, 0, 0, 0);
    }
  `;
}
function $0e693fb2f91ad76c$var$getFloatTextureSetRGBASnippet(glsl) {
    return `
    void setOutput(vec4 val) {
      ${glsl.output} = val;
    }
  `;
}
function $0e693fb2f91ad76c$var$getShaderPrefix(glsl) {
    const SHADER_PREFIX = `${glsl.version}
    precision highp float;
    precision highp int;
    precision highp sampler2D;
    ${glsl.varyingFs} vec2 resultUV;
    ${glsl.defineOutput}
    const vec2 halfCR = vec2(0.5, 0.5);

    struct ivec5
    {
      int x;
      int y;
      int z;
      int w;
      int u;
    };

    struct ivec6
    {
      int x;
      int y;
      int z;
      int w;
      int u;
      int v;
    };

    uniform float NAN;
    ${glsl.defineSpecialNaN}
    ${glsl.defineSpecialInf}
    ${glsl.defineRound}

    int imod(int x, int y) {
      return x - y * (x / y);
    }

    int idiv(int a, int b, float sign) {
      int res = a / b;
      int mod = imod(a, b);
      if (sign < 0. && mod != 0) {
        res -= 1;
      }
      return res;
    }

    //Based on the work of Dave Hoskins
    //https://www.shadertoy.com/view/4djSRW
    #define HASHSCALE1 443.8975
    float random(float seed){
      vec2 p = resultUV * seed;
      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);
      p3 += dot(p3, p3.yzx + 19.19);
      return fract((p3.x + p3.y) * p3.z);
    }

    ${$0e693fb2f91ad76c$var$SAMPLE_1D_SNIPPET}
    ${$0e693fb2f91ad76c$var$SAMPLE_2D_SNIPPET}
    ${$0e693fb2f91ad76c$var$SAMPLE_3D_SNIPPET}
  `;
    return SHADER_PREFIX;
}
const $0e693fb2f91ad76c$var$SAMPLE_1D_SNIPPET = `
vec2 uvFromFlat(int texNumR, int texNumC, int index) {
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
vec2 packedUVfrom1D(int texNumR, int texNumC, int index) {
  int texelIndex = index / 2;
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $0e693fb2f91ad76c$var$SAMPLE_2D_SNIPPET = `
vec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,
  int texNumC, int row, int col) {
  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = texelIndex / texNumC;
  int texC = texelIndex - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $0e693fb2f91ad76c$var$SAMPLE_3D_SNIPPET = `
vec2 packedUVfrom3D(int texNumR, int texNumC,
    int texelsInBatch, int texelsInLogicalRow, int b,
    int row, int col) {
  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);
  int texR = index / texNumC;
  int texC = index - texR * texNumC;
  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);
}
`;
const $0e693fb2f91ad76c$var$SHADER_PACKED_PREFIX = `
  float getChannel(vec4 frag, vec2 innerDims) {
    vec2 modCoord = mod(innerDims, 2.);
    return modCoord.x == 0. ?
      (modCoord.y == 0. ? frag.r : frag.g) :
      (modCoord.y == 0. ? frag.b : frag.a);
  }
  float getChannel(vec4 frag, int dim) {
    float modCoord = mod(float(dim), 2.);
    return modCoord == 0. ? frag.r : frag.g;
  }
`;
function $0e693fb2f91ad76c$var$getOutputScalarCoords() {
    return `
    int getOutputCoords() {
      return 0;
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutputPacked1DCoords(shape, texShape, enableShapeUniforms) {
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if (packedTexShape[0] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ceil(float(outTexShape[1]) / 2.0));
      }
    `;
        return `
      int getOutputCoords() {
        return 2 * int(resultUV.x * ${packedTexShape[1]}.0);
      }
    `;
    }
    if (packedTexShape[1] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ceil(float(outTexShape[0]) / 2.0));
      }
    `;
        return `
      int getOutputCoords() {
        return 2 * int(resultUV.y * ${packedTexShape[0]}.0);
      }
    `;
    }
    if (enableShapeUniforms) return `
    int getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      return 2 * (resTexRC.x * packedTexShape[1] + resTexRC.y);
    }
  `;
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      return 2 * (resTexRC.x * ${packedTexShape[1]} + resTexRC.y);
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutput1DCoords(shape, texShape, enableShapeUniforms) {
    if (texShape[0] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return int(resultUV.x * float(outTexShape[1]));
      }
    `;
        return `
      int getOutputCoords() {
        return int(resultUV.x * ${texShape[1]}.0);
      }
    `;
    }
    if (texShape[1] === 1) {
        if (enableShapeUniforms) return `
      int getOutputCoords() {
        return int(resultUV.y * float(outTexShape[0]));
      }
    `;
        return `
      int getOutputCoords() {
        return int(resultUV.y * ${texShape[0]}.0);
      }
    `;
    }
    if (enableShapeUniforms) return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      return resTexRC.x * outTexShape[1] + resTexRC.y;
    }
  `;
    return `
    int getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      return resTexRC.x * ${texShape[1]} + resTexRC.y;
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutputPacked3DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) return `
    ivec3 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec3(b, r, c);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texelsInLogicalRow = Math.ceil(shape[2] / 2);
    const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[1] / 2);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec3(b, r, c);
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutput3DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) {
        const coordsFromIndexSnippet = $iR3z2.getOutputLogicalCoordinatesFromFlatIndexByUniform([
            'r',
            'c',
            'd'
        ], shape);
        return `
  ivec3 getOutputCoords() {
    ivec2 resTexRC = ivec2(resultUV.yx *
                           vec2(outTexShape[0], outTexShape[1]));
    int index = resTexRC.x * outTexShape[1] + resTexRC.y;
    ${coordsFromIndexSnippet}
    return ivec3(r, c, d);
  }
`;
    }
    const coordsFromIndexSnippet = $iR3z2.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd'
    ], shape);
    return `
    ivec3 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutputPackedNDCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) // TODO: support 5d and 6d
    return `
    ivec4 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));
      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;

      int texelsInLogicalRow = int(ceil(float(outShape[3]) / 2.0));
      int texelsInBatch = texelsInLogicalRow * int(ceil(float(outShape[2]) / 2.0));
      int texelsInBatchN = texelsInBatch * outShape[1];

      int b2 = index / texelsInBatchN;
      index -= b2 * texelsInBatchN;

      int b = index / texelsInBatch;
      index -= b * texelsInBatch;

      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec4(b2, b, r, c);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texelsInLogicalRow = Math.ceil(shape[shape.length - 1] / 2);
    const texelsInBatch = texelsInLogicalRow * Math.ceil(shape[shape.length - 2] / 2);
    let texelsInBatchN = texelsInBatch;
    let batches = ``;
    let coords = 'b, r, c';
    for(let b = 2; b < shape.length - 1; b++){
        texelsInBatchN *= shape[shape.length - b - 1];
        batches = `
      int b${b} = index / ${texelsInBatchN};
      index -= b${b} * ${texelsInBatchN};
    ` + batches;
        coords = `b${b}, ` + coords;
    }
    return `
    ivec${shape.length} getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;

      ${batches}

      int b = index / ${texelsInBatch};
      index -= b * ${texelsInBatch};

      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec${shape.length}(${coords});
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutput4DCoords(shape, texShape, enableShapeUniforms) {
    if (enableShapeUniforms) {
        const coordsFromIndexSnippet = $iR3z2.getOutputLogicalCoordinatesFromFlatIndexByUniform([
            'r',
            'c',
            'd',
            'd2'
        ], shape);
        return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
    }
    const coordsFromIndexSnippet = $iR3z2.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd',
        'd2'
    ], shape);
    return `
    ivec4 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      ${coordsFromIndexSnippet}
      return ivec4(r, c, d, d2);
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutput5DCoords(shape, texShape) {
    const coordsFromIndexSnippet = $iR3z2.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd',
        'd2',
        'd3'
    ], shape);
    return `
    ivec5 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx * vec2(${texShape[0]},
                             ${texShape[1]}));

      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec5 outShape = ivec5(r, c, d, d2, d3);
      return outShape;
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutput6DCoords(shape, texShape) {
    const coordsFromIndexSnippet = $iR3z2.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd',
        'd2',
        'd3',
        'd4'
    ], shape);
    return `
    ivec6 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
        vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;

      ${coordsFromIndexSnippet}

      ivec6 result = ivec6(r, c, d, d2, d3, d4);
      return result;
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutputPacked2DCoords(shape, texShape, enableShapeUniforms) {
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if ((0, $lBDHD).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
        return 2 * ivec2(resultUV.yx * vec2(packedTexShape[0], packedTexShape[1]));
      }
    `;
        return `
      ivec2 getOutputCoords() {
        return 2 * ivec2(resultUV.yx * vec2(${packedTexShape[0]}, ${packedTexShape[1]}));
      }
    `;
    }
    // texels needed to accommodate a logical row
    const texelsInLogicalRow = Math.ceil(shape[1] / 2);
    /**
     * getOutputCoords
     *
     * resTexRC: The rows and columns of the texels. If you move over one
     * texel to the right in the packed texture, you are moving over one column
     * (not two).
     *
     * index: The texel index
     */ if (enableShapeUniforms) return `
    ivec2 getOutputCoords() {
      ivec2 packedTexShape = ivec2(ceil(float(outTexShape[0]) / 2.0), ceil(float(outTexShape[1]) / 2.0));
      int texelsInLogicalRow = int(ceil(float(outShape[1]) / 2.0));
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(packedTexShape[0], packedTexShape[1]));

      int index = resTexRC.x * packedTexShape[1] + resTexRC.y;
      int r = 2 * (index / texelsInLogicalRow);
      int c = imod(index, texelsInLogicalRow) * 2;

      return ivec2(r, c);
    }
  `;
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${packedTexShape[0]}, ${packedTexShape[1]}));

      int index = resTexRC.x * ${packedTexShape[1]} + resTexRC.y;
      int r = 2 * (index / ${texelsInLogicalRow});
      int c = imod(index, ${texelsInLogicalRow}) * 2;

      return ivec2(r, c);
    }
  `;
}
function $0e693fb2f91ad76c$var$getOutput2DCoords(shape, texShape, enableShapeUniforms) {
    if ((0, $lBDHD).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(outTexShape[0], outTexShape[1]));
      }
    `;
        return `
      ivec2 getOutputCoords() {
        return ivec2(resultUV.yx * vec2(${texShape[0]}, ${texShape[1]}));
      }
    `;
    }
    if (shape[1] === 1) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
        return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(index, 0);
      }
    `;
    }
    if (shape[0] === 1) {
        if (enableShapeUniforms) return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(outTexShape[0], outTexShape[1]));
        int index = resTexRC.x * outTexShape[1] + resTexRC.y;
        return ivec2(0, index);
      }
    `;
        return `
      ivec2 getOutputCoords() {
        ivec2 resTexRC = ivec2(resultUV.yx *
                               vec2(${texShape[0]}, ${texShape[1]}));
        int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
        return ivec2(0, index);
      }
    `;
    }
    if (enableShapeUniforms) return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(outTexShape[0], outTexShape[1]));
      int index = resTexRC.x * outTexShape[1] + resTexRC.y;
      int r = index / outShape[1];
      int c = index - r * outShape[1];
      return ivec2(r, c);
    }
  `;
    return `
    ivec2 getOutputCoords() {
      ivec2 resTexRC = ivec2(resultUV.yx *
                             vec2(${texShape[0]}, ${texShape[1]}));
      int index = resTexRC.x * ${texShape[1]} + resTexRC.y;
      int r = index / ${shape[1]};
      int c = index - r * ${shape[1]};
      return ivec2(r, c);
    }
  `;
}
function $0e693fb2f91ad76c$var$getFlatOffsetUniformName(texName) {
    return `offset${texName}`;
}
function $0e693fb2f91ad76c$var$getPackedSamplerScalar(inputInfo) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const glsl = (0, $8qxEr.getGlslDifferences)();
    return `
    vec4 ${funcName}() {
      return ${glsl.texture2D}(${texName}, halfCR);
    }
  `;
}
function $0e693fb2f91ad76c$var$getSamplerScalar(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    if (inputInfo.shapeInfo.isUniform) return `float ${funcName}() {return ${texName};}`;
    const [texNumR, texNumC] = inputInfo.shapeInfo.texShape;
    if (texNumR === 1 && texNumC === 1) return `
      float ${funcName}() {
        return sampleTexture(${texName}, halfCR);
      }
    `;
    const offset = $0e693fb2f91ad76c$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    const [tNumR, tNumC] = inputInfo.shapeInfo.texShape;
    return `
    float ${funcName}() {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getPackedSampler1D(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const glsl = (0, $8qxEr.getGlslDifferences)();
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int index) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      vec2 uv = packedUVfrom1D(
        packedTexShape[0], packedTexShape[1], index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    return `
    vec4 ${funcName}(int index) {
      vec2 uv = packedUVfrom1D(
        ${packedTexShape[0]}, ${packedTexShape[1]}, index);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getSampler1D(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int index) {
        ${$0e693fb2f91ad76c$var$getUniformSampler(inputInfo)}
      }
    `;
    const texShape = inputInfo.shapeInfo.texShape;
    const tNumR = texShape[0];
    const tNumC = texShape[1];
    if (tNumC === 1 && tNumR === 1) return `
      float ${funcName}(int index) {
        return sampleTexture(${texName}, halfCR);
      }
    `;
    const offset = $0e693fb2f91ad76c$var$getFlatOffsetUniformName(texName);
    if (tNumC === 1) {
        if (enableShapeUniforms) return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int index) {
        vec2 uv = vec2(0.5, (float(index + ${offset}) + 0.5) / ${tNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (tNumR === 1) {
        if (enableShapeUniforms) return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int index) {
        vec2 uv = vec2((float(index + ${offset}) + 0.5) / ${tNumC}.0, 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (enableShapeUniforms) return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    return `
    float ${funcName}(int index) {
      vec2 uv = uvFromFlat(${tNumR}, ${tNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getPackedSampler2D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const glsl = (0, $8qxEr.getGlslDifferences)();
    if (texShape != null && (0, $lBDHD).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
        return `
      vec4 ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);

        return ${glsl.texture2D}(${texName}, uv);
      }
    `;
    }
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom2D(valuesPerRow, packedTexShape[0], packedTexShape[1], row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const valuesPerRow = Math.ceil(shape[1] / 2);
    return `
    vec4 ${funcName}(int row, int col) {
      vec2 uv = packedUVfrom2D(${valuesPerRow}, ${packedTexShape[0]}, ${packedTexShape[1]}, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getSampler2D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    if (texShape != null && (0, $lBDHD).arraysEqual(shape, texShape)) {
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        vec2 uv = (vec2(col, row) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        const texNumR = texShape[0];
        const texNumC = texShape[1];
        return `
    float ${funcName}(int row, int col) {
      vec2 uv = (vec2(col, row) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    const { newShape: newShape, keptDims: keptDims } = (0, $lBDHD).squeezeShape(shape);
    const squeezedShape = newShape;
    if (squeezedShape.length < shape.length) {
        const newInputInfo = $0e693fb2f91ad76c$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'row',
            'col'
        ];
        return `
      ${$0e693fb2f91ad76c$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col) {
        return ${funcName}(${$0e693fb2f91ad76c$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col) {
        int index = round(dot(vec2(row, col), vec2(${shape[1]}, 1)));
        ${$0e693fb2f91ad76c$var$getUniformSampler(inputInfo)}
      }
    `;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const offset = $0e693fb2f91ad76c$var$getFlatOffsetUniformName(texName);
    if (texNumC === 1) {
        // index is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2(0.5, (index + 0.5) / float(${texName}TexShape[0]));
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2(0.5, (index + 0.5) / ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    if (texNumR === 1) {
        // index is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        float index = dot(vec3(row, col, ${offset}), vec3(${texName}Shape[1], 1, 1));
        vec2 uv = vec2((index + 0.5) / float(${texName}TexShape[1]), 0.5);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col) {
      float index = dot(vec3(row, col, ${offset}), vec3(${shape[1]}, 1, 1));
      vec2 uv = vec2((index + 0.5) / ${texNumC}.0, 0.5);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    if (enableShapeUniforms) return `
      float ${funcName}(int row, int col) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${texName}Shape[1] + col + ${offset};
        vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
        return sampleTexture(${texName}, uv);
      }
    `;
    return `
  float ${funcName}(int row, int col) {
    // Explicitly use integer operations as dot() only works on floats.
    int index = row * ${shape[1]} + col + ${offset};
    vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
    return sampleTexture(${texName}, uv);
  }
`;
}
function $0e693fb2f91ad76c$var$getPackedSampler3D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const texShape = inputInfo.shapeInfo.texShape;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    if (shape[0] === 1) {
        const squeezedShape = shape.slice(1);
        const keptDims = [
            1,
            2
        ];
        const newInputInfo = $0e693fb2f91ad76c$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'b',
            'row',
            'col'
        ];
        return `
        ${$0e693fb2f91ad76c$var$getPackedSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        vec4 ${funcName}(int b, int row, int col) {
          return ${funcName}(${$0e693fb2f91ad76c$var$getSqueezedParams(params, keptDims)});
        }
      `;
    }
    const glsl = (0, $8qxEr.getGlslDifferences)();
    if (enableShapeUniforms) return `
    vec4 ${funcName}(int b, int row, int col) {
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int valuesPerRow = int(ceil(float(${texName}Shape[2]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[1]) / 2.0));
      vec2 uv = packedUVfrom3D(
        packedTexShape[0], packedTexShape[1], texelsInBatch, valuesPerRow, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const texNumR = packedTexShape[0];
    const texNumC = packedTexShape[1];
    const valuesPerRow = Math.ceil(shape[2] / 2);
    const texelsInBatch = valuesPerRow * Math.ceil(shape[1] / 2);
    return `
    vec4 ${funcName}(int b, int row, int col) {
      vec2 uv = packedUVfrom3D(
        ${texNumR}, ${texNumC}, ${texelsInBatch}, ${valuesPerRow}, b, row, col);
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getSampler3D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride0 = shape[1] * shape[2];
    const stride1 = shape[2];
    const { newShape: newShape, keptDims: keptDims } = (0, $lBDHD).squeezeShape(shape);
    const squeezedShape = newShape;
    if (squeezedShape.length < shape.length) {
        const newInputInfo = $0e693fb2f91ad76c$export$5d06d3f48295bf13(inputInfo, squeezedShape);
        const params = [
            'row',
            'col',
            'depth'
        ];
        return `
        ${$0e693fb2f91ad76c$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
        float ${funcName}(int row, int col, int depth) {
          return ${funcName}(${$0e693fb2f91ad76c$var$getSqueezedParams(params, keptDims)});
        }
      `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth) {
        int index = round(dot(vec3(row, col, depth),
                          vec3(${stride0}, ${stride1}, 1)));
        ${$0e693fb2f91ad76c$var$getUniformSampler(inputInfo)}
      }
    `;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    if (texNumC === stride0 && flatOffset == null) {
        // texC is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth) {
        int stride1 = ${texName}Shape[2];
        float texR = float(row);
        float texC = dot(vec2(col, depth), vec2(stride1, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
        float ${funcName}(int row, int col, int depth) {
          float texR = float(row);
          float texC = dot(vec2(col, depth), vec2(${stride1}, 1));
          vec2 uv = (vec2(texC, texR) + halfCR) /
                     vec2(${texNumC}.0, ${texNumR}.0);
          return sampleTexture(${texName}, uv);
        }
      `;
    }
    if (texNumC === stride1 && flatOffset == null) {
        // texR is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth) {
        float texR = dot(vec2(row, col), vec2(${texName}Shape[1], 1));
        float texC = float(depth);
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
    float ${funcName}(int row, int col, int depth) {
      float texR = dot(vec2(row, col), vec2(${shape[1]}, 1));
      float texC = float(depth);
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}.0, ${texNumR}.0);
      return sampleTexture(${texName}, uv);
    }
  `;
    }
    const offset = $0e693fb2f91ad76c$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}(int row, int col, int depth) {
      // Explicitly use integer operations as dot() only works on floats.
      int stride0 = ${texName}Shape[1] * ${texName}Shape[2];
      int stride1 = ${texName}Shape[2];
      int index = row * stride0 + col * stride1 + depth + ${offset};
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index);
      return sampleTexture(${texName}, uv);
    }
    `;
    return `
      float ${funcName}(int row, int col, int depth) {
        // Explicitly use integer operations as dot() only works on floats.
        int index = row * ${stride0} + col * ${stride1} + depth + ${offset};
        vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
        return sampleTexture(${texName}, uv);
      }
  `;
}
function $0e693fb2f91ad76c$var$getPackedSamplerND(inputInfo, enableShapeUniforms) {
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const glsl = (0, $8qxEr.getGlslDifferences)();
    if (enableShapeUniforms) // TODO: support 5d and 6d
    return `
    vec4 ${funcName}(int b2, int b, int row, int col) {
      int valuesPerRow = int(ceil(float(${texName}Shape[3]) / 2.0));
      int texelsInBatch = valuesPerRow * int(ceil(float(${texName}Shape[2]) / 2.0));
      int index = b * texelsInBatch + (row / 2) * valuesPerRow + (col / 2);
      texelsInBatch *= ${texName}Shape[1];
      index = b2 * texelsInBatch + index;
      ivec2 packedTexShape = ivec2(ceil(float(${texName}TexShape[0]) / 2.0), ceil(float(${texName}TexShape[1]) / 2.0));
      int texR = index / packedTexShape[1];
      int texC = index - texR * packedTexShape[1];
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(packedTexShape[1], packedTexShape[0]); return ${glsl.texture2D}(${texName}, uv);
    }
  `;
    const shape = inputInfo.shapeInfo.logicalShape;
    const rank = shape.length;
    const texShape = inputInfo.shapeInfo.texShape;
    const packedTexShape = [
        Math.ceil(texShape[0] / 2),
        Math.ceil(texShape[1] / 2)
    ];
    const texNumR = packedTexShape[0];
    const texNumC = packedTexShape[1];
    const valuesPerRow = Math.ceil(shape[rank - 1] / 2);
    let texelsInBatch = valuesPerRow * Math.ceil(shape[rank - 2] / 2);
    let params = `int b, int row, int col`;
    let index = `b * ${texelsInBatch} + (row / 2) * ${valuesPerRow} + (col / 2)`;
    for(let b = 2; b < rank - 1; b++){
        params = `int b${b}, ` + params;
        texelsInBatch *= shape[rank - b - 1];
        index = `b${b} * ${texelsInBatch} + ` + index;
    }
    return `
    vec4 ${funcName}(${params}) {
      int index = ${index};
      int texR = index / ${texNumC};
      int texC = index - texR * ${texNumC};
      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${texNumC}, ${texNumR});
      return ${glsl.texture2D}(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getSampler4D(inputInfo, enableShapeUniforms) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride2 = shape[3];
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    const { newShape: newShape, keptDims: keptDims } = (0, $lBDHD).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $0e693fb2f91ad76c$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2'
        ];
        return `
      ${$0e693fb2f91ad76c$var$getSamplerFromInInfo(newInputInfo, enableShapeUniforms)}
      float ${funcName}(int row, int col, int depth, int depth2) {
        return ${funcName}(${$0e693fb2f91ad76c$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        int index = round(dot(vec4(row, col, depth, depth2),
                          vec4(${stride0}, ${stride1}, ${stride2}, 1)));
        ${$0e693fb2f91ad76c$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    const stride2Str = `int stride2 = ${texName}Shape[3];`;
    const stride1Str = `int stride1 = ${texName}Shape[2] * stride2;`;
    const stride0Str = `int stride0 = ${texName}Shape[1] * stride1;`;
    if (texNumC === stride0 && flatOffset == null) {
        // texC is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        ${stride2Str}
        ${stride1Str}
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(stride1, stride2, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = float(row);
        float texC =
            dot(vec3(col, depth, depth2),
                vec3(${stride1}, ${stride2}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    if (texNumC === stride2 && flatOffset == null) {
        // texR is used directly as physical (no risk of float16 overflow).
        if (enableShapeUniforms) return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${texName}Shape[1] * ${texName}Shape[2], ${texName}Shape[2], 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texName}TexShape[1], ${texName}TexShape[0]);
        return sampleTexture(${texName}, uv);
      }
    `;
        return `
      float ${funcName}(int row, int col, int depth, int depth2) {
        float texR = dot(vec3(row, col, depth),
                         vec3(${shape[1] * shape[2]}, ${shape[2]}, 1));
        float texC = float(depth2);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    }
    const offset = $0e693fb2f91ad76c$var$getFlatOffsetUniformName(texName);
    if (enableShapeUniforms) return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      ${stride2Str}
      ${stride1Str}
      ${stride0Str}
      int index = row * stride0 + col * stride1 +
          depth * stride2 + depth2;
      vec2 uv = uvFromFlat(${texName}TexShape[0], ${texName}TexShape[1], index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
    return `
    float ${funcName}(int row, int col, int depth, int depth2) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} +
          depth * ${stride2} + depth2;
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index + ${offset});
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getSampler5D(inputInfo) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const stride3 = shape[4];
    const stride2 = shape[3] * stride3;
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    const { newShape: newShape, keptDims: keptDims } = (0, $lBDHD).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $0e693fb2f91ad76c$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2',
            'depth3'
        ];
        return `
      ${$0e693fb2f91ad76c$var$getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        return ${funcName}(${$0e693fb2f91ad76c$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float index = dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          depth3;
        ${$0e693fb2f91ad76c$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    if (texNumC === stride0 && flatOffset == null) // texC is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
                         vec4(${stride1}, ${stride2}, ${stride3}, 1));
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    if (texNumC === stride3 && flatOffset == null) // texR is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
        float texR = dot(
          vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3]},
               ${shape[2] * shape[3]}, ${shape[3]}, 1));
        int texC = depth3;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    const offset = $0e693fb2f91ad76c$var$getFlatOffsetUniformName(texName);
    return `
    float ${funcName}(int row, int col, int depth, int depth2, int depth3) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getSampler6D(inputInfo) {
    const shape = inputInfo.shapeInfo.logicalShape;
    const texName = inputInfo.name;
    const funcName = 'get' + texName.charAt(0).toUpperCase() + texName.slice(1);
    const { newShape: newShape, keptDims: keptDims } = (0, $lBDHD).squeezeShape(shape);
    if (newShape.length < shape.length) {
        const newInputInfo = $0e693fb2f91ad76c$export$5d06d3f48295bf13(inputInfo, newShape);
        const params = [
            'row',
            'col',
            'depth',
            'depth2',
            'depth3',
            'depth4'
        ];
        return `
      ${$0e693fb2f91ad76c$var$getSamplerFromInInfo(newInputInfo)}
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        return ${funcName}(${$0e693fb2f91ad76c$var$getSqueezedParams(params, keptDims)});
      }
    `;
    }
    const stride4 = shape[5];
    const stride3 = shape[4] * stride4;
    const stride2 = shape[3] * stride3;
    const stride1 = shape[2] * stride2;
    const stride0 = shape[1] * stride1;
    if (inputInfo.shapeInfo.isUniform) // Uniform arrays will be less than 65505 (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
        int index = round(dot(
          vec4(row, col, depth, depth2),
          vec4(${stride0}, ${stride1}, ${stride2}, ${stride3})) +
          dot(
            vec2(depth3, depth4),
            vec2(${stride4}, 1)));
        ${$0e693fb2f91ad76c$var$getUniformSampler(inputInfo)}
      }
    `;
    const flatOffset = inputInfo.shapeInfo.flatOffset;
    const texShape = inputInfo.shapeInfo.texShape;
    const texNumR = texShape[0];
    const texNumC = texShape[1];
    if (texNumC === stride0 && flatOffset == null) // texC is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        int texR = row;
        float texC = dot(vec4(col, depth, depth2, depth3),
          vec4(${stride1}, ${stride2}, ${stride3}, ${stride4})) +
               float(depth4);
        vec2 uv = (vec2(texC, texR) + halfCR) /
                   vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    if (texNumC === stride4 && flatOffset == null) // texR is used directly as physical (no risk of float16 overflow).
    return `
      float ${funcName}(int row, int col, int depth,
                    int depth2, int depth3, int depth4) {
        float texR = dot(vec4(row, col, depth, depth2),
          vec4(${shape[1] * shape[2] * shape[3] * shape[4]},
               ${shape[2] * shape[3] * shape[4]},
               ${shape[3] * shape[4]},
               ${shape[4]})) + float(depth3);
        int texC = depth4;
        vec2 uv = (vec2(texC, texR) + halfCR) /
                  vec2(${texNumC}.0, ${texNumR}.0);
        return sampleTexture(${texName}, uv);
      }
    `;
    const offset = $0e693fb2f91ad76c$var$getFlatOffsetUniformName(texName);
    return `
    float ${funcName}(int row, int col, int depth,
                  int depth2, int depth3, int depth4) {
      // Explicitly use integer operations as dot() only works on floats.
      int index = row * ${stride0} + col * ${stride1} + depth * ${stride2} +
          depth2 * ${stride3} + depth3 * ${stride4} + depth4 + ${offset};
      vec2 uv = uvFromFlat(${texNumR}, ${texNumC}, index);
      return sampleTexture(${texName}, uv);
    }
  `;
}
function $0e693fb2f91ad76c$var$getUniformSampler(inputInfo) {
    const texName = inputInfo.name;
    const inSize = (0, $lBDHD).sizeFromShape(inputInfo.shapeInfo.logicalShape);
    if (inSize < 2) return `return ${texName};`;
    return `
    for (int i = 0; i < ${inSize}; i++) {
      if (i == index) {
        return ${texName}[i];
      }
    }
  `;
}
function $0e693fb2f91ad76c$var$getPackedSamplerAtOutputCoords(inputInfo, outShapeInfo) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'AtOutCoords';
    const inRank = inputInfo.shapeInfo.logicalShape.length;
    const outRank = outShapeInfo.logicalShape.length;
    const broadcastDims = $0e693fb2f91ad76c$var$getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
    const type = $0e693fb2f91ad76c$export$859efd105c10c755(outRank);
    const rankDiff = outRank - inRank;
    let coordsSnippet;
    const fields = [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ];
    if (inRank === 0) coordsSnippet = '';
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${fields[d + rankDiff]} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s, i)=>`coords.${fields[i + rankDiff]}`).join(', ');
    let output = `return outputValue;`;
    const inSize = (0, $lBDHD).sizeFromShape(inputInfo.shapeInfo.logicalShape);
    const isInputScalar = inSize === 1;
    const outSize = (0, $lBDHD).sizeFromShape(outShapeInfo.logicalShape);
    const isOutputScalar = outSize === 1;
    if (inRank === 1 && !isInputScalar && !isOutputScalar) output = `
      return vec4(outputValue.xy, outputValue.xy);
    `;
    else if (isInputScalar && !isOutputScalar) {
        if (outRank === 1) output = `
        return vec4(outputValue.x, outputValue.x, 0., 0.);
      `;
        else output = `
        return vec4(outputValue.x);
      `;
    } else if (broadcastDims.length) {
        const rows = inRank - 2;
        const cols = inRank - 1;
        if (broadcastDims.indexOf(rows) > -1 && broadcastDims.indexOf(cols) > -1) output = `return vec4(outputValue.x);`;
        else if (broadcastDims.indexOf(rows) > -1) output = `return vec4(outputValue.x, outputValue.y, ` + `outputValue.x, outputValue.y);`;
        else if (broadcastDims.indexOf(cols) > -1) output = `return vec4(outputValue.xx, outputValue.zz);`;
    }
    return `
    vec4 ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      vec4 outputValue = get${texFuncSnippet}(${unpackedCoordsSnippet});
      ${output}
    }
  `;
}
function $0e693fb2f91ad76c$var$getSamplerAtOutputCoords(inputInfo, outShapeInfo) {
    const texName = inputInfo.name;
    const texFuncSnippet = texName.charAt(0).toUpperCase() + texName.slice(1);
    const funcName = 'get' + texFuncSnippet + 'AtOutCoords';
    const outTexShape = outShapeInfo.texShape;
    const inTexShape = inputInfo.shapeInfo.texShape;
    const inRank = inputInfo.shapeInfo.logicalShape.length;
    const outRank = outShapeInfo.logicalShape.length;
    if (!inputInfo.shapeInfo.isUniform && inRank === outRank && inputInfo.shapeInfo.flatOffset == null && (0, $lBDHD).arraysEqual(inTexShape, outTexShape)) return `
      float ${funcName}() {
        return sampleTexture(${texName}, resultUV);
      }
    `;
    const type = $0e693fb2f91ad76c$export$859efd105c10c755(outRank);
    const broadcastDims = $0e693fb2f91ad76c$var$getBroadcastDims(inputInfo.shapeInfo.logicalShape, outShapeInfo.logicalShape);
    const rankDiff = outRank - inRank;
    let coordsSnippet;
    const fields = [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ];
    if (inRank === 0) coordsSnippet = '';
    else if (outRank < 2 && broadcastDims.length >= 1) coordsSnippet = 'coords = 0;';
    else coordsSnippet = broadcastDims.map((d)=>`coords.${fields[d + rankDiff]} = 0;`).join('\n');
    let unpackedCoordsSnippet = '';
    if (outRank < 2 && inRank > 0) unpackedCoordsSnippet = 'coords';
    else unpackedCoordsSnippet = inputInfo.shapeInfo.logicalShape.map((s, i)=>`coords.${fields[i + rankDiff]}`).join(', ');
    return `
    float ${funcName}() {
      ${type} coords = getOutputCoords();
      ${coordsSnippet}
      return get${texFuncSnippet}(${unpackedCoordsSnippet});
    }
  `;
}
function $0e693fb2f91ad76c$export$859efd105c10c755(rank) {
    if (rank <= 1) return 'int';
    else if (rank === 2) return 'ivec2';
    else if (rank === 3) return 'ivec3';
    else if (rank === 4) return 'ivec4';
    else if (rank === 5) return 'ivec5';
    else if (rank === 6) return 'ivec6';
    else throw Error(`GPU for rank ${rank} is not yet supported`);
}
function $0e693fb2f91ad76c$export$19e35a0844e29cf9(isPacked, shape, texShape) {
    const { newShape: newShape, keptDims: keptDims } = (0, $lBDHD).squeezeShape(shape);
    const rank = shape.length;
    const useSqueezePackedShape = isPacked && rank === 3 && shape[0] === 1;
    const squeezeShape = useSqueezePackedShape ? shape.slice(1) : newShape;
    const useSqueezeShape = !isPacked && rank > 1 && !(0, $lBDHD).arraysEqual(shape, texShape) && newShape.length < rank || useSqueezePackedShape;
    const uniformShape = useSqueezeShape ? squeezeShape : shape;
    return {
        useSqueezeShape: useSqueezeShape,
        uniformShape: uniformShape,
        keptDims: keptDims
    };
}
function $0e693fb2f91ad76c$export$5d06d3f48295bf13(inInfo, squeezedShape) {
    // Deep copy.
    const newInputInfo = JSON.parse(JSON.stringify(inInfo));
    newInputInfo.shapeInfo.logicalShape = squeezedShape;
    return newInputInfo;
}
function $0e693fb2f91ad76c$var$getSqueezedParams(params, keptDims) {
    return keptDims.map((d)=>params[d]).join(', ');
}

});
parcelRegister("iR3z2", function(module, exports) {

$parcel$export(module.exports, "getLogicalCoordinatesFromFlatIndex", function () { return $db9ff0ffa315812b$export$53c37f67510642ce; });
$parcel$export(module.exports, "getOutputLogicalCoordinatesFromFlatIndexByUniform", function () { return $db9ff0ffa315812b$export$ae684ebb20c3e80c; });
$parcel$export(module.exports, "getLogicalCoordinatesFromFlatIndexByUniform", function () { return $db9ff0ffa315812b$export$a1b266196cc2d8ea; });
$parcel$export(module.exports, "getFlatIndexFrom3D", function () { return $db9ff0ffa315812b$export$4c68558c71205a01; });
$parcel$export(module.exports, "getFlatIndexFrom3DOutput", function () { return $db9ff0ffa315812b$export$4ec1e3f6361de451; });
$parcel$export(module.exports, "ENCODE_FLOAT_SNIPPET", function () { return $db9ff0ffa315812b$export$2ac12a308a563905; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
function $db9ff0ffa315812b$export$53c37f67510642ce(coords, shape, index = 'index') {
    const strides = (0, $lBDHD).computeStrides(shape);
    return strides.map((stride, i)=>{
        const line1 = `int ${coords[i]} = ${index} / ${stride}`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * ${stride}` : `index -= ${coords[i]} * ${stride}`;
        return `${line1}; ${line2};`;
    }).join('');
}
function $db9ff0ffa315812b$export$ae684ebb20c3e80c(coords, shape, index = 'index') {
    const strides = (0, $lBDHD).computeStrides(shape);
    return strides.map((_, i)=>{
        const line1 = `int ${coords[i]} = ${index} / outShapeStrides[${i}]`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * outShapeStrides[${i}]` : `index -= ${coords[i]} * outShapeStrides[${i}]`;
        return `${line1}; ${line2};`;
    }).join('');
}
// Produces GLSL code that computes strides.
function $db9ff0ffa315812b$var$symbolicallyComputeStrides(indicesArr, variableName) {
    const numCoords = indicesArr.length;
    const shape = indicesArr.map((d)=>`${variableName}[${d}]`);
    const strides = new Array(numCoords - 1);
    strides[numCoords - 2] = shape[numCoords - 1];
    for(let i = numCoords - 3; i >= 0; --i)strides[i] = `(${strides[i + 1]} * ${shape[i + 1]})`;
    return strides;
}
function $db9ff0ffa315812b$export$a1b266196cc2d8ea(coords, variableName, index = 'index') {
    const indicesArray = coords.map((_, i)=>i);
    const strides = $db9ff0ffa315812b$var$symbolicallyComputeStrides(indicesArray, variableName);
    return strides.map((_, i)=>{
        const line1 = `int ${coords[i]} = ${index} / ${strides[i]}`;
        const line2 = i === strides.length - 1 ? `int ${coords[i + 1]} = ${index} - ${coords[i]} * ${strides[i]}` : `index -= ${coords[i]} * ${strides[i]}`;
        return `${line1}; ${line2};`;
    }).join('');
}
function $db9ff0ffa315812b$var$buildVec(x) {
    if (x.length === 1) return `${x[0]}`;
    return `vec${x.length}(${x.join(',')})`;
}
function $db9ff0ffa315812b$export$fe4cd89a7b9cb48b(x, y) {
    if (x.length !== y.length) throw new Error(`Vectors to be dotted must be of the same length -` + `got ${x.length} and ${y.length}`);
    const slices = [];
    const nearestVec4 = Math.floor(x.length / 4);
    const nearestVec4Remainder = x.length % 4;
    for(let i = 0; i < nearestVec4; i++){
        const xSlice = x.slice(i * 4, i * 4 + 4);
        const ySlice = y.slice(i * 4, i * 4 + 4);
        slices.push(`${$db9ff0ffa315812b$var$buildVec(xSlice)}, ${$db9ff0ffa315812b$var$buildVec(ySlice)}`);
    }
    if (nearestVec4Remainder !== 0) {
        let xSlice = x.slice(nearestVec4 * 4);
        let ySlice = y.slice(nearestVec4 * 4);
        if (xSlice.length === 1) {
            xSlice = xSlice.map((d)=>`float(${d})`);
            ySlice = ySlice.map((d)=>`float(${d})`);
        }
        slices.push(`${$db9ff0ffa315812b$var$buildVec(xSlice)}, ${$db9ff0ffa315812b$var$buildVec(ySlice)}`);
    }
    return slices.map((d, i)=>`dot(${d})`).join('+');
}
function $db9ff0ffa315812b$export$4c68558c71205a01(shape) {
    const strides = (0, $lBDHD).computeStrides(shape).map((d)=>d.toString());
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * ${strides[0]} + coords.y * ${strides[1]} + coords.z;
  }
`;
}
function $db9ff0ffa315812b$export$4ec1e3f6361de451() {
    return `
  int getFlatIndex(ivec3 coords) {
    return coords.x * outShapeStrides[0] + coords.y * outShapeStrides[1] + coords.z;
  }
`;
}
const $db9ff0ffa315812b$export$2ac12a308a563905 = `
  const float FLOAT_MAX = 1.70141184e38;
  const float FLOAT_MIN = 1.17549435e-38;

  lowp vec4 encode_float(highp float v) {
    if (isnan(v)) {
      return vec4(255, 255, 255, 255);
    }

    highp float av = abs(v);

    if(av < FLOAT_MIN) {
      return vec4(0.0, 0.0, 0.0, 0.0);
    } else if(v > FLOAT_MAX) {
      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;
    } else if(v < -FLOAT_MAX) {
      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;
    }

    highp vec4 c = vec4(0,0,0,0);

    highp float e = floor(log2(av));
    highp float m = exp2(fract(log2(av))) - 1.0;

    c[2] = floor(128.0 * m);
    m -= c[2] / 128.0;
    c[1] = floor(32768.0 * m);
    m -= c[1] / 32768.0;
    c[0] = floor(8388608.0 * m);

    highp float ebias = e + 127.0;
    c[3] = floor(ebias / 2.0);
    ebias -= c[3] * 2.0;
    c[2] += floor(ebias) * 128.0;

    c[3] += 128.0 * step(0.0, -v);

    return c / 255.0;
  }
`;

});




parcelRegister("euZt6", function(module, exports) {

$parcel$export(module.exports, "DecodeMatrixPackedProgram", function () { return $a8e38c5d1c6d7a41$export$4434db41c70879cb; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");

var $SwRKX = parcelRequire("SwRKX");

var $iR3z2 = parcelRequire("iR3z2");

var $2zyhV = parcelRequire("2zyhV");
class $a8e38c5d1c6d7a41$export$4434db41c70879cb {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outPackingScheme = (0, $2zyhV.PackingScheme).DENSE;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $8qxEr.getGlslDifferences)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      ivec3 outCoordsFromFlatIndex(int index) {
        ${this.enableShapeUniforms ? $iR3z2.getOutputLogicalCoordinatesFromFlatIndexByUniform([
            'r',
            'c',
            'd'
        ], outputShape) : $iR3z2.getLogicalCoordinatesFromFlatIndex([
            'r',
            'c',
            'd'
        ], outputShape)}
        return ivec3(r, c, d);
      }

      void main() {
        ivec2 resTexRC = ivec2(resultUV.yx * vec2(texShape[0], texShape[1]));
        int index = 4 * (resTexRC.x * texShape[1] + resTexRC.y);

        vec4 result = vec4(0.);

        for (int i=0; i<4; i++) {
          int flatIndex = index + i;
          ivec3 rc = outCoordsFromFlatIndex(flatIndex);
          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));
        }

        ${glsl.output} = result;
      }
    `;
    }
}

});

parcelRegister("5pqKu", function(module, exports) {

$parcel$export(module.exports, "EncodeFloatProgram", function () { return $3f04094c9e27b353$export$dae4f112167b5aac; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");

var $iR3z2 = parcelRequire("iR3z2");

var $2zyhV = parcelRequire("2zyhV");
class $3f04094c9e27b353$export$dae4f112167b5aac {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.outTexUsage = (0, $2zyhV.TextureUsage).DOWNLOAD;
        const glsl = (0, $8qxEr.getGlslDifferences)();
        this.outputShape = outputShape;
        this.userCode = `
      ${0, $iR3z2.ENCODE_FLOAT_SNIPPET}

      void main() {
        float x = getAAtOutCoords();
        ${glsl.output} = encode_float(x);
      }
    `;
    }
}

});

parcelRegister("5gsGP", function(module, exports) {

$parcel$export(module.exports, "EncodeFloatPackedProgram", function () { return $3d54b38b6dfe2e42$export$97e262e8a4818e2e; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");

var $iR3z2 = parcelRequire("iR3z2");

var $2zyhV = parcelRequire("2zyhV");
class $3d54b38b6dfe2e42$export$97e262e8a4818e2e {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = false;
        this.outTexUsage = (0, $2zyhV.TextureUsage).DOWNLOAD;
        const glsl = (0, $8qxEr.getGlslDifferences)();
        this.outputShape = outputShape;
        this.userCode = `
      ${0, $iR3z2.ENCODE_FLOAT_SNIPPET}

      void main() {
        ivec3 coords = getOutputCoords();
        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));
        ${glsl.output} = encode_float(x);
      }
    `;
    }
}

});

parcelRegister("ajlEV", function(module, exports) {

$parcel$export(module.exports, "EncodeMatrixProgram", function () { return $781c7ac581855b91$export$b2e063313033aeab; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");

var $SwRKX = parcelRequire("SwRKX");

var $iR3z2 = parcelRequire("iR3z2");
const $781c7ac581855b91$var$CHANNEL_CHAR_TO_INDEX_MAP = {
    'R': 0,
    'G': 1,
    'B': 2,
    'A': 3
};
class $781c7ac581855b91$export$b2e063313033aeab {
    constructor(outputShape, inputIsUnsignedByte = false, usedChannels = 'RGBA'){
        this.variableNames = [
            'A'
        ];
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $8qxEr.getGlslDifferences)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        let output = `result`;
        if (inputIsUnsignedByte) output = `floor(result * 255. + 0.5)`;
        let mainLoop = '';
        for(let usedChannelIndex = 0; usedChannelIndex < usedChannels.length; usedChannelIndex++){
            const curChannel = usedChannels[usedChannelIndex];
            mainLoop += `
          if(offset == ${usedChannelIndex}) {
            result = values[${$781c7ac581855b91$var$CHANNEL_CHAR_TO_INDEX_MAP[curChannel]}];
          }`;
        }
        this.userCode = `
      ${this.enableShapeUniforms ? $iR3z2.getFlatIndexFrom3DOutput() : $iR3z2.getFlatIndexFrom3D(outputShape)}

      void main() {
        ivec3 coords = getOutputCoords();
        int flatIndex = getFlatIndex(coords);
        float result = 0.;
        int offset = imod(flatIndex, ${usedChannels.length});

        flatIndex = idiv(flatIndex, ${usedChannels.length}, 1.);

        int r = flatIndex / texShape[1];
        if (r < texShape[0]) {
          int c = imod(flatIndex, texShape[1]);
          vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
          vec4 values = ${glsl.texture2D}(A, uv);
          ${mainLoop}
        }
        ${glsl.output} = vec4(${output}, 0., 0., 0.);
      }
    `;
    }
}

});

parcelRegister("kCGTi", function(module, exports) {

$parcel$export(module.exports, "EncodeMatrixPackedProgram", function () { return $f038a07d906c4559$export$3b3e6b1f67c8c4d5; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");

var $SwRKX = parcelRequire("SwRKX");

var $iR3z2 = parcelRequire("iR3z2");
class $f038a07d906c4559$export$3b3e6b1f67c8c4d5 {
    constructor(outputShape, inputIsUnsignedByte = false){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'texShape',
                type: 'ivec2'
            }
        ];
        const glsl = (0, $8qxEr.getGlslDifferences)();
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        let mainLoop = '';
        let output = 'result';
        if (inputIsUnsignedByte) output = 'floor(result * 255. + 0.5)';
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++){
            const channel = row * 2 + col;
            mainLoop += `
          localCoords = coords;
          if(localCoords[2] + ${col} < ${this.enableShapeUniforms ? 'outShape[2]' : `${outputShape[2]}`}) {
          localCoords[2] += ${col};
          if (localCoords[1] + ${row} < ${this.enableShapeUniforms ? 'outShape[1]' : `${outputShape[1]}`}) {
            localCoords[1] += ${row};

            flatIndex = getFlatIndex(localCoords);
            offset = imod(flatIndex, 4);

            flatIndex = idiv(flatIndex, 4, 1.);

            int r = flatIndex / texShape[1];
            int c = imod(flatIndex, texShape[1]);
            vec2 uv = (vec2(c, r) + halfCR) / vec2(texShape[1], texShape[0]);
            values = ${glsl.texture2D}(A, uv);

            if (offset == 0) {
              result[${channel}] = values[0];
            } else if (offset == 1) {
              result[${channel}] = values[1];
            } else if (offset == 2) {
              result[${channel}] = values[2];
            } else {
              result[${channel}] = values[3];
            }
          }
        }
        `;
        }
        this.userCode = `
        ${this.enableShapeUniforms ? $iR3z2.getFlatIndexFrom3DOutput() : $iR3z2.getFlatIndexFrom3D(outputShape)}

        void main() {
          ivec3 coords = getOutputCoords();

          vec4 result = vec4(0.);
          int flatIndex, r, c, offset;
          ivec3 localCoords;
          vec2 uv;
          vec4 values;

          ${mainLoop}

          ${glsl.output} = ${output};
        }
    `;
    }
}

});

parcelRegister("1as8e", function(module, exports) {

$parcel$export(module.exports, "GPGPUContext", function () { return $0d9c8bfbf4649dad$export$fa7a74a0ce382ac5; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $lBDHD = parcelRequire("lBDHD");

var $8BJsC = parcelRequire("8BJsC");

var $3DtaJ = parcelRequire("3DtaJ");

var $2zyhV = parcelRequire("2zyhV");

var $k42ZR = parcelRequire("k42ZR");
class $0d9c8bfbf4649dad$export$fa7a74a0ce382ac5 {
    constructor(gl){
        this.outputTexture = null;
        this.program = null;
        this.disposed = false;
        this.itemsToPoll = [];
        const glVersion = (0, $tdutJ.env)().getNumber('WEBGL_VERSION');
        if (gl != null) {
            this.gl = gl;
            (0, $8BJsC.setWebGLContext)(glVersion, gl);
        } else this.gl = (0, $8BJsC.getWebGLContext)(glVersion);
        gl = this.gl;
        if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2) {
            const gl2 = gl;
            this.createVertexArray = ()=>{
                return $k42ZR.callAndCheck(gl2, ()=>gl2.createVertexArray());
            };
            this.bindVertexArray = (vao)=>{
                return $k42ZR.callAndCheck(gl2, ()=>gl2.bindVertexArray(vao));
            };
            this.deleteVertexArray = (vao)=>{
                return $k42ZR.callAndCheck(gl2, ()=>gl2.deleteVertexArray(vao));
            };
            this.getVertexArray = ()=>{
                return $k42ZR.callAndCheck(gl2, ()=>gl2.getParameter(gl2.VERTEX_ARRAY_BINDING));
            };
        } else if (gl != null) {
            const ext = gl.getExtension('OES_vertex_array_object');
            if (ext == null) throw new Error("All WebGL1 implementations are expected to offer OES_vertex_array_object.");
            this.createVertexArray = ()=>{
                return $k42ZR.callAndCheck(gl, ()=>ext.createVertexArrayOES());
            };
            this.bindVertexArray = (vao)=>{
                return $k42ZR.callAndCheck(gl, ()=>ext.bindVertexArrayOES(vao));
            };
            this.deleteVertexArray = (vao)=>{
                return $k42ZR.callAndCheck(gl, ()=>ext.deleteVertexArrayOES(vao));
            };
            this.getVertexArray = ()=>{
                return $k42ZR.callAndCheck(gl, ()=>gl.getParameter(ext.VERTEX_ARRAY_BINDING_OES));
            };
        }
        // WebGL 2.0 enables texture floats without an extension.
        let COLOR_BUFFER_FLOAT = 'WEBGL_color_buffer_float';
        const COLOR_BUFFER_HALF_FLOAT = 'EXT_color_buffer_half_float';
        this.parallelCompilationExtension = this.gl.getExtension('KHR_parallel_shader_compile');
        if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 1) {
            const TEXTURE_FLOAT = 'OES_texture_float';
            const TEXTURE_HALF_FLOAT = 'OES_texture_half_float';
            this.textureFloatExtension = $k42ZR.getExtensionOrThrow(this.gl, TEXTURE_FLOAT);
            if ($k42ZR.hasExtension(this.gl, TEXTURE_HALF_FLOAT)) this.textureHalfFloatExtension = $k42ZR.getExtensionOrThrow(this.gl, TEXTURE_HALF_FLOAT);
            else if ((0, $tdutJ.env)().get('WEBGL_FORCE_F16_TEXTURES')) throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
            this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
            if ($k42ZR.hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) this.colorBufferHalfFloatExtension = $k42ZR.getExtensionOrThrow(this.gl, COLOR_BUFFER_HALF_FLOAT);
            else if ((0, $tdutJ.env)().get('WEBGL_FORCE_F16_TEXTURES')) throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
        } else {
            COLOR_BUFFER_FLOAT = 'EXT_color_buffer_float';
            if ($k42ZR.hasExtension(this.gl, COLOR_BUFFER_FLOAT)) this.colorBufferFloatExtension = this.gl.getExtension(COLOR_BUFFER_FLOAT);
            else if ($k42ZR.hasExtension(this.gl, COLOR_BUFFER_HALF_FLOAT)) this.colorBufferHalfFloatExtension = this.gl.getExtension(COLOR_BUFFER_HALF_FLOAT);
            else throw new Error('GL context does not support color renderable floats');
        }
        this.vertexBuffer = $3DtaJ.createVertexBuffer(this.gl);
        this.indexBuffer = $3DtaJ.createIndexBuffer(this.gl);
        this.framebuffer = $k42ZR.createFramebuffer(this.gl);
        this.textureConfig = $2zyhV.getTextureConfig(this.gl, this.textureHalfFloatExtension);
    }
    get debug() {
        return (0, $tdutJ.env)().getBool('DEBUG');
    }
    dispose() {
        if (this.disposed) return;
        if (this.program != null) console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing.");
        if (this.outputTexture != null) console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
        const gl = this.gl;
        $k42ZR.callAndCheck(gl, ()=>gl.finish());
        $k42ZR.callAndCheck(gl, ()=>gl.bindFramebuffer(gl.FRAMEBUFFER, null));
        $k42ZR.callAndCheck(gl, ()=>gl.deleteFramebuffer(this.framebuffer));
        $k42ZR.callAndCheck(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, null));
        $k42ZR.callAndCheck(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null));
        $k42ZR.callAndCheck(gl, ()=>gl.deleteBuffer(this.indexBuffer));
        this.disposed = true;
    }
    createFloat32MatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $3DtaJ.createFloat32MatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    createFloat16MatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $3DtaJ.createFloat16MatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    createUnsignedBytesMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $3DtaJ.createUnsignedBytesMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    uploadPixelDataToTexture(texture, pixels) {
        this.throwIfDisposed();
        $3DtaJ.uploadPixelDataToTexture(this.gl, texture, pixels);
    }
    uploadDenseMatrixToTexture(texture, width, height, data) {
        this.throwIfDisposed();
        $3DtaJ.uploadDenseMatrixToTexture(this.gl, texture, width, height, data, this.textureConfig);
    }
    createFloat16PackedMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $3DtaJ.createFloat16PackedMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    createPackedMatrixTexture(rows, columns) {
        this.throwIfDisposed();
        return $3DtaJ.createPackedMatrixTexture(this.gl, rows, columns, this.textureConfig);
    }
    deleteMatrixTexture(texture) {
        this.throwIfDisposed();
        if (this.outputTexture === texture) {
            $k42ZR.unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
            this.outputTexture = null;
        }
        $k42ZR.callAndCheck(this.gl, ()=>this.gl.deleteTexture(texture));
    }
    downloadByteEncodedFloatMatrixFromOutputTexture(texture, rows, columns) {
        return this.downloadMatrixDriver(texture, ()=>$3DtaJ.downloadByteEncodedFloatMatrixFromOutputTexture(this.gl, rows, columns, this.textureConfig));
    }
    downloadPackedMatrixFromBuffer(buffer, batch, rows, columns, physicalRows, physicalCols) {
        return $3DtaJ.downloadPackedMatrixFromBuffer(this.gl, buffer, batch, rows, columns, physicalRows, physicalCols, this.textureConfig);
    }
    downloadFloat32MatrixFromBuffer(buffer, size) {
        return $3DtaJ.downloadFloat32MatrixFromBuffer(this.gl, buffer, size);
    }
    createBufferFromTexture(texture, rows, columns) {
        this.bindTextureToFrameBuffer(texture);
        const result = $3DtaJ.createBufferFromOutputTexture(this.gl, rows, columns, this.textureConfig);
        this.unbindTextureToFrameBuffer();
        return result;
    }
    createAndWaitForFence() {
        const fenceContext = this.createFence(this.gl);
        return this.pollFence(fenceContext);
    }
    createFence(gl) {
        let query;
        let isFencePassed;
        if ((0, $tdutJ.env)().getBool('WEBGL_FENCE_API_ENABLED')) {
            const gl2 = gl;
            const sync = gl2.fenceSync(gl2.SYNC_GPU_COMMANDS_COMPLETE, 0);
            gl.flush();
            isFencePassed = ()=>{
                const status = gl2.clientWaitSync(sync, 0, 0);
                return status === gl2.ALREADY_SIGNALED || status === gl2.CONDITION_SATISFIED;
            };
            query = sync;
        } else if ((0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') > 0) {
            query = this.beginQuery();
            this.endQuery();
            isFencePassed = ()=>this.isQueryAvailable(query, (0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
        } else // If we have no way to fence, return true immediately. This will fire in
        // WebGL 1.0 when there is no disjoint query timer. In this case, because
        // the fence passes immediately, we'll immediately ask for a download of
        // the texture, which will cause the UI thread to hang.
        isFencePassed = ()=>true;
        return {
            query: query,
            isFencePassed: isFencePassed
        };
    }
    downloadMatrixFromPackedTexture(texture, physicalRows, physicalCols) {
        return this.downloadMatrixDriver(texture, ()=>$3DtaJ.downloadMatrixFromPackedOutputTexture(this.gl, physicalRows, physicalCols));
    }
    createProgram(fragmentShader) {
        this.throwIfDisposed();
        const gl = this.gl;
        if (this.vertexShader == null) this.vertexShader = $3DtaJ.createVertexShader(gl);
        const program = $k42ZR.createProgram(gl);
        $k42ZR.callAndCheck(gl, ()=>gl.attachShader(program, this.vertexShader));
        $k42ZR.callAndCheck(gl, ()=>gl.attachShader(program, fragmentShader));
        $k42ZR.linkProgram(gl, program);
        const program2 = Object.assign(program, {
            vao: this.createVertexArray()
        });
        if (this.debug) $k42ZR.validateProgram(gl, program2);
        return program2;
    }
    buildVao(program) {
        this.setProgram(program);
        this.bindVertexArray(program.vao);
        const gl = this.gl;
        // Bind index buffer, and vertex buffers based on program attrib
        // locations.
        $k42ZR.callAndCheck(gl, ()=>gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.indexBuffer));
        $3DtaJ.bindVertexProgramAttributeStreams(gl, program, this.vertexBuffer);
    }
    deleteProgram(program) {
        this.throwIfDisposed();
        if (program === this.program) this.program = null;
        if (program != null) {
            $k42ZR.callAndCheck(this.gl, ()=>this.gl.deleteProgram(program));
            this.deleteVertexArray(program.vao);
        }
    }
    setProgram(program) {
        this.throwIfDisposed();
        this.program = program;
        if (this.program != null) {
            if (this.debug) $k42ZR.validateProgram(this.gl, this.program);
        }
        $k42ZR.callAndCheck(this.gl, ()=>this.gl.useProgram(program));
    }
    getUniformLocation(program, uniformName, shouldThrow = true) {
        this.throwIfDisposed();
        if (shouldThrow) return $k42ZR.getProgramUniformLocationOrThrow(this.gl, program, uniformName);
        else return $k42ZR.getProgramUniformLocation(this.gl, program, uniformName);
    }
    getAttributeLocation(program, attribute) {
        this.throwIfDisposed();
        return $k42ZR.callAndCheck(this.gl, ()=>this.gl.getAttribLocation(program, attribute));
    }
    getUniformLocationNoThrow(program, uniformName) {
        this.throwIfDisposed();
        return this.gl.getUniformLocation(program, uniformName);
    }
    setInputMatrixTexture(inputMatrixTexture, uniformLocation, textureUnit) {
        this.throwIfDisposed();
        this.throwIfNoProgram();
        $k42ZR.bindTextureToProgramUniformSampler(this.gl, inputMatrixTexture, uniformLocation, textureUnit);
    }
    setOutputMatrixTexture(outputMatrixTexture, rows, columns) {
        this.setOutputMatrixTextureDriver(outputMatrixTexture, columns, rows);
    }
    setOutputPackedMatrixTexture(outputPackedMatrixTexture, rows, columns) {
        this.throwIfDisposed();
        const [width, height] = $2zyhV.getPackedMatrixTextureShapeWidthHeight(rows, columns);
        this.setOutputMatrixTextureDriver(outputPackedMatrixTexture, width, height);
    }
    setOutputMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
        this.setOutputMatrixWriteRegionDriver(startColumn, startRow, numColumns, numRows);
    }
    setOutputPackedMatrixWriteRegion(startRow, numRows, startColumn, numColumns) {
        throw new Error('setOutputPackedMatrixWriteRegion not implemented.');
    }
    debugValidate() {
        if (this.program != null) $k42ZR.validateProgram(this.gl, this.program);
        $k42ZR.validateFramebuffer(this.gl);
    }
    executeProgram() {
        this.throwIfDisposed();
        this.throwIfNoProgram();
        const gl = this.gl;
        if (this.debug) {
            const boundVao = this.getVertexArray();
            console.assert(boundVao === this.program.vao, 'VAO changed between setProgram and executeProgram!');
            this.debugValidate();
        }
        $k42ZR.callAndCheck(gl, ()=>gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0));
    }
    blockUntilAllProgramsCompleted() {
        this.throwIfDisposed();
        $k42ZR.callAndCheck(this.gl, ()=>this.gl.finish());
    }
    getQueryTimerExtension() {
        if (this.disjointQueryTimerExtension == null) this.disjointQueryTimerExtension = $k42ZR.getExtensionOrThrow(this.gl, (0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2 ? 'EXT_disjoint_timer_query_webgl2' : 'EXT_disjoint_timer_query');
        return this.disjointQueryTimerExtension;
    }
    getQueryTimerExtensionWebGL2() {
        return this.getQueryTimerExtension();
    }
    getQueryTimerExtensionWebGL1() {
        return this.getQueryTimerExtension();
    }
    beginQuery() {
        if ((0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            const query = gl2.createQuery();
            gl2.beginQuery(ext.TIME_ELAPSED_EXT, query);
            return query;
        }
        const ext = this.getQueryTimerExtensionWebGL1();
        const query = ext.createQueryEXT();
        ext.beginQueryEXT(ext.TIME_ELAPSED_EXT, query);
        return query;
    }
    endQuery() {
        if ((0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION') === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            gl2.endQuery(ext.TIME_ELAPSED_EXT);
            return;
        }
        const ext = this.getQueryTimerExtensionWebGL1();
        ext.endQueryEXT(ext.TIME_ELAPSED_EXT);
    }
    async waitForQueryAndGetTime(query) {
        await (0, $lBDHD).repeatedTry(()=>this.disposed || // while testing contexts are created / disposed
            // in rapid succession, so without this check we
            // may poll for the query timer indefinitely
            this.isQueryAvailable(query, (0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION')));
        return this.getQueryTime(query, (0, $tdutJ.env)().getNumber('WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION'));
    }
    getQueryTime(query, queryTimerVersion) {
        if (queryTimerVersion === 0) return null;
        if (queryTimerVersion === 2) {
            const gl2 = this.gl;
            const timeElapsedNanos = gl2.getQueryParameter(query, gl2.QUERY_RESULT);
            // Return milliseconds.
            return timeElapsedNanos / 1000000;
        } else {
            const ext = this.getQueryTimerExtensionWebGL1();
            const timeElapsedNanos = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_EXT);
            // Return milliseconds.
            return timeElapsedNanos / 1000000;
        }
    }
    isQueryAvailable(query, queryTimerVersion) {
        if (queryTimerVersion === 0) return true;
        if (queryTimerVersion === 2) {
            const gl2 = this.gl;
            const ext = this.getQueryTimerExtensionWebGL2();
            const available = gl2.getQueryParameter(query, gl2.QUERY_RESULT_AVAILABLE);
            if (this.disjoint == null) this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
            return available && !this.disjoint;
        } else {
            const ext = this.getQueryTimerExtensionWebGL1();
            const available = ext.getQueryObjectEXT(query, ext.QUERY_RESULT_AVAILABLE_EXT);
            if (this.disjoint == null) this.disjoint = this.gl.getParameter(ext.GPU_DISJOINT_EXT);
            return available && !this.disjoint;
        }
    }
    pollFence(fenceContext) {
        return new Promise((resolve)=>{
            this.addItemToPoll(()=>fenceContext.isFencePassed(), ()=>resolve());
        });
    }
    pollItems() {
        // Find the last query that has finished.
        const index = $0d9c8bfbf4649dad$export$4a09b41294052731(this.itemsToPoll.map((x)=>x.isDoneFn));
        for(let i = 0; i <= index; ++i){
            const { resolveFn: resolveFn } = this.itemsToPoll[i];
            resolveFn();
        }
        this.itemsToPoll = this.itemsToPoll.slice(index + 1);
    }
    addItemToPoll(isDoneFn, resolveFn) {
        this.itemsToPoll.push({
            isDoneFn: isDoneFn,
            resolveFn: resolveFn
        });
        if (this.itemsToPoll.length > 1) // We already have a running loop that polls.
        return;
        // Start a new loop that polls.
        let scheduleFn = undefined;
        if ('setTimeoutCustom' in (0, $tdutJ.env)().platform) scheduleFn = (0, $tdutJ.env)().platform.setTimeoutCustom.bind((0, $tdutJ.env)().platform);
        (0, $lBDHD).repeatedTry(()=>{
            this.pollItems();
            // End the loop if no more items to poll.
            return this.itemsToPoll.length === 0;
        }, ()=>0, null, scheduleFn);
    }
    bindTextureToFrameBuffer(texture) {
        this.throwIfDisposed();
        $k42ZR.bindColorTextureToFramebuffer(this.gl, texture, this.framebuffer);
        if (this.debug) $k42ZR.validateFramebuffer(this.gl);
    }
    unbindTextureToFrameBuffer() {
        if (this.outputTexture != null) {
            $k42ZR.bindColorTextureToFramebuffer(this.gl, this.outputTexture, this.framebuffer);
            if (this.debug) $k42ZR.validateFramebuffer(this.gl);
        } else $k42ZR.unbindColorTextureFromFramebuffer(this.gl, this.framebuffer);
    }
    downloadMatrixDriver(texture, downloadAndDecode) {
        this.bindTextureToFrameBuffer(texture);
        const result = downloadAndDecode();
        this.unbindTextureToFrameBuffer();
        return result;
    }
    setOutputMatrixTextureDriver(outputMatrixTextureMaybePacked, width, height) {
        this.throwIfDisposed();
        const gl = this.gl;
        $k42ZR.bindColorTextureToFramebuffer(gl, outputMatrixTextureMaybePacked, this.framebuffer);
        if (this.debug) $k42ZR.validateFramebuffer(gl);
        this.outputTexture = outputMatrixTextureMaybePacked;
        $k42ZR.callAndCheck(gl, ()=>gl.viewport(0, 0, width, height));
        $k42ZR.callAndCheck(gl, ()=>gl.scissor(0, 0, width, height));
    }
    setOutputMatrixWriteRegionDriver(x, y, width, height) {
        this.throwIfDisposed();
        $k42ZR.callAndCheck(this.gl, ()=>this.gl.scissor(x, y, width, height));
    }
    throwIfDisposed() {
        if (this.disposed) throw new Error('Attempted to use disposed GPGPUContext.');
    }
    throwIfNoProgram() {
        if (this.program == null) throw new Error('No GPU program is currently set.');
    }
}
function $0d9c8bfbf4649dad$export$4a09b41294052731(arr) {
    let i = 0;
    for(; i < arr.length; ++i){
        const isDone = arr[i]();
        if (!isDone) break;
    }
    return i - 1;
}

});
parcelRegister("3DtaJ", function(module, exports) {

$parcel$export(module.exports, "createVertexShader", function () { return $2a5ba49137883786$export$4ca6704ce1875929; });
$parcel$export(module.exports, "createVertexBuffer", function () { return $2a5ba49137883786$export$8ddd35f9c5bd5634; });
$parcel$export(module.exports, "createIndexBuffer", function () { return $2a5ba49137883786$export$2be7df49658092d0; });
$parcel$export(module.exports, "getInternalFormatForFloat32MatrixTexture", function () { return $2a5ba49137883786$export$46e83db9ed4a55ec; });
$parcel$export(module.exports, "createFloat32MatrixTexture", function () { return $2a5ba49137883786$export$b6545ebc87bceaba; });
$parcel$export(module.exports, "getInternalFormatForFloat16MatrixTexture", function () { return $2a5ba49137883786$export$c3c5df7eccaed480; });
$parcel$export(module.exports, "createFloat16MatrixTexture", function () { return $2a5ba49137883786$export$3e231b7a052616c2; });
$parcel$export(module.exports, "getInternalFormatForUnsignedBytesMatrixTexture", function () { return $2a5ba49137883786$export$ed62004e3546feef; });
$parcel$export(module.exports, "createUnsignedBytesMatrixTexture", function () { return $2a5ba49137883786$export$23456bef7917c292; });
$parcel$export(module.exports, "getInternalFormatForPackedMatrixTexture", function () { return $2a5ba49137883786$export$dcae4a9709a9d6; });
$parcel$export(module.exports, "createPackedMatrixTexture", function () { return $2a5ba49137883786$export$9edab265a05c8d3a; });
$parcel$export(module.exports, "getInternalFormatForFloat16PackedMatrixTexture", function () { return $2a5ba49137883786$export$9b8d6c2b6b2037b0; });
$parcel$export(module.exports, "createFloat16PackedMatrixTexture", function () { return $2a5ba49137883786$export$9c51ae7c3160b50c; });
$parcel$export(module.exports, "bindVertexProgramAttributeStreams", function () { return $2a5ba49137883786$export$9080d84e4e2d38c9; });
$parcel$export(module.exports, "uploadDenseMatrixToTexture", function () { return $2a5ba49137883786$export$fe948dd2858cae63; });
$parcel$export(module.exports, "uploadPixelDataToTexture", function () { return $2a5ba49137883786$export$2d42c33b8625a8d7; });
$parcel$export(module.exports, "createBufferFromOutputTexture", function () { return $2a5ba49137883786$export$2983fc3c819070e9; });
$parcel$export(module.exports, "downloadFloat32MatrixFromBuffer", function () { return $2a5ba49137883786$export$3d2780ea6b3027ca; });
$parcel$export(module.exports, "downloadByteEncodedFloatMatrixFromOutputTexture", function () { return $2a5ba49137883786$export$6bc5a1ce24b8dc6c; });
$parcel$export(module.exports, "downloadPackedMatrixFromBuffer", function () { return $2a5ba49137883786$export$4fe1bc4caaf85c22; });
$parcel$export(module.exports, "downloadMatrixFromPackedOutputTexture", function () { return $2a5ba49137883786$export$7287c6a301610ce2; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");

var $8qxEr = parcelRequire("8qxEr");

var $2zyhV = parcelRequire("2zyhV");

var $k42ZR = parcelRequire("k42ZR");
function $2a5ba49137883786$export$4ca6704ce1875929(gl) {
    const glsl = (0, $8qxEr.getGlslDifferences)();
    const vertexShaderSource = `${glsl.version}
    precision highp float;
    ${glsl.attribute} vec3 clipSpacePos;
    ${glsl.attribute} vec2 uv;
    ${glsl.varyingVs} vec2 resultUV;

    void main() {
      gl_Position = vec4(clipSpacePos, 1);
      resultUV = uv;
    }`;
    return $k42ZR.createVertexShader(gl, vertexShaderSource);
}
function $2a5ba49137883786$export$8ddd35f9c5bd5634(gl) {
    // [x y z u v] * [upper-left, lower-left, upper-right, lower-right]
    const vertexArray = new Float32Array([
        -1,
        1,
        0,
        0,
        1,
        -1,
        -1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        1,
        -1,
        0,
        1,
        0
    ]);
    return $k42ZR.createStaticVertexBuffer(gl, vertexArray);
}
function $2a5ba49137883786$export$2be7df49658092d0(gl) {
    // OpenGL (and WebGL) have "CCW == front" winding
    const triangleVertexIndices = new Uint16Array([
        0,
        1,
        2,
        2,
        1,
        3
    ]);
    return $k42ZR.createStaticIndexBuffer(gl, triangleVertexIndices);
}
function $2a5ba49137883786$var$createAndConfigureTexture(gl, width, height, internalFormat, textureFormat, textureType) {
    $k42ZR.validateTextureSize(width, height);
    const texture = $k42ZR.createTexture(gl);
    const tex2d = gl.TEXTURE_2D;
    $k42ZR.callAndCheck(gl, ()=>gl.bindTexture(tex2d, texture));
    $k42ZR.callAndCheck(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE));
    $k42ZR.callAndCheck(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE));
    $k42ZR.callAndCheck(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_MIN_FILTER, gl.NEAREST));
    $k42ZR.callAndCheck(gl, ()=>gl.texParameteri(tex2d, gl.TEXTURE_MAG_FILTER, gl.NEAREST));
    if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 1) $k42ZR.callAndCheck(gl, ()=>gl.texImage2D(tex2d, 0, internalFormat, width, height, 0, textureFormat, textureType, null));
    else $k42ZR.callAndCheck(gl, ()=>gl.texStorage2D(tex2d, 1, internalFormat, width, height));
    $k42ZR.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
    return {
        texture: texture,
        texShape: [
            height,
            width
        ]
    };
}
function $2a5ba49137883786$export$46e83db9ed4a55ec(textureConfig) {
    return textureConfig.internalFormatFloat;
}
function $2a5ba49137883786$export$b6545ebc87bceaba(gl, rows, columns, textureConfig) {
    const [width, height] = $2zyhV.getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
    return $2a5ba49137883786$var$createAndConfigureTexture(gl, width, height, $2a5ba49137883786$export$46e83db9ed4a55ec(textureConfig), textureConfig.textureFormatFloat, gl.FLOAT);
}
function $2a5ba49137883786$export$c3c5df7eccaed480(textureConfig) {
    return textureConfig.internalFormatHalfFloat;
}
function $2a5ba49137883786$export$3e231b7a052616c2(gl, rows, columns, textureConfig) {
    const [width, height] = $2zyhV.getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
    return $2a5ba49137883786$var$createAndConfigureTexture(gl, width, height, $2a5ba49137883786$export$c3c5df7eccaed480(textureConfig), textureConfig.textureFormatFloat, textureConfig.textureTypeHalfFloat);
}
function $2a5ba49137883786$export$ed62004e3546feef(textureConfig) {
    return textureConfig.downloadTextureFormat;
}
function $2a5ba49137883786$export$23456bef7917c292(gl, rows, columns, textureConfig) {
    const [width, height] = $2zyhV.getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
    return $2a5ba49137883786$var$createAndConfigureTexture(gl, width, height, $2a5ba49137883786$export$ed62004e3546feef(textureConfig), gl.RGBA, gl.UNSIGNED_BYTE);
}
function $2a5ba49137883786$export$dcae4a9709a9d6(textureConfig) {
    return textureConfig.internalFormatPackedFloat;
}
function $2a5ba49137883786$export$9edab265a05c8d3a(gl, rows, columns, textureConfig) {
    const [width, height] = $2zyhV.getPackedMatrixTextureShapeWidthHeight(rows, columns);
    return $2a5ba49137883786$var$createAndConfigureTexture(gl, width, height, $2a5ba49137883786$export$dcae4a9709a9d6(textureConfig), gl.RGBA, gl.FLOAT);
}
function $2a5ba49137883786$export$9b8d6c2b6b2037b0(textureConfig) {
    return textureConfig.internalFormatPackedHalfFloat;
}
function $2a5ba49137883786$export$9c51ae7c3160b50c(gl, rows, columns, textureConfig) {
    const [width, height] = $2zyhV.getPackedMatrixTextureShapeWidthHeight(rows, columns);
    return $2a5ba49137883786$var$createAndConfigureTexture(gl, width, height, $2a5ba49137883786$export$9b8d6c2b6b2037b0(textureConfig), gl.RGBA, textureConfig.textureTypeHalfFloat);
}
function $2a5ba49137883786$export$9080d84e4e2d38c9(gl, program, vertexBuffer) {
    const posOffset = 0; // x is the first buffer element
    const uvOffset = 12; // uv comes after [x y z]
    const stride = 20; // xyz + uv, each entry is 4-byte float.
    $k42ZR.callAndCheck(gl, ()=>gl.bindBuffer(gl.ARRAY_BUFFER, vertexBuffer));
    const success = $k42ZR.bindVertexBufferToProgramAttribute(gl, program, 'clipSpacePos', vertexBuffer, 3, stride, posOffset);
    return success && $k42ZR.bindVertexBufferToProgramAttribute(gl, program, 'uv', vertexBuffer, 2, stride, uvOffset);
}
function $2a5ba49137883786$export$fe948dd2858cae63(gl, texture, width, height, data, textureConfig) {
    $k42ZR.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
    let dataForUpload, texelDataType, internalFormat;
    if (data instanceof Uint8Array) {
        dataForUpload = new Uint8Array(width * height * 4);
        texelDataType = gl.UNSIGNED_BYTE;
        internalFormat = gl.RGBA;
    } else {
        dataForUpload = new Float32Array(width * height * 4);
        texelDataType = gl.FLOAT;
        internalFormat = textureConfig.internalFormatPackedFloat;
    }
    dataForUpload.set(data);
    if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2) $k42ZR.callAndCheck(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, gl.RGBA, texelDataType, dataForUpload));
    else $k42ZR.callAndCheck(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, width, height, 0, gl.RGBA, texelDataType, dataForUpload));
    $k42ZR.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $2a5ba49137883786$export$2d42c33b8625a8d7(gl, texture, pixels) {
    $k42ZR.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, texture));
    if (pixels.data instanceof Uint8Array) {
        if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2) $k42ZR.callAndCheck(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, pixels.width, pixels.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
        else $k42ZR.callAndCheck(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, pixels.width, pixels.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels.data));
    } else if ((0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2) $k42ZR.callAndCheck(gl, ()=>gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    else $k42ZR.callAndCheck(gl, ()=>gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, pixels));
    $k42ZR.callAndCheck(gl, ()=>gl.bindTexture(gl.TEXTURE_2D, null));
}
function $2a5ba49137883786$export$2983fc3c819070e9(gl2, rows, columns, textureConfig) {
    // Create and bind the buffer.
    const buffer = gl2.createBuffer();
    $k42ZR.callAndCheck(gl2, ()=>gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer));
    // Initialize the buffer to the size of the texture in bytes.
    const bytesPerFloat = 4;
    const valuesPerTexel = 4;
    const bufferSizeBytes = bytesPerFloat * valuesPerTexel * rows * columns;
    $k42ZR.callAndCheck(gl2, ()=>gl2.bufferData(gl2.PIXEL_PACK_BUFFER, bufferSizeBytes, gl2.STREAM_READ));
    // Enqueue a command on the GPU command queue to copy of texture into the
    // buffer.
    $k42ZR.callAndCheck(gl2, ()=>gl2.readPixels(0, 0, columns, rows, gl2.RGBA, gl2.FLOAT, 0));
    $k42ZR.callAndCheck(gl2, ()=>gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null));
    return buffer;
}
function $2a5ba49137883786$export$3d2780ea6b3027ca(gl, buffer, size) {
    const gl2 = gl;
    const downloadTarget = new Float32Array(size);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
    return downloadTarget;
}
function $2a5ba49137883786$export$6bc5a1ce24b8dc6c(gl, rows, columns, textureConfig) {
    const [w, h] = $2zyhV.getUnpackedMatrixTextureShapeWidthHeight(rows, columns);
    const numChannels = 4;
    const downloadTarget = new Uint8Array($2zyhV.getUnpackedArraySizeFromMatrixSize(rows * columns, numChannels));
    $k42ZR.callAndCheck(gl, ()=>gl.readPixels(0, 0, w, h, textureConfig.downloadTextureFormat, gl.UNSIGNED_BYTE, downloadTarget));
    // By wrapping the buffer in a Float32Array, we use native browser IEEE 754
    // decoding of the 4 bytes that back each 32 bit float.
    return new Float32Array(downloadTarget.buffer);
}
function $2a5ba49137883786$export$4fe1bc4caaf85c22(gl, buffer, batch, rows, cols, physicalRows, physicalCols, textureConfig) {
    const gl2 = gl;
    const downloadTarget = new Float32Array($2zyhV.getPackedRGBAArraySizeFromMatrixShape(physicalRows, physicalCols));
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, buffer);
    gl2.getBufferSubData(gl2.PIXEL_PACK_BUFFER, 0, downloadTarget);
    gl2.bindBuffer(gl2.PIXEL_PACK_BUFFER, null);
    return downloadTarget;
}
function $2a5ba49137883786$export$7287c6a301610ce2(gl, physicalRows, physicalCols) {
    const packedRGBA = new Float32Array(physicalRows * physicalCols * 4);
    $k42ZR.callAndCheck(gl, ()=>gl.readPixels(0, 0, physicalCols, physicalRows, gl.RGBA, gl.FLOAT, packedRGBA));
    return packedRGBA;
}

});


parcelRegister("glyiU", function(module, exports) {

$parcel$export(module.exports, "addImplCPU", function () { return $be693793d2814d81$export$c7f405723b4a93e7; });
$parcel$export(module.exports, "bincountImplCPU", function () { return $be693793d2814d81$export$566def819e5d4601; });
$parcel$export(module.exports, "bincountReduceImplCPU", function () { return $be693793d2814d81$export$447b89266e53682e; });
$parcel$export(module.exports, "bitwiseAndImplCPU", function () { return $be693793d2814d81$export$b9ea48282fa3ef20; });
$parcel$export(module.exports, "castImplCPU", function () { return $be693793d2814d81$export$babf602309dd6292; });
$parcel$export(module.exports, "ceilImplCPU", function () { return $be693793d2814d81$export$bb3ce81256fe261b; });
$parcel$export(module.exports, "concatImplCPU", function () { return $be693793d2814d81$export$95e7342d25849d64; });
$parcel$export(module.exports, "equalImplCPU", function () { return $be693793d2814d81$export$13d1298222b29d06; });
$parcel$export(module.exports, "expImplCPU", function () { return $be693793d2814d81$export$f72e179c9610cb8c; });
$parcel$export(module.exports, "expm1ImplCPU", function () { return $be693793d2814d81$export$5903785c29f035f5; });
$parcel$export(module.exports, "floorImplCPU", function () { return $be693793d2814d81$export$195a28e6add8ab7e; });
$parcel$export(module.exports, "gatherNdImplCPU", function () { return $be693793d2814d81$export$e3196a12dce24214; });
$parcel$export(module.exports, "gatherV2ImplCPU", function () { return $be693793d2814d81$export$cffe0fde89e98de6; });
$parcel$export(module.exports, "greaterImplCPU", function () { return $be693793d2814d81$export$eabb8927944259dd; });
$parcel$export(module.exports, "greaterEqualImplCPU", function () { return $be693793d2814d81$export$a3d2e203d979d298; });
$parcel$export(module.exports, "lessImplCPU", function () { return $be693793d2814d81$export$74c893b3c5e74e60; });
$parcel$export(module.exports, "lessEqualImplCPU", function () { return $be693793d2814d81$export$6d1533a3ea9565f; });
$parcel$export(module.exports, "linSpaceImplCPU", function () { return $be693793d2814d81$export$c86a2be8970d7a7d; });
$parcel$export(module.exports, "logImplCPU", function () { return $be693793d2814d81$export$e88dde64a338f813; });
$parcel$export(module.exports, "maxImplCPU", function () { return $be693793d2814d81$export$a94164c9f637858e; });
$parcel$export(module.exports, "maximumImplCPU", function () { return $be693793d2814d81$export$b3afdc53a543e175; });
$parcel$export(module.exports, "minimumImplCPU", function () { return $be693793d2814d81$export$1f01be3f637863fa; });
$parcel$export(module.exports, "multiplyImplCPU", function () { return $be693793d2814d81$export$598d1d66b05a298f; });
$parcel$export(module.exports, "negImplCPU", function () { return $be693793d2814d81$export$1cbcde7624effb15; });
$parcel$export(module.exports, "notEqualImplCPU", function () { return $be693793d2814d81$export$b91372753635df24; });
$parcel$export(module.exports, "prodImplCPU", function () { return $be693793d2814d81$export$2d654219115cec80; });
$parcel$export(module.exports, "raggedGatherImplCPU", function () { return $be693793d2814d81$export$7cf38d50772f4bbc; });
$parcel$export(module.exports, "raggedRangeImplCPU", function () { return $be693793d2814d81$export$46d9d0942af5d1c2; });
$parcel$export(module.exports, "raggedTensorToTensorImplCPU", function () { return $be693793d2814d81$export$b3c4ab635ddc431f; });
$parcel$export(module.exports, "rangeImplCPU", function () { return $be693793d2814d81$export$fbee6deed7e76443; });
$parcel$export(module.exports, "rsqrtImplCPU", function () { return $be693793d2814d81$export$431ccb02913a1aee; });
$parcel$export(module.exports, "scatterImplCPU", function () { return $be693793d2814d81$export$2295c910080b5ca7; });
$parcel$export(module.exports, "sigmoidImplCPU", function () { return $be693793d2814d81$export$9b816377c2ca1f1f; });
$parcel$export(module.exports, "simpleAbsImplCPU", function () { return $be693793d2814d81$export$d7efa3585619eabe; });
$parcel$export(module.exports, "sliceImplCPU", function () { return $be693793d2814d81$export$45812d0d8578899; });
$parcel$export(module.exports, "sparseFillEmptyRowsImplCPU", function () { return $be693793d2814d81$export$6cee5fb970d08428; });
$parcel$export(module.exports, "sparseReshapeImplCPU", function () { return $be693793d2814d81$export$d17b3360054ff370; });
$parcel$export(module.exports, "sparseSegmentReductionImplCPU", function () { return $be693793d2814d81$export$a503222c03b33888; });
$parcel$export(module.exports, "sqrtImplCPU", function () { return $be693793d2814d81$export$548a22b20eeaf85b; });
$parcel$export(module.exports, "staticRegexReplaceImplCPU", function () { return $be693793d2814d81$export$b3e893e48b8d1e39; });
$parcel$export(module.exports, "stridedSliceImplCPU", function () { return $be693793d2814d81$export$efd4e188e5de0188; });
$parcel$export(module.exports, "stringNGramsImplCPU", function () { return $be693793d2814d81$export$bb9e83cb65884ef3; });
$parcel$export(module.exports, "stringSplitImplCPU", function () { return $be693793d2814d81$export$bb4b4a9a1db97dea; });
$parcel$export(module.exports, "stringToHashBucketFastImplCPU", function () { return $be693793d2814d81$export$d7d8a9bba3df6e63; });
$parcel$export(module.exports, "subImplCPU", function () { return $be693793d2814d81$export$be7474e96b733333; });
$parcel$export(module.exports, "tileImplCPU", function () { return $be693793d2814d81$export$349e02a266ab3131; });
$parcel$export(module.exports, "topKImplCPU", function () { return $be693793d2814d81$export$cc4aa6851cf96e2b; });
$parcel$export(module.exports, "transposeImplCPU", function () { return $be693793d2814d81$export$a0105d4a7143676c; });
$parcel$export(module.exports, "uniqueImplCPU", function () { return $be693793d2814d81$export$c417de669ad2e148; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Import shared functionality from tfjs-backend-cpu without triggering
// side effects.
// tslint:disable-next-line: no-imports-from-dist

var $iZJn1 = parcelRequire("iZJn1");
const { addImpl: $be693793d2814d81$export$c7f405723b4a93e7, bincountImpl: $be693793d2814d81$export$566def819e5d4601, bincountReduceImpl: $be693793d2814d81$export$447b89266e53682e, bitwiseAndImpl: $be693793d2814d81$export$b9ea48282fa3ef20, castImpl: $be693793d2814d81$export$babf602309dd6292, ceilImpl: $be693793d2814d81$export$bb3ce81256fe261b, concatImpl: $be693793d2814d81$export$95e7342d25849d64, equalImpl: $be693793d2814d81$export$13d1298222b29d06, expImpl: $be693793d2814d81$export$f72e179c9610cb8c, expm1Impl: $be693793d2814d81$export$5903785c29f035f5, floorImpl: $be693793d2814d81$export$195a28e6add8ab7e, gatherNdImpl: $be693793d2814d81$export$e3196a12dce24214, gatherV2Impl: $be693793d2814d81$export$cffe0fde89e98de6, greaterImpl: $be693793d2814d81$export$eabb8927944259dd, greaterEqualImpl: $be693793d2814d81$export$a3d2e203d979d298, lessImpl: $be693793d2814d81$export$74c893b3c5e74e60, lessEqualImpl: $be693793d2814d81$export$6d1533a3ea9565f, linSpaceImpl: $be693793d2814d81$export$c86a2be8970d7a7d, logImpl: $be693793d2814d81$export$e88dde64a338f813, maxImpl: $be693793d2814d81$export$a94164c9f637858e, maximumImpl: $be693793d2814d81$export$b3afdc53a543e175, minimumImpl: $be693793d2814d81$export$1f01be3f637863fa, multiplyImpl: $be693793d2814d81$export$598d1d66b05a298f, negImpl: $be693793d2814d81$export$1cbcde7624effb15, notEqualImpl: $be693793d2814d81$export$b91372753635df24, prodImpl: $be693793d2814d81$export$2d654219115cec80, raggedGatherImpl: $be693793d2814d81$export$7cf38d50772f4bbc, raggedRangeImpl: $be693793d2814d81$export$46d9d0942af5d1c2, raggedTensorToTensorImpl: $be693793d2814d81$export$b3c4ab635ddc431f, rangeImpl: $be693793d2814d81$export$fbee6deed7e76443, rsqrtImpl: $be693793d2814d81$export$431ccb02913a1aee, scatterImpl: $be693793d2814d81$export$2295c910080b5ca7, sigmoidImpl: $be693793d2814d81$export$9b816377c2ca1f1f, simpleAbsImpl: $be693793d2814d81$export$d7efa3585619eabe, sliceImpl: $be693793d2814d81$export$45812d0d8578899, sparseFillEmptyRowsImpl: $be693793d2814d81$export$6cee5fb970d08428, sparseReshapeImpl: $be693793d2814d81$export$d17b3360054ff370, sparseSegmentReductionImpl: $be693793d2814d81$export$a503222c03b33888, sqrtImpl: $be693793d2814d81$export$548a22b20eeaf85b, staticRegexReplaceImpl: $be693793d2814d81$export$b3e893e48b8d1e39, stridedSliceImpl: $be693793d2814d81$export$efd4e188e5de0188, stringNGramsImpl: $be693793d2814d81$export$bb9e83cb65884ef3, stringSplitImpl: $be693793d2814d81$export$bb4b4a9a1db97dea, stringToHashBucketFastImpl: $be693793d2814d81$export$d7d8a9bba3df6e63, subImpl: $be693793d2814d81$export$be7474e96b733333, tileImpl: $be693793d2814d81$export$349e02a266ab3131, topKImpl: $be693793d2814d81$export$cc4aa6851cf96e2b, transposeImpl: $be693793d2814d81$export$a0105d4a7143676c, uniqueImpl: $be693793d2814d81$export$c417de669ad2e148 } = $iZJn1;

});
parcelRegister("iZJn1", function(module, exports) {

$parcel$export(module.exports, "simpleAbsImpl", function () { return (parcelRequire("cSRnW")).simpleAbsImpl; });
$parcel$export(module.exports, "addImpl", function () { return (parcelRequire("kuzxZ")).addImpl; });
$parcel$export(module.exports, "bincountImpl", function () { return (parcelRequire("lL92y")).bincountImpl; });
$parcel$export(module.exports, "bincountReduceImpl", function () { return (parcelRequire("lL92y")).bincountReduceImpl; });
$parcel$export(module.exports, "bitwiseAndImpl", function () { return (parcelRequire("3pAeM")).bitwiseAndImpl; });
$parcel$export(module.exports, "castImpl", function () { return (parcelRequire("9IBUg")).castImpl; });
$parcel$export(module.exports, "ceilImpl", function () { return (parcelRequire("kHDCc")).ceilImpl; });
$parcel$export(module.exports, "concatImpl", function () { return (parcelRequire("kwcGR")).concatImpl; });
$parcel$export(module.exports, "equalImpl", function () { return (parcelRequire("9Gjjv")).equalImpl; });
$parcel$export(module.exports, "expImpl", function () { return (parcelRequire("a6Y9A")).expImpl; });
$parcel$export(module.exports, "expm1Impl", function () { return (parcelRequire("9G2FR")).expm1Impl; });
$parcel$export(module.exports, "floorImpl", function () { return (parcelRequire("lJgzZ")).floorImpl; });
$parcel$export(module.exports, "floorDivImpl", function () { return (parcelRequire("kjdJQ")).floorDivImpl; });
$parcel$export(module.exports, "gatherNdImpl", function () { return (parcelRequire("gZ4JZ")).gatherNdImpl; });
$parcel$export(module.exports, "gatherV2Impl", function () { return (parcelRequire("9E7lO")).gatherV2Impl; });
$parcel$export(module.exports, "greaterImpl", function () { return (parcelRequire("hfAls")).greaterImpl; });
$parcel$export(module.exports, "greaterEqualImpl", function () { return (parcelRequire("6LIWt")).greaterEqualImpl; });
$parcel$export(module.exports, "lessImpl", function () { return (parcelRequire("1y3pA")).lessImpl; });
$parcel$export(module.exports, "lessEqualImpl", function () { return (parcelRequire("gkuUa")).lessEqualImpl; });
$parcel$export(module.exports, "linSpaceImpl", function () { return (parcelRequire("kwLEl")).linSpaceImpl; });
$parcel$export(module.exports, "logImpl", function () { return (parcelRequire("9J2ld")).logImpl; });
$parcel$export(module.exports, "maxImpl", function () { return (parcelRequire("2uwJU")).maxImpl; });
$parcel$export(module.exports, "maximumImpl", function () { return (parcelRequire("cOTDj")).maximumImpl; });
$parcel$export(module.exports, "minimumImpl", function () { return (parcelRequire("gbhaU")).minimumImpl; });
$parcel$export(module.exports, "multiplyImpl", function () { return (parcelRequire("bMajv")).multiplyImpl; });
$parcel$export(module.exports, "negImpl", function () { return (parcelRequire("3iNqQ")).negImpl; });
$parcel$export(module.exports, "notEqualImpl", function () { return (parcelRequire("dSDQI")).notEqualImpl; });
$parcel$export(module.exports, "prodImpl", function () { return (parcelRequire("knCR9")).prodImpl; });
$parcel$export(module.exports, "raggedGatherImpl", function () { return (parcelRequire("4cNdG")).raggedGatherImpl; });
$parcel$export(module.exports, "raggedRangeImpl", function () { return (parcelRequire("9WmKq")).raggedRangeImpl; });
$parcel$export(module.exports, "raggedTensorToTensorImpl", function () { return (parcelRequire("6kS8g")).raggedTensorToTensorImpl; });
$parcel$export(module.exports, "rangeImpl", function () { return (parcelRequire("fWx5R")).rangeImpl; });
$parcel$export(module.exports, "rsqrtImpl", function () { return (parcelRequire("bUDnX")).rsqrtImpl; });
$parcel$export(module.exports, "scatterImpl", function () { return (parcelRequire("eI5eD")).scatterImpl; });
$parcel$export(module.exports, "sigmoidImpl", function () { return (parcelRequire("eLSm4")).sigmoidImpl; });
$parcel$export(module.exports, "sliceImpl", function () { return (parcelRequire("59DpV")).sliceImpl; });
$parcel$export(module.exports, "sparseFillEmptyRowsImpl", function () { return (parcelRequire("5GI8X")).sparseFillEmptyRowsImpl; });
$parcel$export(module.exports, "sparseReshapeImpl", function () { return (parcelRequire("h0C13")).sparseReshapeImpl; });
$parcel$export(module.exports, "sparseSegmentReductionImpl", function () { return (parcelRequire("bVemu")).sparseSegmentReductionImpl; });
$parcel$export(module.exports, "sqrtImpl", function () { return (parcelRequire("e5xGp")).sqrtImpl; });
$parcel$export(module.exports, "squaredDifferenceImpl", function () { return (parcelRequire("aIdWo")).squaredDifferenceImpl; });
$parcel$export(module.exports, "staticRegexReplaceImpl", function () { return (parcelRequire("h11VZ")).staticRegexReplaceImpl; });
$parcel$export(module.exports, "stridedSliceImpl", function () { return (parcelRequire("lxY5y")).stridedSliceImpl; });
$parcel$export(module.exports, "stringNGramsImpl", function () { return (parcelRequire("HdgEZ")).stringNGramsImpl; });
$parcel$export(module.exports, "stringSplitImpl", function () { return (parcelRequire("kir6G")).stringSplitImpl; });
$parcel$export(module.exports, "stringToHashBucketFastImpl", function () { return (parcelRequire("5vxaZ")).stringToHashBucketFastImpl; });
$parcel$export(module.exports, "subImpl", function () { return (parcelRequire("2rbI5")).subImpl; });
$parcel$export(module.exports, "tileImpl", function () { return (parcelRequire("9240Q")).tileImpl; });
$parcel$export(module.exports, "topKImpl", function () { return (parcelRequire("ksnUK")).topKImpl; });
$parcel$export(module.exports, "transposeImpl", function () { return (parcelRequire("4gkPf")).transposeImpl; });
$parcel$export(module.exports, "uniqueImpl", function () { return (parcelRequire("8pjeL")).uniqueImpl; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ // Shared functionality among backends.

var $cSRnW = parcelRequire("cSRnW");

var $kuzxZ = parcelRequire("kuzxZ");

var $lL92y = parcelRequire("lL92y");

var $3pAeM = parcelRequire("3pAeM");

var $9IBUg = parcelRequire("9IBUg");

var $kHDCc = parcelRequire("kHDCc");

var $kwcGR = parcelRequire("kwcGR");

var $9Gjjv = parcelRequire("9Gjjv");

var $a6Y9A = parcelRequire("a6Y9A");

var $9G2FR = parcelRequire("9G2FR");

var $lJgzZ = parcelRequire("lJgzZ");

var $kjdJQ = parcelRequire("kjdJQ");

var $gZ4JZ = parcelRequire("gZ4JZ");

var $9E7lO = parcelRequire("9E7lO");

var $hfAls = parcelRequire("hfAls");

var $6LIWt = parcelRequire("6LIWt");

var $1y3pA = parcelRequire("1y3pA");

var $gkuUa = parcelRequire("gkuUa");

var $kwLEl = parcelRequire("kwLEl");

var $9J2ld = parcelRequire("9J2ld");

var $2uwJU = parcelRequire("2uwJU");

var $cOTDj = parcelRequire("cOTDj");

var $gbhaU = parcelRequire("gbhaU");

var $bMajv = parcelRequire("bMajv");

var $3iNqQ = parcelRequire("3iNqQ");

var $dSDQI = parcelRequire("dSDQI");

var $knCR9 = parcelRequire("knCR9");

var $4cNdG = parcelRequire("4cNdG");

var $9WmKq = parcelRequire("9WmKq");

var $6kS8g = parcelRequire("6kS8g");

var $fWx5R = parcelRequire("fWx5R");

var $bUDnX = parcelRequire("bUDnX");

var $eI5eD = parcelRequire("eI5eD");

var $eLSm4 = parcelRequire("eLSm4");

var $59DpV = parcelRequire("59DpV");

var $5GI8X = parcelRequire("5GI8X");

var $h0C13 = parcelRequire("h0C13");

var $bVemu = parcelRequire("bVemu");

var $e5xGp = parcelRequire("e5xGp");

var $aIdWo = parcelRequire("aIdWo");

var $h11VZ = parcelRequire("h11VZ");

var $lxY5y = parcelRequire("lxY5y");

var $HdgEZ = parcelRequire("HdgEZ");

var $kir6G = parcelRequire("kir6G");

var $5vxaZ = parcelRequire("5vxaZ");

var $2rbI5 = parcelRequire("2rbI5");

var $9240Q = parcelRequire("9240Q");

var $ksnUK = parcelRequire("ksnUK");

var $4gkPf = parcelRequire("4gkPf");

var $8pjeL = parcelRequire("8pjeL");

});


parcelRegister("jC64O", function(module, exports) {

$parcel$export(module.exports, "PackProgram", function () { return $e476479bfaba12ba$export$5ebf74a9a135ce1d; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $SwRKX = parcelRequire("SwRKX");

var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $e476479bfaba12ba$export$5ebf74a9a135ce1d {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        // Only input / output 3D tensors.
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        if (this.rank === 0) this.userCode = `
        void main() {
          setOutput(vec4(getA(), 0., 0., 0.));
        }
      `;
        else {
            const channels = (0, $coLQR.getChannels)('rc', this.rank);
            const dtype = (0, $1eI1C.getCoordsDataType)(this.rank);
            const outOfBoundsCondition = this.getOutOfBoundsCondition(channels);
            const setup = this.getSetup(channels);
            const output = this.getOutput(channels);
            this.userCode = `
        void main() {
          ${dtype} rc = getOutputCoords();

          if(${outOfBoundsCondition}) {
            setOutput(vec4(0));
          } else {
            ${setup}

            setOutput(vec4(${output}));
          }
        }
      `;
        }
    }
    getSourceCoordsArr(dims) {
        const coords = [];
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++){
            let coord = `${row === 0 ? 'r' : 'rp1'}, ${col === 0 ? 'c' : 'cp1'}`;
            for(let d = 2; d < this.rank; d++)coord = `${dims[dims.length - 1 - d]},` + coord;
            coords.push(coord);
        }
        return coords;
    }
    getOutOfBoundsCondition(dims) {
        if (this.rank === 1) return `rc > ${this.enableShapeUniforms ? 'outShape' : this.outputShape[0]}`;
        let cond = '';
        for(let i = this.rank - 2; i < this.rank; i++){
            cond += `${dims[i]} >= ${this.enableShapeUniforms ? `outShape[${i}]` : this.outputShape[i]}`;
            if (i < this.rank - 1) cond += '||';
        }
        return cond;
    }
    getSetup(dims) {
        if (this.rank === 1) return '';
        const innerDims = dims.slice(-2);
        const col = this.enableShapeUniforms ? `outShape[${this.rank} - 1]` : this.outputShape[this.rank - 1];
        const row = this.enableShapeUniforms ? `outShape[${this.rank} - 2]` : this.outputShape[this.rank - 2];
        return `
      int r = ${innerDims[0]};
      int c = ${innerDims[1]};
      int rp1 = r + 1;
      int cp1 = c + 1;

      bool cEdge = cp1 >= ${col};
      bool rEdge = rp1 >= ${row};
    `;
    }
    getOutput(dims) {
        const sourceCoords = this.getSourceCoordsArr(dims);
        if (this.rank === 1) {
            const outShape = this.enableShapeUniforms ? 'outShape' : this.outputShape[0];
            return `getA(rc), (rc + 1 >= ${outShape} ? 0. : getA(rc + 1)), 0, 0`;
        }
        return `getA(${sourceCoords[0]}),
            cEdge ? 0. : getA(${sourceCoords[1]}),
            rEdge ? 0. : getA(${sourceCoords[2]}),
            rEdge || cEdge ? 0. : getA(${sourceCoords[3]})`;
    }
}

});
parcelRegister("coLQR", function(module, exports) {

$parcel$export(module.exports, "getVecChannels", function () { return $906cd84829f7196c$export$a7c2113d79df2971; });
$parcel$export(module.exports, "getChannels", function () { return $906cd84829f7196c$export$7a4d1d0d17b69972; });
$parcel$export(module.exports, "getSourceCoords", function () { return $906cd84829f7196c$export$8f96407d418c6727; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ function $906cd84829f7196c$export$a7c2113d79df2971(name, rank) {
    return [
        'x',
        'y',
        'z',
        'w',
        'u',
        'v'
    ].slice(0, rank).map((d)=>`${name}.${d}`);
}
function $906cd84829f7196c$export$7a4d1d0d17b69972(name, rank) {
    if (rank === 1) return [
        name
    ];
    return $906cd84829f7196c$export$a7c2113d79df2971(name, rank);
}
function $906cd84829f7196c$export$8f96407d418c6727(rank, dims) {
    if (rank === 1) return 'rc';
    let coords = '';
    for(let i = 0; i < rank; i++){
        coords += dims[i];
        if (i < rank - 1) coords += ',';
    }
    return coords;
}

});


parcelRegister("h6lzw", function(module, exports) {

$parcel$export(module.exports, "ReshapePackedProgram", function () { return $c733baf750228c9e$export$ce249f6fedcc44de; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $SwRKX = parcelRequire("SwRKX");

var $iR3z2 = parcelRequire("iR3z2");
class $c733baf750228c9e$export$ce249f6fedcc44de {
    constructor(outputShape, inputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'inputShape',
                type: 'ivec3'
            }
        ];
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        let mainLoop = ``;
        for(let i = 0; i < 4; i++){
            let thisRC = `thisRC = rc;`;
            if (i % 2 === 1) thisRC += `thisRC.z += 1;`;
            if (i > 1) thisRC += `thisRC.y += 1;`;
            mainLoop += `
        ${thisRC}
        ${i > 0 ? `if(thisRC.y < rows && thisRC.z < cols){` : ''}
          int flatIndex = getFlatIndex(thisRC);

          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);
          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));

          result[${i}] =
            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);
        ${i > 0 ? '}' : ''}
      `;
        }
        this.userCode = `
      ${$c733baf750228c9e$var$getReshapedInputCoords(inputShape, this.enableShapeUniforms)}
      ${this.enableShapeUniforms ? $iR3z2.getFlatIndexFrom3DOutput() : $iR3z2.getFlatIndexFrom3D(outputShape)}

      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0.);

        ivec3 thisRC;
        int rows = ${this.enableShapeUniforms ? 'outShape[1]' : outputShape[1]};
        int cols = ${this.enableShapeUniforms ? 'outShape[2]' : outputShape[2]};

        ${mainLoop}

        setOutput(result);
      }
    `;
    }
}
function $c733baf750228c9e$var$getReshapedInputCoords(shape, enableShapeUniforms) {
    const coordsFromIndexSnippet = enableShapeUniforms ? $iR3z2.getLogicalCoordinatesFromFlatIndexByUniform([
        'r',
        'c',
        'd'
    ], 'inputShape') : $iR3z2.getLogicalCoordinatesFromFlatIndex([
        'r',
        'c',
        'd'
    ], shape);
    return `
    ivec3 inputCoordsFromReshapedOutCoords(int index) {
      ${coordsFromIndexSnippet}
      return ivec3(r, c, d);
    }
  `;
}

});

parcelRegister("2re5Z", function(module, exports) {

$parcel$export(module.exports, "TextureManager", function () { return $1c690974ec3d82d6$export$337f59f8fd79d24f; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");

var $3DtaJ = parcelRequire("3DtaJ");

var $2zyhV = parcelRequire("2zyhV");
class $1c690974ec3d82d6$export$337f59f8fd79d24f {
    constructor(gpgpu){
        this.gpgpu = gpgpu;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this._numBytesAllocated = 0;
        // Number of bytes that have been allocated and available for reuse.
        this._numBytesFree = 0;
        this.freeTextures = {};
        this.usedTextures = {};
        this.logEnabled = false;
    }
    acquireTexture(shapeRC, usage, isPacked) {
        const physicalTexType = $1c690974ec3d82d6$var$getPhysicalFromLogicalTextureType(usage, isPacked);
        const shapeKey = $1c690974ec3d82d6$var$getKeyFromTextureShape(shapeRC, physicalTexType, isPacked);
        if (!(shapeKey in this.freeTextures)) this.freeTextures[shapeKey] = [];
        if (!(shapeKey in this.usedTextures)) this.usedTextures[shapeKey] = [];
        const texBytes = $1c690974ec3d82d6$export$66c19e55ce03e099(shapeRC, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
        if (this.freeTextures[shapeKey].length > 0) {
            this.numFreeTextures--;
            this.numUsedTextures++;
            this._numBytesFree -= texBytes;
            this.log();
            const newTexture = this.freeTextures[shapeKey].pop();
            this.usedTextures[shapeKey].push(newTexture);
            return newTexture;
        }
        let newTexture;
        if (physicalTexType === (0, $2zyhV.PhysicalTextureType).PACKED_2X2_FLOAT32) newTexture = this.gpgpu.createPackedMatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $2zyhV.PhysicalTextureType).PACKED_2X2_FLOAT16) newTexture = this.gpgpu.createFloat16PackedMatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $2zyhV.PhysicalTextureType).UNPACKED_FLOAT32) newTexture = this.gpgpu.createFloat32MatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $2zyhV.PhysicalTextureType).UNPACKED_FLOAT16) newTexture = this.gpgpu.createFloat16MatrixTexture(shapeRC[0], shapeRC[1]);
        else if (physicalTexType === (0, $2zyhV.PhysicalTextureType).PACKED_4X1_UNSIGNED_BYTE) newTexture = this.gpgpu.createUnsignedBytesMatrixTexture(shapeRC[0], shapeRC[1]);
        this.usedTextures[shapeKey].push(newTexture);
        this.numUsedTextures++;
        this._numBytesAllocated += texBytes;
        this.log();
        return newTexture;
    }
    releaseTexture(texture, shape, logicalTexType, isPacked) {
        if (this.freeTextures == null) // Already disposed.
        return;
        const physicalTexType = $1c690974ec3d82d6$var$getPhysicalFromLogicalTextureType(logicalTexType, isPacked);
        const shapeKey = $1c690974ec3d82d6$var$getKeyFromTextureShape(shape, physicalTexType, isPacked);
        if (!(shapeKey in this.freeTextures)) this.freeTextures[shapeKey] = [];
        const texBytes = $1c690974ec3d82d6$export$66c19e55ce03e099(shape, physicalTexType, this.gpgpu.gl, this.gpgpu.textureConfig, isPacked);
        const deleteTexThreshold = (0, $tdutJ.env)().getNumber('WEBGL_DELETE_TEXTURE_THRESHOLD');
        if (deleteTexThreshold !== -1 && this._numBytesAllocated > deleteTexThreshold) {
            this.gpgpu.deleteMatrixTexture(texture.texture);
            this._numBytesAllocated -= texBytes;
        } else {
            this.freeTextures[shapeKey].push(texture);
            this.numFreeTextures++;
            this._numBytesFree += texBytes;
        }
        this.numUsedTextures--;
        const texList = this.usedTextures[shapeKey];
        const texIndex = texList && texList.indexOf(texture);
        if (texIndex == null || texIndex < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
        texList[texIndex] = texList[texList.length - 1];
        texList.pop();
        this.log();
    }
    log() {
        if (!this.logEnabled) return;
        const total = this.numFreeTextures + this.numUsedTextures;
        console.log('Free/Used', `${this.numFreeTextures} / ${this.numUsedTextures}`, `(${total})`);
        const freeRatio = this._numBytesFree / this._numBytesAllocated;
        console.log(`Bytes allocated: ${this._numBytesAllocated}`);
        console.log(`Bytes unused: ${this._numBytesFree} (${Math.round(100 * freeRatio)}%)`);
    }
    get numBytesAllocated() {
        return this._numBytesAllocated;
    }
    get numBytesFree() {
        return this._numBytesFree;
    }
    getNumUsedTextures() {
        return this.numUsedTextures;
    }
    getNumFreeTextures() {
        return this.numFreeTextures;
    }
    dispose() {
        if (this.freeTextures == null) // Already disposed.
        return;
        for(const texShape in this.freeTextures)this.freeTextures[texShape].forEach((tex)=>{
            this.gpgpu.deleteMatrixTexture(tex.texture);
        });
        for(const texShape in this.usedTextures)this.usedTextures[texShape].forEach((tex)=>{
            this.gpgpu.deleteMatrixTexture(tex.texture);
        });
        // TODO: Assign non-null value (empty object) to textures after disposed.
        this.freeTextures = null;
        this.usedTextures = null;
        this.numUsedTextures = 0;
        this.numFreeTextures = 0;
        this._numBytesAllocated = 0;
        this._numBytesFree = 0;
    }
}
function $1c690974ec3d82d6$var$numBytesForInternalFormat(gl, internalFormat) {
    // tslint:disable-next-line:no-any
    const glany = gl;
    if (internalFormat === glany.R32F) return 4;
    else if (internalFormat === glany.R16F) return 2;
    else if (internalFormat === glany.RGBA32F) return 16;
    else if (internalFormat === gl.RGBA) return 16;
    else if (internalFormat === glany.RGBA16F) return 8;
    else if (internalFormat === glany.RGBA8) return 4;
    throw new Error(`Unknown internal format ${internalFormat}`);
}
function $1c690974ec3d82d6$export$66c19e55ce03e099(shape, physicalTexType, gl, textureConfig, isPacked) {
    // It is not possible to infer packed status from the texture type because
    // depending on the textureConfig, different  texture types may resolve to the
    // same internal format (e.g. in WebGL1, the internal format for
    // UNPACKED_FLOAT16 textures is gl.RGBA). Therefore we pass in `isPacked`
    // explicitly.
    const internalFormat = $1c690974ec3d82d6$var$internalFormatForPhysicalTexType(physicalTexType, textureConfig);
    let numElements;
    if (isPacked) {
        const [packedWidth, packedHeight] = (0, $2zyhV.getPackedMatrixTextureShapeWidthHeight)(shape[0], shape[1]);
        numElements = packedWidth * packedHeight;
    } else {
        const [width, height] = (0, $2zyhV.getUnpackedMatrixTextureShapeWidthHeight)(shape[0], shape[1]);
        numElements = width * height;
    }
    const bytesPerElement = $1c690974ec3d82d6$var$numBytesForInternalFormat(gl, internalFormat);
    return numElements * bytesPerElement;
}
function $1c690974ec3d82d6$var$internalFormatForPhysicalTexType(physicalTexType, textureConfig) {
    switch(physicalTexType){
        case (0, $2zyhV.PhysicalTextureType).PACKED_2X2_FLOAT32:
            return (0, $3DtaJ.getInternalFormatForPackedMatrixTexture)(textureConfig);
        case (0, $2zyhV.PhysicalTextureType).PACKED_2X2_FLOAT16:
            return (0, $3DtaJ.getInternalFormatForFloat16PackedMatrixTexture)(textureConfig);
        case (0, $2zyhV.PhysicalTextureType).UNPACKED_FLOAT32:
            return (0, $3DtaJ.getInternalFormatForFloat32MatrixTexture)(textureConfig);
        case (0, $2zyhV.PhysicalTextureType).UNPACKED_FLOAT16:
            return (0, $3DtaJ.getInternalFormatForFloat16MatrixTexture)(textureConfig);
        case (0, $2zyhV.PhysicalTextureType).PACKED_4X1_UNSIGNED_BYTE:
            return (0, $3DtaJ.getInternalFormatForUnsignedBytesMatrixTexture)(textureConfig);
        default:
            throw new Error(`Unknown physical texture type ${physicalTexType}`);
    }
}
function $1c690974ec3d82d6$var$getPhysicalTextureForRendering(isPacked) {
    if ((0, $tdutJ.env)().getBool('WEBGL_RENDER_FLOAT32_ENABLED')) {
        if (isPacked) return (0, $2zyhV.PhysicalTextureType).PACKED_2X2_FLOAT32;
        return (0, $2zyhV.PhysicalTextureType).UNPACKED_FLOAT32;
    }
    if (isPacked) return (0, $2zyhV.PhysicalTextureType).PACKED_2X2_FLOAT16;
    return (0, $2zyhV.PhysicalTextureType).UNPACKED_FLOAT16;
}
function $1c690974ec3d82d6$var$getPhysicalFromLogicalTextureType(logicalTexType, isPacked) {
    if (logicalTexType === (0, $2zyhV.TextureUsage).UPLOAD) return (0, $2zyhV.PhysicalTextureType).PACKED_2X2_FLOAT32;
    else if (logicalTexType === (0, $2zyhV.TextureUsage).RENDER || logicalTexType == null) return $1c690974ec3d82d6$var$getPhysicalTextureForRendering(isPacked);
    else if (logicalTexType === (0, $2zyhV.TextureUsage).DOWNLOAD || logicalTexType === (0, $2zyhV.TextureUsage).PIXELS) return (0, $2zyhV.PhysicalTextureType).PACKED_4X1_UNSIGNED_BYTE;
    throw new Error(`Unknown logical texture type ${logicalTexType}`);
}
function $1c690974ec3d82d6$var$getKeyFromTextureShape(shapeRowsCol, physicalTexType, isPacked) {
    return `${shapeRowsCol[0]}_${shapeRowsCol[1]}_${physicalTexType}_${isPacked}`;
}

});

parcelRegister("1V6Qm", function(module, exports) {

$parcel$export(module.exports, "UnaryOpProgram", function () { return $16606c4bf9008f58$export$f93811a5a466fd42; });
$parcel$export(module.exports, "CHECK_NAN_SNIPPET", function () { return $16606c4bf9008f58$export$39f0cca2b63399f6; });
$parcel$export(module.exports, "LINEAR", function () { return $16606c4bf9008f58$export$8244104593af74a6; });
$parcel$export(module.exports, "ABS", function () { return $16606c4bf9008f58$export$3f020f6dcff67a1b; });
$parcel$export(module.exports, "ELU", function () { return $16606c4bf9008f58$export$945a5ccf96adb3b2; });
$parcel$export(module.exports, "RELU", function () { return $16606c4bf9008f58$export$27041fe53e1ee6da; });
$parcel$export(module.exports, "RELU6", function () { return $16606c4bf9008f58$export$94bf29e9c85fc840; });
$parcel$export(module.exports, "CLONE", function () { return $16606c4bf9008f58$export$c07b68c109124fe2; });
$parcel$export(module.exports, "SIGMOID", function () { return $16606c4bf9008f58$export$f95dbffd98d0457a; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $SwRKX = parcelRequire("SwRKX");
class $16606c4bf9008f58$export$f93811a5a466fd42 {
    constructor(aShape, opSnippet){
        this.variableNames = [
            'A'
        ];
        this.outputShape = aShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      float unaryOperation(float x) {
        ${opSnippet}
      }

      void main() {
        float x = getAAtOutCoords();
        float y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}
const $16606c4bf9008f58$export$39f0cca2b63399f6 = `if (isnan(x)) return x;`;
const $16606c4bf9008f58$export$8244104593af74a6 = `return x;`;
const $16606c4bf9008f58$export$3f020f6dcff67a1b = `return abs(x);`;
function $16606c4bf9008f58$export$8a2ed3f7f077984e(alpha = 0.0) {
    return $16606c4bf9008f58$export$39f0cca2b63399f6 + `
    return x > 0.0 ? 1.0 : float(${alpha});
  `;
}
const $16606c4bf9008f58$export$945a5ccf96adb3b2 = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const $16606c4bf9008f58$export$27041fe53e1ee6da = $16606c4bf9008f58$export$39f0cca2b63399f6 + `
  return (x < 0.0) ? 0.0 : x;
`;
const $16606c4bf9008f58$export$94bf29e9c85fc840 = $16606c4bf9008f58$export$39f0cca2b63399f6 + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const $16606c4bf9008f58$export$c07b68c109124fe2 = 'return x;';
const $16606c4bf9008f58$export$f95dbffd98d0457a = `return 1.0 / (1.0 + exp(-1.0 * x));`;

});

parcelRegister("2s8wb", function(module, exports) {

$parcel$export(module.exports, "LINEAR", function () { return $1c94cdd32961b605$export$8244104593af74a6; });
$parcel$export(module.exports, "ELU", function () { return $1c94cdd32961b605$export$945a5ccf96adb3b2; });
$parcel$export(module.exports, "RELU", function () { return $1c94cdd32961b605$export$27041fe53e1ee6da; });
$parcel$export(module.exports, "RELU6", function () { return $1c94cdd32961b605$export$94bf29e9c85fc840; });
$parcel$export(module.exports, "SIGMOID", function () { return $1c94cdd32961b605$export$f95dbffd98d0457a; });
$parcel$export(module.exports, "UnaryOpPackedProgram", function () { return $1c94cdd32961b605$export$4d8daca4f85ed73d; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $SwRKX = parcelRequire("SwRKX");
const $1c94cdd32961b605$export$8244104593af74a6 = `return x;`;
const $1c94cdd32961b605$export$945a5ccf96adb3b2 = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const $1c94cdd32961b605$export$27041fe53e1ee6da = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $1c94cdd32961b605$export$94bf29e9c85fc840 = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $1c94cdd32961b605$export$f95dbffd98d0457a = `return 1.0 / (1.0 + exp(-1.0 * x));`;
class $1c94cdd32961b605$export$4d8daca4f85ed73d {
    constructor(aShape, opSnippet){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = aShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      vec4 unaryOperation(vec4 x) {
        ${opSnippet}
      }

      void main() {
        vec4 x = getAAtOutCoords();
        vec4 y = unaryOperation(x);

        setOutput(y);
      }
    `;
    }
}

});

parcelRegister("4uRal", function(module, exports) {

$parcel$export(module.exports, "UnpackProgram", function () { return $34633466d581898e$export$c457dd67217cb5eb; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $SwRKX = parcelRequire("SwRKX");

var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $34633466d581898e$export$c457dd67217cb5eb {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = false;
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        const rank = outputShape.length;
        const channels = (0, $coLQR.getChannels)('rc', rank);
        const dtype = (0, $1eI1C.getCoordsDataType)(rank);
        const sourceCoords = (0, $coLQR.getSourceCoords)(rank, channels);
        const innerDims = channels.slice(-2);
        const coords = rank <= 1 ? 'rc' : `vec2(${innerDims.join(',')})`;
        this.userCode = `
      void main() {
        ${dtype} rc = getOutputCoords();
        vec4 packedInput = getA(${sourceCoords});

        setOutput(getChannel(packedInput, ${coords}));
      }
    `;
    }
}

});


parcelRegister("5QpdQ", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $44155fb03ed50183$export$83d89fbfd8236492; });
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $44155fb03ed50183$export$83d89fbfd8236492 = '4.22.0';

});

parcelRegister("jsSx3", function(module, exports) {

$parcel$export(module.exports, "forceHalfFloat", function () { return $e2baeecdb62fdc88$export$3f638ed94e6c5baa; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");





function $e2baeecdb62fdc88$export$3f638ed94e6c5baa() {
    (0, $tdutJ.env)().set('WEBGL_FORCE_F16_TEXTURES', true);
}

});


parcelRegister("jDCaT", function(module, exports) {
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $fPoI0 = parcelRequire("fPoI0");

var $6mTE0 = parcelRequire("6mTE0");

var $3f7oM = parcelRequire("3f7oM");

var $dny5i = parcelRequire("dny5i");

var $coVXD = parcelRequire("coVXD");

var $fpIe8 = parcelRequire("fpIe8");

var $89xEO = parcelRequire("89xEO");

var $8FGe5 = parcelRequire("8FGe5");

var $aQhCF = parcelRequire("aQhCF");

var $aF5Pq = parcelRequire("aF5Pq");

var $lETd6 = parcelRequire("lETd6");

var $galfP = parcelRequire("galfP");

var $boKU8 = parcelRequire("boKU8");

var $01Yv5 = parcelRequire("01Yv5");

var $blZHh = parcelRequire("blZHh");

var $1OVTs = parcelRequire("1OVTs");

var $c6dnH = parcelRequire("c6dnH");

var $fPHhl = parcelRequire("fPHhl");

var $hebZ2 = parcelRequire("hebZ2");

var $ifBe2 = parcelRequire("ifBe2");

var $cV6iQ = parcelRequire("cV6iQ");

var $bPSWG = parcelRequire("bPSWG");

var $lRvHa = parcelRequire("lRvHa");

var $eFCqu = parcelRequire("eFCqu");

var $gn6ey = parcelRequire("gn6ey");

var $3AB21 = parcelRequire("3AB21");

var $i7P7l = parcelRequire("i7P7l");

var $35WUX = parcelRequire("35WUX");

var $4CTNt = parcelRequire("4CTNt");

var $6iqSX = parcelRequire("6iqSX");

var $kamKt = parcelRequire("kamKt");

var $hRABi = parcelRequire("hRABi");

var $j7Glz = parcelRequire("j7Glz");

var $eJFMQ = parcelRequire("eJFMQ");

var $8uNdK = parcelRequire("8uNdK");

var $7kR0w = parcelRequire("7kR0w");

var $9FFfP = parcelRequire("9FFfP");

var $9vESg = parcelRequire("9vESg");

var $gBPLr = parcelRequire("gBPLr");

var $9cz55 = parcelRequire("9cz55");

var $2Jg4s = parcelRequire("2Jg4s");

var $jAf7p = parcelRequire("jAf7p");

var $1HvoH = parcelRequire("1HvoH");

var $8jD8J = parcelRequire("8jD8J");

var $k6EQl = parcelRequire("k6EQl");

var $ln1JP = parcelRequire("ln1JP");

var $6rmwj = parcelRequire("6rmwj");

var $c28E9 = parcelRequire("c28E9");

var $dRubT = parcelRequire("dRubT");

var $hpX9N = parcelRequire("hpX9N");

var $4VrHD = parcelRequire("4VrHD");

var $iu4kW = parcelRequire("iu4kW");

var $bN25W = parcelRequire("bN25W");

var $jJgPs = parcelRequire("jJgPs");

var $bTvxU = parcelRequire("bTvxU");

var $6Oijd = parcelRequire("6Oijd");

var $aeVNP = parcelRequire("aeVNP");

var $h2JA1 = parcelRequire("h2JA1");

var $bHm9c = parcelRequire("bHm9c");

var $e4Jud = parcelRequire("e4Jud");

var $abjo2 = parcelRequire("abjo2");

var $jtfrV = parcelRequire("jtfrV");

var $a6gZI = parcelRequire("a6gZI");

var $jXUlf = parcelRequire("jXUlf");

var $kbbnN = parcelRequire("kbbnN");

var $ekEC3 = parcelRequire("ekEC3");

var $djtfK = parcelRequire("djtfK");

var $4ug3z = parcelRequire("4ug3z");

var $f8MZb = parcelRequire("f8MZb");

var $an1JO = parcelRequire("an1JO");

var $lVOy4 = parcelRequire("lVOy4");

var $aUf8D = parcelRequire("aUf8D");

var $84pSa = parcelRequire("84pSa");

var $7r73c = parcelRequire("7r73c");

var $1KAh7 = parcelRequire("1KAh7");

var $gyauv = parcelRequire("gyauv");

var $gSuzE = parcelRequire("gSuzE");

var $8mAVU = parcelRequire("8mAVU");

var $2LjZh = parcelRequire("2LjZh");

var $cktSR = parcelRequire("cktSR");

var $lb9yU = parcelRequire("lb9yU");

var $fAFKQ = parcelRequire("fAFKQ");

var $dZaRz = parcelRequire("dZaRz");

var $g2gcl = parcelRequire("g2gcl");

var $b1p2r = parcelRequire("b1p2r");

var $dEJ9v = parcelRequire("dEJ9v");

var $3WGve = parcelRequire("3WGve");

var $fHp2B = parcelRequire("fHp2B");

var $jbDKz = parcelRequire("jbDKz");

var $aQoth = parcelRequire("aQoth");

var $j6D3Z = parcelRequire("j6D3Z");

var $csZ3d = parcelRequire("csZ3d");

var $a1srA = parcelRequire("a1srA");

var $7CXf7 = parcelRequire("7CXf7");

var $ad9Ji = parcelRequire("ad9Ji");

var $hNUu4 = parcelRequire("hNUu4");

var $83UWs = parcelRequire("83UWs");

var $ji5Ez = parcelRequire("ji5Ez");

var $fSu9M = parcelRequire("fSu9M");

var $3NoKu = parcelRequire("3NoKu");

var $6w4nw = parcelRequire("6w4nw");

var $6RCoa = parcelRequire("6RCoa");

var $26wA9 = parcelRequire("26wA9");

var $1FWdY = parcelRequire("1FWdY");

var $05jkH = parcelRequire("05jkH");

var $6ZxUc = parcelRequire("6ZxUc");

var $kLdPP = parcelRequire("kLdPP");

var $TkopF = parcelRequire("TkopF");

var $3303z = parcelRequire("3303z");

var $8ExI5 = parcelRequire("8ExI5");

var $1JwhF = parcelRequire("1JwhF");

var $fFnU7 = parcelRequire("fFnU7");

var $esUwy = parcelRequire("esUwy");

var $nIJXn = parcelRequire("nIJXn");

var $7k8sn = parcelRequire("7k8sn");

var $DYnMj = parcelRequire("DYnMj");

var $3dQjt = parcelRequire("3dQjt");

var $aUagc = parcelRequire("aUagc");

var $DVL3y = parcelRequire("DVL3y");

var $8ZvNg = parcelRequire("8ZvNg");

var $jvLKk = parcelRequire("jvLKk");

var $3Nvei = parcelRequire("3Nvei");

var $aNJFF = parcelRequire("aNJFF");

var $eF9kq = parcelRequire("eF9kq");

var $5Fdoe = parcelRequire("5Fdoe");

var $8GNOd = parcelRequire("8GNOd");

var $k7AO2 = parcelRequire("k7AO2");

var $kN1ZG = parcelRequire("kN1ZG");

var $8rHVs = parcelRequire("8rHVs");

var $1nhJg = parcelRequire("1nhJg");

var $hEBYh = parcelRequire("hEBYh");

var $88U0s = parcelRequire("88U0s");

var $1wxSb = parcelRequire("1wxSb");

var $fj3BY = parcelRequire("fj3BY");

var $uWPTD = parcelRequire("uWPTD");

var $eLOoU = parcelRequire("eLOoU");

var $j3rx2 = parcelRequire("j3rx2");

var $bG342 = parcelRequire("bG342");

var $jSYPl = parcelRequire("jSYPl");

var $llO7x = parcelRequire("llO7x");

var $hyAtS = parcelRequire("hyAtS");

var $1cVP6 = parcelRequire("1cVP6");

var $7eL0d = parcelRequire("7eL0d");

var $5EpvY = parcelRequire("5EpvY");

var $jAESl = parcelRequire("jAESl");

var $6uqGG = parcelRequire("6uqGG");

var $7EnID = parcelRequire("7EnID");

var $71KcT = parcelRequire("71KcT");

var $a0Q6Q = parcelRequire("a0Q6Q");

var $emSRY = parcelRequire("emSRY");

var $XFubH = parcelRequire("XFubH");

var $lr1zN = parcelRequire("lr1zN");

var $8t3xP = parcelRequire("8t3xP");

var $1nMPb = parcelRequire("1nMPb");

var $2Tic5 = parcelRequire("2Tic5");

var $rGNHl = parcelRequire("rGNHl");

var $aI9ut = parcelRequire("aI9ut");

var $7x9zr = parcelRequire("7x9zr");

var $hQKEf = parcelRequire("hQKEf");

var $frWKu = parcelRequire("frWKu");

var $krsGy = parcelRequire("krsGy");

var $d7pGt = parcelRequire("d7pGt");

var $lJLGw = parcelRequire("lJLGw");

var $bKD1Y = parcelRequire("bKD1Y");

var $dQpiP = parcelRequire("dQpiP");

var $8awEX = parcelRequire("8awEX");

var $fZ5E6 = parcelRequire("fZ5E6");

var $bMbPr = parcelRequire("bMbPr");

var $39OK0 = parcelRequire("39OK0");

var $4v9Gf = parcelRequire("4v9Gf");

var $40QsG = parcelRequire("40QsG");
// List all kernel configs here
const $e4bf458b839c2500$var$kernelConfigs = [
    (0, $6mTE0._fusedMatMulConfig),
    (0, $3f7oM.absConfig),
    (0, $dny5i.acosConfig),
    (0, $coVXD.acoshConfig),
    (0, $fpIe8.addConfig),
    (0, $89xEO.addNConfig),
    (0, $8FGe5.allConfig),
    (0, $aQhCF.anyConfig),
    (0, $aF5Pq.argMaxConfig),
    (0, $lETd6.argMinConfig),
    (0, $galfP.asinConfig),
    (0, $boKU8.asinhConfig),
    (0, $01Yv5.atanConfig),
    (0, $blZHh.atan2Config),
    (0, $1OVTs.atanhConfig),
    (0, $c6dnH.avgPoolConfig),
    (0, $fPHhl.avgPool3DConfig),
    (0, $hebZ2.avgPool3DGradConfig),
    (0, $ifBe2.avgPoolGradConfig),
    (0, $cV6iQ.batchMatMulConfig),
    (0, $bPSWG.batchNormConfig),
    (0, $lRvHa.batchToSpaceNDConfig),
    (0, $eFCqu.bincountConfig),
    (0, $gn6ey.bitwiseAndConfig),
    (0, $3AB21.broadcastArgsConfig),
    (0, $i7P7l.castConfig),
    (0, $35WUX.ceilConfig),
    (0, $4CTNt.clipByValueConfig),
    (0, $6iqSX.complexConfig),
    (0, $kamKt.complexAbsConfig),
    (0, $hRABi.concatConfig),
    (0, $j7Glz.conv2DConfig),
    (0, $eJFMQ.conv2DBackpropFilterConfig),
    (0, $8uNdK.conv2DBackpropInputConfig),
    (0, $7kR0w.conv3DConfig),
    (0, $9FFfP.conv3DBackpropFilterV2Config),
    (0, $9vESg.conv3DBackpropInputConfig),
    (0, $gBPLr.cosConfig),
    (0, $9cz55.coshConfig),
    (0, $2Jg4s.cropAndResizeConfig),
    (0, $jAf7p.cumprodConfig),
    (0, $1HvoH.cumsumConfig),
    (0, $8jD8J.denseBincountConfig),
    (0, $k6EQl.depthToSpaceConfig),
    (0, $ln1JP.depthwiseConv2dNativeConfig),
    (0, $6rmwj.depthwiseConv2dNativeBackpropFilterConfig),
    (0, $c28E9.depthwiseConv2dNativeBackpropInputConfig),
    (0, $dRubT.diagConfig),
    (0, $hpX9N.dilation2DConfig),
    (0, $4VrHD.einsumConfig),
    (0, $iu4kW.eluConfig),
    (0, $bN25W.eluGradConfig),
    (0, $jJgPs.equalConfig),
    (0, $bTvxU.erfConfig),
    (0, $6Oijd.expConfig),
    (0, $aeVNP.expandDimsConfig),
    (0, $h2JA1.expm1Config),
    (0, $bHm9c.fftConfig),
    (0, $e4Jud.fillConfig),
    (0, $abjo2.flipLeftRightConfig),
    (0, $jtfrV.floorConfig),
    (0, $a6gZI.floorDivConfig),
    (0, $jXUlf.fromPixelsConfig),
    (0, $kbbnN.fusedConv2DConfig),
    (0, $ekEC3.fusedDepthwiseConv2DConfig),
    (0, $djtfK.gatherNdConfig),
    (0, $4ug3z.gatherV2Config),
    (0, $f8MZb.greaterConfig),
    (0, $an1JO.greaterEqualConfig),
    (0, $lVOy4.identityConfig),
    (0, $aUf8D.ifftConfig),
    (0, $84pSa.imagConfig),
    (0, $7r73c.isFiniteConfig),
    (0, $1KAh7.isInfConfig),
    (0, $gyauv.isNaNConfig),
    (0, $gSuzE.leakyReluConfig),
    (0, $8mAVU.lessConfig),
    (0, $2LjZh.lessEqualConfig),
    (0, $cktSR.linSpaceConfig),
    (0, $lb9yU.logConfig),
    (0, $fAFKQ.log1pConfig),
    (0, $dZaRz.logicalAndConfig),
    (0, $g2gcl.logicalNotConfig),
    (0, $b1p2r.logicalOrConfig),
    (0, $dEJ9v.LRNConfig),
    (0, $3WGve.LRNGradConfig),
    (0, $fHp2B.maxConfig),
    (0, $jbDKz.maximumConfig),
    (0, $aQoth.maxPoolConfig),
    (0, $j6D3Z.maxPool3DConfig),
    (0, $csZ3d.maxPool3DGradConfig),
    (0, $a1srA.maxPoolGradConfig),
    (0, $7CXf7.maxPoolWithArgmaxConfig),
    (0, $ad9Ji.meanConfig),
    (0, $hNUu4.minConfig),
    (0, $83UWs.minimumConfig),
    (0, $ji5Ez.mirrorPadConfig),
    (0, $fSu9M.modConfig),
    (0, $3NoKu.multinomialConfig),
    (0, $6w4nw.multiplyConfig),
    (0, $6RCoa.negConfig),
    (0, $26wA9.nonMaxSuppressionV3Config),
    (0, $1FWdY.nonMaxSuppressionV4Config),
    (0, $05jkH.nonMaxSuppressionV5Config),
    (0, $6ZxUc.notEqualConfig),
    (0, $kLdPP.oneHotConfig),
    (0, $TkopF.onesLikeConfig),
    (0, $3303z.packConfig),
    (0, $8ExI5.padV2Config),
    (0, $1JwhF.powConfig),
    (0, $fFnU7.preluConfig),
    (0, $esUwy.prodConfig),
    (0, $nIJXn.raggedGatherConfig),
    (0, $7k8sn.raggedRangeConfig),
    (0, $DYnMj.raggedTensorToTensorConfig),
    (0, $3dQjt.rangeConfig),
    (0, $aUagc.realConfig),
    (0, $DVL3y.realDivConfig),
    (0, $8ZvNg.reciprocalConfig),
    (0, $jvLKk.reluConfig),
    (0, $3Nvei.relu6Config),
    (0, $aNJFF.reshapeConfig),
    (0, $eF9kq.resizeBilinearConfig),
    (0, $5Fdoe.resizeBilinearGradConfig),
    (0, $8GNOd.resizeNearestNeighborConfig),
    (0, $k7AO2.resizeNearestNeighborGradConfig),
    (0, $kN1ZG.reverseConfig),
    (0, $8rHVs.rotateWithOffsetConfig),
    (0, $1nhJg.roundConfig),
    (0, $hEBYh.rsqrtConfig),
    (0, $88U0s.scatterNdConfig),
    (0, $1wxSb.searchSortedConfig),
    (0, $fj3BY.selectConfig),
    (0, $uWPTD.seluConfig),
    (0, $eLOoU.sigmoidConfig),
    (0, $j3rx2.signConfig),
    (0, $bG342.sinConfig),
    (0, $jSYPl.sinhConfig),
    (0, $llO7x.sliceConfig),
    (0, $hyAtS.softmaxConfig),
    (0, $1cVP6.softplusConfig),
    (0, $7eL0d.spaceToBatchNDConfig),
    (0, $5EpvY.sparseFillEmptyRowsConfig),
    (0, $jAESl.sparseReshapeConfig),
    (0, $6uqGG.sparseSegmentMeanConfig),
    (0, $7EnID.sparseSegmentSumConfig),
    (0, $71KcT.sparseToDenseConfig),
    (0, $a0Q6Q.splitVConfig),
    (0, $emSRY.sqrtConfig),
    (0, $XFubH.squareConfig),
    (0, $lr1zN.squaredDifferenceConfig),
    (0, $8t3xP.staticRegexReplaceConfig),
    (0, $1nMPb.stepConfig),
    (0, $2Tic5.stridedSliceConfig),
    (0, $rGNHl.stringNGramsConfig),
    (0, $aI9ut.stringSplitConfig),
    (0, $7x9zr.stringToHashBucketFastConfig),
    (0, $hQKEf.subConfig),
    (0, $frWKu.sumConfig),
    (0, $krsGy.tanConfig),
    (0, $d7pGt.tanhConfig),
    (0, $lJLGw.tensorScatterUpdateConfig),
    (0, $bKD1Y.tileConfig),
    (0, $dQpiP.topKConfig),
    (0, $8awEX.transformConfig),
    (0, $fZ5E6.transposeConfig),
    (0, $bMbPr.uniqueConfig),
    (0, $39OK0.unpackConfig),
    (0, $4v9Gf.unsortedSegmentSumConfig),
    (0, $40QsG.zerosLikeConfig)
];
for (const kernelConfig of $e4bf458b839c2500$var$kernelConfigs)(0, $fPoI0.registerKernel)(kernelConfig);

});
parcelRegister("6mTE0", function(module, exports) {

$parcel$export(module.exports, "_fusedMatMulConfig", function () { return $4a2ff5ec0846820d$export$f70d36da1c218f84; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $a1L4Y = parcelRequire("a1L4Y");
function $4a2ff5ec0846820d$export$d86ca0bbe0236889(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { transposeA: transposeA, transposeB: transposeB, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    return (0, $a1L4Y.batchMatMulImpl)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend,
        bias: bias,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha,
        activation: activation
    });
}
const $4a2ff5ec0846820d$export$f70d36da1c218f84 = {
    kernelName: (0, $9BGT9._FusedMatMul),
    backendName: 'webgl',
    kernelFunc: $4a2ff5ec0846820d$export$d86ca0bbe0236889
};

});
parcelRegister("a1L4Y", function(module, exports) {

$parcel$export(module.exports, "MATMUL_SHARED_DIM_THRESHOLD", function () { return $74ce84550516e931$export$42c1ddb439199e73; });
$parcel$export(module.exports, "batchMatMulImpl", function () { return $74ce84550516e931$export$d524d65e88e1168b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5mf1d = parcelRequire("5mf1d");
var $kKv2E = parcelRequire("kKv2E");
var $lBDHD = parcelRequire("lBDHD");

var $k2x5z = parcelRequire("k2x5z");

var $kX9AB = parcelRequire("kX9AB");

var $6w4nw = parcelRequire("6w4nw");

var $aNJFF = parcelRequire("aNJFF");

var $frWKu = parcelRequire("frWKu");

var $fZ5E6 = parcelRequire("fZ5E6");
const $74ce84550516e931$export$42c1ddb439199e73 = 1000;
function $74ce84550516e931$export$d524d65e88e1168b({ a: a, b: b, transposeA: transposeA, transposeB: transposeB, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    const aRank = a.shape.length;
    const bRank = b.shape.length;
    const innerShapeA = transposeA ? a.shape[aRank - 2] : a.shape[aRank - 1];
    const innerShapeB = transposeB ? b.shape[bRank - 1] : b.shape[bRank - 2];
    const outerShapeA = transposeA ? a.shape[aRank - 1] : a.shape[aRank - 2];
    const outerShapeB = transposeB ? b.shape[bRank - 2] : b.shape[bRank - 1];
    const outerDimsA = a.shape.slice(0, -2);
    const outerDimsB = b.shape.slice(0, -2);
    const batchDimA = (0, $lBDHD).sizeFromShape(outerDimsA);
    const batchDimB = (0, $lBDHD).sizeFromShape(outerDimsB);
    const outShapeOuterDims = (0, $5mf1d).assertAndGetBroadcastShape(a.shape.slice(0, -2), b.shape.slice(0, -2));
    const outShape = outShapeOuterDims.concat([
        outerShapeA,
        outerShapeB
    ]);
    (0, $lBDHD).assert(innerShapeA === innerShapeB, ()=>`Error in matMul: inner shapes (${innerShapeA}) and (` + `${innerShapeB}) of Tensors with shapes ${a.shape} and ` + `${b.shape} and transposeA=${transposeA}` + ` and transposeB=${transposeB} must match.`);
    const a3dShape = transposeA ? [
        batchDimA,
        innerShapeA,
        outerShapeA
    ] : [
        batchDimA,
        outerShapeA,
        innerShapeA
    ];
    const b3dShape = transposeB ? [
        batchDimB,
        outerShapeB,
        innerShapeB
    ] : [
        batchDimB,
        innerShapeB,
        outerShapeB
    ];
    // The rest of the implementation is designed to operate on rank-3 tensors
    const a3d = (0, $aNJFF.reshape)({
        inputs: {
            x: a
        },
        backend: backend,
        attrs: {
            shape: a3dShape
        }
    });
    const b3d = (0, $aNJFF.reshape)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            shape: b3dShape
        }
    });
    const intermediates = [
        a3d,
        b3d
    ];
    const batchDim = Math.max(batchDimA, batchDimB);
    const sharedDim = transposeA ? a3d.shape[1] : a3d.shape[2];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const fusedActivation = activation != null ? (0, $k2x5z.mapActivationToShaderProgram)(activation, true) : null;
    const containsFusedOps = hasBias || hasPreluActivationWeights || hasLeakyreluAlpha || fusedActivation != null;
    let out;
    // Since the matrices are vectors, it is faster to call mul().sum()
    // because sum() is O(sqrt(N)) due to divide-and-conquer.
    if ((outerShapeA === 1 || outerShapeB === 1) && sharedDim > $74ce84550516e931$export$42c1ddb439199e73 && containsFusedOps === false) {
        let aVec = a3d;
        let bVec = b3d;
        if (transposeA) {
            aVec = (0, $fZ5E6.transpose)({
                inputs: {
                    x: a3d
                },
                backend: backend,
                attrs: {
                    perm: [
                        0,
                        2,
                        1
                    ]
                }
            });
            intermediates.push(aVec);
        }
        if (transposeB) {
            bVec = (0, $fZ5E6.transpose)({
                inputs: {
                    x: b3d
                },
                backend: backend,
                attrs: {
                    perm: [
                        0,
                        2,
                        1
                    ]
                }
            });
            intermediates.push(bVec);
        }
        const shouldReshapeA = outerShapeB !== 1;
        const shouldReshapeB = outerShapeB === 1;
        let aVec3d = aVec;
        if (shouldReshapeA) {
            aVec3d = (0, $aNJFF.reshape)({
                inputs: {
                    x: aVec
                },
                backend: backend,
                attrs: {
                    shape: [
                        batchDim,
                        sharedDim,
                        1
                    ]
                }
            });
            intermediates.push(aVec3d);
        }
        const axis = outerShapeB === 1 ? 2 : 1;
        let bVec3d = bVec;
        if (shouldReshapeB) {
            bVec3d = (0, $aNJFF.reshape)({
                inputs: {
                    x: bVec
                },
                backend: backend,
                attrs: {
                    shape: [
                        batchDim,
                        1,
                        sharedDim
                    ]
                }
            });
            intermediates.push(bVec3d);
        }
        const product = (0, $6w4nw.multiply)({
            inputs: {
                a: aVec3d,
                b: bVec3d
            },
            backend: backend
        });
        out = (0, $frWKu.sum)({
            inputs: {
                x: product
            },
            backend: backend,
            attrs: {
                axis: axis,
                keepDims: true
            }
        });
        intermediates.push(product);
    } else {
        const dtype = (0, $kKv2E.upcastType)(a.dtype, b.dtype);
        const program = new (0, $kX9AB.MatMulPackedProgram)(a3dShape, b3dShape, [
            batchDim,
            outerShapeA,
            outerShapeB
        ], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const inputs = [
            a3d,
            b3d
        ];
        if (bias != null) inputs.push(bias);
        if (hasPreluActivationWeights) inputs.push(preluActivationWeights);
        if (hasLeakyreluAlpha) {
            const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $lBDHD).createScalarValue(leakyreluAlpha, 'float32'));
            inputs.push($leakyreluAlpha);
            intermediates.push($leakyreluAlpha);
        }
        out = backend.runWebGLProgram(program, inputs, dtype);
    }
    const outReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    intermediates.push(out);
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return outReshaped;
}

});
parcelRegister("k2x5z", function(module, exports) {

$parcel$export(module.exports, "CHECK_NAN_SNIPPET_UNARY", function () { return $e96da9523c766d0b$export$bf39b1cb254b6187; });
$parcel$export(module.exports, "unaryKernelFunc", function () { return $e96da9523c766d0b$export$ba4daf5748026fba; });
$parcel$export(module.exports, "binaryKernelFunc", function () { return $e96da9523c766d0b$export$29353c66e70e3e16; });
$parcel$export(module.exports, "mapActivationToShaderProgram", function () { return $e96da9523c766d0b$export$445d43a4039ec7b7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $kKv2E = parcelRequire("kKv2E");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");

var $6iqSX = parcelRequire("6iqSX");

var $gSuzE = parcelRequire("gSuzE");

var $fFnU7 = parcelRequire("fFnU7");

var $1V6Qm = parcelRequire("1V6Qm");

var $2s8wb = parcelRequire("2s8wb");
const $e96da9523c766d0b$export$bf39b1cb254b6187 = `if (isnan(x)) return x;`;
function $e96da9523c766d0b$export$ba4daf5748026fba({ opSnippet: opSnippet, packedOpSnippet: packedOpSnippet, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { x: x } = inputs;
        const webglBackend = backend;
        const $dtype = dtype || x.dtype;
        if (webglBackend.shouldExecuteOnCPU([
            x
        ]) && cpuKernelImpl != null) {
            const xData = webglBackend.texData.get(x.dataId);
            const outValues = cpuKernelImpl(xData.values, $dtype);
            return webglBackend.makeTensorInfo(x.shape, $dtype, outValues);
        }
        const shouldUsePackedProgram = (0, $tdutJ.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS') && packedOpSnippet != null;
        let program;
        if (shouldUsePackedProgram) program = new (0, $2s8wb.UnaryOpPackedProgram)(x.shape, packedOpSnippet);
        else program = new (0, $1V6Qm.UnaryOpProgram)(x.shape, opSnippet);
        return webglBackend.runWebGLProgram(program, [
            x
        ], $dtype);
    };
}
function $e96da9523c766d0b$export$29353c66e70e3e16({ opSnippet: opSnippet, packedOpSnippet: packedOpSnippet, checkOutOfBounds: checkOutOfBounds = false, supportsComplex: supportsComplex = false, cpuKernelImpl: cpuKernelImpl, dtype: dtype }) {
    return ({ inputs: inputs, backend: backend })=>{
        const { a: a, b: b } = inputs;
        const webglBackend = backend;
        if (supportsComplex && a.dtype === 'complex64') {
            const aData = webglBackend.texData.get(a.dataId);
            const bData = webglBackend.texData.get(b.dataId);
            const [real, imag] = [
                [
                    aData.complexTensorInfos.real,
                    bData.complexTensorInfos.real
                ],
                [
                    aData.complexTensorInfos.imag,
                    bData.complexTensorInfos.imag
                ]
            ].map((complexParts)=>{
                const [aPart, bPart] = complexParts;
                const aHandle = {
                    dataId: aPart.dataId,
                    dtype: aPart.dtype,
                    shape: a.shape
                };
                const bHandle = {
                    dataId: bPart.dataId,
                    dtype: bPart.dtype,
                    shape: b.shape
                };
                const program = new (0, $iFjfL.BinaryOpProgram)(opSnippet, a.shape, b.shape);
                return webglBackend.runWebGLProgram(program, [
                    aHandle,
                    bHandle
                ], (0, $kKv2E.upcastType)(aPart.dtype, bPart.dtype));
            });
            const complexOutput = (0, $6iqSX.complex)({
                inputs: {
                    real: real,
                    imag: imag
                },
                backend: webglBackend
            });
            webglBackend.disposeIntermediateTensorInfo(real);
            webglBackend.disposeIntermediateTensorInfo(imag);
            // TODO(annxingyuan): Implement CPU forwarding for complex inputs.
            return complexOutput;
        }
        const $dtype = dtype || (0, $kKv2E.upcastType)(a.dtype, b.dtype);
        if ((a.dtype === 'string' || b.dtype === 'string' || webglBackend.shouldExecuteOnCPU([
            a,
            b
        ])) && cpuKernelImpl != null) {
            const aVals = webglBackend.texData.get(a.dataId).values;
            const bVals = webglBackend.texData.get(b.dataId).values;
            const decodedAVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $dEVRx).fromUint8ToStringArray(aVals) : aVals;
            const decodedBVals = a.dtype === 'string' ? // tslint:disable-next-line: no-any
            (0, $dEVRx).fromUint8ToStringArray(bVals) : bVals;
            const [outValues, outShape] = cpuKernelImpl(a.shape, b.shape, decodedAVals, decodedBVals, $dtype);
            const out = webglBackend.makeTensorInfo(outShape, $dtype);
            const outData = webglBackend.texData.get(out.dataId);
            outData.values = outValues;
            return out;
        }
        const shouldUsePackedProgram = (0, $tdutJ.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') && packedOpSnippet != null;
        let program;
        if (shouldUsePackedProgram) program = new (0, $12pF4.BinaryOpPackedProgram)(packedOpSnippet, a.shape, b.shape, checkOutOfBounds);
        else program = new (0, $iFjfL.BinaryOpProgram)(opSnippet, a.shape, b.shape);
        return webglBackend.runWebGLProgram(program, [
            a,
            b
        ], $dtype);
    };
}
function $e96da9523c766d0b$export$445d43a4039ec7b7(activation, packed = false) {
    if (activation === 'linear') {
        if (packed) return $2s8wb.LINEAR;
        return $1V6Qm.LINEAR;
    } else if (activation === 'relu') {
        if (packed) return $2s8wb.RELU;
        return $1V6Qm.RELU;
    } else if (activation === 'elu') {
        if (packed) return $2s8wb.ELU;
        return $1V6Qm.ELU;
    } else if (activation === 'relu6') {
        if (packed) return $2s8wb.RELU6;
        return $1V6Qm.RELU6;
    } else if (activation === 'prelu') {
        if (packed) return 0, $fFnU7.PRELU_PACKED;
        return 0, $fFnU7.PRELU;
    } else if (activation === 'leakyrelu') {
        if (packed) return 0, $gSuzE.LEAKYRELU_PACKED;
        return 0, $gSuzE.LEAKYRELU;
    } else if (activation === 'sigmoid') {
        if (packed) return $2s8wb.SIGMOID;
        return $1V6Qm.SIGMOID;
    }
    throw new Error(`Activation ${activation} has not been implemented for the WebGL backend.`);
}

});
parcelRegister("iFjfL", function(module, exports) {

$parcel$export(module.exports, "CHECK_NAN_SNIPPET", function () { return $0381b9c49b409ad9$export$39f0cca2b63399f6; });
$parcel$export(module.exports, "BinaryOpProgram", function () { return $0381b9c49b409ad9$export$9045e9161086790b; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");

var $SwRKX = parcelRequire("SwRKX");
const $0381b9c49b409ad9$export$39f0cca2b63399f6 = `
  if (isnan(a)) return a;
  if (isnan(b)) return b;
`;
const $0381b9c49b409ad9$export$1e6d79ff8c3b3c83 = 'return (a - b) * (a - b);';
class $0381b9c49b409ad9$export$9045e9161086790b {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'A',
            'B'
        ];
        this.outputShape = (0, $dEVRx).assertAndGetBroadcastShape(aShape, bShape);
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        this.userCode = `
      float binaryOperation(float a, float b) {
        ${op}
      }

      void main() {
        float a = getAAtOutCoords();
        float b = getBAtOutCoords();
        setOutput(binaryOperation(a, b));
      }
    `;
    }
}

});

parcelRegister("12pF4", function(module, exports) {

$parcel$export(module.exports, "CHECK_NAN_SNIPPET_PACKED", function () { return $0c19e2319d787d17$export$2b4d5cee4bd7b2dd; });
$parcel$export(module.exports, "BinaryOpPackedProgram", function () { return $0c19e2319d787d17$export$7ef3bdc75c177be0; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $SwRKX = parcelRequire("SwRKX");

var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
const $0c19e2319d787d17$export$2b4d5cee4bd7b2dd = `
  result.r = isNaN.r ? NAN : result.r;
  result.g = isNaN.g ? NAN : result.g;
  result.b = isNaN.b ? NAN : result.b;
  result.a = isNaN.a ? NAN : result.a;
`;
const $0c19e2319d787d17$export$54f9164222714c69 = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const $0c19e2319d787d17$export$fd75136f014548e = `
  return vec4(notEqual(a, b));
`;
class $0c19e2319d787d17$export$7ef3bdc75c177be0 {
    constructor(op, aShape, bShape, checkOutOfBounds = false){
        this.variableNames = [
            'A',
            'B'
        ];
        this.supportsBroadcasting = true;
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = (0, $dEVRx).assertAndGetBroadcastShape(aShape, bShape);
        const rank = this.outputShape.length;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(rank);
        let checkOutOfBoundsString = '';
        if (checkOutOfBounds) {
            if (rank === 0 || (0, $lBDHD).sizeFromShape(this.outputShape) === 1) checkOutOfBoundsString = `
          result.y = 0.;
          result.z = 0.;
          result.w = 0.;
        `;
            else {
                const dtype = (0, $1eI1C.getCoordsDataType)(rank);
                checkOutOfBoundsString = `
          ${dtype} coords = getOutputCoords();
        `;
                if (rank === 1) {
                    if (this.enableShapeUniforms) checkOutOfBoundsString += `
            result.y = (coords + 1) >= outShape ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
                    else checkOutOfBoundsString += `
            result.y = (coords + 1) >= ${this.outputShape[0]} ? 0. : result.y;
            result.z = 0.;
            result.w = 0.;
          `;
                } else {
                    const channels = (0, $coLQR.getChannels)('coords', rank);
                    if (this.enableShapeUniforms) checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= outShape[${rank} - 2];
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= outShape[${rank} - 1];
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
                    else checkOutOfBoundsString += `
            bool nextRowOutOfBounds =
              (${channels[rank - 2]} + 1) >= ${this.outputShape[rank - 2]};
            bool nextColOutOfBounds =
              (${channels[rank - 1]} + 1) >= ${this.outputShape[rank - 1]};
            result.y = nextColOutOfBounds ? 0. : result.y;
            result.z = nextRowOutOfBounds ? 0. : result.z;
            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;
          `;
                }
            }
        }
        this.userCode = `
      vec4 binaryOperation(vec4 a, vec4 b) {
        ${op}
      }

      void main() {
        vec4 a = getAAtOutCoords();
        vec4 b = getBAtOutCoords();

        vec4 result = binaryOperation(a, b);
        ${checkOutOfBoundsString}

        setOutput(result);
      }
    `;
    }
}

});

parcelRegister("6iqSX", function(module, exports) {

$parcel$export(module.exports, "complex", function () { return $495947689977deff$export$83a0e34f1302825b; });
$parcel$export(module.exports, "complexConfig", function () { return $495947689977deff$export$67917f7910d27fd8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $lVOy4 = parcelRequire("lVOy4");
function $495947689977deff$export$83a0e34f1302825b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { real: real, imag: imag } = inputs;
    const complexInfo = backend.makeTensorInfo(real.shape, 'complex64');
    const complex = backend.texData.get(complexInfo.dataId);
    const realTensorInfo = (0, $lVOy4.identity)({
        inputs: {
            x: real
        },
        backend: backend
    });
    const imagTensorInfo = (0, $lVOy4.identity)({
        inputs: {
            x: imag
        },
        backend: backend
    });
    complex.complexTensorInfos = {
        real: realTensorInfo,
        imag: imagTensorInfo
    };
    return complexInfo;
}
const $495947689977deff$export$67917f7910d27fd8 = {
    kernelName: (0, $9BGT9.Complex),
    backendName: 'webgl',
    kernelFunc: $495947689977deff$export$83a0e34f1302825b
};

});
parcelRegister("lVOy4", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $ff7621bc7b89acb2$export$f0954fd7d5368655; });
$parcel$export(module.exports, "identityConfig", function () { return $ff7621bc7b89acb2$export$c426d3942537ad84; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
function $ff7621bc7b89acb2$export$f0954fd7d5368655(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    backend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: x.shape,
        dtype: x.dtype
    };
}
const $ff7621bc7b89acb2$export$c426d3942537ad84 = {
    kernelName: (0, $9BGT9.Identity),
    backendName: 'webgl',
    kernelFunc: $ff7621bc7b89acb2$export$f0954fd7d5368655
};

});


parcelRegister("gSuzE", function(module, exports) {

$parcel$export(module.exports, "LEAKYRELU", function () { return $c49967d91d891f84$export$92ed4431d8daa517; });
$parcel$export(module.exports, "LEAKYRELU_PACKED", function () { return $c49967d91d891f84$export$e86410c26dcc9bb1; });
$parcel$export(module.exports, "leakyReluConfig", function () { return $c49967d91d891f84$export$aa04ab963fdf437f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");
const $c49967d91d891f84$export$92ed4431d8daa517 = `return (a < 0.) ? b * a : a;`;
const $c49967d91d891f84$export$e86410c26dcc9bb1 = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function $c49967d91d891f84$export$23a860e40a2c6b61(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { alpha: alpha } = attrs;
    const $alpha = backend.makeTensorInfo([], 'float32', (0, $lBDHD).createScalarValue(alpha, 'float32'));
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $12pF4.BinaryOpPackedProgram)($c49967d91d891f84$export$e86410c26dcc9bb1, x.shape, $alpha.shape) : new (0, $iFjfL.BinaryOpProgram)($c49967d91d891f84$export$92ed4431d8daa517, x.shape, $alpha.shape);
    const result = backend.runWebGLProgram(program, [
        x,
        $alpha
    ], 'float32');
    backend.disposeIntermediateTensorInfo($alpha);
    return result;
}
const $c49967d91d891f84$export$aa04ab963fdf437f = {
    kernelName: (0, $9BGT9.LeakyRelu),
    backendName: 'webgl',
    kernelFunc: $c49967d91d891f84$export$23a860e40a2c6b61
};

});

parcelRegister("fFnU7", function(module, exports) {

$parcel$export(module.exports, "PRELU", function () { return $b67d3a31dffae29a$export$97f8593018a4b737; });
$parcel$export(module.exports, "PRELU_PACKED", function () { return $b67d3a31dffae29a$export$4cc182bd80c9848a; });
$parcel$export(module.exports, "preluConfig", function () { return $b67d3a31dffae29a$export$a5c4a9b694579636; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");
const $b67d3a31dffae29a$export$97f8593018a4b737 = `return (a < 0.) ? b * a : a;`;
const $b67d3a31dffae29a$export$4cc182bd80c9848a = `
  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));
  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);
`;
function $b67d3a31dffae29a$export$5882f235222e6729(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x, alpha: alpha } = inputs;
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $12pF4.BinaryOpPackedProgram)($b67d3a31dffae29a$export$4cc182bd80c9848a, x.shape, alpha.shape) : new (0, $iFjfL.BinaryOpProgram)($b67d3a31dffae29a$export$97f8593018a4b737, x.shape, alpha.shape);
    return backend.runWebGLProgram(program, [
        x,
        alpha
    ], 'float32');
}
const $b67d3a31dffae29a$export$a5c4a9b694579636 = {
    kernelName: (0, $9BGT9.Prelu),
    backendName: 'webgl',
    kernelFunc: $b67d3a31dffae29a$export$5882f235222e6729
};

});


parcelRegister("kX9AB", function(module, exports) {

$parcel$export(module.exports, "MatMulPackedProgram", function () { return $f410c197a0fe88da$export$21e5f112101779d8; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $SwRKX = parcelRequire("SwRKX");
class $f410c197a0fe88da$export$21e5f112101779d8 {
    constructor(aShape, bShape, outputShape, transposeA = false, transposeB = false, addBias = false, activation = null, hasPreluActivation = false, hasLeakyreluActivation = false){
        this.variableNames = [
            'matrixA',
            'matrixB'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        const sharedDim = transposeA ? aShape[1] : aShape[2];
        const sharedDimensionPacked = Math.ceil(sharedDim / 2);
        const aSample = transposeA ? 'i * 2, rc.y' : 'rc.y, i * 2';
        const bSample = transposeB ? 'rc.z, i * 2' : 'i * 2, rc.z';
        const aSwizzle = transposeA ? [
            'a.xxyy',
            'a.zzww'
        ] : [
            'a.xxzz',
            'a.yyww'
        ];
        const bSwizzle = transposeB ? [
            'b.xzxz',
            'b.ywyw'
        ] : [
            'b.xyxy',
            'b.zwzw'
        ];
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyreluActivation) this.variableNames.push('leakyreluAlpha');
        let batchASnippet = 'rc.x';
        let batchBSnippet = 'rc.x';
        if (aShape[0] < bShape[0]) batchASnippet = `imod(rc.x, ${aShape[0]})`;
        else if (bShape[0] < aShape[0]) batchBSnippet = `imod(rc.x, ${bShape[0]})`;
        this.userCode = `
      ${activationSnippet}
      // Don't use uniform for sharedDimensionPacked for performance.
      const float sharedDimension = ${sharedDimensionPacked}.0;

      vec4 dot2x2ARowBCol(ivec3 rc) {
        vec4 result = vec4(0);
        int batchA = ${batchASnippet};
        int batchB = ${batchBSnippet};
        for (int i = 0; i < ${sharedDimensionPacked}; i++) {
          vec4 a = getMatrixA(batchA, ${aSample});
          vec4 b = getMatrixB(batchB, ${bSample});

          // These swizzled products need to be separately added.
          // See: https://github.com/tensorflow/tfjs/issues/1735
          result += (${aSwizzle[0]} * ${bSwizzle[0]});
          result += (${aSwizzle[1]} * ${bSwizzle[1]});
        }
        return result;
      }

      void main() {
        ivec3 rc = getOutputCoords();
        vec4 result = dot2x2ARowBCol(rc);

        ${addBiasSnippet}

        ${applyActivationSnippet}

        setOutput(result);
      }
    `;
    }
}

});

parcelRegister("6w4nw", function(module, exports) {

$parcel$export(module.exports, "multiply", function () { return $4be920b6d6e833d3$export$2060d2db72cce88f; });
$parcel$export(module.exports, "multiplyConfig", function () { return $4be920b6d6e833d3$export$745576778aafee88; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $bthpE = parcelRequire("bthpE");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");

var $glyiU = parcelRequire("glyiU");

var $6iqSX = parcelRequire("6iqSX");
const $4be920b6d6e833d3$var$MUL = 'return a * b;';
function $4be920b6d6e833d3$export$2060d2db72cce88f(args) {
    const { inputs: inputs, backend: backend } = args;
    const { a: a, b: b } = inputs;
    const dtype = (0, $dEVRx).upcastType(a.dtype, b.dtype);
    if (a.dtype === 'complex64') {
        const aData = backend.texData.get(a.dataId);
        const bData = backend.texData.get(b.dataId);
        const realProgram = new (0, $bthpE.BinaryOpComplexProgram)($bthpE.COMPLEX_MULTIPLY.REAL, a.shape, b.shape);
        const imagProgram = new (0, $bthpE.BinaryOpComplexProgram)($bthpE.COMPLEX_MULTIPLY.IMAG, a.shape, b.shape);
        const inputs = [
            {
                dataId: aData.complexTensorInfos.real.dataId,
                dtype: aData.complexTensorInfos.real.dtype,
                shape: a.shape
            },
            {
                dataId: aData.complexTensorInfos.imag.dataId,
                dtype: aData.complexTensorInfos.imag.dtype,
                shape: a.shape
            },
            {
                dataId: bData.complexTensorInfos.real.dataId,
                dtype: bData.complexTensorInfos.real.dtype,
                shape: b.shape
            },
            {
                dataId: bData.complexTensorInfos.imag.dataId,
                dtype: bData.complexTensorInfos.imag.dtype,
                shape: b.shape
            }
        ];
        const realPart = backend.runWebGLProgram(realProgram, inputs, 'float32');
        const imagPart = backend.runWebGLProgram(imagProgram, inputs, 'float32');
        const complexOutput = (0, $6iqSX.complex)({
            inputs: {
                real: realPart,
                imag: imagPart
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(imagPart);
        // TODO(annxingyuan): CPU forwarding for complex inputs.
        return complexOutput;
    }
    if (backend.shouldExecuteOnCPU([
        a,
        b
    ])) {
        const aData = backend.texData.get(a.dataId);
        const bData = backend.texData.get(b.dataId);
        const [outValues, outShape] = (0, $glyiU.multiplyImplCPU)(a.shape, b.shape, aData.values, bData.values, dtype);
        const out = backend.makeTensorInfo(outShape, dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
        return out;
    }
    let program;
    if ((0, $tdutJ.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS')) program = new (0, $12pF4.BinaryOpPackedProgram)($4be920b6d6e833d3$var$MUL, a.shape, b.shape);
    else program = new (0, $iFjfL.BinaryOpProgram)($4be920b6d6e833d3$var$MUL, a.shape, b.shape);
    return backend.runWebGLProgram(program, [
        a,
        b
    ], dtype);
}
const $4be920b6d6e833d3$export$745576778aafee88 = {
    kernelName: (0, $9BGT9.Multiply),
    backendName: 'webgl',
    kernelFunc: $4be920b6d6e833d3$export$2060d2db72cce88f
};

});
parcelRegister("bthpE", function(module, exports) {

$parcel$export(module.exports, "COMPLEX_MULTIPLY", function () { return $859fe8ee0f5a1621$export$51b2b2579375d8b0; });
$parcel$export(module.exports, "BinaryOpComplexProgram", function () { return $859fe8ee0f5a1621$export$d4e4851a08b0c91; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
const $859fe8ee0f5a1621$export$51b2b2579375d8b0 = {
    REAL: 'return areal * breal - aimag * bimag;',
    IMAG: 'return areal * bimag + aimag * breal;'
};
class $859fe8ee0f5a1621$export$d4e4851a08b0c91 {
    constructor(op, aShape, bShape){
        this.variableNames = [
            'AReal',
            'AImag',
            'BReal',
            'BImag'
        ];
        this.outputShape = (0, $dEVRx).assertAndGetBroadcastShape(aShape, bShape);
        this.userCode = `
      float binaryOpComplex(
          float areal, float aimag, float breal, float bimag) {
        ${op}
      }

      void main() {
        float areal = getARealAtOutCoords();
        float aimag = getAImagAtOutCoords();
        float breal = getBRealAtOutCoords();
        float bimag = getBImagAtOutCoords();
        setOutput(binaryOpComplex(areal, aimag, breal, bimag));
      }
    `;
    }
}

});


parcelRegister("aNJFF", function(module, exports) {

$parcel$export(module.exports, "reshape", function () { return $7dd1e85351ee66eb$export$9eaad88cf88cee2b; });
$parcel$export(module.exports, "reshapeConfig", function () { return $7dd1e85351ee66eb$export$cfa02e698602aca2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $7p7u4 = parcelRequire("7p7u4");

var $k42ZR = parcelRequire("k42ZR");
function $7dd1e85351ee66eb$export$9eaad88cf88cee2b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { shape: shape } = attrs;
    const webglBackend = backend;
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const $shape = (0, $lBDHD).inferFromImplicitShape(shape, xSize);
    const $xSize = (0, $lBDHD).sizeFromShape($shape);
    (0, $lBDHD).assert(xSize === $xSize, ()=>`The new shape (${$shape}) has ${$xSize} elements and the old ` + `shape (${x.shape}) has ${xSize} elements. The new shape and old ` + `shape must have the same number of elements.`);
    const xTexData = webglBackend.texData.get(x.dataId);
    if (xTexData.isPacked && !(0, $k42ZR.isReshapeFree)(x.shape, $shape) && !(xTexData.texture !== null && (0, $k42ZR.isReshapeFree)(xTexData.shape, $shape))) return (0, $7p7u4.packedReshape)(x, $shape, webglBackend);
    webglBackend.incRef(x.dataId);
    return {
        dataId: x.dataId,
        shape: $shape,
        dtype: x.dtype
    };
}
const $7dd1e85351ee66eb$export$cfa02e698602aca2 = {
    kernelName: (0, $9BGT9.Reshape),
    backendName: 'webgl',
    kernelFunc: $7dd1e85351ee66eb$export$9eaad88cf88cee2b
};

});
parcelRegister("7p7u4", function(module, exports) {

$parcel$export(module.exports, "packedReshape", function () { return $5640ac5e18623ff0$export$2ae2c9dd4c61df98; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $h6lzw = parcelRequire("h6lzw");

var $k42ZR = parcelRequire("k42ZR");
function $5640ac5e18623ff0$export$2ae2c9dd4c61df98(input, afterShape, backend) {
    const input3DShape = [
        (0, $k42ZR.getBatchDim)(input.shape),
        ...(0, $k42ZR.getRowsCols)(input.shape)
    ];
    const input3D = {
        dtype: input.dtype,
        shape: input3DShape,
        dataId: input.dataId
    };
    const afterShapeAs3D = [
        (0, $k42ZR.getBatchDim)(afterShape),
        ...(0, $k42ZR.getRowsCols)(afterShape)
    ];
    const program = new (0, $h6lzw.ReshapePackedProgram)(afterShapeAs3D, input3DShape);
    const preventEagerUnpackingOfOutput = true;
    const customValues = [
        input3DShape
    ];
    const output = backend.runWebGLProgram(program, [
        input3D
    ], input.dtype, customValues, preventEagerUnpackingOfOutput);
    return {
        dataId: output.dataId,
        shape: afterShape,
        dtype: output.dtype
    };
}

});


parcelRegister("frWKu", function(module, exports) {

$parcel$export(module.exports, "sum", function () { return $b3f6f2ecf517d517$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "sumConfig", function () { return $b3f6f2ecf517d517$export$47edea402251c258; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $kBZK7 = parcelRequire("kBZK7");
function $b3f6f2ecf517d517$export$8a63f25cc62965f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    return (0, $kBZK7.sumImpl)(x, axis, keepDims, backend);
}
const $b3f6f2ecf517d517$export$47edea402251c258 = {
    kernelName: (0, $9BGT9.Sum),
    backendName: 'webgl',
    kernelFunc: $b3f6f2ecf517d517$export$8a63f25cc62965f1
};

});
parcelRegister("kBZK7", function(module, exports) {

$parcel$export(module.exports, "sumImpl", function () { return $f01728369d9023c9$export$c29f6d05a9b60dfa; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $kKv2E = parcelRequire("kKv2E");
var $lBDHD = parcelRequire("lBDHD");

var $5kt6u = parcelRequire("5kt6u");

var $aNJFF = parcelRequire("aNJFF");

var $c7ELT = parcelRequire("c7ELT");
function $f01728369d9023c9$export$c29f6d05a9b60dfa(x, axis, keepDims, backend) {
    const reductionIndices = axis;
    const xRank = x.shape.length;
    const origAxes = (0, $lBDHD).parseAxisParam(reductionIndices, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, xRank);
    const sumInputIsTransposed = permutedAxes != null;
    let sumInput = x;
    if (sumInputIsTransposed) {
        sumInput = (0, $c7ELT.transposeImpl)(x, permutedAxes, backend);
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, xRank);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('sum', axes, xRank);
    const [sumOutShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(sumInput.shape, axes);
    let outShape = sumOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    outShape = (0, $dEVRx).expandShapeToKeepDim(sumOutShape, origAxes);
    const inSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $aNJFF.reshape)({
        inputs: {
            x: sumInput
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const outType = (0, $kKv2E.sumOutType)(x.dtype);
    const reduced = (0, $5kt6u.reduce)(reshapedInput, outType, 'sum', backend);
    const out = (0, $aNJFF.reshape)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    if (sumInputIsTransposed) backend.disposeIntermediateTensorInfo(sumInput);
    return out;
}

});
parcelRegister("5kt6u", function(module, exports) {

$parcel$export(module.exports, "reduce", function () { return $3e15655e7812c56f$export$533b26079ad0b4b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");

var $aTVeK = parcelRequire("aTVeK");

var $7naoI = parcelRequire("7naoI");
// Returns an array of configuration objects that describe each stage of the
// reduction.
function $3e15655e7812c56f$var$getReductionStages(inShape) {
    const stages = [];
    while(stages.length === 0 || stages[stages.length - 1].outSize !== 1){
        const outSize = stages.length ? stages[stages.length - 1].outSize : inShape[1];
        const windowSize = (0, $dEVRx).computeOptimalWindowSize(outSize);
        stages.push({
            inSize: outSize,
            windowSize: windowSize,
            outSize: Math.ceil(outSize / windowSize)
        });
    }
    return stages;
}
function $3e15655e7812c56f$export$533b26079ad0b4b(x, dtype, reductionType, backend) {
    const reductionStages = $3e15655e7812c56f$var$getReductionStages(x.shape);
    let result = x;
    for(let i = 0; i < reductionStages.length; i++){
        const { inSize: inSize, windowSize: windowSize, outSize: outSize } = reductionStages[i];
        let program;
        let previousResult;
        if (reductionType === 'mean') program = i === 0 ? new (0, $aTVeK.MeanProgram)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        }, inSize) : new (0, $aTVeK.MeanProgram)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        });
        else program = new (0, $7naoI.ReduceProgram)({
            windowSize: windowSize,
            inSize: inSize,
            batchSize: x.shape[0],
            outSize: outSize
        }, reductionType);
        previousResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], dtype);
        if (previousResult.dataId !== x.dataId) backend.disposeIntermediateTensorInfo(previousResult);
    }
    return result;
}

});
parcelRegister("aTVeK", function(module, exports) {

$parcel$export(module.exports, "MeanProgram", function () { return $7efb707aafed0bab$export$a1460fd06abdca4; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");
class $7efb707aafed0bab$export$a1460fd06abdca4 {
    constructor(reduceInfo, divisor){
        this.variableNames = [
            'x'
        ];
        const { windowSize: windowSize, batchSize: batchSize, inSize: inSize, outSize: outSize } = reduceInfo;
        this.outputShape = [
            batchSize,
            outSize
        ];
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        let updateSnippet = `sumValue += dot(values, ones);`;
        if (divisor != null) {
            const denominator = 1 / divisor;
            updateSnippet = `sumValue += dot(values * ${(0, $lBDHD).isInt(denominator) ? denominator.toPrecision(2) : denominator}, ones);`;
        }
        let checkOutOfBounds = '';
        if (inSize % windowSize > 0) checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return 0.0;
        }
      `;
        this.userCode = `
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(getValue(batch, inIdx), 0.0, 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1), 0.0, 0.0);

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2), 0.0);

          ${updateSnippet}
        }
        setOutput(sumValue);
      }
    `;
    }
}

});

parcelRegister("7naoI", function(module, exports) {

$parcel$export(module.exports, "ReduceProgram", function () { return $55e2bf205d965978$export$14f07173aed228a5; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $55e2bf205d965978$export$14f07173aed228a5 {
    constructor(reduceInfo, reduceType){
        this.variableNames = [
            'x'
        ];
        const { windowSize: windowSize, batchSize: batchSize, inSize: inSize, outSize: outSize } = reduceInfo;
        this.outputShape = [
            batchSize,
            outSize
        ];
        let initializationValue = '0.0';
        let compareOp = ``;
        if (reduceType === 'prod') initializationValue = '1.0';
        else if (reduceType === 'min') {
            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
            initializationValue = '1.0 / 1e-20';
            compareOp = `min`;
        } else if (reduceType === 'max') {
            // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
            initializationValue = '-1.0 / 1e-20';
            compareOp = `max`;
        }
        let returnValue = `${reduceType}(${reduceType}(${reduceType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (reduceType === 'sum') returnValue = `sumValue`;
        else if (reduceType === 'prod') returnValue = `prodValue`;
        else if (reduceType === 'all') returnValue = `allValue`;
        else if (reduceType === 'any') returnValue = `anyValue`;
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        let updateSnippet = `
      if (${reduceType === 'sum'}) {
        sumValue += dot(values, ones);
      } else if (${reduceType === 'prod'}) {
        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);
        prodValue *= tmp[0] * tmp[1];
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
        if (${reduceType === 'min'} || ${reduceType === 'max'}) {
          minMaxValue = ${compareOp}(values, minMaxValue);
          bvec4 isNaN = isnan(values);
          if (isNaN.r || isNaN.g || isNaN.b || isNaN.a) {
            minMaxValue = vec4(NAN);
          }
        }
      }
    `;
        let vecType = `vec4`;
        if (reduceType === 'all') {
            initializationValue = '1.0';
            updateSnippet = `
        bool reducedAllValue = all(values);
        float floatedReducedAllValue = float(reducedAllValue);
        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);
      `;
            vecType = `bvec4`;
        } else if (reduceType === 'any') {
            initializationValue = '0.0';
            updateSnippet = `
        bool reducedAnyValue = any(values);
        float floatedReducedAnyValue = float(reducedAnyValue);
        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);
      `;
            vecType = `bvec4`;
        }
        let checkOutOfBounds = '';
        if (inSize % windowSize > 0) checkOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
        this.userCode = `
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float getValue(int batch, int inIdx) {
        ${checkOutOfBounds}
        return getX(batch, inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        vec4 minMaxValue = vec4(${initializationValue});
        float prodValue = 1.0;
        float sumValue = 0.0;
        float allValue = 1.0;
        float anyValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          ${vecType} values = ${vecType}(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
    }
}

});


parcelRegister("c7ELT", function(module, exports) {

$parcel$export(module.exports, "transposeImpl", function () { return $8d35c3de0e38181b$export$986b9e65182e08d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");

var $glyiU = parcelRequire("glyiU");

var $i3clQ = parcelRequire("i3clQ");

var $fh3h6 = parcelRequire("fh3h6");
function $8d35c3de0e38181b$export$986b9e65182e08d(x, perm, backend) {
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $fh3h6.TransposePackedProgram)(x.shape, perm) : new (0, $i3clQ.TransposeProgram)(x.shape, perm);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}

});
parcelRegister("i3clQ", function(module, exports) {

$parcel$export(module.exports, "TransposeProgram", function () { return $d2421689414e6650$export$e48ac6bd7e0ddfac; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $d2421689414e6650$export$e48ac6bd7e0ddfac {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(this.rank);
        const switched = $d2421689414e6650$var$getSwitchedCoords(newDim);
        this.userCode = `
    void main() {
      ${dtype} resRC = getOutputCoords();
      setOutput(getA(${switched}));
    }
    `;
    }
}
function $d2421689414e6650$var$getSwitchedCoords(newDim) {
    const rank = newDim.length;
    if (rank > 6) throw Error(`Transpose for rank ${rank} is not yet supported`);
    const originalOrder = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w',
        'resRC.u',
        'resRC.v'
    ];
    const switchedCoords = new Array(rank);
    for(let i = 0; i < newDim.length; i++)switchedCoords[newDim[i]] = originalOrder[i];
    return switchedCoords.join();
}

});

parcelRegister("fh3h6", function(module, exports) {

$parcel$export(module.exports, "TransposePackedProgram", function () { return $b1eafbd6a5dc7ceb$export$4daa0c968248fb58; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $b1eafbd6a5dc7ceb$export$4daa0c968248fb58 {
    constructor(aShape, newDim){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[newDim[i]];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        if (this.rank > 6) throw Error(`Packed transpose for rank ${this.rank} is not yet supported.`);
        const dtype = (0, $1eI1C.getCoordsDataType)(this.rank);
        const outputOrder = (0, $coLQR.getVecChannels)('rc', this.rank);
        const switchedOrder = new Array(this.rank);
        for(let i = 0; i < newDim.length; i++)switchedOrder[newDim[i]] = outputOrder[i];
        const innerDims = `vec2(${switchedOrder.slice(-2).join()})`;
        const nextColumn = `++${outputOrder[this.rank - 1]} < ${outputShape[this.rank - 1]}`;
        const getc = `getChannel(getA(${switchedOrder.join()}), ${innerDims})`;
        this.userCode = `
    void main() {
      ${dtype} rc = getOutputCoords();
      vec4 result = vec4(0.);
      result[0] = ${getc};
      if(${nextColumn}) {
        result[1] = ${getc};
      }
      --${outputOrder[this.rank - 1]};
      if(++${outputOrder[this.rank - 2]} < ${outputShape[this.rank - 2]}) {
        result[2] = ${getc};
        if(${nextColumn}) {
          result[3] = ${getc};
        }
      }
      setOutput(result);
    }
    `;
    }
}

});




parcelRegister("fZ5E6", function(module, exports) {

$parcel$export(module.exports, "transpose", function () { return $ba30eea5abe8835c$export$9cb09a71b7d66923; });
$parcel$export(module.exports, "transposeConfig", function () { return $ba30eea5abe8835c$export$895a002a39b774be; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $c7ELT = parcelRequire("c7ELT");
var $glyiU = parcelRequire("glyiU");
function $ba30eea5abe8835c$export$9cb09a71b7d66923(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { perm: perm } = attrs;
    const webglBackend = backend;
    const xRank = x.shape.length;
    const newShape = new Array(xRank);
    for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[perm[i]];
    let out;
    if (webglBackend.shouldExecuteOnCPU([
        x
    ])) {
        const xTexData = webglBackend.texData.get(x.dataId);
        const values = xTexData.values;
        const outValues = (0, $glyiU.transposeImplCPU)(values, x.shape, x.dtype, perm, newShape);
        out = webglBackend.makeTensorInfo(newShape, x.dtype);
        const outData = webglBackend.texData.get(out.dataId);
        outData.values = outValues;
    } else out = (0, $c7ELT.transposeImpl)(x, perm, webglBackend);
    return out;
}
const $ba30eea5abe8835c$export$895a002a39b774be = {
    kernelName: (0, $9BGT9.Transpose),
    backendName: 'webgl',
    kernelFunc: $ba30eea5abe8835c$export$9cb09a71b7d66923
};

});



parcelRegister("3f7oM", function(module, exports) {

$parcel$export(module.exports, "absConfig", function () { return $25c8830fbe93f7df$export$d66f48648b9d5ec7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $tdutJ = parcelRequire("tdutJ");

var $glyiU = parcelRequire("glyiU");

var $1V6Qm = parcelRequire("1V6Qm");

var $2s8wb = parcelRequire("2s8wb");
const $25c8830fbe93f7df$var$ABS = `return abs(x);`;
function $25c8830fbe93f7df$export$2335f513bbd82c6d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    // TODO: handle cases when x is complex. Once the cpu implementation
    // can handle complex values, refactor to use unaryKernelFunc.
    if (backend.shouldExecuteOnCPU([
        x
    ]) && x.dtype !== 'complex64') {
        const xData = backend.texData.get(x.dataId);
        const outValues = (0, $glyiU.simpleAbsImplCPU)(xData.values);
        return backend.makeTensorInfo(x.shape, x.dtype, outValues);
    }
    let program;
    if ((0, $tdutJ.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) program = new (0, $2s8wb.UnaryOpPackedProgram)(x.shape, $25c8830fbe93f7df$var$ABS);
    else program = new (0, $1V6Qm.UnaryOpProgram)(x.shape, $25c8830fbe93f7df$var$ABS);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $25c8830fbe93f7df$export$d66f48648b9d5ec7 = {
    kernelName: (0, $9BGT9.Abs),
    backendName: 'webgl',
    kernelFunc: $25c8830fbe93f7df$export$2335f513bbd82c6d
};

});

parcelRegister("dny5i", function(module, exports) {

$parcel$export(module.exports, "acosConfig", function () { return $9bd7dcc685469e2c$export$255826ca70737275; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $1V6Qm = parcelRequire("1V6Qm");
const $9bd7dcc685469e2c$var$ACOS = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return acos(x);
`;
const $9bd7dcc685469e2c$export$fd6306be3fde5b04 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $9bd7dcc685469e2c$var$ACOS
});
const $9bd7dcc685469e2c$export$255826ca70737275 = {
    kernelName: (0, $9BGT9.Acos),
    backendName: 'webgl',
    kernelFunc: $9bd7dcc685469e2c$export$fd6306be3fde5b04
};

});

parcelRegister("coVXD", function(module, exports) {

$parcel$export(module.exports, "acoshConfig", function () { return $9074afb96f6ba1b1$export$3f520b71a56c9e70; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $1V6Qm = parcelRequire("1V6Qm");
const $9074afb96f6ba1b1$var$ACOSH = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
  if (x < 1.0) return NAN;
return log(x + sqrt(x * x - 1.0));`;
const $9074afb96f6ba1b1$export$b26caf0f29211d08 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $9074afb96f6ba1b1$var$ACOSH
});
const $9074afb96f6ba1b1$export$3f520b71a56c9e70 = {
    kernelName: (0, $9BGT9.Acosh),
    backendName: 'webgl',
    kernelFunc: $9074afb96f6ba1b1$export$b26caf0f29211d08
};

});

parcelRegister("fpIe8", function(module, exports) {

$parcel$export(module.exports, "addConfig", function () { return $b38b7f5b0ccb3a15$export$b1f3a580afb68e4c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $b38b7f5b0ccb3a15$var$ADD = 'return a + b;';
const $b38b7f5b0ccb3a15$export$d50bf7e4980f70a9 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $b38b7f5b0ccb3a15$var$ADD,
    packedOpSnippet: $b38b7f5b0ccb3a15$var$ADD,
    supportsComplex: true,
    cpuKernelImpl: (0, $glyiU.addImplCPU)
});
const $b38b7f5b0ccb3a15$export$b1f3a580afb68e4c = {
    kernelName: (0, $9BGT9.Add),
    backendName: 'webgl',
    kernelFunc: $b38b7f5b0ccb3a15$export$d50bf7e4980f70a9
};

});

parcelRegister("89xEO", function(module, exports) {

$parcel$export(module.exports, "addNConfig", function () { return $5ef945a3f7bd6c28$export$ff8000bc6f0313e1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $tdutJ = parcelRequire("tdutJ");
var $kKv2E = parcelRequire("kKv2E");

var $CgSGI = parcelRequire("CgSGI");

var $8QCdR = parcelRequire("8QCdR");

var $lVOy4 = parcelRequire("lVOy4");
function $5ef945a3f7bd6c28$export$37b75d0026f96b8d(args) {
    const { inputs: inputs, backend: backend } = args;
    const tensors = inputs;
    if (tensors.length === 1) return (0, $lVOy4.identity)({
        inputs: {
            x: tensors[0]
        },
        backend: backend
    });
    // Limit the number of uploaded textures for optimization.
    if (tensors.length > (0, $tdutJ.env)().getNumber('WEBGL_MAX_TEXTURES_IN_SHADER')) {
        const midIndex = Math.floor(tensors.length / 2);
        const leftSide = $5ef945a3f7bd6c28$export$37b75d0026f96b8d({
            inputs: tensors.slice(0, midIndex),
            backend: backend
        });
        const rightSide = $5ef945a3f7bd6c28$export$37b75d0026f96b8d({
            inputs: tensors.slice(midIndex),
            backend: backend
        });
        return $5ef945a3f7bd6c28$export$37b75d0026f96b8d({
            inputs: [
                leftSide,
                rightSide
            ],
            backend: backend
        });
    }
    const dtype = tensors.map((t)=>t.dtype).reduce((d1, d2)=>(0, $kKv2E.upcastType)(d1, d2));
    const shapes = tensors.map((t)=>t.shape);
    // We can make sure shapes are identical in op level.
    const usePackedOp = (0, $tdutJ.env)().getBool('WEBGL_PACK');
    const program = usePackedOp ? new (0, $8QCdR.AddNPackedProgram)(tensors[0].shape, shapes) : new (0, $CgSGI.AddNProgram)(tensors[0].shape, shapes);
    return backend.runWebGLProgram(program, tensors, dtype);
}
const $5ef945a3f7bd6c28$export$ff8000bc6f0313e1 = {
    kernelName: (0, $9BGT9.AddN),
    backendName: 'webgl',
    kernelFunc: $5ef945a3f7bd6c28$export$37b75d0026f96b8d
};

});
parcelRegister("CgSGI", function(module, exports) {

$parcel$export(module.exports, "AddNProgram", function () { return $0730a4f3da30a7a8$export$9d269fc8eb4783d5; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $0730a4f3da30a7a8$export$9d269fc8eb4783d5 {
    constructor(outputShape, shapes){
        this.outputShape = [];
        this.outputShape = outputShape;
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`float v${variable} = get${variable}AtOutCoords();`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        this.userCode = `
      void main() {
        ${snippets.join('\n        ')}

        float result = ${operation};
        setOutput(result);
      }
    `;
    }
}

});

parcelRegister("8QCdR", function(module, exports) {

$parcel$export(module.exports, "AddNPackedProgram", function () { return $6710d445b03ef37a$export$156b01c0aab97d90; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $6710d445b03ef37a$export$156b01c0aab97d90 {
    constructor(outputShape, shapes){
        this.outputShape = [];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = outputShape;
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const snippets = [];
        // Get target elements from every input tensor.
        this.variableNames.forEach((variable)=>{
            snippets.push(`vec4 v${variable} = get${variable}AtOutCoords();`);
        });
        // Calculate the sum of all elements.
        const operation = this.variableNames.map((variable)=>{
            return `v${variable}`;
        }).join(' + ');
        this.userCode = `
      void main() {
        ${snippets.join('\n        ')}

        vec4 result = ${operation};
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("8FGe5", function(module, exports) {

$parcel$export(module.exports, "allConfig", function () { return $6502e84e2612b8a0$export$4e3f081eb1a330fa; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $5kt6u = parcelRequire("5kt6u");

var $aNJFF = parcelRequire("aNJFF");

var $fZ5E6 = parcelRequire("fZ5E6");
function $6502e84e2612b8a0$export$84bf76cd7afc7469(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $fZ5E6.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, xRank);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('all', axes, xRank);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const a2D = (0, $aNJFF.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $5kt6u.reduce)(a2D, a2D.dtype, 'all', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $dEVRx).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $aNJFF.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $aNJFF.reshape)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $6502e84e2612b8a0$export$4e3f081eb1a330fa = {
    kernelName: (0, $9BGT9.All),
    backendName: 'webgl',
    kernelFunc: $6502e84e2612b8a0$export$84bf76cd7afc7469
};

});

parcelRegister("aQhCF", function(module, exports) {

$parcel$export(module.exports, "anyConfig", function () { return $7e4c6e3a0d77caec$export$1a8ff634f2df3da6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $5kt6u = parcelRequire("5kt6u");

var $aNJFF = parcelRequire("aNJFF");

var $fZ5E6 = parcelRequire("fZ5E6");
function $7e4c6e3a0d77caec$export$4154a199d7d90455(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $fZ5E6.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, xRank);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('any', axes, xRank);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const a2D = (0, $aNJFF.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $5kt6u.reduce)(a2D, a2D.dtype, 'any', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $dEVRx).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $aNJFF.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $aNJFF.reshape)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $7e4c6e3a0d77caec$export$1a8ff634f2df3da6 = {
    kernelName: (0, $9BGT9.Any),
    backendName: 'webgl',
    kernelFunc: $7e4c6e3a0d77caec$export$4154a199d7d90455
};

});

parcelRegister("aF5Pq", function(module, exports) {

$parcel$export(module.exports, "argMaxConfig", function () { return $7c32411fb998894d$export$ec7419fc9ad0069e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $blLxJ = parcelRequire("blLxJ");

var $fZ5E6 = parcelRequire("fZ5E6");
function $7c32411fb998894d$export$7980a683c1b852b4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $fZ5E6.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('argMax', [
        axes[0]
    ], $x.shape.length);
    const out = (0, $blLxJ.argMinMaxReduce)(backend, $x, axes[0], 'max');
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return out;
}
const $7c32411fb998894d$export$ec7419fc9ad0069e = {
    kernelName: (0, $9BGT9.ArgMax),
    backendName: 'webgl',
    kernelFunc: $7c32411fb998894d$export$7980a683c1b852b4
};

});
parcelRegister("blLxJ", function(module, exports) {

$parcel$export(module.exports, "argMinMaxReduce", function () { return $843688ed6829efac$export$63dee7a356b9210b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $lBDHD = parcelRequire("lBDHD");

var $kl6qZ = parcelRequire("kl6qZ");

var $53sGH = parcelRequire("53sGH");

var $aNJFF = parcelRequire("aNJFF");
function $843688ed6829efac$var$argReduce(backend, x, reduceType, bestIndicesA = null) {
    let batchSize = x.shape[0];
    let inSize = x.shape[1];
    if (bestIndicesA != null) {
        batchSize = bestIndicesA.shape[0];
        inSize = bestIndicesA.shape[1];
    }
    const windowSize = (0, $dEVRx).computeOptimalWindowSize(inSize);
    const reduceInfo = {
        windowSize: windowSize,
        inSize: inSize,
        batchSize: batchSize,
        outSize: Math.ceil(inSize / windowSize)
    };
    const program = new (0, $kl6qZ.ArgMinMaxProgram)(reduceInfo, reduceType, bestIndicesA == null);
    const inputs = [
        x
    ];
    if (bestIndicesA != null) inputs.push(bestIndicesA);
    const output = backend.runWebGLProgram(program, inputs, 'int32');
    // No need to run another GPGPU program.
    if (output.shape[1] === 1) return output;
    const result = $843688ed6829efac$var$argReduce(backend, x, reduceType, output);
    backend.disposeIntermediateTensorInfo(output);
    return result;
}
function $843688ed6829efac$var$argReducePacked(backend, x, reduceType, bestIndicesA = null) {
    const inShape = bestIndicesA != null ? bestIndicesA.shape : x.shape;
    const inSize = inShape[inShape.length - 1];
    const windowSize = (0, $dEVRx).computeOptimalWindowSize(inSize);
    const program = new (0, $53sGH.ArgMinMaxPackedProgram)(inShape, windowSize, reduceType, bestIndicesA == null);
    const inputs = bestIndicesA == null ? [
        x
    ] : [
        x,
        bestIndicesA
    ];
    const output = backend.runWebGLProgram(program, inputs, 'int32');
    if (output.shape.length === x.shape.length) {
        const result = $843688ed6829efac$var$argReducePacked(backend, x, reduceType, output);
        backend.disposeIntermediateTensorInfo(output);
        return result;
    }
    return output;
}
function $843688ed6829efac$export$63dee7a356b9210b(backend, x, axis, reduceType) {
    const axes = [
        axis
    ];
    (0, $dEVRx).assertAxesAreInnerMostDims('arg' + reduceType.charAt(0).toUpperCase() + reduceType.slice(1), axes, x.shape.length);
    if (!(0, $tdutJ.env)().getBool('WEBGL_PACK_REDUCE') || x.shape.length <= 2) {
        const intermediateTensorInfos = [];
        // Eagerly unpack x input since it is passed in to all the shaders which
        // require unpacked inputs.
        const xtexData = backend.texData.get(x.dataId);
        const xIsPacked = xtexData !== null && xtexData.isPacked;
        let xUnPacked = x;
        if (xIsPacked) {
            xUnPacked = backend.unpackTensor(x);
            intermediateTensorInfos.push(xUnPacked);
        }
        const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(xUnPacked.shape, axes);
        const inSize = (0, $lBDHD).sizeFromShape(reduceShape);
        const a2D = (0, $aNJFF.reshape)({
            inputs: {
                x: xUnPacked
            },
            backend: backend,
            attrs: {
                shape: [
                    -1,
                    inSize
                ]
            }
        });
        intermediateTensorInfos.push(a2D);
        const reduced = $843688ed6829efac$var$argReduce(backend, a2D, reduceType);
        intermediateTensorInfos.push(reduced);
        const reshaped = (0, $aNJFF.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return reshaped;
    }
    return $843688ed6829efac$var$argReducePacked(backend, x, reduceType);
}

});
parcelRegister("kl6qZ", function(module, exports) {

$parcel$export(module.exports, "ArgMinMaxProgram", function () { return $eceac287a5e22f8a$export$7fa5759722b57eba; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $eceac287a5e22f8a$export$7fa5759722b57eba {
    constructor(reduceInfo, op, firstPass){
        this.variableNames = [
            'A'
        ];
        const { windowSize: windowSize, batchSize: batchSize, outSize: outSize } = reduceInfo;
        if (!firstPass) this.variableNames.push('bestIndicesA');
        this.outputShape = [
            batchSize,
            outSize
        ];
        const compOp = op === 'max' ? '>' : '<';
        const indexSnippet = firstPass ? 'inOffset + i;' : 'round(getBestIndicesA(batch, inOffset + i));';
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = outIdx * ${windowSize};

        int bestIndex = inOffset;
        float bestValue = getA(batch, bestIndex);

        for (int i = 0; i < ${windowSize}; i++) {
          int inIdx = ${indexSnippet};
          float candidate = getA(batch, inIdx);
          if (candidate ${compOp} bestValue) {
            bestValue = candidate;
            bestIndex = inIdx;
          }
        }
        setOutput(float(bestIndex));
      }
    `;
    }
}

});

parcelRegister("53sGH", function(module, exports) {

$parcel$export(module.exports, "ArgMinMaxPackedProgram", function () { return $3ae37c593ea9bf97$export$6b02cde2348cc418; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $3ae37c593ea9bf97$export$6b02cde2348cc418 {
    constructor(shape, windowSize, op, firstPass){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        (0, $lBDHD).assert(shape.length > 2, ()=>`Packed arg${op.charAt(0).toUpperCase() + op.slice(1)} supports only inputs with rank above 2.`);
        const inSize = shape[shape.length - 1];
        const outSize = Math.ceil(inSize / windowSize);
        this.outputShape = shape.slice(0, -1);
        if (outSize > 1) this.outputShape.push(outSize);
        if (!firstPass) this.variableNames.push('bestIndicesA');
        const outShape = this.outputShape;
        const rank = outShape.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(rank);
        const coords = (0, $coLQR.getChannels)('coords', rank);
        let sourceLocSetup;
        let sourceRank;
        if (outSize === 1) {
            sourceRank = rank + 1;
            const sourceLocDType = (0, $1eI1C.getCoordsDataType)(sourceRank);
            sourceLocSetup = `
        ${sourceLocDType} sourceLocR = ${sourceLocDType}(${coords.join()}, 0);
        ++${coords[rank - 1]};
        ${sourceLocDType} sourceLocG = ${sourceLocDType}(${coords.join()}, 0);
        ++${coords[rank - 2]};
        ${sourceLocDType} sourceLocA = ${sourceLocDType}(${coords.join()}, 0);
        --${coords[rank - 1]};
        ${sourceLocDType} sourceLocB = ${sourceLocDType}(${coords.join()}, 0);
        --${coords[rank - 2]};`;
        } else {
            sourceRank = rank;
            sourceLocSetup = `
        ${dtype} sourceLocR = coords;
        ++${coords[rank - 1]};
        ${dtype} sourceLocG = coords;
        ++${coords[rank - 2]};
        ${dtype} sourceLocA = coords;
        --${coords[rank - 1]};
        ${dtype} sourceLocB = coords;
        --${coords[rank - 2]};`;
        }
        const channels = [
            'x',
            'y',
            'z',
            'w',
            'u',
            'v'
        ].slice(0, sourceRank);
        const inChannel = '.' + channels[sourceRank - 1]; // e.g. ".b" for rank 3.
        const intChannels = channels.map((x)=>'int ' + x);
        const srcRCoords = (0, $coLQR.getChannels)('sourceLocR', sourceRank - 1).concat('inIdx.r');
        const srcGCoords = (0, $coLQR.getChannels)('sourceLocG', sourceRank - 1).concat('inIdx.g');
        const srcBCoords = (0, $coLQR.getChannels)('sourceLocB', sourceRank - 1).concat('inIdx.b');
        const srcACoords = (0, $coLQR.getChannels)('sourceLocA', sourceRank - 1).concat('inIdx.a');
        const compOp = op === 'max' ? 'greaterThan' : 'lessThan';
        const fetchCandidateIdx = firstPass ? '' : `
          inIdx = round(vec4(getBestIndicesAChannel(${srcRCoords.join()}),
                             getBestIndicesAChannel(${srcGCoords.join()}),
                             getBestIndicesAChannel(${srcBCoords.join()}),
                             getBestIndicesAChannel(${srcACoords.join()})));`;
        const fetchValue = `vec4(
            getAChannel(${srcRCoords.join()}),
            hasNextCol ? getAChannel(${srcGCoords.join()}) : 0.,
            hasNextRow ? getAChannel(${srcBCoords.join()}) : 0.,
            hasNextRow && hasNextCol ? getAChannel(${srcACoords.join()}) : 0.)`;
        const getBestIndicesAChannelSnippet = firstPass ? '' : `
      float getBestIndicesAChannel(${intChannels.join()}) {
        return getChannel(getBestIndicesA(${channels.join()}),
                                          vec2(${channels.slice(-2).join()}));
      }`;
        this.userCode = `
      float getAChannel(${intChannels.join()}) {
        return getChannel(getA(${channels.join()}),
                               vec2(${channels.slice(-2).join()}));
      }
      ${getBestIndicesAChannelSnippet}
      void main() {
        ${dtype} coords = getOutputCoords();
        bool hasNextCol = ${coords[rank - 1]} < ${outShape[rank - 1] - 1};
        bool hasNextRow = ${coords[rank - 2]} < ${outShape[rank - 2] - 1};
        ${sourceLocSetup}
        ivec4 srcIdx = ivec4(sourceLocR${inChannel}, sourceLocG${inChannel},
          sourceLocB${inChannel}, sourceLocA${inChannel}) * ${windowSize};
        ivec4 inIdx = srcIdx;
        vec4 bestIndex = vec4(inIdx);
        vec4 bestValue = ${fetchValue};

        for (int i = 0; i < ${windowSize}; i++) {
          inIdx = srcIdx;
          ${fetchCandidateIdx}
          vec4 candidate = ${fetchValue};
          bvec4 nan = isnan(candidate);
          bvec4 replace = bvec4(
            vec4(${compOp}(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));

          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,
                           replace.y  ? candidate.y : bestValue.y,
                           replace.z  ? candidate.z : bestValue.z,
                           replace.w  ? candidate.w : bestValue.w);
          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));
          srcIdx++;
        }
        setOutput(bestIndex);
      }
    `;
    }
}

});



parcelRegister("lETd6", function(module, exports) {

$parcel$export(module.exports, "argMinConfig", function () { return $fc48290b5c9d4032$export$21836a5e5fa09eb4; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $blLxJ = parcelRequire("blLxJ");

var $fZ5E6 = parcelRequire("fZ5E6");
function $fc48290b5c9d4032$export$ec99a91cddfb29a2(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis } = attrs;
    let axes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, x.shape.length);
    let $x = x;
    const intermediateTensorInfos = [];
    if (permutedAxes != null) {
        $x = (0, $fZ5E6.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        intermediateTensorInfos.push($x);
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, $x.shape.length);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('argMin', [
        axes[0]
    ], $x.shape.length);
    const out = (0, $blLxJ.argMinMaxReduce)(backend, $x, axes[0], 'min');
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return out;
}
const $fc48290b5c9d4032$export$21836a5e5fa09eb4 = {
    kernelName: (0, $9BGT9.ArgMin),
    backendName: 'webgl',
    kernelFunc: $fc48290b5c9d4032$export$ec99a91cddfb29a2
};

});

parcelRegister("galfP", function(module, exports) {

$parcel$export(module.exports, "asinConfig", function () { return $bc4e11313745e2bc$export$de5cb0ef95dd6700; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $1V6Qm = parcelRequire("1V6Qm");
const $bc4e11313745e2bc$var$ASIN = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
  if (abs(x) > 1.) {
    return NAN;
  }
  return asin(x);
`;
const $bc4e11313745e2bc$export$41726bdb1fc63f = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $bc4e11313745e2bc$var$ASIN
});
const $bc4e11313745e2bc$export$de5cb0ef95dd6700 = {
    kernelName: (0, $9BGT9.Asin),
    backendName: 'webgl',
    kernelFunc: $bc4e11313745e2bc$export$41726bdb1fc63f
};

});

parcelRegister("boKU8", function(module, exports) {

$parcel$export(module.exports, "asinhConfig", function () { return $84c651d288506a3f$export$20d424616c76166; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $1V6Qm = parcelRequire("1V6Qm");
const $84c651d288506a3f$var$ASINH = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `return log(x + sqrt(x * x + 1.0));`;
const $84c651d288506a3f$export$839d8a01b6af4fc0 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $84c651d288506a3f$var$ASINH
});
const $84c651d288506a3f$export$20d424616c76166 = {
    kernelName: (0, $9BGT9.Asinh),
    backendName: 'webgl',
    kernelFunc: $84c651d288506a3f$export$839d8a01b6af4fc0
};

});

parcelRegister("01Yv5", function(module, exports) {

$parcel$export(module.exports, "atanConfig", function () { return $005f06420cf624ed$export$159d632e3ff13624; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $1V6Qm = parcelRequire("1V6Qm");
const $005f06420cf624ed$var$ATAN = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
  return atan(x);
`;
const $005f06420cf624ed$export$628dc4eed22b0fbd = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $005f06420cf624ed$var$ATAN
});
const $005f06420cf624ed$export$159d632e3ff13624 = {
    kernelName: (0, $9BGT9.Atan),
    backendName: 'webgl',
    kernelFunc: $005f06420cf624ed$export$628dc4eed22b0fbd
};

});

parcelRegister("blZHh", function(module, exports) {

$parcel$export(module.exports, "atan2Config", function () { return $844183a4e0b1978d$export$c53c7ab019edb8a0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");

var $k2x5z = parcelRequire("k2x5z");
const $844183a4e0b1978d$var$ATAN2 = (0, $iFjfL.CHECK_NAN_SNIPPET) + `
  return atan(a, b);
`;
const $844183a4e0b1978d$var$ATAN2_PACKED = `
  vec4 result = atan(a, b);
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $12pF4.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $844183a4e0b1978d$export$b8b770ee6a0d9760 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $844183a4e0b1978d$var$ATAN2,
    packedOpSnippet: $844183a4e0b1978d$var$ATAN2_PACKED
});
const $844183a4e0b1978d$export$c53c7ab019edb8a0 = {
    kernelName: (0, $9BGT9.Atan2),
    backendName: 'webgl',
    kernelFunc: $844183a4e0b1978d$export$b8b770ee6a0d9760
};

});

parcelRegister("1OVTs", function(module, exports) {

$parcel$export(module.exports, "atanhConfig", function () { return $15375e61bf8a75b6$export$e9ce1ba75fc9b746; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $1V6Qm = parcelRequire("1V6Qm");
const $15375e61bf8a75b6$var$ATANH = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
  if ((x < -1.0) || (x > 1.0)) return NAN;
return (log(1.0 + x) - log(1.0 - x)) / 2.0;`;
const $15375e61bf8a75b6$export$21ea955025ceb08b = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $15375e61bf8a75b6$var$ATANH
});
const $15375e61bf8a75b6$export$e9ce1ba75fc9b746 = {
    kernelName: (0, $9BGT9.Atanh),
    backendName: 'webgl',
    kernelFunc: $15375e61bf8a75b6$export$21ea955025ceb08b
};

});

parcelRegister("c6dnH", function(module, exports) {

$parcel$export(module.exports, "avgPoolConfig", function () { return $8cf06cd639177137$export$6c901824a23e6150; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");
var $lBDHD = parcelRequire("lBDHD");

var $gfZLY = parcelRequire("gfZLY");

var $k42ZR = parcelRequire("k42ZR");

var $lVOy4 = parcelRequire("lVOy4");
function $8cf06cd639177137$export$d5c65a2abd3d97dc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $k42ZR.assertNotComplex)(x, 'avgPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $lBDHD).assert((0, $dEVRx).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in avgPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $lBDHD).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $lVOy4.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const avgPoolProgram = new (0, $gfZLY.Pool2DProgram)(convInfo, 'avg', false);
    return backend.runWebGLProgram(avgPoolProgram, [
        x
    ], 'float32');
}
const $8cf06cd639177137$export$6c901824a23e6150 = {
    kernelName: (0, $9BGT9.AvgPool),
    backendName: 'webgl',
    kernelFunc: $8cf06cd639177137$export$d5c65a2abd3d97dc
};

});
parcelRegister("gfZLY", function(module, exports) {

$parcel$export(module.exports, "Pool2DProgram", function () { return $bd5df6dcb09291de$export$ddaa65439647a5ac; });
$parcel$export(module.exports, "Pool3DProgram", function () { return $bd5df6dcb09291de$export$a835a97097fdbb0f; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $bd5df6dcb09291de$export$ddaa65439647a5ac {
    constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false){
        this.variableNames = [
            'x'
        ];
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.outputShape = convInfo.outShape;
        const isAvgPool = poolType === 'avg';
        const batchFlattenPositionStr = `((batch  * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
        const flattenPositionStr = `(xR * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + d`;
        let initializationValue = '0.0';
        if (!isAvgPool) // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
        initializationValue = '-1.0 / 1e-20';
        if (computePositions) {
            const compareOp = '>=';
            this.userCode = `
        const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
        const ivec2 pads = ivec2(${padTop}, ${padLeft});

        void main() {
          ivec4 coords = getOutputCoords();
          int batch = coords[0];
          int d = coords[3];

          ivec2 xRCCorner = coords.yz * strides - pads;
          int xRCorner = xRCCorner.x;
          int xCCorner = xRCCorner.y;

          // max/min x(?, ?, d) to get y(yR, yC, d).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;
          float avgValue = 0.0;

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              int xC = xCCorner + wC;

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float value = getX(batch, xR, xC, d);

              // If a min / max value has already been found, use it. If not,
              // use the current value.
              float currMinMaxValue = mix(
                  value, minMaxValue, minMaxValueFound);
              if (value ${compareOp} currMinMaxValue) {
                minMaxValue = value;
                minMaxValueFound = 1.0;
                minMaxPosition = ${flattenPositions ? includeBatchInIndex ? batchFlattenPositionStr : flattenPositionStr : `wR * ${effectiveFilterWidth} + wC`};
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const compareOp = 'max';
        let returnValue = `${poolType}(${poolType}(${poolType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (poolType === 'avg') returnValue = `avgValue / max(count, 1.0)`;
        const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
        const filterWidthVec4Remainder = filterWidth % 4;
        const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xR, int xC, int d) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xR, xC, d);
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d = coords[3];

        ivec2 xRCCorner = coords.yz * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // max/min x(?, ?, d) to get y(yR, yC, d).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          int xR = xRCorner + wR;

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
            int xC = xCCorner + wC * ${dilationWidth};

            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              getValue(batch, xR, xC + 3 * ${dilationWidth}, d)
            );

            ${updateSnippet}
          }

          int xC = xCCorner + ${filterWidthNearestVec4};
          if (${filterWidthVec4Remainder === 1}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              initializationValue,
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 2}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              initializationValue,
              initializationValue
            );

            ${updateSnippet}
          } else if (${filterWidthVec4Remainder === 3}) {
            vec4 values = vec4(
              getValue(batch, xR, xC, d),
              getValue(batch, xR, xC + ${dilationWidth}, d),
              getValue(batch, xR, xC + 2 * ${dilationWidth}, d),
              initializationValue
            );

            ${updateSnippet}
          }
        }
        setOutput(${returnValue});
      }
    `;
    }
}
class $bd5df6dcb09291de$export$a835a97097fdbb0f {
    constructor(convInfo, poolType, computePositions, flattenPositions = false, includeBatchInIndex = false){
        this.variableNames = [
            'x'
        ];
        if (poolType === 'avg' && computePositions) throw new Error('Cannot compute positions for average pool.');
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.outputShape = convInfo.outShape;
        const isAvgPool = poolType === 'avg';
        let initializationValue = '0.0';
        if (!isAvgPool) // WebGL on Firefox Linux can't compile 1/0 so we do 1/eps.
        initializationValue = '-1.0 / 1e-20';
        if (computePositions) {
            const compareOp = '>=';
            this.userCode = `
        const ivec3 strides =
            ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
        const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

        void main() {
          ivec5 coords = getOutputCoords();
          int batch = coords.x;
          int ch = coords.u;

          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
          int xDCorner = xCorner.x;
          int xRCorner = xCorner.y;
          int xCCorner = xCorner.z;

          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).
          // ? = to be determined
          float minMaxValue = 0.0;
          float minMaxValueFound = 0.0;
          int minMaxPosition = 0;

          for (int wD = 0; wD < ${effectiveFilterDepth};
              wD += ${dilationDepth}) {
            int xD = xDCorner + wD;

            if (xD < 0 || xD >= ${convInfo.inDepth}) {
              continue;
            }

            for (int wR = 0; wR < ${effectiveFilterHeight};
                wR += ${dilationHeight}) {
              int xR = xRCorner + wR;

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int wC = 0; wC < ${effectiveFilterWidth};
                  wC += ${dilationWidth}) {
                int xC = xCCorner + wC;

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float value = getX(batch, xD, xR, xC, ch);

                // If a min / max value has already been found, use it. If not,
                // use the current value.
                float currMinMaxValue = mix(
                    value, minMaxValue, minMaxValueFound);
                if (value ${compareOp} currMinMaxValue) {
                  minMaxValue = value;
                  minMaxValueFound = 1.0;
                  minMaxPosition = ${flattenPositions ? includeBatchInIndex ? `(((batch * ${convInfo.inDepth} + xD) * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `((xD * ${convInfo.inHeight} + xR) * ${convInfo.inWidth} + xC) * ${convInfo.inChannels} + ch` : `wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                      wR * ${effectiveFilterWidth} + wC`};
                }
              }
            }
          }
          setOutput(float(minMaxPosition));
        }
      `;
            return;
        }
        const compareOp = 'max';
        let returnValue = `${poolType}(${poolType}(${poolType}(` + 'minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])';
        if (poolType === 'avg') // Use `max(count, 1.0)` instead of `count` in case count === 0.0.
        // If count === 0.0, `avgValue` is always 0.0 and we change `count`'s
        // value to avoid dividing zero.
        returnValue = `avgValue / max(count, 1.0)`;
        const filterWidthNearestVec4 = Math.floor(filterWidth / 4) * 4;
        const filterWidthVec4Remainder = filterWidth % 4;
        const updateSnippet = `
      if (${isAvgPool}) {
        avgValue += dot(values, ones);
      } else {
        minMaxValue = ${compareOp}(values, minMaxValue);
      }
    `;
        this.userCode = `
      const ivec3 strides =
        ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float initializationValue = ${initializationValue};
      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);

      float count = 0.0;

      float getValue(int batch, int xD, int xR, int xC, int ch) {
        if (xC < 0 || xC >= ${convInfo.inWidth}) {
          return initializationValue;
        }
        count += 1.0;
        return getX(batch, xD, xR, xC, ch);
      }

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xDCorner = xCorner.x;
        int xRCorner = xCorner.y;
        int xCCorner = xCorner.z;

        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).
        // ? = to be determined
        vec4 minMaxValue = vec4(${initializationValue});
        float avgValue = 0.0;
        count = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          int xD = xDCorner + wD;

          if (xD < 0 || xD >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
            int xR = xRCorner + wR;

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidthNearestVec4}; wC += 4) {
              int xC = xCCorner + wC * ${dilationWidth};

              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 3 * ${dilationWidth}, ch)
              );

              ${updateSnippet}
            }

            int xC = xCCorner + ${filterWidthNearestVec4};
            if (${filterWidthVec4Remainder === 1}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                initializationValue,
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 2}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                initializationValue,
                initializationValue
              );

              ${updateSnippet}
            } else if (${filterWidthVec4Remainder === 3}) {
              vec4 values = vec4(
                getValue(batch, xD, xR, xC, ch),
                getValue(batch, xD, xR, xC + ${dilationWidth}, ch),
                getValue(batch, xD, xR, xC + 2 * ${dilationWidth}, ch),
                initializationValue
              );

              ${updateSnippet}
            }
          }
        }
        setOutput(${returnValue});
      }
    `;
    }
}

});


parcelRegister("fPHhl", function(module, exports) {

$parcel$export(module.exports, "avgPool3DConfig", function () { return $b86d30b09c6004e1$export$5a9c81d240244392; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");

var $gfZLY = parcelRequire("gfZLY");
function $b86d30b09c6004e1$export$8e92f7d23b27f144(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode, dataFormat: dataFormat } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $dEVRx).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const avgPoolProgram = new (0, $gfZLY.Pool3DProgram)(convInfo, 'avg', false);
    return backend.runWebGLProgram(avgPoolProgram, [
        x
    ], 'float32');
}
const $b86d30b09c6004e1$export$5a9c81d240244392 = {
    kernelName: (0, $9BGT9.AvgPool3D),
    backendName: 'webgl',
    kernelFunc: $b86d30b09c6004e1$export$8e92f7d23b27f144
};

});

parcelRegister("hebZ2", function(module, exports) {

$parcel$export(module.exports, "avgPool3DGradConfig", function () { return $c8ad0a238cae3981$export$1eeb8780807d0508; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");

var $cOec2 = parcelRequire("cOec2");
function $c8ad0a238cae3981$export$798cb4034e996ff4(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $dEVRx).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const avgPoolBackpropProgram = new (0, $cOec2.AvgPool3DBackpropProgram)(convInfo);
    return backend.runWebGLProgram(avgPoolBackpropProgram, [
        dy
    ], x.dtype);
}
const $c8ad0a238cae3981$export$1eeb8780807d0508 = {
    kernelName: (0, $9BGT9.AvgPool3DGrad),
    backendName: 'webgl',
    kernelFunc: $c8ad0a238cae3981$export$798cb4034e996ff4
};

});
parcelRegister("cOec2", function(module, exports) {

$parcel$export(module.exports, "AvgPool2DBackpropProgram", function () { return $95352a04661325eb$export$5dc4ec478e6759de; });
$parcel$export(module.exports, "AvgPool3DBackpropProgram", function () { return $95352a04661325eb$export$f166702869bc274f; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $95352a04661325eb$export$5dc4ec478e6759de {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const avgMultiplier = 1 / (filterHeight * filterWidth);
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
            wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth};
            wC+= ${dilationWidth}) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);

            dotProd += dyValue * avgMultiplier;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $95352a04661325eb$export$f166702869bc274f {
    constructor(convInfo){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = convInfo.inShape;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const avgMultiplier = 1 / (filterDepth * filterHeight * filterWidth);
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});
      const float avgMultiplier = float(${avgMultiplier});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
            wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);

              dotProd += dyValue * avgMultiplier;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});


parcelRegister("ifBe2", function(module, exports) {

$parcel$export(module.exports, "avgPoolGradConfig", function () { return $d49680ea40e4be63$export$ac3f8709351ab225; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $dEVRx = parcelRequire("dEVRx");

var $cOec2 = parcelRequire("cOec2");

var $k42ZR = parcelRequire("k42ZR");
function $d49680ea40e4be63$export$2f098171d1c79aea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    (0, $k42ZR.assertNotComplex)([
        dy,
        input
    ], 'avgPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad } = attrs;
    const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad);
    const avgPoolBackpropProgram = new (0, $cOec2.AvgPool2DBackpropProgram)(convInfo);
    return backend.runWebGLProgram(avgPoolBackpropProgram, [
        dy
    ], x.dtype);
}
const $d49680ea40e4be63$export$ac3f8709351ab225 = {
    kernelName: (0, $9BGT9.AvgPoolGrad),
    backendName: 'webgl',
    kernelFunc: $d49680ea40e4be63$export$2f098171d1c79aea
};

});

parcelRegister("cV6iQ", function(module, exports) {

$parcel$export(module.exports, "batchMatMulConfig", function () { return $967fb28e60a07856$export$d0dd993198185538; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $a1L4Y = parcelRequire("a1L4Y");
function $967fb28e60a07856$export$8f97894b482227f0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { a: a, b: b } = inputs;
    const { transposeA: transposeA, transposeB: transposeB } = attrs;
    return (0, $a1L4Y.batchMatMulImpl)({
        a: a,
        b: b,
        transposeA: transposeA,
        transposeB: transposeB,
        backend: backend
    });
}
const $967fb28e60a07856$export$d0dd993198185538 = {
    kernelName: (0, $9BGT9.BatchMatMul),
    backendName: 'webgl',
    kernelFunc: $967fb28e60a07856$export$8f97894b482227f0
};

});

parcelRegister("bPSWG", function(module, exports) {

$parcel$export(module.exports, "batchNormConfig", function () { return $89df14268a57a281$export$df2dc5c7a755e418; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $8bFMR = parcelRequire("8bFMR");

var $2iLdX = parcelRequire("2iLdX");
const $89df14268a57a281$export$8ea8088e6d0cdd02 = ({ inputs: inputs, backend: backend, attrs: attrs })=>{
    const { x: x, mean: mean, variance: variance, offset: offset, scale: scale } = inputs;
    (0, $lBDHD).assert(mean.shape.length === variance.shape.length, ()=>"Batch normalization gradient requires mean and variance to have equal ranks.");
    (0, $lBDHD).assert(offset == null || mean.shape.length === offset.shape.length, ()=>"Batch normalization gradient requires mean and offset to have equal ranks.");
    (0, $lBDHD).assert(scale == null || mean.shape.length === scale.shape.length, ()=>"Batch normalization gradient requires mean and scale to have equal ranks.");
    let { varianceEpsilon: varianceEpsilon } = attrs;
    if (varianceEpsilon == null) varianceEpsilon = 0.001;
    const finalInputs = [
        x,
        mean,
        variance
    ];
    let offsetShape = null;
    if (offset != null) {
        offsetShape = offset.shape;
        finalInputs.push(offset);
    }
    let scaleShape = null;
    if (scale != null) {
        scaleShape = scale.shape;
        finalInputs.push(scale);
    }
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_NORMALIZATION') ? new (0, $2iLdX.BatchNormPackedProgram)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon) : new (0, $8bFMR.BatchNormProgram)(x.shape, mean.shape, variance.shape, offsetShape, scaleShape, varianceEpsilon);
    const output = backend.runWebGLProgram(program, finalInputs, finalInputs[0].dtype);
    return output;
};
const $89df14268a57a281$export$df2dc5c7a755e418 = {
    kernelName: (0, $9BGT9.FusedBatchNorm),
    backendName: 'webgl',
    kernelFunc: $89df14268a57a281$export$8ea8088e6d0cdd02
};

});
parcelRegister("8bFMR", function(module, exports) {

$parcel$export(module.exports, "BatchNormProgram", function () { return $5f5fc3df6e000c9b$export$bd15a4172044baef; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
class $5f5fc3df6e000c9b$export$bd15a4172044baef {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon){
        this.outputShape = [];
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $dEVRx).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $dEVRx).assertAndGetBroadcastShape(xShape, varianceShape);
        let offsetSnippet = '0.0';
        if (offsetShape != null) {
            (0, $dEVRx).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
            offsetSnippet = 'getOffsetAtOutCoords()';
        }
        let scaleSnippet = '1.0';
        if (scaleShape != null) {
            (0, $dEVRx).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
            scaleSnippet = 'getScaleAtOutCoords()';
        }
        this.outputShape = xShape;
        this.userCode = `
      void main() {
        float x = getXAtOutCoords();
        float mean = getMeanAtOutCoords();
        float variance = getVarianceAtOutCoords();
        float offset = ${offsetSnippet};
        float scale = ${scaleSnippet};
        float inv = scale * inversesqrt(variance + float(${varianceEpsilon}));
        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));
      }
    `;
    }
}

});

parcelRegister("2iLdX", function(module, exports) {

$parcel$export(module.exports, "BatchNormPackedProgram", function () { return $1ad1e4f01d0b7d05$export$cfdd4076f282cff6; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
class $1ad1e4f01d0b7d05$export$cfdd4076f282cff6 {
    constructor(xShape, meanShape, varianceShape, offsetShape, scaleShape, varianceEpsilon){
        this.packedInputs = true;
        this.packedOutput = true;
        this.variableNames = [
            'x',
            'mean',
            'variance'
        ];
        (0, $dEVRx).assertAndGetBroadcastShape(xShape, meanShape);
        (0, $dEVRx).assertAndGetBroadcastShape(xShape, varianceShape);
        let offsetSnippet = 'vec4(0.0)';
        if (offsetShape != null) {
            (0, $dEVRx).assertAndGetBroadcastShape(xShape, offsetShape);
            this.variableNames.push('offset');
            offsetSnippet = 'getOffsetAtOutCoords()';
        }
        let scaleSnippet = 'vec4(1.0)';
        if (scaleShape != null) {
            (0, $dEVRx).assertAndGetBroadcastShape(xShape, scaleShape);
            this.variableNames.push('scale');
            scaleSnippet = 'getScaleAtOutCoords()';
        }
        this.outputShape = xShape;
        this.userCode = `
      void main() {
        vec4 offset = ${offsetSnippet};
        vec4 scale = ${scaleSnippet};

        vec4 x = getXAtOutCoords();
        vec4 mean = getMeanAtOutCoords();
        vec4 variance = getVarianceAtOutCoords();

        vec4 inv = scale * inversesqrt(variance + vec4(${varianceEpsilon}));

        setOutput((x - mean) * inv + offset);
      }
    `;
    }
}

});


parcelRegister("lRvHa", function(module, exports) {

$parcel$export(module.exports, "batchToSpaceNDConfig", function () { return $fea7223418980caa$export$44e08e19f97e5513; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $aNJFF = parcelRequire("aNJFF");

var $llO7x = parcelRequire("llO7x");

var $fZ5E6 = parcelRequire("fZ5E6");
const $fea7223418980caa$export$ea37d960c1808536 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, crops: crops } = attrs;
    (0, $lBDHD).assert(x.shape.length <= 4, ()=>"batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const reshaped = (0, $dEVRx).getReshaped(x.shape, blockShape, prod);
    const permuted = (0, $dEVRx).getPermuted(reshaped.length, blockShape.length);
    const reshapedPermuted = (0, $dEVRx).getReshapedPermuted(x.shape, blockShape, prod);
    const sliceBeginCoords = (0, $dEVRx).getSliceBeginCoords(crops, blockShape.length);
    const sliceSize = (0, $dEVRx).getSliceSize(reshapedPermuted, crops, blockShape.length);
    const toDispose = [];
    const reshapedIntermediate = (0, $aNJFF.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: reshaped
        }
    });
    const transposedIntermediate = (0, $fZ5E6.transpose)({
        inputs: {
            x: reshapedIntermediate
        },
        backend: backend,
        attrs: {
            perm: permuted
        }
    });
    const reshapedIntermediate2 = (0, $aNJFF.reshape)({
        inputs: {
            x: transposedIntermediate
        },
        backend: backend,
        attrs: {
            shape: reshapedPermuted
        }
    });
    const sliced = (0, $llO7x.slice)({
        inputs: {
            x: reshapedIntermediate2
        },
        backend: backend,
        attrs: {
            begin: sliceBeginCoords,
            size: sliceSize
        }
    });
    toDispose.push(reshapedIntermediate);
    toDispose.push(transposedIntermediate);
    toDispose.push(reshapedIntermediate2);
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return sliced;
};
const $fea7223418980caa$export$44e08e19f97e5513 = {
    kernelName: (0, $9BGT9.BatchToSpaceND),
    backendName: 'webgl',
    kernelFunc: $fea7223418980caa$export$ea37d960c1808536
};

});
parcelRegister("llO7x", function(module, exports) {

$parcel$export(module.exports, "slice", function () { return $f8b2700972b8a31c$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "sliceConfig", function () { return $f8b2700972b8a31c$export$8d8a1e11dd2cc6c4; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $iEcDD = parcelRequire("iEcDD");
var $lBDHD = parcelRequire("lBDHD");

var $glyiU = parcelRequire("glyiU");

var $6gkKM = parcelRequire("6gkKM");

var $cRgXX = parcelRequire("cRgXX");
function $f8b2700972b8a31c$var$shallowSlice(x, begin, size, backend) {
    const xTexData = backend.texData.get(x.dataId);
    const t = backend.makeTensorInfo(size, x.dtype);
    const newTexData = backend.texData.get(t.dataId);
    // Copy texture data from the original tensor.
    Object.assign(newTexData, xTexData);
    newTexData.refCount = 1;
    newTexData.shape = size;
    newTexData.dtype = x.dtype;
    let flatOffset = (0, $iEcDD).computeFlatOffset(begin, (0, $lBDHD).computeStrides(x.shape));
    if (xTexData.slice) // We are slicing an already sliced tensor, so we have to accumulate
    // the offset.
    flatOffset += xTexData.slice.flatOffset;
    newTexData.slice = {
        flatOffset: flatOffset,
        // Point to the original dataId, which is used to do ref counting.
        origDataId: xTexData.slice && xTexData.slice.origDataId || x.dataId
    };
    // Increase the ref count for that data bucket.
    const refCount = backend.dataRefCount.get(newTexData.slice.origDataId) || 1;
    backend.dataRefCount.set(newTexData.slice.origDataId, refCount + 1);
    return t;
}
function $f8b2700972b8a31c$export$58adb3bec8346d0f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, size: size } = attrs;
    const [$begin, $size] = (0, $iEcDD).parseSliceParams(x, begin, size);
    (0, $iEcDD).assertParamsValid(x, $begin, $size);
    if ((0, $lBDHD).sizeFromShape($size) === 0) return backend.makeTensorInfo($size, x.dtype, []);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgl doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (backend.shouldExecuteOnCPU([
        x
    ]) || x.dtype === 'string') {
        const xTexData = backend.texData.get(x.dataId);
        const outValues = (0, $glyiU.sliceImplCPU)(xTexData.values, $begin, $size, x.shape, x.dtype);
        return backend.makeTensorInfo($size, x.dtype, outValues);
    }
    const { isPacked: isPacked } = backend.texData.get(x.dataId);
    const isContinous = (0, $iEcDD).isSliceContinous(x.shape, $begin, $size);
    if (isPacked || !isContinous) {
        const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $cRgXX.SlicePackedProgram)($size) : new (0, $6gkKM.SliceProgram)($size);
        const customValues = [
            $begin
        ];
        return backend.runWebGLProgram(program, [
            x
        ], x.dtype, customValues);
    }
    backend.uploadToGPU(x.dataId);
    return $f8b2700972b8a31c$var$shallowSlice(x, $begin, $size, backend);
}
const $f8b2700972b8a31c$export$8d8a1e11dd2cc6c4 = {
    kernelName: (0, $9BGT9.Slice),
    backendName: 'webgl',
    kernelFunc: $f8b2700972b8a31c$export$58adb3bec8346d0f
};

});
parcelRegister("6gkKM", function(module, exports) {

$parcel$export(module.exports, "SliceProgram", function () { return $48f455e9f1a35c4d$export$ef8bf52bc4951c85; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $48f455e9f1a35c4d$export$ef8bf52bc4951c85 {
    constructor(destSize){
        this.variableNames = [
            'source'
        ];
        this.outputShape = destSize;
        this.rank = destSize.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(this.rank);
        this.customUniforms = [
            {
                name: 'start',
                arrayIndex: this.rank,
                type: 'int'
            }
        ];
        const sourceCoords = $48f455e9f1a35c4d$var$getCoords(this.rank);
        let body;
        const coordSum = destSize.map((_, i)=>{
            return `sourceLoc.${$48f455e9f1a35c4d$var$coords[i]} = start[${i}] + coords.${$48f455e9f1a35c4d$var$coords[i]};`;
        });
        body = `
        ${dtype} sourceLoc;
        ${dtype} coords = getOutputCoords();
        ${coordSum.join('\n')}
      `;
        this.userCode = `
      void main() {
        ${body}
        setOutput(getSource(${sourceCoords}));
      }
    `;
    }
}
const $48f455e9f1a35c4d$var$coords = [
    'x',
    'y',
    'z',
    'w',
    'u',
    'v'
];
function $48f455e9f1a35c4d$var$getCoords(rank) {
    if (rank === 1) return 'sourceLoc';
    else if (rank <= 6) return $48f455e9f1a35c4d$var$coords.slice(0, rank).map((x)=>'sourceLoc.' + x).join(',');
    else throw Error(`Slicing for rank ${rank} is not yet supported`);
}

});

parcelRegister("cRgXX", function(module, exports) {

$parcel$export(module.exports, "SlicePackedProgram", function () { return $95c79864e526be2e$export$a6c6101de259f77; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $95c79864e526be2e$export$a6c6101de259f77 {
    constructor(destSize){
        this.variableNames = [
            'source'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = destSize;
        this.rank = destSize.length;
        this.customUniforms = [
            {
                name: 'start',
                arrayIndex: this.rank,
                type: 'int'
            }
        ];
        const dtype = (0, $1eI1C.getCoordsDataType)(this.rank);
        const coords = (0, $coLQR.getChannels)('coords', this.rank);
        const sourceLoc = (0, $coLQR.getChannels)('sourceLoc', this.rank);
        const innerDims = this.rank === 1 ? 'sourceLoc' : `vec2(${sourceLoc.slice(-2).join()})`;
        const getChannel = `getChannel(getSource(${sourceLoc.join()}), ${innerDims})`;
        const upperRow = `
      result.x = ${getChannel};
      if (++${coords[this.rank - 1]} < ${destSize[this.rank - 1]}) {
        ++${sourceLoc[this.rank - 1]};
        result.y = ${getChannel};
        --${sourceLoc[this.rank - 1]};
      }
    `;
        const lowerRow = this.rank === 1 ? '' : `
      --${coords[this.rank - 1]};
      if (++${coords[this.rank - 2]} < ${destSize[this.rank - 2]}) {
        ++${sourceLoc[this.rank - 2]};
        result.z = ${getChannel};
        if (++${coords[this.rank - 1]} < ${destSize[this.rank - 1]}) {
          ++${sourceLoc[this.rank - 1]};
          result.w = ${getChannel};
        }
      }
    `;
        const sourceLocSetup = this.rank <= 4 ? `sourceLoc = coords +
            ${dtype}(${destSize.map((_, i)=>`start[${i}]`).join()});` : destSize.map((_, i)=>`${sourceLoc[i]} = ${coords[i]} + start[${i}];`).join('\n');
        this.userCode = `
      void main() {
        ${dtype} coords = getOutputCoords();
        ${dtype} sourceLoc;
        ${sourceLocSetup}
        vec4 result = vec4(0.);
        ${upperRow}
        ${lowerRow}
        setOutput(result);
      }
    `;
    }
}

});



parcelRegister("eFCqu", function(module, exports) {

$parcel$export(module.exports, "bincountConfig", function () { return $aae2b3b14eccbb7c$export$af9f0093738840fb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $aae2b3b14eccbb7c$export$7e474bab088ed182(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size } = attrs;
    const xVals = backend.readSync(x.dataId);
    const weightsVals = backend.readSync(weights.dataId);
    const outVals = (0, $glyiU.bincountImplCPU)(xVals, weightsVals, weights.dtype, weights.shape, size);
    return backend.makeTensorInfo([
        size
    ], weights.dtype, outVals);
}
const $aae2b3b14eccbb7c$export$af9f0093738840fb = {
    kernelName: (0, $9BGT9.Bincount),
    backendName: 'webgl',
    kernelFunc: $aae2b3b14eccbb7c$export$7e474bab088ed182
};

});

parcelRegister("gn6ey", function(module, exports) {

$parcel$export(module.exports, "bitwiseAndConfig", function () { return $beb3a134d0f05fee$export$6d53927dafa38bf9; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $tdutJ = parcelRequire("tdutJ");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");

var $glyiU = parcelRequire("glyiU");
const $beb3a134d0f05fee$export$c4be938c09e5b0e3 = `
  int r = int(a.r) & int(b.r);
  int g = int(a.g) & int(b.g);
  int rb = int(a.b) & int(b.b);
  int ra = int(a.a) & int(b.a);
  return vec4(r, g, rb, ra);
`;
const $beb3a134d0f05fee$export$798433bcbadf4947 = `
  return float(int(a.r) & int(b.r));
`;
function $beb3a134d0f05fee$export$84529b0ad3b42cd1(args) {
    const { inputs: inputs, backend: backend } = args;
    const { a: a, b: b } = inputs;
    const shouldUsePackedProgram = (0, $tdutJ.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS');
    const versionNumber = (0, $tdutJ.env)().getNumber('WEBGL_VERSION');
    // The type of a and b are ensured to be `int32` in core, therefore no need to
    // consider other type situations.
    if (backend.shouldExecuteOnCPU([
        a,
        b
    ]) || versionNumber === 1) {
        const aVals = backend.texData.get(a.dataId).values;
        const bVals = backend.texData.get(b.dataId).values;
        const [outValues, outShape] = (0, $glyiU.bitwiseAndImplCPU)(a.shape, b.shape, aVals, bVals, a.dtype);
        const out = backend.makeTensorInfo(outShape, a.dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
        return out;
    }
    let program;
    if (shouldUsePackedProgram) program = new (0, $12pF4.BinaryOpPackedProgram)($beb3a134d0f05fee$export$c4be938c09e5b0e3, a.shape, b.shape, false);
    else program = new (0, $iFjfL.BinaryOpProgram)($beb3a134d0f05fee$export$798433bcbadf4947, a.shape, b.shape);
    return backend.runWebGLProgram(program, [
        a,
        b
    ], a.dtype);
}
const $beb3a134d0f05fee$export$6d53927dafa38bf9 = {
    kernelName: (0, $9BGT9.BitwiseAnd),
    backendName: 'webgl',
    kernelFunc: $beb3a134d0f05fee$export$84529b0ad3b42cd1
};

});

parcelRegister("3AB21", function(module, exports) {

$parcel$export(module.exports, "broadcastArgsConfig", function () { return $29d175968dfef78c$export$8f7b2ec0c6f08fb2; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
function $29d175968dfef78c$export$d226d344aedce941(args) {
    const { inputs: inputs, backend: backend } = args;
    const { s0: s0, s1: s1 } = inputs;
    const s0Vals = backend.readSync(s0.dataId);
    const s1Vals = backend.readSync(s1.dataId);
    const broadcastShape = (0, $dEVRx).assertAndGetBroadcastShape(Array.from(s0Vals), Array.from(s1Vals));
    return backend.makeTensorInfo([
        broadcastShape.length
    ], 'int32', Int32Array.from(broadcastShape));
}
const $29d175968dfef78c$export$8f7b2ec0c6f08fb2 = {
    kernelName: (0, $9BGT9.BroadcastArgs),
    backendName: 'webgl',
    kernelFunc: $29d175968dfef78c$export$d226d344aedce941
};

});

parcelRegister("i7P7l", function(module, exports) {

$parcel$export(module.exports, "castConfig", function () { return $d320884f4b029dee$export$ac4d0f0f3927a8f3; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");
var $lxzgt = parcelRequire("lxzgt");

var $glyiU = parcelRequire("glyiU");

var $6iqSX = parcelRequire("6iqSX");

var $lVOy4 = parcelRequire("lVOy4");

var $6ZxUc = parcelRequire("6ZxUc");

var $aUagc = parcelRequire("aUagc");

var $uLf4A = parcelRequire("uLf4A");
function $d320884f4b029dee$export$f2db7d5238e1d23f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dtype: dtype } = attrs;
    // Casting to complex64.
    if (dtype === 'complex64') {
        if (x.dtype === 'complex64') return (0, $lVOy4.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        // TODO(annxingyuan): Import kernel function once zeros is modularized.
        const zerosTensor = $lxzgt.zeros(x.shape);
        const floatX = $d320884f4b029dee$export$f2db7d5238e1d23f({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                dtype: 'float32'
            }
        });
        const result = (0, $6iqSX.complex)({
            inputs: {
                real: floatX,
                imag: zerosTensor
            },
            backend: backend
        });
        zerosTensor.dispose();
        backend.disposeIntermediateTensorInfo(floatX);
        return result;
    }
    // Casting from complex64
    if (x.dtype === 'complex64') {
        const realPart = (0, $aUagc.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const result = $d320884f4b029dee$export$f2db7d5238e1d23f({
            inputs: {
                x: realPart
            },
            backend: backend,
            attrs: {
                dtype: dtype
            }
        });
        backend.disposeIntermediateTensorInfo(realPart);
        return result;
    }
    if (!(0, $lBDHD).hasEncodingLoss(x.dtype, dtype)) {
        // We don't change the underlying data, since we cast to higher
        // precision.
        const result = (0, $lVOy4.identity)({
            inputs: {
                x: x
            },
            backend: backend
        });
        return {
            dataId: result.dataId,
            shape: result.shape,
            dtype: dtype
        };
    }
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const values = backend.texData.get(x.dataId).values;
        const [resultShape, resultType, resultData] = (0, $glyiU.castImplCPU)(values, x.shape, x.dtype, dtype);
        return backend.makeTensorInfo(resultShape, resultType, resultData);
    }
    if (dtype === 'int32') return (0, $uLf4A.int)(x, backend);
    if (dtype === 'bool') {
        const zerosTensorInfo = backend.makeTensorInfo([], 'bool', (0, $lBDHD).getTypedArrayFromDType('bool', 1));
        const binaryInputs = {
            a: x,
            b: zerosTensorInfo
        };
        const result = (0, $6ZxUc.notEqual)({
            inputs: binaryInputs,
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(zerosTensorInfo);
        return result;
    }
    throw new Error(`Error in Cast: failed to cast ${x.dtype} to ${dtype}`);
}
const $d320884f4b029dee$export$ac4d0f0f3927a8f3 = {
    kernelName: (0, $9BGT9.Cast),
    backendName: 'webgl',
    kernelFunc: $d320884f4b029dee$export$f2db7d5238e1d23f
};

});
parcelRegister("6ZxUc", function(module, exports) {

$parcel$export(module.exports, "notEqual", function () { return $5172bd7ae6871703$export$53a6892c50694894; });
$parcel$export(module.exports, "notEqualConfig", function () { return $5172bd7ae6871703$export$d003d4d7e1500775; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $5172bd7ae6871703$var$NOT_EQUAL = `return float(a != b);`;
const $5172bd7ae6871703$export$53a6892c50694894 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $5172bd7ae6871703$var$NOT_EQUAL,
    cpuKernelImpl: (0, $glyiU.notEqualImplCPU),
    dtype: 'bool'
});
const $5172bd7ae6871703$export$d003d4d7e1500775 = {
    kernelName: (0, $9BGT9.NotEqual),
    backendName: 'webgl',
    kernelFunc: $5172bd7ae6871703$export$53a6892c50694894
};

});

parcelRegister("aUagc", function(module, exports) {

$parcel$export(module.exports, "real", function () { return $7f0717ccd8e2794c$export$9fc57fb453bdbd67; });
$parcel$export(module.exports, "realConfig", function () { return $7f0717ccd8e2794c$export$4b7bce57557ae68b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $lVOy4 = parcelRequire("lVOy4");
function $7f0717ccd8e2794c$export$9fc57fb453bdbd67(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.texData.get(input.dataId);
    return (0, $lVOy4.identity)({
        inputs: {
            x: inputData.complexTensorInfos.real
        },
        backend: backend
    });
}
const $7f0717ccd8e2794c$export$4b7bce57557ae68b = {
    kernelName: (0, $9BGT9.Real),
    backendName: 'webgl',
    kernelFunc: $7f0717ccd8e2794c$export$9fc57fb453bdbd67
};

});

parcelRegister("uLf4A", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $05c772c17ac1bc43$export$7d260a2a5f8bc19e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1V6Qm = parcelRequire("1V6Qm");
const $05c772c17ac1bc43$var$TO_INT = `return float(int(x));`;
function $05c772c17ac1bc43$export$7d260a2a5f8bc19e(input, backend) {
    const program = new (0, $1V6Qm.UnaryOpProgram)(input.shape, $05c772c17ac1bc43$var$TO_INT);
    const output = backend.runWebGLProgram(program, [
        input
    ], 'int32');
    return {
        dataId: output.dataId,
        shape: output.shape,
        dtype: output.dtype
    };
}

});


parcelRegister("35WUX", function(module, exports) {

$parcel$export(module.exports, "ceilConfig", function () { return $240f8a86e125571c$export$df387212b1898306; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $240f8a86e125571c$var$CEIL = `return ceil(x);`;
const $240f8a86e125571c$export$803ce6b71a0a94b2 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $240f8a86e125571c$var$CEIL,
    packedOpSnippet: $240f8a86e125571c$var$CEIL,
    cpuKernelImpl: (0, $glyiU.ceilImplCPU)
});
const $240f8a86e125571c$export$df387212b1898306 = {
    kernelName: (0, $9BGT9.Ceil),
    backendName: 'webgl',
    kernelFunc: $240f8a86e125571c$export$803ce6b71a0a94b2
};

});

parcelRegister("4CTNt", function(module, exports) {

$parcel$export(module.exports, "clipByValueConfig", function () { return $35e5fe20a1272ea9$export$f7ee8f07ce0ff4e1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $tdutJ = parcelRequire("tdutJ");

var $ls1i7 = parcelRequire("ls1i7");

var $1Bljs = parcelRequire("1Bljs");
function $35e5fe20a1272ea9$export$fa97baf70ad024c0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { clipValueMin: clipValueMin, clipValueMax: clipValueMax } = attrs;
    let program;
    if ((0, $tdutJ.env)().getBool('WEBGL_PACK_CLIP')) program = new (0, $1Bljs.ClipPackedProgram)(x.shape);
    else program = new (0, $ls1i7.ClipProgram)(x.shape);
    const customValues = [
        [
            clipValueMin
        ],
        [
            clipValueMax
        ]
    ];
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype, customValues);
}
const $35e5fe20a1272ea9$export$f7ee8f07ce0ff4e1 = {
    kernelName: (0, $9BGT9.ClipByValue),
    backendName: 'webgl',
    kernelFunc: $35e5fe20a1272ea9$export$fa97baf70ad024c0
};

});
parcelRegister("ls1i7", function(module, exports) {

$parcel$export(module.exports, "ClipProgram", function () { return $f9dd36ef4abda9b3$export$ce48b7c79e7985d1; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $f9dd36ef4abda9b3$export$ce48b7c79e7985d1 {
    constructor(aShape){
        this.variableNames = [
            'A'
        ];
        this.customUniforms = [
            {
                name: 'minVal',
                type: 'float'
            },
            {
                name: 'maxVal',
                type: 'float'
            }
        ];
        this.outputShape = aShape;
        this.userCode = `

      void main() {
        float value = getAAtOutCoords();
        if (isnan(value)) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, minVal, maxVal));
      }
    `;
    }
}

});

parcelRegister("1Bljs", function(module, exports) {

$parcel$export(module.exports, "ClipPackedProgram", function () { return $12a9c76e4bffef09$export$812909708a626d33; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $12a9c76e4bffef09$export$812909708a626d33 {
    constructor(aShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'minVal',
                type: 'float'
            },
            {
                name: 'maxVal',
                type: 'float'
            }
        ];
        this.outputShape = aShape;
        this.userCode = `
      void main() {
        vec4 value = getAAtOutCoords();

        if (any(isnan(value))) {
          setOutput(value);
          return;
        }

        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));
      }
    `;
    }
}

});


parcelRegister("kamKt", function(module, exports) {

$parcel$export(module.exports, "complexAbsConfig", function () { return $eae6632fe1dae122$export$a4817d2978acc054; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $5PBu5 = parcelRequire("5PBu5");
// Returns a TensorInfo with the complex shape and the dataId of the
// underlying part. We need to do this because a reshaped complex tensor is
// not reflected in its parts.
function $eae6632fe1dae122$var$makeComplexComponentTensorInfo(complexTensor, complexPart) {
    return {
        dataId: complexPart.dataId,
        dtype: complexPart.dtype,
        shape: complexTensor.shape
    };
}
function $eae6632fe1dae122$export$2837bc62566f8808(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const xData = backend.texData.get(x.dataId);
    const program = new (0, $5PBu5.ComplexAbsProgram)(x.shape);
    const programInputs = [
        $eae6632fe1dae122$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.real),
        $eae6632fe1dae122$var$makeComplexComponentTensorInfo(x, xData.complexTensorInfos.imag)
    ];
    return backend.runWebGLProgram(program, programInputs, programInputs[0].dtype);
}
const $eae6632fe1dae122$export$a4817d2978acc054 = {
    kernelName: (0, $9BGT9.ComplexAbs),
    backendName: 'webgl',
    kernelFunc: $eae6632fe1dae122$export$2837bc62566f8808
};

});
parcelRegister("5PBu5", function(module, exports) {

$parcel$export(module.exports, "ComplexAbsProgram", function () { return $43eecac4c357f86a$export$d03dbc86862098f5; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $43eecac4c357f86a$export$d03dbc86862098f5 {
    constructor(shape){
        this.variableNames = [
            'real',
            'imag'
        ];
        this.outputShape = shape;
        this.userCode = `
      void main() {
        float re = abs(getRealAtOutCoords());
        float im = abs(getImagAtOutCoords());
        float mx = max(re, im);

        // sadly the length function in glsl is not underflow-safe
        // (at least not on Intel GPUs). So the safe solution is
        // to ensure underflow-safety in all cases.
        setOutput(
          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))
        );
      }
    `;
    }
}

});


parcelRegister("hRABi", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $d013c6fe6fb0b53f$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatConfig", function () { return $d013c6fe6fb0b53f$export$c8cf96dae25282e5; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $ejcR2 = parcelRequire("ejcR2");

var $lVOy4 = parcelRequire("lVOy4");
function $d013c6fe6fb0b53f$export$ee1b3e54f0441b22(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    const $axis = (0, $lBDHD).parseAxisParam(axis, inputs[0].shape)[0];
    const shapes = inputs.map((t)=>t.shape);
    (0, $dEVRx).assertParamsConsistent(shapes, $axis);
    const outShape = (0, $dEVRx).computeOutShape(inputs.map((t)=>t.shape), $axis);
    if ((0, $lBDHD).sizeFromShape(outShape) === 0) return backend.makeTensorInfo(outShape, inputs[0].dtype, []);
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $lBDHD).sizeFromShape(t.shape) > 0);
    if ($inputs.length === 1) return (0, $lVOy4.identity)({
        inputs: {
            x: $inputs[0]
        },
        backend: backend
    });
    return (0, $ejcR2.concatImpl)($inputs, $axis, backend);
}
const $d013c6fe6fb0b53f$export$c8cf96dae25282e5 = {
    kernelName: (0, $9BGT9.Concat),
    backendName: 'webgl',
    kernelFunc: $d013c6fe6fb0b53f$export$ee1b3e54f0441b22
};

});
parcelRegister("ejcR2", function(module, exports) {

$parcel$export(module.exports, "concatImpl", function () { return $a6accfa85b7ce9c5$export$777da59f594f497d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $lBDHD = parcelRequire("lBDHD");

var $24fSn = parcelRequire("24fSn");

var $gVA27 = parcelRequire("gVA27");

var $glyiU = parcelRequire("glyiU");

var $1V6Qm = parcelRequire("1V6Qm");

var $2s8wb = parcelRequire("2s8wb");

var $6iqSX = parcelRequire("6iqSX");

var $84pSa = parcelRequire("84pSa");

var $aUagc = parcelRequire("aUagc");

var $aNJFF = parcelRequire("aNJFF");
function $a6accfa85b7ce9c5$export$777da59f594f497d(inputs, axis, backend) {
    const dtype = inputs[0].dtype;
    if (dtype === 'complex64') {
        const reals = inputs.map((t)=>(0, $aUagc.real)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const imags = inputs.map((t)=>(0, $84pSa.imag)({
                inputs: {
                    input: t
                },
                backend: backend
            }));
        const realConcated = $a6accfa85b7ce9c5$export$777da59f594f497d(reals, axis, backend);
        const imagConcated = $a6accfa85b7ce9c5$export$777da59f594f497d(imags, axis, backend);
        const result = (0, $6iqSX.complex)({
            inputs: {
                real: realConcated,
                imag: imagConcated
            },
            backend: backend
        });
        reals.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
        imags.forEach((i)=>backend.disposeIntermediateTensorInfo(i));
        backend.disposeIntermediateTensorInfo(realConcated);
        backend.disposeIntermediateTensorInfo(imagConcated);
        return result;
    }
    let runOnCpu = backend.shouldExecuteOnCPU(inputs);
    // Run on cpu if dtype is string. For string, the backend represents it
    // as Uint8Array[], where each Uint8Array is a character. Given that the
    // computation is only on the outer array, uploading the whole data onto
    // gpu is wasteful. Also, currently webgl doesn't have a design to
    // upload and retrieve Uint8Array[] between cpu and gpu. Therefore, we
    // just run the kernel on cpu if dtype is string.
    if (dtype === 'string') runOnCpu = true;
    if (runOnCpu) {
        // Any concat of n-dimensional tensors across any axis can be reduced to
        // a concatenation of two-dimensional tensors across the axis 1 by first
        // partitioning the axes of the original tensors into those less than the
        // axis to be concatenated and the rest. Then reshape the tensors
        // into a two-dimensional tensor by collapsing these two sets of axes and
        // concatenate the resulting matrices across the axis 1, finally reshaping
        // the result to have the proper shape.
        const tensors2D = inputs.map((t)=>{
            const innerSize = (0, $lBDHD).sizeFromShape(t.shape.slice(axis));
            const shape = [
                -1,
                innerSize
            ];
            return (0, $aNJFF.reshape)({
                inputs: {
                    x: t
                },
                backend: backend,
                attrs: {
                    shape: shape
                }
            });
        });
        const inputsValShapes = tensors2D.map((t)=>{
            return {
                vals: backend.readSync(t.dataId),
                shape: t.shape
            };
        });
        // Concats 2d tensors along axis=1.
        const outShape = (0, $dEVRx).computeOutShape(tensors2D.map((t)=>t.shape), 1 /* axis */ );
        const simplyConcat = tensors2D[0].shape[0] === 1;
        const outVals = (0, $glyiU.concatImplCPU)(inputsValShapes, outShape, dtype, simplyConcat);
        const finalOutShape = (0, $dEVRx).computeOutShape(inputs.map((t)=>t.shape), axis);
        const outInfo = backend.makeTensorInfo(finalOutShape, dtype, outVals);
        tensors2D.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return outInfo;
    }
    // Keep only non-empty tensors (ignore tensors with 0 in their shape).
    const $inputs = inputs.filter((t)=>(0, $lBDHD).sizeFromShape(t.shape) > 0);
    const shouldPack = (0, $tdutJ.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') && $inputs[0].shape.length > 1;
    if ($inputs.length === 1) {
        // Clone tensor.
        const program = shouldPack ? new (0, $1V6Qm.UnaryOpProgram)(inputs[0].shape, (0, $1V6Qm.CLONE)) : new (0, $2s8wb.UnaryOpPackedProgram)(inputs[0].shape, (0, $1V6Qm.CLONE));
        return backend.runWebGLProgram(program, inputs, dtype);
    }
    const maxTexturesInShader = (0, $tdutJ.env)().getNumber('WEBGL_MAX_TEXTURES_IN_SHADER');
    if ($inputs.length > maxTexturesInShader) {
        const reducedInputs = [];
        for(let i = 0; i < $inputs.length; i += maxTexturesInShader){
            const subArray = $inputs.slice(i, i + maxTexturesInShader);
            reducedInputs.push($a6accfa85b7ce9c5$export$777da59f594f497d(subArray, axis, backend));
        }
        const result = $a6accfa85b7ce9c5$export$777da59f594f497d(reducedInputs, axis, backend);
        for (const i of reducedInputs)backend.disposeIntermediateTensorInfo(i);
        return result;
    }
    if (shouldPack) {
        const program = new (0, $gVA27.ConcatPackedProgram)($inputs.map((t)=>t.shape), axis);
        return backend.runWebGLProgram(program, $inputs, dtype);
    }
    const { tensors2D: tensors2D, outShape: outShape } = $a6accfa85b7ce9c5$var$computeTensors2D($inputs, axis, backend);
    const program = new (0, $24fSn.ConcatProgram)(tensors2D.map((t)=>t.shape));
    const result = backend.runWebGLProgram(program, tensors2D, dtype);
    tensors2D.forEach((r)=>backend.disposeIntermediateTensorInfo(r));
    const reshapedResult = (0, $aNJFF.reshape)({
        inputs: {
            x: result
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(result);
    return reshapedResult;
}
function $a6accfa85b7ce9c5$var$computeTensors2D(inputs, axis, backend) {
    // Any concat of n-dimensional tensors across any axis can be reduced to
    // a concatenation of two-dimensional tensors across the axis 1 by first
    // partitioning the axes of the original tensors into those less than the
    // axis to be concatenated and the rest. Then reshape the tensors
    // into a two-dimensional tensor by collapsing these two sets of axes and
    // concatenate the resulting matrices across the axis 1, finally reshaping
    // the result to have the proper shape.
    const outShape = (0, $dEVRx).computeOutShape(inputs.map((t)=>t.shape), axis);
    const tensors2D = inputs.map((x)=>(0, $aNJFF.reshape)({
            inputs: {
                x: x
            },
            attrs: {
                shape: [
                    -1,
                    (0, $lBDHD).sizeFromShape(x.shape.slice(axis))
                ]
            },
            backend: backend
        }));
    return {
        tensors2D: tensors2D,
        outShape: outShape
    };
}

});
parcelRegister("24fSn", function(module, exports) {

$parcel$export(module.exports, "ConcatProgram", function () { return $181845212ed37ebc$export$9059cb52ee2cb142; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
class $181845212ed37ebc$export$9059cb52ee2cb142 {
    // Concats 2d tensors along axis=1. See comments in MathBackendWebGL.concat().
    constructor(shapes){
        this.outputShape = [];
        this.outputShape = (0, $dEVRx).computeOutShape(shapes, 1 /* axis */ );
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const offsets = new Array(shapes.length - 1);
        offsets[0] = shapes[0][1];
        for(let i = 1; i < offsets.length; i++)offsets[i] = offsets[i - 1] + shapes[i][1];
        const snippets = [
            `if (yC < ${offsets[0]}) setOutput(getT0(yR, yC));`
        ];
        for(let i = 1; i < offsets.length; i++){
            const shift = offsets[i - 1];
            snippets.push(`else if (yC < ${offsets[i]}) ` + `setOutput(getT${i}(yR, yC-${shift}));`);
        }
        const lastIndex = offsets.length;
        const lastShift = offsets[offsets.length - 1];
        snippets.push(`else setOutput(getT${lastIndex}(yR, yC-${lastShift}));`);
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int yR = coords.x;
        int yC = coords.y;

        ${snippets.join('\n        ')}
      }
    `;
    }
}

});

parcelRegister("gVA27", function(module, exports) {

$parcel$export(module.exports, "ConcatPackedProgram", function () { return $c52deba23594e56a$export$e91e551248cfdb97; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");

var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $c52deba23594e56a$export$e91e551248cfdb97 {
    constructor(shapes, axis){
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        this.outputShape = (0, $dEVRx).computeOutShape(shapes, axis);
        const shape = this.outputShape;
        const rank = shape.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(rank);
        const coords = (0, $coLQR.getChannels)('coords', rank);
        const channels = [
            'x',
            'y',
            'z',
            'w',
            'u',
            'v'
        ].slice(0, rank);
        this.variableNames = shapes.map((_, i)=>`T${i}`);
        const offsets = new Array(shapes.length - 1);
        offsets[0] = shapes[0][axis];
        for(let i = 1; i < offsets.length; i++)offsets[i] = offsets[i - 1] + shapes[i][axis];
        const channel = channels[axis];
        const lastChannels = channels.slice(-2);
        const allChannels = channels.join();
        let getValueSnippet = `if (${channel} < ${offsets[0]}) {
        return getChannel(
            getT0(${allChannels}), vec2(${lastChannels.join()}));
        }`;
        for(let i = 1; i < offsets.length; i++){
            const shift = offsets[i - 1];
            // Note: the >= comparison below may seem unnecessary given the check
            // above but is needed to workaround branch execution issues on some
            // devices. It makes all the conditions exclusive without relying on
            // execution order.
            getValueSnippet += `
        if (${channel} < ${offsets[i]}  && ${channel} >= ${offsets[i - 1]}) {
          return getChannel(
            getT${i}(${$c52deba23594e56a$var$shiftedChannels(channels, channel, shift)}),
            vec2(${$c52deba23594e56a$var$shiftedChannels(lastChannels, channel, shift)}));
        }`;
        }
        const lastIndex = offsets.length;
        const shift = offsets[offsets.length - 1];
        getValueSnippet += `
        return getChannel(
          getT${lastIndex}(${$c52deba23594e56a$var$shiftedChannels(channels, channel, shift)}),
          vec2(${$c52deba23594e56a$var$shiftedChannels(lastChannels, channel, shift)}));`;
        this.userCode = `
      float getValue(${channels.map((x)=>'int ' + x)}) {
        ${getValueSnippet}
      }

      void main() {
        ${dtype} coords = getOutputCoords();
        vec4 result = vec4(getValue(${coords}), 0., 0., 0.);

        ${coords[rank - 1]} = ${coords[rank - 1]} + 1;
        if (${coords[rank - 1]} < ${shape[rank - 1]}) {
          result.g = getValue(${coords});
        }

        ${coords[rank - 2]} = ${coords[rank - 2]} + 1;
        if (${coords[rank - 2]} < ${shape[rank - 2]}) {
          result.a = getValue(${coords});
        }

        ${coords[rank - 1]} = ${coords[rank - 1]} - 1;
        if (${coords[rank - 2]} < ${shape[rank - 2]} &&
            ${coords[rank - 1]} < ${shape[rank - 1]}) {
          result.b = getValue(${coords});
        }
        setOutput(result);
      }
    `;
    }
}
/**
 * Return an expression for coordinates into a vector where a given channel
 * will be offset by [shift].
 *
 * @param channels the channels to consider
 * @param channel the channel we want shifted
 * @param shift  the amount to subtract from the channel.
 *
 * @returns a string of the form 'x, y-[shift], z' where any one channel can
 * have the shift applied.
 */ function $c52deba23594e56a$var$shiftedChannels(channels, channel, shift) {
    const channelIdx = channels.indexOf(channel);
    const res = channels.map((c, idx)=>{
        if (idx === channelIdx) return `${c} - ${shift}`;
        else return c;
    });
    return res.join();
}

});

parcelRegister("84pSa", function(module, exports) {

$parcel$export(module.exports, "imag", function () { return $5e02c437b2ab909b$export$d78fab5778ab392b; });
$parcel$export(module.exports, "imagConfig", function () { return $5e02c437b2ab909b$export$ddfc128c2801add7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $lVOy4 = parcelRequire("lVOy4");
function $5e02c437b2ab909b$export$d78fab5778ab392b(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    const inputData = backend.texData.get(input.dataId);
    return (0, $lVOy4.identity)({
        inputs: {
            x: inputData.complexTensorInfos.imag
        },
        backend: backend
    });
}
const $5e02c437b2ab909b$export$ddfc128c2801add7 = {
    kernelName: (0, $9BGT9.Imag),
    backendName: 'webgl',
    kernelFunc: $5e02c437b2ab909b$export$d78fab5778ab392b
};

});



parcelRegister("j7Glz", function(module, exports) {

$parcel$export(module.exports, "conv2DConfig", function () { return $debf850150d0604b$export$4a39bf13b4378042; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $tdutJ = parcelRequire("tdutJ");

var $3ASjM = parcelRequire("3ASjM");

var $4zPxy = parcelRequire("4zPxy");

var $g4sZJ = parcelRequire("g4sZJ");

var $aNJFF = parcelRequire("aNJFF");
function $debf850150d0604b$export$188f9215482e3db8(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $dEVRx).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    let out;
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID')) out = (0, $g4sZJ.conv2dByMatMul)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
    else if (convInfo.strideWidth <= 2 && $dataFormat === 'channelsLast' && (0, $tdutJ.env)().getBool('WEBGL_EXP_CONV')) {
        const program = new (0, $4zPxy.Conv2DPackedProgram)(convInfo);
        const customValues = [
            [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ],
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ],
            [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ],
            [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        ];
        out = backend.runWebGLProgram(program, [
            x,
            filter
        ], 'float32', customValues);
    } else if ((0, $tdutJ.env)().getBool('WEBGL_CONV_IM2COL')) out = (0, $g4sZJ.conv2dWithIm2Row)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend
    });
    else {
        const program = new (0, $3ASjM.Conv2DProgram)(convInfo);
        out = backend.runWebGLProgram(program, [
            x,
            filter
        ], 'float32');
    }
    const outReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    backend.disposeIntermediateTensorInfo(out);
    return outReshaped;
}
const $debf850150d0604b$export$4a39bf13b4378042 = {
    kernelName: (0, $9BGT9.Conv2D),
    backendName: 'webgl',
    kernelFunc: $debf850150d0604b$export$188f9215482e3db8
};

});
parcelRegister("3ASjM", function(module, exports) {

$parcel$export(module.exports, "Conv2DProgram", function () { return $29dede56b514d5f2$export$8dc36706147178e9; });
$parcel$export(module.exports, "Conv3DProgram", function () { return $29dede56b514d5f2$export$67aff94cf1ececaf; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $29dede56b514d5f2$export$8dc36706147178e9 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivationWeights = false, hasLeakyreluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
        const inputDepthVec4Remainder = convInfo.inChannels % 4;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const channelDim = isChannelsLast ? 3 : 1;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivationWeights) activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyreluAlpha) activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivationWeights) this.variableNames.push('preluActivationWeights');
        if (hasLeakyreluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d2 = coords[${channelDim}];

        ivec2 xRCCorner =
            ivec2(coords[${rowDim}], coords[${colDim}]) * strides - pads;
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * ${dilationHeight};

          if (xR < 0 || xR >= ${convInfo.inHeight}) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * ${dilationWidth};

            if (xC < 0 || xC >= ${convInfo.inWidth}) {
              continue;
            }

            for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
              vec4 wValues = vec4(
                getW(wR, wC, d1, d2),
                getW(wR, wC, d1 + 1, d2),
                getW(wR, wC, d1 + 2, d2),
                getW(wR, wC, d1 + 3, d2)
              );

              if (${isChannelsLast}) {
                vec4 xValues = vec4(
                  getX(batch, xR, xC, d1),
                  getX(batch, xR, xC, d1 + 1),
                  getX(batch, xR, xC, d1 + 2),
                  getX(batch, xR, xC, d1 + 3)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec4 xValues = vec4(
                  getX(batch, d1, xR, xC),
                  getX(batch, d1 + 1, xR, xC),
                  getX(batch, d1 + 2, xR, xC),
                  getX(batch, d1 + 3, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }
            }

            if (${inputDepthVec4Remainder === 1}) {

              if (${isChannelsLast}) {
                dotProd +=
                    getX(batch, xR, xC, ${inputDepthNearestVec4}) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              } else {
                dotProd +=
                    getX(batch, ${inputDepthNearestVec4}, xR, xC) *
                    getW(wR, wC, ${inputDepthNearestVec4}, d2);
              }

            } else if (${inputDepthVec4Remainder === 2}) {
              vec2 wValues = vec2(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2)
              );

              if (${isChannelsLast}) {
                vec2 xValues = vec2(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec2 xValues = vec2(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            } else if (${inputDepthVec4Remainder === 3}) {
              vec3 wValues = vec3(
                getW(wR, wC, ${inputDepthNearestVec4}, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 1, d2),
                getW(wR, wC, ${inputDepthNearestVec4} + 2, d2)
              );

              if (${isChannelsLast}) {
                vec3 xValues = vec3(
                  getX(batch, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                dotProd += dot(xValues, wValues);
              } else {
                vec3 xValues = vec3(
                  getX(batch, ${inputDepthNearestVec4}, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 1, xR, xC),
                  getX(batch, ${inputDepthNearestVec4} + 2, xR, xC)
                );
                dotProd += dot(xValues, wValues);
              }

            }
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}
class $29dede56b514d5f2$export$67aff94cf1ececaf {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const inputDepthNearestVec4 = Math.floor(convInfo.inChannels / 4) * 4;
        const inputDepthVec4Remainder = convInfo.inChannels % 4;
        this.userCode = `
      const ivec3 strides = ivec3(${strideDepth}, ${strideHeight}, ${strideWidth});
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d2 = coords.u;

        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;
        int xFCorner = xFRCCorner.x;
        int xRCorner = xFRCCorner.y;
        int xCCorner = xFRCCorner.z;

        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get
        // y(yF, yR, yC, d2). ? = to be determined. : = across all
        // values in that axis.
        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          int xF = xFCorner + wF * ${dilationDepth};

          if (xF < 0 || xF >= ${convInfo.inDepth}) {
            continue;
          }

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            int xR = xRCorner + wR * ${dilationHeight};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              int xC = xCCorner + wC * ${dilationWidth};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              for (int d1 = 0; d1 < ${inputDepthNearestVec4}; d1 += 4) {
                vec4 xValues = vec4(
                  getX(batch, xF, xR, xC, d1),
                  getX(batch, xF, xR, xC, d1 + 1),
                  getX(batch, xF, xR, xC, d1 + 2),
                  getX(batch, xF, xR, xC, d1 + 3)
                );
                vec4 wValues = vec4(
                  getW(wF, wR, wC, d1, d2),
                  getW(wF, wR, wC, d1 + 1, d2),
                  getW(wF, wR, wC, d1 + 2, d2),
                  getW(wF, wR, wC, d1 + 3, d2)
                );

                dotProd += dot(xValues, wValues);
              }

              if (${inputDepthVec4Remainder === 1}) {
                dotProd +=
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}) *
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2);
              } else if (${inputDepthVec4Remainder === 2}) {
                vec2 xValues = vec2(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1)
                );
                vec2 wValues = vec2(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2)
                );
                dotProd += dot(xValues, wValues);
              } else if (${inputDepthVec4Remainder === 3}) {
                vec3 xValues = vec3(
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4}),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 1),
                  getX(batch, xF, xR, xC, ${inputDepthNearestVec4} + 2)
                );
                vec3 wValues = vec3(
                  getW(wF, wR, wC, ${inputDepthNearestVec4}, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 1, d2),
                  getW(wF, wR, wC, ${inputDepthNearestVec4} + 2, d2)
                );
                dotProd += dot(xValues, wValues);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});

parcelRegister("4zPxy", function(module, exports) {

$parcel$export(module.exports, "Conv2DPackedProgram", function () { return $3552691e9ff5a45e$export$20f35e9a79361289; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $SwRKX = parcelRequire("SwRKX");
class $3552691e9ff5a45e$export$20f35e9a79361289 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        const padLeft = convInfo.padInfo.left;
        const strideWidth = convInfo.strideWidth;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const texelsAcross = filterWidth;
        let mainLoop = `
       int xR; int xC; int xCOffset;
       vec4 wTexel; vec4 previous; vec4 final;`;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
           vec4 xTexelC${c * 2};
           int xTexelC${c * 2}Ready;
           vec4 xTexelC${c * 2 + 1};
           int xTexelC${c * 2 + 1}Ready;
           vec4 xC${c};`;
        /**
         * This vectorized implementation works by gathering the values needed for
         * each output channel's dot product into vec4's and then multiplying them
         * all together (this happens in the final double for-loop below). Most of
         * the main loop consists of constructing these vec4's with the minimum
         * number of texture2D calls, which means making use of all four returned
         * values from a texture2D call at once.
         */ mainLoop += `
     for (int r = 0; r < ${filterHeight}; r++) {
      for (int d1 = 0; d1 < ${convInfo.inChannels}; d1 += 2) {
       `;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
           xTexelC${c * 2} = vec4(0.0);
           xTexelC${c * 2}Ready = 0;
           xTexelC${c * 2 + 1} = vec4(0.0);
           xTexelC${c * 2 + 1}Ready = 0;
           xC${c} = vec4(0.0);`;
        mainLoop += `
         xR = xRCorner + r * dilations[0];
         if (xR >=0 && xR < inDims[0]) {
       `;
        for(let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++){
            const colIndex = texelC * 2;
            mainLoop += `
           xC = xCCorner + ${colIndex * dilationWidth};
           `;
            if (strideWidth === 1) {
                if (colIndex < filterWidth) {
                    // If padding is odd, the outer texels have to be composed.
                    if (padLeft % 2 === 1) {
                        // TODO: Ensure vec4 previous does not result in redundant sample,
                        // and avoid setting xTexelRC's that exceed the boundary in the
                        // first place rather than resetting them to vec4(0)).
                        // To compute xCOffset:
                        // - If padding is odd, we must add 1 to ensure we ask for an
                        // even-numbered row.
                        // - We subtract 2 to access the previous texel.
                        mainLoop += `
                 xCOffset = xC + 1;
                 if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }
               `;
                        // This texel has been read in previous iteration if the dilation
                        // is 1.
                        if (dilationWidth === 1 && colIndex > 0) mainLoop += `
                 xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                 `;
                        else mainLoop += `
                   xCOffset = xC + 1 - 2;

                   if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       previous.zw = vec2(0.0);
                     }

                     xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                   } else {
                     xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                   }
                   `;
                    } else // Padding is even, so xRC corresponds to a single texel.
                    mainLoop += `
                 if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 xC${colIndex} = xTexelC${colIndex};
                 `;
                    if (colIndex + 1 < filterWidth) {
                        // If dilation is even, the second entry should match the first
                        // (either both are composed or both are single samples). But if
                        // dilation is odd, then the second entry should be the opposite
                        // of the first (if the first is composed, the second is a single
                        // sample, and vice versa.)
                        const nextTexelOffset = padLeft % 2 === 0 ? (0, $lBDHD).nearestLargerEven(dilationWidth) : dilationWidth;
                        if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
                            mainLoop += `
                   xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                   if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                     xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                     // Need to manually clear unused channels in case
                     // we're reading from recycled texture.
                     if (xCOffset + 1 >= inDims[1]) {
                       xTexelC${colIndex + 1}.zw = vec2(0.0);
                     }
                     xTexelC${colIndex + 1}Ready = 1;
                   }
                   `;
                            // If dilation > 1 then the xRC's will not be able to share any
                            // values, so each xRC will require two unique calls to getX.
                            if (dilationWidth > 1) mainLoop += `
                     xCOffset -= 2;
                     if (xCOffset >= 0 && xCOffset < inDims[1]) {
                      previous = getX(batch, xR, xCOffset, d1);
                      xC${colIndex + 1} = vec4(previous.zw, xTexelC${colIndex + 1}.xy);
                     } else {
                      xC${colIndex + 1} = vec4(0.0, 0.0, xTexelC${colIndex + 1}.xy);
                     }
                     `;
                            else mainLoop += `
                     xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                     `;
                        } else // If dilation is 1 and padding is odd, we have already read the
                        // texel when constructing the previous x value. Here we can
                        // simply skip the texture read.
                        if (nextTexelOffset === 1) mainLoop += `
                     xC${colIndex + 1} = xTexelC${colIndex};
                     `;
                        else mainLoop += `
                     xCOffset = xC + ${nextTexelOffset};

                     if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                       xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                       if (xCOffset + 1 >= inDims[1]) {
                         xTexelC${colIndex + 1}.zw = vec2(0.0);
                       }
                       xTexelC${colIndex + 1}Ready = 1;
                     }

                     xC${colIndex + 1} = xTexelC${colIndex + 1};
                     `;
                    }
                }
            } else if (colIndex < filterWidth) {
                // Depending on whether padLeft is even or odd, we want either the
                // xy or zw channels from X texels for xC${colIndex}. If padLeft is
                // even, xC${colIndex +1} is simply the zw channels of texels we've
                // already sampled. But if padLeft is odd, xC{$c + 1}.zw will
                // need to come from the xy channels of a new texel, hence the `
                // vec4
                // final` initialized below.
                if (padLeft % 2 === 1) {
                    mainLoop += `
                 xCOffset = xC + 1 - strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                   xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                   // Need to manually clear unused channels in case
                   // we're reading from recycled texture.
                   if (xC + 2 >= inDims[1]) {
                     xTexelC${colIndex + 1}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex + 1}Ready = 1;
                 }

                 xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
               `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                   final = vec4(0.0);
                   xCOffset = xC + 1 + strides[1];
                   if(xCOffset >= 0 && xCOffset < inDims[1]) {
                     final = getX(batch, xR, xCOffset, d1);
                   }
                   xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                 `;
                } else {
                    mainLoop += `
                 if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                   xTexelC${colIndex} = getX(batch, xR, xC, d1);
                   if (xC + 1 >= inDims[1]) {
                     xTexelC${colIndex}.zw = vec2(0.0);
                   }
                   xTexelC${colIndex}Ready = 1;
                 }

                 xCOffset = xC + strides[1];
                 if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                   xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                   if (xCOffset + 1 >= inDims[1]) {
                     xTexelC${colIndex + 1}.zw = vec2(0.);
                   }
                   xTexelC${colIndex + 1}Ready = 1;
                 }

                 xC${colIndex} = vec4(
                   xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
               `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                   xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                 `;
                }
            }
            // localize the dotProd accumulation within the loop, the theory is for
            // GPU with limited cache, accumulate sum across large amount of
            // veriables will cause lots of cache misses. (i.e. 5x5 filter will have
            // 50 variables)
            if (colIndex < filterWidth) {
                mainLoop += `
             wTexel = getW(r, ${colIndex}, d1, d2);
             dotProd += xC${colIndex}.xxzz * vec4(wTexel.xy, wTexel.xy);
             if(d1 + 1 < ${convInfo.inChannels}) {
               dotProd += xC${colIndex}.yyww * vec4(wTexel.zw, wTexel.zw);
             }
           `;
                if (colIndex + 1 < filterWidth) mainLoop += `
               wTexel = getW(r, ${colIndex + 1}, d1, d2);
               dotProd += xC${colIndex + 1}.xxzz * vec4(wTexel.xy, wTexel.xy);
               if(d1 + 1 < ${convInfo.inChannels}) {
                 dotProd += xC${colIndex + 1}.yyww * vec4(wTexel.zw, wTexel.zw);
               }
             `;
            }
        }
        mainLoop += `
     }
   `;
        mainLoop += `
     }
   `;
        mainLoop += `
     }
   `;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
           vec4 b = getPreluActivationWeightsAtOutCoords();
           ${activation}
         }`;
            else if (hasLeakyReluAlpha) activationSnippet = `vec4 activation(vec4 a) {
           vec4 b = getLeakyreluAlphaAtOutCoords();
           ${activation}
         }`;
            else activationSnippet = `vec4 activation(vec4 x) {
           ${activation}
         }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
       ${activationSnippet}

       void main() {
         ivec4 coords = getOutputCoords();
         int batch = coords.x;
         ivec2 xRCCorner = coords.yz * strides - pads;
         int d2 = coords.w;
         int xRCorner = xRCCorner.x;
         int xCCorner = xRCCorner.y;

         //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
         vec4 dotProd = vec4(0.000000000000001);

         ${mainLoop}

         vec4 result = dotProd - vec4(0.000000000000001);
         ${addBiasSnippet}
         ${applyActivationSnippet}
         setOutput(result);
       }
     `;
    }
}

});

parcelRegister("g4sZJ", function(module, exports) {

$parcel$export(module.exports, "conv2dByMatMul", function () { return $bb3382d102c253dd$export$fe56ce0f8b4bfd45; });
$parcel$export(module.exports, "conv2dWithIm2Row", function () { return $bb3382d102c253dd$export$65b699e5c77381b8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $7JuTR = parcelRequire("7JuTR");

var $k2x5z = parcelRequire("k2x5z");

var $kX9AB = parcelRequire("kX9AB");

var $k42ZR = parcelRequire("k42ZR");

var $a1L4Y = parcelRequire("a1L4Y");

var $lVOy4 = parcelRequire("lVOy4");

var $aNJFF = parcelRequire("aNJFF");
// Both conv2dByMatMul and conv2dWithIm2Row fuse height and width into one
// dimension to compute batchMatMul, so bias and activation weights are also
// supposed to fuse the two dimensions into one.
//
// This function computes the target shape for fusing height and width
// dimensions. Returning null means the shape is already compatible.
//
// Even though the bias is not supposed to be a 3-D or a 4-D (including
// batch) tensor and PReLU activiation weights is not supposed to be a 4-D
// tensor, we still need to support them, because we haven't disabled
// them for NHWC format.
// https://github.com/tensorflow/tfjs/blob/b53bd47e880367ae57493f0ea628abaf08db2d5d/tfjs-core/src/ops/fused/conv2d.ts#L181-L196
function $bb3382d102c253dd$var$getShapeForBatchMatMul(shape, isChannelsLast) {
    const length = shape.length;
    if (length >= 3) return isChannelsLast ? [
        ...shape.slice(0, -3),
        shape[length - 3] * shape[length - 2],
        shape[length - 1]
    ] : [
        ...shape.slice(0, -3),
        shape[length - 3],
        shape[length - 2] * shape[length - 1]
    ];
    else if (!isChannelsLast && length === 1 && shape[0] > 1) return [
        shape[0],
        1
    ];
    else return null;
}
function $bb3382d102c253dd$export$fe56ce0f8b4bfd45({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Reshapes conv2D input to 2D tensors, uses matMul and then reshape the
    // result from 2D to 4D.
    const xShape = x.shape;
    const xTexData = backend.texData.get(x.dataId);
    const sharedMatMulDim = convInfo.inChannels;
    const outerShapeX = xShape[0] * xShape[1] * xShape[2];
    const outerShapeFilter = convInfo.outChannels;
    const isChannelsLast = convInfo.dataFormat === 'channelsLast';
    const transposeA = false;
    const transposeB = false;
    let out;
    const intermediates = [];
    if (preluActivationWeights != null) {
        const targetShape = $bb3382d102c253dd$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $aNJFF.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $bb3382d102c253dd$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $aNJFF.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    // TODO: Once reduction ops are packed, batchMatMul will always be packed
    // and we can remove this condition.
    const batchMatMulWillBeUnpacked = (outerShapeX === 1 || outerShapeFilter === 1) && sharedMatMulDim > (0, $a1L4Y.MATMUL_SHARED_DIM_THRESHOLD);
    // The algorithm in the if condition assumes (1) the output will be packed,
    // (2) x is packed, (3) x isChannelsLast, (4)  x's packed texture is already
    // on GPU, (5) col is odd, (6) the width, height and inChannels are the same
    // for xTexData.shape and xShape.
    const canOptimize = !batchMatMulWillBeUnpacked && xTexData.isPacked && isChannelsLast && xTexData.texture != null && xShape[2] % 2 !== 0 && (0, $lBDHD).arraysEqual(xTexData.shape.slice(-3), xShape.slice(-3));
    if (canOptimize) {
        // We avoid expensive packed 2x2 reshape by padding col count to next,
        // even number. When col is odd, the result of packed batchMatMul is
        // the same (has the same texture layout and and values in the texture) as
        // it is for next even col. We make the odd-cols tensor to look like
        // even-cols tensor before the operation and, after the batchMatMul,
        // fix the even-cols result to have odd number of cols.
        const targetShape = xShape[0] * xShape[1] * (xShape[2] + 1);
        const xReshaped = {
            dataId: x.dataId,
            shape: [
                1,
                targetShape,
                convInfo.inChannels
            ],
            dtype: x.dtype
        };
        // xTexData.shape gets referenced from GPGPUBinary.inShapeInfos.
        // Decrementing col count, after batchMatMul->...->compileProgram leads to
        // invalid col count within the reference in GPGPUBinary.inShapeInfos.
        // Alternative fix would be to provide a copy to GPGPUBinary.inShapeInfos
        // in compileProgram method, but that would affect compilation of all
        // programs - instead, provide a copy here, with even col count, before
        // calling batchMatMul->...->compileProgram and after that, the original
        // xTexData.shape is restored.
        const originalXTexDataShape = xTexData.shape;
        xTexData.shape = xTexData.shape.slice();
        xTexData.shape[xTexData.shape.length - 2]++;
        (0, $lBDHD).assert($k42ZR.isReshapeFree(xTexData.shape, xReshaped.shape), ()=>`packed reshape ${xTexData.shape} to ${xReshaped.shape} isn't free`);
        const filterReshaped = (0, $aNJFF.reshape)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
        intermediates.push(filterReshaped);
        const pointwiseConv = (0, $a1L4Y.batchMatMulImpl)({
            a: xReshaped,
            b: filterReshaped,
            backend: backend,
            transposeA: transposeA,
            transposeB: transposeB,
            bias: bias,
            activation: activation,
            preluActivationWeights: preluActivationWeights,
            leakyreluAlpha: leakyreluAlpha
        });
        const pointwiseConvTexData = backend.texData.get(pointwiseConv.dataId);
        (0, $lBDHD).assert(pointwiseConvTexData.isPacked, ()=>'batchMatMul result is expected to be packed');
        // Restore the input shape to original.
        xTexData.shape = originalXTexDataShape;
        // Set the output shape - there is no need for expensive reshape as data
        // layout is already correct.
        pointwiseConvTexData.shape = convInfo.outShape;
        out = (0, $lVOy4.identity)({
            inputs: {
                x: pointwiseConv
            },
            backend: backend
        });
        out.shape = convInfo.outShape;
        intermediates.push(pointwiseConv);
    } else {
        const numCols = convInfo.outHeight * convInfo.outWidth;
        const xReshaped = (0, $aNJFF.reshape)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                shape: isChannelsLast ? [
                    convInfo.batchSize,
                    numCols,
                    convInfo.inChannels
                ] : [
                    convInfo.batchSize,
                    convInfo.inChannels,
                    numCols
                ]
            }
        });
        const filterReshaped = (0, $aNJFF.reshape)({
            inputs: {
                x: filter
            },
            backend: backend,
            attrs: {
                shape: [
                    1,
                    convInfo.inChannels,
                    convInfo.outChannels
                ]
            }
        });
        const result = (0, $a1L4Y.batchMatMulImpl)({
            a: isChannelsLast ? xReshaped : filterReshaped,
            b: isChannelsLast ? filterReshaped : xReshaped,
            transposeA: !isChannelsLast,
            transposeB: transposeB,
            backend: backend,
            bias: bias,
            activation: activation,
            preluActivationWeights: preluActivationWeights,
            leakyreluAlpha: leakyreluAlpha
        });
        out = (0, $aNJFF.reshape)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                shape: convInfo.outShape
            }
        });
        intermediates.push(xReshaped);
        intermediates.push(filterReshaped);
        intermediates.push(result);
    }
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return out;
}
function $bb3382d102c253dd$export$65b699e5c77381b8({ x: x, filter: filter, convInfo: convInfo, backend: backend, bias: bias = null, preluActivationWeights: preluActivationWeights = null, leakyreluAlpha: leakyreluAlpha = 0, activation: activation = null }) {
    // Rearranges conv2d input so each block to be convolved over forms the
    // column of a new matrix with shape [filterWidth * filterHeight *
    // inChannels, outHeight * outWidth]. The filter is also rearranged so each
    // output channel forms a row of a new matrix with shape [outChannels,
    // filterWidth * filterHeight * inChannels]. The convolution is then
    // computed by multiplying these matrices and reshaping the result.
    const { filterWidth: filterWidth, filterHeight: filterHeight, inChannels: inChannels, outWidth: outWidth, outHeight: outHeight, dataFormat: dataFormat } = convInfo;
    const isChannelsLast = dataFormat === 'channelsLast';
    const sharedDim = filterWidth * filterHeight * inChannels;
    const numCols = outHeight * outWidth;
    const x2ColShape = [
        convInfo.batchSize,
        sharedDim,
        numCols
    ];
    const transposeA = true;
    const transposeB = false;
    const intermediates = [];
    if (preluActivationWeights != null) {
        const targetShape = $bb3382d102c253dd$var$getShapeForBatchMatMul(preluActivationWeights.shape, isChannelsLast);
        if (targetShape != null) {
            preluActivationWeights = (0, $aNJFF.reshape)({
                inputs: {
                    x: preluActivationWeights
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(preluActivationWeights);
        }
    }
    if (bias != null) {
        const targetShape = $bb3382d102c253dd$var$getShapeForBatchMatMul(bias.shape, isChannelsLast);
        if (targetShape != null) {
            bias = (0, $aNJFF.reshape)({
                inputs: {
                    x: bias
                },
                backend: backend,
                attrs: {
                    shape: targetShape
                }
            });
            intermediates.push(bias);
        }
    }
    const w2Row = (0, $aNJFF.reshape)({
        inputs: {
            x: filter
        },
        backend: backend,
        attrs: {
            shape: [
                1,
                sharedDim,
                (0, $lBDHD).sizeFromShape(filter.shape) / sharedDim
            ]
        }
    });
    intermediates.push(w2Row);
    const im2ColProgram = new (0, $7JuTR.Im2ColPackedProgram)(x2ColShape, convInfo);
    const customValues = [
        x.shape,
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inChannels
        ],
        [
            convInfo.filterWidth * convInfo.inChannels
        ],
        [
            convInfo.outWidth
        ]
    ];
    const im2Col = backend.runWebGLProgram(im2ColProgram, [
        x
    ], 'float32', customValues);
    const im2ColReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: im2Col
        },
        backend: backend,
        attrs: {
            shape: x2ColShape
        }
    });
    intermediates.push(im2Col);
    intermediates.push(im2ColReshaped);
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const fusedActivation = activation ? (0, $k2x5z.mapActivationToShaderProgram)(activation, true) : null;
    const matmulProgram = new (0, $kX9AB.MatMulPackedProgram)(isChannelsLast ? im2ColReshaped.shape : w2Row.shape, isChannelsLast ? w2Row.shape : im2ColReshaped.shape, isChannelsLast ? [
        convInfo.batchSize,
        numCols,
        convInfo.outChannels
    ] : [
        convInfo.batchSize,
        convInfo.outChannels,
        numCols
    ], transposeA, transposeB, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const inputs = isChannelsLast ? [
        im2ColReshaped,
        w2Row
    ] : [
        w2Row,
        im2ColReshaped
    ];
    if (bias) inputs.push(bias);
    if (hasPreluActivationWeights) inputs.push(preluActivationWeights);
    if (hasLeakyreluAlpha) {
        const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $lBDHD).createScalarValue(leakyreluAlpha, 'float32'));
        inputs.push($leakyreluAlpha);
        intermediates.push($leakyreluAlpha);
    }
    const product = backend.runWebGLProgram(matmulProgram, inputs, 'float32');
    const out = (0, $aNJFF.reshape)({
        inputs: {
            x: product
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(product);
    for (const i of intermediates)backend.disposeIntermediateTensorInfo(i);
    return out;
}

});
parcelRegister("7JuTR", function(module, exports) {

$parcel$export(module.exports, "Im2ColPackedProgram", function () { return $5a14b4746eb865b5$export$d76a638e68b7f211; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");

var $SwRKX = parcelRequire("SwRKX");
class $5a14b4746eb865b5$export$d76a638e68b7f211 {
    constructor(outputShape, convInfo){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'inputShape',
                type: 'ivec4'
            },
            {
                name: 'pad',
                type: 'ivec2'
            },
            {
                name: 'stride',
                type: 'ivec2'
            },
            {
                name: 'dilation',
                type: 'ivec2'
            },
            {
                name: 'inChannels',
                type: 'int'
            },
            {
                name: 'itemsPerBlockRow',
                type: 'int'
            },
            {
                name: 'outWidth',
                type: 'int'
            }
        ];
        this.outputShape = outputShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        const { dataFormat: dataFormat } = convInfo;
        const glsl = (0, $8qxEr.getGlslDifferences)();
        const isChannelsLast = dataFormat === 'channelsLast';
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const boundsCheckingSnippet = this.enableShapeUniforms ? 'if(blockIndex < outShape[2] && pos < outShape[1]) {' : `if(blockIndex < ${outputShape[2]} && pos < ${outputShape[1]}) {`;
        let unrolled = ``;
        for(let row = 0; row <= 1; row++)for(let col = 0; col <= 1; col++)unrolled += `
          blockIndex = rc.z + ${col};
          pos = rc.y + ${row};

          ${boundsCheckingSnippet}
            offsetY = int(blockIndex / outWidth) * stride[0] - pad[0];
            d0 = offsetY + dilation[0] * (pos / itemsPerBlockRow);

            if(d0 < inputShape[${rowDim}] && d0 >= 0) {
              // Use custom imod instead mod. On Intel GPU, mod may generate
              // unexpected value.
              // https://github.com/tensorflow/tfjs/issues/5447
              offsetX = imod(blockIndex, outWidth) * stride[1] - pad[1];
              d1 = offsetX + dilation[1] * (imod(pos, itemsPerBlockRow) /
                  inChannels);

              if(d1 < inputShape[${colDim}] && d1 >= 0) {

                ch = imod(pos, inChannels);

                if (${isChannelsLast}) {
                  innerDims = vec2(d1, ch);
                  result[${row * 2 + col}] = getChannel(
                    getA(rc.x, d0, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                } else {
                  innerDims = vec2(d0, d1);
                  result[${row * 2 + col}] = getChannel(
                    getA(rc.x, ch, int(innerDims.x),
                    int(innerDims.y)), innerDims);
                }
              }
            }
          }
        `;
        this.userCode = `
      void main() {
        ivec3 rc = getOutputCoords();

        vec4 result = vec4(0);

        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;
        vec2 innerDims;

        ${unrolled}

        ${glsl.output} = result;
      }
    `;
    }
}

});



parcelRegister("eJFMQ", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropFilterConfig", function () { return $aba5aea6c6c98fa2$export$7a95f55d2d2e7d24; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $k2Lf6 = parcelRequire("k2Lf6");
function $aba5aea6c6c98fa2$export$652a30c9379f3de7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const $dataFormat = (0, $dEVRx).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    const program = new (0, $k2Lf6.Conv2DDerFilterProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $aba5aea6c6c98fa2$export$7a95f55d2d2e7d24 = {
    kernelName: (0, $9BGT9.Conv2DBackpropFilter),
    backendName: 'webgl',
    kernelFunc: $aba5aea6c6c98fa2$export$652a30c9379f3de7
};

});
parcelRegister("k2Lf6", function(module, exports) {

$parcel$export(module.exports, "Conv2DDerFilterProgram", function () { return $e978a3ef29ed293c$export$1223560f67be2f2d; });
$parcel$export(module.exports, "Conv2DDerInputProgram", function () { return $e978a3ef29ed293c$export$5dc650171c0f6623; });
$parcel$export(module.exports, "Conv3DDerFilterProgram", function () { return $e978a3ef29ed293c$export$932d18866f409cf3; });
$parcel$export(module.exports, "Conv3DDerInputProgram", function () { return $e978a3ef29ed293c$export$acda329ff653a25; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $e978a3ef29ed293c$export$1223560f67be2f2d {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int d2 = coords.w;

        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              ${isChannelsLast ? `float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);` : `float dyValue = getDy(b, d2, yR, yC);
              float xValue = getX(b, d1, xR, xC);
              dotProd += (xValue * dyValue);`}
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $e978a3ef29ed293c$export$5dc650171c0f6623 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const isChannelsLast = convInfo.dataFormat === 'channelsLast';
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        const rowDim = isChannelsLast ? 1 : 2;
        const colDim = isChannelsLast ? 2 : 3;
        const channelDim = isChannelsLast ? 3 : 1;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[${channelDim}];

        ivec2 dyCorner = ivec2(coords[${rowDim}], coords[${colDim}]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {

              if (${isChannelsLast}) {
                float xValue = getDy(batch, idyR, idyC, d2);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              } else {
                float xValue = getDy(batch, d2, idyR, idyC);
                float wValue = getW(wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }

            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $e978a3ef29ed293c$export$932d18866f409cf3 {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padFront = convInfo.padInfo.front;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        this.userCode = `
      void main() {
        ivec5 coords = getOutputCoords();
        int wF = coords.x;
        int wR = coords.y;
        int wC = coords.z;
        int d1 = coords.w;
        int d2 = coords.u;

        float dotProd = 0.0;

        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yF = 0; yF < ${convInfo.outDepth}; yF++) {
            int xF = wF + yF * ${strideDepth} - ${padFront};

            if (xF < 0 || xF >= ${convInfo.inDepth}) {
              continue;
            }

            for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
              int xR = wR + yR * ${strideHeight} - ${padTop};

              if (xR < 0 || xR >= ${convInfo.inHeight}) {
                continue;
              }

              for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
                int xC = wC + yC * ${strideWidth} - ${padLeft};

                if (xC < 0 || xC >= ${convInfo.inWidth}) {
                  continue;
                }

                float dyValue = getDy(b, yF, yR, yC, d2);
                float xValue = getX(b, xF, xR, xC, d1);
                dotProd += (xValue * dyValue);
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $e978a3ef29ed293c$export$acda329ff653a25 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterDepth = convInfo.filterDepth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padFront = filterDepth - 1 - convInfo.padInfo.front;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.u;


        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyFCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        float dotProd = 0.0;
        for (int wF = 0; wF < ${filterDepth}; wF++) {
          float dyF = float(dyFCorner + wF) / ${strideDepth}.0;

          if (dyF < 0.0 || dyF >= ${convInfo.outDepth}.0 || fract(dyF) > 0.0) {
            continue;
          }
          int idyF = int(dyF);

          int wFPerm = ${filterDepth} - 1 - wF;

          for (int wR = 0; wR < ${filterHeight}; wR++) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
              fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            int wRPerm = ${filterHeight} - 1 - wR;

            for (int wC = 0; wC < ${filterWidth}; wC++) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              int wCPerm = ${filterWidth} - 1 - wC;

              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2++) {
                float xValue = getDy(batch, idyF, idyR, idyC, d2);
                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);
                dotProd += xValue * wValue;
              }
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});


parcelRegister("8uNdK", function(module, exports) {

$parcel$export(module.exports, "conv2DBackpropInputConfig", function () { return $62f74e462c77efb9$export$19bbc19fff1ed26f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $tdutJ = parcelRequire("tdutJ");

var $k2Lf6 = parcelRequire("k2Lf6");

var $eLoUc = parcelRequire("eLoUc");
function $62f74e462c77efb9$export$633310eed0c26e72(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { inputShape: inputShape, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const $dataFormat = (0, $dEVRx).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $dEVRx).computeConv2DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad, dimRoundingMode, false, $dataFormat);
    if ((0, $tdutJ.env)().getBool('WEBGL_PACK_CONV2DTRANSPOSE') && $dataFormat === 'channelsLast') {
        const customValues = [
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ]
        ];
        const program = new (0, $eLoUc.Conv2DDerInputPackedProgram)(convInfo);
        return backend.runWebGLProgram(program, [
            dy,
            filter
        ], 'float32', customValues);
    } else {
        const program = new (0, $k2Lf6.Conv2DDerInputProgram)(convInfo);
        return backend.runWebGLProgram(program, [
            dy,
            filter
        ], 'float32');
    }
}
const $62f74e462c77efb9$export$19bbc19fff1ed26f = {
    kernelName: (0, $9BGT9.Conv2DBackpropInput),
    backendName: 'webgl',
    kernelFunc: $62f74e462c77efb9$export$633310eed0c26e72
};

});
parcelRegister("eLoUc", function(module, exports) {

$parcel$export(module.exports, "Conv2DDerInputPackedProgram", function () { return $abf8c62d3e4cd415$export$9ade432542e381ca; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $SwRKX = parcelRequire("SwRKX");
class $abf8c62d3e4cd415$export$9ade432542e381ca {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'strides',
                type: 'vec2'
            }
        ];
        this.outputShape = convInfo.inShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];

        ivec2 dyCorner = ivec2(coords[1], coords[2]) - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        vec4 result = vec4(0.);
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / strides[0];
          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);
          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int wCPerm = ${filterWidth} - 1 - wC;

            float dyC = float(dyCCorner + wC) / strides[1];
            bool idyCVal = (dyC >= 0.0) && (dyC < ${convInfo.outWidth}.0)
              && (fract(dyC) == 0.0);
            int idyC = int(dyC);

            float dyC2 = float(dyCCorner + wC + 1) / strides[1];
            bool idyCVal2 = (dyC2 >= 0.0) && (dyC2 < ${convInfo.outWidth}.0)
              && (fract(dyC2) == 0.0);
            int idyC2 = int(dyC2);

            if (idyCVal && idyCVal2) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC, d2);
                vec4 dySample2 = (idyC / 2 == idyC2 / 2) ?
                  dySample : getDy(batch, idyR, idyC2, d2);

                vec2 dyValue = mod(float(idyC), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.xy += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));

                dyValue = mod(float(idyC2), 2.) == 0. ?
                  dySample2.xy : dySample2.zw;
                result.zw += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            } else if (idyCVal) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC, d2);
                vec2 dyValue = mod(float(idyC), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.xy += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            } else if (idyCVal2) {
              for (int d2 = 0; d2 < ${convInfo.outChannels}; d2 += 2) {
                vec4 wValue = getW(wRPerm, wCPerm, d1, d2);
                vec4 dySample = getDy(batch, idyR, idyC2, d2);
                vec2 dyValue = mod(float(idyC2), 2.) == 0. ?
                  dySample.xy : dySample.zw;
                result.zw += vec2(dot(dyValue, wValue.xy),
                  dot(dyValue, wValue.zw));
              }
            }
          }
        }
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("7kR0w", function(module, exports) {

$parcel$export(module.exports, "conv3DConfig", function () { return $557384d0692a72af$export$1fe590fda0829040; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $3ASjM = parcelRequire("3ASjM");
function $557384d0692a72af$export$1929932f31d07956(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $dEVRx).computeConv3DInfo(x.shape, filter.shape, strides, dilations, pad);
    const program = new (0, $3ASjM.Conv3DProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32');
}
const $557384d0692a72af$export$1fe590fda0829040 = {
    kernelName: (0, $9BGT9.Conv3D),
    backendName: 'webgl',
    kernelFunc: $557384d0692a72af$export$1929932f31d07956
};

});

parcelRegister("9FFfP", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropFilterV2Config", function () { return $70a7f1a068e87468$export$6dce9169640850fa; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $k2Lf6 = parcelRequire("k2Lf6");
function $70a7f1a068e87468$export$b57760dc3101cea7(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, pad: pad, filterShape: filterShape } = attrs;
    const convInfo = (0, $dEVRx).computeConv3DInfo(x.shape, filterShape, strides, 1 /* dilations */ , pad);
    const program = new (0, $k2Lf6.Conv3DDerFilterProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $70a7f1a068e87468$export$6dce9169640850fa = {
    kernelName: (0, $9BGT9.Conv3DBackpropFilterV2),
    backendName: 'webgl',
    kernelFunc: $70a7f1a068e87468$export$b57760dc3101cea7
};

});

parcelRegister("9vESg", function(module, exports) {

$parcel$export(module.exports, "conv3DBackpropInputConfig", function () { return $6ec6b714a997b806$export$cdcac766a3ef1744; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $k2Lf6 = parcelRequire("k2Lf6");
function $6ec6b714a997b806$export$deb6d1ca1fa2977b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { pad: pad, strides: strides, inputShape: inputShape } = attrs;
    const convInfo = (0, $dEVRx).computeConv3DInfo(inputShape, filter.shape, strides, 1 /* dilations */ , pad);
    const program = new (0, $k2Lf6.Conv3DDerInputProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $6ec6b714a997b806$export$cdcac766a3ef1744 = {
    kernelName: (0, $9BGT9.Conv3DBackpropInputV2),
    backendName: 'webgl',
    kernelFunc: $6ec6b714a997b806$export$deb6d1ca1fa2977b
};

});

parcelRegister("gBPLr", function(module, exports) {

$parcel$export(module.exports, "cosConfig", function () { return $c17841559a2464c6$export$ff099a1da5235a7e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $12pF4 = parcelRequire("12pF4");

var $k2x5z = parcelRequire("k2x5z");
const $c17841559a2464c6$var$COS = (0, $k2x5z.CHECK_NAN_SNIPPET_UNARY) + `
  return cos(x);
`;
const $c17841559a2464c6$var$COS_PACKED = `
  vec4 result = cos(x);
  bvec4 isNaN = isnan(x);
  ${(0, $12pF4.CHECK_NAN_SNIPPET_PACKED)}
  return result;
`;
const $c17841559a2464c6$export$50d414a77b60d802 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $c17841559a2464c6$var$COS,
    packedOpSnippet: $c17841559a2464c6$var$COS_PACKED
});
const $c17841559a2464c6$export$ff099a1da5235a7e = {
    kernelName: (0, $9BGT9.Cos),
    backendName: 'webgl',
    kernelFunc: $c17841559a2464c6$export$50d414a77b60d802
};

});

parcelRegister("9cz55", function(module, exports) {

$parcel$export(module.exports, "coshConfig", function () { return $6b30726644a9bd79$export$c5824052b09ba0ed; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $6b30726644a9bd79$var$COSH = `
  float e2x = exp(-x);
  return (e2x + 1.0 / e2x) / 2.0;
`;
const $6b30726644a9bd79$export$2e2fd1ad24e4d350 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $6b30726644a9bd79$var$COSH
});
const $6b30726644a9bd79$export$c5824052b09ba0ed = {
    kernelName: (0, $9BGT9.Cosh),
    backendName: 'webgl',
    kernelFunc: $6b30726644a9bd79$export$2e2fd1ad24e4d350
};

});

parcelRegister("2Jg4s", function(module, exports) {

$parcel$export(module.exports, "cropAndResizeConfig", function () { return $1fcc40194390c635$export$f7086edcf0050c7f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $bExgF = parcelRequire("bExgF");
const $1fcc40194390c635$export$6f0f0090e1f6cd3c = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, boxes: boxes, boxInd: boxInd } = inputs;
    const { cropSize: cropSize, method: method, extrapolationValue: extrapolationValue } = attrs;
    const program = new (0, $bExgF.CropAndResizeProgram)(image.shape, boxes.shape, cropSize, method, extrapolationValue);
    return backend.runWebGLProgram(program, [
        image,
        boxes,
        boxInd
    ], 'float32');
};
const $1fcc40194390c635$export$f7086edcf0050c7f = {
    kernelName: (0, $9BGT9.CropAndResize),
    backendName: 'webgl',
    kernelFunc: $1fcc40194390c635$export$6f0f0090e1f6cd3c
};

});
parcelRegister("bExgF", function(module, exports) {

$parcel$export(module.exports, "CropAndResizeProgram", function () { return $87bd3c6c12a9d102$export$c889a58f7ea63106; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $87bd3c6c12a9d102$export$c889a58f7ea63106 {
    constructor(imageShape, boxShape, cropSize, method, extrapolationValue){
        this.variableNames = [
            'Image',
            'Boxes',
            'BoxInd'
        ];
        this.outputShape = [];
        const [batch, imageHeight, imageWidth, depth] = imageShape;
        const [numBoxes] = boxShape;
        const [cropHeight, cropWidth] = cropSize;
        this.outputShape = [
            numBoxes,
            cropHeight,
            cropWidth,
            depth
        ];
        const methodId = method === 'bilinear' ? 1 : 0;
        const [inputHeightFloat, inputWidthFloat] = [
            `${imageHeight - 1}.0`,
            `${imageWidth - 1}.0`
        ];
        const [heightRatio, heightScale, inY] = cropHeight > 1 ? [
            `${(imageHeight - 1) / (cropHeight - 1)}`,
            '(y2-y1) * height_ratio',
            `y1*${inputHeightFloat} + float(y)*(height_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (y1+y2) * ${inputHeightFloat}`
        ];
        const [widthRatio, widthScale, inX] = cropWidth > 1 ? [
            `${(imageWidth - 1) / (cropWidth - 1)}`,
            '(x2-x1) * width_ratio',
            `x1*${inputWidthFloat} + float(x)*(width_scale)`
        ] : [
            '0.0',
            '0.0',
            `0.5 * (x1+x2) * ${inputWidthFloat}`
        ];
        // Reference implementation
        // tslint:disable-next-line:max-line-length
        // https://github.com/tensorflow/tensorflow/blob/master/tensorflow/core/kernels/crop_and_resize_op_gpu.cu.cc
        this.userCode = `
      const float height_ratio = float(${heightRatio});
      const float width_ratio = float(${widthRatio});
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int y = coords[1];
        int x = coords[2];
        int d = coords[3];

        // get box vals
        float y1 = getBoxes(b,0);
        float x1 = getBoxes(b,1);
        float y2 = getBoxes(b,2);
        float x2 = getBoxes(b,3);

        // get image in batch index
        int bInd = round(getBoxInd(b));
        if(bInd < 0 || bInd >= ${batch}) {
          return;
        }

        float height_scale = ${heightScale};
        float width_scale = ${widthScale};

        float in_y = ${inY};
        if( in_y < 0.0 || in_y > ${inputHeightFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }
        float in_x = ${inX};
        if( in_x < 0.0 || in_x > ${inputWidthFloat} ) {
          setOutput(float(${extrapolationValue}));
          return;
        }

        vec2 sourceFracIndexCR = vec2(in_x,in_y);
        if(${methodId} == 1) {
          // Compute the four integer indices.
          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);
          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));

          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);
          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);
          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);
          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);

          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);

          float top = topLeft + (topRight - topLeft) * fracCR.x;
          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;
          float newValue = top + (bottom - top) * fracCR.y;
          setOutput(newValue);
        } else {
          // Compute the coordinators of nearest neighbor point.
          ivec2 sourceNearestCR = ivec2(floor(
            sourceFracIndexCR + vec2(0.5,0.5)));
          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);
          setOutput(newValue);
        }
      }
    `;
    }
}

});


parcelRegister("jAf7p", function(module, exports) {

$parcel$export(module.exports, "cumprodConfig", function () { return $e41d1b5b2e47965d$export$db50d81ed60c5a35; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $lI03n = parcelRequire("lI03n");

var $aqu17 = parcelRequire("aqu17");
function $e41d1b5b2e47965d$export$dc7513e907e94b8d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $aqu17.cumImpl)((0, $lI03n.CumOpType).Prod, x, backend, axis, exclusive, reverse);
}
const $e41d1b5b2e47965d$export$db50d81ed60c5a35 = {
    kernelName: (0, $9BGT9.Cumprod),
    backendName: 'webgl',
    kernelFunc: $e41d1b5b2e47965d$export$dc7513e907e94b8d
};

});
parcelRegister("lI03n", function(module, exports) {

$parcel$export(module.exports, "CumOpType", function () { return $fcddbfaa3270c433$export$5245168906ddd3d9; });
$parcel$export(module.exports, "CumProgram", function () { return $fcddbfaa3270c433$export$6788a4605888e813; });

var $1eI1C = parcelRequire("1eI1C");
var $fcddbfaa3270c433$export$5245168906ddd3d9;
(function(CumOpType) {
    CumOpType["Prod"] = "*";
    CumOpType["Sum"] = "+";
})($fcddbfaa3270c433$export$5245168906ddd3d9 || ($fcddbfaa3270c433$export$5245168906ddd3d9 = {}));
class $fcddbfaa3270c433$export$6788a4605888e813 {
    constructor(op, outputShape, exclusive, reverse){
        this.op = op;
        this.outputShape = outputShape;
        this.variableNames = [
            'x'
        ];
        this.customUniforms = [
            {
                name: 'index',
                type: 'float'
            }
        ];
        const rank = this.outputShape.length;
        const initVal = this.op === $fcddbfaa3270c433$export$5245168906ddd3d9.Prod ? '1.0' : '0.0';
        const val = exclusive ? initVal : `getX(${$fcddbfaa3270c433$var$getCoords(rank, 'coords', this.op)})`;
        const length = this.outputShape[this.outputShape.length - 1];
        let condition = '';
        let idxString = '';
        // When exclusive is set, the cum op becomes roll op that copies the
        // value from the previous index based on the direction specified by the
        // reverse flag.
        if (exclusive) {
            condition = reverse ? `end != ${length - 1}` : 'end != 0';
            idxString = reverse ? 'end + 1' : 'end - 1';
        } else {
            condition = reverse ? `end + pow2 < ${length}` : 'end >= pow2';
            idxString = reverse ? 'end + pow2' : 'end - pow2';
        }
        this.userCode = `
      void main() {
        ${(0, $1eI1C.getCoordsDataType)(rank)} coords = getOutputCoords();
        int end = ${$fcddbfaa3270c433$var$getFinalCoord(rank, 'coords', this.op)};
        float val = ${val};
        int pow2 = int(pow(2.0, index));
        if (${condition}) {
          int idx = ${idxString};
          ${$fcddbfaa3270c433$var$getFinalCoord(rank, 'coords', this.op)} = idx;
          val ${this.op}= getX(${$fcddbfaa3270c433$var$getCoords(rank, 'coords', this.op)});
        }
        setOutput(val);
      }
    `;
    }
}
function $fcddbfaa3270c433$var$getCoords(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.x, ${name}.y`;
    else if (rank === 3) return `${name}.x, ${name}.y, ${name}.z`;
    else if (rank === 4) return `${name}.x, ${name}.y, ${name}.z, ${name}.w`;
    else throw new Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}
function $fcddbfaa3270c433$var$getFinalCoord(rank, name, op) {
    if (rank === 1) return `${name}`;
    else if (rank === 2) return `${name}.y`;
    else if (rank === 3) return `${name}.z`;
    else if (rank === 4) return `${name}.w`;
    else throw new Error(`Cumulative ${op} for rank ${rank} is not yet supported`);
}

});

parcelRegister("aqu17", function(module, exports) {

$parcel$export(module.exports, "cumImpl", function () { return $79739de061115c62$export$88973bdd32b5a724; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");

var $lI03n = parcelRequire("lI03n");

var $lVOy4 = parcelRequire("lVOy4");

var $fZ5E6 = parcelRequire("fZ5E6");
function $79739de061115c62$export$88973bdd32b5a724(op, x, backend, axis, exclusive, reverse) {
    const xRank = x.shape.length;
    const permutation = (0, $dEVRx).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) permutedX = (0, $fZ5E6.transpose)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            perm: permutation
        }
    });
    const permutedAxis = (0, $dEVRx).getInnerMostAxes(1, xRank)[0];
    if (permutedAxis !== xRank - 1) throw new Error(`WebGL cumprod shader expects an inner-most axis=${x.shape.length - 1} ` + `but got axis=${axis}`);
    const size = permutedX.shape[permutedAxis];
    let result = (0, $lVOy4.identity)({
        inputs: {
            x: permutedX
        },
        backend: backend
    });
    // Use cum parallel algorithm, inspired by:
    // https://developer.nvidia.com/gpugems/gpugems3/part-vi-gpu-computing/chapter-39-parallel-prefix-sum-scan-cuda
    // Note: although the algorithm is called sum, it works for any associtative
    // operator with an identity.
    for(let i = 0; i <= Math.ceil(Math.log2(size)) - 1; i++){
        const program = new (0, $lI03n.CumProgram)(op, permutedX.shape, false, reverse);
        const customValues = [
            [
                i
            ]
        ];
        const prevResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], result.dtype, customValues);
        backend.disposeIntermediateTensorInfo(prevResult);
    }
    // For exclusive cum, shift the end result in the direction of product or sum
    // and add 1 for product or 0 for sum to the front index.
    if (exclusive) {
        const program = new (0, $lI03n.CumProgram)(op, permutedX.shape, exclusive, reverse);
        const prevResult = result;
        result = backend.runWebGLProgram(program, [
            result
        ], result.dtype);
        backend.disposeIntermediateTensorInfo(prevResult);
    }
    if (permutation != null) {
        const reversePermutation = (0, $dEVRx).getUndoAxesPermutation(permutation);
        const reverseTransposedResult = (0, $fZ5E6.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: reversePermutation
            }
        });
        backend.disposeIntermediateTensorInfo(result);
        backend.disposeIntermediateTensorInfo(permutedX);
        return reverseTransposedResult;
    }
    return result;
}

});


parcelRegister("1HvoH", function(module, exports) {

$parcel$export(module.exports, "cumsumConfig", function () { return $13d229707d573bd7$export$2f6196f3316e7ed2; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $lI03n = parcelRequire("lI03n");

var $aqu17 = parcelRequire("aqu17");
function $13d229707d573bd7$export$71990b1e1c4912fe(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, exclusive: exclusive, reverse: reverse } = attrs;
    return (0, $aqu17.cumImpl)((0, $lI03n.CumOpType).Sum, x, backend, axis, exclusive, reverse);
}
const $13d229707d573bd7$export$2f6196f3316e7ed2 = {
    kernelName: (0, $9BGT9.Cumsum),
    backendName: 'webgl',
    kernelFunc: $13d229707d573bd7$export$71990b1e1c4912fe
};

});

parcelRegister("8jD8J", function(module, exports) {

$parcel$export(module.exports, "denseBincountConfig", function () { return $60de7571cd8e8dbc$export$88ba267b84334692; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $60de7571cd8e8dbc$export$436934e6cf1946f1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, weights: weights } = inputs;
    const { size: size, binaryOutput: binaryOutput } = attrs;
    if (x.shape.length === 1) {
        const xVals = backend.readSync(x.dataId);
        const weightsVals = backend.readSync(weights.dataId);
        const outVals = (0, $glyiU.bincountImplCPU)(xVals, weightsVals, weights.dtype, weights.shape, size);
        return backend.makeTensorInfo([
            size
        ], weights.dtype, outVals);
    } else if (x.shape.length === 2) {
        const xBuf = backend.bufferSync(x);
        const weightsBuf = backend.bufferSync(weights);
        const outBuf = (0, $glyiU.bincountReduceImplCPU)(xBuf, weightsBuf, size, binaryOutput);
        return backend.makeTensorInfo(outBuf.shape, weights.dtype, outBuf.values);
    }
    throw new Error(`Error in denseBincount: input must be at most rank 2, but got rank` + `${x.shape.length}.`);
}
const $60de7571cd8e8dbc$export$88ba267b84334692 = {
    kernelName: (0, $9BGT9.DenseBincount),
    backendName: 'webgl',
    kernelFunc: $60de7571cd8e8dbc$export$436934e6cf1946f1
};

});

parcelRegister("k6EQl", function(module, exports) {

$parcel$export(module.exports, "depthToSpaceConfig", function () { return $ea340cd45856dfe0$export$9c5b88dcb1d2008b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $jpb52 = parcelRequire("jpb52");
function $ea340cd45856dfe0$export$3b50daec0f185f12(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockSize: blockSize, dataFormat: dataFormat } = attrs;
    const batchSize = x.shape[0];
    const inputHeight = dataFormat === 'NHWC' ? x.shape[1] : x.shape[2];
    const inputWidth = dataFormat === 'NHWC' ? x.shape[2] : x.shape[3];
    const inputDepth = dataFormat === 'NHWC' ? x.shape[3] : x.shape[1];
    const outputHeight = inputHeight * blockSize;
    const outputWidth = inputWidth * blockSize;
    const outputDepth = inputDepth / (blockSize * blockSize);
    const outputShape = dataFormat === 'NHWC' ? [
        batchSize,
        outputHeight,
        outputWidth,
        outputDepth
    ] : [
        batchSize,
        outputDepth,
        outputHeight,
        outputWidth
    ];
    const program = new (0, $jpb52.DepthToSpaceProgram)(outputShape, blockSize, dataFormat);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $ea340cd45856dfe0$export$9c5b88dcb1d2008b = {
    kernelName: (0, $9BGT9.DepthToSpace),
    backendName: 'webgl',
    kernelFunc: $ea340cd45856dfe0$export$3b50daec0f185f12
};

});
parcelRegister("jpb52", function(module, exports) {

$parcel$export(module.exports, "DepthToSpaceProgram", function () { return $e208f26e40261c22$export$eb07f17369165f28; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $e208f26e40261c22$export$eb07f17369165f28 {
    constructor(outputShape, blockSize, dataFormat){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.outputShape = outputShape;
        this.blockSize = blockSize;
        this.dataFormat = dataFormat;
        this.userCode = `
    void main() {
      ivec4 coords = getOutputCoords();
      int b = coords[0];
      int h = ${this.getHeightCoordString()};
      int w = ${this.getWidthCoordString()};
      int d = ${this.getDepthCoordString()};

      int in_h = h / ${blockSize};
      int offset_h = imod(h, ${blockSize});
      int in_w = w / ${blockSize};
      int offset_w = imod(w, ${blockSize});
      int offset_d = (offset_h * ${blockSize} + offset_w) *
        ${this.getOutputDepthSize()};
      int in_d = d + offset_d;

      float result = ${this.getInputSamplingString()};
      setOutput(result);
    }
  `;
    }
    getHeightCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[1]`;
        else return `coords[2]`;
    }
    getWidthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[2]`;
        else return `coords[3]`;
    }
    getDepthCoordString() {
        if (this.dataFormat === 'NHWC') return `coords[3]`;
        else return `coords[1]`;
    }
    getOutputDepthSize() {
        if (this.dataFormat === 'NHWC') return this.outputShape[3];
        else return this.outputShape[1];
    }
    getInputSamplingString() {
        if (this.dataFormat === 'NHWC') return `getX(b, in_h, in_w, in_d)`;
        else return `getX(b, in_d, in_h, in_w)`;
    }
}

});


parcelRegister("ln1JP", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeConfig", function () { return $f8ed181ae27bceed$export$240667804b7c390e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $tdutJ = parcelRequire("tdutJ");
var $lBDHD = parcelRequire("lBDHD");

var $g4BN9 = parcelRequire("g4BN9");

var $42TvE = parcelRequire("42TvE");
function $f8ed181ae27bceed$export$14e793fe8822afd1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode } = attrs;
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $lBDHD).assert((0, $dEVRx).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    let program;
    if ((0, $tdutJ.env)().getBool('WEBGL_PACK_DEPTHWISECONV') && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1) program = new (0, $42TvE.DepthwiseConvPacked2DProgram)(convInfo);
    else program = new (0, $g4BN9.DepthwiseConv2DProgram)(convInfo);
    const customValues = [
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inHeight,
            convInfo.inWidth
        ]
    ];
    return backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32', customValues);
}
const $f8ed181ae27bceed$export$240667804b7c390e = {
    kernelName: (0, $9BGT9.DepthwiseConv2dNative),
    backendName: 'webgl',
    kernelFunc: $f8ed181ae27bceed$export$14e793fe8822afd1
};

});
parcelRegister("g4BN9", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2DProgram", function () { return $bb3a55b58699da38$export$4ead5a4ba22ede40; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $SwRKX = parcelRequire("SwRKX");
class $bb3a55b58699da38$export$4ead5a4ba22ede40 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `float activation(float a) {
          float b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyReluAlpha) activationSnippet = `float activation(float a) {
          float b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `
          float activation(float x) {
            ${activation}
          }
        `;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};

        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.
        for (int wR = 0; wR < ${filterHeight}; wR++) {
          int xR = xRCorner + wR * dilations[0];

          if (xR < 0 || xR >= inDims[0]) {
            continue;
          }

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            int xC = xCCorner + wC * dilations[1];

            if (xC < 0 || xC >= inDims[1]) {
              continue;
            }

            float xVal = getX(batch, xR, xC, d1);
            float wVal = getW(wR, wC, d1, q);
            dotProd += xVal * wVal;
          }
        }

        float result = dotProd;
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}

});

parcelRegister("42TvE", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConvPacked2DProgram", function () { return $2f22685b6ed35bb9$export$acb9287627a2b170; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $SwRKX = parcelRequire("SwRKX");
class $2f22685b6ed35bb9$export$acb9287627a2b170 {
    constructor(convInfo, addBias = false, activation = null, hasPreluActivation = false, hasLeakyReluAlpha = false){
        this.variableNames = [
            'x',
            'W'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'pads',
                type: 'ivec2'
            },
            {
                name: 'strides',
                type: 'ivec2'
            },
            {
                name: 'dilations',
                type: 'ivec2'
            },
            {
                name: 'inDims',
                type: 'ivec2'
            }
        ];
        this.outputShape = convInfo.outShape;
        this.enableShapeUniforms = (0, $SwRKX.useShapeUniforms)(this.outputShape.length);
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        const padLeft = convInfo.padInfo.left;
        const strideWidth = convInfo.strideWidth;
        const dilationWidth = convInfo.dilationWidth;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const texelsAcross = filterWidth;
        let mainLoop = `
      int xR; int xC; int xCOffset;
      vec4 wTexel; vec4 previous; vec4 final;`;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
          vec4 xTexelC${c * 2};
          int xTexelC${c * 2}Ready;
          vec4 xTexelC${c * 2 + 1};
          int xTexelC${c * 2 + 1}Ready;
          vec4 xC${c};`;
        /**
         * This vectorized implementation works by gathering the values needed for
         * each output channel's dot product into vec4's and then multiplying them
         * all together (this happens in the final double for-loop below). Most of
         * the main loop consists of constructing these vec4's with the minimum
         * number of texture2D calls, which means making use of all four returned
         * values from a texture2D call at once.
         */ mainLoop += `
    for (int r = 0; r < ${filterHeight}; r++) {
      `;
        for(let c = 0; c < filterWidth; c++)mainLoop += `
          xTexelC${c * 2} = vec4(0.0);
          xTexelC${c * 2}Ready = 0;
          xTexelC${c * 2 + 1} = vec4(0.0);
          xTexelC${c * 2 + 1}Ready = 0;
          xC${c} = vec4(0.0);`;
        mainLoop += `
        xR = xRCorner + r * dilations[0];
        if (xR >=0 && xR < inDims[0]) {
      `;
        for(let texelC = 0; texelC < (texelsAcross + 1) / 2; texelC++){
            const colIndex = texelC * 2;
            mainLoop += `
          xC = xCCorner + ${colIndex * dilationWidth};
          `;
            if (strideWidth === 1) {
                if (colIndex < filterWidth) {
                    // If padding is odd, the outer texels have to be composed.
                    if (padLeft % 2 === 1) {
                        // TODO: Ensure vec4 previous does not result in redundant sample,
                        // and avoid setting xTexelRC's that exceed the boundary in the
                        // first place rather than resetting them to vec4(0)).
                        // To compute xCOffset:
                        // - If padding is odd, we must add 1 to ensure we ask for an
                        // even-numbered row.
                        // - We subtract 2 to access the previous texel.
                        mainLoop += `
                xCOffset = xC + 1;
                if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);

                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }
              `;
                        // This texel has been read in previous iteration if the dilation
                        // is 1.
                        if (dilationWidth === 1 && colIndex > 0) mainLoop += `
                xC${colIndex} = vec4(xTexelC${colIndex - 2}.zw, xTexelC${colIndex}.xy);
                `;
                        else mainLoop += `
                  xCOffset = xC + 1 - 2;

                  if (xCOffset >= 0 && xCOffset < inDims[1]) {
                    previous = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      previous.zw = vec2(0.0);
                    }

                    xC${colIndex} = vec4(previous.zw, xTexelC${colIndex}.xy);
                  } else {
                    xC${colIndex} = vec4(0.0, 0.0, xTexelC${colIndex}.xy);
                  }
                  `;
                    } else // Padding is even, so xRC corresponds to a single texel.
                    mainLoop += `
                if (xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xC${colIndex} = xTexelC${colIndex};
                `;
                    if (colIndex + 1 < filterWidth) {
                        // If dilation is even, the second entry should match the first
                        // (either both are composed or both are single samples). But if
                        // dilation is odd, then the second entry should be the opposite
                        // of the first (if the first is composed, the second is a single
                        // sample, and vice versa.)
                        const nextTexelOffset = padLeft % 2 === 0 ? (0, $lBDHD).nearestLargerEven(dilationWidth) : dilationWidth;
                        if (dilationWidth % 2 === 0 && padLeft % 2 === 1 || dilationWidth % 2 !== 0 && padLeft % 2 !== 1) {
                            mainLoop += `
                  xCOffset = xC + imod(pads[1], 2) + ${nextTexelOffset};

                  if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                    xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);

                    // Need to manually clear unused channels in case
                    // we're reading from recycled texture.
                    if (xCOffset + 1 >= inDims[1]) {
                      xTexelC${colIndex + 1}.zw = vec2(0.0);
                    }
                    xTexelC${colIndex + 1}Ready = 1;
                  }
                  `;
                            // If dilation > 1 then the xRC's will not be able to share any
                            // values, so each xRC will require two unique calls to getX.
                            if (dilationWidth > 1) mainLoop += `
                    xCOffset -= 2;
                    if (xCOffset >= 0 && xCOffset < inDims[1]) {
                     previous = getX(batch, xR, xCOffset, d1);
                     xC${colIndex + 1} = vec4(previous.zw, xTexelC${colIndex + 1}.xy);
                    } else {
                     xC${colIndex + 1} = vec4(0.0, 0.0, xTexelC${colIndex + 1}.xy);
                    }
                    `;
                            else mainLoop += `
                    xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.xy);
                    `;
                        } else // If dilation is 1 and padding is odd, we have already read the
                        // texel when constructing the previous x value. Here we can
                        // simply skip the texture read.
                        if (nextTexelOffset === 1) mainLoop += `
                    xC${colIndex + 1} = xTexelC${colIndex};
                    `;
                        else mainLoop += `
                    xCOffset = xC + ${nextTexelOffset};

                    if (xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                      xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                      if (xCOffset + 1 >= inDims[1]) {
                        xTexelC${colIndex + 1}.zw = vec2(0.0);
                      }
                      xTexelC${colIndex + 1}Ready = 1;
                    }

                    xC${colIndex + 1} = xTexelC${colIndex + 1};
                    `;
                    }
                }
            } else if (colIndex < filterWidth) {
                // Depending on whether padLeft is even or odd, we want either the
                // xy or zw channels from X texels for xC${colIndex}. If padLeft is
                // even, xC${colIndex +1} is simply the zw channels of texels we've
                // already sampled. But if padLeft is odd, xC{$c + 1}.zw will
                // need to come from the xy channels of a new texel, hence the `
                // vec4
                // final` initialized below.
                if (padLeft % 2 === 1) {
                    mainLoop += `
                xCOffset = xC + 1 - strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xCOffset, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                if(xC + 1 >= 0 && xC + 1 < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xC + 1, d1);
                  // Need to manually clear unused channels in case
                  // we're reading from recycled texture.
                  if (xC + 2 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
              `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                  final = vec4(0.0);
                  xCOffset = xC + 1 + strides[1];
                  if(xCOffset >= 0 && xCOffset < inDims[1]) {
                    final = getX(batch, xR, xCOffset, d1);
                  }
                  xC${colIndex + 1} = vec4(xTexelC${colIndex + 1}.xy, final.xy);
                `;
                } else {
                    mainLoop += `
                if(xC >= 0 && xC < inDims[1] && xTexelC${colIndex}Ready == 0) {
                  xTexelC${colIndex} = getX(batch, xR, xC, d1);
                  if (xC + 1 >= inDims[1]) {
                    xTexelC${colIndex}.zw = vec2(0.0);
                  }
                  xTexelC${colIndex}Ready = 1;
                }

                xCOffset = xC + strides[1];
                if(xCOffset >= 0 && xCOffset < inDims[1] && xTexelC${colIndex + 1}Ready == 0) {
                  xTexelC${colIndex + 1} = getX(batch, xR, xCOffset, d1);
                  if (xCOffset + 1 >= inDims[1]) {
                    xTexelC${colIndex + 1}.zw = vec2(0.);
                  }
                  xTexelC${colIndex + 1}Ready = 1;
                }

                xC${colIndex} = vec4(
                  xTexelC${colIndex}.xy, xTexelC${colIndex + 1}.xy);
              `;
                    if (colIndex + 1 < filterWidth) mainLoop += `
                  xC${colIndex + 1} = vec4(xTexelC${colIndex}.zw, xTexelC${colIndex + 1}.zw);
                `;
                }
            }
            // localize the dotProd accumulation within the loop, the theory is for
            // GPU with limited cache, accumulate sum across large amount of
            // veriables will cause lots of cache misses. (i.e. 5x5 filter will have
            // 50 variables)
            if (colIndex < filterWidth) {
                mainLoop += `
            wTexel = getW(r, ${colIndex}, d1, q);
            dotProd += xC${colIndex} * vec4(wTexel.xz, wTexel.xz);
          `;
                if (colIndex + 1 < filterWidth) mainLoop += `
              wTexel = getW(r, ${colIndex + 1}, d1, q);
              dotProd += xC${colIndex + 1} * vec4(wTexel.xz, wTexel.xz);
            `;
            }
        }
        mainLoop += `
    }
  `;
        mainLoop += `
      }
    `;
        let activationSnippet = '', applyActivationSnippet = '';
        if (activation) {
            if (hasPreluActivation) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getPreluActivationWeightsAtOutCoords();
          ${activation}
        }`;
            else if (hasLeakyReluAlpha) activationSnippet = `vec4 activation(vec4 a) {
          vec4 b = getLeakyreluAlphaAtOutCoords();
          ${activation}
        }`;
            else activationSnippet = `vec4 activation(vec4 x) {
          ${activation}
        }`;
            applyActivationSnippet = `result = activation(result);`;
        }
        const addBiasSnippet = addBias ? 'result += getBiasAtOutCoords();' : '';
        if (addBias) this.variableNames.push('bias');
        if (hasPreluActivation) this.variableNames.push('preluActivationWeights');
        if (hasLeakyReluAlpha) this.variableNames.push('leakyreluAlpha');
        this.userCode = `
      ${activationSnippet}

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        ivec2 xRCCorner = coords.yz * strides - pads;
        int d2 = coords.w;
        int d1 = d2 / ${channelMul};
        int q = d2 - d1 * ${channelMul};
        int xRCorner = xRCCorner.x;
        int xCCorner = xRCCorner.y;

        //intialize dotProd with a small epsilon seems to reduce GPU accuracy loss.
        vec4 dotProd = vec4(0.000000000000001);

        ${mainLoop}

        vec4 result = dotProd - vec4(0.000000000000001);
        ${addBiasSnippet}
        ${applyActivationSnippet}
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("6rmwj", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropFilterConfig", function () { return $4b06bbb9ea1f2a65$export$30bc0ac3775583fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $kY5Rr = parcelRequire("kY5Rr");
function $4b06bbb9ea1f2a65$export$cc0ae65e9edc7e1a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, dy: dy } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, filterShape: filterShape } = attrs;
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filterShape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $kY5Rr.DepthwiseConv2DDerFilterProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        x,
        dy
    ], 'float32');
}
const $4b06bbb9ea1f2a65$export$30bc0ac3775583fc = {
    kernelName: (0, $9BGT9.DepthwiseConv2dNativeBackpropFilter),
    backendName: 'webgl',
    kernelFunc: $4b06bbb9ea1f2a65$export$cc0ae65e9edc7e1a
};

});
parcelRegister("kY5Rr", function(module, exports) {

$parcel$export(module.exports, "DepthwiseConv2DDerFilterProgram", function () { return $f43df5159572bb2e$export$9f5b7866589daeae; });
$parcel$export(module.exports, "DepthwiseConv2DDerInputProgram", function () { return $f43df5159572bb2e$export$9b7e054f73b1374b; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $f43df5159572bb2e$export$9f5b7866589daeae {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'dy'
        ];
        this.outputShape = convInfo.filterShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = convInfo.padInfo.top;
        const padLeft = convInfo.padInfo.left;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int wR = coords.x;
        int wC = coords.y;
        int d1 = coords.z;
        int dm = coords.w;
        int d2 = d1 * ${channelMul} + dm;

        float dotProd = 0.0;

        // TO DO: Vec4 over the batch size
        for (int b = 0; b < ${convInfo.batchSize}; b++) {
          for (int yR = 0; yR < ${convInfo.outHeight}; yR++) {
            int xR = wR + yR * ${strideHeight} - ${padTop};

            if (xR < 0 || xR >= ${convInfo.inHeight}) {
              continue;
            }

            for (int yC = 0; yC < ${convInfo.outWidth}; yC++) {
              int xC = wC + yC * ${strideWidth} - ${padLeft};

              if (xC < 0 || xC >= ${convInfo.inWidth}) {
                continue;
              }

              float dyValue = getDy(b, yR, yC, d2);
              float xValue = getX(b, xR, xC, d1);
              dotProd += (xValue * dyValue);
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $f43df5159572bb2e$export$9b7e054f73b1374b {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'W'
        ];
        this.outputShape = convInfo.inShape;
        const filterHeight = convInfo.filterHeight;
        const filterWidth = convInfo.filterWidth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const padTop = filterHeight - 1 - convInfo.padInfo.top;
        const padLeft = filterWidth - 1 - convInfo.padInfo.left;
        const channelMul = convInfo.outChannels / convInfo.inChannels;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords[0];
        int d1 = coords[3];
        ivec2 dyCorner = coords.yz - pads;
        int dyRCorner = dyCorner.x;
        int dyCCorner = dyCorner.y;

        float dotProd = 0.0;

        for (int wR = 0; wR < ${filterHeight}; wR++) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          int wRPerm = ${filterHeight} - 1 - wR;

          for (int wC = 0; wC < ${filterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            int wCPerm = ${filterWidth} - 1 - wC;

            // TO DO: Vec4 over the channelMul
            for (int dm = 0; dm < ${channelMul}; dm++) {
              int d2 = d1 * ${channelMul} + dm;
              float xValue = getDy(batch, idyR, idyC, d2);
              float wValue = getW(wRPerm, wCPerm, d1, dm);
              dotProd += xValue * wValue;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});


parcelRegister("c28E9", function(module, exports) {

$parcel$export(module.exports, "depthwiseConv2dNativeBackpropInputConfig", function () { return $8c2c60fa1781c011$export$55d12409e744bebe; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $kY5Rr = parcelRequire("kY5Rr");
function $8c2c60fa1781c011$export$37e2ab95a4a4c24b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, filter: filter } = inputs;
    const { strides: strides, dilations: dilations, pad: pad, dimRoundingMode: dimRoundingMode, inputShape: inputShape } = attrs;
    const convInfo = (0, $dEVRx).computeConv2DInfo(inputShape, filter.shape, strides, dilations, pad, dimRoundingMode, true);
    const program = new (0, $kY5Rr.DepthwiseConv2DDerInputProgram)(convInfo);
    return backend.runWebGLProgram(program, [
        dy,
        filter
    ], 'float32');
}
const $8c2c60fa1781c011$export$55d12409e744bebe = {
    kernelName: (0, $9BGT9.DepthwiseConv2dNativeBackpropInput),
    backendName: 'webgl',
    kernelFunc: $8c2c60fa1781c011$export$37e2ab95a4a4c24b
};

});

parcelRegister("dRubT", function(module, exports) {

$parcel$export(module.exports, "diagConfig", function () { return $a177a4d94d36e3f7$export$56dc5d812a22748f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $14b5m = parcelRequire("14b5m");

var $aNJFF = parcelRequire("aNJFF");
function $a177a4d94d36e3f7$export$c042e7c2f59bc046(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    const outShape = [
        ...x.shape,
        ...x.shape
    ];
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const flat = (0, $aNJFF.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                xSize
            ]
        }
    });
    const program = new (0, $14b5m.DiagProgram)(xSize);
    const res = backend.runWebGLProgram(program, [
        flat
    ], flat.dtype);
    const out = (0, $aNJFF.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(flat);
    backend.disposeIntermediateTensorInfo(res);
    return out;
}
const $a177a4d94d36e3f7$export$56dc5d812a22748f = {
    kernelName: (0, $9BGT9.Diag),
    backendName: 'webgl',
    kernelFunc: $a177a4d94d36e3f7$export$c042e7c2f59bc046
};

});
parcelRegister("14b5m", function(module, exports) {

$parcel$export(module.exports, "DiagProgram", function () { return $0c6ec3811001a8cc$export$d3d3824ae4245092; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $0c6ec3811001a8cc$export$d3d3824ae4245092 {
    constructor(size){
        this.variableNames = [
            'X'
        ];
        this.outputShape = [
            size,
            size
        ];
        this.userCode = `
      void main() {
          ivec2 coords = getOutputCoords();
          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;
          setOutput(val);
      }
    `;
    }
}

});


parcelRegister("hpX9N", function(module, exports) {

$parcel$export(module.exports, "dilation2DConfig", function () { return $cae2a8d45b6472a6$export$36d3c11f61a8891a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $9SvKa = parcelRequire("9SvKa");

var $aNJFF = parcelRequire("aNJFF");
function $cae2a8d45b6472a6$export$544ec6096a7ab30(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter } = inputs;
    const { strides: strides, pad: pad, dilations: dilations } = attrs;
    const convInfo = (0, $dEVRx).computeDilation2DInfo(x.shape, filter.shape, strides, pad, 'NHWC' /* dataFormat */ , dilations);
    let out;
    const program = new (0, $9SvKa.Dilation2DProgram)(convInfo);
    out = backend.runWebGLProgram(program, [
        x,
        filter
    ], 'float32');
    const outReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    backend.disposeIntermediateTensorInfo(out);
    return outReshaped;
}
const $cae2a8d45b6472a6$export$36d3c11f61a8891a = {
    kernelName: (0, $9BGT9.Dilation2D),
    backendName: 'webgl',
    kernelFunc: $cae2a8d45b6472a6$export$544ec6096a7ab30
};

});
parcelRegister("9SvKa", function(module, exports) {

$parcel$export(module.exports, "Dilation2DProgram", function () { return $7311c7d121027e19$export$b3acfd0493b4c03e; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $7311c7d121027e19$export$b3acfd0493b4c03e {
    constructor(convInfo){
        this.variableNames = [
            'x',
            'W'
        ];
        this.outputShape = convInfo.outShape;
        const { inHeight: inHeight, inWidth: inWidth, padInfo: padInfo, strideHeight: strideHeight, strideWidth: strideWidth, filterHeight: filterHeight, filterWidth: filterWidth, dilationHeight: dilationHeight, dilationWidth: dilationWidth } = convInfo;
        const { top: padTop, left: padLeft } = padInfo;
        this.userCode = `
      const ivec2 strides = ivec2(${strideHeight}, ${strideWidth});
      const ivec2 pads = ivec2(${padTop}, ${padLeft});
      const float neg_infinity = -3.4e38;

      void main() {
        ivec4 coords = getOutputCoords();
        int batch = coords.x;
        int d1 = coords.w;
        ivec2 outTopLeftCorner =
            coords.yz * strides - pads;
        int hBeg = outTopLeftCorner.x;
        int wBeg = outTopLeftCorner.y;

        float curVal = neg_infinity;
        for (int h = 0; h < ${filterHeight}; h++) {
          int hIn = hBeg + h * ${dilationHeight};

          if (hIn >= 0 && hIn < ${inHeight}) {
            for (int w = 0; w < ${filterWidth}; w++) {
              int wIn = wBeg + w * ${dilationWidth};

              if (wIn >= 0 && wIn < ${inWidth}) {
                float xVal = getX(batch, hIn, wIn, d1);
                float wVal = getW(h, w, d1);

                float val = xVal + wVal;
                if (val > curVal) {
                  curVal = val;
                }
              }
            }
          }
        }

        float result = curVal;
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("4VrHD", function(module, exports) {

$parcel$export(module.exports, "einsumConfig", function () { return $3961f978bf8b94c2$export$40bbf341885a23b7; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $6w4nw = parcelRequire("6w4nw");

var $aNJFF = parcelRequire("aNJFF");

var $frWKu = parcelRequire("frWKu");

var $fZ5E6 = parcelRequire("fZ5E6");
function $3961f978bf8b94c2$export$27265e7daac5c403(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { equation: equation } = attrs;
    const tensors = inputs;
    const { allDims: allDims, summedDims: summedDims, idDims: idDims } = (0, $dEVRx).decodeEinsumEquation(equation, tensors.length);
    (0, $dEVRx).checkEinsumDimSizes(allDims.length, idDims, tensors);
    const { path: path, steps: steps } = (0, $dEVRx).getEinsumComputePath(summedDims, idDims);
    const nSteps = steps.length;
    let out = null;
    let numDimsRemaining = allDims.length;
    const tensorsToDispose = [];
    for(let i = 0; i < nSteps; ++i){
        for (const idTerm of steps[i]){
            const { permutationIndices: perm, expandDims: dimsToExpand } = (0, $dEVRx).getEinsumPermutation(numDimsRemaining, idDims[idTerm]);
            let x;
            if ((0, $dEVRx).isIdentityPermutation(perm)) x = tensors[idTerm];
            else {
                x = (0, $fZ5E6.transpose)({
                    inputs: {
                        x: tensors[idTerm]
                    },
                    backend: backend,
                    attrs: {
                        perm: perm
                    }
                });
                tensorsToDispose.push(x);
            }
            const targetShape = x.shape.slice();
            for(let k = 0; k < dimsToExpand.length; ++k)targetShape.splice(dimsToExpand[k], 0, 1);
            if (!(0, $lBDHD).arraysEqual(x.shape, targetShape)) {
                x = (0, $aNJFF.reshape)({
                    inputs: {
                        x: x
                    },
                    backend: backend,
                    attrs: {
                        shape: targetShape
                    }
                });
                tensorsToDispose.push(x);
            }
            if (out === null) out = x;
            else {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                out = (0, $6w4nw.multiply)({
                    inputs: {
                        a: x,
                        b: out
                    },
                    backend: backend
                });
                tensorsToDispose.push(out);
            }
        }
        if (i < nSteps - 1) {
            if (path[i] >= 0) {
                out = (0, $frWKu.sum)({
                    inputs: {
                        x: out
                    },
                    backend: backend,
                    attrs: {
                        axis: path[i] - (allDims.length - numDimsRemaining),
                        keepDims: false
                    }
                });
                tensorsToDispose.push(out);
            }
            numDimsRemaining--;
        }
    }
    // Clean up intermediate tensors.
    for (const tensorInfo of tensorsToDispose){
        if (tensorInfo === out) continue;
        backend.disposeIntermediateTensorInfo(tensorInfo);
    }
    return out;
}
const $3961f978bf8b94c2$export$40bbf341885a23b7 = {
    kernelName: (0, $9BGT9.Einsum),
    backendName: 'webgl',
    kernelFunc: $3961f978bf8b94c2$export$27265e7daac5c403
};

});

parcelRegister("iu4kW", function(module, exports) {

$parcel$export(module.exports, "eluConfig", function () { return $d74e64852a8e3598$export$b990686634ee3cce; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $d74e64852a8e3598$var$ELU = `return (x >= 0.0) ? x : (exp(x) - 1.0);`;
const $d74e64852a8e3598$var$ELU_PACKED = `
  vec4 result;

  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);
  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);
  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);
  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);

  return result;
`;
const $d74e64852a8e3598$var$elu = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $d74e64852a8e3598$var$ELU,
    packedOpSnippet: $d74e64852a8e3598$var$ELU_PACKED
});
const $d74e64852a8e3598$export$b990686634ee3cce = {
    kernelName: (0, $9BGT9.Elu),
    backendName: 'webgl',
    kernelFunc: $d74e64852a8e3598$var$elu
};

});

parcelRegister("bN25W", function(module, exports) {

$parcel$export(module.exports, "eluGradConfig", function () { return $8955e552148a1ab3$export$59bb07dd04647a1d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $tdutJ = parcelRequire("tdutJ");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");
const $8955e552148a1ab3$var$ELU_DER = `return (b >= 0.0) ? a : a * (b + 1.0);`;
const $8955e552148a1ab3$var$ELU_DER_PACKED = `
  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));
  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));
`;
const $8955e552148a1ab3$export$a346244024505ff9 = (args)=>{
    const { inputs: inputs, backend: backend } = args;
    const { dy: dy, y: y } = inputs;
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_BINARY_OPERATIONS') ? new (0, $12pF4.BinaryOpPackedProgram)($8955e552148a1ab3$var$ELU_DER_PACKED, dy.shape, y.shape) : new (0, $iFjfL.BinaryOpProgram)($8955e552148a1ab3$var$ELU_DER, dy.shape, y.shape);
    return backend.runWebGLProgram(program, [
        dy,
        y
    ], dy.dtype);
};
const $8955e552148a1ab3$export$59bb07dd04647a1d = {
    kernelName: (0, $9BGT9.EluGrad),
    backendName: 'webgl',
    kernelFunc: $8955e552148a1ab3$export$a346244024505ff9
};

});

parcelRegister("jJgPs", function(module, exports) {

$parcel$export(module.exports, "equalConfig", function () { return $e5cf462f8283e6c1$export$3c8bc3d8ee318217; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $e5cf462f8283e6c1$var$PACKED_EQUAL = `
  return vec4(equal(a, b));
`;
const $e5cf462f8283e6c1$var$EQUAL = `return float(a == b);`;
const $e5cf462f8283e6c1$export$411ce8e5a71e3069 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $e5cf462f8283e6c1$var$EQUAL,
    packedOpSnippet: $e5cf462f8283e6c1$var$PACKED_EQUAL,
    dtype: 'bool',
    cpuKernelImpl: (0, $glyiU.equalImplCPU)
});
const $e5cf462f8283e6c1$export$3c8bc3d8ee318217 = {
    kernelName: (0, $9BGT9.Equal),
    backendName: 'webgl',
    kernelFunc: $e5cf462f8283e6c1$export$411ce8e5a71e3069
};

});

parcelRegister("bTvxU", function(module, exports) {

$parcel$export(module.exports, "erfConfig", function () { return $8a8d4d23e86ca9e6$export$d044ffef16079bd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $8a8d4d23e86ca9e6$var$ERF = `
  // Error function is calculated approximately with elementary function.
  // See "Handbook of Mathematical Functions with Formulas,
  // Graphs, and Mathematical Tables", Abramowitz and Stegun.
  float p = ${(0, $dEVRx).ERF_P};
  float a1 = ${(0, $dEVRx).ERF_A1};
  float a2 = ${(0, $dEVRx).ERF_A2};
  float a3 = ${(0, $dEVRx).ERF_A3};
  float a4 = ${(0, $dEVRx).ERF_A4};
  float a5 = ${(0, $dEVRx).ERF_A5};

  float sign = sign(x);
  x = abs(x);
  float t = 1.0 / (1.0 + p * x);
  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));
`;
const $8a8d4d23e86ca9e6$export$d3896f355fc09423 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $8a8d4d23e86ca9e6$var$ERF
});
const $8a8d4d23e86ca9e6$export$d044ffef16079bd = {
    kernelName: (0, $9BGT9.Erf),
    backendName: 'webgl',
    kernelFunc: $8a8d4d23e86ca9e6$export$d3896f355fc09423
};

});

parcelRegister("6Oijd", function(module, exports) {

$parcel$export(module.exports, "exp", function () { return $4f559d5b7b47b12b$export$b310ec824aaee37f; });
$parcel$export(module.exports, "expConfig", function () { return $4f559d5b7b47b12b$export$2fd7ea0fcf021f34; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $4f559d5b7b47b12b$export$e17bfbab9ca97165 = (0, $k2x5z.CHECK_NAN_SNIPPET_UNARY) + `
  return exp(x);
`;
const $4f559d5b7b47b12b$var$EXP_PACKED = `
  vec4 result = exp(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $4f559d5b7b47b12b$export$b310ec824aaee37f = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $4f559d5b7b47b12b$export$e17bfbab9ca97165,
    packedOpSnippet: $4f559d5b7b47b12b$var$EXP_PACKED,
    cpuKernelImpl: (0, $glyiU.expImplCPU),
    dtype: 'float32'
});
const $4f559d5b7b47b12b$export$2fd7ea0fcf021f34 = {
    kernelName: (0, $9BGT9.Exp),
    backendName: 'webgl',
    kernelFunc: $4f559d5b7b47b12b$export$b310ec824aaee37f
};

});

parcelRegister("aeVNP", function(module, exports) {

$parcel$export(module.exports, "expandDims", function () { return $77480c9844d0e763$export$d660d8ed21f46635; });
$parcel$export(module.exports, "expandDimsConfig", function () { return $77480c9844d0e763$export$86341ba0ce5d8e60; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $aNJFF = parcelRequire("aNJFF");
function $77480c9844d0e763$export$d660d8ed21f46635(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { dim: dim } = attrs;
    const { input: input } = inputs;
    const inputRank = input.shape.length;
    const newShape = input.shape.slice();
    let $dim = dim;
    if (dim < 0) {
        // Negative value is counted from the tail of rank.
        (0, $lBDHD).assert(-(inputRank + 1) <= dim, ()=>`Axis must be in the interval [${-(inputRank + 1)}, ${inputRank}]`);
        $dim = inputRank + dim + 1;
    }
    newShape.splice($dim, 0, 1);
    return (0, $aNJFF.reshape)({
        inputs: {
            x: input
        },
        backend: backend,
        attrs: {
            shape: newShape
        }
    });
}
const $77480c9844d0e763$export$86341ba0ce5d8e60 = {
    kernelName: (0, $9BGT9.ExpandDims),
    backendName: 'webgl',
    kernelFunc: $77480c9844d0e763$export$d660d8ed21f46635
};

});

parcelRegister("h2JA1", function(module, exports) {

$parcel$export(module.exports, "expm1Config", function () { return $c685facbd321741e$export$16db8a08b36f938; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $c685facbd321741e$var$EXPM1 = `return exp(x) - 1.0;`;
const $c685facbd321741e$export$b6c0a80d46d3391d = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $c685facbd321741e$var$EXPM1,
    packedOpSnippet: $c685facbd321741e$var$EXPM1,
    cpuKernelImpl: (0, $glyiU.expm1ImplCPU)
});
const $c685facbd321741e$export$16db8a08b36f938 = {
    kernelName: (0, $9BGT9.Expm1),
    backendName: 'webgl',
    kernelFunc: $c685facbd321741e$export$b6c0a80d46d3391d
};

});

parcelRegister("bHm9c", function(module, exports) {

$parcel$export(module.exports, "fftConfig", function () { return $8844e3da9fec6c4d$export$a4d564e380763c78; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $5BRJh = parcelRequire("5BRJh");
function $8844e3da9fec6c4d$export$a535ef183b6128fa(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $5BRJh.fftImpl)(input, false, backend);
}
const $8844e3da9fec6c4d$export$a4d564e380763c78 = {
    kernelName: (0, $9BGT9.FFT),
    backendName: 'webgl',
    kernelFunc: $8844e3da9fec6c4d$export$a535ef183b6128fa
};

});
parcelRegister("5BRJh", function(module, exports) {

$parcel$export(module.exports, "fftImpl", function () { return $415a15f3da7be4c2$export$75d3742a7578721e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $laP0F = parcelRequire("laP0F");

var $6iqSX = parcelRequire("6iqSX");

var $aNJFF = parcelRequire("aNJFF");
function $415a15f3da7be4c2$export$75d3742a7578721e(x, inverse, backend) {
    const xData = backend.texData.get(x.dataId);
    const inputSize = (0, $lBDHD).sizeFromShape(x.shape);
    // Collapse all outer dimensions to a single batch dimension.
    const innerDimensionSize = x.shape[x.shape.length - 1];
    const batch = inputSize / innerDimensionSize;
    const input2D = (0, $aNJFF.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                batch,
                innerDimensionSize
            ]
        }
    });
    const xShape = input2D.shape;
    const realProgram = new (0, $laP0F.FFTProgram)('real', xShape, inverse);
    const imagProgram = new (0, $laP0F.FFTProgram)('imag', xShape, inverse);
    const inputs = [
        {
            dataId: xData.complexTensorInfos.real.dataId,
            dtype: xData.complexTensorInfos.real.dtype,
            shape: xShape
        },
        {
            dataId: xData.complexTensorInfos.imag.dataId,
            dtype: xData.complexTensorInfos.imag.dtype,
            shape: xShape
        }
    ];
    const realPart = backend.runWebGLProgram(realProgram, inputs, 'float32');
    const imagPart = backend.runWebGLProgram(imagProgram, inputs, 'float32');
    const complexOutput = (0, $6iqSX.complex)({
        inputs: {
            real: realPart,
            imag: imagPart
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(realPart);
    backend.disposeIntermediateTensorInfo(imagPart);
    const complexOutputReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: complexOutput
        },
        backend: backend,
        attrs: {
            shape: x.shape
        }
    });
    backend.disposeIntermediateTensorInfo(input2D);
    backend.disposeIntermediateTensorInfo(complexOutput);
    return complexOutputReshaped;
}

});
parcelRegister("laP0F", function(module, exports) {

$parcel$export(module.exports, "FFTProgram", function () { return $f6a2199f35a7b6a4$export$234ba885e3a114f6; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $f6a2199f35a7b6a4$export$234ba885e3a114f6 {
    constructor(component, inputShape, inverse){
        this.variableNames = [
            'real',
            'imag'
        ];
        const innerDim = inputShape[1];
        this.outputShape = inputShape;
        const exponentMultiplierSnippet = inverse ? `2.0 * ${Math.PI}` : `-2.0 * ${Math.PI}`;
        const resultDenominator = inverse ? `${innerDim}.0` : '1.0';
        let opString;
        if (component === 'real') opString = 'return real * expR - imag * expI;';
        else if (component === 'imag') opString = 'return real * expI + imag * expR;';
        else throw new Error(`FFT component must be either "real" or "imag", got ${component}.`);
        this.userCode = `
      const float exponentMultiplier = ${exponentMultiplierSnippet};

      float unaryOpComplex(float real, float expR, float imag, float expI) {
        ${opString}
      }

      float mulMatDFT(int batch, int index) {
        float indexRatio = float(index) / float(${innerDim});
        float exponentMultiplierTimesIndexRatio =
            exponentMultiplier * indexRatio;

        float result = 0.0;

        for (int i = 0; i < ${innerDim}; i++) {
          // x = (-2|2 * PI / N) * index * i;
          float x = exponentMultiplierTimesIndexRatio * float(i);
          float expR = cos(x);
          float expI = sin(x);
          float real = getReal(batch, i);
          float imag = getImag(batch, i);

          result +=
              unaryOpComplex(real, expR, imag, expI) / ${resultDenominator};
        }

        return result;
      }

      void main() {
        ivec2 coords = getOutputCoords();
        setOutput(mulMatDFT(coords[0], coords[1]));
      }
    `;
    }
}

});



parcelRegister("e4Jud", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $a3f4b90e04e73e26$export$9563e054e6f787fb; });
$parcel$export(module.exports, "fillConfig", function () { return $a3f4b90e04e73e26$export$c953bf474b2bde62; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $3yfy4 = parcelRequire("3yfy4");
function $a3f4b90e04e73e26$export$9563e054e6f787fb(args) {
    const { backend: backend, attrs: attrs } = args;
    const { shape: shape, value: value } = attrs;
    let { dtype: dtype } = attrs;
    dtype = dtype || (0, $lBDHD).inferDtype(value);
    if (dtype === 'string') {
        // String type should be handled in CPU memory.
        const values = (0, $lBDHD).getArrayFromDType(dtype, (0, $lBDHD).sizeFromShape(shape));
        values.fill(value);
        return backend.makeTensorInfo(shape, dtype, values);
    } else {
        const program = new (0, $3yfy4.FillProgram)(shape, value);
        const customValues = [
            [
                value
            ]
        ];
        return backend.runWebGLProgram(program, [], dtype, customValues);
    }
}
const $a3f4b90e04e73e26$export$c953bf474b2bde62 = {
    kernelName: (0, $9BGT9.Fill),
    backendName: 'webgl',
    kernelFunc: $a3f4b90e04e73e26$export$9563e054e6f787fb
};

});
parcelRegister("3yfy4", function(module, exports) {

$parcel$export(module.exports, "FillProgram", function () { return $29609bad6a39b9d1$export$758181b12323e997; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $29609bad6a39b9d1$export$758181b12323e997 {
    constructor(shape, value){
        this.outputShape = [];
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.variableNames = [
            'x'
        ];
        this.outputShape = shape;
        this.userCode = `
      void main() {
        // Input can be obtained from uniform value.
        setOutput(value);
      }
    `;
    }
}

});


parcelRegister("abjo2", function(module, exports) {

$parcel$export(module.exports, "flipLeftRightConfig", function () { return $7699f84663c22e1e$export$c9ec83cb23304466; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $dSCBn = parcelRequire("dSCBn");
const $7699f84663c22e1e$export$c9ec83cb23304466 = {
    kernelName: (0, $9BGT9.FlipLeftRight),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, backend: backend })=>{
        const { image: image } = inputs;
        const webglBackend = backend;
        const program = new (0, $dSCBn.FlipLeftRightProgram)(image.shape);
        const output = webglBackend.runWebGLProgram(program, [
            image
        ], image.dtype);
        return output;
    }
};

});
parcelRegister("dSCBn", function(module, exports) {

$parcel$export(module.exports, "FlipLeftRightProgram", function () { return $a1ae43032e5fa416$export$872622c1de722f28; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $a1ae43032e5fa416$export$872622c1de722f28 {
    constructor(imageShape){
        this.variableNames = [
            'Image'
        ];
        this.outputShape = [];
        const imageWidth = imageShape[2];
        this.outputShape = imageShape;
        this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];

          int coordX = ${imageWidth} - x - 1;
          float outputValue;
          if(coordX >= 0 && coordX < ${imageWidth}) {
            outputValue = getImage(coords[0], coords[1], coordX, coords[3]);
          } else {
            outputValue = getImage(coords[0], coords[1], coords[2], coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}

});


parcelRegister("jtfrV", function(module, exports) {

$parcel$export(module.exports, "floorConfig", function () { return $e2ccb5b2f78449ba$export$7e9a0f96fa6bd01c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $e2ccb5b2f78449ba$var$FLOOR = `return floor(x);`;
const $e2ccb5b2f78449ba$export$a3fe094919f356fd = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $e2ccb5b2f78449ba$var$FLOOR,
    packedOpSnippet: $e2ccb5b2f78449ba$var$FLOOR,
    cpuKernelImpl: (0, $glyiU.floorImplCPU)
});
const $e2ccb5b2f78449ba$export$7e9a0f96fa6bd01c = {
    kernelName: (0, $9BGT9.Floor),
    backendName: 'webgl',
    kernelFunc: $e2ccb5b2f78449ba$export$a3fe094919f356fd
};

});

parcelRegister("a6gZI", function(module, exports) {

$parcel$export(module.exports, "floorDivConfig", function () { return $75a7a5abed34c072$export$7eac933a0c7fd37f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
// We use native integer division to deal with floating point imprecision. Since
// we implement floor division and glsl implements truncated division, we
// correct for this by subtracting 1 from result when the result is negative and
// there is a remainder.
const $75a7a5abed34c072$var$INT_DIV = `
  float s = sign(a) * sign(b);
  int ia = round(a);
  int ib = round(b);
  if (ib != 0) {
    // Windows (D3D) wants guaranteed non-zero int division at compile-time.
    return float(idiv(ia, ib, s));
  } else {
    return NAN;
  }
`;
const $75a7a5abed34c072$var$INT_DIV_PACKED = `
  ivec4 ia = round(a);
  ivec4 ib = round(b);
  bvec4 cond = notEqual(ib, ivec4(0));
  ivec4 result = ivec4(0);
  vec4 s = sign(a) * sign(b);

  // Windows (D3D) wants guaranteed non-zero int division at compile-time.
  if (cond[0]) {
    result[0] = idiv(ia[0], ib[0], s[0]);
  }
  if (cond[1]) {
    result[1] = idiv(ia[1], ib[1], s[1]);
  }
  if (cond[2]) {
    result[2] = idiv(ia[2], ib[2], s[2]);
  }
  if (cond[3]) {
    result[3] = idiv(ia[3], ib[3], s[3]);
  }
  return vec4(result);
`;
const $75a7a5abed34c072$export$112397bc52715a8 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $75a7a5abed34c072$var$INT_DIV,
    packedOpSnippet: $75a7a5abed34c072$var$INT_DIV_PACKED,
    dtype: 'int32'
});
const $75a7a5abed34c072$export$7eac933a0c7fd37f = {
    kernelName: (0, $9BGT9.FloorDiv),
    backendName: 'webgl',
    kernelFunc: $75a7a5abed34c072$export$112397bc52715a8
};

});

parcelRegister("jXUlf", function(module, exports) {

$parcel$export(module.exports, "fromPixelsConfig", function () { return $e88f3b510f998a97$export$b22e14d614fc7178; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $2zyhV = parcelRequire("2zyhV");

var $4LqyZ = parcelRequire("4LqyZ");

var $5wwL3 = parcelRequire("5wwL3");
const $e88f3b510f998a97$export$b22e14d614fc7178 = {
    kernelName: (0, $9BGT9.FromPixels),
    backendName: 'webgl',
    kernelFunc: $e88f3b510f998a97$var$fromPixels
};
let $e88f3b510f998a97$var$fromPixels2DContext;
let $e88f3b510f998a97$var$willReadFrequently = (0, $tdutJ.env)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
function $e88f3b510f998a97$var$fromPixels(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    let { pixels: pixels } = inputs;
    const { numChannels: numChannels } = attrs;
    const isVideo = typeof HTMLVideoElement !== 'undefined' && pixels instanceof HTMLVideoElement;
    const isImage = typeof HTMLImageElement !== 'undefined' && pixels instanceof HTMLImageElement;
    const [width, height] = isVideo ? [
        pixels.videoWidth,
        pixels.videoHeight
    ] : [
        pixels.width,
        pixels.height
    ];
    const texShape = [
        height,
        width
    ];
    const outShape = [
        height,
        width,
        numChannels
    ];
    if (isImage || isVideo) {
        const newWillReadFrequently = (0, $tdutJ.env)().getBool('CANVAS2D_WILL_READ_FREQUENTLY_FOR_GPU');
        if ($e88f3b510f998a97$var$fromPixels2DContext == null || newWillReadFrequently !== $e88f3b510f998a97$var$willReadFrequently) {
            $e88f3b510f998a97$var$willReadFrequently = newWillReadFrequently;
            $e88f3b510f998a97$var$fromPixels2DContext = document.createElement('canvas').getContext('2d', {
                willReadFrequently: $e88f3b510f998a97$var$willReadFrequently
            });
        }
        $e88f3b510f998a97$var$fromPixels2DContext.canvas.width = width;
        $e88f3b510f998a97$var$fromPixels2DContext.canvas.height = height;
        $e88f3b510f998a97$var$fromPixels2DContext.drawImage(pixels, 0, 0, width, height);
        pixels = $e88f3b510f998a97$var$fromPixels2DContext.canvas;
    }
    const tempPixelHandle = backend.makeTensorInfo(texShape, 'int32');
    // This is a byte texture with pixels.
    backend.texData.get(tempPixelHandle.dataId).usage = (0, $2zyhV.TextureUsage).PIXELS;
    backend.gpgpu.uploadPixelDataToTexture(backend.getTexture(tempPixelHandle.dataId), pixels);
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK') ? new (0, $5wwL3.FromPixelsPackedProgram)(outShape) : new (0, $4LqyZ.FromPixelsProgram)(outShape);
    const res = backend.runWebGLProgram(program, [
        tempPixelHandle
    ], 'int32');
    backend.disposeData(tempPixelHandle.dataId);
    return res;
}

});
parcelRegister("4LqyZ", function(module, exports) {

$parcel$export(module.exports, "FromPixelsProgram", function () { return $37802824ee41d2f9$export$7ffba7be7a218615; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");
class $37802824ee41d2f9$export$7ffba7be7a218615 {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        const glsl = (0, $8qxEr.getGlslDifferences)();
        const [height, width] = outputShape;
        this.outputShape = outputShape;
        this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];
        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${width}.0, ${height}.0);

        vec4 values = ${glsl.texture2D}(A, uv);
        float value;
        if (depth == 0) {
          value = values.r;
        } else if (depth == 1) {
          value = values.g;
        } else if (depth == 2) {
          value = values.b;
        } else if (depth == 3) {
          value = values.a;
        }

        setOutput(floor(value * 255.0 + 0.5));
      }
    `;
    }
}

});

parcelRegister("5wwL3", function(module, exports) {

$parcel$export(module.exports, "FromPixelsPackedProgram", function () { return $405959f1e8845f28$export$5f4cf05de268f9cf; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $8qxEr = parcelRequire("8qxEr");
class $405959f1e8845f28$export$5f4cf05de268f9cf {
    constructor(outputShape){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = false;
        this.packedOutput = true;
        const glsl = (0, $8qxEr.getGlslDifferences)();
        const [height, width] = outputShape;
        this.outputShape = outputShape;
        this.userCode = `
      void main() {
        ivec3 coords = getOutputCoords();
        int texR = coords[0];
        int texC = coords[1];
        int depth = coords[2];

        vec4 result = vec4(0.);

        for(int row=0; row<=1; row++) {
          for(int col=0; col<=1; col++) {
            texC = coords[1] + row;
            depth = coords[2] + col;

            vec2 uv = (vec2(texC, texR) + halfCR) /
                       vec2(${width}.0, ${height}.0);
            vec4 values = ${glsl.texture2D}(A, uv);
            float value;
            if (depth == 0) {
              value = values.r;
            } else if (depth == 1) {
              value = values.g;
            } else if (depth == 2) {
              value = values.b;
            } else if (depth == 3) {
              value = values.a;
            }

            result[row * 2 + col] = floor(value * 255.0 + 0.5);
          }
        }

        ${glsl.output} = result;
      }
    `;
    }
}

});


parcelRegister("kbbnN", function(module, exports) {

$parcel$export(module.exports, "fusedConv2DConfig", function () { return $eb0daa247235b8dc$export$5b64efa829ddf94e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $3ASjM = parcelRequire("3ASjM");

var $4zPxy = parcelRequire("4zPxy");

var $k2x5z = parcelRequire("k2x5z");

var $g4sZJ = parcelRequire("g4sZJ");

var $aNJFF = parcelRequire("aNJFF");
function $eb0daa247235b8dc$export$b4f4a900a93010a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dataFormat: dataFormat, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const $dataFormat = (0, $dEVRx).convertConv2DDataFormat(dataFormat);
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filter.shape, strides, dilations, pad, dimRoundingMode, false, $dataFormat);
    let out;
    const intermediates = [];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    const prepareInputs = ()=>{
        const inputs = [
            x,
            filter
        ];
        // If the input is a 1-D tensor, align it with the channels.
        //
        // For fusedConv2d, the inputs (x, W, bias, preluActivationWeights) are
        // supposed to be aligned with the dataFormat. The 4-D tensor inputs or
        // scalar inputs are originally aligned, but the 1-D tensor inputs are
        // supposed to be aligned with the channels (only bias and PReLU activation
        // weights could be a 1-D tensor).
        const alignInputWithDataFormat = (input, dataFormat)=>{
            if (dataFormat === 'NCHW' && input.shape.length === 1 && input.shape[0] !== 1) {
                const alignedInput = (0, $aNJFF.reshape)({
                    inputs: {
                        x: input
                    },
                    backend: backend,
                    attrs: {
                        shape: [
                            input.shape[0],
                            1,
                            1
                        ]
                    }
                });
                intermediates.push(alignedInput);
                return alignedInput;
            }
            return input;
        };
        if (hasBias) inputs.push(alignInputWithDataFormat(bias, dataFormat));
        if (hasPreluActivationWeights) inputs.push(alignInputWithDataFormat(preluActivationWeights, dataFormat));
        if (hasLeakyreluAlpha) {
            const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $lBDHD).createScalarValue(leakyreluAlpha, 'float32'));
            inputs.push($leakyreluAlpha);
            intermediates.push($leakyreluAlpha);
        }
        return inputs;
    };
    if (convInfo.filterHeight === 1 && convInfo.filterWidth === 1 && convInfo.dilationHeight === 1 && convInfo.dilationWidth === 1 && convInfo.strideHeight === 1 && convInfo.strideWidth === 1 && (convInfo.padInfo.type === 'SAME' || convInfo.padInfo.type === 'VALID')) out = (0, $g4sZJ.conv2dByMatMul)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    else if (convInfo.strideWidth <= 2 && $dataFormat === 'channelsLast' && (0, $tdutJ.env)().getBool('WEBGL_EXP_CONV')) {
        const fusedActivation = activation ? (0, $k2x5z.mapActivationToShaderProgram)(activation, true) : null;
        const program = new (0, $4zPxy.Conv2DPackedProgram)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const customValues = [
            [
                convInfo.padInfo.top,
                convInfo.padInfo.left
            ],
            [
                convInfo.strideHeight,
                convInfo.strideWidth
            ],
            [
                convInfo.dilationHeight,
                convInfo.dilationWidth
            ],
            [
                convInfo.inHeight,
                convInfo.inWidth
            ]
        ];
        const inputs = prepareInputs();
        out = backend.runWebGLProgram(program, inputs, 'float32', customValues);
    } else if ((0, $tdutJ.env)().getBool('WEBGL_CONV_IM2COL')) out = (0, $g4sZJ.conv2dWithIm2Row)({
        x: x,
        filter: filter,
        convInfo: convInfo,
        backend: backend,
        bias: bias,
        activation: activation,
        preluActivationWeights: preluActivationWeights,
        leakyreluAlpha: leakyreluAlpha
    });
    else {
        const fusedActivation = activation ? (0, $k2x5z.mapActivationToShaderProgram)(activation, false) : null;
        const program = new (0, $3ASjM.Conv2DProgram)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
        const inputs = prepareInputs();
        out = backend.runWebGLProgram(program, inputs, 'float32');
    }
    const outReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: out
        },
        backend: backend,
        attrs: {
            shape: convInfo.outShape
        }
    });
    intermediates.push(out);
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return outReshaped;
}
const $eb0daa247235b8dc$export$5b64efa829ddf94e = {
    kernelName: (0, $9BGT9.FusedConv2D),
    backendName: 'webgl',
    kernelFunc: $eb0daa247235b8dc$export$b4f4a900a93010a
};

});

parcelRegister("ekEC3", function(module, exports) {

$parcel$export(module.exports, "fusedDepthwiseConv2DConfig", function () { return $a6f26fceadbd1879$export$58481cc3409b412c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $g4BN9 = parcelRequire("g4BN9");

var $42TvE = parcelRequire("42TvE");

var $k2x5z = parcelRequire("k2x5z");
function $a6f26fceadbd1879$export$d61de7729228094b(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, filter: filter, bias: bias, preluActivationWeights: preluActivationWeights } = inputs;
    const { strides: strides, pad: pad, dilations: dilations, dimRoundingMode: dimRoundingMode, activation: activation, leakyreluAlpha: leakyreluAlpha } = attrs;
    const intermediates = [];
    let $dilations = dilations;
    if ($dilations == null) $dilations = [
        1,
        1
    ];
    (0, $lBDHD).assert((0, $dEVRx).eitherStridesOrDilationsAreOne(strides, $dilations), ()=>'Error in depthwiseConv2d: Either strides or dilations must be ' + `1. Got strides ${strides} and dilations '${$dilations}'`);
    const convInfo = (0, $dEVRx).computeConv2DInfo(x.shape, filter.shape, strides, $dilations, pad, dimRoundingMode, true);
    const shouldPackDepthwiseConv = (0, $tdutJ.env)().getBool('WEBGL_PACK_DEPTHWISECONV') && convInfo.strideWidth <= 2 && convInfo.outChannels / convInfo.inChannels === 1;
    const fusedActivation = activation ? (0, $k2x5z.mapActivationToShaderProgram)(activation, shouldPackDepthwiseConv) : null;
    const programInputs = [
        x,
        filter
    ];
    const hasBias = bias != null;
    const hasPreluActivationWeights = preluActivationWeights != null;
    const hasLeakyreluAlpha = activation === 'leakyrelu';
    if (hasBias) programInputs.push(bias);
    if (hasPreluActivationWeights) programInputs.push(preluActivationWeights);
    if (hasLeakyreluAlpha) {
        const $leakyreluAlpha = backend.makeTensorInfo([], 'float32', (0, $lBDHD).createScalarValue(leakyreluAlpha, 'float32'));
        programInputs.push($leakyreluAlpha);
        intermediates.push($leakyreluAlpha);
    }
    let program;
    if (shouldPackDepthwiseConv) program = new (0, $42TvE.DepthwiseConvPacked2DProgram)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    else program = new (0, $g4BN9.DepthwiseConv2DProgram)(convInfo, hasBias, fusedActivation, hasPreluActivationWeights, hasLeakyreluAlpha);
    const customValues = [
        [
            convInfo.padInfo.top,
            convInfo.padInfo.left
        ],
        [
            convInfo.strideHeight,
            convInfo.strideWidth
        ],
        [
            convInfo.dilationHeight,
            convInfo.dilationWidth
        ],
        [
            convInfo.inHeight,
            convInfo.inWidth
        ]
    ];
    const result = backend.runWebGLProgram(program, programInputs, 'float32', customValues);
    intermediates.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $a6f26fceadbd1879$export$58481cc3409b412c = {
    kernelName: (0, $9BGT9.FusedDepthwiseConv2D),
    backendName: 'webgl',
    kernelFunc: $a6f26fceadbd1879$export$d61de7729228094b
};

});

parcelRegister("djtfK", function(module, exports) {

$parcel$export(module.exports, "gatherNdConfig", function () { return $9b13bdbba0d452ad$export$d9700eb1c7f5c969; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $dx6DM = parcelRequire("dx6DM");

var $glyiU = parcelRequire("glyiU");

var $aNJFF = parcelRequire("aNJFF");
function $9b13bdbba0d452ad$export$3c586830e482d2b9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { params: params, indices: indices } = inputs;
    const indicesShape = indices.shape;
    const sliceRank = indicesShape[indicesShape.length - 1];
    const paramsSize = (0, $lBDHD).sizeFromShape(params.shape);
    const [resultShape, numSlices, sliceSize, strides] = (0, $dEVRx).prepareAndValidate(params, indices);
    const flattenIndices = (0, $aNJFF.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numSlices,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $aNJFF.reshape)({
        inputs: {
            x: params
        },
        backend: backend,
        attrs: {
            shape: [
                (0, $lBDHD).sizeFromShape(params.shape) / sliceSize,
                sliceSize
            ]
        }
    });
    if (backend.shouldExecuteOnCPU([
        params,
        indices
    ]) || params.dtype === 'string') {
        const indicesData = backend.readSync(indices.dataId);
        const paramsBuf = backend.bufferSync(params);
        const outValue = (0, $glyiU.gatherNdImplCPU)(indicesData, paramsBuf, params.dtype, numSlices, sliceRank, sliceSize, strides, params.shape, paramsSize);
        return backend.makeTensorInfo(resultShape, params.dtype, outValue.values);
    }
    const program = new (0, $dx6DM.GatherNDProgram)(sliceRank, strides, [
        numSlices,
        sliceSize
    ], params.shape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices
    ], flattenX.dtype);
    const reshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: resultShape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $9b13bdbba0d452ad$export$d9700eb1c7f5c969 = {
    kernelName: (0, $9BGT9.GatherNd),
    backendName: 'webgl',
    kernelFunc: $9b13bdbba0d452ad$export$3c586830e482d2b9
};

});
parcelRegister("dx6DM", function(module, exports) {

$parcel$export(module.exports, "GatherNDProgram", function () { return $9da3821a913eaf22$export$ffd508d535a7dba1; });

var $1eI1C = parcelRequire("1eI1C");
class $9da3821a913eaf22$export$ffd508d535a7dba1 {
    constructor(sliceDim, strides, shape, paramsShape){
        this.sliceDim = sliceDim;
        this.strides = strides;
        this.paramsShape = paramsShape;
        this.variableNames = [
            'x',
            'indices'
        ];
        this.outputShape = shape;
        const dtype = (0, $1eI1C.getCoordsDataType)(shape.length);
        let mainLoop = `
    int index;`;
        for(let j = 0; j < this.sliceDim; j++)mainLoop += `
          index = round(getIndices(coords[0], ${j}));
          out_of_bounds = out_of_bounds || index < 0;
          out_of_bounds = out_of_bounds || index >= ${this.paramsShape[j]};
          flattenIndex += index * ${this.strides[j]};`;
        this.userCode = `
         void main() {
          ${dtype} coords = getOutputCoords();
          int flattenIndex = 0;
          bool out_of_bounds = false;

          ${mainLoop}

          setOutput(out_of_bounds ? 0.0 : getX(flattenIndex, coords[1]));
        }
      `;
    }
}

});


parcelRegister("4ug3z", function(module, exports) {

$parcel$export(module.exports, "gatherV2", function () { return $34466b43a46c2f3b$export$3d75b4295ded9925; });
$parcel$export(module.exports, "gatherV2Config", function () { return $34466b43a46c2f3b$export$b1bd3139c91d8765; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $7yicL = parcelRequire("7yicL");

var $glyiU = parcelRequire("glyiU");

var $aNJFF = parcelRequire("aNJFF");
function $34466b43a46c2f3b$export$3d75b4295ded9925(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, indices: indices } = inputs;
    const { axis: axis, batchDims: batchDims } = attrs;
    const parsedAxis = (0, $lBDHD).parseAxisParam(axis, x.shape)[0];
    if ((0, $tdutJ.env)().get('DEBUG')) {
        // In debug mode, throw error when any index is out of bound.
        // Otherwise, just fill out of bounds with zeroes.
        const indicesVals = backend.readSync(indices.dataId);
        const axisDim = x.shape[parsedAxis];
        for(let i = 0; i < indicesVals.length; ++i){
            const index = indicesVals[i];
            (0, $lBDHD).assert(index <= axisDim - 1 && index >= 0, ()=>`GatherV2: the index value ${index} is not in [0, ${axisDim - 1}]`);
        }
    }
    const shapeInfo = (0, $dEVRx).segment_util.collectGatherOpShapeInfo(x, indices, parsedAxis, batchDims);
    const indicesSize = (0, $lBDHD).sizeFromShape(indices.shape);
    const toDispose = [];
    const flattenX = (0, $aNJFF.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                shapeInfo.outerSize,
                shapeInfo.dimSize,
                shapeInfo.sliceSize
            ]
        }
    });
    const flattenIndex = (0, $aNJFF.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                shapeInfo.batchSize,
                indicesSize / shapeInfo.batchSize
            ]
        }
    });
    toDispose.push(flattenX);
    toDispose.push(flattenIndex);
    const flattenOutputShape = [
        shapeInfo.batchSize,
        shapeInfo.outerSize,
        indicesSize / shapeInfo.batchSize,
        shapeInfo.sliceSize
    ];
    if (backend.shouldExecuteOnCPU([
        x,
        indices
    ]) || x.dtype === 'string') {
        const indicesBuf = backend.bufferSync(flattenIndex);
        const xBuf = backend.bufferSync(flattenX);
        const outBuf = (0, $glyiU.gatherV2ImplCPU)(xBuf, indicesBuf, flattenOutputShape);
        toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
        return backend.makeTensorInfo(shapeInfo.outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $7yicL.GatherProgram)(flattenX.shape, flattenOutputShape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndex
    ], flattenX.dtype);
    toDispose.push(res);
    const reshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shapeInfo.outputShape
        }
    });
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return reshaped;
}
const $34466b43a46c2f3b$export$b1bd3139c91d8765 = {
    kernelName: (0, $9BGT9.GatherV2),
    backendName: 'webgl',
    kernelFunc: $34466b43a46c2f3b$export$3d75b4295ded9925
};

});
parcelRegister("7yicL", function(module, exports) {

$parcel$export(module.exports, "GatherProgram", function () { return $57f9d47b43e1692b$export$e8921930334c8ed5; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $57f9d47b43e1692b$export$e8921930334c8ed5 {
    constructor(aShape, outputShape){
        this.variableNames = [
            'A',
            'indices'
        ];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(this.rank);
        const sourceCoords = $57f9d47b43e1692b$var$getSourceCoords(aShape, 2);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        int index = int(getIndices(resRC.x, resRC.z));
        float inBounds = (index >= 0) && (index < ${aShape[2]}) ? 1.0 : 0.0;
        setOutput(inBounds * getA(${sourceCoords}));
      }
    `;
    }
}
// The input and output are always flattened into rank 4 tensors.
function $57f9d47b43e1692b$var$getSourceCoords(aShape, axis) {
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)if (i === 2) sourceCoords.push('index');
    else sourceCoords.push(`${currentCoords[i]}`);
    return sourceCoords.join();
}

});


parcelRegister("f8MZb", function(module, exports) {

$parcel$export(module.exports, "greaterConfig", function () { return $b05d99f14b0185c8$export$8c4f7e92d92310f8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $b05d99f14b0185c8$var$GREATER = `return float(a > b);`;
const $b05d99f14b0185c8$var$GREATER_PACKED = `
  return vec4(greaterThan(a, b));
`;
const $b05d99f14b0185c8$export$9dca161faaf6308b = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $b05d99f14b0185c8$var$GREATER,
    packedOpSnippet: $b05d99f14b0185c8$var$GREATER_PACKED,
    cpuKernelImpl: (0, $glyiU.greaterImplCPU),
    dtype: 'bool'
});
const $b05d99f14b0185c8$export$8c4f7e92d92310f8 = {
    kernelName: (0, $9BGT9.Greater),
    backendName: 'webgl',
    kernelFunc: $b05d99f14b0185c8$export$9dca161faaf6308b
};

});

parcelRegister("an1JO", function(module, exports) {

$parcel$export(module.exports, "greaterEqualConfig", function () { return $78cd667fff83fe3d$export$7a6926f9fcac24ca; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $78cd667fff83fe3d$var$GREATER_EQUAL = `return float(a >= b);`;
const $78cd667fff83fe3d$var$GREATER_EQUAL_PACKED = `
  return vec4(greaterThanEqual(a, b));
`;
const $78cd667fff83fe3d$export$c2fd4164cadc1fa2 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $78cd667fff83fe3d$var$GREATER_EQUAL,
    packedOpSnippet: $78cd667fff83fe3d$var$GREATER_EQUAL_PACKED,
    dtype: 'bool',
    cpuKernelImpl: (0, $glyiU.greaterEqualImplCPU)
});
const $78cd667fff83fe3d$export$7a6926f9fcac24ca = {
    kernelName: (0, $9BGT9.GreaterEqual),
    backendName: 'webgl',
    kernelFunc: $78cd667fff83fe3d$export$c2fd4164cadc1fa2
};

});

parcelRegister("aUf8D", function(module, exports) {

$parcel$export(module.exports, "ifftConfig", function () { return $7f0ae07f6f32becd$export$dc267425bf21b465; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $5BRJh = parcelRequire("5BRJh");
function $7f0ae07f6f32becd$export$776649b0bf8ce1fd(args) {
    const { inputs: inputs, backend: backend } = args;
    const { input: input } = inputs;
    return (0, $5BRJh.fftImpl)(input, true, backend);
}
const $7f0ae07f6f32becd$export$dc267425bf21b465 = {
    kernelName: (0, $9BGT9.IFFT),
    backendName: 'webgl',
    kernelFunc: $7f0ae07f6f32becd$export$776649b0bf8ce1fd
};

});

parcelRegister("7r73c", function(module, exports) {

$parcel$export(module.exports, "isFiniteConfig", function () { return $56a0862306a29ca5$export$4d45c8f7b9ffdaf1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $56a0862306a29ca5$var$IS_FINITE = `return float(!isnan(x) && !isinf(x));`;
const $56a0862306a29ca5$export$65f0b13f2f82375a = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $56a0862306a29ca5$var$IS_FINITE,
    dtype: 'bool'
});
const $56a0862306a29ca5$export$4d45c8f7b9ffdaf1 = {
    kernelName: (0, $9BGT9.IsFinite),
    backendName: 'webgl',
    kernelFunc: $56a0862306a29ca5$export$65f0b13f2f82375a
};

});

parcelRegister("1KAh7", function(module, exports) {

$parcel$export(module.exports, "isInfConfig", function () { return $146639c75822c398$export$bc383b82282e9b5a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $146639c75822c398$var$IS_INF = `return float(isinf(x));`;
const $146639c75822c398$export$e5d3415c656f7096 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $146639c75822c398$var$IS_INF,
    dtype: 'bool'
});
const $146639c75822c398$export$bc383b82282e9b5a = {
    kernelName: (0, $9BGT9.IsInf),
    backendName: 'webgl',
    kernelFunc: $146639c75822c398$export$e5d3415c656f7096
};

});

parcelRegister("gyauv", function(module, exports) {

$parcel$export(module.exports, "isNaNConfig", function () { return $c0c7f599c4973952$export$d58ff790c765c1f0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $c0c7f599c4973952$var$IS_NAN = `return float(isnan(x));`;
const $c0c7f599c4973952$export$c9f5652083b8129d = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $c0c7f599c4973952$var$IS_NAN,
    dtype: 'bool'
});
const $c0c7f599c4973952$export$d58ff790c765c1f0 = {
    kernelName: (0, $9BGT9.IsNan),
    backendName: 'webgl',
    kernelFunc: $c0c7f599c4973952$export$c9f5652083b8129d
};

});

parcelRegister("8mAVU", function(module, exports) {

$parcel$export(module.exports, "lessConfig", function () { return $616d06eb36edf3d2$export$8d4530ce8b6ffc3c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $616d06eb36edf3d2$var$LESS = `return float(a < b);`;
const $616d06eb36edf3d2$var$LESS_PACKED = `
  return vec4(lessThan(a, b));
`;
const $616d06eb36edf3d2$export$bb1a638da8ad190f = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $616d06eb36edf3d2$var$LESS,
    packedOpSnippet: $616d06eb36edf3d2$var$LESS_PACKED,
    cpuKernelImpl: (0, $glyiU.lessImplCPU),
    dtype: 'bool'
});
const $616d06eb36edf3d2$export$8d4530ce8b6ffc3c = {
    kernelName: (0, $9BGT9.Less),
    backendName: 'webgl',
    kernelFunc: $616d06eb36edf3d2$export$bb1a638da8ad190f
};

});

parcelRegister("2LjZh", function(module, exports) {

$parcel$export(module.exports, "lessEqualConfig", function () { return $202f79a41b5d6543$export$9f26bd257393dd8; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $202f79a41b5d6543$export$8342242c3b80421d = `return float(a <= b);`;
const $202f79a41b5d6543$export$b12559c17f42d056 = `
  return vec4(lessThanEqual(a, b));
`;
const $202f79a41b5d6543$export$c24ad19a692bb92 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $202f79a41b5d6543$export$8342242c3b80421d,
    packedOpSnippet: $202f79a41b5d6543$export$b12559c17f42d056,
    cpuKernelImpl: (0, $glyiU.lessEqualImplCPU),
    dtype: 'bool'
});
const $202f79a41b5d6543$export$9f26bd257393dd8 = {
    kernelName: (0, $9BGT9.LessEqual),
    backendName: 'webgl',
    kernelFunc: $202f79a41b5d6543$export$c24ad19a692bb92
};

});

parcelRegister("cktSR", function(module, exports) {

$parcel$export(module.exports, "linSpaceConfig", function () { return $8f9e8897c5090143$export$46b96f742c70959b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $8f9e8897c5090143$export$865a19adce4d7a46(args) {
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, num: num } = attrs;
    // TODO: Use CPU implementation due to the precision problem in Safari.
    const outVals = (0, $glyiU.linSpaceImplCPU)(start, stop, num);
    return backend.makeTensorInfo([
        outVals.length
    ], 'float32', outVals);
}
const $8f9e8897c5090143$export$46b96f742c70959b = {
    kernelName: (0, $9BGT9.LinSpace),
    backendName: 'webgl',
    kernelFunc: $8f9e8897c5090143$export$865a19adce4d7a46
};

});

parcelRegister("lb9yU", function(module, exports) {

$parcel$export(module.exports, "logConfig", function () { return $f6b20ae6f903de8b$export$a4ae1f00643ddd14; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
// Windows chrome return 0 if the input is negative value. We will specifically
// return NaN if the input is 0 to solve compatiblity issue.
const $f6b20ae6f903de8b$var$LOG = (0, $k2x5z.CHECK_NAN_SNIPPET_UNARY) + `
  return x < 0.0 ? 0./0. : log(x);
`;
const $f6b20ae6f903de8b$var$LOG_PACKED = `
  vec4 result = log(x);
  bvec4 isNaN = isnan(x);
  result.r = isNaN.r ? x.r : (x.r < 0.0 ? 0./0. : result.r);
  result.g = isNaN.g ? x.g : (x.g < 0.0 ? 0./0. : result.g);
  result.b = isNaN.b ? x.b : (x.b < 0.0 ? 0./0. : result.b);
  result.a = isNaN.a ? x.a : (x.a < 0.0 ? 0./0. : result.a);
  return result;
`;
const $f6b20ae6f903de8b$export$bef1f36f5486a6a3 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $f6b20ae6f903de8b$var$LOG,
    packedOpSnippet: $f6b20ae6f903de8b$var$LOG_PACKED,
    cpuKernelImpl: (0, $glyiU.logImplCPU)
});
const $f6b20ae6f903de8b$export$a4ae1f00643ddd14 = {
    kernelName: (0, $9BGT9.Log),
    backendName: 'webgl',
    kernelFunc: $f6b20ae6f903de8b$export$bef1f36f5486a6a3
};

});

parcelRegister("fAFKQ", function(module, exports) {

$parcel$export(module.exports, "log1pConfig", function () { return $b59a9b6379a74860$export$c458b9e5ba980198; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $b59a9b6379a74860$var$LOG1P = (0, $k2x5z.CHECK_NAN_SNIPPET_UNARY) + `
  return log(1.0 + x);
`;
const $b59a9b6379a74860$export$144dcf16adfb9698 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $b59a9b6379a74860$var$LOG1P
});
const $b59a9b6379a74860$export$c458b9e5ba980198 = {
    kernelName: (0, $9BGT9.Log1p),
    backendName: 'webgl',
    kernelFunc: $b59a9b6379a74860$export$144dcf16adfb9698
};

});

parcelRegister("dZaRz", function(module, exports) {

$parcel$export(module.exports, "logicalAndConfig", function () { return $02a0aaefae0a4cb8$export$257f1e82e69113fb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $02a0aaefae0a4cb8$var$LOGICAL_AND = `return float(a >= 1.0 && b >= 1.0);`;
const $02a0aaefae0a4cb8$var$LOGICAL_AND_PACKED = `
  return vec4(
    vec4(greaterThanEqual(a, vec4(1.0))) *
    vec4(greaterThanEqual(b, vec4(1.0))));
`;
const $02a0aaefae0a4cb8$export$db5dd0ef9d505f = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $02a0aaefae0a4cb8$var$LOGICAL_AND,
    packedOpSnippet: $02a0aaefae0a4cb8$var$LOGICAL_AND_PACKED,
    dtype: 'bool'
});
const $02a0aaefae0a4cb8$export$257f1e82e69113fb = {
    kernelName: (0, $9BGT9.LogicalAnd),
    backendName: 'webgl',
    kernelFunc: $02a0aaefae0a4cb8$export$db5dd0ef9d505f
};

});

parcelRegister("g2gcl", function(module, exports) {

$parcel$export(module.exports, "logicalNotConfig", function () { return $03033f941f4d360b$export$68e2dd0840056271; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $03033f941f4d360b$var$LOGICAL_NOT = `return float(!(x >= 1.0));`;
const $03033f941f4d360b$export$c836ff7b605b1617 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $03033f941f4d360b$var$LOGICAL_NOT
});
const $03033f941f4d360b$export$68e2dd0840056271 = {
    kernelName: (0, $9BGT9.LogicalNot),
    backendName: 'webgl',
    kernelFunc: $03033f941f4d360b$export$c836ff7b605b1617
};

});

parcelRegister("b1p2r", function(module, exports) {

$parcel$export(module.exports, "logicalOrConfig", function () { return $806335d2371fcfe0$export$ce04b6546987ef43; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $806335d2371fcfe0$var$LOGICAL_OR = `return float(a >= 1.0 || b >= 1.0);`;
const $806335d2371fcfe0$var$LOGICAL_OR_PACKED = `
  return min(
    vec4(greaterThanEqual(a, vec4(1.0))) +
    vec4(greaterThanEqual(b, vec4(1.0))),
    vec4(1.0));
`;
const $806335d2371fcfe0$export$e2a73975983cadd8 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $806335d2371fcfe0$var$LOGICAL_OR,
    packedOpSnippet: $806335d2371fcfe0$var$LOGICAL_OR_PACKED,
    dtype: 'bool'
});
const $806335d2371fcfe0$export$ce04b6546987ef43 = {
    kernelName: (0, $9BGT9.LogicalOr),
    backendName: 'webgl',
    kernelFunc: $806335d2371fcfe0$export$e2a73975983cadd8
};

});

parcelRegister("dEJ9v", function(module, exports) {

$parcel$export(module.exports, "LRNConfig", function () { return $9f120912de3f7e0e$export$6fb124d5a6994734; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $gPEqu = parcelRequire("gPEqu");

var $5mgrT = parcelRequire("5mgrT");
const $9f120912de3f7e0e$export$4e4a7896ae51c2f1 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_NORMALIZATION') ? new (0, $5mgrT.LRNPackedProgram)(x.shape, depthRadius, bias, alpha, beta) : new (0, $gPEqu.LRNProgram)(x.shape, depthRadius, bias, alpha, beta);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
};
const $9f120912de3f7e0e$export$6fb124d5a6994734 = {
    kernelName: (0, $9BGT9.LRN),
    backendName: 'webgl',
    kernelFunc: $9f120912de3f7e0e$export$4e4a7896ae51c2f1
};

});
parcelRegister("gPEqu", function(module, exports) {

$parcel$export(module.exports, "LRNProgram", function () { return $c410c4925e2af8ee$export$2214c2ca22968528; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $c410c4925e2af8ee$export$2214c2ca22968528 {
    constructor(xShape, radius, bias, alpha, beta){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        const rad = radius;
        const maxD = xShape[3] - 1;
        this.outputShape = xShape;
        // optimize pow(bias + alpha * sum, -beta)
        // src: https://github.com/tensorflow/tensorflow/..
        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
        let powOperator;
        const basis = `float(${bias}) + float(${alpha}) * sum`;
        if (beta === 0.5) powOperator = `inversesqrt(${basis})`;
        else if (beta === 1.0) powOperator = `1.0/(${basis})`;
        else powOperator = `exp(log(${basis}) * float(-${beta}));`;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];
        int d = coords[3];
        float x = getX(b, r, c, d);
        float sum = 0.0;
        for (int j = -${rad}; j <= ${rad}; j++) {
          int idx = d + j;
          if (idx >= 0 && idx <=  ${maxD}) {
            float z = getX(b, r, c, idx);
            sum += z * z;
          }
        }
        float val = x * ${powOperator};
        setOutput(val);
      }
    `;
    }
}

});

parcelRegister("5mgrT", function(module, exports) {

$parcel$export(module.exports, "LRNPackedProgram", function () { return $3e6bc439924b3561$export$3942340f6b6d7fe9; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $3e6bc439924b3561$export$3942340f6b6d7fe9 {
    constructor(xShape, radius, bias, alpha, beta){
        this.variableNames = [
            'x'
        ];
        this.outputShape = [];
        this.packedInputs = true;
        this.packedOutput = true;
        const rad = radius;
        const maxD = xShape[3] - 1;
        this.outputShape = xShape;
        // optimize pow(bias + alpha * sum, -beta)
        // src: https://github.com/tensorflow/tensorflow/..
        // blob/26033a1644a9c4a5fbe3170ab2e864b6a4ccd4ca/..
        // tensorflow/core/kernels/mkl_lrn_op.cc#L320
        let powOperator;
        const basis = `float(${bias}) + float(${alpha}) * sum`;
        if (beta === 0.5) powOperator = `inversesqrt(${basis})`;
        else if (beta === 1.0) powOperator = `1.0/(${basis})`;
        else powOperator = `exp(log(${basis}) * float(-${beta}));`;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords.x;
        int r = coords.y;
        int c = coords.z;
        int d = coords.w;

        bool hasNextCol = d < ${this.outputShape[3]};
        bool hasNextRow = c < ${this.outputShape[2]};

        vec4 sum = vec4(0.);
        vec4 xFragAtOutputCoords = getX(b, r, c, d);

        vec4 xAtOutputCoords = vec4(
          getChannel(xFragAtOutputCoords, vec2(c, d)),
          hasNextCol ?
            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,
          hasNextRow ?
            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,
          (hasNextRow && hasNextCol) ?
            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0
        );

        int firstChannel = d - ${rad};
        vec2 cache = vec2(0.);
        if(firstChannel >= 0){
          vec4 firstChannelFrag = getX(b, r, c, firstChannel);
          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));
            if(hasNextRow){
              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));
            }
        }

        ivec2 depth = ivec2(d, d + 1);
        for (int j = - ${rad}; j <= ${rad}; j++) {
          ivec2 idx = depth + j;
          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));
          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(${maxD}));

          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;
          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;

          if(depthInRange || depthPlusOneInRange){
            vec4 z = vec4(0.);
            vec4 xFragAtCurrentDepth;
            z.xz = cache.xy;
            if(depthPlusOneInRange && hasNextCol){
              xFragAtCurrentDepth = idx.y != d ?
                getX(b, r, c, idx.y) : xFragAtOutputCoords;
              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));
              if(hasNextRow){
                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));
              }
            }
            cache.xy = z.yw;
            sum += z * z;
          }
        }
        vec4 result = xAtOutputCoords * ${powOperator};
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("3WGve", function(module, exports) {

$parcel$export(module.exports, "LRNGradConfig", function () { return $2df7c205483ba0c5$export$99a62fc039d7aca0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $ipFU0 = parcelRequire("ipFU0");
const $2df7c205483ba0c5$export$c1529e4348811bb5 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, y: y, dy: dy } = inputs;
    const { depthRadius: depthRadius, bias: bias, alpha: alpha, beta: beta } = attrs;
    const program = new (0, $ipFU0.LRNGradProgram)(x.shape, depthRadius, bias, alpha, beta);
    return backend.runWebGLProgram(program, [
        x,
        y,
        dy
    ], x.dtype);
};
const $2df7c205483ba0c5$export$99a62fc039d7aca0 = {
    kernelName: (0, $9BGT9.LRNGrad),
    backendName: 'webgl',
    kernelFunc: $2df7c205483ba0c5$export$c1529e4348811bb5
};

});
parcelRegister("ipFU0", function(module, exports) {

$parcel$export(module.exports, "LRNGradProgram", function () { return $d67b10bd2305fb3f$export$f121c71e68d75e; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $d67b10bd2305fb3f$export$f121c71e68d75e {
    constructor(inputShape, depthRadius, bias, alpha, beta){
        this.variableNames = [
            'inputImage',
            'outputImage',
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        this.depth = inputShape[3];
        this.depthRadius = depthRadius;
        this.bias = bias;
        this.alpha = alpha;
        this.beta = beta;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int r = coords[1];
        int c = coords[2];

        float result = 0.0;
        for (int d = 0; d < ${this.depth}; ++d) {
          int depthBegin = int(max(0.0, float(d - ${depthRadius})));
          int depthEnd = int(min(float(${this.depth}),
              float(d + ${depthRadius} + 1)));

          const int MIN_DEPTH_BEGIN = 0;
          const int MAX_DEPTH_END = ${this.depth};

          float norm = 0.0;
          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd) {
              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);
            }
            else {
              break;
            }
          }

          norm = float(${alpha}) * norm + float(${bias});

          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){
            if (k < depthBegin){
              continue;
            }
            else if (k >= depthBegin && k < depthEnd){
              float dyi = -2.0 * float(${alpha})
                * float(${beta})
                * getInputImage(b, r, c, k) * getOutputImage(b, r, c, d)
                / norm;
              if (k == d) {
                dyi += pow(norm, -1.0 * ${beta});
              }
              if (k == coords[3]) {
                dyi *= getDy(b, r, c, d);
                result += dyi;
              }
            }
            else {
              break;
            }
          }
      }
      setOutput(result);
      }
    `;
    }
}

});


parcelRegister("fHp2B", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $b6de4bc5bd208d31$export$8960430cfd85939f; });
$parcel$export(module.exports, "maxConfig", function () { return $b6de4bc5bd208d31$export$7d79147246e312bb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $glyiU = parcelRequire("glyiU");

var $38eQL = parcelRequire("38eQL");

var $c7ELT = parcelRequire("c7ELT");
var $glyiU = parcelRequire("glyiU");
function $b6de4bc5bd208d31$export$8960430cfd85939f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { reductionIndices: reductionIndices, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $lBDHD).parseAxisParam(reductionIndices, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, xRank);
    const maxInputIsTransposed = permutedAxes != null;
    const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
        x
    ]);
    let maxInput = x;
    if (maxInputIsTransposed) {
        if (shouldExecuteOnCPU) {
            const xTexData = backend.texData.get(maxInput.dataId);
            const values = xTexData.values;
            const newShape = new Array(xRank);
            for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[permutedAxes[i]];
            const maxInputValues = (0, $glyiU.transposeImplCPU)(values, x.shape, x.dtype, permutedAxes, newShape);
            maxInput = backend.makeTensorInfo(newShape, x.dtype);
            const maxInputData = backend.texData.get(maxInput.dataId);
            maxInputData.values = maxInputValues;
        } else maxInput = (0, $c7ELT.transposeImpl)(x, permutedAxes, backend);
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, xRank);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('max', axes, xRank);
    const [maxOutShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(maxInput.shape, axes);
    let outShape = maxOutShape;
    if (keepDims) // rather than reshape at the end, set the target shape here.
    outShape = (0, $dEVRx).expandShapeToKeepDim(maxOutShape, origAxes);
    let out;
    if (shouldExecuteOnCPU) {
        const xTexData = backend.texData.get(maxInput.dataId);
        const values = xTexData.values;
        const outValues = (0, $glyiU.maxImplCPU)(values, (0, $lBDHD).sizeFromShape(reduceShape), outShape, x.dtype);
        out = backend.makeTensorInfo(outShape, x.dtype);
        const outData = backend.texData.get(out.dataId);
        outData.values = outValues;
    } else out = (0, $38eQL.maxImpl)(maxInput, reduceShape, outShape, backend);
    if (maxInputIsTransposed) backend.disposeIntermediateTensorInfo(maxInput);
    return out;
}
const $b6de4bc5bd208d31$export$7d79147246e312bb = {
    kernelName: (0, $9BGT9.Max),
    backendName: 'webgl',
    kernelFunc: $b6de4bc5bd208d31$export$8960430cfd85939f
};

});
parcelRegister("38eQL", function(module, exports) {

$parcel$export(module.exports, "maxImpl", function () { return $247da35fc98180c6$export$23c9b99bdac85be0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $5kt6u = parcelRequire("5kt6u");

var $aNJFF = parcelRequire("aNJFF");
function $247da35fc98180c6$export$23c9b99bdac85be0(x, reduceShape, outShape, backend) {
    const inSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $aNJFF.reshape)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const reduced = (0, $5kt6u.reduce)(reshapedInput, x.dtype, 'max', backend);
    const reshapedOutput = (0, $aNJFF.reshape)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    return reshapedOutput;
}

});


parcelRegister("jbDKz", function(module, exports) {

$parcel$export(module.exports, "maximumConfig", function () { return $df7de0f8fd314ad1$export$45b97bdc342e72a2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $df7de0f8fd314ad1$var$MAXIMUM = (0, $iFjfL.CHECK_NAN_SNIPPET) + `
  return max(a, b);
`;
const $df7de0f8fd314ad1$var$MAXIMUM_PACKED = `
  vec4 result = vec4(max(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $12pF4.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $df7de0f8fd314ad1$export$b25e0be55f42c9a = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $df7de0f8fd314ad1$var$MAXIMUM,
    packedOpSnippet: $df7de0f8fd314ad1$var$MAXIMUM_PACKED,
    cpuKernelImpl: (0, $glyiU.maximumImplCPU)
});
const $df7de0f8fd314ad1$export$45b97bdc342e72a2 = {
    kernelName: (0, $9BGT9.Maximum),
    backendName: 'webgl',
    kernelFunc: $df7de0f8fd314ad1$export$b25e0be55f42c9a
};

});

parcelRegister("aQoth", function(module, exports) {

$parcel$export(module.exports, "maxPoolConfig", function () { return $7e51be2cd98bcaf5$export$45c8263b38f19e33; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $gfZLY = parcelRequire("gfZLY");

var $k42ZR = parcelRequire("k42ZR");

var $lVOy4 = parcelRequire("lVOy4");
function $7e51be2cd98bcaf5$export$e4aadcf115842782(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    (0, $k42ZR.assertNotComplex)(x, 'maxPool');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = 1;
    (0, $lBDHD).assert((0, $dEVRx).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
    const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    if (convInfo.filterWidth === 1 && convInfo.filterHeight === 1 && (0, $lBDHD).arraysEqual(convInfo.inShape, convInfo.outShape)) return (0, $lVOy4.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const maxPoolProgram = new (0, $gfZLY.Pool2DProgram)(convInfo, 'max', false);
    return backend.runWebGLProgram(maxPoolProgram, [
        x
    ], x.dtype);
}
const $7e51be2cd98bcaf5$export$45c8263b38f19e33 = {
    kernelName: (0, $9BGT9.MaxPool),
    backendName: 'webgl',
    kernelFunc: $7e51be2cd98bcaf5$export$e4aadcf115842782
};

});

parcelRegister("j6D3Z", function(module, exports) {

$parcel$export(module.exports, "maxPool3DConfig", function () { return $de8ce1040f5154f3$export$91a8fc5da39ec855; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $gfZLY = parcelRequire("gfZLY");
function $de8ce1040f5154f3$export$822a6e53be1125f9(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { filterSize: filterSize, strides: strides, pad: pad, dataFormat: dataFormat, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $dEVRx).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode, dataFormat);
    const maxPoolProgram = new (0, $gfZLY.Pool3DProgram)(convInfo, 'max', false);
    return backend.runWebGLProgram(maxPoolProgram, [
        x
    ], x.dtype);
}
const $de8ce1040f5154f3$export$91a8fc5da39ec855 = {
    kernelName: (0, $9BGT9.MaxPool3D),
    backendName: 'webgl',
    kernelFunc: $de8ce1040f5154f3$export$822a6e53be1125f9
};

});

parcelRegister("csZ3d", function(module, exports) {

$parcel$export(module.exports, "maxPool3DGradConfig", function () { return $913774f7260b91ea$export$5201426bb10bd5eb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $i1lwO = parcelRequire("i1lwO");

var $gfZLY = parcelRequire("gfZLY");
function $913774f7260b91ea$export$e68b9bef571dd4ea(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input } = inputs;
    const x = input;
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const dilations = [
        1,
        1,
        1
    ];
    const convInfo = (0, $dEVRx).computePool3DInfo(x.shape, filterSize, strides, dilations, pad, dimRoundingMode);
    const maxPool3dPositionsProgram = new (0, $gfZLY.Pool3DProgram)(convInfo, 'max', true);
    const maxPool3dPositions = backend.runWebGLProgram(maxPool3dPositionsProgram, [
        x
    ], x.dtype);
    const maxPoolBackpropProgram = new (0, $i1lwO.MaxPool3DBackpropProgram)(convInfo);
    const result = backend.runWebGLProgram(maxPoolBackpropProgram, [
        dy,
        maxPool3dPositions
    ], x.dtype);
    backend.disposeIntermediateTensorInfo(maxPool3dPositions);
    return result;
}
const $913774f7260b91ea$export$5201426bb10bd5eb = {
    kernelName: (0, $9BGT9.MaxPool3DGrad),
    backendName: 'webgl',
    kernelFunc: $913774f7260b91ea$export$e68b9bef571dd4ea
};

});
parcelRegister("i1lwO", function(module, exports) {

$parcel$export(module.exports, "MaxPool2DBackpropProgram", function () { return $d1e9050d7f38e6f2$export$ab6144ed51884dd; });
$parcel$export(module.exports, "MaxPool3DBackpropProgram", function () { return $d1e9050d7f38e6f2$export$ae61ae287bf9d719; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $d1e9050d7f38e6f2$export$ab6144ed51884dd {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.outputShape = convInfo.inShape;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationHeight = convInfo.dilationHeight;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const lastIndex = effectiveFilterHeight * effectiveFilterWidth - 1;
        this.userCode = `
      const ivec2 pads = ivec2(${padTop}, ${padLeft});

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];

        ivec2 dyRCCorner = coords.yz - pads;
        int dyRCorner = dyRCCorner.x;
        int dyCCorner = dyRCCorner.y;

        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;
        for (int wR = 0; wR < ${effectiveFilterHeight};
          wR += ${dilationHeight}) {
          float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

          if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 || fract(dyR) > 0.0) {
            continue;
          }
          int idyR = int(dyR);

          for (int wC = 0; wC < ${effectiveFilterWidth}; wC++) {
            float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

            if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                fract(dyC) > 0.0) {
              continue;
            }
            int idyC = int(dyC);

            float dyValue = getDy(b, idyR, idyC, d);
            int maxPosValue = ${lastIndex} - int(getMaxPos(b, idyR, idyC, d));

            // Get the current value, check it against the value from the
            // position matrix.
            int curPosValue = wR * ${effectiveFilterWidth} + wC;
            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

            dotProd += dyValue * mask;
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}
class $d1e9050d7f38e6f2$export$ae61ae287bf9d719 {
    constructor(convInfo){
        this.variableNames = [
            'dy',
            'maxPos'
        ];
        this.outputShape = convInfo.inShape;
        const strideDepth = convInfo.strideDepth;
        const strideHeight = convInfo.strideHeight;
        const strideWidth = convInfo.strideWidth;
        const dilationDepth = convInfo.dilationDepth;
        const dilationHeight = convInfo.dilationHeight;
        const dilationWidth = convInfo.dilationWidth;
        const effectiveFilterDepth = convInfo.effectiveFilterDepth;
        const effectiveFilterHeight = convInfo.effectiveFilterHeight;
        const effectiveFilterWidth = convInfo.effectiveFilterWidth;
        const padFront = effectiveFilterDepth - 1 - convInfo.padInfo.front;
        const padTop = effectiveFilterHeight - 1 - convInfo.padInfo.top;
        const padLeft = effectiveFilterWidth - 1 - convInfo.padInfo.left;
        const lastIndex = effectiveFilterDepth * effectiveFilterHeight * effectiveFilterWidth - 1;
        this.userCode = `
      const ivec3 pads = ivec3(${padFront}, ${padTop}, ${padLeft});

      void main() {
        ivec5 coords = getOutputCoords();
        int batch = coords.x;
        int ch = coords.u;

        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;
        int dyDCorner = dyCorner.x;
        int dyRCorner = dyCorner.y;
        int dyCCorner = dyCorner.z;

        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get
        // dx(xD, xR, xC, ch).
        // ? = to be determined. : = across all values in that axis.
        float dotProd = 0.0;

        for (int wD = 0; wD < ${effectiveFilterDepth};
           wD += ${dilationDepth}) {
          float dyD = float(dyDCorner + wD) / ${strideDepth}.0;

          if (dyD < 0.0 || dyD >= ${convInfo.outDepth}.0 || fract(dyD) > 0.0) {
            continue;
          }
          int idyD = int(dyD);

          for (int wR = 0; wR < ${effectiveFilterHeight};
              wR += ${dilationHeight}) {
            float dyR = float(dyRCorner + wR) / ${strideHeight}.0;

            if (dyR < 0.0 || dyR >= ${convInfo.outHeight}.0 ||
                fract(dyR) > 0.0) {
              continue;
            }
            int idyR = int(dyR);

            for (int wC = 0; wC < ${effectiveFilterWidth};
                wC += ${dilationWidth}) {
              float dyC = float(dyCCorner + wC) / ${strideWidth}.0;

              if (dyC < 0.0 || dyC >= ${convInfo.outWidth}.0 ||
                  fract(dyC) > 0.0) {
                continue;
              }
              int idyC = int(dyC);

              float dyValue = getDy(batch, idyD, idyR, idyC, ch);
              int maxPosValue = ${lastIndex} -
                  int(getMaxPos(batch, idyD, idyR, idyC, ch));

              // Get the current value, check it against the value from the
              // position matrix.
              int curPosValue =
                  wD * ${effectiveFilterHeight} * ${effectiveFilterWidth} +
                  wR * ${effectiveFilterWidth} + wC;
              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);

              dotProd += dyValue * mask;
            }
          }
        }
        setOutput(dotProd);
      }
    `;
    }
}

});


parcelRegister("a1srA", function(module, exports) {

$parcel$export(module.exports, "maxPoolGradConfig", function () { return $74c00fc5310f8321$export$e01a7f8dbee29127; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $i1lwO = parcelRequire("i1lwO");

var $gfZLY = parcelRequire("gfZLY");

var $k42ZR = parcelRequire("k42ZR");
function $74c00fc5310f8321$export$85dfd1121f049514(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { dy: dy, input: input, output: output } = inputs;
    const x = input;
    (0, $k42ZR.assertNotComplex)([
        input,
        output
    ], 'maxPoolGrad');
    const { filterSize: filterSize, strides: strides, pad: pad, dimRoundingMode: dimRoundingMode } = attrs;
    const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, 1 /* dilations */ , pad, dimRoundingMode);
    const getPositions = true;
    const maxPoolPositionsProgram = new (0, $gfZLY.Pool2DProgram)(convInfo, 'max', getPositions);
    const maxPoolPositions = backend.runWebGLProgram(maxPoolPositionsProgram, [
        x
    ], x.dtype);
    const maxPoolBackPropProgram = new (0, $i1lwO.MaxPool2DBackpropProgram)(convInfo);
    const result = backend.runWebGLProgram(maxPoolBackPropProgram, [
        dy,
        maxPoolPositions
    ], x.dtype);
    backend.disposeIntermediateTensorInfo(maxPoolPositions);
    return result;
}
const $74c00fc5310f8321$export$e01a7f8dbee29127 = {
    kernelName: (0, $9BGT9.MaxPoolGrad),
    backendName: 'webgl',
    kernelFunc: $74c00fc5310f8321$export$85dfd1121f049514
};

});

parcelRegister("7CXf7", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxConfig", function () { return $58da096437bfc14d$export$a069ee2247a7d1ce; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $aLSii = parcelRequire("aLSii");
const $58da096437bfc14d$export$a069ee2247a7d1ce = {
    kernelName: (0, $9BGT9.MaxPoolWithArgmax),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { filterSize: filterSize, strides: strides, pad: pad, includeBatchInIndex: includeBatchInIndex } = attrs;
        const webglBackend = backend;
        (0, $lBDHD).assert(x.shape.length === 4, ()=>`Error in maxPool: input must be rank 4 but got rank ${x.shape.length}.`);
        const dilations = [
            1,
            1
        ];
        (0, $lBDHD).assert((0, $dEVRx).eitherStridesOrDilationsAreOne(strides, dilations), ()=>'Error in maxPool: Either strides or dilations must be 1. ' + `Got strides ${strides} and dilations '${dilations}'`);
        const convInfo = (0, $dEVRx).computePool2DInfo(x.shape, filterSize, strides, dilations, pad);
        const [result, indexes] = (0, $aLSii.maxPoolWithArgmaxImpl)(x, includeBatchInIndex, convInfo, webglBackend);
        return [
            result,
            indexes
        ];
    }
};

});
parcelRegister("aLSii", function(module, exports) {

$parcel$export(module.exports, "maxPoolWithArgmaxImpl", function () { return $7d7868dedfb132fb$export$3cc34964a47e7a3f; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $gfZLY = parcelRequire("gfZLY");
function $7d7868dedfb132fb$export$3cc34964a47e7a3f(x, includeBatchInIndex, convInfo, backend) {
    let program = new (0, $gfZLY.Pool2DProgram)(convInfo, 'max', false);
    const poolOutput = backend.runWebGLProgram(program, [
        x
    ], 'float32');
    program = new (0, $gfZLY.Pool2DProgram)(convInfo, 'max', true, true, includeBatchInIndex);
    const indexOutput = backend.runWebGLProgram(program, [
        x
    ], 'float32');
    return [
        poolOutput,
        indexOutput
    ];
}

});


parcelRegister("ad9Ji", function(module, exports) {

$parcel$export(module.exports, "meanConfig", function () { return $76f2aa63dbba6b8d$export$b934af0ccd0cdbe1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $8seYE = parcelRequire("8seYE");

var $c7ELT = parcelRequire("c7ELT");
var $glyiU = parcelRequire("glyiU");
const $76f2aa63dbba6b8d$export$b934af0ccd0cdbe1 = {
    kernelName: (0, $9BGT9.Mean),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { x: x } = inputs;
        const { keepDims: keepDims, axis: axis } = attrs;
        const webglBackend = backend;
        const xRank = x.shape.length;
        const origAxes = (0, $lBDHD).parseAxisParam(axis, x.shape);
        let axes = origAxes;
        const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, xRank);
        const meanInputIsTransposed = permutedAxes != null;
        const shouldExecuteOnCPU = webglBackend.shouldExecuteOnCPU([
            x
        ]);
        const intermediates = [];
        let meanInput = x;
        if (meanInputIsTransposed) {
            if (shouldExecuteOnCPU) {
                const xTexData = webglBackend.texData.get(meanInput.dataId);
                const values = xTexData.values;
                const newShape = new Array(xRank);
                for(let i = 0; i < newShape.length; i++)newShape[i] = x.shape[permutedAxes[i]];
                const meanInputValues = (0, $glyiU.transposeImplCPU)(values, x.shape, x.dtype, permutedAxes, newShape);
                meanInput = webglBackend.makeTensorInfo(newShape, x.dtype);
                const meanInputData = webglBackend.texData.get(meanInput.dataId);
                meanInputData.values = meanInputValues;
            } else meanInput = (0, $c7ELT.transposeImpl)(x, permutedAxes, webglBackend);
            intermediates.push(meanInput);
            axes = (0, $dEVRx).getInnerMostAxes(axes.length, xRank);
        }
        (0, $dEVRx).assertAxesAreInnerMostDims('sum', axes, xRank);
        const [meanOutShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(meanInput.shape, axes);
        let outShape = meanOutShape;
        if (keepDims) // rather than reshape at the end, set the target shape here.
        outShape = (0, $dEVRx).expandShapeToKeepDim(meanOutShape, origAxes);
        const out = (0, $8seYE.meanImpl)(meanInput, reduceShape, outShape, webglBackend);
        for (const i of intermediates)webglBackend.disposeIntermediateTensorInfo(i);
        return out;
    }
};

});
parcelRegister("8seYE", function(module, exports) {

$parcel$export(module.exports, "meanImpl", function () { return $0196a775724f5b68$export$320c6ab5e6e7bcef; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $lBDHD = parcelRequire("lBDHD");

var $5kt6u = parcelRequire("5kt6u");

var $aNJFF = parcelRequire("aNJFF");
function $0196a775724f5b68$export$320c6ab5e6e7bcef(x, reduceShape, outShape, backend) {
    const inSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const xSize = (0, $lBDHD).sizeFromShape(x.shape);
    const batchSize = xSize / inSize;
    const reshapedInput = (0, $aNJFF.reshape)({
        inputs: {
            x: x
        },
        attrs: {
            shape: [
                batchSize,
                inSize
            ]
        },
        backend: backend
    });
    const reduced = (0, $5kt6u.reduce)(reshapedInput, 'float32', 'mean', backend);
    const reshapedOutput = (0, $aNJFF.reshape)({
        inputs: {
            x: reduced
        },
        attrs: {
            shape: outShape
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(reshapedInput);
    backend.disposeIntermediateTensorInfo(reduced);
    return reshapedOutput;
}

});


parcelRegister("hNUu4", function(module, exports) {

$parcel$export(module.exports, "minConfig", function () { return $cf62d3cb586f373f$export$3cd9f9a31b38cf18; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $5kt6u = parcelRequire("5kt6u");

var $aNJFF = parcelRequire("aNJFF");

var $fZ5E6 = parcelRequire("fZ5E6");
function $cf62d3cb586f373f$export$96ec731ed4dcb222(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const origAxes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $fZ5E6.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, x.shape.length);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('min', axes, xRank);
    const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(permutedX.shape, axes);
    const inSize = (0, $lBDHD).sizeFromShape(reduceShape);
    const a2D = (0, $aNJFF.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    const reduced = (0, $5kt6u.reduce)(a2D, a2D.dtype, 'min', backend);
    let res;
    if (keepDims) {
        const newShape = (0, $dEVRx).expandShapeToKeepDim(outShape, origAxes);
        res = (0, $aNJFF.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    } else res = (0, $aNJFF.reshape)({
        inputs: {
            x: reduced
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(a2D);
    backend.disposeIntermediateTensorInfo(reduced);
    if (permutedAxes != null) backend.disposeIntermediateTensorInfo(permutedX);
    return res;
}
const $cf62d3cb586f373f$export$3cd9f9a31b38cf18 = {
    kernelName: (0, $9BGT9.Min),
    backendName: 'webgl',
    kernelFunc: $cf62d3cb586f373f$export$96ec731ed4dcb222
};

});

parcelRegister("83UWs", function(module, exports) {

$parcel$export(module.exports, "minimumConfig", function () { return $5deac6065c8923dc$export$ea24ffbbbce8d546; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $iFjfL = parcelRequire("iFjfL");

var $12pF4 = parcelRequire("12pF4");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $5deac6065c8923dc$var$MINIMUM = (0, $iFjfL.CHECK_NAN_SNIPPET) + `
  return min(a, b);
`;
const $5deac6065c8923dc$var$MINIMUM_PACKED = `
  vec4 result = vec4(min(a, b));
  bvec4 isNaNA = isnan(a);
  bvec4 isNaNB = isnan(b);
  bvec4 isNaN = bvec4(isNaNA.x || isNaNB.x, isNaNA.y || isNaNB.y, isNaNA.z || isNaNB.z, isNaNA.w || isNaNB.w);
  ` + (0, $12pF4.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $5deac6065c8923dc$export$916782c1f0ddb132 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $5deac6065c8923dc$var$MINIMUM,
    packedOpSnippet: $5deac6065c8923dc$var$MINIMUM_PACKED,
    cpuKernelImpl: (0, $glyiU.minimumImplCPU)
});
const $5deac6065c8923dc$export$ea24ffbbbce8d546 = {
    kernelName: (0, $9BGT9.Minimum),
    backendName: 'webgl',
    kernelFunc: $5deac6065c8923dc$export$916782c1f0ddb132
};

});

parcelRegister("ji5Ez", function(module, exports) {

$parcel$export(module.exports, "mirrorPadConfig", function () { return $e0b41564163cca67$export$2cfd6c6c7daeb5fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $19Rv8 = parcelRequire("19Rv8");

var $c9Ysg = parcelRequire("c9Ysg");
const $e0b41564163cca67$export$cd4ff5cd9b95abe8 = ({ inputs: inputs, backend: backend, attrs: attrs })=>{
    const { x: x } = inputs;
    const { paddings: paddings, mode: mode } = attrs;
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $c9Ysg.MirrorPadPackedProgram)(x.shape, paddings, mode) : new (0, $19Rv8.MirrorPadProgram)(x.shape, paddings, mode);
    const output = backend.runWebGLProgram(program, [
        x
    ], x.dtype);
    return output;
};
const $e0b41564163cca67$export$2cfd6c6c7daeb5fc = {
    kernelName: (0, $9BGT9.MirrorPad),
    backendName: 'webgl',
    kernelFunc: $e0b41564163cca67$export$cd4ff5cd9b95abe8
};

});
parcelRegister("19Rv8", function(module, exports) {

$parcel$export(module.exports, "MirrorPadProgram", function () { return $0d8021eb6eb67357$export$284b676bb83fc2a7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $0d8021eb6eb67357$export$284b676bb83fc2a7 {
    constructor(xShape, paddings, mode){
        this.variableNames = [
            'x'
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const unpackedCoords = [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank);
        const offset = mode === 'reflect' ? 0 : 1;
        if (rank === 1) {
            this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start) {
            outC = start * 2 - outC - ${offset};
          } else if(outC >= end) {
            outC = (end - 1) * 2 - outC + ${offset};
          }
          setOutput(getX(outC - start));
        }
      `;
            return;
        }
        this.userCode = `
      ${dtype} start = ${dtype}(${start});
      ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outC = getOutputCoords();
        for (int i = 0; i < ${rank}; i++) {
          if (outC[i] < start[i]) {
            outC[i] = start[i] * 2 - outC[i] - ${offset};
          } else if(outC[i] >= end[i]) {
            outC[i] = (end[i] - 1) * 2 - outC[i] + ${offset};
          }
        }
        ${dtype} coords = outC - start;
        setOutput(getX(${unpackedCoords}));
      }
    `;
    }
}

});

parcelRegister("c9Ysg", function(module, exports) {

$parcel$export(module.exports, "MirrorPadPackedProgram", function () { return $8da5386432877480$export$8b179cde16652b52; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $8da5386432877480$export$8b179cde16652b52 {
    constructor(xShape, paddings, mode){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const coords = (0, $coLQR.getChannels)('rc', rank);
        const source = (0, $coLQR.getChannels)('source', rank);
        const cLimit = `${coords[rank - 1]} < ${this.outputShape[rank - 1]}`;
        const innerDims = rank === 1 ? 'source' : `vec2(${source.slice(-2).join()})`;
        const offset = mode === 'reflect' ? 0 : 1;
        let mainLoop = '';
        if (rank === 1) {
            const padSetup = `
        ${dtype} source = rc;
        if (source < start) {
          source = start * 2 - source - ${offset};
        } else if (source >= end) {
          source = (end - 1) * 2 - source + ${offset};
        }
        source -= start;
      `;
            mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source.join()}), ${innerDims});
        ${coords[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source.join()}), ${innerDims});
        }
      `;
        } else {
            const padSetup = `
        ${dtype} source = rc;
        ${dtype} lt = ${dtype}(lessThan(source, start));
        ${dtype} gte = ${dtype}(greaterThanEqual(source, end));
        ${dtype} orig = 1 - (lt + gte);
        source = orig * source +
                lt * (start * 2 - source - ${offset}) +
                gte * ((end - 1) * 2 - source + ${offset});
        source -= start;
      `;
            mainLoop = `
        ${dtype} rc = outputLoc;
        ${padSetup}
        result[0] = getChannel(getX(${source.join()}), ${innerDims});
        ${coords[rank - 1]} += 1;
        if(${cLimit}) {
          ${padSetup}
          result[1] = getChannel(getX(${source.join()}), ${innerDims});
        }
        rc = outputLoc;
        ${coords[rank - 2]} += 1;
        if(${coords[rank - 2]} < ${this.outputShape[rank - 2]}) {
          ${padSetup}
          result[2] = getChannel(getX(${source.join()}), ${innerDims});
          ${coords[rank - 1]} += 1;
          if(${cLimit}) {
            ${padSetup}
            result[3] = getChannel(getX(${source.join()}), ${innerDims});
          }
        }
      `;
        }
        this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("fSu9M", function(module, exports) {

$parcel$export(module.exports, "modConfig", function () { return $b8f34aa794701404$export$9037685a81180a9c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $12pF4 = parcelRequire("12pF4");

var $k2x5z = parcelRequire("k2x5z");
const $b8f34aa794701404$var$MOD = `if (b == 0.0) return NAN;
  return mod(a, b);`;
const $b8f34aa794701404$var$MOD_PACKED = `
  vec4 result = mod(a, b);
  bvec4 isNaN = equal(b, vec4(0.0));
  ` + (0, $12pF4.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $b8f34aa794701404$export$842a2cf37af977e1 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $b8f34aa794701404$var$MOD,
    packedOpSnippet: $b8f34aa794701404$var$MOD_PACKED
});
const $b8f34aa794701404$export$9037685a81180a9c = {
    kernelName: (0, $9BGT9.Mod),
    backendName: 'webgl',
    kernelFunc: $b8f34aa794701404$export$842a2cf37af977e1
};

});

parcelRegister("3NoKu", function(module, exports) {

$parcel$export(module.exports, "multinomialConfig", function () { return $2c39254e2cd91e2e$export$ad960e364767f0e2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $jMt3x = parcelRequire("jMt3x");

var $hyAtS = parcelRequire("hyAtS");
function $2c39254e2cd91e2e$export$f4d580f3101a1c7e(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { numSamples: numSamples, seed: seed, normalized: normalized } = attrs;
    const probs = normalized ? logits : (0, $hyAtS.softmax)({
        inputs: {
            logits: logits
        },
        backend: backend,
        attrs: {
            dim: logits.shape.length - 1
        }
    });
    const batchSize = probs.shape[0];
    const numOutcomes = probs.shape[1];
    const program = new (0, $jMt3x.MultinomialProgram)(batchSize, numOutcomes, numSamples);
    const customValues = [
        [
            seed
        ]
    ];
    const res = backend.runWebGLProgram(program, [
        probs
    ], 'int32', customValues);
    if (!normalized) backend.disposeIntermediateTensorInfo(probs);
    return res;
}
const $2c39254e2cd91e2e$export$ad960e364767f0e2 = {
    kernelName: (0, $9BGT9.Multinomial),
    backendName: 'webgl',
    kernelFunc: $2c39254e2cd91e2e$export$f4d580f3101a1c7e
};

});
parcelRegister("jMt3x", function(module, exports) {

$parcel$export(module.exports, "MultinomialProgram", function () { return $e66909f37900f6af$export$f8cda6c8ea4f2110; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $e66909f37900f6af$export$f8cda6c8ea4f2110 {
    constructor(batchSize, numOutcomes, numSamples){
        this.variableNames = [
            'probs'
        ];
        this.customUniforms = [
            {
                name: 'seed',
                type: 'float'
            }
        ];
        this.outputShape = [
            batchSize,
            numSamples
        ];
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];

        float r = random(seed);
        float cdf = 0.0;

        for (int i = 0; i < ${numOutcomes - 1}; i++) {
          cdf += getProbs(batch, i);

          if (r < cdf) {
            setOutput(float(i));
            return;
          }
        }

        // If no other event happened, last event happened.
        setOutput(float(${numOutcomes - 1}));
      }
    `;
    }
}

});

parcelRegister("hyAtS", function(module, exports) {

$parcel$export(module.exports, "softmax", function () { return $cc81e8fc051cc1df$export$e008137e76238601; });
$parcel$export(module.exports, "softmaxConfig", function () { return $cc81e8fc051cc1df$export$c022691f23e2ee69; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $6Oijd = parcelRequire("6Oijd");

var $fHp2B = parcelRequire("fHp2B");

var $DVL3y = parcelRequire("DVL3y");

var $aNJFF = parcelRequire("aNJFF");

var $hQKEf = parcelRequire("hQKEf");

var $frWKu = parcelRequire("frWKu");
function $cc81e8fc051cc1df$export$e008137e76238601(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { logits: logits } = inputs;
    const { dim: dim } = attrs;
    const axes = (0, $lBDHD).parseAxisParam([
        dim
    ], logits.shape);
    const maxLogit = (0, $fHp2B.max)({
        inputs: {
            x: logits
        },
        backend: backend,
        attrs: {
            reductionIndices: axes,
            keepDims: false
        }
    });
    const expandedShape = (0, $dEVRx).expandShapeToKeepDim(maxLogit.shape, axes);
    const maxLogitsReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: maxLogit
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const a = (0, $hQKEf.sub)({
        inputs: {
            a: logits,
            b: maxLogitsReshaped
        },
        backend: backend
    });
    const b = (0, $6Oijd.exp)({
        inputs: {
            x: a
        },
        backend: backend
    });
    const sumExp = (0, $frWKu.sum)({
        inputs: {
            x: b
        },
        backend: backend,
        attrs: {
            axis: axes,
            keepDims: false
        }
    });
    const sumExpReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: sumExp
        },
        backend: backend,
        attrs: {
            shape: expandedShape
        }
    });
    const res = (0, $DVL3y.realDiv)({
        inputs: {
            a: b,
            b: sumExpReshaped
        },
        backend: backend
    });
    backend.disposeIntermediateTensorInfo(maxLogit);
    backend.disposeIntermediateTensorInfo(maxLogitsReshaped);
    backend.disposeIntermediateTensorInfo(a);
    backend.disposeIntermediateTensorInfo(b);
    backend.disposeIntermediateTensorInfo(sumExp);
    backend.disposeIntermediateTensorInfo(sumExpReshaped);
    return res;
}
const $cc81e8fc051cc1df$export$c022691f23e2ee69 = {
    kernelName: (0, $9BGT9.Softmax),
    backendName: 'webgl',
    kernelFunc: $cc81e8fc051cc1df$export$e008137e76238601
};

});
parcelRegister("DVL3y", function(module, exports) {

$parcel$export(module.exports, "realDiv", function () { return $07807229c2ba64ff$export$f76766520aabd67; });
$parcel$export(module.exports, "realDivConfig", function () { return $07807229c2ba64ff$export$15c5d6176b30b9a6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
// Without the equality check div produces 0.9999 for a = b, which when
// floored can cause errors.
const $07807229c2ba64ff$var$DIV = `
if (a == b) {
  return 1.0;
};
return a / b;`;
// We do the same as in ./binaryop_gpu, with vec4 and ivec4.
// On Linux, the vectorized implementation produces NaNs when a and b are 0.
const $07807229c2ba64ff$var$DIV_PACKED = `
  // vec4 one = vec4(equal(a, b));
  // return one + (vec4(1.0) - one) * a / b;
  vec4 result = a / b;
  if(a.x == b.x) {
    result.x = 1.;
  }
  if(a.y == b.y) {
    result.y = 1.;
  }
  if(a.z == b.z) {
    result.z = 1.;
  }
  if(a.w == b.w) {
    result.w = 1.;
  }

  return result;
`;
const $07807229c2ba64ff$export$f76766520aabd67 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $07807229c2ba64ff$var$DIV,
    packedOpSnippet: $07807229c2ba64ff$var$DIV_PACKED,
    checkOutOfBounds: true
});
const $07807229c2ba64ff$export$15c5d6176b30b9a6 = {
    kernelName: (0, $9BGT9.RealDiv),
    backendName: 'webgl',
    kernelFunc: $07807229c2ba64ff$export$f76766520aabd67
};

});

parcelRegister("hQKEf", function(module, exports) {

$parcel$export(module.exports, "sub", function () { return $cfeb7a5a71afe06f$export$f93b5905241a7cca; });
$parcel$export(module.exports, "subConfig", function () { return $cfeb7a5a71afe06f$export$5d068476dad60c4d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $cfeb7a5a71afe06f$var$SUB = 'return a - b;';
const $cfeb7a5a71afe06f$export$f93b5905241a7cca = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $cfeb7a5a71afe06f$var$SUB,
    packedOpSnippet: $cfeb7a5a71afe06f$var$SUB,
    supportsComplex: true,
    cpuKernelImpl: (0, $glyiU.subImplCPU)
});
const $cfeb7a5a71afe06f$export$5d068476dad60c4d = {
    kernelName: (0, $9BGT9.Sub),
    backendName: 'webgl',
    kernelFunc: $cfeb7a5a71afe06f$export$f93b5905241a7cca
};

});



parcelRegister("6RCoa", function(module, exports) {

$parcel$export(module.exports, "negConfig", function () { return $4ff57882bce016a9$export$cc7b18b8229c3db; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");

var $1V6Qm = parcelRequire("1V6Qm");

var $2s8wb = parcelRequire("2s8wb");
const $4ff57882bce016a9$var$NEG = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
  return -x;
`;
const $4ff57882bce016a9$var$NEG_PACKED = `
  vec4 result = -x;
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
function $4ff57882bce016a9$export$d9493ff0dfa0fdd5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (backend.shouldExecuteOnCPU([
        x
    ])) {
        const xData = backend.texData.get(x.dataId);
        const [outValues, newShape] = (0, $glyiU.negImplCPU)(xData.values, x.shape, x.dtype);
        return backend.makeTensorInfo(newShape, x.dtype, outValues);
    }
    let program;
    if ((0, $tdutJ.env)().getBool('WEBGL_PACK_UNARY_OPERATIONS')) program = new (0, $2s8wb.UnaryOpPackedProgram)(x.shape, $4ff57882bce016a9$var$NEG_PACKED);
    else program = new (0, $1V6Qm.UnaryOpProgram)(x.shape, $4ff57882bce016a9$var$NEG);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $4ff57882bce016a9$export$cc7b18b8229c3db = {
    kernelName: (0, $9BGT9.Neg),
    backendName: 'webgl',
    kernelFunc: $4ff57882bce016a9$export$d9493ff0dfa0fdd5
};

});

parcelRegister("26wA9", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV3Config", function () { return $18856a69b3ca10e3$export$549561cd158f260a; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $iEnT2 = parcelRequire("iEnT2");
var $9BGT9 = parcelRequire("9BGT9");
const $18856a69b3ca10e3$var$nonMaxSuppressionV3Impl = (0, $iEnT2).nonMaxSuppressionV3Impl;
function $18856a69b3ca10e3$export$8917e4bf7f7f5d42(args) {
    (0, $dEVRx).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices } = $18856a69b3ca10e3$var$nonMaxSuppressionV3Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold);
    return backend.makeTensorInfo([
        selectedIndices.length
    ], 'int32', new Int32Array(selectedIndices));
}
const $18856a69b3ca10e3$export$549561cd158f260a = {
    kernelName: (0, $9BGT9.NonMaxSuppressionV3),
    backendName: 'webgl',
    kernelFunc: $18856a69b3ca10e3$export$8917e4bf7f7f5d42
};

});

parcelRegister("1FWdY", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV4Config", function () { return $1386c8f29e880f41$export$906b8fb32c570e9d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $iEnT2 = parcelRequire("iEnT2");
var $9BGT9 = parcelRequire("9BGT9");
const $1386c8f29e880f41$var$nonMaxSuppressionV4Impl = (0, $iEnT2).nonMaxSuppressionV4Impl;
function $1386c8f29e880f41$export$ad519bdebe8f4dcf(args) {
    (0, $dEVRx).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, padToMaxOutputSize: padToMaxOutputSize } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const { selectedIndices: selectedIndices, validOutputs: validOutputs } = $1386c8f29e880f41$var$nonMaxSuppressionV4Impl(boxesVals, scoresVals, maxOutputSize, iouThreshold, scoreThreshold, padToMaxOutputSize);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([], 'int32', new Int32Array([
            validOutputs
        ]))
    ];
}
const $1386c8f29e880f41$export$906b8fb32c570e9d = {
    kernelName: (0, $9BGT9.NonMaxSuppressionV4),
    backendName: 'webgl',
    kernelFunc: $1386c8f29e880f41$export$ad519bdebe8f4dcf
};

});

parcelRegister("05jkH", function(module, exports) {

$parcel$export(module.exports, "nonMaxSuppressionV5Config", function () { return $00ff76dd4b179dad$export$4c00b682f309701d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $iEnT2 = parcelRequire("iEnT2");
var $9BGT9 = parcelRequire("9BGT9");
const $00ff76dd4b179dad$var$nonMaxSuppressionV5Impl = (0, $iEnT2).nonMaxSuppressionV5Impl;
function $00ff76dd4b179dad$export$49e389fdbe01a534(args) {
    (0, $dEVRx).warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { boxes: boxes, scores: scores } = inputs;
    const { maxOutputSize: maxOutputSize, iouThreshold: iouThreshold, scoreThreshold: scoreThreshold, softNmsSigma: softNmsSigma } = attrs;
    const boxesVals = backend.readSync(boxes.dataId);
    const scoresVals = backend.readSync(scores.dataId);
    const maxOutputSizeVal = maxOutputSize;
    const iouThresholdVal = iouThreshold;
    const scoreThresholdVal = scoreThreshold;
    const softNmsSigmaVal = softNmsSigma;
    const { selectedIndices: selectedIndices, selectedScores: selectedScores } = $00ff76dd4b179dad$var$nonMaxSuppressionV5Impl(boxesVals, scoresVals, maxOutputSizeVal, iouThresholdVal, scoreThresholdVal, softNmsSigmaVal);
    return [
        backend.makeTensorInfo([
            selectedIndices.length
        ], 'int32', new Int32Array(selectedIndices)),
        backend.makeTensorInfo([
            selectedScores.length
        ], 'float32', new Float32Array(selectedScores))
    ];
}
const $00ff76dd4b179dad$export$4c00b682f309701d = {
    kernelName: (0, $9BGT9.NonMaxSuppressionV5),
    backendName: 'webgl',
    kernelFunc: $00ff76dd4b179dad$export$49e389fdbe01a534
};

});

parcelRegister("kLdPP", function(module, exports) {

$parcel$export(module.exports, "oneHotConfig", function () { return $f1d2edbe047ba293$export$dde5645b472b80b2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $iPPJ3 = parcelRequire("iPPJ3");

var $aNJFF = parcelRequire("aNJFF");
const $f1d2edbe047ba293$export$341b5490a776d041 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices } = inputs;
    const { dtype: dtype, depth: depth, onValue: onValue, offValue: offValue } = attrs;
    const indicesSize = (0, $lBDHD).sizeFromShape(indices.shape);
    const program = new (0, $iPPJ3.OneHotProgram)(indicesSize, depth, onValue, offValue);
    const reshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                indicesSize
            ]
        }
    });
    const result = backend.runWebGLProgram(program, [
        reshaped
    ], dtype);
    backend.disposeIntermediateTensorInfo(reshaped);
    const outShape = [
        ...indices.shape,
        depth
    ];
    const out = (0, $aNJFF.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    backend.disposeIntermediateTensorInfo(result);
    return out;
};
const $f1d2edbe047ba293$export$dde5645b472b80b2 = {
    kernelName: (0, $9BGT9.OneHot),
    backendName: 'webgl',
    kernelFunc: $f1d2edbe047ba293$export$341b5490a776d041
};

});
parcelRegister("iPPJ3", function(module, exports) {

$parcel$export(module.exports, "OneHotProgram", function () { return $db651d14a76aa9e7$export$314e506cf5800fc5; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $db651d14a76aa9e7$export$314e506cf5800fc5 {
    constructor(numIndices, depth, onValue, offValue){
        this.variableNames = [
            'indices'
        ];
        this.outputShape = [
            numIndices,
            depth
        ];
        this.userCode = `
      void main() {
        ivec2 coords = getOutputCoords();
        int index = round(getIndices(coords.x));
        setOutput(mix(float(${offValue}), float(${onValue}),
                      float(index == coords.y)));
      }
    `;
    }
}

});


parcelRegister("TkopF", function(module, exports) {

$parcel$export(module.exports, "onesLikeConfig", function () { return $0a64f4bf0051d3c6$export$d8d7015eb6ab37d0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6iqSX = parcelRequire("6iqSX");

var $e4Jud = parcelRequire("e4Jud");

var $84pSa = parcelRequire("84pSa");

var $aUagc = parcelRequire("aUagc");

var $40QsG = parcelRequire("40QsG");
function $0a64f4bf0051d3c6$export$fb6afd6214fee9e9(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'string') throw new Error('onesLike is not supported under string dtype');
    else if (x.dtype === 'complex64') {
        const realPart = (0, $aUagc.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $0a64f4bf0051d3c6$export$fb6afd6214fee9e9({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $84pSa.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = (0, $40QsG.zerosLike)({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $6iqSX.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else // TODO(cais, smilkov): Add WebGL shader for onesLike:
    //   https://github.com/tensorflow/tfjs/issues/1293
    return (0, $e4Jud.fill)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: 1
        },
        backend: backend
    });
}
const $0a64f4bf0051d3c6$export$d8d7015eb6ab37d0 = {
    kernelName: (0, $9BGT9.OnesLike),
    backendName: 'webgl',
    kernelFunc: $0a64f4bf0051d3c6$export$fb6afd6214fee9e9
};

});
parcelRegister("40QsG", function(module, exports) {

$parcel$export(module.exports, "zerosLike", function () { return $2ebfdb4b35a30201$export$cb1f824e7733584d; });
$parcel$export(module.exports, "zerosLikeConfig", function () { return $2ebfdb4b35a30201$export$15368df05c479e41; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $6iqSX = parcelRequire("6iqSX");

var $e4Jud = parcelRequire("e4Jud");

var $84pSa = parcelRequire("84pSa");

var $aUagc = parcelRequire("aUagc");
function $2ebfdb4b35a30201$export$cb1f824e7733584d(args) {
    const { inputs: inputs, backend: backend } = args;
    const { x: x } = inputs;
    if (x.dtype === 'complex64') {
        const realPart = (0, $aUagc.real)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const r = $2ebfdb4b35a30201$export$cb1f824e7733584d({
            inputs: {
                x: realPart
            },
            backend: backend
        });
        const imagPart = (0, $84pSa.imag)({
            inputs: {
                input: x
            },
            backend: backend
        });
        const i = $2ebfdb4b35a30201$export$cb1f824e7733584d({
            inputs: {
                x: imagPart
            },
            backend: backend
        });
        const result = (0, $6iqSX.complex)({
            inputs: {
                real: r,
                imag: i
            },
            backend: backend
        });
        backend.disposeIntermediateTensorInfo(realPart);
        backend.disposeIntermediateTensorInfo(r);
        backend.disposeIntermediateTensorInfo(imagPart);
        backend.disposeIntermediateTensorInfo(i);
        return result;
    } else return (0, $e4Jud.fill)({
        attrs: {
            shape: x.shape,
            dtype: x.dtype,
            value: x.dtype === 'string' ? '' : 0
        },
        backend: backend
    });
}
const $2ebfdb4b35a30201$export$15368df05c479e41 = {
    kernelName: (0, $9BGT9.ZerosLike),
    backendName: 'webgl',
    kernelFunc: $2ebfdb4b35a30201$export$cb1f824e7733584d
};

});


parcelRegister("3303z", function(module, exports) {

$parcel$export(module.exports, "packConfig", function () { return $2381b2284e47827b$export$1645fa8803aa1f86; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $hRABi = parcelRequire("hRABi");

var $aeVNP = parcelRequire("aeVNP");
function $2381b2284e47827b$export$2a703dbb0cb35339(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { axis: axis } = attrs;
    if (inputs.length === 1) return (0, $aeVNP.expandDims)({
        inputs: {
            input: inputs[0]
        },
        backend: backend,
        attrs: {
            dim: axis
        }
    });
    const shape = inputs[0].shape;
    const dtype = inputs[0].dtype;
    inputs.forEach((t)=>{
        (0, $lBDHD).assertShapesMatch(shape, t.shape, 'All tensors passed to stack must have matching shapes');
        (0, $lBDHD).assert(dtype === t.dtype, ()=>'All tensors passed to stack must have matching dtypes');
    });
    const intermediateTensorInfos = [];
    const expandedTensors = inputs.map((t)=>{
        const expandedT = (0, $aeVNP.expandDims)({
            inputs: {
                input: t
            },
            backend: backend,
            attrs: {
                dim: axis
            }
        });
        intermediateTensorInfos.push(expandedT);
        return expandedT;
    });
    const result = (0, $hRABi.concat)({
        inputs: expandedTensors,
        backend: backend,
        attrs: {
            axis: axis
        }
    });
    intermediateTensorInfos.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $2381b2284e47827b$export$1645fa8803aa1f86 = {
    kernelName: (0, $9BGT9.Pack),
    backendName: 'webgl',
    kernelFunc: $2381b2284e47827b$export$2a703dbb0cb35339
};

});

parcelRegister("8ExI5", function(module, exports) {

$parcel$export(module.exports, "padV2", function () { return $64cc3543dee68294$export$f676d6ad4f38bb89; });
$parcel$export(module.exports, "padV2Config", function () { return $64cc3543dee68294$export$b0317e720bfd61fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $dLz3p = parcelRequire("dLz3p");

var $d44dr = parcelRequire("d44dr");

var $e4Jud = parcelRequire("e4Jud");
const $64cc3543dee68294$export$f676d6ad4f38bb89 = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { paddings: paddings, constantValue: constantValue } = attrs;
    if ((0, $lBDHD).sizeFromShape(x.shape) === 0) {
        // Short-circuit the computation, since x doesn't have value, only
        // the shape is used to compute output shape to pad.
        const outputShape = paddings.map((p, i)=>p[0] + x.shape[i] + p[1]);
        return (0, $e4Jud.fill)({
            backend: backend,
            attrs: {
                shape: outputShape,
                value: constantValue,
                dtype: x.dtype
            }
        });
    }
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $d44dr.PadPackedProgram)(x.shape, paddings, constantValue) : new (0, $dLz3p.PadProgram)(x.shape, paddings, constantValue);
    const customValues = [
        [
            constantValue
        ]
    ];
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype, customValues);
};
const $64cc3543dee68294$export$b0317e720bfd61fc = {
    kernelName: (0, $9BGT9.PadV2),
    backendName: 'webgl',
    kernelFunc: $64cc3543dee68294$export$f676d6ad4f38bb89
};

});
parcelRegister("dLz3p", function(module, exports) {

$parcel$export(module.exports, "PadProgram", function () { return $a05adb215ba25f28$export$15f19b307ce21f0a; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $a05adb215ba25f28$export$15f19b307ce21f0a {
    constructor(xShape, paddings, constantValue){
        this.variableNames = [
            'x'
        ];
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const type = (0, $1eI1C.getCoordsDataType)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const unpackedCoords = [
            'coords[0]',
            'coords[1]',
            'coords[2]',
            'coords[3]'
        ].slice(0, rank);
        if (rank === 1) {
            this.userCode = `
        int start = ${start};
        int end = ${end};

        void main() {
          int outC = getOutputCoords();
          if (outC < start || outC >= end) {
            setOutput(value);
          } else {
            setOutput(getX(outC - start));
          }
        }
      `;
            return;
        }
        this.userCode = `
      ${type} start = ${type}(${start});
      ${type} end = ${type}(${end});

      void main() {
        ${type} outC = getOutputCoords();
        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {
          setOutput(value);
        } else {
          ${type} coords = outC - start;
          setOutput(getX(${unpackedCoords}));
        }
      }
    `;
    }
}

});

parcelRegister("d44dr", function(module, exports) {

$parcel$export(module.exports, "PadPackedProgram", function () { return $982eeb4012a85368$export$ed21e062cfba77c5; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $982eeb4012a85368$export$ed21e062cfba77c5 {
    constructor(xShape, paddings, constantValue){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.customUniforms = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        this.outputShape = paddings.map((p, i)=>p[0] + xShape[i] + p[1]);
        const rank = xShape.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(rank);
        const start = paddings.map((p)=>p[0]).join(',');
        const end = paddings.map((p, i)=>p[0] + xShape[i]).join(',');
        const coords = (0, $coLQR.getChannels)('rc', rank);
        const source = (0, $coLQR.getChannels)('source', rank);
        const cLimit = `${coords[rank - 1]} < ${this.outputShape[rank - 1]}`;
        const innerDims = rank === 1 ? 'source' : `vec2(${source.slice(-2).join()})`;
        const componentSetup = [
            `${dtype} rc = outputLoc;`,
            `${coords[rank - 1]} += 1;
       if(${cLimit}) {
      `,
            rank === 1 ? '' : `}
       rc = outputLoc;
       ${coords[rank - 2]} += 1;
       if(${coords[rank - 2]} < ${this.outputShape[rank - 2]}) {`,
            rank === 1 ? '' : `  ${coords[rank - 1]} += 1;
         if(${cLimit}) {`
        ];
        const paddingArea = rank === 1 ? 'rc < start || rc >= end' : 'any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))';
        let mainLoop = '';
        for(let i = 0, j = rank === 1 ? 2 : 4; i < j; i++)mainLoop += `
        ${componentSetup[i]}
        if (${paddingArea}) {
          result[${i}] = float(value);
        } else {
          ${dtype} source = rc - start;
          result[${i}] = getChannel(getX(${source.join()}), ${innerDims});
        }
      `;
        mainLoop += rank === 1 ? `} ` : `}}`;
        this.userCode = `
      const ${dtype} start = ${dtype}(${start});
      const ${dtype} end = ${dtype}(${end});

      void main() {
        ${dtype} outputLoc = getOutputCoords();
        vec4 result = vec4(0.);
        ${mainLoop}
        setOutput(result);
      }
    `;
    }
}

});


parcelRegister("1JwhF", function(module, exports) {

$parcel$export(module.exports, "powConfig", function () { return $1433095916ad4255$export$b823d49786719761; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $12pF4 = parcelRequire("12pF4");

var $k2x5z = parcelRequire("k2x5z");
const $1433095916ad4255$var$POW = `
  if(a < 0.0 && floor(b) < b){
    return NAN;
  }
  if (b == 0.0) {
    return 1.0;
  }
  return (round(mod(b, 2.0)) != 1) ?
      pow(abs(a), b) : sign(a) * pow(abs(a), b);
`;
const $1433095916ad4255$var$POW_PACKED = `
  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.
  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));
  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);
  vec4 result = multiplier * pow(abs(a), b);

  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS
  bvec4 isExpZero = equal(b, vec4(0.0));
  result.r = isExpZero.r ? 1.0 : result.r;
  result.g = isExpZero.g ? 1.0 : result.g;
  result.b = isExpZero.b ? 1.0 : result.b;
  result.a = isExpZero.a ? 1.0 : result.a;

  bvec4 isNaN1 = lessThan(a, vec4(0.0));
  bvec4 isNaN2 = lessThan(floor(b), b);
  bvec4 isNaN = bvec4(isNaN1.x && isNaN2.x, isNaN1.y && isNaN2.y, isNaN1.z && isNaN2.z, isNaN1.w && isNaN2.w);
  ` + (0, $12pF4.CHECK_NAN_SNIPPET_PACKED) + `
  return result;
`;
const $1433095916ad4255$export$9c297f60e22e3389 = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $1433095916ad4255$var$POW,
    packedOpSnippet: $1433095916ad4255$var$POW_PACKED
});
const $1433095916ad4255$export$b823d49786719761 = {
    kernelName: (0, $9BGT9.Pow),
    backendName: 'webgl',
    kernelFunc: $1433095916ad4255$export$9c297f60e22e3389
};

});

parcelRegister("esUwy", function(module, exports) {

$parcel$export(module.exports, "prodConfig", function () { return $a87f86b278da6a02$export$d556aa935cef5c0c; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $kKv2E = parcelRequire("kKv2E");
var $lBDHD = parcelRequire("lBDHD");

var $5kt6u = parcelRequire("5kt6u");

var $glyiU = parcelRequire("glyiU");

var $aNJFF = parcelRequire("aNJFF");

var $fZ5E6 = parcelRequire("fZ5E6");
function $a87f86b278da6a02$export$5e143010dea16c85(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { axis: axis, keepDims: keepDims } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    const origAxes = (0, $lBDHD).parseAxisParam(axis, x.shape);
    let axes = origAxes;
    const permutedAxes = (0, $dEVRx).getAxesPermutation(axes, xRank);
    let permutedX = x;
    if (permutedAxes != null) {
        permutedX = (0, $fZ5E6.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutedAxes
            }
        });
        axes = (0, $dEVRx).getInnerMostAxes(axes.length, xRank);
        toDispose.push(permutedX);
    }
    (0, $dEVRx).assertAxesAreInnerMostDims('prod', axes, xRank);
    let res;
    if (backend.shouldExecuteOnCPU([
        permutedX
    ])) {
        const xVals = backend.texData.get(permutedX.dataId).values;
        const { outVals: outVals, outShape: outShape, outDtype: outDtype } = (0, $glyiU.prodImplCPU)(permutedX.shape, permutedX.dtype, xVals, axes);
        res = backend.makeTensorInfo(outShape, outDtype, outVals);
    } else {
        const [outShape, reduceShape] = (0, $dEVRx).computeOutAndReduceShapes(permutedX.shape, axes);
        const inSize = (0, $lBDHD).sizeFromShape(reduceShape);
        const a2D = (0, $aNJFF.reshape)({
            inputs: {
                x: permutedX
            },
            backend: backend,
            attrs: {
                shape: [
                    -1,
                    inSize
                ]
            }
        });
        const outputDType = (0, $kKv2E.sumOutType)(x.dtype);
        const reduced = (0, $5kt6u.reduce)(a2D, outputDType, 'prod', backend);
        res = (0, $aNJFF.reshape)({
            inputs: {
                x: reduced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        toDispose.push(a2D);
        toDispose.push(reduced);
    }
    if (keepDims) {
        toDispose.push(res);
        const newShape = (0, $dEVRx).expandShapeToKeepDim(res.shape, origAxes);
        res = (0, $aNJFF.reshape)({
            inputs: {
                x: res
            },
            backend: backend,
            attrs: {
                shape: newShape
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return res;
}
const $a87f86b278da6a02$export$d556aa935cef5c0c = {
    kernelName: (0, $9BGT9.Prod),
    backendName: 'webgl',
    kernelFunc: $a87f86b278da6a02$export$5e143010dea16c85
};

});

parcelRegister("nIJXn", function(module, exports) {

$parcel$export(module.exports, "raggedGatherConfig", function () { return $0474da938a08efe0$export$cebb8a7d5932c7e8; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $0474da938a08efe0$export$e7118f605df251dd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { paramsNestedSplits: paramsNestedSplits, paramsDenseValues: paramsDenseValues, indices: indices } = inputs;
    const { outputRaggedRank: outputRaggedRank } = attrs;
    const $paramsNestedSplits = paramsNestedSplits.map((t)=>backend.readSync(t.dataId));
    const $paramsNestedSplitsShapes = paramsNestedSplits.map((t)=>t.shape);
    const $paramsDenseValues = backend.readSync(paramsDenseValues.dataId);
    const $indices = backend.readSync(indices.dataId);
    const [outputNestedSplits, outputDenseValues, outputDenseValuesShape] = (0, $glyiU.raggedGatherImplCPU)($paramsNestedSplits, $paramsNestedSplitsShapes, $paramsDenseValues, paramsDenseValues.shape, paramsDenseValues.dtype, $indices, indices.shape, outputRaggedRank);
    const outputNestedSplitsTensors = outputNestedSplits.map((splits)=>backend.makeTensorInfo([
            splits.length
        ], 'int32', splits));
    const outputDenseValuesTensor = backend.makeTensorInfo(outputDenseValuesShape, paramsDenseValues.dtype, outputDenseValues);
    return outputNestedSplitsTensors.concat([
        outputDenseValuesTensor
    ]);
}
const $0474da938a08efe0$export$cebb8a7d5932c7e8 = {
    kernelName: (0, $9BGT9.RaggedGather),
    backendName: 'webgl',
    kernelFunc: $0474da938a08efe0$export$e7118f605df251dd
};

});

parcelRegister("7k8sn", function(module, exports) {

$parcel$export(module.exports, "raggedRangeConfig", function () { return $5550f5f5c105150a$export$91ddd62a193b9401; });
/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $5550f5f5c105150a$export$a173be400c6762b5(args) {
    const { inputs: inputs, backend: backend } = args;
    const { starts: starts, limits: limits, deltas: deltas } = inputs;
    const $starts = backend.readSync(starts.dataId);
    const $limits = backend.readSync(limits.dataId);
    const $deltas = backend.readSync(deltas.dataId);
    const [rtNestedSplitsData, rtDenseValuesData] = (0, $glyiU.raggedRangeImplCPU)($starts, starts.shape, starts.dtype, $limits, limits.shape, $deltas, deltas.shape);
    const rtNestedSplits = backend.makeTensorInfo([
        rtNestedSplitsData.length
    ], 'int32', rtNestedSplitsData);
    const rtDenseValues = backend.makeTensorInfo([
        rtDenseValuesData.length
    ], starts.dtype, rtDenseValuesData);
    return [
        rtNestedSplits,
        rtDenseValues
    ];
}
const $5550f5f5c105150a$export$91ddd62a193b9401 = {
    kernelName: (0, $9BGT9.RaggedRange),
    backendName: 'webgl',
    kernelFunc: $5550f5f5c105150a$export$a173be400c6762b5
};

});

parcelRegister("DYnMj", function(module, exports) {

$parcel$export(module.exports, "raggedTensorToTensorConfig", function () { return $07827b58106b00bb$export$792f441e33dcdf26; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $07827b58106b00bb$export$621e390307cbbaa1(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { shape: shape, values: values, defaultValue: defaultValue, rowPartitionTensors: rowPartitionTensors } = inputs;
    const { rowPartitionTypes: rowPartitionTypes } = attrs;
    const $shape = backend.readSync(shape.dataId);
    const $values = backend.readSync(values.dataId);
    const $defaultValue = backend.readSync(defaultValue.dataId);
    const $rowPartitionValues = rowPartitionTensors.map((t)=>backend.readSync(t.dataId));
    const rowPartitionValuesShapes = rowPartitionTensors.map((t)=>t.shape);
    const [outputShape, output] = (0, $glyiU.raggedTensorToTensorImplCPU)($shape, shape.shape, $values, values.shape, values.dtype, $defaultValue, defaultValue.shape, $rowPartitionValues, rowPartitionValuesShapes, rowPartitionTypes);
    return backend.makeTensorInfo(outputShape, values.dtype, output);
}
const $07827b58106b00bb$export$792f441e33dcdf26 = {
    kernelName: (0, $9BGT9.RaggedTensorToTensor),
    backendName: 'webgl',
    kernelFunc: $07827b58106b00bb$export$621e390307cbbaa1
};

});

parcelRegister("3dQjt", function(module, exports) {

$parcel$export(module.exports, "range", function () { return $258b2a49f30199ef$export$d02631cccf789723; });
$parcel$export(module.exports, "rangeConfig", function () { return $258b2a49f30199ef$export$361c4075706e31c2; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
const $258b2a49f30199ef$export$d02631cccf789723 = (args)=>{
    const { backend: backend, attrs: attrs } = args;
    const { start: start, stop: stop, step: step, dtype: dtype } = attrs;
    const values = (0, $glyiU.rangeImplCPU)(start, stop, step, dtype);
    return backend.makeTensorInfo([
        values.length
    ], dtype, values);
};
const $258b2a49f30199ef$export$361c4075706e31c2 = {
    kernelName: (0, $9BGT9.Range),
    backendName: 'webgl',
    kernelFunc: $258b2a49f30199ef$export$d02631cccf789723
};

});

parcelRegister("8ZvNg", function(module, exports) {

$parcel$export(module.exports, "reciprocalConfig", function () { return $68bcaec5b4e2d762$export$412a6b66203fdf72; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $68bcaec5b4e2d762$var$RECIPROCAL = `return 1.0 / x;`;
const $68bcaec5b4e2d762$export$163bc8c839a1ac04 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $68bcaec5b4e2d762$var$RECIPROCAL
});
const $68bcaec5b4e2d762$export$412a6b66203fdf72 = {
    kernelName: (0, $9BGT9.Reciprocal),
    backendName: 'webgl',
    kernelFunc: $68bcaec5b4e2d762$export$163bc8c839a1ac04
};

});

parcelRegister("jvLKk", function(module, exports) {

$parcel$export(module.exports, "reluConfig", function () { return $e345f2fee8d06299$export$731f9199bde068eb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $1V6Qm = parcelRequire("1V6Qm");
const $e345f2fee8d06299$var$RELU = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
  return (x < 0.0) ? 0.0 : x;
`;
const $e345f2fee8d06299$var$RELU_PACKED = `
  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $e345f2fee8d06299$export$16d1e4612cc0139f = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $e345f2fee8d06299$var$RELU,
    packedOpSnippet: $e345f2fee8d06299$var$RELU_PACKED
});
const $e345f2fee8d06299$export$731f9199bde068eb = {
    kernelName: (0, $9BGT9.Relu),
    backendName: 'webgl',
    kernelFunc: $e345f2fee8d06299$export$16d1e4612cc0139f
};

});

parcelRegister("3Nvei", function(module, exports) {

$parcel$export(module.exports, "relu6Config", function () { return $2c3e2c3e8b826b52$export$92c30890ad649d53; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $1V6Qm = parcelRequire("1V6Qm");
const $2c3e2c3e8b826b52$var$RELU6 = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
  return (x < 0.0) ? 0.0 : min(6.0, x);
`;
const $2c3e2c3e8b826b52$var$RELU6_PACKED = `
  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $2c3e2c3e8b826b52$export$4a62bcb95e9c44c4 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $2c3e2c3e8b826b52$var$RELU6,
    packedOpSnippet: $2c3e2c3e8b826b52$var$RELU6_PACKED
});
const $2c3e2c3e8b826b52$export$92c30890ad649d53 = {
    kernelName: (0, $9BGT9.Relu6),
    backendName: 'webgl',
    kernelFunc: $2c3e2c3e8b826b52$export$4a62bcb95e9c44c4
};

});

parcelRegister("eF9kq", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearConfig", function () { return $aacc216fb49cbb7a$export$a37a56137abc1357; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $j5K6W = parcelRequire("j5K6W");

var $kaBwU = parcelRequire("kaBwU");
function $aacc216fb49cbb7a$export$1f1cbc7da93d06a0(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ? new (0, $kaBwU.ResizeBilinearPackedProgram)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new (0, $j5K6W.ResizeBilinearProgram)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
    return backend.runWebGLProgram(program, [
        images
    ], 'float32');
}
const $aacc216fb49cbb7a$export$a37a56137abc1357 = {
    kernelName: (0, $9BGT9.ResizeBilinear),
    backendName: 'webgl',
    kernelFunc: $aacc216fb49cbb7a$export$1f1cbc7da93d06a0
};

});
parcelRegister("j5K6W", function(module, exports) {

$parcel$export(module.exports, "ResizeBilinearProgram", function () { return $de62409f689cb39e$export$52b2ccd78b972549; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $de62409f689cb39e$export$52b2ccd78b972549 {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `(vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC` + ` - vec2(0.5)`;
        else sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec2 sourceFloorRC = ivec2(max(sourceFracIndexRC, vec2(0.0)));
        ivec2 sourceCeilRC = ivec2(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);
        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);
        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);
        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);

        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);

        float top = topLeft + (topRight - topLeft) * fracRC.y;
        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;
        float newValue = top + (bottom - top) * fracRC.x;

        setOutput(newValue);
      }
    `;
    }
}

});

parcelRegister("kaBwU", function(module, exports) {

$parcel$export(module.exports, "ResizeBilinearPackedProgram", function () { return $eaf1da7065bf60dc$export$b334a0f2524628a; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $eaf1da7065bf60dc$export$b334a0f2524628a {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `(vec3(yRC) + vec3(0.5)) * ` + `effectiveInputOverOutputRatioRC - vec3(0.5)`;
        else sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the four integer indices.
        ivec3 sourceFloorRC = ivec3(max(sourceFracIndexRC, vec3(0.0)));
        ivec3 sourceCeilRC = ivec3(
          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        // In parallel, construct four corners for all four components in
        // packed 2x2 cell.
        vec4 topLeft = vec4(
          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 bottomLeft = vec4(
          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);

        vec4 topRight = vec4(
          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec4 bottomRight = vec4(
          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),
          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);

        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);

        vec4 top = mix(topLeft, topRight, fracRC.yyzz);
        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);
        vec4 newValue = mix(top, bottom, fracRC.x);

        setOutput(newValue);
      }
    `;
    }
}

});


parcelRegister("5Fdoe", function(module, exports) {

$parcel$export(module.exports, "resizeBilinearGradConfig", function () { return $0110702da17ea68e$export$51f84ca614e84763; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $2sW7u = parcelRequire("2sW7u");
function $0110702da17ea68e$export$8899506794ec394(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const program = new (0, $2sW7u.ResizeBilinearBackpropProgram)(dy.shape, images.shape, alignCorners);
    return backend.runWebGLProgram(program, [
        dy
    ], dy.dtype);
}
const $0110702da17ea68e$export$51f84ca614e84763 = {
    kernelName: (0, $9BGT9.ResizeBilinearGrad),
    backendName: 'webgl',
    kernelFunc: $0110702da17ea68e$export$8899506794ec394
};

});
parcelRegister("2sW7u", function(module, exports) {

$parcel$export(module.exports, "ResizeBilinearBackpropProgram", function () { return $1cbb47a8d1340ed2$export$dd552814323a3592; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $1cbb47a8d1340ed2$export$dd552814323a3592 {
    constructor(dyShape, inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        const [, xHeight, xWidth] = inputShape;
        const [, yHeight, yWidth] = dyShape;
        // In the backwards pass, we want to find the pixels that were generated for
        // each pixel in the input image the forward pass and add the corresponding
        // coefficient from dy to the gradient (with some interpolation).
        const effectiveXSize = [
            alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
            alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
        ];
        const effectiveYSize = [
            alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
            alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
        ];
        const heightScale = effectiveXSize[0] / effectiveYSize[0];
        const widthScale = effectiveXSize[1] / effectiveYSize[1];
        const invHeightScale = 1 / heightScale;
        const invWidthScale = 1 / widthScale;
        // This defines the size of the window of values around a particular
        // index in dy that we want to search for contributions to dx.
        const winHeight = Math.ceil(invHeightScale) * 2 + 2;
        const winWidth = Math.ceil(invWidthScale) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(startRLerp - float(winHeight / 2));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(startCLerp - float(winWidth / 2));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float dxR = float(dyR) * heightScale;
            int topDxRIndex = int(floor(dxR));
            int bottomDxRIndex = int(min(ceil(dxR), ${xHeight - 1}.0));
            float dxRLerp = dxR - float(topDxRIndex);
            float inverseDxRLerp = 1.0 - dxRLerp;

            float dxC = float(dyC) * widthScale;
            int leftDxCIndex = int(floor(dxC));
            int rightDxCIndex = int(min(ceil(dxC), ${xWidth - 1}.0));
            float dxCLerp = dxC - float(leftDxCIndex);
            float inverseDxCLerp = 1.0 - dxCLerp;

            if (r == topDxRIndex && c == leftDxCIndex) {
              // topLeft
              accumulator +=
                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;
            }

            if (r == topDxRIndex && c == rightDxCIndex) {
              // topRight
              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;
            }

            if (r == bottomDxRIndex && c == leftDxCIndex) {
              // bottomLeft
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;
            }

            if (r == bottomDxRIndex && c == rightDxCIndex) {
              // bottomRight
              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}

});


parcelRegister("8GNOd", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborConfig", function () { return $6538e1f94e137f20$export$2b6a92caba113b89; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $8ifQW = parcelRequire("8ifQW");

var $bTuor = parcelRequire("bTuor");
function $6538e1f94e137f20$export$74a902ae74ac2560(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images } = inputs;
    const { alignCorners: alignCorners, halfPixelCenters: halfPixelCenters, size: size } = attrs;
    const [newHeight, newWidth] = size;
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_IMAGE_OPERATIONS') ? new (0, $bTuor.ResizeNearestNeighborPackedProgram)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters) : new (0, $8ifQW.ResizeNearestNeighborProgram)(images.shape, newHeight, newWidth, alignCorners, halfPixelCenters);
    return backend.runWebGLProgram(program, [
        images
    ], images.dtype);
}
const $6538e1f94e137f20$export$2b6a92caba113b89 = {
    kernelName: (0, $9BGT9.ResizeNearestNeighbor),
    backendName: 'webgl',
    kernelFunc: $6538e1f94e137f20$export$74a902ae74ac2560
};

});
parcelRegister("8ifQW", function(module, exports) {

$parcel$export(module.exports, "ResizeNearestNeighborProgram", function () { return $609c4d3f3c78721a$export$2218952be90fb74a; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $609c4d3f3c78721a$export$2218952be90fb74a {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        // When align corners is false, we rounds the value with floor.
        const roundBase = alignCorners ? '0.5' : '0.0';
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `max((vec2(yRC) + vec2(0.5)) * effectiveInputOverOutputRatioRC` + `, vec2(0.0))`;
        else sourceFracIndexRC = `vec2(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec2 effectiveInputOverOutputRatioRC = vec2(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec2 inputShapeRC = vec2(${oldHeight}.0, ${oldWidth}.0);

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        ivec2 yRC = coords.yz;

        // Fractional source index.
        vec2 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec2 sourceNearestRC = ivec2(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));
        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);

        setOutput(newValue);
      }
    `;
    }
}

});

parcelRegister("bTuor", function(module, exports) {

$parcel$export(module.exports, "ResizeNearestNeighborPackedProgram", function () { return $8a8c6836775c1c31$export$a616f6d9a33abf84; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $8a8c6836775c1c31$export$a616f6d9a33abf84 {
    constructor(inputShape, newHeight, newWidth, alignCorners, halfPixelCenters){
        this.variableNames = [
            'A'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = [];
        const [batch, oldHeight, oldWidth, depth] = inputShape;
        this.outputShape = [
            batch,
            newHeight,
            newWidth,
            depth
        ];
        const effectiveInSize = [
            alignCorners && newHeight > 1 ? oldHeight - 1 : oldHeight,
            alignCorners && newWidth > 1 ? oldWidth - 1 : oldWidth
        ];
        const effectiveOutSize = [
            alignCorners && newHeight > 1 ? newHeight - 1 : newHeight,
            alignCorners && newWidth > 1 ? newWidth - 1 : newWidth
        ];
        // When align corners is false, we rounds the value with floor.
        const roundBase = alignCorners ? '0.5' : '0.0';
        let sourceFracIndexRC;
        if (halfPixelCenters) sourceFracIndexRC = `max((vec3(yRC) + vec3(0.5)) * ` + `effectiveInputOverOutputRatioRC, vec3(0.0))`;
        else sourceFracIndexRC = `vec3(yRC) * effectiveInputOverOutputRatioRC`;
        this.userCode = `
      const vec3 effectiveInputOverOutputRatioRC = vec3(
          ${effectiveInSize[0] / effectiveOutSize[0]},
          ${effectiveInSize[1] / effectiveOutSize[1]},
          ${effectiveInSize[1] / effectiveOutSize[1]});
      const vec3 inputShapeRC = vec3(${oldHeight}.0, ${oldWidth}.0,
                                     ${oldWidth}.0);

      float getAValue(int b, int r, int c, int d) {
        return getChannel(getA(b, r, c, d), vec2(c, d));
      }

      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        // Calculate values for next column in yRC.z.
        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);

        // Fractional source index.
        vec3 sourceFracIndexRC = ${sourceFracIndexRC};

        // Compute the coordinators of nearest neighbor point.
        ivec3 sourceNearestRC = ivec3(
          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${roundBase})));

        // Should we calculate next column and row elements in 2x2 packed cell.
        bool hasNextCol = d < ${depth - 1};
        bool hasNextRow = coords.z < ${newWidth - 1};

        vec4 newValue = vec4(
          getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d),
          hasNextCol ? getAValue(b, sourceNearestRC.x, sourceNearestRC.y, d + 1)
                     : 0.0,
          hasNextRow ? getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d)
                     : 0.0,
          (hasNextRow && hasNextCol) ?
            getAValue(b, sourceNearestRC.x, sourceNearestRC.z, d + 1) : 0.0);

        setOutput(newValue);
      }
    `;
    }
}

});


parcelRegister("k7AO2", function(module, exports) {

$parcel$export(module.exports, "resizeNearestNeighborGradConfig", function () { return $ea61030902c79565$export$2b08d810b5090fe1; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $8WsDc = parcelRequire("8WsDc");
function $ea61030902c79565$export$2b75795f158f1b18(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { images: images, dy: dy } = inputs;
    const { alignCorners: alignCorners } = attrs;
    const program = new (0, $8WsDc.ResizeNearestNeigborBackpropProgram)(dy.shape, images.shape, alignCorners);
    return backend.runWebGLProgram(program, [
        dy
    ], dy.dtype);
}
const $ea61030902c79565$export$2b08d810b5090fe1 = {
    kernelName: (0, $9BGT9.ResizeNearestNeighborGrad),
    backendName: 'webgl',
    kernelFunc: $ea61030902c79565$export$2b75795f158f1b18
};

});
parcelRegister("8WsDc", function(module, exports) {

$parcel$export(module.exports, "ResizeNearestNeigborBackpropProgram", function () { return $6829f318949248ae$export$b6671a84abe827c4; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $6829f318949248ae$export$b6671a84abe827c4 {
    constructor(dyShape, inputShape, alignCorners){
        this.variableNames = [
            'dy'
        ];
        this.outputShape = [];
        this.outputShape = inputShape;
        const [, xHeight, xWidth] = inputShape;
        const [, yHeight, yWidth] = dyShape;
        // In the backwards pass, we want to find the pixels that were generated for
        // each pixel in the input image the forward pass and add the corresponding
        // coefficient from dy to the gradient (with some interpolation).
        const effectiveXSize = [
            alignCorners && yHeight > 1 ? xHeight - 1 : xHeight,
            alignCorners && yWidth > 1 ? xWidth - 1 : xWidth
        ];
        const effectiveYSize = [
            alignCorners && yHeight > 1 ? yHeight - 1 : yHeight,
            alignCorners && yWidth > 1 ? yWidth - 1 : yWidth
        ];
        const heightScale = effectiveXSize[0] / effectiveYSize[0];
        const widthScale = effectiveXSize[1] / effectiveYSize[1];
        const invHeightScale = 1 / heightScale;
        const invWidthScale = 1 / widthScale;
        // This defines the size of the window of values around a particular
        // index in dy that we want to search for contributions to dx.
        const winHeight = Math.ceil(invHeightScale) * 2 + 2;
        const winWidth = Math.ceil(invWidthScale) * 2 + 2;
        this.userCode = `
      void main() {
        ivec4 coords = getOutputCoords();
        int b = coords[0];
        int d = coords[3];
        int r = coords[1];
        int c = coords[2];

        float accumulator = 0.0;

        const float heightScale = float(${heightScale});
        const float widthScale = float(${widthScale});

        const float invHeightScale = float(${invHeightScale});
        const float invWidthScale = float(${invWidthScale});

        const int winHeight = int(${winHeight});
        const int winWidth = int(${winWidth});

        // Compute bounds for where in dy we will look
        float startRLerp = floor(float(r) * invHeightScale);
        int startDyR = int(floor(startRLerp - float(winHeight / 2)));

        float startCLerp = floor(float(c) * invWidthScale);
        int startDyC = int(floor(startCLerp - float(winWidth / 2)));

        // Loop over dy
        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {
          int dyR = dyROffset + startDyR;

          // Guard against the window exceeding the bounds of dy
          if (dyR < 0 || dyR >= ${yHeight}) {
            continue;
          }

          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {
            int dyC = dyCOffset + startDyC;

            // Guard against the window exceeding the bounds of dy
            if (dyC < 0 || dyC >= ${yWidth}) {
              continue;
            }

            float sourceFracRow =
              float(${effectiveXSize[0]}) *
                (float(dyR) / float(${effectiveYSize[0]}));

            float sourceFracCol =
                float(${effectiveXSize[1]}) *
                  (float(dyC) / float(${effectiveYSize[1]}));

            int sourceNearestRow = int(min(
                float(int(${xHeight}) - 1),
                ${alignCorners} ? float(round(sourceFracRow)) :
                                  float(floor(sourceFracRow))));

            int sourceNearestCol = int(min(
                float(int(${xWidth}) - 1),
                ${alignCorners} ? float(round(sourceFracCol)) :
                                  float(floor(sourceFracCol))));

            if (r == sourceNearestRow && c == sourceNearestCol) {
              accumulator += getDy(b, dyR, dyC, d);
            }
          }
        }
        // End loop over dy

        setOutput(accumulator);
      }
    `;
    }
}

});


parcelRegister("kN1ZG", function(module, exports) {

$parcel$export(module.exports, "reverseConfig", function () { return $f229ee3550331d9d$export$cab6a4e8d2ed8e8d; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $fOew3 = parcelRequire("fOew3");

var $6SsVM = parcelRequire("6SsVM");

var $lVOy4 = parcelRequire("lVOy4");
function $f229ee3550331d9d$export$66c1ae025e96b4bc(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { dims: dims } = attrs;
    const xRank = x.shape.length;
    const $dims = (0, $lBDHD).parseAxisParam(dims, x.shape);
    if (xRank === 0) return (0, $lVOy4.identity)({
        inputs: {
            x: x
        },
        backend: backend
    });
    const program = (0, $tdutJ.env)().getBool('WEBGL_PACK_ARRAY_OPERATIONS') ? new (0, $6SsVM.ReversePackedProgram)(x.shape, $dims) : new (0, $fOew3.ReverseProgram)(x.shape, $dims);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $f229ee3550331d9d$export$cab6a4e8d2ed8e8d = {
    kernelName: (0, $9BGT9.Reverse),
    backendName: 'webgl',
    kernelFunc: $f229ee3550331d9d$export$66c1ae025e96b4bc
};

});
parcelRegister("fOew3", function(module, exports) {

$parcel$export(module.exports, "ReverseProgram", function () { return $b826c91ffe314d7d$export$abc2effa29e77e92; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $b826c91ffe314d7d$export$abc2effa29e77e92 {
    constructor(xShape, axis){
        this.variableNames = [
            'x'
        ];
        const rank = xShape.length;
        if (rank > 4) throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
        this.outputShape = xShape;
        if (rank === 1) {
            this.userCode = `
        void main() {
          int coord = getOutputCoords();
          setOutput(getX(${xShape[0]} - coord - 1));
        }
      `;
            return;
        }
        const getInCoord = (i)=>{
            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) return `${xShape[i]} - coords[${i}] - 1`;
            return `coords[${i}]`;
        };
        const inCoords = xShape.map((_, i)=>getInCoord(i)).join(',');
        const type = (0, $1eI1C.getCoordsDataType)(rank);
        this.userCode = `
      void main() {
        ${type} coords = getOutputCoords();
        setOutput(getX(${inCoords}));
      }
    `;
    }
}

});

parcelRegister("6SsVM", function(module, exports) {

$parcel$export(module.exports, "ReversePackedProgram", function () { return $501e3a54567af04a$export$e427e51a4a356956; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $coLQR = parcelRequire("coLQR");

var $1eI1C = parcelRequire("1eI1C");
class $501e3a54567af04a$export$e427e51a4a356956 {
    constructor(xShape, axis){
        this.variableNames = [
            'x'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        const rank = xShape.length;
        if (rank > 4) throw new Error(`WebGL backend: Reverse of rank-${rank} tensor is not yet supported`);
        this.outputShape = xShape;
        const channels = (0, $coLQR.getChannels)('rc', rank);
        const nextColumn = `${channels[rank - 1]} + 1 < ${this.outputShape[rank - 1]}`;
        const nextRow = `${channels[rank - 2]} + 1 < ${this.outputShape[rank - 2]}`;
        const type = (0, $1eI1C.getCoordsDataType)(rank);
        if (rank === 1) this.userCode = `
        void main(){
          int rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = getChannel(getX(${xShape[0]} - rc - 1),
            ${xShape[0]} - rc - 1);
          if(${nextColumn}){
              result.g = getChannel(getX(${xShape[0]} - (rc  + 1) - 1),
                ${xShape[0]} - (rc  + 1) - 1);
          }
          setOutput(result);
        }
      `;
        else this.userCode = `
        void main() {
          ${type} rc = getOutputCoords();
          vec4 result = vec4(0.);
          result.r = ${getR(channels.slice())};
          if(${nextColumn}){
            result.g = ${getG(channels.slice())};
          }
          if(${nextRow}) {
            result.b = ${getB(channels.slice())};
            if(${nextColumn}) {
              result.a = ${getA(channels.slice())};
            }
          }
          setOutput(result);
        }
    `;
        function getR(channels) {
            return getChannel(channels);
        }
        function getG(channels) {
            channels[rank - 1] = '(' + channels[rank - 1] + ` + 1)`;
            return getChannel(channels);
        }
        function getB(channels) {
            channels[rank - 2] = '(' + channels[rank - 2] + ` + 1)`;
            return getChannel(channels);
        }
        function getA(channels) {
            channels[rank - 1] = '(' + channels[rank - 1] + ` + 1)`;
            channels[rank - 2] = '(' + channels[rank - 2] + ` + 1)`;
            return getChannel(channels);
        }
        function getChannel(channels) {
            const inCoordsArray = xShape.map((_, i)=>getInCoord(i, channels));
            const inCoords = inCoordsArray.join(',');
            const innerDims = inCoordsArray.slice(-2).join(',');
            return `getChannel(getX(${inCoords}), vec2(${innerDims}))`;
        }
        function getInCoord(i, channels1) {
            if (axis.indexOf(i) !== -1 && xShape[i] !== 1) return `${xShape[i]} - ${channels1[i]} - 1`;
            else return `${channels1[i]}`;
        }
    }
}

});


parcelRegister("8rHVs", function(module, exports) {

$parcel$export(module.exports, "rotateWithOffsetConfig", function () { return $6262eb159d7d53b9$export$44ba8c83417ab668; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $9LHKR = parcelRequire("9LHKR");
const $6262eb159d7d53b9$export$44ba8c83417ab668 = {
    kernelName: (0, $9BGT9.RotateWithOffset),
    backendName: 'webgl',
    kernelFunc: ({ inputs: inputs, attrs: attrs, backend: backend })=>{
        const { image: image } = inputs;
        const { radians: radians, fillValue: fillValue, center: center } = attrs;
        const webglBackend = backend;
        const program = new (0, $9LHKR.RotateProgram)(image.shape, fillValue);
        const [centerX, centerY] = (0, $dEVRx).getImageCenter(center, image.shape[1], image.shape[2]);
        const customValues = [
            [
                centerX,
                centerY,
                Math.sin(radians),
                Math.cos(radians)
            ]
        ];
        const output = webglBackend.runWebGLProgram(program, [
            image
        ], image.dtype, customValues);
        return output;
    }
};

});
parcelRegister("9LHKR", function(module, exports) {

$parcel$export(module.exports, "RotateProgram", function () { return $71ca71a4531cfa0f$export$a37df1d4e69844e7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $71ca71a4531cfa0f$export$a37df1d4e69844e7 {
    constructor(imageShape, fillValue){
        this.variableNames = [
            'Image'
        ];
        this.outputShape = [];
        this.customUniforms = [
            {
                name: 'params',
                type: 'vec4'
            }
        ];
        const imageHeight = imageShape[1];
        const imageWidth = imageShape[2];
        this.outputShape = imageShape;
        let fillSnippet = '';
        if (typeof fillValue === 'number') fillSnippet = `float outputValue = ${fillValue.toFixed(2)};`;
        else fillSnippet = `
        vec3 fill = vec3(${fillValue.join(',')});
        float outputValue = fill[coords[3]];`;
        this.userCode = `
        void main() {
          ivec4 coords = getOutputCoords();
          int x = coords[2];
          int y = coords[1];
          float coordXFloat = (float(x) - params[0]) * params[3] -
            (float(y) - params[1]) * params[2];
          float coordYFloat = (float(x) - params[0]) * params[2] +
            (float(y) - params[1]) * params[3];
          int coordX = int(round(coordXFloat + params[0]));
          int coordY = int(round(coordYFloat + params[1]));
          ${fillSnippet}
          if(coordX >= 0 && coordX < ${imageWidth} && coordY >= 0 && coordY < ${imageHeight}) {
            outputValue = getImage(coords[0], coordY, coordX, coords[3]);
          }
          setOutput(outputValue);
        }
    `;
    }
}

});


parcelRegister("1nhJg", function(module, exports) {

$parcel$export(module.exports, "roundConfig", function () { return $1005b10c0acd83a5$export$6c09e3291f636503; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $1005b10c0acd83a5$var$ROUND = `
  // OpenGL ES does not support round function.
  // The algorithm is based on banker's rounding.
  float base = floor(x);
  if ((x - base) < 0.5) {
    return floor(x);
  } else if ((x - base) > 0.5) {
    return ceil(x);
  } else {
    if (mod(base, 2.0) == 0.0) {
      return base;
    } else {
      return base + 1.0;
    }
  }
`;
const $1005b10c0acd83a5$export$2077e0241d6afd3c = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $1005b10c0acd83a5$var$ROUND
});
const $1005b10c0acd83a5$export$6c09e3291f636503 = {
    kernelName: (0, $9BGT9.Round),
    backendName: 'webgl',
    kernelFunc: $1005b10c0acd83a5$export$2077e0241d6afd3c
};

});

parcelRegister("hEBYh", function(module, exports) {

$parcel$export(module.exports, "rsqrtConfig", function () { return $cda3a061af914214$export$941104b789956ef6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $cda3a061af914214$var$RSQRT = `return inversesqrt(x);`;
const $cda3a061af914214$export$1cc01d192953037e = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $cda3a061af914214$var$RSQRT,
    cpuKernelImpl: (0, $glyiU.rsqrtImplCPU)
});
const $cda3a061af914214$export$941104b789956ef6 = {
    kernelName: (0, $9BGT9.Rsqrt),
    backendName: 'webgl',
    kernelFunc: $cda3a061af914214$export$1cc01d192953037e
};

});

parcelRegister("88U0s", function(module, exports) {

$parcel$export(module.exports, "scatterNdConfig", function () { return $5eda83ccb51e0b10$export$573371744f044f5; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");

var $9wxvs = parcelRequire("9wxvs");

var $880JO = parcelRequire("880JO");

var $aNJFF = parcelRequire("aNJFF");
function $5eda83ccb51e0b10$export$b6f42038a536d877(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { indices: indices, updates: updates } = inputs;
    const { shape: shape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $dEVRx).calculateShapes(updates, indices, shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(shape, indices.dtype);
    const flattenIndices = (0, $aNJFF.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $aNJFF.reshape)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const defaultValue = backend.makeTensorInfo([], 'float32', new Float32Array([
        0
    ])); // scalar(0)
    let program;
    if ((0, $tdutJ.env)().getBool('WEBGL_PACK')) program = new (0, $880JO.ScatterPackedProgram)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape);
    else program = new (0, $9wxvs.ScatterProgram)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices,
        defaultValue
    ], flattenX.dtype);
    const reshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: shape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(res);
    backend.disposeIntermediateTensorInfo(defaultValue);
    return reshaped;
}
const $5eda83ccb51e0b10$export$573371744f044f5 = {
    kernelName: (0, $9BGT9.ScatterNd),
    backendName: 'webgl',
    kernelFunc: $5eda83ccb51e0b10$export$b6f42038a536d877
};

});
parcelRegister("9wxvs", function(module, exports) {

$parcel$export(module.exports, "ScatterProgram", function () { return $6ef117e0e8b351d3$export$8d0317f5c5cbc1ac; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $6ef117e0e8b351d3$export$8d0317f5c5cbc1ac {
    constructor(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex = true, defaultIsTensor = false){
        this.variableNames = [
            'updates',
            'indices',
            'defaultValue'
        ];
        this.outputShape = shape;
        const stridesType = (0, $1eI1C.getCoordsDataType)(strides.length);
        const dtype = (0, $1eI1C.getCoordsDataType)(shape.length);
        let indicesString = '';
        if (indicesRank === 1) indicesString = 'i';
        else if (indicesRank === 2) indicesString = 'i, j';
        const indicesSnippet = `getIndices(${indicesString})`;
        let updatesString = '';
        if (updatesRank === 1) updatesString = 'i';
        else if (updatesRank === 2) updatesString = 'i, coords[1]';
        const updatesSnippet = `getUpdates(${updatesString})`;
        let defaultValuesString = '';
        if (defaultIsTensor) defaultValuesString = 'coords[0], coords[1]';
        const defaultValueSnippet = `getDefaultValue(${defaultValuesString})`;
        const strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
        this.userCode = `
        ${stridesType} strides = ${stridesType}(${strides});

        void main() {
          ${dtype} coords = getOutputCoords();
          float sum = 0.0;
          bool found = false;
          for (int i = 0; i < ${updateSize}; i++) {
            int flattenedIndex = 0;
            for (int j = 0; j < ${sliceDim}; j++) {
              int index = round(${indicesSnippet});
              flattenedIndex += index * ${strideString};
            }
            if (flattenedIndex == coords[0]) {
              sum += ${updatesSnippet};
              found = true;
            }
          }
          setOutput(mix(${defaultValueSnippet}, sum, float(found)));
        }
      `;
    }
}

});

parcelRegister("880JO", function(module, exports) {

$parcel$export(module.exports, "ScatterPackedProgram", function () { return $5eafa4a144ac3998$export$6e81fd9352ed9fbb; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $5eafa4a144ac3998$export$6e81fd9352ed9fbb {
    constructor(updateSize, sliceDim, indicesRank, updatesRank, strides, shape, summingDupeIndex = true, defaultIsTensor = false){
        this.variableNames = [
            'updates',
            'indices',
            'defaultValue'
        ];
        this.packedInputs = true;
        this.packedOutput = true;
        this.outputShape = shape;
        const stridesType = (0, $1eI1C.getCoordsDataType)(strides.length);
        const dtype = (0, $1eI1C.getCoordsDataType)(shape.length);
        let indicesString = '';
        if (indicesRank === 1) indicesString = 'i';
        else if (indicesRank === 2) indicesString = 'i, j';
        const indicesSnippet = `getIndices(${indicesString})`;
        let updatesString = '';
        if (updatesRank === 1) updatesString = 'i';
        else if (updatesRank === 2) updatesString = 'i, coords[1]';
        const updatesSnippet = `getUpdates(${updatesString})`;
        let defaultValuesString = '';
        if (defaultIsTensor) defaultValuesString = 'coords[0], coords[1]';
        const defaultValueSnippet = `getDefaultValue(${defaultValuesString})`;
        const strideString = sliceDim > 1 ? 'strides[j]' : 'strides';
        const strideString2 = sliceDim > 1 ? 'strides[j + 1]' : 'strides';
        this.userCode = `
        ${stridesType} strides = ${stridesType}(${strides});

        void main() {
          ${dtype} coords = getOutputCoords();
          vec4 sum = vec4(0.);
          vec4 found = vec4(0.);
          for (int i = 0; i < ${updateSize}; i+=2) {
            ivec2 flattenedIndex = ivec2(0);
            for (int j = 0; j < ${sliceDim}; j+=2) {
              ivec4 index = round(${indicesSnippet});
              flattenedIndex += index.xz * ${strideString};
              if (j + 1 < ${sliceDim}) {
                flattenedIndex += index.yw * ${strideString2};
              }
            }
            if (flattenedIndex[0] == coords[0] || flattenedIndex[1] == coords[0] ||
                flattenedIndex[0] == coords[0] + 1 || flattenedIndex[1] == coords[0] + 1) {
              vec4 updVals = ${updatesSnippet};
              if (flattenedIndex[0] == coords[0]) {
                sum.xy += updVals.xy;
                found.xy = vec2(1.);
              } else if (flattenedIndex[0] == coords[0] + 1) {
                sum.zw += updVals.xy;
                found.zw = vec2(1.);
              }
              if (flattenedIndex[1] == coords[0]) {
                sum.xy += updVals.zw;
                found.xy = vec2(1.);
              } else if (flattenedIndex[1] == coords[0] + 1) {
                sum.zw += updVals.zw;
                found.zw = vec2(1.);
              }
            }
          }
          setOutput(mix(${defaultValueSnippet}, sum, found));
        }
      `;
    }
}

});


parcelRegister("1wxSb", function(module, exports) {

$parcel$export(module.exports, "searchSortedConfig", function () { return $11c30e0da86aae7d$export$4b437b1a1aa6472f; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $kZobx = parcelRequire("kZobx");
function $11c30e0da86aae7d$export$56fad8d65b0adbdd(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sortedSequence: sortedSequence, values: values } = inputs;
    const { side: side } = attrs;
    const program = new (0, $kZobx.SearchSortedProgram)(sortedSequence.shape[0], sortedSequence.shape[1], values.shape[1], side);
    const customValues = [
        [
            sortedSequence.shape[1]
        ]
    ];
    return backend.runWebGLProgram(program, [
        sortedSequence,
        values
    ], 'int32', customValues);
}
const $11c30e0da86aae7d$export$4b437b1a1aa6472f = {
    kernelName: (0, $9BGT9.SearchSorted),
    backendName: 'webgl',
    kernelFunc: $11c30e0da86aae7d$export$56fad8d65b0adbdd
};

});
parcelRegister("kZobx", function(module, exports) {

$parcel$export(module.exports, "SearchSortedProgram", function () { return $f47c43d4536c103a$export$2511b5550383de5c; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
class $f47c43d4536c103a$export$2511b5550383de5c {
    constructor(batchSize, numInputs, numValues, side){
        this.variableNames = [
            'sortedSequence',
            'values'
        ];
        this.customUniforms = [
            {
                name: 'numInputs',
                type: 'int'
            }
        ];
        this.outputShape = [
            batchSize,
            numValues
        ];
        const webGL2LoopHead = 'while (left < right) {';
        // WebGL1 doesn't accept non constant loop conditions, so upper bound loop
        // iterations.
        const webGL1LoopHead = `for (int i = 0; i < ${Math.ceil(Math.log2(numInputs + 1))}; ++i) { if (left >= right) break;`;
        const loopHead = (0, $tdutJ.env)().getNumber('WEBGL_VERSION') === 2 ? webGL2LoopHead : webGL1LoopHead;
        // left corresponds to lower bound and right to upper bound.
        const boundComparator = side === 'left' ? '<' : '<=';
        this.userCode = `
       int findBound(int batch, float value) {
         int left = 0;
         int right = numInputs;
         int mid;
         ${loopHead}
           mid = (left + right) / 2;
           if (getSortedSequence(batch, mid) ${boundComparator} value) {
             left = mid + 1;
           } else {
             right = mid;
           }
         }
         return right;
       }

       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int valueIndex = coords[1];

         float value = getValues(batch, valueIndex);

         setOutput(float(findBound(batch, value)));
       }
     `;
    }
}

});


parcelRegister("fj3BY", function(module, exports) {

$parcel$export(module.exports, "selectConfig", function () { return $b24b6e81a3e9dd8e$export$7ff911e710ee72fc; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");
var $kKv2E = parcelRequire("kKv2E");

var $cJxFr = parcelRequire("cJxFr");
function $b24b6e81a3e9dd8e$export$2e6c959c16ff56b8(args) {
    const { inputs: inputs, backend: backend } = args;
    const { condition: condition, t: t, e: e } = inputs;
    const program = new (0, $cJxFr.SelectProgram)(condition.shape.length, t.shape, t.shape.length);
    return backend.runWebGLProgram(program, [
        condition,
        t,
        e
    ], (0, $kKv2E.upcastType)(t.dtype, e.dtype));
}
const $b24b6e81a3e9dd8e$export$7ff911e710ee72fc = {
    kernelName: (0, $9BGT9.Select),
    backendName: 'webgl',
    kernelFunc: $b24b6e81a3e9dd8e$export$2e6c959c16ff56b8
};

});
parcelRegister("cJxFr", function(module, exports) {

$parcel$export(module.exports, "SelectProgram", function () { return $9453cda5fcc03834$export$845ed2d1f74ef297; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $9453cda5fcc03834$export$845ed2d1f74ef297 {
    constructor(cRank, shape, rank){
        this.variableNames = [
            'c',
            'a',
            'b'
        ];
        this.outputShape = shape;
        let cCoords;
        let abCoords;
        if (rank > 4) throw Error(`Where for rank ${rank} is not yet supported`);
        if (rank === 1) {
            abCoords = `resRC`;
            cCoords = `resRC`;
        } else {
            const currentCoords = [
                'resRC.x',
                'resRC.y',
                'resRC.z',
                'resRC.w'
            ];
            const cCoordVars = [];
            const abCoordVars = [];
            for(let i = 0; i < shape.length; i++){
                abCoordVars.push(`${currentCoords[i]}`);
                if (i < cRank) cCoordVars.push(`${currentCoords[i]}`);
            }
            cCoords = cCoordVars.join();
            abCoords = abCoordVars.join();
        }
        const dtype = (0, $1eI1C.getCoordsDataType)(rank);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        float cVal = getC(${cCoords});
        if (cVal >= 1.0) {
          setOutput(getA(${abCoords}));
        } else {
          setOutput(getB(${abCoords}));
        }
      }
    `;
    }
}

});


parcelRegister("uWPTD", function(module, exports) {

$parcel$export(module.exports, "seluConfig", function () { return $05d071116c76d212$export$8afc8558705c1a39; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $05d071116c76d212$var$SELU = `
  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.
  // see: https://arxiv.org/abs/1706.02515
  float scaleAlpha = ${(0, $dEVRx).SELU_SCALEALPHA};
  float scale = ${(0, $dEVRx).SELU_SCALE};
  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);
`;
const $05d071116c76d212$export$a5f8240d9e99b438 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $05d071116c76d212$var$SELU
});
const $05d071116c76d212$export$8afc8558705c1a39 = {
    kernelName: (0, $9BGT9.Selu),
    backendName: 'webgl',
    kernelFunc: $05d071116c76d212$export$a5f8240d9e99b438
};

});

parcelRegister("eLOoU", function(module, exports) {

$parcel$export(module.exports, "sigmoidConfig", function () { return $ac0c8d05cf0bdbff$export$195d1cf7c59f3ef; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $ac0c8d05cf0bdbff$var$SIGMOID = (0, $k2x5z.CHECK_NAN_SNIPPET_UNARY) + `
  return 1.0 / (1.0 + exp(-1.0 * x));
`;
const $ac0c8d05cf0bdbff$var$SIGMOID_PACKED = `
  vec4 result = 1.0 / (1.0 + exp(-1.0 * x));
  bvec4 isNaN = isnan(x);

  result.r = isNaN.r ? x.r : result.r;
  result.g = isNaN.g ? x.g : result.g;
  result.b = isNaN.b ? x.b : result.b;
  result.a = isNaN.a ? x.a : result.a;

  return result;
`;
const $ac0c8d05cf0bdbff$export$3b295495ca3cad7c = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $ac0c8d05cf0bdbff$var$SIGMOID,
    packedOpSnippet: $ac0c8d05cf0bdbff$var$SIGMOID_PACKED,
    cpuKernelImpl: (0, $glyiU.sigmoidImplCPU)
});
const $ac0c8d05cf0bdbff$export$195d1cf7c59f3ef = {
    kernelName: (0, $9BGT9.Sigmoid),
    backendName: 'webgl',
    kernelFunc: $ac0c8d05cf0bdbff$export$3b295495ca3cad7c
};

});

parcelRegister("j3rx2", function(module, exports) {

$parcel$export(module.exports, "signConfig", function () { return $ddf3a75e5b43951d$export$9c0fb3eb2124ceb7; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
// Sign does not propagate NANs.
const $ddf3a75e5b43951d$var$SIGN = `
  if (isnan(x)) { return 0.0; }
  return sign(x);
`;
const $ddf3a75e5b43951d$export$c5552dfdbc7cec71 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $ddf3a75e5b43951d$var$SIGN
});
const $ddf3a75e5b43951d$export$9c0fb3eb2124ceb7 = {
    kernelName: (0, $9BGT9.Sign),
    backendName: 'webgl',
    kernelFunc: $ddf3a75e5b43951d$export$c5552dfdbc7cec71
};

});

parcelRegister("bG342", function(module, exports) {

$parcel$export(module.exports, "sinConfig", function () { return $8805fe6bb04574ed$export$d993ec4e5c253b66; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $12pF4 = parcelRequire("12pF4");

var $k2x5z = parcelRequire("k2x5z");
const $8805fe6bb04574ed$var$SIN = (0, $k2x5z.CHECK_NAN_SNIPPET_UNARY) + `
  return sin(x);
`;
const $8805fe6bb04574ed$var$SIN_PACKED = `
  vec4 result = sin(x);
  bvec4 isNaN = isnan(x);
  ${(0, $12pF4.CHECK_NAN_SNIPPET_PACKED)}
  return result;
`;
const $8805fe6bb04574ed$export$5de3937cb4b592ed = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $8805fe6bb04574ed$var$SIN,
    packedOpSnippet: $8805fe6bb04574ed$var$SIN_PACKED
});
const $8805fe6bb04574ed$export$d993ec4e5c253b66 = {
    kernelName: (0, $9BGT9.Sin),
    backendName: 'webgl',
    kernelFunc: $8805fe6bb04574ed$export$5de3937cb4b592ed
};

});

parcelRegister("jSYPl", function(module, exports) {

$parcel$export(module.exports, "sinhConfig", function () { return $e7a23e75ebd50d7c$export$b92766b47f18ac85; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $e7a23e75ebd50d7c$var$SINH = `
  float e2x = exp(x);
  return (e2x - 1.0 / e2x) / 2.0;
`;
const $e7a23e75ebd50d7c$export$545004b505d7c555 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $e7a23e75ebd50d7c$var$SINH
});
const $e7a23e75ebd50d7c$export$b92766b47f18ac85 = {
    kernelName: (0, $9BGT9.Sinh),
    backendName: 'webgl',
    kernelFunc: $e7a23e75ebd50d7c$export$545004b505d7c555
};

});

parcelRegister("1cVP6", function(module, exports) {

$parcel$export(module.exports, "softplusConfig", function () { return $0e13c3f03ba95eff$export$d9bcfe553d12d9e3; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $0e13c3f03ba95eff$var$SOFTPLUS = `
  float epsilon = 1.1920928955078125e-7;
  float threshold = log(epsilon) + 2.0;

  bool too_large = x > -threshold;
  bool too_small = x < threshold;

  float result;
  float exp_x = exp(x);

  if (too_large){
    result = x;
  }
  else if (too_small){
    result = exp_x;
  }
  else{
    result = log(exp_x + 1.0);
  }
  return result;
`;
const $0e13c3f03ba95eff$export$76aa560a8c2b0055 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $0e13c3f03ba95eff$var$SOFTPLUS
});
const $0e13c3f03ba95eff$export$d9bcfe553d12d9e3 = {
    kernelName: (0, $9BGT9.Softplus),
    backendName: 'webgl',
    kernelFunc: $0e13c3f03ba95eff$export$76aa560a8c2b0055
};

});

parcelRegister("7eL0d", function(module, exports) {

$parcel$export(module.exports, "spaceToBatchNDConfig", function () { return $544e4cea0474e0d5$export$2f85417863d2050b; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $8ExI5 = parcelRequire("8ExI5");

var $aNJFF = parcelRequire("aNJFF");

var $fZ5E6 = parcelRequire("fZ5E6");
const $544e4cea0474e0d5$export$effb9d7cae92012f = (args)=>{
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { blockShape: blockShape, paddings: paddings } = attrs;
    (0, $lBDHD).assert(x.shape.length <= 4, ()=>"spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");
    const prod = blockShape.reduce((a, b)=>a * b);
    const completePaddings = [
        [
            0,
            0
        ]
    ];
    completePaddings.push(...paddings);
    for(let i = 1 + blockShape.length; i < x.shape.length; ++i)completePaddings.push([
        0,
        0
    ]);
    const toDispose = [];
    const paddedX = (0, $8ExI5.padV2)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            paddings: completePaddings,
            constantValue: 0
        }
    });
    const reshapedPaddedShape = (0, $dEVRx).getReshaped(paddedX.shape, blockShape, prod, false);
    const permutedReshapedPaddedPermutation = (0, $dEVRx).getPermuted(reshapedPaddedShape.length, blockShape.length, false);
    const flattenShape = (0, $dEVRx).getReshapedPermuted(paddedX.shape, blockShape, prod, false);
    const reshapedPaddedX = (0, $aNJFF.reshape)({
        inputs: {
            x: paddedX
        },
        backend: backend,
        attrs: {
            shape: reshapedPaddedShape
        }
    });
    const paddedXT = (0, $fZ5E6.transpose)({
        inputs: {
            x: reshapedPaddedX
        },
        backend: backend,
        attrs: {
            perm: permutedReshapedPaddedPermutation
        }
    });
    const result = (0, $aNJFF.reshape)({
        inputs: {
            x: paddedXT
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    toDispose.push(paddedX);
    toDispose.push(reshapedPaddedX);
    toDispose.push(paddedXT);
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
};
const $544e4cea0474e0d5$export$2f85417863d2050b = {
    kernelName: (0, $9BGT9.SpaceToBatchND),
    backendName: 'webgl',
    kernelFunc: $544e4cea0474e0d5$export$effb9d7cae92012f
};

});

parcelRegister("5EpvY", function(module, exports) {

$parcel$export(module.exports, "sparseFillEmptyRowsConfig", function () { return $41d47ae2f940dcd1$export$818286c593224d1a; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $41d47ae2f940dcd1$export$c82a1904a15b5028(args) {
    const { inputs: inputs, backend: backend } = args;
    const { indices: indices, values: values, denseShape: denseShape, defaultValue: defaultValue } = inputs;
    if (denseShape.shape.length !== 1) throw new Error(`Dense shape must be a vector, saw:
         ${denseShape.shape}`);
    if (indices.shape.length !== 2) throw new Error(`Indices must be a matrix, saw:
         ${indices.shape}`);
    if (values.shape.length !== 1) throw new Error(`Values must be a vector, saw:
         ${values.shape}`);
    if (defaultValue.shape.length !== 0) throw new Error(`Default value must be a scalar, saw:
        ${defaultValue.shape}`);
    const $indices = backend.readSync(indices.dataId);
    const $values = backend.readSync(values.dataId);
    const $denseShape = backend.readSync(denseShape.dataId);
    const $defaultValue = backend.readSync(defaultValue.dataId)[0];
    const [outputIndices, outputIndicesShape, outputValues, emptyRowIndicator, reverseIndexMap] = (0, $glyiU.sparseFillEmptyRowsImplCPU)($indices, indices.shape, indices.dtype, $values, values.dtype, $denseShape, $defaultValue);
    return [
        backend.makeTensorInfo(outputIndicesShape, indices.dtype, outputIndices),
        backend.makeTensorInfo([
            outputIndicesShape[0]
        ], values.dtype, outputValues),
        backend.makeTensorInfo([
            emptyRowIndicator.length
        ], 'bool', new Uint8Array(emptyRowIndicator.map((value)=>Number(value)))),
        backend.makeTensorInfo([
            reverseIndexMap.length
        ], indices.dtype, new Int32Array(reverseIndexMap))
    ];
}
const $41d47ae2f940dcd1$export$818286c593224d1a = {
    kernelName: (0, $9BGT9.SparseFillEmptyRows),
    backendName: 'webgl',
    kernelFunc: $41d47ae2f940dcd1$export$c82a1904a15b5028
};

});

parcelRegister("jAESl", function(module, exports) {

$parcel$export(module.exports, "sparseReshapeConfig", function () { return $e43116210a88f757$export$eb106efc10374803; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $e43116210a88f757$export$1408c45865e11fc6(args) {
    const { inputs: inputs, backend: backend } = args;
    const { inputIndices: inputIndices, inputShape: inputShape, newShape: newShape } = inputs;
    if (inputIndices.shape.length !== 2) throw new Error(`Input indices should be a matrix but received shape ${inputIndices.shape}`);
    if (inputShape.shape.length !== 1) throw new Error(`Input shape should be a vector but received shape ${inputShape.shape}`);
    if (newShape.shape.length !== 1) throw new Error(`Target shape should be a vector but received shape ${newShape.shape}`);
    const $inputShape = Array.from(backend.readSync(inputShape.dataId));
    const $inputIndices = backend.readSync(inputIndices.dataId);
    const targetShape = Array.from(backend.readSync(newShape.dataId));
    const [newIndices, indicesShape, outputShape] = (0, $glyiU.sparseReshapeImplCPU)($inputIndices, inputIndices.shape, inputIndices.dtype, $inputShape, targetShape);
    return [
        backend.makeTensorInfo(indicesShape, inputIndices.dtype, newIndices),
        backend.makeTensorInfo([
            outputShape.length
        ], newShape.dtype, new Int32Array(outputShape))
    ];
}
const $e43116210a88f757$export$eb106efc10374803 = {
    kernelName: (0, $9BGT9.SparseReshape),
    backendName: 'webgl',
    kernelFunc: $e43116210a88f757$export$1408c45865e11fc6
};

});

parcelRegister("6uqGG", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentMeanConfig", function () { return $4b9a3ef9b19b2642$export$51e7224ae14d7f78; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $4b9a3ef9b19b2642$export$dbc0c9096869d04e(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
              ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
              ${segmentIds.shape}`);
    const $data = backend.readSync(data.dataId);
    const $indices = backend.readSync(indices.dataId);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const [outputData, outputDataShape] = (0, $glyiU.sparseSegmentReductionImplCPU)($data, data.shape, data.dtype, $indices, $segmentIds, true);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $4b9a3ef9b19b2642$export$51e7224ae14d7f78 = {
    kernelName: (0, $9BGT9.SparseSegmentMean),
    backendName: 'webgl',
    kernelFunc: $4b9a3ef9b19b2642$export$dbc0c9096869d04e
};

});

parcelRegister("7EnID", function(module, exports) {

$parcel$export(module.exports, "sparseSegmentSumConfig", function () { return $591eaaef6d03ca7e$export$73fa0270f28b9555; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $591eaaef6d03ca7e$export$2255ce53fc777865(args) {
    const { inputs: inputs, backend: backend } = args;
    const { data: data, indices: indices, segmentIds: segmentIds } = inputs;
    if (data.shape.length < 1) throw new Error(`Data should be at least 1 dimensional but received scalar`);
    if (indices.shape.length !== 1) throw new Error(`Indices should be a vector but received shape
             ${indices.shape}`);
    if (segmentIds.shape.length !== 1) throw new Error(`Segment ids should be a vector but received shape
             ${segmentIds.shape}`);
    const $data = backend.readSync(data.dataId);
    const $indices = backend.readSync(indices.dataId);
    const $segmentIds = backend.readSync(segmentIds.dataId);
    const [outputData, outputDataShape] = (0, $glyiU.sparseSegmentReductionImplCPU)($data, data.shape, data.dtype, $indices, $segmentIds);
    return backend.makeTensorInfo(outputDataShape, data.dtype, outputData);
}
const $591eaaef6d03ca7e$export$73fa0270f28b9555 = {
    kernelName: (0, $9BGT9.SparseSegmentSum),
    backendName: 'webgl',
    kernelFunc: $591eaaef6d03ca7e$export$2255ce53fc777865
};

});

parcelRegister("71KcT", function(module, exports) {

$parcel$export(module.exports, "sparseToDenseConfig", function () { return $51dc7826850a46ea$export$7bc088f8ad44ef99; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $glyiU = parcelRequire("glyiU");

var $9wxvs = parcelRequire("9wxvs");

var $aNJFF = parcelRequire("aNJFF");
function $51dc7826850a46ea$export$1be4b823dd1a3080(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { sparseIndices: sparseIndices, sparseValues: sparseValues, defaultValue: defaultValue } = inputs;
    const { outputShape: outputShape } = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $dEVRx).calculateShapes(sparseValues, sparseIndices, outputShape);
    const sumDupeIndices = false;
    if (sparseValues.dtype === 'string') {
        const indicesBuf = backend.bufferSync(sparseIndices);
        const updatesBuf = backend.bufferSync(sparseValues);
        const $defaultValue = (0, $lBDHD).decodeString(backend.readSync(defaultValue.dataId)[0]);
        const outBuf = (0, $glyiU.scatterImplCPU)(indicesBuf, updatesBuf, outputShape, outputSize, sliceSize, numUpdates, sliceRank, strides, $defaultValue, sumDupeIndices);
        return backend.makeTensorInfo(outputShape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $9wxvs.ScatterProgram)(numUpdates, sliceRank, sparseIndices.shape.length, sparseValues.shape.length, strides, [
        outputSize,
        1
    ], sumDupeIndices);
    const res = backend.runWebGLProgram(program, [
        sparseValues,
        sparseIndices,
        defaultValue
    ], sparseValues.dtype);
    const reshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: outputShape
        }
    });
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $51dc7826850a46ea$export$7bc088f8ad44ef99 = {
    kernelName: (0, $9BGT9.SparseToDense),
    backendName: 'webgl',
    kernelFunc: $51dc7826850a46ea$export$1be4b823dd1a3080
};

});

parcelRegister("a0Q6Q", function(module, exports) {

$parcel$export(module.exports, "splitVConfig", function () { return $74a2534de18b767d$export$317be24be3af9ea0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $llO7x = parcelRequire("llO7x");
function $74a2534de18b767d$export$c0085d48b0a75d8f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { numOrSizeSplits: numOrSizeSplits, axis: axis } = attrs;
    const $axis = (0, $lBDHD).parseAxisParam(axis, x.shape)[0];
    const splitSizes = (0, $dEVRx).prepareSplitSize(x, numOrSizeSplits, $axis);
    const xRank = x.shape.length;
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    return splitSizes.map((s)=>{
        const sliceSize = [
            ...size
        ];
        sliceSize[$axis] = s;
        const sliceT = (0, $llO7x.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: sliceSize
            }
        });
        begin[$axis] += s;
        return sliceT;
    });
}
const $74a2534de18b767d$export$317be24be3af9ea0 = {
    kernelName: (0, $9BGT9.SplitV),
    backendName: 'webgl',
    kernelFunc: $74a2534de18b767d$export$c0085d48b0a75d8f
};

});

parcelRegister("emSRY", function(module, exports) {

$parcel$export(module.exports, "sqrtConfig", function () { return $a75daeb57003c68e$export$a592ba9268f10eeb; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");

var $glyiU = parcelRequire("glyiU");
const $a75daeb57003c68e$var$SQRT = `return sqrt(x);`;
const $a75daeb57003c68e$export$eba8049fb5020b81 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $a75daeb57003c68e$var$SQRT,
    packedOpSnippet: $a75daeb57003c68e$var$SQRT,
    cpuKernelImpl: (0, $glyiU.sqrtImplCPU)
});
const $a75daeb57003c68e$export$a592ba9268f10eeb = {
    kernelName: (0, $9BGT9.Sqrt),
    backendName: 'webgl',
    kernelFunc: $a75daeb57003c68e$export$eba8049fb5020b81
};

});

parcelRegister("XFubH", function(module, exports) {

$parcel$export(module.exports, "squareConfig", function () { return $0b35b109bbae28d7$export$7c77bece4d51efc4; });
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $0b35b109bbae28d7$var$SQUARE = `return x * x;`;
const $0b35b109bbae28d7$export$dd4f28cef696bc7d = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $0b35b109bbae28d7$var$SQUARE
});
const $0b35b109bbae28d7$export$7c77bece4d51efc4 = {
    kernelName: (0, $9BGT9.Square),
    backendName: 'webgl',
    kernelFunc: $0b35b109bbae28d7$export$dd4f28cef696bc7d
};

});

parcelRegister("lr1zN", function(module, exports) {

$parcel$export(module.exports, "squaredDifferenceConfig", function () { return $f9ad579f5885671c$export$9ed4691d69db8a43; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $f9ad579f5885671c$var$SQUARED_DIFFERENCE = 'return (a - b) * (a - b);';
const $f9ad579f5885671c$export$b178697fb6d0b37f = (0, $k2x5z.binaryKernelFunc)({
    opSnippet: $f9ad579f5885671c$var$SQUARED_DIFFERENCE,
    packedOpSnippet: $f9ad579f5885671c$var$SQUARED_DIFFERENCE
});
const $f9ad579f5885671c$export$9ed4691d69db8a43 = {
    kernelName: (0, $9BGT9.SquaredDifference),
    backendName: 'webgl',
    kernelFunc: $f9ad579f5885671c$export$b178697fb6d0b37f
};

});

parcelRegister("8t3xP", function(module, exports) {

$parcel$export(module.exports, "staticRegexReplaceConfig", function () { return $62a3c80af482f634$export$1069b2f6977254f4; });
/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $62a3c80af482f634$export$2bdfdc7ae087914d(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    if (x.dtype !== 'string') throw new Error('Input must be of datatype string');
    const $x = backend.readSync(x.dataId);
    const stringInput = (0, $dEVRx).fromUint8ToStringArray($x);
    const output = (0, $glyiU.staticRegexReplaceImplCPU)(stringInput, 'string', attrs);
    return backend.makeTensorInfo(x.shape, 'string', output);
}
const $62a3c80af482f634$export$1069b2f6977254f4 = {
    kernelName: (0, $9BGT9.StaticRegexReplace),
    backendName: 'webgl',
    kernelFunc: $62a3c80af482f634$export$2bdfdc7ae087914d
};

});

parcelRegister("1nMPb", function(module, exports) {

$parcel$export(module.exports, "stepConfig", function () { return $101dcff1ee8fb1d7$export$c42ffaf52eb2647; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $1V6Qm = parcelRequire("1V6Qm");
function $101dcff1ee8fb1d7$export$35d34bc0ed591a92({ inputs: inputs, attrs: attrs, backend: backend }) {
    const { x: x } = inputs;
    const opSnippet = (0, $1V6Qm.CHECK_NAN_SNIPPET) + `
    return x > 0.0 ? 1.0 : float(${attrs.alpha});
  `;
    const program = new (0, $1V6Qm.UnaryOpProgram)(x.shape, opSnippet);
    return backend.runWebGLProgram(program, [
        x
    ], x.dtype);
}
const $101dcff1ee8fb1d7$export$c42ffaf52eb2647 = {
    kernelName: (0, $9BGT9.Step),
    backendName: 'webgl',
    kernelFunc: $101dcff1ee8fb1d7$export$35d34bc0ed591a92
};

});

parcelRegister("2Tic5", function(module, exports) {

$parcel$export(module.exports, "stridedSliceConfig", function () { return $21aed4c49a1e1a5c$export$81773633114187bd; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
var $iEcDD = parcelRequire("iEcDD");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $glyiU = parcelRequire("glyiU");

var $kLZtq = parcelRequire("kLZtq");

var $aNJFF = parcelRequire("aNJFF");

var $llO7x = parcelRequire("llO7x");
function $21aed4c49a1e1a5c$export$4ae57224f3b0605c(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { begin: begin, end: end, strides: strides, beginMask: beginMask, endMask: endMask, ellipsisMask: ellipsisMask, newAxisMask: newAxisMask, shrinkAxisMask: shrinkAxisMask } = attrs;
    const { finalShapeSparse: finalShapeSparse, finalShape: finalShape, isIdentity: isIdentity, sliceDim0: sliceDim0, isSimpleSlice: isSimpleSlice, begin: $begin, end: $end, strides: $strides } = (0, $iEcDD).sliceInfo(x.shape, begin, end, strides, beginMask, endMask, ellipsisMask, newAxisMask, shrinkAxisMask);
    let result;
    if (isIdentity) // Optimization #1, slice is a no-op plus reshape
    result = (0, $aNJFF.reshape)({
        inputs: {
            x: x
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    else if (sliceDim0 || isSimpleSlice) {
        // Optimization #2, slice is memory contiguous (only occurs in dim 0)
        (0, $lBDHD).assert(x.shape.length >= 1, ()=>`Input must have rank at least 1, got: ${x.shape.length}`);
        const size = (0, $iEcDD).computeOutShape($begin, $end, $strides);
        // To tolerate begin[0] > end[0] (a 0-output slice), we min(begin, end).
        const sliced = (0, $llO7x.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: $begin,
                size: size
            }
        });
        result = (0, $aNJFF.reshape)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: finalShape
            }
        });
        backend.disposeIntermediateTensorInfo(sliced);
    } else {
        const shouldExecuteOnCPU = backend.shouldExecuteOnCPU([
            x
        ]);
        if (shouldExecuteOnCPU) {
            // tslint:disable-next-line: no-unnecessary-type-assertion
            const values = backend.readSync(x.dataId);
            // tslint:disable-next-line: no-unnecessary-type-assertion
            const xBuf = (0, $5siju.buffer)(x.shape, x.dtype, values);
            const resultValues = (0, $glyiU.stridedSliceImplCPU)(finalShapeSparse, xBuf, $strides, $begin);
            result = backend.makeTensorInfo(finalShape, x.dtype, resultValues.values);
        } else {
            const program = new (0, $kLZtq.StridedSliceProgram)($begin, $strides, finalShapeSparse);
            result = backend.runWebGLProgram(program, [
                x
            ], x.dtype);
        }
    }
    const resultReshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: result
        },
        backend: backend,
        attrs: {
            shape: finalShape
        }
    });
    backend.disposeIntermediateTensorInfo(result);
    return resultReshaped;
}
const $21aed4c49a1e1a5c$export$81773633114187bd = {
    kernelName: (0, $9BGT9.StridedSlice),
    backendName: 'webgl',
    kernelFunc: $21aed4c49a1e1a5c$export$4ae57224f3b0605c
};

});
parcelRegister("kLZtq", function(module, exports) {

$parcel$export(module.exports, "StridedSliceProgram", function () { return $f1f7e1d1878c9f82$export$335c52ce94f359f6; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $f1f7e1d1878c9f82$export$335c52ce94f359f6 {
    constructor(begin, strides, size){
        this.variableNames = [
            'x'
        ];
        this.outputShape = size;
        const rank = size.length;
        const inputDtype = (0, $1eI1C.getCoordsDataType)(size.length);
        const dtype = (0, $1eI1C.getCoordsDataType)(size.length);
        let newCoords = '';
        if (rank === 1) newCoords = 'coords * strides + begin';
        else {
            let outputAxis = 0;
            newCoords = size.map((_, i)=>{
                outputAxis++;
                return size.length === 1 ? `coords * strides[${i}] + begin[${i}]` : `coords[${outputAxis - 1}] * strides[${i}] + begin[${i}]`;
            }).join(',');
        }
        this.userCode = `
      ${inputDtype} begin = ${inputDtype}(${begin});
      ${inputDtype} strides = ${inputDtype}(${strides});

      void main() {
        ${dtype} coords = getOutputCoords();
        setOutput(getX(${newCoords}));
      }
    `;
    }
}

});


parcelRegister("rGNHl", function(module, exports) {

$parcel$export(module.exports, "stringNGramsConfig", function () { return $0533b908eb5638dd$export$35e13284eed34c22; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $0533b908eb5638dd$export$3490514dcc63b044(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { separator: separator, nGramWidths: nGramWidths, leftPad: leftPad, rightPad: rightPad, padWidth: padWidth, preserveShortSequences: preserveShortSequences } = attrs;
    const { data: data, dataSplits: dataSplits } = inputs;
    const $data = backend.readSync(data.dataId);
    const $dataSplits = backend.readSync(dataSplits.dataId);
    const [nGrams, nGramsSplits] = (0, $glyiU.stringNGramsImplCPU)($data, $dataSplits, separator, nGramWidths, leftPad, rightPad, padWidth, preserveShortSequences);
    return [
        backend.makeTensorInfo([
            nGrams.length
        ], 'string', nGrams),
        backend.makeTensorInfo(dataSplits.shape, 'int32', nGramsSplits)
    ];
}
const $0533b908eb5638dd$export$35e13284eed34c22 = {
    kernelName: (0, $9BGT9.StringNGrams),
    backendName: 'webgl',
    kernelFunc: $0533b908eb5638dd$export$3490514dcc63b044
};

});

parcelRegister("aI9ut", function(module, exports) {

$parcel$export(module.exports, "stringSplitConfig", function () { return $7cc56010651cb873$export$c51cbbd627a96532; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $7cc56010651cb873$export$aa7f8babb17e7672(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { skipEmpty: skipEmpty } = attrs;
    const { input: input, delimiter: delimiter } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (input.shape.length !== 1) throw new Error(`Input must be a vector, got shape: ${input.shape}`);
    if (delimiter.shape.length !== 0) throw new Error(`Delimiter must be a scalar, got shape: ${delimiter.shape}`);
    const $input = backend.readSync(input.dataId);
    const $delimiter = backend.readSync(delimiter.dataId)[0];
    const [indices, values, shape] = (0, $glyiU.stringSplitImplCPU)($input, $delimiter, skipEmpty);
    const outputSize = values.length;
    return [
        backend.makeTensorInfo([
            outputSize,
            2
        ], 'int32', indices),
        backend.makeTensorInfo([
            outputSize
        ], 'string', values),
        backend.makeTensorInfo([
            2
        ], 'int32', new Int32Array(shape))
    ];
}
const $7cc56010651cb873$export$c51cbbd627a96532 = {
    kernelName: (0, $9BGT9.StringSplit),
    backendName: 'webgl',
    kernelFunc: $7cc56010651cb873$export$aa7f8babb17e7672
};

});

parcelRegister("7x9zr", function(module, exports) {

$parcel$export(module.exports, "stringToHashBucketFastConfig", function () { return $57c30a01380770ac$export$a88a78b2b233f507; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");
function $57c30a01380770ac$export$6195616d6fd0c848(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { numBuckets: numBuckets } = attrs;
    const { input: input } = inputs;
    if (input.dtype !== 'string') throw new Error('Input must be of datatype string');
    if (numBuckets <= 0) throw new Error(`Number of buckets must be at least 1`);
    const $input = backend.readSync(input.dataId);
    const output = (0, $glyiU.stringToHashBucketFastImplCPU)($input, numBuckets);
    return backend.makeTensorInfo(input.shape, 'int32', output);
}
const $57c30a01380770ac$export$a88a78b2b233f507 = {
    kernelName: (0, $9BGT9.StringToHashBucketFast),
    backendName: 'webgl',
    kernelFunc: $57c30a01380770ac$export$6195616d6fd0c848
};

});

parcelRegister("krsGy", function(module, exports) {

$parcel$export(module.exports, "tanConfig", function () { return $ee1c949a022b5673$export$97648844df7611f3; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $ee1c949a022b5673$var$TAN = `return tan(x);`;
const $ee1c949a022b5673$export$fcdd3b0b3246a325 = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $ee1c949a022b5673$var$TAN
});
const $ee1c949a022b5673$export$97648844df7611f3 = {
    kernelName: (0, $9BGT9.Tan),
    backendName: 'webgl',
    kernelFunc: $ee1c949a022b5673$export$fcdd3b0b3246a325
};

});

parcelRegister("d7pGt", function(module, exports) {

$parcel$export(module.exports, "tanhConfig", function () { return $98cfda265e4d6889$export$a2fc7de1a1e4eee0; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $k2x5z = parcelRequire("k2x5z");
const $98cfda265e4d6889$var$TANH = `
  float e2x = exp(-2.0 * abs(x));
  return sign(x) * (1.0 - e2x) / (1.0 + e2x);
`;
const $98cfda265e4d6889$export$7128670e45beef9a = (0, $k2x5z.unaryKernelFunc)({
    opSnippet: $98cfda265e4d6889$var$TANH
});
const $98cfda265e4d6889$export$a2fc7de1a1e4eee0 = {
    kernelName: (0, $9BGT9.Tanh),
    backendName: 'webgl',
    kernelFunc: $98cfda265e4d6889$export$7128670e45beef9a
};

});

parcelRegister("lJLGw", function(module, exports) {

$parcel$export(module.exports, "tensorScatterUpdateConfig", function () { return $fd32ca2864c8b72d$export$2819813ce8339b64; });
/**
 * @license
 * Copyright 2022 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $9BGT9 = parcelRequire("9BGT9");

var $9wxvs = parcelRequire("9wxvs");

var $aNJFF = parcelRequire("aNJFF");
function $fd32ca2864c8b72d$export$d3ac02769385eb36(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { tensor: tensor, indices: indices, updates: updates } = inputs;
    const {} = attrs;
    const { sliceRank: sliceRank, numUpdates: numUpdates, sliceSize: sliceSize, strides: strides, outputSize: outputSize } = (0, $dEVRx).calculateShapes(updates, indices, tensor.shape);
    const flattenShape = [
        outputSize / sliceSize,
        sliceSize
    ];
    if (outputSize === 0) return backend.makeTensorInfo(tensor.shape, indices.dtype);
    const flattenIndices = (0, $aNJFF.reshape)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceRank
            ]
        }
    });
    const flattenX = (0, $aNJFF.reshape)({
        inputs: {
            x: updates
        },
        backend: backend,
        attrs: {
            shape: [
                numUpdates,
                sliceSize
            ]
        }
    });
    const flattenTensor = (0, $aNJFF.reshape)({
        inputs: {
            x: tensor
        },
        backend: backend,
        attrs: {
            shape: flattenShape
        }
    });
    const program = new (0, $9wxvs.ScatterProgram)(numUpdates, sliceRank, flattenIndices.shape.length, flattenX.shape.length, strides, flattenShape, false, true);
    const res = backend.runWebGLProgram(program, [
        flattenX,
        flattenIndices,
        flattenTensor
    ], flattenTensor.dtype);
    const reshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: res
        },
        backend: backend,
        attrs: {
            shape: tensor.shape
        }
    });
    backend.disposeIntermediateTensorInfo(flattenIndices);
    backend.disposeIntermediateTensorInfo(flattenX);
    backend.disposeIntermediateTensorInfo(flattenTensor);
    backend.disposeIntermediateTensorInfo(res);
    return reshaped;
}
const $fd32ca2864c8b72d$export$2819813ce8339b64 = {
    kernelName: (0, $9BGT9.TensorScatterUpdate),
    backendName: 'webgl',
    kernelFunc: $fd32ca2864c8b72d$export$d3ac02769385eb36
};

});

parcelRegister("bKD1Y", function(module, exports) {

$parcel$export(module.exports, "tile", function () { return $88e2444f54c27e87$export$3c17558da18e4d75; });
$parcel$export(module.exports, "tileConfig", function () { return $88e2444f54c27e87$export$a5a9f8050ba7f41e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $5siju = parcelRequire("5siju");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $glyiU = parcelRequire("glyiU");

var $31y7L = parcelRequire("31y7L");
function $88e2444f54c27e87$export$3c17558da18e4d75(params) {
    const { inputs: inputs, backend: backend, attrs: attrs } = params;
    const { x: x } = inputs;
    const { reps: reps } = attrs;
    // tile gpu program cannot handle rank > 5 case.
    if (x.dtype === 'string' || x.shape.length > 5) {
        // Even thought string tensor is always on CPU, just to be consistent on how
        // to access tensor data.
        const data = backend.readSync(x.dataId);
        const value = x.dtype === 'string' ? data.map((d)=>(0, $lBDHD).decodeString(d)) : data;
        const buf = (0, $5siju.buffer)(x.shape, x.dtype, value);
        const outBuf = (0, $glyiU.tileImplCPU)(buf, reps);
        return backend.makeTensorInfo(outBuf.shape, outBuf.dtype, outBuf.values);
    }
    const program = new (0, $31y7L.TileProgram)(x.shape, reps);
    const output = backend.runWebGLProgram(program, [
        x
    ], x.dtype);
    return output;
}
const $88e2444f54c27e87$export$a5a9f8050ba7f41e = {
    kernelName: (0, $9BGT9.Tile),
    backendName: 'webgl',
    kernelFunc: $88e2444f54c27e87$export$3c17558da18e4d75
};

});
parcelRegister("31y7L", function(module, exports) {

$parcel$export(module.exports, "TileProgram", function () { return $233bef786fcef662$export$215140f0ab19f420; });
/**
 * @license
 * Copyright 2017 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ 
var $1eI1C = parcelRequire("1eI1C");
class $233bef786fcef662$export$215140f0ab19f420 {
    constructor(aShape, reps){
        this.variableNames = [
            'A'
        ];
        const outputShape = new Array(aShape.length);
        for(let i = 0; i < outputShape.length; i++)outputShape[i] = aShape[i] * reps[i];
        this.outputShape = outputShape;
        this.rank = outputShape.length;
        const dtype = (0, $1eI1C.getCoordsDataType)(this.rank);
        const sourceCoords = $233bef786fcef662$var$getSourceCoords(aShape);
        this.userCode = `
      void main() {
        ${dtype} resRC = getOutputCoords();
        setOutput(getA(${sourceCoords}));
      }
    `;
    }
}
function $233bef786fcef662$var$getSourceCoords(aShape) {
    const rank = aShape.length;
    if (rank > 5) throw Error(`Tile for rank ${rank} is not yet supported`);
    if (rank === 1) return `imod(resRC, ${aShape[0]})`;
    const currentCoords = [
        'resRC.x',
        'resRC.y',
        'resRC.z',
        'resRC.w',
        'resRC.u'
    ];
    const sourceCoords = [];
    for(let i = 0; i < aShape.length; i++)sourceCoords.push(`imod(${currentCoords[i]}, ${aShape[i]})`);
    return sourceCoords.join();
}

});


parcelRegister("dQpiP", function(module, exports) {

$parcel$export(module.exports, "topKConfig", function () { return $a143c246c1cd2bac$export$cffaee31213314ce; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $tdutJ = parcelRequire("tdutJ");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $glyiU = parcelRequire("glyiU");

var $5TWQ2 = parcelRequire("5TWQ2");

var $e4Jud = parcelRequire("e4Jud");

var $4ug3z = parcelRequire("4ug3z");

var $aNJFF = parcelRequire("aNJFF");

var $llO7x = parcelRequire("llO7x");
function $a143c246c1cd2bac$var$disposeIntermediateTensorInfoOrNull(backend, tensorInfo) {
    if (tensorInfo !== null) backend.disposeIntermediateTensorInfo(tensorInfo);
}
function $a143c246c1cd2bac$var$roundUpToPow2(num) {
    let pow2 = 1;
    while(pow2 < num)pow2 *= 2;
    return pow2;
}
function $a143c246c1cd2bac$export$7e641efc73a2d81(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x } = inputs;
    const { k: k, sorted: sorted } = attrs;
    // Empirically determined constant used to determine last dim threshold for
    // handing off execution to the CPU.
    const TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD = (0, $tdutJ.env)().getNumber('TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD');
    // Empirically determined constant used to determine k threshold for handing
    // off execution to the CPU.
    const TOPK_K_CPU_HANDOFF_THRESHOLD = (0, $tdutJ.env)().getNumber('TOPK_K_CPU_HANDOFF_THRESHOLD');
    const xShape = x.shape;
    const lastDim = xShape[xShape.length - 1];
    if (backend.shouldExecuteOnCPU([
        x
    ]) || lastDim < TOPK_LAST_DIM_CPU_HANDOFF_SIZE_THRESHOLD || k > TOPK_K_CPU_HANDOFF_THRESHOLD) {
        const xVals = backend.readSync(x.dataId);
        const [allTopKVals, allTopKIndices] = (0, $glyiU.topKImplCPU)(xVals, xShape, x.dtype, k, sorted);
        return [
            backend.makeTensorInfo(allTopKVals.shape, allTopKVals.dtype, allTopKVals.values),
            backend.makeTensorInfo(allTopKIndices.shape, allTopKIndices.dtype, allTopKIndices.values)
        ];
    }
    if (k === 0) {
        xShape[xShape.length - 1] = 0;
        return [
            backend.makeTensorInfo(xShape, x.dtype, []),
            backend.makeTensorInfo(xShape, 'int32', [])
        ];
    }
    if (lastDim === 1 /* firstPass */ ) return [
        x,
        (0, $e4Jud.fill)({
            attrs: {
                shape: xShape,
                dtype: 'int32',
                value: 0
            },
            backend: backend
        })
    ];
    // Eagerly unpack x input since it is passed in to all the shaders which
    // require unpacked inputs.
    const xtexData = backend.texData.get(x.dataId);
    const xIsPacked = xtexData !== null && xtexData.isPacked;
    const xUnPacked = xIsPacked ? backend.unpackTensor(x) : x;
    // Reshape into a 2d tensor [batch, lastDim] and compute topk along lastDim.
    const xSize = (0, $lBDHD).sizeFromShape(xShape);
    const batch = xSize / lastDim;
    const x2D = (0, $aNJFF.reshape)({
        inputs: {
            x: xUnPacked
        },
        attrs: {
            shape: [
                batch,
                lastDim
            ]
        },
        backend: backend
    });
    if (xIsPacked) $a143c246c1cd2bac$var$disposeIntermediateTensorInfoOrNull(backend, xUnPacked);
    const kPow2 = $a143c246c1cd2bac$var$roundUpToPow2(k);
    const lastDimPow2 = $a143c246c1cd2bac$var$roundUpToPow2(lastDim);
    // Only the indices containing the top K are kept at every step to reduce
    // number of outputs in the GPU algorithms, so once the final set of indices
    // is computed then gather is used to grab the corresponding values
    // from the original input.
    let indices = null;
    // GPU algorithm always takes in an indices input but this input is not used
    // on the first run of a GPU algorithm, therefore if indices is null we simply
    // pass in x2D instead of it but the value will not actually be used
    const getInputs = ()=>indices === null ? [
            x2D,
            x2D
        ] : [
            x2D,
            indices
        ];
    const runSwap = (dir, inc, shape)=>{
        const inputs = getInputs();
        const program = new (0, $5TWQ2.SwapProgram)(shape);
        const fistPass = indices === null ? 1 : 0;
        const customValues = [
            [
                lastDim
            ],
            [
                fistPass
            ],
            [
                Number.NEGATIVE_INFINITY
            ],
            [
                dir
            ],
            [
                inc
            ]
        ];
        const prevIndices = indices;
        indices = backend.runWebGLProgram(program, inputs, 'int32', customValues);
        $a143c246c1cd2bac$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    };
    // Step 1: local sort
    for(let len = 1; len < kPow2; len *= 2){
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, [
            batch,
            lastDimPow2
        ]);
    }
    // Step 2: merge
    for(let indicesSize = lastDimPow2; indicesSize > kPow2; indicesSize /= 2){
        const inputs = getInputs();
        const mergeProgram = new (0, $5TWQ2.MergeProgram)([
            batch,
            indicesSize / 2
        ]);
        const firstPass = indices === null ? 1 : 0;
        const customValues = [
            [
                lastDim
            ],
            [
                firstPass
            ],
            [
                kPow2
            ]
        ];
        const prevIndices = indices;
        indices = backend.runWebGLProgram(mergeProgram, inputs, 'int32', customValues);
        $a143c246c1cd2bac$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
        // Step 3: rebuild
        const len = kPow2 / 2;
        const dir = len * 2;
        for(let inc = len; inc >= 1; inc /= 2)runSwap(dir, inc, indices.shape);
    }
    // Keep only the requested top K results instead of kPow2
    let prevIndices = indices;
    indices = (0, $llO7x.slice)({
        inputs: {
            x: indices
        },
        backend: backend,
        attrs: {
            begin: 0,
            size: [
                batch,
                k
            ]
        }
    });
    $a143c246c1cd2bac$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    // Gather values on last dimension
    let values = (0, $4ug3z.gatherV2)({
        inputs: {
            x: x2D,
            indices: indices
        },
        backend: backend,
        attrs: {
            axis: 1,
            batchDims: 1
        }
    });
    $a143c246c1cd2bac$var$disposeIntermediateTensorInfoOrNull(backend, x2D);
    // Reshape back to the original input shape, except that the last
    // dimension is k.
    const newShape = xShape.slice(0, -1);
    newShape.push(k);
    prevIndices = indices;
    indices = (0, $aNJFF.reshape)({
        inputs: {
            x: indices
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $a143c246c1cd2bac$var$disposeIntermediateTensorInfoOrNull(backend, prevIndices);
    const prevValues = values;
    values = (0, $aNJFF.reshape)({
        inputs: {
            x: values
        },
        attrs: {
            shape: newShape
        },
        backend: backend
    });
    $a143c246c1cd2bac$var$disposeIntermediateTensorInfoOrNull(backend, prevValues);
    return [
        values,
        indices
    ];
}
const $a143c246c1cd2bac$export$cffaee31213314ce = {
    kernelName: (0, $9BGT9.TopK),
    backendName: 'webgl',
    kernelFunc: $a143c246c1cd2bac$export$7e641efc73a2d81
};

});
parcelRegister("5TWQ2", function(module, exports) {

$parcel$export(module.exports, "SwapProgram", function () { return $44bfbae18bd6116d$export$5ee54e3c81d6f6e7; });
$parcel$export(module.exports, "MergeProgram", function () { return $44bfbae18bd6116d$export$c3fbf8b38d821ac9; });
// Based on Algorithm 2 of Bitonic Top K, ref:
// https://anilshanbhag.in/static/papers/gputopk_sigmod18.pdf
// The original algorithm is based on computing the top K only, however
// since for TFJS we require the indices of the top K values as well then the
// algorithm found here is a bit modified. Rather than producing the values
// at each step, the indices containing the top K are generated instead.
// The output values are not generated to reduce the number of outputs in the
// GPU, the values can easily be retrieved from the indices using a gather
// op.
class $44bfbae18bd6116d$export$5ee54e3c81d6f6e7 {
    /**
     * @param shape desired output shape (can be larger than input shape, output
     *                                    will be padded with -Infinity)
     */ constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        // |n| Size of the original input of TopK.
        // |firstPass|indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |inc| Swaps pairs of indices (0, inc), (1, inc + 1), (2, inc + 2) ...
        this.customUniforms = [
            {
                name: 'n',
                type: 'int'
            },
            {
                name: 'firstPass',
                type: 'int'
            },
            {
                name: 'negativeInf',
                type: 'float'
            },
            {
                name: 'dir',
                type: 'int'
            },
            {
                name: 'inc',
                type: 'int'
            }
        ];
        this.outputShape = shape;
        this.userCode = `
       void main() {
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // We compare elements pair-wise within a group of size 2 * inc.
         // The comparing rule for each group alternates between ascending
         // and descending. Within each group, we compare each pair at
         // positions i and i+inc. To decide whether an element at position i
         // is x0 or x1, we mod it by 2 * inc, if the result is smaller than
         // inc, it is in the first half of the group, we denote it as x0,
         // otherwise we denote it as x1.
         // For example, as shown in the Bitonic top K paper referenced above,
         // Figure5(a) shows that element[1] is in the
         // second half of the group when group size is 2, but it is in the
         // first half of the group when group size is 4.

         bool isFirstInPair = imod(elemIdx, 2 * inc) < inc;
         int i = isFirstInPair ? elemIdx : elemIdx - inc;

         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + inc : int(getIndices(batch, i + inc));
         float x0 = i0 < n ? getX(batch, i0) : negativeInf;
         float x1 = i1 < n ? getX(batch, i1) : negativeInf;

         // Denotes which direction indices are in (ascending or descending).
         bool reverse = imod(elemIdx, 2 * dir) >= dir;
         bool isGreater = x0 > x1 || (x0 == x1 && i1 > i0);
         if (reverse == isGreater) { // Elements in opposite order of direction
           int iTemp = i0;
           i0 = i1;
           i1 = iTemp;
         }
         if (isFirstInPair) {
            setOutput(float(i0));
         } else {
            setOutput(float(i1));
         }
       }
     `;
    }
}
class $44bfbae18bd6116d$export$c3fbf8b38d821ac9 {
    /**
     * @param shape desired output shape (must be half of the input size)
     */ constructor(shape){
        this.variableNames = [
            'x',
            'indices'
        ];
        // |n| Size of the original input of TopK
        // |firstPass| indicates if this is the first time swap is being used which
        // means no indices input containing the top K is present yet.
        // |k| Top k elements desired
        this.customUniforms = [
            {
                name: 'n',
                type: 'int'
            },
            {
                name: 'firstPass',
                type: 'int'
            },
            {
                name: 'k',
                type: 'int'
            }
        ];
        this.outputShape = shape;
        this.userCode = `
    void main() {
         // Takes max of indices (0, k), (1, k + 1), (2, k + 2) ...
         ivec2 coords = getOutputCoords();
         int batch = coords[0];
         int elemIdx = coords[1];

         // The output size is half of the previous size.
         // If the previous sequence is | | | | _ _ _ _  | | | |  _ _ _ _ (k=4),
         // we only need to output the indices at positions |, the indices at
         // positions _ can be thrown away, see Figure5(b) After Phase 2
         // (Merge phase) in the Bitonic Top K paper referenced above.
         // For example, the paper shows we only need to output the orange bars.
         // The output sequence should look like this | | | | | | | |.
         // Because the sequence is halved, to map the output index back
         // to the previous sequence to find the corresponding value,
         // we need to double the index. When we double the index,
         // we basically interpolate a position, so 2i looks like
         // | _ | _ | _ | _ | _ | _ | _. We move the | to the first k position
         // of each 2k positions by - elemIdx % k. E.g. for output at
         // index 4,5,6,7, we want to get the corresponding element at
         // original index 8,9,10,11, for output at index 8,9,10,11,
         // we want to get the corresponding element at original index
         // 16,17,18,19, so on and so forth.

         int i = elemIdx < k ? elemIdx : (elemIdx * 2 - imod(elemIdx, k));
         int i0 = firstPass == 1 ? i : int(getIndices(batch, i));
         int i1 = firstPass == 1 ? i + k : int(getIndices(batch, i + k));

         float x0 = getX(batch, i0);
         float x1 = i1 < n ? getX(batch, i1) : x0;

         setOutput(x0 >= x1 ? float(i0) : float(i1));
       }
     `;
    }
}

});


parcelRegister("8awEX", function(module, exports) {

$parcel$export(module.exports, "transformConfig", function () { return $5f2897710858288d$export$1c7a3de6335954ed; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $eIqrK = parcelRequire("eIqrK");
function $5f2897710858288d$export$51186ad6e864892a(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { image: image, transforms: transforms } = inputs;
    const { interpolation: interpolation, fillMode: fillMode, fillValue: fillValue, outputShape: outputShape } = attrs;
    const [batch, imageHeight, imageWidth, numChannels] = image.shape;
    const [outHeight, outWidth] = outputShape != null ? outputShape : [
        imageHeight,
        imageWidth
    ];
    const outShape = [
        batch,
        outHeight,
        outWidth,
        numChannels
    ];
    const program = new (0, $eIqrK.TransformProgram)(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape);
    return backend.runWebGLProgram(program, [
        image,
        transforms
    ], 'float32');
}
const $5f2897710858288d$export$1c7a3de6335954ed = {
    kernelName: (0, $9BGT9.Transform),
    backendName: 'webgl',
    kernelFunc: $5f2897710858288d$export$51186ad6e864892a
};

});
parcelRegister("eIqrK", function(module, exports) {

$parcel$export(module.exports, "TransformProgram", function () { return $ab69b080b13fa13b$export$c83a293baf8f269d; });
/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $ab69b080b13fa13b$export$c83a293baf8f269d {
    constructor(imageHeight, imageWidth, interpolation, fillMode, fillValue, outShape){
        this.variableNames = [
            'Image',
            'Transforms'
        ];
        this.outputShape = outShape;
        const interpolationModeId = interpolation === 'nearest' ? 1 : 2;
        let fillModeId;
        switch(fillMode){
            case 'constant':
                fillModeId = 1;
                break;
            case 'reflect':
                fillModeId = 2;
                break;
            case 'wrap':
                fillModeId = 3;
                break;
            case 'nearest':
                fillModeId = 4;
                break;
            default:
                fillModeId = 1;
                break;
        }
        this.userCode = `
            float mapCoord(float outCoord, float len) {
              float inCoord = outCoord;
              if(${fillModeId} == 2) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    if (inCoord < sz2) {
                      inCoord = sz2 * float(int(float(-inCoord / sz2))) +
                      inCoord;
                    }
                    inCoord = inCoord < -len ? inCoord + sz2 : -inCoord - 1.0;
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz2 = 2.0 * len;
                    inCoord -= sz2 * float(int(float(inCoord / sz2)));
                    if (inCoord >= len) {
                      inCoord = sz2 - inCoord - 1.0;
                    }
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 3) {
                if (inCoord < 0.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord += len * (float(int(float(-inCoord / sz))) + 1.0);
                  }
                } else if (inCoord > len - 1.0) {
                  if (len <= 1.0) {
                    inCoord = 0.0;
                  } else {
                    float sz = len - 1.0;
                    inCoord -= len * float(int(float(inCoord / sz)));
                  }
                }
                return clamp(inCoord, 0.0, len - 1.0);
              } else if (${fillModeId} == 4) {
                return clamp(outCoord, 0.0, len - 1.0);
              } else {
                return outCoord;
              }
            }

            float readWithFillValue(int batch, int coordY, int coordX,
              int channel) {
              float outputValue;
              if (0 <= coordY && coordY < ${imageHeight} && 0 <= coordX && coordX < ${imageWidth}) {
                  outputValue = getImage(batch, coordY, coordX, channel);
              } else {
                outputValue = float(${fillValue});
              }
              return outputValue;
            }

            void main() {
              ivec4 coords = getOutputCoords();
              float outputValue;
              int batch = coords[0];
              int x = coords[2];
              int y = coords[1];
              int channel = coords[3];
              float xf = float(x);
              float yf = float(y);
              float a1 = getTransforms(batch, 0);
              float a2 = getTransforms(batch, 1);
              float a3 = getTransforms(batch, 2);
              float b1 = getTransforms(batch, 3);
              float b2 = getTransforms(batch, 4);
              float b3 = getTransforms(batch, 5);
              float c1 = getTransforms(batch, 6);
              float c2 = getTransforms(batch, 7);
              float projection = c1 * xf + c2 * yf + 1.0;
              if (projection == 0.0) {
                outputValue = float(${fillValue});
              } else {
                float inX = (a1 * xf + a2 * yf + a3) / projection;
                float inY = (b1 * xf + b2 * yf + b3) / projection;
                float mapX = mapCoord(inX, float(${imageWidth}));
                float mapY = mapCoord(inY, float(${imageHeight}));

                if (${interpolationModeId} == 1) {
                  int coordY = int(round(mapY));
                  int coordX = int(round(mapX));
                  outputValue = readWithFillValue(batch, coordY, coordX,
                    channel);
                } else {
                  float yFloor = floor(mapY);
                  float xFloor = floor(mapX);
                  float yCeil = yFloor + 1.0;
                  float xCeil = xFloor + 1.0;
                  float valueYFloor = (xCeil - mapX) *
                  readWithFillValue(batch, int(yFloor), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yFloor), int(xCeil), channel);
                  float valueYCeil = (xCeil - mapX) *
                  readWithFillValue(batch, int(yCeil), int(xFloor), channel) +
                  (mapX - xFloor) *
                  readWithFillValue(batch, int(yCeil), int(xCeil), channel);
                  outputValue = (yCeil - mapY) * valueYFloor +
                  (mapY - yFloor) * valueYCeil;
                }
              }
              setOutput(outputValue);
            }
        `;
    }
}

});


parcelRegister("bMbPr", function(module, exports) {

$parcel$export(module.exports, "uniqueConfig", function () { return $892d5a5808702a04$export$78cd70dcd092910e; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the License);
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an AS IS BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $glyiU = parcelRequire("glyiU");

var $k42ZR = parcelRequire("k42ZR");
function $892d5a5808702a04$export$7a5d5c156e7dc406(args) {
    const { inputs: inputs, attrs: attrs, backend: backend } = args;
    const { axis: axis } = attrs;
    const { x: x } = inputs;
    (0, $k42ZR.assertNotComplex)(x, 'unique');
    // For now, always forward calculation to the CPU backend.
    console.warn('WARNING: ', 'UI might be locked temporarily as data is being downloaded');
    const values = backend.readSync(x.dataId);
    const { outputValues: outputValues, outputShape: outputShape, indices: indices } = (0, $glyiU.uniqueImplCPU)(values, axis, x.shape, x.dtype);
    return [
        backend.makeTensorInfo(outputShape, x.dtype, outputValues),
        backend.makeTensorInfo([
            indices.length
        ], 'int32', indices)
    ];
}
const $892d5a5808702a04$export$78cd70dcd092910e = {
    kernelName: (0, $9BGT9.Unique),
    backendName: 'webgl',
    kernelFunc: $892d5a5808702a04$export$7a5d5c156e7dc406
};

});

parcelRegister("39OK0", function(module, exports) {

$parcel$export(module.exports, "unpackConfig", function () { return $24c9927f7c7edc5d$export$d06292128cae50d6; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $9BGT9 = parcelRequire("9BGT9");

var $aNJFF = parcelRequire("aNJFF");

var $llO7x = parcelRequire("llO7x");
function $24c9927f7c7edc5d$export$417857010dc9287f(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { value: value } = inputs;
    let { axis: axis } = attrs;
    if (axis < 0) axis += value.shape.length;
    const x = value;
    const xRank = x.shape.length;
    const num = value.shape[axis];
    const outShape = new Array(xRank - 1);
    let outIndex = 0;
    for(let i = 0; i < xRank; i++)if (i !== axis) outShape[outIndex++] = x.shape[i];
    const toDispose = [];
    const begin = new Array(xRank).fill(0);
    const size = x.shape.slice();
    size[axis] = 1;
    const res = new Array(num);
    for(let i = 0; i < res.length; i++){
        begin[axis] = i;
        const sliced = (0, $llO7x.slice)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                begin: begin,
                size: size
            }
        });
        const reshaped = (0, $aNJFF.reshape)({
            inputs: {
                x: sliced
            },
            backend: backend,
            attrs: {
                shape: outShape
            }
        });
        res[i] = reshaped;
        toDispose.push(sliced);
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return res;
}
const $24c9927f7c7edc5d$export$d06292128cae50d6 = {
    kernelName: (0, $9BGT9.Unpack),
    backendName: 'webgl',
    kernelFunc: $24c9927f7c7edc5d$export$417857010dc9287f
};

});

parcelRegister("4v9Gf", function(module, exports) {

$parcel$export(module.exports, "unsortedSegmentSumConfig", function () { return $347190fc6fe85a97$export$71e3626a4ca29968; });
/**
 * @license
 * Copyright 2020 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ parcelRequire("8AHkS");
var $dEVRx = parcelRequire("dEVRx");
var $kKv2E = parcelRequire("kKv2E");
var $9BGT9 = parcelRequire("9BGT9");
var $lBDHD = parcelRequire("lBDHD");

var $4EhnX = parcelRequire("4EhnX");

var $3dQjt = parcelRequire("3dQjt");

var $aNJFF = parcelRequire("aNJFF");

var $bKD1Y = parcelRequire("bKD1Y");

var $fZ5E6 = parcelRequire("fZ5E6");
function $347190fc6fe85a97$export$ba7c4d144d85a309(args) {
    const { inputs: inputs, backend: backend, attrs: attrs } = args;
    const { x: x, segmentIds: segmentIds } = inputs;
    const { numSegments: numSegments } = attrs;
    const xRank = x.shape.length;
    const toDispose = [];
    let axis = 0;
    const permutation = (0, $dEVRx).getAxesPermutation([
        axis
    ], xRank);
    let permutedX = x;
    if (permutation != null) {
        permutedX = (0, $fZ5E6.transpose)({
            inputs: {
                x: x
            },
            backend: backend,
            attrs: {
                perm: permutation
            }
        });
        toDispose.push(permutedX);
        axis = (0, $dEVRx).getInnerMostAxes(1, xRank)[0];
    }
    const outShape = (0, $dEVRx).segment_util.computeOutShape(permutedX.shape, axis, numSegments);
    const inSize = (0, $lBDHD).sizeFromShape([
        permutedX.shape[axis]
    ]);
    const a2D = (0, $aNJFF.reshape)({
        inputs: {
            x: permutedX
        },
        backend: backend,
        attrs: {
            shape: [
                -1,
                inSize
            ]
        }
    });
    toDispose.push(a2D);
    const outputDType = (0, $kKv2E.sumOutType)(x.dtype);
    const segOpCompute = (x, segOpType, segmentIds, dtype, numSegments)=>{
        const batchSize = x.shape[0];
        const inSize = x.shape[1];
        const windowSize = (0, $dEVRx).segment_util.segOpComputeOptimalWindowSize(inSize, numSegments);
        const segOpInfo = {
            windowSize: windowSize,
            inSize: inSize,
            batchSize: batchSize,
            numSegments: numSegments
        };
        const program = new (0, $4EhnX.SegmentOpProgram)(segOpInfo, segOpType);
        const output = backend.compileAndRun(program, [
            x,
            segmentIds
        ], dtype);
        toDispose.push(output);
        // No need to run another GPGPU program.
        if (output.shape[1] === numSegments) return output;
        const rangeInfo = (0, $3dQjt.range)({
            backend: backend,
            attrs: {
                start: 0,
                stop: numSegments,
                step: 1,
                dtype: 'float32'
            }
        });
        const tileInfo = (0, $bKD1Y.tile)({
            inputs: {
                x: rangeInfo
            },
            backend: backend,
            attrs: {
                reps: [
                    inSize / windowSize
                ]
            }
        });
        toDispose.push(rangeInfo);
        toDispose.push(tileInfo);
        const result = segOpCompute(output, segOpType, tileInfo, dtype, numSegments);
        return result;
    };
    const segOpResult = segOpCompute(a2D, 'unsortedSegmentSum', segmentIds, outputDType, numSegments);
    const reshaped = (0, $aNJFF.reshape)({
        inputs: {
            x: segOpResult
        },
        backend: backend,
        attrs: {
            shape: outShape
        }
    });
    let result = reshaped;
    if (permutation != null) {
        toDispose.push(reshaped);
        const perm = (0, $dEVRx).getUndoAxesPermutation(permutation);
        result = (0, $fZ5E6.transpose)({
            inputs: {
                x: result
            },
            backend: backend,
            attrs: {
                perm: perm
            }
        });
    }
    toDispose.forEach((t)=>backend.disposeIntermediateTensorInfo(t));
    return result;
}
const $347190fc6fe85a97$export$71e3626a4ca29968 = {
    kernelName: (0, $9BGT9.UnsortedSegmentSum),
    backendName: 'webgl',
    kernelFunc: $347190fc6fe85a97$export$ba7c4d144d85a309
};

});
parcelRegister("4EhnX", function(module, exports) {

$parcel$export(module.exports, "SegmentOpProgram", function () { return $3628623d5dbcba0c$export$543f739d986d05c3; });
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ class $3628623d5dbcba0c$export$543f739d986d05c3 {
    constructor(segOpInfo, segOpType){
        this.variableNames = [
            'x',
            'segmentIds'
        ];
        const windowSize = segOpInfo.windowSize;
        const batchSize = segOpInfo.batchSize;
        const inSize = segOpInfo.inSize;
        const numSegments = segOpInfo.numSegments;
        const outSize = numSegments * Math.ceil(inSize / windowSize);
        this.outputShape = [
            batchSize,
            outSize
        ];
        const initializationValue = '0.0';
        const returnValue = `sumValue`;
        const windowSizeNearestVec4 = Math.floor(windowSize / 4) * 4;
        const windowSizeVec4Remainder = windowSize % 4;
        const updateSnippet = `
        sumValue += dot(values, segFilter);
    `;
        let checkValueOutOfBounds = '';
        if (inSize % windowSize > 0) checkValueOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return initializationValue;
        }
      `;
        let checkSegmentIdOutOfBounds = '';
        if (inSize % windowSize > 0) checkSegmentIdOutOfBounds = `
        if (inIdx < 0 || inIdx >= ${inSize}) {
          return -1.0;
        }
      `;
        this.userCode = `
      const float initializationValue = ${initializationValue};

      float getValue(int batch, int inIdx) {
        ${checkValueOutOfBounds}
        return getX(batch, inIdx);
      }

      float getSegmentIdAtIndex(int inIdx) {
        ${checkSegmentIdOutOfBounds}
        return getSegmentIds(inIdx);
      }

      void main() {
        ivec2 coords = getOutputCoords();
        int batch = coords[0];
        int outIdx = coords[1];
        int inOffset = int(floor(float(outIdx) / float(
          ${numSegments})) * float(${windowSize}));
        int currentSeg = int(mod(float(outIdx), float(${numSegments})));

        float sumValue = 0.0;

        for (int i = 0; i < ${windowSizeNearestVec4}; i += 4) {
          int inIdx = inOffset + i;
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            getValue(batch, inIdx + 3)
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0
          );

          ${updateSnippet}
        }

        int inIdx = inOffset + ${windowSizeNearestVec4};
        if (${windowSizeVec4Remainder === 1}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            initializationValue,
            initializationValue,
            initializationValue
          );

          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            0,
            0,
            0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 2}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            initializationValue,
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
              0,
              0
          );

          ${updateSnippet}
        } else if (${windowSizeVec4Remainder === 3}) {
          vec4 values = vec4(
            getValue(batch, inIdx),
            getValue(batch, inIdx + 1),
            getValue(batch, inIdx + 2),
            initializationValue
          );

          vec4 segFilter = vec4(
            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,
            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,
            0
          );

          ${updateSnippet}
        }
        setOutput(${returnValue});
      }
    `;
    }
}

});




parcelRegister("4Ci0Z", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $35c8af6c1617f8b8$export$83d89fbfd8236492; });
/** @license See the LICENSE file. */ // This code is auto-generated, do not modify this file!
const $35c8af6c1617f8b8$export$83d89fbfd8236492 = '4.22.0';

});


parcelRegister("tMWS5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0598adb54c0050af$export$2e2bcd8739ae039; });
function $0598adb54c0050af$export$2e2bcd8739ae039(model) {
    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';
    // Create table header
    const header = table.createTHead();
    const headerRow = header.insertRow();
    [
        'Layer Type',
        'Output Shape',
        'Param #'
    ].forEach((text)=>{
        const th = document.createElement('th');
        th.textContent = text;
        th.style.border = '1px solid #ddd';
        th.style.padding = '8px';
        th.style.backgroundColor = '#f2f2f2';
        headerRow.appendChild(th);
    });
    // Create table body
    const tbody = table.createTBody();
    model.layers.forEach((layer)=>{
        const row = tbody.insertRow();
        const cells = [
            `${layer.name} (${layer.getClassName()})`,
            JSON.stringify(layer.outputShape),
            layer.countParams()
        ];
        cells.forEach((text)=>{
            const cell = row.insertCell();
            cell.textContent = text;
            cell.style.border = '1px solid #ddd';
            cell.style.padding = '8px';
        });
    });
    // Add total parameters row
    const totalRow = tbody.insertRow();
    const totalNameCell = totalRow.insertCell();
    totalNameCell.textContent = 'Total params:';
    totalNameCell.style.fontWeight = 'bold';
    totalNameCell.style.border = '1px solid #ddd';
    totalNameCell.style.padding = '8px';
    const totalParamsCell = totalRow.insertCell();
    totalParamsCell.textContent = model.countParams().toLocaleString();
    totalParamsCell.style.fontWeight = 'bold';
    totalParamsCell.colSpan = 2;
    totalParamsCell.style.border = '1px solid #ddd';
    totalParamsCell.style.padding = '8px';
    return table;
}

});

})();
//# sourceMappingURL=graphing-calculator.dd1ce485.js.map
